/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 802);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Random utility functions used in the UI-Router code
 *
 * These functions are exported, but are subject to change without notice.
 *
 * @preferred
 * @module common
 */ /** for typedoc */


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var predicates_1 = __webpack_require__(1);
var hof_1 = __webpack_require__(3);
var coreservices_1 = __webpack_require__(6);
var w = typeof window === 'undefined' ? {} : window;
var angular = w.angular || {};
exports.fromJson = angular.fromJson || JSON.parse.bind(JSON);
exports.toJson = angular.toJson || JSON.stringify.bind(JSON);
exports.copy = angular.copy || _copy;
exports.forEach = angular.forEach || _forEach;
exports.extend = angular.extend || _extend;
exports.equals = angular.equals || _equals;
exports.identity = function (x) {
    return x;
};
exports.noop = function () {
    return undefined;
};
/**
 * Builds proxy functions on the `to` object which pass through to the `from` object.
 *
 * For each key in `fnNames`, creates a proxy function on the `to` object.
 * The proxy function calls the real function on the `from` object.
 *
 *
 * #### Example:
 * This example creates an new class instance whose functions are prebound to the new'd object.
 * ```js
 * class Foo {
 *   constructor(data) {
 *     // Binds all functions from Foo.prototype to 'this',
 *     // then copies them to 'this'
 *     bindFunctions(Foo.prototype, this, this);
 *     this.data = data;
 *   }
 *
 *   log() {
 *     console.log(this.data);
 *   }
 * }
 *
 * let myFoo = new Foo([1,2,3]);
 * var logit = myFoo.log;
 * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
 * ```
 *
 * #### Example:
 * This example creates a bound version of a service function, and copies it to another object
 * ```
 *
 * var SomeService = {
 *   this.data = [3, 4, 5];
 *   this.log = function() {
 *     console.log(this.data);
 *   }
 * }
 *
 * // Constructor fn
 * function OtherThing() {
 *   // Binds all functions from SomeService to SomeService,
 *   // then copies them to 'this'
 *   bindFunctions(SomeService, this, SomeService);
 * }
 *
 * let myOtherThing = new OtherThing();
 * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
 * ```
 *
 * @param source A function that returns the source object which contains the original functions to be bound
 * @param target A function that returns the target object which will receive the bound functions
 * @param bind A function that returns the object which the functions will be bound to
 * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
 * @param latebind If true, the binding of the function is delayed until the first time it's invoked
 */
function createProxyFunctions(source, target, bind, fnNames, latebind) {
    if (latebind === void 0) {
        latebind = false;
    }
    var bindFunction = function bindFunction(fnName) {
        return source()[fnName].bind(bind());
    };
    var makeLateRebindFn = function makeLateRebindFn(fnName) {
        return function lateRebindFunction() {
            target[fnName] = bindFunction(fnName);
            return target[fnName].apply(null, arguments);
        };
    };
    fnNames = fnNames || Object.keys(source());
    return fnNames.reduce(function (acc, name) {
        acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
        return acc;
    }, target);
}
exports.createProxyFunctions = createProxyFunctions;
/**
 * prototypal inheritance helper.
 * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
 */
exports.inherit = function (parent, extra) {
    return exports.extend(new (exports.extend(function () {}, { prototype: parent }))(), extra);
};
/**
 * Given an arguments object, converts the arguments at index idx and above to an array.
 * This is similar to es6 rest parameters.
 *
 * Optionally, the argument at index idx may itself already be an array.
 *
 * For example,
 * given either:
 *        arguments = [ obj, "foo", "bar" ]
 * or:
 *        arguments = [ obj, ["foo", "bar"] ]
 * then:
 *        restArgs(arguments, 1) == ["foo", "bar"]
 *
 * This allows functions like pick() to be implemented such that it allows either a bunch
 * of string arguments (like es6 rest parameters), or a single array of strings:
 *
 * given:
 *        var obj = { foo: 1, bar: 2, baz: 3 };
 * then:
 *        pick(obj, "foo", "bar");   // returns { foo: 1, bar: 2 }
 *        pick(obj, ["foo", "bar"]); // returns { foo: 1, bar: 2 }
 */
var restArgs = function restArgs(args, idx) {
    if (idx === void 0) {
        idx = 0;
    }
    return Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(args, idx));
};
/** Given an array, returns true if the object is found in the array, (using indexOf) */
exports.inArray = hof_1.curry(_inArray);
function _inArray(array, obj) {
    return array.indexOf(obj) !== -1;
}
exports._inArray = _inArray;
/**
 * Given an array, and an item, if the item is found in the array, it removes it (in-place).
 * The same array is returned
 */
exports.removeFrom = hof_1.curry(_removeFrom);
function _removeFrom(array, obj) {
    var idx = array.indexOf(obj);
    if (idx >= 0) array.splice(idx, 1);
    return array;
}
exports._removeFrom = _removeFrom;
/** pushes a values to an array and returns the value */
exports.pushTo = hof_1.curry(_pushTo);
function _pushTo(arr, val) {
    return arr.push(val), val;
}
exports._pushTo = _pushTo;
/** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
exports.deregAll = function (functions) {
    return functions.slice().forEach(function (fn) {
        typeof fn === 'function' && fn();
        exports.removeFrom(functions, fn);
    });
};
/**
 * Applies a set of defaults to an options object.  The options object is filtered
 * to only those properties of the objects in the defaultsList.
 * Earlier objects in the defaultsList take precedence when applying defaults.
 */
function defaults(opts) {
    if (opts === void 0) {
        opts = {};
    }
    var defaultsList = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        defaultsList[_i - 1] = arguments[_i];
    }
    var defaults = merge.apply(null, [{}].concat(defaultsList));
    return exports.extend({}, defaults, pick(opts || {}, Object.keys(defaults)));
}
exports.defaults = defaults;
/**
 * Merges properties from the list of objects to the destination object.
 * If a property already exists in the destination object, then it is not overwritten.
 */
function merge(dst) {
    var objs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objs[_i - 1] = arguments[_i];
    }
    exports.forEach(objs, function (obj) {
        exports.forEach(obj, function (value, key) {
            if (!dst.hasOwnProperty(key)) dst[key] = value;
        });
    });
    return dst;
}
exports.merge = merge;
/** Reduce function that merges each element of the list into a single object, using extend */
exports.mergeR = function (memo, item) {
    return exports.extend(memo, item);
};
/**
 * Finds the common ancestor path between two states.
 *
 * @param {Object} first The first state.
 * @param {Object} second The second state.
 * @return {Array} Returns an array of state names in descending order, not including the root.
 */
function ancestors(first, second) {
    var path = [];
    for (var n in first.path) {
        if (first.path[n] !== second.path[n]) break;
        path.push(first.path[n]);
    }
    return path;
}
exports.ancestors = ancestors;
function pickOmitImpl(predicate, obj) {
    var keys = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        keys[_i - 2] = arguments[_i];
    }
    var objCopy = {};
    for (var key in obj) {
        if (predicate(keys, key)) objCopy[key] = obj[key];
    }
    return objCopy;
}
/** Return a copy of the object only containing the whitelisted properties. */
function pick(obj) {
    return pickOmitImpl.apply(null, [exports.inArray].concat(restArgs(arguments)));
}
exports.pick = pick;
/** Return a copy of the object omitting the blacklisted properties. */
function omit(obj) {
    var notInArray = function notInArray(array, item) {
        return !exports.inArray(array, item);
    };
    return pickOmitImpl.apply(null, [notInArray].concat(restArgs(arguments)));
}
exports.omit = omit;
/**
 * Maps an array, or object to a property (by name)
 */
function pluck(collection, propName) {
    return map(collection, hof_1.prop(propName));
}
exports.pluck = pluck;
/** Filters an Array or an Object's properties based on a predicate */
function filter(collection, callback) {
    var arr = predicates_1.isArray(collection),
        result = arr ? [] : {};
    var accept = arr ? function (x) {
        return result.push(x);
    } : function (x, key) {
        return result[key] = x;
    };
    exports.forEach(collection, function (item, i) {
        if (callback(item, i)) accept(item, i);
    });
    return result;
}
exports.filter = filter;
/** Finds an object from an array, or a property of an object, that matches a predicate */
function find(collection, callback) {
    var result;
    exports.forEach(collection, function (item, i) {
        if (result) return;
        if (callback(item, i)) result = item;
    });
    return result;
}
exports.find = find;
/** Given an object, returns a new object, where each property is transformed by the callback function */
exports.mapObj = map;
/** Maps an array or object properties using a callback function */
function map(collection, callback) {
    var result = predicates_1.isArray(collection) ? [] : {};
    exports.forEach(collection, function (item, i) {
        return result[i] = callback(item, i);
    });
    return result;
}
exports.map = map;
/**
 * Given an object, return its enumerable property values
 *
 * @example
 * ```
 *
 * let foo = { a: 1, b: 2, c: 3 }
 * let vals = values(foo); // [ 1, 2, 3 ]
 * ```
 */
exports.values = function (obj) {
    return Object.keys(obj).map(function (key) {
        return obj[key];
    });
};
/**
 * Reduce function that returns true if all of the values are truthy.
 *
 * @example
 * ```
 *
 * let vals = [ 1, true, {}, "hello world"];
 * vals.reduce(allTrueR, true); // true
 *
 * vals.push(0);
 * vals.reduce(allTrueR, true); // false
 * ```
 */
exports.allTrueR = function (memo, elem) {
    return memo && elem;
};
/**
 * Reduce function that returns true if any of the values are truthy.
 *
 *  * @example
 * ```
 *
 * let vals = [ 0, null, undefined ];
 * vals.reduce(anyTrueR, true); // false
 *
 * vals.push("hello world");
 * vals.reduce(anyTrueR, true); // true
 * ```
 */
exports.anyTrueR = function (memo, elem) {
    return memo || elem;
};
/**
 * Reduce function which un-nests a single level of arrays
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
 * ```
 */
exports.unnestR = function (memo, elem) {
    return memo.concat(elem);
};
/**
 * Reduce function which recursively un-nests all arrays
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
 * ```
 */
exports.flattenR = function (memo, elem) {
    return predicates_1.isArray(elem) ? memo.concat(elem.reduce(exports.flattenR, [])) : pushR(memo, elem);
};
/**
 * Reduce function that pushes an object to an array, then returns the array.
 * Mostly just for [[flattenR]] and [[uniqR]]
 */
function pushR(arr, obj) {
    arr.push(obj);
    return arr;
}
exports.pushR = pushR;
/** Reduce function that filters out duplicates */
exports.uniqR = function (acc, token) {
    return exports.inArray(acc, token) ? acc : pushR(acc, token);
};
/**
 * Return a new array with a single level of arrays unnested.
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
 * ```
 */
exports.unnest = function (arr) {
    return arr.reduce(exports.unnestR, []);
};
/**
 * Return a completely flattened version of an array.
 *
 * @example
 * ```
 *
 * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
 * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
 * ```
 */
exports.flatten = function (arr) {
    return arr.reduce(exports.flattenR, []);
};
/**
 * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
 * @example
 * ```
 *
 * let isNumber = (obj) => typeof(obj) === 'number';
 * let allNumbers = [ 1, 2, 3, 4, 5 ];
 * allNumbers.filter(assertPredicate(isNumber)); //OK
 *
 * let oneString = [ 1, 2, 3, 4, "5" ];
 * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
 * ```
 */
exports.assertPredicate = assertFn;
/**
 * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
 * @example
 * ```
 *
 * var data = { foo: 1, bar: 2 };
 *
 * let keys = [ 'foo', 'bar' ]
 * let values = keys.map(assertMap(key => data[key], "Key not found"));
 * // values is [1, 2]
 *
 * let keys = [ 'foo', 'bar', 'baz' ]
 * let values = keys.map(assertMap(key => data[key], "Key not found"));
 * // throws Error("Key not found")
 * ```
 */
exports.assertMap = assertFn;
function assertFn(predicateOrMap, errMsg) {
    if (errMsg === void 0) {
        errMsg = "assert failure";
    }
    return function (obj) {
        var result = predicateOrMap(obj);
        if (!result) {
            throw new Error(predicates_1.isFunction(errMsg) ? errMsg(obj) : errMsg);
        }
        return result;
    };
}
exports.assertFn = assertFn;
/**
 * Like _.pairs: Given an object, returns an array of key/value pairs
 *
 * @example
 * ```
 *
 * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
 * ```
 */
exports.pairs = function (obj) {
    return Object.keys(obj).map(function (key) {
        return [key, obj[key]];
    });
};
/**
 * Given two or more parallel arrays, returns an array of tuples where
 * each tuple is composed of [ a[i], b[i], ... z[i] ]
 *
 * @example
 * ```
 *
 * let foo = [ 0, 2, 4, 6 ];
 * let bar = [ 1, 3, 5, 7 ];
 * let baz = [ 10, 30, 50, 70 ];
 * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
 * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
 * ```
 */
function arrayTuples() {
    var arrayArgs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arrayArgs[_i] = arguments[_i];
    }
    if (arrayArgs.length === 0) return [];
    var length = arrayArgs.reduce(function (min, arr) {
        return Math.min(arr.length, min);
    }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
    return Array.apply(null, Array(length)).map(function (ignored, idx) {
        return arrayArgs.map(function (arr) {
            return arr[idx];
        });
    });
}
exports.arrayTuples = arrayTuples;
/**
 * Reduce function which builds an object from an array of [key, value] pairs.
 *
 * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
 *
 * Each keyValueTuple should be an array with values [ key: string, value: any ]
 *
 * @example
 * ```
 *
 * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
 *
 * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
 *
 * // Or, more simply:
 * var pairsToObj = pairs.reduce(applyPairs, {})
 * // pairsToObj == { fookey: "fooval", barkey: "barval" }
 * ```
 */
function applyPairs(memo, keyValTuple) {
    var key, value;
    if (predicates_1.isArray(keyValTuple)) key = keyValTuple[0], value = keyValTuple[1];
    if (!predicates_1.isString(key)) throw new Error("invalid parameters to applyPairs");
    memo[key] = value;
    return memo;
}
exports.applyPairs = applyPairs;
/** Get the last element of an array */
function tail(arr) {
    return arr.length && arr[arr.length - 1] || undefined;
}
exports.tail = tail;
/**
 * shallow copy from src to dest
 *
 * note: This is a shallow copy, while angular.copy is a deep copy.
 * ui-router uses `copy` only to make copies of state parameters.
 */
function _copy(src, dest) {
    if (dest) Object.keys(dest).forEach(function (key) {
        return delete dest[key];
    });
    if (!dest) dest = {};
    return exports.extend(dest, src);
}
/** Naive forEach implementation works with Objects or Arrays */
function _forEach(obj, cb, _this) {
    if (predicates_1.isArray(obj)) return obj.forEach(cb, _this);
    Object.keys(obj).forEach(function (key) {
        return cb(obj[key], key);
    });
}
function _copyProps(to, from) {
    Object.keys(from).forEach(function (key) {
        return to[key] = from[key];
    });
    return to;
}
function _extend(toObj) {
    return restArgs(arguments, 1).filter(exports.identity).reduce(_copyProps, toObj);
}
function _equals(o1, o2) {
    if (o1 === o2) return true;
    if (o1 === null || o2 === null) return false;
    if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
    var t1 = typeof o1 === "undefined" ? "undefined" : _typeof(o1),
        t2 = typeof o2 === "undefined" ? "undefined" : _typeof(o2);
    if (t1 !== t2 || t1 !== 'object') return false;
    var tup = [o1, o2];
    if (hof_1.all(predicates_1.isArray)(tup)) return _arraysEq(o1, o2);
    if (hof_1.all(predicates_1.isDate)(tup)) return o1.getTime() === o2.getTime();
    if (hof_1.all(predicates_1.isRegExp)(tup)) return o1.toString() === o2.toString();
    if (hof_1.all(predicates_1.isFunction)(tup)) return true; // meh
    var predicates = [predicates_1.isFunction, predicates_1.isArray, predicates_1.isDate, predicates_1.isRegExp];
    if (predicates.map(hof_1.any).reduce(function (b, fn) {
        return b || !!fn(tup);
    }, false)) return false;
    var key,
        keys = {};
    for (key in o1) {
        if (!_equals(o1[key], o2[key])) return false;
        keys[key] = true;
    }
    for (key in o2) {
        if (!keys[key]) return false;
    }
    return true;
}
function _arraysEq(a1, a2) {
    if (a1.length !== a2.length) return false;
    return arrayTuples(a1, a2).reduce(function (b, t) {
        return b && _equals(t[0], t[1]);
    }, true);
}
/**
 * Create a sort function
 *
 * Creates a sort function which sorts by a numeric property.
 *
 * The `propFn` should return the property as a number which can be sorted.
 *
 * #### Example:
 * This example returns the `priority` prop.
 * ```js
 * var sortfn = sortBy(obj => obj.priority)
 * // equivalent to:
 * var longhandSortFn = (a, b) => a.priority - b.priority;
 * ```
 *
 * #### Example:
 * This example uses [[prop]]
 * ```js
 * var sortfn = sortBy(prop('priority'))
 * ```
 *
 * The `checkFn` can be used to exclude objects from sorting.
 *
 * #### Example:
 * This example only sorts objects with type === 'FOO'
 * ```js
 * var sortfn = sortBy(prop('priority'), propEq('type', 'FOO'))
 * ```
 *
 * @param propFn a function that returns the property (as a number)
 * @param checkFn a predicate
 *
 * @return a sort function like: `(a, b) => (checkFn(a) && checkFn(b)) ? propFn(a) - propFn(b) : 0`
 */
exports.sortBy = function (propFn, checkFn) {
    if (checkFn === void 0) {
        checkFn = hof_1.val(true);
    }
    return function (a, b) {
        return checkFn(a) && checkFn(b) ? propFn(a) - propFn(b) : 0;
    };
};
/**
 * Composes a list of sort functions
 *
 * Creates a sort function composed of multiple sort functions.
 * Each sort function is invoked in series.
 * The first sort function to return non-zero "wins".
 *
 * @param sortFns list of sort functions
 */
exports.composeSort = function () {
    var sortFns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sortFns[_i] = arguments[_i];
    }
    return function (a, b) {
        return sortFns.reduce(function (prev, fn) {
            return prev || fn(a, b);
        }, 0);
    };
};
// issue #2676
exports.silenceUncaughtInPromise = function (promise) {
    return promise.catch(function (e) {
        return 0;
    }) && promise;
};
exports.silentRejection = function (error) {
    return exports.silenceUncaughtInPromise(coreservices_1.services.$q.reject(error));
};
//# sourceMappingURL=common.js.map

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** Predicates
 *
 * These predicates return true/false based on the input.
 * Although these functions are exported, they are subject to change without notice.
 *
 * @module common_predicates
 */ /** */

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var hof_1 = __webpack_require__(3);
var toStr = Object.prototype.toString;
var tis = function tis(t) {
  return function (x) {
    return (typeof x === "undefined" ? "undefined" : _typeof(x)) === t;
  };
};
exports.isUndefined = tis('undefined');
exports.isDefined = hof_1.not(exports.isUndefined);
exports.isNull = function (o) {
  return o === null;
};
exports.isNullOrUndefined = hof_1.or(exports.isNull, exports.isUndefined);
exports.isFunction = tis('function');
exports.isNumber = tis('number');
exports.isString = tis('string');
exports.isObject = function (x) {
  return x !== null && (typeof x === "undefined" ? "undefined" : _typeof(x)) === 'object';
};
exports.isArray = Array.isArray;
exports.isDate = function (x) {
  return toStr.call(x) === '[object Date]';
};
exports.isRegExp = function (x) {
  return toStr.call(x) === '[object RegExp]';
};
/**
 * Predicate which checks if a value is injectable
 *
 * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
 * where all the elements in the array are Strings, except the last one, which is a Function
 */
function isInjectable(val) {
  if (exports.isArray(val) && val.length) {
    var head = val.slice(0, -1),
        tail = val.slice(-1);
    return !(head.filter(hof_1.not(exports.isString)).length || tail.filter(hof_1.not(exports.isFunction)).length);
  }
  return exports.isFunction(val);
}
exports.isInjectable = isInjectable;
/**
 * Predicate which checks if a value looks like a Promise
 *
 * It is probably a Promise if it's an object, and it has a `then` property which is a Function
 */
exports.isPromise = hof_1.and(exports.isObject, hof_1.pipe(hof_1.prop('then'), exports.isFunction));
//# sourceMappingURL=predicates.js.map

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createFind = __webpack_require__(324),
    findIndex = __webpack_require__(8);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Higher order functions
 *
 * These utility functions are exported, but are subject to change without notice.
 *
 * @module common_hof
 */ /** */

/**
 * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
 *
 * Given a function with N parameters, returns a new function that supports partial application.
 * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
 * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
 * accept more parameters until all N parameters have been supplied.
 *
 *
 * This contrived example uses a partially applied function as an predicate, which returns true
 * if an object is found in both arrays.
 * @example
 * ```
 * // returns true if an object is in both of the two arrays
 * function inBoth(array1, array2, object) {
 *   return array1.indexOf(object) !== -1 &&
 *          array2.indexOf(object) !== 1;
 * }
 * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
 * let foos = [obj1, obj3]
 * let bars = [obj3, obj4, obj5]
 *
 * // A curried "copy" of inBoth
 * let curriedInBoth = curry(inBoth);
 * // Partially apply both the array1 and array2
 * let inFoosAndBars = curriedInBoth(foos, bars);
 *
 * // Supply the final argument; since all arguments are
 * // supplied, the original inBoth function is then called.
 * let obj1InBoth = inFoosAndBars(obj1); // false
 *
 * // Use the inFoosAndBars as a predicate.
 * // Filter, on each iteration, supplies the final argument
 * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
 * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
 *
 * ```
 *
 * Stolen from: http://stackoverflow.com/questions/4394747/javascript-curry-function
 *
 * @param fn
 * @returns {*|function(): (*|any)}
 */

function curry(fn) {
    var initial_args = [].slice.apply(arguments, [1]);
    var func_args_length = fn.length;
    function curried(args) {
        if (args.length >= func_args_length) return fn.apply(null, args);
        return function () {
            return curried(args.concat([].slice.apply(arguments)));
        };
    }
    return curried(initial_args);
}
exports.curry = curry;
/**
 * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
 * given: f(x), g(x), h(x)
 * let composed = compose(f,g,h)
 * then, composed is: f(g(h(x)))
 */
function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function () {
        var i = start,
            result = args[start].apply(this, arguments);
        while (i--) {
            result = args[i].call(this, result);
        }return result;
    };
}
exports.compose = compose;
/**
 * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
 * given: f(x), g(x), h(x)
 * let piped = pipe(f,g,h);
 * then, piped is: h(g(f(x)))
 */
function pipe() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        funcs[_i] = arguments[_i];
    }
    return compose.apply(null, [].slice.call(arguments).reverse());
}
exports.pipe = pipe;
/**
 * Given a property name, returns a function that returns that property from an object
 * let obj = { foo: 1, name: "blarg" };
 * let getName = prop("name");
 * getName(obj) === "blarg"
 */
exports.prop = function (name) {
    return function (obj) {
        return obj && obj[name];
    };
};
/**
 * Given a property name and a value, returns a function that returns a boolean based on whether
 * the passed object has a property that matches the value
 * let obj = { foo: 1, name: "blarg" };
 * let getName = propEq("name", "blarg");
 * getName(obj) === true
 */
exports.propEq = curry(function (name, val, obj) {
    return obj && obj[name] === val;
});
/**
 * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
 * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
 * let getName = prop("nestedObj.name");
 * getName(obj) === "blarg"
 * let propNotFound = prop("this.property.doesnt.exist");
 * propNotFound(obj) === undefined
 */
exports.parse = function (name) {
    return pipe.apply(null, name.split(".").map(exports.prop));
};
/**
 * Given a function that returns a truthy or falsey value, returns a
 * function that returns the opposite (falsey or truthy) value given the same inputs
 */
exports.not = function (fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return !fn.apply(null, args);
    };
};
/**
 * Given two functions that return truthy or falsey values, returns a function that returns truthy
 * if both functions return truthy for the given arguments
 */
function and(fn1, fn2) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn1.apply(null, args) && fn2.apply(null, args);
    };
}
exports.and = and;
/**
 * Given two functions that return truthy or falsey values, returns a function that returns truthy
 * if at least one of the functions returns truthy for the given arguments
 */
function or(fn1, fn2) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn1.apply(null, args) || fn2.apply(null, args);
    };
}
exports.or = or;
/**
 * Check if all the elements of an array match a predicate function
 *
 * @param fn1 a predicate function `fn1`
 * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
 */
exports.all = function (fn1) {
    return function (arr) {
        return arr.reduce(function (b, x) {
            return b && !!fn1(x);
        }, true);
    };
};
exports.any = function (fn1) {
    return function (arr) {
        return arr.reduce(function (b, x) {
            return b || !!fn1(x);
        }, false);
    };
};
/** Given a class, returns a Predicate function that returns true if the object is of that class */
exports.is = function (ctor) {
    return function (obj) {
        return obj != null && obj.constructor === ctor || obj instanceof ctor;
    };
};
/** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
exports.eq = function (val) {
    return function (other) {
        return val === other;
    };
};
/** Given a value, returns a function which returns the value */
exports.val = function (v) {
    return function () {
        return v;
    };
};
function invoke(fnName, args) {
    return function (obj) {
        return obj[fnName].apply(obj, args);
    };
}
exports.invoke = invoke;
/**
 * Sorta like Pattern Matching (a functional programming conditional construct)
 *
 * See http://c2.com/cgi/wiki?PatternMatching
 *
 * This is a conditional construct which allows a series of predicates and output functions
 * to be checked and then applied.  Each predicate receives the input.  If the predicate
 * returns truthy, then its matching output function (mapping function) is provided with
 * the input and, then the result is returned.
 *
 * Each combination (2-tuple) of predicate + output function should be placed in an array
 * of size 2: [ predicate, mapFn ]
 *
 * These 2-tuples should be put in an outer array.
 *
 * @example
 * ```
 *
 * // Here's a 2-tuple where the first element is the isString predicate
 * // and the second element is a function that returns a description of the input
 * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
 *
 * // Second tuple: predicate "isNumber", mapfn returns a description
 * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
 *
 * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
 *
 * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
 *
 * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
 *
 * console.log(descriptionOf(undefined)); // 'notdefined'
 * console.log(descriptionOf(55)); // '(55) That's a number!'
 * console.log(descriptionOf("foo")); // 'Here's your string foo'
 * ```
 *
 * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
 * with a Predicate and a mapping/output function
 * @returns {function(any): *}
 */
function pattern(struct) {
    return function (x) {
        for (var i = 0; i < struct.length; i++) {
            if (struct[i][0](x)) return struct[i][1](x);
        }
    };
}
exports.pattern = pattern;
//# sourceMappingURL=hof.js.map

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return array && array.length ? array[0] : undefined;
}

module.exports = head;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.notImplemented = function (fnname) {
    return function () {
        throw new Error(fnname + "(): No coreservices implementation for UI-Router is loaded.");
    };
};
var services = {
    $q: undefined,
    $injector: undefined
};
exports.services = services;
//# sourceMappingURL=coreservices.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayFilter = __webpack_require__(91),
    baseFilter = __webpack_require__(281),
    baseIteratee = __webpack_require__(16),
    isArray = __webpack_require__(4);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseFindIndex = __webpack_require__(282),
    baseIteratee = __webpack_require__(16),
    toInteger = __webpack_require__(391);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module common
 */ /** */


function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}
__export(__webpack_require__(397));
__export(__webpack_require__(404));
__export(__webpack_require__(405));
__export(__webpack_require__(406));
__export(__webpack_require__(407));
__export(__webpack_require__(408));
__export(__webpack_require__(409));
__export(__webpack_require__(410));
__export(__webpack_require__(118));
__export(__webpack_require__(123));
__export(__webpack_require__(403));
//# sourceMappingURL=index.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(100);

/** Detect free variable `self`. */
var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseClone = __webpack_require__(278);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseKeys = __webpack_require__(96),
    getTag = __webpack_require__(29),
    isArrayLike = __webpack_require__(18),
    isString = __webpack_require__(383),
    stringSize = __webpack_require__(368);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
}

module.exports = isObjectLike;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Functions that manipulate strings
 *
 * Although these functions are exported, they are subject to change without notice.
 *
 * @module common_strings
 */ /** */


var predicates_1 = __webpack_require__(1);
var rejectFactory_1 = __webpack_require__(33);
var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
var transition_1 = __webpack_require__(84);
var resolvable_1 = __webpack_require__(31);
/**
 * Returns a string shortened to a maximum length
 *
 * If the string is already less than the `max` length, return the string.
 * Else return the string, shortened to `max - 3` and append three dots ("...").
 *
 * @param max the maximum length of the string to return
 * @param str the input string
 */
function maxLength(max, str) {
    if (str.length <= max) return str;
    return str.substr(0, max - 3) + "...";
}
exports.maxLength = maxLength;
/**
 * Returns a string, with spaces added to the end, up to a desired str length
 *
 * If the string is already longer than the desired length, return the string.
 * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
 *
 * @param length the desired length of the string to return
 * @param str the input string
 */
function padString(length, str) {
    while (str.length < length) {
        str += " ";
    }return str;
}
exports.padString = padString;
function kebobString(camelCase) {
    return camelCase.replace(/^([A-Z])/, function ($1) {
        return $1.toLowerCase();
    }) // replace first char
    .replace(/([A-Z])/g, function ($1) {
        return "-" + $1.toLowerCase();
    }); // replace rest
}
exports.kebobString = kebobString;
function _toJson(obj) {
    return JSON.stringify(obj);
}
function _fromJson(json) {
    return predicates_1.isString(json) ? JSON.parse(json) : json;
}
function promiseToString(p) {
    return "Promise(" + JSON.stringify(p) + ")";
}
function functionToString(fn) {
    var fnStr = fnToString(fn);
    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
    var fnName = fn['name'] || "";
    if (fnName && toStr.match(/function \(/)) {
        return 'function ' + fnName + toStr.substr(9);
    }
    return toStr;
}
exports.functionToString = functionToString;
function fnToString(fn) {
    var _fn = predicates_1.isArray(fn) ? fn.slice(-1)[0] : fn;
    return _fn && _fn.toString() || "undefined";
}
exports.fnToString = fnToString;
var stringifyPatternFn = null;
var stringifyPattern = function stringifyPattern(value) {
    var isTransitionRejectionPromise = rejectFactory_1.Rejection.isTransitionRejectionPromise;
    stringifyPatternFn = stringifyPatternFn || hof_1.pattern([[hof_1.not(predicates_1.isDefined), hof_1.val("undefined")], [predicates_1.isNull, hof_1.val("null")], [predicates_1.isPromise, hof_1.val("[Promise]")], [isTransitionRejectionPromise, function (x) {
        return x._transitionRejection.toString();
    }], [hof_1.is(rejectFactory_1.Rejection), hof_1.invoke("toString")], [hof_1.is(transition_1.Transition), hof_1.invoke("toString")], [hof_1.is(resolvable_1.Resolvable), hof_1.invoke("toString")], [predicates_1.isInjectable, functionToString], [hof_1.val(true), common_1.identity]]);
    return stringifyPatternFn(value);
};
function stringify(o) {
    var seen = [];
    function format(val) {
        if (predicates_1.isObject(val)) {
            if (seen.indexOf(val) !== -1) return '[circular ref]';
            seen.push(val);
        }
        return stringifyPattern(val);
    }
    return JSON.stringify(o, function (key, val) {
        return format(val);
    }).replace(/\\"/g, '"');
}
exports.stringify = stringify;
/** Returns a function that splits a string on a character or substring */
exports.beforeAfterSubstr = function (char) {
    return function (str) {
        if (!str) return ["", ""];
        var idx = str.indexOf(char);
        if (idx === -1) return [str, ""];
        return [str.substr(0, idx), str.substr(idx + 1)];
    };
};
/**
 * Splits on a delimiter, but returns the delimiters in the array
 *
 * #### Example:
 * ```js
 * var splitOnSlashes = splitOnDelim('/');
 * splitOnSlashes("/foo"); // ["/", "foo"]
 * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
 * ```
 */
function splitOnDelim(delim) {
    var re = new RegExp("(" + delim + ")", "g");
    return function (str) {
        return str.split(re).filter(common_1.identity);
    };
}
exports.splitOnDelim = splitOnDelim;
;
/**
 * Reduce fn that joins neighboring strings
 *
 * Given an array of strings, returns a new array
 * where all neighboring strings have been joined.
 *
 * #### Example:
 * ```js
 * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
 * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
 * ```
 */
function joinNeighborsR(acc, x) {
    if (predicates_1.isString(common_1.tail(acc)) && predicates_1.isString(x)) return acc.slice(0, -1).concat(common_1.tail(acc) + x);
    return common_1.pushR(acc, x);
}
exports.joinNeighborsR = joinNeighborsR;
;
//# sourceMappingURL=strings.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseMatches = __webpack_require__(295),
    baseMatchesProperty = __webpack_require__(296),
    identity = __webpack_require__(46),
    isArray = __webpack_require__(4),
    property = __webpack_require__(388);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
    return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsNative = __webpack_require__(290),
    getValue = __webpack_require__(331);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(113),
    isLength = __webpack_require__(76);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module state
 */ /** for typedoc */


var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
/**
 * Encapsulate the target (destination) state/params/options of a [[Transition]].
 *
 * This class is frequently used to redirect a transition to a new destination.
 *
 * See:
 *
 * - [[HookResult]]
 * - [[TransitionHookFn]]
 * - [[TransitionService.onStart]]
 *
 * To create a `TargetState`, use [[StateService.target]].
 *
 * ---
 *
 * This class wraps:
 *
 * 1) an identifier for a state
 * 2) a set of parameters
 * 3) and transition options
 * 4) the registered state object (the [[StateDeclaration]])
 *
 * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
 * either be a *state object* (a [[StateDeclaration]] or [[State]]) or a *state name* (a string).
 * The `TargetState` class normalizes those options.
 *
 * A `TargetState` may be valid (the state being targeted exists in the registry)
 * or invalid (the state being targeted is not registered).
 */
var TargetState = function () {
    /**
     * The TargetState constructor
     *
     * Note: Do not construct a `TargetState` manually.
     * To create a `TargetState`, use the [[StateService.target]] factory method.
     *
     * @param _identifier An identifier for a state.
     *    Either a fully-qualified state name, or the object used to define the state.
     * @param _definition The internal state representation, if exists.
     * @param _params Parameters for the target state
     * @param _options Transition options.
     *
     * @internalapi
     */
    function TargetState(_identifier, _definition, _params, _options) {
        if (_options === void 0) {
            _options = {};
        }
        this._identifier = _identifier;
        this._definition = _definition;
        this._options = _options;
        this._params = _params || {};
    }
    /** The name of the state this object targets */
    TargetState.prototype.name = function () {
        return this._definition && this._definition.name || this._identifier;
    };
    /** The identifier used when creating this TargetState */
    TargetState.prototype.identifier = function () {
        return this._identifier;
    };
    /** The target parameter values */
    TargetState.prototype.params = function () {
        return this._params;
    };
    /** The internal state object (if it was found) */
    TargetState.prototype.$state = function () {
        return this._definition;
    };
    /** The internal state declaration (if it was found) */
    TargetState.prototype.state = function () {
        return this._definition && this._definition.self;
    };
    /** The target options */
    TargetState.prototype.options = function () {
        return this._options;
    };
    /** True if the target state was found */
    TargetState.prototype.exists = function () {
        return !!(this._definition && this._definition.self);
    };
    /** True if the object is valid */
    TargetState.prototype.valid = function () {
        return !this.error();
    };
    /** If the object is invalid, returns the reason why */
    TargetState.prototype.error = function () {
        var base = this.options().relative;
        if (!this._definition && !!base) {
            var stateName = base.name ? base.name : base;
            return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
        }
        if (!this._definition) return "No such state '" + this.name() + "'";
        if (!this._definition.self) return "State '" + this.name() + "' has an invalid definition";
    };
    TargetState.prototype.toString = function () {
        return "'" + this.name() + "'" + common_1.toJson(this.params());
    };
    return TargetState;
}();
/** Returns true if the object has a state property that might be a state or state name */
TargetState.isDef = function (obj) {
    return obj && obj.state && (predicates_1.isString(obj.state) || predicates_1.isString(obj.state.name));
};
exports.TargetState = TargetState;
//# sourceMappingURL=targetState.js.map

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ng_from_import = __webpack_require__(36);
var ng_from_global = angular;
exports.ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;
//# sourceMappingURL=angular.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(10);

/** Built-in value references. */
var _Symbol = root.Symbol;

module.exports = _Symbol;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(21),
    getRawTag = __webpack_require__(330),
    objectToString = __webpack_require__(358);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayLikeKeys = __webpack_require__(92),
    baseKeys = __webpack_require__(96),
    isArrayLike = __webpack_require__(18);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * UI-Router Transition Tracing
 *
 * Enable transition tracing to print transition information to the console,
 * in order to help debug your application.
 * Tracing logs detailed information about each Transition to your console.
 *
 * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
 *
 * ### ES6
 * ```js
 * import {trace} from "ui-router-ng2"; // or "angular-ui-router"
 * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
 * ```
 *
 * ### CJS
 * ```js
 * let trace = require("angular-ui-router").trace; // or "ui-router-ng2"
 * trace.enable("TRANSITION", "VIEWCONFIG");
 * ```
 *
 * ### Globals
 * ```js
 * let trace = window["angular-ui-router"].trace; // or "ui-router-ng2"
 * trace.enable(); // Trace everything (very verbose)
 * ```
 *
 * ### Angular 1:
 * ```js
 * app.run($trace => $trace.enable());
 * ```
 *
 * @coreapi
 * @module trace
 */ /** for typedoc */

var hof_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(1);
var strings_1 = __webpack_require__(15);
/** @hidden */
function uiViewString(viewData) {
    if (!viewData) return 'ui-view (defunct)';
    return "[ui-view#" + viewData.id + " tag " + ("in template from '" + (viewData.creationContext && viewData.creationContext.name || '(root)') + "' state]: ") + ("fqn: '" + viewData.fqn + "', ") + ("name: '" + viewData.name + "@" + viewData.creationContext + "')");
}
/** @hidden */
var viewConfigString = function viewConfigString(viewConfig) {
    return "[ViewConfig#" + viewConfig.$id + " from '" + (viewConfig.viewDecl.$context.name || '(root)') + "' state]: target ui-view: '" + viewConfig.viewDecl.$uiViewName + "@" + viewConfig.viewDecl.$uiViewContextAnchor + "'";
};
/** @hidden */
function normalizedCat(input) {
    return predicates_1.isNumber(input) ? Category[input] : Category[Category[input]];
}
/**
 * Trace categories Enum
 *
 * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
 *
 * `trace.enable(Category.TRANSITION)`
 *
 * These can also be provided using a matching string, or position ordinal
 *
 * `trace.enable("TRANSITION")`
 *
 * `trace.enable(1)`
 */
var Category;
(function (Category) {
    Category[Category["RESOLVE"] = 0] = "RESOLVE";
    Category[Category["TRANSITION"] = 1] = "TRANSITION";
    Category[Category["HOOK"] = 2] = "HOOK";
    Category[Category["UIVIEW"] = 3] = "UIVIEW";
    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
})(Category = exports.Category || (exports.Category = {}));
/**
 * Prints UI-Router Transition trace information to the console.
 */
var Trace = function () {
    /** @hidden */
    function Trace() {
        /** @hidden */
        this._enabled = {};
        this.approximateDigests = 0;
    }
    /** @hidden */
    Trace.prototype._set = function (enabled, categories) {
        var _this = this;
        if (!categories.length) {
            categories = Object.keys(Category).map(function (k) {
                return parseInt(k, 10);
            }).filter(function (k) {
                return !isNaN(k);
            }).map(function (key) {
                return Category[key];
            });
        }
        categories.map(normalizedCat).forEach(function (category) {
            return _this._enabled[category] = enabled;
        });
    };
    /**
     * Enables a trace [[Category]]
     *
     * ```js
     * trace.enable("TRANSITION");
     * ```
     *
     * @param categories categories to enable. If `categories` is omitted, all categories are enabled.
     *        Also takes strings (category name) or ordinal (category position)
     */
    Trace.prototype.enable = function () {
        var categories = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            categories[_i] = arguments[_i];
        }
        this._set(true, categories);
    };
    /**
     * Disables a trace [[Category]]
     *
     * ```js
     * trace.disable("VIEWCONFIG");
     * ```
     *
     * @param categories categories to disable. If `categories` is omitted, all categories are disabled.
     *        Also takes strings (category name) or ordinal (category position)
     */
    Trace.prototype.disable = function () {
        var categories = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            categories[_i] = arguments[_i];
        }
        this._set(false, categories);
    };
    /**
     * Retrieves the enabled stateus of a [[Category]]
     *
     * ```js
     * trace.enabled("VIEWCONFIG"); // true or false
     * ```
     *
     * @returns boolean true if the category is enabled
     */
    Trace.prototype.enabled = function (category) {
        return !!this._enabled[normalizedCat(category)];
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceTransitionStart = function (trans) {
        if (!this.enabled(Category.TRANSITION)) return;
        var tid = trans.$id,
            digest = this.approximateDigests,
            transitionStr = strings_1.stringify(trans);
        console.log("Transition #" + tid + " r" + trans.router.$id + ": Started  -> " + transitionStr);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceTransitionIgnored = function (trans) {
        if (!this.enabled(Category.TRANSITION)) return;
        var tid = trans && trans.$id,
            digest = this.approximateDigests,
            transitionStr = strings_1.stringify(trans);
        console.log("Transition #" + tid + " r" + trans.router.$id + ": Ignored  <> " + transitionStr);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceHookInvocation = function (step, trans, options) {
        if (!this.enabled(Category.HOOK)) return;
        var tid = hof_1.parse("transition.$id")(options),
            digest = this.approximateDigests,
            event = hof_1.parse("traceData.hookType")(options) || "internal",
            context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown",
            name = strings_1.functionToString(step.registeredHook.callback);
        console.log("Transition #" + tid + " r" + trans.router.$id + ":   Hook -> " + event + " context: " + context + ", " + strings_1.maxLength(200, name));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
        if (!this.enabled(Category.HOOK)) return;
        var tid = hof_1.parse("transition.$id")(transitionOptions),
            digest = this.approximateDigests,
            hookResultStr = strings_1.stringify(hookResult);
        console.log("Transition #" + tid + " r" + trans.router.$id + ":   <- Hook returned: " + strings_1.maxLength(200, hookResultStr));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceResolvePath = function (path, when, trans) {
        if (!this.enabled(Category.RESOLVE)) return;
        var tid = trans && trans.$id,
            digest = this.approximateDigests,
            pathStr = path && path.toString();
        console.log("Transition #" + tid + " r" + trans.router.$id + ":         Resolving " + pathStr + " (" + when + ")");
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
        if (!this.enabled(Category.RESOLVE)) return;
        var tid = trans && trans.$id,
            digest = this.approximateDigests,
            resolvableStr = resolvable && resolvable.toString(),
            result = strings_1.stringify(resolvable.data);
        console.log("Transition #" + tid + " r" + trans.router.$id + ":               <- Resolved  " + resolvableStr + " to: " + strings_1.maxLength(200, result));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceError = function (reason, trans) {
        if (!this.enabled(Category.TRANSITION)) return;
        var tid = trans && trans.$id,
            digest = this.approximateDigests,
            transitionStr = strings_1.stringify(trans);
        console.log("Transition #" + tid + " r" + trans.router.$id + ": <- Rejected " + transitionStr + ", reason: " + reason);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceSuccess = function (finalState, trans) {
        if (!this.enabled(Category.TRANSITION)) return;
        var tid = trans && trans.$id,
            digest = this.approximateDigests,
            state = finalState.name,
            transitionStr = strings_1.stringify(trans);
        console.log("Transition #" + tid + " r" + trans.router.$id + ": <- Success  " + transitionStr + ", final state: " + state);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
        if (extra === void 0) {
            extra = "";
        }
        if (!this.enabled(Category.UIVIEW)) return;
        console.log("ui-view: " + strings_1.padString(30, event) + " " + uiViewString(viewData) + extra);
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
        if (!this.enabled(Category.UIVIEW)) return;
        this.traceUIViewEvent("Updating", viewData, " with ViewConfig from context='" + context + "'");
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceUIViewFill = function (viewData, html) {
        if (!this.enabled(Category.UIVIEW)) return;
        this.traceUIViewEvent("Fill", viewData, " with: " + strings_1.maxLength(200, html));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
        if (!this.enabled(Category.VIEWCONFIG)) return;
        console.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
    };
    /** @internalapi called by ui-router code */
    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
        if (!this.enabled(Category.VIEWCONFIG)) return;
        console.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
    };
    return Trace;
}();
exports.Trace = Trace;
/**
 * The [[Trace]] singleton
 *
 * #### Example:
 * ```js
 * import {trace} from "angular-ui-router";
 * trace.enable(1, 5);
 * ```
 */
var trace = new Trace();
exports.trace = trace;
//# sourceMappingURL=trace.js.map

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @internalapi
 * @module params
 */ /** for typedoc */

var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(1);
var coreservices_1 = __webpack_require__(6);
var paramType_1 = __webpack_require__(81);
var hasOwn = Object.prototype.hasOwnProperty;
var isShorthand = function isShorthand(cfg) {
    return ["value", "type", "squash", "array", "dynamic"].filter(hasOwn.bind(cfg || {})).length === 0;
};
var DefType;
(function (DefType) {
    DefType[DefType["PATH"] = 0] = "PATH";
    DefType[DefType["SEARCH"] = 1] = "SEARCH";
    DefType[DefType["CONFIG"] = 2] = "CONFIG";
})(DefType = exports.DefType || (exports.DefType = {}));
function unwrapShorthand(cfg) {
    cfg = isShorthand(cfg) && { value: cfg } || cfg;
    return common_1.extend(cfg, {
        $$fn: predicates_1.isInjectable(cfg.value) ? cfg.value : function () {
            return cfg.value;
        }
    });
}
function getType(cfg, urlType, location, id, paramTypes) {
    if (cfg.type && urlType && urlType.name !== 'string') throw new Error("Param '" + id + "' has two type configurations.");
    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type)) return paramTypes.type(cfg.type);
    if (urlType) return urlType;
    if (!cfg.type) {
        var type = location === DefType.CONFIG ? "any" : location === DefType.PATH ? "path" : location === DefType.SEARCH ? "query" : "string";
        return paramTypes.type(type);
    }
    return cfg.type instanceof paramType_1.ParamType ? cfg.type : paramTypes.type(cfg.type);
}
/**
 * returns false, true, or the squash value to indicate the "default parameter url squash policy".
 */
function getSquashPolicy(config, isOptional, defaultPolicy) {
    var squash = config.squash;
    if (!isOptional || squash === false) return false;
    if (!predicates_1.isDefined(squash) || squash == null) return defaultPolicy;
    if (squash === true || predicates_1.isString(squash)) return squash;
    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
}
function getReplace(config, arrayMode, isOptional, squash) {
    var replace,
        configuredKeys,
        defaultPolicy = [{ from: "", to: isOptional || arrayMode ? undefined : "" }, { from: null, to: isOptional || arrayMode ? undefined : "" }];
    replace = predicates_1.isArray(config.replace) ? config.replace : [];
    if (predicates_1.isString(squash)) replace.push({ from: squash, to: undefined });
    configuredKeys = common_1.map(replace, hof_1.prop("from"));
    return common_1.filter(defaultPolicy, function (item) {
        return configuredKeys.indexOf(item.from) === -1;
    }).concat(replace);
}
var Param = function () {
    function Param(id, type, config, location, urlMatcherFactory) {
        config = unwrapShorthand(config);
        type = getType(config, type, location, id, urlMatcherFactory.paramTypes);
        var arrayMode = getArrayMode();
        type = arrayMode ? type.$asArray(arrayMode, location === DefType.SEARCH) : type;
        var isOptional = config.value !== undefined || location === DefType.SEARCH;
        var dynamic = predicates_1.isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
        var raw = predicates_1.isDefined(config.raw) ? !!config.raw : !!type.raw;
        var squash = getSquashPolicy(config, isOptional, urlMatcherFactory.defaultSquashPolicy());
        var replace = getReplace(config, arrayMode, isOptional, squash);
        var inherit = predicates_1.isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
        // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
        function getArrayMode() {
            var arrayDefaults = { array: location === DefType.SEARCH ? "auto" : false };
            var arrayParamNomenclature = id.match(/\[\]$/) ? { array: true } : {};
            return common_1.extend(arrayDefaults, arrayParamNomenclature, config).array;
        }
        common_1.extend(this, { id: id, type: type, location: location, isOptional: isOptional, dynamic: dynamic, raw: raw, squash: squash, replace: replace, inherit: inherit, array: arrayMode, config: config });
    }
    Param.prototype.isDefaultValue = function (value) {
        return this.isOptional && this.type.equals(this.value(), value);
    };
    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    Param.prototype.value = function (value) {
        var _this = this;
        /**
         * [Internal] Get the default value of a parameter, which may be an injectable function.
         */
        var $$getDefaultValue = function $$getDefaultValue() {
            if (!coreservices_1.services.$injector) throw new Error("Injectable functions cannot be called at configuration time");
            var defaultValue = coreservices_1.services.$injector.invoke(_this.config.$$fn);
            if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue)) throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
            return defaultValue;
        };
        var $replace = function $replace(val) {
            var replacement = common_1.map(common_1.filter(_this.replace, hof_1.propEq('from', val)), hof_1.prop("to"));
            return replacement.length ? replacement[0] : val;
        };
        value = $replace(value);
        return !predicates_1.isDefined(value) ? $$getDefaultValue() : this.type.$normalize(value);
    };
    Param.prototype.isSearch = function () {
        return this.location === DefType.SEARCH;
    };
    Param.prototype.validates = function (value) {
        // There was no parameter value, but the param is optional
        if ((!predicates_1.isDefined(value) || value === null) && this.isOptional) return true;
        // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
        var normalized = this.type.$normalize(value);
        if (!this.type.is(normalized)) return false;
        // The value was of the correct type, but when encoded, did not match the ParamType's regexp
        var encoded = this.type.encode(normalized);
        return !(predicates_1.isString(encoded) && !this.type.pattern.exec(encoded));
    };
    Param.prototype.toString = function () {
        return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
    };
    Param.values = function (params, values) {
        if (values === void 0) {
            values = {};
        }
        return params.map(function (param) {
            return [param.id, param.value(values[param.id])];
        }).reduce(common_1.applyPairs, {});
    };
    /**
     * Finds [[Param]] objects which have different param values
     *
     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
     *
     * @param params: The list of Param objects to filter
     * @param values1: The first set of parameter values
     * @param values2: the second set of parameter values
     *
     * @returns any Param objects whose values were different between values1 and values2
     */
    Param.changed = function (params, values1, values2) {
        if (values1 === void 0) {
            values1 = {};
        }
        if (values2 === void 0) {
            values2 = {};
        }
        return params.filter(function (param) {
            return !param.type.equals(values1[param.id], values2[param.id]);
        });
    };
    /**
     * Checks if two param value objects are equal (for a set of [[Param]] objects)
     *
     * @param params The list of [[Param]] objects to check
     * @param values1 The first set of param values
     * @param values2 The second set of param values
     *
     * @returns true if the param values in values1 and values2 are equal
     */
    Param.equals = function (params, values1, values2) {
        if (values1 === void 0) {
            values1 = {};
        }
        if (values2 === void 0) {
            values2 = {};
        }
        return Param.changed(params, values1, values2).length === 0;
    };
    /** Returns true if a the parameter values are valid, according to the Param definitions */
    Param.validates = function (params, values) {
        if (values === void 0) {
            values = {};
        }
        return params.map(function (param) {
            return param.validates(values[param.id]);
        }).reduce(common_1.allTrueR, true);
    };
    return Param;
}();
exports.Param = Param;
//# sourceMappingURL=param.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseForOwn = __webpack_require__(94),
    createBaseEach = __webpack_require__(321);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assignValue = __webpack_require__(39),
    baseAssignValue = __webpack_require__(63);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DataView = __webpack_require__(264),
    Map = __webpack_require__(59),
    Promise = __webpack_require__(266),
    Set = __webpack_require__(267),
    WeakMap = __webpack_require__(269),
    baseGetTag = __webpack_require__(22),
    toSource = __webpack_require__(110);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function getTag(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

module.exports = getTag;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isSymbol = __webpack_require__(47);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = toKey;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module resolve
 */ /** for typedoc */

var common_1 = __webpack_require__(0);
var coreservices_1 = __webpack_require__(6);
var trace_1 = __webpack_require__(24);
var strings_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(1);
// TODO: explicitly make this user configurable
exports.defaultResolvePolicy = {
    when: "LAZY",
    async: "WAIT"
};
/**
 * The basic building block for the resolve system.
 *
 * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
 * and the unwrapped-when-complete (.data) result of the resolveFn.
 *
 * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
 * resolveFn) and returns the resulting promise.
 *
 * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
 * parameter to those fns.
 */
var Resolvable = function () {
    function Resolvable(arg1, resolveFn, deps, policy, data) {
        this.resolved = false;
        this.promise = undefined;
        if (arg1 instanceof Resolvable) {
            common_1.extend(this, arg1);
        } else if (predicates_1.isFunction(resolveFn)) {
            if (arg1 == null || arg1 == undefined) throw new Error("new Resolvable(): token argument is required");
            if (!predicates_1.isFunction(resolveFn)) throw new Error("new Resolvable(): resolveFn argument must be a function");
            this.token = arg1;
            this.policy = policy;
            this.resolveFn = resolveFn;
            this.deps = deps || [];
            this.data = data;
            this.resolved = data !== undefined;
            this.promise = this.resolved ? coreservices_1.services.$q.when(this.data) : undefined;
        } else if (predicates_1.isObject(arg1) && arg1.token && predicates_1.isFunction(arg1.resolveFn)) {
            var literal = arg1;
            return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
        }
    }
    Resolvable.prototype.getPolicy = function (state) {
        var thisPolicy = this.policy || {};
        var statePolicy = state && state.resolvePolicy || {};
        return {
            when: thisPolicy.when || statePolicy.when || exports.defaultResolvePolicy.when,
            async: thisPolicy.async || statePolicy.async || exports.defaultResolvePolicy.async
        };
    };
    /**
     * Asynchronously resolve this Resolvable's data
     *
     * Given a ResolveContext that this Resolvable is found in:
     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
     * and update the Resolvable's state
     */
    Resolvable.prototype.resolve = function (resolveContext, trans) {
        var _this = this;
        var $q = coreservices_1.services.$q;
        // Gets all dependencies from ResolveContext and wait for them to be resolved
        var getResolvableDependencies = function getResolvableDependencies() {
            return $q.all(resolveContext.getDependencies(_this).map(function (r) {
                return r.get(resolveContext, trans);
            }));
        };
        // Invokes the resolve function passing the resolved dependencies as arguments
        var invokeResolveFn = function invokeResolveFn(resolvedDeps) {
            return _this.resolveFn.apply(null, resolvedDeps);
        };
        /**
         * For RXWAIT policy:
         *
         * Given an observable returned from a resolve function:
         * - enables .cache() mode (this allows multicast subscribers)
         * - then calls toPromise() (this triggers subscribe() and thus fetches)
         * - Waits for the promise, then return the cached observable (not the first emitted value).
         */
        var waitForRx = function waitForRx(observable$) {
            var cached = observable$.cache(1);
            return cached.take(1).toPromise().then(function () {
                return cached;
            });
        };
        // If the resolve policy is RXWAIT, wait for the observable to emit something. otherwise pass through.
        var node = resolveContext.findNode(this);
        var state = node && node.state;
        var maybeWaitForRx = this.getPolicy(state).async === "RXWAIT" ? waitForRx : common_1.identity;
        // After the final value has been resolved, update the state of the Resolvable
        var applyResolvedValue = function applyResolvedValue(resolvedValue) {
            _this.data = resolvedValue;
            _this.resolved = true;
            trace_1.trace.traceResolvableResolved(_this, trans);
            return _this.data;
        };
        // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
        return this.promise = $q.when().then(getResolvableDependencies).then(invokeResolveFn).then(maybeWaitForRx).then(applyResolvedValue);
    };
    /**
     * Gets a promise for this Resolvable's data.
     *
     * Fetches the data and returns a promise.
     * Returns the existing promise if it has already been fetched once.
     */
    Resolvable.prototype.get = function (resolveContext, trans) {
        return this.promise || this.resolve(resolveContext, trans);
    };
    Resolvable.prototype.toString = function () {
        return "Resolvable(token: " + strings_1.stringify(this.token) + ", requires: [" + this.deps.map(strings_1.stringify) + "])";
    };
    Resolvable.prototype.clone = function () {
        return new Resolvable(this);
    };
    return Resolvable;
}();
Resolvable.fromData = function (token, data) {
    return new Resolvable(token, function () {
        return data;
    }, null, null, data);
};
exports.Resolvable = Resolvable;
//# sourceMappingURL=resolvable.js.map

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var TransitionHookPhase;
(function (TransitionHookPhase) {
    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
    TransitionHookPhase[TransitionHookPhase["ASYNC"] = 2] = "ASYNC";
    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
})(TransitionHookPhase = exports.TransitionHookPhase || (exports.TransitionHookPhase = {}));
var TransitionHookScope;
(function (TransitionHookScope) {
    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
})(TransitionHookScope = exports.TransitionHookScope || (exports.TransitionHookScope = {}));
//# sourceMappingURL=interface.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module transition
 */ /** for typedoc */


var common_1 = __webpack_require__(0);
var strings_1 = __webpack_require__(15);
var RejectType;
(function (RejectType) {
    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
    RejectType[RejectType["INVALID"] = 4] = "INVALID";
    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
    RejectType[RejectType["ERROR"] = 6] = "ERROR";
})(RejectType = exports.RejectType || (exports.RejectType = {}));
var Rejection = function () {
    function Rejection(type, message, detail) {
        this.type = type;
        this.message = message;
        this.detail = detail;
    }
    Rejection.prototype.toString = function () {
        var detailString = function detailString(d) {
            return d && d.toString !== Object.prototype.toString ? d.toString() : strings_1.stringify(d);
        };
        var type = this.type,
            message = this.message,
            detail = detailString(this.detail);
        return "TransitionRejection(type: " + type + ", message: " + message + ", detail: " + detail + ")";
    };
    Rejection.prototype.toPromise = function () {
        return common_1.extend(common_1.silentRejection(this), { _transitionRejection: this });
    };
    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
    Rejection.isTransitionRejectionPromise = function (obj) {
        return obj && typeof obj.then === 'function' && obj._transitionRejection instanceof Rejection;
    };
    /** Returns a TransitionRejection due to transition superseded */
    Rejection.superseded = function (detail, options) {
        var message = "The transition has been superseded by a different transition";
        var rejection = new Rejection(RejectType.SUPERSEDED, message, detail);
        if (options && options.redirected) {
            rejection.redirected = true;
        }
        return rejection;
    };
    /** Returns a TransitionRejection due to redirected transition */
    Rejection.redirected = function (detail) {
        return Rejection.superseded(detail, { redirected: true });
    };
    /** Returns a TransitionRejection due to invalid transition */
    Rejection.invalid = function (detail) {
        var message = "This transition is invalid";
        return new Rejection(RejectType.INVALID, message, detail);
    };
    /** Returns a TransitionRejection due to ignored transition */
    Rejection.ignored = function (detail) {
        var message = "The transition was ignored";
        return new Rejection(RejectType.IGNORED, message, detail);
    };
    /** Returns a TransitionRejection due to aborted transition */
    Rejection.aborted = function (detail) {
        // TODO think about how to encapsulate an Error() object
        var message = "The transition has been aborted";
        return new Rejection(RejectType.ABORTED, message, detail);
    };
    /** Returns a TransitionRejection due to aborted transition */
    Rejection.errored = function (detail) {
        // TODO think about how to encapsulate an Error() object
        var message = "The transition errored";
        return new Rejection(RejectType.ERROR, message, detail);
    };
    return Rejection;
}();
exports.Rejection = Rejection;
//# sourceMappingURL=rejectFactory.js.map

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var common_1 = __webpack_require__(0);
var strings_1 = __webpack_require__(15);
var predicates_1 = __webpack_require__(1);
var hof_1 = __webpack_require__(3);
var trace_1 = __webpack_require__(24);
var coreservices_1 = __webpack_require__(6);
var rejectFactory_1 = __webpack_require__(33);
var targetState_1 = __webpack_require__(19);
var defaultOptions = {
    current: common_1.noop,
    transition: null,
    traceData: {},
    bind: null
};
/** @hidden */
var TransitionHook = function () {
    function TransitionHook(transition, stateContext, registeredHook, options) {
        var _this = this;
        this.transition = transition;
        this.stateContext = stateContext;
        this.registeredHook = registeredHook;
        this.options = options;
        this.stateService = function () {
            return _this.transition.router.stateService;
        };
        this.rejectIfSuperseded = function () {
            return _this.registeredHook.eventType.rejectIfSuperseded && _this.options.current() !== _this.options.transition;
        };
        this.options = common_1.defaults(options, defaultOptions);
    }
    TransitionHook.prototype.invokeHook = function () {
        var hook = this.registeredHook;
        if (hook._deregistered) return;
        var options = this.options;
        trace_1.trace.traceHookInvocation(this, this.transition, options);
        if (this.rejectIfSuperseded()) {
            return rejectFactory_1.Rejection.superseded(options.current()).toPromise();
        }
        var cb = hook.callback;
        var bind = this.options.bind;
        var trans = this.transition;
        var state = this.stateContext;
        var errorHandler = hook.eventType.getErrorHandler(this);
        var resultHandler = hook.eventType.getResultHandler(this);
        resultHandler = resultHandler || common_1.identity;
        if (!errorHandler) {
            return resultHandler(cb.call(bind, trans, state));
        }
        try {
            return resultHandler(cb.call(bind, trans, state));
        } catch (error) {
            return errorHandler(error);
        }
    };
    /**
     * This method handles the return value of a Transition Hook.
     *
     * A hook can return false (cancel), a TargetState (redirect),
     * or a promise (which may later resolve to false or a redirect)
     *
     * This also handles "transition superseded" -- when a new transition
     * was started while the hook was still running
     */
    TransitionHook.prototype.handleHookResult = function (result) {
        // This transition is no longer current.
        // Another transition started while this hook was still running.
        if (this.rejectIfSuperseded()) {
            // Abort this transition
            return rejectFactory_1.Rejection.superseded(this.options.current()).toPromise();
        }
        // Hook returned a promise
        if (predicates_1.isPromise(result)) {
            // Wait for the promise, then reprocess the resolved value
            return result.then(this.handleHookResult.bind(this));
        }
        trace_1.trace.traceHookResult(result, this.transition, this.options);
        // Hook returned false
        if (result === false) {
            // Abort this Transition
            return rejectFactory_1.Rejection.aborted("Hook aborted transition").toPromise();
        }
        var isTargetState = hof_1.is(targetState_1.TargetState);
        // hook returned a TargetState
        if (isTargetState(result)) {
            // Halt the current Transition and start a redirected Transition (to the TargetState).
            return rejectFactory_1.Rejection.redirected(result).toPromise();
        }
    };
    TransitionHook.prototype.toString = function () {
        var _a = this,
            options = _a.options,
            registeredHook = _a.registeredHook;
        var event = hof_1.parse("traceData.hookType")(options) || "internal",
            context = hof_1.parse("traceData.context.state.name")(options) || hof_1.parse("traceData.context")(options) || "unknown",
            name = strings_1.fnToString(registeredHook.callback);
        return event + " context: " + context + ", " + strings_1.maxLength(200, name);
    };
    /**
     * Run all TransitionHooks, ignoring their return value.
     */
    TransitionHook.runAllHooks = function (hooks) {
        hooks.forEach(function (hook) {
            return hook.invokeHook();
        });
    };
    /**
     * Given an array of TransitionHooks, runs each one synchronously and sequentially.
     * Should any hook return a Rejection synchronously, the remaining hooks will not run.
     *
     * Returns a promise chain composed of any promises returned from each hook.invokeStep() call
     */
    TransitionHook.runOnBeforeHooks = function (hooks) {
        var results = [];
        for (var _i = 0, hooks_1 = hooks; _i < hooks_1.length; _i++) {
            var hook = hooks_1[_i];
            var hookResult = hook.invokeHook();
            if (rejectFactory_1.Rejection.isTransitionRejectionPromise(hookResult)) {
                // Break on first thrown error or false/TargetState
                return hookResult;
            }
            results.push(hookResult);
        }
        return results.filter(predicates_1.isPromise).reduce(function (chain, promise) {
            return chain.then(hof_1.val(promise));
        }, coreservices_1.services.$q.when());
    };
    return TransitionHook;
}();
TransitionHook.HANDLE_RESULT = function (hook) {
    return function (result) {
        return hook.handleHookResult(result);
    };
};
TransitionHook.IGNORE_RESULT = function (hook) {
    return function (result) {
        return undefined;
    };
};
TransitionHook.LOG_ERROR = function (hook) {
    return function (error) {
        return hook.stateService().defaultErrorHandler()(error), undefined;
    };
};
TransitionHook.REJECT_ERROR = function (hook) {
    return function (error) {
        return rejectFactory_1.Rejection.errored(error).toPromise();
    };
};
TransitionHook.THROW_ERROR = function (hook) {
    return undefined;
};
exports.TransitionHook = TransitionHook;
//# sourceMappingURL=transitionHook.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(233);

var MODULE_NAME = 'ui.bootstrap.module.position';

angular.module(MODULE_NAME, ['ui.bootstrap.position']);

module.exports = MODULE_NAME;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(262);
module.exports = angular;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4+314e4831
 */

(function (global, factory) {
  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.ES6Promise = factory();
})(undefined, function () {
  'use strict';

  function objectOrFunction(x) {
    var type = typeof x === 'undefined' ? 'undefined' : _typeof(x);
    return x !== null && (type === 'object' || type === 'function');
  }

  function isFunction(x) {
    return typeof x === 'function';
  }

  var _isArray = void 0;
  if (Array.isArray) {
    _isArray = Array.isArray;
  } else {
    _isArray = function _isArray(x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    };
  }

  var isArray = _isArray;

  var len = 0;
  var vertxNext = void 0;
  var customSchedulerFn = void 0;

  var asap = function asap(callback, arg) {
    queue[len] = callback;
    queue[len + 1] = arg;
    len += 2;
    if (len === 2) {
      // If len is 2, that means that we need to schedule an async flush.
      // If additional callbacks are queued before the queue is flushed, they
      // will be processed by this flush that we are scheduling.
      if (customSchedulerFn) {
        customSchedulerFn(flush);
      } else {
        scheduleFlush();
      }
    }
  };

  function setScheduler(scheduleFn) {
    customSchedulerFn = scheduleFn;
  }

  function setAsap(asapFn) {
    asap = asapFn;
  }

  var browserWindow = typeof window !== 'undefined' ? window : undefined;
  var browserGlobal = browserWindow || {};
  var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
  var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

  // test for web worker but not in IE10
  var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

  // node
  function useNextTick() {
    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
    // see https://github.com/cujojs/when/issues/410 for details
    return function () {
      return process.nextTick(flush);
    };
  }

  // vertx
  function useVertxTimer() {
    if (typeof vertxNext !== 'undefined') {
      return function () {
        vertxNext(flush);
      };
    }

    return useSetTimeout();
  }

  function useMutationObserver() {
    var iterations = 0;
    var observer = new BrowserMutationObserver(flush);
    var node = document.createTextNode('');
    observer.observe(node, { characterData: true });

    return function () {
      node.data = iterations = ++iterations % 2;
    };
  }

  // web worker
  function useMessageChannel() {
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    return function () {
      return channel.port2.postMessage(0);
    };
  }

  function useSetTimeout() {
    // Store setTimeout reference so es6-promise will be unaffected by
    // other code modifying setTimeout (like sinon.useFakeTimers())
    var globalSetTimeout = setTimeout;
    return function () {
      return globalSetTimeout(flush, 1);
    };
  }

  var queue = new Array(1000);
  function flush() {
    for (var i = 0; i < len; i += 2) {
      var callback = queue[i];
      var arg = queue[i + 1];

      callback(arg);

      queue[i] = undefined;
      queue[i + 1] = undefined;
    }

    len = 0;
  }

  function attemptVertx() {
    try {
      var vertx = Function('return this')().require('vertx');
      vertxNext = vertx.runOnLoop || vertx.runOnContext;
      return useVertxTimer();
    } catch (e) {
      return useSetTimeout();
    }
  }

  var scheduleFlush = void 0;
  // Decide what async method to use to triggering processing of queued callbacks:
  if (isNode) {
    scheduleFlush = useNextTick();
  } else if (BrowserMutationObserver) {
    scheduleFlush = useMutationObserver();
  } else if (isWorker) {
    scheduleFlush = useMessageChannel();
  } else if (browserWindow === undefined && "function" === 'function') {
    scheduleFlush = attemptVertx();
  } else {
    scheduleFlush = useSetTimeout();
  }

  function then(onFulfillment, onRejection) {
    var parent = this;

    var child = new this.constructor(noop);

    if (child[PROMISE_ID] === undefined) {
      makePromise(child);
    }

    var _state = parent._state;

    if (_state) {
      var callback = arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    } else {
      subscribe(parent, child, onFulfillment, onRejection);
    }

    return child;
  }

  /**
    `Promise.resolve` returns a promise that will become resolved with the
    passed `value`. It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      resolve(1);
    });
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.resolve(1);
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    @method resolve
    @static
    @param {Any} value value that the returned promise will be resolved with
    Useful for tooling.
    @return {Promise} a promise that will become fulfilled with the given
    `value`
  */
  function resolve$1(object) {
    /*jshint validthis:true */
    var Constructor = this;

    if (object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && object.constructor === Constructor) {
      return object;
    }

    var promise = new Constructor(noop);
    resolve(promise, object);
    return promise;
  }

  var PROMISE_ID = Math.random().toString(36).substring(2);

  function noop() {}

  var PENDING = void 0;
  var FULFILLED = 1;
  var REJECTED = 2;

  var TRY_CATCH_ERROR = { error: null };

  function selfFulfillment() {
    return new TypeError("You cannot resolve a promise with itself");
  }

  function cannotReturnOwn() {
    return new TypeError('A promises callback cannot return that same promise.');
  }

  function getThen(promise) {
    try {
      return promise.then;
    } catch (error) {
      TRY_CATCH_ERROR.error = error;
      return TRY_CATCH_ERROR;
    }
  }

  function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
    try {
      then$$1.call(value, fulfillmentHandler, rejectionHandler);
    } catch (e) {
      return e;
    }
  }

  function handleForeignThenable(promise, thenable, then$$1) {
    asap(function (promise) {
      var sealed = false;
      var error = tryThen(then$$1, thenable, function (value) {
        if (sealed) {
          return;
        }
        sealed = true;
        if (thenable !== value) {
          resolve(promise, value);
        } else {
          fulfill(promise, value);
        }
      }, function (reason) {
        if (sealed) {
          return;
        }
        sealed = true;

        reject(promise, reason);
      }, 'Settle: ' + (promise._label || ' unknown promise'));

      if (!sealed && error) {
        sealed = true;
        reject(promise, error);
      }
    }, promise);
  }

  function handleOwnThenable(promise, thenable) {
    if (thenable._state === FULFILLED) {
      fulfill(promise, thenable._result);
    } else if (thenable._state === REJECTED) {
      reject(promise, thenable._result);
    } else {
      subscribe(thenable, undefined, function (value) {
        return resolve(promise, value);
      }, function (reason) {
        return reject(promise, reason);
      });
    }
  }

  function handleMaybeThenable(promise, maybeThenable, then$$1) {
    if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
      handleOwnThenable(promise, maybeThenable);
    } else {
      if (then$$1 === TRY_CATCH_ERROR) {
        reject(promise, TRY_CATCH_ERROR.error);
        TRY_CATCH_ERROR.error = null;
      } else if (then$$1 === undefined) {
        fulfill(promise, maybeThenable);
      } else if (isFunction(then$$1)) {
        handleForeignThenable(promise, maybeThenable, then$$1);
      } else {
        fulfill(promise, maybeThenable);
      }
    }
  }

  function resolve(promise, value) {
    if (promise === value) {
      reject(promise, selfFulfillment());
    } else if (objectOrFunction(value)) {
      handleMaybeThenable(promise, value, getThen(value));
    } else {
      fulfill(promise, value);
    }
  }

  function publishRejection(promise) {
    if (promise._onerror) {
      promise._onerror(promise._result);
    }

    publish(promise);
  }

  function fulfill(promise, value) {
    if (promise._state !== PENDING) {
      return;
    }

    promise._result = value;
    promise._state = FULFILLED;

    if (promise._subscribers.length !== 0) {
      asap(publish, promise);
    }
  }

  function reject(promise, reason) {
    if (promise._state !== PENDING) {
      return;
    }
    promise._state = REJECTED;
    promise._result = reason;

    asap(publishRejection, promise);
  }

  function subscribe(parent, child, onFulfillment, onRejection) {
    var _subscribers = parent._subscribers;
    var length = _subscribers.length;

    parent._onerror = null;

    _subscribers[length] = child;
    _subscribers[length + FULFILLED] = onFulfillment;
    _subscribers[length + REJECTED] = onRejection;

    if (length === 0 && parent._state) {
      asap(publish, parent);
    }
  }

  function publish(promise) {
    var subscribers = promise._subscribers;
    var settled = promise._state;

    if (subscribers.length === 0) {
      return;
    }

    var child = void 0,
        callback = void 0,
        detail = promise._result;

    for (var i = 0; i < subscribers.length; i += 3) {
      child = subscribers[i];
      callback = subscribers[i + settled];

      if (child) {
        invokeCallback(settled, child, callback, detail);
      } else {
        callback(detail);
      }
    }

    promise._subscribers.length = 0;
  }

  function tryCatch(callback, detail) {
    try {
      return callback(detail);
    } catch (e) {
      TRY_CATCH_ERROR.error = e;
      return TRY_CATCH_ERROR;
    }
  }

  function invokeCallback(settled, promise, callback, detail) {
    var hasCallback = isFunction(callback),
        value = void 0,
        error = void 0,
        succeeded = void 0,
        failed = void 0;

    if (hasCallback) {
      value = tryCatch(callback, detail);

      if (value === TRY_CATCH_ERROR) {
        failed = true;
        error = value.error;
        value.error = null;
      } else {
        succeeded = true;
      }

      if (promise === value) {
        reject(promise, cannotReturnOwn());
        return;
      }
    } else {
      value = detail;
      succeeded = true;
    }

    if (promise._state !== PENDING) {
      // noop
    } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
  }

  function initializePromise(promise, resolver) {
    try {
      resolver(function resolvePromise(value) {
        resolve(promise, value);
      }, function rejectPromise(reason) {
        reject(promise, reason);
      });
    } catch (e) {
      reject(promise, e);
    }
  }

  var id = 0;
  function nextId() {
    return id++;
  }

  function makePromise(promise) {
    promise[PROMISE_ID] = id++;
    promise._state = undefined;
    promise._result = undefined;
    promise._subscribers = [];
  }

  function validationError() {
    return new Error('Array Methods must be provided an Array');
  }

  var Enumerator = function () {
    function Enumerator(Constructor, input) {
      this._instanceConstructor = Constructor;
      this.promise = new Constructor(noop);

      if (!this.promise[PROMISE_ID]) {
        makePromise(this.promise);
      }

      if (isArray(input)) {
        this.length = input.length;
        this._remaining = input.length;

        this._result = new Array(this.length);

        if (this.length === 0) {
          fulfill(this.promise, this._result);
        } else {
          this.length = this.length || 0;
          this._enumerate(input);
          if (this._remaining === 0) {
            fulfill(this.promise, this._result);
          }
        }
      } else {
        reject(this.promise, validationError());
      }
    }

    Enumerator.prototype._enumerate = function _enumerate(input) {
      for (var i = 0; this._state === PENDING && i < input.length; i++) {
        this._eachEntry(input[i], i);
      }
    };

    Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
      var c = this._instanceConstructor;
      var resolve$$1 = c.resolve;

      if (resolve$$1 === resolve$1) {
        var _then = getThen(entry);

        if (_then === then && entry._state !== PENDING) {
          this._settledAt(entry._state, i, entry._result);
        } else if (typeof _then !== 'function') {
          this._remaining--;
          this._result[i] = entry;
        } else if (c === Promise$1) {
          var promise = new c(noop);
          handleMaybeThenable(promise, entry, _then);
          this._willSettleAt(promise, i);
        } else {
          this._willSettleAt(new c(function (resolve$$1) {
            return resolve$$1(entry);
          }), i);
        }
      } else {
        this._willSettleAt(resolve$$1(entry), i);
      }
    };

    Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
      var promise = this.promise;

      if (promise._state === PENDING) {
        this._remaining--;

        if (state === REJECTED) {
          reject(promise, value);
        } else {
          this._result[i] = value;
        }
      }

      if (this._remaining === 0) {
        fulfill(promise, this._result);
      }
    };

    Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
      var enumerator = this;

      subscribe(promise, undefined, function (value) {
        return enumerator._settledAt(FULFILLED, i, value);
      }, function (reason) {
        return enumerator._settledAt(REJECTED, i, reason);
      });
    };

    return Enumerator;
  }();

  /**
    `Promise.all` accepts an array of promises, and returns a new promise which
    is fulfilled with an array of fulfillment values for the passed promises, or
    rejected with the reason of the first passed promise to be rejected. It casts all
    elements of the passed iterable to promises as it runs this algorithm.
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = resolve(2);
    let promise3 = resolve(3);
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // The array here would be [ 1, 2, 3 ];
    });
    ```
  
    If any of the `promises` given to `all` are rejected, the first promise
    that is rejected will be given as an argument to the returned promises's
    rejection handler. For example:
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = reject(new Error("2"));
    let promise3 = reject(new Error("3"));
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // Code here never runs because there are rejected promises!
    }, function(error) {
      // error.message === "2"
    });
    ```
  
    @method all
    @static
    @param {Array} entries array of promises
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise} promise that is fulfilled when all `promises` have been
    fulfilled, or rejected if any of them become rejected.
    @static
  */
  function all(entries) {
    return new Enumerator(this, entries).promise;
  }

  /**
    `Promise.race` returns a new promise which is settled in the same way as the
    first passed promise to settle.
  
    Example:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 2');
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // result === 'promise 2' because it was resolved before promise1
      // was resolved.
    });
    ```
  
    `Promise.race` is deterministic in that only the state of the first
    settled promise matters. For example, even if other promises given to the
    `promises` array argument are resolved, but the first settled promise has
    become rejected before the other promises became fulfilled, the returned
    promise will become rejected:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        reject(new Error('promise 2'));
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // Code here never runs
    }, function(reason){
      // reason.message === 'promise 2' because promise 2 became rejected before
      // promise 1 became fulfilled
    });
    ```
  
    An example real-world use case is implementing timeouts:
  
    ```javascript
    Promise.race([ajax('foo.json'), timeout(5000)])
    ```
  
    @method race
    @static
    @param {Array} promises array of promises to observe
    Useful for tooling.
    @return {Promise} a promise which settles in the same way as the first passed
    promise to settle.
  */
  function race(entries) {
    /*jshint validthis:true */
    var Constructor = this;

    if (!isArray(entries)) {
      return new Constructor(function (_, reject) {
        return reject(new TypeError('You must pass an array to race.'));
      });
    } else {
      return new Constructor(function (resolve, reject) {
        var length = entries.length;
        for (var i = 0; i < length; i++) {
          Constructor.resolve(entries[i]).then(resolve, reject);
        }
      });
    }
  }

  /**
    `Promise.reject` returns a promise rejected with the passed `reason`.
    It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      reject(new Error('WHOOPS'));
    });
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.reject(new Error('WHOOPS'));
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    @method reject
    @static
    @param {Any} reason value that the returned promise will be rejected with.
    Useful for tooling.
    @return {Promise} a promise rejected with the given `reason`.
  */
  function reject$1(reason) {
    /*jshint validthis:true */
    var Constructor = this;
    var promise = new Constructor(noop);
    reject(promise, reason);
    return promise;
  }

  function needsResolver() {
    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
  }

  function needsNew() {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
  }

  /**
    Promise objects represent the eventual result of an asynchronous operation. The
    primary way of interacting with a promise is through its `then` method, which
    registers callbacks to receive either a promise's eventual value or the reason
    why the promise cannot be fulfilled.
  
    Terminology
    -----------
  
    - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
    - `thenable` is an object or function that defines a `then` method.
    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
    - `exception` is a value that is thrown using the throw statement.
    - `reason` is a value that indicates why a promise was rejected.
    - `settled` the final resting state of a promise, fulfilled or rejected.
  
    A promise can be in one of three states: pending, fulfilled, or rejected.
  
    Promises that are fulfilled have a fulfillment value and are in the fulfilled
    state.  Promises that are rejected have a rejection reason and are in the
    rejected state.  A fulfillment value is never a thenable.
  
    Promises can also be said to *resolve* a value.  If this value is also a
    promise, then the original promise's settled state will match the value's
    settled state.  So a promise that *resolves* a promise that rejects will
    itself reject, and a promise that *resolves* a promise that fulfills will
    itself fulfill.
  
  
    Basic Usage:
    ------------
  
    ```js
    let promise = new Promise(function(resolve, reject) {
      // on success
      resolve(value);
  
      // on failure
      reject(reason);
    });
  
    promise.then(function(value) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Advanced Usage:
    ---------------
  
    Promises shine when abstracting away asynchronous interactions such as
    `XMLHttpRequest`s.
  
    ```js
    function getJSON(url) {
      return new Promise(function(resolve, reject){
        let xhr = new XMLHttpRequest();
  
        xhr.open('GET', url);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'json';
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send();
  
        function handler() {
          if (this.readyState === this.DONE) {
            if (this.status === 200) {
              resolve(this.response);
            } else {
              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
            }
          }
        };
      });
    }
  
    getJSON('/posts.json').then(function(json) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Unlike callbacks, promises are great composable primitives.
  
    ```js
    Promise.all([
      getJSON('/posts'),
      getJSON('/comments')
    ]).then(function(values){
      values[0] // => postsJSON
      values[1] // => commentsJSON
  
      return values;
    });
    ```
  
    @class Promise
    @param {Function} resolver
    Useful for tooling.
    @constructor
  */

  var Promise$1 = function () {
    function Promise(resolver) {
      this[PROMISE_ID] = nextId();
      this._result = this._state = undefined;
      this._subscribers = [];

      if (noop !== resolver) {
        typeof resolver !== 'function' && needsResolver();
        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
      }
    }

    /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
     ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
     Chaining
    --------
     The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
     ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
     findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
     ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
     Assimilation
    ------------
     Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
     If the assimliated promise rejects, then the downstream promise will also reject.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
     Simple Example
    --------------
     Synchronous Example
     ```javascript
    let result;
     try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
     Advanced Example
    --------------
     Synchronous Example
     ```javascript
    let author, books;
     try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
     function foundBooks(books) {
     }
     function failure(reason) {
     }
     findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
     @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
    */

    /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
    ```js
    function findAuthor(){
    throw new Error('couldn't find that author');
    }
    // synchronous
    try {
    findAuthor();
    } catch(reason) {
    // something went wrong
    }
    // async with promises
    findAuthor().catch(function(reason){
    // something went wrong
    });
    ```
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
    */

    Promise.prototype.catch = function _catch(onRejection) {
      return this.then(null, onRejection);
    };

    /**
      `finally` will be invoked regardless of the promise's fate just as native
      try/catch/finally behaves
    
      Synchronous example:
    
      ```js
      findAuthor() {
        if (Math.random() > 0.5) {
          throw new Error();
        }
        return new Author();
      }
    
      try {
        return findAuthor(); // succeed or fail
      } catch(error) {
        return findOtherAuther();
      } finally {
        // always runs
        // doesn't affect the return value
      }
      ```
    
      Asynchronous example:
    
      ```js
      findAuthor().catch(function(reason){
        return findOtherAuther();
      }).finally(function(){
        // author was either found, or not
      });
      ```
    
      @method finally
      @param {Function} callback
      @return {Promise}
    */

    Promise.prototype.finally = function _finally(callback) {
      var promise = this;
      var constructor = promise.constructor;

      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    };

    return Promise;
  }();

  Promise$1.prototype.then = then;
  Promise$1.all = all;
  Promise$1.race = race;
  Promise$1.resolve = resolve$1;
  Promise$1.reject = reject$1;
  Promise$1._setScheduler = setScheduler;
  Promise$1._setAsap = setAsap;
  Promise$1._asap = asap;

  /*global self*/
  function polyfill() {
    var local = void 0;

    if (typeof global !== 'undefined') {
      local = global;
    } else if (typeof self !== 'undefined') {
      local = self;
    } else {
      try {
        local = Function('return this')();
      } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
      }
    }

    var P = local.Promise;

    if (P) {
      var promiseToString = null;
      try {
        promiseToString = Object.prototype.toString.call(P.resolve());
      } catch (e) {
        // silently ignored
      }

      if (promiseToString === '[object Promise]' && !P.cast) {
        return;
      }
    }

    local.Promise = Promise$1;
  }

  // Strange compat..
  Promise$1.polyfill = polyfill;
  Promise$1.Promise = Promise$1;

  return Promise$1;
});

//# sourceMappingURL=es6-promise.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(117), __webpack_require__(136)))

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var listCacheClear = __webpack_require__(344),
    listCacheDelete = __webpack_require__(345),
    listCacheGet = __webpack_require__(346),
    listCacheHas = __webpack_require__(347),
    listCacheSet = __webpack_require__(348);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseAssignValue = __webpack_require__(63),
    eq = __webpack_require__(45);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var eq = __webpack_require__(45);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = __webpack_require__(4),
    isKey = __webpack_require__(70),
    stringToPath = __webpack_require__(370),
    toString = __webpack_require__(49);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isKeyable = __webpack_require__(342);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(17);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var baseGetTag = __webpack_require__(22),
    isObjectLike = __webpack_require__(14);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseToString = __webpack_require__(306);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module core
 */
/**
 * Matches state names using glob-like pattern strings.
 *
 * Globs can be used in specific APIs including:
 *
 * - [[StateService.is]]
 * - [[StateService.includes]]
 * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
 *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
 *
 * A `Glob` string is a pattern which matches state names.
 * Nested state names are split into segments (separated by a dot) when processing.
 * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
 *
 * Globs work according to the following rules:
 *
 * ### Exact match:
 *
 * The glob `'A.B'` matches the state named exactly `'A.B'`.
 *
 * | Glob        |Matches states named|Does not match state named|
 * |:------------|:--------------------|:---------------------|
 * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
 * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
 * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
 *
 * ### Single star (`*`)
 *
 * A single star (`*`) is a wildcard that matches exactly one segment.
 *
 * | Glob        |Matches states named  |Does not match state named |
 * |:------------|:---------------------|:--------------------------|
 * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
 * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
 * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
 *
 * ### Double star (`**`)
 *
 * A double star (`'**'`) is a wildcard that matches *zero or more segments*
 *
 * | Glob        |Matches states named                           |Does not match state named         |
 * |:------------|:----------------------------------------------|:----------------------------------|
 * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
 * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
 * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
 * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
 *
 */

var Glob = function () {
    function Glob(text) {
        this.text = text;
        this.glob = text.split('.');
        var regexpString = this.text.split('.').map(function (seg) {
            if (seg === '**') return '(?:|(?:\\.[^.]*)*)';
            if (seg === '*') return '\\.[^.]*';
            return '\\.' + seg;
        }).join('');
        this.regexp = new RegExp("^" + regexpString + "$");
    }
    Glob.prototype.matches = function (name) {
        return this.regexp.test('.' + name);
    };
    /** @deprecated whats the point? */
    Glob.is = function (text) {
        return text.indexOf('*') > -1;
    };
    /** @deprecated whats the point? */
    Glob.fromString = function (text) {
        if (!this.is(text)) return null;
        return new Glob(text);
    };
    return Glob;
}();
exports.Glob = Glob;
//# sourceMappingURL=glob.js.map

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module path */ /** for typedoc */

var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
var param_1 = __webpack_require__(25);
/**
 * A node in a [[TreeChanges]] path
 *
 * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
 * Each PathNode corresponds to a state being entered, exited, or retained.
 * The stateful information includes parameter values and resolve data.
 */
var PathNode = function () {
    function PathNode(stateOrPath) {
        if (stateOrPath instanceof PathNode) {
            var node = stateOrPath;
            this.state = node.state;
            this.paramSchema = node.paramSchema.slice();
            this.paramValues = common_1.extend({}, node.paramValues);
            this.resolvables = node.resolvables.slice();
            this.views = node.views && node.views.slice();
        } else {
            var state = stateOrPath;
            this.state = state;
            this.paramSchema = state.parameters({ inherit: false });
            this.paramValues = {};
            this.resolvables = state.resolvables.map(function (res) {
                return res.clone();
            });
        }
    }
    /** Sets [[paramValues]] for the node, from the values of an object hash */
    PathNode.prototype.applyRawParams = function (params) {
        var getParamVal = function getParamVal(paramDef) {
            return [paramDef.id, paramDef.value(params[paramDef.id])];
        };
        this.paramValues = this.paramSchema.reduce(function (memo, pDef) {
            return common_1.applyPairs(memo, getParamVal(pDef));
        }, {});
        return this;
    };
    /** Gets a specific [[Param]] metadata that belongs to the node */
    PathNode.prototype.parameter = function (name) {
        return common_1.find(this.paramSchema, hof_1.propEq("id", name));
    };
    /**
     * @returns true if the state and parameter values for another PathNode are
     * equal to the state and param values for this PathNode
     */
    PathNode.prototype.equals = function (node, keys) {
        var _this = this;
        if (keys === void 0) {
            keys = this.paramSchema.map(function (p) {
                return p.id;
            });
        }
        var paramValsEq = function paramValsEq(key) {
            return _this.parameter(key).type.equals(_this.paramValues[key], node.paramValues[key]);
        };
        return this.state === node.state && keys.map(paramValsEq).reduce(common_1.allTrueR, true);
    };
    /** Returns a clone of the PathNode */
    PathNode.clone = function (node) {
        return new PathNode(node);
    };
    /**
     * Returns a new path which is a subpath of the first path which matched the second path.
     *
     * The new path starts from root and contains any nodes that match the nodes in the second path.
     * Nodes are compared using their state property and parameter values.
     *
     * @param pathA the first path
     * @param pathB the second path
     * @param ignoreDynamicParams don't compare dynamic parameter values
     */
    PathNode.matching = function (pathA, pathB, ignoreDynamicParams) {
        if (ignoreDynamicParams === void 0) {
            ignoreDynamicParams = true;
        }
        var matching = [];
        for (var i = 0; i < pathA.length && i < pathB.length; i++) {
            var a = pathA[i],
                b = pathB[i];
            if (a.state !== b.state) break;
            var changedParams = param_1.Param.changed(a.paramSchema, a.paramValues, b.paramValues).filter(function (param) {
                return !(ignoreDynamicParams && param.dynamic);
            });
            if (changedParams.length) break;
            matching.push(a);
        }
        return matching;
    };
    return PathNode;
}();
exports.PathNode = PathNode;
//# sourceMappingURL=node.js.map

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @module path */ /** for typedoc */


var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
var targetState_1 = __webpack_require__(19);
var node_1 = __webpack_require__(51);
/**
 * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
 */
var PathFactory = function () {
    function PathFactory() {}
    /** Given a PathNode[], create an TargetState */
    PathFactory.makeTargetState = function (path) {
        var state = common_1.tail(path).state;
        return new targetState_1.TargetState(state, state, path.map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}));
    };
    PathFactory.buildPath = function (targetState) {
        var toParams = targetState.params();
        return targetState.$state().path.map(function (state) {
            return new node_1.PathNode(state).applyRawParams(toParams);
        });
    };
    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
    PathFactory.buildToPath = function (fromPath, targetState) {
        var toPath = PathFactory.buildPath(targetState);
        if (targetState.options().inherit) {
            return PathFactory.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
        }
        return toPath;
    };
    /**
     * Creates ViewConfig objects and adds to nodes.
     *
     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
     */
    PathFactory.applyViewConfigs = function ($view, path, states) {
        // Only apply the viewConfigs to the nodes for the given states
        path.filter(function (node) {
            return common_1.inArray(states, node.state);
        }).forEach(function (node) {
            var viewDecls = common_1.values(node.state.views || {});
            var subPath = PathFactory.subPath(path, function (n) {
                return n === node;
            });
            var viewConfigs = viewDecls.map(function (view) {
                return $view.createViewConfig(subPath, view);
            });
            node.views = viewConfigs.reduce(common_1.unnestR, []);
        });
    };
    /**
     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
     *
     * For a parameter in a node to be inherited from the from path:
     * - The toPath's node must have a matching node in the fromPath (by state).
     * - The parameter name must not be found in the toKeys parameter array.
     *
     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
     * it is not inherited from the fromPath.
     */
    PathFactory.inheritParams = function (fromPath, toPath, toKeys) {
        if (toKeys === void 0) {
            toKeys = [];
        }
        function nodeParamVals(path, state) {
            var node = common_1.find(path, hof_1.propEq('state', state));
            return common_1.extend({}, node && node.paramValues);
        }
        var noInherit = fromPath.map(function (node) {
            return node.paramSchema;
        }).reduce(common_1.unnestR, []).filter(function (param) {
            return !param.inherit;
        }).map(hof_1.prop('id'));
        /**
         * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
         * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
         */
        function makeInheritedParamsNode(toNode) {
            // All param values for the node (may include default key/vals, when key was not found in toParams)
            var toParamVals = common_1.extend({}, toNode && toNode.paramValues);
            // limited to only those keys found in toParams
            var incomingParamVals = common_1.pick(toParamVals, toKeys);
            toParamVals = common_1.omit(toParamVals, toKeys);
            var fromParamVals = common_1.omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
            // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
            var ownParamVals = common_1.extend(toParamVals, fromParamVals, incomingParamVals);
            return new node_1.PathNode(toNode.state).applyRawParams(ownParamVals);
        }
        // The param keys specified by the incoming toParams
        return toPath.map(makeInheritedParamsNode);
    };
    /**
     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
     */
    PathFactory.treeChanges = function (fromPath, toPath, reloadState) {
        var keep = 0,
            max = Math.min(fromPath.length, toPath.length);
        var staticParams = function staticParams(state) {
            return state.parameters({ inherit: false }).filter(hof_1.not(hof_1.prop('dynamic'))).map(hof_1.prop('id'));
        };
        var nodesMatch = function nodesMatch(node1, node2) {
            return node1.equals(node2, staticParams(node1.state));
        };
        while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
            keep++;
        }
        /** Given a retained node, return a new node which uses the to node's param values */
        function applyToParams(retainedNode, idx) {
            var cloned = node_1.PathNode.clone(retainedNode);
            cloned.paramValues = toPath[idx].paramValues;
            return cloned;
        }
        var from, retained, exiting, entering, to;
        from = fromPath;
        retained = from.slice(0, keep);
        exiting = from.slice(keep);
        // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
        var retainedWithToParams = retained.map(applyToParams);
        entering = toPath.slice(keep);
        to = retainedWithToParams.concat(entering);
        return { from: from, to: to, retained: retained, exiting: exiting, entering: entering };
    };
    /**
     * Return a subpath of a path, which stops at the first matching node
     *
     * Given an array of nodes, returns a subset of the array starting from the first node,
     * stopping when the first node matches the predicate.
     *
     * @param path a path of [[PathNode]]s
     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
     * @returns a subpath up to the matching node, or undefined if no match is found
     */
    PathFactory.subPath = function (path, predicate) {
        var node = common_1.find(path, predicate);
        var elementIdx = path.indexOf(node);
        return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
    };
    return PathFactory;
}();
/** Gets the raw parameter values from a path */
PathFactory.paramValues = function (path) {
    return path.reduce(function (acc, node) {
        return common_1.extend(acc, node.paramValues);
    }, {});
};
exports.PathFactory = PathFactory;
//# sourceMappingURL=pathFactory.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module resolve */
/** for typedoc */

var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
var trace_1 = __webpack_require__(24);
var coreservices_1 = __webpack_require__(6);
var interface_1 = __webpack_require__(122);
var resolvable_1 = __webpack_require__(31);
var pathFactory_1 = __webpack_require__(52);
var strings_1 = __webpack_require__(15);
var when = interface_1.resolvePolicies.when;
var ALL_WHENS = [when.EAGER, when.LAZY];
var EAGER_WHENS = [when.EAGER];
exports.NATIVE_INJECTOR_TOKEN = "Native Injector";
/**
 * Encapsulates Depenency Injection for a path of nodes
 *
 * UI-Router states are organized as a tree.
 * A nested state has a path of ancestors to the root of the tree.
 * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
 * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
 *
 * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
 */
var ResolveContext = function () {
    function ResolveContext(_path) {
        this._path = _path;
    }
    /** Gets all the tokens found in the resolve context, de-duplicated */
    ResolveContext.prototype.getTokens = function () {
        return this._path.reduce(function (acc, node) {
            return acc.concat(node.resolvables.map(function (r) {
                return r.token;
            }));
        }, []).reduce(common_1.uniqR, []);
    };
    /**
     * Gets the Resolvable that matches the token
     *
     * Gets the last Resolvable that matches the token in this context, or undefined.
     * Throws an error if it doesn't exist in the ResolveContext
     */
    ResolveContext.prototype.getResolvable = function (token) {
        var matching = this._path.map(function (node) {
            return node.resolvables;
        }).reduce(common_1.unnestR, []).filter(function (r) {
            return r.token === token;
        });
        return common_1.tail(matching);
    };
    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
    ResolveContext.prototype.getPolicy = function (resolvable) {
        var node = this.findNode(resolvable);
        return resolvable.getPolicy(node.state);
    };
    /**
     * Returns a ResolveContext that includes a portion of this one
     *
     * Given a state, this method creates a new ResolveContext from this one.
     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
     *
     * #### Why
     *
     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
     * This method is used to create a narrower context when injecting ancestor nodes.
     *
     * @example
     * `let ABCD = new ResolveContext([A, B, C, D]);`
     *
     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
     * However, `B` should only be able to access resolvables from `A`, `B`.
     *
     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
     * `let AB = ABCD.subcontext(a)`
     */
    ResolveContext.prototype.subContext = function (state) {
        return new ResolveContext(pathFactory_1.PathFactory.subPath(this._path, function (node) {
            return node.state === state;
        }));
    };
    /**
     * Adds Resolvables to the node that matches the state
     *
     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
     * The resolvable is added to the node matching the `state` parameter.
     *
     * These new resolvables are not automatically fetched.
     * The calling code should either fetch them, fetch something that depends on them,
     * or rely on [[resolvePath]] being called when some state is being entered.
     *
     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
     *
     * @param newResolvables the new Resolvables
     * @param state Used to find the node to put the resolvable on
     */
    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
        var node = common_1.find(this._path, hof_1.propEq('state', state));
        var keys = newResolvables.map(function (r) {
            return r.token;
        });
        node.resolvables = node.resolvables.filter(function (r) {
            return keys.indexOf(r.token) === -1;
        }).concat(newResolvables);
    };
    /**
     * Returns a promise for an array of resolved path Element promises
     *
     * @param when
     * @param trans
     * @returns {Promise<any>|any}
     */
    ResolveContext.prototype.resolvePath = function (when, trans) {
        var _this = this;
        if (when === void 0) {
            when = "LAZY";
        }
        // This option determines which 'when' policy Resolvables we are about to fetch.
        var whenOption = common_1.inArray(ALL_WHENS, when) ? when : "LAZY";
        // If the caller specified EAGER, only the EAGER Resolvables are fetched.
        // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
        var matchedWhens = whenOption === interface_1.resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
        // get the subpath to the state argument, if provided
        trace_1.trace.traceResolvePath(this._path, when, trans);
        var matchesPolicy = function matchesPolicy(acceptedVals, whenOrAsync) {
            return function (resolvable) {
                return common_1.inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
            };
        };
        // Trigger all the (matching) Resolvables in the path
        // Reduce all the "WAIT" Resolvables into an array
        var promises = this._path.reduce(function (acc, node) {
            var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
            var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
            var wait = nodeResolvables.filter(hof_1.not(matchesPolicy(['NOWAIT'], 'async')));
            // For the matching Resolvables, start their async fetch process.
            var subContext = _this.subContext(node.state);
            var getResult = function getResult(r) {
                return r.get(subContext, trans).then(function (value) {
                    return { token: r.token, value: value };
                });
            };
            nowait.forEach(getResult);
            return acc.concat(wait.map(getResult));
        }, []);
        // Wait for all the "WAIT" resolvables
        return coreservices_1.services.$q.all(promises);
    };
    ResolveContext.prototype.injector = function () {
        return this._injector || (this._injector = new UIInjectorImpl(this));
    };
    ResolveContext.prototype.findNode = function (resolvable) {
        return common_1.find(this._path, function (node) {
            return common_1.inArray(node.resolvables, resolvable);
        });
    };
    /**
     * Gets the async dependencies of a Resolvable
     *
     * Given a Resolvable, returns its dependencies as a Resolvable[]
     */
    ResolveContext.prototype.getDependencies = function (resolvable) {
        var _this = this;
        var node = this.findNode(resolvable);
        // Find which other resolvables are "visible" to the `resolvable` argument
        // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
        var subPath = pathFactory_1.PathFactory.subPath(this._path, function (x) {
            return x === node;
        }) || this._path;
        var availableResolvables = subPath.reduce(function (acc, node) {
            return acc.concat(node.resolvables);
        }, []) //all of subpath's resolvables
        .filter(function (res) {
            return res !== resolvable;
        }); // filter out the `resolvable` argument
        var getDependency = function getDependency(token) {
            var matching = availableResolvables.filter(function (r) {
                return r.token === token;
            });
            if (matching.length) return common_1.tail(matching);
            var fromInjector = _this.injector().getNative(token);
            if (!fromInjector) {
                throw new Error("Could not find Dependency Injection token: " + strings_1.stringify(token));
            }
            return new resolvable_1.Resolvable(token, function () {
                return fromInjector;
            }, [], fromInjector);
        };
        return resolvable.deps.map(getDependency);
    };
    return ResolveContext;
}();
exports.ResolveContext = ResolveContext;
var UIInjectorImpl = function () {
    function UIInjectorImpl(context) {
        this.context = context;
        this.native = this.get(exports.NATIVE_INJECTOR_TOKEN) || coreservices_1.services.$injector;
    }
    UIInjectorImpl.prototype.get = function (token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable) {
            if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
                return resolvable.get(this.context);
            }
            if (!resolvable.resolved) {
                throw new Error("Resolvable async .get() not complete:" + strings_1.stringify(resolvable.token));
            }
            return resolvable.data;
        }
        return this.native && this.native.get(token);
    };
    UIInjectorImpl.prototype.getAsync = function (token) {
        var resolvable = this.context.getResolvable(token);
        if (resolvable) return resolvable.get(this.context);
        return coreservices_1.services.$q.when(this.native.get(token));
    };
    UIInjectorImpl.prototype.getNative = function (token) {
        return this.native && this.native.get(token);
    };
    return UIInjectorImpl;
}();
//# sourceMappingURL=resolveContext.js.map

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module url
 */ /** for typedoc */

var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(1);
var param_1 = __webpack_require__(25);
var strings_1 = __webpack_require__(15);
/** @hidden */
function quoteRegExp(string, param) {
    var surroundPattern = ['', ''],
        result = string.replace(/[\\\[\]\^$*+?.()|{}]/g, "\\$&");
    if (!param) return result;
    switch (param.squash) {
        case false:
            surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
            break;
        case true:
            result = result.replace(/\/$/, '');
            surroundPattern = ['(?:\/(', ')|\/)?'];
            break;
        default:
            surroundPattern = ["(" + param.squash + "|", ')?'];
            break;
    }
    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
}
/** @hidden */
var memoizeTo = function memoizeTo(obj, prop, fn) {
    return obj[prop] = obj[prop] || fn();
};
/**
 * Matches URLs against patterns.
 *
 * Matches URLs against patterns and extracts named parameters from the path or the search
 * part of the URL.
 *
 * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
 * parameters. Multiple search parameter names are separated by '&'. Search parameters
 * do not influence whether or not a URL is matched, but their values are passed through into
 * the matched parameters returned by [[UrlMatcher.exec]].
 *
 * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
 * or colon placeholders (`/somePath/:param`).
 *
 * - *A parameter RegExp* may be defined for a param after a colon
 * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
 * The regexp must match for the url to be matched.
 * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
 *
 * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
 *
 * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
 *   See [[UrlMatcherFactory.type]] for more information.
 *
 * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
 *   A catch-all * parameter value will contain the remainder of the URL.
 *
 * ---
 *
 * Parameter names may contain only word characters (latin letters, digits, and underscore) and
 * must be unique within the pattern (across both path and search parameters).
 * A path parameter matches any number of characters other than '/'. For catch-all
 * placeholders the path parameter matches any number of characters.
 *
 * Examples:
 *
 * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
 *   trailing slashes, and patterns have to match the entire path, not just a prefix.
 * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
 *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
 * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
 * * `'/user/{id:[^/]*}'` - Same as the previous example.
 * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
 *   parameter consists of 1 to 8 hex digits.
 * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
 *   path into the parameter 'path'.
 * * `'/files/*path'` - ditto.
 * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
 *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
 *
 */
var UrlMatcher = function () {
    /**
     * @param pattern The pattern to compile into a matcher.
     * @param paramTypes The [[ParamTypes]] registry
     * @param config  A configuration object
     * - `caseInsensitive` - `true` if URL matching should be case insensitive, otherwise `false`, the default value (for backward compatibility) is `false`.
     * - `strict` - `false` if matching against a URL with a trailing slash should be treated as equivalent to a URL without a trailing slash, the default value is `true`.
     */
    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
        var _this = this;
        this.config = config;
        /** @hidden */
        this._cache = { path: [this], parent: null, pattern: null };
        /** @hidden */
        this._children = [];
        /** @hidden */
        this._params = [];
        /** @hidden */
        this._segments = [];
        /** @hidden */
        this._compiled = [];
        this.pattern = pattern;
        this.config = common_1.defaults(this.config, {
            params: {},
            strict: true,
            caseInsensitive: false,
            paramMap: common_1.identity
        });
        // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
        //   '*' name
        //   ':' name
        //   '{' name '}'
        //   '{' name ':' regexp '}'
        // The regular expression is somewhat complicated due to the need to allow curly braces
        // inside the regular expression. The placeholder regexp breaks down as follows:
        //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
        //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
        //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
        //    [^{}\\]+                       - anything other than curly braces or backslash
        //    \\.                            - a backslash escape
        //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
        var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
            searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g,
            last = 0,
            m,
            patterns = [];
        var checkParamErrors = function checkParamErrors(id) {
            if (!UrlMatcher.nameValidator.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
            if (common_1.find(_this._params, hof_1.propEq('id', id))) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
        };
        // Split into static segments separated by path parameter placeholders.
        // The number of segments is always 1 more than the number of parameters.
        var matchDetails = function matchDetails(m, isSearch) {
            // IE[78] returns '' for unmatched groups instead of null
            var id = m[2] || m[3];
            var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '.*' : null);
            var makeRegexpType = function makeRegexpType(regexp) {
                return common_1.inherit(paramTypes.type(isSearch ? "query" : "path"), {
                    pattern: new RegExp(regexp, _this.config.caseInsensitive ? 'i' : undefined)
                });
            };
            return {
                id: id,
                regexp: regexp,
                cfg: _this.config.params[id],
                segment: pattern.substring(last, m.index),
                type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp)
            };
        };
        var p, segment;
        while (m = placeholder.exec(pattern)) {
            p = matchDetails(m, false);
            if (p.segment.indexOf('?') >= 0) break; // we're into the search part
            checkParamErrors(p.id);
            this._params.push(paramFactory.fromPath(p.id, p.type, this.config.paramMap(p.cfg, false)));
            this._segments.push(p.segment);
            patterns.push([p.segment, common_1.tail(this._params)]);
            last = placeholder.lastIndex;
        }
        segment = pattern.substring(last);
        // Find any search parameter names and remove them from the last segment
        var i = segment.indexOf('?');
        if (i >= 0) {
            var search = segment.substring(i);
            segment = segment.substring(0, i);
            if (search.length > 0) {
                last = 0;
                while (m = searchPlaceholder.exec(search)) {
                    p = matchDetails(m, true);
                    checkParamErrors(p.id);
                    this._params.push(paramFactory.fromSearch(p.id, p.type, this.config.paramMap(p.cfg, true)));
                    last = placeholder.lastIndex;
                }
            }
        }
        this._segments.push(segment);
        this._compiled = patterns.map(function (pattern) {
            return quoteRegExp.apply(null, pattern);
        }).concat(quoteRegExp(segment));
    }
    /**
     * Creates a new concatenated UrlMatcher
     *
     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
     *
     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
     */
    UrlMatcher.prototype.append = function (url) {
        this._children.push(url);
        url._cache = {
            path: this._cache.path.concat(url),
            parent: this,
            pattern: null
        };
        return url;
    };
    /** @hidden */
    UrlMatcher.prototype.isRoot = function () {
        return this._cache.path[0] === this;
    };
    /** Returns the input pattern string */
    UrlMatcher.prototype.toString = function () {
        return this.pattern;
    };
    /**
     * Tests the specified url/path against this matcher.
     *
     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
     * parameter values.  Returns null if the path does not match.
     *
     * The returned object contains the values
     * of any search parameters that are mentioned in the pattern, but their value may be null if
     * they are not present in `search`. This means that search parameters are always treated
     * as optional.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
     *   x: '1', q: 'hello'
     * });
     * // returns { id: 'bob', q: 'hello', r: null }
     * ```
     *
     * @param path    The URL path to match, e.g. `$location.path()`.
     * @param search  URL search parameters, e.g. `$location.search()`.
     * @param hash    URL hash e.g. `$location.hash()`.
     * @param options
     *
     * @returns The captured parameter values.
     */
    UrlMatcher.prototype.exec = function (path, search, hash, options) {
        var _this = this;
        if (search === void 0) {
            search = {};
        }
        if (options === void 0) {
            options = {};
        }
        var match = memoizeTo(this._cache, 'pattern', function () {
            return new RegExp(['^', common_1.unnest(_this._cache.path.map(hof_1.prop('_compiled'))).join(''), _this.config.strict === false ? '\/?' : '', '$'].join(''), _this.config.caseInsensitive ? 'i' : undefined);
        }).exec(path);
        if (!match) return null;
        //options = defaults(options, { isolate: false });
        var allParams = this.parameters(),
            pathParams = allParams.filter(function (param) {
            return !param.isSearch();
        }),
            searchParams = allParams.filter(function (param) {
            return param.isSearch();
        }),
            nPathSegments = this._cache.path.map(function (urlm) {
            return urlm._segments.length - 1;
        }).reduce(function (a, x) {
            return a + x;
        }),
            values = {};
        if (nPathSegments !== match.length - 1) throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
        function decodePathArray(string) {
            var reverseString = function reverseString(str) {
                return str.split("").reverse().join("");
            };
            var unquoteDashes = function unquoteDashes(str) {
                return str.replace(/\\-/g, "-");
            };
            var split = reverseString(string).split(/-(?!\\)/);
            var allReversed = common_1.map(split, reverseString);
            return common_1.map(allReversed, unquoteDashes).reverse();
        }
        for (var i = 0; i < nPathSegments; i++) {
            var param = pathParams[i];
            var value = match[i + 1];
            // if the param value matches a pre-replace pair, replace the value before decoding.
            for (var j = 0; j < param.replace.length; j++) {
                if (param.replace[j].from === value) value = param.replace[j].to;
            }
            if (value && param.array === true) value = decodePathArray(value);
            if (predicates_1.isDefined(value)) value = param.type.decode(value);
            values[param.id] = param.value(value);
        }
        searchParams.forEach(function (param) {
            var value = search[param.id];
            for (var j = 0; j < param.replace.length; j++) {
                if (param.replace[j].from === value) value = param.replace[j].to;
            }
            if (predicates_1.isDefined(value)) value = param.type.decode(value);
            values[param.id] = param.value(value);
        });
        if (hash) values["#"] = hash;
        return values;
    };
    /**
     * @hidden
     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
     *
     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
     *    pattern has no parameters, an empty array is returned.
     */
    UrlMatcher.prototype.parameters = function (opts) {
        if (opts === void 0) {
            opts = {};
        }
        if (opts.inherit === false) return this._params;
        return common_1.unnest(this._cache.path.map(hof_1.prop('_params')));
    };
    /**
     * @hidden
     * Returns a single parameter from this UrlMatcher by id
     *
     * @param id
     * @param opts
     * @returns {T|Param|any|boolean|UrlMatcher|null}
     */
    UrlMatcher.prototype.parameter = function (id, opts) {
        if (opts === void 0) {
            opts = {};
        }
        var parent = this._cache.parent;
        return common_1.find(this._params, hof_1.propEq('id', id)) || opts.inherit !== false && parent && parent.parameter(id, opts) || null;
    };
    /**
     * Validates the input parameter values against this UrlMatcher
     *
     * Checks an object hash of parameters to validate their correctness according to the parameter
     * types of this `UrlMatcher`.
     *
     * @param params The object hash of parameters to validate.
     * @returns Returns `true` if `params` validates, otherwise `false`.
     */
    UrlMatcher.prototype.validates = function (params) {
        var _this = this;
        var validParamVal = function validParamVal(param, val) {
            return !param || param.validates(val);
        };
        return common_1.pairs(params || {}).map(function (_a) {
            var key = _a[0],
                val = _a[1];
            return validParamVal(_this.parameter(key), val);
        }).reduce(common_1.allTrueR, true);
    };
    /**
     * Given a set of parameter values, creates a URL from this UrlMatcher.
     *
     * Creates a URL that matches this pattern by substituting the specified values
     * for the path and search parameters.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
     * // returns '/user/bob?q=yes'
     * ```
     *
     * @param values  the values to substitute for the parameters in this pattern.
     * @returns the formatted URL (path and optionally search part).
     */
    UrlMatcher.prototype.format = function (values) {
        if (values === void 0) {
            values = {};
        }
        if (!this.validates(values)) return null;
        // Build the full path of UrlMatchers (including all parent UrlMatchers)
        var urlMatchers = this._cache.path;
        // Extract all the static segments and Params into an ordered array
        var pathSegmentsAndParams = urlMatchers.map(UrlMatcher.pathSegmentsAndParams).reduce(common_1.unnestR, []);
        // Extract the query params into a separate array
        var queryParams = urlMatchers.map(UrlMatcher.queryParams).reduce(common_1.unnestR, []);
        /**
         * Given a Param,
         * Applies the parameter value, then returns details about it
         */
        function getDetails(param) {
            // Normalize to typed value
            var value = param.value(values[param.id]);
            var isDefaultValue = param.isDefaultValue(value);
            // Check if we're in squash mode for the parameter
            var squash = isDefaultValue ? param.squash : false;
            // Allow the Parameter's Type to encode the value
            var encoded = param.type.encode(value);
            return { param: param, value: value, isDefaultValue: isDefaultValue, squash: squash, encoded: encoded };
        }
        // Build up the path-portion from the list of static segments and parameters
        var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
            // The element is a static segment (a raw string); just append it
            if (predicates_1.isString(x)) return acc + x;
            // Otherwise, it's a Param.  Fetch details about the parameter value
            var _a = getDetails(x),
                squash = _a.squash,
                encoded = _a.encoded,
                param = _a.param;
            // If squash is === true, try to remove a slash from the path
            if (squash === true) return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
            // If squash is a string, use the string for the param value
            if (predicates_1.isString(squash)) return acc + squash;
            if (squash !== false) return acc; // ?
            if (encoded == null) return acc;
            // If this parameter value is an array, encode the value using encodeDashes
            if (predicates_1.isArray(encoded)) return acc + common_1.map(encoded, UrlMatcher.encodeDashes).join("-");
            // If the parameter type is "raw", then do not encodeURIComponent
            if (param.raw) return acc + encoded;
            // Encode the value
            return acc + encodeURIComponent(encoded);
        }, "");
        // Build the query string by applying parameter values (array or regular)
        // then mapping to key=value, then flattening and joining using "&"
        var queryString = queryParams.map(function (param) {
            var _a = getDetails(param),
                squash = _a.squash,
                encoded = _a.encoded,
                isDefaultValue = _a.isDefaultValue;
            if (encoded == null || isDefaultValue && squash !== false) return;
            if (!predicates_1.isArray(encoded)) encoded = [encoded];
            if (encoded.length === 0) return;
            if (!param.raw) encoded = common_1.map(encoded, encodeURIComponent);
            return encoded.map(function (val) {
                return param.id + "=" + val;
            });
        }).filter(common_1.identity).reduce(common_1.unnestR, []).join("&");
        // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
        return pathString + (queryString ? "?" + queryString : "") + (values["#"] ? "#" + values["#"] : "");
    };
    /** @hidden */
    UrlMatcher.encodeDashes = function (str) {
        return encodeURIComponent(str).replace(/-/g, function (c) {
            return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase();
        });
    };
    /** @hidden Given a matcher, return an array with the matcher's path segments and path params, in order */
    UrlMatcher.pathSegmentsAndParams = function (matcher) {
        var staticSegments = matcher._segments;
        var pathParams = matcher._params.filter(function (p) {
            return p.location === param_1.DefType.PATH;
        });
        return common_1.arrayTuples(staticSegments, pathParams.concat(undefined)).reduce(common_1.unnestR, []).filter(function (x) {
            return x !== "" && predicates_1.isDefined(x);
        });
    };
    /** @hidden Given a matcher, return an array with the matcher's query params */
    UrlMatcher.queryParams = function (matcher) {
        return matcher._params.filter(function (p) {
            return p.location === param_1.DefType.SEARCH;
        });
    };
    /**
     * Compare two UrlMatchers
     *
     * This comparison function converts a UrlMatcher into static and dynamic path segments.
     * Each static path segment is a static string between a path separator (slash character).
     * Each dynamic segment is a path parameter.
     *
     * The comparison function sorts static segments before dynamic ones.
     */
    UrlMatcher.compare = function (a, b) {
        var splitOnSlash = strings_1.splitOnDelim('/');
        /**
         * Turn a UrlMatcher and all its parent matchers into an array
         * of slash literals '/', string literals, and Param objects
         *
         * This example matcher matches strings like "/foo/:param/tail":
         * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
         * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
         *
         */
        var segments = function segments(matcher) {
            return matcher._cache.path.map(UrlMatcher.pathSegmentsAndParams).reduce(common_1.unnestR, []).reduce(strings_1.joinNeighborsR, []).map(function (x) {
                return predicates_1.isString(x) ? splitOnSlash(x) : x;
            }).reduce(common_1.unnestR, []);
        };
        var aSegments = segments(a),
            bSegments = segments(b);
        // console.table( { aSegments, bSegments });
        // Sort slashes first, then static strings, the Params
        var weight = hof_1.pattern([[hof_1.eq("/"), hof_1.val(1)], [predicates_1.isString, hof_1.val(2)], [hof_1.is(param_1.Param), hof_1.val(3)]]);
        var pairs = common_1.arrayTuples(aSegments.map(weight), bSegments.map(weight));
        // console.table(pairs);
        return pairs.reduce(function (cmp, weightPair) {
            return cmp !== 0 ? cmp : weightPair[0] - weightPair[1];
        }, 0);
    };
    return UrlMatcher;
}();
/** @hidden */
UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
exports.UrlMatcher = UrlMatcher;
//# sourceMappingURL=urlMatcher.js.map

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Main entry point for angular 1.x build
 * @module ng1
 */ /** */


function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}
var core = __webpack_require__(9);
exports.core = core;
__export(__webpack_require__(9));
__export(__webpack_require__(57));
__export(__webpack_require__(58));
__export(__webpack_require__(88));
__webpack_require__(255);
__webpack_require__(253);
__webpack_require__(257);
__webpack_require__(254);
__webpack_require__(261);
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = "ui.router";
//# sourceMappingURL=index.js.map

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * # UI-Router for Angular 1
 *
 * - Provides an implementation for the [[CoreServices]] API, based on angular 1 services.
 * - Also registers some services with the angular 1 injector.
 * - Creates and bootstraps a new [[UIRouter]] object.  Ties it to the the angular 1 lifecycle.
 *
 * @module ng1
 * @preferred
 */
/** for typedoc */

var angular_1 = __webpack_require__(20);
var ui_router_core_1 = __webpack_require__(9);
var views_1 = __webpack_require__(58);
var templateFactory_1 = __webpack_require__(259);
var stateProvider_1 = __webpack_require__(88);
var onEnterExitRetain_1 = __webpack_require__(258);
var locationServices_1 = __webpack_require__(256);
var urlRouterProvider_1 = __webpack_require__(260);
angular_1.ng.module("ui.router.angular1", []);
var mod_init = angular_1.ng.module('ui.router.init', []);
var mod_util = angular_1.ng.module('ui.router.util', ['ng', 'ui.router.init']);
var mod_rtr = angular_1.ng.module('ui.router.router', ['ui.router.util']);
var mod_state = angular_1.ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
var mod_main = angular_1.ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
var mod_cmpt = angular_1.ng.module('ui.router.compat', ['ui.router']);
var router = null;
$uiRouter.$inject = ['$locationProvider'];
/** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
function $uiRouter($locationProvider) {
    // Create a new instance of the Router when the $uiRouterProvider is initialized
    router = this.router = new ui_router_core_1.UIRouter();
    router.stateProvider = new stateProvider_1.StateProvider(router.stateRegistry, router.stateService);
    // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
    router.stateRegistry.decorator("views", views_1.ng1ViewsBuilder);
    router.stateRegistry.decorator("onExit", onEnterExitRetain_1.getStateHookBuilder("onExit"));
    router.stateRegistry.decorator("onRetain", onEnterExitRetain_1.getStateHookBuilder("onRetain"));
    router.stateRegistry.decorator("onEnter", onEnterExitRetain_1.getStateHookBuilder("onEnter"));
    router.viewService._pluginapi._viewConfigFactory('ng1', views_1.getNg1ViewConfigFactory());
    var ng1LocationService = router.locationService = router.locationConfig = new locationServices_1.Ng1LocationServices($locationProvider);
    locationServices_1.Ng1LocationServices.monkeyPatchPathParameterType(router);
    // backwards compat: also expose router instance as $uiRouterProvider.router
    router['router'] = router;
    router['$get'] = $get;
    $get.$inject = ['$location', '$browser', '$sniffer', '$rootScope', '$http', '$templateCache'];
    function $get($location, $browser, $sniffer, $rootScope, $http, $templateCache) {
        ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser);
        delete router['router'];
        delete router['$get'];
        return router;
    }
    return router;
}
var getProviderFor = function getProviderFor(serviceName) {
    return ['$uiRouterProvider', function ($urp) {
        var service = $urp.router[serviceName];
        service["$get"] = function () {
            return service;
        };
        return service;
    }];
};
// This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
runBlock.$inject = ['$injector', '$q', '$uiRouter'];
function runBlock($injector, $q, $uiRouter) {
    ui_router_core_1.services.$injector = $injector;
    ui_router_core_1.services.$q = $q;
    // The $injector is now available.
    // Find any resolvables that had dependency annotation deferred
    $uiRouter.stateRegistry.get().map(function (x) {
        return x.$$state().resolvables;
    }).reduce(ui_router_core_1.unnestR, []).filter(function (x) {
        return x.deps === "deferred";
    }).forEach(function (resolvable) {
        return resolvable.deps = $injector.annotate(resolvable.resolveFn);
    });
}
// $urlRouter service and $urlRouterProvider
var getUrlRouterProvider = function getUrlRouterProvider(router) {
    return router.urlRouterProvider = new urlRouterProvider_1.UrlRouterProvider(router);
};
// $state service and $stateProvider
// $urlRouter service and $urlRouterProvider
var getStateProvider = function getStateProvider() {
    return ui_router_core_1.extend(router.stateProvider, { $get: function $get() {
            return router.stateService;
        } });
};
watchDigests.$inject = ['$rootScope'];
function watchDigests($rootScope) {
    $rootScope.$watch(function () {
        ui_router_core_1.trace.approximateDigests++;
    });
}
exports.watchDigests = watchDigests;
mod_init.provider("$uiRouter", $uiRouter);
mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
mod_util.provider('$urlService', getProviderFor('urlService'));
mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () {
    return router.urlMatcherFactory;
}]);
mod_util.provider('$templateFactory', function () {
    return new templateFactory_1.TemplateFactory();
});
mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
mod_state.provider('$transitions', getProviderFor('transitionService'));
mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) {
    return $uiRouter.globals.params;
}]);
mod_main.factory('$view', function () {
    return router.viewService;
});
mod_main.service("$trace", function () {
    return ui_router_core_1.trace;
});
mod_main.run(watchDigests);
mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) {}]);
mod_state.run(['$state', function ($state) {}]);
mod_rtr.run(['$urlRouter', function ($urlRouter) {}]);
mod_init.run(runBlock);
/** @hidden TODO: find a place to move this */
exports.getLocals = function (ctx) {
    var tokens = ctx.getTokens().filter(ui_router_core_1.isString);
    var tuples = tokens.map(function (key) {
        var resolvable = ctx.getResolvable(key);
        var waitPolicy = ctx.getPolicy(resolvable).async;
        return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
    });
    return tuples.reduce(ui_router_core_1.applyPairs, {});
};
//# sourceMappingURL=services.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ui_router_core_1 = __webpack_require__(9);
function getNg1ViewConfigFactory() {
    var templateFactory = null;
    return function (path, view) {
        templateFactory = templateFactory || ui_router_core_1.services.$injector.get("$templateFactory");
        return [new Ng1ViewConfig(path, view, templateFactory)];
    };
}
exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
var hasAnyKey = function hasAnyKey(keys, obj) {
    return keys.reduce(function (acc, key) {
        return acc || ui_router_core_1.isDefined(obj[key]);
    }, false);
};
/**
 * This is a [[StateBuilder.builder]] function for angular1 `views`.
 *
 * When the [[StateBuilder]] builds a [[State]] object from a raw [[StateDeclaration]], this builder
 * handles the `views` property with logic specific to angular-ui-router (ng1).
 *
 * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
 * and applies the state-level configuration to a view named `$default`.
 */
function ng1ViewsBuilder(state) {
    // Do not process root state
    if (!state.parent) return {};
    var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'],
        ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'],
        compKeys = ['component', 'bindings', 'componentProvider'],
        nonCompKeys = tplKeys.concat(ctrlKeys),
        allKeys = compKeys.concat(nonCompKeys);
    var views = {},
        viewsObject = state.views || { "$default": ui_router_core_1.pick(state, allKeys) };
    ui_router_core_1.forEach(viewsObject, function (config, name) {
        // Account for views: { "": { template... } }
        name = name || "$default";
        // Account for views: { header: "headerComponent" }
        if (ui_router_core_1.isString(config)) config = { component: config };
        if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
            throw new Error("Cannot combine: " + compKeys.join("|") + " with: " + nonCompKeys.join("|") + " in stateview: '" + name + "@" + state.name + "'");
        }
        config.resolveAs = config.resolveAs || '$resolve';
        config.$type = "ng1";
        config.$context = state;
        config.$name = name;
        var normalized = ui_router_core_1.ViewService.normalizeUIViewTarget(config.$context, config.$name);
        config.$uiViewName = normalized.uiViewName;
        config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
        views[name] = config;
    });
    return views;
}
exports.ng1ViewsBuilder = ng1ViewsBuilder;
var id = 0;
var Ng1ViewConfig = function () {
    function Ng1ViewConfig(path, viewDecl, factory) {
        var _this = this;
        this.path = path;
        this.viewDecl = viewDecl;
        this.factory = factory;
        this.$id = id++;
        this.loaded = false;
        this.getTemplate = function (uiView, context) {
            return _this.component ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings) : _this.template;
        };
    }
    Ng1ViewConfig.prototype.load = function () {
        var _this = this;
        var $q = ui_router_core_1.services.$q;
        var context = new ui_router_core_1.ResolveContext(this.path);
        var params = this.path.reduce(function (acc, node) {
            return ui_router_core_1.extend(acc, node.paramValues);
        }, {});
        var promises = {
            template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
            controller: $q.when(this.getController(context))
        };
        return $q.all(promises).then(function (results) {
            ui_router_core_1.trace.traceViewServiceEvent("Loaded", _this);
            _this.controller = results.controller;
            ui_router_core_1.extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
            return _this;
        });
    };
    /**
     * Gets the controller for a view configuration.
     *
     * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
     */
    Ng1ViewConfig.prototype.getController = function (context) {
        var provider = this.viewDecl.controllerProvider;
        if (!ui_router_core_1.isInjectable(provider)) return this.viewDecl.controller;
        var deps = ui_router_core_1.services.$injector.annotate(provider);
        var providerFn = ui_router_core_1.isArray(provider) ? ui_router_core_1.tail(provider) : provider;
        var resolvable = new ui_router_core_1.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    return Ng1ViewConfig;
}();
exports.Ng1ViewConfig = Ng1ViewConfig;
//# sourceMappingURL=views.js.map

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(17),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mapCacheClear = __webpack_require__(349),
    mapCacheDelete = __webpack_require__(350),
    mapCacheGet = __webpack_require__(351),
    mapCacheHas = __webpack_require__(352),
    mapCacheSet = __webpack_require__(353);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ListCache = __webpack_require__(38),
    stackClear = __webpack_require__(363),
    stackDelete = __webpack_require__(364),
    stackGet = __webpack_require__(365),
    stackHas = __webpack_require__(366),
    stackSet = __webpack_require__(367);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defineProperty = __webpack_require__(98);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var castPath = __webpack_require__(41),
    toKey = __webpack_require__(30);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : undefined;
}

module.exports = baseGet;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsEqualDeep = __webpack_require__(287),
    isObjectLike = __webpack_require__(14);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Uint8Array = __webpack_require__(89);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayFilter = __webpack_require__(91),
    stubArray = __webpack_require__(115);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isArray = __webpack_require__(4),
    isSymbol = __webpack_require__(47);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}

module.exports = isKey;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

module.exports = isPrototype;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var freeGlobal = __webpack_require__(100);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var copyObject = __webpack_require__(28),
    createAssigner = __webpack_require__(320),
    keysIn = __webpack_require__(77);

/**
 * This method is like `_.assign` except that it iterates over own and
 * inherited source properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias extend
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assign
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
 */
var assignIn = createAssigner(function (object, source) {
  copyObject(source, keysIn(source), object);
});

module.exports = assignIn;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsArguments = __webpack_require__(286),
    isObjectLike = __webpack_require__(14);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
    return arguments;
}()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(10),
    stubFalse = __webpack_require__(389);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module)))

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayLikeKeys = __webpack_require__(92),
    baseKeysIn = __webpack_require__(293),
    isArrayLike = __webpack_require__(18);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayReduce = __webpack_require__(272),
    baseEach = __webpack_require__(27),
    baseIteratee = __webpack_require__(16),
    baseReduce = __webpack_require__(300),
    isArray = __webpack_require__(4);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
    var func = isArray(collection) ? arrayReduce : baseReduce,
        initAccum = arguments.length < 3;

    return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(395);
module.exports = 'ngFileUpload';

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @module common
 */ /** for typedoc */


var Queue = function () {
    function Queue(_items, _limit) {
        if (_items === void 0) {
            _items = [];
        }
        if (_limit === void 0) {
            _limit = null;
        }
        this._items = _items;
        this._limit = _limit;
    }
    Queue.prototype.enqueue = function (item) {
        var items = this._items;
        items.push(item);
        if (this._limit && items.length > this._limit) items.shift();
        return item;
    };
    Queue.prototype.dequeue = function () {
        if (this.size()) return this._items.splice(0, 1)[0];
    };
    Queue.prototype.clear = function () {
        var current = this._items;
        this._items = [];
        return current;
    };
    Queue.prototype.size = function () {
        return this._items.length;
    };
    Queue.prototype.remove = function (item) {
        var idx = this._items.indexOf(item);
        return idx > -1 && this._items.splice(idx, 1)[0];
    };
    Queue.prototype.peekTail = function () {
        return this._items[this._items.length - 1];
    };
    Queue.prototype.peekHead = function () {
        if (this.size()) return this._items[0];
    };
    return Queue;
}();
exports.Queue = Queue;
//# sourceMappingURL=queue.js.map

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module params */ /** for typedoc */

var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
/**
 * An internal class which implements [[ParamTypeDefinition]].
 *
 * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
 * When a param type definition is registered, an instance of this class is created internally.
 *
 * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
 *
 * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
 *
 * #### Example:
 * ```js
 * var paramTypeDef = {
 *   decode: function(val) { return parseInt(val, 10); },
 *   encode: function(val) { return val && val.toString(); },
 *   equals: function(a, b) { return this.is(a) && a === b; },
 *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
 *   pattern: /\d+/
 * }
 *
 * var paramType = new ParamType(paramTypeDef);
 * ```
 * @internalapi
 */
var ParamType = function () {
    /**
     * @param def  A configuration object which contains the custom type definition.  The object's
     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
     * @returns a new ParamType object
     */
    function ParamType(def) {
        /** @inheritdoc */
        this.pattern = /.*/;
        /** @inheritdoc */
        this.inherit = true;
        common_1.extend(this, def);
    }
    // consider these four methods to be "abstract methods" that should be overridden
    /** @inheritdoc */
    ParamType.prototype.is = function (val, key) {
        return true;
    };
    /** @inheritdoc */
    ParamType.prototype.encode = function (val, key) {
        return val;
    };
    /** @inheritdoc */
    ParamType.prototype.decode = function (val, key) {
        return val;
    };
    /** @inheritdoc */
    ParamType.prototype.equals = function (a, b) {
        return a == b;
    };
    ParamType.prototype.$subPattern = function () {
        var sub = this.pattern.toString();
        return sub.substr(1, sub.length - 2);
    };
    ParamType.prototype.toString = function () {
        return "{ParamType:" + this.name + "}";
    };
    /** Given an encoded string, or a decoded object, returns a decoded object */
    ParamType.prototype.$normalize = function (val) {
        return this.is(val) ? val : this.decode(val);
    };
    /**
     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
     * e.g.:
     * - urlmatcher pattern "/path?{queryParam[]:int}"
     * - url: "/path?queryParam=1&queryParam=2
     * - $stateParams.queryParam will be [1, 2]
     * if `mode` is "auto", then
     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
     */
    ParamType.prototype.$asArray = function (mode, isSearch) {
        if (!mode) return this;
        if (mode === "auto" && !isSearch) throw new Error("'auto' array mode is for query parameters only");
        return new ArrayType(this, mode);
    };
    return ParamType;
}();
exports.ParamType = ParamType;
/**
 * Wraps up a `ParamType` object to handle array values.
 * @internalapi
 */
function ArrayType(type, mode) {
    var _this = this;
    // Wrap non-array value as array
    function arrayWrap(val) {
        return predicates_1.isArray(val) ? val : predicates_1.isDefined(val) ? [val] : [];
    }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
        switch (val.length) {
            case 0:
                return undefined;
            case 1:
                return mode === "auto" ? val[0] : val;
            default:
                return val;
        }
    }
    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
        return function handleArray(val) {
            if (predicates_1.isArray(val) && val.length === 0) return val;
            var arr = arrayWrap(val);
            var result = common_1.map(arr, callback);
            return allTruthyMode === true ? common_1.filter(result, function (x) {
                return !x;
            }).length === 0 : arrayUnwrap(result);
        };
    }
    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
        return function handleArray(val1, val2) {
            var left = arrayWrap(val1),
                right = arrayWrap(val2);
            if (left.length !== right.length) return false;
            for (var i = 0; i < left.length; i++) {
                if (!callback(left[i], right[i])) return false;
            }
            return true;
        };
    }
    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
        var paramTypeFn = type[name].bind(type);
        var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
        _this[name] = wrapperFn(paramTypeFn);
    });
    common_1.extend(this, {
        dynamic: type.dynamic,
        name: type.name,
        pattern: type.pattern,
        inherit: type.inherit,
        is: arrayHandler(type.is.bind(type), true),
        $arrayMode: mode
    });
}
//# sourceMappingURL=paramType.js.map

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module state
 */ /** for typedoc */


var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
/**
 * Internal representation of a UI-Router state.
 *
 * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
 *
 * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[State]] object.
 *
 * This class prototypally inherits from the corresponding [[StateDeclaration]].
 * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
 */
var State = function () {
    function State(config) {
        common_1.extend(this, config);
        // Object.freeze(this);
    }
    /**
     * Returns true if the provided parameter is the same state.
     *
     * Compares the identity of the state against the passed value, which is either an object
     * reference to the actual `State` instance, the original definition object passed to
     * `$stateProvider.state()`, or the fully-qualified name.
     *
     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
     * @returns Returns `true` if `ref` matches the current `State` instance.
     */
    State.prototype.is = function (ref) {
        return this === ref || this.self === ref || this.fqn() === ref;
    };
    /**
     * @deprecated this does not properly handle dot notation
     * @returns Returns a dot-separated name of the state.
     */
    State.prototype.fqn = function () {
        if (!this.parent || !(this.parent instanceof this.constructor)) return this.name;
        var name = this.parent.fqn();
        return name ? name + "." + this.name : this.name;
    };
    /**
     * Returns the root node of this state's tree.
     *
     * @returns The root of this state's tree.
     */
    State.prototype.root = function () {
        return this.parent && this.parent.root() || this;
    };
    /**
     * Gets the state's `Param`eters
     *
     * Gets [[Param]] information that is owned by the state.
     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] information.
     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
     *
     * @param opts options
     */
    State.prototype.parameters = function (opts) {
        opts = common_1.defaults(opts, { inherit: true, matchingKeys: null });
        var inherited = opts.inherit && this.parent && this.parent.parameters() || [];
        return inherited.concat(common_1.values(this.params)).filter(function (param) {
            return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id);
        });
    };
    /**
     * Returns a single [[Param]] that is owned by the state
     *
     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]] information.
     * @param id the name of the [[Param]] to return
     * @param opts options
     */
    State.prototype.parameter = function (id, opts) {
        if (opts === void 0) {
            opts = {};
        }
        return this.url && this.url.parameter(id, opts) || common_1.find(common_1.values(this.params), hof_1.propEq('id', id)) || opts.inherit && this.parent && this.parent.parameter(id);
    };
    State.prototype.toString = function () {
        return this.fqn();
    };
    return State;
}();
exports.State = State;
//# sourceMappingURL=stateObject.js.map

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module transition
 */ /** for typedoc */

var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
var interface_1 = __webpack_require__(32); // has or is using
var glob_1 = __webpack_require__(50);
/**
 * Determines if the given state matches the matchCriteria
 *
 * @hidden
 *
 * @param state a State Object to test against
 * @param criterion
 * - If a string, matchState uses the string as a glob-matcher against the state name
 * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
 *   and returns a positive match if any of the globs match.
 * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
 * @returns {boolean}
 */
function matchState(state, criterion) {
    var toMatch = predicates_1.isString(criterion) ? [criterion] : criterion;
    function matchGlobs(_state) {
        var globStrings = toMatch;
        for (var i = 0; i < globStrings.length; i++) {
            var glob = new glob_1.Glob(globStrings[i]);
            if (glob && glob.matches(_state.name) || !glob && globStrings[i] === _state.name) {
                return true;
            }
        }
        return false;
    }
    var matchFn = predicates_1.isFunction(toMatch) ? toMatch : matchGlobs;
    return !!matchFn(state);
}
exports.matchState = matchState;
/**
 * @hidden
 * The registration data for a registered transition hook
 */
var RegisteredHook = function () {
    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, options) {
        if (options === void 0) {
            options = {};
        }
        this.tranSvc = tranSvc;
        this.eventType = eventType;
        this.callback = callback;
        this.matchCriteria = matchCriteria;
        this.priority = options.priority || 0;
        this.bind = options.bind || null;
        this._deregistered = false;
    }
    /**
     * Given an array of PathNodes, and a HookMatchCriteria, returns an array containing
     * the PathNodes that the criteria matches, or null if there were no matching nodes.
     *
     * Returning null is significant to distinguish between the default
     * "match-all criterion value" of `true` compared to a () => true,
     * when the nodes is an empty array.
     *
     * This is useful to allow a transition match criteria of `entering: true`
     * to still match a transition, even when `entering === []`.  Contrast that
     * with `entering: (state) => true` which only matches when a state is actually
     * being entered.
     */
    RegisteredHook.prototype._matchingNodes = function (nodes, criterion) {
        if (criterion === true) return nodes;
        var matching = nodes.filter(function (node) {
            return matchState(node.state, criterion);
        });
        return matching.length ? matching : null;
    };
    /**
     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
     *
     * { to: true, from: true, entering: true, exiting: true, retained: true }
     */
    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
        return common_1.map(this.tranSvc._pluginapi._getPathTypes(), function () {
            return true;
        });
    };
    /**
     * Create a IMatchingNodes object from the TransitionHookTypes that basically looks like this:
     *
     * let matches: IMatchingNodes = {
     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
     * };
     */
    RegisteredHook.prototype._getMatchingNodes = function (treeChanges) {
        var _this = this;
        var criteria = common_1.extend(this._getDefaultMatchCriteria(), this.matchCriteria);
        var paths = common_1.values(this.tranSvc._pluginapi._getPathTypes());
        return paths.reduce(function (mn, pathtype) {
            // STATE scope criteria matches against every node in the path.
            // TRANSITION scope criteria matches against only the last node in the path
            var isStateHook = pathtype.scope === interface_1.TransitionHookScope.STATE;
            var path = treeChanges[pathtype.name] || [];
            var nodes = isStateHook ? path : [common_1.tail(path)];
            mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name]);
            return mn;
        }, {});
    };
    /**
     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
     *
     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
     */
    RegisteredHook.prototype.matches = function (treeChanges) {
        var matches = this._getMatchingNodes(treeChanges);
        // Check if all the criteria matched the TreeChanges object
        var allMatched = common_1.values(matches).every(common_1.identity);
        return allMatched ? matches : null;
    };
    return RegisteredHook;
}();
exports.RegisteredHook = RegisteredHook;
/** @hidden Return a registration function of the requested type. */
function makeEvent(registry, transitionService, eventType) {
    // Create the object which holds the registered transition hooks.
    var _registeredHooks = registry._registeredHooks = registry._registeredHooks || {};
    var hooks = _registeredHooks[eventType.name] = [];
    // Create hook registration function on the IHookRegistry for the event
    registry[eventType.name] = hookRegistrationFn;
    function hookRegistrationFn(matchObject, callback, options) {
        if (options === void 0) {
            options = {};
        }
        var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, options);
        hooks.push(registeredHook);
        return function deregisterEventHook() {
            registeredHook._deregistered = true;
            common_1.removeFrom(hooks)(registeredHook);
        };
    }
    return hookRegistrationFn;
}
exports.makeEvent = makeEvent;
//# sourceMappingURL=hookRegistry.js.map

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trace_1 = __webpack_require__(24);
var coreservices_1 = __webpack_require__(6);
var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
var hof_1 = __webpack_require__(3);
var interface_1 = __webpack_require__(32);
var transitionHook_1 = __webpack_require__(34);
var hookRegistry_1 = __webpack_require__(83);
var hookBuilder_1 = __webpack_require__(129);
var node_1 = __webpack_require__(51);
var pathFactory_1 = __webpack_require__(52);
var targetState_1 = __webpack_require__(19);
var param_1 = __webpack_require__(25);
var resolvable_1 = __webpack_require__(31);
var rejectFactory_1 = __webpack_require__(33);
var resolveContext_1 = __webpack_require__(53);
var router_1 = __webpack_require__(123);
/** @hidden */
var stateSelf = hof_1.prop("self");
/**
 * Represents a transition between two states.
 *
 * When navigating to a state, we are transitioning **from** the current state **to** the new state.
 *
 * This object contains all contextual information about the to/from states, parameters, resolves.
 * It has information about all states being entered and exited as a result of the transition.
 */
var Transition = function () {
    /**
     * Creates a new Transition object.
     *
     * If the target state is not valid, an error is thrown.
     *
     * @internalapi
     *
     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
     *        encapsulates the "from state".
     * @param targetState The target state and parameters being transitioned to (also, the transition options)
     * @param router The [[UIRouter]] instance
     */
    function Transition(fromPath, targetState, router) {
        var _this = this;
        /** @hidden */
        this._deferred = coreservices_1.services.$q.defer();
        /**
         * This promise is resolved or rejected based on the outcome of the Transition.
         *
         * When the transition is successful, the promise is resolved
         * When the transition is unsuccessful, the promise is rejected with the [[TransitionRejection]] or javascript error
         */
        this.promise = this._deferred.promise;
        /** @hidden Holds the hook registration functions such as those passed to Transition.onStart() */
        this._registeredHooks = {};
        /**
         * Checks if this transition is currently active/running.
         */
        this.isActive = function () {
            return _this === _this._options.current();
        };
        this.router = router;
        this._targetState = targetState;
        if (!targetState.valid()) {
            throw new Error(targetState.error());
        }
        // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
        this._options = common_1.extend({ current: hof_1.val(this) }, targetState.options());
        this.$id = router.transitionService._transitionCount++;
        var toPath = pathFactory_1.PathFactory.buildToPath(fromPath, targetState);
        this._treeChanges = pathFactory_1.PathFactory.treeChanges(fromPath, toPath, this._options.reloadState);
        this.createTransitionHookRegFns();
        var onCreateHooks = this.hookBuilder().buildHooksForPhase(interface_1.TransitionHookPhase.CREATE);
        transitionHook_1.TransitionHook.runAllHooks(onCreateHooks);
        this.applyViewConfigs(router);
        this.applyRootResolvables(router);
    }
    /** @hidden */
    Transition.prototype.onBefore = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    Transition.prototype.onStart = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    Transition.prototype.onExit = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    Transition.prototype.onRetain = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    Transition.prototype.onEnter = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    Transition.prototype.onFinish = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    Transition.prototype.onSuccess = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    Transition.prototype.onError = function (criteria, callback, options) {
        return;
    };
    /** @hidden
     * Creates the transition-level hook registration functions
     * (which can then be used to register hooks)
     */
    Transition.prototype.createTransitionHookRegFns = function () {
        var _this = this;
        this.router.transitionService._pluginapi._getEvents().filter(function (type) {
            return type.hookPhase !== interface_1.TransitionHookPhase.CREATE;
        }).forEach(function (type) {
            return hookRegistry_1.makeEvent(_this, _this.router.transitionService, type);
        });
    };
    /** @internalapi */
    Transition.prototype.getHooks = function (hookName) {
        return this._registeredHooks[hookName];
    };
    Transition.prototype.applyViewConfigs = function (router) {
        var enteringStates = this._treeChanges.entering.map(function (node) {
            return node.state;
        });
        pathFactory_1.PathFactory.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
    };
    Transition.prototype.applyRootResolvables = function (router) {
        var _this = this;
        var rootResolvables = [new resolvable_1.Resolvable(router_1.UIRouter, function () {
            return router;
        }, [], undefined, router), new resolvable_1.Resolvable(Transition, function () {
            return _this;
        }, [], undefined, this), new resolvable_1.Resolvable('$transition$', function () {
            return _this;
        }, [], undefined, this), new resolvable_1.Resolvable('$stateParams', function () {
            return _this.params();
        }, [], undefined, this.params())];
        var rootNode = this._treeChanges.to[0];
        var context = new resolveContext_1.ResolveContext(this._treeChanges.to);
        context.addResolvables(rootResolvables, rootNode.state);
    };
    /**
     * @internalapi
     *
     * @returns the internal from [State] object
     */
    Transition.prototype.$from = function () {
        return common_1.tail(this._treeChanges.from).state;
    };
    /**
     * @internalapi
     *
     * @returns the internal to [State] object
     */
    Transition.prototype.$to = function () {
        return common_1.tail(this._treeChanges.to).state;
    };
    /**
     * Returns the "from state"
     *
     * Returns the state that the transition is coming *from*.
     *
     * @returns The state declaration object for the Transition's ("from state").
     */
    Transition.prototype.from = function () {
        return this.$from().self;
    };
    /**
     * Returns the "to state"
     *
     * Returns the state that the transition is  going *from*.
     *
     * @returns The state declaration object for the Transition's target state ("to state").
     */
    Transition.prototype.to = function () {
        return this.$to().self;
    };
    /**
     * Gets the Target State
     *
     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
     *
     * @returns the [[TargetState]] of this Transition
     */
    Transition.prototype.targetState = function () {
        return this._targetState;
    };
    /**
     * Determines whether two transitions are equivalent.
     */
    Transition.prototype.is = function (compare) {
        if (compare instanceof Transition) {
            // TODO: Also compare parameters
            return this.is({ to: compare.$to().name, from: compare.$from().name });
        }
        return !(compare.to && !hookRegistry_1.matchState(this.$to(), compare.to) || compare.from && !hookRegistry_1.matchState(this.$from(), compare.from));
    };
    Transition.prototype.params = function (pathname) {
        if (pathname === void 0) {
            pathname = "to";
        }
        return Object.freeze(this._treeChanges[pathname].map(hof_1.prop("paramValues")).reduce(common_1.mergeR, {}));
    };
    /**
     * Creates a [[UIInjector]] Dependency Injector
     *
     * Returns a Dependency Injector for the Transition's target state (to state).
     * The injector provides resolve values which the target state has access to.
     *
     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
     *
     * #### Example:
     * ```js
     * .onEnter({ entering: 'myState' }, trans => {
     *   var myResolveValue = trans.injector().get('myResolve');
     *   // Inject a global service from the global/native injector (if it exists)
     *   var MyService = trans.injector().get('MyService');
     * })
     * ```
     *
     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
     * You can use [[UIInjector.getAsync]] to get a promise for the data.
     * #### Example:
     * ```js
     * .onBefore({}, trans => {
     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
     *     return myResolveValue !== 'ABORT';
     *   });
     * });
     * ```
     *
     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
     * #### Example:
     * ```js
     * .onEnter({ to: 'foo.bar' }, trans => {
     *   // returns result of `foo` state's `data` resolve
     *   // even though `foo.bar` also has a `data` resolve
     *   var fooData = trans.injector('foo').get('data');
     * });
     * ```
     *
     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
     * The resolve data from the `from` path will be returned.
     * #### Example:
     * ```js
     * .onExit({ exiting: 'foo.bar' }, trans => {
     *   // Gets the resolve value of `data` from the exiting state.
     *   var fooData = trans.injector(null, 'foo.bar').get('data');
     * });
     * ```
     *
     *
     * @param state Limits the resolves provided to only the resolves the provided state has access to.
     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
     *
     * @returns a [[UIInjector]]
     */
    Transition.prototype.injector = function (state, pathName) {
        if (pathName === void 0) {
            pathName = "to";
        }
        var path = this._treeChanges[pathName];
        if (state) path = pathFactory_1.PathFactory.subPath(path, function (node) {
            return node.state === state || node.state.name === state;
        });
        return new resolveContext_1.ResolveContext(path).injector();
    };
    /**
     * Gets all available resolve tokens (keys)
     *
     * This method can be used in conjunction with [[injector]] to inspect the resolve values
     * available to the Transition.
     *
     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
     * in the Transition's [[TreeChanges.to]] path.
     *
     * #### Example:
     * This example logs all resolve values
     * ```js
     * let tokens = trans.getResolveTokens();
     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
     * ```
     *
     * #### Example:
     * This example creates promises for each resolve value.
     * This triggers fetches of resolves (if any have not yet been fetched).
     * When all promises have all settled, it logs the resolve values.
     * ```js
     * let tokens = trans.getResolveTokens();
     * let promise = tokens.map(token => trans.injector().getAsync(token));
     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
     * ```
     *
     * Note: Angular 1 users whould use `$q.all()`
     *
     * @param pathname resolve context's path name (e.g., `to` or `from`)
     *
     * @returns an array of resolve tokens (keys)
     */
    Transition.prototype.getResolveTokens = function (pathname) {
        if (pathname === void 0) {
            pathname = "to";
        }
        return new resolveContext_1.ResolveContext(this._treeChanges[pathname]).getTokens();
    };
    /**
     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
     *
     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
     */
    Transition.prototype.addResolvable = function (resolvable, state) {
        if (state === void 0) {
            state = "";
        }
        resolvable = hof_1.is(resolvable_1.Resolvable)(resolvable) ? resolvable : new resolvable_1.Resolvable(resolvable);
        var stateName = typeof state === "string" ? state : state.name;
        var topath = this._treeChanges.to;
        var targetNode = common_1.find(topath, function (node) {
            return node.state.name === stateName;
        });
        var resolveContext = new resolveContext_1.ResolveContext(topath);
        resolveContext.addResolvables([resolvable], targetNode.state);
    };
    /**
     * Gets the transition from which this transition was redirected.
     *
     * If the current transition is a redirect, this method returns the transition that was redirected.
     *
     * #### Example:
     * ```js
     * let transitionA = $state.go('A').transition
     * transitionA.onStart({}, () => $state.target('B'));
     * $transitions.onSuccess({ to: 'B' }, (trans) => {
     *   trans.to().name === 'B'; // true
     *   trans.redirectedFrom() === transitionA; // true
     * });
     * ```
     *
     * @returns The previous Transition, or null if this Transition is not the result of a redirection
     */
    Transition.prototype.redirectedFrom = function () {
        return this._options.redirectedFrom || null;
    };
    /**
     * Gets the original transition in a redirect chain
     *
     * A transition might belong to a long chain of multiple redirects.
     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
     *
     * #### Example:
     * ```js
     * // states
     * registry.register({ name: 'A', redirectTo: 'B' });
     * registry.register({ name: 'B', redirectTo: 'C' });
     * registry.register({ name: 'C', redirectTo: 'D' });
     * registry.register({ name: 'D' });
     *
     * let transitionA = $state.go('A').transition
     *
     * $transitions.onSuccess({ to: 'D' }, (trans) => {
     *   trans.to().name === 'D'; // true
     *   trans.redirectedFrom().to().name === 'C'; // true
     *   trans.originalTransition() === transitionA; // true
     *   trans.originalTransition().to().name === 'A'; // true
     * });
     * ```
     *
     * @returns The original Transition that started a redirect chain
     */
    Transition.prototype.originalTransition = function () {
        var rf = this.redirectedFrom();
        return rf && rf.originalTransition() || this;
    };
    /**
     * Get the transition options
     *
     * @returns the options for this Transition.
     */
    Transition.prototype.options = function () {
        return this._options;
    };
    /**
     * Gets the states being entered.
     *
     * @returns an array of states that will be entered during this transition.
     */
    Transition.prototype.entering = function () {
        return common_1.map(this._treeChanges.entering, hof_1.prop('state')).map(stateSelf);
    };
    /**
     * Gets the states being exited.
     *
     * @returns an array of states that will be exited during this transition.
     */
    Transition.prototype.exiting = function () {
        return common_1.map(this._treeChanges.exiting, hof_1.prop('state')).map(stateSelf).reverse();
    };
    /**
     * Gets the states being retained.
     *
     * @returns an array of states that are already entered from a previous Transition, that will not be
     *    exited during this Transition
     */
    Transition.prototype.retained = function () {
        return common_1.map(this._treeChanges.retained, hof_1.prop('state')).map(stateSelf);
    };
    /**
     * Get the [[ViewConfig]]s associated with this Transition
     *
     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
     *
     * @param pathname the name of the path to fetch views for:
     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
     *
     * @returns a list of ViewConfig objects for the given path.
     */
    Transition.prototype.views = function (pathname, state) {
        if (pathname === void 0) {
            pathname = "entering";
        }
        var path = this._treeChanges[pathname];
        path = !state ? path : path.filter(hof_1.propEq('state', state));
        return path.map(hof_1.prop("views")).filter(common_1.identity).reduce(common_1.unnestR, []);
    };
    Transition.prototype.treeChanges = function (pathname) {
        return pathname ? this._treeChanges[pathname] : this._treeChanges;
    };
    /**
     * Creates a new transition that is a redirection of the current one.
     *
     * This transition can be returned from a [[TransitionService]] hook to
     * redirect a transition to a new state and/or set of parameters.
     *
     * @internalapi
     *
     * @returns Returns a new [[Transition]] instance.
     */
    Transition.prototype.redirect = function (targetState) {
        var redirects = 1,
            trans = this;
        while ((trans = trans.redirectedFrom()) != null) {
            if (++redirects > 20) throw new Error("Too many consecutive Transition redirects (20+)");
        }
        var redirectOpts = { redirectedFrom: this, source: "redirect" };
        // If the original transition was caused by URL sync, then use { location: 'replace' }
        // on the new transition (unless  the target state explicitly specifies location)
        if (this.options().source === 'url') {
            redirectOpts.location = 'replace';
        }
        var newOptions = common_1.extend({}, this.options(), targetState.options(), redirectOpts);
        targetState = new targetState_1.TargetState(targetState.identifier(), targetState.$state(), targetState.params(), newOptions);
        var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
        var originalEnteringNodes = this._treeChanges.entering;
        var redirectEnteringNodes = newTransition._treeChanges.entering;
        // --- Re-use resolve data from original transition ---
        // When redirecting from a parent state to a child state where the parent parameter values haven't changed
        // (because of the redirect), the resolves fetched by the original transition are still valid in the
        // redirected transition.
        //
        // This allows you to define a redirect on a parent state which depends on an async resolve value.
        // You can wait for the resolve, then redirect to a child state based on the result.
        // The redirected transition does not have to re-fetch the resolve.
        // ---------------------------------------------------------
        var nodeIsReloading = function nodeIsReloading(reloadState) {
            return function (node) {
                return reloadState && node.state.includes[reloadState.name];
            };
        };
        // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
        var matchingEnteringNodes = node_1.PathNode.matching(redirectEnteringNodes, originalEnteringNodes).filter(hof_1.not(nodeIsReloading(targetState.options().reloadState)));
        // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
        matchingEnteringNodes.forEach(function (node, idx) {
            node.resolvables = originalEnteringNodes[idx].resolvables;
        });
        return newTransition;
    };
    /** @hidden If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
    Transition.prototype._changedParams = function () {
        var tc = this._treeChanges;
        /** Return undefined if it's not a "dynamic" transition, for the following reasons */
        // If user explicitly wants a reload
        if (this._options.reload) return undefined;
        // If any states are exiting or entering
        if (tc.exiting.length || tc.entering.length) return undefined;
        // If to/from path lengths differ
        if (tc.to.length !== tc.from.length) return undefined;
        // If the to/from paths are different
        var pathsDiffer = common_1.arrayTuples(tc.to, tc.from).map(function (tuple) {
            return tuple[0].state !== tuple[1].state;
        }).reduce(common_1.anyTrueR, false);
        if (pathsDiffer) return undefined;
        // Find any parameter values that differ
        var nodeSchemas = tc.to.map(function (node) {
            return node.paramSchema;
        });
        var _a = [tc.to, tc.from].map(function (path) {
            return path.map(function (x) {
                return x.paramValues;
            });
        }),
            toValues = _a[0],
            fromValues = _a[1];
        var tuples = common_1.arrayTuples(nodeSchemas, toValues, fromValues);
        return tuples.map(function (_a) {
            var schema = _a[0],
                toVals = _a[1],
                fromVals = _a[2];
            return param_1.Param.changed(schema, toVals, fromVals);
        }).reduce(common_1.unnestR, []);
    };
    /**
     * Returns true if the transition is dynamic.
     *
     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
     *
     * @returns true if the Transition is dynamic
     */
    Transition.prototype.dynamic = function () {
        var changes = this._changedParams();
        return !changes ? false : changes.map(function (x) {
            return x.dynamic;
        }).reduce(common_1.anyTrueR, false);
    };
    /**
     * Returns true if the transition is ignored.
     *
     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
     *
     * @returns true if the Transition is ignored.
     */
    Transition.prototype.ignored = function () {
        var changes = this._changedParams();
        return !changes ? false : changes.length === 0;
    };
    /**
     * @hidden
     */
    Transition.prototype.hookBuilder = function () {
        return new hookBuilder_1.HookBuilder(this);
    };
    /**
     * Runs the transition
     *
     * This method is generally called from the [[StateService.transitionTo]]
     *
     * @internalapi
     *
     * @returns a promise for a successful transition.
     */
    Transition.prototype.run = function () {
        var _this = this;
        var runAllHooks = transitionHook_1.TransitionHook.runAllHooks;
        var hookBuilder = this.hookBuilder();
        var globals = this.router.globals;
        globals.transitionHistory.enqueue(this);
        var onBeforeHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.BEFORE);
        var syncResult = transitionHook_1.TransitionHook.runOnBeforeHooks(onBeforeHooks);
        if (rejectFactory_1.Rejection.isTransitionRejectionPromise(syncResult)) {
            syncResult.catch(function () {
                return 0;
            }); // issue #2676
            var rejectReason = syncResult._transitionRejection;
            this._deferred.reject(rejectReason);
            return this.promise;
        }
        if (!this.valid()) {
            var error = new Error(this.error());
            this._deferred.reject(error);
            return this.promise;
        }
        if (this.ignored()) {
            trace_1.trace.traceTransitionIgnored(this);
            this._deferred.reject(rejectFactory_1.Rejection.ignored());
            return this.promise;
        }
        // When the chain is complete, then resolve or reject the deferred
        var transitionSuccess = function transitionSuccess() {
            trace_1.trace.traceSuccess(_this.$to(), _this);
            _this.success = true;
            _this._deferred.resolve(_this.to());
            var onSuccessHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.SUCCESS);
            runAllHooks(onSuccessHooks);
        };
        var transitionError = function transitionError(reason) {
            trace_1.trace.traceError(reason, _this);
            _this.success = false;
            _this._deferred.reject(reason);
            _this._error = reason;
            var onErrorHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.ERROR);
            runAllHooks(onErrorHooks);
        };
        trace_1.trace.traceTransitionStart(this);
        // Chain the next hook off the previous
        var appendHookToChain = function appendHookToChain(prev, nextHook) {
            return prev.then(function () {
                return nextHook.invokeHook();
            });
        };
        // Run the hooks, then resolve or reject the overall deferred in the .then() handler
        var asyncHooks = hookBuilder.buildHooksForPhase(interface_1.TransitionHookPhase.ASYNC);
        asyncHooks.reduce(appendHookToChain, syncResult).then(transitionSuccess, transitionError);
        return this.promise;
    };
    /**
     * Checks if the Transition is valid
     *
     * @returns true if the Transition is valid
     */
    Transition.prototype.valid = function () {
        return !this.error() || this.success !== undefined;
    };
    /**
     * The Transition error reason.
     *
     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
     *
     * @returns an error message explaining why the transition is invalid, or the reason the transition failed.
     */
    Transition.prototype.error = function () {
        var state = this.$to();
        if (state.self.abstract) return "Cannot transition to abstract state '" + state.name + "'";
        if (!param_1.Param.validates(state.parameters(), this.params())) return "Param values not valid for state '" + state.name + "'";
        if (this.success === false) return this._error;
    };
    /**
     * A string representation of the Transition
     *
     * @returns A string representation of the Transition
     */
    Transition.prototype.toString = function () {
        var fromStateOrName = this.from();
        var toStateOrName = this.to();
        var avoidEmptyHash = function avoidEmptyHash(params) {
            return params["#"] !== null && params["#"] !== undefined ? params : common_1.omit(params, "#");
        };
        // (X) means the to state is invalid.
        var id = this.$id,
            from = predicates_1.isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName,
            fromParams = common_1.toJson(avoidEmptyHash(this._treeChanges.from.map(hof_1.prop('paramValues')).reduce(common_1.mergeR, {}))),
            toValid = this.valid() ? "" : "(X) ",
            to = predicates_1.isObject(toStateOrName) ? toStateOrName.name : toStateOrName,
            toParams = common_1.toJson(avoidEmptyHash(this.params()));
        return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
    };
    return Transition;
}();
/** @hidden */
Transition.diToken = Transition;
exports.Transition = Transition;
//# sourceMappingURL=transition.js.map

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module transition
 */ /** for typedoc */

var interface_1 = __webpack_require__(32);
var transition_1 = __webpack_require__(84);
var hookRegistry_1 = __webpack_require__(83);
var resolve_1 = __webpack_require__(400);
var views_1 = __webpack_require__(402);
var url_1 = __webpack_require__(401);
var redirectTo_1 = __webpack_require__(399);
var onEnterExitRetain_1 = __webpack_require__(398);
var lazyLoad_1 = __webpack_require__(119);
var transitionEventType_1 = __webpack_require__(130);
var transitionHook_1 = __webpack_require__(34);
var predicates_1 = __webpack_require__(1);
var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
/**
 * The default [[Transition]] options.
 *
 * Include this object when applying custom defaults:
 * let reloadOpts = { reload: true, notify: true }
 * let options = defaults(theirOpts, customDefaults, defaultOptions);
 */
exports.defaultTransOpts = {
    location: true,
    relative: null,
    inherit: false,
    notify: true,
    reload: false,
    custom: {},
    current: function current() {
        return null;
    },
    source: "unknown"
};
/**
 * This class provides services related to Transitions.
 *
 * - Most importantly, it allows global Transition Hooks to be registered.
 * - It allows the default transition error handler to be set.
 * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
 *
 * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
 */
var TransitionService = function () {
    /** @hidden */
    function TransitionService(_router) {
        this._router = _router;
        /** @hidden */
        this._transitionCount = 0;
        /** @hidden The transition hook types, such as `onEnter`, `onStart`, etc */
        this._eventTypes = [];
        /** @hidden The registered transition hooks */
        this._registeredHooks = {};
        /** @hidden The  paths on a criteria object */
        this._criteriaPaths = {};
        this.$view = _router.viewService;
        this._deregisterHookFns = {};
        this._pluginapi = common_1.createProxyFunctions(hof_1.val(this), {}, hof_1.val(this), ['_definePathType', '_defineEvent', '_getPathTypes', '_getEvents', 'getHooks']);
        this._defineDefaultPaths();
        this._defineDefaultEvents();
        this._registerDefaultTransitionHooks();
    }
    /**
     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
     *
     * Registers a transition lifecycle hook, which is invoked during transition construction.
     *
     * This low level hook should only be used by plugins.
     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
     * The Sticky States plugin uses this hook to modify the treechanges.
     *
     * ### Lifecycle
     *
     * `onCreate` hooks are invoked *while a transition is being constructed*.
     *
     * ### Return value
     *
     * The hook's return value is ignored
     *
     * @internalapi
     * @param criteria defines which Transitions the Hook should be invoked for.
     * @param callback the hook function which will be invoked.
     * @param options the registration options
     * @returns a function which deregisters the hook.
     */
    TransitionService.prototype.onCreate = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onBefore = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onStart = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onExit = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onRetain = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onEnter = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onFinish = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onSuccess = function (criteria, callback, options) {
        return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onError = function (criteria, callback, options) {
        return;
    };
    /** @internalapi */
    TransitionService.prototype.dispose = function (router) {
        delete router.globals.transition;
        common_1.values(this._registeredHooks).forEach(function (hooksArray) {
            return hooksArray.forEach(function (hook) {
                hook._deregistered = true;
                common_1.removeFrom(hooksArray, hook);
            });
        });
    };
    /**
     * Creates a new [[Transition]] object
     *
     * This is a factory function for creating new Transition objects.
     * It is used internally by the [[StateService]] and should generally not be called by application code.
     *
     * @param fromPath the path to the current state (the from state)
     * @param targetState the target state (destination)
     * @returns a Transition
     */
    TransitionService.prototype.create = function (fromPath, targetState) {
        return new transition_1.Transition(fromPath, targetState, this._router);
    };
    /** @hidden */
    TransitionService.prototype._defineDefaultEvents = function () {
        var Phase = interface_1.TransitionHookPhase;
        var TH = transitionHook_1.TransitionHook;
        var paths = this._criteriaPaths;
        this._defineEvent("onCreate", Phase.CREATE, 0, paths.to, false, TH.IGNORE_RESULT, TH.THROW_ERROR, false);
        this._defineEvent("onBefore", Phase.BEFORE, 0, paths.to, false, TH.HANDLE_RESULT);
        this._defineEvent("onStart", Phase.ASYNC, 0, paths.to);
        this._defineEvent("onExit", Phase.ASYNC, 100, paths.exiting, true);
        this._defineEvent("onRetain", Phase.ASYNC, 200, paths.retained);
        this._defineEvent("onEnter", Phase.ASYNC, 300, paths.entering);
        this._defineEvent("onFinish", Phase.ASYNC, 400, paths.to);
        this._defineEvent("onSuccess", Phase.SUCCESS, 0, paths.to, false, TH.IGNORE_RESULT, TH.LOG_ERROR, false);
        this._defineEvent("onError", Phase.ERROR, 0, paths.to, false, TH.IGNORE_RESULT, TH.LOG_ERROR, false);
    };
    /** @hidden */
    TransitionService.prototype._defineDefaultPaths = function () {
        var STATE = interface_1.TransitionHookScope.STATE,
            TRANSITION = interface_1.TransitionHookScope.TRANSITION;
        this._definePathType("to", TRANSITION);
        this._definePathType("from", TRANSITION);
        this._definePathType("exiting", STATE);
        this._definePathType("retained", STATE);
        this._definePathType("entering", STATE);
    };
    /**
     * Defines a transition hook type and returns a transition hook registration
     * function (which can then be used to register hooks of this type).
     * @internalapi
     */
    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, rejectIfSuperseded) {
        if (reverseSort === void 0) {
            reverseSort = false;
        }
        if (getResultHandler === void 0) {
            getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT;
        }
        if (getErrorHandler === void 0) {
            getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR;
        }
        if (rejectIfSuperseded === void 0) {
            rejectIfSuperseded = true;
        }
        var eventType = new transitionEventType_1.TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, rejectIfSuperseded);
        this._eventTypes.push(eventType);
        hookRegistry_1.makeEvent(this, this, eventType);
    };
    ;
    /**
     * @hidden
     * Returns the known event types, such as `onBefore`
     * If a phase argument is provided, returns only events for the given phase.
     */
    TransitionService.prototype._getEvents = function (phase) {
        var transitionHookTypes = predicates_1.isDefined(phase) ? this._eventTypes.filter(function (type) {
            return type.hookPhase === phase;
        }) : this._eventTypes.slice();
        return transitionHookTypes.sort(function (l, r) {
            var cmpByPhase = l.hookPhase - r.hookPhase;
            return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
        });
    };
    /**
     * Adds a Path to be used as a criterion against a TreeChanges path
     *
     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
     * Each state in the exiting path is checked against the criteria and returned as part of the match.
     *
     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
     *
     * @internalapi
     */
    TransitionService.prototype._definePathType = function (name, hookScope) {
        this._criteriaPaths[name] = { name: name, scope: hookScope };
    };
    /**
     * Gets a Path definition used as a criterion against a TreeChanges path
     *
     * @internalapi
     */
    TransitionService.prototype._getPathTypes = function () {
        return this._criteriaPaths;
    };
    /** @hidden */
    TransitionService.prototype.getHooks = function (hookName) {
        return this._registeredHooks[hookName];
    };
    /** @hidden */
    TransitionService.prototype._registerDefaultTransitionHooks = function () {
        var fns = this._deregisterHookFns;
        // Wire up redirectTo hook
        fns.redirectTo = redirectTo_1.registerRedirectToHook(this);
        // Wire up onExit/Retain/Enter state hooks
        fns.onExit = onEnterExitRetain_1.registerOnExitHook(this);
        fns.onRetain = onEnterExitRetain_1.registerOnRetainHook(this);
        fns.onEnter = onEnterExitRetain_1.registerOnEnterHook(this);
        // Wire up Resolve hooks
        fns.eagerResolve = resolve_1.registerEagerResolvePath(this);
        fns.lazyResolve = resolve_1.registerLazyResolveState(this);
        // Wire up the View management hooks
        fns.loadViews = views_1.registerLoadEnteringViews(this);
        fns.activateViews = views_1.registerActivateViews(this);
        // After globals.current is updated at priority: 10000
        fns.updateUrl = url_1.registerUpdateUrl(this);
        // Lazy load state trees
        fns.lazyLoad = lazyLoad_1.registerLazyLoadHook(this);
    };
    return TransitionService;
}();
exports.TransitionService = TransitionService;
//# sourceMappingURL=transitionService.js.map

/***/ }),
/* 86 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/transportation-alternative/transportation-alternative-list-template1.html';
var html = "<div class=call-for-help> <display-overview slug-url={{$ctrl.slugUrl}} details=$ctrl.details.overview on-edit=$ctrl.onEditOverview()> </display-overview> <section class=call-for-help-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 call-for-help-list\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <div class=search-box ng-if=$ctrl.isSearchBoxVisisble> <search-box on-search=$ctrl.onSearch($event) placeholder=\"Enter Provider Name\"></search-box> </div> <button class=\"submit-btn text-uppercase\" ng-click=$ctrl.routeAddPageUrl()>add new</button> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item no-result-found\" ng-if=\"$ctrl.details.list.length === 0\"> <h4>No Result Found!</h4> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item\" ng-repeat=\"item in $ctrl.details.list\"> <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10 list-content\"> <div class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 item-image\"> <img class=img-responsive ng-src={{$ctrl._getImage(item)}} /> </div> <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10 item-details\"> <h3 class=title>{{item.name}}</h3> <div class=\"col-md-3 col-sm-4 col-xs-4 col-lg-4 item-details-content no-padding-left\"> <p class=content-title>Email</p> <p class=details>{{item.email || ' - '}}</p> </div> <div class=\"col-md-4 col-sm-4 col-xs-4 col-lg-4 item-details-content no-padding-left\"> <p class=content-title>Phone</p> <p class=details ng-repeat=\"phone in item.phone\"> {{phone.number || '-'}}{{phone.extn ? ', Ext.' + phone.extn : ''}} </p> </div> <div class=\"col-md-4 col-sm-4 col-xs-4 col-lg-4 item-details-content no-padding\"> <p class=content-title>Service Area</p> <div class=details> <span ng-repeat=\"location in item.serviceArea\">{{location.name}}{{!$last ? ', ' : ''}}</span> </div> </div> </div> </div> <div class=\"col-md-2 text-right item-btns\"> <a ng-click=$ctrl.routeDetailsPageUrl(item.slug)> <span class=\"icons icon-View\"></span> </a> <a ng-click=$ctrl.routeEditPageUrl(item.slug)> <span class=\"icons icon-Edit\"></span> </a> <span class=\"icons icon-Delete\" ng-click=$ctrl.onDelete(item.slug)></span> </div> </div> <div class=\"col-md-12 pagination\" ng-if=$ctrl.showPagination> <pagination total-items=$ctrl.totalItems item-per-page=$ctrl.itemPerPage current-page=$ctrl.currentPage on-change=$ctrl.onChange($event)> </pagination> </div> </div> </section> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(228);

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module ng1 */ /** for typedoc */

var ui_router_core_1 = __webpack_require__(9);
/**
 * @ngdoc object
 * @name ui.router.state.$stateProvider
 *
 * @requires ui.router.router.$urlRouterProvider
 * @requires ui.router.util.$urlMatcherFactoryProvider
 *
 * @description
 * The new `$stateProvider` works similar to Angular's v1 router, but it focuses purely
 * on state.
 *
 * A state corresponds to a "place" in the application in terms of the overall UI and
 * navigation. A state describes (via the controller / template / view properties) what
 * the UI looks like and does at that place.
 *
 * States often have things in common, and the primary way of factoring out these
 * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
 * nested states.
 *
 * The `$stateProvider` provides interfaces to declare these states for your app.
 */
var StateProvider = function () {
    function StateProvider(stateRegistry, stateService) {
        this.stateRegistry = stateRegistry;
        this.stateService = stateService;
        ui_router_core_1.createProxyFunctions(ui_router_core_1.val(StateProvider.prototype), this, ui_router_core_1.val(this));
    }
    /**
     * @ngdoc function
     * @name ui.router.state.$stateProvider#decorator
     * @methodOf ui.router.state.$stateProvider
     *
     * @description
     * Allows you to extend (carefully) or override (at your own peril) the
     * `stateBuilder` object used internally by `$stateProvider`. This can be used
     * to add custom functionality to ui-router, for example inferring templateUrl
     * based on the state name.
     *
     * When passing only a name, it returns the current (original or decorated) builder
     * function that matches `name`.
     *
     * The builder functions that can be decorated are listed below. Though not all
     * necessarily have a good use case for decoration, that is up to you to decide.
     *
     * In addition, users can attach custom decorators, which will generate new
     * properties within the state's internal definition. There is currently no clear
     * use-case for this beyond accessing internal states (i.e. $state.$current),
     * however, expect this to become increasingly relevant as we introduce additional
     * meta-programming features.
     *
     * **Warning**: Decorators should not be interdependent because the order of
     * execution of the builder functions in non-deterministic. Builder functions
     * should only be dependent on the state definition object and super function.
     *
     *
     * Existing builder functions and current return values:
     *
     * - **parent** `{object}` - returns the parent state object.
     * - **data** `{object}` - returns state data, including any inherited data that is not
     *   overridden by own values (if any).
     * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
     *   or `null`.
     * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
     *   navigable).
     * - **params** `{object}` - returns an array of state params that are ensured to
     *   be a super-set of parent's params.
     * - **views** `{object}` - returns a views object where each key is an absolute view
     *   name (i.e. "viewName@stateName") and each value is the config object
     *   (template, controller) for the view. Even when you don't use the views object
     *   explicitly on a state config, one is still created for you internally.
     *   So by decorating this builder function you have access to decorating template
     *   and controller properties.
     * - **ownParams** `{object}` - returns an array of params that belong to the state,
     *   not including any params defined by ancestor states.
     * - **path** `{string}` - returns the full path from the root down to this state.
     *   Needed for state activation.
     * - **includes** `{object}` - returns an object that includes every state that
     *   would pass a `$state.includes()` test.
     *
     * @example
     * <pre>
     * // Override the internal 'views' builder with a function that takes the state
     * // definition, and a reference to the internal function being overridden:
     * $stateProvider.decorator('views', function (state, parent) {
     *   let result = {},
     *       views = parent(state);
     *
     *   angular.forEach(views, function (config, name) {
     *     let autoName = (state.name + '.' + name).replace('.', '/');
     *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
     *     result[name] = config;
     *   });
     *   return result;
     * });
     *
     * $stateProvider.state('home', {
     *   views: {
     *     'contact.list': { controller: 'ListController' },
     *     'contact.item': { controller: 'ItemController' }
     *   }
     * });
     *
     * // ...
     *
     * $state.go('home');
     * // Auto-populates list and item views with /partials/home/contact/list.html,
     * // and /partials/home/contact/item.html, respectively.
     * </pre>
     *
     * @param {string} name The name of the builder function to decorate.
     * @param {object} func A function that is responsible for decorating the original
     * builder function. The function receives two parameters:
     *
     *   - `{object}` - state - The state config object.
     *   - `{object}` - super - The original builder function.
     *
     * @return {object} $stateProvider - $stateProvider instance
     */
    StateProvider.prototype.decorator = function (name, func) {
        return this.stateRegistry.decorator(name, func) || this;
    };
    StateProvider.prototype.state = function (name, definition) {
        if (ui_router_core_1.isObject(name)) {
            definition = name;
        } else {
            definition.name = name;
        }
        this.stateRegistry.register(definition);
        return this;
    };
    /**
     * Registers an invalid state handler
     *
     * This is a passthrough to [[StateService.onInvalid]] for ng1.
     */
    StateProvider.prototype.onInvalid = function (callback) {
        return this.stateService.onInvalid(callback);
    };
    return StateProvider;
}();
exports.StateProvider = StateProvider;
//# sourceMappingURL=stateProvider.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(10);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseTimes = __webpack_require__(305),
    isArguments = __webpack_require__(74),
    isArray = __webpack_require__(4),
    isBuffer = __webpack_require__(75),
    isIndex = __webpack_require__(43),
    isTypedArray = __webpack_require__(114);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseFor = __webpack_require__(284),
    keys = __webpack_require__(23);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayPush = __webpack_require__(62),
    isArray = __webpack_require__(4);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isPrototype = __webpack_require__(71),
    nativeKeys = __webpack_require__(356);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function (object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(17);

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

module.exports = defineProperty;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SetCache = __webpack_require__(268),
    arraySome = __webpack_require__(273),
    cacheHas = __webpack_require__(308);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/** Detect free variable `global` from Node.js. */
var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(136)))

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetAllKeys = __webpack_require__(95),
    getSymbols = __webpack_require__(68),
    keys = __webpack_require__(23);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var overArg = __webpack_require__(107);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayPush = __webpack_require__(62),
    getPrototype = __webpack_require__(102),
    getSymbols = __webpack_require__(68),
    stubArray = __webpack_require__(115);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var eq = __webpack_require__(45),
    isArrayLike = __webpack_require__(18),
    isIndex = __webpack_require__(43),
    isObject = __webpack_require__(13);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index === 'undefined' ? 'undefined' : _typeof(index);
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(13);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function (object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
  };
}

module.exports = matchesStrictComparable;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var apply = __webpack_require__(270);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseSetToString = __webpack_require__(303),
    shortOut = __webpack_require__(362);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayEach = __webpack_require__(90),
    baseEach = __webpack_require__(27),
    castFunction = __webpack_require__(309),
    isArray = __webpack_require__(4);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseHasIn = __webpack_require__(285),
    hasPath = __webpack_require__(332);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(22),
    isObject = __webpack_require__(13);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsTypedArray = __webpack_require__(292),
    baseUnary = __webpack_require__(66),
    nodeUtil = __webpack_require__(72);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// your library here
(function (root, factory) {
    'use strict';

    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(36)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module !== 'undefined' && _typeof(module.exports) === 'object') {
        // CommonJS support (for us webpack/browserify/ComponentJS folks)
        module.exports = factory(require('angular'));
    } else {
        // in the case of no module loading system
        // then don't worry about creating a global
        // variable like you would in normal UMD.
        // It's not really helpful... Just call your factory
        return factory(root.angular);
    }
})(undefined, NgImageLoad);

function NgImageLoad(angular) {
    'use strict';

    var moduleName = 'ngImageLoad';
    angular.module(moduleName, []).run(['NgImageLoadService', function (NgImageLoadService) {
        NgImageLoadService.load();
    }]).directive('ngImageLoad', ['NgImageLoadService', ngImageLoadDirective]).provider('NgImageLoadService', NgImageLoadServiceProvider);

    return moduleName;
}

function ngImageLoadDirective(NgImageLoadService) {
    return {
        restrict: 'A',
        scope: {
            ngImageLoad: '@',
            defaultImageKey: '@',
            defaultImageUrl: '@'
        },
        link: function link(scope, element, attrs) {
            var imageUrl = scope.ngImageLoad;
            var isImageLoaded = false;
            _process(imageUrl);

            function _process(url) {
                getDefaultImage();
                if (url) {
                    _loadImage(url);
                }
            }
            function getDefaultImage() {
                var promise;
                if (scope.defaultImageUrl) {
                    promise = NgImageLoadService.loadImage(scope.defaultImageUrl);
                } else if (scope.defaultImageKey) {
                    promise = NgImageLoadService.getImageByKey(scope.defaultImageKey);
                } else {
                    promise = NgImageLoadService.getDefaultImage();
                }
                promise.then(function (url) {
                    if (!url) {
                        console.error('No default image provided');
                    } else {
                        if (!isImageLoaded) {
                            _updateImage(url);
                        }
                    }
                }, function (err) {
                    console.error(err);
                });
            }
            function _loadImage(url) {
                NgImageLoadService.loadImage(url).then(function (url) {
                    isImageLoaded = true;
                    _updateImage(url);
                }, function (err) {
                    console.error(err);
                });
            }
            function _updateImage(url) {
                element.attr('src', url);
            }
            attrs.$observe('ngImageLoad', function (value) {
                isImageLoaded = false;
                _process(value);
            });
        }
    };
}

function NgImageLoadServiceProvider() {
    var defaultImage = {
        url: '',
        promise: null
    };
    var images = [];

    return {
        $get: ['$q', NgImageLoadService],
        setDefault: setDefault,
        preloadImage: preloadImage,
        preloadImages: preloadImages
    };

    function setDefault(url) {
        defaultImage.url = url;
    }

    function preloadImage(details) {
        images.push(details);
    }

    function preloadImages(details) {
        for (var i = 0; i < details.length; i++) {
            preloadImage(details[i]);
        }
    }

    function NgImageLoadService($q) {
        return {
            load: load,
            loadImage: loadImage,
            loadImages: loadImages,
            getImageByKey: getImageByKey,
            getImagesByKey: getImagesByKey,
            getDefaultImage: getDefaultImage
        };

        function load() {
            if (defaultImage.url) {
                defaultImage.promise = loadImage(defaultImage.url);
            }
            for (var i = 0; i < images.length; i++) {
                images[i].promise = loadImage(images[i].url);
            }
        }

        function loadImage(url) {
            var defer = $q.defer();
            if (url) {
                var image = new Image();
                image.addEventListener('load', function () {
                    defer.resolve(url);
                });
                image.addEventListener('error', function (error) {
                    defer.reject(error);
                });
                image.src = url;
            } else {
                defer.reject('parameter \'url\' not provided');
            }
            return defer.promise;
        }

        function loadImages(details) {
            var _images = [];
            for (var i = 0; i < details.length; i++) {
                _images.push(loadImage(details[i]));
            }
            return _images;
        }

        function getImageByKey(key) {
            var defer = $q.defer();
            var imageKeyExist = false;
            if (!key) {
                defer.reject('parameter \'key\' not provided');
            } else {
                for (var i = 0; i < images.length; i++) {
                    if (images[i].hasOwnProperty('key') && images[i].key === key) {
                        imageKeyExist = true;
                        images[i].promise.then(defer.resolve, defer.reject);
                        break;
                    }
                }
                if (imageKeyExist === false) {
                    defer.reject('no image exist with key \'' + key + '\'');
                }
            }
            return defer.promise;
        }

        function getImagesByKey(details) {
            var _images = [];
            for (var i = 0; i < details.length; i++) {
                _images.push(getImageByKey(details[i]));
            }
            return _images;
        }

        function getDefaultImage() {
            var defer = $q.defer();
            if (!defaultImage.promise) {
                defer.reject('default image url not provided');
            } else {
                defaultImage.promise.then(defer.resolve, defer.reject);
            }
            return defer.promise;
        }
    }
}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module core
 */ /** */

var stateParams_1 = __webpack_require__(121);
var queue_1 = __webpack_require__(80);
var common_1 = __webpack_require__(0);
/**
 * Global mutable state
 */
var Globals = function () {
    function Globals(transitionService) {
        var _this = this;
        this.params = new stateParams_1.StateParams();
        this.transitionHistory = new queue_1.Queue([], 1);
        this.successfulTransitions = new queue_1.Queue([], 1);
        var beforeNewTransition = function beforeNewTransition($transition$) {
            _this.transition = $transition$;
            _this.transitionHistory.enqueue($transition$);
            var updateGlobalState = function updateGlobalState() {
                _this.successfulTransitions.enqueue($transition$);
                _this.$current = $transition$.$to();
                _this.current = _this.$current.self;
                common_1.copy($transition$.params(), _this.params);
            };
            $transition$.onSuccess({}, updateGlobalState, { priority: 10000 });
            var clearCurrentTransition = function clearCurrentTransition() {
                if (_this.transition === $transition$) _this.transition = null;
            };
            $transition$.promise.then(clearCurrentTransition, clearCurrentTransition);
        };
        transitionService.onBefore({}, beforeNewTransition);
    }
    return Globals;
}();
exports.Globals = Globals;
//# sourceMappingURL=globals.js.map

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var coreservices_1 = __webpack_require__(6);
/**
 * A [[TransitionHookFn]] that performs lazy loading
 *
 * When entering a state "abc" which has a `lazyLoad` function defined:
 * - Invoke the `lazyLoad` function (unless it is already in process)
 *   - Flag the hook function as "in process"
 *   - The function should return a promise (that resolves when lazy loading is complete)
 * - Wait for the promise to settle
 *   - If the promise resolves to a [[LazyLoadResult]], then register those states
 *   - Flag the hook function as "not in process"
 * - If the hook was successful
 *   - Remove the `lazyLoad` function from the state declaration
 * - If all the hooks were successful
 *   - Retry the transition (by returning a TargetState)
 *
 * ```
 * .state('abc', {
 *   component: 'fooComponent',
 *   lazyLoad: () => System.import('./fooComponent')
 *   });
 * ```
 *
 * See [[StateDeclaration.lazyLoad]]
 */
var lazyLoadHook = function lazyLoadHook(transition) {
    var router = transition.router;
    function retryTransition() {
        if (transition.originalTransition().options().source !== 'url') {
            // The original transition was not triggered via url sync
            // The lazy state should be loaded now, so re-try the original transition
            var orig = transition.targetState();
            return router.stateService.target(orig.identifier(), orig.params(), orig.options());
        }
        // The original transition was triggered via url sync
        // Run the URL rules and find the best match
        var $url = router.urlService;
        var result = $url.match($url.parts());
        var rule = result && result.rule;
        // If the best match is a state, redirect the transition (instead
        // of calling sync() which supersedes the current transition)
        if (rule && rule.type === "STATE") {
            var state = rule.state;
            var params = result.match;
            return router.stateService.target(state, params, transition.options());
        }
        // No matching state found, so let .sync() choose the best non-state match/otherwise
        router.urlRouter.sync();
    }
    var promises = transition.entering().filter(function (state) {
        return !!state.lazyLoad;
    }).map(function (state) {
        return lazyLoadState(transition, state);
    });
    return coreservices_1.services.$q.all(promises).then(retryTransition);
};
exports.registerLazyLoadHook = function (transitionService) {
    return transitionService.onBefore({ entering: function entering(state) {
            return !!state.lazyLoad;
        } }, lazyLoadHook);
};
/**
 * Invokes a state's lazy load function
 *
 * @param transition a Transition context
 * @param state the state to lazy load
 * @returns A promise for the lazy load result
 */
function lazyLoadState(transition, state) {
    var lazyLoadFn = state.lazyLoad;
    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
    var promise = lazyLoadFn['_promise'];
    if (!promise) {
        var success = function success(result) {
            delete state.lazyLoad;
            delete state.$$state().lazyLoad;
            delete lazyLoadFn['_promise'];
            return result;
        };
        var error = function error(err) {
            delete lazyLoadFn['_promise'];
            return coreservices_1.services.$q.reject(err);
        };
        promise = lazyLoadFn['_promise'] = coreservices_1.services.$q.when(lazyLoadFn(transition, state)).then(updateStateRegistry).then(success, error);
    }
    /** Register any lazy loaded state definitions */
    function updateStateRegistry(result) {
        if (result && Array.isArray(result.states)) {
            result.states.forEach(function (state) {
                return transition.router.stateRegistry.register(state);
            });
        }
        return result;
    }
    return promise;
}
exports.lazyLoadState = lazyLoadState;
//# sourceMappingURL=lazyLoad.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module params
 */ /** for typedoc */

var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
var hof_1 = __webpack_require__(3);
var coreservices_1 = __webpack_require__(6);
var paramType_1 = __webpack_require__(81);
/**
 * A registry for parameter types.
 *
 * This registry manages the built-in (and custom) parameter types.
 *
 * The built-in parameter types are:
 *
 * - [[string]]
 * - [[path]]
 * - [[query]]
 * - [[hash]]
 * - [[int]]
 * - [[bool]]
 * - [[date]]
 * - [[json]]
 * - [[any]]
 */
var ParamTypes = function () {
    /** @internalapi */
    function ParamTypes() {
        /** @hidden */
        this.enqueue = true;
        /** @hidden */
        this.typeQueue = [];
        /** @internalapi */
        this.defaultTypes = common_1.pick(ParamTypes.prototype, "hash", "string", "query", "path", "int", "bool", "date", "json", "any");
        // Register default types. Store them in the prototype of this.types.
        var makeType = function makeType(definition, name) {
            return new paramType_1.ParamType(common_1.extend({ name: name }, definition));
        };
        this.types = common_1.inherit(common_1.map(this.defaultTypes, makeType), {});
    }
    /** @internalapi */
    ParamTypes.prototype.dispose = function () {
        this.types = {};
    };
    /**
     * Registers a parameter type
     *
     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
     */
    ParamTypes.prototype.type = function (name, definition, definitionFn) {
        if (!predicates_1.isDefined(definition)) return this.types[name];
        if (this.types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
        this.types[name] = new paramType_1.ParamType(common_1.extend({ name: name }, definition));
        if (definitionFn) {
            this.typeQueue.push({ name: name, def: definitionFn });
            if (!this.enqueue) this._flushTypeQueue();
        }
        return this;
    };
    /** @internalapi */
    ParamTypes.prototype._flushTypeQueue = function () {
        while (this.typeQueue.length) {
            var type = this.typeQueue.shift();
            if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
            common_1.extend(this.types[type.name], coreservices_1.services.$injector.invoke(type.def));
        }
    };
    return ParamTypes;
}();
exports.ParamTypes = ParamTypes;
/** @hidden */
function initDefaultTypes() {
    var makeDefaultType = function makeDefaultType(def) {
        var valToString = function valToString(val) {
            return val != null ? val.toString() : val;
        };
        var defaultTypeBase = {
            encode: valToString,
            decode: valToString,
            is: hof_1.is(String),
            pattern: /.*/,
            equals: function equals(a, b) {
                return a == b;
            }
        };
        return common_1.extend({}, defaultTypeBase, def);
    };
    // Default Parameter Type Definitions
    common_1.extend(ParamTypes.prototype, {
        string: makeDefaultType({}),
        path: makeDefaultType({
            pattern: /[^/]*/
        }),
        query: makeDefaultType({}),
        hash: makeDefaultType({
            inherit: false
        }),
        int: makeDefaultType({
            decode: function decode(val) {
                return parseInt(val, 10);
            },
            is: function is(val) {
                return !predicates_1.isNullOrUndefined(val) && this.decode(val.toString()) === val;
            },
            pattern: /-?\d+/
        }),
        bool: makeDefaultType({
            encode: function encode(val) {
                return val && 1 || 0;
            },
            decode: function decode(val) {
                return parseInt(val, 10) !== 0;
            },
            is: hof_1.is(Boolean),
            pattern: /0|1/
        }),
        date: makeDefaultType({
            encode: function encode(val) {
                return !this.is(val) ? undefined : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join("-");
            },
            decode: function decode(val) {
                if (this.is(val)) return val;
                var match = this.capture.exec(val);
                return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
            },
            is: function is(val) {
                return val instanceof Date && !isNaN(val.valueOf());
            },
            equals: function equals(l, r) {
                return ['getFullYear', 'getMonth', 'getDate'].reduce(function (acc, fn) {
                    return acc && l[fn]() === r[fn]();
                }, true);
            },
            pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
            capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
        }),
        json: makeDefaultType({
            encode: common_1.toJson,
            decode: common_1.fromJson,
            is: hof_1.is(Object),
            equals: common_1.equals,
            pattern: /[^/]*/
        }),
        // does not encode/decode
        any: makeDefaultType({
            encode: common_1.identity,
            decode: common_1.identity,
            is: function is() {
                return true;
            },
            equals: common_1.equals
        })
    });
}
initDefaultTypes();
//# sourceMappingURL=paramTypes.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module params */ /** for typedoc */

var common_1 = __webpack_require__(0);
var StateParams = function () {
    function StateParams(params) {
        if (params === void 0) {
            params = {};
        }
        common_1.extend(this, params);
    }
    /**
     * Merges a set of parameters with all parameters inherited between the common parents of the
     * current state and a given destination state.
     *
     * @param {Object} newParams The set of parameters which will be composited with inherited params.
     * @param {Object} $current Internal definition of object representing the current state.
     * @param {Object} $to Internal definition of object representing state to transition to.
     */
    StateParams.prototype.$inherit = function (newParams, $current, $to) {
        var parents = common_1.ancestors($current, $to),
            parentParams,
            inherited = {},
            inheritList = [];
        for (var i in parents) {
            if (!parents[i] || !parents[i].params) continue;
            parentParams = Object.keys(parents[i].params);
            if (!parentParams.length) continue;
            for (var j in parentParams) {
                if (inheritList.indexOf(parentParams[j]) >= 0) continue;
                inheritList.push(parentParams[j]);
                inherited[parentParams[j]] = this[parentParams[j]];
            }
        }
        return common_1.extend({}, inherited, newParams);
    };
    ;
    return StateParams;
}();
exports.StateParams = StateParams;
//# sourceMappingURL=stateParams.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @internalapi */

exports.resolvePolicies = {
    when: {
        LAZY: "LAZY",
        EAGER: "EAGER"
    },
    async: {
        WAIT: "WAIT",
        NOWAIT: "NOWAIT",
        RXWAIT: "RXWAIT"
    }
};
//# sourceMappingURL=interface.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module core
 */ /** */

var urlMatcherFactory_1 = __webpack_require__(131);
var urlRouter_1 = __webpack_require__(132);
var transitionService_1 = __webpack_require__(85);
var view_1 = __webpack_require__(135);
var stateRegistry_1 = __webpack_require__(127);
var stateService_1 = __webpack_require__(128);
var globals_1 = __webpack_require__(118);
var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
var urlService_1 = __webpack_require__(134);
/** @hidden */
var _routerInstance = 0;
/**
 * The master class used to instantiate an instance of UI-Router.
 *
 * UI-Router (for a specific framework) will create an instance of this class during bootstrap.
 * This class instantiates and wires the UI-Router services together.
 *
 * After a new instance of the UIRouter class is created, it should be configured for your app.
 * For instance, app states should be registered with the [[stateRegistry]].
 *
 * Tell UI-Router to monitor the URL by calling `uiRouter.urlRouter.listen()` ([[UrlRouter.listen]])
 */
var UIRouter = function () {
    function UIRouter(locationService, locationConfig) {
        if (locationService === void 0) {
            locationService = urlService_1.UrlService.locationServiceStub;
        }
        if (locationConfig === void 0) {
            locationConfig = urlService_1.UrlService.locationConfigStub;
        }
        this.locationService = locationService;
        this.locationConfig = locationConfig;
        /** @hidden */
        this.$id = _routerInstance++;
        this.viewService = new view_1.ViewService();
        this.transitionService = new transitionService_1.TransitionService(this);
        this.globals = new globals_1.Globals(this.transitionService);
        this.urlMatcherFactory = new urlMatcherFactory_1.UrlMatcherFactory();
        this.urlRouter = new urlRouter_1.UrlRouter(this);
        this.stateRegistry = new stateRegistry_1.StateRegistry(this);
        this.stateService = new stateService_1.StateService(this);
        this.urlService = new urlService_1.UrlService(this);
        this._disposables = [];
        /** @hidden */
        this._plugins = {};
        this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
        this.globals.$current = this.stateRegistry.root();
        this.globals.current = this.globals.$current.self;
        this.disposable(this.transitionService);
        this.disposable(this.urlRouter);
        this.disposable(this.stateRegistry);
        this.disposable(locationService);
        this.disposable(locationConfig);
    }
    /** Registers an object to be notified when the router is disposed */
    UIRouter.prototype.disposable = function (disposable) {
        this._disposables.push(disposable);
    };
    /**
     * Disposes this router instance
     *
     * When called, clears resources retained by the router by calling `dispose(this)` on all
     * registered [[disposable]] objects.
     *
     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
     *
     * @param disposable (optional) the disposable to dispose
     */
    UIRouter.prototype.dispose = function (disposable) {
        var _this = this;
        if (disposable && predicates_1.isFunction(disposable.dispose)) {
            disposable.dispose(this);
            return undefined;
        }
        this._disposables.slice().forEach(function (d) {
            try {
                typeof d.dispose === 'function' && d.dispose(_this);
                common_1.removeFrom(_this._disposables, d);
            } catch (ignored) {}
        });
    };
    /** Allow javascript factory function */
    UIRouter.prototype.plugin = function (plugin, options) {
        if (options === void 0) {
            options = {};
        }
        var pluginInstance = new plugin(this, options);
        if (!pluginInstance.name) throw new Error("Required property `name` missing on plugin: " + pluginInstance);
        this._disposables.push(pluginInstance);
        return this._plugins[pluginInstance.name] = pluginInstance;
    };
    UIRouter.prototype.getPlugin = function (pluginName) {
        return pluginName ? this._plugins[pluginName] : common_1.values(this._plugins);
    };
    return UIRouter;
}();
exports.UIRouter = UIRouter;
//# sourceMappingURL=router.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module state */ /** for typedoc */

var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
var strings_1 = __webpack_require__(15);
var hof_1 = __webpack_require__(3);
var resolvable_1 = __webpack_require__(31);
var coreservices_1 = __webpack_require__(6);
var parseUrl = function parseUrl(url) {
    if (!predicates_1.isString(url)) return false;
    var root = url.charAt(0) === '^';
    return { val: root ? url.substring(1) : url, root: root };
};
function nameBuilder(state) {
    return state.name;
}
function selfBuilder(state) {
    state.self.$$state = function () {
        return state;
    };
    return state.self;
}
function dataBuilder(state) {
    if (state.parent && state.parent.data) {
        state.data = state.self.data = common_1.inherit(state.parent.data, state.data);
    }
    return state.data;
}
var getUrlBuilder = function getUrlBuilder($urlMatcherFactoryProvider, root) {
    return function urlBuilder(state) {
        var stateDec = state;
        // For future states, i.e., states whose name ends with `.**`,
        // match anything that starts with the url prefix
        if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
            stateDec.url += "{remainder:any}"; // match any path (.*)
        }
        var parsed = parseUrl(stateDec.url),
            parent = state.parent;
        var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, {
            params: state.params || {},
            paramMap: function paramMap(paramConfig, isSearch) {
                if (stateDec.reloadOnSearch === false && isSearch) paramConfig = common_1.extend(paramConfig || {}, { dynamic: true });
                return paramConfig;
            }
        });
        if (!url) return null;
        if (!$urlMatcherFactoryProvider.isMatcher(url)) throw new Error("Invalid url '" + url + "' in state '" + state + "'");
        return parsed && parsed.root ? url : (parent && parent.navigable || root()).url.append(url);
    };
};
var getNavigableBuilder = function getNavigableBuilder(isRoot) {
    return function navigableBuilder(state) {
        return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
    };
};
var getParamsBuilder = function getParamsBuilder(paramFactory) {
    return function paramsBuilder(state) {
        var makeConfigParam = function makeConfigParam(config, id) {
            return paramFactory.fromConfig(id, null, config);
        };
        var urlParams = state.url && state.url.parameters({ inherit: false }) || [];
        var nonUrlParams = common_1.values(common_1.mapObj(common_1.omit(state.params || {}, urlParams.map(hof_1.prop('id'))), makeConfigParam));
        return urlParams.concat(nonUrlParams).map(function (p) {
            return [p.id, p];
        }).reduce(common_1.applyPairs, {});
    };
};
function pathBuilder(state) {
    return state.parent ? state.parent.path.concat(state) : [state];
}
function includesBuilder(state) {
    var includes = state.parent ? common_1.extend({}, state.parent.includes) : {};
    includes[state.name] = true;
    return includes;
}
/**
 * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
 *
 * When the [[StateBuilder]] builds a [[State]] object from a raw [[StateDeclaration]], this builder
 * validates the `resolve` property and converts it to a [[Resolvable]] array.
 *
 * resolve: input value can be:
 *
 * {
 *   // analyzed but not injected
 *   myFooResolve: function() { return "myFooData"; },
 *
 *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
 *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
 *
 *   // Array split; "DependencyName" dep as string
 *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
 *
 *   // Array split; DependencyType dep as token (compared using ===)
 *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
 *
 *   // val.$inject used as deps
 *   // where:
 *   //     corgeResolve.$inject = ["DependencyName"];
 *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
 *   // then "DependencyName" dep as string
 *   myCorgeResolve: corgeResolve,
 *
 *  // inject service by name
 *  // When a string is found, desugar creating a resolve that injects the named service
 *   myGraultResolve: "SomeService"
 * }
 *
 * or:
 *
 * [
 *   new Resolvable("myFooResolve", function() { return "myFooData" }),
 *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
 *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
 * ]
 */
function resolvablesBuilder(state) {
    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
    var objects2Tuples = function objects2Tuples(resolveObj, resolvePolicies) {
        return Object.keys(resolveObj || {}).map(function (token) {
            return { token: token, val: resolveObj[token], deps: undefined, policy: resolvePolicies[token] };
        });
    };
    /** fetch DI annotations from a function or ng1-style array */
    var annotate = function annotate(fn) {
        var $injector = coreservices_1.services.$injector;
        // ng1 doesn't have an $injector until runtime.
        // If the $injector doesn't exist, use "deferred" literal as a
        // marker indicating they should be annotated when runtime starts
        return fn['$inject'] || $injector && $injector.annotate(fn, $injector.strictDi) || "deferred";
    };
    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
    var isResolveLiteral = function isResolveLiteral(obj) {
        return !!(obj.token && obj.resolveFn);
    };
    /** true if the object looks like a provide literal, or a ng2 Provider */
    var isLikeNg2Provider = function isLikeNg2Provider(obj) {
        return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
    };
    /** true if the object looks like a tuple from obj2Tuples */
    var isTupleFromObj = function isTupleFromObj(obj) {
        return !!(obj && obj.val && (predicates_1.isString(obj.val) || predicates_1.isArray(obj.val) || predicates_1.isFunction(obj.val)));
    };
    /** extracts the token from a Provider or provide literal */
    var token = function token(p) {
        return p.provide || p.token;
    };
    /** Given a literal resolve or provider object, returns a Resolvable */
    var literal2Resolvable = hof_1.pattern([[hof_1.prop('resolveFn'), function (p) {
        return new resolvable_1.Resolvable(token(p), p.resolveFn, p.deps, p.policy);
    }], [hof_1.prop('useFactory'), function (p) {
        return new resolvable_1.Resolvable(token(p), p.useFactory, p.deps || p.dependencies, p.policy);
    }], [hof_1.prop('useClass'), function (p) {
        return new resolvable_1.Resolvable(token(p), function () {
            return new p.useClass();
        }, [], p.policy);
    }], [hof_1.prop('useValue'), function (p) {
        return new resolvable_1.Resolvable(token(p), function () {
            return p.useValue;
        }, [], p.policy, p.useValue);
    }], [hof_1.prop('useExisting'), function (p) {
        return new resolvable_1.Resolvable(token(p), common_1.identity, [p.useExisting], p.policy);
    }]]);
    var tuple2Resolvable = hof_1.pattern([[hof_1.pipe(hof_1.prop("val"), predicates_1.isString), function (tuple) {
        return new resolvable_1.Resolvable(tuple.token, common_1.identity, [tuple.val], tuple.policy);
    }], [hof_1.pipe(hof_1.prop("val"), predicates_1.isArray), function (tuple) {
        return new resolvable_1.Resolvable(tuple.token, common_1.tail(tuple.val), tuple.val.slice(0, -1), tuple.policy);
    }], [hof_1.pipe(hof_1.prop("val"), predicates_1.isFunction), function (tuple) {
        return new resolvable_1.Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy);
    }]]);
    var item2Resolvable = hof_1.pattern([[hof_1.is(resolvable_1.Resolvable), function (r) {
        return r;
    }], [isResolveLiteral, literal2Resolvable], [isLikeNg2Provider, literal2Resolvable], [isTupleFromObj, tuple2Resolvable], [hof_1.val(true), function (obj) {
        throw new Error("Invalid resolve value: " + strings_1.stringify(obj));
    }]]);
    // If resolveBlock is already an array, use it as-is.
    // Otherwise, assume it's an object and convert to an Array of tuples
    var decl = state.resolve;
    var items = predicates_1.isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
    return items.map(item2Resolvable);
}
exports.resolvablesBuilder = resolvablesBuilder;
/**
 * @internalapi A internal global service
 *
 * StateBuilder is a factory for the internal [[State]] objects.
 *
 * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
 * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
 * [[State]] object, which has an API and is used internally.
 *
 * Custom properties or API may be added to the internal [[State]] object by registering a decorator function
 * using the [[builder]] method.
 */
var StateBuilder = function () {
    function StateBuilder(matcher, urlMatcherFactory) {
        this.matcher = matcher;
        var self = this;
        var root = function root() {
            return matcher.find("");
        };
        var isRoot = function isRoot(state) {
            return state.name === "";
        };
        function parentBuilder(state) {
            if (isRoot(state)) return null;
            return matcher.find(self.parentName(state)) || root();
        }
        this.builders = {
            name: [nameBuilder],
            self: [selfBuilder],
            parent: [parentBuilder],
            data: [dataBuilder],
            // Build a URLMatcher if necessary, either via a relative or absolute URL
            url: [getUrlBuilder(urlMatcherFactory, root)],
            // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
            navigable: [getNavigableBuilder(isRoot)],
            params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
            // Each framework-specific ui-router implementation should define its own `views` builder
            // e.g., src/ng1/statebuilders/views.ts
            views: [],
            // Keep a full path from the root down to this state as this is needed for state activation.
            path: [pathBuilder],
            // Speed up $state.includes() as it's used a lot
            includes: [includesBuilder],
            resolvables: [resolvablesBuilder]
        };
    }
    /**
     * Registers a [[BuilderFunction]] for a specific [[State]] property (e.g., `parent`, `url`, or `path`).
     * More than one BuilderFunction can be registered for a given property.
     *
     * The BuilderFunction(s) will be used to define the property on any subsequently built [[State]] objects.
     *
     * @param name The name of the State property being registered for.
     * @param fn The BuilderFunction which will be used to build the State property
     * @returns a function which deregisters the BuilderFunction
     */
    StateBuilder.prototype.builder = function (name, fn) {
        var builders = this.builders;
        var array = builders[name] || [];
        // Backwards compat: if only one builder exists, return it, else return whole arary.
        if (predicates_1.isString(name) && !predicates_1.isDefined(fn)) return array.length > 1 ? array : array[0];
        if (!predicates_1.isString(name) || !predicates_1.isFunction(fn)) return;
        builders[name] = array;
        builders[name].push(fn);
        return function () {
            return builders[name].splice(builders[name].indexOf(fn, 1)) && null;
        };
    };
    /**
     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
     * properties and API built.
     *
     * @param state an uninitialized State object
     * @returns the built State object
     */
    StateBuilder.prototype.build = function (state) {
        var _a = this,
            matcher = _a.matcher,
            builders = _a.builders;
        var parent = this.parentName(state);
        if (parent && !matcher.find(parent)) return null;
        for (var key in builders) {
            if (!builders.hasOwnProperty(key)) continue;
            var chain = builders[key].reduce(function (parentFn, step) {
                return function (_state) {
                    return step(_state, parentFn);
                };
            }, common_1.noop);
            state[key] = chain(state);
        }
        return state;
    };
    StateBuilder.prototype.parentName = function (state) {
        var name = state.name || "";
        var segments = name.split('.');
        if (segments.length > 1) {
            if (state.parent) {
                throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
            }
            var lastSegment = segments.pop();
            if (lastSegment === '**') segments.pop();
            return segments.join(".");
        }
        if (!state.parent) return "";
        return predicates_1.isString(state.parent) ? state.parent : state.parent.name;
    };
    StateBuilder.prototype.name = function (state) {
        var name = state.name;
        if (name.indexOf('.') !== -1 || !state.parent) return name;
        var parentName = predicates_1.isString(state.parent) ? state.parent : state.parent.name;
        return parentName ? parentName + "." + name : name;
    };
    return StateBuilder;
}();
exports.StateBuilder = StateBuilder;
//# sourceMappingURL=stateBuilder.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module state */ /** for typedoc */

var predicates_1 = __webpack_require__(1);
var glob_1 = __webpack_require__(50);
var common_1 = __webpack_require__(0);
var StateMatcher = function () {
    function StateMatcher(_states) {
        this._states = _states;
    }
    StateMatcher.prototype.isRelative = function (stateName) {
        stateName = stateName || "";
        return stateName.indexOf(".") === 0 || stateName.indexOf("^") === 0;
    };
    StateMatcher.prototype.find = function (stateOrName, base) {
        if (!stateOrName && stateOrName !== "") return undefined;
        var isStr = predicates_1.isString(stateOrName);
        var name = isStr ? stateOrName : stateOrName.name;
        if (this.isRelative(name)) name = this.resolvePath(name, base);
        var state = this._states[name];
        if (state && (isStr || !isStr && (state === stateOrName || state.self === stateOrName))) {
            return state;
        } else if (isStr) {
            var matches = common_1.values(this._states).filter(function (state) {
                return new glob_1.Glob(state.name).matches(name);
            });
            if (matches.length > 1) {
                console.log("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) {
                    return match.name;
                }));
            }
            return matches[0];
        }
        return undefined;
    };
    StateMatcher.prototype.resolvePath = function (name, base) {
        if (!base) throw new Error("No reference point given for path '" + name + "'");
        var baseState = this.find(base);
        var splitName = name.split("."),
            i = 0,
            pathLength = splitName.length,
            current = baseState;
        for (; i < pathLength; i++) {
            if (splitName[i] === "" && i === 0) {
                current = baseState;
                continue;
            }
            if (splitName[i] === "^") {
                if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
                current = current.parent;
                continue;
            }
            break;
        }
        var relName = splitName.slice(i).join(".");
        return current.name + (current.name && relName ? "." : "") + relName;
    };
    return StateMatcher;
}();
exports.StateMatcher = StateMatcher;
//# sourceMappingURL=stateMatcher.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module state */ /** for typedoc */

var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
var stateObject_1 = __webpack_require__(82);
/** @internalapi */
var StateQueueManager = function () {
    function StateQueueManager($registry, $urlRouter, states, builder, listeners) {
        this.$registry = $registry;
        this.$urlRouter = $urlRouter;
        this.states = states;
        this.builder = builder;
        this.listeners = listeners;
        this.queue = [];
    }
    /** @internalapi */
    StateQueueManager.prototype.dispose = function () {
        this.queue = [];
    };
    StateQueueManager.prototype.register = function (config) {
        var _a = this,
            states = _a.states,
            queue = _a.queue;
        // Wrap a new object around the state so we can store our private details easily.
        // @TODO: state = new State(extend({}, config, { ... }))
        var state = common_1.inherit(new stateObject_1.State(), common_1.extend({}, config, {
            self: config,
            resolve: config.resolve || [],
            toString: function toString() {
                return config.name;
            }
        }));
        if (!predicates_1.isString(state.name)) throw new Error("State must have a valid name");
        if (states.hasOwnProperty(state.name) || common_1.pluck(queue, 'name').indexOf(state.name) !== -1) throw new Error("State '" + state.name + "' is already defined");
        queue.push(state);
        this.flush();
        return state;
    };
    StateQueueManager.prototype.flush = function () {
        var _a = this,
            queue = _a.queue,
            states = _a.states,
            builder = _a.builder;
        var registered = [],
            // states that got registered
        orphans = [],
            // states that don't yet have a parent registered
        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
        while (queue.length > 0) {
            var state = queue.shift();
            var result = builder.build(state);
            var orphanIdx = orphans.indexOf(state);
            if (result) {
                var existingState = this.$registry.get(state.name);
                if (existingState && existingState.name === state.name) {
                    throw new Error("State '" + state.name + "' is already defined");
                }
                if (existingState && existingState.name === state.name + ".**") {
                    // Remove future state of the same name
                    this.$registry.deregister(existingState);
                }
                states[state.name] = state;
                this.attachRoute(state);
                if (orphanIdx >= 0) orphans.splice(orphanIdx, 1);
                registered.push(state);
                continue;
            }
            var prev = previousQueueLength[state.name];
            previousQueueLength[state.name] = queue.length;
            if (orphanIdx >= 0 && prev === queue.length) {
                // Wait until two consecutive iterations where no additional states were dequeued successfully.
                // throw new Error(`Cannot register orphaned state '${state.name}'`);
                queue.push(state);
                return states;
            } else if (orphanIdx < 0) {
                orphans.push(state);
            }
            queue.push(state);
        }
        if (registered.length) {
            this.listeners.forEach(function (listener) {
                return listener("registered", registered.map(function (s) {
                    return s.self;
                }));
            });
        }
        return states;
    };
    StateQueueManager.prototype.attachRoute = function (state) {
        if (state.abstract || !state.url) return;
        this.$urlRouter.rule(this.$urlRouter.urlRuleFactory.create(state));
    };
    return StateQueueManager;
}();
exports.StateQueueManager = StateQueueManager;
//# sourceMappingURL=stateQueueManager.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module state
 */ /** for typedoc */


var stateMatcher_1 = __webpack_require__(125);
var stateBuilder_1 = __webpack_require__(124);
var stateQueueManager_1 = __webpack_require__(126);
var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
var StateRegistry = function () {
    /** @internalapi */
    function StateRegistry(_router) {
        this._router = _router;
        this.states = {};
        this.listeners = [];
        this.matcher = new stateMatcher_1.StateMatcher(this.states);
        this.builder = new stateBuilder_1.StateBuilder(this.matcher, _router.urlMatcherFactory);
        this.stateQueue = new stateQueueManager_1.StateQueueManager(this, _router.urlRouter, this.states, this.builder, this.listeners);
        this._registerRoot();
    }
    /** @internalapi */
    StateRegistry.prototype._registerRoot = function () {
        var rootStateDef = {
            name: '',
            url: '^',
            views: null,
            params: {
                '#': { value: null, type: 'hash', dynamic: true }
            },
            abstract: true
        };
        var _root = this._root = this.stateQueue.register(rootStateDef);
        _root.navigable = null;
    };
    /** @internalapi */
    StateRegistry.prototype.dispose = function () {
        var _this = this;
        this.stateQueue.dispose();
        this.listeners = [];
        this.get().forEach(function (state) {
            return _this.get(state) && _this.deregister(state);
        });
    };
    /**
     * Listen for a State Registry events
     *
     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
     *
     * #### Example:
     * ```js
     * let allStates = registry.get();
     *
     * // Later, invoke deregisterFn() to remove the listener
     * let deregisterFn = registry.onStatesChanged((event, states) => {
     *   switch(event) {
     *     case: 'registered':
     *       states.forEach(state => allStates.push(state));
     *       break;
     *     case: 'deregistered':
     *       states.forEach(state => {
     *         let idx = allStates.indexOf(state);
     *         if (idx !== -1) allStates.splice(idx, 1);
     *       });
     *       break;
     *   }
     * });
     * ```
     *
     * @param listener a callback function invoked when the registered states changes.
     *        The function receives two parameters, `event` and `state`.
     *        See [[StateRegistryListener]]
     * @return a function that deregisters the listener
     */
    StateRegistry.prototype.onStatesChanged = function (listener) {
        this.listeners.push(listener);
        return function deregisterListener() {
            common_1.removeFrom(this.listeners)(listener);
        }.bind(this);
    };
    /**
     * Gets the implicit root state
     *
     * Gets the root of the state tree.
     * The root state is implicitly created by UI-Router.
     * Note: this returns the internal [[State]] representation, not a [[StateDeclaration]]
     *
     * @return the root [[State]]
     */
    StateRegistry.prototype.root = function () {
        return this._root;
    };
    /**
     * Adds a state to the registry
     *
     * Registers a [[StateDeclaration]] or queues it for registration.
     *
     * Note: a state will be queued if the state's parent isn't yet registered.
     * It will also be queued if the queue is not yet in [[StateQueueManager.autoFlush]] mode.
     *
     * @param stateDefinition the definition of the state to register.
     * @returns the internal [[State]] object.
     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
     *          If the state was only queued, then the object is not fully built.
     */
    StateRegistry.prototype.register = function (stateDefinition) {
        return this.stateQueue.register(stateDefinition);
    };
    /** @hidden */
    StateRegistry.prototype._deregisterTree = function (state) {
        var _this = this;
        var all = this.get().map(function (s) {
            return s.$$state();
        });
        var getChildren = function getChildren(states) {
            var children = all.filter(function (s) {
                return states.indexOf(s.parent) !== -1;
            });
            return children.length === 0 ? children : children.concat(getChildren(children));
        };
        var children = getChildren([state]);
        var deregistered = [state].concat(children).reverse();
        deregistered.forEach(function (state) {
            var $ur = _this._router.urlRouter;
            // Remove URL rule
            $ur.rules().filter(hof_1.propEq("state", state)).forEach($ur.removeRule.bind($ur));
            // Remove state from registry
            delete _this.states[state.name];
        });
        return deregistered;
    };
    /**
     * Removes a state from the registry
     *
     * This removes a state from the registry.
     * If the state has children, they are are also removed from the registry.
     *
     * @param stateOrName the state's name or object representation
     * @returns {State[]} a list of removed states
     */
    StateRegistry.prototype.deregister = function (stateOrName) {
        var _state = this.get(stateOrName);
        if (!_state) throw new Error("Can't deregister state; not found: " + stateOrName);
        var deregisteredStates = this._deregisterTree(_state.$$state());
        this.listeners.forEach(function (listener) {
            return listener("deregistered", deregisteredStates.map(function (s) {
                return s.self;
            }));
        });
        return deregisteredStates;
    };
    StateRegistry.prototype.get = function (stateOrName, base) {
        var _this = this;
        if (arguments.length === 0) return Object.keys(this.states).map(function (name) {
            return _this.states[name].self;
        });
        var found = this.matcher.find(stateOrName, base);
        return found && found.self || null;
    };
    StateRegistry.prototype.decorator = function (name, func) {
        return this.builder.builder(name, func);
    };
    return StateRegistry;
}();
exports.StateRegistry = StateRegistry;
//# sourceMappingURL=stateRegistry.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module state
 */ /** */

var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
var queue_1 = __webpack_require__(80);
var coreservices_1 = __webpack_require__(6);
var pathFactory_1 = __webpack_require__(52);
var node_1 = __webpack_require__(51);
var transitionService_1 = __webpack_require__(85);
var rejectFactory_1 = __webpack_require__(33);
var targetState_1 = __webpack_require__(19);
var param_1 = __webpack_require__(25);
var glob_1 = __webpack_require__(50);
var resolveContext_1 = __webpack_require__(53);
var lazyLoad_1 = __webpack_require__(119);
var hof_1 = __webpack_require__(3);
/**
 * Provides state related service functions
 *
 * This class provides services related to ui-router states.
 * An instance of this class is located on the global [[UIRouter]] object.
 */
var StateService = function () {
    /** @internalapi */
    function StateService(router) {
        this.router = router;
        /** @internalapi */
        this.invalidCallbacks = [];
        /** @hidden */
        this._defaultErrorHandler = function $defaultErrorHandler($error$) {
            if ($error$ instanceof Error && $error$.stack) {
                console.error($error$);
                console.error($error$.stack);
            } else if ($error$ instanceof rejectFactory_1.Rejection) {
                console.error($error$.toString());
                if ($error$.detail && $error$.detail.stack) console.error($error$.detail.stack);
            } else {
                console.error($error$);
            }
        };
        var getters = ['current', '$current', 'params', 'transition'];
        var boundFns = Object.keys(StateService.prototype).filter(hof_1.not(common_1.inArray(getters)));
        common_1.createProxyFunctions(hof_1.val(StateService.prototype), this, hof_1.val(this), boundFns);
    }
    Object.defineProperty(StateService.prototype, "transition", {
        /**
         * The [[Transition]] currently in progress (or null)
         *
         * This is a passthrough through to [[UIRouterGlobals.transition]]
         */
        get: function get() {
            return this.router.globals.transition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "params", {
        /**
         * The latest successful state parameters
         *
         * This is a passthrough through to [[UIRouterGlobals.params]]
         */
        get: function get() {
            return this.router.globals.params;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "current", {
        /**
         * The current [[StateDeclaration]]
         *
         * This is a passthrough through to [[UIRouterGlobals.current]]
         */
        get: function get() {
            return this.router.globals.current;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateService.prototype, "$current", {
        /**
         * The current [[State]]
         *
         * This is a passthrough through to [[UIRouterGlobals.$current]]
         */
        get: function get() {
            return this.router.globals.$current;
        },
        enumerable: true,
        configurable: true
    });
    /** @internalapi */
    StateService.prototype.dispose = function () {
        this.defaultErrorHandler(common_1.noop);
        this.invalidCallbacks = [];
    };
    /**
     * Handler for when [[transitionTo]] is called with an invalid state.
     *
     * Invokes the [[onInvalid]] callbacks, in natural order.
     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
     *
     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
     *
     * @internalapi
     */
    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
        var _this = this;
        var fromState = pathFactory_1.PathFactory.makeTargetState(fromPath);
        var globals = this.router.globals;
        var latestThing = function latestThing() {
            return globals.transitionHistory.peekTail();
        };
        var latest = latestThing();
        var callbackQueue = new queue_1.Queue(this.invalidCallbacks.slice());
        var injector = new resolveContext_1.ResolveContext(fromPath).injector();
        var checkForRedirect = function checkForRedirect(result) {
            if (!(result instanceof targetState_1.TargetState)) {
                return;
            }
            var target = result;
            // Recreate the TargetState, in case the state is now defined.
            target = _this.target(target.identifier(), target.params(), target.options());
            if (!target.valid()) return rejectFactory_1.Rejection.invalid(target.error()).toPromise();
            if (latestThing() !== latest) return rejectFactory_1.Rejection.superseded().toPromise();
            return _this.transitionTo(target.identifier(), target.params(), target.options());
        };
        function invokeNextCallback() {
            var nextCallback = callbackQueue.dequeue();
            if (nextCallback === undefined) return rejectFactory_1.Rejection.invalid(toState.error()).toPromise();
            var callbackResult = coreservices_1.services.$q.when(nextCallback(toState, fromState, injector));
            return callbackResult.then(checkForRedirect).then(function (result) {
                return result || invokeNextCallback();
            });
        }
        return invokeNextCallback();
    };
    /**
     * Registers an Invalid State handler
     *
     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
     * has been called with an invalid state reference parameter
     *
     * Example:
     * ```js
     * stateService.onInvalid(function(to, from, injector) {
     *   if (to.name() === 'foo') {
     *     let lazyLoader = injector.get('LazyLoadService');
     *     return lazyLoader.load('foo')
     *         .then(() => stateService.target('foo'));
     *   }
     * });
     * ```
     *
     * @param {function} callback invoked when the toState is invalid
     *   This function receives the (invalid) toState, the fromState, and an injector.
     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
     *   If one is returned, it is treated as a redirect.
     *
     * @returns a function which deregisters the callback
     */
    StateService.prototype.onInvalid = function (callback) {
        this.invalidCallbacks.push(callback);
        return function deregisterListener() {
            common_1.removeFrom(this.invalidCallbacks)(callback);
        }.bind(this);
    };
    /**
     * Reloads the current state
     *
     * A method that force reloads the current state, or a partial state hierarchy.
     * All resolves are re-resolved, and components reinstantiated.
     *
     * #### Example:
     * ```js
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * ```
     *
     * Note: `reload()` is just an alias for:
     *
     * ```js
     * $state.transitionTo($state.current, $state.params, {
     *   reload: true, inherit: false
     * });
     * ```
     *
     * @param reloadState A state name or a state object.
     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
     *
     * #### Example:
     * ```js
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
     * //and current state is 'contacts.detail.item'
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * ```
     *
     * @returns A promise representing the state of the new transition. See [[StateService.go]]
     */
    StateService.prototype.reload = function (reloadState) {
        return this.transitionTo(this.current, this.params, {
            reload: predicates_1.isDefined(reloadState) ? reloadState : true,
            inherit: false,
            notify: false
        });
    };
    ;
    /**
     * Transition to a different state or parameters
     *
     * Convenience method for transitioning to a new state.
     *
     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
     * `{ location: true, inherit: true, relative: $state.$current, notify: true }`.
     * This allows you to easily use an absolute or relative to path and specify
     * only the parameters you'd like to update (while letting unspecified parameters
     * inherit from the currently active ancestor states).
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * ```
     *
     *
     * @param to Absolute state name, state object, or relative state path. Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to a parent state
     * - `$state.go('^.sibling')` - will go to a sibling state
     * - `$state.go('.child.grandchild')` - will go to grandchild state
     *
     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
     *
     *    Any parameters that are not specified will be inherited from currently defined parameters (because of `inherit: true`).
     *    This allows, for example, going to a sibling state that shares parameters specified in a parent state.
     *
     *    Parameter inheritance only works between common ancestor states, I.e.
     *    transitioning to a sibling will get you the parameters for all parents, transitioning to a child
     *    will get you all current parameters, etc.
     *
     * @param options Transition options
     *
     * @returns {promise} A promise representing the state of the new transition.
     *
     * - Possible success values:
     *    - $state.current
     *
     * - Possible rejection reasons:
     *   - transition superseded - when a newer transition has been started after this one
     *   - transition aborted - when the transition is cancelled by a Transition Hook returning `false`
     *   - transition failed - when a transition hook errors
     *   - resolve error - when a resolve has errored or rejected
     *
     */
    StateService.prototype.go = function (to, params, options) {
        var defautGoOpts = { relative: this.$current, inherit: true };
        var transOpts = common_1.defaults(options, defautGoOpts, transitionService_1.defaultTransOpts);
        return this.transitionTo(to, params, transOpts);
    };
    ;
    /**
     * Creates a [[TargetState]]
     *
     * This is a factory method for creating a TargetState
     *
     * This may be returned from a Transition Hook to redirect a transition, for example.
     */
    StateService.prototype.target = function (identifier, params, options) {
        if (options === void 0) {
            options = {};
        }
        // If we're reloading, find the state object to reload from
        if (predicates_1.isObject(options.reload) && !options.reload.name) throw new Error('Invalid reload state object');
        var reg = this.router.stateRegistry;
        options.reloadState = options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
        if (options.reload && !options.reloadState) throw new Error("No such reload state '" + (predicates_1.isString(options.reload) ? options.reload : options.reload.name) + "'");
        var stateDefinition = reg.matcher.find(identifier, options.relative);
        return new targetState_1.TargetState(identifier, stateDefinition, params, options);
    };
    ;
    StateService.prototype.getCurrentPath = function () {
        var _this = this;
        var globals = this.router.globals;
        var latestSuccess = globals.successfulTransitions.peekTail();
        var rootPath = function rootPath() {
            return [new node_1.PathNode(_this.router.stateRegistry.root())];
        };
        return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
    };
    /**
     * Low-level method for transitioning to a new state.
     *
     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * ```
     *
     * @param to State name or state object.
     * @param toParams A map of the parameters that will be sent to the state,
     *      will populate $stateParams.
     * @param options Transition options
     *
     * @returns A promise representing the state of the new transition. See [[go]]
     */
    StateService.prototype.transitionTo = function (to, toParams, options) {
        var _this = this;
        if (toParams === void 0) {
            toParams = {};
        }
        if (options === void 0) {
            options = {};
        }
        var router = this.router;
        var globals = router.globals;
        var transHistory = globals.transitionHistory;
        options = common_1.defaults(options, transitionService_1.defaultTransOpts);
        options = common_1.extend(options, { current: transHistory.peekTail.bind(transHistory) });
        var ref = this.target(to, toParams, options);
        var currentPath = this.getCurrentPath();
        if (!ref.exists()) return this._handleInvalidTargetState(currentPath, ref);
        if (!ref.valid()) return common_1.silentRejection(ref.error());
        /**
         * Special handling for Ignored, Aborted, and Redirected transitions
         *
         * The semantics for the transition.run() promise and the StateService.transitionTo()
         * promise differ. For instance, the run() promise may be rejected because it was
         * IGNORED, but the transitionTo() promise is resolved because from the user perspective
         * no error occurred.  Likewise, the transition.run() promise may be rejected because of
         * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
         */
        var rejectedTransitionHandler = function rejectedTransitionHandler(transition) {
            return function (error) {
                if (error instanceof rejectFactory_1.Rejection) {
                    if (error.type === rejectFactory_1.RejectType.IGNORED) {
                        // Consider ignored `Transition.run()` as a successful `transitionTo`
                        router.urlRouter.update();
                        return coreservices_1.services.$q.when(globals.current);
                    }
                    var detail = error.detail;
                    if (error.type === rejectFactory_1.RejectType.SUPERSEDED && error.redirected && detail instanceof targetState_1.TargetState) {
                        // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
                        // by returning the promise for the new (redirect) `Transition.run()`.
                        var redirect = transition.redirect(detail);
                        return redirect.run().catch(rejectedTransitionHandler(redirect));
                    }
                    if (error.type === rejectFactory_1.RejectType.ABORTED) {
                        router.urlRouter.update();
                    }
                }
                var errorHandler = _this.defaultErrorHandler();
                errorHandler(error);
                return coreservices_1.services.$q.reject(error);
            };
        };
        var transition = this.router.transitionService.create(currentPath, ref);
        var transitionToPromise = transition.run().catch(rejectedTransitionHandler(transition));
        common_1.silenceUncaughtInPromise(transitionToPromise); // issue #2676
        // Return a promise for the transition, which also has the transition object on it.
        return common_1.extend(transitionToPromise, { transition: transition });
    };
    ;
    /**
     * Checks if the current state *is* the provided state
     *
     * Similar to [[includes]] but only checks for the full state name.
     * If params is supplied then it will be tested for strict equality against the current
     * active params object, so all params must match with none missing and no extras.
     *
     * #### Example:
     * ```js
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     * ```
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * ```html
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * ```
     *
     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns Returns true if it is the state.
     */
    StateService.prototype.is = function (stateOrName, params, options) {
        options = common_1.defaults(options, { relative: this.$current });
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
        if (!predicates_1.isDefined(state)) return undefined;
        if (this.$current !== state) return false;
        if (!params) return true;
        var schema = state.parameters({ inherit: true, matchingKeys: params });
        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
    };
    ;
    /**
     * Checks if the current state *includes* the provided state
     *
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * #### Example when `$state.$current.name === 'contacts.details.item'`
     * ```js
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     * ```
     *
     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
     * ```js
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * ```
     *
     * @param stateOrName A partial name, relative name, glob pattern,
     *   or state object to be searched for within the current state name.
     * @param params A param object, e.g. `{sectionId: section.id}`,
     *   that you'd like to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    StateService.prototype.includes = function (stateOrName, params, options) {
        options = common_1.defaults(options, { relative: this.$current });
        var glob = predicates_1.isString(stateOrName) && glob_1.Glob.fromString(stateOrName);
        if (glob) {
            if (!glob.matches(this.$current.name)) return false;
            stateOrName = this.$current.name;
        }
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative),
            include = this.$current.includes;
        if (!predicates_1.isDefined(state)) return undefined;
        if (!predicates_1.isDefined(include[state.name])) return false;
        if (!params) return true;
        var schema = state.parameters({ inherit: true, matchingKeys: params });
        return param_1.Param.equals(schema, param_1.Param.values(schema, params), this.params);
    };
    ;
    /**
     * Generates a URL for a state and parameters
     *
     * Returns the url for the given state populated with the given params.
     *
     * #### Example:
     * ```js
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * ```
     *
     * @param stateOrName The state name or state object you'd like to generate a url from.
     * @param params An object of parameter values to fill the state's required parameters.
     * @param options Options object. The options are:
     *
     * - **`lossy`** - {boolean=true} -  If true, and if there is no url associated with the state provided in the
     *    first parameter, then the constructed href url will be built from the first navigable ancestor (aka
     *    ancestor with a valid url).
     * - **`inherit`** - {boolean=true}, If `true` will inherit url parameters from current url.
     * - **`relative`** - {object=$state.$current}, When transitioning with relative path (e.g '^'),
     *    defines which state to be relative from.
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     *
     * @returns {string} compiled state url
     */
    StateService.prototype.href = function (stateOrName, params, options) {
        var defaultHrefOpts = {
            lossy: true,
            inherit: true,
            absolute: false,
            relative: this.$current
        };
        options = common_1.defaults(options, defaultHrefOpts);
        params = params || {};
        var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
        if (!predicates_1.isDefined(state)) return null;
        if (options.inherit) params = this.params.$inherit(params, this.$current, state);
        var nav = state && options.lossy ? state.navigable : state;
        if (!nav || nav.url === undefined || nav.url === null) {
            return null;
        }
        return this.router.urlRouter.href(nav.url, param_1.Param.values(state.parameters(), params), {
            absolute: options.absolute
        });
    };
    ;
    /**
     * Sets or gets the default [[transitionTo]] error handler.
     *
     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
     * This includes errors caused by resolves and transition hooks.
     *
     * Note:
     * This handler does not receive certain Transition rejections.
     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
     *
     * The built-in default error handler logs the error to the console.
     *
     * You can provide your own custom handler.
     *
     * #### Example:
     * ```js
     * stateService.defaultErrorHandler(function() {
     *   // Do not log transitionTo errors
     * });
     * ```
     *
     * @param handler a global error handler function
     * @returns the current global error handler
     */
    StateService.prototype.defaultErrorHandler = function (handler) {
        return this._defaultErrorHandler = handler || this._defaultErrorHandler;
    };
    StateService.prototype.get = function (stateOrName, base) {
        var reg = this.router.stateRegistry;
        if (arguments.length === 0) return reg.get();
        return reg.get(stateOrName, base || this.$current);
    };
    /**
     * Lazy loads a state
     *
     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
     *
     * @param stateOrName the state that should be lazy loaded
     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
     * This noop transition is not actually run.
     *
     * @returns a promise to lazy load
     */
    StateService.prototype.lazyLoad = function (stateOrName, transition) {
        var state = this.get(stateOrName);
        if (!state || !state.lazyLoad) throw new Error("Can not lazy load " + stateOrName);
        var currentPath = this.getCurrentPath();
        var target = pathFactory_1.PathFactory.makeTargetState(currentPath);
        transition = transition || this.router.transitionService.create(currentPath, target);
        return lazyLoad_1.lazyLoadState(transition, state);
    };
    return StateService;
}();
exports.StateService = StateService;
//# sourceMappingURL=stateService.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module transition
 */ /** for typedoc */


var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
var interface_1 = __webpack_require__(32);
var transitionHook_1 = __webpack_require__(34);
/**
 * This class returns applicable TransitionHooks for a specific Transition instance.
 *
 * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
 * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
 * determined by the type of hook)
 *
 * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
 *
 * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
 * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
 * in the Transition class, so we must also provide the Transition's _treeChanges)
 *
 */
var HookBuilder = function () {
    function HookBuilder(transition) {
        this.transition = transition;
        this.treeChanges = transition.treeChanges();
        this.transitionOptions = transition.options();
        this.toState = common_1.tail(this.treeChanges.to).state;
        this.fromState = common_1.tail(this.treeChanges.from).state;
        this.$transitions = transition.router.transitionService;
        this.baseHookOptions = {
            transition: transition,
            current: transition.options().current
        };
    }
    HookBuilder.prototype.buildHooksForPhase = function (phase) {
        var _this = this;
        return this.$transitions._pluginapi._getEvents(phase).map(function (type) {
            return _this.buildHooks(type);
        }).reduce(common_1.unnestR, []).filter(common_1.identity);
    };
    /**
     * Returns an array of newly built TransitionHook objects.
     *
     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
     * - For each of the [[PathNode]]s, creates a TransitionHook
     *
     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
     */
    HookBuilder.prototype.buildHooks = function (hookType) {
        var _this = this;
        // Find all the matching registered hooks for a given hook type
        var matchingHooks = this.getMatchingHooks(hookType, this.treeChanges);
        if (!matchingHooks) return [];
        var makeTransitionHooks = function makeTransitionHooks(hook) {
            // Fetch the Nodes that caused this hook to match.
            var matches = hook.matches(_this.treeChanges);
            // Select the PathNode[] that will be used as TransitionHook context objects
            var matchingNodes = matches[hookType.criteriaMatchPath.name];
            // Return an array of HookTuples
            return matchingNodes.map(function (node) {
                var _options = common_1.extend({
                    bind: hook.bind,
                    traceData: { hookType: hookType.name, context: node }
                }, _this.baseHookOptions);
                var state = hookType.criteriaMatchPath.scope === interface_1.TransitionHookScope.STATE ? node.state : null;
                var transitionHook = new transitionHook_1.TransitionHook(_this.transition, state, hook, _options);
                return { hook: hook, node: node, transitionHook: transitionHook };
            });
        };
        return matchingHooks.map(makeTransitionHooks).reduce(common_1.unnestR, []).sort(tupleSort(hookType.reverseSort)).map(function (tuple) {
            return tuple.transitionHook;
        });
    };
    /**
     * Finds all RegisteredHooks from:
     * - The Transition object instance hook registry
     * - The TransitionService ($transitions) global hook registry
     *
     * which matched:
     * - the eventType
     * - the matchCriteria (to, from, exiting, retained, entering)
     *
     * @returns an array of matched [[RegisteredHook]]s
     */
    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges) {
        var isCreate = hookType.hookPhase === interface_1.TransitionHookPhase.CREATE;
        // Instance and Global hook registries
        var registries = isCreate ? [this.$transitions] : [this.transition, this.$transitions];
        return registries.map(function (reg) {
            return reg.getHooks(hookType.name);
        }) // Get named hooks from registries
        .filter(common_1.assertPredicate(predicates_1.isArray, "broken event named: " + hookType.name)) // Sanity check
        .reduce(common_1.unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
        .filter(function (hook) {
            return hook.matches(treeChanges);
        }); // Only those satisfying matchCriteria
    };
    return HookBuilder;
}();
exports.HookBuilder = HookBuilder;
/**
 * A factory for a sort function for HookTuples.
 *
 * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
 * the EventHook priority.
 *
 * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
 * @returns a tuple sort function
 */
function tupleSort(reverseDepthSort) {
    if (reverseDepthSort === void 0) {
        reverseDepthSort = false;
    }
    return function nodeDepthThenPriority(l, r) {
        var factor = reverseDepthSort ? -1 : 1;
        var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
        return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
    };
}
//# sourceMappingURL=hookBuilder.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var transitionHook_1 = __webpack_require__(34);
/**
 * This class defines a type of hook, such as `onBefore` or `onEnter`.
 * Plugins can define custom hook types, such as sticky states does for `onInactive`.
 *
 * @interalapi
 */
var TransitionEventType = function () {
    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, rejectIfSuperseded) {
        if (reverseSort === void 0) {
            reverseSort = false;
        }
        if (getResultHandler === void 0) {
            getResultHandler = transitionHook_1.TransitionHook.HANDLE_RESULT;
        }
        if (getErrorHandler === void 0) {
            getErrorHandler = transitionHook_1.TransitionHook.REJECT_ERROR;
        }
        if (rejectIfSuperseded === void 0) {
            rejectIfSuperseded = true;
        }
        this.name = name;
        this.hookPhase = hookPhase;
        this.hookOrder = hookOrder;
        this.criteriaMatchPath = criteriaMatchPath;
        this.reverseSort = reverseSort;
        this.getResultHandler = getResultHandler;
        this.getErrorHandler = getErrorHandler;
        this.rejectIfSuperseded = rejectIfSuperseded;
    }
    return TransitionEventType;
}();
exports.TransitionEventType = TransitionEventType;
//# sourceMappingURL=transitionEventType.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @internalapi
 * @module url
 */ /** for typedoc */

var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
var urlMatcher_1 = __webpack_require__(54);
var param_1 = __webpack_require__(25);
var paramTypes_1 = __webpack_require__(120);
/**
 * Factory for [[UrlMatcher]] instances.
 *
 * The factory is available to ng1 services as
 * `$urlMatcherFactor` or ng1 providers as `$urlMatcherFactoryProvider`.
 */
var UrlMatcherFactory = function () {
    function UrlMatcherFactory() {
        var _this = this;
        /** @hidden */this.paramTypes = new paramTypes_1.ParamTypes();
        /** @hidden */this._isCaseInsensitive = false;
        /** @hidden */this._isStrictMode = true;
        /** @hidden */this._defaultSquashPolicy = false;
        /** @hidden */
        this._getConfig = function (config) {
            return common_1.extend({ strict: _this._isStrictMode, caseInsensitive: _this._isCaseInsensitive }, config);
        };
        /** @internalapi Creates a new [[Param]] for a given location (DefType) */
        this.paramFactory = {
            /** Creates a new [[Param]] from a CONFIG block */
            fromConfig: function fromConfig(id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.CONFIG, _this);
            },
            /** Creates a new [[Param]] from a url PATH */
            fromPath: function fromPath(id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.PATH, _this);
            },
            /** Creates a new [[Param]] from a url SEARCH */
            fromSearch: function fromSearch(id, type, config) {
                return new param_1.Param(id, type, config, param_1.DefType.SEARCH, _this);
            }
        };
        common_1.extend(this, { UrlMatcher: urlMatcher_1.UrlMatcher, Param: param_1.Param });
    }
    /** @inheritdoc */
    UrlMatcherFactory.prototype.caseInsensitive = function (value) {
        return this._isCaseInsensitive = predicates_1.isDefined(value) ? value : this._isCaseInsensitive;
    };
    /** @inheritdoc */
    UrlMatcherFactory.prototype.strictMode = function (value) {
        return this._isStrictMode = predicates_1.isDefined(value) ? value : this._isStrictMode;
    };
    /** @inheritdoc */
    UrlMatcherFactory.prototype.defaultSquashPolicy = function (value) {
        if (predicates_1.isDefined(value) && value !== true && value !== false && !predicates_1.isString(value)) throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
        return this._defaultSquashPolicy = predicates_1.isDefined(value) ? value : this._defaultSquashPolicy;
    };
    /**
     * Creates a [[UrlMatcher]] for the specified pattern.
     *
     * @param pattern  The URL pattern.
     * @param config  The config object hash.
     * @returns The UrlMatcher.
     */
    UrlMatcherFactory.prototype.compile = function (pattern, config) {
        return new urlMatcher_1.UrlMatcher(pattern, this.paramTypes, this.paramFactory, this._getConfig(config));
    };
    /**
     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
     *
     * @param object  The object to perform the type check against.
     * @returns `true` if the object matches the `UrlMatcher` interface, by
     *          implementing all the same methods.
     */
    UrlMatcherFactory.prototype.isMatcher = function (object) {
        // TODO: typeof?
        if (!predicates_1.isObject(object)) return false;
        var result = true;
        common_1.forEach(urlMatcher_1.UrlMatcher.prototype, function (val, name) {
            if (predicates_1.isFunction(val)) result = result && predicates_1.isDefined(object[name]) && predicates_1.isFunction(object[name]);
        });
        return result;
    };
    ;
    /**
     * Creates and registers a custom [[ParamType]] object
     *
     * A [[ParamType]] can be used to generate URLs with typed parameters.
     *
     * @param name  The type name.
     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
     * @param definitionFn A function that is injected before the app runtime starts.
     *        The result of this function should be a [[ParamTypeDefinition]].
     *        The result is merged into the existing `definition`.
     *        See [[ParamType]] for information on the values accepted.
     *
     * @returns - if a type was registered: the [[UrlMatcherFactory]]
     *   - if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
     *
     * Note: Register custom types *before using them* in a state definition.
     *
     * See [[ParamTypeDefinition]] for examples
     */
    UrlMatcherFactory.prototype.type = function (name, definition, definitionFn) {
        var type = this.paramTypes.type(name, definition, definitionFn);
        return !predicates_1.isDefined(definition) ? type : this;
    };
    ;
    /** @hidden */
    UrlMatcherFactory.prototype.$get = function () {
        this.paramTypes.enqueue = false;
        this.paramTypes._flushTypeQueue();
        return this;
    };
    ;
    /** @internalapi */
    UrlMatcherFactory.prototype.dispose = function () {
        this.paramTypes.dispose();
    };
    return UrlMatcherFactory;
}();
exports.UrlMatcherFactory = UrlMatcherFactory;
//# sourceMappingURL=urlMatcherFactory.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @internalapi
 * @module url
 */
/** for typedoc */

var common_1 = __webpack_require__(0);
var predicates_1 = __webpack_require__(1);
var urlMatcher_1 = __webpack_require__(54);
var hof_1 = __webpack_require__(3);
var urlRule_1 = __webpack_require__(133);
var targetState_1 = __webpack_require__(19);
/** @hidden */
function appendBasePath(url, isHtml5, absolute, baseHref) {
    if (baseHref === '/') return url;
    if (isHtml5) return baseHref.slice(0, -1) + url;
    if (absolute) return baseHref.slice(1) + url;
    return url;
}
/** @hidden */
var getMatcher = hof_1.prop("urlMatcher");
/**
 * Default rule priority sorting function.
 *
 * Sorts rules by:
 *
 * - Explicit priority (set rule priority using [[UrlService.when]])
 * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
 * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
 * - Registration order (for rule types other than STATE and URLMATCHER)
 *
 * @coreapi
 */
var defaultRuleSortFn;
defaultRuleSortFn = common_1.composeSort(common_1.sortBy(hof_1.pipe(hof_1.prop("priority"), function (x) {
    return -x;
})), common_1.sortBy(hof_1.pipe(hof_1.prop("type"), function (type) {
    return { "STATE": 4, "URLMATCHER": 4, "REGEXP": 3, "RAW": 2, "OTHER": 1 }[type];
})), function (a, b) {
    return getMatcher(a) && getMatcher(b) ? urlMatcher_1.UrlMatcher.compare(getMatcher(a), getMatcher(b)) : 0;
}, common_1.sortBy(hof_1.prop("$id"), common_1.inArray(["REGEXP", "RAW", "OTHER"])));
/**
 * Updates URL and responds to URL changes
 *
 * This class updates the URL when the state changes.
 * It also responds to changes in the URL.
 */
var UrlRouter = function () {
    /** @hidden */
    function UrlRouter(router) {
        /** @hidden */this._sortFn = defaultRuleSortFn;
        /** @hidden */this._rules = [];
        /** @hidden */this.interceptDeferred = false;
        /** @hidden */this._id = 0;
        this._router = router;
        this.urlRuleFactory = new urlRule_1.UrlRuleFactory(router);
        common_1.createProxyFunctions(hof_1.val(UrlRouter.prototype), this, hof_1.val(this));
    }
    /** @internalapi */
    UrlRouter.prototype.dispose = function () {
        this.listen(false);
        this._rules = [];
        delete this._otherwiseFn;
    };
    /** @inheritdoc */
    UrlRouter.prototype.sort = function (compareFn) {
        this._rules.sort(this._sortFn = compareFn || this._sortFn);
    };
    /**
     * Given a URL, check all rules and return the best [[MatchResult]]
     * @param url
     * @returns {MatchResult}
     */
    UrlRouter.prototype.match = function (url) {
        var _this = this;
        url = common_1.extend({ path: '', search: {}, hash: '' }, url);
        var rules = this.rules();
        if (this._otherwiseFn) rules.push(this._otherwiseFn);
        // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
        var checkRule = function checkRule(rule) {
            var match = rule.match(url, _this._router);
            return match && { match: match, rule: rule, weight: rule.matchPriority(match) };
        };
        // The rules are pre-sorted.
        // - Find the first matching rule.
        // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
        // - Choose the rule with the highest match weight.
        var best;
        for (var i = 0; i < rules.length; i++) {
            // Stop when there is a 'best' rule and the next rule sorts differently than it.
            if (best && this._sortFn(rules[i], best.rule) !== 0) break;
            var current = checkRule(rules[i]);
            // Pick the best MatchResult
            best = !best || current && current.weight > best.weight ? current : best;
        }
        return best;
    };
    /** @inheritdoc */
    UrlRouter.prototype.sync = function (evt) {
        if (evt && evt.defaultPrevented) return;
        var router = this._router,
            $url = router.urlService,
            $state = router.stateService;
        var url = {
            path: $url.path(), search: $url.search(), hash: $url.hash()
        };
        var best = this.match(url);
        var applyResult = hof_1.pattern([[predicates_1.isString, function (newurl) {
            return $url.url(newurl);
        }], [targetState_1.TargetState.isDef, function (def) {
            return $state.go(def.state, def.params, def.options);
        }], [hof_1.is(targetState_1.TargetState), function (target) {
            return $state.go(target.state(), target.params(), target.options());
        }]]);
        applyResult(best && best.rule.handler(best.match, url, router));
    };
    /** @inheritdoc */
    UrlRouter.prototype.listen = function (enabled) {
        var _this = this;
        if (enabled === false) {
            this._stopFn && this._stopFn();
            delete this._stopFn;
        } else {
            return this._stopFn = this._stopFn || this._router.urlService.onChange(function (evt) {
                return _this.sync(evt);
            });
        }
    };
    /**
     * Internal API.
     * @internalapi
     */
    UrlRouter.prototype.update = function (read) {
        var $url = this._router.locationService;
        if (read) {
            this.location = $url.path();
            return;
        }
        if ($url.path() === this.location) return;
        $url.url(this.location, true);
    };
    /**
     * Internal API.
     *
     * Pushes a new location to the browser history.
     *
     * @internalapi
     * @param urlMatcher
     * @param params
     * @param options
     */
    UrlRouter.prototype.push = function (urlMatcher, params, options) {
        var replace = options && !!options.replace;
        this._router.urlService.url(urlMatcher.format(params || {}), replace);
    };
    /**
     * Builds and returns a URL with interpolated parameters
     *
     * #### Example:
     * ```js
     * matcher = $umf.compile("/about/:person");
     * params = { person: "bob" };
     * $bob = $urlRouter.href(matcher, params);
     * // $bob == "/about/bob";
     * ```
     *
     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
     * @param params An object of parameter values to fill the matcher's required parameters.
     * @param options Options object. The options are:
     *
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     *
     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
     */
    UrlRouter.prototype.href = function (urlMatcher, params, options) {
        if (!urlMatcher.validates(params)) return null;
        var url = urlMatcher.format(params);
        options = options || { absolute: false };
        var cfg = this._router.urlService.config;
        var isHtml5 = cfg.html5Mode();
        if (!isHtml5 && url !== null) {
            url = "#" + cfg.hashPrefix() + url;
        }
        url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
        if (!options.absolute || !url) {
            return url;
        }
        var slash = !isHtml5 && url ? '/' : '',
            port = cfg.port();
        port = port === 80 || port === 443 ? '' : ':' + port;
        return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
    };
    /**
     * Manually adds a URL Rule.
     *
     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
     * This api can be used directly for more control (to register [[RawUrlRule]], for example).
     * Rules can be created using [[UrlRouter.ruleFactory]], or create manually as simple objects.
     *
     * @return a function that deregisters the rule
     */
    UrlRouter.prototype.rule = function (rule) {
        var _this = this;
        if (!urlRule_1.UrlRuleFactory.isUrlRule(rule)) throw new Error("invalid rule");
        rule.$id = this._id++;
        rule.priority = rule.priority || 0;
        this._rules.push(rule);
        this.sort();
        return function () {
            return _this.removeRule(rule);
        };
    };
    /** @inheritdoc */
    UrlRouter.prototype.removeRule = function (rule) {
        common_1.removeFrom(this._rules, rule);
        this.sort();
    };
    /** @inheritdoc */
    UrlRouter.prototype.rules = function () {
        return this._rules.slice();
    };
    /** @inheritdoc */
    UrlRouter.prototype.otherwise = function (handler) {
        if (!predicates_1.isFunction(handler) && !predicates_1.isString(handler) && !hof_1.is(targetState_1.TargetState)(handler) && !targetState_1.TargetState.isDef(handler)) {
            throw new Error("'redirectTo' must be a string, function, TargetState, or have a state: 'newtarget' property");
        }
        var handlerFn = predicates_1.isFunction(handler) ? handler : hof_1.val(handler);
        this._otherwiseFn = this.urlRuleFactory.create(hof_1.val(true), handlerFn);
        this.sort();
    };
    ;
    /** @inheritdoc */
    UrlRouter.prototype.when = function (matcher, handler, options) {
        var rule = this.urlRuleFactory.create(matcher, handler);
        if (predicates_1.isDefined(options && options.priority)) rule.priority = options.priority;
        this.rule(rule);
        return rule;
    };
    ;
    /** @inheritdoc */
    UrlRouter.prototype.deferIntercept = function (defer) {
        if (defer === undefined) defer = true;
        this.interceptDeferred = defer;
    };
    ;
    return UrlRouter;
}();
exports.UrlRouter = UrlRouter;
//# sourceMappingURL=urlRouter.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module url
 */ /** */

var urlMatcher_1 = __webpack_require__(54);
var predicates_1 = __webpack_require__(1);
var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
var stateObject_1 = __webpack_require__(82);
/**
 * Creates a [[UrlRule]]
 *
 * Creates a [[UrlRule]] from a:
 *
 * - `string`
 * - [[UrlMatcher]]
 * - `RegExp`
 * - [[State]]
 * @internalapi
 */
var UrlRuleFactory = function () {
    function UrlRuleFactory(router) {
        this.router = router;
    }
    UrlRuleFactory.prototype.compile = function (str) {
        return this.router.urlMatcherFactory.compile(str);
    };
    UrlRuleFactory.prototype.create = function (what, handler) {
        var _this = this;
        var makeRule = hof_1.pattern([[predicates_1.isString, function (_what) {
            return makeRule(_this.compile(_what));
        }], [hof_1.is(urlMatcher_1.UrlMatcher), function (_what) {
            return _this.fromUrlMatcher(_what, handler);
        }], [hof_1.is(stateObject_1.State), function (_what) {
            return _this.fromState(_what, _this.router);
        }], [hof_1.is(RegExp), function (_what) {
            return _this.fromRegExp(_what, handler);
        }], [predicates_1.isFunction, function (_what) {
            return new BaseUrlRule(_what, handler);
        }]]);
        var rule = makeRule(what);
        if (!rule) throw new Error("invalid 'what' in when()");
        return rule;
    };
    /**
     * A UrlRule which matches based on a UrlMatcher
     *
     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     *
     * ## Handler as UrlMatcher
     *
     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
     * The url is replaced with the result.
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var handler = $umf.compile("/home/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     */
    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
        var _handler = handler;
        if (predicates_1.isString(handler)) handler = this.router.urlMatcherFactory.compile(handler);
        if (hof_1.is(urlMatcher_1.UrlMatcher)(handler)) _handler = function _handler(match) {
            return handler.format(match);
        };
        function match(url) {
            var match = urlMatcher.exec(url.path, url.search, url.hash);
            return urlMatcher.validates(match) && match;
        }
        // Prioritize URLs, lowest to highest:
        // - Some optional URL parameters, but none matched
        // - No optional parameters in URL
        // - Some optional parameters, some matched
        // - Some optional parameters, all matched
        function matchPriority(params) {
            var optional = urlMatcher.parameters().filter(function (param) {
                return param.isOptional;
            });
            if (!optional.length) return 0.000001;
            var matched = optional.filter(function (param) {
                return params[param.id];
            });
            return matched.length / optional.length;
        }
        var details = { urlMatcher: urlMatcher, matchPriority: matchPriority, type: "URLMATCHER" };
        return common_1.extend(new BaseUrlRule(match, _handler), details);
    };
    /**
     * A UrlRule which matches a state by its url
     *
     * #### Example:
     * ```js
     * var rule = factory.fromState($state.get('foo'), router);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match);
     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
     * ```
     */
    UrlRuleFactory.prototype.fromState = function (state, router) {
        /**
         * Handles match by transitioning to matched state
         *
         * First checks if the router should start a new transition.
         * A new transition is not required if the current state's URL
         * and the new URL are already identical
         */
        var handler = function handler(match) {
            var $state = router.stateService;
            var globals = router.globals;
            if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
                $state.transitionTo(state, match, { inherit: true, source: "url" });
            }
        };
        var details = { state: state, type: "STATE" };
        return common_1.extend(this.fromUrlMatcher(state.url, handler), details);
    };
    /**
     * A UrlRule which matches based on a regular expression
     *
     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - regexp match array (from `regexp`)
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     *
     * ## Handler as string
     *
     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
     * The string is first interpolated using `string.replace()` style pattern.
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     */
    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
        if (regexp.global || regexp.sticky) throw new Error("Rule RegExp must not be global or sticky");
        /**
         * If handler is a string, the url will be replaced by the string.
         * If the string has any String.replace() style variables in it (like `$2`),
         * they will be replaced by the captures from [[match]]
         */
        var redirectUrlTo = function redirectUrlTo(match) {
            // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
            return handler.replace(/\$(\$|\d{1,2})/, function (m, what) {
                return match[what === '$' ? 0 : Number(what)];
            });
        };
        var _handler = predicates_1.isString(handler) ? redirectUrlTo : handler;
        var match = function match(url) {
            return regexp.exec(url.path);
        };
        var details = { regexp: regexp, type: "REGEXP" };
        return common_1.extend(new BaseUrlRule(match, _handler), details);
    };
    return UrlRuleFactory;
}();
UrlRuleFactory.isUrlRule = function (obj) {
    return obj && ['type', 'match', 'handler'].every(function (key) {
        return predicates_1.isDefined(obj[key]);
    });
};
exports.UrlRuleFactory = UrlRuleFactory;
/**
 * A base rule which calls `match`
 *
 * The value from the `match` function is passed through to the `handler`.
 * @internalapi
 */
var BaseUrlRule = function () {
    function BaseUrlRule(match, handler) {
        var _this = this;
        this.match = match;
        this.type = "RAW";
        this.matchPriority = function (match) {
            return 0 - _this.$id;
        };
        this.handler = handler || common_1.identity;
    }
    return BaseUrlRule;
}();
exports.BaseUrlRule = BaseUrlRule;
//# sourceMappingURL=urlRule.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @coreapi
 * @module url
 */ /** */


var coreservices_1 = __webpack_require__(6);
var common_1 = __webpack_require__(0);
/** @hidden */
var makeStub = function makeStub(keys) {
    return keys.reduce(function (acc, key) {
        return acc[key] = coreservices_1.notImplemented(key), acc;
    }, { dispose: common_1.noop });
};
/** @hidden */var locationServicesFns = ["url", "path", "search", "hash", "onChange"];
/** @hidden */var locationConfigFns = ["port", "protocol", "host", "baseHref", "html5Mode", "hashPrefix"];
/** @hidden */var umfFns = ["type", "caseInsensitive", "strictMode", "defaultSquashPolicy"];
/** @hidden */var rulesFns = ["sort", "when", "otherwise", "rules", "rule", "removeRule"];
/** @hidden */var syncFns = ["deferIntercept", "listen", "sync", "match"];
/**
 * API for URL management
 */
var UrlService = function () {
    /** @hidden */
    function UrlService(router, lateBind) {
        if (lateBind === void 0) {
            lateBind = true;
        }
        this.router = router;
        this.rules = {};
        this.config = {};
        // proxy function calls from UrlService to the LocationService/LocationConfig
        var locationServices = function locationServices() {
            return router.locationService;
        };
        common_1.createProxyFunctions(locationServices, this, locationServices, locationServicesFns, lateBind);
        var locationConfig = function locationConfig() {
            return router.locationConfig;
        };
        common_1.createProxyFunctions(locationConfig, this.config, locationConfig, locationConfigFns, lateBind);
        var umf = function umf() {
            return router.urlMatcherFactory;
        };
        common_1.createProxyFunctions(umf, this.config, umf, umfFns);
        var urlRouter = function urlRouter() {
            return router.urlRouter;
        };
        common_1.createProxyFunctions(urlRouter, this.rules, urlRouter, rulesFns);
        common_1.createProxyFunctions(urlRouter, this, urlRouter, syncFns);
    }
    UrlService.prototype.url = function (newurl, replace, state) {
        return;
    };
    ;
    /** @inheritdoc */
    UrlService.prototype.path = function () {
        return;
    };
    ;
    /** @inheritdoc */
    UrlService.prototype.search = function () {
        return;
    };
    ;
    /** @inheritdoc */
    UrlService.prototype.hash = function () {
        return;
    };
    ;
    /** @inheritdoc */
    UrlService.prototype.onChange = function (callback) {
        return;
    };
    ;
    /**
     * Returns the current URL parts
     *
     * This method returns the current URL components as a [[UrlParts]] object.
     *
     * @returns the current url parts
     */
    UrlService.prototype.parts = function () {
        return { path: this.path(), search: this.search(), hash: this.hash() };
    };
    UrlService.prototype.dispose = function () {};
    /** @inheritdoc */
    UrlService.prototype.sync = function (evt) {
        return;
    };
    /** @inheritdoc */
    UrlService.prototype.listen = function (enabled) {
        return;
    };
    ;
    /** @inheritdoc */
    UrlService.prototype.deferIntercept = function (defer) {
        return;
    };
    /** @inheritdoc */
    UrlService.prototype.match = function (urlParts) {
        return;
    };
    return UrlService;
}();
/** @hidden */
UrlService.locationServiceStub = makeStub(locationServicesFns);
/** @hidden */
UrlService.locationConfigStub = makeStub(locationConfigFns);
exports.UrlService = UrlService;
//# sourceMappingURL=urlService.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @coreapi
 * @module view
 */ /** for typedoc */

var common_1 = __webpack_require__(0);
var hof_1 = __webpack_require__(3);
var predicates_1 = __webpack_require__(1);
var trace_1 = __webpack_require__(24);
/**
 * The View service
 *
 * This service pairs existing `ui-view` components (which live in the DOM)
 * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
 *
 * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
 *   The views from exited states are deactivated via [[deactivateViewConfig]].
 *   (See: the [[registerActivateViews]] Transition Hook)
 *
 * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
 *
 * - When the [[sync]] function is called, the registered `ui-view`(s) ([[UIViewConfig]]
 * are configured with the matching `ViewConfig`(s)  ([[ActiveUIView]]).
 *
 */
var ViewService = function () {
    function ViewService() {
        var _this = this;
        this._uiViews = [];
        this._viewConfigs = [];
        this._viewConfigFactories = {};
        this._pluginapi = {
            _rootViewContext: this._rootViewContext.bind(this),
            _viewConfigFactory: this._viewConfigFactory.bind(this),
            _registeredUIViews: function _registeredUIViews() {
                return _this._uiViews;
            },
            _activeViewConfigs: function _activeViewConfigs() {
                return _this._viewConfigs;
            }
        };
    }
    ViewService.prototype._rootViewContext = function (context) {
        return this._rootContext = context || this._rootContext;
    };
    ;
    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
        this._viewConfigFactories[viewType] = factory;
    };
    ViewService.prototype.createViewConfig = function (path, decl) {
        var cfgFactory = this._viewConfigFactories[decl.$type];
        if (!cfgFactory) throw new Error("ViewService: No view config factory registered for type " + decl.$type);
        var cfgs = cfgFactory(path, decl);
        return predicates_1.isArray(cfgs) ? cfgs : [cfgs];
    };
    /**
     * Deactivates a ViewConfig.
     *
     * This function deactivates a `ViewConfig`.
     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
     *
     * @param viewConfig The ViewConfig view to deregister.
     */
    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
        trace_1.trace.traceViewServiceEvent("<- Removing", viewConfig);
        common_1.removeFrom(this._viewConfigs, viewConfig);
    };
    ViewService.prototype.activateViewConfig = function (viewConfig) {
        trace_1.trace.traceViewServiceEvent("-> Registering", viewConfig);
        this._viewConfigs.push(viewConfig);
    };
    ViewService.prototype.sync = function () {
        var _this = this;
        var uiViewsByFqn = this._uiViews.map(function (uiv) {
            return [uiv.fqn, uiv];
        }).reduce(common_1.applyPairs, {});
        /**
         * Given a ui-view and a ViewConfig, determines if they "match".
         *
         * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
         * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
         *
         * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
         * can be a segmented ui-view path, describing a portion of a ui-view fqn.
         *
         * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
         *
         * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
         * - the ui-view's name matches the ViewConfig's target name
         * - the ui-view's context matches the ViewConfig's anchor
         *
         * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
         * - There exists a parent ui-view where:
         *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
         *    - the parent ui-view's context matches the ViewConfig's anchor
         * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
         *
         * Example:
         *
         * DOM:
         * <div ui-view>                        <!-- created in the root context (name: "") -->
         *   <div ui-view="foo">                <!-- created in the context named: "A"      -->
         *     <div ui-view>                    <!-- created in the context named: "A.B"    -->
         *       <div ui-view="bar">            <!-- created in the context named: "A.B.C"  -->
         *       </div>
         *     </div>
         *   </div>
         * </div>
         *
         * uiViews: [
         *  { fqn: "$default",                  creationContext: { name: "" } },
         *  { fqn: "$default.foo",              creationContext: { name: "A" } },
         *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
         *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
         * ]
         *
         * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
         *
         * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
         * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
         * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
         * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
         *
         * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
         * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
         * - There exists a parent ui-view (which has fqn: "$default.foo") where:
         *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
         *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
         * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
         *   the tail of the ui-view's fqn "default.bar"
         */
        var matches = function matches(uiView) {
            return function (viewConfig) {
                // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
                if (uiView.$type !== viewConfig.viewDecl.$type) return false;
                // Split names apart from both viewConfig and uiView into segments
                var vc = viewConfig.viewDecl;
                var vcSegments = vc.$uiViewName.split(".");
                var uivSegments = uiView.fqn.split(".");
                // Check if the tails of the segment arrays match. ex, these arrays' tails match:
                // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
                if (!common_1.equals(vcSegments, uivSegments.slice(0 - vcSegments.length))) return false;
                // Now check if the fqn ending at the first segment of the viewConfig matches the context:
                // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
                var negOffset = 1 - vcSegments.length || undefined;
                var fqnToFirstSegment = uivSegments.slice(0, negOffset).join(".");
                var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
                return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
            };
        };
        // Return the number of dots in the fully qualified name
        function uiViewDepth(uiView) {
            return uiView.fqn.split(".").length;
        }
        // Return the ViewConfig's context's depth in the context tree.
        function viewConfigDepth(config) {
            var context = config.viewDecl.$context,
                count = 0;
            while (++count && context.parent) {
                context = context.parent;
            }return count;
        }
        // Given a depth function, returns a compare function which can return either ascending or descending order
        var depthCompare = hof_1.curry(function (depthFn, posNeg, left, right) {
            return posNeg * (depthFn(left) - depthFn(right));
        });
        var matchingConfigPair = function matchingConfigPair(uiView) {
            var matchingConfigs = _this._viewConfigs.filter(matches(uiView));
            if (matchingConfigs.length > 1) {
                // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
                // Sort by depth and return the match from the deepest child
                // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
                matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
            }
            return [uiView, matchingConfigs[0]];
        };
        var configureUIView = function configureUIView(_a) {
            var uiView = _a[0],
                viewConfig = _a[1];
            // If a parent ui-view is reconfigured, it could destroy child ui-views.
            // Before configuring a child ui-view, make sure it's still in the active uiViews array.
            if (_this._uiViews.indexOf(uiView) !== -1) uiView.configUpdated(viewConfig);
        };
        this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair).forEach(configureUIView);
    };
    ;
    /**
     * Registers a `ui-view` component
     *
     * When a `ui-view` component is created, it uses this method to register itself.
     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
     *
     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
     * and what the view's state context is.
     *
     * Note: There is no corresponding `deregisterUIView`.
     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
     *
     * @param uiView The metadata for a UIView
     * @return a de-registration function used when the view is destroyed.
     */
    ViewService.prototype.registerUIView = function (uiView) {
        trace_1.trace.traceViewServiceUIViewEvent("-> Registering", uiView);
        var uiViews = this._uiViews;
        var fqnMatches = function fqnMatches(uiv) {
            return uiv.fqn === uiView.fqn;
        };
        if (uiViews.filter(fqnMatches).length) trace_1.trace.traceViewServiceUIViewEvent("!!!! duplicate uiView named:", uiView);
        uiViews.push(uiView);
        this.sync();
        return function () {
            var idx = uiViews.indexOf(uiView);
            if (idx === -1) {
                trace_1.trace.traceViewServiceUIViewEvent("Tried removing non-registered uiView", uiView);
                return;
            }
            trace_1.trace.traceViewServiceUIViewEvent("<- Deregistering", uiView);
            common_1.removeFrom(uiViews)(uiView);
        };
    };
    ;
    /**
     * Returns the list of views currently available on the page, by fully-qualified name.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */
    ViewService.prototype.available = function () {
        return this._uiViews.map(hof_1.prop("fqn"));
    };
    /**
     * Returns the list of views on the page containing loaded content.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */
    ViewService.prototype.active = function () {
        return this._uiViews.filter(hof_1.prop("$config")).map(hof_1.prop("name"));
    };
    /**
     * Normalizes a view's name from a state.views configuration block.
     *
     * @param context the context object (state declaration) that the view belongs to
     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
     *
     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
     */
    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
        if (rawViewName === void 0) {
            rawViewName = "";
        }
        // TODO: Validate incoming view name with a regexp to allow:
        // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
        // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
        var viewAtContext = rawViewName.split("@");
        var uiViewName = viewAtContext[0] || "$default"; // default to unnamed view
        var uiViewContextAnchor = predicates_1.isString(viewAtContext[1]) ? viewAtContext[1] : "^"; // default to parent context
        // Handle relative view-name sugar syntax.
        // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
        var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
        if (relativeViewNameSugar) {
            // Clobbers existing contextAnchor (rawViewName validation will fix this)
            uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
            uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
        }
        if (uiViewName.charAt(0) === '!') {
            uiViewName = uiViewName.substr(1);
            uiViewContextAnchor = ""; // target absolutely from root
        }
        // handle parent relative targeting "^.^.^"
        var relativeMatch = /^(\^(?:\.\^)*)$/;
        if (relativeMatch.exec(uiViewContextAnchor)) {
            var anchor = uiViewContextAnchor.split(".").reduce(function (anchor, x) {
                return anchor.parent;
            }, context);
            uiViewContextAnchor = anchor.name;
        }
        return { uiViewName: uiViewName, uiViewContextAnchor: uiViewContextAnchor };
    };
    return ViewService;
}();
exports.ViewService = ViewService;
//# sourceMappingURL=view.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 137 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/transportation-alternative/transportation-alternative-details-template1.html';
var html = "<section class=call-for-help-details-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 call-for-help-details\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>details</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <button type=button class=\"btn go-back text-uppercase\" ng-click=$ctrl.onGoBack()>go back</button> <span class=icon-Edit ng-click=$ctrl.onEdit($ctrl.details.basicInfo.id)></span> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item display-flex\"> <div class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 item-image\"> <img ng-src={{$ctrl._getImage($ctrl.details.basicInfo)}} class=\"img img-responsive\"/> </div> <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10 item-detail\"> <h2 class=text-capitalize>{{$ctrl.details.basicInfo.name}}</h2> <div class=\"col-md-12 county-hrs-operation-wrap\"> <div class=\"col-md-12 col-sm-12 col-xs-4 col-lg-4 county no-padding-left\"> <h3>Service Area</h3> <p><span ng-repeat=\"location in $ctrl.details.basicInfo.serviceArea\">{{location.name}}{{!$last ? ', ' : ''}}</span></p> </div> <div class=\"col-md-12 col-sm-12 col-xs-4 col-lg-4 hours-of-operation no-padding-left\"> <h3>Hours of Operation</h3> <p class=detail-span ng-if=!$ctrl.details.operationInfo.hoursOfOperation.isAllDay>{{$ctrl.details.operationInfo.hoursOfOperation.startTime | date:'hh:mm a'}} - {{$ctrl.details.operationInfo.hoursOfOperation.endTime | date:'hh:mm a'}} </p> <p class=detail-span ng-if=$ctrl.details.operationInfo.hoursOfOperation.isAllDay> All Day </p> </div> </div> <div class=\"col-md-12 phone-email-wrap\"> <div class=\"col-md-12 col-sm-12 col-xs-4 col-lg-4 phone no-padding-left\"> <h3>Phone</h3> <p><span ng-repeat=\"phone in $ctrl.details.basicInfo.phone\">{{phone.number}}, Ext.{{phone.extn}}{{!$last ? ', ' : ''}}</span></p> </div> <div class=\"col-md-12 col-sm-12 col-xs-4 col-lg-4 email no-padding-left\"> <h3>Email</h3> <p>{{$ctrl.details.basicInfo.email || 'NA'}}</p> </div> </div> <div class=\"col-md-12 website-days-operation-wrap\"> <div class=\"col-md-12 col-sm-12 col-xs-6 col-lg-6 website\"> <h3>Website</h3> <p>{{$ctrl.details.basicInfo.url || 'NA'}}</p> </div> <div class=\"col-md-12 col-sm-12 col-xs-6 col-lg-6 days-of-operation\"> <days-of-operation details=$ctrl.daysOfOperation></days-of-operation> </div> </div> </div> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, Promise) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!function (global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  runtime.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
}(
// In sloppy mode, unbound `this` refers to the global object, fallback to
// Function constructor if we're in global strict mode. That is sadly a form
// of indirect eval which violates Content Security Policy.
function () {
  return this;
}() || Function("return this")());
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module), __webpack_require__(37)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.root = undefined;

__webpack_require__(145);

__webpack_require__(146);

__webpack_require__(141);

var _angular = __webpack_require__(36);

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = __webpack_require__(56);

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _root = __webpack_require__(704);

var _app = __webpack_require__(416);

var _components = __webpack_require__(572);

__webpack_require__(202);

var _angularResource = __webpack_require__(208);

var _angularResource2 = _interopRequireDefault(_angularResource);

var _angularToastr = __webpack_require__(210);

var _angularToastr2 = _interopRequireDefault(_angularToastr);

var _angularLoadingBar = __webpack_require__(206);

var _angularLoadingBar2 = _interopRequireDefault(_angularLoadingBar);

__webpack_require__(140);

var _angularCookies = __webpack_require__(204);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

__webpack_require__(185);

__webpack_require__(184);

__webpack_require__(186);

__webpack_require__(182);

__webpack_require__(183);

var _Constants = __webpack_require__(411);

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module('app.constant', []).constant('Constants', new _Constants2.default());

var root = exports.root = _angular2.default.module('root', [_angularUiRouter2.default, _angularResource2.default, _app.app, _components.components, 'jcs-autoValidate', _angularToastr2.default, _angularLoadingBar2.default, _angularCookies2.default, 'app.constant']).component('root', _root.rootComponent).config(["cfpLoadingBarProvider", "$urlRouterProvider", "$httpProvider", "$provide", function (cfpLoadingBarProvider, $urlRouterProvider, $httpProvider, $provide) {
    'ngInject';

    cfpLoadingBarProvider.includeSpinner = false;
    $urlRouterProvider.otherwise('/');
    //$urlRouterProvider.otherwise(() => ({ state: 'app.dashboard.HomeBanner'})
    $provide.factory('myHttpInterceptor', ["$q", "$injector", function ($q, $injector) {

        return {
            // optional method
            'request': function request(config) {
                // do something on success
                var AuthService = $injector.get('AuthService');
                config.headers.Authorization = AuthService.getAuthorizationHeader();
                return config;
            },

            // optional method
            'requestError': function requestError(rejection) {
                // do something on error

                return $q.reject(rejection);
            },
            'response': function response(_response) {
                // do something on success
                return _response || $q.when(_response);
            },
            'responseError': function responseError(rejection) {
                // do something on error
                if (rejection.config.url.indexOf('https://graph.facebook.com/') === -1 && rejection.status === 404 || rejection.status === 401) {
                    var AuthService = $injector.get('AuthService');
                    AuthService.expireSession();
                }
                return $q.reject(rejection);
            }
        };
    }]);
    $httpProvider.interceptors.push('myHttpInterceptor');
}])
// cloud ip
.constant('API_ENDPOINT', 'https://cms.gettherescny.org/api/')

// local ip
// .constant('API_ENDPOINT', 'http://191.168.0.128:1340/')
.name;

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 146 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

/*** IMPORTS FROM imports-loader ***/
var define = false;
var exports = false;

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * uiCropper v1.0.4
 * https://crackerakiua.github.io/ui-cropper/
 *
 * Copyright (c) 2017 Alex Kaul
 * License: MIT
 *
 * Generated at Wednesday, August 16th, 2017, 6:07:49 PM
 */
(function () {
    angular.module('uiCropper', []);

    angular.module('uiCropper').factory('cropAreaCircle', ['cropArea', function (CropArea) {
        var CropAreaCircle = function CropAreaCircle() {
            CropArea.apply(this, arguments);

            this._boxResizeBaseSize = 25;
            this._boxResizeNormalRatio = 1;
            this._boxResizeHoverRatio = 1.2;
            this._iconMoveNormalRatio = 0.9;
            this._iconMoveHoverRatio = 1.2;

            this._boxResizeNormalSize = this._boxResizeBaseSize * this._boxResizeNormalRatio;
            this._boxResizeHoverSize = this._boxResizeBaseSize * this._boxResizeHoverRatio;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
            this._posResizeStartX = 0;
            this._posResizeStartY = 0;
            this._posResizeStartSize = 0;

            this._boxResizeIsHover = false;
            this._areaIsHover = false;
            this._boxResizeIsDragging = false;
            this._areaIsDragging = false;
        };

        CropAreaCircle.prototype = new CropArea();

        CropAreaCircle.prototype.getType = function () {
            return 'circle';
        };

        CropAreaCircle.prototype._calcCirclePerimeterCoords = function (angleDegrees) {
            var hSize = this._size.w / 2;
            var angleRadians = angleDegrees * (Math.PI / 180),
                circlePerimeterX = this.getCenterPoint().x + hSize * Math.cos(angleRadians),
                circlePerimeterY = this.getCenterPoint().y + hSize * Math.sin(angleRadians);
            return [circlePerimeterX, circlePerimeterY];
        };

        CropAreaCircle.prototype._calcResizeIconCenterCoords = function () {
            return this._calcCirclePerimeterCoords(-45);
        };

        CropAreaCircle.prototype._isCoordWithinArea = function (coord) {
            return Math.sqrt((coord[0] - this.getCenterPoint().x) * (coord[0] - this.getCenterPoint().x) + (coord[1] - this.getCenterPoint().y) * (coord[1] - this.getCenterPoint().y)) < this._size.w / 2;
        };
        CropAreaCircle.prototype._isCoordWithinBoxResize = function (coord) {
            var resizeIconCenterCoords = this._calcResizeIconCenterCoords();
            var hSize = this._boxResizeHoverSize / 2;
            return coord[0] > resizeIconCenterCoords[0] - hSize && coord[0] < resizeIconCenterCoords[0] + hSize && coord[1] > resizeIconCenterCoords[1] - hSize && coord[1] < resizeIconCenterCoords[1] + hSize;
        };

        CropAreaCircle.prototype._drawArea = function (ctx, centerCoords, size) {
            ctx.arc(centerCoords.x, centerCoords.y, size.w / 2, 0, 2 * Math.PI);
        };

        CropAreaCircle.prototype.draw = function () {
            CropArea.prototype.draw.apply(this, arguments);

            // draw move icon
            var center = this.getCenterPoint();
            this._cropCanvas.drawIconMove([center.x, center.y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio);

            // draw resize cubes
            this._cropCanvas.drawIconResizeBoxNESW(this._calcResizeIconCenterCoords(), this._boxResizeBaseSize, this._boxResizeIsHover ? this._boxResizeHoverRatio : this._boxResizeNormalRatio);
        };

        CropAreaCircle.prototype.processMouseMove = function (mouseCurX, mouseCurY) {
            var cursor = 'default';
            var res = false;

            this._boxResizeIsHover = false;
            this._areaIsHover = false;

            if (this._areaIsDragging) {
                this.setCenterPointOnMove({
                    x: mouseCurX - this._posDragStartX,
                    y: mouseCurY - this._posDragStartY
                });
                this._areaIsHover = true;
                cursor = 'move';
                res = true;
                this._events.trigger('area-move');
            } else if (this._boxResizeIsDragging) {
                cursor = 'nesw-resize';
                var iFR, iFX, iFY;
                iFX = mouseCurX - this._posResizeStartX;
                iFY = this._posResizeStartY - mouseCurY;
                if (iFX > iFY) {
                    iFR = this._posResizeStartSize.w + iFY * 2;
                } else {
                    iFR = this._posResizeStartSize.w + iFX * 2;
                }

                var newNO = {},
                    newSE = {};

                newNO.x = this.getCenterPoint().x - iFR * 0.5;
                newSE.x = this.getCenterPoint().x + iFR * 0.5;

                newNO.y = this.getCenterPoint().y - iFR * 0.5;
                newSE.y = this.getCenterPoint().y + iFR * 0.5;

                this.circleOnMove(newNO, newSE);
                this._boxResizeIsHover = true;
                res = true;
                this._events.trigger('area-resize');
            } else if (this._isCoordWithinBoxResize([mouseCurX, mouseCurY])) {
                cursor = 'nesw-resize';
                this._areaIsHover = false;
                this._boxResizeIsHover = true;
                res = true;
            } else if (this._isCoordWithinArea([mouseCurX, mouseCurY])) {
                cursor = 'move';
                this._areaIsHover = true;
                res = true;
            }

            //this._dontDragOutside();
            angular.element(this._ctx.canvas).css({
                'cursor': cursor
            });

            return res;
        };

        CropAreaCircle.prototype.processMouseDown = function (mouseDownX, mouseDownY) {
            if (this._isCoordWithinBoxResize([mouseDownX, mouseDownY])) {
                this._areaIsDragging = false;
                this._areaIsHover = false;
                this._boxResizeIsDragging = true;
                this._boxResizeIsHover = true;
                this._posResizeStartX = mouseDownX;
                this._posResizeStartY = mouseDownY;
                this._posResizeStartSize = this._size;
                this._events.trigger('area-resize-start');
            } else if (this._isCoordWithinArea([mouseDownX, mouseDownY])) {
                this._areaIsDragging = true;
                this._areaIsHover = true;
                this._boxResizeIsDragging = false;
                this._boxResizeIsHover = false;
                var center = this.getCenterPoint();
                this._posDragStartX = mouseDownX - center.x;
                this._posDragStartY = mouseDownY - center.y;
                this._events.trigger('area-move-start');
            }
        };

        CropAreaCircle.prototype.processMouseUp = function () /*mouseUpX, mouseUpY*/{
            if (this._areaIsDragging) {
                this._areaIsDragging = false;
                this._events.trigger('area-move-end');
            }
            if (this._boxResizeIsDragging) {
                this._boxResizeIsDragging = false;
                this._events.trigger('area-resize-end');
            }
            this._areaIsHover = false;
            this._boxResizeIsHover = false;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
        };

        return CropAreaCircle;
    }]);

    angular.module('uiCropper').factory('cropAreaRectangle', ['cropArea', function (CropArea) {
        var CropAreaRectangle = function CropAreaRectangle() {
            CropArea.apply(this, arguments);

            this._resizeCtrlBaseRadius = 15;
            this._resizeCtrlNormalRatio = 0.6;
            this._resizeCtrlHoverRatio = 0.70;
            this._iconMoveNormalRatio = 0.9;
            this._iconMoveHoverRatio = 1.2;

            this._resizeCtrlNormalRadius = this._resizeCtrlBaseRadius * this._resizeCtrlNormalRatio;
            this._resizeCtrlHoverRadius = this._resizeCtrlBaseRadius * this._resizeCtrlHoverRatio;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
            this._posResizeStartX = 0;
            this._posResizeStartY = 0;
            this._posResizeStartSize = {
                w: 0,
                h: 0
            };

            this._resizeCtrlIsHover = -1;
            this._areaIsHover = false;
            this._resizeCtrlIsDragging = -1;
            this._areaIsDragging = false;
        };

        CropAreaRectangle.prototype = new CropArea();

        // return a type string
        CropAreaRectangle.prototype.getType = function () {
            return 'rectangle';
        };

        CropAreaRectangle.prototype._calcRectangleCorners = function () {
            var size = this.getSize();
            var se = this.getSouthEastBound();
            return [[size.x, size.y], //northwest
            [se.x, size.y], //northeast
            [size.x, se.y], //southwest
            [se.x, se.y] //southeast
            ];
        };

        CropAreaRectangle.prototype._calcRectangleDimensions = function () {
            var size = this.getSize();
            var se = this.getSouthEastBound();
            return {
                left: size.x,
                top: size.y,
                right: se.x,
                bottom: se.y
            };
        };

        CropAreaRectangle.prototype._isCoordWithinArea = function (coord) {
            var rectangleDimensions = this._calcRectangleDimensions();
            return coord[0] >= rectangleDimensions.left && coord[0] <= rectangleDimensions.right && coord[1] >= rectangleDimensions.top && coord[1] <= rectangleDimensions.bottom;
        };

        CropAreaRectangle.prototype._isCoordWithinResizeCtrl = function (coord) {
            var resizeIconsCenterCoords = this._calcRectangleCorners();
            var res = -1;
            for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
                var resizeIconCenterCoords = resizeIconsCenterCoords[i];
                if (coord[0] > resizeIconCenterCoords[0] - this._resizeCtrlHoverRadius && coord[0] < resizeIconCenterCoords[0] + this._resizeCtrlHoverRadius && coord[1] > resizeIconCenterCoords[1] - this._resizeCtrlHoverRadius && coord[1] < resizeIconCenterCoords[1] + this._resizeCtrlHoverRadius) {
                    res = i;
                    break;
                }
            }
            return res;
        };

        CropAreaRectangle.prototype._drawArea = function (ctx, center, size) {
            ctx.rect(size.x, size.y, size.w, size.h);
        };

        CropAreaRectangle.prototype.draw = function () {
            CropArea.prototype.draw.apply(this, arguments);

            var center = this.getCenterPoint();
            // draw move icon
            this._cropCanvas.drawIconMove([center.x, center.y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio);

            // draw resize thumbs
            var resizeIconsCenterCoords = this._calcRectangleCorners();
            for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
                var resizeIconCenterCoords = resizeIconsCenterCoords[i];
                this._cropCanvas.drawIconResizeBoxBase(resizeIconCenterCoords, this._resizeCtrlBaseRadius, this._resizeCtrlIsHover === i ? this._resizeCtrlHoverRatio : this._resizeCtrlNormalRatio);
            }
        };

        CropAreaRectangle.prototype.processMouseMove = function (mouseCurX, mouseCurY) {
            var cursor = 'default';
            var res = false;

            this._resizeCtrlIsHover = -1;
            this._areaIsHover = false;

            if (this._areaIsDragging) {
                this.setCenterPointOnMove({
                    x: mouseCurX - this._posDragStartX,
                    y: mouseCurY - this._posDragStartY
                });
                this._areaIsHover = true;
                cursor = 'move';
                res = true;
                this._events.trigger('area-move');
            } else if (this._resizeCtrlIsDragging > -1) {
                var s = this.getSize();
                var se = this.getSouthEastBound();
                var posX = mouseCurX;
                switch (this._resizeCtrlIsDragging) {
                    case 0:
                        // Top Left
                        if (this._aspect) {
                            posX = se.x - (se.y - mouseCurY) * this._aspect;
                        }
                        this.setSizeByCorners({
                            x: posX,
                            y: mouseCurY
                        }, {
                            x: se.x,
                            y: se.y
                        });
                        cursor = 'nwse-resize';
                        break;
                    case 1:
                        // Top Right
                        if (this._aspect) {
                            posX = s.x + (se.y - mouseCurY) * this._aspect;
                        }
                        this.setSizeByCorners({
                            x: s.x,
                            y: mouseCurY
                        }, {
                            x: posX,
                            y: se.y
                        });
                        cursor = 'nesw-resize';
                        break;
                    case 2:
                        // Bottom Left
                        if (this._aspect) {
                            posX = se.x - (mouseCurY - s.y) * this._aspect;
                        }
                        this.setSizeByCorners({
                            x: posX,
                            y: s.y
                        }, {
                            x: se.x,
                            y: mouseCurY
                        });
                        cursor = 'nesw-resize';
                        break;
                    case 3:
                        // Bottom Right
                        if (this._aspect) {
                            posX = s.x + (mouseCurY - s.y) * this._aspect;
                        }
                        this.setSizeByCorners({
                            x: s.x,
                            y: s.y
                        }, {
                            x: posX,
                            y: mouseCurY
                        });
                        cursor = 'nwse-resize';
                        break;
                }

                this._resizeCtrlIsHover = this._resizeCtrlIsDragging;
                res = true;
                this._events.trigger('area-resize');
            } else {
                var hoveredResizeBox = this._isCoordWithinResizeCtrl([mouseCurX, mouseCurY]);
                if (hoveredResizeBox > -1) {
                    switch (hoveredResizeBox) {
                        case 0:
                            cursor = 'nwse-resize';
                            break;
                        case 1:
                            cursor = 'nesw-resize';
                            break;
                        case 2:
                            cursor = 'nesw-resize';
                            break;
                        case 3:
                            cursor = 'nwse-resize';
                            break;
                    }
                    this._areaIsHover = false;
                    this._resizeCtrlIsHover = hoveredResizeBox;
                    res = true;
                } else if (this._isCoordWithinArea([mouseCurX, mouseCurY])) {
                    cursor = 'move';
                    this._areaIsHover = true;
                    res = true;
                }
            }

            angular.element(this._ctx.canvas).css({
                'cursor': cursor
            });

            return res;
        };

        CropAreaRectangle.prototype.processMouseDown = function (mouseDownX, mouseDownY) {
            var isWithinResizeCtrl = this._isCoordWithinResizeCtrl([mouseDownX, mouseDownY]);
            if (isWithinResizeCtrl > -1) {
                this._areaIsDragging = false;
                this._areaIsHover = false;
                this._resizeCtrlIsDragging = isWithinResizeCtrl;
                this._resizeCtrlIsHover = isWithinResizeCtrl;
                this._posResizeStartX = mouseDownX;
                this._posResizeStartY = mouseDownY;
                this._posResizeStartSize = this._size;
                this._events.trigger('area-resize-start');
            } else if (this._isCoordWithinArea([mouseDownX, mouseDownY])) {
                this._areaIsDragging = true;
                this._areaIsHover = true;
                this._resizeCtrlIsDragging = -1;
                this._resizeCtrlIsHover = -1;
                var center = this.getCenterPoint();
                this._posDragStartX = mouseDownX - center.x;
                this._posDragStartY = mouseDownY - center.y;
                this._events.trigger('area-move-start');
            }
        };

        CropAreaRectangle.prototype.processMouseUp = function () /*mouseUpX, mouseUpY*/{
            if (this._areaIsDragging) {
                this._areaIsDragging = false;
                this._events.trigger('area-move-end');
            }
            if (this._resizeCtrlIsDragging > -1) {
                this._resizeCtrlIsDragging = -1;
                this._events.trigger('area-resize-end');
            }
            this._areaIsHover = false;
            this._resizeCtrlIsHover = -1;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
        };

        return CropAreaRectangle;
    }]);

    angular.module('uiCropper').factory('cropAreaSquare', ['cropArea', function (CropArea) {
        var CropAreaSquare = function CropAreaSquare() {
            CropArea.apply(this, arguments);

            this._resizeCtrlBaseRadius = 15;
            this._resizeCtrlNormalRatio = 0.6;
            this._resizeCtrlHoverRatio = 0.70;
            this._iconMoveNormalRatio = 0.9;
            this._iconMoveHoverRatio = 1.2;

            this._resizeCtrlNormalRadius = this._resizeCtrlBaseRadius * this._resizeCtrlNormalRatio;
            this._resizeCtrlHoverRadius = this._resizeCtrlBaseRadius * this._resizeCtrlHoverRatio;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
            this._posResizeStartX = 0;
            this._posResizeStartY = 0;
            this._posResizeStartSize = 0;

            this._resizeCtrlIsHover = -1;
            this._areaIsHover = false;
            this._resizeCtrlIsDragging = -1;
            this._areaIsDragging = false;
        };

        CropAreaSquare.prototype = new CropArea();

        CropAreaSquare.prototype.getType = function () {
            return 'square';
        };

        CropAreaSquare.prototype._calcSquareCorners = function () {
            var size = this.getSize(),
                se = this.getSouthEastBound();
            return [[size.x, size.y], //northwest
            [se.x, size.y], //northeast
            [size.x, se.y], //southwest
            [se.x, se.y] //southeast
            ];
        };

        CropAreaSquare.prototype._calcSquareDimensions = function () {
            var size = this.getSize(),
                se = this.getSouthEastBound();
            return {
                left: size.x,
                top: size.y,
                right: se.x,
                bottom: se.y
            };
        };

        CropAreaSquare.prototype._isCoordWithinArea = function (coord) {
            var squareDimensions = this._calcSquareDimensions();
            return coord[0] >= squareDimensions.left && coord[0] <= squareDimensions.right && coord[1] >= squareDimensions.top && coord[1] <= squareDimensions.bottom;
        };

        CropAreaSquare.prototype._isCoordWithinResizeCtrl = function (coord) {
            var resizeIconsCenterCoords = this._calcSquareCorners();
            var res = -1;
            for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
                var resizeIconCenterCoords = resizeIconsCenterCoords[i];
                if (coord[0] > resizeIconCenterCoords[0] - this._resizeCtrlHoverRadius && coord[0] < resizeIconCenterCoords[0] + this._resizeCtrlHoverRadius && coord[1] > resizeIconCenterCoords[1] - this._resizeCtrlHoverRadius && coord[1] < resizeIconCenterCoords[1] + this._resizeCtrlHoverRadius) {
                    res = i;
                    break;
                }
            }
            return res;
        };

        CropAreaSquare.prototype._drawArea = function (ctx, centerCoords, size) {
            ctx.rect(size.x, size.y, size.w, size.h);
        };

        CropAreaSquare.prototype.draw = function () {
            CropArea.prototype.draw.apply(this, arguments);

            // draw move icon
            var center = this.getCenterPoint();
            this._cropCanvas.drawIconMove([center.x, center.y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio);

            // draw resize cubes
            var resizeIconsCenterCoords = this._calcSquareCorners();
            for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
                var resizeIconCenterCoords = resizeIconsCenterCoords[i];
                this._cropCanvas.drawIconResizeBoxBase(resizeIconCenterCoords, this._resizeCtrlBaseRadius, this._resizeCtrlIsHover === i ? this._resizeCtrlHoverRatio : this._resizeCtrlNormalRatio);
            }
        };

        CropAreaSquare.prototype._clampPoint = function (x, y) {
            var size = this._ctx.canvas.width;

            if (x < 0) {
                y -= Math.abs(x);
                x = 0;
            }

            if (y < 0) {
                x -= Math.abs(y);
                y = 0;
            }

            if (x > size) {
                y -= size - x;
                x = size;
            }

            if (y > size) {
                x -= size - y;
                y = size;
            }

            return {
                x: x,
                y: y
            };
        };

        CropAreaSquare.prototype.processMouseMove = function (mouseCurX, mouseCurY) {
            var cursor = 'default';
            var res = false;

            this._resizeCtrlIsHover = -1;
            this._areaIsHover = false;

            if (this._areaIsDragging) {
                this.setCenterPointOnMove({
                    x: mouseCurX - this._posDragStartX,
                    y: mouseCurY - this._posDragStartY
                });
                this._areaIsHover = true;
                cursor = 'move';
                res = true;
                this._events.trigger('area-move');
            } else if (this._resizeCtrlIsDragging > -1) {
                var xMulti, yMulti;
                switch (this._resizeCtrlIsDragging) {
                    case 0:
                        // Top Left
                        xMulti = -1;
                        yMulti = -1;
                        cursor = 'nwse-resize';
                        break;
                    case 1:
                        // Top Right
                        xMulti = 1;
                        yMulti = -1;
                        cursor = 'nesw-resize';
                        break;
                    case 2:
                        // Bottom Left
                        xMulti = -1;
                        yMulti = 1;
                        cursor = 'nesw-resize';
                        break;
                    case 3:
                        // Bottom Right
                        xMulti = 1;
                        yMulti = 1;
                        cursor = 'nwse-resize';
                        break;
                }
                var iFX = (mouseCurX - this._posResizeStartX) * xMulti,
                    iFY = (mouseCurY - this._posResizeStartY) * yMulti,
                    iFR;
                if (iFX > iFY) {
                    iFR = this._posResizeStartSize.w + iFY;
                } else {
                    iFR = this._posResizeStartSize.w + iFX;
                }
                var newSize = Math.max(this._minSize.w, iFR),
                    newNO = {},
                    newSE = {},
                    newSO = {},
                    newNE = {},
                    s = this.getSize(),
                    se = this.getSouthEastBound();

                switch (this._resizeCtrlIsDragging) {
                    case 0:
                        // Top Left
                        newNO.x = se.x - newSize;
                        newNO.y = se.y - newSize;

                        newNO = this._clampPoint(newNO.x, newNO.y);

                        this.setSizeByCorners(newNO, {
                            x: se.x,
                            y: se.y
                        });

                        cursor = 'nwse-resize';
                        break;
                    case 1:
                        // Top Right

                        newNE.x = s.x + newSize;
                        newNE.y = se.y - newSize;

                        newNE = this._clampPoint(newNE.x, newNE.y);

                        this.setSizeByCorners({
                            x: s.x,
                            y: newNE.y
                        }, {
                            x: newNE.x,
                            y: se.y
                        });

                        cursor = 'nesw-resize';
                        break;
                    case 2:
                        // Bottom Left
                        newSO.x = se.x - newSize;
                        newSO.y = s.y + newSize;

                        newSO = this._clampPoint(newSO.x, newSO.y);

                        this.setSizeByCorners({
                            x: newSO.x,
                            y: s.y
                        }, {
                            x: se.x,
                            y: newSO.y
                        });

                        cursor = 'nesw-resize';
                        break;
                    case 3:
                        // Bottom Right

                        newSE.x = s.x + newSize;
                        newSE.y = s.y + newSize;

                        newSE = this._clampPoint(newSE.x, newSE.y);

                        this.setSizeByCorners({
                            x: s.x,
                            y: s.y
                        }, newSE);

                        cursor = 'nwse-resize';
                        break;
                }
                this._resizeCtrlIsHover = this._resizeCtrlIsDragging;
                res = true;
                this._events.trigger('area-resize');
            } else {
                var hoveredResizeBox = this._isCoordWithinResizeCtrl([mouseCurX, mouseCurY]);
                if (hoveredResizeBox > -1) {
                    switch (hoveredResizeBox) {
                        case 0:
                            cursor = 'nwse-resize';
                            break;
                        case 1:
                            cursor = 'nesw-resize';
                            break;
                        case 2:
                            cursor = 'nesw-resize';
                            break;
                        case 3:
                            cursor = 'nwse-resize';
                            break;
                    }
                    this._areaIsHover = false;
                    this._resizeCtrlIsHover = hoveredResizeBox;
                    res = true;
                } else if (this._isCoordWithinArea([mouseCurX, mouseCurY])) {
                    cursor = 'move';
                    this._areaIsHover = true;
                    res = true;
                }
            }

            angular.element(this._ctx.canvas).css({
                'cursor': cursor
            });

            return res;
        };

        CropAreaSquare.prototype.processMouseDown = function (mouseDownX, mouseDownY) {
            var isWithinResizeCtrl = this._isCoordWithinResizeCtrl([mouseDownX, mouseDownY]);
            if (isWithinResizeCtrl > -1) {
                this._areaIsDragging = false;
                this._areaIsHover = false;
                this._resizeCtrlIsDragging = isWithinResizeCtrl;
                this._resizeCtrlIsHover = isWithinResizeCtrl;
                this._posResizeStartX = mouseDownX;
                this._posResizeStartY = mouseDownY;
                this._posResizeStartSize = this._size;
                this._events.trigger('area-resize-start');
            } else if (this._isCoordWithinArea([mouseDownX, mouseDownY])) {
                this._areaIsDragging = true;
                this._areaIsHover = true;
                this._resizeCtrlIsDragging = -1;
                this._resizeCtrlIsHover = -1;
                var center = this.getCenterPoint();
                this._posDragStartX = mouseDownX - center.x;
                this._posDragStartY = mouseDownY - center.y;
                this._events.trigger('area-move-start');
            }
        };

        CropAreaSquare.prototype.processMouseUp = function () /*mouseUpX, mouseUpY*/{
            if (this._areaIsDragging) {
                this._areaIsDragging = false;
                this._events.trigger('area-move-end');
            }
            if (this._resizeCtrlIsDragging > -1) {
                this._resizeCtrlIsDragging = -1;
                this._events.trigger('area-resize-end');
            }
            this._areaIsHover = false;
            this._resizeCtrlIsHover = -1;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
        };

        return CropAreaSquare;
    }]);

    angular.module('uiCropper').factory('cropArea', ['cropCanvas', function (CropCanvas) {
        var CropArea = function CropArea(ctx, events) {
            this._ctx = ctx;
            this._events = events;

            this._minSize = {
                x: 0,
                y: 0,
                w: 80,
                h: 80
            };

            this._initSize = undefined;
            this._initCoords = undefined;
            this._allowCropResizeOnCorners = false;

            this._forceAspectRatio = false;
            this._aspect = null;

            this._cropCanvas = new CropCanvas(ctx);

            this._image = new Image();
            this._size = {
                x: 0,
                y: 0,
                w: 150,
                h: 150
            };
        };

        /* GETTERS/SETTERS */

        CropArea.prototype.setAllowCropResizeOnCorners = function (bool) {
            this._allowCropResizeOnCorners = bool;
        };
        CropArea.prototype.getImage = function () {
            return this._image;
        };
        CropArea.prototype.setImage = function (image) {
            this._image = image;
        };
        CropArea.prototype.setForceAspectRatio = function (force) {
            this._forceAspectRatio = force;
        };
        CropArea.prototype.setAspect = function (aspect) {
            this._aspect = aspect;
        };
        CropArea.prototype.getAspect = function () {
            return this._aspect;
        };
        CropArea.prototype.getCanvasSize = function () {
            return {
                w: this._ctx.canvas.width,
                h: this._ctx.canvas.height
            };
        };
        CropArea.prototype.getSize = function () {
            return this._size;
        };
        CropArea.prototype.setSize = function (size) {
            size = this._processSize(size);
            this._size = this._preventBoundaryCollision(size);
        };
        CropArea.prototype.setSizeOnMove = function (size) {
            size = this._processSize(size);
            if (this._allowCropResizeOnCorners) {
                this._size = this._preventBoundaryCollision(size);
            } else {
                this._size = this._allowMouseOutsideCanvas(size);
            }
        };
        CropArea.prototype.circleOnMove = function (northWestCorner, southEastCorner) {
            var size = {
                x: northWestCorner.x,
                y: northWestCorner.y,
                w: southEastCorner.x - northWestCorner.x,
                h: southEastCorner.y - northWestCorner.y
            };
            var canvasH = this._ctx.canvas.height,
                canvasW = this._ctx.canvas.width;
            if (size.w > canvasW || size.h > canvasH) {
                if (canvasW < canvasH) {
                    size.w = canvasW;
                    size.h = canvasW;
                } else {
                    size.w = canvasH;
                    size.h = canvasH;
                }
            }
            if (size.x + size.w > canvasW) {
                size.x = canvasW - size.w;
            }
            if (size.y + size.h > canvasH) {
                size.y = canvasH - size.h;
            }
            if (size.x < 0) {
                size.x = 0;
            }
            if (size.y < 0) {
                size.y = 0;
            }
            if (this._minSize.w > size.w) {
                size.w = this._minSize.w;
                size.x = this._size.x;
            }
            if (this._minSize.h > size.h) {
                size.h = this._minSize.h;
                size.y = this._size.y;
            }
            this._size = size;
        };

        CropArea.prototype.setSizeByCorners = function (northWestCorner, southEastCorner) {

            var size = {
                x: northWestCorner.x,
                y: northWestCorner.y,
                w: southEastCorner.x - northWestCorner.x,
                h: southEastCorner.y - northWestCorner.y
            };
            this.setSize(size);
        };

        CropArea.prototype.getSouthEastBound = function () {
            return this._southEastBound(this.getSize());
        };

        CropArea.prototype.setMinSize = function (size) {
            this._minSize = this._processSize(size);
            this.setSize(this._minSize);
        };

        CropArea.prototype.getMinSize = function () {
            return this._minSize;
        };

        CropArea.prototype.getCenterPoint = function () {
            var s = this.getSize();
            return {
                x: s.x + s.w / 2,
                y: s.y + s.h / 2
            };
        };

        CropArea.prototype.setCenterPoint = function (point) {
            var s = this.getSize();
            this.setSize({
                x: point.x - s.w / 2,
                y: point.y - s.h / 2,
                w: s.w,
                h: s.h
            });
        };

        CropArea.prototype.setCenterPointOnMove = function (point) {
            var s = this.getSize();
            this.setSizeOnMove({
                x: point.x - s.w / 2,
                y: point.y - s.h / 2,
                w: s.w,
                h: s.h
            });
        };

        CropArea.prototype.setInitSize = function (size) {
            this._initSize = this._processSize(size);
            this.setSize(this._initSize);
        };

        CropArea.prototype.getInitSize = function () {
            return this._initSize;
        };

        CropArea.prototype.setInitCoords = function (coords) {
            //add h/w-data to coords-object
            coords.h = this.getSize().h;
            coords.w = this.getSize().w;
            this._initCoords = this._processSize(coords);
            this.setSize(this._initCoords);
        };

        CropArea.prototype.getInitCoords = function () {
            return this._initCoords;
        };

        // return a type string
        CropArea.prototype.getType = function () {
            //default to circle
            return 'circle';
        };

        /* FUNCTIONS */
        CropArea.prototype._allowMouseOutsideCanvas = function (size) {
            var canvasH = this._ctx.canvas.height,
                canvasW = this._ctx.canvas.width;
            var newSize = {
                w: size.w,
                h: size.h
            };
            if (size.x < 0) {
                newSize.x = 0;
            } else if (size.x + size.w > canvasW) {
                newSize.x = canvasW - size.w;
            } else {
                newSize.x = size.x;
            }
            if (size.y < 0) {
                newSize.y = 0;
            } else if (size.y + size.h > canvasH) {
                newSize.y = canvasH - size.h;
            } else {
                newSize.y = size.y;
            }
            return newSize;
        };

        CropArea.prototype._preventBoundaryCollision = function (size) {
            var canvasH = this._ctx.canvas.height,
                canvasW = this._ctx.canvas.width;

            var nw = {
                x: size.x,
                y: size.y
            };
            var se = this._southEastBound(size);

            // check northwest corner
            if (nw.x < 0) {
                nw.x = 0;
            }
            if (nw.y < 0) {
                nw.y = 0;
            }

            // check southeast corner
            if (se.x > canvasW) {
                se.x = canvasW;
            }
            if (se.y > canvasH) {
                se.y = canvasH;
            }

            var newSizeWidth = this._forceAspectRatio ? size.w : se.x - nw.x,
                newSizeHeight = this._forceAspectRatio ? size.h : se.y - nw.y;

            if (newSizeHeight > canvasH) {
                newSizeHeight = canvasH;
            }

            // save rectangle scale
            if (this._aspect) {
                newSizeWidth = newSizeHeight * this._aspect;
                if (nw.x + newSizeWidth > canvasW) {
                    newSizeWidth = canvasW - nw.x;
                    newSizeHeight = newSizeWidth / this._aspect;
                    if (this._minSize.w > newSizeWidth) {
                        newSizeWidth = this._minSize.w;
                    }
                    if (this._minSize.h > newSizeHeight) {
                        newSizeHeight = this._minSize.h;
                    }
                    nw.x = canvasW - newSizeWidth;
                }
                if (nw.y + newSizeHeight > canvasH) {
                    nw.y = canvasH - newSizeHeight;
                }
            }

            // save square scale
            if (this._forceAspectRatio) {
                newSizeWidth = newSizeHeight;
                if (nw.x + newSizeWidth > canvasW) {
                    newSizeWidth = canvasW - nw.x;
                    if (newSizeWidth < this._minSize.w) {
                        newSizeWidth = this._minSize.w;
                    }
                    newSizeHeight = newSizeWidth;
                }
            }

            var newSize = {
                x: nw.x,
                y: nw.y,
                w: newSizeWidth,
                h: newSizeHeight
            };

            //check size (if < min, adjust nw corner)
            if (newSize.w < this._minSize.w && !this._forceAspectRatio) {
                newSize.w = this._minSize.w;
                se = this._southEastBound(newSize);
                //adjust se corner, if it's out of bounds
                if (se.x > canvasW) {
                    se.x = canvasW;
                    //adjust nw corner according to min width
                    nw.x = Math.max(se.x - canvasW, se.x - this._minSize.w);
                    newSize = {
                        x: nw.x,
                        y: nw.y,
                        w: se.x - nw.x,
                        h: se.y - nw.y
                    };
                }
            }

            if (newSize.h < this._minSize.h && !this._forceAspectRatio) {
                newSize.h = this._minSize.h;
                se = this._southEastBound(newSize);

                if (se.y > canvasH) {
                    se.y = canvasH;
                    //adjust nw corner according to min height
                    nw.y = Math.max(se.y - canvasH, se.y - this._minSize.h);
                    newSize = {
                        x: nw.x,
                        y: nw.y,
                        w: se.x - nw.x,
                        h: se.y - nw.y
                    };
                }
            }

            if (this._forceAspectRatio) {
                //check if outside SE bound
                se = this._southEastBound(newSize);
                if (se.y > canvasH) {
                    newSize.y = canvasH - newSize.h;
                }
                if (se.x > canvasW) {
                    newSize.x = canvasW - newSize.w;
                }
            }

            return newSize;
        };

        CropArea.prototype._dontDragOutside = function () {
            var h = this._ctx.canvas.height,
                w = this._ctx.canvas.width;

            if (this._width > w) {
                this._width = w;
            }
            if (this._height > h) {
                this._height = h;
            }
            if (this._x < this._width / 2) {
                this._x = this._width / 2;
            }
            if (this._x > w - this._width / 2) {
                this._x = w - this._width / 2;
            }
            if (this._y < this._height / 2) {
                this._y = this._height / 2;
            }
            if (this._y > h - this._height / 2) {
                this._y = h - this._height / 2;
            }
        };

        CropArea.prototype._drawArea = function () {};

        CropArea.prototype._processSize = function (size) {
            // make this polymorphic to accept a single floating point number
            // for square-like sizes (including circle)
            if (typeof size === 'number') {
                size = {
                    w: size,
                    h: size
                };
            }
            var width = size.w;
            if (this._aspect) {
                width = size.h * this._aspect;
            }
            return {
                x: typeof size.x === 'undefined' ? this.getSize().x : size.x,
                y: typeof size.y === 'undefined' ? this.getSize().y : size.y,
                w: width || this._minSize.w,
                h: size.h || this._minSize.h
            };
        };

        CropArea.prototype._southEastBound = function (size) {
            return {
                x: size.x + size.w,
                y: size.y + size.h
            };
        };

        CropArea.prototype.draw = function () {
            // draw crop area
            this._cropCanvas.drawCropArea(this._image, this.getCenterPoint(), this._size, this._drawArea);
        };

        CropArea.prototype.processMouseMove = function () {};

        CropArea.prototype.processMouseDown = function () {};

        CropArea.prototype.processMouseUp = function () {};

        return CropArea;
    }]);

    angular.module('uiCropper').factory('cropCanvas', [function () {
        // Shape = Array of [x,y]; [0, 0] - center
        var shapeArrowNW = [[-0.5, -2], [-3, -4.5], [-0.5, -7], [-7, -7], [-7, -0.5], [-4.5, -3], [-2, -0.5]];
        var shapeArrowNE = [[0.5, -2], [3, -4.5], [0.5, -7], [7, -7], [7, -0.5], [4.5, -3], [2, -0.5]];
        var shapeArrowSW = [[-0.5, 2], [-3, 4.5], [-0.5, 7], [-7, 7], [-7, 0.5], [-4.5, 3], [-2, 0.5]];
        var shapeArrowSE = [[0.5, 2], [3, 4.5], [0.5, 7], [7, 7], [7, 0.5], [4.5, 3], [2, 0.5]];
        var shapeArrowN = [[-1.5, -2.5], [-1.5, -6], [-5, -6], [0, -11], [5, -6], [1.5, -6], [1.5, -2.5]];
        var shapeArrowW = [[-2.5, -1.5], [-6, -1.5], [-6, -5], [-11, 0], [-6, 5], [-6, 1.5], [-2.5, 1.5]];
        var shapeArrowS = [[-1.5, 2.5], [-1.5, 6], [-5, 6], [0, 11], [5, 6], [1.5, 6], [1.5, 2.5]];
        var shapeArrowE = [[2.5, -1.5], [6, -1.5], [6, -5], [11, 0], [6, 5], [6, 1.5], [2.5, 1.5]];

        // Colors
        var colors = {
            areaOutline: '#fff',
            resizeBoxStroke: '#bababa',
            resizeBoxFill: '#444',
            resizeBoxArrowFill: '#fff',
            resizeCircleStroke: '#bababa',
            resizeCircleFill: '#444',
            moveIconFill: '#fff'
        };

        var cropper = {
            strokeWidth: 1
        };

        return function (ctx) {

            /* Base functions */

            // Calculate Point
            var calcPoint = function calcPoint(point, offset, scale) {
                return [scale * point[0] + offset[0], scale * point[1] + offset[1]];
            };

            // Draw Filled Polygon
            var drawFilledPolygon = function drawFilledPolygon(shape, fillStyle, centerCoords, scale) {
                ctx.save();
                ctx.fillStyle = fillStyle;
                ctx.beginPath();
                var pc,
                    pc0 = calcPoint(shape[0], centerCoords, scale);
                ctx.moveTo(pc0[0], pc0[1]);

                for (var p in shape) {
                    if (p > 0) {
                        pc = calcPoint(shape[p], centerCoords, scale);
                        ctx.lineTo(pc[0], pc[1]);
                    }
                }

                ctx.lineTo(pc0[0], pc0[1]);
                ctx.fill();
                ctx.closePath();
                ctx.restore();
            };

            /* Icons */

            this.drawIconMove = function (centerCoords, scale) {
                drawFilledPolygon(shapeArrowN, colors.moveIconFill, centerCoords, scale);
                drawFilledPolygon(shapeArrowW, colors.moveIconFill, centerCoords, scale);
                drawFilledPolygon(shapeArrowS, colors.moveIconFill, centerCoords, scale);
                drawFilledPolygon(shapeArrowE, colors.moveIconFill, centerCoords, scale);
            };

            this.drawIconResizeCircle = function (centerCoords, circleRadius, scale) {
                var scaledCircleRadius = circleRadius * scale;
                ctx.save();
                ctx.strokeStyle = colors.resizeCircleStroke;
                ctx.lineWidth = cropper.strokeWidth;
                ctx.fillStyle = colors.resizeCircleFill;
                ctx.beginPath();
                ctx.arc(centerCoords[0], centerCoords[1], scaledCircleRadius, 0, 2 * Math.PI);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();
                ctx.restore();
            };

            this.drawIconResizeBoxBase = function (centerCoords, boxSize, scale) {
                var scaledBoxSize = boxSize * scale;
                ctx.save();
                ctx.strokeStyle = colors.resizeBoxStroke;
                ctx.lineWidth = cropper.strokeWidth;
                ctx.fillStyle = colors.resizeBoxFill;
                ctx.fillRect(centerCoords[0] - scaledBoxSize / 2, centerCoords[1] - scaledBoxSize / 2, scaledBoxSize, scaledBoxSize);
                ctx.strokeRect(centerCoords[0] - scaledBoxSize / 2, centerCoords[1] - scaledBoxSize / 2, scaledBoxSize, scaledBoxSize);
                ctx.restore();
            };
            this.drawIconResizeBoxNESW = function (centerCoords, boxSize, scale) {
                this.drawIconResizeBoxBase(centerCoords, boxSize, scale);
                drawFilledPolygon(shapeArrowNE, colors.resizeBoxArrowFill, centerCoords, scale);
                drawFilledPolygon(shapeArrowSW, colors.resizeBoxArrowFill, centerCoords, scale);
            };
            this.drawIconResizeBoxNWSE = function (centerCoords, boxSize, scale) {
                this.drawIconResizeBoxBase(centerCoords, boxSize, scale);
                drawFilledPolygon(shapeArrowNW, colors.resizeBoxArrowFill, centerCoords, scale);
                drawFilledPolygon(shapeArrowSE, colors.resizeBoxArrowFill, centerCoords, scale);
            };

            /* Crop Area */

            this.drawCropArea = function (image, centerCoords, size, fnDrawClipPath) {
                var xRatio = Math.abs(image.width / ctx.canvas.width),
                    yRatio = Math.abs(image.height / ctx.canvas.height),
                    xLeft = Math.abs(centerCoords.x - size.w / 2),
                    yTop = Math.abs(centerCoords.y - size.h / 2);

                ctx.save();
                ctx.strokeStyle = colors.areaOutline;
                ctx.lineWidth = cropper.strokeWidth;
                ctx.setLineDash([5, 5]);
                ctx.beginPath();
                fnDrawClipPath(ctx, centerCoords, size);
                ctx.stroke();
                ctx.clip();

                // draw part of original image
                if (size.w > 0) {
                    ctx.drawImage(image, xLeft * xRatio, yTop * yRatio, Math.abs(size.w * xRatio), Math.abs(size.h * yRatio), xLeft, yTop, Math.abs(size.w), Math.abs(size.h));
                }

                ctx.beginPath();
                fnDrawClipPath(ctx, centerCoords, size);
                ctx.stroke();
                ctx.clip();

                ctx.restore();
            };
        };
    }]);

    /**
     * EXIF service is based on the exif-js library (https://github.com/jseidelin/exif-js)
     */
    /*eslint-disable */
    //Disable eslint as this is a 3rd party lib
    angular.module('uiCropper').service('cropEXIF', [function () {
        var debug = false;

        var ExifTags = this.Tags = {

            // version tags
            0x9000: 'ExifVersion', // EXIF version
            0xA000: 'FlashpixVersion', // Flashpix format version

            // colorspace tags
            0xA001: 'ColorSpace', // Color space information tag

            // image configuration
            0xA002: 'PixelXDimension', // Valid width of meaningful image
            0xA003: 'PixelYDimension', // Valid height of meaningful image
            0x9101: 'ComponentsConfiguration', // Information about channels
            0x9102: 'CompressedBitsPerPixel', // Compressed bits per pixel

            // user information
            0x927C: 'MakerNote', // Any desired information written by the manufacturer
            0x9286: 'UserComment', // Comments by user

            // related file
            0xA004: 'RelatedSoundFile', // Name of related sound file

            // date and time
            0x9003: 'DateTimeOriginal', // Date and time when the original image was generated
            0x9004: 'DateTimeDigitized', // Date and time when the image was stored digitally
            0x9290: 'SubsecTime', // Fractions of seconds for DateTime
            0x9291: 'SubsecTimeOriginal', // Fractions of seconds for DateTimeOriginal
            0x9292: 'SubsecTimeDigitized', // Fractions of seconds for DateTimeDigitized

            // picture-taking conditions
            0x829A: 'ExposureTime', // Exposure time (in seconds)
            0x829D: 'FNumber', // F number
            0x8822: 'ExposureProgram', // Exposure program
            0x8824: 'SpectralSensitivity', // Spectral sensitivity
            0x8827: 'ISOSpeedRatings', // ISO speed rating
            0x8828: 'OECF', // Optoelectric conversion factor
            0x9201: 'ShutterSpeedValue', // Shutter speed
            0x9202: 'ApertureValue', // Lens aperture
            0x9203: 'BrightnessValue', // Value of brightness
            0x9204: 'ExposureBias', // Exposure bias
            0x9205: 'MaxApertureValue', // Smallest F number of lens
            0x9206: 'SubjectDistance', // Distance to subject in meters
            0x9207: 'MeteringMode', // Metering mode
            0x9208: 'LightSource', // Kind of light source
            0x9209: 'Flash', // Flash status
            0x9214: 'SubjectArea', // Location and area of main subject
            0x920A: 'FocalLength', // Focal length of the lens in mm
            0xA20B: 'FlashEnergy', // Strobe energy in BCPS
            0xA20C: 'SpatialFrequencyResponse', //
            0xA20E: 'FocalPlaneXResolution', // Number of pixels in width direction per FocalPlaneResolutionUnit
            0xA20F: 'FocalPlaneYResolution', // Number of pixels in height direction per FocalPlaneResolutionUnit
            0xA210: 'FocalPlaneResolutionUnit', // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
            0xA214: 'SubjectLocation', // Location of subject in image
            0xA215: 'ExposureIndex', // Exposure index selected on camera
            0xA217: 'SensingMethod', // Image sensor type
            0xA300: 'FileSource', // Image source (3 == DSC)
            0xA301: 'SceneType', // Scene type (1 == directly photographed)
            0xA302: 'CFAPattern', // Color filter array geometric pattern
            0xA401: 'CustomRendered', // Special processing
            0xA402: 'ExposureMode', // Exposure mode
            0xA403: 'WhiteBalance', // 1 = auto white balance, 2 = manual
            0xA404: 'DigitalZoomRation', // Digital zoom ratio
            0xA405: 'FocalLengthIn35mmFilm', // Equivalent foacl length assuming 35mm film camera (in mm)
            0xA406: 'SceneCaptureType', // Type of scene
            0xA407: 'GainControl', // Degree of overall image gain adjustment
            0xA408: 'Contrast', // Direction of contrast processing applied by camera
            0xA409: 'Saturation', // Direction of saturation processing applied by camera
            0xA40A: 'Sharpness', // Direction of sharpness processing applied by camera
            0xA40B: 'DeviceSettingDescription', //
            0xA40C: 'SubjectDistanceRange', // Distance to subject

            // other tags
            0xA005: 'InteroperabilityIFDPointer',
            0xA420: 'ImageUniqueID' // Identifier assigned uniquely to each image
        };

        var TiffTags = this.TiffTags = {
            0x0100: 'ImageWidth',
            0x0101: 'ImageHeight',
            0x8769: 'ExifIFDPointer',
            0x8825: 'GPSInfoIFDPointer',
            0xA005: 'InteroperabilityIFDPointer',
            0x0102: 'BitsPerSample',
            0x0103: 'Compression',
            0x0106: 'PhotometricInterpretation',
            0x0112: 'Orientation',
            0x0115: 'SamplesPerPixel',
            0x011C: 'PlanarConfiguration',
            0x0212: 'YCbCrSubSampling',
            0x0213: 'YCbCrPositioning',
            0x011A: 'XResolution',
            0x011B: 'YResolution',
            0x0128: 'ResolutionUnit',
            0x0111: 'StripOffsets',
            0x0116: 'RowsPerStrip',
            0x0117: 'StripByteCounts',
            0x0201: 'JPEGInterchangeFormat',
            0x0202: 'JPEGInterchangeFormatLength',
            0x012D: 'TransferFunction',
            0x013E: 'WhitePoint',
            0x013F: 'PrimaryChromaticities',
            0x0211: 'YCbCrCoefficients',
            0x0214: 'ReferenceBlackWhite',
            0x0132: 'DateTime',
            0x010E: 'ImageDescription',
            0x010F: 'Make',
            0x0110: 'Model',
            0x0131: 'Software',
            0x013B: 'Artist',
            0x8298: 'Copyright'
        };

        var GPSTags = this.GPSTags = {
            0x0000: 'GPSVersionID',
            0x0001: 'GPSLatitudeRef',
            0x0002: 'GPSLatitude',
            0x0003: 'GPSLongitudeRef',
            0x0004: 'GPSLongitude',
            0x0005: 'GPSAltitudeRef',
            0x0006: 'GPSAltitude',
            0x0007: 'GPSTimeStamp',
            0x0008: 'GPSSatellites',
            0x0009: 'GPSStatus',
            0x000A: 'GPSMeasureMode',
            0x000B: 'GPSDOP',
            0x000C: 'GPSSpeedRef',
            0x000D: 'GPSSpeed',
            0x000E: 'GPSTrackRef',
            0x000F: 'GPSTrack',
            0x0010: 'GPSImgDirectionRef',
            0x0011: 'GPSImgDirection',
            0x0012: 'GPSMapDatum',
            0x0013: 'GPSDestLatitudeRef',
            0x0014: 'GPSDestLatitude',
            0x0015: 'GPSDestLongitudeRef',
            0x0016: 'GPSDestLongitude',
            0x0017: 'GPSDestBearingRef',
            0x0018: 'GPSDestBearing',
            0x0019: 'GPSDestDistanceRef',
            0x001A: 'GPSDestDistance',
            0x001B: 'GPSProcessingMethod',
            0x001C: 'GPSAreaInformation',
            0x001D: 'GPSDateStamp',
            0x001E: 'GPSDifferential'
        };

        var StringValues = this.StringValues = {
            ExposureProgram: {
                0: 'Not defined',
                1: 'Manual',
                2: 'Normal program',
                3: 'Aperture priority',
                4: 'Shutter priority',
                5: 'Creative program',
                6: 'Action program',
                7: 'Portrait mode',
                8: 'Landscape mode'
            },
            MeteringMode: {
                0: 'Unknown',
                1: 'Average',
                2: 'CenterWeightedAverage',
                3: 'Spot',
                4: 'MultiSpot',
                5: 'Pattern',
                6: 'Partial',
                255: 'Other'
            },
            LightSource: {
                0: 'Unknown',
                1: 'Daylight',
                2: 'Fluorescent',
                3: 'Tungsten (incandescent light)',
                4: 'Flash',
                9: 'Fine weather',
                10: 'Cloudy weather',
                11: 'Shade',
                12: 'Daylight fluorescent (D 5700 - 7100K)',
                13: 'Day white fluorescent (N 4600 - 5400K)',
                14: 'Cool white fluorescent (W 3900 - 4500K)',
                15: 'White fluorescent (WW 3200 - 3700K)',
                17: 'Standard light A',
                18: 'Standard light B',
                19: 'Standard light C',
                20: 'D55',
                21: 'D65',
                22: 'D75',
                23: 'D50',
                24: 'ISO studio tungsten',
                255: 'Other'
            },
            Flash: {
                0x0000: 'Flash did not fire',
                0x0001: 'Flash fired',
                0x0005: 'Strobe return light not detected',
                0x0007: 'Strobe return light detected',
                0x0009: 'Flash fired, compulsory flash mode',
                0x000D: 'Flash fired, compulsory flash mode, return light not detected',
                0x000F: 'Flash fired, compulsory flash mode, return light detected',
                0x0010: 'Flash did not fire, compulsory flash mode',
                0x0018: 'Flash did not fire, auto mode',
                0x0019: 'Flash fired, auto mode',
                0x001D: 'Flash fired, auto mode, return light not detected',
                0x001F: 'Flash fired, auto mode, return light detected',
                0x0020: 'No flash function',
                0x0041: 'Flash fired, red-eye reduction mode',
                0x0045: 'Flash fired, red-eye reduction mode, return light not detected',
                0x0047: 'Flash fired, red-eye reduction mode, return light detected',
                0x0049: 'Flash fired, compulsory flash mode, red-eye reduction mode',
                0x004D: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
                0x004F: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
                0x0059: 'Flash fired, auto mode, red-eye reduction mode',
                0x005D: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
                0x005F: 'Flash fired, auto mode, return light detected, red-eye reduction mode'
            },
            SensingMethod: {
                1: 'Not defined',
                2: 'One-chip color area sensor',
                3: 'Two-chip color area sensor',
                4: 'Three-chip color area sensor',
                5: 'Color sequential area sensor',
                7: 'Trilinear sensor',
                8: 'Color sequential linear sensor'
            },
            SceneCaptureType: {
                0: 'Standard',
                1: 'Landscape',
                2: 'Portrait',
                3: 'Night scene'
            },
            SceneType: {
                1: 'Directly photographed'
            },
            CustomRendered: {
                0: 'Normal process',
                1: 'Custom process'
            },
            WhiteBalance: {
                0: 'Auto white balance',
                1: 'Manual white balance'
            },
            GainControl: {
                0: 'None',
                1: 'Low gain up',
                2: 'High gain up',
                3: 'Low gain down',
                4: 'High gain down'
            },
            Contrast: {
                0: 'Normal',
                1: 'Soft',
                2: 'Hard'
            },
            Saturation: {
                0: 'Normal',
                1: 'Low saturation',
                2: 'High saturation'
            },
            Sharpness: {
                0: 'Normal',
                1: 'Soft',
                2: 'Hard'
            },
            SubjectDistanceRange: {
                0: 'Unknown',
                1: 'Macro',
                2: 'Close view',
                3: 'Distant view'
            },
            FileSource: {
                3: 'DSC'
            },

            Components: {
                0: '',
                1: 'Y',
                2: 'Cb',
                3: 'Cr',
                4: 'R',
                5: 'G',
                6: 'B'
            }
        };

        function addEvent(element, event, handler) {
            if (element.addEventListener) {
                element.addEventListener(event, handler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + event, handler);
            }
        }

        function imageHasData(img) {
            return !!img.exifdata;
        }

        function base64ToArrayBuffer(base64, contentType) {
            contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
            base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
            var binary = atob(base64);
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }
            return buffer;
        }

        function objectURLToBlob(url, callback) {
            var http = new XMLHttpRequest();
            http.open('GET', url, true);
            http.responseType = 'blob';
            http.onload = function (e) {
                if (this.status === 200 || this.status === 0) {
                    callback(this.response);
                }
            };
            http.send();
        }

        function getImageData(img, callback) {
            function handleBinaryFile(binFile) {
                var data = findEXIFinJPEG(binFile);
                var iptcdata = findIPTCinJPEG(binFile);
                img.exifdata = data || {};
                img.iptcdata = iptcdata || {};
                if (callback) {
                    callback.call(img);
                }
            }

            var fileReader = new FileReader();

            if (img.src) {

                if (/^data\:/i.test(img.src)) {
                    // Data URI
                    var arrayBuffer = base64ToArrayBuffer(img.src);
                    handleBinaryFile(arrayBuffer);
                } else if (/^blob\:/i.test(img.src)) {
                    // Object URL
                    fileReader.onload = function (e) {
                        handleBinaryFile(e.target.result);
                    };
                    objectURLToBlob(img.src, function (blob) {
                        fileReader.readAsArrayBuffer(blob);
                    });
                }
                var http = new XMLHttpRequest();
                http.onload = function () {
                    if (this.status === 200 || this.status === 0) {
                        handleBinaryFile(http.response);
                    } else {
                        throw 'Could not load image';
                    }
                    http = null;
                };
                http.open('GET', img.src, true);
                http.responseType = 'arraybuffer';
                try {
                    http.send(null);
                } catch (e) {}
            } else if (window.FileReader && (img instanceof window.Blob || img instanceof window.File)) {
                fileReader.onload = function (e) {
                    if (debug) {
                        console.log('Got file of length ' + e.target.result.byteLength);
                    }
                    handleBinaryFile(e.target.result);
                };

                fileReader.readAsArrayBuffer(img);
            }
        }

        function findEXIFinJPEG(file) {
            var dataView = new DataView(file);

            if (debug) {
                console.log('Got file of length ' + file.byteLength);
            }
            if (dataView.getUint8(0) !== 0xFF || dataView.getUint8(1) !== 0xD8) {
                if (debug) {
                    console.log('Not a valid JPEG');
                }
                return false; // not a valid jpeg
            }

            var offset = 2,
                length = file.byteLength,
                marker;

            while (offset < length) {
                if (dataView.getUint8(offset) !== 0xFF) {
                    if (debug) {
                        console.log('Not a valid marker at offset ' + offset + ', found: ' + dataView.getUint8(offset));
                    }
                    return false; // not a valid marker, something is wrong
                }

                marker = dataView.getUint8(offset + 1);
                if (debug) {
                    console.log(marker);
                }

                // we could implement handling for other markers here,
                // but we're only looking for 0xFFE1 for EXIF data

                if (marker === 225) {
                    if (debug) {
                        console.log('Found 0xFFE1 marker');
                    }

                    return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

                    // offset += 2 + file.getShortAt(offset+2, true);
                } else {
                    offset += 2 + dataView.getUint16(offset + 2);
                }
            }
        }

        function findIPTCinJPEG(file) {
            var dataView = new DataView(file);

            if (debug) {
                console.log('Got file of length ' + file.byteLength);
            }
            if (dataView.getUint8(0) !== 0xFF || dataView.getUint8(1) !== 0xD8) {
                if (debug) {
                    console.log('Not a valid JPEG');
                }
                return false; // not a valid jpeg
            }

            var offset = 2,
                length = file.byteLength;

            var isFieldSegmentStart = function isFieldSegmentStart(dataView, offset) {
                return dataView.getUint8(offset) === 0x38 && dataView.getUint8(offset + 1) === 0x42 && dataView.getUint8(offset + 2) === 0x49 && dataView.getUint8(offset + 3) === 0x4D && dataView.getUint8(offset + 4) === 0x04 && dataView.getUint8(offset + 5) === 0x04;
            };

            while (offset < length) {

                if (isFieldSegmentStart(dataView, offset)) {

                    // Get the length of the name header (which is padded to an even number of bytes)
                    var nameHeaderLength = dataView.getUint8(offset + 7);
                    if (nameHeaderLength % 2 !== 0) {
                        nameHeaderLength += 1;
                    }
                    // Check for pre photoshop 6 format
                    if (nameHeaderLength === 0) {
                        // Always 4
                        nameHeaderLength = 4;
                    }

                    var startOffset = offset + 8 + nameHeaderLength;
                    var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

                    return readIPTCData(file, startOffset, sectionLength);
                }

                // Not the marker, continue searching
                offset++;
            }
        }

        var IptcFieldMap = {
            0x78: 'caption',
            0x6E: 'credit',
            0x19: 'keywords',
            0x37: 'dateCreated',
            0x50: 'byline',
            0x55: 'bylineTitle',
            0x7A: 'captionWriter',
            0x69: 'headline',
            0x74: 'copyright',
            0x0F: 'category'
        };

        function readIPTCData(file, startOffset, sectionLength) {
            var dataView = new DataView(file);
            var data = {};
            var fieldValue, fieldName, dataSize, segmentType, segmentSize;
            var segmentStartPos = startOffset;
            while (segmentStartPos < startOffset + sectionLength) {
                if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
                    segmentType = dataView.getUint8(segmentStartPos + 2);
                    if (segmentType in IptcFieldMap) {
                        dataSize = dataView.getInt16(segmentStartPos + 3);
                        segmentSize = dataSize + 5;
                        fieldName = IptcFieldMap[segmentType];
                        fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                        // Check if we already stored a value with this name
                        if (data.hasOwnProperty(fieldName)) {
                            // Value already stored with this name, create multivalue field
                            if (data[fieldName] instanceof Array) {
                                data[fieldName].push(fieldValue);
                            } else {
                                data[fieldName] = [data[fieldName], fieldValue];
                            }
                        } else {
                            data[fieldName] = fieldValue;
                        }
                    }
                }
                segmentStartPos++;
            }
            return data;
        }

        function readTags(file, tiffStart, dirStart, strings, bigEnd) {
            var entries = file.getUint16(dirStart, !bigEnd),
                tags = {},
                entryOffset,
                tag,
                i;

            for (i = 0; i < entries; i++) {
                entryOffset = dirStart + i * 12 + 2;
                tag = strings[file.getUint16(entryOffset, !bigEnd)];
                if (!tag && debug) {
                    console.log('Unknown tag: ' + file.getUint16(entryOffset, !bigEnd));
                }
                tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
            }
            return tags;
        }

        function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
            var type = file.getUint16(entryOffset + 2, !bigEnd),
                numValues = file.getUint32(entryOffset + 4, !bigEnd),
                valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart,
                offset,
                vals,
                val,
                n,
                numerator,
                denominator;

            switch (type) {
                case 1: // byte, 8-bit unsigned int
                case 7:
                    // undefined, 8-bit byte, value depending on field
                    if (numValues === 1) {
                        return file.getUint8(entryOffset + 8, !bigEnd);
                    }
                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;

                case 2:
                    // ascii, 8-bit byte
                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
                    return getStringFromDB(file, offset, numValues - 1);

                case 3:
                    // short, 16 bit int
                    if (numValues === 1) {
                        return file.getUint16(entryOffset + 8, !bigEnd);
                    }
                    offset = numValues > 2 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
                    }
                    return vals;

                case 4:
                    // long, 32 bit int
                    if (numValues === 1) {
                        return file.getUint32(entryOffset + 8, !bigEnd);
                    }
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;

                case 5:
                    // rational = two long values, first is numerator, second is denominator
                    if (numValues === 1) {
                        numerator = file.getUint32(valueOffset, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4, !bigEnd);
                        val = {}; //@TODO need to inspect if this fix is really working
                        val.numerator = numerator;
                        val.denominator = denominator;
                        return val;
                    }
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
                        vals[n] = {}; //@TODO need to inspect if this fix is really working
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;

                case 9:
                    // slong, 32 bit signed int
                    if (numValues === 1) {
                        return file.getInt32(entryOffset + 8, !bigEnd);
                    }
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;

                case 10:
                    // signed rational, two slongs, first is numerator, second is denominator
                    if (numValues === 1) {
                        return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
                    }
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
                    }
                    return vals;
            }
        }

        function getStringFromDB(buffer, start, length) {
            var outstr = '';
            for (var n = start; n < start + length; n++) {
                outstr += String.fromCharCode(buffer.getUint8(n));
            }
            return outstr;
        }

        function readEXIFData(file, start) {
            if (getStringFromDB(file, start, 4) !== 'Exif') {
                if (debug) {
                    console.log('Not valid EXIF data! ' + getStringFromDB(file, start, 4));
                }
                return false;
            }

            var bigEnd,
                tags,
                tag,
                exifData,
                gpsData,
                tiffOffset = start + 6;

            // test for TIFF validity and endianness
            if (file.getUint16(tiffOffset) === 0x4949) {
                bigEnd = false;
            } else if (file.getUint16(tiffOffset) === 0x4D4D) {
                bigEnd = true;
            } else {
                if (debug) {
                    console.log('Not valid TIFF data! (no 0x4949 or 0x4D4D)');
                }
                return false;
            }

            if (file.getUint16(tiffOffset + 2, !bigEnd) !== 0x002A) {
                if (debug) {
                    console.log('Not valid TIFF data! (no 0x002A)');
                }
                return false;
            }

            var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);

            if (firstIFDOffset < 0x00000008) {
                if (debug) {
                    console.log('Not valid TIFF data! (First offset less than 8)', file.getUint32(tiffOffset + 4, !bigEnd));
                }
                return false;
            }

            tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

            if (tags.ExifIFDPointer) {
                exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
                for (tag in exifData) {
                    switch (tag) {
                        case 'LightSource':
                        case 'Flash':
                        case 'MeteringMode':
                        case 'ExposureProgram':
                        case 'SensingMethod':
                        case 'SceneCaptureType':
                        case 'SceneType':
                        case 'CustomRendered':
                        case 'WhiteBalance':
                        case 'GainControl':
                        case 'Contrast':
                        case 'Saturation':
                        case 'Sharpness':
                        case 'SubjectDistanceRange':
                        case 'FileSource':
                            exifData[tag] = StringValues[tag][exifData[tag]];
                            break;

                        case 'ExifVersion':
                        case 'FlashpixVersion':
                            exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                            break;

                        case 'ComponentsConfiguration':
                            exifData[tag] = StringValues.Components[exifData[tag][0]] + StringValues.Components[exifData[tag][1]] + StringValues.Components[exifData[tag][2]] + StringValues.Components[exifData[tag][3]];
                            break;
                    }
                    tags[tag] = exifData[tag];
                }
            }

            if (tags.GPSInfoIFDPointer) {
                gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
                for (tag in gpsData) {
                    switch (tag) {
                        case 'GPSVersionID':
                            gpsData[tag] = gpsData[tag][0] + '.' + gpsData[tag][1] + '.' + gpsData[tag][2] + '.' + gpsData[tag][3];
                            break;
                    }
                    tags[tag] = gpsData[tag];
                }
            }

            return tags;
        }

        this.getData = function (img, callback) {
            if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) {
                return false;
            }

            if (!imageHasData(img)) {
                getImageData(img, callback);
            } else {
                if (callback) {
                    callback.call(img);
                }
            }
            return true;
        };

        this.getTag = function (img, tag) {
            if (!imageHasData(img)) {
                return;
            }
            return img.exifdata[tag];
        };

        this.getAllTags = function (img) {
            if (!imageHasData(img)) {
                return {};
            }
            var a,
                data = img.exifdata,
                tags = {};
            for (a in data) {
                if (data.hasOwnProperty(a)) {
                    tags[a] = data[a];
                }
            }
            return tags;
        };

        this.pretty = function (img) {
            if (!imageHasData(img)) {
                return '';
            }
            var a,
                data = img.exifdata,
                strPretty = '';
            for (a in data) {
                if (data.hasOwnProperty(a)) {
                    if (_typeof(data[a]) === 'object') {
                        if (data[a] instanceof Number) {
                            strPretty += a + ' : ' + data[a] + ' [' + data[a].numerator + '/' + data[a].denominator + ']\r\n';
                        } else {
                            strPretty += a + ' : [' + data[a].length + ' values]\r\n';
                        }
                    } else {
                        strPretty += a + ' : ' + data[a] + '\r\n';
                    }
                }
            }
            return strPretty;
        };

        this.readFromBinaryFile = function (file) {
            return findEXIFinJPEG(file);
        };
    }]);

    angular.module('uiCropper').factory('cropHost', ['$document', '$q', 'cropAreaCircle', 'cropAreaSquare', 'cropAreaRectangle', 'cropEXIF', function ($document, $q, CropAreaCircle, CropAreaSquare, CropAreaRectangle, cropEXIF) {
        /* STATIC FUNCTIONS */
        var colorPaletteLength = 8;

        // Get Element's Offset
        var getElementOffset = function getElementOffset(elem) {
            var box = elem.getBoundingClientRect();

            var body = document.body;
            var docElem = document.documentElement;

            var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;

            var clientTop = docElem.clientTop || body.clientTop || 0;
            var clientLeft = docElem.clientLeft || body.clientLeft || 0;

            var top = box.top + scrollTop - clientTop;
            var left = box.left + scrollLeft - clientLeft;

            return {
                top: Math.round(top),
                left: Math.round(left)
            };
        };

        return function (elCanvas, opts, events) {
            /* PRIVATE VARIABLES */

            // Object Pointers
            var ctx = null,
                image = null,
                theArea = null,
                initMax = null,
                isAspectRatio = null,
                self = this,


            // Dimensions
            minCanvasDims = [100, 100],
                maxCanvasDims = [300, 300],
                scalemode = null,


            // Result Image size
            resImgSizeArray = [],
                resImgSize = {
                w: 200,
                h: 200
            },
                areaMinRelativeSize = null,


            // Result Image type
            resImgFormat = 'image/png',


            // Result Image quality
            resImgQuality = null,
                forceAspectRatio = false;

            /* PRIVATE FUNCTIONS */
            this.setInitMax = function (bool) {
                initMax = bool;
            };
            this.setAllowCropResizeOnCorners = function (bool) {
                theArea.setAllowCropResizeOnCorners(bool);
            };
            // Draw Scene
            function drawScene() {
                // clear canvas
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

                if (image !== null) {
                    // draw source image
                    ctx.drawImage(image, 0, 0, ctx.canvas.width, ctx.canvas.height);

                    ctx.save();

                    // and make it darker
                    ctx.fillStyle = 'rgba(0, 0, 0, 0.65)';
                    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

                    ctx.restore();

                    // draw Area
                    theArea.draw();
                }
            }

            // Resets CropHost
            var resetCropHost = function resetCropHost() {
                if (image !== null) {
                    theArea.setImage(image);
                    var imageDims = [image.width, image.height],
                        imageRatio = image.width / image.height,
                        canvasDims = imageDims;

                    if (canvasDims[0] > maxCanvasDims[0]) {
                        canvasDims[0] = maxCanvasDims[0];
                        canvasDims[1] = canvasDims[0] / imageRatio;
                    } else if (canvasDims[0] < minCanvasDims[0]) {
                        canvasDims[0] = minCanvasDims[0];
                        canvasDims[1] = canvasDims[0] / imageRatio;
                    }
                    if (scalemode === 'fixed-height' && canvasDims[1] > maxCanvasDims[1]) {
                        canvasDims[1] = maxCanvasDims[1];
                        canvasDims[0] = canvasDims[1] * imageRatio;
                    } else if (canvasDims[1] < minCanvasDims[1]) {
                        canvasDims[1] = minCanvasDims[1];
                        canvasDims[0] = canvasDims[1] * imageRatio;
                    }
                    elCanvas.prop('width', canvasDims[0]).prop('height', canvasDims[1]);
                    if (scalemode === 'fixed-height') {
                        elCanvas.css({
                            'margin-left': -canvasDims[0] / 2 + 'px',
                            'margin-top': -canvasDims[1] / 2 + 'px'
                        });
                    }

                    var cw = ctx.canvas.width;
                    var ch = ctx.canvas.height;

                    var areaType = self.getAreaType();
                    // enforce 1:1 aspect ratio for square-like selections
                    if (areaType === 'circle' || areaType === 'square') {
                        if (ch < cw) {
                            cw = ch;
                        }
                        ch = cw;
                    } else if (areaType === 'rectangle' && isAspectRatio) {
                        var aspectRatio = theArea.getAspect(); // use `aspectRatio` instead of `resImgSize` dimensions bc `resImgSize` can be 'selection' string
                        if (cw / ch > aspectRatio) {
                            cw = aspectRatio * ch;
                        } else {
                            ch = aspectRatio * cw;
                        }
                    }

                    if (initMax) {
                        theArea.setSize({
                            w: cw,
                            h: ch
                        });
                    } else if (undefined !== theArea.getInitSize()) {
                        theArea.setSize({
                            w: Math.min(theArea.getInitSize().w, cw / 2),
                            h: Math.min(theArea.getInitSize().h, ch / 2)
                        });
                    } else {
                        theArea.setSize({
                            w: Math.min(200, cw / 2),
                            h: Math.min(200, ch / 2)
                        });
                    }

                    if (theArea.getInitCoords()) {
                        if (self.areaInitIsRelativeToImage) {
                            var ratio = image.width / canvasDims[0];
                            theArea.setSize({
                                w: theArea.getInitSize().w / ratio,
                                h: theArea.getInitSize().h / ratio,
                                x: theArea.getInitCoords().x / ratio,
                                y: theArea.getInitCoords().y / ratio
                            });
                        } else {
                            theArea.setSize({
                                w: theArea.getSize().w,
                                h: theArea.getSize().h,
                                x: theArea.getInitCoords().x,
                                y: theArea.getInitCoords().y
                            });
                        }
                    } else {
                        theArea.setCenterPoint({
                            x: ctx.canvas.width / 2,
                            y: ctx.canvas.height / 2
                        });
                    }
                } else {
                    elCanvas.prop('width', 0).prop('height', 0).css({
                        'margin-top': 0
                    });
                }

                drawScene();
            };

            var getChangedTouches = function getChangedTouches(event) {
                if (angular.isDefined(event.changedTouches)) {
                    return event.changedTouches;
                } else {
                    return event.originalEvent.changedTouches;
                }
            };

            var onMouseMove = function onMouseMove(e) {
                if (image !== null) {
                    var offset = getElementOffset(ctx.canvas),
                        pageX,
                        pageY;
                    if (e.type === 'touchmove') {
                        pageX = getChangedTouches(e)[0].pageX;
                        pageY = getChangedTouches(e)[0].pageY;
                    } else {
                        pageX = e.pageX;
                        pageY = e.pageY;
                    }
                    theArea.processMouseMove(pageX - offset.left, pageY - offset.top);
                    drawScene();
                }
            };

            var onMouseDown = function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
                if (image !== null) {
                    var offset = getElementOffset(ctx.canvas),
                        pageX,
                        pageY;
                    if (e.type === 'touchstart') {
                        pageX = getChangedTouches(e)[0].pageX;
                        pageY = getChangedTouches(e)[0].pageY;
                    } else {
                        pageX = e.pageX;
                        pageY = e.pageY;
                    }
                    theArea.processMouseDown(pageX - offset.left, pageY - offset.top);
                    drawScene();
                }
            };

            var onMouseUp = function onMouseUp(e) {
                if (image !== null) {
                    var offset = getElementOffset(ctx.canvas),
                        pageX,
                        pageY;
                    if (e.type === 'touchend') {
                        pageX = getChangedTouches(e)[0].pageX;
                        pageY = getChangedTouches(e)[0].pageY;
                    } else {
                        pageX = e.pageX;
                        pageY = e.pageY;
                    }
                    theArea.processMouseUp(pageX - offset.left, pageY - offset.top);
                    drawScene();
                }
            };

            var renderTempCanvas = function renderTempCanvas(ris, center) {
                var temp_ctx, temp_canvas;
                temp_canvas = angular.element('<canvas></canvas>')[0];
                temp_ctx = temp_canvas.getContext('2d');
                temp_canvas.width = ris.w;
                temp_canvas.height = ris.h;
                if (image !== null) {
                    var x = (center.x - theArea.getSize().w / 2) * (image.width / ctx.canvas.width),
                        y = (center.y - theArea.getSize().h / 2) * (image.height / ctx.canvas.height),
                        areaWidth = theArea.getSize().w * (image.width / ctx.canvas.width),
                        areaHeight = theArea.getSize().h * (image.height / ctx.canvas.height);

                    if (forceAspectRatio) {
                        temp_ctx.drawImage(image, x, y, areaWidth, areaHeight, 0, 0, ris.w, ris.h);
                    } else {
                        var aspectRatio = areaWidth / areaHeight;
                        var resultHeight, resultWidth;

                        if (aspectRatio > 1) {
                            resultWidth = ris.w;
                            resultHeight = resultWidth / aspectRatio;
                        } else {
                            resultHeight = ris.h;
                            resultWidth = resultHeight * aspectRatio;
                        }

                        temp_canvas.width = resultWidth;
                        temp_canvas.height = resultHeight;

                        temp_ctx.drawImage(image, x, y, areaWidth, areaHeight, 0, 0, Math.round(resultWidth), Math.round(resultHeight));
                    }
                }
                return temp_canvas;
            };

            var renderImageToDataURL = function renderImageToDataURL(getResultImageSize) {
                var temp_canvas,
                    retObj = {
                    dataURI: null,
                    imageData: null
                };
                temp_canvas = renderTempCanvas(getResultImageSize, theArea.getCenterPoint());
                if (image !== null) {
                    if (resImgQuality !== null) {
                        retObj.dataURI = temp_canvas.toDataURL(resImgFormat, resImgQuality);
                    } else {
                        retObj.dataURI = temp_canvas.toDataURL(resImgFormat);
                    }
                }
                return retObj;
            };

            this.getResultImage = function () {
                if (resImgSizeArray.length === 0) {
                    return renderImageToDataURL(this.getResultImageSize());
                }

                var arrayResultImages = [];
                for (var i = 0; i < resImgSizeArray.length; i++) {
                    arrayResultImages.push({
                        dataURI: renderImageToDataURL(resImgSizeArray[i]).dataURI,
                        w: resImgSizeArray[i].w,
                        h: resImgSizeArray[i].h
                    });
                }

                return arrayResultImages;
            };

            this.getResultImageDataBlob = function () {
                var temp_canvas,
                    _p = $q.defer();
                temp_canvas = renderTempCanvas(this.getResultImageSize(), theArea.getCenterPoint());
                if (resImgQuality !== null) {
                    temp_canvas.toBlob(function (blob) {
                        _p.resolve(blob);
                    }, resImgFormat, resImgQuality);
                } else {
                    temp_canvas.toBlob(function (blob) {
                        _p.resolve(blob);
                    }, resImgFormat);
                }

                return _p.promise;
            };

            this.getAreaCoords = function () {
                return theArea.getSize();
            };

            this.getArea = function () {
                return theArea;
            };

            this.setNewImageSource = function (imageSource) {
                image = null;
                resetCropHost();
                if (imageSource) {
                    var newImage = new Image();
                    newImage.onload = function () {
                        events.trigger('load-done');

                        cropEXIF.getData(newImage, function () {
                            var orientation = cropEXIF.getTag(newImage, 'Orientation');

                            if ([3, 6, 8].indexOf(orientation) > -1) {
                                var canvas = document.createElement('canvas'),
                                    ctx = canvas.getContext('2d'),
                                    cw = newImage.width,
                                    ch = newImage.height,
                                    cx = 0,
                                    cy = 0,
                                    deg = 0,
                                    rw = 0,
                                    rh = 0;
                                rw = cw;
                                rh = ch;
                                switch (orientation) {
                                    case 3:
                                        cx = -newImage.width;
                                        cy = -newImage.height;
                                        deg = 180;
                                        break;
                                    case 6:
                                        cw = newImage.height;
                                        ch = newImage.width;
                                        cy = -newImage.height;
                                        rw = ch;
                                        rh = cw;
                                        deg = 90;
                                        break;
                                    case 8:
                                        cw = newImage.height;
                                        ch = newImage.width;
                                        cx = -newImage.width;
                                        rw = ch;
                                        rh = cw;
                                        deg = 270;
                                        break;
                                }

                                //// canvas.toDataURL will only work if the canvas isn't too large. Resize to 1000px.
                                var maxWorH = 1000;
                                if (cw > maxWorH || ch > maxWorH) {
                                    var p = 0;
                                    if (cw > maxWorH) {
                                        p = maxWorH / cw;
                                        cw = maxWorH;
                                        ch = p * ch;
                                    } else if (ch > maxWorH) {
                                        p = maxWorH / ch;
                                        ch = maxWorH;
                                        cw = p * cw;
                                    }

                                    cy = p * cy;
                                    cx = p * cx;
                                    rw = p * rw;
                                    rh = p * rh;
                                }

                                canvas.width = cw;
                                canvas.height = ch;
                                ctx.rotate(deg * Math.PI / 180);
                                ctx.drawImage(newImage, cx, cy, rw, rh);

                                image = new Image();
                                image.onload = function () {
                                    resetCropHost();
                                    events.trigger('image-updated');
                                };

                                image.src = canvas.toDataURL(resImgFormat);
                            } else {
                                image = newImage;
                                events.trigger('image-updated');
                            }
                            resetCropHost();
                        });
                    };
                    newImage.onerror = function () {
                        events.trigger('load-error');
                    };
                    events.trigger('load-start');
                    if (imageSource instanceof window.Blob) {
                        newImage.src = URL.createObjectURL(imageSource);
                    } else {
                        if (imageSource.substring(0, 4).toLowerCase() === 'http' || imageSource.substring(0, 2) === '//') {
                            newImage.crossOrigin = 'anonymous';
                        }
                        newImage.src = imageSource;
                    }
                }
            };

            this.setMaxDimensions = function (width, height) {
                maxCanvasDims = [width, height];

                if (image !== null) {
                    var curWidth = ctx.canvas.width,
                        curHeight = ctx.canvas.height;

                    var imageDims = [image.width, image.height],
                        imageRatio = image.width / image.height,
                        canvasDims = imageDims;

                    if (canvasDims[0] > maxCanvasDims[0]) {
                        canvasDims[0] = maxCanvasDims[0];
                        canvasDims[1] = canvasDims[0] / imageRatio;
                    } else if (canvasDims[0] < minCanvasDims[0]) {
                        canvasDims[0] = minCanvasDims[0];
                        canvasDims[1] = canvasDims[0] / imageRatio;
                    }
                    if (scalemode === 'fixed-height' && canvasDims[1] > maxCanvasDims[1]) {
                        canvasDims[1] = maxCanvasDims[1];
                        canvasDims[0] = canvasDims[1] * imageRatio;
                    } else if (canvasDims[1] < minCanvasDims[1]) {
                        canvasDims[1] = minCanvasDims[1];
                        canvasDims[0] = canvasDims[1] * imageRatio;
                    }
                    elCanvas.prop('width', canvasDims[0]).prop('height', canvasDims[1]);

                    if (scalemode === 'fixed-height') {
                        elCanvas.css({
                            'margin-left': -canvasDims[0] / 2 + 'px',
                            'margin-top': -canvasDims[1] / 2 + 'px'
                        });
                    }

                    var ratioNewCurWidth = ctx.canvas.width / curWidth,
                        ratioNewCurHeight = ctx.canvas.height / curHeight,
                        ratioMin = Math.min(ratioNewCurWidth, ratioNewCurHeight);

                    //TODO: use top left corner point
                    var center = theArea.getCenterPoint();
                    theArea.setSize({
                        w: theArea.getSize().w * ratioMin,
                        h: theArea.getSize().h * ratioMin
                    });
                    theArea.setCenterPoint({
                        x: center.x * ratioNewCurWidth,
                        y: center.y * ratioNewCurHeight
                    });
                } else {
                    elCanvas.prop('width', 0).prop('height', 0).css({
                        'margin-top': 0
                    });
                }

                drawScene();
            };

            this.setAreaMinSize = function (size) {
                if (angular.isUndefined(size)) {
                    return;
                } else if (typeof size === 'number' || typeof size === 'string') {
                    size = {
                        w: parseInt(parseInt(size), 10),
                        h: parseInt(parseInt(size), 10)
                    };
                } else {
                    size = {
                        w: parseInt(size.w, 10),
                        h: parseInt(size.h, 10)
                    };
                }
                if (!isNaN(size.w) && !isNaN(size.h)) {
                    theArea.setMinSize(size);
                    drawScene();
                }
            };

            this.setAreaMinRelativeSize = function (size) {
                if (image === null || angular.isUndefined(size)) {
                    return;
                }

                var canvasSize = theArea.getCanvasSize();

                if (typeof size === 'number' || typeof size === 'string') {
                    areaMinRelativeSize = {
                        w: size,
                        h: size
                    };
                    size = {
                        w: canvasSize.w / (image.width / parseInt(parseInt(size), 10)),
                        h: canvasSize.h / (image.height / parseInt(parseInt(size), 10))
                    };
                } else {
                    areaMinRelativeSize = size;
                    size = {
                        w: canvasSize.w / (image.width / parseInt(parseInt(size.w), 10)),
                        h: canvasSize.h / (image.height / parseInt(parseInt(size.h), 10))
                    };
                }

                if (!isNaN(size.w) && !isNaN(size.h)) {
                    theArea.setMinSize(size);
                    drawScene();
                }
            };

            this.setAreaInitSize = function (size) {
                if (angular.isUndefined(size)) {
                    return;
                } else if (typeof size === 'number' || typeof size === 'string') {
                    size = {
                        w: parseInt(parseInt(size), 10),
                        h: parseInt(parseInt(size), 10)
                    };
                } else {
                    size = {
                        w: parseInt(size.w, 10),
                        h: parseInt(size.h, 10)
                    };
                }
                if (!isNaN(size.w) && !isNaN(size.h)) {
                    theArea.setInitSize(size);
                    drawScene();
                }
            };

            this.setAreaInitCoords = function (coords) {
                if (angular.isUndefined(coords)) {
                    return;
                } else {
                    coords = {
                        x: parseInt(coords.x, 10),
                        y: parseInt(coords.y, 10)
                    };
                }
                if (!isNaN(coords.x) && !isNaN(coords.y)) {
                    theArea.setInitCoords(coords);
                    drawScene();
                }
            };

            this.setMaxCanvasDimensions = function (maxCanvasDimensions) {
                if (!angular.isUndefined(maxCanvasDimensions)) {
                    var newMaxCanvasDims = [];
                    if (typeof maxCanvasDimensions === 'number' || typeof maxCanvasDimensions === 'string') {
                        newMaxCanvasDims = [parseInt(parseInt(maxCanvasDimensions), 10), parseInt(parseInt(maxCanvasDimensions), 10)];
                    } else {
                        newMaxCanvasDims = [parseInt(maxCanvasDimensions.w, 10), parseInt(maxCanvasDimensions.h, 10)];
                    }
                    if (!isNaN(newMaxCanvasDims[0]) && newMaxCanvasDims[0] > 0 && newMaxCanvasDims[0] > minCanvasDims[0] && !isNaN(newMaxCanvasDims[1]) && newMaxCanvasDims[1] > 0 && newMaxCanvasDims[1] > minCanvasDims[1]) {
                        maxCanvasDims = newMaxCanvasDims;
                    }
                }
            };

            this.setMinCanvasDimensions = function (minCanvasDimensions) {
                if (!angular.isUndefined(minCanvasDimensions)) {
                    var newMinCanvasDims = [];
                    if (typeof minCanvasDimensions === 'number' || typeof minCanvasDimensions === 'string') {
                        newMinCanvasDims = [parseInt(parseInt(minCanvasDimensions), 10), parseInt(parseInt(minCanvasDimensions), 10)];
                    } else {
                        newMinCanvasDims = [parseInt(minCanvasDimensions.w, 10), parseInt(minCanvasDimensions.h, 10)];
                    }
                    if (!isNaN(newMinCanvasDims[0]) && newMinCanvasDims[0] >= 0 && !isNaN(newMinCanvasDims[1]) && newMinCanvasDims[1] >= 0) {
                        minCanvasDims = newMinCanvasDims;
                    }
                }
            };

            this.setScalemode = function (value) {
                scalemode = value;
            };

            this.getScalemode = function () {
                return scalemode;
            };

            this.getResultImageSize = function () {
                if (resImgSize === 'selection') {
                    return theArea.getSize();
                }

                if (resImgSize === 'max') {
                    // We maximize the rendered size
                    var zoom = 1;
                    if (image && ctx && ctx.canvas) {
                        zoom = image.width / ctx.canvas.width;
                    }
                    var size = {
                        w: zoom * theArea.getSize().w,
                        h: zoom * theArea.getSize().h
                    };

                    if (areaMinRelativeSize) {
                        if (size.w < areaMinRelativeSize.w) {
                            size.w = areaMinRelativeSize.w;
                        }
                        if (size.h < areaMinRelativeSize.h) {
                            size.h = areaMinRelativeSize.h;
                        }
                    }

                    return size;
                }

                return resImgSize;
            };

            this.setResultImageSize = function (size) {
                if (angular.isArray(size)) {
                    resImgSizeArray = size.slice();
                    size = {
                        w: parseInt(size[0].w, 10),
                        h: parseInt(size[0].h, 10)
                    };
                    return;
                }
                if (angular.isUndefined(size)) {
                    return;
                }
                //allow setting of size to "selection" for mirroring selection's dimensions
                if (angular.isString(size)) {
                    resImgSize = size;
                    return;
                }
                //allow scalar values for square-like selection shapes
                if (angular.isNumber(size)) {
                    size = parseInt(size, 10);
                    size = {
                        w: size,
                        h: size
                    };
                }
                size = {
                    w: parseInt(size.w, 10),
                    h: parseInt(size.h, 10)
                };
                if (!isNaN(size.w) && !isNaN(size.h)) {
                    resImgSize = size;
                    drawScene();
                }
            };

            this.setResultImageFormat = function (format) {
                resImgFormat = format;
            };

            this.setResultImageQuality = function (quality) {
                quality = parseFloat(quality);
                if (!isNaN(quality) && quality >= 0 && quality <= 1) {
                    resImgQuality = quality;
                }
            };

            // returns a string of the selection area's type
            this.getAreaType = function () {
                return theArea.getType();
            };

            this.setAreaType = function (type) {
                var center = theArea.getCenterPoint();
                var curSize = theArea.getSize(),
                    curMinSize = theArea.getMinSize(),
                    curX = center.x,
                    curY = center.y;

                var AreaClass = CropAreaCircle;
                if (type === 'square') {
                    AreaClass = CropAreaSquare;
                } else if (type === 'rectangle') {
                    AreaClass = CropAreaRectangle;
                }
                theArea = new AreaClass(ctx, events);
                theArea.setMinSize(curMinSize);
                theArea.setSize(curSize);
                if (type === 'square' || type === 'circle') {
                    forceAspectRatio = true;
                    theArea.setForceAspectRatio(true);
                } else {
                    forceAspectRatio = false;
                    theArea.setForceAspectRatio(false);
                }

                //TODO: use top left point
                theArea.setCenterPoint({
                    x: curX,
                    y: curY
                });

                // resetCropHost();
                if (image !== null) {
                    theArea.setImage(image);
                }

                drawScene();
            };

            this.getDominantColor = function (uri) {
                var imageDC = new Image(),
                    colorThief = new ColorThief(),
                    dominantColor = null,
                    _p = $q.defer();
                imageDC.src = uri;
                imageDC.onload = function () {
                    dominantColor = colorThief.getColor(imageDC);
                    _p.resolve(dominantColor);
                };

                return _p.promise;
            };

            this.getPalette = function (uri) {
                var imageDC = new Image(),
                    colorThief = new ColorThief(),
                    palette = null,
                    _p = $q.defer();
                imageDC.src = uri;
                imageDC.onload = function () {
                    palette = colorThief.getPalette(imageDC, colorPaletteLength);
                    _p.resolve(palette);
                };

                return _p.promise;
            };

            this.setPaletteColorLength = function (lg) {
                colorPaletteLength = lg;
            };

            this.setAspect = function (aspect) {
                isAspectRatio = true;
                theArea.setAspect(aspect);
                var minSize = theArea.getMinSize();
                minSize.w = minSize.h * aspect;
                theArea.setMinSize(minSize);
                var size = theArea.getSize();
                size.w = size.h * aspect;
                theArea.setSize(size);
            };

            /* Life Cycle begins */

            // Init Context var
            ctx = elCanvas[0].getContext('2d');

            // Init CropArea
            theArea = new CropAreaCircle(ctx, events);

            // Init Mouse Event Listeners
            $document.on('mousemove', onMouseMove);
            elCanvas.on('mousedown', onMouseDown);
            $document.on('mouseup', onMouseUp);

            // Init Touch Event Listeners
            $document.on('touchmove', onMouseMove);
            elCanvas.on('touchstart', onMouseDown);
            $document.on('touchend', onMouseUp);

            // CropHost Destructor
            this.destroy = function () {
                $document.off('mousemove', onMouseMove);
                elCanvas.off('mousedown', onMouseDown);
                $document.off('mouseup', onMouseUp);

                $document.off('touchmove', onMouseMove);
                elCanvas.off('touchstart', onMouseDown);
                $document.off('touchend', onMouseUp);

                elCanvas.remove();
            };
        };
    }]);

    angular.module('uiCropper').factory('cropPubSub', [function () {
        return function () {
            var events = {};
            // Subscribe
            this.on = function (names, handler) {
                names.split(' ').forEach(function (name) {
                    if (!events[name]) {
                        events[name] = [];
                    }
                    events[name].push(handler);
                });
                return this;
            };
            // Publish
            this.trigger = function (name, args) {
                angular.forEach(events[name], function (handler) {
                    handler.call(null, args);
                });
                return this;
            };
        };
    }]);

    angular.module('uiCropper').directive('uiCropper', ['$timeout', 'cropHost', 'cropPubSub', function ($timeout, CropHost, CropPubSub) {
        return {
            restrict: 'E',
            scope: {
                image: '=',
                resultImage: '=',
                resultArrayImage: '=?',
                resultBlob: '=?',
                urlBlob: '=?',
                chargement: '=?',
                cropject: '=?',
                maxCanvasDimensions: '=?',
                minCanvasDimensions: '=?',
                canvasScalemode: '@?', /* String. If set to 'full-width' the directive uses all width available */
                /* and the canvas expands in height as much as it need to maintain the aspect ratio */
                /* if set to 'fixed-height', the directive is restricted by a parent element in height */

                changeOnFly: '=?',
                liveView: '=?',
                initMaxArea: '=?',
                areaCoords: '=?',
                areaType: '@',
                areaMinSize: '=?',
                areaInitSize: '=?',
                areaInitCoords: '=?',
                areaInitIsRelativeToImage: '=?', /* Boolean: If true the areaInitCoords and areaInitSize is scaled according to canvas size. */
                /* No matter how big/small the canvas is, the resultImage remains the same */
                /* Example: areaInitCoords are {x: 100, y: 100}, areaInitSize {w: 100, h: 100}   */
                /* Image is 1000x1000
                 /* if canvas is 500x500 Crop coordinates will be x: 50, y: 50, w: 50, h: 50 */
                /* if canvas is 100x100 crop coordinates will be x: 10, y: 10, w: 10, h: 10 */
                areaMinRelativeSize: '=?',
                resultImageSize: '=?',
                resultImageFormat: '@',
                resultImageQuality: '=?',

                aspectRatio: '=?',
                allowCropResizeOnCorners: '=?',

                dominantColor: '=?',
                paletteColor: '=?',
                paletteColorLength: '=?',

                onChange: '&',
                onLoadBegin: '&',
                onLoadDone: '&',
                onLoadError: '&'
            },
            template: '<canvas></canvas>',
            controller: ['$scope', function ($scope) {
                $scope.events = new CropPubSub();
            }],
            link: function link(scope, element) {
                // Init Events Manager
                var events = scope.events;

                // Init Crop Host
                var cropHost = new CropHost(element.find('canvas'), {}, events);

                if (scope.canvasScalemode) {
                    cropHost.setScalemode(scope.canvasScalemode);
                } else {
                    cropHost.setScalemode('fixed-height');
                }

                element.addClass(cropHost.getScalemode());

                // Store Result Image to check if it's changed
                var storedResultImage;

                var updateAreaCoords = function updateAreaCoords(scope) {
                    scope.areaCoords = cropHost.getAreaCoords();
                };

                var updateResultImage = function updateResultImage(scope, force, callback) {
                    if (scope.image !== '' && (!scope.liveView.block || force)) {
                        var resultImageObj = cropHost.getResultImage();
                        var resultImage;
                        if (angular.isArray(resultImageObj)) {
                            resultImage = resultImageObj[0].dataURI;
                            scope.resultArrayImage = resultImageObj;
                        } else {
                            resultImage = resultImageObj.dataURI;
                        }

                        var urlCreator = window.URL || window.webkitURL;
                        if (storedResultImage !== resultImage) {
                            storedResultImage = resultImage;
                            scope.resultImage = resultImage;
                            if (scope.liveView.callback) {
                                scope.liveView.callback(resultImage);
                            }
                            if (callback) {
                                callback(resultImage);
                            }
                            cropHost.getResultImageDataBlob().then(function (blob) {
                                scope.resultBlob = blob;
                                scope.urlBlob = urlCreator.createObjectURL(blob);
                            });

                            if (scope.resultImage) {
                                cropHost.getDominantColor(scope.resultImage).then(function (dominantColor) {
                                    scope.dominantColor = dominantColor;
                                });
                                cropHost.getPalette(scope.resultImage).then(function (palette) {
                                    scope.paletteColor = palette;
                                });
                            }

                            updateAreaCoords(scope);
                            scope.onChange({
                                $dataURI: scope.resultImage
                            });
                        }
                    }
                };

                if (scope.liveView && typeof scope.liveView.block === 'boolean') {
                    scope.liveView.render = function (callback) {
                        updateResultImage(scope, true, callback);
                    };
                } else {
                    scope.liveView = { block: false };
                }

                var updateCropject = function updateCropject(scope) {
                    var areaCoords = cropHost.getAreaCoords();

                    var dimRatio = {
                        x: cropHost.getArea().getImage().width / cropHost.getArea().getCanvasSize().w,
                        y: cropHost.getArea().getImage().height / cropHost.getArea().getCanvasSize().h
                    };

                    scope.cropject = {
                        canvasSize: cropHost.getArea().getCanvasSize(),
                        areaCoords: areaCoords,
                        cropWidth: areaCoords.w,
                        cropHeight: areaCoords.h,
                        cropTop: areaCoords.y,
                        cropLeft: areaCoords.x,
                        cropImageWidth: Math.round(areaCoords.w * dimRatio.x),
                        cropImageHeight: Math.round(areaCoords.h * dimRatio.y),
                        cropImageTop: Math.round(areaCoords.y * dimRatio.y),
                        cropImageLeft: Math.round(areaCoords.x * dimRatio.x)
                    };
                };

                // Wrapper to safely exec functions within $apply on a running $digest cycle
                var fnSafeApply = function fnSafeApply(fn) {
                    return function () {
                        $timeout(function () {
                            scope.$apply(function (scope) {
                                fn(scope);
                            });
                        });
                    };
                };

                // Will get the users language settings, and return the appropriate loading text
                var printLoadMsg = function printLoadMsg() {
                    var language = window.navigator.userLanguage || window.navigator.language;

                    switch (language) {
                        case 'nl':
                        case 'nl_NL':
                            return 'Aan het laden';

                        case 'fr':
                        case 'fr-FR':
                            return 'Chargement';

                        case 'es':
                        case 'es-ES':
                            return 'Cargando';

                        case 'ca':
                        case 'ca-ES':
                            return 'Càrrega';

                        case 'de':
                        case 'de-DE':
                            return 'Laden';

                        case 'pt':
                        case 'pt-BR':
                            return 'Carregando';

                        default:
                            return 'Loading';
                    }
                };

                if (!scope.chargement) {
                    scope.chargement = printLoadMsg();
                }
                var displayLoading = function displayLoading() {
                    element.append('<div class="loading"><span>' + scope.chargement + '...</span></div>');
                };

                // Setup CropHost Event Handlers
                events.on('load-start', fnSafeApply(function (scope) {
                    scope.onLoadBegin({});
                })).on('load-done', fnSafeApply(function (scope) {
                    var children = element.children();
                    angular.forEach(children, function (child) {
                        if (angular.element(child).hasClass('loading')) {
                            angular.element(child).remove();
                        }
                    });
                    updateCropject(scope);
                    scope.onLoadDone({});
                })).on('load-error', fnSafeApply(function (scope) {
                    scope.onLoadError({});
                })).on('area-move area-resize', fnSafeApply(function (scope) {
                    if (scope.changeOnFly === true) {
                        updateResultImage(scope);
                    }
                    updateCropject(scope);
                })).on('image-updated', fnSafeApply(function (scope) {
                    cropHost.setAreaMinRelativeSize(scope.areaMinRelativeSize);
                })).on('area-move-end area-resize-end image-updated', fnSafeApply(function (scope) {
                    updateResultImage(scope);
                    updateCropject(scope);
                }));

                // Sync CropHost with Directive's options
                scope.$watch('image', function (newVal) {
                    if (newVal) {
                        displayLoading();
                    }
                    // cancel timeout if necessary
                    if (scope.timeout !== null) {
                        $timeout.cancel(scope.timeout);
                    }
                    scope.timeout = $timeout(function () {
                        scope.timeout = null;
                        cropHost.setInitMax(scope.initMaxArea);
                        cropHost.setNewImageSource(scope.image);
                    }, 100);
                });
                scope.$watch('areaType', function () {
                    cropHost.setAreaType(scope.areaType);
                    updateResultImage(scope);
                });
                scope.$watch('areaMinSize', function () {
                    cropHost.setAreaMinSize(scope.areaMinSize);
                    updateResultImage(scope);
                });
                scope.$watch('areaMinRelativeSize', function () {
                    if (scope.image !== '') {
                        cropHost.setAreaMinRelativeSize(scope.areaMinRelativeSize);
                        updateResultImage(scope);
                    }
                });
                scope.$watch('areaInitSize', function () {
                    cropHost.setAreaInitSize(scope.areaInitSize);
                    updateResultImage(scope);
                });
                scope.$watch('areaInitCoords', function () {
                    cropHost.setAreaInitCoords(scope.areaInitCoords);
                    cropHost.areaInitIsRelativeToImage = scope.areaInitIsRelativeToImage;
                    updateResultImage(scope);
                });
                scope.$watch('maxCanvasDimensions', function () {
                    cropHost.setMaxCanvasDimensions(scope.maxCanvasDimensions);
                });
                scope.$watch('minCanvasDimensions', function () {
                    cropHost.setMinCanvasDimensions(scope.minCanvasDimensions);
                });
                scope.$watch('resultImageFormat', function () {
                    cropHost.setResultImageFormat(scope.resultImageFormat);
                    updateResultImage(scope);
                });
                scope.$watch('resultImageQuality', function () {
                    cropHost.setResultImageQuality(scope.resultImageQuality);
                    updateResultImage(scope);
                });
                scope.$watch('resultImageSize', function () {
                    cropHost.setResultImageSize(scope.resultImageSize);
                    updateResultImage(scope);
                });
                scope.$watch('paletteColorLength', function () {
                    cropHost.setPaletteColorLength(scope.paletteColorLength);
                });
                scope.$watch('aspectRatio', function () {
                    if (typeof scope.aspectRatio === 'string' && scope.aspectRatio !== '') {
                        scope.aspectRatio = parseInt(scope.aspectRatio);
                    }
                    if (scope.aspectRatio) {
                        cropHost.setAspect(scope.aspectRatio);
                    }
                });
                scope.$watch('allowCropResizeOnCorners', function () {
                    if (scope.allowCropResizeOnCorners) {
                        cropHost.setAllowCropResizeOnCorners(scope.allowCropResizeOnCorners);
                    }
                });

                // Update CropHost dimensions when the directive element is resized
                scope.$watch(function () {
                    if (cropHost.getScalemode() === 'fixed-height') {
                        return [element[0].clientWidth, element[0].clientHeight];
                    }
                    if (cropHost.getScalemode() === 'full-width') {
                        return element[0].clientWidth;
                    }
                }, function (value) {

                    if (cropHost.getScalemode() === 'fixed-height') {
                        if (value[0] > 0 && value[1] > 0) {
                            cropHost.setMaxDimensions(value[0], value[1]);
                            updateResultImage(scope);
                        }
                    }
                    if (cropHost.getScalemode() === 'full-width') {
                        if (value > 0) {
                            cropHost.setMaxDimensions(value);
                        }
                    }
                }, true);

                // Destroy CropHost Instance when the directive is destroying
                scope.$on('$destroy', function () {
                    cropHost.destroy();
                });
            }
        };
    }]);
})();

/* canvas-toBlob.js
 * A canvas.toBlob() implementation.
 * 2013-12-27
 * 
 * By Eli Grey, http://eligrey.com and Devin Samarin, https://github.com/eboyjr
 * License: X11/MIT
 *   See https://github.com/eligrey/canvas-toBlob.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
  plusplus: true */

/*! @source http://purl.eligrey.com/github/canvas-toBlob.js/blob/master/canvas-toBlob.js */

(function (view) {
    "use strict";

    var Uint8Array = view.Uint8Array,
        HTMLCanvasElement = view.HTMLCanvasElement,
        canvas_proto = HTMLCanvasElement && HTMLCanvasElement.prototype,
        is_base64_regex = /\s*;\s*base64\s*(?:;|$)/i,
        to_data_url = "toDataURL",
        base64_ranks,
        decode_base64 = function decode_base64(base64) {
        var len = base64.length,
            buffer = new Uint8Array(len / 4 * 3 | 0),
            i = 0,
            outptr = 0,
            last = [0, 0],
            state = 0,
            save = 0,
            rank,
            code,
            undef;
        while (len--) {
            code = base64.charCodeAt(i++);
            rank = base64_ranks[code - 43];
            if (rank !== 255 && rank !== undef) {
                last[1] = last[0];
                last[0] = code;
                save = save << 6 | rank;
                state++;
                if (state === 4) {
                    buffer[outptr++] = save >>> 16;
                    if (last[1] !== 61 /* padding character */) {
                            buffer[outptr++] = save >>> 8;
                        }
                    if (last[0] !== 61 /* padding character */) {
                            buffer[outptr++] = save;
                        }
                    state = 0;
                }
            }
        }
        // 2/3 chance there's going to be some null bytes at the end, but that
        // doesn't really matter with most image formats.
        // If it somehow matters for you, truncate the buffer up outptr.
        return buffer;
    };
    if (Uint8Array) {
        base64_ranks = new Uint8Array([62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, 0, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51]);
    }
    if (HTMLCanvasElement && !canvas_proto.toBlob) {
        canvas_proto.toBlob = function (callback, type /*, ...args*/) {
            if (!type) {
                type = "image/png";
            }
            if (this.mozGetAsFile) {
                callback(this.mozGetAsFile("canvas", type));
                return;
            }
            if (this.msToBlob && /^\s*image\/png\s*(?:$|;)/i.test(type)) {
                callback(this.msToBlob());
                return;
            }

            var args = Array.prototype.slice.call(arguments, 1),
                dataURI = this[to_data_url].apply(this, args),
                header_end = dataURI.indexOf(","),
                data = dataURI.substring(header_end + 1),
                is_base64 = is_base64_regex.test(dataURI.substring(0, header_end)),
                blob;
            if (Blob.fake) {
                // no reason to decode a data: URI that's just going to become a data URI again
                blob = new Blob();
                if (is_base64) {
                    blob.encoding = "base64";
                } else {
                    blob.encoding = "URI";
                }
                blob.data = data;
                blob.size = data.length;
            } else if (Uint8Array) {
                if (is_base64) {
                    blob = new Blob([decode_base64(data)], {
                        type: type
                    });
                } else {
                    blob = new Blob([decodeURIComponent(data)], {
                        type: type
                    });
                }
            }
            if (typeof callback !== 'undefined') {
                callback(blob);
            }
        };

        if (canvas_proto.toDataURLHD) {
            canvas_proto.toBlobHD = function () {
                to_data_url = "toDataURLHD";
                var blob = this.toBlob();
                to_data_url = "toDataURL";
                return blob;
            };
        } else {
            canvas_proto.toBlobHD = canvas_proto.toBlob;
        }
    }
})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content || undefined);

/*!
 * Color Thief v2.0
 * by Lokesh Dhakar - http://www.lokeshdhakar.com
 *
 * Thanks
 * ------
 * Nick Rabinowitz - For creating quantize.js.
 * John Schulz - For clean up and optimization. @JFSIII
 * Nathan Spady - For adding drag and drop support to the demo page.
 *
 * License
 * -------
 * Copyright 2011, 2015 Lokesh Dhakar
 * Released under the MIT license
 * https://raw.githubusercontent.com/lokesh/color-thief/master/LICENSE
 *
 */
(function () {
    /*!
     * Color Thief v2.0
     * by Lokesh Dhakar - http://www.lokeshdhakar.com
     *
     * Thanks
     * ------
     * Nick Rabinowitz - For creating quantize.js.
     * John Schulz - For clean up and optimization. @JFSIII
     * Nathan Spady - For adding drag and drop support to the demo page.
     *
     * License
     * -------
     * Copyright 2011, 2015 Lokesh Dhakar
     * Released under the MIT license
     * https://raw.githubusercontent.com/lokesh/color-thief/master/LICENSE
     *
     */

    /*
      CanvasImage Class
      Class that wraps the html image element and canvas.
      It also simplifies some of the canvas context manipulation
      with a set of helper functions.
    */
    var CanvasImage = function CanvasImage(image) {
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');

        document.body.appendChild(this.canvas);

        this.width = this.canvas.width = image.width;
        this.height = this.canvas.height = image.height;

        this.context.drawImage(image, 0, 0, this.width, this.height);
    };

    CanvasImage.prototype.clear = function () {
        this.context.clearRect(0, 0, this.width, this.height);
    };

    CanvasImage.prototype.update = function (imageData) {
        this.context.putImageData(imageData, 0, 0);
    };

    CanvasImage.prototype.getPixelCount = function () {
        return this.width * this.height;
    };

    CanvasImage.prototype.getImageData = function () {
        return this.context.getImageData(0, 0, this.width, this.height);
    };

    CanvasImage.prototype.removeCanvas = function () {
        this.canvas.parentNode.removeChild(this.canvas);
    };

    var ColorThief = function ColorThief() {};

    /*
     * getColor(sourceImage[, quality])
     * returns {r: num, g: num, b: num}
     *
     * Use the median cut algorithm provided by quantize.js to cluster similar
     * colors and return the base color from the largest cluster.
     *
     * Quality is an optional argument. It needs to be an integer. 1 is the highest quality settings.
     * 10 is the default. There is a trade-off between quality and speed. The bigger the number, the
     * faster a color will be returned but the greater the likelihood that it will not be the visually
     * most dominant color.
     *
     * */
    ColorThief.prototype.getColor = function (sourceImage, quality) {
        var palette = this.getPalette(sourceImage, 5, quality);
        var dominantColor = palette[0];
        return dominantColor;
    };

    /*
     * getPalette(sourceImage[, colorCount, quality])
     * returns array[ {r: num, g: num, b: num}, {r: num, g: num, b: num}, ...]
     *
     * Use the median cut algorithm provided by quantize.js to cluster similar colors.
     *
     * colorCount determines the size of the palette; the number of colors returned. If not set, it
     * defaults to 10.
     *
     * BUGGY: Function does not always return the requested amount of colors. It can be +/- 2.
     *
     * quality is an optional argument. It needs to be an integer. 1 is the highest quality settings.
     * 10 is the default. There is a trade-off between quality and speed. The bigger the number, the
     * faster the palette generation but the greater the likelihood that colors will be missed.
     *
     *
     */
    ColorThief.prototype.getPalette = function (sourceImage, colorCount, quality) {

        if (typeof colorCount === 'undefined') {
            colorCount = 10;
        }
        if (typeof quality === 'undefined' || quality < 1) {
            quality = 10;
        }

        // Create custom CanvasImage object
        var image = new CanvasImage(sourceImage);
        var imageData = image.getImageData();
        var pixels = imageData.data;
        var pixelCount = image.getPixelCount();

        // Store the RGB values in an array format suitable for quantize function
        var pixelArray = [];
        for (var i = 0, offset, r, g, b, a; i < pixelCount; i = i + quality) {
            offset = i * 4;
            r = pixels[offset + 0];
            g = pixels[offset + 1];
            b = pixels[offset + 2];
            a = pixels[offset + 3];
            // If pixel is mostly opaque and not white
            if (a >= 125) {
                if (!(r > 250 && g > 250 && b > 250)) {
                    pixelArray.push([r, g, b]);
                }
            }
        }

        // Send array to quantize function which clusters values
        // using median cut algorithm
        var cmap = MMCQ.quantize(pixelArray, colorCount);
        var palette = cmap ? cmap.palette() : null;

        // Clean up
        image.removeCanvas();

        return palette;
    };

    /*!
     * quantize.js Copyright 2008 Nick Rabinowitz.
     * Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
     */

    // fill out a couple protovis dependencies
    /*!
     * Block below copied from Protovis: http://mbostock.github.com/protovis/
     * Copyright 2010 Stanford Visualization Group
     * Licensed under the BSD License: http://www.opensource.org/licenses/bsd-license.php
     */
    if (!pv) {
        var pv = {
            map: function map(array, f) {
                var o = {};
                return f ? array.map(function (d, i) {
                    o.index = i;
                    return f.call(o, d);
                }) : array.slice();
            },
            naturalOrder: function naturalOrder(a, b) {
                return a < b ? -1 : a > b ? 1 : 0;
            },
            sum: function sum(array, f) {
                var o = {};
                return array.reduce(f ? function (p, d, i) {
                    o.index = i;
                    return p + f.call(o, d);
                } : function (p, d) {
                    return p + d;
                }, 0);
            },
            max: function max(array, f) {
                return Math.max.apply(null, f ? pv.map(array, f) : array);
            }
        };
    }

    /**
     * Basic Javascript port of the MMCQ (modified median cut quantization)
     * algorithm from the Leptonica library (http://www.leptonica.com/).
     * Returns a color map you can use to map original pixels to the reduced
     * palette. Still a work in progress.
     *
     * @author Nick Rabinowitz
     * @example
     // array of pixels as [R,G,B] arrays
    var myPixels = [[190,197,190], [202,204,200], [207,214,210], [211,214,211], [205,207,207]
                    // etc
                    ];
    var maxColors = 4;
     var cmap = MMCQ.quantize(myPixels, maxColors);
    var newPalette = cmap.palette();
    var newPixels = myPixels.map(function(p) {
        return cmap.map(p);
    });
      */
    var MMCQ = function () {
        // private constants
        var sigbits = 5,
            rshift = 8 - sigbits,
            maxIterations = 1000,
            fractByPopulations = 0.75;

        // get reduced-space color index for a pixel
        function getColorIndex(r, g, b) {
            return (r << 2 * sigbits) + (g << sigbits) + b;
        }

        // Simple priority queue
        function PQueue(comparator) {
            var contents = [],
                sorted = false;

            function sort() {
                contents.sort(comparator);
                sorted = true;
            }

            return {
                push: function push(o) {
                    contents.push(o);
                    sorted = false;
                },
                peek: function peek(index) {
                    if (!sorted) sort();
                    if (index === undefined) index = contents.length - 1;
                    return contents[index];
                },
                pop: function pop() {
                    if (!sorted) sort();
                    return contents.pop();
                },
                size: function size() {
                    return contents.length;
                },
                map: function map(f) {
                    return contents.map(f);
                },
                debug: function debug() {
                    if (!sorted) sort();
                    return contents;
                }
            };
        }

        // 3d color space box
        function VBox(r1, r2, g1, g2, b1, b2, histo) {
            var vbox = this;
            vbox.r1 = r1;
            vbox.r2 = r2;
            vbox.g1 = g1;
            vbox.g2 = g2;
            vbox.b1 = b1;
            vbox.b2 = b2;
            vbox.histo = histo;
        }
        VBox.prototype = {
            volume: function volume(force) {
                var vbox = this;
                if (!vbox._volume || force) {
                    vbox._volume = (vbox.r2 - vbox.r1 + 1) * (vbox.g2 - vbox.g1 + 1) * (vbox.b2 - vbox.b1 + 1);
                }
                return vbox._volume;
            },
            count: function count(force) {
                var vbox = this,
                    histo = vbox.histo;
                if (!vbox._count_set || force) {
                    var npix = 0,
                        i,
                        j,
                        k;
                    for (i = vbox.r1; i <= vbox.r2; i++) {
                        for (j = vbox.g1; j <= vbox.g2; j++) {
                            for (k = vbox.b1; k <= vbox.b2; k++) {
                                var index = getColorIndex(i, j, k);
                                npix += histo[index] || 0;
                            }
                        }
                    }
                    vbox._count = npix;
                    vbox._count_set = true;
                }
                return vbox._count;
            },
            copy: function copy() {
                var vbox = this;
                return new VBox(vbox.r1, vbox.r2, vbox.g1, vbox.g2, vbox.b1, vbox.b2, vbox.histo);
            },
            avg: function avg(force) {
                var vbox = this,
                    histo = vbox.histo;
                if (!vbox._avg || force) {
                    var ntot = 0,
                        mult = 1 << 8 - sigbits,
                        rsum = 0,
                        gsum = 0,
                        bsum = 0,
                        hval,
                        i,
                        j,
                        k,
                        histoindex;
                    for (i = vbox.r1; i <= vbox.r2; i++) {
                        for (j = vbox.g1; j <= vbox.g2; j++) {
                            for (k = vbox.b1; k <= vbox.b2; k++) {
                                histoindex = getColorIndex(i, j, k);
                                hval = histo[histoindex] || 0;
                                ntot += hval;
                                rsum += hval * (i + 0.5) * mult;
                                gsum += hval * (j + 0.5) * mult;
                                bsum += hval * (k + 0.5) * mult;
                            }
                        }
                    }
                    if (ntot) {
                        vbox._avg = [~~(rsum / ntot), ~~(gsum / ntot), ~~(bsum / ntot)];
                    } else {
                        //                    console.log('empty box');
                        vbox._avg = [~~(mult * (vbox.r1 + vbox.r2 + 1) / 2), ~~(mult * (vbox.g1 + vbox.g2 + 1) / 2), ~~(mult * (vbox.b1 + vbox.b2 + 1) / 2)];
                    }
                }
                return vbox._avg;
            },
            contains: function contains(pixel) {
                var vbox = this,
                    rval = pixel[0] >> rshift;
                gval = pixel[1] >> rshift;
                bval = pixel[2] >> rshift;
                return rval >= vbox.r1 && rval <= vbox.r2 && gval >= vbox.g1 && gval <= vbox.g2 && bval >= vbox.b1 && bval <= vbox.b2;
            }
        };

        // Color map
        function CMap() {
            this.vboxes = new PQueue(function (a, b) {
                return pv.naturalOrder(a.vbox.count() * a.vbox.volume(), b.vbox.count() * b.vbox.volume());
            });
        }
        CMap.prototype = {
            push: function push(vbox) {
                this.vboxes.push({
                    vbox: vbox,
                    color: vbox.avg()
                });
            },
            palette: function palette() {
                return this.vboxes.map(function (vb) {
                    return vb.color;
                });
            },
            size: function size() {
                return this.vboxes.size();
            },
            map: function map(color) {
                var vboxes = this.vboxes;
                for (var i = 0; i < vboxes.size(); i++) {
                    if (vboxes.peek(i).vbox.contains(color)) {
                        return vboxes.peek(i).color;
                    }
                }
                return this.nearest(color);
            },
            nearest: function nearest(color) {
                var vboxes = this.vboxes,
                    d1,
                    d2,
                    pColor;
                for (var i = 0; i < vboxes.size(); i++) {
                    d2 = Math.sqrt(Math.pow(color[0] - vboxes.peek(i).color[0], 2) + Math.pow(color[1] - vboxes.peek(i).color[1], 2) + Math.pow(color[2] - vboxes.peek(i).color[2], 2));
                    if (d2 < d1 || d1 === undefined) {
                        d1 = d2;
                        pColor = vboxes.peek(i).color;
                    }
                }
                return pColor;
            },
            forcebw: function forcebw() {
                // XXX: won't  work yet
                var vboxes = this.vboxes;
                vboxes.sort(function (a, b) {
                    return pv.naturalOrder(pv.sum(a.color), pv.sum(b.color));
                });

                // force darkest color to black if everything < 5
                var lowest = vboxes[0].color;
                if (lowest[0] < 5 && lowest[1] < 5 && lowest[2] < 5) vboxes[0].color = [0, 0, 0];

                // force lightest color to white if everything > 251
                var idx = vboxes.length - 1,
                    highest = vboxes[idx].color;
                if (highest[0] > 251 && highest[1] > 251 && highest[2] > 251) vboxes[idx].color = [255, 255, 255];
            }
        };

        // histo (1-d array, giving the number of pixels in
        // each quantized region of color space), or null on error
        function getHisto(pixels) {
            var histosize = 1 << 3 * sigbits,
                histo = new Array(histosize),
                index,
                rval,
                gval,
                bval;
            pixels.forEach(function (pixel) {
                rval = pixel[0] >> rshift;
                gval = pixel[1] >> rshift;
                bval = pixel[2] >> rshift;
                index = getColorIndex(rval, gval, bval);
                histo[index] = (histo[index] || 0) + 1;
            });
            return histo;
        }

        function vboxFromPixels(pixels, histo) {
            var rmin = 1000000,
                rmax = 0,
                gmin = 1000000,
                gmax = 0,
                bmin = 1000000,
                bmax = 0,
                rval,
                gval,
                bval;
            // find min/max
            pixels.forEach(function (pixel) {
                rval = pixel[0] >> rshift;
                gval = pixel[1] >> rshift;
                bval = pixel[2] >> rshift;
                if (rval < rmin) rmin = rval;else if (rval > rmax) rmax = rval;
                if (gval < gmin) gmin = gval;else if (gval > gmax) gmax = gval;
                if (bval < bmin) bmin = bval;else if (bval > bmax) bmax = bval;
            });
            return new VBox(rmin, rmax, gmin, gmax, bmin, bmax, histo);
        }

        function medianCutApply(histo, vbox) {
            if (!vbox.count()) return;

            var rw = vbox.r2 - vbox.r1 + 1,
                gw = vbox.g2 - vbox.g1 + 1,
                bw = vbox.b2 - vbox.b1 + 1,
                maxw = pv.max([rw, gw, bw]);
            // only one pixel, no split
            if (vbox.count() == 1) {
                return [vbox.copy()];
            }
            /* Find the partial sum arrays along the selected axis. */
            var total = 0,
                partialsum = [],
                lookaheadsum = [],
                i,
                j,
                k,
                sum,
                index;
            if (maxw == rw) {
                for (i = vbox.r1; i <= vbox.r2; i++) {
                    sum = 0;
                    for (j = vbox.g1; j <= vbox.g2; j++) {
                        for (k = vbox.b1; k <= vbox.b2; k++) {
                            index = getColorIndex(i, j, k);
                            sum += histo[index] || 0;
                        }
                    }
                    total += sum;
                    partialsum[i] = total;
                }
            } else if (maxw == gw) {
                for (i = vbox.g1; i <= vbox.g2; i++) {
                    sum = 0;
                    for (j = vbox.r1; j <= vbox.r2; j++) {
                        for (k = vbox.b1; k <= vbox.b2; k++) {
                            index = getColorIndex(j, i, k);
                            sum += histo[index] || 0;
                        }
                    }
                    total += sum;
                    partialsum[i] = total;
                }
            } else {
                /* maxw == bw */
                for (i = vbox.b1; i <= vbox.b2; i++) {
                    sum = 0;
                    for (j = vbox.r1; j <= vbox.r2; j++) {
                        for (k = vbox.g1; k <= vbox.g2; k++) {
                            index = getColorIndex(j, k, i);
                            sum += histo[index] || 0;
                        }
                    }
                    total += sum;
                    partialsum[i] = total;
                }
            }
            partialsum.forEach(function (d, i) {
                lookaheadsum[i] = total - d;
            });

            function doCut(color) {
                var dim1 = color + '1',
                    dim2 = color + '2',
                    left,
                    right,
                    vbox1,
                    vbox2,
                    d2,
                    count2 = 0;
                for (i = vbox[dim1]; i <= vbox[dim2]; i++) {
                    if (partialsum[i] > total / 2) {
                        vbox1 = vbox.copy();
                        vbox2 = vbox.copy();
                        left = i - vbox[dim1];
                        right = vbox[dim2] - i;
                        if (left <= right) d2 = Math.min(vbox[dim2] - 1, ~~(i + right / 2));else d2 = Math.max(vbox[dim1], ~~(i - 1 - left / 2));
                        // avoid 0-count boxes
                        while (!partialsum[d2]) {
                            d2++;
                        }count2 = lookaheadsum[d2];
                        while (!count2 && partialsum[d2 - 1]) {
                            count2 = lookaheadsum[--d2];
                        } // set dimensions
                        vbox1[dim2] = d2;
                        vbox2[dim1] = vbox1[dim2] + 1;
                        //                    console.log('vbox counts:', vbox.count(), vbox1.count(), vbox2.count());
                        return [vbox1, vbox2];
                    }
                }
            }
            // determine the cut planes
            return maxw == rw ? doCut('r') : maxw == gw ? doCut('g') : doCut('b');
        }

        function quantize(pixels, maxcolors) {
            // short-circuit
            if (!pixels.length || maxcolors < 2 || maxcolors > 256) {
                //            console.log('wrong number of maxcolors');
                return false;
            }

            // XXX: check color content and convert to grayscale if insufficient

            var histo = getHisto(pixels),
                histosize = 1 << 3 * sigbits;

            // check that we aren't below maxcolors already
            var nColors = 0;
            histo.forEach(function () {
                nColors++;
            });
            if (nColors <= maxcolors) {}
            // XXX: generate the new colors from the histo and return


            // get the beginning vbox from the colors
            var vbox = vboxFromPixels(pixels, histo),
                pq = new PQueue(function (a, b) {
                return pv.naturalOrder(a.count(), b.count());
            });
            pq.push(vbox);

            // inner function to do the iteration
            function iter(lh, target) {
                var ncolors = 1,
                    niters = 0,
                    vbox;
                while (niters < maxIterations) {
                    vbox = lh.pop();
                    if (!vbox.count()) {
                        /* just put it back */
                        lh.push(vbox);
                        niters++;
                        continue;
                    }
                    // do the cut
                    var vboxes = medianCutApply(histo, vbox),
                        vbox1 = vboxes[0],
                        vbox2 = vboxes[1];

                    if (!vbox1) {
                        //                    console.log("vbox1 not defined; shouldn't happen!");
                        return;
                    }
                    lh.push(vbox1);
                    if (vbox2) {
                        /* vbox2 can be null */
                        lh.push(vbox2);
                        ncolors++;
                    }
                    if (ncolors >= target) return;
                    if (niters++ > maxIterations) {
                        //                    console.log("infinite loop; perhaps too few pixels!");
                        return;
                    }
                }
            }

            // first set of colors, sorted by population
            iter(pq, fractByPopulations * maxcolors);

            // Re-sort by the product of pixel occupancy times the size in color space.
            var pq2 = new PQueue(function (a, b) {
                return pv.naturalOrder(a.count() * a.volume(), b.count() * b.volume());
            });
            while (pq.size()) {
                pq2.push(pq.pop());
            }

            // next set - generate the median cuts using the (npix * vol) sorting.
            iter(pq2, maxcolors - pq2.size());

            // calculate the actual colors
            var cmap = new CMap();
            while (pq2.size()) {
                cmap.push(pq2.pop());
            }

            return cmap;
        }

        return {
            quantize: quantize
        };
    }();

    /**
     * Export class to global
     */
    if (window) {
        window.ColorThief = ColorThief;
    };
    if (typeof define === 'function' && define.amd) {
        define([], function () {
            return ColorThief;
        }); // for AMD loader
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = ColorThief; // for CommonJS
    } else {
        this.ColorThief = ColorThief;
    }
}).call(undefined);

/**
 * Mega pixel image rendering library for iOS6 Safari
 *
 * Fixes iOS6 Safari's image file rendering issue for large size image (over mega-pixel),
 * which causes unexpected subsampling when drawing it in canvas.
 * By using this library, you can safely render the image with proper stretching.
 *
 * Copyright (c) 2012 Shinichi Tomita <shinichi.tomita@gmail.com>
 * Released under the MIT license
 */
(function () {

    /**
     * Detect subsampling in loaded image.
     * In iOS, larger images than 2M pixels may be subsampled in rendering.
     */
    function detectSubsampling(img) {
        var iw = img.naturalWidth,
            ih = img.naturalHeight;
        if (iw * ih > 1024 * 1024) {
            // subsampling may happen over megapixel image
            var canvas = document.createElement('canvas');
            canvas.width = canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, -iw + 1, 0);
            // subsampled image becomes half smaller in rendering size.
            // check alpha channel value to confirm image is covering edge pixel or not.
            // if alpha value is 0 image is not covering, hence subsampled.
            return ctx.getImageData(0, 0, 1, 1).data[3] === 0;
        } else {
            return false;
        }
    }

    /**
     * Detecting vertical squash in loaded image.
     * Fixes a bug which squash image vertically while drawing into canvas for some images.
     */
    function detectVerticalSquash(img, iw, ih) {
        var canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = ih;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var data = ctx.getImageData(0, 0, 1, ih).data;
        // search image edge pixel position in case it is squashed vertically.
        var sy = 0;
        var ey = ih;
        var py = ih;
        while (py > sy) {
            var alpha = data[(py - 1) * 4 + 3];
            if (alpha === 0) {
                ey = py;
            } else {
                sy = py;
            }
            py = ey + sy >> 1;
        }
        var ratio = py / ih;
        return ratio === 0 ? 1 : ratio;
    }

    /**
     * Rendering image element (with resizing) and get its data URL
     */
    function renderImageToDataURL(img, options, doSquash) {
        var canvas = document.createElement('canvas');
        renderImageToCanvas(img, canvas, options, doSquash);
        return canvas.toDataURL('image/jpeg', options.quality || 0.8);
    }

    /**
     * Rendering image element (with resizing) into the canvas element
     */
    function renderImageToCanvas(img, canvas, options, doSquash) {
        var iw = img.naturalWidth,
            ih = img.naturalHeight;
        if (iw + ih === false) {
            return;
        }
        var width = options.width,
            height = options.height;
        var ctx = canvas.getContext('2d');
        ctx.save();
        transformCoordinate(canvas, ctx, width, height, options.orientation);
        var subsampled = detectSubsampling(img);
        if (subsampled) {
            iw /= 2;
            ih /= 2;
        }
        var d = 1024; // size of tiling canvas
        var tmpCanvas = document.createElement('canvas');
        tmpCanvas.width = tmpCanvas.height = d;
        var tmpCtx = tmpCanvas.getContext('2d');
        var vertSquashRatio = doSquash ? detectVerticalSquash(img, iw, ih) : 1;
        var dw = Math.ceil(d * width / iw);
        var dh = Math.ceil(d * height / ih / vertSquashRatio);
        var sy = 0;
        var dy = 0;
        while (sy < ih) {
            var sx = 0;
            var dx = 0;
            while (sx < iw) {
                tmpCtx.clearRect(0, 0, d, d);
                tmpCtx.drawImage(img, -sx, -sy);
                ctx.drawImage(tmpCanvas, 0, 0, d, d, dx, dy, dw, dh);
                sx += d;
                dx += dw;
            }
            sy += d;
            dy += dh;
        }
        ctx.restore();
        tmpCanvas = tmpCtx = null;
    }

    /**
     * Transform canvas coordination according to specified frame size and orientation
     * Orientation value is from EXIF tag
     */
    function transformCoordinate(canvas, ctx, width, height, orientation) {
        switch (orientation) {
            case 5:
            case 6:
            case 7:
            case 8:
                canvas.width = height;
                canvas.height = width;
                break;
            default:
                canvas.width = width;
                canvas.height = height;
        }
        switch (orientation) {
            case 2:
                // horizontal flip
                ctx.translate(width, 0);
                ctx.scale(-1, 1);
                break;
            case 3:
                // 180 rotate left
                ctx.translate(width, height);
                ctx.rotate(Math.PI);
                break;
            case 4:
                // vertical flip
                ctx.translate(0, height);
                ctx.scale(1, -1);
                break;
            case 5:
                // vertical flip + 90 rotate right
                ctx.rotate(0.5 * Math.PI);
                ctx.scale(1, -1);
                break;
            case 6:
                // 90 rotate right
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(0, -height);
                break;
            case 7:
                // horizontal flip + 90 rotate right
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(width, -height);
                ctx.scale(-1, 1);
                break;
            case 8:
                // 90 rotate left
                ctx.rotate(-0.5 * Math.PI);
                ctx.translate(-width, 0);
                break;
            default:
                break;
        }
    }

    var URL = window.URL && window.URL.createObjectURL ? window.URL : window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL : null;

    /**
     * MegaPixImage class
     */
    function MegaPixImage(srcImage) {
        if (window.Blob && srcImage instanceof Blob) {
            if (!URL) {
                throw Error('No createObjectURL function found to create blob url');
            }
            var img = new Image();
            img.src = URL.createObjectURL(srcImage);
            this.blob = srcImage;
            srcImage = img;
        }
        if (!srcImage.naturalWidth && !srcImage.naturalHeight) {
            var _this = this;
            srcImage.onload = srcImage.onerror = function () {
                var listeners = _this.imageLoadListeners;
                if (listeners) {
                    _this.imageLoadListeners = null;
                    for (var i = 0, len = listeners.length; i < len; i++) {
                        listeners[i]();
                    }
                }
            };
            this.imageLoadListeners = [];
        }
        this.srcImage = srcImage;
    }

    /**
     * Rendering megapix image into specified target element
     */
    MegaPixImage.prototype.render = function (target, options, callback) {
        if (this.imageLoadListeners) {
            var _this = this;
            this.imageLoadListeners.push(function () {
                _this.render(target, options, callback);
            });
            return;
        }
        options = options || {};
        var imgWidth = this.srcImage.naturalWidth,
            imgHeight = this.srcImage.naturalHeight,
            width = options.width,
            height = options.height,
            maxWidth = options.maxWidth,
            maxHeight = options.maxHeight,
            doSquash = !this.blob || this.blob.type === 'image/jpeg';
        if (width && !height) {
            height = imgHeight * width / imgWidth << 0;
        } else if (height && !width) {
            width = imgWidth * height / imgHeight << 0;
        } else {
            width = imgWidth;
            height = imgHeight;
        }
        if (maxWidth && width > maxWidth) {
            width = maxWidth;
            height = imgHeight * width / imgWidth << 0;
        }
        if (maxHeight && height > maxHeight) {
            height = maxHeight;
            width = imgWidth * height / imgHeight << 0;
        }
        var opt = { width: width, height: height };
        for (var k in options) {
            opt[k] = options[k];
        }

        var tagName = target.tagName.toLowerCase();
        if (tagName === 'img') {
            target.src = renderImageToDataURL(this.srcImage, opt, doSquash);
        } else if (tagName === 'canvas') {
            renderImageToCanvas(this.srcImage, target, opt, doSquash);
        }
        if (typeof this.onrender === 'function') {
            this.onrender(target);
        }
        if (callback) {
            callback();
        }
        if (this.blob) {
            this.blob = null;
            URL.revokeObjectURL(this.srcImage.src);
        }
    };

    /**
     * Export class to global
     */
    if (typeof define === 'function' && define.amd) {
        define([], function () {
            return MegaPixImage;
        }); // for AMD loader
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = MegaPixImage; // for CommonJS
    } else {
        this.MegaPixImage = MegaPixImage;
    }
}).call(undefined);


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
 * angular-auto-validate - v1.19.0 - 2015-10-25
 * https://github.com/jonsamwell/angular-auto-validate
 * Copyright (c) 2015 Jon Samwell (http://www.jonsamwell.com)
 */
!function (a, b) {
  "use strict";
  n.$inject = ["a", "b", "c"];
  function c() {
    var a = {},
        c = !0,
        d = !0,
        e = !0,
        f = function f(a) {
      var b;return a && 0 !== a.length ? (b = a.toLowerCase(), a = !("f" === b || "0" === b || "false" === b)) : a = !1, a;
    },
        g = function g(a, b) {
      var c;return void 0 !== a && (c = a.attr(b) || a.attr("data-" + b)), c;
    },
        h = function h(a, b) {
      var c;return void 0 !== a && (c = void 0 !== a.attr(b) || void 0 !== a.attr("data-" + b)), c;
    },
        i = function i(a, b) {
      return f(g(a, b));
    },
        j = function j(a) {
      return c && !i(a, "disable-valid-styling");
    },
        k = function k(a) {
      return !i(a, "disable-auto-validate");
    },
        l = function l(a) {
      return d && !i(a, "disable-invalid-styling");
    };this.enable = function (a) {
      e = a;
    }, this.isEnabled = function () {
      return e;
    }, this.setDefaultElementModifier = function (b) {
      if (void 0 === a[b]) throw new Error("Element modifier not registered: " + b);this.defaultElementModifier = b;
    }, this.registerDomModifier = function (b, c) {
      a[b] = c;
    }, this.setErrorMessageResolver = function (a) {
      this.errorMessageResolver = a;
    }, this.getErrorMessage = function (a, c) {
      var d;if (void 0 === this.errorMessageResolver) throw new Error("Please set an error message resolver via the setErrorMessageResolver function before attempting to resolve an error message.");return h(c, "disable-validation-message") ? (d = b.injector(["ng"]).get("$q").defer(), d.resolve(""), d.promise) : this.errorMessageResolver(a, c);
    }, this.setValidElementStyling = function (a) {
      c = a;
    }, this.setInvalidElementStyling = function (a) {
      d = a;
    }, this.getDomModifier = function (b) {
      var c = (void 0 !== b ? b.attr("element-modifier") : this.defaultElementModifier) || (void 0 !== b ? b.attr("data-element-modifier") : this.defaultElementModifier) || this.defaultElementModifier;if (void 0 === c) throw new Error("Please set a default dom modifier via the setDefaultElementModifier method on the validator class.");return a[c];
    }, this.makeValid = function (a) {
      k(a) && (j(a) ? this.getDomModifier(a).makeValid(a) : this.makeDefault(a));
    }, this.makeInvalid = function (a, b) {
      k(a) && (l(a) ? this.getDomModifier(a).makeInvalid(a, b) : this.makeDefault(a));
    }, this.makeDefault = function (a) {
      if (k(a)) {
        var b = this.getDomModifier(a);b.makeDefault && b.makeDefault(a);
      }
    }, this.defaultFormValidationOptions = { forceValidation: !1, disabled: !1, validateNonVisibleControls: !1, removeExternalValidationErrorsOnSubmit: !0, validateOnFormSubmit: !1 }, this.$get = [function () {
      return this;
    }];
  }function d(a) {
    var c = function c(a) {
      b.forEach(a.find("span"), function (a) {
        a = b.element(a), (a.hasClass("error-msg") || a.hasClass("form-control-feedback") || a.hasClass("control-feedback")) && a.remove();
      }), a.removeClass("has-success has-error has-feedback");
    },
        d = function d(a, b) {
      for (var c, d = a, e = 0; 10 >= e; e += 1) {
        if (void 0 !== d && d.hasClass(b)) {
          c = d;break;
        }void 0 !== d && (d = d.parent());
      }return c;
    },
        e = function e(a, c) {
      for (var d, f = 0; f < a.children.length && (d = a.children[f], void 0 === d || !b.element(d).hasClass(c)) && !(void 0 !== d.children && (d = e(d, c), d.length > 0)); f += 1) {}return b.element(d);
    },
        f = function f(a) {
      return d(a, "form-group");
    },
        g = function g(a) {
      return e(a, "input-group");
    },
        h = function h(a, b) {
      a[0].parentNode.insertBefore(b[0], a[0].nextSibling);
    },
        i = !1,
        j = function j(a) {
      i = a;
    },
        k = function k(d) {
      var e,
          j = f(d);if (j) {
        if (c(j), e = g(j[0]), j.addClass("has-success " + (e.length > 0 || i === !1 ? "" : "has-feedback")), i) {
          var k = '<span class="glyphicon glyphicon-ok form-control-feedback"></span>';e.length > 0 && (k = k.replace("form-", ""), k = '<span class="input-group-addon control-feedback">' + k + "</span"), h(d, b.element(k));
        }
      } else a.error("Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class");
    },
        l = function l(d, e) {
      var j,
          k = f(d),
          l = b.element('<span class="help-block has-error error-msg">' + e + "</span>");if (k) {
        if (c(k), j = g(k[0]), k.addClass("has-error " + (j.length > 0 || i === !1 ? "" : "has-feedback")), h(j.length > 0 ? j : m(d), l), i) {
          var n = '<span class="glyphicon glyphicon-remove form-control-feedback"></span>';j.length > 0 && (n = n.replace("form-", ""), n = '<span class="input-group-addon control-feedback">' + n + "</span"), h(m(d), b.element(n));
        }
      } else a.error("Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class");
    },
        m = function m(a) {
      var b = a,
          c = a[0].type ? a[0].type.toLowerCase() : "";return "checkbox" !== c && "radio" !== c || "label" !== a.parent()[0].nodeName.toLowerCase() || (b = a.parent()), b;
    },
        n = function n(b) {
      var d = f(b);d ? c(d) : a.error("Angular-auto-validate: invalid bs3 form structure elements must be wrapped by a form-group class");
    };return { makeValid: k, makeInvalid: l, makeDefault: n, enableValidationStateIcons: j, key: "bs3" };
  }function e(a) {
    var c = function c(_c, d, e) {
      d = b.isUndefined(d) ? 0 : d, e = b.isUndefined(e) ? !0 : e;var f = 0;return function () {
        var b = this,
            g = arguments;f += 1;var h = function (a) {
          return function () {
            return a === f ? _c.apply(b, g) : void 0;
          };
        }(f);return a(h, d, e);
      };
    };return { debounce: c };
  }function f(a, c) {
    var d,
        e = "default",
        f = "js/angular-auto-validate/dist/lang",
        g = function g(a) {
      return d = c.get("{0}/jcs-auto-validate_{1}.json".format(f, a.toLowerCase()));
    },
        h = function h(a) {
      f = a;
    },
        i = function i(c, f) {
      var h = a.defer();return f = f || g, e = c.toLowerCase(), void 0 === b.autoValidate.errorMessages[e] ? (d = f(c), d.then(function (a) {
        d = void 0, b.autoValidate.errorMessages[e] = a.data, h.resolve(b.autoValidate.errorMessages[e]);
      }, function (a) {
        b.autoValidate.errorMessages[e] = { defaultMsg: "Loading culture failed!" }, d = null, h.reject(a);
      })) : h.resolve(b.autoValidate.errorMessages[e]), h.promise;
    },
        j = function j(c) {
      var f = a.defer();return c = void 0 === c ? e : c.toLowerCase(), void 0 !== d ? d.then(function () {
        f.resolve(b.autoValidate.errorMessages[c]);
      }, function (a) {
        f.reject(a);
      }) : f.resolve(b.autoValidate.errorMessages[c]), f.promise;
    },
        k = function k(a, b) {
      var c;return b && (a += "-err-type", c = b.attr("ng-" + a), void 0 === c && (c = b.attr("data-ng-" + a) || b.attr(a)), c && (c = c.replace(/[\W]/g, ""))), c;
    },
        l = function l(c, f) {
      var g,
          h,
          i,
          j = a.defer(),
          m = [];if (void 0 !== d) d.then(function () {
        l(c, f).then(function (a) {
          j.resolve(a);
        });
      });else {
        if (g = b.autoValidate.errorMessages[e][c], i = k(c, f), i && (g = b.autoValidate.errorMessages[e][i]), void 0 === g && void 0 !== i ? g = b.autoValidate.errorMessages[e].defaultMsg.format(i) : void 0 === g && (g = b.autoValidate.errorMessages[e].defaultMsg.format(c)), f && f.attr) try {
          h = f.attr("ng-" + c), void 0 === h && (h = f.attr("data-ng-" + c) || f.attr(c)), m.push(h || ""), g = g.format(m);
        } catch (n) {}j.resolve(g);
      }return j.promise;
    };return { setI18nFileRootPath: h, setCulture: i, getErrorMessages: j, resolve: l };
  }function g() {
    var a = function a(_a, c) {
      b.forEach(_a.find("small"), function (a) {
        b.element(a).hasClass("error") && b.element(a).remove();
      }), c.removeClass("error");
    },
        c = function c(a) {
      for (var b = a, c = 0; 3 >= c && (void 0 === b || !b.hasClass("columns") && !b.hasClass("column")); c += 1) {
        void 0 !== b && (b = b.parent());
      }return b;
    },
        d = function d(b) {
      var d = c(b);a(d && d.length > 0 ? d : b, b);
    },
        e = function e(d, _e) {
      var f,
          g = c(d);a(g || d, d), d.addClass("error"), g && (f = b.element('<small class="error">' + _e + "</small>"), g.append(f));
    },
        f = function f(a) {
      d(a);
    };return { makeValid: d, makeInvalid: e, makeDefault: f, key: "foundation5" };
  }function h() {
    var a = function a(_a2) {
      return _a2[0].offsetWidth > 0 && _a2[0].offsetHeight > 0;
    };return { isElementVisible: a };
  }function i(a, c) {
    var d = ["input", "textarea", "select", "form"],
        e = function e(a) {
      return c.isElementVisible(a);
    },
        f = function f(c) {
      var d,
          e = b.element(c).controller("form");return d = void 0 !== e && null !== e ? e.autoValidateFormOptions : a.defaultFormValidationOptions;
    },
        g = function g(a, b, c) {
      var f,
          g,
          h,
          i = a && a.length > 0,
          j = i && "#comment" === a[0].nodeName.toLowerCase();return i && j === !1 && (f = e(a) || b.validateNonVisibleControls, g = d.indexOf(a[0].nodeName.toLowerCase()) > -1 || a[0].hasAttribute("register-custom-form-control"), h = b.validateOnFormSubmit === !1 || b.validateOnFormSubmit === !0 && c === !0), i && !j && f && g && h;
    },
        h = function h(c, d, e) {
      var h,
          i = !0,
          j = e || f(d),
          k = c.$pristine === !1 || j.forceValidation,
          l = function l(a) {
        var c,
            d = !0;return b.forEach(a, function (a, b) {
          d && a && (d = !1, c = b);
        }), c;
      };return j.disabled === !1 && (j.forceValidation || g(d, j, j.getFormController().$submitted) && c && k) && (i = !c.$invalid, j.removeExternalValidationErrorsOnSubmit && c.removeAllExternalValidation && c.removeAllExternalValidation(), i ? a.makeValid(d) : (h = l(c.$errors || c.$error), void 0 === h ? i = !0 : a.getErrorMessage(h, d).then(function (b) {
        a.makeInvalid(d, b);
      }))), i;
    },
        i = function i(b) {
      a.makeDefault(b);
    },
        j = function j(a) {
      b.forEach(a[0].all || a[0].elements || a[0], function (a) {
        var c,
            d = b.element(a);c = d.controller("ngModel"), void 0 !== c && ("form" === d[0].nodeName.toLowerCase() ? j(d) : c.$setPristine());
      });
    },
        k = function k(a) {
      var c,
          d = !0,
          e = a ? b.element(a).controller("form") : void 0,
          i = function i(a, c, _i) {
        var j, l, m, n;if (a = b.element(a), j = a.controller("ngModel"), void 0 !== j && (c || g(a, _i, e.$submitted))) if ("form" === a[0].nodeName.toLowerCase()) k(a);else {
          m = f(a), n = m.forceValidation, m.forceValidation = c;try {
            l = h(j, a, m), d = d && l;
          } finally {
            m.forceValidation = n;
          }
        }
      };return void 0 === a || void 0 !== e && e.autoValidateFormOptions.disabled ? void 0 !== a : (c = b.copy(e.autoValidateFormOptions), c.forceValidation = !0, b.forEach(a[0].elements || a[0].all || a[0], function (a) {
        i(a, !0, c);
      }), a[0].customHTMLFormControlsCollection && b.forEach(a[0].customHTMLFormControlsCollection, function (a) {
        i(a, !0, c);
      }), d);
    },
        l = function l(b, c, d) {
      c ? a.getErrorMessage(c, b).then(function (c) {
        a.makeInvalid(b, c);
      }) : a.makeInvalid(b, d);
    };return { setElementValidationError: l, validateElement: h, validateForm: k, resetElement: i, resetForm: j };
  }function j(a, b) {
    return void 0 !== a && null !== a || void 0 === b ? "false" !== a : b;
  }function k(a, c, d) {
    var e = a.autoValidateFormOptions = a.autoValidateFormOptions || b.copy(c.defaultFormValidationOptions);e.getFormController = function () {
      return a;
    }, e.forceValidation = !1, e.disabled = !c.isEnabled() || j(d.disableDynamicValidation, e.disabled), e.validateNonVisibleControls = j(d.validateNonVisibleControls, e.validateNonVisibleControls), e.validateOnFormSubmit = j(d.validateOnFormSubmit, e.validateOnFormSubmit), e.removeExternalValidationErrorsOnSubmit = void 0 === d.removeExternalValidationErrorsOnSubmit ? e.removeExternalValidationErrorsOnSubmit : j(d.removeExternalValidationErrorsOnSubmit, e.removeExternalValidationErrorsOnSubmit), c.isEnabled() === !1 && "false" === d.disableDynamicValidation && (e.disabled = !1);
  }function l(a) {
    return { restrict: "E", link: function link(b, c) {
        function d() {
          a.resetForm(c), e.$setPristine && e.$setPristine(), e.$setUntouched && e.$setUntouched();
        }var e = c.controller("form");void 0 !== e && e.autoValidateFormOptions && e.autoValidateFormOptions.disabled === !1 && (c.on("reset", d), b.$on("$destroy", function () {
          c.off("reset", d);
        }));
      } };
  }function m() {
    var a = function a(_a3) {
      for (var c = _a3, d = 0; 50 >= d && (void 0 === c || "form" !== c.nodeName.toLowerCase()); d += 1) {
        void 0 !== c && (c = b.element(c).parent()[0]);
      }return c;
    };return { restrict: "A", link: function link(b, c) {
        var d = a(c.parent()[0]);d && (d.customHTMLFormControlsCollection = d.customHTMLFormControlsCollection || [], d.customHTMLFormControlsCollection.push(c[0]));
      } };
  }function n(a, b, c) {
    return a[0].compile = function (a, d) {
      var e = b(d.ngSubmit),
          f = "true" === d.ngSubmitForce;return function (a, b) {
        function d(d) {
          a.$apply(function () {
            void 0 !== i && null !== i && i.autoValidateFormOptions && i.autoValidateFormOptions.disabled === !0 ? e(a, { $event: d }) : (void 0 === i.$setSubmitted && (i.$submitted = !0), (c.validateForm(b) || f === !0) && e(a, { $event: d }));
          });
        }function g() {
          b[0].reset ? b[0].reset() : c.resetForm(b);
        }var h,
            i = b.controller("form");i && i.autoValidateFormOptions && (i.autoValidateFormOptions.resetForm = g, void 0 !== i.$name && "" !== i.$name && (h = a.$on("form:" + i.$name + ":reset", g))), b.on("submit", d), a.$on("$destroy", function () {
          b.off("submit", d), h && h();
        });
      };
    }, a;
  }function o(a) {
    a.decorator("ngSubmitDirective", n);
  }function p(a, b, c, d) {
    a.setErrorMessageResolver(b.resolve), a.registerDomModifier(c.key, c), a.registerDomModifier(d.key, d), a.setDefaultElementModifier(c.key);
  }b.module("jcs-autoValidate", []), b.module("jcs-autoValidate").provider("validator", c), d.$inject = ["$log"], b.module("jcs-autoValidate").factory("bootstrap3ElementModifier", d), e.$inject = ["$timeout"], b.module("jcs-autoValidate").factory("jcs-debounce", e), "format" in a.prototype || (a.prototype.format = function () {
    var a = arguments;return this.replace(/{(\d+)}/g, function (b, c) {
      return void 0 !== _typeof(a[c]) ? a[c] : b;
    });
  }), b.autoValidate = b.autoValidate || { errorMessages: {} }, b.autoValidate.errorMessages["default"] = { defaultMsg: "Please add error message for {0}", email: "Please enter a valid email address", minlength: "Please enter at least {0} characters", maxlength: "You have entered more than the maximum {0} characters", min: "Please enter the minimum number of {0}", max: "Please enter the maximum number of {0}", required: "This field is required", date: "Please enter a valid date", pattern: "Please ensure the entered information adheres to this pattern {0}", number: "Please enter a valid number", url: "Please enter a valid URL in the format of http(s)://www.google.com" }, f.$inject = ["$q", "$http"], b.module("jcs-autoValidate").factory("defaultErrorMessageResolver", f), b.module("jcs-autoValidate").factory("foundation5ElementModifier", g), i.$inject = ["validator", "jcs-elementUtils"], b.module("jcs-autoValidate").factory("jcs-elementUtils", h), b.module("jcs-autoValidate").factory("validationManager", i), b.module("jcs-autoValidate").directive("form", ["validator", function (a) {
    return { restrict: "E", require: "form", priority: 9999, compile: function compile() {
        return { pre: function pre(b, c, d, e) {
            k(e, a, d);
          } };
      } };
  }]), b.module("jcs-autoValidate").directive("ngForm", ["validator", function (a) {
    return { restrict: "EA", require: "form", priority: 9999, compile: function compile() {
        return { pre: function pre(b, c, d, e) {
            k(e, a, d);
          } };
      } };
  }]), l.$inject = ["validationManager"], b.module("jcs-autoValidate").directive("form", l), b.module("jcs-autoValidate").directive("registerCustomFormControl", m), n.$inject = ["$delegate", "$parse", "validationManager"], o.$inject = ["$provide"], b.module("jcs-autoValidate").config(o), b.module("jcs-autoValidate").config(["$provide", function (a) {
    a.decorator("ngModelDirective", ["$timeout", "$delegate", "validationManager", "jcs-debounce", function (a, c, d, e) {
      var f = c[0],
          g = f.link || f.compile;return f.compile = function (a) {
        var c = b.version.major >= 1 && b.version.minor >= 3,
            f = g;return c && b.isFunction(g) && (f = g(a)), { pre: function pre(a, g, h, i) {
            var j = i[0],
                k = i[1],
                l = void 0 === h.ngModelOptions ? void 0 : a.$eval(h.ngModelOptions),
                m = j.$setValidity,
                n = j.$setPristine,
                o = e.debounce(function () {
              var a = void 0 !== k && null !== k ? k.autoValidateFormOptions : void 0;d.validateElement(j, g, a);
            }, 100);return void 0 === h.formnovalidate && void 0 !== k && null !== k && k.autoValidateFormOptions && k.autoValidateFormOptions.disabled === !1 && (c && void 0 !== l && void 0 !== l.updateOn && "" !== l.updateOn ? (g.on(l.updateOn, function () {
              o();
            }), a.$on("$destroy", function () {
              g.off(l.updateOn);
            })) : j.$setValidity = function (a, b) {
              m.call(j, a, b), o();
            }, j.$setPristine = function () {
              n.call(j), d.resetElement(g);
            }, j.autoValidated = !0), j.setExternalValidation = function (a, b, c) {
              if (c) {
                var e = j.$error || j.$errors;e[a] = !1;
              }j.externalErrors = j.externalErrors || {}, j.externalErrors[a] = !1, d.setElementValidationError(g, a, b);
            }, j.removeExternalValidation = function (a, b) {
              if (b) {
                var c = j.$error || j.$errors;delete c[a];
              }j.externalErrors && delete j.externalErrors[a], d.resetElement(g);
            }, j.removeAllExternalValidation = function () {
              if (j.externalErrors) {
                var a = j.$error || j.$errors;b.forEach(j.externalErrors, function (b, c) {
                  delete a[c];
                }), j.externalErrors = {}, d.resetElement(g);
              }
            }, k && (k.setExternalValidation = function (a, b, c, d) {
              var e = !1;return k[a] && (k[a].setExternalValidation(b, c, d), e = !0), e;
            }, k.removeExternalValidation = function (a, b, c, d) {
              var e = !1;return k[a] && (k[a].removeExternalValidation(b, d), e = !0), e;
            }), f.pre ? f.pre.apply(this, arguments) : this;
          }, post: function post(a, b, c, d) {
            return f.post ? f.post.apply(this, arguments) : f.apply(this, arguments);
          } };
      }, c;
    }]);
  }]), p.$inject = ["validator", "defaultErrorMessageResolver", "bootstrap3ElementModifier", "foundation5ElementModifier"], b.module("jcs-autoValidate").run(p);
}(String, angular);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @license AngularJS v1.6.9
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {
  'use strict';

  /**
   * @ngdoc module
   * @name ngCookies
   * @description
   *
   * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
   *
   * See {@link ngCookies.$cookies `$cookies`} for usage.
   */

  angular.module('ngCookies', ['ng']).info({ angularVersion: '1.6.9' }).
  /**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */
  provider('$cookies', [/** @this */function $CookiesProvider() {
    /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For security reasons the user agent will not accept the cookie
     *   if the current domain is not a sub-domain of this domain or equal to it.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
     *   secured connection.
     *
     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
     * This is important so that cookies will be visible for all routes when html5mode is enabled.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesProviderExample', ['ngCookies'])
     *   .config(['$cookiesProvider', function($cookiesProvider) {
     *     // Setting default options
     *     $cookiesProvider.defaults.domain = 'foo.com';
     *     $cookiesProvider.defaults.secure = true;
     *   }]);
     * ```
     **/
    var defaults = this.defaults = {};

    function calcOptions(options) {
      return options ? angular.extend({}, defaults, options) : defaults;
    }

    /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * <div class="alert alert-info">
     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
     * current browser cookie values. In version 1.4, this behavior has changed, and
     * `$cookies` now provides a standard api of getters, setters etc.
     * </div>
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */
    this.$get = ['$$cookieReader', '$$cookieWriter', function ($$cookieReader, $$cookieWriter) {
      return {
        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */
        get: function get(key) {
          return $$cookieReader()[key];
        },

        /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
        getObject: function getObject(key) {
          var value = this.get(key);
          return value ? angular.fromJson(value) : value;
        },

        /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */
        getAll: function getAll() {
          return $$cookieReader();
        },

        /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        put: function put(key, value, options) {
          $$cookieWriter(key, value, calcOptions(options));
        },

        /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        putObject: function putObject(key, value, options) {
          this.put(key, angular.toJson(value), options);
        },

        /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        remove: function remove(key, options) {
          $$cookieWriter(key, undefined, calcOptions(options));
        }
      };
    }];
  }]);

  angular.module('ngCookies').
  /**
   * @ngdoc service
   * @name $cookieStore
   * @deprecated
   * sinceVersion="v1.4.0"
   * Please use the {@link ngCookies.$cookies `$cookies`} service instead.
   *
   * @requires $cookies
   *
   * @description
   * Provides a key-value (string-object) storage, that is backed by session cookies.
   * Objects put or retrieved from this storage are automatically serialized or
   * deserialized by AngularJS's `toJson`/`fromJson`.
   *
   * Requires the {@link ngCookies `ngCookies`} module to be installed.
   *
   * @example
   *
   * ```js
   * angular.module('cookieStoreExample', ['ngCookies'])
   *   .controller('ExampleController', ['$cookieStore', function($cookieStore) {
   *     // Put cookie
   *     $cookieStore.put('myFavorite','oatmeal');
   *     // Get cookie
   *     var favoriteCookie = $cookieStore.get('myFavorite');
   *     // Removing a cookie
   *     $cookieStore.remove('myFavorite');
   *   }]);
   * ```
   */
  factory('$cookieStore', ['$cookies', function ($cookies) {

    return {
      /**
       * @ngdoc method
       * @name $cookieStore#get
       *
       * @description
       * Returns the value of given cookie key
       *
       * @param {string} key Id to use for lookup.
       * @returns {Object} Deserialized cookie value, undefined if the cookie does not exist.
       */
      get: function get(key) {
        return $cookies.getObject(key);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#put
       *
       * @description
       * Sets a value for given cookie key
       *
       * @param {string} key Id for the `value`.
       * @param {Object} value Value to be stored.
       */
      put: function put(key, value) {
        $cookies.putObject(key, value);
      },

      /**
       * @ngdoc method
       * @name $cookieStore#remove
       *
       * @description
       * Remove given cookie
       *
       * @param {string} key Id of the key-value pair to delete.
       */
      remove: function remove(key) {
        $cookies.remove(key);
      }
    };
  }]);

  /**
   * @name $$cookieWriter
   * @requires $document
   *
   * @description
   * This is a private service for writing cookies
   *
   * @param {string} name Cookie name
   * @param {string=} value Cookie value (if undefined, cookie will be deleted)
   * @param {Object=} options Object with options that need to be stored for the cookie.
   */
  function $$CookieWriter($document, $log, $browser) {
    var cookiePath = $browser.baseHref();
    var rawDocument = $document[0];

    function buildCookieString(name, value, options) {
      var path, expires;
      options = options || {};
      expires = options.expires;
      path = angular.isDefined(options.path) ? options.path : cookiePath;
      if (angular.isUndefined(value)) {
        expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
        value = '';
      }
      if (angular.isString(expires)) {
        expires = new Date(expires);
      }

      var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
      str += path ? ';path=' + path : '';
      str += options.domain ? ';domain=' + options.domain : '';
      str += expires ? ';expires=' + expires.toUTCString() : '';
      str += options.secure ? ';secure' : '';

      // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
      // - 300 cookies
      // - 20 cookies per unique domain
      // - 4096 bytes per cookie
      var cookieLength = str.length + 1;
      if (cookieLength > 4096) {
        $log.warn('Cookie \'' + name + '\' possibly not set or overflowed because it was too large (' + cookieLength + ' > 4096 bytes)!');
      }

      return str;
    }

    return function (name, value, options) {
      rawDocument.cookie = buildCookieString(name, value, options);
    };
  }

  $$CookieWriter.$inject = ['$document', '$log', '$browser'];

  angular.module('ngCookies').provider('$$cookieWriter', /** @this */function $$CookieWriterProvider() {
    this.$get = $$CookieWriter;
  });
})(window, window.angular);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(203);
module.exports = 'ngCookies';

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*! 
 * angular-loading-bar v0.9.0
 * https://chieffancypants.github.io/angular-loading-bar
 * Copyright (c) 2016 Wes Cruver
 * License: MIT
 */
/*
 * angular-loading-bar
 *
 * intercepts XHR requests and creates a loading bar.
 * Based on the excellent nprogress work by rstacruz (more info in readme)
 *
 * (c) 2013 Wes Cruver
 * License: MIT
 */

(function () {

  'use strict';

  // Alias the loading bar for various backwards compatibilities since the project has matured:

  angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
  angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);

  /**
   * loadingBarInterceptor service
   *
   * Registers itself as an Angular interceptor and listens for XHR requests.
   */
  angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar']).config(['$httpProvider', function ($httpProvider) {

    var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {

      /**
       * The total number of requests made
       */
      var reqsTotal = 0;

      /**
       * The number of requests completed (either successfully or not)
       */
      var reqsCompleted = 0;

      /**
       * The amount of time spent fetching before showing the loading bar
       */
      var latencyThreshold = cfpLoadingBar.latencyThreshold;

      /**
       * $timeout handle for latencyThreshold
       */
      var startTimeout;

      /**
       * calls cfpLoadingBar.complete() which removes the
       * loading bar from the DOM.
       */
      function setComplete() {
        $timeout.cancel(startTimeout);
        cfpLoadingBar.complete();
        reqsCompleted = 0;
        reqsTotal = 0;
      }

      /**
       * Determine if the response has already been cached
       * @param  {Object}  config the config option from the request
       * @return {Boolean} retrns true if cached, otherwise false
       */
      function isCached(config) {
        var cache;
        var defaultCache = $cacheFactory.get('$http');
        var defaults = $httpProvider.defaults;

        // Choose the proper cache source. Borrowed from angular: $http service
        if ((config.cache || defaults.cache) && config.cache !== false && (config.method === 'GET' || config.method === 'JSONP')) {
          cache = angular.isObject(config.cache) ? config.cache : angular.isObject(defaults.cache) ? defaults.cache : defaultCache;
        }

        var cached = cache !== undefined ? cache.get(config.url) !== undefined : false;

        if (config.cached !== undefined && cached !== config.cached) {
          return config.cached;
        }
        config.cached = cached;
        return cached;
      }

      return {
        'request': function request(config) {
          // Check to make sure this request hasn't already been cached and that
          // the requester didn't explicitly ask us to ignore this request:
          if (!config.ignoreLoadingBar && !isCached(config)) {
            $rootScope.$broadcast('cfpLoadingBar:loading', { url: config.url });
            if (reqsTotal === 0) {
              startTimeout = $timeout(function () {
                cfpLoadingBar.start();
              }, latencyThreshold);
            }
            reqsTotal++;
            cfpLoadingBar.set(reqsCompleted / reqsTotal);
          }
          return config;
        },

        'response': function response(_response) {
          if (!_response || !_response.config) {
            $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
            return _response;
          }

          if (!_response.config.ignoreLoadingBar && !isCached(_response.config)) {
            reqsCompleted++;
            $rootScope.$broadcast('cfpLoadingBar:loaded', { url: _response.config.url, result: _response });
            if (reqsCompleted >= reqsTotal) {
              setComplete();
            } else {
              cfpLoadingBar.set(reqsCompleted / reqsTotal);
            }
          }
          return _response;
        },

        'responseError': function responseError(rejection) {
          if (!rejection || !rejection.config) {
            $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
            return $q.reject(rejection);
          }

          if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
            reqsCompleted++;
            $rootScope.$broadcast('cfpLoadingBar:loaded', { url: rejection.config.url, result: rejection });
            if (reqsCompleted >= reqsTotal) {
              setComplete();
            } else {
              cfpLoadingBar.set(reqsCompleted / reqsTotal);
            }
          }
          return $q.reject(rejection);
        }
      };
    }];

    $httpProvider.interceptors.push(interceptor);
  }]);

  /**
   * Loading Bar
   *
   * This service handles adding and removing the actual element in the DOM.
   * Generally, best practices for DOM manipulation is to take place in a
   * directive, but because the element itself is injected in the DOM only upon
   * XHR requests, and it's likely needed on every view, the best option is to
   * use a service.
   */
  angular.module('cfp.loadingBar', []).provider('cfpLoadingBar', function () {

    this.autoIncrement = true;
    this.includeSpinner = true;
    this.includeBar = true;
    this.latencyThreshold = 100;
    this.startSize = 0.02;
    this.parentSelector = 'body';
    this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
    this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';

    this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
      var $animate;
      var $parentSelector = this.parentSelector,
          loadingBarContainer = angular.element(this.loadingBarTemplate),
          loadingBar = loadingBarContainer.find('div').eq(0),
          spinner = angular.element(this.spinnerTemplate);

      var incTimeout,
          completeTimeout,
          started = false,
          status = 0;

      var autoIncrement = this.autoIncrement;
      var includeSpinner = this.includeSpinner;
      var includeBar = this.includeBar;
      var startSize = this.startSize;

      /**
       * Inserts the loading bar element into the dom, and sets it to 2%
       */
      function _start() {
        if (!$animate) {
          $animate = $injector.get('$animate');
        }

        $timeout.cancel(completeTimeout);

        // do not continually broadcast the started event:
        if (started) {
          return;
        }

        var document = $document[0];
        var parent = document.querySelector ? document.querySelector($parentSelector) : $document.find($parentSelector)[0];

        if (!parent) {
          parent = document.getElementsByTagName('body')[0];
        }

        var $parent = angular.element(parent);
        var $after = parent.lastChild && angular.element(parent.lastChild);

        $rootScope.$broadcast('cfpLoadingBar:started');
        started = true;

        if (includeBar) {
          $animate.enter(loadingBarContainer, $parent, $after);
        }

        if (includeSpinner) {
          $animate.enter(spinner, $parent, loadingBarContainer);
        }

        _set(startSize);
      }

      /**
       * Set the loading bar's width to a certain percent.
       *
       * @param n any value between 0 and 1
       */
      function _set(n) {
        if (!started) {
          return;
        }
        var pct = n * 100 + '%';
        loadingBar.css('width', pct);
        status = n;

        // increment loadingbar to give the illusion that there is always
        // progress but make sure to cancel the previous timeouts so we don't
        // have multiple incs running at the same time.
        if (autoIncrement) {
          $timeout.cancel(incTimeout);
          incTimeout = $timeout(function () {
            _inc();
          }, 250);
        }
      }

      /**
       * Increments the loading bar by a random amount
       * but slows down as it progresses
       */
      function _inc() {
        if (_status() >= 1) {
          return;
        }

        var rnd = 0;

        // TODO: do this mathmatically instead of through conditions

        var stat = _status();
        if (stat >= 0 && stat < 0.25) {
          // Start out between 3 - 6% increments
          rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
        } else if (stat >= 0.25 && stat < 0.65) {
          // increment between 0 - 3%
          rnd = Math.random() * 3 / 100;
        } else if (stat >= 0.65 && stat < 0.9) {
          // increment between 0 - 2%
          rnd = Math.random() * 2 / 100;
        } else if (stat >= 0.9 && stat < 0.99) {
          // finally, increment it .5 %
          rnd = 0.005;
        } else {
          // after 99%, don't increment:
          rnd = 0;
        }

        var pct = _status() + rnd;
        _set(pct);
      }

      function _status() {
        return status;
      }

      function _completeAnimation() {
        status = 0;
        started = false;
      }

      function _complete() {
        if (!$animate) {
          $animate = $injector.get('$animate');
        }

        $rootScope.$broadcast('cfpLoadingBar:completed');
        _set(1);

        $timeout.cancel(completeTimeout);

        // Attempt to aggregate any start/complete calls within 500ms:
        completeTimeout = $timeout(function () {
          var promise = $animate.leave(loadingBarContainer, _completeAnimation);
          if (promise && promise.then) {
            promise.then(_completeAnimation);
          }
          $animate.leave(spinner);
        }, 500);
      }

      return {
        start: _start,
        set: _set,
        status: _status,
        inc: _inc,
        complete: _complete,
        autoIncrement: this.autoIncrement,
        includeSpinner: this.includeSpinner,
        latencyThreshold: this.latencyThreshold,
        parentSelector: this.parentSelector,
        startSize: this.startSize
      };
    }]; //
  }); // wtf javascript. srsly
})(); //

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(205);
module.exports = 'angular-loading-bar';

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @license AngularJS v1.6.9
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {
  'use strict';

  var $resourceMinErr = angular.$$minErr('$resource');

  // Helper functions and regex to lookup a dotted path on an object
  // stopping at undefined/null.  The path must be composed of ASCII
  // identifiers (just like $parse)
  var MEMBER_NAME_REGEX = /^(\.[a-zA-Z_$@][0-9a-zA-Z_$@]*)+$/;

  function isValidDottedPath(path) {
    return path != null && path !== '' && path !== 'hasOwnProperty' && MEMBER_NAME_REGEX.test('.' + path);
  }

  function lookupDottedPath(obj, path) {
    if (!isValidDottedPath(path)) {
      throw $resourceMinErr('badmember', 'Dotted member path "@{0}" is invalid.', path);
    }
    var keys = path.split('.');
    for (var i = 0, ii = keys.length; i < ii && angular.isDefined(obj); i++) {
      var key = keys[i];
      obj = obj !== null ? obj[key] : undefined;
    }
    return obj;
  }

  /**
   * Create a shallow copy of an object and clear other fields from the destination
   */
  function shallowClearAndCopy(src, dst) {
    dst = dst || {};

    angular.forEach(dst, function (value, key) {
      delete dst[key];
    });

    for (var key in src) {
      if (src.hasOwnProperty(key) && !(key.charAt(0) === '$' && key.charAt(1) === '$')) {
        dst[key] = src[key];
      }
    }

    return dst;
  }

  /**
   * @ngdoc module
   * @name ngResource
   * @description
   *
   * The `ngResource` module provides interaction support with RESTful services
   * via the $resource service.
   *
   * See {@link ngResource.$resourceProvider} and {@link ngResource.$resource} for usage.
   */

  /**
   * @ngdoc provider
   * @name $resourceProvider
   *
   * @description
   *
   * Use `$resourceProvider` to change the default behavior of the {@link ngResource.$resource}
   * service.
   *
   * ## Dependencies
   * Requires the {@link ngResource } module to be installed.
   *
   */

  /**
   * @ngdoc service
   * @name $resource
   * @requires $http
   * @requires ng.$log
   * @requires $q
   * @requires ng.$timeout
   *
   * @description
   * A factory which creates a resource object that lets you interact with
   * [RESTful](http://en.wikipedia.org/wiki/Representational_State_Transfer) server-side data sources.
   *
   * The returned resource object has action methods which provide high-level behaviors without
   * the need to interact with the low level {@link ng.$http $http} service.
   *
   * Requires the {@link ngResource `ngResource`} module to be installed.
   *
   * By default, trailing slashes will be stripped from the calculated URLs,
   * which can pose problems with server backends that do not expect that
   * behavior.  This can be disabled by configuring the `$resourceProvider` like
   * this:
   *
   * ```js
       app.config(['$resourceProvider', function($resourceProvider) {
         // Don't strip trailing slashes from calculated URLs
         $resourceProvider.defaults.stripTrailingSlashes = false;
       }]);
   * ```
   *
   * @param {string} url A parameterized URL template with parameters prefixed by `:` as in
   *   `/user/:username`. If you are using a URL with a port number (e.g.
   *   `http://example.com:8080/api`), it will be respected.
   *
   *   If you are using a url with a suffix, just add the suffix, like this:
   *   `$resource('http://example.com/resource.json')` or `$resource('http://example.com/:id.json')`
   *   or even `$resource('http://example.com/resource/:resource_id.:format')`
   *   If the parameter before the suffix is empty, :resource_id in this case, then the `/.` will be
   *   collapsed down to a single `.`.  If you need this sequence to appear and not collapse then you
   *   can escape it with `/\.`.
   *
   * @param {Object=} paramDefaults Default values for `url` parameters. These can be overridden in
   *   `actions` methods. If a parameter value is a function, it will be called every time
   *   a param value needs to be obtained for a request (unless the param was overridden). The function
   *   will be passed the current data value as an argument.
   *
   *   Each key value in the parameter object is first bound to url template if present and then any
   *   excess keys are appended to the url search query after the `?`.
   *
   *   Given a template `/path/:verb` and parameter `{verb:'greet', salutation:'Hello'}` results in
   *   URL `/path/greet?salutation=Hello`.
   *
   *   If the parameter value is prefixed with `@`, then the value for that parameter will be
   *   extracted from the corresponding property on the `data` object (provided when calling actions
   *   with a request body).
   *   For example, if the `defaultParam` object is `{someParam: '@someProp'}` then the value of
   *   `someParam` will be `data.someProp`.
   *   Note that the parameter will be ignored, when calling a "GET" action method (i.e. an action
   *   method that does not accept a request body)
   *
   * @param {Object.<Object>=} actions Hash with declaration of custom actions that will be available
   *   in addition to the default set of resource actions (see below). If a custom action has the same
   *   key as a default action (e.g. `save`), then the default action will be *overwritten*, and not
   *   extended.
   *
   *   The declaration should be created in the format of {@link ng.$http#usage $http.config}:
   *
   *       {action1: {method:?, params:?, isArray:?, headers:?, ...},
   *        action2: {method:?, params:?, isArray:?, headers:?, ...},
   *        ...}
   *
   *   Where:
   *
   *   - **`action`** – {string} – The name of action. This name becomes the name of the method on
   *     your resource object.
   *   - **`method`** – {string} – Case insensitive HTTP method (e.g. `GET`, `POST`, `PUT`,
   *     `DELETE`, `JSONP`, etc).
   *   - **`params`** – {Object=} – Optional set of pre-bound parameters for this action. If any of
   *     the parameter value is a function, it will be called every time when a param value needs to
   *     be obtained for a request (unless the param was overridden). The function will be passed the
   *     current data value as an argument.
   *   - **`url`** – {string} – action specific `url` override. The url templating is supported just
   *     like for the resource-level urls.
   *   - **`isArray`** – {boolean=} – If true then the returned object for this action is an array,
   *     see `returns` section.
   *   - **`transformRequest`** –
   *     `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
   *     transform function or an array of such functions. The transform function takes the http
   *     request body and headers and returns its transformed (typically serialized) version.
   *     By default, transformRequest will contain one function that checks if the request data is
   *     an object and serializes it using `angular.toJson`. To prevent this behavior, set
   *     `transformRequest` to an empty array: `transformRequest: []`
   *   - **`transformResponse`** –
   *     `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
   *     transform function or an array of such functions. The transform function takes the http
   *     response body, headers and status and returns its transformed (typically deserialized)
   *     version.
   *     By default, transformResponse will contain one function that checks if the response looks
   *     like a JSON string and deserializes it using `angular.fromJson`. To prevent this behavior,
   *     set `transformResponse` to an empty array: `transformResponse: []`
   *   - **`cache`** – `{boolean|Cache}` – If true, a default $http cache will be used to cache the
   *     GET request, otherwise if a cache instance built with
   *     {@link ng.$cacheFactory $cacheFactory} is supplied, this cache will be used for
   *     caching.
   *   - **`timeout`** – `{number}` – timeout in milliseconds.<br />
   *     **Note:** In contrast to {@link ng.$http#usage $http.config}, {@link ng.$q promises} are
   *     **not** supported in $resource, because the same value would be used for multiple requests.
   *     If you are looking for a way to cancel requests, you should use the `cancellable` option.
   *   - **`cancellable`** – `{boolean}` – if set to true, the request made by a "non-instance" call
   *     will be cancelled (if not already completed) by calling `$cancelRequest()` on the call's
   *     return value. Calling `$cancelRequest()` for a non-cancellable or an already
   *     completed/cancelled request will have no effect.<br />
   *   - **`withCredentials`** - `{boolean}` - whether to set the `withCredentials` flag on the
   *     XHR object. See
   *     [requests with credentials](https://developer.mozilla.org/en/http_access_control#section_5)
   *     for more information.
   *   - **`responseType`** - `{string}` - see
   *     [requestType](https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#responseType).
   *   - **`interceptor`** - `{Object=}` - The interceptor object has two optional methods -
   *     `response` and `responseError`. Both `response` and `responseError` interceptors get called
   *     with `http response` object. See {@link ng.$http $http interceptors}. In addition, the
   *     resource instance or array object is accessible by the `resource` property of the
   *     `http response` object.
   *     Keep in mind that the associated promise will be resolved with the value returned by the
   *     response interceptor, if one is specified. The default response interceptor returns
   *     `response.resource` (i.e. the resource instance or array).
   *   - **`hasBody`** - `{boolean}` - allows to specify if a request body should be included or not.
   *     If not specified only POST, PUT and PATCH requests will have a body.
   *
   * @param {Object} options Hash with custom settings that should extend the
   *   default `$resourceProvider` behavior.  The supported options are:
   *
   *   - **`stripTrailingSlashes`** – {boolean} – If true then the trailing
   *   slashes from any calculated URL will be stripped. (Defaults to true.)
   *   - **`cancellable`** – {boolean} – If true, the request made by a "non-instance" call will be
   *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return value.
   *   This can be overwritten per action. (Defaults to false.)
   *
   * @returns {Object} A resource "class" object with methods for the default set of resource actions
   *   optionally extended with custom `actions`. The default set contains these actions:
   *   ```js
   *   { 'get':    {method:'GET'},
   *     'save':   {method:'POST'},
   *     'query':  {method:'GET', isArray:true},
   *     'remove': {method:'DELETE'},
   *     'delete': {method:'DELETE'} };
   *   ```
   *
   *   Calling these methods invoke an {@link ng.$http} with the specified http method,
   *   destination and parameters. When the data is returned from the server then the object is an
   *   instance of the resource class. The actions `save`, `remove` and `delete` are available on it
   *   as  methods with the `$` prefix. This allows you to easily perform CRUD operations (create,
   *   read, update, delete) on server-side data like this:
   *   ```js
   *   var User = $resource('/user/:userId', {userId:'@id'});
   *   var user = User.get({userId:123}, function() {
   *     user.abc = true;
   *     user.$save();
   *   });
   *   ```
   *
   *   It is important to realize that invoking a $resource object method immediately returns an
   *   empty reference (object or array depending on `isArray`). Once the data is returned from the
   *   server the existing reference is populated with the actual data. This is a useful trick since
   *   usually the resource is assigned to a model which is then rendered by the view. Having an empty
   *   object results in no rendering, once the data arrives from the server then the object is
   *   populated with the data and the view automatically re-renders itself showing the new data. This
   *   means that in most cases one never has to write a callback function for the action methods.
   *
   *   The action methods on the class object or instance object can be invoked with the following
   *   parameters:
   *
   *   - "class" actions without a body: `Resource.action([parameters], [success], [error])`
   *   - "class" actions with a body: `Resource.action([parameters], postData, [success], [error])`
   *   - instance actions: `instance.$action([parameters], [success], [error])`
   *
   *
   *   When calling instance methods, the instance itself is used as the request body (if the action
   *   should have a body). By default, only actions using `POST`, `PUT` or `PATCH` have request
   *   bodies, but you can use the `hasBody` configuration option to specify whether an action
   *   should have a body or not (regardless of its HTTP method).
   *
   *
   *   Success callback is called with (value (Object|Array), responseHeaders (Function),
   *   status (number), statusText (string)) arguments, where the value is the populated resource
   *   instance or collection object. The error callback is called with (httpResponse) argument.
   *
   *   Class actions return empty instance (with additional properties below).
   *   Instance actions return promise of the action.
   *
   *   The Resource instances and collections have these additional properties:
   *
   *   - `$promise`: the {@link ng.$q promise} of the original server interaction that created this
   *     instance or collection.
   *
   *     On success, the promise is resolved with the same resource instance or collection object,
   *     updated with data from server. This makes it easy to use in
   *     {@link ngRoute.$routeProvider resolve section of $routeProvider.when()} to defer view
   *     rendering until the resource(s) are loaded.
   *
   *     On failure, the promise is rejected with the {@link ng.$http http response} object.
   *
   *     If an interceptor object was provided, the promise will instead be resolved with the value
   *     returned by the interceptor.
   *
   *   - `$resolved`: `true` after first server interaction is completed (either with success or
   *      rejection), `false` before that. Knowing if the Resource has been resolved is useful in
   *      data-binding.
   *
   *   The Resource instances and collections have these additional methods:
   *
   *   - `$cancelRequest`: If there is a cancellable, pending request related to the instance or
   *      collection, calling this method will abort the request.
   *
   *   The Resource instances have these additional methods:
   *
   *   - `toJSON`: It returns a simple object without any of the extra properties added as part of
   *     the Resource API. This object can be serialized through {@link angular.toJson} safely
   *     without attaching AngularJS-specific fields. Notice that `JSON.stringify` (and
   *     `angular.toJson`) automatically use this method when serializing a Resource instance
   *     (see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#toJSON%28%29_behavior)).
   *
   * @example
   *
   * ### Credit card resource
   *
   * ```js
       // Define CreditCard class
       var CreditCard = $resource('/user/:userId/card/:cardId',
        {userId:123, cardId:'@id'}, {
         charge: {method:'POST', params:{charge:true}}
        });
  
       // We can retrieve a collection from the server
       var cards = CreditCard.query(function() {
         // GET: /user/123/card
         // server returns: [ {id:456, number:'1234', name:'Smith'} ];
  
         var card = cards[0];
         // each item is an instance of CreditCard
         expect(card instanceof CreditCard).toEqual(true);
         card.name = "J. Smith";
         // non GET methods are mapped onto the instances
         card.$save();
         // POST: /user/123/card/456 {id:456, number:'1234', name:'J. Smith'}
         // server returns: {id:456, number:'1234', name: 'J. Smith'};
  
         // our custom method is mapped as well.
         card.$charge({amount:9.99});
         // POST: /user/123/card/456?amount=9.99&charge=true {id:456, number:'1234', name:'J. Smith'}
       });
  
       // we can create an instance as well
       var newCard = new CreditCard({number:'0123'});
       newCard.name = "Mike Smith";
       newCard.$save();
       // POST: /user/123/card {number:'0123', name:'Mike Smith'}
       // server returns: {id:789, number:'0123', name: 'Mike Smith'};
       expect(newCard.id).toEqual(789);
   * ```
   *
   * The object returned from this function execution is a resource "class" which has "static" method
   * for each action in the definition.
   *
   * Calling these methods invoke `$http` on the `url` template with the given `method`, `params` and
   * `headers`.
   *
   * @example
   *
   * ### User resource
   *
   * When the data is returned from the server then the object is an instance of the resource type and
   * all of the non-GET methods are available with `$` prefix. This allows you to easily support CRUD
   * operations (create, read, update, delete) on server-side data.
  
     ```js
       var User = $resource('/user/:userId', {userId:'@id'});
       User.get({userId:123}, function(user) {
         user.abc = true;
         user.$save();
       });
     ```
   *
   * It's worth noting that the success callback for `get`, `query` and other methods gets passed
   * in the response that came from the server as well as $http header getter function, so one
   * could rewrite the above example and get access to http headers as:
   *
     ```js
       var User = $resource('/user/:userId', {userId:'@id'});
       User.get({userId:123}, function(user, getResponseHeaders){
         user.abc = true;
         user.$save(function(user, putResponseHeaders) {
           //user => saved user object
           //putResponseHeaders => $http header getter
         });
       });
     ```
   *
   * You can also access the raw `$http` promise via the `$promise` property on the object returned
   *
     ```
       var User = $resource('/user/:userId', {userId:'@id'});
       User.get({userId:123})
           .$promise.then(function(user) {
             $scope.user = user;
           });
     ```
   *
   * @example
   *
   * ### Creating a custom 'PUT' request
   *
   * In this example we create a custom method on our resource to make a PUT request
   * ```js
   *    var app = angular.module('app', ['ngResource', 'ngRoute']);
   *
   *    // Some APIs expect a PUT request in the format URL/object/ID
   *    // Here we are creating an 'update' method
   *    app.factory('Notes', ['$resource', function($resource) {
   *    return $resource('/notes/:id', null,
   *        {
   *            'update': { method:'PUT' }
   *        });
   *    }]);
   *
   *    // In our controller we get the ID from the URL using ngRoute and $routeParams
   *    // We pass in $routeParams and our Notes factory along with $scope
   *    app.controller('NotesCtrl', ['$scope', '$routeParams', 'Notes',
                                        function($scope, $routeParams, Notes) {
   *    // First get a note object from the factory
   *    var note = Notes.get({ id:$routeParams.id });
   *    $id = note.id;
   *
   *    // Now call update passing in the ID first then the object you are updating
   *    Notes.update({ id:$id }, note);
   *
   *    // This will PUT /notes/ID with the note object in the request payload
   *    }]);
   * ```
   *
   * @example
   *
   * ### Cancelling requests
   *
   * If an action's configuration specifies that it is cancellable, you can cancel the request related
   * to an instance or collection (as long as it is a result of a "non-instance" call):
   *
     ```js
       // ...defining the `Hotel` resource...
       var Hotel = $resource('/api/hotel/:id', {id: '@id'}, {
         // Let's make the `query()` method cancellable
         query: {method: 'get', isArray: true, cancellable: true}
       });
  
       // ...somewhere in the PlanVacationController...
       ...
       this.onDestinationChanged = function onDestinationChanged(destination) {
         // We don't care about any pending request for hotels
         // in a different destination any more
         this.availableHotels.$cancelRequest();
  
         // Let's query for hotels in '<destination>'
         // (calls: /api/hotel?location=<destination>)
         this.availableHotels = Hotel.query({location: destination});
       };
     ```
   *
   */
  angular.module('ngResource', ['ng']).info({ angularVersion: '1.6.9' }).provider('$resource', function ResourceProvider() {
    var PROTOCOL_AND_IPV6_REGEX = /^https?:\/\/\[[^\]]*][^/]*/;

    var provider = this;

    /**
     * @ngdoc property
     * @name $resourceProvider#defaults
     * @description
     * Object containing default options used when creating `$resource` instances.
     *
     * The default values satisfy a wide range of usecases, but you may choose to overwrite any of
     * them to further customize your instances. The available properties are:
     *
     * - **stripTrailingSlashes** – `{boolean}` – If true, then the trailing slashes from any
     *   calculated URL will be stripped.<br />
     *   (Defaults to true.)
     * - **cancellable** – `{boolean}` – If true, the request made by a "non-instance" call will be
     *   cancelled (if not already completed) by calling `$cancelRequest()` on the call's return
     *   value. For more details, see {@link ngResource.$resource}. This can be overwritten per
     *   resource class or action.<br />
     *   (Defaults to false.)
     * - **actions** - `{Object.<Object>}` - A hash with default actions declarations. Actions are
     *   high-level methods corresponding to RESTful actions/methods on resources. An action may
     *   specify what HTTP method to use, what URL to hit, if the return value will be a single
     *   object or a collection (array) of objects etc. For more details, see
     *   {@link ngResource.$resource}. The actions can also be enhanced or overwritten per resource
     *   class.<br />
     *   The default actions are:
     *   ```js
     *   {
     *     get: {method: 'GET'},
     *     save: {method: 'POST'},
     *     query: {method: 'GET', isArray: true},
     *     remove: {method: 'DELETE'},
     *     delete: {method: 'DELETE'}
     *   }
     *   ```
     *
     * #### Example
     *
     * For example, you can specify a new `update` action that uses the `PUT` HTTP verb:
     *
     * ```js
     *   angular.
     *     module('myApp').
     *     config(['$resourceProvider', function ($resourceProvider) {
     *       $resourceProvider.defaults.actions.update = {
     *         method: 'PUT'
     *       };
     *     }]);
     * ```
     *
     * Or you can even overwrite the whole `actions` list and specify your own:
     *
     * ```js
     *   angular.
     *     module('myApp').
     *     config(['$resourceProvider', function ($resourceProvider) {
     *       $resourceProvider.defaults.actions = {
     *         create: {method: 'POST'},
     *         get:    {method: 'GET'},
     *         getAll: {method: 'GET', isArray:true},
     *         update: {method: 'PUT'},
     *         delete: {method: 'DELETE'}
     *       };
     *     });
     * ```
     *
     */
    this.defaults = {
      // Strip slashes by default
      stripTrailingSlashes: true,

      // Make non-instance requests cancellable (via `$cancelRequest()`)
      cancellable: false,

      // Default actions configuration
      actions: {
        'get': { method: 'GET' },
        'save': { method: 'POST' },
        'query': { method: 'GET', isArray: true },
        'remove': { method: 'DELETE' },
        'delete': { method: 'DELETE' }
      }
    };

    this.$get = ['$http', '$log', '$q', '$timeout', function ($http, $log, $q, $timeout) {

      var noop = angular.noop,
          forEach = angular.forEach,
          extend = angular.extend,
          copy = angular.copy,
          isArray = angular.isArray,
          isDefined = angular.isDefined,
          isFunction = angular.isFunction,
          isNumber = angular.isNumber,
          encodeUriQuery = angular.$$encodeUriQuery,
          encodeUriSegment = angular.$$encodeUriSegment;

      function Route(template, defaults) {
        this.template = template;
        this.defaults = extend({}, provider.defaults, defaults);
        this.urlParams = {};
      }

      Route.prototype = {
        setUrlParams: function setUrlParams(config, params, actionUrl) {
          var self = this,
              url = actionUrl || self.template,
              val,
              encodedVal,
              protocolAndIpv6 = '';

          var urlParams = self.urlParams = Object.create(null);
          forEach(url.split(/\W/), function (param) {
            if (param === 'hasOwnProperty') {
              throw $resourceMinErr('badname', 'hasOwnProperty is not a valid parameter name.');
            }
            if (!new RegExp('^\\d+$').test(param) && param && new RegExp('(^|[^\\\\]):' + param + '(\\W|$)').test(url)) {
              urlParams[param] = {
                isQueryParamValue: new RegExp('\\?.*=:' + param + '(?:\\W|$)').test(url)
              };
            }
          });
          url = url.replace(/\\:/g, ':');
          url = url.replace(PROTOCOL_AND_IPV6_REGEX, function (match) {
            protocolAndIpv6 = match;
            return '';
          });

          params = params || {};
          forEach(self.urlParams, function (paramInfo, urlParam) {
            val = params.hasOwnProperty(urlParam) ? params[urlParam] : self.defaults[urlParam];
            if (isDefined(val) && val !== null) {
              if (paramInfo.isQueryParamValue) {
                encodedVal = encodeUriQuery(val, true);
              } else {
                encodedVal = encodeUriSegment(val);
              }
              url = url.replace(new RegExp(':' + urlParam + '(\\W|$)', 'g'), function (match, p1) {
                return encodedVal + p1;
              });
            } else {
              url = url.replace(new RegExp('(/?):' + urlParam + '(\\W|$)', 'g'), function (match, leadingSlashes, tail) {
                if (tail.charAt(0) === '/') {
                  return tail;
                } else {
                  return leadingSlashes + tail;
                }
              });
            }
          });

          // strip trailing slashes and set the url (unless this behavior is specifically disabled)
          if (self.defaults.stripTrailingSlashes) {
            url = url.replace(/\/+$/, '') || '/';
          }

          // Collapse `/.` if found in the last URL path segment before the query.
          // E.g. `http://url.com/id/.format?q=x` becomes `http://url.com/id.format?q=x`.
          url = url.replace(/\/\.(?=\w+($|\?))/, '.');
          // Replace escaped `/\.` with `/.`.
          // (If `\.` comes from a param value, it will be encoded as `%5C.`.)
          config.url = protocolAndIpv6 + url.replace(/\/(\\|%5C)\./, '/.');

          // set params - delegate param encoding to $http
          forEach(params, function (value, key) {
            if (!self.urlParams[key]) {
              config.params = config.params || {};
              config.params[key] = value;
            }
          });
        }
      };

      function resourceFactory(url, paramDefaults, actions, options) {
        var route = new Route(url, options);

        actions = extend({}, provider.defaults.actions, actions);

        function extractParams(data, actionParams) {
          var ids = {};
          actionParams = extend({}, paramDefaults, actionParams);
          forEach(actionParams, function (value, key) {
            if (isFunction(value)) {
              value = value(data);
            }
            ids[key] = value && value.charAt && value.charAt(0) === '@' ? lookupDottedPath(data, value.substr(1)) : value;
          });
          return ids;
        }

        function defaultResponseInterceptor(response) {
          return response.resource;
        }

        function Resource(value) {
          shallowClearAndCopy(value || {}, this);
        }

        Resource.prototype.toJSON = function () {
          var data = extend({}, this);
          delete data.$promise;
          delete data.$resolved;
          delete data.$cancelRequest;
          return data;
        };

        forEach(actions, function (action, name) {
          var hasBody = action.hasBody === true || action.hasBody !== false && /^(POST|PUT|PATCH)$/i.test(action.method);
          var numericTimeout = action.timeout;
          var cancellable = isDefined(action.cancellable) ? action.cancellable : route.defaults.cancellable;

          if (numericTimeout && !isNumber(numericTimeout)) {
            $log.debug('ngResource:\n' + '  Only numeric values are allowed as `timeout`.\n' + '  Promises are not supported in $resource, because the same value would ' + 'be used for multiple requests. If you are looking for a way to cancel ' + 'requests, you should use the `cancellable` option.');
            delete action.timeout;
            numericTimeout = null;
          }

          Resource[name] = function (a1, a2, a3, a4) {
            var params = {},
                data,
                success,
                error;

            switch (arguments.length) {
              case 4:
                error = a4;
                success = a3;
              // falls through
              case 3:
              case 2:
                if (isFunction(a2)) {
                  if (isFunction(a1)) {
                    success = a1;
                    error = a2;
                    break;
                  }

                  success = a2;
                  error = a3;
                  // falls through
                } else {
                  params = a1;
                  data = a2;
                  success = a3;
                  break;
                }
              // falls through
              case 1:
                if (isFunction(a1)) success = a1;else if (hasBody) data = a1;else params = a1;
                break;
              case 0:
                break;
              default:
                throw $resourceMinErr('badargs', 'Expected up to 4 arguments [params, data, success, error], got {0} arguments', arguments.length);
            }

            var isInstanceCall = this instanceof Resource;
            var value = isInstanceCall ? data : action.isArray ? [] : new Resource(data);
            var httpConfig = {};
            var responseInterceptor = action.interceptor && action.interceptor.response || defaultResponseInterceptor;
            var responseErrorInterceptor = action.interceptor && action.interceptor.responseError || undefined;
            var hasError = !!error;
            var hasResponseErrorInterceptor = !!responseErrorInterceptor;
            var timeoutDeferred;
            var numericTimeoutPromise;

            forEach(action, function (value, key) {
              switch (key) {
                default:
                  httpConfig[key] = copy(value);
                  break;
                case 'params':
                case 'isArray':
                case 'interceptor':
                case 'cancellable':
                  break;
              }
            });

            if (!isInstanceCall && cancellable) {
              timeoutDeferred = $q.defer();
              httpConfig.timeout = timeoutDeferred.promise;

              if (numericTimeout) {
                numericTimeoutPromise = $timeout(timeoutDeferred.resolve, numericTimeout);
              }
            }

            if (hasBody) httpConfig.data = data;
            route.setUrlParams(httpConfig, extend({}, extractParams(data, action.params || {}), params), action.url);

            var promise = $http(httpConfig).then(function (response) {
              var data = response.data;

              if (data) {
                // Need to convert action.isArray to boolean in case it is undefined
                if (isArray(data) !== !!action.isArray) {
                  throw $resourceMinErr('badcfg', 'Error in resource configuration for action `{0}`. Expected response to ' + 'contain an {1} but got an {2} (Request: {3} {4})', name, action.isArray ? 'array' : 'object', isArray(data) ? 'array' : 'object', httpConfig.method, httpConfig.url);
                }
                if (action.isArray) {
                  value.length = 0;
                  forEach(data, function (item) {
                    if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
                      value.push(new Resource(item));
                    } else {
                      // Valid JSON values may be string literals, and these should not be converted
                      // into objects. These items will not have access to the Resource prototype
                      // methods, but unfortunately there
                      value.push(item);
                    }
                  });
                } else {
                  var promise = value.$promise; // Save the promise
                  shallowClearAndCopy(data, value);
                  value.$promise = promise; // Restore the promise
                }
              }
              response.resource = value;

              return response;
            }, function (response) {
              response.resource = value;
              return $q.reject(response);
            });

            promise = promise['finally'](function () {
              value.$resolved = true;
              if (!isInstanceCall && cancellable) {
                value.$cancelRequest = noop;
                $timeout.cancel(numericTimeoutPromise);
                timeoutDeferred = numericTimeoutPromise = httpConfig.timeout = null;
              }
            });

            promise = promise.then(function (response) {
              var value = responseInterceptor(response);
              (success || noop)(value, response.headers, response.status, response.statusText);
              return value;
            }, hasError || hasResponseErrorInterceptor ? function (response) {
              if (hasError && !hasResponseErrorInterceptor) {
                // Avoid `Possibly Unhandled Rejection` error,
                // but still fulfill the returned promise with a rejection
                promise.catch(noop);
              }
              if (hasError) error(response);
              return hasResponseErrorInterceptor ? responseErrorInterceptor(response) : $q.reject(response);
            } : undefined);

            if (!isInstanceCall) {
              // we are creating instance / collection
              // - set the initial promise
              // - return the instance / collection
              value.$promise = promise;
              value.$resolved = false;
              if (cancellable) value.$cancelRequest = cancelRequest;

              return value;
            }

            // instance call
            return promise;

            function cancelRequest(value) {
              promise.catch(noop);
              if (timeoutDeferred !== null) {
                timeoutDeferred.resolve(value);
              }
            }
          };

          Resource.prototype['$' + name] = function (params, success, error) {
            if (isFunction(params)) {
              error = success;success = params;params = {};
            }
            var result = Resource[name].call(this, params, this, success, error);
            return result.$promise || result;
          };
        });

        return Resource;
      }

      return resourceFactory;
    }];
  });
})(window, window.angular);

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(207);
module.exports = 'ngResource';

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  'use strict';

  angular.module('toastr', []).factory('toastr', toastr);

  toastr.$inject = ['$animate', '$injector', '$document', '$rootScope', '$sce', 'toastrConfig', '$q'];

  function toastr($animate, $injector, $document, $rootScope, $sce, toastrConfig, $q) {
    var container;
    var index = 0;
    var toasts = [];

    var previousToastMessage = '';
    var openToasts = {};

    var containerDefer = $q.defer();

    var toast = {
      active: active,
      clear: clear,
      error: error,
      info: info,
      remove: remove,
      success: success,
      warning: warning,
      refreshTimer: refreshTimer
    };

    return toast;

    /* Public API */
    function active() {
      return toasts.length;
    }

    function clear(toast) {
      // Bit of a hack, I will remove this soon with a BC
      if (arguments.length === 1 && !toast) {
        return;
      }

      if (toast) {
        remove(toast.toastId);
      } else {
        for (var i = 0; i < toasts.length; i++) {
          remove(toasts[i].toastId);
        }
      }
    }

    function error(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.error;
      return _buildNotification(type, message, title, optionsOverride);
    }

    function info(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.info;
      return _buildNotification(type, message, title, optionsOverride);
    }

    function success(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.success;
      return _buildNotification(type, message, title, optionsOverride);
    }

    function warning(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.warning;
      return _buildNotification(type, message, title, optionsOverride);
    }

    function refreshTimer(toast, newTime) {
      if (toast && toast.isOpened && toasts.indexOf(toast) >= 0) {
        toast.scope.refreshTimer(newTime);
      }
    }

    function remove(toastId, wasClicked) {
      var toast = findToast(toastId);

      if (toast && !toast.deleting) {
        // Avoid clicking when fading out
        toast.deleting = true;
        toast.isOpened = false;
        $animate.leave(toast.el).then(function () {
          if (toast.scope.options.onHidden) {
            toast.scope.options.onHidden(!!wasClicked, toast);
          }
          toast.scope.$destroy();
          var index = toasts.indexOf(toast);
          delete openToasts[toast.scope.message];
          toasts.splice(index, 1);
          var maxOpened = toastrConfig.maxOpened;
          if (maxOpened && toasts.length >= maxOpened) {
            toasts[maxOpened - 1].open.resolve();
          }
          if (lastToast()) {
            container.remove();
            container = null;
            containerDefer = $q.defer();
          }
        });
      }

      function findToast(toastId) {
        for (var i = 0; i < toasts.length; i++) {
          if (toasts[i].toastId === toastId) {
            return toasts[i];
          }
        }
      }

      function lastToast() {
        return !toasts.length;
      }
    }

    /* Internal functions */
    function _buildNotification(type, message, title, optionsOverride) {
      if (angular.isObject(title)) {
        optionsOverride = title;
        title = null;
      }

      return _notify({
        iconClass: type,
        message: message,
        optionsOverride: optionsOverride,
        title: title
      });
    }

    function _getOptions() {
      return angular.extend({}, toastrConfig);
    }

    function _createOrGetContainer(options) {
      if (container) {
        return containerDefer.promise;
      }

      container = angular.element('<div></div>');
      container.attr('id', options.containerId);
      container.addClass(options.positionClass);
      container.css({ 'pointer-events': 'auto' });

      var target = angular.element(document.querySelector(options.target));

      if (!target || !target.length) {
        throw 'Target for toasts doesn\'t exist';
      }

      $animate.enter(container, target).then(function () {
        containerDefer.resolve();
      });

      return containerDefer.promise;
    }

    function _notify(map) {
      var options = _getOptions();

      if (shouldExit()) {
        return;
      }

      var newToast = createToast();

      toasts.push(newToast);

      if (ifMaxOpenedAndAutoDismiss()) {
        var oldToasts = toasts.slice(0, toasts.length - options.maxOpened);
        for (var i = 0, len = oldToasts.length; i < len; i++) {
          remove(oldToasts[i].toastId);
        }
      }

      if (maxOpenedNotReached()) {
        newToast.open.resolve();
      }

      newToast.open.promise.then(function () {
        _createOrGetContainer(options).then(function () {
          newToast.isOpened = true;
          if (options.newestOnTop) {
            $animate.enter(newToast.el, container).then(function () {
              newToast.scope.init();
            });
          } else {
            var sibling = container[0].lastChild ? angular.element(container[0].lastChild) : null;
            $animate.enter(newToast.el, container, sibling).then(function () {
              newToast.scope.init();
            });
          }
        });
      });

      return newToast;

      function ifMaxOpenedAndAutoDismiss() {
        return options.autoDismiss && options.maxOpened && toasts.length > options.maxOpened;
      }

      function createScope(toast, map, options) {
        if (options.allowHtml) {
          toast.scope.allowHtml = true;
          toast.scope.title = $sce.trustAsHtml(map.title);
          toast.scope.message = $sce.trustAsHtml(map.message);
        } else {
          toast.scope.title = map.title;
          toast.scope.message = map.message;
        }

        toast.scope.toastType = toast.iconClass;
        toast.scope.toastId = toast.toastId;
        toast.scope.extraData = options.extraData;

        toast.scope.options = {
          extendedTimeOut: options.extendedTimeOut,
          messageClass: options.messageClass,
          onHidden: options.onHidden,
          onShown: generateEvent('onShown'),
          onTap: generateEvent('onTap'),
          progressBar: options.progressBar,
          tapToDismiss: options.tapToDismiss,
          timeOut: options.timeOut,
          titleClass: options.titleClass,
          toastClass: options.toastClass
        };

        if (options.closeButton) {
          toast.scope.options.closeHtml = options.closeHtml;
        }

        function generateEvent(event) {
          if (options[event]) {
            return function () {
              options[event](toast);
            };
          }
        }
      }

      function createToast() {
        var newToast = {
          toastId: index++,
          isOpened: false,
          scope: $rootScope.$new(),
          open: $q.defer()
        };
        newToast.iconClass = map.iconClass;
        if (map.optionsOverride) {
          angular.extend(options, cleanOptionsOverride(map.optionsOverride));
          newToast.iconClass = map.optionsOverride.iconClass || newToast.iconClass;
        }

        createScope(newToast, map, options);

        newToast.el = createToastEl(newToast.scope);

        return newToast;

        function cleanOptionsOverride(options) {
          var badOptions = ['containerId', 'iconClasses', 'maxOpened', 'newestOnTop', 'positionClass', 'preventDuplicates', 'preventOpenDuplicates', 'templates'];
          for (var i = 0, l = badOptions.length; i < l; i++) {
            delete options[badOptions[i]];
          }

          return options;
        }
      }

      function createToastEl(scope) {
        var angularDomEl = angular.element('<div toast></div>'),
            $compile = $injector.get('$compile');
        return $compile(angularDomEl)(scope);
      }

      function maxOpenedNotReached() {
        return options.maxOpened && toasts.length <= options.maxOpened || !options.maxOpened;
      }

      function shouldExit() {
        var isDuplicateOfLast = options.preventDuplicates && map.message === previousToastMessage;
        var isDuplicateOpen = options.preventOpenDuplicates && openToasts[map.message];

        if (isDuplicateOfLast || isDuplicateOpen) {
          return true;
        }

        previousToastMessage = map.message;
        openToasts[map.message] = true;

        return false;
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('toastr').constant('toastrConfig', {
    allowHtml: false,
    autoDismiss: false,
    closeButton: false,
    closeHtml: '<button>&times;</button>',
    containerId: 'toast-container',
    extendedTimeOut: 1000,
    iconClasses: {
      error: 'toast-error',
      info: 'toast-info',
      success: 'toast-success',
      warning: 'toast-warning'
    },
    maxOpened: 0,
    messageClass: 'toast-message',
    newestOnTop: true,
    onHidden: null,
    onShown: null,
    onTap: null,
    positionClass: 'toast-top-right',
    preventDuplicates: false,
    preventOpenDuplicates: false,
    progressBar: false,
    tapToDismiss: true,
    target: 'body',
    templates: {
      toast: 'directives/toast/toast.html',
      progressbar: 'directives/progressbar/progressbar.html'
    },
    timeOut: 5000,
    titleClass: 'toast-title',
    toastClass: 'toast'
  });
})();

(function () {
  'use strict';

  angular.module('toastr').directive('progressBar', progressBar);

  progressBar.$inject = ['toastrConfig'];

  function progressBar(toastrConfig) {
    return {
      require: '^toast',
      templateUrl: function templateUrl() {
        return toastrConfig.templates.progressbar;
      },
      link: linkFunction
    };

    function linkFunction(scope, element, attrs, toastCtrl) {
      var intervalId, currentTimeOut, hideTime;

      toastCtrl.progressBar = scope;

      scope.start = function (duration) {
        if (intervalId) {
          clearInterval(intervalId);
        }

        currentTimeOut = parseFloat(duration);
        hideTime = new Date().getTime() + currentTimeOut;
        intervalId = setInterval(updateProgress, 10);
      };

      scope.stop = function () {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };

      function updateProgress() {
        var percentage = (hideTime - new Date().getTime()) / currentTimeOut * 100;
        element.css('width', percentage + '%');
      }

      scope.$on('$destroy', function () {
        // Failsafe stop
        clearInterval(intervalId);
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('toastr').controller('ToastController', ToastController);

  function ToastController() {
    this.progressBar = null;

    this.startProgressBar = function (duration) {
      if (this.progressBar) {
        this.progressBar.start(duration);
      }
    };

    this.stopProgressBar = function () {
      if (this.progressBar) {
        this.progressBar.stop();
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('toastr').directive('toast', toast);

  toast.$inject = ['$injector', '$interval', 'toastrConfig', 'toastr'];

  function toast($injector, $interval, toastrConfig, toastr) {
    return {
      templateUrl: function templateUrl() {
        return toastrConfig.templates.toast;
      },
      controller: 'ToastController',
      link: toastLinkFunction
    };

    function toastLinkFunction(scope, element, attrs, toastCtrl) {
      var timeout;

      scope.toastClass = scope.options.toastClass;
      scope.titleClass = scope.options.titleClass;
      scope.messageClass = scope.options.messageClass;
      scope.progressBar = scope.options.progressBar;

      if (wantsCloseButton()) {
        var button = angular.element(scope.options.closeHtml),
            $compile = $injector.get('$compile');
        button.addClass('toast-close-button');
        button.attr('ng-click', 'close(true, $event)');
        $compile(button)(scope);
        element.children().prepend(button);
      }

      scope.init = function () {
        if (scope.options.timeOut) {
          timeout = createTimeout(scope.options.timeOut);
        }
        if (scope.options.onShown) {
          scope.options.onShown();
        }
      };

      element.on('mouseenter', function () {
        hideAndStopProgressBar();
        if (timeout) {
          $interval.cancel(timeout);
        }
      });

      scope.tapToast = function () {
        if (angular.isFunction(scope.options.onTap)) {
          scope.options.onTap();
        }
        if (scope.options.tapToDismiss) {
          scope.close(true);
        }
      };

      scope.close = function (wasClicked, $event) {
        if ($event && angular.isFunction($event.stopPropagation)) {
          $event.stopPropagation();
        }
        toastr.remove(scope.toastId, wasClicked);
      };

      scope.refreshTimer = function (newTime) {
        if (timeout) {
          $interval.cancel(timeout);
          timeout = createTimeout(newTime || scope.options.timeOut);
        }
      };

      element.on('mouseleave', function () {
        if (scope.options.timeOut === 0 && scope.options.extendedTimeOut === 0) {
          return;
        }
        scope.$apply(function () {
          scope.progressBar = scope.options.progressBar;
        });
        timeout = createTimeout(scope.options.extendedTimeOut);
      });

      function createTimeout(time) {
        toastCtrl.startProgressBar(time);
        return $interval(function () {
          toastCtrl.stopProgressBar();
          toastr.remove(scope.toastId);
        }, time, 1);
      }

      function hideAndStopProgressBar() {
        scope.progressBar = false;
        toastCtrl.stopProgressBar();
      }

      function wantsCloseButton() {
        return scope.options.closeHtml;
      }
    }
  }
})();

angular.module("toastr").run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/progressbar/progressbar.html", "<div class=\"toast-progress\"></div>\n");
  $templateCache.put("directives/toast/toast.html", "<div class=\"{{toastClass}} {{toastType}}\" ng-click=\"tapToast()\">\n  <div ng-switch on=\"allowHtml\">\n    <div ng-switch-default ng-if=\"title\" class=\"{{titleClass}}\" aria-label=\"{{title}}\">{{title}}</div>\n    <div ng-switch-default class=\"{{messageClass}}\" aria-label=\"{{message}}\">{{message}}</div>\n    <div ng-switch-when=\"true\" ng-if=\"title\" class=\"{{titleClass}}\" ng-bind-html=\"title\"></div>\n    <div ng-switch-when=\"true\" class=\"{{messageClass}}\" ng-bind-html=\"message\"></div>\n  </div>\n  <progress-bar ng-if=\"progressBar\"></progress-bar>\n</div>\n");
}]);

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(209);
module.exports = 'toastr';

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.dateparser', []).service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function ($log, $locale, dateFilter, orderByFilter, filterFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  var localeId;
  var formatCodeToRegex;

  this.init = function () {
    localeId = $locale.id;

    this.parsers = {};
    this.formatters = {};

    formatCodeToRegex = [{
      key: 'yyyy',
      regex: '\\d{4}',
      apply: function apply(value) {
        this.year = +value;
      },
      formatter: function formatter(date) {
        var _date = new Date();
        _date.setFullYear(Math.abs(date.getFullYear()));
        return dateFilter(_date, 'yyyy');
      }
    }, {
      key: 'yy',
      regex: '\\d{2}',
      apply: function apply(value) {
        value = +value;this.year = value < 69 ? value + 2000 : value + 1900;
      },
      formatter: function formatter(date) {
        var _date = new Date();
        _date.setFullYear(Math.abs(date.getFullYear()));
        return dateFilter(_date, 'yy');
      }
    }, {
      key: 'y',
      regex: '\\d{1,4}',
      apply: function apply(value) {
        this.year = +value;
      },
      formatter: function formatter(date) {
        var _date = new Date();
        _date.setFullYear(Math.abs(date.getFullYear()));
        return dateFilter(_date, 'y');
      }
    }, {
      key: 'M!',
      regex: '0?[1-9]|1[0-2]',
      apply: function apply(value) {
        this.month = value - 1;
      },
      formatter: function formatter(date) {
        var value = date.getMonth();
        if (/^[0-9]$/.test(value)) {
          return dateFilter(date, 'MM');
        }

        return dateFilter(date, 'M');
      }
    }, {
      key: 'MMMM',
      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
      apply: function apply(value) {
        this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'MMMM');
      }
    }, {
      key: 'MMM',
      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
      apply: function apply(value) {
        this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'MMM');
      }
    }, {
      key: 'MM',
      regex: '0[1-9]|1[0-2]',
      apply: function apply(value) {
        this.month = value - 1;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'MM');
      }
    }, {
      key: 'M',
      regex: '[1-9]|1[0-2]',
      apply: function apply(value) {
        this.month = value - 1;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'M');
      }
    }, {
      key: 'd!',
      regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
      apply: function apply(value) {
        this.date = +value;
      },
      formatter: function formatter(date) {
        var value = date.getDate();
        if (/^[1-9]$/.test(value)) {
          return dateFilter(date, 'dd');
        }

        return dateFilter(date, 'd');
      }
    }, {
      key: 'dd',
      regex: '[0-2][0-9]{1}|3[0-1]{1}',
      apply: function apply(value) {
        this.date = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'dd');
      }
    }, {
      key: 'd',
      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
      apply: function apply(value) {
        this.date = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'd');
      }
    }, {
      key: 'EEEE',
      regex: $locale.DATETIME_FORMATS.DAY.join('|'),
      formatter: function formatter(date) {
        return dateFilter(date, 'EEEE');
      }
    }, {
      key: 'EEE',
      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
      formatter: function formatter(date) {
        return dateFilter(date, 'EEE');
      }
    }, {
      key: 'HH',
      regex: '(?:0|1)[0-9]|2[0-3]',
      apply: function apply(value) {
        this.hours = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'HH');
      }
    }, {
      key: 'hh',
      regex: '0[0-9]|1[0-2]',
      apply: function apply(value) {
        this.hours = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'hh');
      }
    }, {
      key: 'H',
      regex: '1?[0-9]|2[0-3]',
      apply: function apply(value) {
        this.hours = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'H');
      }
    }, {
      key: 'h',
      regex: '[0-9]|1[0-2]',
      apply: function apply(value) {
        this.hours = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'h');
      }
    }, {
      key: 'mm',
      regex: '[0-5][0-9]',
      apply: function apply(value) {
        this.minutes = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'mm');
      }
    }, {
      key: 'm',
      regex: '[0-9]|[1-5][0-9]',
      apply: function apply(value) {
        this.minutes = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'm');
      }
    }, {
      key: 'sss',
      regex: '[0-9][0-9][0-9]',
      apply: function apply(value) {
        this.milliseconds = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'sss');
      }
    }, {
      key: 'ss',
      regex: '[0-5][0-9]',
      apply: function apply(value) {
        this.seconds = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'ss');
      }
    }, {
      key: 's',
      regex: '[0-9]|[1-5][0-9]',
      apply: function apply(value) {
        this.seconds = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 's');
      }
    }, {
      key: 'a',
      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
      apply: function apply(value) {
        if (this.hours === 12) {
          this.hours = 0;
        }

        if (value === 'PM') {
          this.hours += 12;
        }
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'a');
      }
    }, {
      key: 'Z',
      regex: '[+-]\\d{4}',
      apply: function apply(value) {
        var matches = value.match(/([+-])(\d{2})(\d{2})/),
            sign = matches[1],
            hours = matches[2],
            minutes = matches[3];
        this.hours += toInt(sign + hours);
        this.minutes += toInt(sign + minutes);
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'Z');
      }
    }, {
      key: 'ww',
      regex: '[0-4][0-9]|5[0-3]',
      formatter: function formatter(date) {
        return dateFilter(date, 'ww');
      }
    }, {
      key: 'w',
      regex: '[0-9]|[1-4][0-9]|5[0-3]',
      formatter: function formatter(date) {
        return dateFilter(date, 'w');
      }
    }, {
      key: 'GGGG',
      regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
      formatter: function formatter(date) {
        return dateFilter(date, 'GGGG');
      }
    }, {
      key: 'GGG',
      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
      formatter: function formatter(date) {
        return dateFilter(date, 'GGG');
      }
    }, {
      key: 'GG',
      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
      formatter: function formatter(date) {
        return dateFilter(date, 'GG');
      }
    }, {
      key: 'G',
      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
      formatter: function formatter(date) {
        return dateFilter(date, 'G');
      }
    }];

    if (angular.version.major >= 1 && angular.version.minor > 4) {
      formatCodeToRegex.push({
        key: 'LLLL',
        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
        apply: function apply(value) {
          this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value);
        },
        formatter: function formatter(date) {
          return dateFilter(date, 'LLLL');
        }
      });
    }
  };

  this.init();

  function getFormatCodeToRegex(key) {
    return filterFilter(formatCodeToRegex, { key: key }, true)[0];
  }

  this.getParser = function (key) {
    var f = getFormatCodeToRegex(key);
    return f && f.apply || null;
  };

  this.overrideParser = function (key, parser) {
    var f = getFormatCodeToRegex(key);
    if (f && angular.isFunction(parser)) {
      this.parsers = {};
      f.apply = parser;
    }
  }.bind(this);

  function createParser(format) {
    var map = [],
        regex = format.split('');

    // check for literal values
    var quoteIndex = format.indexOf('\'');
    if (quoteIndex > -1) {
      var inLiteral = false;
      format = format.split('');
      for (var i = quoteIndex; i < format.length; i++) {
        if (inLiteral) {
          if (format[i] === '\'') {
            if (i + 1 < format.length && format[i + 1] === '\'') {
              // escaped single quote
              format[i + 1] = '$';
              regex[i + 1] = '';
            } else {
              // end of literal
              regex[i] = '';
              inLiteral = false;
            }
          }
          format[i] = '$';
        } else {
          if (format[i] === '\'') {
            // start of literal
            format[i] = '$';
            regex[i] = '';
            inLiteral = true;
          }
        }
      }

      format = format.join('');
    }

    angular.forEach(formatCodeToRegex, function (data) {
      var index = format.indexOf(data.key);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({
          index: index,
          key: data.key,
          apply: data.apply,
          matcher: data.regex
        });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  function createFormatter(format) {
    var formatters = [];
    var i = 0;
    var formatter, literalIdx;
    while (i < format.length) {
      if (angular.isNumber(literalIdx)) {
        if (format.charAt(i) === '\'') {
          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
            formatters.push(constructLiteralFormatter(format, literalIdx, i));
            literalIdx = null;
          }
        } else if (i === format.length) {
          while (literalIdx < format.length) {
            formatter = constructFormatterFromIdx(format, literalIdx);
            formatters.push(formatter);
            literalIdx = formatter.endIdx;
          }
        }

        i++;
        continue;
      }

      if (format.charAt(i) === '\'') {
        literalIdx = i;
        i++;
        continue;
      }

      formatter = constructFormatterFromIdx(format, i);

      formatters.push(formatter.parser);
      i = formatter.endIdx;
    }

    return formatters;
  }

  function constructLiteralFormatter(format, literalIdx, endIdx) {
    return function () {
      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
    };
  }

  function constructFormatterFromIdx(format, i) {
    var currentPosStr = format.substr(i);
    for (var j = 0; j < formatCodeToRegex.length; j++) {
      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
        var data = formatCodeToRegex[j];
        return {
          endIdx: i + data.key.length,
          parser: data.formatter
        };
      }
    }

    return {
      endIdx: i + 1,
      parser: function parser() {
        return currentPosStr.charAt(0);
      }
    };
  }

  this.filter = function (date, format) {
    if (!angular.isDate(date) || isNaN(date) || !format) {
      return '';
    }

    format = $locale.DATETIME_FORMATS[format] || format;

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.formatters[format]) {
      this.formatters[format] = createFormatter(format);
    }

    var formatters = this.formatters[format];

    return formatters.reduce(function (str, formatter) {
      return str + formatter(date);
    }, '');
  };

  this.parse = function (input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format, 'apply');
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex),
        tzOffset = false;
    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.matcher === 'Z') {
          tzOffset = true;
        }

        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      var datesetter = tzOffset ? Date.prototype.setUTCFullYear : Date.prototype.setFullYear;
      var timesetter = tzOffset ? Date.prototype.setUTCHours : Date.prototype.setHours;

      if (isValid(fields.year, fields.month, fields.date)) {
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
          dt = new Date(baseDate);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours, fields.minutes, fields.seconds, fields.milliseconds);
        } else {
          dt = new Date(0);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours || 0, fields.minutes || 0, fields.seconds || 0, fields.milliseconds || 0);
        }
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  this.toTimezone = toTimezone;
  this.fromTimezone = fromTimezone;
  this.timezoneToOffset = timezoneToOffset;
  this.addDateMinutes = addDateMinutes;
  this.convertTimezoneToLocal = convertTimezoneToLocal;

  function toTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
  }

  function fromTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
  }

  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
  function timezoneToOffset(timezone, fallback) {
    timezone = timezone.replace(/:/g, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }
}]);

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(211);

var MODULE_NAME = 'ui.bootstrap.module.dateparser';

angular.module(MODULE_NAME, ['ui.bootstrap.dateparser']);

module.exports = MODULE_NAME;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass']).value('$datepickerSuppressError', false).value('$datepickerLiteralWarning', true).constant('uibDatepickerConfig', {
  datepickerMode: 'day',
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  maxDate: null,
  maxMode: 'year',
  minDate: null,
  minMode: 'day',
  monthColumns: 3,
  ngModelOptions: {},
  shortcutPropagation: false,
  showWeeks: true,
  yearColumns: 5,
  yearRows: 4
}).controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser', function ($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop },
      // nullModelCtrl;
  ngModelOptions = {},
      watchListeners = [];

  $element.addClass('uib-datepicker');
  $attrs.$set('role', 'application');

  if (!$scope.datepickerOptions) {
    $scope.datepickerOptions = {};
  }

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  ['customClass', 'dateDisabled', 'datepickerMode', 'formatDay', 'formatDayHeader', 'formatDayTitle', 'formatMonth', 'formatMonthTitle', 'formatYear', 'maxDate', 'maxMode', 'minDate', 'minMode', 'monthColumns', 'showWeeks', 'shortcutPropagation', 'startingDay', 'yearColumns', 'yearRows'].forEach(function (key) {
    switch (key) {
      case 'customClass':
      case 'dateDisabled':
        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
        break;
      case 'datepickerMode':
        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ? $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
        break;
      case 'formatDay':
      case 'formatDayHeader':
      case 'formatDayTitle':
      case 'formatMonth':
      case 'formatMonthTitle':
      case 'formatYear':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $interpolate($scope.datepickerOptions[key])($scope.$parent) : datepickerConfig[key];
        break;
      case 'monthColumns':
      case 'showWeeks':
      case 'shortcutPropagation':
      case 'yearColumns':
      case 'yearRows':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $scope.datepickerOptions[key] : datepickerConfig[key];
        break;
      case 'startingDay':
        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
          self.startingDay = $scope.datepickerOptions.startingDay;
        } else if (angular.isNumber(datepickerConfig.startingDay)) {
          self.startingDay = datepickerConfig.startingDay;
        } else {
          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        }

        break;
      case 'maxDate':
      case 'minDate':
        $scope.$watch('datepickerOptions.' + key, function (value) {
          if (value) {
            if (angular.isDate(value)) {
              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
            } else {
              if ($datepickerLiteralWarning) {
                $log.warn('Literal date support has been deprecated, please switch to date object usage');
              }

              self[key] = new Date(dateFilter(value, 'medium'));
            }
          } else {
            self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) : null;
          }

          self.refreshView();
        });

        break;
      case 'maxMode':
      case 'minMode':
        if ($scope.datepickerOptions[key]) {
          $scope.$watch(function () {
            return $scope.datepickerOptions[key];
          }, function (value) {
            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) || key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
              $scope.datepickerMode = self[key];
              $scope.datepickerOptions.datepickerMode = self[key];
            }
          });
        } else {
          self[key] = $scope[key] = datepickerConfig[key] || null;
        }

        break;
    }
  });

  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if (angular.isDefined($attrs.ngDisabled)) {
    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
      $scope.disabled = disabled;
      self.refreshView();
    }));
  }

  $scope.isActive = function (dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function (ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelOptions = extractOptions(ngModelCtrl);

    if ($scope.datepickerOptions.initDate) {
      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
      $scope.$watch('datepickerOptions.initDate', function (initDate) {
        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
          self.refreshView();
        }
      });
    } else {
      self.activeDate = new Date();
    }

    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
    this.activeDate = !isNaN(date) ? dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) : dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));

    ngModelCtrl.$render = function () {
      self.render();
    };
  };

  this.render = function () {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object');
      }
    }
    this.refreshView();
  };

  this.refreshView = function () {
    if (this.element) {
      $scope.selectedDt = null;
      this._refreshView();
      if ($scope.activeDt) {
        $scope.activeDateId = $scope.activeDt.uid;
      }

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setValidity('dateDisabled', !date || this.element && !this.isDisabled(date));
    }
  };

  this.createDateObject = function (date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
    var today = new Date();
    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
    var time = this.compare(date, today);
    var dt = {
      date: date,
      label: dateParser.filter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      past: time < 0,
      current: time === 0,
      future: time > 0,
      customClass: this.customClass(date) || null
    };

    if (model && this.compare(date, model) === 0) {
      $scope.selectedDt = dt;
    }

    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
      $scope.activeDt = dt;
    }

    return dt;
  };

  this.isDisabled = function (date) {
    return $scope.disabled || this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $scope.dateDisabled && $scope.dateDisabled({ date: date, mode: $scope.datepickerMode });
  };

  this.customClass = function (date) {
    return $scope.customClass({ date: date, mode: $scope.datepickerMode });
  };

  // Split array into smaller arrays
  this.split = function (arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  $scope.select = function (date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

      $scope.$emit('uib:datepicker.mode');
    }

    $scope.$broadcast('uib:datepicker.focus');
  };

  $scope.move = function (direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function (direction) {
    direction = direction || 1;

    if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }

    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

    $scope.$emit('uib:datepicker.mode');
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function focusElement() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('uib:datepicker.focus', focusElement);

  $scope.keydown = function (evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };

  $element.on('keydown', function (evt) {
    $scope.$apply(function () {
      $scope.keydown(evt);
    });
  });

  $scope.$on('$destroy', function () {
    //Clear all watch listeners on destroy
    while (watchListeners.length) {
      watchListeners.shift()();
    }
  });

  function setMode(mode) {
    $scope.datepickerMode = mode;
    $scope.datepickerOptions.datepickerMode = mode;
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) {
      // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = ngModelCtrl.$options || $scope.datepickerOptions.ngModelOptions || datepickerConfig.ngModelOptions || {};

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else {
      // in angular >=1.6 $options is always present
      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
      var timezone = ngModelCtrl.$options.getOption('timezone') || ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) || (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);

      // values passed to createChild override existing values
      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
      .createChild(datepickerConfig.ngModelOptions) // lowest precedence
      .createChild($scope.datepickerOptions.ngModelOptions).createChild(ngModelCtrl.$options) // highest precedence
      .createChild({ timezone: timezone }); // to keep from squashing a non-null value
    }

    return ngModelOptions;
  }
}]).controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  this.step = { months: 1 };
  this.element = $element;
  function getDaysInMonth(year, month) {
    return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
  }

  this.init = function (ctrl) {
    angular.extend(ctrl, this);
    scope.showWeeks = ctrl.showWeeks;
    ctrl.refreshView();
  };

  this.getDates = function (startDate, n) {
    var dates = new Array(n),
        current = new Date(startDate),
        i = 0,
        date;
    while (i < n) {
      date = new Date(current);
      dates[i++] = date;
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  this._refreshView = function () {
    var year = this.activeDate.getFullYear(),
        month = this.activeDate.getMonth(),
        firstDayOfMonth = new Date(this.activeDate);

    firstDayOfMonth.setFullYear(year, month, 1);

    var difference = this.startingDay - firstDayOfMonth.getDay(),
        numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference,
        firstDate = new Date(firstDayOfMonth);

    if (numDisplayedFromPreviousMonth > 0) {
      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
    }

    // 42 is the number of days on a six-week calendar
    var days = this.getDates(firstDate, 42);
    for (var i = 0; i < 42; i++) {
      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
        secondary: days[i].getMonth() !== month,
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.labels = new Array(7);
    for (var j = 0; j < 7; j++) {
      scope.labels[j] = {
        abbr: dateFilter(days[j].date, this.formatDayHeader),
        full: dateFilter(days[j].date, 'EEEE')
      };
    }

    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
    scope.rows = this.split(days, 7);

    if (scope.showWeeks) {
      scope.weekNumbers = [];
      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
          numWeeks = scope.rows.length;
      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
        scope.weekNumbers.push(getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
      }
    }
  };

  this.compare = function (date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  function getISO8601WeekNumber(date) {
    var checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    var time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
  }

  this.handleKeyDown = function (key, evt) {
    var date = this.activeDate.getDate();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 7;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 7;
    } else if (key === 'pageup' || key === 'pagedown') {
      var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
      this.activeDate.setMonth(month, 1);
      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
    } else if (key === 'home') {
      date = 1;
    } else if (key === 'end') {
      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
    }
    this.activeDate.setDate(date);
  };
}]).controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
  this.step = { years: 1 };
  this.element = $element;

  this.init = function (ctrl) {
    angular.extend(ctrl, this);
    ctrl.refreshView();
  };

  this._refreshView = function () {
    var months = new Array(12),
        year = this.activeDate.getFullYear(),
        date;

    for (var i = 0; i < 12; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(year, i, 1);
      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
    scope.rows = this.split(months, this.monthColumns);
    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
  };

  this.compare = function (date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  this.handleKeyDown = function (key, evt) {
    var date = this.activeDate.getMonth();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - this.monthColumns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + this.monthColumns;
    } else if (key === 'pageup' || key === 'pagedown') {
      var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
      this.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.activeDate.setMonth(date);
  };
}]).controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
  var columns, range;
  this.element = $element;

  function getStartingYear(year) {
    return parseInt((year - 1) / range, 10) * range + 1;
  }

  this.yearpickerInit = function () {
    columns = this.yearColumns;
    range = this.yearRows * columns;
    this.step = { years: range };
  };

  this._refreshView = function () {
    var years = new Array(range),
        date;

    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(start + i, 0, 1);
      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = [years[0].label, years[range - 1].label].join(' - ');
    scope.rows = this.split(years, columns);
    scope.columns = columns;
  };

  this.compare = function (date1, date2) {
    return date1.getFullYear() - date2.getFullYear();
  };

  this.handleKeyDown = function (key, evt) {
    var date = this.activeDate.getFullYear();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - columns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + columns;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? -1 : 1) * range;
    } else if (key === 'home') {
      date = getStartingYear(this.activeDate.getFullYear());
    } else if (key === 'end') {
      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
    }
    this.activeDate.setFullYear(date);
  };
}]).directive('uibDatepicker', function () {
  return {
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
    },
    scope: {
      datepickerOptions: '=?'
    },
    require: ['uibDatepicker', '^ngModel'],
    restrict: 'A',
    controller: 'UibDatepickerController',
    controllerAs: 'datepicker',
    link: function link(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
}).directive('uibDaypicker', function () {
  return {
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/day.html';
    },
    require: ['^uibDatepicker', 'uibDaypicker'],
    restrict: 'A',
    controller: 'UibDaypickerController',
    link: function link(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
          daypickerCtrl = ctrls[1];

      daypickerCtrl.init(datepickerCtrl);
    }
  };
}).directive('uibMonthpicker', function () {
  return {
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/month.html';
    },
    require: ['^uibDatepicker', 'uibMonthpicker'],
    restrict: 'A',
    controller: 'UibMonthpickerController',
    link: function link(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
          monthpickerCtrl = ctrls[1];

      monthpickerCtrl.init(datepickerCtrl);
    }
  };
}).directive('uibYearpicker', function () {
  return {
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/year.html';
    },
    require: ['^uibDatepicker', 'uibYearpicker'],
    restrict: 'A',
    controller: 'UibYearpickerController',
    link: function link(scope, element, attrs, ctrls) {
      var ctrl = ctrls[0];
      angular.extend(ctrl, ctrls[1]);
      ctrl.yearpickerInit();

      ctrl.refreshView();
    }
  };
});

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(212);
__webpack_require__(223);
__webpack_require__(243);
__webpack_require__(244);
__webpack_require__(245);
__webpack_require__(246);
__webpack_require__(213);

var MODULE_NAME = 'ui.bootstrap.module.datepicker';

angular.module(MODULE_NAME, ['ui.bootstrap.datepicker', 'uib/template/datepicker/datepicker.html', 'uib/template/datepicker/day.html', 'uib/template/datepicker/month.html', 'uib/template/datepicker/year.html']);

module.exports = MODULE_NAME;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(214);
__webpack_require__(35);
__webpack_require__(247);
__webpack_require__(217);

var MODULE_NAME = 'ui.bootstrap.module.datepickerPopup';

angular.module(MODULE_NAME, ['ui.bootstrap.datepickerPopup', 'uib/template/datepickerPopup/popup.html', 'ui.bootstrap.module.datepicker']);

module.exports = MODULE_NAME;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(142);
__webpack_require__(55);
__webpack_require__(143);
module.exports = __webpack_require__(215);

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position']).value('$datepickerPopupLiteralWarning', true).constant('uibDatepickerPopupConfig', {
  altInputFormats: [],
  appendToBody: false,
  clearText: 'Clear',
  closeOnDateSelection: true,
  closeText: 'Done',
  currentText: 'Today',
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  onOpenFocus: true,
  showButtonBar: true,
  placement: 'auto bottom-left'
}).controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning', function ($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
  var cache = {},
      isHtml5DateInput = false;
  var dateFormat,
      closeOnDateSelection,
      appendToBody,
      onOpenFocus,
      datepickerPopupTemplateUrl,
      datepickerTemplateUrl,
      popupEl,
      datepickerEl,
      scrollParentEl,
      ngModel,
      ngModelOptions,
      $popup,
      altInputFormats,
      watchListeners = [];

  this.init = function (_ngModel_) {
    ngModel = _ngModel_;
    ngModelOptions = extractOptions(ngModel);
    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ? $scope.$parent.$eval($attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;
    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ? $scope.$parent.$eval($attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ? $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ? $attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl;
    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ? $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
    altInputFormats = angular.isDefined($attrs.altInputFormats) ? $scope.$parent.$eval($attrs.altInputFormats) : datepickerPopupConfig.altInputFormats;

    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ? $scope.$parent.$eval($attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;

    if (datepickerPopupConfig.html5Types[$attrs.type]) {
      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
      isHtml5DateInput = true;
    } else {
      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
      $attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
        // Invalidate the $modelValue to ensure that formatters re-run
        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
        if (newDateFormat !== dateFormat) {
          dateFormat = newDateFormat;
          ngModel.$modelValue = null;

          if (!dateFormat) {
            throw new Error('uibDatepickerPopup must have a date format specified.');
          }
        }
      });
    }

    if (!dateFormat) {
      throw new Error('uibDatepickerPopup must have a date format specified.');
    }

    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
      throw new Error('HTML5 date input types do not support custom formats.');
    }

    // popup element used to display calendar
    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

    popupEl.attr({
      'ng-model': 'date',
      'ng-change': 'dateSelection(date)',
      'template-url': datepickerPopupTemplateUrl
    });

    // datepicker element
    datepickerEl = angular.element(popupEl.children()[0]);
    datepickerEl.attr('template-url', datepickerTemplateUrl);

    if (!$scope.datepickerOptions) {
      $scope.datepickerOptions = {};
    }

    if (isHtml5DateInput) {
      if ($attrs.type === 'month') {
        $scope.datepickerOptions.datepickerMode = 'month';
        $scope.datepickerOptions.minMode = 'month';
      }
    }

    datepickerEl.attr('datepicker-options', 'datepickerOptions');

    if (!isHtml5DateInput) {
      // Internal API to maintain the correct ng-invalid-[key] class
      ngModel.$$parserName = 'date';
      ngModel.$validators.date = validator;
      ngModel.$parsers.unshift(parseDate);
      ngModel.$formatters.push(function (value) {
        if (ngModel.$isEmpty(value)) {
          $scope.date = value;
          return value;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }

        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));

        return dateParser.filter($scope.date, dateFormat);
      });
    } else {
      ngModel.$formatters.push(function (value) {
        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
        return value;
      });
    }

    // Detect changes in the view from the text box
    ngModel.$viewChangeListeners.push(function () {
      $scope.date = parseDateString(ngModel.$viewValue);
    });

    $element.on('keydown', inputKeydownBind);

    $popup = $compile(popupEl)($scope);
    // Prevent jQuery cache memory leak (template is now redundant after linking)
    popupEl.remove();

    if (appendToBody) {
      $document.find('body').append($popup);
    } else {
      $element.after($popup);
    }

    $scope.$on('$destroy', function () {
      if ($scope.isOpen === true) {
        if (!$rootScope.$$phase) {
          $scope.$apply(function () {
            $scope.isOpen = false;
          });
        }
      }

      $popup.remove();
      $element.off('keydown', inputKeydownBind);
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);

      //Clear all watch listeners on destroy
      while (watchListeners.length) {
        watchListeners.shift()();
      }
    });
  };

  $scope.getText = function (key) {
    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
  };

  $scope.isDisabled = function (date) {
    if (date === 'today') {
      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
    }

    var dates = {};
    angular.forEach(['minDate', 'maxDate'], function (key) {
      if (!$scope.datepickerOptions[key]) {
        dates[key] = null;
      } else if (angular.isDate($scope.datepickerOptions[key])) {
        dates[key] = new Date($scope.datepickerOptions[key]);
      } else {
        if ($datepickerPopupLiteralWarning) {
          $log.warn('Literal date support has been deprecated, please switch to date object usage');
        }

        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
      }
    });

    return $scope.datepickerOptions && dates.minDate && $scope.compare(date, dates.minDate) < 0 || dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
  };

  $scope.compare = function (date1, date2) {
    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  };

  // Inner change
  $scope.dateSelection = function (dt) {
    $scope.date = dt;
    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
    $element.val(date);
    ngModel.$setViewValue(date);

    if (closeOnDateSelection) {
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.keydown = function (evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.select = function (date, evt) {
    evt.stopPropagation();

    if (date === 'today') {
      var today = new Date();
      if (angular.isDate($scope.date)) {
        date = new Date($scope.date);
        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      } else {
        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
        date.setHours(0, 0, 0, 0);
      }
    }
    $scope.dateSelection(date);
  };

  $scope.close = function (evt) {
    evt.stopPropagation();

    $scope.isOpen = false;
    $element[0].focus();
  };

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if ($attrs.ngDisabled) {
    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (disabled) {
      $scope.disabled = disabled;
    }));
  }

  $scope.$watch('isOpen', function (value) {
    if (value) {
      if (!$scope.disabled) {
        $timeout(function () {
          positionPopup();

          if (onOpenFocus) {
            $scope.$broadcast('uib:datepicker.focus');
          }

          $document.on('click', documentClickBind);

          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
          if (appendToBody || $position.parsePlacement(placement)[2]) {
            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
            if (scrollParentEl) {
              scrollParentEl.on('scroll', positionPopup);
            }
          } else {
            scrollParentEl = null;
          }

          angular.element($window).on('resize', positionPopup);
        }, 0, false);
      } else {
        $scope.isOpen = false;
      }
    } else {
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);
    }
  });

  function cameltoDash(string) {
    return string.replace(/([A-Z])/g, function ($1) {
      return '-' + $1.toLowerCase();
    });
  }

  function parseDateString(viewValue) {
    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
    if (isNaN(date)) {
      for (var i = 0; i < altInputFormats.length; i++) {
        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
        if (!isNaN(date)) {
          return date;
        }
      }
    }
    return date;
  }

  function parseDate(viewValue) {
    if (angular.isNumber(viewValue)) {
      // presumably timestamp to date object
      viewValue = new Date(viewValue);
    }

    if (!viewValue) {
      return null;
    }

    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
      return viewValue;
    }

    if (angular.isString(viewValue)) {
      var date = parseDateString(viewValue);
      if (!isNaN(date)) {
        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
      }
    }

    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
  }

  function validator(modelValue, viewValue) {
    var value = modelValue || viewValue;

    if (!$attrs.ngRequired && !value) {
      return true;
    }

    if (angular.isNumber(value)) {
      value = new Date(value);
    }

    if (!value) {
      return true;
    }

    if (angular.isDate(value) && !isNaN(value)) {
      return true;
    }

    if (angular.isString(value)) {
      return !isNaN(parseDateString(value));
    }

    return false;
  }

  function documentClickBind(event) {
    if (!$scope.isOpen && $scope.disabled) {
      return;
    }

    var popup = $popup[0];
    var dpContainsTarget = $element[0].contains(event.target);
    // The popup node may not be an element node
    // In some browsers (IE) only element nodes have the 'contains' function
    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
      $scope.$apply(function () {
        $scope.isOpen = false;
      });
    }
  }

  function inputKeydownBind(evt) {
    if (evt.which === 27 && $scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function () {
        $scope.isOpen = false;
      });
      $element[0].focus();
    } else if (evt.which === 40 && !$scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function () {
        $scope.isOpen = true;
      });
    }
  }

  function positionPopup() {
    if ($scope.isOpen) {
      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
      var position = $position.positionElements($element, dpElement, placement, appendToBody);
      dpElement.css({ top: position.top + 'px', left: position.left + 'px' });
      if (dpElement.hasClass('uib-position-measure')) {
        dpElement.removeClass('uib-position-measure');
      }
    }
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) {
      // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = angular.isObject(ngModelCtrl.$options) ? ngModelCtrl.$options : {
        timezone: null
      };

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else {
      // in angular >=1.6 $options is always present
      ngModelOptions = ngModelCtrl.$options;
    }

    return ngModelOptions;
  }

  $scope.$on('uib:datepicker.mode', function () {
    $timeout(positionPopup, 0, false);
  });
}]).directive('uibDatepickerPopup', function () {
  return {
    require: ['ngModel', 'uibDatepickerPopup'],
    controller: 'UibDatepickerPopupController',
    scope: {
      datepickerOptions: '=?',
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@'
    },
    link: function link(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0],
          ctrl = ctrls[1];

      ctrl.init(ngModel);
    }
  };
}).directive('uibDatepickerPopupWrap', function () {
  return {
    restrict: 'A',
    transclude: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
    }
  };
});

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
.factory('$$debounce', ['$timeout', function ($timeout) {
  return function (callback, debounceTime) {
    var timeoutPromise;

    return function () {
      var self = this;
      var args = Array.prototype.slice.call(arguments);
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }

      timeoutPromise = $timeout(function () {
        callback.apply(self, args);
      }, debounceTime);
    };
  };
}]);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(218);

var MODULE_NAME = 'ui.bootstrap.module.debounce';

angular.module(MODULE_NAME, ['ui.bootstrap.debounce']);

module.exports = MODULE_NAME;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position']).constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
}).service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function ($document, $rootScope, $$multiMap) {
  var openScope = null;
  var openedContainers = $$multiMap.createNew();

  this.isOnlyOpen = function (dropdownScope, appendTo) {
    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openDropdown = openedDropdowns.reduce(function (toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (openDropdown) {
        return openedDropdowns.length === 1;
      }
    }

    return false;
  };

  this.open = function (dropdownScope, element, appendTo) {
    if (!openScope) {
      $document.on('click', closeDropdown);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openedScopes = openedDropdowns.map(function (dropdown) {
        return dropdown.scope;
      });
      if (openedScopes.indexOf(dropdownScope) === -1) {
        openedContainers.put(appendTo, {
          scope: dropdownScope
        });
      }
    } else {
      openedContainers.put(appendTo, {
        scope: dropdownScope
      });
    }
  };

  this.close = function (dropdownScope, element, appendTo) {
    if (openScope === dropdownScope) {
      $document.off('click', closeDropdown);
      $document.off('keydown', this.keybindFilter);
      openScope = null;
    }

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var dropdownToClose = openedDropdowns.reduce(function (toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (dropdownToClose) {
        openedContainers.remove(appendTo, dropdownToClose);
      }
    }
  };

  var closeDropdown = function closeDropdown(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope || !openScope.isOpen) {
      return;
    }

    if (evt && openScope.getAutoClose() === 'disabled') {
      return;
    }

    if (evt && evt.which === 3) {
      return;
    }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.focusToggleElement();
    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  this.keybindFilter = function (evt) {
    if (!openScope) {
      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    var toggleElement = openScope.getToggleElement();
    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
    if (evt.which === 27) {
      evt.stopPropagation();
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}]).controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
      scope = $scope.$new(),
      // create a child scope so we are not polluting original one
  templateScope,
      appendToOpenClass = dropdownConfig.appendToOpenClass,
      openClass = dropdownConfig.openClass,
      getIsOpen,
      setIsOpen = angular.noop,
      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
      keynavEnabled = false,
      selectedOption = null,
      body = $document.find('body');

  $element.addClass('dropdown');

  this.init = function () {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function (value) {
        scope.isOpen = !!value;
      });
    }

    keynavEnabled = angular.isDefined($attrs.keyboardNav);
  };

  this.toggle = function (open) {
    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    if (angular.isFunction(setIsOpen)) {
      setIsOpen(scope, scope.isOpen);
    }

    return scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function () {
    return scope.isOpen;
  };

  scope.getToggleElement = function () {
    return self.toggleElement;
  };

  scope.getAutoClose = function () {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function () {
    return $element;
  };

  scope.isKeynavEnabled = function () {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function (keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
    angular.element(self.dropdownMenu).find('a') : $element.find('ul').eq(0).find('a');

    switch (keyCode) {
      case 40:
        {
          if (!angular.isNumber(self.selectedOption)) {
            self.selectedOption = 0;
          } else {
            self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;
          }
          break;
        }
      case 38:
        {
          if (!angular.isNumber(self.selectedOption)) {
            self.selectedOption = elems.length - 1;
          } else {
            self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;
          }
          break;
        }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function () {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function () {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  function removeDropdownMenu() {
    $element.append(self.dropdownMenu);
  }

  scope.$watch('isOpen', function (isOpen, wasOpen) {
    var appendTo = null,
        appendToBody = false;

    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }

    if (angular.isDefined($attrs.dropdownAppendToBody)) {
      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
      if (appendToBodyValue !== false) {
        appendToBody = true;
      }
    }

    if (appendToBody && !appendTo) {
      appendTo = body;
    }

    if (appendTo && self.dropdownMenu) {
      if (isOpen) {
        appendTo.append(self.dropdownMenu);
        $element.on('$destroy', removeDropdownMenu);
      } else {
        $element.off('$destroy', removeDropdownMenu);
        removeDropdownMenu();
      }
    }

    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
          css,
          rightalign,
          scrollbarPadding,
          scrollbarWidth = 0;

      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        scrollbarPadding = $position.scrollbarPadding(appendTo);

        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
          scrollbarWidth = scrollbarPadding.scrollbarWidth;
        }

        css.right = window.innerWidth - scrollbarWidth - (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);

        css.top = pos.top - appendOffset.top + 'px';

        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth - (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendTo ? appendTo : $element;
    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);

    if (hasOpenClass === !isOpen) {
      var toggleClass;
      if (appendTo) {
        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
      } else {
        toggleClass = isOpen ? 'addClass' : 'removeClass';
      }
      $animate[toggleClass](openContainer, dropdownOpenClass).then(function () {
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });
    }

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function (dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
            $document.on('keydown', uibDropdownService.keybindFilter);
          });
        });
      } else {
        $document.on('keydown', uibDropdownService.keybindFilter);
      }

      scope.focusToggleElement();
      uibDropdownService.open(scope, $element, appendTo);
    } else {
      uibDropdownService.close(scope, $element, appendTo);
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
}]).directive('uibDropdown', function () {
  return {
    controller: 'UibDropdownController',
    link: function link(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
}).directive('uibDropdownMenu', function () {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function link(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      element.addClass('dropdown-menu');

      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }

      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
}).directive('uibDropdownToggle', function () {
  return {
    require: '?^uibDropdown',
    link: function link(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function toggleDropdown(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function () {
            dropdownCtrl.toggle();
          });
        }
      };

      element.on('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function () {
        element.off('click', toggleDropdown);
      });
    }
  };
});

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(87);
__webpack_require__(35);
__webpack_require__(220);

var MODULE_NAME = 'ui.bootstrap.module.dropdown';

angular.module(MODULE_NAME, ['ui.bootstrap.dropdown']);

module.exports = MODULE_NAME;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(55);
module.exports = __webpack_require__(221);

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(224);

var MODULE_NAME = 'ui.bootstrap.module.isClass';

angular.module(MODULE_NAME, ['ui.bootstrap.isClass']);

module.exports = MODULE_NAME;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', []).directive('uibIsClass', ['$animate', function ($animate) {
  //                    11111111          22222222
  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
  //                    11111111           22222222
  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

  var dataPerTracked = {};

  return {
    restrict: 'A',
    compile: function compile(tElement, tAttrs) {
      var linkedScopes = [];
      var instances = [];
      var expToData = {};
      var lastActivated = null;
      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
      var onExp = onExpMatches[2];
      var expsStr = onExpMatches[1];
      var exps = expsStr.split(',');

      return linkFn;

      function linkFn(scope, element, attrs) {
        linkedScopes.push(scope);
        instances.push({
          scope: scope,
          element: element
        });

        exps.forEach(function (exp, k) {
          addForExp(exp, scope);
        });

        scope.$on('$destroy', removeScope);
      }

      function addForExp(exp, scope) {
        var matches = exp.match(IS_REGEXP);
        var clazz = scope.$eval(matches[1]);
        var compareWithExp = matches[2];
        var data = expToData[exp];
        if (!data) {
          var watchFn = function watchFn(compareWithVal) {
            var newActivated = null;
            instances.some(function (instance) {
              var thisVal = instance.scope.$eval(onExp);
              if (thisVal === compareWithVal) {
                newActivated = instance;
                return true;
              }
            });
            if (data.lastActivated !== newActivated) {
              if (data.lastActivated) {
                $animate.removeClass(data.lastActivated.element, clazz);
              }
              if (newActivated) {
                $animate.addClass(newActivated.element, clazz);
              }
              data.lastActivated = newActivated;
            }
          };
          expToData[exp] = data = {
            lastActivated: null,
            scope: scope,
            watchFn: watchFn,
            compareWithExp: compareWithExp,
            watcher: scope.$watch(compareWithExp, watchFn)
          };
        }
        data.watchFn(scope.$eval(compareWithExp));
      }

      function removeScope(e) {
        var removedScope = e.targetScope;
        var index = linkedScopes.indexOf(removedScope);
        linkedScopes.splice(index, 1);
        instances.splice(index, 1);
        if (linkedScopes.length) {
          var newWatchScope = linkedScopes[0];
          angular.forEach(expToData, function (data) {
            if (data.scope === removedScope) {
              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
              data.scope = newWatchScope;
            }
          });
        } else {
          expToData = {};
        }
      }
    }
  };
}]);

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(87);
__webpack_require__(35);
__webpack_require__(234);
__webpack_require__(248);
__webpack_require__(227);

var MODULE_NAME = 'ui.bootstrap.module.modal';

angular.module(MODULE_NAME, ['ui.bootstrap.modal', 'uib/template/modal/window.html']);

module.exports = MODULE_NAME;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(55);
module.exports = __webpack_require__(225);

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
.provider('$uibResolve', function () {
  var resolve = this;
  this.resolver = null;

  this.setResolver = function (resolver) {
    this.resolver = resolver;
  };

  this.$get = ['$injector', '$q', function ($injector, $q) {
    var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
    return {
      resolve: function resolve(invocables, locals, parent, self) {
        if (resolver) {
          return resolver.resolve(invocables, locals, parent, self);
        }

        var promises = [];

        angular.forEach(invocables, function (value) {
          if (angular.isFunction(value) || angular.isArray(value)) {
            promises.push($q.resolve($injector.invoke(value)));
          } else if (angular.isString(value)) {
            promises.push($q.resolve($injector.get(value)));
          } else {
            promises.push($q.resolve(value));
          }
        });

        return $q.all(promises).then(function (resolves) {
          var resolveObj = {};
          var resolveIter = 0;
          angular.forEach(invocables, function (value, key) {
            resolveObj[key] = resolves[resolveIter++];
          });

          return resolveObj;
        });
      }
    };
  }];
})

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
.directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack', function ($animate, $injector, $modalStack) {
  return {
    restrict: 'A',
    compile: function compile(tElement, tAttrs) {
      tElement.addClass(tAttrs.backdropClass);
      return linkFn;
    }
  };

  function linkFn(scope, element, attrs) {
    if (attrs.modalInClass) {
      $animate.addClass(element, attrs.modalInClass);

      scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
        var done = setIsAsync();
        if (scope.modalOptions.animation) {
          $animate.removeClass(element, attrs.modalInClass).then(done);
        } else {
          done();
        }
      });
    }
  }
}]).directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document', function ($modalStack, $q, $animateCss, $document) {
  return {
    scope: {
      index: '@'
    },
    restrict: 'A',
    transclude: true,
    templateUrl: function templateUrl(tElement, tAttrs) {
      return tAttrs.templateUrl || 'uib/template/modal/window.html';
    },
    link: function link(scope, element, attrs) {
      element.addClass(attrs.windowTopClass || '');
      scope.size = attrs.size;

      scope.close = function (evt) {
        var modal = $modalStack.getTop();
        if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && evt.target === evt.currentTarget) {
          evt.preventDefault();
          evt.stopPropagation();
          $modalStack.dismiss(modal.key, 'backdrop click');
        }
      };

      // moved from template to fix issue #2280
      element.on('click', scope.close);

      // This property is only added to the scope for the purpose of detecting when this directive is rendered.
      // We can detect that by using this property in the template associated with this directive and then use
      // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
      scope.$isRendered = true;

      // Deferred object that will be resolved when this modal is rendered.
      var modalRenderDeferObj = $q.defer();
      // Resolve render promise post-digest
      scope.$$postDigest(function () {
        modalRenderDeferObj.resolve();
      });

      modalRenderDeferObj.promise.then(function () {
        var animationPromise = null;

        if (attrs.modalInClass) {
          animationPromise = $animateCss(element, {
            addClass: attrs.modalInClass
          }).start();

          scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
            var done = setIsAsync();
            $animateCss(element, {
              removeClass: attrs.modalInClass
            }).start().then(done);
          });
        }

        $q.when(animationPromise).then(function () {
          // Notify {@link $modalStack} that modal is rendered.
          var modal = $modalStack.getTop();
          if (modal) {
            $modalStack.modalRendered(modal.key);
          }

          /**
           * If something within the freshly-opened modal already has focus (perhaps via a
           * directive that causes focus) then there's no need to try to focus anything.
           */
          if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
            var inputWithAutofocus = element[0].querySelector('[autofocus]');
            /**
             * Auto-focusing of a freshly-opened modal element causes any child elements
             * with the autofocus attribute to lose focus. This is an issue on touch
             * based devices which will show and then hide the onscreen keyboard.
             * Attempts to refocus the autofocus element via JavaScript will not reopen
             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
             * the modal element if the modal does not contain an autofocus element.
             */
            if (inputWithAutofocus) {
              inputWithAutofocus.focus();
            } else {
              element[0].focus();
            }
          }
        });
      });
    }
  };
}]).directive('uibModalAnimationClass', function () {
  return {
    compile: function compile(tElement, tAttrs) {
      if (tAttrs.modalAnimation) {
        tElement.addClass(tAttrs.uibModalAnimationClass);
      }
    }
  };
}).directive('uibModalTransclude', ['$animate', function ($animate) {
  return {
    link: function link(scope, element, attrs, controller, transclude) {
      transclude(scope.$parent, function (clone) {
        element.empty();
        $animate.enter(clone, element);
      });
    }
  };
}]).factory('$uibModalStack', ['$animate', '$animateCss', '$document', '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition', function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
  var OPENED_MODAL_CLASS = 'modal-open';

  var backdropDomEl, backdropScope;
  var openedWindows = $$stackedMap.createNew();
  var openedClasses = $$multiMap.createNew();
  var $modalStack = {
    NOW_CLOSING_EVENT: 'modal.stack.now-closing'
  };
  var topModalIndex = 0;
  var previousTopOpenedModal = null;
  var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

  //Modal focus behavior
  var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' + 'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' + 'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
  var scrollbarPadding;
  var SNAKE_CASE_REGEXP = /[A-Z]/g;

  // TODO: extract into common dependency with tooltip
  function snake_case(name) {
    var separator = '-';
    return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  function isVisible(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
  }

  function backdropIndex() {
    var topBackdropIndex = -1;
    var opened = openedWindows.keys();
    for (var i = 0; i < opened.length; i++) {
      if (openedWindows.get(opened[i]).value.backdrop) {
        topBackdropIndex = i;
      }
    }

    // If any backdrop exist, ensure that it's index is always
    // right below the top modal
    if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
      topBackdropIndex = topModalIndex;
    }
    return topBackdropIndex;
  }

  $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
    if (backdropScope) {
      backdropScope.index = newBackdropIndex;
    }
  });

  function removeModalWindow(modalInstance, elementToReceiveFocus) {
    var modalWindow = openedWindows.get(modalInstance).value;
    var appendToElement = modalWindow.appendTo;

    //clean up the stack
    openedWindows.remove(modalInstance);
    previousTopOpenedModal = openedWindows.top();
    if (previousTopOpenedModal) {
      topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
    }

    removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
      var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
      openedClasses.remove(modalBodyClass, modalInstance);
      var areAnyOpen = openedClasses.hasKey(modalBodyClass);
      appendToElement.toggleClass(modalBodyClass, areAnyOpen);
      if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
        if (scrollbarPadding.originalRight) {
          appendToElement.css({ paddingRight: scrollbarPadding.originalRight + 'px' });
        } else {
          appendToElement.css({ paddingRight: '' });
        }
        scrollbarPadding = null;
      }
      toggleTopWindowClass(true);
    }, modalWindow.closedDeferred);
    checkRemoveBackdrop();

    //move focus to specified element if available, or else to body
    if (elementToReceiveFocus && elementToReceiveFocus.focus) {
      elementToReceiveFocus.focus();
    } else if (appendToElement.focus) {
      appendToElement.focus();
    }
  }

  // Add or remove "windowTopClass" from the top window in the stack
  function toggleTopWindowClass(toggleSwitch) {
    var modalWindow;

    if (openedWindows.length() > 0) {
      modalWindow = openedWindows.top().value;
      modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
    }
  }

  function checkRemoveBackdrop() {
    //remove backdrop if no longer needed
    if (backdropDomEl && backdropIndex() === -1) {
      var backdropScopeRef = backdropScope;
      removeAfterAnimate(backdropDomEl, backdropScope, function () {
        backdropScopeRef = null;
      });
      backdropDomEl = undefined;
      backdropScope = undefined;
    }
  }

  function removeAfterAnimate(domEl, scope, done, closedDeferred) {
    var asyncDeferred;
    var asyncPromise = null;
    var setIsAsync = function setIsAsync() {
      if (!asyncDeferred) {
        asyncDeferred = $q.defer();
        asyncPromise = asyncDeferred.promise;
      }

      return function asyncDone() {
        asyncDeferred.resolve();
      };
    };
    scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

    // Note that it's intentional that asyncPromise might be null.
    // That's when setIsAsync has not been called during the
    // NOW_CLOSING_EVENT broadcast.
    return $q.when(asyncPromise).then(afterAnimating);

    function afterAnimating() {
      if (afterAnimating.done) {
        return;
      }
      afterAnimating.done = true;

      $animate.leave(domEl).then(function () {
        if (done) {
          done();
        }

        domEl.remove();
        if (closedDeferred) {
          closedDeferred.resolve();
        }
      });

      scope.$destroy();
    }
  }

  $document.on('keydown', keydownListener);

  $rootScope.$on('$destroy', function () {
    $document.off('keydown', keydownListener);
  });

  function keydownListener(evt) {
    if (evt.isDefaultPrevented()) {
      return evt;
    }

    var modal = openedWindows.top();
    if (modal) {
      switch (evt.which) {
        case 27:
          {
            if (modal.value.keyboard) {
              evt.preventDefault();
              $rootScope.$apply(function () {
                $modalStack.dismiss(modal.key, 'escape key press');
              });
            }
            break;
          }
        case 9:
          {
            var list = $modalStack.loadFocusElementList(modal);
            var focusChanged = false;
            if (evt.shiftKey) {
              if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                focusChanged = $modalStack.focusLastFocusableElement(list);
              }
            } else {
              if ($modalStack.isFocusInLastItem(evt, list)) {
                focusChanged = $modalStack.focusFirstFocusableElement(list);
              }
            }

            if (focusChanged) {
              evt.preventDefault();
              evt.stopPropagation();
            }

            break;
          }
      }
    }
  }

  $modalStack.open = function (modalInstance, modal) {
    var modalOpener = $document[0].activeElement,
        modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

    toggleTopWindowClass(false);

    // Store the current top first, to determine what index we ought to use
    // for the current top modal
    previousTopOpenedModal = openedWindows.top();

    openedWindows.add(modalInstance, {
      deferred: modal.deferred,
      renderDeferred: modal.renderDeferred,
      closedDeferred: modal.closedDeferred,
      modalScope: modal.scope,
      backdrop: modal.backdrop,
      keyboard: modal.keyboard,
      openedClass: modal.openedClass,
      windowTopClass: modal.windowTopClass,
      animation: modal.animation,
      appendTo: modal.appendTo
    });

    openedClasses.put(modalBodyClass, modalInstance);

    var appendToElement = modal.appendTo,
        currBackdropIndex = backdropIndex();

    if (currBackdropIndex >= 0 && !backdropDomEl) {
      backdropScope = $rootScope.$new(true);
      backdropScope.modalOptions = modal;
      backdropScope.index = currBackdropIndex;
      backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
      backdropDomEl.attr({
        'class': 'modal-backdrop',
        'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
        'uib-modal-animation-class': 'fade',
        'modal-in-class': 'in'
      });
      if (modal.backdropClass) {
        backdropDomEl.addClass(modal.backdropClass);
      }

      if (modal.animation) {
        backdropDomEl.attr('modal-animation', 'true');
      }
      $compile(backdropDomEl)(backdropScope);
      $animate.enter(backdropDomEl, appendToElement);
      if ($uibPosition.isScrollable(appendToElement)) {
        scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
          appendToElement.css({ paddingRight: scrollbarPadding.right + 'px' });
        }
      }
    }

    var content;
    if (modal.component) {
      content = document.createElement(snake_case(modal.component.name));
      content = angular.element(content);
      content.attr({
        resolve: '$resolve',
        'modal-instance': '$uibModalInstance',
        close: '$close($value)',
        dismiss: '$dismiss($value)'
      });
    } else {
      content = modal.content;
    }

    // Set the top modal index based on the index of the previous top modal
    topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
    var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
    angularDomEl.attr({
      'class': 'modal',
      'template-url': modal.windowTemplateUrl,
      'window-top-class': modal.windowTopClass,
      'role': 'dialog',
      'aria-labelledby': modal.ariaLabelledBy,
      'aria-describedby': modal.ariaDescribedBy,
      'size': modal.size,
      'index': topModalIndex,
      'animate': 'animate',
      'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
      'tabindex': -1,
      'uib-modal-animation-class': 'fade',
      'modal-in-class': 'in'
    }).append(content);
    if (modal.windowClass) {
      angularDomEl.addClass(modal.windowClass);
    }

    if (modal.animation) {
      angularDomEl.attr('modal-animation', 'true');
    }

    appendToElement.addClass(modalBodyClass);
    if (modal.scope) {
      // we need to explicitly add the modal index to the modal scope
      // because it is needed by ngStyle to compute the zIndex property.
      modal.scope.$$topModalIndex = topModalIndex;
    }
    $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

    openedWindows.top().value.modalDomEl = angularDomEl;
    openedWindows.top().value.modalOpener = modalOpener;

    applyAriaHidden(angularDomEl);

    function applyAriaHidden(el) {
      if (!el || el[0].tagName === 'BODY') {
        return;
      }

      getSiblings(el).forEach(function (sibling) {
        var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
            ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

        if (!ariaHiddenCount) {
          ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
        }

        sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
        sibling.setAttribute('aria-hidden', 'true');
      });

      return applyAriaHidden(el.parent());

      function getSiblings(el) {
        var children = el.parent() ? el.parent().children() : [];

        return Array.prototype.filter.call(children, function (child) {
          return child !== el[0];
        });
      }
    }
  };

  function broadcastClosing(modalWindow, resultOrReason, closing) {
    return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
  }

  function unhideBackgroundElements() {
    Array.prototype.forEach.call(document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'), function (hiddenEl) {
      var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
          newHiddenCount = ariaHiddenCount - 1;
      hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

      if (!newHiddenCount) {
        hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
        hiddenEl.removeAttribute('aria-hidden');
      }
    });
  }

  $modalStack.close = function (modalInstance, result) {
    var modalWindow = openedWindows.get(modalInstance);
    unhideBackgroundElements();
    if (modalWindow && broadcastClosing(modalWindow, result, true)) {
      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
      modalWindow.value.deferred.resolve(result);
      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
      return true;
    }

    return !modalWindow;
  };

  $modalStack.dismiss = function (modalInstance, reason) {
    var modalWindow = openedWindows.get(modalInstance);
    unhideBackgroundElements();
    if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
      modalWindow.value.deferred.reject(reason);
      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
      return true;
    }
    return !modalWindow;
  };

  $modalStack.dismissAll = function (reason) {
    var topModal = this.getTop();
    while (topModal && this.dismiss(topModal.key, reason)) {
      topModal = this.getTop();
    }
  };

  $modalStack.getTop = function () {
    return openedWindows.top();
  };

  $modalStack.modalRendered = function (modalInstance) {
    var modalWindow = openedWindows.get(modalInstance);
    if (modalWindow) {
      modalWindow.value.renderDeferred.resolve();
    }
  };

  $modalStack.focusFirstFocusableElement = function (list) {
    if (list.length > 0) {
      list[0].focus();
      return true;
    }
    return false;
  };

  $modalStack.focusLastFocusableElement = function (list) {
    if (list.length > 0) {
      list[list.length - 1].focus();
      return true;
    }
    return false;
  };

  $modalStack.isModalFocused = function (evt, modalWindow) {
    if (evt && modalWindow) {
      var modalDomEl = modalWindow.value.modalDomEl;
      if (modalDomEl && modalDomEl.length) {
        return (evt.target || evt.srcElement) === modalDomEl[0];
      }
    }
    return false;
  };

  $modalStack.isFocusInFirstItem = function (evt, list) {
    if (list.length > 0) {
      return (evt.target || evt.srcElement) === list[0];
    }
    return false;
  };

  $modalStack.isFocusInLastItem = function (evt, list) {
    if (list.length > 0) {
      return (evt.target || evt.srcElement) === list[list.length - 1];
    }
    return false;
  };

  $modalStack.loadFocusElementList = function (modalWindow) {
    if (modalWindow) {
      var modalDomE1 = modalWindow.value.modalDomEl;
      if (modalDomE1 && modalDomE1.length) {
        var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
        return elements ? Array.prototype.filter.call(elements, function (element) {
          return isVisible(element);
        }) : elements;
      }
    }
  };

  return $modalStack;
}]).provider('$uibModal', function () {
  var $modalProvider = {
    options: {
      animation: true,
      backdrop: true, //can also be false or 'static'
      keyboard: true
    },
    $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack', function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
      var $modal = {};

      function getTemplatePromise(options) {
        return options.template ? $q.when(options.template) : $templateRequest(angular.isFunction(options.templateUrl) ? options.templateUrl() : options.templateUrl);
      }

      var promiseChain = null;
      $modal.getPromiseChain = function () {
        return promiseChain;
      };

      $modal.open = function (modalOptions) {
        var modalResultDeferred = $q.defer();
        var modalOpenedDeferred = $q.defer();
        var modalClosedDeferred = $q.defer();
        var modalRenderDeferred = $q.defer();

        //prepare an instance of a modal to be injected into controllers and returned to a caller
        var modalInstance = {
          result: modalResultDeferred.promise,
          opened: modalOpenedDeferred.promise,
          closed: modalClosedDeferred.promise,
          rendered: modalRenderDeferred.promise,
          close: function close(result) {
            return $modalStack.close(modalInstance, result);
          },
          dismiss: function dismiss(reason) {
            return $modalStack.dismiss(modalInstance, reason);
          }
        };

        //merge and clean up options
        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
        modalOptions.resolve = modalOptions.resolve || {};
        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

        if (!modalOptions.appendTo.length) {
          throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
        }

        //verify options
        if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
          throw new Error('One of component or template or templateUrl options is required.');
        }

        var templateAndResolvePromise;
        if (modalOptions.component) {
          templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
        } else {
          templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
        }

        function resolveWithTemplate() {
          return templateAndResolvePromise;
        }

        // Wait for the resolution of the existing promise chain.
        // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
        // Then add to $modalStack and resolve opened.
        // Finally clean up the chain variable if no subsequent modal has overwritten it.
        var samePromise;
        samePromise = promiseChain = $q.all([promiseChain]).then(resolveWithTemplate, resolveWithTemplate).then(function resolveSuccess(tplAndVars) {
          var providedScope = modalOptions.scope || $rootScope;

          var modalScope = providedScope.$new();
          modalScope.$close = modalInstance.close;
          modalScope.$dismiss = modalInstance.dismiss;

          modalScope.$on('$destroy', function () {
            if (!modalScope.$$uibDestructionScheduled) {
              modalScope.$dismiss('$uibUnscheduledDestruction');
            }
          });

          var modal = {
            scope: modalScope,
            deferred: modalResultDeferred,
            renderDeferred: modalRenderDeferred,
            closedDeferred: modalClosedDeferred,
            animation: modalOptions.animation,
            backdrop: modalOptions.backdrop,
            keyboard: modalOptions.keyboard,
            backdropClass: modalOptions.backdropClass,
            windowTopClass: modalOptions.windowTopClass,
            windowClass: modalOptions.windowClass,
            windowTemplateUrl: modalOptions.windowTemplateUrl,
            ariaLabelledBy: modalOptions.ariaLabelledBy,
            ariaDescribedBy: modalOptions.ariaDescribedBy,
            size: modalOptions.size,
            openedClass: modalOptions.openedClass,
            appendTo: modalOptions.appendTo
          };

          var component = {};
          var ctrlInstance,
              ctrlInstantiate,
              ctrlLocals = {};

          if (modalOptions.component) {
            constructLocals(component, false, true, false);
            component.name = modalOptions.component;
            modal.component = component;
          } else if (modalOptions.controller) {
            constructLocals(ctrlLocals, true, false, true);

            // the third param will make the controller instantiate later,private api
            // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
            ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
            if (modalOptions.controllerAs && modalOptions.bindToController) {
              ctrlInstance = ctrlInstantiate.instance;
              ctrlInstance.$close = modalScope.$close;
              ctrlInstance.$dismiss = modalScope.$dismiss;
              angular.extend(ctrlInstance, {
                $resolve: ctrlLocals.$scope.$resolve
              }, providedScope);
            }

            ctrlInstance = ctrlInstantiate();

            if (angular.isFunction(ctrlInstance.$onInit)) {
              ctrlInstance.$onInit();
            }
          }

          if (!modalOptions.component) {
            modal.content = tplAndVars[0];
          }

          $modalStack.open(modalInstance, modal);
          modalOpenedDeferred.resolve(true);

          function constructLocals(obj, template, instanceOnScope, injectable) {
            obj.$scope = modalScope;
            obj.$scope.$resolve = {};
            if (instanceOnScope) {
              obj.$scope.$uibModalInstance = modalInstance;
            } else {
              obj.$uibModalInstance = modalInstance;
            }

            var resolves = template ? tplAndVars[1] : tplAndVars;
            angular.forEach(resolves, function (value, key) {
              if (injectable) {
                obj[key] = value;
              }

              obj.$scope.$resolve[key] = value;
            });
          }
        }, function resolveError(reason) {
          modalOpenedDeferred.reject(reason);
          modalResultDeferred.reject(reason);
        })['finally'](function () {
          if (promiseChain === samePromise) {
            promiseChain = null;
          }
        });

        return modalInstance;
      };

      return $modal;
    }]
  };

  return $modalProvider;
});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.multiMap', [])
/**
 * A helper, internal data structure that stores all references attached to key
 */
.factory('$$multiMap', function () {
  return {
    createNew: function createNew() {
      var map = {};

      return {
        entries: function entries() {
          return Object.keys(map).map(function (key) {
            return {
              key: key,
              value: map[key]
            };
          });
        },
        get: function get(key) {
          return map[key];
        },
        hasKey: function hasKey(key) {
          return !!map[key];
        },
        keys: function keys() {
          return Object.keys(map);
        },
        put: function put(key, value) {
          if (!map[key]) {
            map[key] = [];
          }

          map[key].push(value);
        },
        remove: function remove(key, value) {
          var values = map[key];

          if (!values) {
            return;
          }

          var idx = values.indexOf(value);

          if (idx !== -1) {
            values.splice(idx, 1);
          }

          if (!values.length) {
            delete map[key];
          }
        }
      };
    }
  };
});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(231);
__webpack_require__(236);
__webpack_require__(249);
__webpack_require__(230);

var MODULE_NAME = 'ui.bootstrap.module.pagination';

angular.module(MODULE_NAME, ['ui.bootstrap.pagination', 'uib/template/pagination/pagination.html']);

module.exports = MODULE_NAME;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex']).controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
      rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
      forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
      boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
      pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) {
    return $scope.$parent.$eval($attrs.pageLabel, { $page: idx });
  } : angular.identity;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
  $attrs.$set('role', 'menu');

  uibPaging.create(this, $scope, $attrs);

  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }

  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1,
        endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, pageLabel(number), number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) {
          //need ellipsis for all options unless range is too close to beginning
          var previousPageSet = makePage(startPage - 1, '...', false);
          pages.unshift(previousPageSet);
        }
        if (boundaryLinkNumbers) {
          if (startPage === 3) {
            //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }

      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) {
          //need ellipsis for all options unless range is too close to end
          var nextPageSet = makePage(endPage + 1, '...', false);
          pages.push(nextPageSet);
        }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) {
            //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }

  var originalRender = this.render;
  this.render = function () {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}]).constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true,
  forceEllipses: false
}).directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled: '='
    },
    require: ['uibPagination', '?ngModel'],
    restrict: 'A',
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
    },
    link: function link(scope, element, attrs, ctrls) {
      element.addClass('pagination');
      var paginationCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(232);

var MODULE_NAME = 'ui.bootstrap.module.paging';

angular.module(MODULE_NAME, ['ui.bootstrap.paging']);

module.exports = MODULE_NAME;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
.factory('uibPaging', ['$parse', function ($parse) {
  return {
    create: function create(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
      ctrl._watchers = [];

      ctrl.init = function (ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;

        ngModelCtrl.$render = function () {
          ctrl.render();
        };

        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }

        $scope.$watch('totalItems', function (newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };

      ctrl.calculateTotalPages = function () {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };

      ctrl.render = function () {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };

      $scope.selectPage = function (page, evt) {
        if (evt) {
          evt.preventDefault();
        }

        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.getText = function (key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };

      $scope.noPrevious = function () {
        return $scope.page === 1;
      };

      $scope.noNext = function () {
        return $scope.page === $scope.totalPages;
      };

      ctrl.updatePage = function () {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.$on('$destroy', function () {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
.factory('$uibPosition', ['$document', '$window', function ($document, $window) {
  /**
   * Used by scrollbarWidth() function to cache scrollbar's width.
   * Do not access this variable directly, use scrollbarWidth() instead.
   */
  var SCROLLBAR_WIDTH;
  /**
   * scrollbar on body and html element in IE and Edge overlay
   * content and should be considered 0 width.
   */
  var BODY_SCROLLBAR_WIDTH;
  var OVERFLOW_REGEX = {
    normal: /(auto|scroll)/,
    hidden: /(auto|scroll|hidden)/
  };
  var PLACEMENT_REGEX = {
    auto: /\s?auto?\s?/i,
    primary: /^(top|bottom|left|right)$/,
    secondary: /^(top|bottom|left|right|center)$/,
    vertical: /^(top|bottom)$/
  };
  var BODY_REGEX = /(HTML|BODY)/;

  return {

    /**
     * Provides a raw DOM element from a jQuery/jQLite element.
     *
     * @param {element} elem - The element to convert.
     *
     * @returns {element} A HTML element.
     */
    getRawNode: function getRawNode(elem) {
      return elem.nodeName ? elem : elem[0] || elem;
    },

    /**
     * Provides a parsed number for a style property.  Strips
     * units and casts invalid numbers to 0.
     *
     * @param {string} value - The style value to parse.
     *
     * @returns {number} A valid number.
     */
    parseStyle: function parseStyle(value) {
      value = parseFloat(value);
      return isFinite(value) ? value : 0;
    },

    /**
     * Provides the closest positioned ancestor.
     *
     * @param {element} element - The element to get the offest parent for.
     *
     * @returns {element} The closest positioned ancestor.
     */
    offsetParent: function offsetParent(elem) {
      elem = this.getRawNode(elem);

      var offsetParent = elem.offsetParent || $document[0].documentElement;

      function isStaticPositioned(el) {
        return ($window.getComputedStyle(el).position || 'static') === 'static';
      }

      while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
        offsetParent = offsetParent.offsetParent;
      }

      return offsetParent || $document[0].documentElement;
    },

    /**
     * Provides the scrollbar width, concept from TWBS measureScrollbar()
     * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
     * In IE and Edge, scollbar on body and html element overlay and should
     * return a width of 0.
     *
     * @returns {number} The width of the browser scollbar.
     */
    scrollbarWidth: function scrollbarWidth(isBody) {
      if (isBody) {
        if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
          var bodyElem = $document.find('body');
          bodyElem.addClass('uib-position-body-scrollbar-measure');
          BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
          BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
          bodyElem.removeClass('uib-position-body-scrollbar-measure');
        }
        return BODY_SCROLLBAR_WIDTH;
      }

      if (angular.isUndefined(SCROLLBAR_WIDTH)) {
        var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
        $document.find('body').append(scrollElem);
        SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
        SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
        scrollElem.remove();
      }

      return SCROLLBAR_WIDTH;
    },

    /**
     * Provides the padding required on an element to replace the scrollbar.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**scrollbarWidth**: the width of the scrollbar</li>
     *     <li>**widthOverflow**: whether the the width is overflowing</li>
     *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
     *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
     *     <li>**heightOverflow**: whether the the height is overflowing</li>
     *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
     *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
     *   </ul>
     */
    scrollbarPadding: function scrollbarPadding(elem) {
      elem = this.getRawNode(elem);

      var elemStyle = $window.getComputedStyle(elem);
      var paddingRight = this.parseStyle(elemStyle.paddingRight);
      var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
      var scrollParent = this.scrollParent(elem, false, true);
      var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

      return {
        scrollbarWidth: scrollbarWidth,
        widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
        right: paddingRight + scrollbarWidth,
        originalRight: paddingRight,
        heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
        bottom: paddingBottom + scrollbarWidth,
        originalBottom: paddingBottom
      };
    },

    /**
     * Checks to see if the element is scrollable.
     *
     * @param {element} elem - The element to check.
     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
     *   default is false.
     *
     * @returns {boolean} Whether the element is scrollable.
     */
    isScrollable: function isScrollable(elem, includeHidden) {
      elem = this.getRawNode(elem);

      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
      var elemStyle = $window.getComputedStyle(elem);
      return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
    },

    /**
     * Provides the closest scrollable ancestor.
     * A port of the jQuery UI scrollParent method:
     * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
     *
     * @param {element} elem - The element to find the scroll parent of.
     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
     *   default is false.
     * @param {boolean=} [includeSelf=false] - Should the element being passed be
     * included in the scrollable llokup.
     *
     * @returns {element} A HTML element.
     */
    scrollParent: function scrollParent(elem, includeHidden, includeSelf) {
      elem = this.getRawNode(elem);

      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
      var documentEl = $document[0].documentElement;
      var elemStyle = $window.getComputedStyle(elem);
      if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
        return elem;
      }
      var excludeStatic = elemStyle.position === 'absolute';
      var scrollParent = elem.parentElement || documentEl;

      if (scrollParent === documentEl || elemStyle.position === 'fixed') {
        return documentEl;
      }

      while (scrollParent.parentElement && scrollParent !== documentEl) {
        var spStyle = $window.getComputedStyle(scrollParent);
        if (excludeStatic && spStyle.position !== 'static') {
          excludeStatic = false;
        }

        if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
          break;
        }
        scrollParent = scrollParent.parentElement;
      }

      return scrollParent;
    },

    /**
     * Provides read-only equivalent of jQuery's position function:
     * http://api.jquery.com/position/ - distance to closest positioned
     * ancestor.  Does not account for margins by default like jQuery position.
     *
     * @param {element} elem - The element to caclulate the position on.
     * @param {boolean=} [includeMargins=false] - Should margins be accounted
     * for, default is false.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**width**: the width of the element</li>
     *     <li>**height**: the height of the element</li>
     *     <li>**top**: distance to top edge of offset parent</li>
     *     <li>**left**: distance to left edge of offset parent</li>
     *   </ul>
     */
    position: function position(elem, includeMagins) {
      elem = this.getRawNode(elem);

      var elemOffset = this.offset(elem);
      if (includeMagins) {
        var elemStyle = $window.getComputedStyle(elem);
        elemOffset.top -= this.parseStyle(elemStyle.marginTop);
        elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
      }
      var parent = this.offsetParent(elem);
      var parentOffset = { top: 0, left: 0 };

      if (parent !== $document[0].documentElement) {
        parentOffset = this.offset(parent);
        parentOffset.top += parent.clientTop - parent.scrollTop;
        parentOffset.left += parent.clientLeft - parent.scrollLeft;
      }

      return {
        width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
        height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
        top: Math.round(elemOffset.top - parentOffset.top),
        left: Math.round(elemOffset.left - parentOffset.left)
      };
    },

    /**
     * Provides read-only equivalent of jQuery's offset function:
     * http://api.jquery.com/offset/ - distance to viewport.  Does
     * not account for borders, margins, or padding on the body
     * element.
     *
     * @param {element} elem - The element to calculate the offset on.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**width**: the width of the element</li>
     *     <li>**height**: the height of the element</li>
     *     <li>**top**: distance to top edge of viewport</li>
     *     <li>**right**: distance to bottom edge of viewport</li>
     *   </ul>
     */
    offset: function offset(elem) {
      elem = this.getRawNode(elem);

      var elemBCR = elem.getBoundingClientRect();
      return {
        width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
        height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
        top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
        left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
      };
    },

    /**
     * Provides offset distance to the closest scrollable ancestor
     * or viewport.  Accounts for border and scrollbar width.
     *
     * Right and bottom dimensions represent the distance to the
     * respective edge of the viewport element.  If the element
     * edge extends beyond the viewport, a negative value will be
     * reported.
     *
     * @param {element} elem - The element to get the viewport offset for.
     * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
     * of the first scrollable element, default is false.
     * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
     * be accounted for, default is true.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**top**: distance to the top content edge of viewport element</li>
     *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
     *     <li>**left**: distance to the left content edge of viewport element</li>
     *     <li>**right**: distance to the right content edge of viewport element</li>
     *   </ul>
     */
    viewportOffset: function viewportOffset(elem, useDocument, includePadding) {
      elem = this.getRawNode(elem);
      includePadding = includePadding !== false ? true : false;

      var elemBCR = elem.getBoundingClientRect();
      var offsetBCR = { top: 0, left: 0, bottom: 0, right: 0 };

      var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
      var offsetParentBCR = offsetParent.getBoundingClientRect();

      offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
      offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
      if (offsetParent === $document[0].documentElement) {
        offsetBCR.top += $window.pageYOffset;
        offsetBCR.left += $window.pageXOffset;
      }
      offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
      offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

      if (includePadding) {
        var offsetParentStyle = $window.getComputedStyle(offsetParent);
        offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
        offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
        offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
        offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
      }

      return {
        top: Math.round(elemBCR.top - offsetBCR.top),
        bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
        left: Math.round(elemBCR.left - offsetBCR.left),
        right: Math.round(offsetBCR.right - elemBCR.right)
      };
    },

    /**
     * Provides an array of placement values parsed from a placement string.
     * Along with the 'auto' indicator, supported placement strings are:
     *   <ul>
     *     <li>top: element on top, horizontally centered on host element.</li>
     *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
     *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
     *     <li>bottom: element on bottom, horizontally centered on host element.</li>
     *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
     *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
     *     <li>left: element on left, vertically centered on host element.</li>
     *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
     *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
     *     <li>right: element on right, vertically centered on host element.</li>
     *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
     *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
     *   </ul>
     * A placement string with an 'auto' indicator is expected to be
     * space separated from the placement, i.e: 'auto bottom-left'  If
     * the primary and secondary placement values do not match 'top,
     * bottom, left, right' then 'top' will be the primary placement and
     * 'center' will be the secondary placement.  If 'auto' is passed, true
     * will be returned as the 3rd value of the array.
     *
     * @param {string} placement - The placement string to parse.
     *
     * @returns {array} An array with the following values
     * <ul>
     *   <li>**[0]**: The primary placement.</li>
     *   <li>**[1]**: The secondary placement.</li>
     *   <li>**[2]**: If auto is passed: true, else undefined.</li>
     * </ul>
     */
    parsePlacement: function parsePlacement(placement) {
      var autoPlace = PLACEMENT_REGEX.auto.test(placement);
      if (autoPlace) {
        placement = placement.replace(PLACEMENT_REGEX.auto, '');
      }

      placement = placement.split('-');

      placement[0] = placement[0] || 'top';
      if (!PLACEMENT_REGEX.primary.test(placement[0])) {
        placement[0] = 'top';
      }

      placement[1] = placement[1] || 'center';
      if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
        placement[1] = 'center';
      }

      if (autoPlace) {
        placement[2] = true;
      } else {
        placement[2] = false;
      }

      return placement;
    },

    /**
     * Provides coordinates for an element to be positioned relative to
     * another element.  Passing 'auto' as part of the placement parameter
     * will enable smart placement - where the element fits. i.e:
     * 'auto left-top' will check to see if there is enough space to the left
     * of the hostElem to fit the targetElem, if not place right (same for secondary
     * top placement).  Available space is calculated using the viewportOffset
     * function.
     *
     * @param {element} hostElem - The element to position against.
     * @param {element} targetElem - The element to position.
     * @param {string=} [placement=top] - The placement for the targetElem,
     *   default is 'top'. 'center' is assumed as secondary placement for
     *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
     *   <ul>
     *     <li>top</li>
     *     <li>top-right</li>
     *     <li>top-left</li>
     *     <li>bottom</li>
     *     <li>bottom-left</li>
     *     <li>bottom-right</li>
     *     <li>left</li>
     *     <li>left-top</li>
     *     <li>left-bottom</li>
     *     <li>right</li>
     *     <li>right-top</li>
     *     <li>right-bottom</li>
     *   </ul>
     * @param {boolean=} [appendToBody=false] - Should the top and left values returned
     *   be calculated from the body element, default is false.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**top**: Value for targetElem top.</li>
     *     <li>**left**: Value for targetElem left.</li>
     *     <li>**placement**: The resolved placement.</li>
     *   </ul>
     */
    positionElements: function positionElements(hostElem, targetElem, placement, appendToBody) {
      hostElem = this.getRawNode(hostElem);
      targetElem = this.getRawNode(targetElem);

      // need to read from prop to support tests.
      var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
      var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

      placement = this.parsePlacement(placement);

      var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
      var targetElemPos = { top: 0, left: 0, placement: '' };

      if (placement[2]) {
        var viewportOffset = this.viewportOffset(hostElem, appendToBody);

        var targetElemStyle = $window.getComputedStyle(targetElem);
        var adjustedSize = {
          width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
          height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
        };

        placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' : placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' : placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' : placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' : placement[0];

        placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' : placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' : placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' : placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' : placement[1];

        if (placement[1] === 'center') {
          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
              placement[1] = 'left';
            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
              placement[1] = 'right';
            }
          } else {
            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
              placement[1] = 'top';
            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
              placement[1] = 'bottom';
            }
          }
        }
      }

      switch (placement[0]) {
        case 'top':
          targetElemPos.top = hostElemPos.top - targetHeight;
          break;
        case 'bottom':
          targetElemPos.top = hostElemPos.top + hostElemPos.height;
          break;
        case 'left':
          targetElemPos.left = hostElemPos.left - targetWidth;
          break;
        case 'right':
          targetElemPos.left = hostElemPos.left + hostElemPos.width;
          break;
      }

      switch (placement[1]) {
        case 'top':
          targetElemPos.top = hostElemPos.top;
          break;
        case 'bottom':
          targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
          break;
        case 'left':
          targetElemPos.left = hostElemPos.left;
          break;
        case 'right':
          targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
          break;
        case 'center':
          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
          } else {
            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
          }
          break;
      }

      targetElemPos.top = Math.round(targetElemPos.top);
      targetElemPos.left = Math.round(targetElemPos.left);
      targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

      return targetElemPos;
    },

    /**
     * Provides a way to adjust the top positioning after first
     * render to correctly align element to top after content
     * rendering causes resized element height
     *
     * @param {array} placementClasses - The array of strings of classes
     * element should have.
     * @param {object} containerPosition - The object with container
     * position information
     * @param {number} initialHeight - The initial height for the elem.
     * @param {number} currentHeight - The current height for the elem.
     */
    adjustTop: function adjustTop(placementClasses, containerPosition, initialHeight, currentHeight) {
      if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
        return {
          top: containerPosition.top - currentHeight + 'px'
        };
      }
    },

    /**
     * Provides a way for positioning tooltip & dropdown
     * arrows when using placement options beyond the standard
     * left, right, top, or bottom.
     *
     * @param {element} elem - The tooltip/dropdown element.
     * @param {string} placement - The placement for the elem.
     */
    positionArrow: function positionArrow(elem, placement) {
      elem = this.getRawNode(elem);

      var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
      if (!innerElem) {
        return;
      }

      var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

      var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
      if (!arrowElem) {
        return;
      }

      var arrowCss = {
        top: '',
        bottom: '',
        left: '',
        right: ''
      };

      placement = this.parsePlacement(placement);
      if (placement[1] === 'center') {
        // no adjustment necessary - just reset styles
        angular.element(arrowElem).css(arrowCss);
        return;
      }

      var borderProp = 'border-' + placement[0] + '-width';
      var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

      var borderRadiusProp = 'border-';
      if (PLACEMENT_REGEX.vertical.test(placement[0])) {
        borderRadiusProp += placement[0] + '-' + placement[1];
      } else {
        borderRadiusProp += placement[1] + '-' + placement[0];
      }
      borderRadiusProp += '-radius';
      var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

      switch (placement[0]) {
        case 'top':
          arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
          break;
        case 'bottom':
          arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
          break;
        case 'left':
          arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
          break;
        case 'right':
          arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
          break;
      }

      arrowCss[placement[1]] = borderRadius;

      angular.element(arrowElem).css(arrowCss);
    }
  };
}]);

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(235);

var MODULE_NAME = 'ui.bootstrap.module.stackedMap';

angular.module(MODULE_NAME, ['ui.bootstrap.stackedMap']);

module.exports = MODULE_NAME;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
.factory('$$stackedMap', function () {
  return {
    createNew: function createNew() {
      var stack = [];

      return {
        add: function add(key, value) {
          stack.push({
            key: key,
            value: value
          });
        },
        get: function get(key) {
          for (var i = 0; i < stack.length; i++) {
            if (key === stack[i].key) {
              return stack[i];
            }
          }
        },
        keys: function keys() {
          var keys = [];
          for (var i = 0; i < stack.length; i++) {
            keys.push(stack[i].key);
          }
          return keys;
        },
        top: function top() {
          return stack[stack.length - 1];
        },
        remove: function remove(key) {
          var idx = -1;
          for (var i = 0; i < stack.length; i++) {
            if (key === stack[i].key) {
              idx = i;
              break;
            }
          }
          return stack.splice(idx, 1)[0];
        },
        removeTop: function removeTop() {
          return stack.pop();
        },
        length: function length() {
          return stack.length;
        }
      };
    }
  };
});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(237);

var MODULE_NAME = 'ui.bootstrap.module.tabindex';

angular.module(MODULE_NAME, ['ui.bootstrap.tabindex']);

module.exports = MODULE_NAME;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.tabindex', []).directive('uibTabindexToggle', function () {
  return {
    restrict: 'A',
    link: function link(scope, elem, attrs) {
      attrs.$observe('disabled', function (disabled) {
        attrs.$set('tabindex', disabled ? -1 : null);
      });
    }
  };
});

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(250);
__webpack_require__(240);

var MODULE_NAME = 'ui.bootstrap.module.timepicker';

angular.module(MODULE_NAME, ['ui.bootstrap.timepicker', 'uib/template/timepicker/timepicker.html']);

module.exports = MODULE_NAME;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(144);
module.exports = __webpack_require__(238);

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.timepicker', []).constant('uibTimepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: true,
  showSeconds: false,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true,
  templateUrl: 'uib/template/timepicker/timepicker.html'
}).controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
  var selected = new Date(),
      watchers = [],
      ngModelCtrl = { $setViewValue: angular.noop },
      // nullModelCtrl
  meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
      padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
  $element.removeAttr('tabindex');

  this.init = function (ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.unshift(function (modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });

    var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1),
        secondsInputEl = inputs.eq(2);

    hoursModelCtrl = hoursInputEl.controller('ngModel');
    minutesModelCtrl = minutesInputEl.controller('ngModel');
    secondsModelCtrl = secondsInputEl.controller('ngModel');

    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
  };

  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
      hourStep = +value;
    }));
  }

  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
      minuteStep = +value;
    }));
  }

  var min;
  watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  }));

  var max;
  watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  }));

  var disabled = false;
  if ($attrs.ngDisabled) {
    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
      disabled = value;
    }));
  }

  $scope.noIncrementHours = function () {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementHours = function () {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementMinutes = function () {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementMinutes = function () {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementSeconds = function () {
    var incrementedSelected = addSeconds(selected, secondStep);
    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementSeconds = function () {
    var decrementedSelected = addSeconds(selected, -secondStep);
    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noToggleMeridian = function () {
    if (selected.getHours() < 12) {
      return disabled || addMinutes(selected, 12 * 60) > max;
    }

    return disabled || addMinutes(selected, -12 * 60) < min;
  };

  var secondStep = timepickerConfig.secondStep;
  if ($attrs.secondStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
      secondStep = +value;
    }));
  }

  $scope.showSeconds = timepickerConfig.showSeconds;
  if ($attrs.showSeconds) {
    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
      $scope.showSeconds = !!value;
    }));
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
      $scope.showMeridian = !!value;

      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(),
            minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    }));
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = +$scope.hours;
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 : hours >= 0 && hours < 24;
    if (!valid || $scope.hours === '') {
      return undefined;
    }

    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }

  function getMinutesFromTemplate() {
    var minutes = +$scope.minutes;
    var valid = minutes >= 0 && minutes < 60;
    if (!valid || $scope.minutes === '') {
      return undefined;
    }
    return minutes;
  }

  function getSecondsFromTemplate() {
    var seconds = +$scope.seconds;
    return seconds >= 0 && seconds < 60 ? seconds : undefined;
  }

  function pad(value, noPad) {
    if (value === null) {
      return '';
    }

    return angular.isDefined(value) && value.toString().length < 2 && !noPad ? '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
    var isScrollingUp = function isScrollingUp(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };

    hoursInputEl.on('mousewheel wheel', function (e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      }
      e.preventDefault();
    });

    minutesInputEl.on('mousewheel wheel', function (e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      }
      e.preventDefault();
    });

    secondsInputEl.on('mousewheel wheel', function (e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
      }
      e.preventDefault();
    });
  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
    hoursInputEl.on('keydown', function (e) {
      if (!disabled) {
        if (e.which === 38) {
          // up
          e.preventDefault();
          $scope.incrementHours();
          $scope.$apply();
        } else if (e.which === 40) {
          // down
          e.preventDefault();
          $scope.decrementHours();
          $scope.$apply();
        }
      }
    });

    minutesInputEl.on('keydown', function (e) {
      if (!disabled) {
        if (e.which === 38) {
          // up
          e.preventDefault();
          $scope.incrementMinutes();
          $scope.$apply();
        } else if (e.which === 40) {
          // down
          e.preventDefault();
          $scope.decrementMinutes();
          $scope.$apply();
        }
      }
    });

    secondsInputEl.on('keydown', function (e) {
      if (!disabled) {
        if (e.which === 38) {
          // up
          e.preventDefault();
          $scope.incrementSeconds();
          $scope.$apply();
        } else if (e.which === 40) {
          // down
          e.preventDefault();
          $scope.decrementSeconds();
          $scope.$apply();
        }
      }
    });
  };

  this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      $scope.updateSeconds = angular.noop;
      return;
    }

    var invalidate = function invalidate(invalidHours, invalidMinutes, invalidSeconds) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
        if (hoursModelCtrl) {
          hoursModelCtrl.$setValidity('hours', false);
        }
      }

      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
        if (minutesModelCtrl) {
          minutesModelCtrl.$setValidity('minutes', false);
        }
      }

      if (angular.isDefined(invalidSeconds)) {
        $scope.invalidSeconds = invalidSeconds;
        if (secondsModelCtrl) {
          secondsModelCtrl.$setValidity('seconds', false);
        }
      }
    };

    $scope.updateHours = function () {
      var hours = getHoursFromTemplate(),
          minutes = getMinutesFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };

    hoursInputEl.on('blur', function (e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.hours === null || $scope.hours === '') {
        invalidate(true);
      } else if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function () {
          $scope.hours = pad($scope.hours, !padHours);
        });
      }
    });

    $scope.updateMinutes = function () {
      var minutes = getMinutesFromTemplate(),
          hours = getHoursFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };

    minutesInputEl.on('blur', function (e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.minutes === null) {
        invalidate(undefined, true);
      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function () {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });

    $scope.updateSeconds = function () {
      var seconds = getSecondsFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(seconds)) {
        selected.setSeconds(seconds);
        refresh('s');
      } else {
        invalidate(undefined, undefined, true);
      }
    };

    secondsInputEl.on('blur', function (e) {
      if (modelIsEmpty()) {
        makeValid();
      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
        $scope.$apply(function () {
          $scope.seconds = pad($scope.seconds);
        });
      }
    });
  };

  this.render = function () {
    var date = ngModelCtrl.$viewValue;

    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }

      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }

  function makeValid() {
    if (hoursModelCtrl) {
      hoursModelCtrl.$setValidity('hours', true);
    }

    if (minutesModelCtrl) {
      minutesModelCtrl.$setValidity('minutes', true);
    }

    if (secondsModelCtrl) {
      secondsModelCtrl.$setValidity('seconds', true);
    }

    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
    $scope.invalidSeconds = false;
  }

  function updateTemplate(keyboardChange) {
    if (!ngModelCtrl.$modelValue) {
      $scope.hours = null;
      $scope.minutes = null;
      $scope.seconds = null;
      $scope.meridian = meridians[0];
    } else {
      var hours = selected.getHours(),
          minutes = selected.getMinutes(),
          seconds = selected.getSeconds();

      if ($scope.showMeridian) {
        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
      }

      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
      if (keyboardChange !== 'm') {
        $scope.minutes = pad(minutes);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

      if (keyboardChange !== 's') {
        $scope.seconds = pad(seconds);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }
  }

  function addSecondsToSelected(seconds) {
    selected = addSeconds(selected, seconds);
    refresh();
  }

  function addMinutes(selected, minutes) {
    return addSeconds(selected, minutes * 60);
  }

  function addSeconds(date, seconds) {
    var dt = new Date(date.getTime() + seconds * 1000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
    return newDate;
  }

  function modelIsEmpty() {
    return ($scope.hours === null || $scope.hours === '') && ($scope.minutes === null || $scope.minutes === '') && (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
  }

  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ? $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

  $scope.incrementHours = function () {
    if (!$scope.noIncrementHours()) {
      addSecondsToSelected(hourStep * 60 * 60);
    }
  };

  $scope.decrementHours = function () {
    if (!$scope.noDecrementHours()) {
      addSecondsToSelected(-hourStep * 60 * 60);
    }
  };

  $scope.incrementMinutes = function () {
    if (!$scope.noIncrementMinutes()) {
      addSecondsToSelected(minuteStep * 60);
    }
  };

  $scope.decrementMinutes = function () {
    if (!$scope.noDecrementMinutes()) {
      addSecondsToSelected(-minuteStep * 60);
    }
  };

  $scope.incrementSeconds = function () {
    if (!$scope.noIncrementSeconds()) {
      addSecondsToSelected(secondStep);
    }
  };

  $scope.decrementSeconds = function () {
    if (!$scope.noDecrementSeconds()) {
      addSecondsToSelected(-secondStep);
    }
  };

  $scope.toggleMeridian = function () {
    var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

    if (!$scope.noToggleMeridian()) {
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
      } else {
        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
      }
    }
  };

  $scope.blur = function () {
    ngModelCtrl.$setTouched();
  };

  $scope.$on('$destroy', function () {
    while (watchers.length) {
      watchers.shift()();
    }
  });
}]).directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
  return {
    require: ['uibTimepicker', '?^ngModel'],
    restrict: 'A',
    controller: 'UibTimepickerController',
    controllerAs: 'timepicker',
    scope: {},
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
    },
    link: function link(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];

      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
}]);

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(219);
__webpack_require__(35);
__webpack_require__(251);
__webpack_require__(252);
__webpack_require__(242);

var MODULE_NAME = 'ui.bootstrap.module.typeahead';

angular.module(MODULE_NAME, ['ui.bootstrap.typeahead', 'uib/template/typeahead/typeahead-match.html', 'uib/template/typeahead/typeahead-popup.html']);

module.exports = MODULE_NAME;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
.factory('uibTypeaheadParser', ['$parse', function ($parse) {
  //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
  return {
    parse: function parse(input) {
      var match = input.match(TYPEAHEAD_REGEXP);
      if (!match) {
        throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' + ' but got "' + input + '".');
      }

      return {
        itemName: match[3],
        source: $parse(match[4]),
        viewMapper: $parse(match[2] || match[1]),
        modelMapper: $parse(match[1])
      };
    }
  };
}]).controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser', function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
  var HOT_KEYS = [9, 13, 27, 38, 40];
  var eventDebounceTime = 200;
  var modelCtrl, ngModelOptions;
  //SUPPORTED ATTRIBUTES (OPTIONS)

  //minimal no of characters that needs to be entered before typeahead kicks-in
  var minLength = originalScope.$eval(attrs.typeaheadMinLength);
  if (!minLength && minLength !== 0) {
    minLength = 1;
  }

  originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
    minLength = !newVal && newVal !== 0 ? 1 : newVal;
  });

  //minimal wait time after last character typed before typeahead kicks-in
  var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

  //should it restrict model values to the ones selected from the popup only?
  var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
  originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
    isEditable = newVal !== false;
  });

  //binding to a variable that indicates if matches are being retrieved asynchronously
  var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

  //a function to determine if an event should cause selection
  var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function (scope, vals) {
    var evt = vals.$event;
    return evt.which === 13 || evt.which === 9;
  };

  //a callback executed when a match is selected
  var onSelectCallback = $parse(attrs.typeaheadOnSelect);

  //should it select highlighted popup value when losing focus?
  var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

  //binding to a variable that indicates if there were no results after the query is completed
  var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

  var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

  var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

  var appendTo = attrs.typeaheadAppendTo ? originalScope.$eval(attrs.typeaheadAppendTo) : null;

  var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

  //If input matches an item of the list exactly, select it automatically
  var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

  //binding to a variable that indicates if dropdown is open
  var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

  var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

  //INTERNAL VARIABLES

  //model setter executed upon match selection
  var parsedModel = $parse(attrs.ngModel);
  var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
  var $setModelValue = function $setModelValue(scope, newValue) {
    if (angular.isFunction(parsedModel(originalScope)) && ngModelOptions.getOption('getterSetter')) {
      return invokeModelSetter(scope, { $$$p: newValue });
    }

    return parsedModel.assign(scope, newValue);
  };

  //expressions used by typeahead
  var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

  var hasFocus;

  //Used to avoid bug in iOS webview where iOS keyboard does not fire
  //mousedown & mouseup events
  //Issue #3699
  var selected;

  //create a child scope for the typeahead directive so we are not polluting original scope
  //with typeahead-specific data (matches, query etc.)
  var scope = originalScope.$new();
  var offDestroy = originalScope.$on('$destroy', function () {
    scope.$destroy();
  });
  scope.$on('$destroy', offDestroy);

  // WAI-ARIA
  var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
  element.attr({
    'aria-autocomplete': 'list',
    'aria-expanded': false,
    'aria-owns': popupId
  });

  var inputsContainer, hintInputElem;
  //add read-only input to show hint
  if (showHint) {
    inputsContainer = angular.element('<div></div>');
    inputsContainer.css('position', 'relative');
    element.after(inputsContainer);
    hintInputElem = element.clone();
    hintInputElem.attr('placeholder', '');
    hintInputElem.attr('tabindex', '-1');
    hintInputElem.val('');
    hintInputElem.css({
      'position': 'absolute',
      'top': '0px',
      'left': '0px',
      'border-color': 'transparent',
      'box-shadow': 'none',
      'opacity': 1,
      'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
      'color': '#999'
    });
    element.css({
      'position': 'relative',
      'vertical-align': 'top',
      'background-color': 'transparent'
    });

    if (hintInputElem.attr('id')) {
      hintInputElem.removeAttr('id'); // remove duplicate id if present.
    }
    inputsContainer.append(hintInputElem);
    hintInputElem.after(element);
  }

  //pop-up element used to display matches
  var popUpEl = angular.element('<div uib-typeahead-popup></div>');
  popUpEl.attr({
    id: popupId,
    matches: 'matches',
    active: 'activeIdx',
    select: 'select(activeIdx, evt)',
    'move-in-progress': 'moveInProgress',
    query: 'query',
    position: 'position',
    'assign-is-open': 'assignIsOpen(isOpen)',
    debounce: 'debounceUpdate'
  });
  //custom item template
  if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
    popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
  }

  if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
    popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
  }

  var resetHint = function resetHint() {
    if (showHint) {
      hintInputElem.val('');
    }
  };

  var resetMatches = function resetMatches() {
    scope.matches = [];
    scope.activeIdx = -1;
    element.attr('aria-expanded', false);
    resetHint();
  };

  var getMatchId = function getMatchId(index) {
    return popupId + '-option-' + index;
  };

  // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
  // This attribute is added or removed automatically when the `activeIdx` changes.
  scope.$watch('activeIdx', function (index) {
    if (index < 0) {
      element.removeAttr('aria-activedescendant');
    } else {
      element.attr('aria-activedescendant', getMatchId(index));
    }
  });

  var inputIsExactMatch = function inputIsExactMatch(inputValue, index) {
    if (scope.matches.length > index && inputValue) {
      return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
    }

    return false;
  };

  var getMatchesAsync = function getMatchesAsync(inputValue, evt) {
    var locals = { $viewValue: inputValue };
    isLoadingSetter(originalScope, true);
    isNoResultsSetter(originalScope, false);
    $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
      //it might happen that several async queries were in progress if a user were typing fast
      //but we are interested only in responses that correspond to the current view value
      var onCurrentRequest = inputValue === modelCtrl.$viewValue;
      if (onCurrentRequest && hasFocus) {
        if (matches && matches.length > 0) {
          scope.activeIdx = focusFirst ? 0 : -1;
          isNoResultsSetter(originalScope, false);
          scope.matches.length = 0;

          //transform labels
          for (var i = 0; i < matches.length; i++) {
            locals[parserResult.itemName] = matches[i];
            scope.matches.push({
              id: getMatchId(i),
              label: parserResult.viewMapper(scope, locals),
              model: matches[i]
            });
          }

          scope.query = inputValue;
          //position pop-up with matches - we need to re-calculate its position each time we are opening a window
          //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
          //due to other elements being rendered
          recalculatePosition();

          element.attr('aria-expanded', true);

          //Select the single remaining option if user input matches
          if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
            if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
              $$debounce(function () {
                scope.select(0, evt);
              }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
            } else {
              scope.select(0, evt);
            }
          }

          if (showHint) {
            var firstLabel = scope.matches[0].label;
            if (angular.isString(inputValue) && inputValue.length > 0 && firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
              hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
            } else {
              hintInputElem.val('');
            }
          }
        } else {
          resetMatches();
          isNoResultsSetter(originalScope, true);
        }
      }
      if (onCurrentRequest) {
        isLoadingSetter(originalScope, false);
      }
    }, function () {
      resetMatches();
      isLoadingSetter(originalScope, false);
      isNoResultsSetter(originalScope, true);
    });
  };

  // bind events only if appendToBody params exist - performance feature
  if (appendToBody) {
    angular.element($window).on('resize', fireRecalculating);
    $document.find('body').on('scroll', fireRecalculating);
  }

  // Declare the debounced function outside recalculating for
  // proper debouncing
  var debouncedRecalculate = $$debounce(function () {
    // if popup is visible
    if (scope.matches.length) {
      recalculatePosition();
    }

    scope.moveInProgress = false;
  }, eventDebounceTime);

  // Default progress type
  scope.moveInProgress = false;

  function fireRecalculating() {
    if (!scope.moveInProgress) {
      scope.moveInProgress = true;
      scope.$digest();
    }

    debouncedRecalculate();
  }

  // recalculate actual position and set new values to scope
  // after digest loop is popup in right position
  function recalculatePosition() {
    scope.position = appendToBody ? $position.offset(element) : $position.position(element);
    scope.position.top += element.prop('offsetHeight');
  }

  //we need to propagate user's query so we can higlight matches
  scope.query = undefined;

  //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
  var timeoutPromise;

  var scheduleSearchWithTimeout = function scheduleSearchWithTimeout(inputValue) {
    timeoutPromise = $timeout(function () {
      getMatchesAsync(inputValue);
    }, waitTime);
  };

  var cancelPreviousTimeout = function cancelPreviousTimeout() {
    if (timeoutPromise) {
      $timeout.cancel(timeoutPromise);
    }
  };

  resetMatches();

  scope.assignIsOpen = function (isOpen) {
    isOpenSetter(originalScope, isOpen);
  };

  scope.select = function (activeIdx, evt) {
    //called from within the $digest() cycle
    var locals = {};
    var model, item;

    selected = true;
    locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
    model = parserResult.modelMapper(originalScope, locals);
    $setModelValue(originalScope, model);
    modelCtrl.$setValidity('editable', true);
    modelCtrl.$setValidity('parse', true);

    onSelectCallback(originalScope, {
      $item: item,
      $model: model,
      $label: parserResult.viewMapper(originalScope, locals),
      $event: evt
    });

    resetMatches();

    //return focus to the input element if a match was selected via a mouse click event
    // use timeout to avoid $rootScope:inprog error
    if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
      $timeout(function () {
        element[0].focus();
      }, 0, false);
    }
  };

  //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
  element.on('keydown', function (evt) {
    //typeahead is open and an "interesting" key was pressed
    if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
      return;
    }

    var shouldSelect = isSelectEvent(originalScope, { $event: evt });

    /**
     * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
     * or
     * shift + tab is pressed to bring focus to the previous element
     * then clear the results
     */
    if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
      resetMatches();
      scope.$digest();
      return;
    }

    evt.preventDefault();
    var target;
    switch (evt.which) {
      case 27:
        // escape
        evt.stopPropagation();

        resetMatches();
        originalScope.$digest();
        break;
      case 38:
        // up arrow
        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
        scope.$digest();
        target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
        target.parentNode.scrollTop = target.offsetTop;
        break;
      case 40:
        // down arrow
        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
        scope.$digest();
        target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
        target.parentNode.scrollTop = target.offsetTop;
        break;
      default:
        if (shouldSelect) {
          scope.$apply(function () {
            if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
              $$debounce(function () {
                scope.select(scope.activeIdx, evt);
              }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
            } else {
              scope.select(scope.activeIdx, evt);
            }
          });
        }
    }
  });

  element.on('focus', function (evt) {
    hasFocus = true;
    if (minLength === 0 && !modelCtrl.$viewValue) {
      $timeout(function () {
        getMatchesAsync(modelCtrl.$viewValue, evt);
      }, 0);
    }
  });

  element.on('blur', function (evt) {
    if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
      selected = true;
      scope.$apply(function () {
        if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
          $$debounce(function () {
            scope.select(scope.activeIdx, evt);
          }, scope.debounceUpdate.blur);
        } else {
          scope.select(scope.activeIdx, evt);
        }
      });
    }
    if (!isEditable && modelCtrl.$error.editable) {
      modelCtrl.$setViewValue();
      scope.$apply(function () {
        // Reset validity as we are clearing
        modelCtrl.$setValidity('editable', true);
        modelCtrl.$setValidity('parse', true);
      });
      element.val('');
    }
    hasFocus = false;
    selected = false;
  });

  // Keep reference to click handler to unbind it.
  var dismissClickHandler = function dismissClickHandler(evt) {
    // Issue #3973
    // Firefox treats right click as a click on document
    if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
      resetMatches();
      if (!$rootScope.$$phase) {
        originalScope.$digest();
      }
    }
  };

  $document.on('click', dismissClickHandler);

  originalScope.$on('$destroy', function () {
    $document.off('click', dismissClickHandler);
    if (appendToBody || appendTo) {
      $popup.remove();
    }

    if (appendToBody) {
      angular.element($window).off('resize', fireRecalculating);
      $document.find('body').off('scroll', fireRecalculating);
    }
    // Prevent jQuery cache memory leak
    popUpEl.remove();

    if (showHint) {
      inputsContainer.remove();
    }
  });

  var $popup = $compile(popUpEl)(scope);

  if (appendToBody) {
    $document.find('body').append($popup);
  } else if (appendTo) {
    angular.element(appendTo).eq(0).append($popup);
  } else {
    element.after($popup);
  }

  this.init = function (_modelCtrl) {
    modelCtrl = _modelCtrl;
    ngModelOptions = extractOptions(modelCtrl);

    scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);

    //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
    //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
    modelCtrl.$parsers.unshift(function (inputValue) {
      hasFocus = true;

      if (minLength === 0 || inputValue && inputValue.length >= minLength) {
        if (waitTime > 0) {
          cancelPreviousTimeout();
          scheduleSearchWithTimeout(inputValue);
        } else {
          getMatchesAsync(inputValue);
        }
      } else {
        isLoadingSetter(originalScope, false);
        cancelPreviousTimeout();
        resetMatches();
      }

      if (isEditable) {
        return inputValue;
      }

      if (!inputValue) {
        // Reset in case user had typed something previously.
        modelCtrl.$setValidity('editable', true);
        return null;
      }

      modelCtrl.$setValidity('editable', false);
      return undefined;
    });

    modelCtrl.$formatters.push(function (modelValue) {
      var candidateViewValue, emptyViewValue;
      var locals = {};

      // The validity may be set to false via $parsers (see above) if
      // the model is restricted to selected values. If the model
      // is set manually it is considered to be valid.
      if (!isEditable) {
        modelCtrl.$setValidity('editable', true);
      }

      if (inputFormatter) {
        locals.$model = modelValue;
        return inputFormatter(originalScope, locals);
      }

      //it might happen that we don't have enough info to properly render input value
      //we need to check for this situation and simply return model value if we can't apply custom formatting
      locals[parserResult.itemName] = modelValue;
      candidateViewValue = parserResult.viewMapper(originalScope, locals);
      locals[parserResult.itemName] = undefined;
      emptyViewValue = parserResult.viewMapper(originalScope, locals);

      return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
    });
  };

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) {
      // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = ngModelCtrl.$options || {};

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else {
      // in angular >=1.6 $options is always present
      ngModelOptions = ngModelCtrl.$options;
    }

    return ngModelOptions;
  }
}]).directive('uibTypeahead', function () {
  return {
    controller: 'UibTypeaheadController',
    require: ['ngModel', 'uibTypeahead'],
    link: function link(originalScope, element, attrs, ctrls) {
      ctrls[1].init(ctrls[0]);
    }
  };
}).directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {
  return {
    scope: {
      matches: '=',
      query: '=',
      active: '=',
      position: '&',
      moveInProgress: '=',
      select: '&',
      assignIsOpen: '&',
      debounce: '&'
    },
    replace: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
    },
    link: function link(scope, element, attrs) {
      scope.templateUrl = attrs.templateUrl;

      scope.isOpen = function () {
        var isDropdownOpen = scope.matches.length > 0;
        scope.assignIsOpen({ isOpen: isDropdownOpen });
        return isDropdownOpen;
      };

      scope.isActive = function (matchIdx) {
        return scope.active === matchIdx;
      };

      scope.selectActive = function (matchIdx) {
        scope.active = matchIdx;
      };

      scope.selectMatch = function (activeIdx, evt) {
        var debounce = scope.debounce();
        if (angular.isNumber(debounce) || angular.isObject(debounce)) {
          $$debounce(function () {
            scope.select({ activeIdx: activeIdx, evt: evt });
          }, angular.isNumber(debounce) ? debounce : debounce['default']);
        } else {
          scope.select({ activeIdx: activeIdx, evt: evt });
        }
      };
    }
  };
}]).directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
  return {
    scope: {
      index: '=',
      match: '=',
      query: '='
    },
    link: function link(scope, element, attrs) {
      var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
      $templateRequest(tplUrl).then(function (tplContent) {
        var tplEl = angular.element(tplContent.trim());
        element.replaceWith(tplEl);
        $compile(tplEl)(scope);
      });
    }
  };
}]).filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {
  var isSanitizePresent;
  isSanitizePresent = $injector.has('$sanitize');

  function escapeRegexp(queryToEscape) {
    // Regex: capture the whole query string and replace it with the string that will be used to match
    // the results, for example if the capture is "a" the result will be \a
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  }

  function containsHtml(matchItem) {
    return (/<.*>/g.test(matchItem)
    );
  }

  return function (matchItem, query) {
    if (!isSanitizePresent && containsHtml(matchItem)) {
      $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
    }
    matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
    if (!isSanitizePresent) {
      matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
    }
    return matchItem;
  };
}]);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/datepicker.html", "<div ng-switch=\"datepickerMode\">\n" + "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" + "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" + "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" + "</div>\n" + "");
}]);

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/day.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" + "    </tr>\n" + "    <tr>\n" + "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" + "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
}]);

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/month.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
}]);

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/year.html", "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" + "  <thead>\n" + "    <tr>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" + "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" + "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" + "    </tr>\n" + "  </thead>\n" + "  <tbody>\n" + "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" + "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" + "        id=\"{{::dt.uid}}\"\n" + "        ng-class=\"::dt.customClass\">\n" + "        <button type=\"button\" class=\"btn btn-default\"\n" + "          uib-is-class=\"\n" + "            'btn-info' for selectedDt,\n" + "            'active' for activeDt\n" + "            on dt\"\n" + "          ng-click=\"select(dt.date)\"\n" + "          ng-disabled=\"::dt.disabled\"\n" + "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" + "      </td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
}]);

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepickerPopup/popup.html", "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" + "  <li ng-transclude></li>\n" + "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" + "    <span class=\"btn-group pull-left\">\n" + "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" + "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" + "    </span>\n" + "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" + "  </li>\n" + "</ul>\n" + "");
}]);

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/modal/window.html", "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" + "");
}]);

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/pagination/pagination.html", "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" + "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" + "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" + "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" + "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" + "");
}]);

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/timepicker/timepicker.html", "<table class=\"uib-timepicker\">\n" + "  <tbody>\n" + "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" + "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" + "      <td>&nbsp;</td>\n" + "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" + "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" + "      <td ng-show=\"showMeridian\"></td>\n" + "    </tr>\n" + "    <tr>\n" + "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" + "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td class=\"uib-separator\">:</td>\n" + "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" + "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" + "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" + "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" + "      </td>\n" + "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" + "    </tr>\n" + "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" + "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" + "      <td>&nbsp;</td>\n" + "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" + "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" + "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" + "      <td ng-show=\"showMeridian\"></td>\n" + "    </tr>\n" + "  </tbody>\n" + "</table>\n" + "");
}]);

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-match.html", "<a href\n" + "   tabindex=\"-1\"\n" + "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" + "   ng-attr-title=\"{{match.label}}\"></a>\n" + "");
}]);

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-popup.html", "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" + "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" + "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" + "    </li>\n" + "</ul>\n" + "");
}]);

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * These are the UI-Router angular 1 directives.
 *
 * These directives are used in templates to create viewports and navigate to states
 *
 * @ng1api
 * @preferred
 * @module directives
 */ /** for typedoc */

var angular_1 = __webpack_require__(20);
var ui_router_core_1 = __webpack_require__(9);
/** @hidden */
function parseStateRef(ref) {
    var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/),
        parsed;
    if (paramsOnly) ref = '(' + paramsOnly[1] + ')';
    parsed = ref.replace(/\n/g, " ").match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
    if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
    return { state: parsed[1] || null, paramExpr: parsed[3] || null };
}
/** @hidden */
function stateContext(el) {
    var $uiView = el.parent().inheritedData('$uiView');
    var path = ui_router_core_1.parse('$cfg.path')($uiView);
    return path ? ui_router_core_1.tail(path).state.name : undefined;
}
/** @hidden */
function processedDef($state, $element, def) {
    var uiState = def.uiState || $state.current.name;
    var uiStateOpts = ui_router_core_1.extend(defaultOpts($element, $state), def.uiStateOpts || {});
    var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
    return { uiState: uiState, uiStateParams: def.uiStateParams, uiStateOpts: uiStateOpts, href: href };
}
/** @hidden */
function getTypeInfo(el) {
    // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
    var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
    var isForm = el[0].nodeName === "FORM";
    return {
        attr: isForm ? "action" : isSvg ? 'xlink:href' : 'href',
        isAnchor: el.prop("tagName").toUpperCase() === "A",
        clickable: !isForm
    };
}
/** @hidden */
function clickHook(el, $state, $timeout, type, getDef) {
    return function (e) {
        var button = e.which || e.button,
            target = getDef();
        if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || el.attr('target'))) {
            // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
            var transition = $timeout(function () {
                $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
            });
            e.preventDefault();
            // if the state has no URL, ignore one preventDefault from the <a> directive.
            var ignorePreventDefaultCount = type.isAnchor && !target.href ? 1 : 0;
            e.preventDefault = function () {
                if (ignorePreventDefaultCount-- <= 0) $timeout.cancel(transition);
            };
        }
    };
}
/** @hidden */
function defaultOpts(el, $state) {
    return {
        relative: stateContext(el) || $state.$current,
        inherit: true,
        source: "sref"
    };
}
/**
 * `ui-sref`: A directive for linking to a state
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * ### Linked State
 * The attribute value of the `ui-sref` is the name of the state to link to.
 *
 * #### Example:
 * This will activate the `home` state when the link is clicked.
 * <a ui-sref="home">Home</a>
 *
 * ### Relative Links
 * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
 * You just need to be aware that the path is relative to the state that *created* the link.
 * This allows a state to create a relative `ui-sref` which always targets the same destination.
 *
 * #### Example:
 * Both these links are relative to the parent state, even when a child state is currently active.
 * ```html
 * <a ui-sref=".child1">child 1 state</a>
 * <a ui-sref=".child2">child 2 state</a>
 * ```
 *
 * This link activates the parent class.
 * ```html
 * <a ui-sref="^">Return</a>
 * ```
 *
 * ### hrefs
 * If the linked state has a URL, the directive will automatically generate and
 * update the `href` attribute (using the [[StateService.href]]  method).
 *
 * #### Example:
 * Assuming the `users` state has a url of `/users/`
 * ```html
 * <a ui-sref="users" href="/users/">Users</a>
 * ```
 *
 * ### Parameter Values
 * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
 * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
 * The content inside the parentheses is an expression, evaluated to the parameter values.
 *
 * #### Example:
 * This example renders a list of links to users.
 * The state's `userId` parameter value comes from each user's `user.id` property.
 * ```html
 * <li ng-repeat="user in users">
 *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
 * </li>
 * ```
 *
 * Note:
 * The parameter values expression is `$watch`ed for updates.
 *
 * ### Transition Options
 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
 * Options are restricted to `location`, `inherit`, and `reload`.
 *
 * #### Example:
 * ```html
 * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
 * ```
 *
 * ### Highlighting the active link
 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
 *
 * ### Examples
 * If you have the following template:
 *
 * ```html
 * <a ui-sref="home">Home</a>
 * <a ui-sref="about">About</a>
 * <a ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
 *     </li>
 * </ul>
 * ```
 *
 * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
 *
 * ```html
 * <a href="#/home" ui-sref="home">Home</a>
 * <a href="#/about" ui-sref="about">About</a>
 * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
 *
 * <ul>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
 *     </li>
 *     <li ng-repeat="contact in contacts">
 *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
 *     </li>
 * </ul>
 *
 * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
 * ```
 *
 * ### Notes
 *
 * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
 * #### Example:
 * Sets the `lang` parameter to `en` and remains on the same state.
 *
 * ```html
 * <a ui-sref="{ lang: 'en' }">English</a>
 * ```
 *
 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
 *
 * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
 * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
 */
var uiSref;
uiSref = ['$uiRouter', '$timeout', function $StateRefDirective($uiRouter, $timeout) {
    var $state = $uiRouter.stateService;
    return {
        restrict: 'A',
        require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
        link: function link(scope, element, attrs, uiSrefActive) {
            var type = getTypeInfo(element);
            var active = uiSrefActive[1] || uiSrefActive[0];
            var unlinkInfoFn = null;
            var hookFn;
            var rawDef = {};
            var getDef = function getDef() {
                return processedDef($state, element, rawDef);
            };
            var ref = parseStateRef(attrs.uiSref);
            rawDef.uiState = ref.state;
            rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
            function update() {
                var def = getDef();
                if (unlinkInfoFn) unlinkInfoFn();
                if (active) unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                if (def.href != null) attrs.$set(type.attr, def.href);
            }
            if (ref.paramExpr) {
                scope.$watch(ref.paramExpr, function (val) {
                    rawDef.uiStateParams = angular_1.ng.copy(val);
                    update();
                }, true);
                rawDef.uiStateParams = angular_1.ng.copy(scope.$eval(ref.paramExpr));
            }
            update();
            scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
            scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
            if (!type.clickable) return;
            hookFn = clickHook(element, $state, $timeout, type, getDef);
            element[element.on ? 'on' : 'bind']("click", hookFn);
            scope.$on('$destroy', function () {
                element[element.off ? 'off' : 'unbind']("click", hookFn);
            });
        }
    };
}];
/**
 * `ui-state`: A fully dynamic directive for linking to a state
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
 *
 * A directive which links to a state (and optionally, parameters).
 * When clicked, this directive activates the linked state with the supplied parameter values.
 *
 * ### Linked State
 * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
 * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
 *
 * #### Example:
 * Create a list of links.
 * ```html
 * <li ng-repeat="link in navlinks">
 *   <a ui-sref="link.state">{{ link.displayName }}</a>
 * </li>
 *
 * ### Relative Links
 * If the expression evaluates to a relative path, it is processed like [[uiSref]].
 * You just need to be aware that the path is relative to the state that *created* the link.
 * This allows a state to create relative `ui-state` which always targets the same destination.
 *
 * ### hrefs
 * If the linked state has a URL, the directive will automatically generate and
 * update the `href` attribute (using the [[StateService.href]]  method).
 *
 * ### Parameter Values
 * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
 * Param values should be provided using the `ui-state-params` attribute.
 * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
 *
 * #### Example:
 * This example renders a list of links with param values.
 * The state's `userId` parameter value comes from each user's `user.id` property.
 * ```html
 * <li ng-repeat="link in navlinks">
 *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
 * </li>
 * ```
 *
 * ### Transition Options
 * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
 * Options are restricted to `location`, `inherit`, and `reload`.
 * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
 *
 * #### Example:
 * ```html
 * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
 * ```
 *
 * ### Highlighting the active link
 * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
 *
 * ### Notes
 *
 * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
 *   However, it might be simpler to use [[uiSref]] parameter-only links.
 *
 * #### Example:
 * Sets the `lang` parameter to `en` and remains on the same state.
 *
 * ```html
 * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
 * ```
 *
 * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
 * ```
 */
var uiState;
uiState = ['$uiRouter', '$timeout', function $StateRefDynamicDirective($uiRouter, $timeout) {
    var $state = $uiRouter.stateService;
    return {
        restrict: 'A',
        require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
        link: function link(scope, element, attrs, uiSrefActive) {
            var type = getTypeInfo(element);
            var active = uiSrefActive[1] || uiSrefActive[0];
            var unlinkInfoFn = null;
            var hookFn;
            var rawDef = {};
            var getDef = function getDef() {
                return processedDef($state, element, rawDef);
            };
            var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
            var watchDeregFns = inputAttrs.reduce(function (acc, attr) {
                return acc[attr] = ui_router_core_1.noop, acc;
            }, {});
            function update() {
                var def = getDef();
                if (unlinkInfoFn) unlinkInfoFn();
                if (active) unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
                if (def.href != null) attrs.$set(type.attr, def.href);
            }
            inputAttrs.forEach(function (field) {
                rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
                attrs.$observe(field, function (expr) {
                    watchDeregFns[field]();
                    watchDeregFns[field] = scope.$watch(expr, function (newval) {
                        rawDef[field] = newval;
                        update();
                    }, true);
                });
            });
            update();
            scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
            scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
            if (!type.clickable) return;
            hookFn = clickHook(element, $state, $timeout, type, getDef);
            element[element.on ? 'on' : 'bind']("click", hookFn);
            scope.$on('$destroy', function () {
                element[element.off ? 'off' : 'unbind']("click", hookFn);
            });
        }
    };
}];
/**
 * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
 *
 * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
 * related directive's state is active (and remove them when it is inactive).
 *
 * The primary use-case is to highlight the active link in navigation menus,
 * distinguishing it from the inactive menu items.
 *
 * ### Linking to a `ui-sref` or `ui-state`
 * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
 * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
 *
 * ### Matching
 *
 * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
 * This is a "fuzzy match" which uses [[StateService.includes]].
 *
 * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
 * This is an "exact match" which uses [[StateService.is]].
 *
 * ### Parameter values
 * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
 * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
 *
 * #### Example:
 * ```html
 * <li ng-repeat="user in users" ui-sref-active="active">
 *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
 * </li>
 * ```
 *
 * ### Examples
 *
 * Given the following template:
 * @example
 * ```html
 * <ul>
 *   <li ui-sref-active="active" class="item">
 *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
 *   </li>
 * </ul>
 * ```
 *
 * When the app state is `app.user` (or any child state),
 * and contains the state parameter "user" with value "bilbobaggins",
 * the resulting HTML will appear as (note the 'active' class):
 *
 * ```html
 * <ul>
 *   <li ui-sref-active="active" class="item active">
 *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
 *   </li>
 * </ul>
 * ```
 *
 * ### Glob mode
 *
 * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
 * The objects keys represent active class names and values represent the respective state names/globs.
 * `ui-sref-active` will match if the current active state **includes** any of
 * the specified state names/globs, even the abstract ones.
 *
 * #### Example:
 * Given the following template, with "admin" being an abstract state:
 * ```html
 * <div ui-sref-active="{'active': 'admin.**'}">
 *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
 * </div>
 * ```
 *
 * When the current state is "admin.roles" the "active" class will be applied to both the <div> and <a> elements.
 * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
 *
 * ### Notes:
 *
 * - The class name is interpolated **once** during the directives link time (any further changes to the
 * interpolated value are ignored).
 *
 * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
 */
var uiSrefActive;
uiSrefActive = ['$state', '$stateParams', '$interpolate', '$uiRouter', function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
    return {
        restrict: "A",
        controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
            var states = [],
                activeEqClass,
                uiSrefActive;
            // There probably isn't much point in $observing this
            // uiSrefActive and uiSrefActiveEq share the same directive object with some
            // slight difference in logic routing
            activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
            try {
                uiSrefActive = $scope.$eval($attrs.uiSrefActive);
            } catch (e) {}
            uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
            if (ui_router_core_1.isObject(uiSrefActive)) {
                ui_router_core_1.forEach(uiSrefActive, function (stateOrName, activeClass) {
                    if (ui_router_core_1.isString(stateOrName)) {
                        var ref = parseStateRef(stateOrName);
                        addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
                    }
                });
            }
            // Allow uiSref to communicate with uiSrefActive[Equals]
            this.$$addStateInfo = function (newState, newParams) {
                // we already got an explicit state provided by ui-sref-active, so we
                // shadow the one that comes from ui-sref
                if (ui_router_core_1.isObject(uiSrefActive) && states.length > 0) {
                    return;
                }
                var deregister = addState(newState, newParams, uiSrefActive);
                update();
                return deregister;
            };
            function updateAfterTransition(trans) {
                trans.promise.then(update);
            }
            $scope.$on('$stateChangeSuccess', update);
            $scope.$on('$destroy', $uiRouter.transitionService.onStart({}, updateAfterTransition));
            if ($uiRouter.globals.transition) {
                updateAfterTransition($uiRouter.globals.transition);
            }
            function addState(stateName, stateParams, activeClass) {
                var state = $state.get(stateName, stateContext($element));
                var stateInfo = {
                    state: state || { name: stateName },
                    params: stateParams,
                    activeClass: activeClass
                };
                states.push(stateInfo);
                return function removeState() {
                    ui_router_core_1.removeFrom(states)(stateInfo);
                };
            }
            // Update route state
            function update() {
                var splitClasses = function splitClasses(str) {
                    return str.split(/\s/).filter(ui_router_core_1.identity);
                };
                var getClasses = function getClasses(stateList) {
                    return stateList.map(function (x) {
                        return x.activeClass;
                    }).map(splitClasses).reduce(ui_router_core_1.unnestR, []);
                };
                var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(ui_router_core_1.uniqR, []);
                var fuzzyClasses = getClasses(states.filter(function (x) {
                    return $state.includes(x.state.name, x.params);
                }));
                var exactlyMatchesAny = !!states.filter(function (x) {
                    return $state.is(x.state.name, x.params);
                }).length;
                var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
                var addClasses = fuzzyClasses.concat(exactClasses).reduce(ui_router_core_1.uniqR, []);
                var removeClasses = allClasses.filter(function (cls) {
                    return !ui_router_core_1.inArray(addClasses, cls);
                });
                $scope.$evalAsync(function () {
                    addClasses.forEach(function (className) {
                        return $element.addClass(className);
                    });
                    removeClasses.forEach(function (className) {
                        return $element.removeClass(className);
                    });
                });
            }
            update();
        }]
    };
}];
angular_1.ng.module('ui.router.state').directive('uiSref', uiSref).directive('uiSrefActive', uiSrefActive).directive('uiSrefActiveEq', uiSrefActive).directive('uiState', uiState);
//# sourceMappingURL=stateDirectives.js.map

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @ng1api
 * @module directives
 */ /** for typedoc */

var angular_1 = __webpack_require__(20);
var angular_2 = __webpack_require__(36);
var ui_router_core_1 = __webpack_require__(9);
var views_1 = __webpack_require__(58);
var services_1 = __webpack_require__(57);
/**
 * `ui-view`: A viewport directive which is filled in by a view from the active state.
 *
 * ### Attributes
 *
 * - `name`: (Optional) A view name.
 *   The name should be unique amongst the other views in the same state.
 *   You can have views of the same name that live in different states.
 *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
 *
 * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
 *   Uses [[$uiViewScroll]] to do the scrolling.
 *
 * - `onload`: Expression to evaluate whenever the view updates.
 *
 * A view can be unnamed or named.
 * @example
 * ```html
 *
 * <!-- Unnamed -->
 * <div ui-view></div>
 *
 * <!-- Named -->
 * <div ui-view="viewName"></div>
 *
 * <!-- Named (different style) -->
 * <ui-view name="viewName"></ui-view>
 * ```
 *
 * You can only have one unnamed view within any template (or root html). If you are only using a
 * single view and it is unnamed then you can populate it like so:
 * ```
 *
 * <div ui-view></div>
 * $stateProvider.state("home", {
 *   template: "<h1>HELLO!</h1>"
 * })
 * ```
 *
 * The above is a convenient shortcut equivalent to specifying your view explicitly with the {@link ui.router.state.$stateProvider#views `views`}
 * config property, by name, in this case an empty name:
 * ```js
 *
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }
 * })
 * ```
 *
 * But typically you'll only use the views property if you name your view or have more than one view
 * in the same template. There's not really a compelling reason to name a view if its the only one,
 * but you could if you wanted, like so:
 *
 * ```html
 *
 * <div ui-view="main"></div>
 * ```
 *
 * ```js
 *
 * $stateProvider.state("home", {
 *   views: {
 *     "main": {
 *       template: "<h1>HELLO!</h1>"
 *     }
 *   }
 * })
 * ```
 *
 * Really though, you'll use views to set up multiple views:
 * ```html
 *
 * <div ui-view></div>
 * <div ui-view="chart"></div>
 * <div ui-view="data"></div>
 * ```
 *
 * ```js
 * $stateProvider.state("home", {
 *   views: {
 *     "": {
 *       template: "<h1>HELLO!</h1>"
 *     },
 *     "chart": {
 *       template: "<chart_thing/>"
 *     },
 *     "data": {
 *       template: "<data_thing/>"
 *     }
 *   }
 * })
 * ```
 *
 * Examples for `autoscroll`:
 *
 * ```html
 *
 * <!-- If autoscroll present with no expression,
 *      then scroll ui-view into view -->
 * <ui-view autoscroll/>
 *
 * <!-- If autoscroll present with valid expression,
 *      then scroll ui-view into view if expression evaluates to true -->
 * <ui-view autoscroll='true'/>
 * <ui-view autoscroll='false'/>
 * <ui-view autoscroll='scopeVariable'/>
 * ```
 *
 * Resolve data:
 *
 * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
 * can be customized using [[ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
 *
 * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
 * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
 * depends on `$resolve` data.
 *
 * #### Example:
 * ```js
 * $stateProvider.state('home', {
 *   template: '<my-component user="$resolve.user"></my-component>',
 *   resolve: {
 *     user: function(UserService) { return UserService.fetchUser(); }
 *   }
 * });
 * ```
 */
var uiView;
uiView = ['$view', '$animate', '$uiViewScroll', '$interpolate', '$q', function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
    function getRenderer(attrs, scope) {
        return {
            enter: function enter(element, target, cb) {
                if (angular_1.ng.version.minor > 2) {
                    $animate.enter(element, null, target).then(cb);
                } else {
                    $animate.enter(element, null, target, cb);
                }
            },
            leave: function leave(element, cb) {
                if (angular_1.ng.version.minor > 2) {
                    $animate.leave(element).then(cb);
                } else {
                    $animate.leave(element, cb);
                }
            }
        };
    }
    function configsEqual(config1, config2) {
        return config1 === config2;
    }
    var rootData = {
        $cfg: { viewDecl: { $context: $view._pluginapi._rootViewContext() } },
        $uiView: {}
    };
    var directive = {
        count: 0,
        restrict: 'ECA',
        terminal: true,
        priority: 400,
        transclude: 'element',
        compile: function compile(tElement, tAttrs, $transclude) {
            return function (scope, $element, attrs) {
                var previousEl,
                    currentEl,
                    currentScope,
                    unregister,
                    onloadExp = attrs['onload'] || '',
                    autoScrollExp = attrs['autoscroll'],
                    renderer = getRenderer(attrs, scope),
                    viewConfig = undefined,
                    inherited = $element.inheritedData('$uiView') || rootData,
                    name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
                var activeUIView = {
                    $type: 'ng1',
                    id: directive.count++,
                    name: name,
                    fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + "." + name : name,
                    config: null,
                    configUpdated: configUpdatedCallback,
                    get creationContext() {
                        return ui_router_core_1.parse('$cfg.viewDecl.$context')(inherited);
                    }
                };
                ui_router_core_1.trace.traceUIViewEvent("Linking", activeUIView);
                function configUpdatedCallback(config) {
                    if (config && !(config instanceof views_1.Ng1ViewConfig)) return;
                    if (configsEqual(viewConfig, config)) return;
                    ui_router_core_1.trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
                    viewConfig = config;
                    updateView(config);
                }
                $element.data('$uiView', { $uiView: activeUIView });
                updateView();
                unregister = $view.registerUIView(activeUIView);
                scope.$on("$destroy", function () {
                    ui_router_core_1.trace.traceUIViewEvent("Destroying/Unregistering", activeUIView);
                    unregister();
                });
                function cleanupLastView() {
                    if (previousEl) {
                        ui_router_core_1.trace.traceUIViewEvent("Removing (previous) el", previousEl.data('$uiView'));
                        previousEl.remove();
                        previousEl = null;
                    }
                    if (currentScope) {
                        ui_router_core_1.trace.traceUIViewEvent("Destroying scope", activeUIView);
                        currentScope.$destroy();
                        currentScope = null;
                    }
                    if (currentEl) {
                        var _viewData_1 = currentEl.data('$uiViewAnim');
                        ui_router_core_1.trace.traceUIViewEvent("Animate out", _viewData_1);
                        renderer.leave(currentEl, function () {
                            _viewData_1.$$animLeave.resolve();
                            previousEl = null;
                        });
                        previousEl = currentEl;
                        currentEl = null;
                    }
                }
                function updateView(config) {
                    var newScope = scope.$new();
                    var animEnter = $q.defer(),
                        animLeave = $q.defer();
                    var $uiViewData = {
                        $cfg: config,
                        $uiView: activeUIView
                    };
                    var $uiViewAnim = {
                        $animEnter: animEnter.promise,
                        $animLeave: animLeave.promise,
                        $$animLeave: animLeave
                    };
                    /**
                     * @ngdoc event
                     * @name ui.router.state.directive:ui-view#$viewContentLoading
                     * @eventOf ui.router.state.directive:ui-view
                     * @eventType emits on ui-view directive scope
                     * @description
                     *
                     * Fired once the view **begins loading**, *before* the DOM is rendered.
                     *
                     * @param {Object} event Event object.
                     * @param {string} viewName Name of the view.
                     */
                    newScope.$emit('$viewContentLoading', name);
                    var cloned = $transclude(newScope, function (clone) {
                        clone.data('$uiViewAnim', $uiViewAnim);
                        clone.data('$uiView', $uiViewData);
                        renderer.enter(clone, $element, function onUIViewEnter() {
                            animEnter.resolve();
                            if (currentScope) currentScope.$emit('$viewContentAnimationEnded');
                            if (ui_router_core_1.isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                                $uiViewScroll(clone);
                            }
                        });
                        cleanupLastView();
                    });
                    currentEl = cloned;
                    currentScope = newScope;
                    /**
                     * @ngdoc event
                     * @name ui.router.state.directive:ui-view#$viewContentLoaded
                     * @eventOf ui.router.state.directive:ui-view
                     * @eventType emits on ui-view directive scope
                     * @description           *
                     * Fired once the view is **loaded**, *after* the DOM is rendered.
                     *
                     * @param {Object} event Event object.
                     */
                    currentScope.$emit('$viewContentLoaded', config || viewConfig);
                    currentScope.$eval(onloadExp);
                }
            };
        }
    };
    return directive;
}];
$ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$timeout'];
/** @hidden */
function $ViewDirectiveFill($compile, $controller, $transitions, $view, $timeout) {
    var getControllerAs = ui_router_core_1.parse('viewDecl.controllerAs');
    var getResolveAs = ui_router_core_1.parse('viewDecl.resolveAs');
    return {
        restrict: 'ECA',
        priority: -400,
        compile: function compile(tElement) {
            var initial = tElement.html();
            tElement.empty();
            return function (scope, $element) {
                var data = $element.data('$uiView');
                if (!data) {
                    $element.html(initial);
                    $compile($element.contents())(scope);
                    return;
                }
                var cfg = data.$cfg || { viewDecl: {}, getTemplate: angular_2.noop };
                var resolveCtx = cfg.path && new ui_router_core_1.ResolveContext(cfg.path);
                $element.html(cfg.getTemplate($element, resolveCtx) || initial);
                ui_router_core_1.trace.traceUIViewFill(data.$uiView, $element.html());
                var link = $compile($element.contents());
                var controller = cfg.controller;
                var controllerAs = getControllerAs(cfg);
                var resolveAs = getResolveAs(cfg);
                var locals = resolveCtx && services_1.getLocals(resolveCtx);
                scope[resolveAs] = locals;
                if (controller) {
                    var controllerInstance = $controller(controller, ui_router_core_1.extend({}, locals, { $scope: scope, $element: $element }));
                    if (controllerAs) {
                        scope[controllerAs] = controllerInstance;
                        scope[controllerAs][resolveAs] = locals;
                    }
                    // TODO: Use $view service as a central point for registering component-level hooks
                    // Then, when a component is created, tell the $view service, so it can invoke hooks
                    // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
                    // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
                    $element.data('$ngControllerController', controllerInstance);
                    $element.children().data('$ngControllerController', controllerInstance);
                    registerControllerCallbacks($transitions, controllerInstance, scope, cfg);
                }
                // Wait for the component to appear in the DOM
                if (ui_router_core_1.isString(cfg.viewDecl.component)) {
                    var cmp_1 = cfg.viewDecl.component;
                    var kebobName_1 = ui_router_core_1.kebobString(cmp_1);
                    var getComponentController = function getComponentController() {
                        var directiveEl = [].slice.call($element[0].children).filter(function (el) {
                            return el && el.tagName && el.tagName.toLowerCase() === kebobName_1;
                        });
                        return directiveEl && angular_1.ng.element(directiveEl).data("$" + cmp_1 + "Controller");
                    };
                    var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
                        if (!ctrlInstance) return;
                        registerControllerCallbacks($transitions, ctrlInstance, scope, cfg);
                        deregisterWatch_1();
                    });
                }
                link(scope);
            };
        }
    };
}
/** @hidden */
var hasComponentImpl = typeof angular_1.ng.module('ui.router')['component'] === 'function';
/** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
function registerControllerCallbacks($transitions, controllerInstance, $scope, cfg) {
    // Call $onInit() ASAP
    if (ui_router_core_1.isFunction(controllerInstance.$onInit) && !(cfg.viewDecl.component && hasComponentImpl)) controllerInstance.$onInit();
    var viewState = ui_router_core_1.tail(cfg.path).state.self;
    var hookOptions = { bind: controllerInstance };
    // Add component-level hook for onParamsChange
    if (ui_router_core_1.isFunction(controllerInstance.uiOnParamsChanged)) {
        var resolveContext = new ui_router_core_1.ResolveContext(cfg.path);
        var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
        // Fire callback on any successful transition
        var paramsUpdated = function paramsUpdated($transition$) {
            // Exit early if the $transition$ is the same as the view was created within.
            // Exit early if the $transition$ will exit the state the view is for.
            if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1) return;
            var toParams = $transition$.params("to");
            var fromParams = $transition$.params("from");
            var toSchema = $transition$.treeChanges().to.map(function (node) {
                return node.paramSchema;
            }).reduce(ui_router_core_1.unnestR, []);
            var fromSchema = $transition$.treeChanges().from.map(function (node) {
                return node.paramSchema;
            }).reduce(ui_router_core_1.unnestR, []);
            // Find the to params that have different values than the from params
            var changedToParams = toSchema.filter(function (param) {
                var idx = fromSchema.indexOf(param);
                return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
            });
            // Only trigger callback if a to param has changed or is new
            if (changedToParams.length) {
                var changedKeys_1 = changedToParams.map(function (x) {
                    return x.id;
                });
                // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
                var newValues = ui_router_core_1.filter(toParams, function (val, key) {
                    return changedKeys_1.indexOf(key) !== -1;
                });
                controllerInstance.uiOnParamsChanged(newValues, $transition$);
            }
        };
        $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
    }
    // Add component-level hook for uiCanExit
    if (ui_router_core_1.isFunction(controllerInstance.uiCanExit)) {
        var criteria = { exiting: viewState.name };
        $scope.$on('$destroy', $transitions.onBefore(criteria, controllerInstance.uiCanExit, hookOptions));
    }
}
angular_1.ng.module('ui.router.state').directive('uiView', uiView);
angular_1.ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);
//# sourceMappingURL=viewDirective.js.map

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * # Angular 1 injectable services
 *
 * This is a list of the objects which can be injected using angular's injector.
 *
 * There are three different kind of injectable objects:
 *
 * ## **Provider** objects
 * #### injectable into a `.config()` block during configtime
 *
 * - [[$uiRouterProvider]]: The UI-Router instance
 * - [[$stateProvider]]: State registration
 * - [[$transitionsProvider]]: Transition hooks
 * - [[$urlServiceProvider]]: All URL related public APIs
 *
 * - [[$uiViewScrollProvider]]: Disable ui-router view scrolling
 * - [[$urlRouterProvider]]: (deprecated) Url matching rules
 * - [[$urlMatcherFactoryProvider]]: (deprecated) Url parsing config
 *
 * ## **Service** objects
 * #### injectable globally during runtime
 *
 * - [[$uiRouter]]: The UI-Router instance
 * - [[$trace]]: Enable transition trace/debug
 * - [[$transitions]]: Transition hooks
 * - [[$state]]: Imperative state related APIs
 * - [[$stateRegistry]]: State registration
 * - [[$urlService]]: All URL related public APIs
 * - [[$uiRouterGlobals]]: Global variables
 * - [[$uiViewScroll]]: Scroll an element into view
 *
 * - [[$stateParams]]: (deprecated) Global state param values
 * - [[$urlRouter]]: (deprecated) URL synchronization
 * - [[$urlMatcherFactory]]: (deprecated) URL parsing config
 *
 * ## **Per-Transition** objects
 *
 * - These kind of objects are injectable into:
 *   - Resolves ([[Ng1StateDeclaration.resolve]]),
 *   - Transition Hooks ([[TransitionService.onStart]], etc),
 *   - Routed Controllers ([[Ng1ViewDeclaration.controller]])
 *
 * #### Different instances are injected based on the [[Transition]]
 *
 * - [[$transition$]]: The current Transition object
 * - [[$stateParams]]: State param values for pending Transition (deprecated)
 * - Any resolve data defined using [[Ng1StateDeclaration.resolve]]
 *
 * @ng1api
 * @preferred
 * @module injectables
 */ /** */

/**
 * The current (or pending) State Parameters
 *
 * An injectable global **Service Object** which holds the state parameters for the latest **SUCCESSFUL** transition.
 *
 * The values are not updated until *after* a `Transition` successfully completes.
 *
 * **Also:** an injectable **Per-Transition Object** object which holds the pending state parameters for the pending `Transition` currently running.
 *
 * ## Deprecation warning:
 *
 * The value injected for `$stateParams` is different depending on where it is injected.
 *
 * - When injected into an angular service, the object injected is the global **Service Object** with the parameter values for the latest successful `Transition`.
 * - When injected into transition hooks, resolves, or view controllers, the object is the **Per-Transition Object** with the parameter values for the running `Transition`.
 *
 * Because of these confusing details, this service is deprecated.
 *
 * @deprecated Instead of using the global `$stateParams` service object,
 * inject [[$uiRouterGlobals]] and use [[UIRouterGlobals.params]]
 *
 * ```js
 * MyService.$inject = ['$uiRouterGlobals'];
 * function MyService($uiRouterGlobals) {
 *   return {
 *     paramValues: function () {
 *       return $uiRouterGlobals.params;
 *     }
 *   }
 * }
 * ```
 *
 * @deprecated Instead of using the per-transition `$stateParams` object,
 * inject the current `Transition` (as [[$transition$]]) and use [[Transition.params]]
 *
 * ```js
 * MyController.$inject = ['$transition$'];
 * function MyController($transition$) {
 *   var username = $transition$.params().username;
 *   // .. do something with username
 * }
 * ```
 *
 * ---
 *
 * This object can be injected into other services.
 *
 * #### Deprecated Example:
 * ```js
 * SomeService.$inject = ['$http', '$stateParams'];
 * function SomeService($http, $stateParams) {
 *   return {
 *     getUser: function() {
 *       return $http.get('/api/users/' + $stateParams.username);
 *     }
 *   }
 * };
 * angular.service('SomeService', SomeService);
 * ```
 */

var $stateParams;
/**
 * Global UI-Router variables
 *
 * The router global state as a **Service Object** (injectable during runtime).
 *
 * This object contains globals such as the current state and current parameter values.
 */
var $uiRouterGlobals;
/**
 * The UI-Router instance
 *
 * The [[UIRouter]] singleton (the router instance) as a **Service Object** (injectable during runtime).
 *
 * This object is the UI-Router singleton instance, created by angular dependency injection during application bootstrap.
 * It has references to the other UI-Router services
 *
 * #### Note: This object is also exposed as [[$uiRouterProvider]] for injection during angular config time.
 */
var $uiRouter;
/**
 * The UI-Router instance
 *
 * The [[UIRouter]] singleton (the router instance) as a **Provider Object** (injectable during config phase).
 *
 * This object is the UI-Router singleton instance, created by angular dependency injection during application bootstrap.
 * It has references to the other UI-Router services
 *
 * #### Note: This object is also exposed as [[$uiRouter]] for injection during runtime.
 */
var $uiRouterProvider;
/**
 * Transition debug/tracing
 *
 * The [[Trace]] singleton as a **Service Object** (injectable during runtime).
 *
 * Enables or disables Transition tracing which can help to debug issues.
 */
var $trace;
/**
 * The Transition Service
 *
 * The [[TransitionService]] singleton as a **Service Object** (injectable during runtime).
 *
 * This angular service exposes the [[TransitionService]] singleton, which is primarily
 * used to register global transition hooks.
 *
 * #### Note: This object is also exposed as [[$transitionsProvider]] for injection during the config phase.
 */
var $transitions;
/**
 * The Transition Service
 *
 * The [[TransitionService]] singleton as a **Provider Object** (injectable during config phase)
 *
 * This angular service exposes the [[TransitionService]] singleton, which is primarily
 * used to register global transition hooks.
 *
 * #### Note: This object is also exposed as [[$transitions]] for injection during runtime.
 */
var $transitionsProvider;
/**
 * The current [[Transition]] object
 *
 * The current [[Transition]] object as a **Per-Transition Object** (injectable into Resolve, Hooks, Controllers)
 *
 * This object returns information about the current transition, including:
 *
 * - To/from states
 * - To/from parameters
 * - Transition options
 * - States being entered, exited, and retained
 * - Resolve data
 * - A Promise for the transition
 * - Any transition failure information
 * - An injector for both Service and Per-Transition Objects
 */
var $transition$;
/**
 * The State Service
 *
 * The [[StateService]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service used to manage and query information on registered states.
 * It exposes state related APIs including:
 *
 * - Start a [[Transition]]
 * - Imperatively lazy load states
 * - Check if a state is currently active
 * - Look up states by name
 * - Build URLs for a state+parameters
 * - Configure the global Transition error handler
 *
 * This angular service exposes the [[StateService]] singleton.
 */
var $state;
/**
 * The State Registry
 *
 * The [[StateRegistry]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service is used to register/deregister states.
 * It has state registration related APIs including:
 *
 * - Register/deregister states
 * - Listen for state registration/deregistration
 * - Get states by name
 * - Add state decorators (to customize the state creation process)
 *
 * #### Note: This object is also exposed as [[$stateRegistryProvider]] for injection during the config phase.
 */
var $stateRegistry;
/**
 * The State Registry
 *
 * The [[StateRegistry]] singleton as a **Provider Object** (injectable during config time).
 *
 * This service is used to register/deregister states.
 * It has state registration related APIs including:
 *
 * - Register/deregister states
 * - Listen for state registration/deregistration
 * - Get states by name
 * - Add state decorators (to customize the state creation process)
 *
 * #### Note: This object is also exposed as [[$stateRegistry]] for injection during runtime.
 */
var $stateRegistryProvider;
/**
 * The View Scroll provider
 *
 * The [[UIViewScrollProvider]] as a **Provider Object** (injectable during config time).
 *
 * This angular service exposes the [[UIViewScrollProvider]] singleton and is
 * used to disable UI-Router's scroll behavior.
 */
var $uiViewScrollProvider;
/**
 * The View Scroll function
 *
 * The View Scroll function as a **Service Object** (injectable during runtime).
 *
 * This is a function that scrolls an element into view.
 * The element is scrolled after a `$timeout` so the DOM has time to refresh.
 *
 * If you prefer to rely on `$anchorScroll` to scroll the view to the anchor,
 * this can be enabled by calling [[UIViewScrollProvider.useAnchorScroll]].
 *
 * Note: this function is used by the [[uiView]] when the `autoscroll` expression evaluates to true.
 */
var $uiViewScroll;
/**
 * The StateProvider
 *
 * An angular1-only [[StateProvider]] as a **Provider Object** (injectable during config time).
 *
 * This angular service exposes the [[StateProvider]] singleton.
 *
 * The `StateProvider` is primarily used to register states or add custom state decorators.
 *
 * ##### Note: This provider is a ng1 vestige.
 * It is a passthrough to [[$stateRegistry]] and [[$state]].
 */
var $stateProvider;
/**
 * The URL Service Provider
 *
 * The [[UrlService]] singleton as a **Provider Object** (injectable during the angular config phase).
 *
 * A service used to configure and interact with the URL.
 * It has URL related APIs including:
 *
 * - add URL rules [[UrlService.rules.when]]
 * - configure behavior when no url matches [[UrlService.rules.otherwise]]
 * - delay initial URL synchronization [[UrlService.deferIntercept]].
 * - get or set the current url: [[UrlService.url]]
 *
 * ##### Note: This service can also be injected during runtime as [[$urlService]].
 */
var $urlServiceProvider;
/**
 * The URL Service
 *
 * The [[UrlService]] singleton as a **Service Object** (injectable during runtime).
 *
 * Note: This service can also be injected during the config phase as [[$urlServiceProvider]].
 *
 * Used to configure the URL.
 * It has URL related APIs including:
 *
 * - register custom Parameter types [[UrlService.rules.when]]
 * - add URL rules [[UrlService.rules.when]]
 * - configure behavior when no url matches [[UrlService.rules.otherwise]]
 * - delay initial URL synchronization [[UrlService.deferIntercept]].
 * - get or set the current url: [[UrlService.url]]
 *
 * ##### Note: This service can also be injected during the config phase as [[$urlServiceProvider]].
 */
var $urlService;
/**
 * The URL Router Provider
 *
 * The [[UrlRouter]] singleton as a **Provider Object** (injectable during config time).
 *
 * #### Note: This object is also exposed as [[$urlRouter]] for injection during runtime.
 *
 * @deprecated This object is now considered internal. Use [[$urlServiceProvider]] instead.
 */
var $urlRouterProvider;
/**
 * The Url Router
 *
 * The [[UrlRouter]] singleton as a **Service Object** (injectable during runtime).
 *
 * #### Note: This object is also exposed as [[$urlRouterProvider]] for injection during angular config time.
 *
 * @deprecated This object is now considered internal. Use [[$urlService]] instead.
 */
var $urlRouter;
/**
 * The URL Matcher Factory
 *
 * The [[UrlMatcherFactory]] singleton as a **Service Object** (injectable during runtime).
 *
 * This service is used to set url mapping options, define custom parameter types, and create [[UrlMatcher]] objects.
 *
 * #### Note: This object is also exposed as [[$urlMatcherFactoryProvider]] for injection during angular config time.
 *
 * @deprecated This object is now considered internal. Use [[$urlService]] instead.
 */
var $urlMatcherFactory;
/**
 * The URL Matcher Factory
 *
 * The [[UrlMatcherFactory]] singleton as a **Provider Object** (injectable during config time).
 *
 * This service is used to set url mapping options, define custom parameter types, and create [[UrlMatcher]] objects.
 *
 * #### Note: This object is also exposed as [[$urlMatcherFactory]] for injection during runtime.
 *
 * @deprecated This object is now considered internal. Use [[$urlService]] instead.
 */
var $urlMatcherFactoryProvider;
//# sourceMappingURL=injectables.js.map

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ui_router_core_1 = __webpack_require__(9);
/**
 * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
 */
var Ng1LocationServices = function () {
    function Ng1LocationServices($locationProvider) {
        // .onChange() registry
        this._urlListeners = [];
        this.$locationProvider = $locationProvider;
        var _lp = ui_router_core_1.val($locationProvider);
        ui_router_core_1.createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
    }
    Ng1LocationServices.prototype.dispose = function () {};
    Ng1LocationServices.prototype.onChange = function (callback) {
        var _this = this;
        this._urlListeners.push(callback);
        return function () {
            return ui_router_core_1.removeFrom(_this._urlListeners)(callback);
        };
    };
    Ng1LocationServices.prototype.html5Mode = function () {
        var html5Mode = this.$locationProvider.html5Mode();
        html5Mode = ui_router_core_1.isObject(html5Mode) ? html5Mode.enabled : html5Mode;
        return html5Mode && this.$sniffer.history;
    };
    Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
        if (replace === void 0) {
            replace = false;
        }
        if (newUrl) this.$location.url(newUrl);
        if (replace) this.$location.replace();
        if (state) this.$location.state(state);
        return this.$location.url();
    };
    Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser) {
        var _this = this;
        this.$location = $location;
        this.$sniffer = $sniffer;
        // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
        $rootScope.$on("$locationChangeSuccess", function (evt) {
            return _this._urlListeners.forEach(function (fn) {
                return fn(evt);
            });
        });
        var _loc = ui_router_core_1.val($location);
        var _browser = ui_router_core_1.val($browser);
        // Bind these LocationService functions to $location
        ui_router_core_1.createProxyFunctions(_loc, this, _loc, ["replace", "path", "search", "hash"]);
        // Bind these LocationConfig functions to $location
        ui_router_core_1.createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
        // Bind these LocationConfig functions to $browser
        ui_router_core_1.createProxyFunctions(_browser, this, _browser, ['baseHref']);
    };
    /**
     * Applys ng1-specific path parameter encoding
     *
     * The Angular 1 `$location` service is a bit weird.
     * It doesn't allow slashes to be encoded/decoded bi-directionally.
     *
     * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
     *
     * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
     *
     * @param router
     */
    Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
        var pathType = router.urlMatcherFactory.type('path');
        pathType.encode = function (val) {
            return val != null ? val.toString().replace(/(~|\/)/g, function (m) {
                return { '~': '~~', '/': '~2F' }[m];
            }) : val;
        };
        pathType.decode = function (val) {
            return val != null ? val.toString().replace(/(~~|~2F)/g, function (m) {
                return { '~~': '~', '~2F': '/' }[m];
            }) : val;
        };
    };
    return Ng1LocationServices;
}();
exports.Ng1LocationServices = Ng1LocationServices;
//# sourceMappingURL=locationServices.js.map

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @module state */ /** for typedoc */


var angular_1 = __webpack_require__(20);
/**
 * @ngdoc filter
 * @name ui.router.state.filter:isState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_is $state.is("stateName")}.
 */
$IsStateFilter.$inject = ['$state'];
function $IsStateFilter($state) {
    var isFilter = function isFilter(state, params, options) {
        return $state.is(state, params, options);
    };
    isFilter.$stateful = true;
    return isFilter;
}
exports.$IsStateFilter = $IsStateFilter;
/**
 * @ngdoc filter
 * @name ui.router.state.filter:includedByState
 *
 * @requires ui.router.state.$state
 *
 * @description
 * Translates to {@link ui.router.state.$state#methods_includes $state.includes('fullOrPartialStateName')}.
 */
$IncludedByStateFilter.$inject = ['$state'];
function $IncludedByStateFilter($state) {
    var includesFilter = function includesFilter(state, params, options) {
        return $state.includes(state, params, options);
    };
    includesFilter.$stateful = true;
    return includesFilter;
}
exports.$IncludedByStateFilter = $IncludedByStateFilter;
angular_1.ng.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);
//# sourceMappingURL=stateFilters.js.map

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module ng1 */ /** */

var ui_router_core_1 = __webpack_require__(9);
var services_1 = __webpack_require__(57);
/**
 * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
 * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
 *
 * When the [[StateBuilder]] builds a [[State]] object from a raw [[StateDeclaration]], this builder
 * ensures that those hooks are injectable for angular-ui-router (ng1).
 */
exports.getStateHookBuilder = function (hookName) {
    return function stateHookBuilder(state, parentFn) {
        var hook = state[hookName];
        var pathname = hookName === 'onExit' ? 'from' : 'to';
        function decoratedNg1Hook(trans, state) {
            var resolveContext = new ui_router_core_1.ResolveContext(trans.treeChanges(pathname));
            var locals = ui_router_core_1.extend(services_1.getLocals(resolveContext), { $state$: state, $transition$: trans });
            return ui_router_core_1.services.$injector.invoke(hook, this, locals);
        }
        return hook ? decoratedNg1Hook : undefined;
    };
};
//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module view */
/** for typedoc */

var angular_1 = __webpack_require__(20);
var ui_router_core_1 = __webpack_require__(9);
/**
 * Service which manages loading of templates from a ViewConfig.
 */
var TemplateFactory = function () {
    function TemplateFactory() {
        var _this = this;
        /** @hidden */this._useHttp = angular_1.ng.version.minor < 3;
        /** @hidden */this.$get = ['$http', '$templateCache', '$injector', function ($http, $templateCache, $injector) {
            _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
            _this.$http = $http;
            _this.$templateCache = $templateCache;
            return _this;
        }];
    }
    /** @hidden */
    TemplateFactory.prototype.useHttpService = function (value) {
        this._useHttp = value;
    };
    ;
    /**
     * Creates a template from a configuration object.
     *
     * @param config Configuration object for which to load a template.
     * The following properties are search in the specified order, and the first one
     * that is defined is used to create the template:
     *
     * @param params  Parameters to pass to the template function.
     * @param context The resolve context associated with the template's view
     *
     * @return {string|object}  The template html as a string, or a promise for
     * that string,or `null` if no template is configured.
     */
    TemplateFactory.prototype.fromConfig = function (config, params, context) {
        var defaultTemplate = "<ui-view></ui-view>";
        var asTemplate = function asTemplate(result) {
            return ui_router_core_1.services.$q.when(result).then(function (str) {
                return { template: str };
            });
        };
        var asComponent = function asComponent(result) {
            return ui_router_core_1.services.$q.when(result).then(function (str) {
                return { component: str };
            });
        };
        return ui_router_core_1.isDefined(config.template) ? asTemplate(this.fromString(config.template, params)) : ui_router_core_1.isDefined(config.templateUrl) ? asTemplate(this.fromUrl(config.templateUrl, params)) : ui_router_core_1.isDefined(config.templateProvider) ? asTemplate(this.fromProvider(config.templateProvider, params, context)) : ui_router_core_1.isDefined(config.component) ? asComponent(config.component) : ui_router_core_1.isDefined(config.componentProvider) ? asComponent(this.fromComponentProvider(config.componentProvider, params, context)) : asTemplate(defaultTemplate);
    };
    ;
    /**
     * Creates a template from a string or a function returning a string.
     *
     * @param template html template as a string or function that returns an html template as a string.
     * @param params Parameters to pass to the template function.
     *
     * @return {string|object} The template html as a string, or a promise for that
     * string.
     */
    TemplateFactory.prototype.fromString = function (template, params) {
        return ui_router_core_1.isFunction(template) ? template(params) : template;
    };
    ;
    /**
     * Loads a template from the a URL via `$http` and `$templateCache`.
     *
     * @param {string|Function} url url of the template to load, or a function
     * that returns a url.
     * @param {Object} params Parameters to pass to the url function.
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */
    TemplateFactory.prototype.fromUrl = function (url, params) {
        if (ui_router_core_1.isFunction(url)) url = url(params);
        if (url == null) return null;
        if (this._useHttp) {
            return this.$http.get(url, { cache: this.$templateCache, headers: { Accept: 'text/html' } }).then(function (response) {
                return response.data;
            });
        }
        return this.$templateRequest(url);
    };
    ;
    /**
     * Creates a template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */
    TemplateFactory.prototype.fromProvider = function (provider, params, context) {
        var deps = ui_router_core_1.services.$injector.annotate(provider);
        var providerFn = ui_router_core_1.isArray(provider) ? ui_router_core_1.tail(provider) : provider;
        var resolvable = new ui_router_core_1.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    ;
    /**
     * Creates a component's template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */
    TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
        var deps = ui_router_core_1.services.$injector.annotate(provider);
        var providerFn = ui_router_core_1.isArray(provider) ? ui_router_core_1.tail(provider) : provider;
        var resolvable = new ui_router_core_1.Resolvable("", providerFn, deps);
        return resolvable.get(context);
    };
    ;
    /**
     * Creates a template from a component's name
     *
     * This implements route-to-component.
     * It works by retrieving the component (directive) metadata from the injector.
     * It analyses the component's bindings, then constructs a template that instantiates the component.
     * The template wires input and output bindings to resolves or from the parent component.
     *
     * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
     * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
     * @param component {string} Component's name in camel case.
     * @param bindings An object defining the component's bindings: {foo: '<'}
     * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */
    TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
        bindings = bindings || {};
        // Bind once prefix
        var prefix = angular_1.ng.version.minor >= 3 ? "::" : "";
        var attributeTpl = function attributeTpl(input) {
            var name = input.name,
                type = input.type;
            var attrName = ui_router_core_1.kebobString(name);
            // If the ui-view has an attribute which matches a binding on the routed component
            // then pass that attribute through to the routed component template.
            // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
            if (uiView.attr(attrName) && !bindings[name]) return attrName + "='" + uiView.attr(attrName) + "'";
            var resolveName = bindings[name] || name;
            // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
            // some-attr="{{ ::$resolve.someResolveName }}"
            if (type === '@') return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
            // Wire "&" callbacks to resolves that return a callback function
            // Get the result of the resolve (should be a function) and annotate it to get its arguments.
            // some-attr="$resolve.someResolveResultName(foo, bar)"
            if (type === '&') {
                var res = context.getResolvable(resolveName);
                var fn = res && res.data;
                var args = fn && ui_router_core_1.services.$injector.annotate(fn) || [];
                // account for array style injection, i.e., ['foo', function(foo) {}]
                var arrayIdxStr = ui_router_core_1.isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
                return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(",") + ")'";
            }
            // some-attr="::$resolve.someResolveName"
            return attrName + "='" + prefix + "$resolve." + resolveName + "'";
        };
        var attrs = getComponentBindings(component).map(attributeTpl).join(" ");
        var kebobName = ui_router_core_1.kebobString(component);
        return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
    };
    ;
    return TemplateFactory;
}();
exports.TemplateFactory = TemplateFactory;
// Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
function getComponentBindings(name) {
    var cmpDefs = ui_router_core_1.services.$injector.get(name + "Directive"); // could be multiple
    if (!cmpDefs || !cmpDefs.length) throw new Error("Unable to find component named '" + name + "'");
    return cmpDefs.map(getBindings).reduce(ui_router_core_1.unnestR, []);
}
// Given a directive definition, find its object input attributes
// Use different properties, depending on the type of directive (component, bindToController, normal)
var getBindings = function getBindings(def) {
    if (ui_router_core_1.isObject(def.bindToController)) return scopeBindings(def.bindToController);
    return scopeBindings(def.scope);
};
// for ng 1.2 style, process the scope: { input: "=foo" }
// for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
var scopeBindings = function scopeBindings(bindingsObj) {
    return Object.keys(bindingsObj || {}).map(function (key) {
        return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])];
    }).filter(function (tuple) {
        return ui_router_core_1.isDefined(tuple) && ui_router_core_1.isArray(tuple[1]);
    }).map(function (tuple) {
        return { name: tuple[1][2] || tuple[0], type: tuple[1][1] };
    });
};
//# sourceMappingURL=templateFactory.js.map

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module url */ /** */

var ui_router_core_1 = __webpack_require__(9);
var ui_router_core_2 = __webpack_require__(9);
/**
 * Manages rules for client-side URL
 *
 * This class manages the router rules for what to do when the URL changes.
 *
 * ## Deprecation warning
 *
 * Use [[UrlService]]
 *
 * This provider remains for backwards compatibility.
 */
var UrlRouterProvider = function () {
    /** @hidden */
    function UrlRouterProvider(router) {
        this._router = router;
        this._urlRouter = router.urlRouter;
    }
    /** @hidden */
    UrlRouterProvider.prototype.$get = function () {
        var urlRouter = this._urlRouter;
        urlRouter.update(true);
        if (!urlRouter.interceptDeferred) urlRouter.listen();
        return urlRouter;
    };
    /**
     * Registers a url handler function.
     *
     * Registers a low level url handler (a `rule`).
     * A rule detects specific URL patterns and returns a redirect, or performs some action.
     *
     * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Here's an example of how you might allow case insensitive urls
     *   $urlRouterProvider.rule(function ($injector, $location) {
     *     var path = $location.path(),
     *         normalized = path.toLowerCase();
     *
     *     if (path !== normalized) {
     *       return normalized;
     *     }
     *   });
     * });
     * ```
     *
     * @param ruleFn
     * Handler function that takes `$injector` and `$location` services as arguments.
     * You can use them to detect a url and return a different url as a string.
     *
     * @return [[UrlRouterProvider]] (`this`)
     */
    UrlRouterProvider.prototype.rule = function (ruleFn) {
        var _this = this;
        if (!ui_router_core_2.isFunction(ruleFn)) throw new Error("'rule' must be a function");
        var match = function match() {
            return ruleFn(ui_router_core_2.services.$injector, _this._router.locationService);
        };
        var rule = new ui_router_core_1.BaseUrlRule(match, ui_router_core_2.identity);
        this._urlRouter.rule(rule);
        return this;
    };
    ;
    /**
     * Defines the path or behavior to use when no url can be matched.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // if the path doesn't match any of the urls you configured
     *   // otherwise will take care of routing the user to the
     *   // specified url
     *   $urlRouterProvider.otherwise('/index');
     *
     *   // Example of using function rule as param
     *   $urlRouterProvider.otherwise(function ($injector, $location) {
     *     return '/a/valid/url';
     *   });
     * });
     * ```
     *
     * @param rule
     * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
     * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
     *
     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
     */
    UrlRouterProvider.prototype.otherwise = function (rule) {
        var _this = this;
        var urlRouter = this._urlRouter;
        if (ui_router_core_2.isString(rule)) {
            urlRouter.otherwise(rule);
        } else if (ui_router_core_2.isFunction(rule)) {
            urlRouter.otherwise(function () {
                return rule(ui_router_core_2.services.$injector, _this._router.locationService);
            });
        } else {
            throw new Error("'rule' must be a string or function");
        }
        return this;
    };
    ;
    /**
     * Registers a handler for a given url matching.
     *
     * If the handler is a string, it is
     * treated as a redirect, and is interpolated according to the syntax of match
     * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
     *
     * If the handler is a function, it is injectable.
     * It gets invoked if `$location` matches.
     * You have the option of inject the match object as `$match`.
     *
     * The handler can return
     *
     * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
     *   will continue trying to find another one that matches.
     * - **string** which is treated as a redirect and passed to `$location.url()`
     * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
     *
     * @example
     * ```js
     *
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
     *     if ($state.$current.navigable !== state ||
     *         !equalForKeys($match, $stateParams) {
     *      $state.transitionTo(state, $match, false);
     *     }
     *   });
     * });
     * ```
     *
     * @param what A pattern string to match, compiled as a [[UrlMatcher]].
     * @param handler The path (or function that returns a path) that you want to redirect your user to.
     * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
     *
     * Note: the handler may also invoke arbitrary code, such as `$state.go()`
     */
    UrlRouterProvider.prototype.when = function (what, handler) {
        if (ui_router_core_2.isArray(handler) || ui_router_core_2.isFunction(handler)) {
            handler = UrlRouterProvider.injectableHandler(this._router, handler);
        }
        this._urlRouter.when(what, handler);
        return this;
    };
    ;
    UrlRouterProvider.injectableHandler = function (router, handler) {
        return function (match) {
            return ui_router_core_2.services.$injector.invoke(handler, null, { $match: match, $stateParams: router.globals.params });
        };
    };
    /**
     * Disables monitoring of the URL.
     *
     * Call this method before UI-Router has bootstrapped.
     * It will stop UI-Router from performing the initial url sync.
     *
     * This can be useful to perform some asynchronous initialization before the router starts.
     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Prevent $urlRouter from automatically intercepting URL changes;
     *   $urlRouterProvider.deferIntercept();
     * })
     *
     * app.run(function (MyService, $urlRouter, $http) {
     *   $http.get("/stuff").then(function(resp) {
     *     MyService.doStuff(resp.data);
     *     $urlRouter.listen();
     *     $urlRouter.sync();
     *   });
     * });
     * ```
     *
     * @param defer Indicates whether to defer location change interception.
     *        Passing no parameter is equivalent to `true`.
     */
    UrlRouterProvider.prototype.deferIntercept = function (defer) {
        this._urlRouter.deferIntercept(defer);
    };
    ;
    return UrlRouterProvider;
}();
exports.UrlRouterProvider = UrlRouterProvider;
//# sourceMappingURL=urlRouterProvider.js.map

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module ng1 */ /** */

var angular_1 = __webpack_require__(20);
/** @hidden */
function $ViewScrollProvider() {
    var useAnchorScroll = false;
    this.useAnchorScroll = function () {
        useAnchorScroll = true;
    };
    this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
        if (useAnchorScroll) {
            return $anchorScroll;
        }
        return function ($element) {
            return $timeout(function () {
                $element[0].scrollIntoView();
            }, 0, false);
        };
    }];
}
angular_1.ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);
//# sourceMappingURL=viewScroll.js.map

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @license AngularJS v1.6.9
 * (c) 2010-2018 Google, Inc. http://angularjs.org
 * License: MIT
 */
(function (window) {
  'use strict';

  /* exported
    minErrConfig,
    errorHandlingConfig,
    isValidObjectMaxDepth
  */

  var minErrConfig = {
    objectMaxDepth: 5
  };

  /**
   * @ngdoc function
   * @name angular.errorHandlingConfig
   * @module ng
   * @kind function
   *
   * @description
   * Configure several aspects of error handling in AngularJS if used as a setter or return the
   * current configuration if used as a getter. The following options are supported:
   *
   * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
   *
   * Omitted or undefined options will leave the corresponding configuration values unchanged.
   *
   * @param {Object=} config - The configuration object. May only contain the options that need to be
   *     updated. Supported keys:
   *
   * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
   *   non-positive or non-numeric value, removes the max depth limit.
   *   Default: 5
   */
  function errorHandlingConfig(config) {
    if (isObject(config)) {
      if (isDefined(config.objectMaxDepth)) {
        minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
      }
    } else {
      return minErrConfig;
    }
  }

  /**
   * @private
   * @param {Number} maxDepth
   * @return {boolean}
   */
  function isValidObjectMaxDepth(maxDepth) {
    return isNumber(maxDepth) && maxDepth > 0;
  }

  /**
   * @description
   *
   * This object provides a utility for producing rich Error messages within
   * AngularJS. It can be called as follows:
   *
   * var exampleMinErr = minErr('example');
   * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
   *
   * The above creates an instance of minErr in the example namespace. The
   * resulting error will have a namespaced error code of example.one.  The
   * resulting error will replace {0} with the value of foo, and {1} with the
   * value of bar. The object is not restricted in the number of arguments it can
   * take.
   *
   * If fewer arguments are specified than necessary for interpolation, the extra
   * interpolation markers will be preserved in the final string.
   *
   * Since data will be parsed statically during a build step, some restrictions
   * are applied with respect to how minErr instances are created and called.
   * Instances should have names of the form namespaceMinErr for a minErr created
   * using minErr('namespace') . Error codes, namespaces and template strings
   * should all be static strings, not variables or general expressions.
   *
   * @param {string} module The namespace to use for the new minErr instance.
   * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
   *   error from returned function, for cases when a particular type of error is useful.
   * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
   */

  function minErr(module, ErrorConstructor) {
    ErrorConstructor = ErrorConstructor || Error;
    return function () {
      var code = arguments[0],
          template = arguments[1],
          message = '[' + (module ? module + ':' : '') + code + '] ',
          templateArgs = sliceArgs(arguments, 2).map(function (arg) {
        return toDebugString(arg, minErrConfig.objectMaxDepth);
      }),
          paramPrefix,
          i;

      message += template.replace(/\{\d+\}/g, function (match) {
        var index = +match.slice(1, -1);

        if (index < templateArgs.length) {
          return templateArgs[index];
        }

        return match;
      });

      message += '\nhttp://errors.angularjs.org/1.6.9/' + (module ? module + '/' : '') + code;

      for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
        message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
      }

      return new ErrorConstructor(message);
    };
  }

  /* We need to tell ESLint what variables are being exported */
  /* exported
    angular,
    msie,
    jqLite,
    jQuery,
    slice,
    splice,
    push,
    toString,
    minErrConfig,
    errorHandlingConfig,
    isValidObjectMaxDepth,
    ngMinErr,
    angularModule,
    uid,
    REGEX_STRING_REGEXP,
    VALIDITY_STATE_PROPERTY,
  
    lowercase,
    uppercase,
    manualLowercase,
    manualUppercase,
    nodeName_,
    isArrayLike,
    forEach,
    forEachSorted,
    reverseParams,
    nextUid,
    setHashKey,
    extend,
    toInt,
    inherit,
    merge,
    noop,
    identity,
    valueFn,
    isUndefined,
    isDefined,
    isObject,
    isBlankObject,
    isString,
    isNumber,
    isNumberNaN,
    isDate,
    isError,
    isArray,
    isFunction,
    isRegExp,
    isWindow,
    isScope,
    isFile,
    isFormData,
    isBlob,
    isBoolean,
    isPromiseLike,
    trim,
    escapeForRegexp,
    isElement,
    makeMap,
    includes,
    arrayRemove,
    copy,
    simpleCompare,
    equals,
    csp,
    jq,
    concat,
    sliceArgs,
    bind,
    toJsonReplacer,
    toJson,
    fromJson,
    convertTimezoneToLocal,
    timezoneToOffset,
    startingTag,
    tryDecodeURIComponent,
    parseKeyValue,
    toKeyValue,
    encodeUriSegment,
    encodeUriQuery,
    angularInit,
    bootstrap,
    getTestability,
    snake_case,
    bindJQuery,
    assertArg,
    assertArgFn,
    assertNotHasOwnProperty,
    getter,
    getBlockNodes,
    hasOwnProperty,
    createMap,
    stringify,
  
    NODE_TYPE_ELEMENT,
    NODE_TYPE_ATTRIBUTE,
    NODE_TYPE_TEXT,
    NODE_TYPE_COMMENT,
    NODE_TYPE_DOCUMENT,
    NODE_TYPE_DOCUMENT_FRAGMENT
  */

  ////////////////////////////////////

  /**
   * @ngdoc module
   * @name ng
   * @module ng
   * @installation
   * @description
   *
   * The ng module is loaded by default when an AngularJS application is started. The module itself
   * contains the essential components for an AngularJS application to function. The table below
   * lists a high level breakdown of each of the services/factories, filters, directives and testing
   * components available within this core module.
   *
   */

  var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

  // The name of a form control's ValidityState property.
  // This is used so that it's possible for internal tests to create mock ValidityStates.
  var VALIDITY_STATE_PROPERTY = 'validity';

  var hasOwnProperty = Object.prototype.hasOwnProperty;

  /**
   * @ngdoc function
   * @name angular.lowercase
   * @module ng
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.5.0"
   * removeVersion="1.7.0"
   * Use [String.prototype.toLowerCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toLowerCase) instead.
   *
   * @description Converts the specified string to lowercase.
   * @param {string} string String to be converted to lowercase.
   * @returns {string} Lowercased string.
   */
  var lowercase = function lowercase(string) {
    return isString(string) ? string.toLowerCase() : string;
  };

  /**
   * @ngdoc function
   * @name angular.uppercase
   * @module ng
   * @kind function
   *
   * @deprecated
   * sinceVersion="1.5.0"
   * removeVersion="1.7.0"
   * Use [String.prototype.toUpperCase](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/toUpperCase) instead.
   *
   * @description Converts the specified string to uppercase.
   * @param {string} string String to be converted to uppercase.
   * @returns {string} Uppercased string.
   */
  var uppercase = function uppercase(string) {
    return isString(string) ? string.toUpperCase() : string;
  };

  var manualLowercase = function manualLowercase(s) {
    /* eslint-disable no-bitwise */
    return isString(s) ? s.replace(/[A-Z]/g, function (ch) {
      return String.fromCharCode(ch.charCodeAt(0) | 32);
    }) : s;
    /* eslint-enable */
  };
  var manualUppercase = function manualUppercase(s) {
    /* eslint-disable no-bitwise */
    return isString(s) ? s.replace(/[a-z]/g, function (ch) {
      return String.fromCharCode(ch.charCodeAt(0) & ~32);
    }) : s;
    /* eslint-enable */
  };

  // String#toLowerCase and String#toUpperCase don't produce correct results in browsers with Turkish
  // locale, for this reason we need to detect this case and redefine lowercase/uppercase methods
  // with correct but slower alternatives. See https://github.com/angular/angular.js/issues/11387
  if ('i' !== 'I'.toLowerCase()) {
    lowercase = manualLowercase;
    uppercase = manualUppercase;
  }

  var msie,
      // holds major version number for IE, or NaN if UA is not IE.
  jqLite,
      // delay binding since jQuery could be loaded after us.
  jQuery,
      // delay binding
  slice = [].slice,
      splice = [].splice,
      push = [].push,
      toString = Object.prototype.toString,
      getPrototypeOf = Object.getPrototypeOf,
      ngMinErr = minErr('ng'),


  /** @name angular */
  angular = window.angular || (window.angular = {}),
      angularModule,
      uid = 0;

  // Support: IE 9-11 only
  /**
   * documentMode is an IE-only property
   * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
   */
  msie = window.document.documentMode;

  /**
   * @private
   * @param {*} obj
   * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
   *                   String ...)
   */
  function isArrayLike(obj) {

    // `null`, `undefined` and `window` are not array-like
    if (obj == null || isWindow(obj)) return false;

    // arrays, strings and jQuery/jqLite objects are array like
    // * jqLite is either the jQuery or jqLite constructor function
    // * we have to check the existence of jqLite first as this method is called
    //   via the forEach method when constructing the jqLite object in the first place
    if (isArray(obj) || isString(obj) || jqLite && obj instanceof jqLite) return true;

    // Support: iOS 8.2 (not reproducible in simulator)
    // "length" in obj used to prevent JIT error (gh-11508)
    var length = 'length' in Object(obj) && obj.length;

    // NodeList objects (with `item` method) and
    // other objects with suitable length characteristics are array-like
    return isNumber(length) && (length >= 0 && (length - 1 in obj || obj instanceof Array) || typeof obj.item === 'function');
  }

  /**
   * @ngdoc function
   * @name angular.forEach
   * @module ng
   * @kind function
   *
   * @description
   * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
   * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
   * is the value of an object property or an array element, `key` is the object property key or
   * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
   *
   * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
   * using the `hasOwnProperty` method.
   *
   * Unlike ES262's
   * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
   * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
   * return the value provided.
   *
     ```js
       var values = {name: 'misko', gender: 'male'};
       var log = [];
       angular.forEach(values, function(value, key) {
         this.push(key + ': ' + value);
       }, log);
       expect(log).toEqual(['name: misko', 'gender: male']);
     ```
   *
   * @param {Object|Array} obj Object to iterate over.
   * @param {Function} iterator Iterator function.
   * @param {Object=} context Object to become context (`this`) for the iterator function.
   * @returns {Object|Array} Reference to `obj`.
   */

  function forEach(obj, iterator, context) {
    var key, length;
    if (obj) {
      if (isFunction(obj)) {
        for (key in obj) {
          if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      } else if (isArray(obj) || isArrayLike(obj)) {
        var isPrimitive = (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) !== 'object';
        for (key = 0, length = obj.length; key < length; key++) {
          if (isPrimitive || key in obj) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
      } else if (isBlankObject(obj)) {
        // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
        for (key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      } else if (typeof obj.hasOwnProperty === 'function') {
        // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
        for (key in obj) {
          if (obj.hasOwnProperty(key)) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      } else {
        // Slow path for objects which do not have a method `hasOwnProperty`
        for (key in obj) {
          if (hasOwnProperty.call(obj, key)) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      }
    }
    return obj;
  }

  function forEachSorted(obj, iterator, context) {
    var keys = Object.keys(obj).sort();
    for (var i = 0; i < keys.length; i++) {
      iterator.call(context, obj[keys[i]], keys[i]);
    }
    return keys;
  }

  /**
   * when using forEach the params are value, key, but it is often useful to have key, value.
   * @param {function(string, *)} iteratorFn
   * @returns {function(*, string)}
   */
  function reverseParams(iteratorFn) {
    return function (value, key) {
      iteratorFn(key, value);
    };
  }

  /**
   * A consistent way of creating unique IDs in angular.
   *
   * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
   * we hit number precision issues in JavaScript.
   *
   * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
   *
   * @returns {number} an unique alpha-numeric string
   */
  function nextUid() {
    return ++uid;
  }

  /**
   * Set or clear the hashkey for an object.
   * @param obj object
   * @param h the hashkey (!truthy to delete the hashkey)
   */
  function setHashKey(obj, h) {
    if (h) {
      obj.$$hashKey = h;
    } else {
      delete obj.$$hashKey;
    }
  }

  function baseExtend(dst, objs, deep) {
    var h = dst.$$hashKey;

    for (var i = 0, ii = objs.length; i < ii; ++i) {
      var obj = objs[i];
      if (!isObject(obj) && !isFunction(obj)) continue;
      var keys = Object.keys(obj);
      for (var j = 0, jj = keys.length; j < jj; j++) {
        var key = keys[j];
        var src = obj[key];

        if (deep && isObject(src)) {
          if (isDate(src)) {
            dst[key] = new Date(src.valueOf());
          } else if (isRegExp(src)) {
            dst[key] = new RegExp(src);
          } else if (src.nodeName) {
            dst[key] = src.cloneNode(true);
          } else if (isElement(src)) {
            dst[key] = src.clone();
          } else {
            if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
            baseExtend(dst[key], [src], true);
          }
        } else {
          dst[key] = src;
        }
      }
    }

    setHashKey(dst, h);
    return dst;
  }

  /**
   * @ngdoc function
   * @name angular.extend
   * @module ng
   * @kind function
   *
   * @description
   * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
   * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
   * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
   *
   * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
   * {@link angular.merge} for this.
   *
   * @param {Object} dst Destination object.
   * @param {...Object} src Source object(s).
   * @returns {Object} Reference to `dst`.
   */
  function extend(dst) {
    return baseExtend(dst, slice.call(arguments, 1), false);
  }

  /**
  * @ngdoc function
  * @name angular.merge
  * @module ng
  * @kind function
  *
  * @description
  * Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
  * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
  * by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
  *
  * Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
  * objects, performing a deep copy.
  *
  * @deprecated
  * sinceVersion="1.6.5"
  * This function is deprecated, but will not be removed in the 1.x lifecycle.
  * There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
  * supported by this function. We suggest
  * using [lodash's merge()](https://lodash.com/docs/4.17.4#merge) instead.
  *
  * @knownIssue
  * This is a list of (known) object types that are not handled correctly by this function:
  * - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
  * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
  * - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
  * - AngularJS {@link $rootScope.Scope scopes};
  *
  * @param {Object} dst Destination object.
  * @param {...Object} src Source object(s).
  * @returns {Object} Reference to `dst`.
  */
  function merge(dst) {
    return baseExtend(dst, slice.call(arguments, 1), true);
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
    // eslint-disable-next-line no-self-compare
    return num !== num;
  };

  function inherit(parent, extra) {
    return extend(Object.create(parent), extra);
  }

  /**
   * @ngdoc function
   * @name angular.noop
   * @module ng
   * @kind function
   *
   * @description
   * A function that performs no operations. This function can be useful when writing code in the
   * functional style.
     ```js
       function foo(callback) {
         var result = calculateResult();
         (callback || angular.noop)(result);
       }
     ```
   */
  function noop() {}
  noop.$inject = [];

  /**
   * @ngdoc function
   * @name angular.identity
   * @module ng
   * @kind function
   *
   * @description
   * A function that returns its first argument. This function is useful when writing code in the
   * functional style.
   *
     ```js
     function transformer(transformationFn, value) {
       return (transformationFn || angular.identity)(value);
     };
  
     // E.g.
     function getResult(fn, input) {
       return (fn || angular.identity)(input);
     };
  
     getResult(function(n) { return n * 2; }, 21);   // returns 42
     getResult(null, 21);                            // returns 21
     getResult(undefined, 21);                       // returns 21
     ```
   *
   * @param {*} value to be returned.
   * @returns {*} the value passed in.
   */
  function identity($) {
    return $;
  }
  identity.$inject = [];

  function valueFn(value) {
    return function valueRef() {
      return value;
    };
  }

  function hasCustomToString(obj) {
    return isFunction(obj.toString) && obj.toString !== toString;
  }

  /**
   * @ngdoc function
   * @name angular.isUndefined
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is undefined.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is undefined.
   */
  function isUndefined(value) {
    return typeof value === 'undefined';
  }

  /**
   * @ngdoc function
   * @name angular.isDefined
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is defined.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is defined.
   */
  function isDefined(value) {
    return typeof value !== 'undefined';
  }

  /**
   * @ngdoc function
   * @name angular.isObject
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
   * considered to be objects. Note that JavaScript arrays are objects.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is an `Object` but not `null`.
   */
  function isObject(value) {
    // http://jsperf.com/isobject4
    return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
  }

  /**
   * Determine if a value is an object with a null prototype
   *
   * @returns {boolean} True if `value` is an `Object` with a null prototype
   */
  function isBlankObject(value) {
    return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !getPrototypeOf(value);
  }

  /**
   * @ngdoc function
   * @name angular.isString
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is a `String`.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `String`.
   */
  function isString(value) {
    return typeof value === 'string';
  }

  /**
   * @ngdoc function
   * @name angular.isNumber
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is a `Number`.
   *
   * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
   *
   * If you wish to exclude these then you can use the native
   * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
   * method.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Number`.
   */
  function isNumber(value) {
    return typeof value === 'number';
  }

  /**
   * @ngdoc function
   * @name angular.isDate
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a value is a date.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Date`.
   */
  function isDate(value) {
    return toString.call(value) === '[object Date]';
  }

  /**
   * @ngdoc function
   * @name angular.isArray
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is an `Array`. Alias of Array.isArray.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is an `Array`.
   */
  var isArray = Array.isArray;

  /**
   * @description
   * Determines if a reference is an `Error`.
   * Loosely based on https://www.npmjs.com/package/iserror
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is an `Error`.
   */
  function isError(value) {
    var tag = toString.call(value);
    switch (tag) {
      case '[object Error]':
        return true;
      case '[object Exception]':
        return true;
      case '[object DOMException]':
        return true;
      default:
        return value instanceof Error;
    }
  }

  /**
   * @ngdoc function
   * @name angular.isFunction
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is a `Function`.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Function`.
   */
  function isFunction(value) {
    return typeof value === 'function';
  }

  /**
   * Determines if a value is a regular expression object.
   *
   * @private
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `RegExp`.
   */
  function isRegExp(value) {
    return toString.call(value) === '[object RegExp]';
  }

  /**
   * Checks if `obj` is a window object.
   *
   * @private
   * @param {*} obj Object to check
   * @returns {boolean} True if `obj` is a window obj.
   */
  function isWindow(obj) {
    return obj && obj.window === obj;
  }

  function isScope(obj) {
    return obj && obj.$evalAsync && obj.$watch;
  }

  function isFile(obj) {
    return toString.call(obj) === '[object File]';
  }

  function isFormData(obj) {
    return toString.call(obj) === '[object FormData]';
  }

  function isBlob(obj) {
    return toString.call(obj) === '[object Blob]';
  }

  function isBoolean(value) {
    return typeof value === 'boolean';
  }

  function isPromiseLike(obj) {
    return obj && isFunction(obj.then);
  }

  var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
  function isTypedArray(value) {
    return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
  }

  function isArrayBuffer(obj) {
    return toString.call(obj) === '[object ArrayBuffer]';
  }

  var trim = function trim(value) {
    return isString(value) ? value.trim() : value;
  };

  // Copied from:
  // http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
  // Prereq: s is a string.
  var escapeForRegexp = function escapeForRegexp(s) {
    return s.replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
    // eslint-disable-next-line no-control-regex
    .replace(/\x08/g, '\\x08');
  };

  /**
   * @ngdoc function
   * @name angular.isElement
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is a DOM element (or wrapped jQuery element).
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
   */
  function isElement(node) {
    return !!(node && (node.nodeName // We are a direct element.
    || node.prop && node.attr && node.find)); // We have an on and find method part of jQuery API.
  }

  /**
   * @param str 'key1,key2,...'
   * @returns {object} in the form of {key1:true, key2:true, ...}
   */
  function makeMap(str) {
    var obj = {},
        items = str.split(','),
        i;
    for (i = 0; i < items.length; i++) {
      obj[items[i]] = true;
    }
    return obj;
  }

  function nodeName_(element) {
    return lowercase(element.nodeName || element[0] && element[0].nodeName);
  }

  function includes(array, obj) {
    return Array.prototype.indexOf.call(array, obj) !== -1;
  }

  function arrayRemove(array, value) {
    var index = array.indexOf(value);
    if (index >= 0) {
      array.splice(index, 1);
    }
    return index;
  }

  /**
   * @ngdoc function
   * @name angular.copy
   * @module ng
   * @kind function
   *
   * @description
   * Creates a deep copy of `source`, which should be an object or an array.
   *
   * * If no destination is supplied, a copy of the object or array is created.
   * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
   *   are deleted and then all elements/properties from the source are copied to it.
   * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
   * * If `source` is identical to `destination` an exception will be thrown.
   *
   * <br />
   * <div class="alert alert-warning">
   *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
   *   and on `destination`) will be ignored.
   * </div>
   *
   * @param {*} source The source that will be used to make a copy.
   *                   Can be any type, including primitives, `null`, and `undefined`.
   * @param {(Object|Array)=} destination Destination into which the source is copied. If
   *     provided, must be of the same type as `source`.
   * @returns {*} The copy or updated `destination`, if `destination` was specified.
   *
   * @example
    <example module="copyExample" name="angular-copy">
      <file name="index.html">
        <div ng-controller="ExampleController">
          <form novalidate class="simple-form">
            <label>Name: <input type="text" ng-model="user.name" /></label><br />
            <label>Age:  <input type="number" ng-model="user.age" /></label><br />
            Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                    <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
            <button ng-click="reset()">RESET</button>
            <button ng-click="update(user)">SAVE</button>
          </form>
          <pre>form = {{user | json}}</pre>
          <pre>leader = {{leader | json}}</pre>
        </div>
      </file>
      <file name="script.js">
        // Module: copyExample
        angular.
          module('copyExample', []).
          controller('ExampleController', ['$scope', function($scope) {
            $scope.leader = {};
  
            $scope.reset = function() {
              // Example with 1 argument
              $scope.user = angular.copy($scope.leader);
            };
  
            $scope.update = function(user) {
              // Example with 2 arguments
              angular.copy(user, $scope.leader);
            };
  
            $scope.reset();
          }]);
      </file>
    </example>
   */
  function copy(source, destination, maxDepth) {
    var stackSource = [];
    var stackDest = [];
    maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;

    if (destination) {
      if (isTypedArray(destination) || isArrayBuffer(destination)) {
        throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
      }
      if (source === destination) {
        throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
      }

      // Empty the destination object
      if (isArray(destination)) {
        destination.length = 0;
      } else {
        forEach(destination, function (value, key) {
          if (key !== '$$hashKey') {
            delete destination[key];
          }
        });
      }

      stackSource.push(source);
      stackDest.push(destination);
      return copyRecurse(source, destination, maxDepth);
    }

    return copyElement(source, maxDepth);

    function copyRecurse(source, destination, maxDepth) {
      maxDepth--;
      if (maxDepth < 0) {
        return '...';
      }
      var h = destination.$$hashKey;
      var key;
      if (isArray(source)) {
        for (var i = 0, ii = source.length; i < ii; i++) {
          destination.push(copyElement(source[i], maxDepth));
        }
      } else if (isBlankObject(source)) {
        // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
        for (key in source) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      } else if (source && typeof source.hasOwnProperty === 'function') {
        // Slow path, which must rely on hasOwnProperty
        for (key in source) {
          if (source.hasOwnProperty(key)) {
            destination[key] = copyElement(source[key], maxDepth);
          }
        }
      } else {
        // Slowest path --- hasOwnProperty can't be called as a method
        for (key in source) {
          if (hasOwnProperty.call(source, key)) {
            destination[key] = copyElement(source[key], maxDepth);
          }
        }
      }
      setHashKey(destination, h);
      return destination;
    }

    function copyElement(source, maxDepth) {
      // Simple values
      if (!isObject(source)) {
        return source;
      }

      // Already copied values
      var index = stackSource.indexOf(source);
      if (index !== -1) {
        return stackDest[index];
      }

      if (isWindow(source) || isScope(source)) {
        throw ngMinErr('cpws', 'Can\'t copy! Making copies of Window or Scope instances is not supported.');
      }

      var needsRecurse = false;
      var destination = copyType(source);

      if (destination === undefined) {
        destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
        needsRecurse = true;
      }

      stackSource.push(source);
      stackDest.push(destination);

      return needsRecurse ? copyRecurse(source, destination, maxDepth) : destination;
    }

    function copyType(source) {
      switch (toString.call(source)) {
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object Int32Array]':
        case '[object Float32Array]':
        case '[object Float64Array]':
        case '[object Uint8Array]':
        case '[object Uint8ClampedArray]':
        case '[object Uint16Array]':
        case '[object Uint32Array]':
          return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);

        case '[object ArrayBuffer]':
          // Support: IE10
          if (!source.slice) {
            // If we're in this case we know the environment supports ArrayBuffer
            /* eslint-disable no-undef */
            var copied = new ArrayBuffer(source.byteLength);
            new Uint8Array(copied).set(new Uint8Array(source));
            /* eslint-enable */
            return copied;
          }
          return source.slice(0);

        case '[object Boolean]':
        case '[object Number]':
        case '[object String]':
        case '[object Date]':
          return new source.constructor(source.valueOf());

        case '[object RegExp]':
          var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
          re.lastIndex = source.lastIndex;
          return re;

        case '[object Blob]':
          return new source.constructor([source], { type: source.type });
      }

      if (isFunction(source.cloneNode)) {
        return source.cloneNode(true);
      }
    }
  }

  // eslint-disable-next-line no-self-compare
  function simpleCompare(a, b) {
    return a === b || a !== a && b !== b;
  }

  /**
   * @ngdoc function
   * @name angular.equals
   * @module ng
   * @kind function
   *
   * @description
   * Determines if two objects or two values are equivalent. Supports value types, regular
   * expressions, arrays and objects.
   *
   * Two objects or values are considered equivalent if at least one of the following is true:
   *
   * * Both objects or values pass `===` comparison.
   * * Both objects or values are of the same type and all of their properties are equal by
   *   comparing them with `angular.equals`.
   * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
   * * Both values represent the same regular expression (In JavaScript,
   *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
   *   representation matches).
   *
   * During a property comparison, properties of `function` type and properties with names
   * that begin with `$` are ignored.
   *
   * Scope and DOMWindow objects are being compared only by identify (`===`).
   *
   * @param {*} o1 Object or value to compare.
   * @param {*} o2 Object or value to compare.
   * @returns {boolean} True if arguments are equal.
   *
   * @example
     <example module="equalsExample" name="equalsExample">
       <file name="index.html">
        <div ng-controller="ExampleController">
          <form novalidate>
            <h3>User 1</h3>
            Name: <input type="text" ng-model="user1.name">
            Age: <input type="number" ng-model="user1.age">
  
            <h3>User 2</h3>
            Name: <input type="text" ng-model="user2.name">
            Age: <input type="number" ng-model="user2.age">
  
            <div>
              <br/>
              <input type="button" value="Compare" ng-click="compare()">
            </div>
            User 1: <pre>{{user1 | json}}</pre>
            User 2: <pre>{{user2 | json}}</pre>
            Equal: <pre>{{result}}</pre>
          </form>
        </div>
      </file>
      <file name="script.js">
          angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
            $scope.user1 = {};
            $scope.user2 = {};
            $scope.compare = function() {
              $scope.result = angular.equals($scope.user1, $scope.user2);
            };
          }]);
      </file>
    </example>
   */
  function equals(o1, o2) {
    if (o1 === o2) return true;
    if (o1 === null || o2 === null) return false;
    // eslint-disable-next-line no-self-compare
    if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
    var t1 = typeof o1 === 'undefined' ? 'undefined' : _typeof(o1),
        t2 = typeof o2 === 'undefined' ? 'undefined' : _typeof(o2),
        length,
        key,
        keySet;
    if (t1 === t2 && t1 === 'object') {
      if (isArray(o1)) {
        if (!isArray(o2)) return false;
        if ((length = o1.length) === o2.length) {
          for (key = 0; key < length; key++) {
            if (!equals(o1[key], o2[key])) return false;
          }
          return true;
        }
      } else if (isDate(o1)) {
        if (!isDate(o2)) return false;
        return simpleCompare(o1.getTime(), o2.getTime());
      } else if (isRegExp(o1)) {
        if (!isRegExp(o2)) return false;
        return o1.toString() === o2.toString();
      } else {
        if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) || isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
        keySet = createMap();
        for (key in o1) {
          if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
          if (!equals(o1[key], o2[key])) return false;
          keySet[key] = true;
        }
        for (key in o2) {
          if (!(key in keySet) && key.charAt(0) !== '$' && isDefined(o2[key]) && !isFunction(o2[key])) return false;
        }
        return true;
      }
    }
    return false;
  }

  var csp = function csp() {
    if (!isDefined(csp.rules)) {

      var ngCspElement = window.document.querySelector('[ng-csp]') || window.document.querySelector('[data-ng-csp]');

      if (ngCspElement) {
        var ngCspAttribute = ngCspElement.getAttribute('ng-csp') || ngCspElement.getAttribute('data-ng-csp');
        csp.rules = {
          noUnsafeEval: !ngCspAttribute || ngCspAttribute.indexOf('no-unsafe-eval') !== -1,
          noInlineStyle: !ngCspAttribute || ngCspAttribute.indexOf('no-inline-style') !== -1
        };
      } else {
        csp.rules = {
          noUnsafeEval: noUnsafeEval(),
          noInlineStyle: false
        };
      }
    }

    return csp.rules;

    function noUnsafeEval() {
      try {
        // eslint-disable-next-line no-new, no-new-func
        new Function('');
        return false;
      } catch (e) {
        return true;
      }
    }
  };

  /**
   * @ngdoc directive
   * @module ng
   * @name ngJq
   *
   * @element ANY
   * @param {string=} ngJq the name of the library available under `window`
   * to be used for angular.element
   * @description
   * Use this directive to force the angular.element library.  This should be
   * used to force either jqLite by leaving ng-jq blank or setting the name of
   * the jquery variable under window (eg. jQuery).
   *
   * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
   * DOMContentLoaded event), it must be placed on an element that comes before the script
   * which loads angular. Also, only the first instance of `ng-jq` will be used and all
   * others ignored.
   *
   * @example
   * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
   ```html
   <!doctype html>
   <html ng-app ng-jq>
   ...
   ...
   </html>
   ```
   * @example
   * This example shows how to use a jQuery based library of a different name.
   * The library name must be available at the top most 'window'.
   ```html
   <!doctype html>
   <html ng-app ng-jq="jQueryLib">
   ...
   ...
   </html>
   ```
   */
  var jq = function jq() {
    if (isDefined(jq.name_)) return jq.name_;
    var el;
    var i,
        ii = ngAttrPrefixes.length,
        prefix,
        name;
    for (i = 0; i < ii; ++i) {
      prefix = ngAttrPrefixes[i];
      el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
      if (el) {
        name = el.getAttribute(prefix + 'jq');
        break;
      }
    }

    return jq.name_ = name;
  };

  function concat(array1, array2, index) {
    return array1.concat(slice.call(array2, index));
  }

  function sliceArgs(args, startIndex) {
    return slice.call(args, startIndex || 0);
  }

  /**
   * @ngdoc function
   * @name angular.bind
   * @module ng
   * @kind function
   *
   * @description
   * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
   * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
   * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
   * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
   *
   * @param {Object} self Context which `fn` should be evaluated in.
   * @param {function()} fn Function to be bound.
   * @param {...*} args Optional arguments to be prebound to the `fn` function call.
   * @returns {function()} Function that wraps the `fn` with all the specified bindings.
   */
  function bind(self, fn) {
    var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
    if (isFunction(fn) && !(fn instanceof RegExp)) {
      return curryArgs.length ? function () {
        return arguments.length ? fn.apply(self, concat(curryArgs, arguments, 0)) : fn.apply(self, curryArgs);
      } : function () {
        return arguments.length ? fn.apply(self, arguments) : fn.call(self);
      };
    } else {
      // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
      return fn;
    }
  }

  function toJsonReplacer(key, value) {
    var val = value;

    if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
      val = undefined;
    } else if (isWindow(value)) {
      val = '$WINDOW';
    } else if (value && window.document === value) {
      val = '$DOCUMENT';
    } else if (isScope(value)) {
      val = '$SCOPE';
    }

    return val;
  }

  /**
   * @ngdoc function
   * @name angular.toJson
   * @module ng
   * @kind function
   *
   * @description
   * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
   * stripped since AngularJS uses this notation internally.
   *
   * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
   * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
   *    If set to an integer, the JSON output will contain that many spaces per indentation.
   * @returns {string|undefined} JSON-ified string representing `obj`.
   * @knownIssue
   *
   * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
   * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
   * `Date.prototype.toJSON` method as follows:
   *
   * ```
   * var _DatetoJSON = Date.prototype.toJSON;
   * Date.prototype.toJSON = function() {
   *   try {
   *     return _DatetoJSON.call(this);
   *   } catch(e) {
   *     if (e instanceof RangeError) {
   *       return null;
   *     }
   *     throw e;
   *   }
   * };
   * ```
   *
   * See https://github.com/angular/angular.js/pull/14221 for more information.
   */
  function toJson(obj, pretty) {
    if (isUndefined(obj)) return undefined;
    if (!isNumber(pretty)) {
      pretty = pretty ? 2 : null;
    }
    return JSON.stringify(obj, toJsonReplacer, pretty);
  }

  /**
   * @ngdoc function
   * @name angular.fromJson
   * @module ng
   * @kind function
   *
   * @description
   * Deserializes a JSON string.
   *
   * @param {string} json JSON string to deserialize.
   * @returns {Object|Array|string|number} Deserialized JSON string.
   */
  function fromJson(json) {
    return isString(json) ? JSON.parse(json) : json;
  }

  var ALL_COLONS = /:/g;
  function timezoneToOffset(timezone, fallback) {
    // Support: IE 9-11 only, Edge 13-15+
    // IE/Edge do not "understand" colon (`:`) in timezone
    timezone = timezone.replace(ALL_COLONS, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }

  /**
   * @returns {string} Returns the string representation of the element.
   */
  function startingTag(element) {
    element = jqLite(element).clone().empty();
    var elemHtml = jqLite('<div>').append(element).html();
    try {
      return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) : elemHtml.match(/^(<[^>]+>)/)[1].replace(/^<([\w-]+)/, function (match, nodeName) {
        return '<' + lowercase(nodeName);
      });
    } catch (e) {
      return lowercase(elemHtml);
    }
  }

  /////////////////////////////////////////////////

  /**
   * Tries to decode the URI component without throwing an exception.
   *
   * @private
   * @param str value potential URI component to check.
   * @returns {boolean} True if `value` can be decoded
   * with the decodeURIComponent function.
   */
  function tryDecodeURIComponent(value) {
    try {
      return decodeURIComponent(value);
    } catch (e) {
      // Ignore any invalid uri component.
    }
  }

  /**
   * Parses an escaped url query string into key-value pairs.
   * @returns {Object.<string,boolean|Array>}
   */
  function parseKeyValue( /**string*/keyValue) {
    var obj = {};
    forEach((keyValue || '').split('&'), function (keyValue) {
      var splitPoint, key, val;
      if (keyValue) {
        key = keyValue = keyValue.replace(/\+/g, '%20');
        splitPoint = keyValue.indexOf('=');
        if (splitPoint !== -1) {
          key = keyValue.substring(0, splitPoint);
          val = keyValue.substring(splitPoint + 1);
        }
        key = tryDecodeURIComponent(key);
        if (isDefined(key)) {
          val = isDefined(val) ? tryDecodeURIComponent(val) : true;
          if (!hasOwnProperty.call(obj, key)) {
            obj[key] = val;
          } else if (isArray(obj[key])) {
            obj[key].push(val);
          } else {
            obj[key] = [obj[key], val];
          }
        }
      }
    });
    return obj;
  }

  function toKeyValue(obj) {
    var parts = [];
    forEach(obj, function (value, key) {
      if (isArray(value)) {
        forEach(value, function (arrayValue) {
          parts.push(encodeUriQuery(key, true) + (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
        });
      } else {
        parts.push(encodeUriQuery(key, true) + (value === true ? '' : '=' + encodeUriQuery(value, true)));
      }
    });
    return parts.length ? parts.join('&') : '';
  }

  /**
   * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
   * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
   * segments:
   *    segment       = *pchar
   *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
   *    pct-encoded   = "%" HEXDIG HEXDIG
   *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
   *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
   *                     / "*" / "+" / "," / ";" / "="
   */
  function encodeUriSegment(val) {
    return encodeUriQuery(val, true).replace(/%26/gi, '&').replace(/%3D/gi, '=').replace(/%2B/gi, '+');
  }

  /**
   * This method is intended for encoding *key* or *value* parts of query component. We need a custom
   * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
   * encoded per http://tools.ietf.org/html/rfc3986:
   *    query         = *( pchar / "/" / "?" )
   *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
   *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
   *    pct-encoded   = "%" HEXDIG HEXDIG
   *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
   *                     / "*" / "+" / "," / ";" / "="
   */
  function encodeUriQuery(val, pctEncodeSpaces) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%3B/gi, ';').replace(/%20/g, pctEncodeSpaces ? '%20' : '+');
  }

  var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];

  function getNgAttribute(element, ngAttr) {
    var attr,
        i,
        ii = ngAttrPrefixes.length;
    for (i = 0; i < ii; ++i) {
      attr = ngAttrPrefixes[i] + ngAttr;
      if (isString(attr = element.getAttribute(attr))) {
        return attr;
      }
    }
    return null;
  }

  function allowAutoBootstrap(document) {
    var script = document.currentScript;

    if (!script) {
      // Support: IE 9-11 only
      // IE does not have `document.currentScript`
      return true;
    }

    // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
    if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
      return false;
    }

    var attributes = script.attributes;
    var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];

    return srcs.every(function (src) {
      if (!src) {
        return true;
      }
      if (!src.value) {
        return false;
      }

      var link = document.createElement('a');
      link.href = src.value;

      if (document.location.origin === link.origin) {
        // Same-origin resources are always allowed, even for non-whitelisted schemes.
        return true;
      }
      // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
      // This is to prevent angular.js bundled with browser extensions from being used to bypass the
      // content security policy in web pages and other browser extensions.
      switch (link.protocol) {
        case 'http:':
        case 'https:':
        case 'ftp:':
        case 'blob:':
        case 'file:':
        case 'data:':
          return true;
        default:
          return false;
      }
    });
  }

  // Cached as it has to run during loading so that document.currentScript is available.
  var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);

  /**
   * @ngdoc directive
   * @name ngApp
   * @module ng
   *
   * @element ANY
   * @param {angular.Module} ngApp an optional application
   *   {@link angular.module module} name to load.
   * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
   *   created in "strict-di" mode. This means that the application will fail to invoke functions which
   *   do not use explicit function annotation (and are thus unsuitable for minification), as described
   *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
   *   tracking down the root of these bugs.
   *
   * @description
   *
   * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
   * designates the **root element** of the application and is typically placed near the root element
   * of the page - e.g. on the `<body>` or `<html>` tags.
   *
   * There are a few things to keep in mind when using `ngApp`:
   * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
   *   found in the document will be used to define the root element to auto-bootstrap as an
   *   application. To run multiple applications in an HTML document you must manually bootstrap them using
   *   {@link angular.bootstrap} instead.
   * - AngularJS applications cannot be nested within each other.
   * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
   *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
   *   {@link ngRoute.ngView `ngView`}.
   *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
   *   causing animations to stop working and making the injector inaccessible from outside the app.
   *
   * You can specify an **AngularJS module** to be used as the root module for the application.  This
   * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
   * should contain the application code needed or have dependencies on other modules that will
   * contain the code. See {@link angular.module} for more information.
   *
   * In the example below if the `ngApp` directive were not placed on the `html` element then the
   * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
   * would not be resolved to `3`.
   *
   * @example
   *
   * ### Simple Usage
   *
   * `ngApp` is the easiest, and most common way to bootstrap an application.
   *
   <example module="ngAppDemo" name="ng-app">
     <file name="index.html">
     <div ng-controller="ngAppDemoController">
       I can add: {{a}} + {{b}} =  {{ a+b }}
     </div>
     </file>
     <file name="script.js">
     angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     });
     </file>
   </example>
   *
   * @example
   *
   * ### With `ngStrictDi`
   *
   * Using `ngStrictDi`, you would see something like this:
   *
   <example ng-app-included="true" name="strict-di">
     <file name="index.html">
     <div ng-app="ngAppStrictDemo" ng-strict-di>
         <div ng-controller="GoodController1">
             I can add: {{a}} + {{b}} =  {{ a+b }}
  
             <p>This renders because the controller does not fail to
                instantiate, by using explicit annotation style (see
                script.js for details)
             </p>
         </div>
  
         <div ng-controller="GoodController2">
             Name: <input ng-model="name"><br />
             Hello, {{name}}!
  
             <p>This renders because the controller does not fail to
                instantiate, by using explicit annotation style
                (see script.js for details)
             </p>
         </div>
  
         <div ng-controller="BadController">
             I can add: {{a}} + {{b}} =  {{ a+b }}
  
             <p>The controller could not be instantiated, due to relying
                on automatic function annotations (which are disabled in
                strict mode). As such, the content of this section is not
                interpolated, and there should be an error in your web console.
             </p>
         </div>
     </div>
     </file>
     <file name="script.js">
     angular.module('ngAppStrictDemo', [])
       // BadController will fail to instantiate, due to relying on automatic function annotation,
       // rather than an explicit annotation
       .controller('BadController', function($scope) {
         $scope.a = 1;
         $scope.b = 2;
       })
       // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
       // due to using explicit annotations using the array style and $inject property, respectively.
       .controller('GoodController1', ['$scope', function($scope) {
         $scope.a = 1;
         $scope.b = 2;
       }])
       .controller('GoodController2', GoodController2);
       function GoodController2($scope) {
         $scope.name = 'World';
       }
       GoodController2.$inject = ['$scope'];
     </file>
     <file name="style.css">
     div[ng-controller] {
         margin-bottom: 1em;
         -webkit-border-radius: 4px;
         border-radius: 4px;
         border: 1px solid;
         padding: .5em;
     }
     div[ng-controller^=Good] {
         border-color: #d6e9c6;
         background-color: #dff0d8;
         color: #3c763d;
     }
     div[ng-controller^=Bad] {
         border-color: #ebccd1;
         background-color: #f2dede;
         color: #a94442;
         margin-bottom: 0;
     }
     </file>
   </example>
   */
  function angularInit(element, bootstrap) {
    var appElement,
        module,
        config = {};

    // The element `element` has priority over any other element.
    forEach(ngAttrPrefixes, function (prefix) {
      var name = prefix + 'app';

      if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
        appElement = element;
        module = element.getAttribute(name);
      }
    });
    forEach(ngAttrPrefixes, function (prefix) {
      var name = prefix + 'app';
      var candidate;

      if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
        appElement = candidate;
        module = candidate.getAttribute(name);
      }
    });
    if (appElement) {
      if (!isAutoBootstrapAllowed) {
        window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' + 'an extension, document.location.href does not match.');
        return;
      }
      config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
      bootstrap(appElement, module ? [module] : [], config);
    }
  }

  /**
   * @ngdoc function
   * @name angular.bootstrap
   * @module ng
   * @description
   * Use this function to manually start up AngularJS application.
   *
   * For more information, see the {@link guide/bootstrap Bootstrap guide}.
   *
   * AngularJS will detect if it has been loaded into the browser more than once and only allow the
   * first loaded script to be bootstrapped and will report a warning to the browser console for
   * each of the subsequent scripts. This prevents strange results in applications, where otherwise
   * multiple instances of AngularJS try to work on the DOM.
   *
   * <div class="alert alert-warning">
   * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
   * They must use {@link ng.directive:ngApp ngApp}.
   * </div>
   *
   * <div class="alert alert-warning">
   * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
   * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
   * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
   * causing animations to stop working and making the injector inaccessible from outside the app.
   * </div>
   *
   * ```html
   * <!doctype html>
   * <html>
   * <body>
   * <div ng-controller="WelcomeController">
   *   {{greeting}}
   * </div>
   *
   * <script src="angular.js"></script>
   * <script>
   *   var app = angular.module('demo', [])
   *   .controller('WelcomeController', function($scope) {
   *       $scope.greeting = 'Welcome!';
   *   });
   *   angular.bootstrap(document, ['demo']);
   * </script>
   * </body>
   * </html>
   * ```
   *
   * @param {DOMElement} element DOM element which is the root of AngularJS application.
   * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
   *     Each item in the array should be the name of a predefined module or a (DI annotated)
   *     function that will be invoked by the injector as a `config` block.
   *     See: {@link angular.module modules}
   * @param {Object=} config an object for defining configuration options for the application. The
   *     following keys are supported:
   *
   * * `strictDi` - disable automatic function annotation for the application. This is meant to
   *   assist in finding bugs which break minified code. Defaults to `false`.
   *
   * @returns {auto.$injector} Returns the newly created injector for this app.
   */
  function bootstrap(element, modules, config) {
    if (!isObject(config)) config = {};
    var defaultConfig = {
      strictDi: false
    };
    config = extend(defaultConfig, config);
    var doBootstrap = function doBootstrap() {
      element = jqLite(element);

      if (element.injector()) {
        var tag = element[0] === window.document ? 'document' : startingTag(element);
        // Encode angle brackets to prevent input from being sanitized to empty string #8683.
        throw ngMinErr('btstrpd', 'App already bootstrapped with this element \'{0}\'', tag.replace(/</, '&lt;').replace(/>/, '&gt;'));
      }

      modules = modules || [];
      modules.unshift(['$provide', function ($provide) {
        $provide.value('$rootElement', element);
      }]);

      if (config.debugInfoEnabled) {
        // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
        modules.push(['$compileProvider', function ($compileProvider) {
          $compileProvider.debugInfoEnabled(true);
        }]);
      }

      modules.unshift('ng');
      var injector = createInjector(modules, config.strictDi);
      injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector', function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function () {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]);
      return injector;
    };

    var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
    var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;

    if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
      config.debugInfoEnabled = true;
      window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
    }

    if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
      return doBootstrap();
    }

    window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
    angular.resumeBootstrap = function (extraModules) {
      forEach(extraModules, function (module) {
        modules.push(module);
      });
      return doBootstrap();
    };

    if (isFunction(angular.resumeDeferredBootstrap)) {
      angular.resumeDeferredBootstrap();
    }
  }

  /**
   * @ngdoc function
   * @name angular.reloadWithDebugInfo
   * @module ng
   * @description
   * Use this function to reload the current application with debug information turned on.
   * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
   *
   * See {@link ng.$compileProvider#debugInfoEnabled} for more.
   */
  function reloadWithDebugInfo() {
    window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
    window.location.reload();
  }

  /**
   * @name angular.getTestability
   * @module ng
   * @description
   * Get the testability service for the instance of AngularJS on the given
   * element.
   * @param {DOMElement} element DOM element which is the root of AngularJS application.
   */
  function getTestability(rootElement) {
    var injector = angular.element(rootElement).injector();
    if (!injector) {
      throw ngMinErr('test', 'no injector found for element argument to getTestability');
    }
    return injector.get('$$testability');
  }

  var SNAKE_CASE_REGEXP = /[A-Z]/g;
  function snake_case(name, separator) {
    separator = separator || '_';
    return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  var bindJQueryFired = false;
  function bindJQuery() {
    var originalCleanData;

    if (bindJQueryFired) {
      return;
    }

    // bind to jQuery if present;
    var jqName = jq();
    jQuery = isUndefined(jqName) ? window.jQuery : // use jQuery (if present)
    !jqName ? undefined : // use jqLite
    window[jqName]; // use jQuery specified by `ngJq`

    // Use jQuery if it exists with proper functionality, otherwise default to us.
    // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
    // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
    // versions. It will not work for sure with jQuery <1.7, though.
    if (jQuery && jQuery.fn.on) {
      jqLite = jQuery;
      extend(jQuery.fn, {
        scope: JQLitePrototype.scope,
        isolateScope: JQLitePrototype.isolateScope,
        controller: /** @type {?} */JQLitePrototype.controller,
        injector: JQLitePrototype.injector,
        inheritedData: JQLitePrototype.inheritedData
      });

      // All nodes removed from the DOM via various jQuery APIs like .remove()
      // are passed through jQuery.cleanData. Monkey-patch this method to fire
      // the $destroy event on all removed nodes.
      originalCleanData = jQuery.cleanData;
      jQuery.cleanData = function (elems) {
        var events;
        for (var i = 0, elem; (elem = elems[i]) != null; i++) {
          events = jQuery._data(elem, 'events');
          if (events && events.$destroy) {
            jQuery(elem).triggerHandler('$destroy');
          }
        }
        originalCleanData(elems);
      };
    } else {
      jqLite = JQLite;
    }

    angular.element = jqLite;

    // Prevent double-proxying.
    bindJQueryFired = true;
  }

  /**
   * throw error if the argument is falsy.
   */
  function assertArg(arg, name, reason) {
    if (!arg) {
      throw ngMinErr('areq', 'Argument \'{0}\' is {1}', name || '?', reason || 'required');
    }
    return arg;
  }

  function assertArgFn(arg, name, acceptArrayAnnotation) {
    if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
    }

    assertArg(isFunction(arg), name, 'not a function, got ' + (arg && (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' ? arg.constructor.name || 'Object' : typeof arg === 'undefined' ? 'undefined' : _typeof(arg)));
    return arg;
  }

  /**
   * throw error if the name given is hasOwnProperty
   * @param  {String} name    the name to test
   * @param  {String} context the context in which the name is used, such as module or directive
   */
  function assertNotHasOwnProperty(name, context) {
    if (name === 'hasOwnProperty') {
      throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
    }
  }

  /**
   * Return the value accessible from the object by path. Any undefined traversals are ignored
   * @param {Object} obj starting object
   * @param {String} path path to traverse
   * @param {boolean} [bindFnToScope=true]
   * @returns {Object} value as accessible by path
   */
  //TODO(misko): this function needs to be removed
  function getter(obj, path, bindFnToScope) {
    if (!path) return obj;
    var keys = path.split('.');
    var key;
    var lastInstance = obj;
    var len = keys.length;

    for (var i = 0; i < len; i++) {
      key = keys[i];
      if (obj) {
        obj = (lastInstance = obj)[key];
      }
    }
    if (!bindFnToScope && isFunction(obj)) {
      return bind(lastInstance, obj);
    }
    return obj;
  }

  /**
   * Return the DOM siblings between the first and last node in the given array.
   * @param {Array} array like object
   * @returns {Array} the inputted object or a jqLite collection containing the nodes
   */
  function getBlockNodes(nodes) {
    // TODO(perf): update `nodes` instead of creating a new object?
    var node = nodes[0];
    var endNode = nodes[nodes.length - 1];
    var blockNodes;

    for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
      if (blockNodes || nodes[i] !== node) {
        if (!blockNodes) {
          blockNodes = jqLite(slice.call(nodes, 0, i));
        }
        blockNodes.push(node);
      }
    }

    return blockNodes || nodes;
  }

  /**
   * Creates a new object without a prototype. This object is useful for lookup without having to
   * guard against prototypically inherited properties via hasOwnProperty.
   *
   * Related micro-benchmarks:
   * - http://jsperf.com/object-create2
   * - http://jsperf.com/proto-map-lookup/2
   * - http://jsperf.com/for-in-vs-object-keys2
   *
   * @returns {Object}
   */
  function createMap() {
    return Object.create(null);
  }

  function stringify(value) {
    if (value == null) {
      // null || undefined
      return '';
    }
    switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
      case 'string':
        break;
      case 'number':
        value = '' + value;
        break;
      default:
        if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
          value = value.toString();
        } else {
          value = toJson(value);
        }
    }

    return value;
  }

  var NODE_TYPE_ELEMENT = 1;
  var NODE_TYPE_ATTRIBUTE = 2;
  var NODE_TYPE_TEXT = 3;
  var NODE_TYPE_COMMENT = 8;
  var NODE_TYPE_DOCUMENT = 9;
  var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

  /**
   * @ngdoc type
   * @name angular.Module
   * @module ng
   * @description
   *
   * Interface for configuring AngularJS {@link angular.module modules}.
   */

  function setupModuleLoader(window) {

    var $injectorMinErr = minErr('$injector');
    var ngMinErr = minErr('ng');

    function ensure(obj, name, factory) {
      return obj[name] || (obj[name] = factory());
    }

    var angular = ensure(window, 'angular', Object);

    // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
    angular.$$minErr = angular.$$minErr || minErr;

    return ensure(angular, 'module', function () {
      /** @type {Object.<string, angular.Module>} */
      var modules = {};

      /**
       * @ngdoc function
       * @name angular.module
       * @module ng
       * @description
       *
       * The `angular.module` is a global place for creating, registering and retrieving AngularJS
       * modules.
       * All modules (AngularJS core or 3rd party) that should be available to an application must be
       * registered using this mechanism.
       *
       * Passing one argument retrieves an existing {@link angular.Module},
       * whereas passing more than one argument creates a new {@link angular.Module}
       *
       *
       * # Module
       *
       * A module is a collection of services, directives, controllers, filters, and configuration information.
       * `angular.module` is used to configure the {@link auto.$injector $injector}.
       *
       * ```js
       * // Create a new module
       * var myModule = angular.module('myModule', []);
       *
       * // register a new service
       * myModule.value('appName', 'MyCoolApp');
       *
       * // configure existing services inside initialization blocks.
       * myModule.config(['$locationProvider', function($locationProvider) {
       *   // Configure existing providers
       *   $locationProvider.hashPrefix('!');
       * }]);
       * ```
       *
       * Then you can create an injector and load your modules like this:
       *
       * ```js
       * var injector = angular.injector(['ng', 'myModule'])
       * ```
       *
       * However it's more likely that you'll just use
       * {@link ng.directive:ngApp ngApp} or
       * {@link angular.bootstrap} to simplify this process for you.
       *
       * @param {!string} name The name of the module to create or retrieve.
       * @param {!Array.<string>=} requires If specified then new module is being created. If
       *        unspecified then the module is being retrieved for further configuration.
       * @param {Function=} configFn Optional configuration function for the module. Same as
       *        {@link angular.Module#config Module#config()}.
       * @returns {angular.Module} new module with the {@link angular.Module} api.
       */
      return function module(name, requires, configFn) {

        var _info = {};

        var assertNotHasOwnProperty = function assertNotHasOwnProperty(name, context) {
          if (name === 'hasOwnProperty') {
            throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
          }
        };

        assertNotHasOwnProperty(name, 'module');
        if (requires && modules.hasOwnProperty(name)) {
          modules[name] = null;
        }
        return ensure(modules, name, function () {
          if (!requires) {
            throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' + 'the module name or forgot to load it. If registering a module ensure that you ' + 'specify the dependencies as the second argument.', name);
          }

          /** @type {!Array.<Array.<*>>} */
          var invokeQueue = [];

          /** @type {!Array.<Function>} */
          var configBlocks = [];

          /** @type {!Array.<Function>} */
          var runBlocks = [];

          var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

          /** @type {angular.Module} */
          var moduleInstance = {
            // Private state
            _invokeQueue: invokeQueue,
            _configBlocks: configBlocks,
            _runBlocks: runBlocks,

            /**
             * @ngdoc method
             * @name angular.Module#info
             * @module ng
             *
             * @param {Object=} info Information about the module
             * @returns {Object|Module} The current info object for this module if called as a getter,
             *                          or `this` if called as a setter.
             *
             * @description
             * Read and write custom information about this module.
             * For example you could put the version of the module in here.
             *
             * ```js
             * angular.module('myModule', []).info({ version: '1.0.0' });
             * ```
             *
             * The version could then be read back out by accessing the module elsewhere:
             *
             * ```
             * var version = angular.module('myModule').info().version;
             * ```
             *
             * You can also retrieve this information during runtime via the
             * {@link $injector#modules `$injector.modules`} property:
             *
             * ```js
             * var version = $injector.modules['myModule'].info().version;
             * ```
             */
            info: function info(value) {
              if (isDefined(value)) {
                if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
                _info = value;
                return this;
              }
              return _info;
            },

            /**
             * @ngdoc property
             * @name angular.Module#requires
             * @module ng
             *
             * @description
             * Holds the list of modules which the injector will load before the current module is
             * loaded.
             */
            requires: requires,

            /**
             * @ngdoc property
             * @name angular.Module#name
             * @module ng
             *
             * @description
             * Name of the module.
             */
            name: name,

            /**
             * @ngdoc method
             * @name angular.Module#provider
             * @module ng
             * @param {string} name service name
             * @param {Function} providerType Construction function for creating new instance of the
             *                                service.
             * @description
             * See {@link auto.$provide#provider $provide.provider()}.
             */
            provider: invokeLaterAndSetModuleName('$provide', 'provider'),

            /**
             * @ngdoc method
             * @name angular.Module#factory
             * @module ng
             * @param {string} name service name
             * @param {Function} providerFunction Function for creating new instance of the service.
             * @description
             * See {@link auto.$provide#factory $provide.factory()}.
             */
            factory: invokeLaterAndSetModuleName('$provide', 'factory'),

            /**
             * @ngdoc method
             * @name angular.Module#service
             * @module ng
             * @param {string} name service name
             * @param {Function} constructor A constructor function that will be instantiated.
             * @description
             * See {@link auto.$provide#service $provide.service()}.
             */
            service: invokeLaterAndSetModuleName('$provide', 'service'),

            /**
             * @ngdoc method
             * @name angular.Module#value
             * @module ng
             * @param {string} name service name
             * @param {*} object Service instance object.
             * @description
             * See {@link auto.$provide#value $provide.value()}.
             */
            value: invokeLater('$provide', 'value'),

            /**
             * @ngdoc method
             * @name angular.Module#constant
             * @module ng
             * @param {string} name constant name
             * @param {*} object Constant value.
             * @description
             * Because the constants are fixed, they get applied before other provide methods.
             * See {@link auto.$provide#constant $provide.constant()}.
             */
            constant: invokeLater('$provide', 'constant', 'unshift'),

            /**
            * @ngdoc method
            * @name angular.Module#decorator
            * @module ng
            * @param {string} name The name of the service to decorate.
            * @param {Function} decorFn This function will be invoked when the service needs to be
            *                           instantiated and should return the decorated service instance.
            * @description
            * See {@link auto.$provide#decorator $provide.decorator()}.
            */
            decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),

            /**
             * @ngdoc method
             * @name angular.Module#animation
             * @module ng
             * @param {string} name animation name
             * @param {Function} animationFactory Factory function for creating new instance of an
             *                                    animation.
             * @description
             *
             * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
             *
             *
             * Defines an animation hook that can be later used with
             * {@link $animate $animate} service and directives that use this service.
             *
             * ```js
             * module.animation('.animation-name', function($inject1, $inject2) {
             *   return {
             *     eventName : function(element, done) {
             *       //code to run the animation
             *       //once complete, then run done()
             *       return function cancellationFunction(element) {
             *         //code to cancel the animation
             *       }
             *     }
             *   }
             * })
             * ```
             *
             * See {@link ng.$animateProvider#register $animateProvider.register()} and
             * {@link ngAnimate ngAnimate module} for more information.
             */
            animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),

            /**
             * @ngdoc method
             * @name angular.Module#filter
             * @module ng
             * @param {string} name Filter name - this must be a valid AngularJS expression identifier
             * @param {Function} filterFactory Factory function for creating new instance of filter.
             * @description
             * See {@link ng.$filterProvider#register $filterProvider.register()}.
             *
             * <div class="alert alert-warning">
             * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
             * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
             * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
             * (`myapp_subsection_filterx`).
             * </div>
             */
            filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),

            /**
             * @ngdoc method
             * @name angular.Module#controller
             * @module ng
             * @param {string|Object} name Controller name, or an object map of controllers where the
             *    keys are the names and the values are the constructors.
             * @param {Function} constructor Controller constructor function.
             * @description
             * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
             */
            controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),

            /**
             * @ngdoc method
             * @name angular.Module#directive
             * @module ng
             * @param {string|Object} name Directive name, or an object map of directives where the
             *    keys are the names and the values are the factories.
             * @param {Function} directiveFactory Factory function for creating new instance of
             * directives.
             * @description
             * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
             */
            directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),

            /**
             * @ngdoc method
             * @name angular.Module#component
             * @module ng
             * @param {string} name Name of the component in camel-case (i.e. myComp which will match as my-comp)
             * @param {Object} options Component definition object (a simplified
             *    {@link ng.$compile#directive-definition-object directive definition object})
             *
             * @description
             * See {@link ng.$compileProvider#component $compileProvider.component()}.
             */
            component: invokeLaterAndSetModuleName('$compileProvider', 'component'),

            /**
             * @ngdoc method
             * @name angular.Module#config
             * @module ng
             * @param {Function} configFn Execute this function on module load. Useful for service
             *    configuration.
             * @description
             * Use this method to configure services by injecting their
             * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
             * {@link ngRoute.$routeProvider $routeProvider}.
             *
             * Note that you can only inject {@link angular.Module#provider `providers`} and
             * {@link angular.Module#constant `constants`} into this function.
             *
             * For more about how to configure services, see
             * {@link providers#provider-recipe Provider Recipe}.
             */
            config: config,

            /**
             * @ngdoc method
             * @name angular.Module#run
             * @module ng
             * @param {Function} initializationFn Execute this function after injector creation.
             *    Useful for application initialization.
             * @description
             * Use this method to register work which should be performed when the injector is done
             * loading all modules.
             */
            run: function run(block) {
              runBlocks.push(block);
              return this;
            }
          };

          if (configFn) {
            config(configFn);
          }

          return moduleInstance;

          /**
           * @param {string} provider
           * @param {string} method
           * @param {String=} insertMethod
           * @returns {angular.Module}
           */
          function invokeLater(provider, method, insertMethod, queue) {
            if (!queue) queue = invokeQueue;
            return function () {
              queue[insertMethod || 'push']([provider, method, arguments]);
              return moduleInstance;
            };
          }

          /**
           * @param {string} provider
           * @param {string} method
           * @returns {angular.Module}
           */
          function invokeLaterAndSetModuleName(provider, method, queue) {
            if (!queue) queue = invokeQueue;
            return function (recipeName, factoryFunction) {
              if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
              queue.push([provider, method, arguments]);
              return moduleInstance;
            };
          }
        });
      };
    });
  }

  /* global shallowCopy: true */

  /**
   * Creates a shallow copy of an object, an array or a primitive.
   *
   * Assumes that there are no proto properties for objects.
   */
  function shallowCopy(src, dst) {
    if (isArray(src)) {
      dst = dst || [];

      for (var i = 0, ii = src.length; i < ii; i++) {
        dst[i] = src[i];
      }
    } else if (isObject(src)) {
      dst = dst || {};

      for (var key in src) {
        if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
          dst[key] = src[key];
        }
      }
    }

    return dst || src;
  }

  /* exported toDebugString */

  function serializeObject(obj, maxDepth) {
    var seen = [];

    // There is no direct way to stringify object until reaching a specific depth
    // and a very deep object can cause a performance issue, so we copy the object
    // based on this specific depth and then stringify it.
    if (isValidObjectMaxDepth(maxDepth)) {
      // This file is also included in `angular-loader`, so `copy()` might not always be available in
      // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
      obj = angular.copy(obj, null, maxDepth);
    }
    return JSON.stringify(obj, function (key, val) {
      val = toJsonReplacer(key, val);
      if (isObject(val)) {

        if (seen.indexOf(val) >= 0) return '...';

        seen.push(val);
      }
      return val;
    });
  }

  function toDebugString(obj, maxDepth) {
    if (typeof obj === 'function') {
      return obj.toString().replace(/ \{[\s\S]*$/, '');
    } else if (isUndefined(obj)) {
      return 'undefined';
    } else if (typeof obj !== 'string') {
      return serializeObject(obj, maxDepth);
    }
    return obj;
  }

  /* global angularModule: true,
    version: true,
  
    $CompileProvider,
  
    htmlAnchorDirective,
    inputDirective,
    inputDirective,
    formDirective,
    scriptDirective,
    selectDirective,
    optionDirective,
    ngBindDirective,
    ngBindHtmlDirective,
    ngBindTemplateDirective,
    ngClassDirective,
    ngClassEvenDirective,
    ngClassOddDirective,
    ngCloakDirective,
    ngControllerDirective,
    ngFormDirective,
    ngHideDirective,
    ngIfDirective,
    ngIncludeDirective,
    ngIncludeFillContentDirective,
    ngInitDirective,
    ngNonBindableDirective,
    ngPluralizeDirective,
    ngRepeatDirective,
    ngShowDirective,
    ngStyleDirective,
    ngSwitchDirective,
    ngSwitchWhenDirective,
    ngSwitchDefaultDirective,
    ngOptionsDirective,
    ngTranscludeDirective,
    ngModelDirective,
    ngListDirective,
    ngChangeDirective,
    patternDirective,
    patternDirective,
    requiredDirective,
    requiredDirective,
    minlengthDirective,
    minlengthDirective,
    maxlengthDirective,
    maxlengthDirective,
    ngValueDirective,
    ngModelOptionsDirective,
    ngAttributeAliasDirectives,
    ngEventDirectives,
  
    $AnchorScrollProvider,
    $AnimateProvider,
    $CoreAnimateCssProvider,
    $$CoreAnimateJsProvider,
    $$CoreAnimateQueueProvider,
    $$AnimateRunnerFactoryProvider,
    $$AnimateAsyncRunFactoryProvider,
    $BrowserProvider,
    $CacheFactoryProvider,
    $ControllerProvider,
    $DateProvider,
    $DocumentProvider,
    $$IsDocumentHiddenProvider,
    $ExceptionHandlerProvider,
    $FilterProvider,
    $$ForceReflowProvider,
    $InterpolateProvider,
    $IntervalProvider,
    $HttpProvider,
    $HttpParamSerializerProvider,
    $HttpParamSerializerJQLikeProvider,
    $HttpBackendProvider,
    $xhrFactoryProvider,
    $jsonpCallbacksProvider,
    $LocationProvider,
    $LogProvider,
    $$MapProvider,
    $ParseProvider,
    $RootScopeProvider,
    $QProvider,
    $$QProvider,
    $$SanitizeUriProvider,
    $SceProvider,
    $SceDelegateProvider,
    $SnifferProvider,
    $TemplateCacheProvider,
    $TemplateRequestProvider,
    $$TestabilityProvider,
    $TimeoutProvider,
    $$RAFProvider,
    $WindowProvider,
    $$jqLiteProvider,
    $$CookieReaderProvider
  */

  /**
   * @ngdoc object
   * @name angular.version
   * @module ng
   * @description
   * An object that contains information about the current AngularJS version.
   *
   * This object has the following properties:
   *
   * - `full` – `{string}` – Full version string, such as "0.9.18".
   * - `major` – `{number}` – Major version number, such as "0".
   * - `minor` – `{number}` – Minor version number, such as "9".
   * - `dot` – `{number}` – Dot version number, such as "18".
   * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
   */
  var version = {
    // These placeholder strings will be replaced by grunt's `build` task.
    // They need to be double- or single-quoted.
    full: '1.6.9',
    major: 1,
    minor: 6,
    dot: 9,
    codeName: 'fiery-basilisk'
  };

  function publishExternalAPI(angular) {
    extend(angular, {
      'errorHandlingConfig': errorHandlingConfig,
      'bootstrap': bootstrap,
      'copy': copy,
      'extend': extend,
      'merge': merge,
      'equals': equals,
      'element': jqLite,
      'forEach': forEach,
      'injector': createInjector,
      'noop': noop,
      'bind': bind,
      'toJson': toJson,
      'fromJson': fromJson,
      'identity': identity,
      'isUndefined': isUndefined,
      'isDefined': isDefined,
      'isString': isString,
      'isFunction': isFunction,
      'isObject': isObject,
      'isNumber': isNumber,
      'isElement': isElement,
      'isArray': isArray,
      'version': version,
      'isDate': isDate,
      'lowercase': lowercase,
      'uppercase': uppercase,
      'callbacks': { $$counter: 0 },
      'getTestability': getTestability,
      'reloadWithDebugInfo': reloadWithDebugInfo,
      '$$minErr': minErr,
      '$$csp': csp,
      '$$encodeUriSegment': encodeUriSegment,
      '$$encodeUriQuery': encodeUriQuery,
      '$$stringify': stringify
    });

    angularModule = setupModuleLoader(window);

    angularModule('ng', ['ngLocale'], ['$provide', function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).directive({
        a: htmlAnchorDirective,
        input: inputDirective,
        textarea: inputDirective,
        form: formDirective,
        script: scriptDirective,
        select: selectDirective,
        option: optionDirective,
        ngBind: ngBindDirective,
        ngBindHtml: ngBindHtmlDirective,
        ngBindTemplate: ngBindTemplateDirective,
        ngClass: ngClassDirective,
        ngClassEven: ngClassEvenDirective,
        ngClassOdd: ngClassOddDirective,
        ngCloak: ngCloakDirective,
        ngController: ngControllerDirective,
        ngForm: ngFormDirective,
        ngHide: ngHideDirective,
        ngIf: ngIfDirective,
        ngInclude: ngIncludeDirective,
        ngInit: ngInitDirective,
        ngNonBindable: ngNonBindableDirective,
        ngPluralize: ngPluralizeDirective,
        ngRepeat: ngRepeatDirective,
        ngShow: ngShowDirective,
        ngStyle: ngStyleDirective,
        ngSwitch: ngSwitchDirective,
        ngSwitchWhen: ngSwitchWhenDirective,
        ngSwitchDefault: ngSwitchDefaultDirective,
        ngOptions: ngOptionsDirective,
        ngTransclude: ngTranscludeDirective,
        ngModel: ngModelDirective,
        ngList: ngListDirective,
        ngChange: ngChangeDirective,
        pattern: patternDirective,
        ngPattern: patternDirective,
        required: requiredDirective,
        ngRequired: requiredDirective,
        minlength: minlengthDirective,
        ngMinlength: minlengthDirective,
        maxlength: maxlengthDirective,
        ngMaxlength: maxlengthDirective,
        ngValue: ngValueDirective,
        ngModelOptions: ngModelOptionsDirective
      }).directive({
        ngInclude: ngIncludeFillContentDirective
      }).directive(ngAttributeAliasDirectives).directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $animateCss: $CoreAnimateCssProvider,
        $$animateJs: $$CoreAnimateJsProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $$isDocumentHidden: $$IsDocumentHiddenProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $$forceReflow: $$ForceReflowProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $xhrFactory: $xhrFactoryProvider,
        $jsonpCallbacks: $jsonpCallbacksProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$jqLite: $$jqLiteProvider,
        $$Map: $$MapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }]).info({ angularVersion: '1.6.9' });
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   *     Any commits to this file should be reviewed with security in mind.  *
   *   Changes to this file can potentially create security vulnerabilities. *
   *          An approval from 2 Core members with history of modifying      *
   *                         this file is required.                          *
   *                                                                         *
   *  Does the change somehow allow for arbitrary javascript to be executed? *
   *    Or allows for someone to change the prototype of built-in objects?   *
   *     Or gives undesired access to variables likes document or window?    *
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  /* global
    JQLitePrototype: true,
    BOOLEAN_ATTR: true,
    ALIASED_ATTR: true
  */

  //////////////////////////////////
  //JQLite
  //////////////////////////////////

  /**
   * @ngdoc function
   * @name angular.element
   * @module ng
   * @kind function
   *
   * @description
   * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
   *
   * If jQuery is available, `angular.element` is an alias for the
   * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
   * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
   *
   * jqLite is a tiny, API-compatible subset of jQuery that allows
   * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
   * commonly needed functionality with the goal of having a very small footprint.
   *
   * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
   * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
   * specific version of jQuery if multiple versions exist on the page.
   *
   * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
   * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
   *
   * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
   * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
   * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
   *
   * ## AngularJS's jqLite
   * jqLite provides only the following jQuery methods:
   *
   * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
   * - [`after()`](http://api.jquery.com/after/)
   * - [`append()`](http://api.jquery.com/append/)
   * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
   * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
   * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
   * - [`clone()`](http://api.jquery.com/clone/)
   * - [`contents()`](http://api.jquery.com/contents/)
   * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
   *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
   * - [`data()`](http://api.jquery.com/data/)
   * - [`detach()`](http://api.jquery.com/detach/)
   * - [`empty()`](http://api.jquery.com/empty/)
   * - [`eq()`](http://api.jquery.com/eq/)
   * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
   * - [`hasClass()`](http://api.jquery.com/hasClass/)
   * - [`html()`](http://api.jquery.com/html/)
   * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
   * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
   * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
   * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
   * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
   * - [`prepend()`](http://api.jquery.com/prepend/)
   * - [`prop()`](http://api.jquery.com/prop/)
   * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
   * - [`remove()`](http://api.jquery.com/remove/)
   * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
   * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
   * - [`removeData()`](http://api.jquery.com/removeData/)
   * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
   * - [`text()`](http://api.jquery.com/text/)
   * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
   * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
   * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
   * - [`val()`](http://api.jquery.com/val/)
   * - [`wrap()`](http://api.jquery.com/wrap/)
   *
   * ## jQuery/jqLite Extras
   * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
   *
   * ### Events
   * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
   *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
   *    element before it is removed.
   *
   * ### Methods
   * - `controller(name)` - retrieves the controller of the current element or its parent. By default
   *   retrieves controller associated with the `ngController` directive. If `name` is provided as
   *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
   *   `'ngModel'`).
   * - `injector()` - retrieves the injector of the current element or its parent.
   * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
   *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
   *   be enabled.
   * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
   *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
   *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
   *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
   * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
   *   parent element is reached.
   *
   * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
   * https://github.com/angular/angular.js/issues/14251 for more information.
   *
   * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
   * @returns {Object} jQuery object.
   */

  JQLite.expando = 'ng339';

  var jqCache = JQLite.cache = {},
      jqId = 1;

  /*
   * !!! This is an undocumented "private" function !!!
   */
  JQLite._data = function (node) {
    //jQuery always returns an object on cache miss
    return this.cache[node[this.expando]] || {};
  };

  function jqNextId() {
    return ++jqId;
  }

  var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
  var MS_HACK_REGEXP = /^-ms-/;
  var MOUSE_EVENT_MAP = { mouseleave: 'mouseout', mouseenter: 'mouseover' };
  var jqLiteMinErr = minErr('jqLite');

  /**
   * Converts kebab-case to camelCase.
   * There is also a special case for the ms prefix starting with a lowercase letter.
   * @param name Name to normalize
   */
  function cssKebabToCamel(name) {
    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
  }

  function fnCamelCaseReplace(all, letter) {
    return letter.toUpperCase();
  }

  /**
   * Converts kebab-case to camelCase.
   * @param name Name to normalize
   */
  function kebabToCamel(name) {
    return name.replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
  }

  var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
  var HTML_REGEXP = /<|&#?\w+;/;
  var TAG_NAME_REGEXP = /<([\w:-]+)/;
  var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

  var wrapMap = {
    'option': [1, '<select multiple="multiple">', '</select>'],

    'thead': [1, '<table>', '</table>'],
    'col': [2, '<table><colgroup>', '</colgroup></table>'],
    'tr': [2, '<table><tbody>', '</tbody></table>'],
    'td': [3, '<table><tbody><tr>', '</tr></tbody></table>'],
    '_default': [0, '', '']
  };

  wrapMap.optgroup = wrapMap.option;
  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td;

  function jqLiteIsTextNode(html) {
    return !HTML_REGEXP.test(html);
  }

  function jqLiteAcceptsData(node) {
    // The window object can accept data but has no nodeType
    // Otherwise we are only interested in elements (1) and documents (9)
    var nodeType = node.nodeType;
    return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
  }

  function jqLiteHasData(node) {
    for (var key in jqCache[node.ng339]) {
      return true;
    }
    return false;
  }

  function jqLiteBuildFragment(html, context) {
    var tmp,
        tag,
        wrap,
        fragment = context.createDocumentFragment(),
        nodes = [],
        i;

    if (jqLiteIsTextNode(html)) {
      // Convert non-html into a text node
      nodes.push(context.createTextNode(html));
    } else {
      // Convert html into DOM nodes
      tmp = fragment.appendChild(context.createElement('div'));
      tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
      wrap = wrapMap[tag] || wrapMap._default;
      tmp.innerHTML = wrap[1] + html.replace(XHTML_TAG_REGEXP, '<$1></$2>') + wrap[2];

      // Descend through wrappers to the right content
      i = wrap[0];
      while (i--) {
        tmp = tmp.lastChild;
      }

      nodes = concat(nodes, tmp.childNodes);

      tmp = fragment.firstChild;
      tmp.textContent = '';
    }

    // Remove wrapper from fragment
    fragment.textContent = '';
    fragment.innerHTML = ''; // Clear inner HTML
    forEach(nodes, function (node) {
      fragment.appendChild(node);
    });

    return fragment;
  }

  function jqLiteParseHTML(html, context) {
    context = context || window.document;
    var parsed;

    if (parsed = SINGLE_TAG_REGEXP.exec(html)) {
      return [context.createElement(parsed[1])];
    }

    if (parsed = jqLiteBuildFragment(html, context)) {
      return parsed.childNodes;
    }

    return [];
  }

  function jqLiteWrapNode(node, wrapper) {
    var parent = node.parentNode;

    if (parent) {
      parent.replaceChild(wrapper, node);
    }

    wrapper.appendChild(node);
  }

  // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
  var jqLiteContains = window.Node.prototype.contains || /** @this */function (arg) {
    // eslint-disable-next-line no-bitwise
    return !!(this.compareDocumentPosition(arg) & 16);
  };

  /////////////////////////////////////////////
  function JQLite(element) {
    if (element instanceof JQLite) {
      return element;
    }

    var argIsString;

    if (isString(element)) {
      element = trim(element);
      argIsString = true;
    }
    if (!(this instanceof JQLite)) {
      if (argIsString && element.charAt(0) !== '<') {
        throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
      }
      return new JQLite(element);
    }

    if (argIsString) {
      jqLiteAddNodes(this, jqLiteParseHTML(element));
    } else if (isFunction(element)) {
      jqLiteReady(element);
    } else {
      jqLiteAddNodes(this, element);
    }
  }

  function jqLiteClone(element) {
    return element.cloneNode(true);
  }

  function jqLiteDealoc(element, onlyDescendants) {
    if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);

    if (element.querySelectorAll) {
      jqLite.cleanData(element.querySelectorAll('*'));
    }
  }

  function jqLiteOff(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');

    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var handle = expandoStore && expandoStore.handle;

    if (!handle) return; //no listeners registered

    if (!type) {
      for (type in events) {
        if (type !== '$destroy') {
          element.removeEventListener(type, handle);
        }
        delete events[type];
      }
    } else {

      var removeHandler = function removeHandler(type) {
        var listenerFns = events[type];
        if (isDefined(fn)) {
          arrayRemove(listenerFns || [], fn);
        }
        if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
          element.removeEventListener(type, handle);
          delete events[type];
        }
      };

      forEach(type.split(' '), function (type) {
        removeHandler(type);
        if (MOUSE_EVENT_MAP[type]) {
          removeHandler(MOUSE_EVENT_MAP[type]);
        }
      });
    }
  }

  function jqLiteRemoveData(element, name) {
    var expandoId = element.ng339;
    var expandoStore = expandoId && jqCache[expandoId];

    if (expandoStore) {
      if (name) {
        delete expandoStore.data[name];
        return;
      }

      if (expandoStore.handle) {
        if (expandoStore.events.$destroy) {
          expandoStore.handle({}, '$destroy');
        }
        jqLiteOff(element);
      }
      delete jqCache[expandoId];
      element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
    }
  }

  function jqLiteExpandoStore(element, createIfNecessary) {
    var expandoId = element.ng339,
        expandoStore = expandoId && jqCache[expandoId];

    if (createIfNecessary && !expandoStore) {
      element.ng339 = expandoId = jqNextId();
      expandoStore = jqCache[expandoId] = { events: {}, data: {}, handle: undefined };
    }

    return expandoStore;
  }

  function jqLiteData(element, key, value) {
    if (jqLiteAcceptsData(element)) {
      var prop;

      var isSimpleSetter = isDefined(value);
      var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
      var massGetter = !key;
      var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
      var data = expandoStore && expandoStore.data;

      if (isSimpleSetter) {
        // data('key', value)
        data[kebabToCamel(key)] = value;
      } else {
        if (massGetter) {
          // data()
          return data;
        } else {
          if (isSimpleGetter) {
            // data('key')
            // don't force creation of expandoStore if it doesn't exist yet
            return data && data[kebabToCamel(key)];
          } else {
            // mass-setter: data({key1: val1, key2: val2})
            for (prop in key) {
              data[kebabToCamel(prop)] = key[prop];
            }
          }
        }
      }
    }
  }

  function jqLiteHasClass(element, selector) {
    if (!element.getAttribute) return false;
    return (' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').indexOf(' ' + selector + ' ') > -1;
  }

  function jqLiteRemoveClass(element, cssClasses) {
    if (cssClasses && element.setAttribute) {
      var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ');
      var newClasses = existingClasses;

      forEach(cssClasses.split(' '), function (cssClass) {
        cssClass = trim(cssClass);
        newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
      });

      if (newClasses !== existingClasses) {
        element.setAttribute('class', trim(newClasses));
      }
    }
  }

  function jqLiteAddClass(element, cssClasses) {
    if (cssClasses && element.setAttribute) {
      var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ');
      var newClasses = existingClasses;

      forEach(cssClasses.split(' '), function (cssClass) {
        cssClass = trim(cssClass);
        if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
          newClasses += cssClass + ' ';
        }
      });

      if (newClasses !== existingClasses) {
        element.setAttribute('class', trim(newClasses));
      }
    }
  }

  function jqLiteAddNodes(root, elements) {
    // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

    if (elements) {

      // if a Node (the most common case)
      if (elements.nodeType) {
        root[root.length++] = elements;
      } else {
        var length = elements.length;

        // if an Array or NodeList and not a Window
        if (typeof length === 'number' && elements.window !== elements) {
          if (length) {
            for (var i = 0; i < length; i++) {
              root[root.length++] = elements[i];
            }
          }
        } else {
          root[root.length++] = elements;
        }
      }
    }
  }

  function jqLiteController(element, name) {
    return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
  }

  function jqLiteInheritedData(element, name, value) {
    // if element is the document object work with the html element instead
    // this makes $(document).scope() possible
    if (element.nodeType === NODE_TYPE_DOCUMENT) {
      element = element.documentElement;
    }
    var names = isArray(name) ? name : [name];

    while (element) {
      for (var i = 0, ii = names.length; i < ii; i++) {
        if (isDefined(value = jqLite.data(element, names[i]))) return value;
      }

      // If dealing with a document fragment node with a host element, and no parent, use the host
      // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
      // to lookup parent controllers.
      element = element.parentNode || element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host;
    }
  }

  function jqLiteEmpty(element) {
    jqLiteDealoc(element, true);
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }

  function jqLiteRemove(element, keepData) {
    if (!keepData) jqLiteDealoc(element);
    var parent = element.parentNode;
    if (parent) parent.removeChild(element);
  }

  function jqLiteDocumentLoaded(action, win) {
    win = win || window;
    if (win.document.readyState === 'complete') {
      // Force the action to be run async for consistent behavior
      // from the action's point of view
      // i.e. it will definitely not be in a $apply
      win.setTimeout(action);
    } else {
      // No need to unbind this handler as load is only ever called once
      jqLite(win).on('load', action);
    }
  }

  function jqLiteReady(fn) {
    function trigger() {
      window.document.removeEventListener('DOMContentLoaded', trigger);
      window.removeEventListener('load', trigger);
      fn();
    }

    // check if document is already loaded
    if (window.document.readyState === 'complete') {
      window.setTimeout(fn);
    } else {
      // We can not use jqLite since we are not done loading and jQuery could be loaded later.

      // Works for modern browsers and IE9
      window.document.addEventListener('DOMContentLoaded', trigger);

      // Fallback to window.onload for others
      window.addEventListener('load', trigger);
    }
  }

  //////////////////////////////////////////
  // Functions which are declared directly.
  //////////////////////////////////////////
  var JQLitePrototype = JQLite.prototype = {
    ready: jqLiteReady,
    toString: function toString() {
      var value = [];
      forEach(this, function (e) {
        value.push('' + e);
      });
      return '[' + value.join(', ') + ']';
    },

    eq: function eq(index) {
      return index >= 0 ? jqLite(this[index]) : jqLite(this[this.length + index]);
    },

    length: 0,
    push: push,
    sort: [].sort,
    splice: [].splice
  };

  //////////////////////////////////////////
  // Functions iterating getter/setters.
  // these functions return self on setter and
  // value on get.
  //////////////////////////////////////////
  var BOOLEAN_ATTR = {};
  forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function (value) {
    BOOLEAN_ATTR[lowercase(value)] = value;
  });
  var BOOLEAN_ELEMENTS = {};
  forEach('input,select,option,textarea,button,form,details'.split(','), function (value) {
    BOOLEAN_ELEMENTS[value] = true;
  });
  var ALIASED_ATTR = {
    'ngMinlength': 'minlength',
    'ngMaxlength': 'maxlength',
    'ngMin': 'min',
    'ngMax': 'max',
    'ngPattern': 'pattern',
    'ngStep': 'step'
  };

  function getBooleanAttrName(element, name) {
    // check dom last since we will most likely fail on name
    var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

    // booleanAttr is here twice to minimize DOM access
    return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
  }

  function getAliasedAttrName(name) {
    return ALIASED_ATTR[name];
  }

  forEach({
    data: jqLiteData,
    removeData: jqLiteRemoveData,
    hasData: jqLiteHasData,
    cleanData: function jqLiteCleanData(nodes) {
      for (var i = 0, ii = nodes.length; i < ii; i++) {
        jqLiteRemoveData(nodes[i]);
      }
    }
  }, function (fn, name) {
    JQLite[name] = fn;
  });

  forEach({
    data: jqLiteData,
    inheritedData: jqLiteInheritedData,

    scope: function scope(element) {
      // Can't use jqLiteData here directly so we stay compatible with jQuery!
      return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
    },

    isolateScope: function isolateScope(element) {
      // Can't use jqLiteData here directly so we stay compatible with jQuery!
      return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
    },

    controller: jqLiteController,

    injector: function injector(element) {
      return jqLiteInheritedData(element, '$injector');
    },

    removeAttr: function removeAttr(element, name) {
      element.removeAttribute(name);
    },

    hasClass: jqLiteHasClass,

    css: function css(element, name, value) {
      name = cssKebabToCamel(name);

      if (isDefined(value)) {
        element.style[name] = value;
      } else {
        return element.style[name];
      }
    },

    attr: function attr(element, name, value) {
      var ret;
      var nodeType = element.nodeType;
      if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT || !element.getAttribute) {
        return;
      }

      var lowercasedName = lowercase(name);
      var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];

      if (isDefined(value)) {
        // setter

        if (value === null || value === false && isBooleanAttr) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
        }
      } else {
        // getter

        ret = element.getAttribute(name);

        if (isBooleanAttr && ret !== null) {
          ret = lowercasedName;
        }
        // Normalize non-existing attributes to undefined (as jQuery).
        return ret === null ? undefined : ret;
      }
    },

    prop: function prop(element, name, value) {
      if (isDefined(value)) {
        element[name] = value;
      } else {
        return element[name];
      }
    },

    text: function () {
      getText.$dv = '';
      return getText;

      function getText(element, value) {
        if (isUndefined(value)) {
          var nodeType = element.nodeType;
          return nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT ? element.textContent : '';
        }
        element.textContent = value;
      }
    }(),

    val: function val(element, value) {
      if (isUndefined(value)) {
        if (element.multiple && nodeName_(element) === 'select') {
          var result = [];
          forEach(element.options, function (option) {
            if (option.selected) {
              result.push(option.value || option.text);
            }
          });
          return result;
        }
        return element.value;
      }
      element.value = value;
    },

    html: function html(element, value) {
      if (isUndefined(value)) {
        return element.innerHTML;
      }
      jqLiteDealoc(element, true);
      element.innerHTML = value;
    },

    empty: jqLiteEmpty
  }, function (fn, name) {
    /**
     * Properties: writes return selection, reads return first value
     */
    JQLite.prototype[name] = function (arg1, arg2) {
      var i, key;
      var nodeCount = this.length;

      // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
      // in a way that survives minification.
      // jqLiteEmpty takes no arguments but is a setter.
      if (fn !== jqLiteEmpty && isUndefined(fn.length === 2 && fn !== jqLiteHasClass && fn !== jqLiteController ? arg1 : arg2)) {
        if (isObject(arg1)) {

          // we are a write, but the object properties are the key/values
          for (i = 0; i < nodeCount; i++) {
            if (fn === jqLiteData) {
              // data() takes the whole object in jQuery
              fn(this[i], arg1);
            } else {
              for (key in arg1) {
                fn(this[i], key, arg1[key]);
              }
            }
          }
          // return self for chaining
          return this;
        } else {
          // we are a read, so read the first child.
          // TODO: do we still need this?
          var value = fn.$dv;
          // Only if we have $dv do we iterate over all, otherwise it is just the first element.
          var jj = isUndefined(value) ? Math.min(nodeCount, 1) : nodeCount;
          for (var j = 0; j < jj; j++) {
            var nodeValue = fn(this[j], arg1, arg2);
            value = value ? value + nodeValue : nodeValue;
          }
          return value;
        }
      } else {
        // we are a write, so apply to all children
        for (i = 0; i < nodeCount; i++) {
          fn(this[i], arg1, arg2);
        }
        // return self for chaining
        return this;
      }
    };
  });

  function createEventHandler(element, events) {
    var eventHandler = function eventHandler(event, type) {
      // jQuery specific api
      event.isDefaultPrevented = function () {
        return event.defaultPrevented;
      };

      var eventFns = events[type || event.type];
      var eventFnsLength = eventFns ? eventFns.length : 0;

      if (!eventFnsLength) return;

      if (isUndefined(event.immediatePropagationStopped)) {
        var originalStopImmediatePropagation = event.stopImmediatePropagation;
        event.stopImmediatePropagation = function () {
          event.immediatePropagationStopped = true;

          if (event.stopPropagation) {
            event.stopPropagation();
          }

          if (originalStopImmediatePropagation) {
            originalStopImmediatePropagation.call(event);
          }
        };
      }

      event.isImmediatePropagationStopped = function () {
        return event.immediatePropagationStopped === true;
      };

      // Some events have special handlers that wrap the real handler
      var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

      // Copy event handlers in case event handlers array is modified during execution.
      if (eventFnsLength > 1) {
        eventFns = shallowCopy(eventFns);
      }

      for (var i = 0; i < eventFnsLength; i++) {
        if (!event.isImmediatePropagationStopped()) {
          handlerWrapper(element, event, eventFns[i]);
        }
      }
    };

    // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
    //       events on `element`
    eventHandler.elem = element;
    return eventHandler;
  }

  function defaultHandlerWrapper(element, event, handler) {
    handler.call(element, event);
  }

  function specialMouseHandlerWrapper(target, event, handler) {
    // Refer to jQuery's implementation of mouseenter & mouseleave
    // Read about mouseenter and mouseleave:
    // http://www.quirksmode.org/js/events_mouse.html#link8
    var related = event.relatedTarget;
    // For mousenter/leave call the handler if related is outside the target.
    // NB: No relatedTarget if the mouse left/entered the browser window
    if (!related || related !== target && !jqLiteContains.call(target, related)) {
      handler.call(target, event);
    }
  }

  //////////////////////////////////////////
  // Functions iterating traversal.
  // These functions chain results into a single
  // selector.
  //////////////////////////////////////////
  forEach({
    removeData: jqLiteRemoveData,

    on: function jqLiteOn(element, type, fn, unsupported) {
      if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

      // Do not add event handlers to non-elements because they will not be cleaned up.
      if (!jqLiteAcceptsData(element)) {
        return;
      }

      var expandoStore = jqLiteExpandoStore(element, true);
      var events = expandoStore.events;
      var handle = expandoStore.handle;

      if (!handle) {
        handle = expandoStore.handle = createEventHandler(element, events);
      }

      // http://jsperf.com/string-indexof-vs-split
      var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
      var i = types.length;

      var addHandler = function addHandler(type, specialHandlerWrapper, noEventListener) {
        var eventFns = events[type];

        if (!eventFns) {
          eventFns = events[type] = [];
          eventFns.specialHandlerWrapper = specialHandlerWrapper;
          if (type !== '$destroy' && !noEventListener) {
            element.addEventListener(type, handle);
          }
        }

        eventFns.push(fn);
      };

      while (i--) {
        type = types[i];
        if (MOUSE_EVENT_MAP[type]) {
          addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
          addHandler(type, undefined, true);
        } else {
          addHandler(type);
        }
      }
    },

    off: jqLiteOff,

    one: function one(element, type, fn) {
      element = jqLite(element);

      //add the listener twice so that when it is called
      //you can remove the original function and still be
      //able to call element.off(ev, fn) normally
      element.on(type, function onFn() {
        element.off(type, fn);
        element.off(type, onFn);
      });
      element.on(type, fn);
    },

    replaceWith: function replaceWith(element, replaceNode) {
      var index,
          parent = element.parentNode;
      jqLiteDealoc(element);
      forEach(new JQLite(replaceNode), function (node) {
        if (index) {
          parent.insertBefore(node, index.nextSibling);
        } else {
          parent.replaceChild(node, element);
        }
        index = node;
      });
    },

    children: function children(element) {
      var children = [];
      forEach(element.childNodes, function (element) {
        if (element.nodeType === NODE_TYPE_ELEMENT) {
          children.push(element);
        }
      });
      return children;
    },

    contents: function contents(element) {
      return element.contentDocument || element.childNodes || [];
    },

    append: function append(element, node) {
      var nodeType = element.nodeType;
      if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;

      node = new JQLite(node);

      for (var i = 0, ii = node.length; i < ii; i++) {
        var child = node[i];
        element.appendChild(child);
      }
    },

    prepend: function prepend(element, node) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        var index = element.firstChild;
        forEach(new JQLite(node), function (child) {
          element.insertBefore(child, index);
        });
      }
    },

    wrap: function wrap(element, wrapNode) {
      jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
    },

    remove: jqLiteRemove,

    detach: function detach(element) {
      jqLiteRemove(element, true);
    },

    after: function after(element, newElement) {
      var index = element,
          parent = element.parentNode;

      if (parent) {
        newElement = new JQLite(newElement);

        for (var i = 0, ii = newElement.length; i < ii; i++) {
          var node = newElement[i];
          parent.insertBefore(node, index.nextSibling);
          index = node;
        }
      }
    },

    addClass: jqLiteAddClass,
    removeClass: jqLiteRemoveClass,

    toggleClass: function toggleClass(element, selector, condition) {
      if (selector) {
        forEach(selector.split(' '), function (className) {
          var classCondition = condition;
          if (isUndefined(classCondition)) {
            classCondition = !jqLiteHasClass(element, className);
          }
          (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
        });
      }
    },

    parent: function parent(element) {
      var parent = element.parentNode;
      return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
    },

    next: function next(element) {
      return element.nextElementSibling;
    },

    find: function find(element, selector) {
      if (element.getElementsByTagName) {
        return element.getElementsByTagName(selector);
      } else {
        return [];
      }
    },

    clone: jqLiteClone,

    triggerHandler: function triggerHandler(element, event, extraParameters) {

      var dummyEvent, eventFnsCopy, handlerArgs;
      var eventName = event.type || event;
      var expandoStore = jqLiteExpandoStore(element);
      var events = expandoStore && expandoStore.events;
      var eventFns = events && events[eventName];

      if (eventFns) {
        // Create a dummy event to pass to the handlers
        dummyEvent = {
          preventDefault: function preventDefault() {
            this.defaultPrevented = true;
          },
          isDefaultPrevented: function isDefaultPrevented() {
            return this.defaultPrevented === true;
          },
          stopImmediatePropagation: function stopImmediatePropagation() {
            this.immediatePropagationStopped = true;
          },
          isImmediatePropagationStopped: function isImmediatePropagationStopped() {
            return this.immediatePropagationStopped === true;
          },
          stopPropagation: noop,
          type: eventName,
          target: element
        };

        // If a custom event was provided then extend our dummy event with it
        if (event.type) {
          dummyEvent = extend(dummyEvent, event);
        }

        // Copy event handlers in case event handlers array is modified during execution.
        eventFnsCopy = shallowCopy(eventFns);
        handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];

        forEach(eventFnsCopy, function (fn) {
          if (!dummyEvent.isImmediatePropagationStopped()) {
            fn.apply(element, handlerArgs);
          }
        });
      }
    }
  }, function (fn, name) {
    /**
     * chaining functions
     */
    JQLite.prototype[name] = function (arg1, arg2, arg3) {
      var value;

      for (var i = 0, ii = this.length; i < ii; i++) {
        if (isUndefined(value)) {
          value = fn(this[i], arg1, arg2, arg3);
          if (isDefined(value)) {
            // any function which returns a value needs to be wrapped
            value = jqLite(value);
          }
        } else {
          jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
        }
      }
      return isDefined(value) ? value : this;
    };
  });

  // bind legacy bind/unbind to on/off
  JQLite.prototype.bind = JQLite.prototype.on;
  JQLite.prototype.unbind = JQLite.prototype.off;

  // Provider for private $$jqLite service
  /** @this */
  function $$jqLiteProvider() {
    this.$get = function $$jqLite() {
      return extend(JQLite, {
        hasClass: function hasClass(node, classes) {
          if (node.attr) node = node[0];
          return jqLiteHasClass(node, classes);
        },
        addClass: function addClass(node, classes) {
          if (node.attr) node = node[0];
          return jqLiteAddClass(node, classes);
        },
        removeClass: function removeClass(node, classes) {
          if (node.attr) node = node[0];
          return jqLiteRemoveClass(node, classes);
        }
      });
    };
  }

  /**
   * Computes a hash of an 'obj'.
   * Hash of a:
   *  string is string
   *  number is number as string
   *  object is either result of calling $$hashKey function on the object or uniquely generated id,
   *         that is also assigned to the $$hashKey property of the object.
   *
   * @param obj
   * @returns {string} hash string such that the same input will have the same hash string.
   *         The resulting string key is in 'type:hashKey' format.
   */
  function hashKey(obj, nextUidFn) {
    var key = obj && obj.$$hashKey;

    if (key) {
      if (typeof key === 'function') {
        key = obj.$$hashKey();
      }
      return key;
    }

    var objType = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
    if (objType === 'function' || objType === 'object' && obj !== null) {
      key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
    } else {
      key = objType + ':' + obj;
    }

    return key;
  }

  // A minimal ES2015 Map implementation.
  // Should be bug/feature equivalent to the native implementations of supported browsers
  // (for the features required in Angular).
  // See https://kangax.github.io/compat-table/es6/#test-Map
  var nanKey = Object.create(null);
  function NgMapShim() {
    this._keys = [];
    this._values = [];
    this._lastKey = NaN;
    this._lastIndex = -1;
  }
  NgMapShim.prototype = {
    _idx: function _idx(key) {
      if (key === this._lastKey) {
        return this._lastIndex;
      }
      this._lastKey = key;
      this._lastIndex = this._keys.indexOf(key);
      return this._lastIndex;
    },
    _transformKey: function _transformKey(key) {
      return isNumberNaN(key) ? nanKey : key;
    },
    get: function get(key) {
      key = this._transformKey(key);
      var idx = this._idx(key);
      if (idx !== -1) {
        return this._values[idx];
      }
    },
    set: function set(key, value) {
      key = this._transformKey(key);
      var idx = this._idx(key);
      if (idx === -1) {
        idx = this._lastIndex = this._keys.length;
      }
      this._keys[idx] = key;
      this._values[idx] = value;

      // Support: IE11
      // Do not `return this` to simulate the partial IE11 implementation
    },
    delete: function _delete(key) {
      key = this._transformKey(key);
      var idx = this._idx(key);
      if (idx === -1) {
        return false;
      }
      this._keys.splice(idx, 1);
      this._values.splice(idx, 1);
      this._lastKey = NaN;
      this._lastIndex = -1;
      return true;
    }
  };

  // For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
  // are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
  // implementations get more stable, we can reconsider switching to `window.Map` (when available).
  var NgMap = NgMapShim;

  var $$MapProvider = [/** @this */function () {
    this.$get = [function () {
      return NgMap;
    }];
  }];

  /**
   * @ngdoc function
   * @module ng
   * @name angular.injector
   * @kind function
   *
   * @description
   * Creates an injector object that can be used for retrieving services as well as for
   * dependency injection (see {@link guide/di dependency injection}).
   *
   * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
   *     {@link angular.module}. The `ng` module must be explicitly added.
   * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
   *     disallows argument name annotation inference.
   * @returns {injector} Injector object. See {@link auto.$injector $injector}.
   *
   * @example
   * Typical usage
   * ```js
   *   // create an injector
   *   var $injector = angular.injector(['ng']);
   *
   *   // use the injector to kick off your application
   *   // use the type inference to auto inject arguments, or use implicit injection
   *   $injector.invoke(function($rootScope, $compile, $document) {
   *     $compile($document)($rootScope);
   *     $rootScope.$digest();
   *   });
   * ```
   *
   * Sometimes you want to get access to the injector of a currently running AngularJS app
   * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
   * application has been bootstrapped. You can do this using the extra `injector()` added
   * to JQuery/jqLite elements. See {@link angular.element}.
   *
   * *This is fairly rare but could be the case if a third party library is injecting the
   * markup.*
   *
   * In the following example a new block of HTML containing a `ng-controller`
   * directive is added to the end of the document body by JQuery. We then compile and link
   * it into the current AngularJS scope.
   *
   * ```js
   * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
   * $(document.body).append($div);
   *
   * angular.element(document).injector().invoke(function($compile) {
   *   var scope = angular.element($div).scope();
   *   $compile($div)(scope);
   * });
   * ```
   */

  /**
   * @ngdoc module
   * @name auto
   * @installation
   * @description
   *
   * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
   */

  var ARROW_ARG = /^([^(]+?)=>/;
  var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
  var FN_ARG_SPLIT = /,/;
  var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
  var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
  var $injectorMinErr = minErr('$injector');

  function stringifyFn(fn) {
    return Function.prototype.toString.call(fn);
  }

  function extractArgs(fn) {
    var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
        args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
    return args;
  }

  function anonFn(fn) {
    // For anonymous functions, showing at the very least the function signature can help in
    // debugging.
    var args = extractArgs(fn);
    if (args) {
      return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
    }
    return 'fn';
  }

  function annotate(fn, strictDi, name) {
    var $inject, argDecl, last;

    if (typeof fn === 'function') {
      if (!($inject = fn.$inject)) {
        $inject = [];
        if (fn.length) {
          if (strictDi) {
            if (!isString(name) || !name) {
              name = fn.name || anonFn(fn);
            }
            throw $injectorMinErr('strictdi', '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
          }
          argDecl = extractArgs(fn);
          forEach(argDecl[1].split(FN_ARG_SPLIT), function (arg) {
            arg.replace(FN_ARG, function (all, underscore, name) {
              $inject.push(name);
            });
          });
        }
        fn.$inject = $inject;
      }
    } else if (isArray(fn)) {
      last = fn.length - 1;
      assertArgFn(fn[last], 'fn');
      $inject = fn.slice(0, last);
    } else {
      assertArgFn(fn, 'fn', true);
    }
    return $inject;
  }

  ///////////////////////////////////////

  /**
   * @ngdoc service
   * @name $injector
   *
   * @description
   *
   * `$injector` is used to retrieve object instances as defined by
   * {@link auto.$provide provider}, instantiate types, invoke methods,
   * and load modules.
   *
   * The following always holds true:
   *
   * ```js
   *   var $injector = angular.injector();
   *   expect($injector.get('$injector')).toBe($injector);
   *   expect($injector.invoke(function($injector) {
   *     return $injector;
   *   })).toBe($injector);
   * ```
   *
   * ## Injection Function Annotation
   *
   * JavaScript does not have annotations, and annotations are needed for dependency injection. The
   * following are all valid ways of annotating function with injection arguments and are equivalent.
   *
   * ```js
   *   // inferred (only works if code not minified/obfuscated)
   *   $injector.invoke(function(serviceA){});
   *
   *   // annotated
   *   function explicit(serviceA) {};
   *   explicit.$inject = ['serviceA'];
   *   $injector.invoke(explicit);
   *
   *   // inline
   *   $injector.invoke(['serviceA', function(serviceA){}]);
   * ```
   *
   * ### Inference
   *
   * In JavaScript calling `toString()` on a function returns the function definition. The definition
   * can then be parsed and the function arguments can be extracted. This method of discovering
   * annotations is disallowed when the injector is in strict mode.
   * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
   * argument names.
   *
   * ### `$inject` Annotation
   * By adding an `$inject` property onto a function the injection parameters can be specified.
   *
   * ### Inline
   * As an array of injection names, where the last item in the array is the function to call.
   */

  /**
   * @ngdoc property
   * @name $injector#modules
   * @type {Object}
   * @description
   * A hash containing all the modules that have been loaded into the
   * $injector.
   *
   * You can use this property to find out information about a module via the
   * {@link angular.Module#info `myModule.info(...)`} method.
   *
   * For example:
   *
   * ```
   * var info = $injector.modules['ngAnimate'].info();
   * ```
   *
   * **Do not use this property to attempt to modify the modules after the application
   * has been bootstrapped.**
   */

  /**
   * @ngdoc method
   * @name $injector#get
   *
   * @description
   * Return an instance of the service.
   *
   * @param {string} name The name of the instance to retrieve.
   * @param {string=} caller An optional string to provide the origin of the function call for error messages.
   * @return {*} The instance.
   */

  /**
   * @ngdoc method
   * @name $injector#invoke
   *
   * @description
   * Invoke the method and supply the method arguments from the `$injector`.
   *
   * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
   *   injected according to the {@link guide/di $inject Annotation} rules.
   * @param {Object=} self The `this` for the invoked method.
   * @param {Object=} locals Optional object. If preset then any argument names are read from this
   *                         object first, before the `$injector` is consulted.
   * @returns {*} the value returned by the invoked `fn` function.
   */

  /**
   * @ngdoc method
   * @name $injector#has
   *
   * @description
   * Allows the user to query if the particular service exists.
   *
   * @param {string} name Name of the service to query.
   * @returns {boolean} `true` if injector has given service.
   */

  /**
   * @ngdoc method
   * @name $injector#instantiate
   * @description
   * Create a new instance of JS type. The method takes a constructor function, invokes the new
   * operator, and supplies all of the arguments to the constructor function as specified by the
   * constructor annotation.
   *
   * @param {Function} Type Annotated constructor function.
   * @param {Object=} locals Optional object. If preset then any argument names are read from this
   * object first, before the `$injector` is consulted.
   * @returns {Object} new instance of `Type`.
   */

  /**
   * @ngdoc method
   * @name $injector#annotate
   *
   * @description
   * Returns an array of service names which the function is requesting for injection. This API is
   * used by the injector to determine which services need to be injected into the function when the
   * function is invoked. There are three ways in which the function can be annotated with the needed
   * dependencies.
   *
   * #### Argument names
   *
   * The simplest form is to extract the dependencies from the arguments of the function. This is done
   * by converting the function into a string using `toString()` method and extracting the argument
   * names.
   * ```js
   *   // Given
   *   function MyController($scope, $route) {
   *     // ...
   *   }
   *
   *   // Then
   *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
   * ```
   *
   * You can disallow this method by using strict injection mode.
   *
   * This method does not work with code minification / obfuscation. For this reason the following
   * annotation strategies are supported.
   *
   * #### The `$inject` property
   *
   * If a function has an `$inject` property and its value is an array of strings, then the strings
   * represent names of services to be injected into the function.
   * ```js
   *   // Given
   *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
   *     // ...
   *   }
   *   // Define function dependencies
   *   MyController['$inject'] = ['$scope', '$route'];
   *
   *   // Then
   *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
   * ```
   *
   * #### The array notation
   *
   * It is often desirable to inline Injected functions and that's when setting the `$inject` property
   * is very inconvenient. In these situations using the array notation to specify the dependencies in
   * a way that survives minification is a better choice:
   *
   * ```js
   *   // We wish to write this (not minification / obfuscation safe)
   *   injector.invoke(function($compile, $rootScope) {
   *     // ...
   *   });
   *
   *   // We are forced to write break inlining
   *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
   *     // ...
   *   };
   *   tmpFn.$inject = ['$compile', '$rootScope'];
   *   injector.invoke(tmpFn);
   *
   *   // To better support inline function the inline annotation is supported
   *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
   *     // ...
   *   }]);
   *
   *   // Therefore
   *   expect(injector.annotate(
   *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
   *    ).toEqual(['$compile', '$rootScope']);
   * ```
   *
   * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
   * be retrieved as described above.
   *
   * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
   *
   * @returns {Array.<string>} The names of the services which the function requires.
   */
  /**
   * @ngdoc method
   * @name $injector#loadNewModules
   *
   * @description
   *
   * **This is a dangerous API, which you use at your own risk!**
   *
   * Add the specified modules to the current injector.
   *
   * This method will add each of the injectables to the injector and execute all of the config and run
   * blocks for each module passed to the method.
   *
   * If a module has already been loaded into the injector then it will not be loaded again.
   *
   * * The application developer is responsible for loading the code containing the modules; and for
   * ensuring that lazy scripts are not downloaded and executed more often that desired.
   * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
   * * Modules cannot be unloaded.
   *
   * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
   * into the injector, which may indicate whether the script has been executed already.
   *
   * @example
   * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
   *
   * ```javascript
   * app.factory('loadModule', function($injector) {
   *   return function loadModule(moduleName, bundleUrl) {
   *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
   *   };
   * })
   * ```
   *
   * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
   *     Each item in the array should be the name of a predefined module or a (DI annotated)
   *     function that will be invoked by the injector as a `config` block.
   *     See: {@link angular.module modules}
   */

  /**
   * @ngdoc service
   * @name $provide
   *
   * @description
   *
   * The {@link auto.$provide $provide} service has a number of methods for registering components
   * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
   * {@link angular.Module}.
   *
   * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
   * factories** are functions which, in turn, are created by a **service provider**.
   * The **service providers** are constructor functions. When instantiated they must contain a
   * property called `$get`, which holds the **service factory** function.
   *
   * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
   * correct **service provider**, instantiating it and then calling its `$get` **service factory**
   * function to get the instance of the **service**.
   *
   * Often services have no configuration options and there is no need to add methods to the service
   * provider.  The provider will be no more than a constructor function with a `$get` property. For
   * these cases the {@link auto.$provide $provide} service has additional helper methods to register
   * services without specifying a provider.
   *
   * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
   *     {@link auto.$injector $injector}
   * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
   *     providers and services.
   * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
   *     services, not providers.
   * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
   *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
   *     given factory function.
   * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
   *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
   *      a new object using the given constructor function.
   * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
   *      will be able to modify or replace the implementation of another service.
   *
   * See the individual methods for more information and examples.
   */

  /**
   * @ngdoc method
   * @name $provide#provider
   * @description
   *
   * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
   * are constructor functions, whose instances are responsible for "providing" a factory for a
   * service.
   *
   * Service provider names start with the name of the service they provide followed by `Provider`.
   * For example, the {@link ng.$log $log} service has a provider called
   * {@link ng.$logProvider $logProvider}.
   *
   * Service provider objects can have additional methods which allow configuration of the provider
   * and its service. Importantly, you can configure what kind of service is created by the `$get`
   * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
   * method {@link ng.$logProvider#debugEnabled debugEnabled}
   * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
   * console or not.
   *
   * It is possible to inject other providers into the provider function,
   * but the injected provider must have been defined before the one that requires it.
   *
   * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                          'Provider'` key.
   * @param {(Object|function())} provider If the provider is:
   *
   *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
   *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
   *   - `Constructor`: a new instance of the provider will be created using
   *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
   *
   * @returns {Object} registered provider instance
  
   * @example
   *
   * The following example shows how to create a simple event tracking service and register it using
   * {@link auto.$provide#provider $provide.provider()}.
   *
   * ```js
   *  // Define the eventTracker provider
   *  function EventTrackerProvider() {
   *    var trackingUrl = '/track';
   *
   *    // A provider method for configuring where the tracked events should been saved
   *    this.setTrackingUrl = function(url) {
   *      trackingUrl = url;
   *    };
   *
   *    // The service factory function
   *    this.$get = ['$http', function($http) {
   *      var trackedEvents = {};
   *      return {
   *        // Call this to track an event
   *        event: function(event) {
   *          var count = trackedEvents[event] || 0;
   *          count += 1;
   *          trackedEvents[event] = count;
   *          return count;
   *        },
   *        // Call this to save the tracked events to the trackingUrl
   *        save: function() {
   *          $http.post(trackingUrl, trackedEvents);
   *        }
   *      };
   *    }];
   *  }
   *
   *  describe('eventTracker', function() {
   *    var postSpy;
   *
   *    beforeEach(module(function($provide) {
   *      // Register the eventTracker provider
   *      $provide.provider('eventTracker', EventTrackerProvider);
   *    }));
   *
   *    beforeEach(module(function(eventTrackerProvider) {
   *      // Configure eventTracker provider
   *      eventTrackerProvider.setTrackingUrl('/custom-track');
   *    }));
   *
   *    it('tracks events', inject(function(eventTracker) {
   *      expect(eventTracker.event('login')).toEqual(1);
   *      expect(eventTracker.event('login')).toEqual(2);
   *    }));
   *
   *    it('saves to the tracking url', inject(function(eventTracker, $http) {
   *      postSpy = spyOn($http, 'post');
   *      eventTracker.event('login');
   *      eventTracker.save();
   *      expect(postSpy).toHaveBeenCalled();
   *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
   *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
   *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
   *    }));
   *  });
   * ```
   */

  /**
   * @ngdoc method
   * @name $provide#factory
   * @description
   *
   * Register a **service factory**, which will be called to return the service instance.
   * This is short for registering a service where its provider consists of only a `$get` property,
   * which is the given service factory function.
   * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
   * configure your service in a provider.
   *
   * @param {string} name The name of the instance.
   * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
   *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
   * @returns {Object} registered provider instance
   *
   * @example
   * Here is an example of registering a service
   * ```js
   *   $provide.factory('ping', ['$http', function($http) {
   *     return function ping() {
   *       return $http.send('/ping');
   *     };
   *   }]);
   * ```
   * You would then inject and use this service like this:
   * ```js
   *   someModule.controller('Ctrl', ['ping', function(ping) {
   *     ping();
   *   }]);
   * ```
   */

  /**
   * @ngdoc method
   * @name $provide#service
   * @description
   *
   * Register a **service constructor**, which will be invoked with `new` to create the service
   * instance.
   * This is short for registering a service where its provider's `$get` property is a factory
   * function that returns an instance instantiated by the injector from the service constructor
   * function.
   *
   * Internally it looks a bit like this:
   *
   * ```
   * {
   *   $get: function() {
   *     return $injector.instantiate(constructor);
   *   }
   * }
   * ```
   *
   *
   * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
   * as a type/class.
   *
   * @param {string} name The name of the instance.
   * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
   *     that will be instantiated.
   * @returns {Object} registered provider instance
   *
   * @example
   * Here is an example of registering a service using
   * {@link auto.$provide#service $provide.service(class)}.
   * ```js
   *   var Ping = function($http) {
   *     this.$http = $http;
   *   };
   *
   *   Ping.$inject = ['$http'];
   *
   *   Ping.prototype.send = function() {
   *     return this.$http.get('/ping');
   *   };
   *   $provide.service('ping', Ping);
   * ```
   * You would then inject and use this service like this:
   * ```js
   *   someModule.controller('Ctrl', ['ping', function(ping) {
   *     ping.send();
   *   }]);
   * ```
   */

  /**
   * @ngdoc method
   * @name $provide#value
   * @description
   *
   * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
   * number, an array, an object or a function. This is short for registering a service where its
   * provider's `$get` property is a factory function that takes no arguments and returns the **value
   * service**. That also means it is not possible to inject other services into a value service.
   *
   * Value services are similar to constant services, except that they cannot be injected into a
   * module configuration function (see {@link angular.Module#config}) but they can be overridden by
   * an AngularJS {@link auto.$provide#decorator decorator}.
   *
   * @param {string} name The name of the instance.
   * @param {*} value The value.
   * @returns {Object} registered provider instance
   *
   * @example
   * Here are some examples of creating value services.
   * ```js
   *   $provide.value('ADMIN_USER', 'admin');
   *
   *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
   *
   *   $provide.value('halfOf', function(value) {
   *     return value / 2;
   *   });
   * ```
   */

  /**
   * @ngdoc method
   * @name $provide#constant
   * @description
   *
   * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
   * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
   * possible to inject other services into a constant.
   *
   * But unlike {@link auto.$provide#value value}, a constant can be
   * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
   * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
   *
   * @param {string} name The name of the constant.
   * @param {*} value The constant value.
   * @returns {Object} registered instance
   *
   * @example
   * Here a some examples of creating constants:
   * ```js
   *   $provide.constant('SHARD_HEIGHT', 306);
   *
   *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
   *
   *   $provide.constant('double', function(value) {
   *     return value * 2;
   *   });
   * ```
   */

  /**
   * @ngdoc method
   * @name $provide#decorator
   * @description
   *
   * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
   * intercepts the creation of a service, allowing it to override or modify the behavior of the
   * service. The return value of the decorator function may be the original service, or a new service
   * that replaces (or wraps and delegates to) the original service.
   *
   * You can find out more about using decorators in the {@link guide/decorators} guide.
   *
   * @param {string} name The name of the service to decorate.
   * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
   *    provided and should return the decorated service instance. The function is called using
   *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
   *    Local injection arguments:
   *
   *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
   *      decorated or delegated to.
   *
   * @example
   * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
   * calls to {@link ng.$log#error $log.warn()}.
   * ```js
   *   $provide.decorator('$log', ['$delegate', function($delegate) {
   *     $delegate.warn = $delegate.error;
   *     return $delegate;
   *   }]);
   * ```
   */

  function createInjector(modulesToLoad, strictDi) {
    strictDi = strictDi === true;
    var INSTANTIATING = {},
        providerSuffix = 'Provider',
        path = [],
        loadedModules = new NgMap(),
        providerCache = {
      $provide: {
        provider: supportObject(provider),
        factory: supportObject(factory),
        service: supportObject(service),
        value: supportObject(value),
        constant: supportObject(constant),
        decorator: decorator
      }
    },
        providerInjector = providerCache.$injector = createInternalInjector(providerCache, function (serviceName, caller) {
      if (angular.isString(caller)) {
        path.push(caller);
      }
      throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
    }),
        instanceCache = {},
        protoInstanceInjector = createInternalInjector(instanceCache, function (serviceName, caller) {
      var provider = providerInjector.get(serviceName + providerSuffix, caller);
      return instanceInjector.invoke(provider.$get, provider, undefined, serviceName);
    }),
        instanceInjector = protoInstanceInjector;

    providerCache['$injector' + providerSuffix] = { $get: valueFn(protoInstanceInjector) };
    instanceInjector.modules = providerInjector.modules = createMap();
    var runBlocks = loadModules(modulesToLoad);
    instanceInjector = protoInstanceInjector.get('$injector');
    instanceInjector.strictDi = strictDi;
    forEach(runBlocks, function (fn) {
      if (fn) instanceInjector.invoke(fn);
    });

    instanceInjector.loadNewModules = function (mods) {
      forEach(loadModules(mods), function (fn) {
        if (fn) instanceInjector.invoke(fn);
      });
    };

    return instanceInjector;

    ////////////////////////////////////
    // $provider
    ////////////////////////////////////

    function supportObject(delegate) {
      return function (key, value) {
        if (isObject(key)) {
          forEach(key, reverseParams(delegate));
        } else {
          return delegate(key, value);
        }
      };
    }

    function provider(name, provider_) {
      assertNotHasOwnProperty(name, 'service');
      if (isFunction(provider_) || isArray(provider_)) {
        provider_ = providerInjector.instantiate(provider_);
      }
      if (!provider_.$get) {
        throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
      }
      return providerCache[name + providerSuffix] = provider_;
    }

    function enforceReturnValue(name, factory) {
      return (/** @this */function enforcedReturnValue() {
          var result = instanceInjector.invoke(factory, this);
          if (isUndefined(result)) {
            throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
          }
          return result;
        }
      );
    }

    function factory(name, factoryFn, enforce) {
      return provider(name, {
        $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
      });
    }

    function service(name, constructor) {
      return factory(name, ['$injector', function ($injector) {
        return $injector.instantiate(constructor);
      }]);
    }

    function value(name, val) {
      return factory(name, valueFn(val), false);
    }

    function constant(name, value) {
      assertNotHasOwnProperty(name, 'constant');
      providerCache[name] = value;
      instanceCache[name] = value;
    }

    function decorator(serviceName, decorFn) {
      var origProvider = providerInjector.get(serviceName + providerSuffix),
          orig$get = origProvider.$get;

      origProvider.$get = function () {
        var origInstance = instanceInjector.invoke(orig$get, origProvider);
        return instanceInjector.invoke(decorFn, null, { $delegate: origInstance });
      };
    }

    ////////////////////////////////////
    // Module Loading
    ////////////////////////////////////
    function loadModules(modulesToLoad) {
      assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
      var runBlocks = [],
          moduleFn;
      forEach(modulesToLoad, function (module) {
        if (loadedModules.get(module)) return;
        loadedModules.set(module, true);

        function runInvokeQueue(queue) {
          var i, ii;
          for (i = 0, ii = queue.length; i < ii; i++) {
            var invokeArgs = queue[i],
                provider = providerInjector.get(invokeArgs[0]);

            provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
          }
        }

        try {
          if (isString(module)) {
            moduleFn = angularModule(module);
            instanceInjector.modules[module] = moduleFn;
            runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
            runInvokeQueue(moduleFn._invokeQueue);
            runInvokeQueue(moduleFn._configBlocks);
          } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
          } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
          } else {
            assertArgFn(module, 'module');
          }
        } catch (e) {
          if (isArray(module)) {
            module = module[module.length - 1];
          }
          if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
            // Safari & FF's stack traces don't contain error.message content
            // unlike those of Chrome and IE
            // So if stack doesn't contain message, we create a new string that contains both.
            // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
            // eslint-disable-next-line no-ex-assign
            e = e.message + '\n' + e.stack;
          }
          throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}', module, e.stack || e.message || e);
        }
      });
      return runBlocks;
    }

    ////////////////////////////////////
    // internal Injector
    ////////////////////////////////////

    function createInternalInjector(cache, factory) {

      function getService(serviceName, caller) {
        if (cache.hasOwnProperty(serviceName)) {
          if (cache[serviceName] === INSTANTIATING) {
            throw $injectorMinErr('cdep', 'Circular dependency found: {0}', serviceName + ' <- ' + path.join(' <- '));
          }
          return cache[serviceName];
        } else {
          try {
            path.unshift(serviceName);
            cache[serviceName] = INSTANTIATING;
            cache[serviceName] = factory(serviceName, caller);
            return cache[serviceName];
          } catch (err) {
            if (cache[serviceName] === INSTANTIATING) {
              delete cache[serviceName];
            }
            throw err;
          } finally {
            path.shift();
          }
        }
      }

      function injectionArgs(fn, locals, serviceName) {
        var args = [],
            $inject = createInjector.$$annotate(fn, strictDi, serviceName);

        for (var i = 0, length = $inject.length; i < length; i++) {
          var key = $inject[i];
          if (typeof key !== 'string') {
            throw $injectorMinErr('itkn', 'Incorrect injection token! Expected service name as string, got {0}', key);
          }
          args.push(locals && locals.hasOwnProperty(key) ? locals[key] : getService(key, serviceName));
        }
        return args;
      }

      function isClass(func) {
        // Support: IE 9-11 only
        // IE 9-11 do not support classes and IE9 leaks with the code below.
        if (msie || typeof func !== 'function') {
          return false;
        }
        var result = func.$$ngIsClass;
        if (!isBoolean(result)) {
          // Support: Edge 12-13 only
          // See: https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/6156135/
          result = func.$$ngIsClass = /^(?:class\b|constructor\()/.test(stringifyFn(func));
        }
        return result;
      }

      function invoke(fn, self, locals, serviceName) {
        if (typeof locals === 'string') {
          serviceName = locals;
          locals = null;
        }

        var args = injectionArgs(fn, locals, serviceName);
        if (isArray(fn)) {
          fn = fn[fn.length - 1];
        }

        if (!isClass(fn)) {
          // http://jsperf.com/angularjs-invoke-apply-vs-switch
          // #5388
          return fn.apply(self, args);
        } else {
          args.unshift(null);
          return new (Function.prototype.bind.apply(fn, args))();
        }
      }

      function instantiate(Type, locals, serviceName) {
        // Check if Type is annotated and use just the given function at n-1 as parameter
        // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
        var ctor = isArray(Type) ? Type[Type.length - 1] : Type;
        var args = injectionArgs(Type, locals, serviceName);
        // Empty object at position 0 is ignored for invocation with `new`, but required.
        args.unshift(null);
        return new (Function.prototype.bind.apply(ctor, args))();
      }

      return {
        invoke: invoke,
        instantiate: instantiate,
        get: getService,
        annotate: createInjector.$$annotate,
        has: function has(name) {
          return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
        }
      };
    }
  }

  createInjector.$$annotate = annotate;

  /**
   * @ngdoc provider
   * @name $anchorScrollProvider
   * @this
   *
   * @description
   * Use `$anchorScrollProvider` to disable automatic scrolling whenever
   * {@link ng.$location#hash $location.hash()} changes.
   */
  function $AnchorScrollProvider() {

    var autoScrollingEnabled = true;

    /**
     * @ngdoc method
     * @name $anchorScrollProvider#disableAutoScrolling
     *
     * @description
     * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
     * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
     * Use this method to disable automatic scrolling.
     *
     * If automatic scrolling is disabled, one must explicitly call
     * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
     * current hash.
     */
    this.disableAutoScrolling = function () {
      autoScrollingEnabled = false;
    };

    /**
     * @ngdoc service
     * @name $anchorScroll
     * @kind function
     * @requires $window
     * @requires $location
     * @requires $rootScope
     *
     * @description
     * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
     * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
     * in the
     * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
     *
     * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
     * match any anchor whenever it changes. This can be disabled by calling
     * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
     *
     * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
     * vertical scroll-offset (either fixed or dynamic).
     *
     * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
     *                       {@link ng.$location#hash $location.hash()} will be used.
     *
     * @property {(number|function|jqLite)} yOffset
     * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
     * positioned elements at the top of the page, such as navbars, headers etc.
     *
     * `yOffset` can be specified in various ways:
     * - **number**: A fixed number of pixels to be used as offset.<br /><br />
     * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
     *   a number representing the offset (in pixels).<br /><br />
     * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
     *   the top of the page to the element's bottom will be used as offset.<br />
     *   **Note**: The element will be taken into account only as long as its `position` is set to
     *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
     *   their height and/or positioning according to the viewport's size.
     *
     * <br />
     * <div class="alert alert-warning">
     * In order for `yOffset` to work properly, scrolling should take place on the document's root and
     * not some child element.
     * </div>
     *
     * @example
       <example module="anchorScrollExample" name="anchor-scroll">
         <file name="index.html">
           <div id="scrollArea" ng-controller="ScrollController">
             <a ng-click="gotoBottom()">Go to bottom</a>
             <a id="bottom"></a> You're at the bottom!
           </div>
         </file>
         <file name="script.js">
           angular.module('anchorScrollExample', [])
             .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
               function($scope, $location, $anchorScroll) {
                 $scope.gotoBottom = function() {
                   // set the location.hash to the id of
                   // the element you wish to scroll to.
                   $location.hash('bottom');
                    // call $anchorScroll()
                   $anchorScroll();
                 };
               }]);
         </file>
         <file name="style.css">
           #scrollArea {
             height: 280px;
             overflow: auto;
           }
            #bottom {
             display: block;
             margin-top: 2000px;
           }
         </file>
       </example>
     *
     * <hr />
     * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
     * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
     *
     * @example
       <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
         <file name="index.html">
           <div class="fixed-header" ng-controller="headerCtrl">
             <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
               Go to anchor {{x}}
             </a>
           </div>
           <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
             Anchor {{x}} of 5
           </div>
         </file>
         <file name="script.js">
           angular.module('anchorScrollOffsetExample', [])
             .run(['$anchorScroll', function($anchorScroll) {
               $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
             }])
             .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
               function($anchorScroll, $location, $scope) {
                 $scope.gotoAnchor = function(x) {
                   var newHash = 'anchor' + x;
                   if ($location.hash() !== newHash) {
                     // set the $location.hash to `newHash` and
                     // $anchorScroll will automatically scroll to it
                     $location.hash('anchor' + x);
                   } else {
                     // call $anchorScroll() explicitly,
                     // since $location.hash hasn't changed
                     $anchorScroll();
                   }
                 };
               }
             ]);
         </file>
         <file name="style.css">
           body {
             padding-top: 50px;
           }
            .anchor {
             border: 2px dashed DarkOrchid;
             padding: 10px 10px 200px 10px;
           }
            .fixed-header {
             background-color: rgba(0, 0, 0, 0.2);
             height: 50px;
             position: fixed;
             top: 0; left: 0; right: 0;
           }
            .fixed-header > a {
             display: inline-block;
             margin: 5px 15px;
           }
         </file>
       </example>
     */
    this.$get = ['$window', '$location', '$rootScope', function ($window, $location, $rootScope) {
      var document = $window.document;

      // Helper function to get first anchor from a NodeList
      // (using `Array#some()` instead of `angular#forEach()` since it's more performant
      //  and working in all supported browsers.)
      function getFirstAnchor(list) {
        var result = null;
        Array.prototype.some.call(list, function (element) {
          if (nodeName_(element) === 'a') {
            result = element;
            return true;
          }
        });
        return result;
      }

      function getYOffset() {

        var offset = scroll.yOffset;

        if (isFunction(offset)) {
          offset = offset();
        } else if (isElement(offset)) {
          var elem = offset[0];
          var style = $window.getComputedStyle(elem);
          if (style.position !== 'fixed') {
            offset = 0;
          } else {
            offset = elem.getBoundingClientRect().bottom;
          }
        } else if (!isNumber(offset)) {
          offset = 0;
        }

        return offset;
      }

      function scrollTo(elem) {
        if (elem) {
          elem.scrollIntoView();

          var offset = getYOffset();

          if (offset) {
            // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
            // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
            // top of the viewport.
            //
            // IF the number of pixels from the top of `elem` to the end of the page's content is less
            // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
            // way down the page.
            //
            // This is often the case for elements near the bottom of the page.
            //
            // In such cases we do not need to scroll the whole `offset` up, just the difference between
            // the top of the element and the offset, which is enough to align the top of `elem` at the
            // desired position.
            var elemTop = elem.getBoundingClientRect().top;
            $window.scrollBy(0, elemTop - offset);
          }
        } else {
          $window.scrollTo(0, 0);
        }
      }

      function scroll(hash) {
        // Allow numeric hashes
        hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
        var elm;

        // empty hash, scroll to the top of the page
        if (!hash) scrollTo(null);

        // element with given id
        else if (elm = document.getElementById(hash)) scrollTo(elm);

          // first anchor with given name :-D
          else if (elm = getFirstAnchor(document.getElementsByName(hash))) scrollTo(elm);

            // no element and hash === 'top', scroll to the top of the page
            else if (hash === 'top') scrollTo(null);
      }

      // does not scroll when user clicks on anchor link that is currently on
      // (no url change, no $location.hash() change), browser native does scroll
      if (autoScrollingEnabled) {
        $rootScope.$watch(function autoScrollWatch() {
          return $location.hash();
        }, function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;

          jqLiteDocumentLoaded(function () {
            $rootScope.$evalAsync(scroll);
          });
        });
      }

      return scroll;
    }];
  }

  var $animateMinErr = minErr('$animate');
  var ELEMENT_NODE = 1;
  var NG_ANIMATE_CLASSNAME = 'ng-animate';

  function mergeClasses(a, b) {
    if (!a && !b) return '';
    if (!a) return b;
    if (!b) return a;
    if (isArray(a)) a = a.join(' ');
    if (isArray(b)) b = b.join(' ');
    return a + ' ' + b;
  }

  function extractElementNode(element) {
    for (var i = 0; i < element.length; i++) {
      var elm = element[i];
      if (elm.nodeType === ELEMENT_NODE) {
        return elm;
      }
    }
  }

  function splitClasses(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    // Use createMap() to prevent class assumptions involving property names in
    // Object.prototype
    var obj = createMap();
    forEach(classes, function (klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  // if any other type of options value besides an Object value is
  // passed into the $animate.method() animation then this helper code
  // will be run which will ignore it. While this patch is not the
  // greatest solution to this, a lot of existing plugins depend on
  // $animate to either call the callback (< 1.2) or return a promise
  // that can be changed. This helper function ensures that the options
  // are wiped clean incase a callback function is provided.
  function prepareAnimateOptions(options) {
    return isObject(options) ? options : {};
  }

  var $$CoreAnimateJsProvider = /** @this */function $$CoreAnimateJsProvider() {
    this.$get = noop;
  };

  // this is prefixed with Core since it conflicts with
  // the animateQueueProvider defined in ngAnimate/animateQueue.js
  var $$CoreAnimateQueueProvider = /** @this */function $$CoreAnimateQueueProvider() {
    var postDigestQueue = new NgMap();
    var postDigestElements = [];

    this.$get = ['$$AnimateRunner', '$rootScope', function ($$AnimateRunner, $rootScope) {
      return {
        enabled: noop,
        on: noop,
        off: noop,
        pin: noop,

        push: function push(element, event, options, domOperation) {
          if (domOperation) {
            domOperation();
          }

          options = options || {};
          if (options.from) {
            element.css(options.from);
          }
          if (options.to) {
            element.css(options.to);
          }

          if (options.addClass || options.removeClass) {
            addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
          }

          var runner = new $$AnimateRunner();

          // since there are no animations to run the runner needs to be
          // notified that the animation call is complete.
          runner.complete();
          return runner;
        }
      };

      function updateData(data, classes, value) {
        var changed = false;
        if (classes) {
          classes = isString(classes) ? classes.split(' ') : isArray(classes) ? classes : [];
          forEach(classes, function (className) {
            if (className) {
              changed = true;
              data[className] = value;
            }
          });
        }
        return changed;
      }

      function handleCSSClassChanges() {
        forEach(postDigestElements, function (element) {
          var data = postDigestQueue.get(element);
          if (data) {
            var existing = splitClasses(element.attr('class'));
            var toAdd = '';
            var toRemove = '';
            forEach(data, function (status, className) {
              var hasClass = !!existing[className];
              if (status !== hasClass) {
                if (status) {
                  toAdd += (toAdd.length ? ' ' : '') + className;
                } else {
                  toRemove += (toRemove.length ? ' ' : '') + className;
                }
              }
            });

            forEach(element, function (elm) {
              if (toAdd) {
                jqLiteAddClass(elm, toAdd);
              }
              if (toRemove) {
                jqLiteRemoveClass(elm, toRemove);
              }
            });
            postDigestQueue.delete(element);
          }
        });
        postDigestElements.length = 0;
      }

      function addRemoveClassesPostDigest(element, add, remove) {
        var data = postDigestQueue.get(element) || {};

        var classesAdded = updateData(data, add, true);
        var classesRemoved = updateData(data, remove, false);

        if (classesAdded || classesRemoved) {

          postDigestQueue.set(element, data);
          postDigestElements.push(element);

          if (postDigestElements.length === 1) {
            $rootScope.$$postDigest(handleCSSClassChanges);
          }
        }
      }
    }];
  };

  /**
   * @ngdoc provider
   * @name $animateProvider
   *
   * @description
   * Default implementation of $animate that doesn't perform any animations, instead just
   * synchronously performs DOM updates and resolves the returned runner promise.
   *
   * In order to enable animations the `ngAnimate` module has to be loaded.
   *
   * To see the functional implementation check out `src/ngAnimate/animate.js`.
   */
  var $AnimateProvider = ['$provide', /** @this */function ($provide) {
    var provider = this;
    var classNameFilter = null;
    var customFilter = null;

    this.$$registeredAnimations = Object.create(null);

    /**
    * @ngdoc method
    * @name $animateProvider#register
    *
    * @description
    * Registers a new injectable animation factory function. The factory function produces the
    * animation object which contains callback functions for each event that is expected to be
    * animated.
    *
    *   * `eventFn`: `function(element, ... , doneFunction, options)`
    *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
    *   on the type of animation additional arguments will be injected into the animation function. The
    *   list below explains the function signatures for the different animation methods:
    *
    *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
    *   - addClass: function(element, addedClasses, doneFunction, options)
    *   - removeClass: function(element, removedClasses, doneFunction, options)
    *   - enter, leave, move: function(element, doneFunction, options)
    *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
    *
    *   Make sure to trigger the `doneFunction` once the animation is fully complete.
    *
    * ```js
    *   return {
    *     //enter, leave, move signature
    *     eventFn : function(element, done, options) {
    *       //code to run the animation
    *       //once complete, then run done()
    *       return function endFunction(wasCancelled) {
    *         //code to cancel the animation
    *       }
    *     }
    *   }
    * ```
    *
    * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
    * @param {Function} factory The factory function that will be executed to return the animation
    *                           object.
    */
    this.register = function (name, factory) {
      if (name && name.charAt(0) !== '.') {
        throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
      }

      var key = name + '-animation';
      provider.$$registeredAnimations[name.substr(1)] = key;
      $provide.factory(key, factory);
    };

    /**
     * @ngdoc method
     * @name $animateProvider#customFilter
     *
     * @description
     * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
     * determine if an animation is allowed or not. When no filter is specified (the default), no
     * animation will be blocked. Setting the `customFilter` value will only allow animations for
     * which the filter function's return value is truthy.
     *
     * This allows to easily create arbitrarily complex rules for filtering animations, such as
     * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
     * Filtering animations can also boost performance for low-powered devices, as well as
     * applications containing a lot of structural operations.
     *
     * <div class="alert alert-success">
     *   **Best Practice:**
     *   Keep the filtering function as lean as possible, because it will be called for each DOM
     *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
     *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
     *   directives that support animations.
     *   Performing computationally expensive or time-consuming operations on each call of the
     *   filtering function can make your animations sluggish.
     * </div>
     *
     * **Note:** If present, `customFilter` will be checked before
     * {@link $animateProvider#classNameFilter classNameFilter}.
     *
     * @param {Function=} filterFn - The filter function which will be used to filter all animations.
     *   If a falsy value is returned, no animation will be performed. The function will be called
     *   with the following arguments:
     *   - **node** `{DOMElement}` - The DOM element to be animated.
     *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
     *     etc).
     *   - **options** `{Object}` - A collection of options/styles used for the animation.
     * @return {Function} The current filter function or `null` if there is none set.
     */
    this.customFilter = function (filterFn) {
      if (arguments.length === 1) {
        customFilter = isFunction(filterFn) ? filterFn : null;
      }

      return customFilter;
    };

    /**
     * @ngdoc method
     * @name $animateProvider#classNameFilter
     *
     * @description
     * Sets and/or returns the CSS class regular expression that is checked when performing
     * an animation. Upon bootstrap the classNameFilter value is not set at all and will
     * therefore enable $animate to attempt to perform an animation on any element that is triggered.
     * When setting the `classNameFilter` value, animations will only be performed on elements
     * that successfully match the filter expression. This in turn can boost performance
     * for low-powered devices as well as applications containing a lot of structural operations.
     *
     * **Note:** If present, `classNameFilter` will be checked after
     * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
     * false, `classNameFilter` will not be checked.
     *
     * @param {RegExp=} expression The className expression which will be checked against all animations
     * @return {RegExp} The current CSS className expression value. If null then there is no expression value
     */
    this.classNameFilter = function (expression) {
      if (arguments.length === 1) {
        classNameFilter = expression instanceof RegExp ? expression : null;
        if (classNameFilter) {
          var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
          if (reservedRegex.test(classNameFilter.toString())) {
            classNameFilter = null;
            throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
          }
        }
      }
      return classNameFilter;
    };

    this.$get = ['$$animateQueue', function ($$animateQueue) {
      function domInsert(element, parentElement, afterElement) {
        // if for some reason the previous element was removed
        // from the dom sometime before this code runs then let's
        // just stick to using the parent element as the anchor
        if (afterElement) {
          var afterNode = extractElementNode(afterElement);
          if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
            afterElement = null;
          }
        }
        if (afterElement) {
          afterElement.after(element);
        } else {
          parentElement.prepend(element);
        }
      }

      /**
       * @ngdoc service
       * @name $animate
       * @description The $animate service exposes a series of DOM utility methods that provide support
       * for animation hooks. The default behavior is the application of DOM operations, however,
       * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
       * to ensure that animation runs with the triggered DOM operation.
       *
       * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
       * included and only when it is active then the animation hooks that `$animate` triggers will be
       * functional. Once active then all structural `ng-` directives will trigger animations as they perform
       * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
       * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
       *
       * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
       *
       * To learn more about enabling animation support, click here to visit the
       * {@link ngAnimate ngAnimate module page}.
       */
      return {
        // we don't call it directly since non-existant arguments may
        // be interpreted as null within the sub enabled function

        /**
         *
         * @ngdoc method
         * @name $animate#on
         * @kind function
         * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
         *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
         *    is fired with the following params:
         *
         * ```js
         * $animate.on('enter', container,
         *    function callback(element, phase) {
         *      // cool we detected an enter animation within the container
         *    }
         * );
         * ```
         *
         * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
         * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
         *     as well as among its children
         * @param {Function} callback the callback function that will be fired when the listener is triggered
         *
         * The arguments present in the callback function are:
         * * `element` - The captured DOM element that the animation was fired on.
         * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
         */
        on: $$animateQueue.on,

        /**
         *
         * @ngdoc method
         * @name $animate#off
         * @kind function
         * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
         * can be used in three different ways depending on the arguments:
         *
         * ```js
         * // remove all the animation event listeners listening for `enter`
         * $animate.off('enter');
         *
         * // remove listeners for all animation events from the container element
         * $animate.off(container);
         *
         * // remove all the animation event listeners listening for `enter` on the given element and its children
         * $animate.off('enter', container);
         *
         * // remove the event listener function provided by `callback` that is set
         * // to listen for `enter` on the given `container` as well as its children
         * $animate.off('enter', container, callback);
         * ```
         *
         * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
         * addClass, removeClass, etc...), or the container element. If it is the element, all other
         * arguments are ignored.
         * @param {DOMElement=} container the container element the event listener was placed on
         * @param {Function=} callback the callback function that was registered as the listener
         */
        off: $$animateQueue.off,

        /**
         * @ngdoc method
         * @name $animate#pin
         * @kind function
         * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
         *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
         *    element despite being outside the realm of the application or within another application. Say for example if the application
         *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
         *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
         *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
         *
         *    Note that this feature is only active when the `ngAnimate` module is used.
         *
         * @param {DOMElement} element the external element that will be pinned
         * @param {DOMElement} parentElement the host parent element that will be associated with the external element
         */
        pin: $$animateQueue.pin,

        /**
         *
         * @ngdoc method
         * @name $animate#enabled
         * @kind function
         * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
         * function can be called in four ways:
         *
         * ```js
         * // returns true or false
         * $animate.enabled();
         *
         * // changes the enabled state for all animations
         * $animate.enabled(false);
         * $animate.enabled(true);
         *
         * // returns true or false if animations are enabled for an element
         * $animate.enabled(element);
         *
         * // changes the enabled state for an element and its children
         * $animate.enabled(element, true);
         * $animate.enabled(element, false);
         * ```
         *
         * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
         * @param {boolean=} enabled whether or not the animations will be enabled for the element
         *
         * @return {boolean} whether or not animations are enabled
         */
        enabled: $$animateQueue.enabled,

        /**
         * @ngdoc method
         * @name $animate#cancel
         * @kind function
         * @description Cancels the provided animation.
         *
         * @param {Promise} animationPromise The animation promise that is returned when an animation is started.
         */
        cancel: function cancel(runner) {
          if (runner.end) {
            runner.end();
          }
        },

        /**
         *
         * @ngdoc method
         * @name $animate#enter
         * @kind function
         * @description Inserts the element into the DOM either after the `after` element (if provided) or
         *   as the first child within the `parent` element and then triggers an animation.
         *   A promise is returned that will be resolved during the next digest once the animation
         *   has completed.
         *
         * @param {DOMElement} element the element which will be inserted into the DOM
         * @param {DOMElement} parent the parent element which will append the element as
         *   a child (so long as the after element is not present)
         * @param {DOMElement=} after the sibling element after which the element will be appended
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Promise} the animation callback promise
         */
        enter: function enter(element, parent, after, options) {
          parent = parent && jqLite(parent);
          after = after && jqLite(after);
          parent = parent || after.parent();
          domInsert(element, parent, after);
          return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
        },

        /**
         *
         * @ngdoc method
         * @name $animate#move
         * @kind function
         * @description Inserts (moves) the element into its new position in the DOM either after
         *   the `after` element (if provided) or as the first child within the `parent` element
         *   and then triggers an animation. A promise is returned that will be resolved
         *   during the next digest once the animation has completed.
         *
         * @param {DOMElement} element the element which will be moved into the new DOM position
         * @param {DOMElement} parent the parent element which will append the element as
         *   a child (so long as the after element is not present)
         * @param {DOMElement=} after the sibling element after which the element will be appended
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Promise} the animation callback promise
         */
        move: function move(element, parent, after, options) {
          parent = parent && jqLite(parent);
          after = after && jqLite(after);
          parent = parent || after.parent();
          domInsert(element, parent, after);
          return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
        },

        /**
         * @ngdoc method
         * @name $animate#leave
         * @kind function
         * @description Triggers an animation and then removes the element from the DOM.
         * When the function is called a promise is returned that will be resolved during the next
         * digest once the animation has completed.
         *
         * @param {DOMElement} element the element which will be removed from the DOM
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Promise} the animation callback promise
         */
        leave: function leave(element, options) {
          return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function () {
            element.remove();
          });
        },

        /**
         * @ngdoc method
         * @name $animate#addClass
         * @kind function
         *
         * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
         *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
         *   animation if element already contains the CSS class or if the class is removed at a later step.
         *   Note that class-based animations are treated differently compared to structural animations
         *   (like enter, move and leave) since the CSS classes may be added/removed at different points
         *   depending if CSS or JavaScript animations are used.
         *
         * @param {DOMElement} element the element which the CSS classes will be applied to
         * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Promise} the animation callback promise
         */
        addClass: function addClass(element, className, options) {
          options = prepareAnimateOptions(options);
          options.addClass = mergeClasses(options.addclass, className);
          return $$animateQueue.push(element, 'addClass', options);
        },

        /**
         * @ngdoc method
         * @name $animate#removeClass
         * @kind function
         *
         * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
         *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
         *   animation if element does not contain the CSS class or if the class is added at a later step.
         *   Note that class-based animations are treated differently compared to structural animations
         *   (like enter, move and leave) since the CSS classes may be added/removed at different points
         *   depending if CSS or JavaScript animations are used.
         *
         * @param {DOMElement} element the element which the CSS classes will be applied to
         * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Promise} the animation callback promise
         */
        removeClass: function removeClass(element, className, options) {
          options = prepareAnimateOptions(options);
          options.removeClass = mergeClasses(options.removeClass, className);
          return $$animateQueue.push(element, 'removeClass', options);
        },

        /**
         * @ngdoc method
         * @name $animate#setClass
         * @kind function
         *
         * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
         *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
         *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
         *    passed. Note that class-based animations are treated differently compared to structural animations
         *    (like enter, move and leave) since the CSS classes may be added/removed at different points
         *    depending if CSS or JavaScript animations are used.
         *
         * @param {DOMElement} element the element which the CSS classes will be applied to
         * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
         * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Promise} the animation callback promise
         */
        setClass: function setClass(element, add, remove, options) {
          options = prepareAnimateOptions(options);
          options.addClass = mergeClasses(options.addClass, add);
          options.removeClass = mergeClasses(options.removeClass, remove);
          return $$animateQueue.push(element, 'setClass', options);
        },

        /**
         * @ngdoc method
         * @name $animate#animate
         * @kind function
         *
         * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
         * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
         * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
         * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
         * style in `to`, the style in `from` is applied immediately, and no animation is run.
         * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
         * method (or as part of the `options` parameter):
         *
         * ```js
         * ngModule.animation('.my-inline-animation', function() {
         *   return {
         *     animate : function(element, from, to, done, options) {
         *       //animation
         *       done();
         *     }
         *   }
         * });
         * ```
         *
         * @param {DOMElement} element the element which the CSS styles will be applied to
         * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
         * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
         * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
         *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
         *    (Note that if no animation is detected then this value will not be applied to the element.)
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Promise} the animation callback promise
         */
        animate: function animate(element, from, to, className, options) {
          options = prepareAnimateOptions(options);
          options.from = options.from ? extend(options.from, from) : from;
          options.to = options.to ? extend(options.to, to) : to;

          className = className || 'ng-inline-animate';
          options.tempClasses = mergeClasses(options.tempClasses, className);
          return $$animateQueue.push(element, 'animate', options);
        }
      };
    }];
  }];

  var $$AnimateAsyncRunFactoryProvider = /** @this */function $$AnimateAsyncRunFactoryProvider() {
    this.$get = ['$$rAF', function ($$rAF) {
      var waitQueue = [];

      function waitForTick(fn) {
        waitQueue.push(fn);
        if (waitQueue.length > 1) return;
        $$rAF(function () {
          for (var i = 0; i < waitQueue.length; i++) {
            waitQueue[i]();
          }
          waitQueue = [];
        });
      }

      return function () {
        var passed = false;
        waitForTick(function () {
          passed = true;
        });
        return function (callback) {
          if (passed) {
            callback();
          } else {
            waitForTick(callback);
          }
        };
      };
    }];
  };

  var $$AnimateRunnerFactoryProvider = /** @this */function $$AnimateRunnerFactoryProvider() {
    this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout', function ($q, $sniffer, $$animateAsyncRun, $$isDocumentHidden, $timeout) {

      var INITIAL_STATE = 0;
      var DONE_PENDING_STATE = 1;
      var DONE_COMPLETE_STATE = 2;

      AnimateRunner.chain = function (chain, callback) {
        var index = 0;

        next();
        function next() {
          if (index === chain.length) {
            callback(true);
            return;
          }

          chain[index](function (response) {
            if (response === false) {
              callback(false);
              return;
            }
            index++;
            next();
          });
        }
      };

      AnimateRunner.all = function (runners, callback) {
        var count = 0;
        var status = true;
        forEach(runners, function (runner) {
          runner.done(onProgress);
        });

        function onProgress(response) {
          status = status && response;
          if (++count === runners.length) {
            callback(status);
          }
        }
      };

      function AnimateRunner(host) {
        this.setHost(host);

        var rafTick = $$animateAsyncRun();
        var timeoutTick = function timeoutTick(fn) {
          $timeout(fn, 0, false);
        };

        this._doneCallbacks = [];
        this._tick = function (fn) {
          if ($$isDocumentHidden()) {
            timeoutTick(fn);
          } else {
            rafTick(fn);
          }
        };
        this._state = 0;
      }

      AnimateRunner.prototype = {
        setHost: function setHost(host) {
          this.host = host || {};
        },

        done: function done(fn) {
          if (this._state === DONE_COMPLETE_STATE) {
            fn();
          } else {
            this._doneCallbacks.push(fn);
          }
        },

        progress: noop,

        getPromise: function getPromise() {
          if (!this.promise) {
            var self = this;
            this.promise = $q(function (resolve, reject) {
              self.done(function (status) {
                if (status === false) {
                  reject();
                } else {
                  resolve();
                }
              });
            });
          }
          return this.promise;
        },

        then: function then(resolveHandler, rejectHandler) {
          return this.getPromise().then(resolveHandler, rejectHandler);
        },

        'catch': function _catch(handler) {
          return this.getPromise()['catch'](handler);
        },

        'finally': function _finally(handler) {
          return this.getPromise()['finally'](handler);
        },

        pause: function pause() {
          if (this.host.pause) {
            this.host.pause();
          }
        },

        resume: function resume() {
          if (this.host.resume) {
            this.host.resume();
          }
        },

        end: function end() {
          if (this.host.end) {
            this.host.end();
          }
          this._resolve(true);
        },

        cancel: function cancel() {
          if (this.host.cancel) {
            this.host.cancel();
          }
          this._resolve(false);
        },

        complete: function complete(response) {
          var self = this;
          if (self._state === INITIAL_STATE) {
            self._state = DONE_PENDING_STATE;
            self._tick(function () {
              self._resolve(response);
            });
          }
        },

        _resolve: function _resolve(response) {
          if (this._state !== DONE_COMPLETE_STATE) {
            forEach(this._doneCallbacks, function (fn) {
              fn(response);
            });
            this._doneCallbacks.length = 0;
            this._state = DONE_COMPLETE_STATE;
          }
        }
      };

      return AnimateRunner;
    }];
  };

  /* exported $CoreAnimateCssProvider */

  /**
   * @ngdoc service
   * @name $animateCss
   * @kind object
   * @this
   *
   * @description
   * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
   * then the `$animateCss` service will actually perform animations.
   *
   * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
   */
  var $CoreAnimateCssProvider = function $CoreAnimateCssProvider() {
    this.$get = ['$$rAF', '$q', '$$AnimateRunner', function ($$rAF, $q, $$AnimateRunner) {

      return function (element, initialOptions) {
        // all of the animation functions should create
        // a copy of the options data, however, if a
        // parent service has already created a copy then
        // we should stick to using that
        var options = initialOptions || {};
        if (!options.$$prepared) {
          options = copy(options);
        }

        // there is no point in applying the styles since
        // there is no animation that goes on at all in
        // this version of $animateCss.
        if (options.cleanupStyles) {
          options.from = options.to = null;
        }

        if (options.from) {
          element.css(options.from);
          options.from = null;
        }

        var closed,
            runner = new $$AnimateRunner();
        return {
          start: run,
          end: run
        };

        function run() {
          $$rAF(function () {
            applyAnimationContents();
            if (!closed) {
              runner.complete();
            }
            closed = true;
          });
          return runner;
        }

        function applyAnimationContents() {
          if (options.addClass) {
            element.addClass(options.addClass);
            options.addClass = null;
          }
          if (options.removeClass) {
            element.removeClass(options.removeClass);
            options.removeClass = null;
          }
          if (options.to) {
            element.css(options.to);
            options.to = null;
          }
        }
      };
    }];
  };

  /* global stripHash: true */

  /**
   * ! This is a private undocumented service !
   *
   * @name $browser
   * @requires $log
   * @description
   * This object has two goals:
   *
   * - hide all the global state in the browser caused by the window object
   * - abstract away all the browser specific features and inconsistencies
   *
   * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
   * service, which can be used for convenient testing of the application without the interaction with
   * the real browser apis.
   */
  /**
   * @param {object} window The global window object.
   * @param {object} document jQuery wrapped document.
   * @param {object} $log window.console or an object with the same interface.
   * @param {object} $sniffer $sniffer service
   */
  function Browser(window, document, $log, $sniffer) {
    var self = this,
        location = window.location,
        history = window.history,
        setTimeout = window.setTimeout,
        clearTimeout = window.clearTimeout,
        pendingDeferIds = {};

    self.isMock = false;

    var outstandingRequestCount = 0;
    var outstandingRequestCallbacks = [];

    // TODO(vojta): remove this temporary api
    self.$$completeOutstandingRequest = completeOutstandingRequest;
    self.$$incOutstandingRequestCount = function () {
      outstandingRequestCount++;
    };

    /**
     * Executes the `fn` function(supports currying) and decrements the `outstandingRequestCallbacks`
     * counter. If the counter reaches 0, all the `outstandingRequestCallbacks` are executed.
     */
    function completeOutstandingRequest(fn) {
      try {
        fn.apply(null, sliceArgs(arguments, 1));
      } finally {
        outstandingRequestCount--;
        if (outstandingRequestCount === 0) {
          while (outstandingRequestCallbacks.length) {
            try {
              outstandingRequestCallbacks.pop()();
            } catch (e) {
              $log.error(e);
            }
          }
        }
      }
    }

    function getHash(url) {
      var index = url.indexOf('#');
      return index === -1 ? '' : url.substr(index);
    }

    /**
     * @private
     * TODO(vojta): prefix this method with $$ ?
     * @param {function()} callback Function that will be called when no outstanding request
     */
    self.notifyWhenNoOutstandingRequests = function (callback) {
      if (outstandingRequestCount === 0) {
        callback();
      } else {
        outstandingRequestCallbacks.push(callback);
      }
    };

    //////////////////////////////////////////////////////////////
    // URL API
    //////////////////////////////////////////////////////////////

    var cachedState,
        lastHistoryState,
        lastBrowserUrl = location.href,
        baseElement = document.find('base'),
        pendingLocation = null,
        getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
      try {
        return history.state;
      } catch (e) {
        // MSIE can reportedly throw when there is no state (UNCONFIRMED).
      }
    };

    cacheState();

    /**
     * @name $browser#url
     *
     * @description
     * GETTER:
     * Without any argument, this method just returns current value of location.href.
     *
     * SETTER:
     * With at least one argument, this method sets url to new value.
     * If html5 history api supported, pushState/replaceState is used, otherwise
     * location.href/location.replace is used.
     * Returns its own instance to allow chaining
     *
     * NOTE: this api is intended for use only by the $location service. Please use the
     * {@link ng.$location $location service} to change url.
     *
     * @param {string} url New url (when used as setter)
     * @param {boolean=} replace Should new url replace current history record?
     * @param {object=} state object to use with pushState/replaceState
     */
    self.url = function (url, replace, state) {
      // In modern browsers `history.state` is `null` by default; treating it separately
      // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
      // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
      if (isUndefined(state)) {
        state = null;
      }

      // Android Browser BFCache causes location, history reference to become stale.
      if (location !== window.location) location = window.location;
      if (history !== window.history) history = window.history;

      // setter
      if (url) {
        var sameState = lastHistoryState === state;

        // Don't change anything if previous and current URLs and states match. This also prevents
        // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
        // See https://github.com/angular/angular.js/commit/ffb2701
        if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
          return self;
        }
        var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
        lastBrowserUrl = url;
        lastHistoryState = state;
        // Don't use history API if only the hash changed
        // due to a bug in IE10/IE11 which leads
        // to not firing a `hashchange` nor `popstate` event
        // in some cases (see #9143).
        if ($sniffer.history && (!sameBase || !sameState)) {
          history[replace ? 'replaceState' : 'pushState'](state, '', url);
          cacheState();
        } else {
          if (!sameBase) {
            pendingLocation = url;
          }
          if (replace) {
            location.replace(url);
          } else if (!sameBase) {
            location.href = url;
          } else {
            location.hash = getHash(url);
          }
          if (location.href !== url) {
            pendingLocation = url;
          }
        }
        if (pendingLocation) {
          pendingLocation = url;
        }
        return self;
        // getter
      } else {
        // - pendingLocation is needed as browsers don't allow to read out
        //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
        //   https://openradar.appspot.com/22186109).
        // - the replacement is a workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=407172
        return pendingLocation || location.href.replace(/%27/g, '\'');
      }
    };

    /**
     * @name $browser#state
     *
     * @description
     * This method is a getter.
     *
     * Return history.state or null if history.state is undefined.
     *
     * @returns {object} state
     */
    self.state = function () {
      return cachedState;
    };

    var urlChangeListeners = [],
        urlChangeInit = false;

    function cacheStateAndFireUrlChange() {
      pendingLocation = null;
      fireStateOrUrlChange();
    }

    // This variable should be used *only* inside the cacheState function.
    var lastCachedState = null;
    function cacheState() {
      // This should be the only place in $browser where `history.state` is read.
      cachedState = getCurrentState();
      cachedState = isUndefined(cachedState) ? null : cachedState;

      // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
      if (equals(cachedState, lastCachedState)) {
        cachedState = lastCachedState;
      }

      lastCachedState = cachedState;
      lastHistoryState = cachedState;
    }

    function fireStateOrUrlChange() {
      var prevLastHistoryState = lastHistoryState;
      cacheState();

      if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
        return;
      }

      lastBrowserUrl = self.url();
      lastHistoryState = cachedState;
      forEach(urlChangeListeners, function (listener) {
        listener(self.url(), cachedState);
      });
    }

    /**
     * @name $browser#onUrlChange
     *
     * @description
     * Register callback function that will be called, when url changes.
     *
     * It's only called when the url is changed from outside of AngularJS:
     * - user types different url into address bar
     * - user clicks on history (forward/back) button
     * - user clicks on a link
     *
     * It's not called when url is changed by $browser.url() method
     *
     * The listener gets called with new url as parameter.
     *
     * NOTE: this api is intended for use only by the $location service. Please use the
     * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
     *
     * @param {function(string)} listener Listener function to be called when url changes.
     * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
     */
    self.onUrlChange = function (callback) {
      // TODO(vojta): refactor to use node's syntax for events
      if (!urlChangeInit) {
        // We listen on both (hashchange/popstate) when available, as some browsers don't
        // fire popstate when user changes the address bar and don't fire hashchange when url
        // changed by push/replaceState

        // html5 history api - popstate event
        if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
        // hashchange event
        jqLite(window).on('hashchange', cacheStateAndFireUrlChange);

        urlChangeInit = true;
      }

      urlChangeListeners.push(callback);
      return callback;
    };

    /**
     * @private
     * Remove popstate and hashchange handler from window.
     *
     * NOTE: this api is intended for use only by $rootScope.
     */
    self.$$applicationDestroyed = function () {
      jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
    };

    /**
     * Checks whether the url has changed outside of AngularJS.
     * Needs to be exported to be able to check for changes that have been done in sync,
     * as hashchange/popstate events fire in async.
     */
    self.$$checkUrlChange = fireStateOrUrlChange;

    //////////////////////////////////////////////////////////////
    // Misc API
    //////////////////////////////////////////////////////////////

    /**
     * @name $browser#baseHref
     *
     * @description
     * Returns current <base href>
     * (always relative - without domain)
     *
     * @returns {string} The current base href
     */
    self.baseHref = function () {
      var href = baseElement.attr('href');
      return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
    };

    /**
     * @name $browser#defer
     * @param {function()} fn A function, who's execution should be deferred.
     * @param {number=} [delay=0] of milliseconds to defer the function execution.
     * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
     *
     * @description
     * Executes a fn asynchronously via `setTimeout(fn, delay)`.
     *
     * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
     * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
     * via `$browser.defer.flush()`.
     *
     */
    self.defer = function (fn, delay) {
      var timeoutId;
      outstandingRequestCount++;
      timeoutId = setTimeout(function () {
        delete pendingDeferIds[timeoutId];
        completeOutstandingRequest(fn);
      }, delay || 0);
      pendingDeferIds[timeoutId] = true;
      return timeoutId;
    };

    /**
     * @name $browser#defer.cancel
     *
     * @description
     * Cancels a deferred task identified with `deferId`.
     *
     * @param {*} deferId Token returned by the `$browser.defer` function.
     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
     *                    canceled.
     */
    self.defer.cancel = function (deferId) {
      if (pendingDeferIds[deferId]) {
        delete pendingDeferIds[deferId];
        clearTimeout(deferId);
        completeOutstandingRequest(noop);
        return true;
      }
      return false;
    };
  }

  /** @this */
  function $BrowserProvider() {
    this.$get = ['$window', '$log', '$sniffer', '$document', function ($window, $log, $sniffer, $document) {
      return new Browser($window, $document, $log, $sniffer);
    }];
  }

  /**
   * @ngdoc service
   * @name $cacheFactory
   * @this
   *
   * @description
   * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
   * them.
   *
   * ```js
   *
   *  var cache = $cacheFactory('cacheId');
   *  expect($cacheFactory.get('cacheId')).toBe(cache);
   *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
   *
   *  cache.put("key", "value");
   *  cache.put("another key", "another value");
   *
   *  // We've specified no options on creation
   *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
   *
   * ```
   *
   *
   * @param {string} cacheId Name or id of the newly created cache.
   * @param {object=} options Options object that specifies the cache behavior. Properties:
   *
   *   - `{number=}` `capacity` — turns the cache into LRU cache.
   *
   * @returns {object} Newly created cache object with the following set of methods:
   *
   * - `{object}` `info()` — Returns id, size, and options of cache.
   * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
   *   it.
   * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
   * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
   * - `{void}` `removeAll()` — Removes all cached values.
   * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
   *
   * @example
     <example module="cacheExampleApp" name="cache-factory">
       <file name="index.html">
         <div ng-controller="CacheController">
           <input ng-model="newCacheKey" placeholder="Key">
           <input ng-model="newCacheValue" placeholder="Value">
           <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
  
           <p ng-if="keys.length">Cached Values</p>
           <div ng-repeat="key in keys">
             <span ng-bind="key"></span>
             <span>: </span>
             <b ng-bind="cache.get(key)"></b>
           </div>
  
           <p>Cache Info</p>
           <div ng-repeat="(key, value) in cache.info()">
             <span ng-bind="key"></span>
             <span>: </span>
             <b ng-bind="value"></b>
           </div>
         </div>
       </file>
       <file name="script.js">
         angular.module('cacheExampleApp', []).
           controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
             $scope.keys = [];
             $scope.cache = $cacheFactory('cacheId');
             $scope.put = function(key, value) {
               if (angular.isUndefined($scope.cache.get(key))) {
                 $scope.keys.push(key);
               }
               $scope.cache.put(key, angular.isUndefined(value) ? null : value);
             };
           }]);
       </file>
       <file name="style.css">
         p {
           margin: 10px 0 3px;
         }
       </file>
     </example>
   */
  function $CacheFactoryProvider() {

    this.$get = function () {
      var caches = {};

      function cacheFactory(cacheId, options) {
        if (cacheId in caches) {
          throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
        }

        var size = 0,
            stats = extend({}, options, { id: cacheId }),
            data = createMap(),
            capacity = options && options.capacity || Number.MAX_VALUE,
            lruHash = createMap(),
            freshEnd = null,
            staleEnd = null;

        /**
         * @ngdoc type
         * @name $cacheFactory.Cache
         *
         * @description
         * A cache object used to store and retrieve data, primarily used by
         * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
         * directive to cache templates and other data.
         *
         * ```js
         *  angular.module('superCache')
         *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
         *      return $cacheFactory('super-cache');
         *    }]);
         * ```
         *
         * Example test:
         *
         * ```js
         *  it('should behave like a cache', inject(function(superCache) {
         *    superCache.put('key', 'value');
         *    superCache.put('another key', 'another value');
         *
         *    expect(superCache.info()).toEqual({
         *      id: 'super-cache',
         *      size: 2
         *    });
         *
         *    superCache.remove('another key');
         *    expect(superCache.get('another key')).toBeUndefined();
         *
         *    superCache.removeAll();
         *    expect(superCache.info()).toEqual({
         *      id: 'super-cache',
         *      size: 0
         *    });
         *  }));
         * ```
         */
        return caches[cacheId] = {

          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#put
           * @kind function
           *
           * @description
           * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
           * retrieved later, and incrementing the size of the cache if the key was not already
           * present in the cache. If behaving like an LRU cache, it will also remove stale
           * entries from the set.
           *
           * It will not insert undefined values into the cache.
           *
           * @param {string} key the key under which the cached data is stored.
           * @param {*} value the value to store alongside the key. If it is undefined, the key
           *    will not be stored.
           * @returns {*} the value stored.
           */
          put: function put(key, value) {
            if (isUndefined(value)) return;
            if (capacity < Number.MAX_VALUE) {
              var lruEntry = lruHash[key] || (lruHash[key] = { key: key });

              refresh(lruEntry);
            }

            if (!(key in data)) size++;
            data[key] = value;

            if (size > capacity) {
              this.remove(staleEnd.key);
            }

            return value;
          },

          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#get
           * @kind function
           *
           * @description
           * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
           *
           * @param {string} key the key of the data to be retrieved
           * @returns {*} the value stored.
           */
          get: function get(key) {
            if (capacity < Number.MAX_VALUE) {
              var lruEntry = lruHash[key];

              if (!lruEntry) return;

              refresh(lruEntry);
            }

            return data[key];
          },

          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#remove
           * @kind function
           *
           * @description
           * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
           *
           * @param {string} key the key of the entry to be removed
           */
          remove: function remove(key) {
            if (capacity < Number.MAX_VALUE) {
              var lruEntry = lruHash[key];

              if (!lruEntry) return;

              if (lruEntry === freshEnd) freshEnd = lruEntry.p;
              if (lruEntry === staleEnd) staleEnd = lruEntry.n;
              link(lruEntry.n, lruEntry.p);

              delete lruHash[key];
            }

            if (!(key in data)) return;

            delete data[key];
            size--;
          },

          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#removeAll
           * @kind function
           *
           * @description
           * Clears the cache object of any entries.
           */
          removeAll: function removeAll() {
            data = createMap();
            size = 0;
            lruHash = createMap();
            freshEnd = staleEnd = null;
          },

          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#destroy
           * @kind function
           *
           * @description
           * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
           * removing it from the {@link $cacheFactory $cacheFactory} set.
           */
          destroy: function destroy() {
            data = null;
            stats = null;
            lruHash = null;
            delete caches[cacheId];
          },

          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#info
           * @kind function
           *
           * @description
           * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
           *
           * @returns {object} an object with the following properties:
           *   <ul>
           *     <li>**id**: the id of the cache instance</li>
           *     <li>**size**: the number of entries kept in the cache instance</li>
           *     <li>**...**: any additional properties from the options object when creating the
           *       cache.</li>
           *   </ul>
           */
          info: function info() {
            return extend({}, stats, { size: size });
          }
        };

        /**
         * makes the `entry` the freshEnd of the LRU linked list
         */
        function refresh(entry) {
          if (entry !== freshEnd) {
            if (!staleEnd) {
              staleEnd = entry;
            } else if (staleEnd === entry) {
              staleEnd = entry.n;
            }

            link(entry.n, entry.p);
            link(entry, freshEnd);
            freshEnd = entry;
            freshEnd.n = null;
          }
        }

        /**
         * bidirectionally links two entries of the LRU linked list
         */
        function link(nextEntry, prevEntry) {
          if (nextEntry !== prevEntry) {
            if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
            if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
          }
        }
      }

      /**
       * @ngdoc method
       * @name $cacheFactory#info
       *
       * @description
       * Get information about all the caches that have been created
       *
       * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
       */
      cacheFactory.info = function () {
        var info = {};
        forEach(caches, function (cache, cacheId) {
          info[cacheId] = cache.info();
        });
        return info;
      };

      /**
       * @ngdoc method
       * @name $cacheFactory#get
       *
       * @description
       * Get access to a cache object by the `cacheId` used when it was created.
       *
       * @param {string} cacheId Name or id of a cache to access.
       * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
       */
      cacheFactory.get = function (cacheId) {
        return caches[cacheId];
      };

      return cacheFactory;
    };
  }

  /**
   * @ngdoc service
   * @name $templateCache
   * @this
   *
   * @description
   * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
   * {@link ng.$cacheFactory $cacheFactory}.
   *
   * The first time a template is used, it is loaded in the template cache for quick retrieval. You
   * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
   * or by consuming the `$templateCache` service directly.
   *
   * Adding via the `script` tag:
   *
   * ```html
   *   <script type="text/ng-template" id="templateId.html">
   *     <p>This is the content of the template</p>
   *   </script>
   * ```
   *
   * **Note:** the `script` tag containing the template does not need to be included in the `head` of
   * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
   * element with {@link ngApp} attribute), otherwise the template will be ignored.
   *
   * Adding via the `$templateCache` service:
   *
   * ```js
   * var myApp = angular.module('myApp', []);
   * myApp.run(function($templateCache) {
   *   $templateCache.put('templateId.html', 'This is the content of the template');
   * });
   * ```
   *
   * To retrieve the template later, simply use it in your component:
   * ```js
   * myApp.component('myComponent', {
   *    templateUrl: 'templateId.html'
   * });
   * ```
   *
   * or get it via the `$templateCache` service:
   * ```js
   * $templateCache.get('templateId.html')
   * ```
   *
   */
  function $TemplateCacheProvider() {
    this.$get = ['$cacheFactory', function ($cacheFactory) {
      return $cacheFactory('templates');
    }];
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   *     Any commits to this file should be reviewed with security in mind.  *
   *   Changes to this file can potentially create security vulnerabilities. *
   *          An approval from 2 Core members with history of modifying      *
   *                         this file is required.                          *
   *                                                                         *
   *  Does the change somehow allow for arbitrary javascript to be executed? *
   *    Or allows for someone to change the prototype of built-in objects?   *
   *     Or gives undesired access to variables like document or window?    *
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  /* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
   *
   * DOM-related variables:
   *
   * - "node" - DOM Node
   * - "element" - DOM Element or Node
   * - "$node" or "$element" - jqLite-wrapped node or element
   *
   *
   * Compiler related stuff:
   *
   * - "linkFn" - linking fn of a single directive
   * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
   * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
   * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
   */

  /**
   * @ngdoc service
   * @name $compile
   * @kind function
   *
   * @description
   * Compiles an HTML string or DOM into a template and produces a template function, which
   * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
   *
   * The compilation is a process of walking the DOM tree and matching DOM elements to
   * {@link ng.$compileProvider#directive directives}.
   *
   * <div class="alert alert-warning">
   * **Note:** This document is an in-depth reference of all directive options.
   * For a gentle introduction to directives with examples of common use cases,
   * see the {@link guide/directive directive guide}.
   * </div>
   *
   * ## Comprehensive Directive API
   *
   * There are many different options for a directive.
   *
   * The difference resides in the return value of the factory function.
   * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
   * that defines the directive properties, or just the `postLink` function (all other properties will have
   * the default values).
   *
   * <div class="alert alert-success">
   * **Best Practice:** It's recommended to use the "directive definition object" form.
   * </div>
   *
   * Here's an example directive declared with a Directive Definition Object:
   *
   * ```js
   *   var myModule = angular.module(...);
   *
   *   myModule.directive('directiveName', function factory(injectables) {
   *     var directiveDefinitionObject = {
   *       {@link $compile#-priority- priority}: 0,
   *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
   *       // or
   *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
   *       {@link $compile#-transclude- transclude}: false,
   *       {@link $compile#-restrict- restrict}: 'A',
   *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
   *       {@link $compile#-scope- scope}: false,
   *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
   *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
   *       {@link $compile#-bindtocontroller- bindToController}: false,
   *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
   *       {@link $compile#-multielement- multiElement}: false,
   *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
   *         return {
   *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
   *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
   *         }
   *         // or
   *         // return function postLink( ... ) { ... }
   *       },
   *       // or
   *       // {@link $compile#-link- link}: {
   *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
   *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
   *       // }
   *       // or
   *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
   *     };
   *     return directiveDefinitionObject;
   *   });
   * ```
   *
   * <div class="alert alert-warning">
   * **Note:** Any unspecified options will use the default value. You can see the default values below.
   * </div>
   *
   * Therefore the above can be simplified as:
   *
   * ```js
   *   var myModule = angular.module(...);
   *
   *   myModule.directive('directiveName', function factory(injectables) {
   *     var directiveDefinitionObject = {
   *       link: function postLink(scope, iElement, iAttrs) { ... }
   *     };
   *     return directiveDefinitionObject;
   *     // or
   *     // return function postLink(scope, iElement, iAttrs) { ... }
   *   });
   * ```
   *
   * ### Life-cycle hooks
   * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
   * directive:
   * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
   *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
   *   this element). This is a good place to put initialization code for your controller.
   * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
   *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
   *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
   *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
   *   also be called when your bindings are initialized.
   * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
   *   changes. Any actions that you wish to take in response to the changes that you detect must be
   *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
   *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
   *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
   *   if detecting changes, you must store the previous value(s) for comparison to the current values.
   * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
   *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
   *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
   *   components will have their `$onDestroy()` hook called before child components.
   * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
   *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
   *   they are waiting for their template to load asynchronously and their own compilation and linking has been
   *   suspended until that occurs.
   *
   * #### Comparison with life-cycle hooks in the new Angular
   * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
   * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
   *
   * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
   * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
   *   In Angular you can only define hooks on the prototype of the Component class.
   * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
   *   `ngDoCheck` in Angular.
   * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
   *   propagated throughout the application.
   *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
   *   error or do nothing depending upon the state of `enableProdMode()`.
   *
   * #### Life-cycle hook examples
   *
   * This example shows how you can check for mutations to a Date object even though the identity of the object
   * has not changed.
   *
   * <example name="doCheckDateExample" module="do-check-module">
   *   <file name="app.js">
   *     angular.module('do-check-module', [])
   *       .component('app', {
   *         template:
   *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
   *           'Date: {{ $ctrl.date }}' +
   *           '<test date="$ctrl.date"></test>',
   *         controller: function() {
   *           this.date = new Date();
   *           this.month = this.date.getMonth();
   *           this.updateDate = function() {
   *             this.date.setMonth(this.month);
   *           };
   *         }
   *       })
   *       .component('test', {
   *         bindings: { date: '<' },
   *         template:
   *           '<pre>{{ $ctrl.log | json }}</pre>',
   *         controller: function() {
   *           var previousValue;
   *           this.log = [];
   *           this.$doCheck = function() {
   *             var currentValue = this.date && this.date.valueOf();
   *             if (previousValue !== currentValue) {
   *               this.log.push('doCheck: date mutated: ' + this.date);
   *               previousValue = currentValue;
   *             }
   *           };
   *         }
   *       });
   *   </file>
   *   <file name="index.html">
   *     <app></app>
   *   </file>
   * </example>
   *
   * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
   * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
   * arrays or objects can have a negative impact on your application performance)
   *
   * <example name="doCheckArrayExample" module="do-check-module">
   *   <file name="index.html">
   *     <div ng-init="items = []">
   *       <button ng-click="items.push(items.length)">Add Item</button>
   *       <button ng-click="items = []">Reset Items</button>
   *       <pre>{{ items }}</pre>
   *       <test items="items"></test>
   *     </div>
   *   </file>
   *   <file name="app.js">
   *      angular.module('do-check-module', [])
   *        .component('test', {
   *          bindings: { items: '<' },
   *          template:
   *            '<pre>{{ $ctrl.log | json }}</pre>',
   *          controller: function() {
   *            this.log = [];
   *
   *            this.$doCheck = function() {
   *              if (this.items_ref !== this.items) {
   *                this.log.push('doCheck: items changed');
   *                this.items_ref = this.items;
   *              }
   *              if (!angular.equals(this.items_clone, this.items)) {
   *                this.log.push('doCheck: items mutated');
   *                this.items_clone = angular.copy(this.items);
   *              }
   *            };
   *          }
   *        });
   *   </file>
   * </example>
   *
   *
   * ### Directive Definition Object
   *
   * The directive definition object provides instructions to the {@link ng.$compile
   * compiler}. The attributes are:
   *
   * #### `multiElement`
   * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
   * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
   * together as the directive elements. It is recommended that this feature be used on directives
   * which are not strictly behavioral (such as {@link ngClick}), and which
   * do not manipulate or replace child nodes (such as {@link ngInclude}).
   *
   * #### `priority`
   * When there are multiple directives defined on a single DOM element, sometimes it
   * is necessary to specify the order in which the directives are applied. The `priority` is used
   * to sort the directives before their `compile` functions get called. Priority is defined as a
   * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
   * are also run in priority order, but post-link functions are run in reverse order. The order
   * of directives with the same priority is undefined. The default priority is `0`.
   *
   * #### `terminal`
   * If set to true then the current `priority` will be the last set of directives
   * which will execute (any directives at the current priority will still execute
   * as the order of execution on same `priority` is undefined). Note that expressions
   * and other directives used in the directive's template will also be excluded from execution.
   *
   * #### `scope`
   * The scope property can be `false`, `true`, or an object:
   *
   * * **`false` (default):** No scope will be created for the directive. The directive will use its
   * parent's scope.
   *
   * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
   * the directive's element. If multiple directives on the same element request a new scope,
   * only one new scope is created.
   *
   * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
   * The 'isolate' scope differs from normal scope in that it does not prototypically
   * inherit from its parent scope. This is useful when creating reusable components, which should not
   * accidentally read or modify data in the parent scope. Note that an isolate scope
   * directive without a `template` or `templateUrl` will not apply the isolate scope
   * to its children elements.
   *
   * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
   * directive's element. These local properties are useful for aliasing values for templates. The keys in
   * the object hash map to the name of the property on the isolate scope; the values define how the property
   * is bound to the parent scope, via matching attributes on the directive's element:
   *
   * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
   *   always a string since DOM attributes are strings. If no `attr` name is specified then the
   *   attribute name is assumed to be the same as the local name. Given `<my-component
   *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
   *   the directive's scope property `localName` will reflect the interpolated value of `hello
   *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
   *   scope. The `name` is read from the parent scope (not the directive's scope).
   *
   * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
   *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
   *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
   *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
   *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
   *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
   *   `localModel` and vice versa. Optional attributes should be marked as such with a question mark:
   *   `=?` or `=?attr`. If the binding expression is non-assignable, or if the attribute isn't
   *   optional and doesn't exist, an exception ({@link error/$compile/nonassign `$compile:nonassign`})
   *   will be thrown upon discovering changes to the local value, since it will be impossible to sync
   *   them back to the parent scope. By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
   *   method is used for tracking changes, and the equality check is based on object identity.
   *   However, if an object literal or an array literal is passed as the binding expression, the
   *   equality check is done by value (using the {@link angular.equals} function). It's also possible
   *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
   *   `$watchCollection`}: use `=*` or `=*attr` (`=*?` or `=*?attr` if the attribute is optional).
   *
    * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
   *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
   *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
   *   local name. You can also make the binding optional by adding `?`: `<?` or `<?attr`.
   *
   *   For example, given `<my-component my-attr="parentModel">` and directive definition of
   *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
   *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
   *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
   *   two caveats:
   *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
   *     sets the same value. That means if your bound value is an object, changes to its properties
   *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
   *     2. one-way binding watches changes to the **identity** of the parent value. That means the
   *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
   *     to the value has changed. In most cases, this should not be of concern, but can be important
   *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
   *     If you now change a property of the object in your parent scope, the change will not be
   *     propagated to the isolated scope, because the identity of the object on the parent scope
   *     has not changed. Instead you must assign a new object.
   *
   *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
   *   back to the parent. However, it does not make this completely impossible.
   *
   * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
   *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
   *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
   *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
   *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
   *   via an expression to the parent scope. This can be done by passing a map of local variable names
   *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
   *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
   *
   * In general it's possible to apply more than one directive to one element, but there might be limitations
   * depending on the type of scope required by the directives. The following points will help explain these limitations.
   * For simplicity only two directives are taken into account, but it is also applicable for several directives:
   *
   * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
   * * **child scope** + **no scope** =>  Both directives will share one single child scope
   * * **child scope** + **child scope** =>  Both directives will share one single child scope
   * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
   * its parent's scope
   * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
   * be applied to the same element.
   * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
   * cannot be applied to the same element.
   *
   *
   * #### `bindToController`
   * This property is used to bind scope properties directly to the controller. It can be either
   * `true` or an object hash with the same format as the `scope` property.
   *
   * When an isolate scope is used for a directive (see above), `bindToController: true` will
   * allow a component to have its properties bound to the controller, rather than to scope.
   *
   * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
   * properties. You can access these bindings once they have been initialized by providing a controller method called
   * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
   * initialized.
   *
   * <div class="alert alert-warning">
   * **Deprecation warning:** if `$compileProcvider.preAssignBindingsEnabled(true)` was called, bindings for non-ES6 class
   * controllers are bound to `this` before the controller constructor is called but this use is now deprecated. Please
   * place initialization code that relies upon bindings inside a `$onInit` method on the controller, instead.
   * </div>
   *
   * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
   * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
   * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
   * scope (useful for component directives).
   *
   * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
   *
   *
   * #### `controller`
   * Controller constructor function. The controller is instantiated before the
   * pre-linking phase and can be accessed by other directives (see
   * `require` attribute). This allows the directives to communicate with each other and augment
   * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
   *
   * * `$scope` - Current scope associated with the element
   * * `$element` - Current element
   * * `$attrs` - Current attributes object for the element
   * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
   *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
   *    * `scope`: (optional) override the scope.
   *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
   *    * `futureParentElement` (optional):
   *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
   *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
   *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
   *          and when the `cloneLinkingFn` is passed,
   *          as those elements need to created and cloned in a special way when they are defined outside their
   *          usual containers (e.g. like `<svg>`).
   *        * See also the `directive.templateNamespace` property.
   *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
   *      then the default transclusion is provided.
   *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
   *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
   *
   * #### `require`
   * Require another directive and inject its controller as the fourth argument to the linking function. The
   * `require` property can be a string, an array or an object:
   * * a **string** containing the name of the directive to pass to the linking function
   * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
   * linking function will be an array of controllers in the same order as the names in the `require` property
   * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
   * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
   * controllers.
   *
   * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
   * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
   * have been constructed but before `$onInit` is called.
   * If the name of the required controller is the same as the local name (the key), the name can be
   * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
   * See the {@link $compileProvider#component} helper for an example of how this can be used.
   * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
   * raised (unless no link function is specified and the required controllers are not being bound to the directive
   * controller, in which case error checking is skipped). The name can be prefixed with:
   *
   * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
   * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
   * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
   * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
   * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
   *   `null` to the `link` fn if not found.
   * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
   *   `null` to the `link` fn if not found.
   *
   *
   * #### `controllerAs`
   * Identifier name for a reference to the controller in the directive's scope.
   * This allows the controller to be referenced from the directive template. This is especially
   * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
   * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
   * `controllerAs` reference might overwrite a property that already exists on the parent scope.
   *
   *
   * #### `restrict`
   * String of subset of `EACM` which restricts the directive to a specific directive
   * declaration style. If omitted, the defaults (elements and attributes) are used.
   *
   * * `E` - Element name (default): `<my-directive></my-directive>`
   * * `A` - Attribute (default): `<div my-directive="exp"></div>`
   * * `C` - Class: `<div class="my-directive: exp;"></div>`
   * * `M` - Comment: `<!-- directive: my-directive exp -->`
   *
   *
   * #### `templateNamespace`
   * String representing the document type used by the markup in the template.
   * AngularJS needs this information as those elements need to be created and cloned
   * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
   *
   * * `html` - All root nodes in the template are HTML. Root nodes may also be
   *   top-level elements such as `<svg>` or `<math>`.
   * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
   * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
   *
   * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
   *
   * #### `template`
   * HTML markup that may:
   * * Replace the contents of the directive's element (default).
   * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
   * * Wrap the contents of the directive's element (if `transclude` is true).
   *
   * Value may be:
   *
   * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
   * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
   *   function api below) and returns a string value.
   *
   *
   * #### `templateUrl`
   * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
   *
   * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
   * for later when the template has been resolved.  In the meantime it will continue to compile and link
   * sibling and parent elements as though this element had not contained any directives.
   *
   * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
   * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
   * case when only one deeply nested directive has `templateUrl`.
   *
   * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}
   *
   * You can specify `templateUrl` as a string representing the URL or as a function which takes two
   * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
   * a string value representing the url.  In either case, the template URL is passed through {@link
   * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
   *
   *
   * #### `replace` (*DEPRECATED*)
   *
   * `replace` will be removed in next major release - i.e. v2.0).
   *
   * Specifies what the template should replace. Defaults to `false`.
   *
   * * `true` - the template will replace the directive's element.
   * * `false` - the template will replace the contents of the directive's element.
   *
   * The replacement process migrates all of the attributes / classes from the old element to the new
   * one. See the {@link guide/directive#template-expanding-directive
   * Directives Guide} for an example.
   *
   * There are very few scenarios where element replacement is required for the application function,
   * the main one being reusable custom components that are used within SVG contexts
   * (because SVG doesn't work with custom elements in the DOM tree).
   *
   * #### `transclude`
   * Extract the contents of the element where the directive appears and make it available to the directive.
   * The contents are compiled and provided to the directive as a **transclusion function**. See the
   * {@link $compile#transclusion Transclusion} section below.
   *
   *
   * #### `compile`
   *
   * ```js
   *   function compile(tElement, tAttrs, transclude) { ... }
   * ```
   *
   * The compile function deals with transforming the template DOM. Since most directives do not do
   * template transformation, it is not used often. The compile function takes the following arguments:
   *
   *   * `tElement` - template element - The element where the directive has been declared. It is
   *     safe to do template transformation on the element and child elements only.
   *
   *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
   *     between all directive compile functions.
   *
   *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
   *
   * <div class="alert alert-warning">
   * **Note:** The template instance and the link instance may be different objects if the template has
   * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
   * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
   * should be done in a linking function rather than in a compile function.
   * </div>
  
   * <div class="alert alert-warning">
   * **Note:** The compile function cannot handle directives that recursively use themselves in their
   * own templates or compile functions. Compiling these directives results in an infinite loop and
   * stack overflow errors.
   *
   * This can be avoided by manually using $compile in the postLink function to imperatively compile
   * a directive's template instead of relying on automatic template compilation via `template` or
   * `templateUrl` declaration or manual compilation inside the compile function.
   * </div>
   *
   * <div class="alert alert-danger">
   * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
   *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
   *   to the link function instead.
   * </div>
  
   * A compile function can have a return value which can be either a function or an object.
   *
   * * returning a (post-link) function - is equivalent to registering the linking function via the
   *   `link` property of the config object when the compile function is empty.
   *
   * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
   *   control when a linking function should be called during the linking phase. See info about
   *   pre-linking and post-linking functions below.
   *
   *
   * #### `link`
   * This property is used only if the `compile` property is not defined.
   *
   * ```js
   *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
   * ```
   *
   * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
   * executed after the template has been cloned. This is where most of the directive logic will be
   * put.
   *
   *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
   *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
   *
   *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
   *     manipulate the children of the element only in `postLink` function since the children have
   *     already been linked.
   *
   *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
   *     between all directive linking functions.
   *
   *   * `controller` - the directive's required controller instance(s) - Instances are shared
   *     among all directives, which allows the directives to use the controllers as a communication
   *     channel. The exact value depends on the directive's `require` property:
   *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
   *       * `string`: the controller instance
   *       * `array`: array of controller instances
   *
   *     If a required controller cannot be found, and it is optional, the instance is `null`,
   *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
   *
   *     Note that you can also require the directive's own controller - it will be made available like
   *     any other controller.
   *
   *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
   *     This is the same as the `$transclude` parameter of directive controllers,
   *     see {@link ng.$compile#-controller- the controller section for details}.
   *     `function([scope], cloneLinkingFn, futureParentElement)`.
   *
   * #### Pre-linking function
   *
   * Executed before the child elements are linked. Not safe to do DOM transformation since the
   * compiler linking function will fail to locate the correct elements for linking.
   *
   * #### Post-linking function
   *
   * Executed after the child elements are linked.
   *
   * Note that child elements that contain `templateUrl` directives will not have been compiled
   * and linked since they are waiting for their template to load asynchronously and their own
   * compilation and linking has been suspended until that occurs.
   *
   * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
   * for their async templates to be resolved.
   *
   *
   * ### Transclusion
   *
   * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
   * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
   * scope from where they were taken.
   *
   * Transclusion is used (often with {@link ngTransclude}) to insert the
   * original contents of a directive's element into a specified place in the template of the directive.
   * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
   * content has access to the properties on the scope from which it was taken, even if the directive
   * has isolated scope.
   * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
   *
   * This makes it possible for the widget to have private state for its template, while the transcluded
   * content has access to its originating scope.
   *
   * <div class="alert alert-warning">
   * **Note:** When testing an element transclude directive you must not place the directive at the root of the
   * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
   * Testing Transclusion Directives}.
   * </div>
   *
   * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
   * directive's element, the entire element or multiple parts of the element contents:
   *
   * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
   * * `'element'` - transclude the whole of the directive's element including any directives on this
   *   element that defined at a lower priority than this directive. When used, the `template`
   *   property is ignored.
   * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
   *
   * **Mult-slot transclusion** is declared by providing an object for the `transclude` property.
   *
   * This object is a map where the keys are the name of the slot to fill and the value is an element selector
   * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
   * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
   *
   * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
   *
   * If the element selector is prefixed with a `?` then that slot is optional.
   *
   * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
   * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
   *
   * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
   * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
   * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
   * injectable into the directive's controller.
   *
   *
   * #### Transclusion Functions
   *
   * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
   * function** to the directive's `link` function and `controller`. This transclusion function is a special
   * **linking function** that will return the compiled contents linked to a new transclusion scope.
   *
   * <div class="alert alert-info">
   * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
   * ngTransclude will deal with it for us.
   * </div>
   *
   * If you want to manually control the insertion and removal of the transcluded content in your directive
   * then you must use this transclude function. When you call a transclude function it returns a a jqLite/JQuery
   * object that contains the compiled DOM, which is linked to the correct transclusion scope.
   *
   * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
   * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
   * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
   *
   * <div class="alert alert-info">
   * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
   * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
   * </div>
   *
   * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
   * attach function**:
   *
   * ```js
   * var transcludedContent, transclusionScope;
   *
   * $transclude(function(clone, scope) {
   *   element.append(clone);
   *   transcludedContent = clone;
   *   transclusionScope = scope;
   * });
   * ```
   *
   * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
   * associated transclusion scope:
   *
   * ```js
   * transcludedContent.remove();
   * transclusionScope.$destroy();
   * ```
   *
   * <div class="alert alert-info">
   * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
   * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
   * then you are also responsible for calling `$destroy` on the transclusion scope.
   * </div>
   *
   * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
   * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
   * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
   *
   *
   * #### Transclusion Scopes
   *
   * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
   * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
   * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
   * was taken.
   *
   * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
   * like this:
   *
   * ```html
   * <div ng-app>
   *   <div isolate>
   *     <div transclusion>
   *     </div>
   *   </div>
   * </div>
   * ```
   *
   * The `$parent` scope hierarchy will look like this:
   *
     ```
     - $rootScope
       - isolate
         - transclusion
     ```
   *
   * but the scopes will inherit prototypically from different scopes to their `$parent`.
   *
     ```
     - $rootScope
       - transclusion
     - isolate
     ```
   *
   *
   * ### Attributes
   *
   * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
   * `link()` or `compile()` functions. It has a variety of uses.
   *
   * * *Accessing normalized attribute names:* Directives like 'ngBind' can be expressed in many ways:
   *   'ng:bind', `data-ng-bind`, or 'x-ng-bind'. The attributes object allows for normalized access
   *   to the attributes.
   *
   * * *Directive inter-communication:* All directives share the same instance of the attributes
   *   object which allows the directives to use the attributes object as inter directive
   *   communication.
   *
   * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
   *   allowing other directives to read the interpolated value.
   *
   * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
   *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
   *   the only way to easily get the actual value because during the linking phase the interpolation
   *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
   *
   * ```js
   * function linkingFn(scope, elm, attrs, ctrl) {
   *   // get the attribute value
   *   console.log(attrs.ngModel);
   *
   *   // change the attribute
   *   attrs.$set('ngModel', 'new value');
   *
   *   // observe changes to interpolated attribute
   *   attrs.$observe('ngModel', function(value) {
   *     console.log('ngModel has changed value to ' + value);
   *   });
   * }
   * ```
   *
   * ## Example
   *
   * <div class="alert alert-warning">
   * **Note**: Typically directives are registered with `module.directive`. The example below is
   * to illustrate how `$compile` works.
   * </div>
   *
   <example module="compileExample" name="compile">
     <file name="index.html">
      <script>
        angular.module('compileExample', [], function($compileProvider) {
          // configure new 'compile' directive by passing a directive
          // factory function. The factory function injects the '$compile'
          $compileProvider.directive('compile', function($compile) {
            // directive factory creates a link function
            return function(scope, element, attrs) {
              scope.$watch(
                function(scope) {
                   // watch the 'compile' expression for changes
                  return scope.$eval(attrs.compile);
                },
                function(value) {
                  // when the 'compile' expression changes
                  // assign it into the current DOM
                  element.html(value);
  
                  // compile the new DOM and link it to the current
                  // scope.
                  // NOTE: we only compile .childNodes so that
                  // we don't get into infinite loop compiling ourselves
                  $compile(element.contents())(scope);
                }
              );
            };
          });
        })
        .controller('GreeterController', ['$scope', function($scope) {
          $scope.name = 'AngularJS';
          $scope.html = 'Hello {{name}}';
        }]);
      </script>
      <div ng-controller="GreeterController">
        <input ng-model="name"> <br/>
        <textarea ng-model="html"></textarea> <br/>
        <div compile="html"></div>
      </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should auto compile', function() {
         var textarea = $('textarea');
         var output = $('div[compile]');
         // The initial state reads 'Hello AngularJS'.
         expect(output.getText()).toBe('Hello AngularJS');
         textarea.clear();
         textarea.sendKeys('{{name}}!');
         expect(output.getText()).toBe('AngularJS!');
       });
     </file>
   </example>
  
   *
   *
   * @param {string|DOMElement} element Element or HTML string to compile into a template function.
   * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
   *
   * <div class="alert alert-danger">
   * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
   *   e.g. will not use the right outer scope. Please pass the transclude function as a
   *   `parentBoundTranscludeFn` to the link function instead.
   * </div>
   *
   * @param {number} maxPriority only apply directives lower than given priority (Only effects the
   *                 root element(s), not their children)
   * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
   * (a DOM element/tree) to a scope. Where:
   *
   *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
   *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
   *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
   *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
   *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
   *
   *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
   *      * `scope` - is the current scope with which the linking function is working with.
   *
   *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
   *  keys may be used to control linking behavior:
   *
   *      * `parentBoundTranscludeFn` - the transclude function made available to
   *        directives; if given, it will be passed through to the link functions of
   *        directives found in `element` during compilation.
   *      * `transcludeControllers` - an object hash with keys that map controller names
   *        to a hash with the key `instance`, which maps to the controller instance;
   *        if given, it will make the controllers available to directives on the compileNode:
   *        ```
   *        {
   *          parent: {
   *            instance: parentControllerInstance
   *          }
   *        }
   *        ```
   *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
   *        the cloned elements; only needed for transcludes that are allowed to contain non html
   *        elements (e.g. SVG elements). See also the directive.controller property.
   *
   * Calling the linking function returns the element of the template. It is either the original
   * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
   *
   * After linking the view is not updated until after a call to $digest which typically is done by
   * AngularJS automatically.
   *
   * If you need access to the bound view, there are two ways to do it:
   *
   * - If you are not asking the linking function to clone the template, create the DOM element(s)
   *   before you send them to the compiler and keep this reference around.
   *   ```js
   *     var element = $compile('<p>{{total}}</p>')(scope);
   *   ```
   *
   * - if on the other hand, you need the element to be cloned, the view reference from the original
   *   example would not point to the clone, but rather to the original template that was cloned. In
   *   this case, you can access the clone via the cloneAttachFn:
   *   ```js
   *     var templateElement = angular.element('<p>{{total}}</p>'),
   *         scope = ....;
   *
   *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
   *       //attach the clone to DOM document at the right place
   *     });
   *
   *     //now we have reference to the cloned DOM via `clonedElement`
   *   ```
   *
   *
   * For information on how the compiler works, see the
   * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
   *
   * @knownIssue
   *
   * ### Double Compilation
   *
     Double compilation occurs when an already compiled part of the DOM gets
     compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
     and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
     section on double compilation} for an in-depth explanation and ways to avoid it.
   *
   */

  var $compileMinErr = minErr('$compile');

  function UNINITIALIZED_VALUE() {}
  var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

  /**
   * @ngdoc provider
   * @name $compileProvider
   *
   * @description
   */
  $CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
  /** @this */
  function $CompileProvider($provide, $$sanitizeUriProvider) {
    var hasDirectives = {},
        Suffix = 'Directive',
        COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
        CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
        ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
        REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

    // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
    // The assumption is that future DOM event attribute names will begin with
    // 'on' and be composed of only English letters.
    var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
    var bindingCache = createMap();

    function parseIsolateBindings(scope, directiveName, isController) {
      var LOCAL_REGEXP = /^\s*([@&<]|=(\*?))(\??)\s*([\w$]*)\s*$/;

      var bindings = createMap();

      forEach(scope, function (definition, scopeName) {
        if (definition in bindingCache) {
          bindings[scopeName] = bindingCache[definition];
          return;
        }
        var match = definition.match(LOCAL_REGEXP);

        if (!match) {
          throw $compileMinErr('iscp', 'Invalid {3} for directive \'{0}\'.' + ' Definition: {... {1}: \'{2}\' ...}', directiveName, scopeName, definition, isController ? 'controller bindings definition' : 'isolate scope definition');
        }

        bindings[scopeName] = {
          mode: match[1][0],
          collection: match[2] === '*',
          optional: match[3] === '?',
          attrName: match[4] || scopeName
        };
        if (match[4]) {
          bindingCache[definition] = bindings[scopeName];
        }
      });

      return bindings;
    }

    function parseDirectiveBindings(directive, directiveName) {
      var bindings = {
        isolateScope: null,
        bindToController: null
      };
      if (isObject(directive.scope)) {
        if (directive.bindToController === true) {
          bindings.bindToController = parseIsolateBindings(directive.scope, directiveName, true);
          bindings.isolateScope = {};
        } else {
          bindings.isolateScope = parseIsolateBindings(directive.scope, directiveName, false);
        }
      }
      if (isObject(directive.bindToController)) {
        bindings.bindToController = parseIsolateBindings(directive.bindToController, directiveName, true);
      }
      if (bindings.bindToController && !directive.controller) {
        // There is no controller
        throw $compileMinErr('noctrl', 'Cannot bind to controller without directive \'{0}\'s controller.', directiveName);
      }
      return bindings;
    }

    function assertValidDirectiveName(name) {
      var letter = name.charAt(0);
      if (!letter || letter !== lowercase(letter)) {
        throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
      }
      if (name !== name.trim()) {
        throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces', name);
      }
    }

    function getDirectiveRequire(directive) {
      var require = directive.require || directive.controller && directive.name;

      if (!isArray(require) && isObject(require)) {
        forEach(require, function (value, key) {
          var match = value.match(REQUIRE_PREFIX_REGEXP);
          var name = value.substring(match[0].length);
          if (!name) require[key] = match[0] + key;
        });
      }

      return require;
    }

    function getDirectiveRestrict(restrict, name) {
      if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
        throw $compileMinErr('badrestrict', 'Restrict property \'{0}\' of directive \'{1}\' is invalid', restrict, name);
      }

      return restrict || 'EA';
    }

    /**
     * @ngdoc method
     * @name $compileProvider#directive
     * @kind function
     *
     * @description
     * Register a new directive with the compiler.
     *
     * @param {string|Object} name Name of the directive in camel-case (i.e. <code>ngBind</code> which
     *    will match as <code>ng-bind</code>), or an object map of directives where the keys are the
     *    names and the values are the factories.
     * @param {Function|Array} directiveFactory An injectable directive factory function. See the
     *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
     * @returns {ng.$compileProvider} Self for chaining.
     */
    this.directive = function registerDirective(name, directiveFactory) {
      assertArg(name, 'name');
      assertNotHasOwnProperty(name, 'directive');
      if (isString(name)) {
        assertValidDirectiveName(name);
        assertArg(directiveFactory, 'directiveFactory');
        if (!hasDirectives.hasOwnProperty(name)) {
          hasDirectives[name] = [];
          $provide.factory(name + Suffix, ['$injector', '$exceptionHandler', function ($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function (directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = { compile: valueFn(directive) };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = getDirectiveRequire(directive);
                directive.restrict = getDirectiveRestrict(directive.restrict, name);
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
        }
        hasDirectives[name].push(directiveFactory);
      } else {
        forEach(name, reverseParams(registerDirective));
      }
      return this;
    };

    /**
     * @ngdoc method
     * @name $compileProvider#component
     * @module ng
     * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
     *    or an object map of components where the keys are the names and the values are the component definition objects.
     * @param {Object} options Component definition object (a simplified
     *    {@link ng.$compile#directive-definition-object directive definition object}),
     *    with the following properties (all optional):
     *
     *    - `controller` – `{(string|function()=}` – controller constructor function that should be
     *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
     *      registered controller} if passed as a string. An empty `noop` function by default.
     *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
     *      If present, the controller will be published to scope under the `controllerAs` name.
     *      If not present, this will default to be `$ctrl`.
     *    - `template` – `{string=|function()=}` – html template as a string or a function that
     *      returns an html template as a string which should be used as the contents of this component.
     *      Empty string by default.
     *
     *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
     *      the following locals:
     *
     *      - `$element` - Current element
     *      - `$attrs` - Current attributes object for the element
     *
     *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
     *      template that should be used  as the contents of this component.
     *
     *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
     *      the following locals:
     *
     *      - `$element` - Current element
     *      - `$attrs` - Current attributes object for the element
     *
     *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
     *      Component properties are always bound to the component controller and not to the scope.
     *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
     *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
     *      Disabled by default.
     *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
     *      this component's controller. The object keys specify the property names under which the required
     *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
     *    - `$...` – additional properties to attach to the directive factory function and the controller
     *      constructor function. (This is used by the component router to annotate)
     *
     * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
     * @description
     * Register a **component definition** with the compiler. This is a shorthand for registering a special
     * type of directive, which represents a self-contained UI component in your application. Such components
     * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
     *
     * Component definitions are very simple and do not require as much configuration as defining general
     * directives. Component definitions usually consist only of a template and a controller backing it.
     *
     * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
     * `bindToController`. They always have **isolate scope** and are restricted to elements.
     *
     * Here are a few examples of how you would usually define components:
     *
     * ```js
     *   var myMod = angular.module(...);
     *   myMod.component('myComp', {
     *     template: '<div>My name is {{$ctrl.name}}</div>',
     *     controller: function() {
     *       this.name = 'shahar';
     *     }
     *   });
     *
     *   myMod.component('myComp', {
     *     template: '<div>My name is {{$ctrl.name}}</div>',
     *     bindings: {name: '@'}
     *   });
     *
     *   myMod.component('myComp', {
     *     templateUrl: 'views/my-comp.html',
     *     controller: 'MyCtrl',
     *     controllerAs: 'ctrl',
     *     bindings: {name: '@'}
     *   });
     *
     * ```
     * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
     *
     * <br />
     * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
     */
    this.component = function registerComponent(name, options) {
      if (!isString(name)) {
        forEach(name, reverseParams(bind(this, registerComponent)));
        return this;
      }

      var controller = options.controller || function () {};

      function factory($injector) {
        function makeInjectable(fn) {
          if (isFunction(fn) || isArray(fn)) {
            return (/** @this */function (tElement, tAttrs) {
                return $injector.invoke(fn, this, { $element: tElement, $attrs: tAttrs });
              }
            );
          } else {
            return fn;
          }
        }

        var template = !options.template && !options.templateUrl ? '' : options.template;
        var ddo = {
          controller: controller,
          controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
          template: makeInjectable(template),
          templateUrl: makeInjectable(options.templateUrl),
          transclude: options.transclude,
          scope: {},
          bindToController: options.bindings || {},
          restrict: 'E',
          require: options.require
        };

        // Copy annotations (starting with $) over to the DDO
        forEach(options, function (val, key) {
          if (key.charAt(0) === '$') ddo[key] = val;
        });

        return ddo;
      }

      // TODO(pete) remove the following `forEach` before we release 1.6.0
      // The component-router@0.2.0 looks for the annotations on the controller constructor
      // Nothing in AngularJS looks for annotations on the factory function but we can't remove
      // it from 1.5.x yet.

      // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
      // These could be used by libraries such as the new component router
      forEach(options, function (val, key) {
        if (key.charAt(0) === '$') {
          factory[key] = val;
          // Don't try to copy over annotations to named controller
          if (isFunction(controller)) controller[key] = val;
        }
      });

      factory.$inject = ['$injector'];

      return this.directive(name, factory);
    };

    /**
     * @ngdoc method
     * @name $compileProvider#aHrefSanitizationWhitelist
     * @kind function
     *
     * @description
     * Retrieves or overrides the default regular expression that is used for whitelisting of safe
     * urls during a[href] sanitization.
     *
     * The sanitization is a security measure aimed at preventing XSS attacks via html links.
     *
     * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
     * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
     * regular expression. If a match is found, the original url is written into the dom. Otherwise,
     * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
     *
     * @param {RegExp=} regexp New regexp to whitelist urls with.
     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
     *    chaining otherwise.
     */
    this.aHrefSanitizationWhitelist = function (regexp) {
      if (isDefined(regexp)) {
        $$sanitizeUriProvider.aHrefSanitizationWhitelist(regexp);
        return this;
      } else {
        return $$sanitizeUriProvider.aHrefSanitizationWhitelist();
      }
    };

    /**
     * @ngdoc method
     * @name $compileProvider#imgSrcSanitizationWhitelist
     * @kind function
     *
     * @description
     * Retrieves or overrides the default regular expression that is used for whitelisting of safe
     * urls during img[src] sanitization.
     *
     * The sanitization is a security measure aimed at prevent XSS attacks via html links.
     *
     * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
     * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
     * regular expression. If a match is found, the original url is written into the dom. Otherwise,
     * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
     *
     * @param {RegExp=} regexp New regexp to whitelist urls with.
     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
     *    chaining otherwise.
     */
    this.imgSrcSanitizationWhitelist = function (regexp) {
      if (isDefined(regexp)) {
        $$sanitizeUriProvider.imgSrcSanitizationWhitelist(regexp);
        return this;
      } else {
        return $$sanitizeUriProvider.imgSrcSanitizationWhitelist();
      }
    };

    /**
     * @ngdoc method
     * @name  $compileProvider#debugInfoEnabled
     *
     * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
     * current debugInfoEnabled state
     * @returns {*} current value if used as getter or itself (chaining) if used as setter
     *
     * @kind function
     *
     * @description
     * Call this method to enable/disable various debug runtime information in the compiler such as adding
     * binding information and a reference to the current scope on to DOM elements.
     * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
     * * `ng-binding` CSS class
     * * `ng-scope` and `ng-isolated-scope` CSS classes
     * * `$binding` data property containing an array of the binding expressions
     * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
     *   the element's scope.
     * * Placeholder comments will contain information about what directive and binding caused the placeholder.
     *   E.g. `<!-- ngIf: shouldShow() -->`.
     *
     * You may want to disable this in production for a significant performance boost. See
     * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
     *
     * The default value is true.
     */
    var debugInfoEnabled = true;
    this.debugInfoEnabled = function (enabled) {
      if (isDefined(enabled)) {
        debugInfoEnabled = enabled;
        return this;
      }
      return debugInfoEnabled;
    };

    /**
     * @ngdoc method
     * @name  $compileProvider#preAssignBindingsEnabled
     *
     * @param {boolean=} enabled update the preAssignBindingsEnabled state if provided, otherwise just return the
     * current preAssignBindingsEnabled state
     * @returns {*} current value if used as getter or itself (chaining) if used as setter
     *
     * @kind function
     *
     * @description
     * Call this method to enable/disable whether directive controllers are assigned bindings before
     * calling the controller's constructor.
     * If enabled (true), the compiler assigns the value of each of the bindings to the
     * properties of the controller object before the constructor of this object is called.
     *
     * If disabled (false), the compiler calls the constructor first before assigning bindings.
     *
     * The default value is false.
     *
     * @deprecated
     * sinceVersion="1.6.0"
     * removeVersion="1.7.0"
     *
     * This method and the option to assign the bindings before calling the controller's constructor
     * will be removed in v1.7.0.
     */
    var preAssignBindingsEnabled = false;
    this.preAssignBindingsEnabled = function (enabled) {
      if (isDefined(enabled)) {
        preAssignBindingsEnabled = enabled;
        return this;
      }
      return preAssignBindingsEnabled;
    };

    /**
     * @ngdoc method
     * @name  $compileProvider#strictComponentBindingsEnabled
     *
     * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided, otherwise just return the
     * current strictComponentBindingsEnabled state
     * @returns {*} current value if used as getter or itself (chaining) if used as setter
     *
     * @kind function
     *
     * @description
     * Call this method to enable/disable strict component bindings check. If enabled, the compiler will enforce that
     * for all bindings of a component that are not set as optional with `?`, an attribute needs to be provided
     * on the component's HTML tag.
     *
     * The default value is false.
     */
    var strictComponentBindingsEnabled = false;
    this.strictComponentBindingsEnabled = function (enabled) {
      if (isDefined(enabled)) {
        strictComponentBindingsEnabled = enabled;
        return this;
      }
      return strictComponentBindingsEnabled;
    };

    var TTL = 10;
    /**
     * @ngdoc method
     * @name $compileProvider#onChangesTtl
     * @description
     *
     * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
     * assuming that the model is unstable.
     *
     * The current default is 10 iterations.
     *
     * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
     * in several iterations of calls to these hooks. However if an application needs more than the default 10
     * iterations to stabilize then you should investigate what is causing the model to continuously change during
     * the `$onChanges` hook execution.
     *
     * Increasing the TTL could have performance implications, so you should not change it without proper justification.
     *
     * @param {number} limit The number of `$onChanges` hook iterations.
     * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
     */
    this.onChangesTtl = function (value) {
      if (arguments.length) {
        TTL = value;
        return this;
      }
      return TTL;
    };

    var commentDirectivesEnabledConfig = true;
    /**
     * @ngdoc method
     * @name $compileProvider#commentDirectivesEnabled
     * @description
     *
     * It indicates to the compiler
     * whether or not directives on comments should be compiled.
     * Defaults to `true`.
     *
     * Calling this function with false disables the compilation of directives
     * on comments for the whole application.
     * This results in a compilation performance gain,
     * as the compiler doesn't have to check comments when looking for directives.
     * This should however only be used if you are sure that no comment directives are used in
     * the application (including any 3rd party directives).
     *
     * @param {boolean} enabled `false` if the compiler may ignore directives on comments
     * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
     */
    this.commentDirectivesEnabled = function (value) {
      if (arguments.length) {
        commentDirectivesEnabledConfig = value;
        return this;
      }
      return commentDirectivesEnabledConfig;
    };

    var cssClassDirectivesEnabledConfig = true;
    /**
     * @ngdoc method
     * @name $compileProvider#cssClassDirectivesEnabled
     * @description
     *
     * It indicates to the compiler
     * whether or not directives on element classes should be compiled.
     * Defaults to `true`.
     *
     * Calling this function with false disables the compilation of directives
     * on element classes for the whole application.
     * This results in a compilation performance gain,
     * as the compiler doesn't have to check element classes when looking for directives.
     * This should however only be used if you are sure that no class directives are used in
     * the application (including any 3rd party directives).
     *
     * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
     * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
     */
    this.cssClassDirectivesEnabled = function (value) {
      if (arguments.length) {
        cssClassDirectivesEnabledConfig = value;
        return this;
      }
      return cssClassDirectivesEnabledConfig;
    };

    this.$get = ['$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse', '$controller', '$rootScope', '$sce', '$animate', '$$sanitizeUri', function ($injector, $interpolate, $exceptionHandler, $templateRequest, $parse, $controller, $rootScope, $sce, $animate, $$sanitizeUri) {

      var SIMPLE_ATTR_NAME = /^\w/;
      var specialAttrHolder = window.document.createElement('div');

      var commentDirectivesEnabled = commentDirectivesEnabledConfig;
      var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;

      var onChangesTtl = TTL;
      // The onChanges hooks should all be run together in a single digest
      // When changes occur, the call to trigger their hooks will be added to this queue
      var onChangesQueue;

      // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
      function flushOnChangesQueue() {
        try {
          if (! --onChangesTtl) {
            // We have hit the TTL limit so reset everything
            onChangesQueue = undefined;
            throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
          }
          // We must run this hook in an apply since the $$postDigest runs outside apply
          $rootScope.$apply(function () {
            var errors = [];
            for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
              try {
                onChangesQueue[i]();
              } catch (e) {
                errors.push(e);
              }
            }
            // Reset the queue to trigger a new schedule next time there is a change
            onChangesQueue = undefined;
            if (errors.length) {
              throw errors;
            }
          });
        } finally {
          onChangesTtl++;
        }
      }

      function Attributes(element, attributesToCopy) {
        if (attributesToCopy) {
          var keys = Object.keys(attributesToCopy);
          var i, l, key;

          for (i = 0, l = keys.length; i < l; i++) {
            key = keys[i];
            this[key] = attributesToCopy[key];
          }
        } else {
          this.$attr = {};
        }

        this.$$element = element;
      }

      Attributes.prototype = {
        /**
         * @ngdoc method
         * @name $compile.directive.Attributes#$normalize
         * @kind function
         *
         * @description
         * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
         * `data-`) to its normalized, camelCase form.
         *
         * Also there is special case for Moz prefix starting with upper case letter.
         *
         * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
         *
         * @param {string} name Name to normalize
         */
        $normalize: directiveNormalize,

        /**
         * @ngdoc method
         * @name $compile.directive.Attributes#$addClass
         * @kind function
         *
         * @description
         * Adds the CSS class value specified by the classVal parameter to the element. If animations
         * are enabled then an animation will be triggered for the class addition.
         *
         * @param {string} classVal The className value that will be added to the element
         */
        $addClass: function $addClass(classVal) {
          if (classVal && classVal.length > 0) {
            $animate.addClass(this.$$element, classVal);
          }
        },

        /**
         * @ngdoc method
         * @name $compile.directive.Attributes#$removeClass
         * @kind function
         *
         * @description
         * Removes the CSS class value specified by the classVal parameter from the element. If
         * animations are enabled then an animation will be triggered for the class removal.
         *
         * @param {string} classVal The className value that will be removed from the element
         */
        $removeClass: function $removeClass(classVal) {
          if (classVal && classVal.length > 0) {
            $animate.removeClass(this.$$element, classVal);
          }
        },

        /**
         * @ngdoc method
         * @name $compile.directive.Attributes#$updateClass
         * @kind function
         *
         * @description
         * Adds and removes the appropriate CSS class values to the element based on the difference
         * between the new and old CSS class values (specified as newClasses and oldClasses).
         *
         * @param {string} newClasses The current CSS className value
         * @param {string} oldClasses The former CSS className value
         */
        $updateClass: function $updateClass(newClasses, oldClasses) {
          var toAdd = tokenDifference(newClasses, oldClasses);
          if (toAdd && toAdd.length) {
            $animate.addClass(this.$$element, toAdd);
          }

          var toRemove = tokenDifference(oldClasses, newClasses);
          if (toRemove && toRemove.length) {
            $animate.removeClass(this.$$element, toRemove);
          }
        },

        /**
         * Set a normalized attribute on the element in a way such that all directives
         * can share the attribute. This function properly handles boolean attributes.
         * @param {string} key Normalized key. (ie ngAttribute)
         * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
         * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
         *     Defaults to true.
         * @param {string=} attrName Optional none normalized name. Defaults to key.
         */
        $set: function $set(key, value, writeAttr, attrName) {
          // TODO: decide whether or not to throw an error if "class"
          //is set through this function since it may cause $updateClass to
          //become unstable.

          var node = this.$$element[0],
              booleanKey = getBooleanAttrName(node, key),
              aliasedKey = getAliasedAttrName(key),
              observer = key,
              nodeName;

          if (booleanKey) {
            this.$$element.prop(key, value);
            attrName = booleanKey;
          } else if (aliasedKey) {
            this[aliasedKey] = value;
            observer = aliasedKey;
          }

          this[key] = value;

          // translate normalized key to actual key
          if (attrName) {
            this.$attr[key] = attrName;
          } else {
            attrName = this.$attr[key];
            if (!attrName) {
              this.$attr[key] = attrName = snake_case(key, '-');
            }
          }

          nodeName = nodeName_(this.$$element);

          if (nodeName === 'a' && (key === 'href' || key === 'xlinkHref') || nodeName === 'img' && key === 'src') {
            // sanitize a[href] and img[src] values
            this[key] = value = $$sanitizeUri(value, key === 'src');
          } else if (nodeName === 'img' && key === 'srcset' && isDefined(value)) {
            // sanitize img[srcset] values
            var result = '';

            // first check if there are spaces because it's not the same pattern
            var trimmedSrcset = trim(value);
            //                (   999x   ,|   999w   ,|   ,|,   )
            var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
            var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

            // split srcset into tuple of uri and descriptor except for the last item
            var rawUris = trimmedSrcset.split(pattern);

            // for each tuples
            var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
            for (var i = 0; i < nbrUrisWith2parts; i++) {
              var innerIdx = i * 2;
              // sanitize the uri
              result += $$sanitizeUri(trim(rawUris[innerIdx]), true);
              // add the descriptor
              result += ' ' + trim(rawUris[innerIdx + 1]);
            }

            // split the last item into uri and descriptor
            var lastTuple = trim(rawUris[i * 2]).split(/\s/);

            // sanitize the last uri
            result += $$sanitizeUri(trim(lastTuple[0]), true);

            // and add the last descriptor if any
            if (lastTuple.length === 2) {
              result += ' ' + trim(lastTuple[1]);
            }
            this[key] = value = result;
          }

          if (writeAttr !== false) {
            if (value === null || isUndefined(value)) {
              this.$$element.removeAttr(attrName);
            } else {
              if (SIMPLE_ATTR_NAME.test(attrName)) {
                this.$$element.attr(attrName, value);
              } else {
                setSpecialAttr(this.$$element[0], attrName, value);
              }
            }
          }

          // fire observers
          var $$observers = this.$$observers;
          if ($$observers) {
            forEach($$observers[observer], function (fn) {
              try {
                fn(value);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
          }
        },

        /**
         * @ngdoc method
         * @name $compile.directive.Attributes#$observe
         * @kind function
         *
         * @description
         * Observes an interpolated attribute.
         *
         * The observer function will be invoked once during the next `$digest` following
         * compilation. The observer is then invoked whenever the interpolated value
         * changes.
         *
         * @param {string} key Normalized key. (ie ngAttribute) .
         * @param {function(interpolatedValue)} fn Function that will be called whenever
                  the interpolated value of the attribute changes.
         *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
         *        guide} for more info.
         * @returns {function()} Returns a deregistration function for this observer.
         */
        $observe: function $observe(key, fn) {
          var attrs = this,
              $$observers = attrs.$$observers || (attrs.$$observers = createMap()),
              listeners = $$observers[key] || ($$observers[key] = []);

          listeners.push(fn);
          $rootScope.$evalAsync(function () {
            if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
              // no one registered attribute interpolation function, so lets call it manually
              fn(attrs[key]);
            }
          });

          return function () {
            arrayRemove(listeners, fn);
          };
        }
      };

      function setSpecialAttr(element, attrName, value) {
        // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
        // so we have to jump through some hoops to get such an attribute
        // https://github.com/angular/angular.js/pull/13318
        specialAttrHolder.innerHTML = '<span ' + attrName + '>';
        var attributes = specialAttrHolder.firstChild.attributes;
        var attribute = attributes[0];
        // We have to remove the attribute from its container element before we can add it to the destination element
        attributes.removeNamedItem(attribute.name);
        attribute.value = value;
        element.attributes.setNamedItem(attribute);
      }

      function safeAddClass($element, className) {
        try {
          $element.addClass(className);
        } catch (e) {
          // ignore, since it means that we are trying to set class on
          // SVG element, where class name is read-only.
        }
      }

      var startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          denormalizeTemplate = startSymbol === '{{' && endSymbol === '}}' ? identity : function denormalizeTemplate(template) {
        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
      },
          NG_ATTR_BINDING = /^ngAttr[A-Z]/;
      var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;

      compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
        var bindings = $element.data('$binding') || [];

        if (isArray(binding)) {
          bindings = bindings.concat(binding);
        } else {
          bindings.push(binding);
        }

        $element.data('$binding', bindings);
      } : noop;

      compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
        safeAddClass($element, 'ng-binding');
      } : noop;

      compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
        var dataName = isolated ? noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope' : '$scope';
        $element.data(dataName, scope);
      } : noop;

      compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
        safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
      } : noop;

      compile.$$createComment = function (directiveName, comment) {
        var content = '';
        if (debugInfoEnabled) {
          content = ' ' + (directiveName || '') + ': ';
          if (comment) content += comment + ' ';
        }
        return window.document.createComment(content);
      };

      return compile;

      //================================

      function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
        if (!($compileNodes instanceof jqLite)) {
          // jquery always rewraps, whereas we need to preserve the original selector so that we can
          // modify it.
          $compileNodes = jqLite($compileNodes);
        }
        var compositeLinkFn = compileNodes($compileNodes, transcludeFn, $compileNodes, maxPriority, ignoreDirective, previousCompileContext);
        compile.$$addScopeClass($compileNodes);
        var namespace = null;
        return function publicLinkFn(scope, cloneConnectFn, options) {
          if (!$compileNodes) {
            throw $compileMinErr('multilink', 'This element has already been linked.');
          }
          assertArg(scope, 'scope');

          if (previousCompileContext && previousCompileContext.needsNewScope) {
            // A parent directive did a replace and a directive on this element asked
            // for transclusion, which caused us to lose a layer of element on which
            // we could hold the new transclusion scope, so we will create it manually
            // here.
            scope = scope.$parent.$new();
          }

          options = options || {};
          var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
              transcludeControllers = options.transcludeControllers,
              futureParentElement = options.futureParentElement;

          // When `parentBoundTranscludeFn` is passed, it is a
          // `controllersBoundTransclude` function (it was previously passed
          // as `transclude` to directive.link) so we must unwrap it to get
          // its `boundTranscludeFn`
          if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
            parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
          }

          if (!namespace) {
            namespace = detectNamespaceForChildElements(futureParentElement);
          }
          var $linkNode;
          if (namespace !== 'html') {
            // When using a directive with replace:true and templateUrl the $compileNodes
            // (or a child element inside of them)
            // might change, so we need to recreate the namespace adapted compileNodes
            // for call to the link function.
            // Note: This will already clone the nodes...
            $linkNode = jqLite(wrapTemplate(namespace, jqLite('<div>').append($compileNodes).html()));
          } else if (cloneConnectFn) {
            // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
            // and sometimes changes the structure of the DOM.
            $linkNode = JQLitePrototype.clone.call($compileNodes);
          } else {
            $linkNode = $compileNodes;
          }

          if (transcludeControllers) {
            for (var controllerName in transcludeControllers) {
              $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
            }
          }

          compile.$$addScopeInfo($linkNode, scope);

          if (cloneConnectFn) cloneConnectFn($linkNode, scope);
          if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);

          if (!cloneConnectFn) {
            $compileNodes = compositeLinkFn = null;
          }
          return $linkNode;
        };
      }

      function detectNamespaceForChildElements(parentElement) {
        // TODO: Make this detect MathML as well...
        var node = parentElement && parentElement[0];
        if (!node) {
          return 'html';
        } else {
          return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
        }
      }

      /**
       * Compile function matches each node in nodeList against the directives. Once all directives
       * for a particular node are collected their compile functions are executed. The compile
       * functions return values - the linking functions - are combined into a composite linking
       * function, which is the a linking function for the node.
       *
       * @param {NodeList} nodeList an array of nodes or NodeList to compile
       * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
       *        scope argument is auto-generated to the new child of the transcluded parent scope.
       * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
       *        the rootElement must be set the jqLite collection of the compile root. This is
       *        needed so that the jqLite collection items can be replaced with widgets.
       * @param {number=} maxPriority Max directive priority.
       * @returns {Function} A composite linking function of all of the matched directives or null.
       */
      function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective, previousCompileContext) {
        var linkFns = [],

        // `nodeList` can be either an element's `.childNodes` (live NodeList)
        // or a jqLite/jQuery collection or an array
        notLiveList = isArray(nodeList) || nodeList instanceof jqLite,
            attrs,
            directives,
            nodeLinkFn,
            childNodes,
            childLinkFn,
            linkFnFound,
            nodeLinkFnFound;

        for (var i = 0; i < nodeList.length; i++) {
          attrs = new Attributes();

          // Support: IE 11 only
          // Workaround for #11781 and #14924
          if (msie === 11) {
            mergeConsecutiveTextNodes(nodeList, i, notLiveList);
          }

          // We must always refer to `nodeList[i]` hereafter,
          // since the nodes can be replaced underneath us.
          directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined, ignoreDirective);

          nodeLinkFn = directives.length ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement, null, [], [], previousCompileContext) : null;

          if (nodeLinkFn && nodeLinkFn.scope) {
            compile.$$addScopeClass(attrs.$$element);
          }

          childLinkFn = nodeLinkFn && nodeLinkFn.terminal || !(childNodes = nodeList[i].childNodes) || !childNodes.length ? null : compileNodes(childNodes, nodeLinkFn ? (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement) && nodeLinkFn.transclude : transcludeFn);

          if (nodeLinkFn || childLinkFn) {
            linkFns.push(i, nodeLinkFn, childLinkFn);
            linkFnFound = true;
            nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
          }

          //use the previous context only for the first element in the virtual group
          previousCompileContext = null;
        }

        // return a linking function if we have found anything, null otherwise
        return linkFnFound ? compositeLinkFn : null;

        function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
          var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
          var stableNodeList;

          if (nodeLinkFnFound) {
            // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
            // offsets don't get screwed up
            var nodeListLength = nodeList.length;
            stableNodeList = new Array(nodeListLength);

            // create a sparse array by only copying the elements which have a linkFn
            for (i = 0; i < linkFns.length; i += 3) {
              idx = linkFns[i];
              stableNodeList[idx] = nodeList[idx];
            }
          } else {
            stableNodeList = nodeList;
          }

          for (i = 0, ii = linkFns.length; i < ii;) {
            node = stableNodeList[linkFns[i++]];
            nodeLinkFn = linkFns[i++];
            childLinkFn = linkFns[i++];

            if (nodeLinkFn) {
              if (nodeLinkFn.scope) {
                childScope = scope.$new();
                compile.$$addScopeInfo(jqLite(node), childScope);
              } else {
                childScope = scope;
              }

              if (nodeLinkFn.transcludeOnThisElement) {
                childBoundTranscludeFn = createBoundTranscludeFn(scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
              } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
                childBoundTranscludeFn = parentBoundTranscludeFn;
              } else if (!parentBoundTranscludeFn && transcludeFn) {
                childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
              } else {
                childBoundTranscludeFn = null;
              }

              nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
            } else if (childLinkFn) {
              childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
            }
          }
        }
      }

      function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
        var node = nodeList[idx];
        var parent = node.parentNode;
        var sibling;

        if (node.nodeType !== NODE_TYPE_TEXT) {
          return;
        }

        while (true) {
          sibling = parent ? node.nextSibling : nodeList[idx + 1];
          if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
            break;
          }

          node.nodeValue = node.nodeValue + sibling.nodeValue;

          if (sibling.parentNode) {
            sibling.parentNode.removeChild(sibling);
          }
          if (notLiveList && sibling === nodeList[idx + 1]) {
            nodeList.splice(idx + 1, 1);
          }
        }
      }

      function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
        function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {

          if (!transcludedScope) {
            transcludedScope = scope.$new(false, containingScope);
            transcludedScope.$$transcluded = true;
          }

          return transcludeFn(transcludedScope, cloneFn, {
            parentBoundTranscludeFn: previousBoundTranscludeFn,
            transcludeControllers: controllers,
            futureParentElement: futureParentElement
          });
        }

        // We need  to attach the transclusion slots onto the `boundTranscludeFn`
        // so that they are available inside the `controllersBoundTransclude` function
        var boundSlots = boundTranscludeFn.$$slots = createMap();
        for (var slotName in transcludeFn.$$slots) {
          if (transcludeFn.$$slots[slotName]) {
            boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
          } else {
            boundSlots[slotName] = null;
          }
        }

        return boundTranscludeFn;
      }

      /**
       * Looks for directives on the given node and adds them to the directive collection which is
       * sorted.
       *
       * @param node Node to search.
       * @param directives An array to which the directives are added to. This array is sorted before
       *        the function returns.
       * @param attrs The shared attrs object which is used to populate the normalized attributes.
       * @param {number=} maxPriority Max directive priority.
       */
      function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
        var nodeType = node.nodeType,
            attrsMap = attrs.$attr,
            match,
            nodeName,
            className;

        switch (nodeType) {
          case NODE_TYPE_ELEMENT:
            /* Element */

            nodeName = nodeName_(node);

            // use the node name: <directive>
            addDirective(directives, directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);

            // iterate over the attributes
            for (var attr, name, nName, ngAttrName, value, isNgAttr, nAttrs = node.attributes, j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
              var attrStartName = false;
              var attrEndName = false;

              attr = nAttrs[j];
              name = attr.name;
              value = attr.value;

              // support ngAttr attribute binding
              ngAttrName = directiveNormalize(name);
              isNgAttr = NG_ATTR_BINDING.test(ngAttrName);
              if (isNgAttr) {
                name = name.replace(PREFIX_REGEXP, '').substr(8).replace(/_(.)/g, function (match, letter) {
                  return letter.toUpperCase();
                });
              }

              var multiElementMatch = ngAttrName.match(MULTI_ELEMENT_DIR_RE);
              if (multiElementMatch && directiveIsMultiElement(multiElementMatch[1])) {
                attrStartName = name;
                attrEndName = name.substr(0, name.length - 5) + 'end';
                name = name.substr(0, name.length - 6);
              }

              nName = directiveNormalize(name.toLowerCase());
              attrsMap[nName] = name;
              if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                attrs[nName] = value;
                if (getBooleanAttrName(node, nName)) {
                  attrs[nName] = true; // presence means true
                }
              }
              addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
              addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName, attrEndName);
            }

            if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
              // Hidden input elements can have strange behaviour when navigating back to the page
              // This tells the browser not to try to cache and reinstate previous values
              node.setAttribute('autocomplete', 'off');
            }

            // use class as directive
            if (!cssClassDirectivesEnabled) break;
            className = node.className;
            if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
            }
            if (isString(className) && className !== '') {
              while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
                nName = directiveNormalize(match[2]);
                if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                  attrs[nName] = trim(match[3]);
                }
                className = className.substr(match.index + match[0].length);
              }
            }
            break;
          case NODE_TYPE_TEXT:
            /* Text Node */
            addTextInterpolateDirective(directives, node.nodeValue);
            break;
          case NODE_TYPE_COMMENT:
            /* Comment */
            if (!commentDirectivesEnabled) break;
            collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
            break;
        }

        directives.sort(byPriority);
        return directives;
      }

      function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
        // function created because of performance, try/catch disables
        // the optimization of the whole function #14848
        try {
          var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
          if (match) {
            var nName = directiveNormalize(match[1]);
            if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
              attrs[nName] = trim(match[2]);
            }
          }
        } catch (e) {
          // turns out that under some circumstances IE9 throws errors when one attempts to read
          // comment's node value.
          // Just ignore it and continue. (Can't seem to reproduce in test case.)
        }
      }

      /**
       * Given a node with a directive-start it collects all of the siblings until it finds
       * directive-end.
       * @param node
       * @param attrStart
       * @param attrEnd
       * @returns {*}
       */
      function groupScan(node, attrStart, attrEnd) {
        var nodes = [];
        var depth = 0;
        if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
          do {
            if (!node) {
              throw $compileMinErr('uterdir', 'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.', attrStart, attrEnd);
            }
            if (node.nodeType === NODE_TYPE_ELEMENT) {
              if (node.hasAttribute(attrStart)) depth++;
              if (node.hasAttribute(attrEnd)) depth--;
            }
            nodes.push(node);
            node = node.nextSibling;
          } while (depth > 0);
        } else {
          nodes.push(node);
        }

        return jqLite(nodes);
      }

      /**
       * Wrapper for linking function which converts normal linking function into a grouped
       * linking function.
       * @param linkFn
       * @param attrStart
       * @param attrEnd
       * @returns {Function}
       */
      function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
        return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
          element = groupScan(element[0], attrStart, attrEnd);
          return linkFn(scope, element, attrs, controllers, transcludeFn);
        };
      }

      /**
       * A function generator that is used to support both eager and lazy compilation
       * linking function.
       * @param eager
       * @param $compileNodes
       * @param transcludeFn
       * @param maxPriority
       * @param ignoreDirective
       * @param previousCompileContext
       * @returns {Function}
       */
      function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
        var compiled;

        if (eager) {
          return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
        }
        return (/** @this */function lazyCompilation() {
            if (!compiled) {
              compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

              // Null out all of these references in order to make them eligible for garbage collection
              // since this is a potentially long lived closure
              $compileNodes = transcludeFn = previousCompileContext = null;
            }
            return compiled.apply(this, arguments);
          }
        );
      }

      /**
       * Once the directives have been collected, their compile functions are executed. This method
       * is responsible for inlining directive templates as well as terminating the application
       * of the directives if the terminal directive has been reached.
       *
       * @param {Array} directives Array of collected directives to execute their compile function.
       *        this needs to be pre-sorted by priority order.
       * @param {Node} compileNode The raw DOM node to apply the compile functions to
       * @param {Object} templateAttrs The shared attribute function
       * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
       *                                                  scope argument is auto-generated to the new
       *                                                  child of the transcluded parent scope.
       * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
       *                              argument has the root jqLite array so that we can replace nodes
       *                              on it.
       * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
       *                                           compiling the transclusion.
       * @param {Array.<Function>} preLinkFns
       * @param {Array.<Function>} postLinkFns
       * @param {Object} previousCompileContext Context used for previous compilation of the current
       *                                        node
       * @returns {Function} linkFn
       */
      function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn, jqCollection, originalReplaceDirective, preLinkFns, postLinkFns, previousCompileContext) {
        previousCompileContext = previousCompileContext || {};

        var terminalPriority = -Number.MAX_VALUE,
            newScopeDirective = previousCompileContext.newScopeDirective,
            controllerDirectives = previousCompileContext.controllerDirectives,
            newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
            templateDirective = previousCompileContext.templateDirective,
            nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
            hasTranscludeDirective = false,
            hasTemplate = false,
            hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
            $compileNode = templateAttrs.$$element = jqLite(compileNode),
            directive,
            directiveName,
            $template,
            replaceDirective = originalReplaceDirective,
            childTranscludeFn = transcludeFn,
            linkFn,
            didScanForMultipleTransclusion = false,
            mightHaveMultipleTransclusionError = false,
            directiveValue;

        // executes all directives on the current element
        for (var i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          var attrStart = directive.$$start;
          var attrEnd = directive.$$end;

          // collect multiblock sections
          if (attrStart) {
            $compileNode = groupScan(compileNode, attrStart, attrEnd);
          }
          $template = undefined;

          if (terminalPriority > directive.priority) {
            break; // prevent further processing of directives
          }

          directiveValue = directive.scope;

          if (directiveValue) {

            // skip the check for directives with async templates, we'll check the derived sync
            // directive when the template arrives
            if (!directive.templateUrl) {
              if (isObject(directiveValue)) {
                // This directive is trying to add an isolated scope.
                // Check that there is no scope of any kind already
                assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective, directive, $compileNode);
                newIsolateScopeDirective = directive;
              } else {
                // This directive is trying to add a child scope.
                // Check that there is no isolated scope already
                assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive, $compileNode);
              }
            }

            newScopeDirective = newScopeDirective || directive;
          }

          directiveName = directive.name;

          // If we encounter a condition that can result in transclusion on the directive,
          // then scan ahead in the remaining directives for others that may cause a multiple
          // transclusion error to be thrown during the compilation process.  If a matching directive
          // is found, then we know that when we encounter a transcluded directive, we need to eagerly
          // compile the `transclude` function rather than doing it lazily in order to throw
          // exceptions at the correct time
          if (!didScanForMultipleTransclusion && (directive.replace && (directive.templateUrl || directive.template) || directive.transclude && !directive.$$tlb)) {
            var candidateDirective;

            for (var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];) {
              if (candidateDirective.transclude && !candidateDirective.$$tlb || candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template)) {
                mightHaveMultipleTransclusionError = true;
                break;
              }
            }

            didScanForMultipleTransclusion = true;
          }

          if (!directive.templateUrl && directive.controller) {
            controllerDirectives = controllerDirectives || createMap();
            assertNoDuplicate('\'' + directiveName + '\' controller', controllerDirectives[directiveName], directive, $compileNode);
            controllerDirectives[directiveName] = directive;
          }

          directiveValue = directive.transclude;

          if (directiveValue) {
            hasTranscludeDirective = true;

            // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
            // This option should only be used by directives that know how to safely handle element transclusion,
            // where the transcluded nodes are added or replaced after linking.
            if (!directive.$$tlb) {
              assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
              nonTlbTranscludeDirective = directive;
            }

            if (directiveValue === 'element') {
              hasElementTranscludeDirective = true;
              terminalPriority = directive.priority;
              $template = $compileNode;
              $compileNode = templateAttrs.$$element = jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
              compileNode = $compileNode[0];
              replaceWith(jqCollection, sliceArgs($template), compileNode);

              // Support: Chrome < 50
              // https://github.com/angular/angular.js/issues/14041

              // In the versions of V8 prior to Chrome 50, the document fragment that is created
              // in the `replaceWith` function is improperly garbage collected despite still
              // being referenced by the `parentNode` property of all of the child nodes.  By adding
              // a reference to the fragment via a different property, we can avoid that incorrect
              // behavior.
              // TODO: remove this line after Chrome 50 has been released
              $template[0].$$parentNode = $template[0].parentNode;

              childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority, replaceDirective && replaceDirective.name, {
                // Don't pass in:
                // - controllerDirectives - otherwise we'll create duplicates controllers
                // - newIsolateScopeDirective or templateDirective - combining templates with
                //   element transclusion doesn't make sense.
                //
                // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                // on the same element more than once.
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
            } else {

              var slots = createMap();

              if (!isObject(directiveValue)) {
                $template = jqLite(jqLiteClone(compileNode)).contents();
              } else {

                // We have transclusion slots,
                // collect them up, compile them and store their transclusion functions
                $template = [];

                var slotMap = createMap();
                var filledSlots = createMap();

                // Parse the element selectors
                forEach(directiveValue, function (elementSelector, slotName) {
                  // If an element selector starts with a ? then it is optional
                  var optional = elementSelector.charAt(0) === '?';
                  elementSelector = optional ? elementSelector.substring(1) : elementSelector;

                  slotMap[elementSelector] = slotName;

                  // We explicitly assign `null` since this implies that a slot was defined but not filled.
                  // Later when calling boundTransclusion functions with a slot name we only error if the
                  // slot is `undefined`
                  slots[slotName] = null;

                  // filledSlots contains `true` for all slots that are either optional or have been
                  // filled. This is used to check that we have not missed any required slots
                  filledSlots[slotName] = optional;
                });

                // Add the matching elements into their slot
                forEach($compileNode.contents(), function (node) {
                  var slotName = slotMap[directiveNormalize(nodeName_(node))];
                  if (slotName) {
                    filledSlots[slotName] = true;
                    slots[slotName] = slots[slotName] || [];
                    slots[slotName].push(node);
                  } else {
                    $template.push(node);
                  }
                });

                // Check for required slots that were not filled
                forEach(filledSlots, function (filled, slotName) {
                  if (!filled) {
                    throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                  }
                });

                for (var slotName in slots) {
                  if (slots[slotName]) {
                    // Only define a transclusion function if the slot was filled
                    slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slots[slotName], transcludeFn);
                  }
                }
              }

              $compileNode.empty(); // clear contents
              childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined, undefined, { needsNewScope: directive.$$isolateScope || directive.$$newScope });
              childTranscludeFn.$$slots = slots;
            }
          }

          if (directive.template) {
            hasTemplate = true;
            assertNoDuplicate('template', templateDirective, directive, $compileNode);
            templateDirective = directive;

            directiveValue = isFunction(directive.template) ? directive.template($compileNode, templateAttrs) : directive.template;

            directiveValue = denormalizeTemplate(directiveValue);

            if (directive.replace) {
              replaceDirective = directive;
              if (jqLiteIsTextNode(directiveValue)) {
                $template = [];
              } else {
                $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
              }
              compileNode = $template[0];

              if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
                throw $compileMinErr('tplrt', 'Template for directive \'{0}\' must have exactly one root element. {1}', directiveName, '');
              }

              replaceWith(jqCollection, $compileNode, compileNode);

              var newTemplateAttrs = { $attr: {} };

              // combine directives from the original node and from the template:
              // - take the array of directives for this element
              // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
              // - collect directives from the template and sort them by priority
              // - combine directives as: processed + template + unprocessed
              var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
              var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));

              if (newIsolateScopeDirective || newScopeDirective) {
                // The original directive caused the current element to be replaced but this element
                // also needs to have a new scope, so we need to tell the template directives
                // that they would need to get their scope from further up, if they require transclusion
                markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
              }
              directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
              mergeTemplateAttributes(templateAttrs, newTemplateAttrs);

              ii = directives.length;
            } else {
              $compileNode.html(directiveValue);
            }
          }

          if (directive.templateUrl) {
            hasTemplate = true;
            assertNoDuplicate('template', templateDirective, directive, $compileNode);
            templateDirective = directive;

            if (directive.replace) {
              replaceDirective = directive;
            }

            // eslint-disable-next-line no-func-assign
            nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode, templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
              controllerDirectives: controllerDirectives,
              newScopeDirective: newScopeDirective !== directive && newScopeDirective,
              newIsolateScopeDirective: newIsolateScopeDirective,
              templateDirective: templateDirective,
              nonTlbTranscludeDirective: nonTlbTranscludeDirective
            });
            ii = directives.length;
          } else if (directive.compile) {
            try {
              linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
              var context = directive.$$originalDirective || directive;
              if (isFunction(linkFn)) {
                addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
              } else if (linkFn) {
                addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
              }
            } catch (e) {
              $exceptionHandler(e, startingTag($compileNode));
            }
          }

          if (directive.terminal) {
            nodeLinkFn.terminal = true;
            terminalPriority = Math.max(terminalPriority, directive.priority);
          }
        }

        nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
        nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
        nodeLinkFn.templateOnThisElement = hasTemplate;
        nodeLinkFn.transclude = childTranscludeFn;

        previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

        // might be normal or delayed nodeLinkFn depending on if templateUrl is present
        return nodeLinkFn;

        ////////////////////

        function addLinkFns(pre, post, attrStart, attrEnd) {
          if (pre) {
            if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
            pre.require = directive.require;
            pre.directiveName = directiveName;
            if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
              pre = cloneAndAnnotateFn(pre, { isolateScope: true });
            }
            preLinkFns.push(pre);
          }
          if (post) {
            if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
            post.require = directive.require;
            post.directiveName = directiveName;
            if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
              post = cloneAndAnnotateFn(post, { isolateScope: true });
            }
            postLinkFns.push(post);
          }
        }

        function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
          var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element, attrs, scopeBindingInfo;

          if (compileNode === linkNode) {
            attrs = templateAttrs;
            $element = templateAttrs.$$element;
          } else {
            $element = jqLite(linkNode);
            attrs = new Attributes($element, templateAttrs);
          }

          controllerScope = scope;
          if (newIsolateScopeDirective) {
            isolateScope = scope.$new(true);
          } else if (newScopeDirective) {
            controllerScope = scope.$parent;
          }

          if (boundTranscludeFn) {
            // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
            // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
            transcludeFn = controllersBoundTransclude;
            transcludeFn.$$boundTransclude = boundTranscludeFn;
            // expose the slots on the `$transclude` function
            transcludeFn.isSlotFilled = function (slotName) {
              return !!boundTranscludeFn.$$slots[slotName];
            };
          }

          if (controllerDirectives) {
            elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
          }

          if (newIsolateScopeDirective) {
            // Initialize isolate scope bindings for new isolate scope directive.
            compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective || templateDirective === newIsolateScopeDirective.$$originalDirective)));
            compile.$$addScopeClass($element, true);
            isolateScope.$$isolateBindings = newIsolateScopeDirective.$$isolateBindings;
            scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope, isolateScope.$$isolateBindings, newIsolateScopeDirective);
            if (scopeBindingInfo.removeWatches) {
              isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
            }
          }

          // Initialize bindToController bindings
          for (var name in elementControllers) {
            var controllerDirective = controllerDirectives[name];
            var controller = elementControllers[name];
            var bindings = controllerDirective.$$bindings.bindToController;

            if (preAssignBindingsEnabled) {
              if (bindings) {
                controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
              } else {
                controller.bindingInfo = {};
              }

              var controllerResult = controller();
              if (controllerResult !== controller.instance) {
                // If the controller constructor has a return value, overwrite the instance
                // from setupControllers
                controller.instance = controllerResult;
                $element.data('$' + controllerDirective.name + 'Controller', controllerResult);
                if (controller.bindingInfo.removeWatches) {
                  controller.bindingInfo.removeWatches();
                }
                controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
              }
            } else {
              controller.instance = controller();
              $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
              controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
            }
          }

          // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
          forEach(controllerDirectives, function (controllerDirective, name) {
            var require = controllerDirective.require;
            if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
              extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
            }
          });

          // Handle the init and destroy lifecycle hooks on all controllers that have them
          forEach(elementControllers, function (controller) {
            var controllerInstance = controller.instance;
            if (isFunction(controllerInstance.$onChanges)) {
              try {
                controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
              } catch (e) {
                $exceptionHandler(e);
              }
            }
            if (isFunction(controllerInstance.$onInit)) {
              try {
                controllerInstance.$onInit();
              } catch (e) {
                $exceptionHandler(e);
              }
            }
            if (isFunction(controllerInstance.$doCheck)) {
              controllerScope.$watch(function () {
                controllerInstance.$doCheck();
              });
              controllerInstance.$doCheck();
            }
            if (isFunction(controllerInstance.$onDestroy)) {
              controllerScope.$on('$destroy', function callOnDestroyHook() {
                controllerInstance.$onDestroy();
              });
            }
          });

          // PRELINKING
          for (i = 0, ii = preLinkFns.length; i < ii; i++) {
            linkFn = preLinkFns[i];
            invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
          }

          // RECURSION
          // We only pass the isolate scope, if the isolate directive has a template,
          // otherwise the child elements do not belong to the isolate directive.
          var scopeToChild = scope;
          if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
            scopeToChild = isolateScope;
          }
          if (childLinkFn) {
            childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
          }

          // POSTLINKING
          for (i = postLinkFns.length - 1; i >= 0; i--) {
            linkFn = postLinkFns[i];
            invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
          }

          // Trigger $postLink lifecycle hooks
          forEach(elementControllers, function (controller) {
            var controllerInstance = controller.instance;
            if (isFunction(controllerInstance.$postLink)) {
              controllerInstance.$postLink();
            }
          });

          // This is the function that is injected as `$transclude`.
          // Note: all arguments are optional!
          function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
            var transcludeControllers;
            // No scope passed in:
            if (!isScope(scope)) {
              slotName = futureParentElement;
              futureParentElement = cloneAttachFn;
              cloneAttachFn = scope;
              scope = undefined;
            }

            if (hasElementTranscludeDirective) {
              transcludeControllers = elementControllers;
            }
            if (!futureParentElement) {
              futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
            }
            if (slotName) {
              // slotTranscludeFn can be one of three things:
              //  * a transclude function - a filled slot
              //  * `null` - an optional slot that was not filled
              //  * `undefined` - a slot that was not declared (i.e. invalid)
              var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
              if (slotTranscludeFn) {
                return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
              } else if (isUndefined(slotTranscludeFn)) {
                throw $compileMinErr('noslot', 'No parent directive that requires a transclusion with slot name "{0}". ' + 'Element: {1}', slotName, startingTag($element));
              }
            } else {
              return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
            }
          }
        }
      }

      function getControllers(directiveName, require, $element, elementControllers) {
        var value;

        if (isString(require)) {
          var match = require.match(REQUIRE_PREFIX_REGEXP);
          var name = require.substring(match[0].length);
          var inheritType = match[1] || match[3];
          var optional = match[2] === '?';

          //If only parents then start at the parent element
          if (inheritType === '^^') {
            $element = $element.parent();
            //Otherwise attempt getting the controller from elementControllers in case
            //the element is transcluded (and has no data) and to avoid .data if possible
          } else {
            value = elementControllers && elementControllers[name];
            value = value && value.instance;
          }

          if (!value) {
            var dataName = '$' + name + 'Controller';
            value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
          }

          if (!value && !optional) {
            throw $compileMinErr('ctreq', 'Controller \'{0}\', required by directive \'{1}\', can\'t be found!', name, directiveName);
          }
        } else if (isArray(require)) {
          value = [];
          for (var i = 0, ii = require.length; i < ii; i++) {
            value[i] = getControllers(directiveName, require[i], $element, elementControllers);
          }
        } else if (isObject(require)) {
          value = {};
          forEach(require, function (controller, property) {
            value[property] = getControllers(directiveName, controller, $element, elementControllers);
          });
        }

        return value || null;
      }

      function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
        var elementControllers = createMap();
        for (var controllerKey in controllerDirectives) {
          var directive = controllerDirectives[controllerKey];
          var locals = {
            $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
            $element: $element,
            $attrs: attrs,
            $transclude: transcludeFn
          };

          var controller = directive.controller;
          if (controller === '@') {
            controller = attrs[directive.name];
          }

          var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

          // For directives with element transclusion the element is a comment.
          // In this case .data will not attach any data.
          // Instead, we save the controllers for the element in a local hash and attach to .data
          // later, once we have the actual element.
          elementControllers[directive.name] = controllerInstance;
          $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
        }
        return elementControllers;
      }

      // Depending upon the context in which a directive finds itself it might need to have a new isolated
      // or child scope created. For instance:
      // * if the directive has been pulled into a template because another directive with a higher priority
      // asked for element transclusion
      // * if the directive itself asks for transclusion but it is at the root of a template and the original
      // element was replaced. See https://github.com/angular/angular.js/issues/12936
      function markDirectiveScope(directives, isolateScope, newScope) {
        for (var j = 0, jj = directives.length; j < jj; j++) {
          directives[j] = inherit(directives[j], { $$isolateScope: isolateScope, $$newScope: newScope });
        }
      }

      /**
       * looks up the directive and decorates it with exception handling and proper parameters. We
       * call this the boundDirective.
       *
       * @param {string} name name of the directive to look up.
       * @param {string} location The directive must be found in specific format.
       *   String containing any of theses characters:
       *
       *   * `E`: element name
       *   * `A': attribute
       *   * `C`: class
       *   * `M`: comment
       * @returns {boolean} true if directive was added.
       */
      function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName, endAttrName) {
        if (name === ignoreDirective) return null;
        var match = null;
        if (hasDirectives.hasOwnProperty(name)) {
          for (var directive, directives = $injector.get(name + Suffix), i = 0, ii = directives.length; i < ii; i++) {
            directive = directives[i];
            if ((isUndefined(maxPriority) || maxPriority > directive.priority) && directive.restrict.indexOf(location) !== -1) {
              if (startAttrName) {
                directive = inherit(directive, { $$start: startAttrName, $$end: endAttrName });
              }
              if (!directive.$$bindings) {
                var bindings = directive.$$bindings = parseDirectiveBindings(directive, directive.name);
                if (isObject(bindings.isolateScope)) {
                  directive.$$isolateBindings = bindings.isolateScope;
                }
              }
              tDirectives.push(directive);
              match = directive;
            }
          }
        }
        return match;
      }

      /**
       * looks up the directive and returns true if it is a multi-element directive,
       * and therefore requires DOM nodes between -start and -end markers to be grouped
       * together.
       *
       * @param {string} name name of the directive to look up.
       * @returns true if directive was registered as multi-element.
       */
      function directiveIsMultiElement(name) {
        if (hasDirectives.hasOwnProperty(name)) {
          for (var directive, directives = $injector.get(name + Suffix), i = 0, ii = directives.length; i < ii; i++) {
            directive = directives[i];
            if (directive.multiElement) {
              return true;
            }
          }
        }
        return false;
      }

      /**
       * When the element is replaced with HTML template then the new attributes
       * on the template need to be merged with the existing attributes in the DOM.
       * The desired effect is to have both of the attributes present.
       *
       * @param {object} dst destination attributes (original DOM)
       * @param {object} src source attributes (from the directive template)
       */
      function mergeTemplateAttributes(dst, src) {
        var srcAttr = src.$attr,
            dstAttr = dst.$attr;

        // reapply the old attributes to the new element
        forEach(dst, function (value, key) {
          if (key.charAt(0) !== '$') {
            if (src[key] && src[key] !== value) {
              if (value.length) {
                value += (key === 'style' ? ';' : ' ') + src[key];
              } else {
                value = src[key];
              }
            }
            dst.$set(key, value, true, srcAttr[key]);
          }
        });

        // copy the new attributes on the old attrs object
        forEach(src, function (value, key) {
          // Check if we already set this attribute in the loop above.
          // `dst` will never contain hasOwnProperty as DOM parser won't let it.
          // You will get an "InvalidCharacterError: DOM Exception 5" error if you
          // have an attribute like "has-own-property" or "data-has-own-property", etc.
          if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
            dst[key] = value;

            if (key !== 'class' && key !== 'style') {
              dstAttr[key] = srcAttr[key];
            }
          }
        });
      }

      function compileTemplateUrl(directives, $compileNode, tAttrs, $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
        var linkQueue = [],
            afterTemplateNodeLinkFn,
            afterTemplateChildLinkFn,
            beforeTemplateCompileNode = $compileNode[0],
            origAsyncDirective = directives.shift(),
            derivedSyncDirective = inherit(origAsyncDirective, {
          templateUrl: null, transclude: null, replace: null, $$originalDirective: origAsyncDirective
        }),
            templateUrl = isFunction(origAsyncDirective.templateUrl) ? origAsyncDirective.templateUrl($compileNode, tAttrs) : origAsyncDirective.templateUrl,
            templateNamespace = origAsyncDirective.templateNamespace;

        $compileNode.empty();

        $templateRequest(templateUrl).then(function (content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;

          content = denormalizeTemplate(content);

          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];

            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt', 'Template for directive \'{0}\' must have exactly one root element. {1}', origAsyncDirective.name, templateUrl);
            }

            tempTemplateAttrs = { $attr: {} };
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);

            if (isObject(origAsyncDirective.scope)) {
              // the original directive that caused the template to be loaded async required
              // an isolate scope
              markDirectiveScope(templateDirectives, true);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }

          directives.unshift(derivedSyncDirective);

          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs, childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns, previousCompileContext);
          forEach($rootElement, function (node, i) {
            if (node === compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);

          while (linkQueue.length) {
            var scope = linkQueue.shift(),
                beforeTemplateLinkNode = linkQueue.shift(),
                linkRootElement = linkQueue.shift(),
                boundTranscludeFn = linkQueue.shift(),
                linkNode = $compileNode[0];

            if (scope.$$destroyed) continue;

            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;

              if (!(previousCompileContext.hasElementTranscludeDirective && origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement, childBoundTranscludeFn);
          }
          linkQueue = null;
        }).catch(function (error) {
          if (isError(error)) {
            $exceptionHandler(error);
          }
        });

        return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
          var childBoundTranscludeFn = boundTranscludeFn;
          if (scope.$$destroyed) return;
          if (linkQueue) {
            linkQueue.push(scope, node, rootElement, childBoundTranscludeFn);
          } else {
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
          }
        };
      }

      /**
       * Sorting function for bound directives.
       */
      function byPriority(a, b) {
        var diff = b.priority - a.priority;
        if (diff !== 0) return diff;
        if (a.name !== b.name) return a.name < b.name ? -1 : 1;
        return a.index - b.index;
      }

      function assertNoDuplicate(what, previousDirective, directive, element) {

        function wrapModuleNameIfDefined(moduleName) {
          return moduleName ? ' (module: ' + moduleName + ')' : '';
        }

        if (previousDirective) {
          throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}', previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName), directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
        }
      }

      function addTextInterpolateDirective(directives, text) {
        var interpolateFn = $interpolate(text, true);
        if (interpolateFn) {
          directives.push({
            priority: 0,
            compile: function textInterpolateCompileFn(templateNode) {
              var templateNodeParent = templateNode.parent(),
                  hasCompileParent = !!templateNodeParent.length;

              // When transcluding a template that has bindings in the root
              // we don't have a parent and thus need to add the class during linking fn.
              if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);

              return function textInterpolateLinkFn(scope, node) {
                var parent = node.parent();
                if (!hasCompileParent) compile.$$addBindingClass(parent);
                compile.$$addBindingInfo(parent, interpolateFn.expressions);
                scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                  node[0].nodeValue = value;
                });
              };
            }
          });
        }
      }

      function wrapTemplate(type, template) {
        type = lowercase(type || 'html');
        switch (type) {
          case 'svg':
          case 'math':
            var wrapper = window.document.createElement('div');
            wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
            return wrapper.childNodes[0].childNodes;
          default:
            return template;
        }
      }

      function getTrustedContext(node, attrNormalizedName) {
        if (attrNormalizedName === 'srcdoc') {
          return $sce.HTML;
        }
        var tag = nodeName_(node);
        // All tags with src attributes require a RESOURCE_URL value, except for
        // img and various html5 media tags.
        if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
          if (['img', 'video', 'audio', 'source', 'track'].indexOf(tag) === -1) {
            return $sce.RESOURCE_URL;
          }
          // maction[xlink:href] can source SVG.  It's not limited to <maction>.
        } else if (attrNormalizedName === 'xlinkHref' || tag === 'form' && attrNormalizedName === 'action' ||
        // links can be stylesheets or imports, which can run script in the current origin
        tag === 'link' && attrNormalizedName === 'href') {
          return $sce.RESOURCE_URL;
        }
      }

      function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
        var trustedContext = getTrustedContext(node, name);
        var mustHaveExpression = !isNgAttr;
        var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;

        var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);

        // no interpolation found -> ignore
        if (!interpolateFn) return;

        if (name === 'multiple' && nodeName_(node) === 'select') {
          throw $compileMinErr('selmulti', 'Binding to the \'multiple\' attribute is not supported. Element: {0}', startingTag(node));
        }

        if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
          throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed.  Please use the ' + 'ng- versions (such as ng-click instead of onclick) instead.');
        }

        directives.push({
          priority: 100,
          compile: function compile() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = attr.$$observers || (attr.$$observers = createMap());

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);

                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).$watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                  //special case for class attribute addition + removal
                  //so that class changes can tap into the animation
                  //hooks provided by the $animate service. Be sure to
                  //skip animations when the first digest occurs (when
                  //both the new and the old values are the same) since
                  //the CSS classes are the non-interpolated values
                  if (name === 'class' && newValue !== oldValue) {
                    attr.$updateClass(newValue, oldValue);
                  } else {
                    attr.$set(name, newValue);
                  }
                });
              }
            };
          }
        });
      }

      /**
       * This is a special jqLite.replaceWith, which can replace items which
       * have no parents, provided that the containing jqLite collection is provided.
       *
       * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
       *                               in the root of the tree.
       * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
       *                                  the shell, but replace its DOM node reference.
       * @param {Node} newNode The new DOM node.
       */
      function replaceWith($rootElement, elementsToRemove, newNode) {
        var firstElementToRemove = elementsToRemove[0],
            removeCount = elementsToRemove.length,
            parent = firstElementToRemove.parentNode,
            i,
            ii;

        if ($rootElement) {
          for (i = 0, ii = $rootElement.length; i < ii; i++) {
            if ($rootElement[i] === firstElementToRemove) {
              $rootElement[i++] = newNode;
              for (var j = i, j2 = j + removeCount - 1, jj = $rootElement.length; j < jj; j++, j2++) {
                if (j2 < jj) {
                  $rootElement[j] = $rootElement[j2];
                } else {
                  delete $rootElement[j];
                }
              }
              $rootElement.length -= removeCount - 1;

              // If the replaced element is also the jQuery .context then replace it
              // .context is a deprecated jQuery api, so we should set it only when jQuery set it
              // http://api.jquery.com/context/
              if ($rootElement.context === firstElementToRemove) {
                $rootElement.context = newNode;
              }
              break;
            }
          }
        }

        if (parent) {
          parent.replaceChild(newNode, firstElementToRemove);
        }

        // Append all the `elementsToRemove` to a fragment. This will...
        // - remove them from the DOM
        // - allow them to still be traversed with .nextSibling
        // - allow a single fragment.qSA to fetch all elements being removed
        var fragment = window.document.createDocumentFragment();
        for (i = 0; i < removeCount; i++) {
          fragment.appendChild(elementsToRemove[i]);
        }

        if (jqLite.hasData(firstElementToRemove)) {
          // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
          // data here because there's no public interface in jQuery to do that and copying over
          // event listeners (which is the main use of private data) wouldn't work anyway.
          jqLite.data(newNode, jqLite.data(firstElementToRemove));

          // Remove $destroy event listeners from `firstElementToRemove`
          jqLite(firstElementToRemove).off('$destroy');
        }

        // Cleanup any data/listeners on the elements and children.
        // This includes invoking the $destroy event on any elements with listeners.
        jqLite.cleanData(fragment.querySelectorAll('*'));

        // Update the jqLite collection to only contain the `newNode`
        for (i = 1; i < removeCount; i++) {
          delete elementsToRemove[i];
        }
        elementsToRemove[0] = newNode;
        elementsToRemove.length = 1;
      }

      function cloneAndAnnotateFn(fn, annotation) {
        return extend(function () {
          return fn.apply(null, arguments);
        }, fn, annotation);
      }

      function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
        try {
          linkFn(scope, $element, attrs, controllers, transcludeFn);
        } catch (e) {
          $exceptionHandler(e, startingTag($element));
        }
      }

      function strictBindingsCheck(attrName, directiveName) {
        if (strictComponentBindingsEnabled) {
          throw $compileMinErr('missingattr', 'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!', attrName, directiveName);
        }
      }

      // Set up $watches for isolate scope and controller bindings.
      function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
        var removeWatchCollection = [];
        var initialChanges = {};
        var changes;

        forEach(bindings, function initializeBinding(definition, scopeName) {
          var attrName = definition.attrName,
              optional = definition.optional,
              mode = definition.mode,
              // @, =, <, or &
          lastValue,
              parentGet,
              parentSet,
              compare,
              removeWatch;

          switch (mode) {

            case '@':
              if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                strictBindingsCheck(attrName, directive.name);
                destination[scopeName] = attrs[attrName] = undefined;
              }
              removeWatch = attrs.$observe(attrName, function (value) {
                if (isString(value) || isBoolean(value)) {
                  var oldValue = destination[scopeName];
                  recordChanges(scopeName, value, oldValue);
                  destination[scopeName] = value;
                }
              });
              attrs.$$observers[attrName].$$scope = scope;
              lastValue = attrs[attrName];
              if (isString(lastValue)) {
                // If the attribute has been provided then we trigger an interpolation to ensure
                // the value is there for use in the link fn
                destination[scopeName] = $interpolate(lastValue)(scope);
              } else if (isBoolean(lastValue)) {
                // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
                // the value to boolean rather than a string, so we special case this situation
                destination[scopeName] = lastValue;
              }
              initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
              removeWatchCollection.push(removeWatch);
              break;

            case '=':
              if (!hasOwnProperty.call(attrs, attrName)) {
                if (optional) break;
                strictBindingsCheck(attrName, directive.name);
                attrs[attrName] = undefined;
              }
              if (optional && !attrs[attrName]) break;

              parentGet = $parse(attrs[attrName]);
              if (parentGet.literal) {
                compare = equals;
              } else {
                compare = simpleCompare;
              }
              parentSet = parentGet.assign || function () {
                // reset the change, or we will throw this exception on every $digest
                lastValue = destination[scopeName] = parentGet(scope);
                throw $compileMinErr('nonassign', 'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!', attrs[attrName], attrName, directive.name);
              };
              lastValue = destination[scopeName] = parentGet(scope);
              var parentValueWatch = function parentValueWatch(parentValue) {
                if (!compare(parentValue, destination[scopeName])) {
                  // we are out of sync and need to copy
                  if (!compare(parentValue, lastValue)) {
                    // parent changed and it has precedence
                    destination[scopeName] = parentValue;
                  } else {
                    // if the parent can be assigned then do so
                    parentSet(scope, parentValue = destination[scopeName]);
                  }
                }
                lastValue = parentValue;
                return lastValue;
              };
              parentValueWatch.$stateful = true;
              if (definition.collection) {
                removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
              } else {
                removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
              }
              removeWatchCollection.push(removeWatch);
              break;

            case '<':
              if (!hasOwnProperty.call(attrs, attrName)) {
                if (optional) break;
                strictBindingsCheck(attrName, directive.name);
                attrs[attrName] = undefined;
              }
              if (optional && !attrs[attrName]) break;

              parentGet = $parse(attrs[attrName]);
              var deepWatch = parentGet.literal;

              var initialValue = destination[scopeName] = parentGet(scope);
              initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);

              removeWatch = scope.$watch(parentGet, function parentValueWatchAction(newValue, oldValue) {
                if (oldValue === newValue) {
                  if (oldValue === initialValue || deepWatch && equals(oldValue, initialValue)) {
                    return;
                  }
                  oldValue = initialValue;
                }
                recordChanges(scopeName, newValue, oldValue);
                destination[scopeName] = newValue;
              }, deepWatch);

              removeWatchCollection.push(removeWatch);
              break;

            case '&':
              if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                strictBindingsCheck(attrName, directive.name);
              }
              // Don't assign Object.prototype method to scope
              parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

              // Don't assign noop to destination if expression is not valid
              if (parentGet === noop && optional) break;

              destination[scopeName] = function (locals) {
                return parentGet(scope, locals);
              };
              break;
          }
        });

        function recordChanges(key, currentValue, previousValue) {
          if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
            // If we have not already scheduled the top level onChangesQueue handler then do so now
            if (!onChangesQueue) {
              scope.$$postDigest(flushOnChangesQueue);
              onChangesQueue = [];
            }
            // If we have not already queued a trigger of onChanges for this controller then do so now
            if (!changes) {
              changes = {};
              onChangesQueue.push(triggerOnChangesHook);
            }
            // If the has been a change on this property already then we need to reuse the previous value
            if (changes[key]) {
              previousValue = changes[key].previousValue;
            }
            // Store this change
            changes[key] = new SimpleChange(previousValue, currentValue);
          }
        }

        function triggerOnChangesHook() {
          destination.$onChanges(changes);
          // Now clear the changes so that we schedule onChanges when more changes arrive
          changes = undefined;
        }

        return {
          initialChanges: initialChanges,
          removeWatches: removeWatchCollection.length && function removeWatches() {
            for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
              removeWatchCollection[i]();
            }
          }
        };
      }
    }];
  }

  function SimpleChange(previous, current) {
    this.previousValue = previous;
    this.currentValue = current;
  }
  SimpleChange.prototype.isFirstChange = function () {
    return this.previousValue === _UNINITIALIZED_VALUE;
  };

  var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
  var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;

  /**
   * Converts all accepted directives format into proper directive name.
   * @param name Name to normalize
   */
  function directiveNormalize(name) {
    return name.replace(PREFIX_REGEXP, '').replace(SPECIAL_CHARS_REGEXP, function (_, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    });
  }

  /**
   * @ngdoc type
   * @name $compile.directive.Attributes
   *
   * @description
   * A shared object between directive compile / linking functions which contains normalized DOM
   * element attributes. The values reflect current binding state `{{ }}`. The normalization is
   * needed since all of these are treated as equivalent in AngularJS:
   *
   * ```
   *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
   * ```
   */

  /**
   * @ngdoc property
   * @name $compile.directive.Attributes#$attr
   *
   * @description
   * A map of DOM element attribute names to the normalized name. This is
   * needed to do reverse lookup from normalized name back to actual name.
   */

  /**
   * @ngdoc method
   * @name $compile.directive.Attributes#$set
   * @kind function
   *
   * @description
   * Set DOM element attribute value.
   *
   *
   * @param {string} name Normalized element attribute name of the property to modify. The name is
   *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
   *          property to the original name.
   * @param {string} value Value to set the attribute to. The value can be an interpolated string.
   */

  /**
   * Closure compiler type information
   */

  function nodesetLinkingFn(
  /* angular.Scope */scope,
  /* NodeList */nodeList,
  /* Element */rootElement,
  /* function(Function) */boundTranscludeFn) {}

  function directiveLinkingFn(
  /* nodesetLinkingFn */nodesetLinkingFn,
  /* angular.Scope */scope,
  /* Node */node,
  /* Element */rootElement,
  /* function(Function) */boundTranscludeFn) {}

  function tokenDifference(str1, str2) {
    var values = '',
        tokens1 = str1.split(/\s+/),
        tokens2 = str2.split(/\s+/);

    outer: for (var i = 0; i < tokens1.length; i++) {
      var token = tokens1[i];
      for (var j = 0; j < tokens2.length; j++) {
        if (token === tokens2[j]) continue outer;
      }
      values += (values.length > 0 ? ' ' : '') + token;
    }
    return values;
  }

  function removeComments(jqNodes) {
    jqNodes = jqLite(jqNodes);
    var i = jqNodes.length;

    if (i <= 1) {
      return jqNodes;
    }

    while (i--) {
      var node = jqNodes[i];
      if (node.nodeType === NODE_TYPE_COMMENT || node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '') {
        splice.call(jqNodes, i, 1);
      }
    }
    return jqNodes;
  }

  var $controllerMinErr = minErr('$controller');

  var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
  function identifierForController(controller, ident) {
    if (ident && isString(ident)) return ident;
    if (isString(controller)) {
      var match = CNTRL_REG.exec(controller);
      if (match) return match[3];
    }
  }

  /**
   * @ngdoc provider
   * @name $controllerProvider
   * @this
   *
   * @description
   * The {@link ng.$controller $controller service} is used by AngularJS to create new
   * controllers.
   *
   * This provider allows controller registration via the
   * {@link ng.$controllerProvider#register register} method.
   */
  function $ControllerProvider() {
    var controllers = {},
        globals = false;

    /**
     * @ngdoc method
     * @name $controllerProvider#has
     * @param {string} name Controller name to check.
     */
    this.has = function (name) {
      return controllers.hasOwnProperty(name);
    };

    /**
     * @ngdoc method
     * @name $controllerProvider#register
     * @param {string|Object} name Controller name, or an object map of controllers where the keys are
     *    the names and the values are the constructors.
     * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
     *    annotations in the array notation).
     */
    this.register = function (name, constructor) {
      assertNotHasOwnProperty(name, 'controller');
      if (isObject(name)) {
        extend(controllers, name);
      } else {
        controllers[name] = constructor;
      }
    };

    /**
     * @ngdoc method
     * @name $controllerProvider#allowGlobals
     * @description If called, allows `$controller` to find controller constructors on `window`
     *
     * @deprecated
     * sinceVersion="v1.3.0"
     * removeVersion="v1.7.0"
     * This method of finding controllers has been deprecated.
     */
    this.allowGlobals = function () {
      globals = true;
    };

    this.$get = ['$injector', '$window', function ($injector, $window) {

      /**
       * @ngdoc service
       * @name $controller
       * @requires $injector
       *
       * @param {Function|string} constructor If called with a function then it's considered to be the
       *    controller constructor function. Otherwise it's considered to be a string which is used
       *    to retrieve the controller constructor using the following steps:
       *
       *    * check if a controller with given name is registered via `$controllerProvider`
       *    * check if evaluating the string on the current scope returns a constructor
       *    * if $controllerProvider#allowGlobals, check `window[constructor]` on the global
       *      `window` object (deprecated, not recommended)
       *
       *    The string can use the `controller as property` syntax, where the controller instance is published
       *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
       *    to work correctly.
       *
       * @param {Object} locals Injection locals for Controller.
       * @return {Object} Instance of given controller.
       *
       * @description
       * `$controller` service is responsible for instantiating controllers.
       *
       * It's just a simple call to {@link auto.$injector $injector}, but extracted into
       * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
       */
      return function $controller(expression, locals, later, ident) {
        // PRIVATE API:
        //   param `later` --- indicates that the controller's constructor is invoked at a later time.
        //                     If true, $controller will allocate the object with the correct
        //                     prototype chain, but will not invoke the controller until a returned
        //                     callback is invoked.
        //   param `ident` --- An optional label which overrides the label parsed from the controller
        //                     expression, if any.
        var instance, match, constructor, identifier;
        later = later === true;
        if (ident && isString(ident)) {
          identifier = ident;
        }

        if (isString(expression)) {
          match = expression.match(CNTRL_REG);
          if (!match) {
            throw $controllerMinErr('ctrlfmt', 'Badly formed controller string \'{0}\'. ' + 'Must match `__name__ as __id__` or `__name__`.', expression);
          }
          constructor = match[1];
          identifier = identifier || match[3];
          expression = controllers.hasOwnProperty(constructor) ? controllers[constructor] : getter(locals.$scope, constructor, true) || (globals ? getter($window, constructor, true) : undefined);

          if (!expression) {
            throw $controllerMinErr('ctrlreg', 'The controller with the name \'{0}\' is not registered.', constructor);
          }

          assertArgFn(expression, constructor, true);
        }

        if (later) {
          // Instantiate controller later:
          // This machinery is used to create an instance of the object before calling the
          // controller's constructor itself.
          //
          // This allows properties to be added to the controller before the constructor is
          // invoked. Primarily, this is used for isolate scope bindings in $compile.
          //
          // This feature is not intended for use by applications, and is thus not documented
          // publicly.
          // Object creation: http://jsperf.com/create-constructor/2
          var controllerPrototype = (isArray(expression) ? expression[expression.length - 1] : expression).prototype;
          instance = Object.create(controllerPrototype || null);

          if (identifier) {
            addIdentifier(locals, identifier, instance, constructor || expression.name);
          }

          return extend(function $controllerInit() {
            var result = $injector.invoke(expression, instance, locals, constructor);
            if (result !== instance && (isObject(result) || isFunction(result))) {
              instance = result;
              if (identifier) {
                // If result changed, re-assign controllerAs value to scope.
                addIdentifier(locals, identifier, instance, constructor || expression.name);
              }
            }
            return instance;
          }, {
            instance: instance,
            identifier: identifier
          });
        }

        instance = $injector.instantiate(expression, locals, constructor);

        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }

        return instance;
      };

      function addIdentifier(locals, identifier, instance, name) {
        if (!(locals && isObject(locals.$scope))) {
          throw minErr('$controller')('noscp', 'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.', name, identifier);
        }

        locals.$scope[identifier] = instance;
      }
    }];
  }

  /**
   * @ngdoc service
   * @name $document
   * @requires $window
   * @this
   *
   * @description
   * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
   *
   * @example
     <example module="documentExample" name="document">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <p>$document title: <b ng-bind="title"></b></p>
           <p>window.document title: <b ng-bind="windowTitle"></b></p>
         </div>
       </file>
       <file name="script.js">
         angular.module('documentExample', [])
           .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
             $scope.title = $document[0].title;
             $scope.windowTitle = angular.element(window.document)[0].title;
           }]);
       </file>
     </example>
   */
  function $DocumentProvider() {
    this.$get = ['$window', function (window) {
      return jqLite(window.document);
    }];
  }

  /**
   * @private
   * @this
   * Listens for document visibility change and makes the current status accessible.
   */
  function $$IsDocumentHiddenProvider() {
    this.$get = ['$document', '$rootScope', function ($document, $rootScope) {
      var doc = $document[0];
      var hidden = doc && doc.hidden;

      $document.on('visibilitychange', changeListener);

      $rootScope.$on('$destroy', function () {
        $document.off('visibilitychange', changeListener);
      });

      function changeListener() {
        hidden = doc.hidden;
      }

      return function () {
        return hidden;
      };
    }];
  }

  /**
   * @ngdoc service
   * @name $exceptionHandler
   * @requires ng.$log
   * @this
   *
   * @description
   * Any uncaught exception in AngularJS expressions is delegated to this service.
   * The default implementation simply delegates to `$log.error` which logs it into
   * the browser console.
   *
   * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
   * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
   *
   * ## Example:
   *
   * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
   * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
   * of `$log.error()`.
   *
   * ```js
   *   angular.
   *     module('exceptionOverwrite', []).
   *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
   *       return function myExceptionHandler(exception, cause) {
   *         logErrorsToBackend(exception, cause);
   *         $log.warn(exception, cause);
   *       };
   *     }]);
   * ```
   *
   * <hr />
   * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
   * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
   * (unless executed during a digest).
   *
   * If you wish, you can manually delegate exceptions, e.g.
   * `try { ... } catch(e) { $exceptionHandler(e); }`
   *
   * @param {Error} exception Exception associated with the error.
   * @param {string=} cause Optional information about the context in which
   *       the error was thrown.
   *
   */
  function $ExceptionHandlerProvider() {
    this.$get = ['$log', function ($log) {
      return function (exception, cause) {
        $log.error.apply($log, arguments);
      };
    }];
  }

  var $$ForceReflowProvider = /** @this */function $$ForceReflowProvider() {
    this.$get = ['$document', function ($document) {
      return function (domNode) {
        //the line below will force the browser to perform a repaint so
        //that all the animated elements within the animation frame will
        //be properly updated and drawn on screen. This is required to
        //ensure that the preparation animation is properly flushed so that
        //the active state picks up from there. DO NOT REMOVE THIS LINE.
        //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
        //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
        //WILL TAKE YEARS AWAY FROM YOUR LIFE.
        if (domNode) {
          if (!domNode.nodeType && domNode instanceof jqLite) {
            domNode = domNode[0];
          }
        } else {
          domNode = $document[0].body;
        }
        return domNode.offsetWidth + 1;
      };
    }];
  };

  var APPLICATION_JSON = 'application/json';
  var CONTENT_TYPE_APPLICATION_JSON = { 'Content-Type': APPLICATION_JSON + ';charset=utf-8' };
  var JSON_START = /^\[|^\{(?!\{)/;
  var JSON_ENDS = {
    '[': /]$/,
    '{': /}$/
  };
  var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
  var $httpMinErr = minErr('$http');

  function serializeValue(v) {
    if (isObject(v)) {
      return isDate(v) ? v.toISOString() : toJson(v);
    }
    return v;
  }

  /** @this */
  function $HttpParamSerializerProvider() {
    /**
     * @ngdoc service
     * @name $httpParamSerializer
     * @description
     *
     * Default {@link $http `$http`} params serializer that converts objects to strings
     * according to the following rules:
     *
     * * `{'foo': 'bar'}` results in `foo=bar`
     * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
     * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
     * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
     *
     * Note that serializer will sort the request parameters alphabetically.
     * */

    this.$get = function () {
      return function ngParamSerializer(params) {
        if (!params) return '';
        var parts = [];
        forEachSorted(params, function (value, key) {
          if (value === null || isUndefined(value) || isFunction(value)) return;
          if (isArray(value)) {
            forEach(value, function (v) {
              parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(v)));
            });
          } else {
            parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
          }
        });

        return parts.join('&');
      };
    };
  }

  /** @this */
  function $HttpParamSerializerJQLikeProvider() {
    /**
     * @ngdoc service
     * @name $httpParamSerializerJQLike
     *
     * @description
     *
     * Alternative {@link $http `$http`} params serializer that follows
     * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
     * The serializer will also sort the params alphabetically.
     *
     * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
     *
     * ```js
     * $http({
     *   url: myUrl,
     *   method: 'GET',
     *   params: myParams,
     *   paramSerializer: '$httpParamSerializerJQLike'
     * });
     * ```
     *
     * It is also possible to set it as the default `paramSerializer` in the
     * {@link $httpProvider#defaults `$httpProvider`}.
     *
     * Additionally, you can inject the serializer and use it explicitly, for example to serialize
     * form data for submission:
     *
     * ```js
     * .controller(function($http, $httpParamSerializerJQLike) {
     *   //...
     *
     *   $http({
     *     url: myUrl,
     *     method: 'POST',
     *     data: $httpParamSerializerJQLike(myData),
     *     headers: {
     *       'Content-Type': 'application/x-www-form-urlencoded'
     *     }
     *   });
     *
     * });
     * ```
     *
     * */
    this.$get = function () {
      return function jQueryLikeParamSerializer(params) {
        if (!params) return '';
        var parts = [];
        serialize(params, '', true);
        return parts.join('&');

        function serialize(toSerialize, prefix, topLevel) {
          if (toSerialize === null || isUndefined(toSerialize)) return;
          if (isArray(toSerialize)) {
            forEach(toSerialize, function (value, index) {
              serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
            });
          } else if (isObject(toSerialize) && !isDate(toSerialize)) {
            forEachSorted(toSerialize, function (value, key) {
              serialize(value, prefix + (topLevel ? '' : '[') + key + (topLevel ? '' : ']'));
            });
          } else {
            parts.push(encodeUriQuery(prefix) + '=' + encodeUriQuery(serializeValue(toSerialize)));
          }
        }
      };
    };
  }

  function defaultHttpResponseTransform(data, headers) {
    if (isString(data)) {
      // Strip json vulnerability protection prefix and trim whitespace
      var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();

      if (tempData) {
        var contentType = headers('Content-Type');
        var hasJsonContentType = contentType && contentType.indexOf(APPLICATION_JSON) === 0;

        if (hasJsonContentType || isJsonLike(tempData)) {
          try {
            data = fromJson(tempData);
          } catch (e) {
            if (!hasJsonContentType) {
              return data;
            }
            throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' + 'Parse error: "{1}"', data, e);
          }
        }
      }
    }

    return data;
  }

  function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
  }

  /**
   * Parse headers into key value object
   *
   * @param {string} headers Raw headers as a string
   * @returns {Object} Parsed headers as key value object
   */
  function parseHeaders(headers) {
    var parsed = createMap(),
        i;

    function fillInParsed(key, val) {
      if (key) {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }

    if (isString(headers)) {
      forEach(headers.split('\n'), function (line) {
        i = line.indexOf(':');
        fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
      });
    } else if (isObject(headers)) {
      forEach(headers, function (headerVal, headerKey) {
        fillInParsed(lowercase(headerKey), trim(headerVal));
      });
    }

    return parsed;
  }

  /**
   * Returns a function that provides access to parsed headers.
   *
   * Headers are lazy parsed when first requested.
   * @see parseHeaders
   *
   * @param {(string|Object)} headers Headers to provide access to.
   * @returns {function(string=)} Returns a getter function which if called with:
   *
   *   - if called with an argument returns a single header value or null
   *   - if called with no arguments returns an object containing all headers.
   */
  function headersGetter(headers) {
    var headersObj;

    return function (name) {
      if (!headersObj) headersObj = parseHeaders(headers);

      if (name) {
        var value = headersObj[lowercase(name)];
        if (value === undefined) {
          value = null;
        }
        return value;
      }

      return headersObj;
    };
  }

  /**
   * Chain all given functions
   *
   * This function is used for both request and response transforming
   *
   * @param {*} data Data to transform.
   * @param {function(string=)} headers HTTP headers getter fn.
   * @param {number} status HTTP status code of the response.
   * @param {(Function|Array.<Function>)} fns Function or an array of functions.
   * @returns {*} Transformed data.
   */
  function transformData(data, headers, status, fns) {
    if (isFunction(fns)) {
      return fns(data, headers, status);
    }

    forEach(fns, function (fn) {
      data = fn(data, headers, status);
    });

    return data;
  }

  function isSuccess(status) {
    return 200 <= status && status < 300;
  }

  /**
   * @ngdoc provider
   * @name $httpProvider
   * @this
   *
   * @description
   * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
   * */
  function $HttpProvider() {
    /**
     * @ngdoc property
     * @name $httpProvider#defaults
     * @description
     *
     * Object containing default values for all {@link ng.$http $http} requests.
     *
     * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
     * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
     * by default. See {@link $http#caching $http Caching} for more information.
     *
     * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
     * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
     * setting default headers.
     *     - **`defaults.headers.common`**
     *     - **`defaults.headers.post`**
     *     - **`defaults.headers.put`**
     *     - **`defaults.headers.patch`**
     *
     * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
     * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
     * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
     *
     * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
     *  used to the prepare string representation of request parameters (specified as an object).
     *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
     *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
     *
     * - **`defaults.transformRequest`** -
     * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
     * An array of functions (or a single function) which are applied to the request data.
     * By default, this is an array with one request transformation function:
     *
     *   - If the `data` property of the request configuration object contains an object, serialize it
     *     into JSON format.
     *
     * - **`defaults.transformResponse`** -
     * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
     * An array of functions (or a single function) which are applied to the response data. By default,
     * this is an array which applies one response transformation function that does two things:
     *
     *  - If XSRF prefix is detected, strip it
     *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
     *    deserialize it using a JSON parser.
     *
     * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
     * Defaults value is `'XSRF-TOKEN'`.
     *
     * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
     * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
     *
     **/
    var defaults = this.defaults = {
      // transform incoming response data
      transformResponse: [defaultHttpResponseTransform],

      // transform outgoing request data
      transformRequest: [function (d) {
        return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
      }],

      // default headers
      headers: {
        common: {
          'Accept': 'application/json, text/plain, */*'
        },
        post: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
        put: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
        patch: shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
      },

      xsrfCookieName: 'XSRF-TOKEN',
      xsrfHeaderName: 'X-XSRF-TOKEN',

      paramSerializer: '$httpParamSerializer',

      jsonpCallbackParam: 'callback'
    };

    var useApplyAsync = false;
    /**
     * @ngdoc method
     * @name $httpProvider#useApplyAsync
     * @description
     *
     * Configure $http service to combine processing of multiple http responses received at around
     * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
     * significant performance improvement for bigger applications that make many HTTP requests
     * concurrently (common during application bootstrap).
     *
     * Defaults to false. If no value is specified, returns the current configured value.
     *
     * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
     *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
     *    to load and share the same digest cycle.
     *
     * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
     *    otherwise, returns the current configured value.
     **/
    this.useApplyAsync = function (value) {
      if (isDefined(value)) {
        useApplyAsync = !!value;
        return this;
      }
      return useApplyAsync;
    };

    /**
     * @ngdoc property
     * @name $httpProvider#interceptors
     * @description
     *
     * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
     * pre-processing of request or postprocessing of responses.
     *
     * These service factories are ordered by request, i.e. they are applied in the same order as the
     * array, on request, but reverse order, on response.
     *
     * {@link ng.$http#interceptors Interceptors detailed info}
     **/
    var interceptorFactories = this.interceptors = [];

    this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce', function ($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {

      var defaultCache = $cacheFactory('$http');

      /**
       * Make sure that default param serializer is exposed as a function
       */
      defaults.paramSerializer = isString(defaults.paramSerializer) ? $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

      /**
       * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
       * The reversal is needed so that we can build up the interception chain around the
       * server request.
       */
      var reversedInterceptors = [];

      forEach(interceptorFactories, function (interceptorFactory) {
        reversedInterceptors.unshift(isString(interceptorFactory) ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
      });

      /**
       * @ngdoc service
       * @kind function
       * @name $http
       * @requires ng.$httpBackend
       * @requires $cacheFactory
       * @requires $rootScope
       * @requires $q
       * @requires $injector
       *
       * @description
       * The `$http` service is a core AngularJS service that facilitates communication with the remote
       * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
       * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
       *
       * For unit testing applications that use `$http` service, see
       * {@link ngMock.$httpBackend $httpBackend mock}.
       *
       * For a higher level of abstraction, please check out the {@link ngResource.$resource
       * $resource} service.
       *
       * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
       * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
       * it is important to familiarize yourself with these APIs and the guarantees they provide.
       *
       *
       * ## General usage
       * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
       * that is used to generate an HTTP request and returns  a {@link ng.$q promise}.
       *
       * ```js
       *   // Simple GET request example:
       *   $http({
       *     method: 'GET',
       *     url: '/someUrl'
       *   }).then(function successCallback(response) {
       *       // this callback will be called asynchronously
       *       // when the response is available
       *     }, function errorCallback(response) {
       *       // called asynchronously if an error occurs
       *       // or server returns response with an error status.
       *     });
       * ```
       *
       * The response object has these properties:
       *
       *   - **data** – `{string|Object}` – The response body transformed with the transform
       *     functions.
       *   - **status** – `{number}` – HTTP status code of the response.
       *   - **headers** – `{function([headerName])}` – Header getter function.
       *   - **config** – `{Object}` – The configuration object that was used to generate the request.
       *   - **statusText** – `{string}` – HTTP status text of the response.
       *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest (`complete`, `error`, `timeout` or `abort`).
       *
       * A response status code between 200 and 299 is considered a success status and will result in
       * the success callback being called. Any response status code outside of that range is
       * considered an error status and will result in the error callback being called.
       * Also, status codes less than -1 are normalized to zero. -1 usually means the request was
       * aborted, e.g. using a `config.timeout`.
       * Note that if the response is a redirect, XMLHttpRequest will transparently follow it, meaning
       * that the outcome (success or error) will be determined by the final response status code.
       *
       *
       * ## Shortcut methods
       *
       * Shortcut methods are also available. All shortcut methods require passing in the URL, and
       * request data must be passed in for POST/PUT requests. An optional config can be passed as the
       * last argument.
       *
       * ```js
       *   $http.get('/someUrl', config).then(successCallback, errorCallback);
       *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
       * ```
       *
       * Complete list of shortcut methods:
       *
       * - {@link ng.$http#get $http.get}
       * - {@link ng.$http#head $http.head}
       * - {@link ng.$http#post $http.post}
       * - {@link ng.$http#put $http.put}
       * - {@link ng.$http#delete $http.delete}
       * - {@link ng.$http#jsonp $http.jsonp}
       * - {@link ng.$http#patch $http.patch}
       *
       *
       * ## Writing Unit Tests that use $http
       * When unit testing (using {@link ngMock ngMock}), it is necessary to call
       * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
       * request using trained responses.
       *
       * ```
       * $httpBackend.expectGET(...);
       * $http.get(...);
       * $httpBackend.flush();
       * ```
       *
       * ## Setting HTTP Headers
       *
       * The $http service will automatically add certain HTTP headers to all requests. These defaults
       * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
       * object, which currently contains this default configuration:
       *
       * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
       *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
       * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
       *   - `Content-Type: application/json`
       * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
       *   - `Content-Type: application/json`
       *
       * To add or overwrite these defaults, simply add or remove a property from these configuration
       * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
       * with the lowercased HTTP method name as the key, e.g.
       * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
       *
       * The defaults can also be set at runtime via the `$http.defaults` object in the same
       * fashion. For example:
       *
       * ```
       * module.run(function($http) {
       *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
       * });
       * ```
       *
       * In addition, you can supply a `headers` property in the config object passed when
       * calling `$http(config)`, which overrides the defaults without changing them globally.
       *
       * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
       * Use the `headers` property, setting the desired header to `undefined`. For example:
       *
       * ```js
       * var req = {
       *  method: 'POST',
       *  url: 'http://example.com',
       *  headers: {
       *    'Content-Type': undefined
       *  },
       *  data: { test: 'test' }
       * }
       *
       * $http(req).then(function(){...}, function(){...});
       * ```
       *
       * ## Transforming Requests and Responses
       *
       * Both requests and responses can be transformed using transformation functions: `transformRequest`
       * and `transformResponse`. These properties can be a single function that returns
       * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
       * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
       *
       * <div class="alert alert-warning">
       * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
       * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
       * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
       * function will be reflected on the scope and in any templates where the object is data-bound.
       * To prevent this, transform functions should have no side-effects.
       * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
       * </div>
       *
       * ### Default Transformations
       *
       * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
       * `defaults.transformResponse` properties. If a request does not provide its own transformations
       * then these will be applied.
       *
       * You can augment or replace the default transformations by modifying these properties by adding to or
       * replacing the array.
       *
       * AngularJS provides the following default transformations:
       *
       * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
       * an array with one function that does the following:
       *
       * - If the `data` property of the request configuration object contains an object, serialize it
       *   into JSON format.
       *
       * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
       * an array with one function that does the following:
       *
       *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
       *  - If the `Content-Type` is `application/json` or the response looks like JSON,
      *      deserialize it using a JSON parser.
       *
       *
       * ### Overriding the Default Transformations Per Request
       *
       * If you wish to override the request/response transformations only for a single request then provide
       * `transformRequest` and/or `transformResponse` properties on the configuration object passed
       * into `$http`.
       *
       * Note that if you provide these properties on the config object the default transformations will be
       * overwritten. If you wish to augment the default transformations then you must include them in your
       * local transformation array.
       *
       * The following code demonstrates adding a new response transformation to be run after the default response
       * transformations have been run.
       *
       * ```js
       * function appendTransform(defaults, transform) {
       *
       *   // We can't guarantee that the default transformation is an array
       *   defaults = angular.isArray(defaults) ? defaults : [defaults];
       *
       *   // Append the new transformation to the defaults
       *   return defaults.concat(transform);
       * }
       *
       * $http({
       *   url: '...',
       *   method: 'GET',
       *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
       *     return doTransform(value);
       *   })
       * });
       * ```
       *
       *
       * ## Caching
       *
       * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
       * set the config.cache value or the default cache value to TRUE or to a cache object (created
       * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
       * precedence over the default cache value.
       *
       * In order to:
       *   * cache all responses - set the default cache value to TRUE or to a cache object
       *   * cache a specific response - set config.cache value to TRUE or to a cache object
       *
       * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
       * then the default `$cacheFactory("$http")` object is used.
       *
       * The default cache value can be set by updating the
       * {@link ng.$http#defaults `$http.defaults.cache`} property or the
       * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
       *
       * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
       * the relevant cache object. The next time the same request is made, the response is returned
       * from the cache without sending a request to the server.
       *
       * Take note that:
       *
       *   * Only GET and JSONP requests are cached.
       *   * The cache key is the request URL including search parameters; headers are not considered.
       *   * Cached responses are returned asynchronously, in the same way as responses from the server.
       *   * If multiple identical requests are made using the same cache, which is not yet populated,
       *     one request will be made to the server and remaining requests will return the same response.
       *   * A cache-control header on the response does not affect if or how responses are cached.
       *
       *
       * ## Interceptors
       *
       * Before you start creating interceptors, be sure to understand the
       * {@link ng.$q $q and deferred/promise APIs}.
       *
       * For purposes of global error handling, authentication, or any kind of synchronous or
       * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
       * able to intercept requests before they are handed to the server and
       * responses before they are handed over to the application code that
       * initiated these requests. The interceptors leverage the {@link ng.$q
       * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
       *
       * The interceptors are service factories that are registered with the `$httpProvider` by
       * adding them to the `$httpProvider.interceptors` array. The factory is called and
       * injected with dependencies (if specified) and returns the interceptor.
       *
       * There are two kinds of interceptors (and two kinds of rejection interceptors):
       *
       *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
       *     modify the `config` object or create a new one. The function needs to return the `config`
       *     object directly, or a promise containing the `config` or a new `config` object.
       *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
       *     resolved with a rejection.
       *   * `response`: interceptors get called with http `response` object. The function is free to
       *     modify the `response` object or create a new one. The function needs to return the `response`
       *     object directly, or as a promise containing the `response` or a new `response` object.
       *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
       *     resolved with a rejection.
       *
       *
       * ```js
       *   // register the interceptor as a service
       *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
       *     return {
       *       // optional method
       *       'request': function(config) {
       *         // do something on success
       *         return config;
       *       },
       *
       *       // optional method
       *      'requestError': function(rejection) {
       *         // do something on error
       *         if (canRecover(rejection)) {
       *           return responseOrNewPromise
       *         }
       *         return $q.reject(rejection);
       *       },
       *
       *
       *
       *       // optional method
       *       'response': function(response) {
       *         // do something on success
       *         return response;
       *       },
       *
       *       // optional method
       *      'responseError': function(rejection) {
       *         // do something on error
       *         if (canRecover(rejection)) {
       *           return responseOrNewPromise
       *         }
       *         return $q.reject(rejection);
       *       }
       *     };
       *   });
       *
       *   $httpProvider.interceptors.push('myHttpInterceptor');
       *
       *
       *   // alternatively, register the interceptor via an anonymous factory
       *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
       *     return {
       *      'request': function(config) {
       *          // same as above
       *       },
       *
       *       'response': function(response) {
       *          // same as above
       *       }
       *     };
       *   });
       * ```
       *
       * ## Security Considerations
       *
       * When designing web applications, consider security threats from:
       *
       * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
       * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
       *
       * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
       * pre-configured with strategies that address these issues, but for this to work backend server
       * cooperation is required.
       *
       * ### JSON Vulnerability Protection
       *
       * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
       * allows third party website to turn your JSON resource URL into
       * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
       * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
       * AngularJS will automatically strip the prefix before processing it as JSON.
       *
       * For example if your server needs to return:
       * ```js
       * ['one','two']
       * ```
       *
       * which is vulnerable to attack, your server can return:
       * ```js
       * )]}',
       * ['one','two']
       * ```
       *
       * AngularJS will strip the prefix, before processing the JSON.
       *
       *
       * ### Cross Site Request Forgery (XSRF) Protection
       *
       * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
       * which the attacker can trick an authenticated user into unknowingly executing actions on your
       * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
       * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
       * header (`X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read the
       * cookie, your server can be assured that the XHR came from JavaScript running on your domain.
       * The header will not be set for cross-domain requests.
       *
       * To take advantage of this, your server needs to set a token in a JavaScript readable session
       * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
       * server can verify that the cookie matches `X-XSRF-TOKEN` HTTP header, and therefore be sure
       * that only JavaScript running on your domain could have sent the request. The token must be
       * unique for each user and must be verifiable by the server (to prevent the JavaScript from
       * making up its own tokens). We recommend that the token is a digest of your site's
       * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
       * for added security.
       *
       * The name of the headers can be specified using the xsrfHeaderName and xsrfCookieName
       * properties of either $httpProvider.defaults at config-time, $http.defaults at run-time,
       * or the per-request config object.
       *
       * In order to prevent collisions in environments where multiple AngularJS apps share the
       * same domain or subdomain, we recommend that each application uses unique cookie name.
       *
       * @param {object} config Object describing the request to be made and how it should be
       *    processed. The object has following properties:
       *
       *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
       *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
       *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
       *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
       *      with the `paramSerializer` and appended as GET parameters.
       *    - **data** – `{string|Object}` – Data to be sent as the request message data.
       *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
       *      HTTP headers to send to the server. If the return value of a function is null, the
       *      header will not be sent. Functions accept a config object as an argument.
       *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
       *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
       *      The handler will be called in the context of a `$apply` block.
       *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
       *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
       *      The handler will be called in the context of a `$apply` block.
       *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
       *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
       *    - **transformRequest** –
       *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
       *      transform function or an array of such functions. The transform function takes the http
       *      request body and headers and returns its transformed (typically serialized) version.
       *      See {@link ng.$http#overriding-the-default-transformations-per-request
       *      Overriding the Default Transformations}
       *    - **transformResponse** –
       *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
       *      transform function or an array of such functions. The transform function takes the http
       *      response body, headers and status and returns its transformed (typically deserialized) version.
       *      See {@link ng.$http#overriding-the-default-transformations-per-request
       *      Overriding the Default Transformations}
       *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
       *      prepare the string representation of request parameters (specified as an object).
       *      If specified as string, it is interpreted as function registered with the
       *      {@link $injector $injector}, which means you can create your own serializer
       *      by registering it as a {@link auto.$provide#service service}.
       *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
       *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
       *    - **cache** – `{boolean|Object}` – A boolean value or object created with
       *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
       *      See {@link $http#caching $http Caching} for more information.
       *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
       *      that should abort the request when resolved.
       *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
       *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
       *      for more information.
       *    - **responseType** - `{string}` - see
       *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
       *
       * @returns {HttpPromise} Returns a {@link ng.$q `Promise}` that will be resolved to a response object
       *                        when the request succeeds or fails.
       *
       *
       * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
       *   requests. This is primarily meant to be used for debugging purposes.
       *
       *
       * @example
      <example module="httpExample" name="http-service">
      <file name="index.html">
      <div ng-controller="FetchController">
      <select ng-model="method" aria-label="Request method">
        <option>GET</option>
        <option>JSONP</option>
      </select>
      <input type="text" ng-model="url" size="80" aria-label="URL" />
      <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
      <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
      <button id="samplejsonpbtn"
        ng-click="updateModel('JSONP',
                      'https://angularjs.org/greet.php?name=Super%20Hero')">
        Sample JSONP
      </button>
      <button id="invalidjsonpbtn"
        ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
          Invalid JSONP
        </button>
      <pre>http status code: {{status}}</pre>
      <pre>http response data: {{data}}</pre>
      </div>
      </file>
      <file name="script.js">
      angular.module('httpExample', [])
      .config(['$sceDelegateProvider', function($sceDelegateProvider) {
        // We must whitelist the JSONP endpoint that we are using to show that we trust it
        $sceDelegateProvider.resourceUrlWhitelist([
          'self',
          'https://angularjs.org/**'
        ]);
      }])
      .controller('FetchController', ['$scope', '$http', '$templateCache',
        function($scope, $http, $templateCache) {
          $scope.method = 'GET';
          $scope.url = 'http-hello.html';
           $scope.fetch = function() {
            $scope.code = null;
            $scope.response = null;
             $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
              then(function(response) {
                $scope.status = response.status;
                $scope.data = response.data;
              }, function(response) {
                $scope.data = response.data || 'Request failed';
                $scope.status = response.status;
            });
          };
           $scope.updateModel = function(method, url) {
            $scope.method = method;
            $scope.url = url;
          };
        }]);
      </file>
      <file name="http-hello.html">
      Hello, $http!
      </file>
      <file name="protractor.js" type="protractor">
      var status = element(by.binding('status'));
      var data = element(by.binding('data'));
      var fetchBtn = element(by.id('fetchbtn'));
      var sampleGetBtn = element(by.id('samplegetbtn'));
      var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
      it('should make an xhr GET request', function() {
      sampleGetBtn.click();
      fetchBtn.click();
      expect(status.getText()).toMatch('200');
      expect(data.getText()).toMatch(/Hello, \$http!/);
      });
      // Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
      // it('should make a JSONP request to angularjs.org', function() {
      //   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
      //   sampleJsonpBtn.click();
      //   fetchBtn.click();
      //   expect(status.getText()).toMatch('200');
      //   expect(data.getText()).toMatch(/Super Hero!/);
      // });
      it('should make JSONP request to invalid URL and invoke the error handler',
        function() {
      invalidJsonpBtn.click();
      fetchBtn.click();
      expect(status.getText()).toMatch('0');
      expect(data.getText()).toMatch('Request failed');
      });
      </file>
      </example>
       */
      function $http(requestConfig) {

        if (!isObject(requestConfig)) {
          throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
        }

        if (!isString($sce.valueOf(requestConfig.url))) {
          throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
        }

        var config = extend({
          method: 'get',
          transformRequest: defaults.transformRequest,
          transformResponse: defaults.transformResponse,
          paramSerializer: defaults.paramSerializer,
          jsonpCallbackParam: defaults.jsonpCallbackParam
        }, requestConfig);

        config.headers = mergeHeaders(requestConfig);
        config.method = uppercase(config.method);
        config.paramSerializer = isString(config.paramSerializer) ? $injector.get(config.paramSerializer) : config.paramSerializer;

        $browser.$$incOutstandingRequestCount();

        var requestInterceptors = [];
        var responseInterceptors = [];
        var promise = $q.resolve(config);

        // apply interceptors
        forEach(reversedInterceptors, function (interceptor) {
          if (interceptor.request || interceptor.requestError) {
            requestInterceptors.unshift(interceptor.request, interceptor.requestError);
          }
          if (interceptor.response || interceptor.responseError) {
            responseInterceptors.push(interceptor.response, interceptor.responseError);
          }
        });

        promise = chainInterceptors(promise, requestInterceptors);
        promise = promise.then(serverRequest);
        promise = chainInterceptors(promise, responseInterceptors);
        promise = promise.finally(completeOutstandingRequest);

        return promise;

        function chainInterceptors(promise, interceptors) {
          for (var i = 0, ii = interceptors.length; i < ii;) {
            var thenFn = interceptors[i++];
            var rejectFn = interceptors[i++];

            promise = promise.then(thenFn, rejectFn);
          }

          interceptors.length = 0;

          return promise;
        }

        function completeOutstandingRequest() {
          $browser.$$completeOutstandingRequest(noop);
        }

        function executeHeaderFns(headers, config) {
          var headerContent,
              processedHeaders = {};

          forEach(headers, function (headerFn, header) {
            if (isFunction(headerFn)) {
              headerContent = headerFn(config);
              if (headerContent != null) {
                processedHeaders[header] = headerContent;
              }
            } else {
              processedHeaders[header] = headerFn;
            }
          });

          return processedHeaders;
        }

        function mergeHeaders(config) {
          var defHeaders = defaults.headers,
              reqHeaders = extend({}, config.headers),
              defHeaderName,
              lowercaseDefHeaderName,
              reqHeaderName;

          defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

          // using for-in instead of forEach to avoid unnecessary iteration after header has been found
          defaultHeadersIteration: for (defHeaderName in defHeaders) {
            lowercaseDefHeaderName = lowercase(defHeaderName);

            for (reqHeaderName in reqHeaders) {
              if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
                continue defaultHeadersIteration;
              }
            }

            reqHeaders[defHeaderName] = defHeaders[defHeaderName];
          }

          // execute if header value is a function for merged headers
          return executeHeaderFns(reqHeaders, shallowCopy(config));
        }

        function serverRequest(config) {
          var headers = config.headers;
          var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

          // strip content-type if data is undefined
          if (isUndefined(reqData)) {
            forEach(headers, function (value, header) {
              if (lowercase(header) === 'content-type') {
                delete headers[header];
              }
            });
          }

          if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
            config.withCredentials = defaults.withCredentials;
          }

          // send request
          return sendReq(config, reqData).then(transformResponse, transformResponse);
        }

        function transformResponse(response) {
          // make a copy since the response must be cacheable
          var resp = extend({}, response);
          resp.data = transformData(response.data, response.headers, response.status, config.transformResponse);
          return isSuccess(response.status) ? resp : $q.reject(resp);
        }
      }

      $http.pendingRequests = [];

      /**
       * @ngdoc method
       * @name $http#get
       *
       * @description
       * Shortcut method to perform `GET` request.
       *
       * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
       *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
       * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
       * @returns {HttpPromise} Future object
       */

      /**
       * @ngdoc method
       * @name $http#delete
       *
       * @description
       * Shortcut method to perform `DELETE` request.
       *
       * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
       *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
       * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
       * @returns {HttpPromise} Future object
       */

      /**
       * @ngdoc method
       * @name $http#head
       *
       * @description
       * Shortcut method to perform `HEAD` request.
       *
       * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
       *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
       * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
       * @returns {HttpPromise} Future object
       */

      /**
       * @ngdoc method
       * @name $http#jsonp
       *
       * @description
       * Shortcut method to perform `JSONP` request.
       *
       * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
       * the url must be declared, via {@link $sce} as a trusted resource URL.
       * You can trust a URL by adding it to the whitelist via
       * {@link $sceDelegateProvider#resourceUrlWhitelist  `$sceDelegateProvider.resourceUrlWhitelist`} or
       * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
       *
       * You should avoid generating the URL for the JSONP request from user provided data.
       * Provide additional query parameters via `params` property of the `config` parameter, rather than
       * modifying the URL itself.
       *
       * JSONP requests must specify a callback to be used in the response from the server. This callback
       * is passed as a query parameter in the request. You must specify the name of this parameter by
       * setting the `jsonpCallbackParam` property on the request config object.
       *
       * ```
       * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
       * ```
       *
       * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
       * Initially this is set to `'callback'`.
       *
       * <div class="alert alert-danger">
       * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
       * parameter value should go.
       * </div>
       *
       * If you would like to customise where and how the callbacks are stored then try overriding
       * or decorating the {@link $jsonpCallbacks} service.
       *
       * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
       *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
       * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
       * @returns {HttpPromise} Future object
       */
      createShortMethods('get', 'delete', 'head', 'jsonp');

      /**
       * @ngdoc method
       * @name $http#post
       *
       * @description
       * Shortcut method to perform `POST` request.
       *
       * @param {string} url Relative or absolute URL specifying the destination of the request
       * @param {*} data Request content
       * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
       * @returns {HttpPromise} Future object
       */

      /**
       * @ngdoc method
       * @name $http#put
       *
       * @description
       * Shortcut method to perform `PUT` request.
       *
       * @param {string} url Relative or absolute URL specifying the destination of the request
       * @param {*} data Request content
       * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
       * @returns {HttpPromise} Future object
       */

      /**
       * @ngdoc method
       * @name $http#patch
       *
       * @description
       * Shortcut method to perform `PATCH` request.
       *
       * @param {string} url Relative or absolute URL specifying the destination of the request
       * @param {*} data Request content
       * @param {Object=} config Optional configuration object. See https://docs.angularjs.org/api/ng/service/$http#usage
       * @returns {HttpPromise} Future object
       */
      createShortMethodsWithData('post', 'put', 'patch');

      /**
       * @ngdoc property
       * @name $http#defaults
       *
       * @description
       * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
       * default headers, withCredentials as well as request and response transformations.
       *
       * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
       */
      $http.defaults = defaults;

      return $http;

      function createShortMethods(names) {
        forEach(arguments, function (name) {
          $http[name] = function (url, config) {
            return $http(extend({}, config || {}, {
              method: name,
              url: url
            }));
          };
        });
      }

      function createShortMethodsWithData(name) {
        forEach(arguments, function (name) {
          $http[name] = function (url, data, config) {
            return $http(extend({}, config || {}, {
              method: name,
              url: url,
              data: data
            }));
          };
        });
      }

      /**
       * Makes the request.
       *
       * !!! ACCESSES CLOSURE VARS:
       * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
       */
      function sendReq(config, reqData) {
        var deferred = $q.defer(),
            promise = deferred.promise,
            cache,
            cachedResp,
            reqHeaders = config.headers,
            isJsonp = lowercase(config.method) === 'jsonp',
            url = config.url;

        if (isJsonp) {
          // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
          // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
          url = $sce.getTrustedResourceUrl(url);
        } else if (!isString(url)) {
          // If it is not a string then the URL must be a $sce trusted object
          url = $sce.valueOf(url);
        }

        url = buildUrl(url, config.paramSerializer(config.params));

        if (isJsonp) {
          // Check the url and add the JSONP callback placeholder
          url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
        }

        $http.pendingRequests.push(config);
        promise.then(removePendingReq, removePendingReq);

        if ((config.cache || defaults.cache) && config.cache !== false && (config.method === 'GET' || config.method === 'JSONP')) {
          cache = isObject(config.cache) ? config.cache : isObject( /** @type {?} */defaults.cache) ? /** @type {?} */defaults.cache : defaultCache;
        }

        if (cache) {
          cachedResp = cache.get(url);
          if (isDefined(cachedResp)) {
            if (isPromiseLike(cachedResp)) {
              // cached request has already been sent, but there is no response yet
              cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
            } else {
              // serving from cache
              if (isArray(cachedResp)) {
                resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
              } else {
                resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
              }
            }
          } else {
            // put the promise for the non-transformed response into cache as a placeholder
            cache.put(url, promise);
          }
        }

        // if we won't have the response in cache, set the xsrf headers and
        // send the request to the backend
        if (isUndefined(cachedResp)) {
          var xsrfValue = urlIsSameOrigin(config.url) ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName] : undefined;
          if (xsrfValue) {
            reqHeaders[config.xsrfHeaderName || defaults.xsrfHeaderName] = xsrfValue;
          }

          $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout, config.withCredentials, config.responseType, createApplyHandlers(config.eventHandlers), createApplyHandlers(config.uploadEventHandlers));
        }

        return promise;

        function createApplyHandlers(eventHandlers) {
          if (eventHandlers) {
            var applyHandlers = {};
            forEach(eventHandlers, function (eventHandler, key) {
              applyHandlers[key] = function (event) {
                if (useApplyAsync) {
                  $rootScope.$applyAsync(callEventHandler);
                } else if ($rootScope.$$phase) {
                  callEventHandler();
                } else {
                  $rootScope.$apply(callEventHandler);
                }

                function callEventHandler() {
                  eventHandler(event);
                }
              };
            });
            return applyHandlers;
          }
        }

        /**
         * Callback registered to $httpBackend():
         *  - caches the response if desired
         *  - resolves the raw $http promise
         *  - calls $apply
         */
        function done(status, response, headersString, statusText, xhrStatus) {
          if (cache) {
            if (isSuccess(status)) {
              cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
            } else {
              // remove promise from the cache
              cache.remove(url);
            }
          }

          function resolveHttpPromise() {
            resolvePromise(response, status, headersString, statusText, xhrStatus);
          }

          if (useApplyAsync) {
            $rootScope.$applyAsync(resolveHttpPromise);
          } else {
            resolveHttpPromise();
            if (!$rootScope.$$phase) $rootScope.$apply();
          }
        }

        /**
         * Resolves the raw $http promise.
         */
        function resolvePromise(response, status, headers, statusText, xhrStatus) {
          //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
          status = status >= -1 ? status : 0;

          (isSuccess(status) ? deferred.resolve : deferred.reject)({
            data: response,
            status: status,
            headers: headersGetter(headers),
            config: config,
            statusText: statusText,
            xhrStatus: xhrStatus
          });
        }

        function resolvePromiseWithResult(result) {
          resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
        }

        function removePendingReq() {
          var idx = $http.pendingRequests.indexOf(config);
          if (idx !== -1) $http.pendingRequests.splice(idx, 1);
        }
      }

      function buildUrl(url, serializedParams) {
        if (serializedParams.length > 0) {
          url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
        }
        return url;
      }

      function sanitizeJsonpCallbackParam(url, cbKey) {
        var parts = url.split('?');
        if (parts.length > 2) {
          // Throw if the url contains more than one `?` query indicator
          throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
        }
        var params = parseKeyValue(parts[1]);
        forEach(params, function (value, key) {
          if (value === 'JSON_CALLBACK') {
            // Throw if the url already contains a reference to JSON_CALLBACK
            throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
          }
          if (key === cbKey) {
            // Throw if the callback param was already provided
            throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
          }
        });

        // Add in the JSON_CALLBACK callback param value
        url += (url.indexOf('?') === -1 ? '?' : '&') + cbKey + '=JSON_CALLBACK';

        return url;
      }
    }];
  }

  /**
   * @ngdoc service
   * @name $xhrFactory
   * @this
   *
   * @description
   * Factory function used to create XMLHttpRequest objects.
   *
   * Replace or decorate this service to create your own custom XMLHttpRequest objects.
   *
   * ```
   * angular.module('myApp', [])
   * .factory('$xhrFactory', function() {
   *   return function createXhr(method, url) {
   *     return new window.XMLHttpRequest({mozSystem: true});
   *   };
   * });
   * ```
   *
   * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
   * @param {string} url URL of the request.
   */
  function $xhrFactoryProvider() {
    this.$get = function () {
      return function createXhr() {
        return new window.XMLHttpRequest();
      };
    };
  }

  /**
   * @ngdoc service
   * @name $httpBackend
   * @requires $jsonpCallbacks
   * @requires $document
   * @requires $xhrFactory
   * @this
   *
   * @description
   * HTTP backend used by the {@link ng.$http service} that delegates to
   * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
   *
   * You should never need to use this service directly, instead use the higher-level abstractions:
   * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
   *
   * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
   * $httpBackend} which can be trained with responses.
   */
  function $HttpBackendProvider() {
    this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function ($browser, $jsonpCallbacks, $document, $xhrFactory) {
      return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
    }];
  }

  function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
    // TODO(vojta): fix the signature
    return function (method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
      url = url || $browser.url();

      if (lowercase(method) === 'jsonp') {
        var callbackPath = callbacks.createCallback(url);
        var jsonpDone = jsonpReq(url, callbackPath, function (status, text) {
          // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
          var response = status === 200 && callbacks.getResponse(callbackPath);
          completeRequest(callback, status, response, '', text, 'complete');
          callbacks.removeCallback(callbackPath);
        });
      } else {

        var xhr = createXhr(method, url);

        xhr.open(method, url, true);
        forEach(headers, function (value, key) {
          if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
          }
        });

        xhr.onload = function requestLoaded() {
          var statusText = xhr.statusText || '';

          // responseText is the old-school way of retrieving response (supported by IE9)
          // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
          var response = 'response' in xhr ? xhr.response : xhr.responseText;

          // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
          var status = xhr.status === 1223 ? 204 : xhr.status;

          // fix status code when it is 0 (0 status is undocumented).
          // Occurs when accessing file resources or on Android 4.1 stock browser
          // while retrieving files from application cache.
          if (status === 0) {
            status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
          }

          completeRequest(callback, status, response, xhr.getAllResponseHeaders(), statusText, 'complete');
        };

        var requestError = function requestError() {
          // The response is always empty
          // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
          completeRequest(callback, -1, null, null, '', 'error');
        };

        var requestAborted = function requestAborted() {
          completeRequest(callback, -1, null, null, '', 'abort');
        };

        var requestTimeout = function requestTimeout() {
          // The response is always empty
          // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
          completeRequest(callback, -1, null, null, '', 'timeout');
        };

        xhr.onerror = requestError;
        xhr.onabort = requestAborted;
        xhr.ontimeout = requestTimeout;

        forEach(eventHandlers, function (value, key) {
          xhr.addEventListener(key, value);
        });

        forEach(uploadEventHandlers, function (value, key) {
          xhr.upload.addEventListener(key, value);
        });

        if (withCredentials) {
          xhr.withCredentials = true;
        }

        if (responseType) {
          try {
            xhr.responseType = responseType;
          } catch (e) {
            // WebKit added support for the json responseType value on 09/03/2013
            // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
            // known to throw when setting the value "json" as the response type. Other older
            // browsers implementing the responseType
            //
            // The json response type can be ignored if not supported, because JSON payloads are
            // parsed on the client-side regardless.
            if (responseType !== 'json') {
              throw e;
            }
          }
        }

        xhr.send(isUndefined(post) ? null : post);
      }

      if (timeout > 0) {
        var timeoutId = $browserDefer(timeoutRequest, timeout);
      } else if (isPromiseLike(timeout)) {
        timeout.then(timeoutRequest);
      }

      function timeoutRequest() {
        if (jsonpDone) {
          jsonpDone();
        }
        if (xhr) {
          xhr.abort();
        }
      }

      function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
        // cancel timeout and subsequent timeout promise resolution
        if (isDefined(timeoutId)) {
          $browserDefer.cancel(timeoutId);
        }
        jsonpDone = xhr = null;

        callback(status, response, headersString, statusText, xhrStatus);
      }
    };

    function jsonpReq(url, callbackPath, done) {
      url = url.replace('JSON_CALLBACK', callbackPath);
      // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
      // - fetches local scripts via XHR and evals them
      // - adds and immediately removes script elements from the document
      var script = rawDocument.createElement('script'),
          _callback = null;
      script.type = 'text/javascript';
      script.src = url;
      script.async = true;

      _callback = function callback(event) {
        script.removeEventListener('load', _callback);
        script.removeEventListener('error', _callback);
        rawDocument.body.removeChild(script);
        script = null;
        var status = -1;
        var text = 'unknown';

        if (event) {
          if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
            event = { type: 'error' };
          }
          text = event.type;
          status = event.type === 'error' ? 404 : 200;
        }

        if (done) {
          done(status, text);
        }
      };

      script.addEventListener('load', _callback);
      script.addEventListener('error', _callback);
      rawDocument.body.appendChild(script);
      return _callback;
    }
  }

  var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
  $interpolateMinErr.throwNoconcat = function (text) {
    throw $interpolateMinErr('noconcat', 'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' + 'interpolations that concatenate multiple expressions when a trusted value is ' + 'required.  See http://docs.angularjs.org/api/ng.$sce', text);
  };

  $interpolateMinErr.interr = function (text, err) {
    return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
  };

  /**
   * @ngdoc provider
   * @name $interpolateProvider
   * @this
   *
   * @description
   *
   * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
   *
   * <div class="alert alert-danger">
   * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
   * template within a Python Jinja template (or any other template language). Mixing templating
   * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
   * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
   * security bugs!
   * </div>
   *
   * @example
  <example name="custom-interpolation-markup" module="customInterpolationApp">
  <file name="index.html">
  <script>
    var customInterpolationApp = angular.module('customInterpolationApp', []);
  
    customInterpolationApp.config(function($interpolateProvider) {
      $interpolateProvider.startSymbol('//');
      $interpolateProvider.endSymbol('//');
    });
  
  
    customInterpolationApp.controller('DemoController', function() {
        this.label = "This binding is brought you by // interpolation symbols.";
    });
  </script>
  <div ng-controller="DemoController as demo">
      //demo.label//
  </div>
  </file>
  <file name="protractor.js" type="protractor">
    it('should interpolate binding with custom symbols', function() {
      expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
    });
  </file>
  </example>
   */
  function $InterpolateProvider() {
    var startSymbol = '{{';
    var endSymbol = '}}';

    /**
     * @ngdoc method
     * @name $interpolateProvider#startSymbol
     * @description
     * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
     *
     * @param {string=} value new value to set the starting symbol to.
     * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
     */
    this.startSymbol = function (value) {
      if (value) {
        startSymbol = value;
        return this;
      } else {
        return startSymbol;
      }
    };

    /**
     * @ngdoc method
     * @name $interpolateProvider#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * @param {string=} value new value to set the ending symbol to.
     * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
     */
    this.endSymbol = function (value) {
      if (value) {
        endSymbol = value;
        return this;
      } else {
        return endSymbol;
      }
    };

    this.$get = ['$parse', '$exceptionHandler', '$sce', function ($parse, $exceptionHandler, $sce) {
      var startSymbolLength = startSymbol.length,
          endSymbolLength = endSymbol.length,
          escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
          escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');

      function escape(ch) {
        return '\\\\\\' + ch;
      }

      function unescapeText(text) {
        return text.replace(escapedStartRegexp, startSymbol).replace(escapedEndRegexp, endSymbol);
      }

      // TODO: this is the same as the constantWatchDelegate in parse.js
      function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
        var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
          unwatch();
          return constantInterp(scope);
        }, listener, objectEquality);
        return unwatch;
      }

      /**
       * @ngdoc service
       * @name $interpolate
       * @kind function
       *
       * @requires $parse
       * @requires $sce
       *
       * @description
       *
       * Compiles a string with markup into an interpolation function. This service is used by the
       * HTML {@link ng.$compile $compile} service for data binding. See
       * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
       * interpolation markup.
       *
       *
       * ```js
       *   var $interpolate = ...; // injected
       *   var exp = $interpolate('Hello {{name | uppercase}}!');
       *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULAR!');
       * ```
       *
       * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
       * `true`, the interpolation function will return `undefined` unless all embedded expressions
       * evaluate to a value other than `undefined`.
       *
       * ```js
       *   var $interpolate = ...; // injected
       *   var context = {greeting: 'Hello', name: undefined };
       *
       *   // default "forgiving" mode
       *   var exp = $interpolate('{{greeting}} {{name}}!');
       *   expect(exp(context)).toEqual('Hello !');
       *
       *   // "allOrNothing" mode
       *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
       *   expect(exp(context)).toBeUndefined();
       *   context.name = 'AngularJS';
       *   expect(exp(context)).toEqual('Hello AngularJS!');
       * ```
       *
       * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
       *
       * #### Escaped Interpolation
       * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
       * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
       * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
       * or binding.
       *
       * This enables web-servers to prevent script injection attacks and defacing attacks, to some
       * degree, while also enabling code examples to work without relying on the
       * {@link ng.directive:ngNonBindable ngNonBindable} directive.
       *
       * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
       * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
       * interpolation start/end markers with their escaped counterparts.**
       *
       * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
       * output when the $interpolate service processes the text. So, for HTML elements interpolated
       * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
       * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
       * this is typically useful only when user-data is used in rendering a template from the server, or
       * when otherwise untrusted data is used by a directive.
       *
       * <example name="interpolation">
       *  <file name="index.html">
       *    <div ng-init="username='A user'">
       *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
       *        </p>
       *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
       *        application, but fails to accomplish their task, because the server has correctly
       *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
       *        characters.</p>
       *      <p>Instead, the result of the attempted script injection is visible, and can be removed
       *        from the database by an administrator.</p>
       *    </div>
       *  </file>
       * </example>
       *
       * @knownIssue
       * It is currently not possible for an interpolated expression to contain the interpolation end
       * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
       * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
       *
       * @knownIssue
       * All directives and components must use the standard `{{` `}}` interpolation symbols
       * in their templates. If you change the application interpolation symbols the {@link $compile}
       * service will attempt to denormalize the standard symbols to the custom symbols.
       * The denormalization process is not clever enough to know not to replace instances of the standard
       * symbols where they would not normally be treated as interpolation symbols. For example in the following
       * code snippet the closing braces of the literal object will get incorrectly denormalized:
       *
       * ```
       * <div data-context='{"context":{"id":3,"type":"page"}}">
       * ```
       *
       * The workaround is to ensure that such instances are separated by whitespace:
       * ```
       * <div data-context='{"context":{"id":3,"type":"page"} }">
       * ```
       *
       * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
       *
       * @param {string} text The text with markup to interpolate.
       * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
       *    embedded expression in order to return an interpolation function. Strings with no
       *    embedded expression will return null for the interpolation function.
       * @param {string=} trustedContext when provided, the returned function passes the interpolated
       *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
       *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
       *    provides Strict Contextual Escaping for details.
       * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
       *    unless all embedded expressions evaluate to a value other than `undefined`.
       * @returns {function(context)} an interpolation function which is used to compute the
       *    interpolated string. The function has these parameters:
       *
       * - `context`: evaluation context for all expressions embedded in the interpolated text
       */
      function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
        // Provide a quick exit and simplified result function for text with no interpolation
        if (!text.length || text.indexOf(startSymbol) === -1) {
          var constantInterp;
          if (!mustHaveExpression) {
            var unescapedText = unescapeText(text);
            constantInterp = valueFn(unescapedText);
            constantInterp.exp = text;
            constantInterp.expressions = [];
            constantInterp.$$watchDelegate = constantWatchDelegate;
          }
          return constantInterp;
        }

        allOrNothing = !!allOrNothing;
        var startIndex,
            endIndex,
            index = 0,
            expressions = [],
            parseFns = [],
            textLength = text.length,
            exp,
            concat = [],
            expressionPositions = [];

        while (index < textLength) {
          if ((startIndex = text.indexOf(startSymbol, index)) !== -1 && (endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1) {
            if (index !== startIndex) {
              concat.push(unescapeText(text.substring(index, startIndex)));
            }
            exp = text.substring(startIndex + startSymbolLength, endIndex);
            expressions.push(exp);
            parseFns.push($parse(exp, parseStringifyInterceptor));
            index = endIndex + endSymbolLength;
            expressionPositions.push(concat.length);
            concat.push('');
          } else {
            // we did not find an interpolation, so we have to add the remainder to the separators array
            if (index !== textLength) {
              concat.push(unescapeText(text.substring(index)));
            }
            break;
          }
        }

        // Concatenating expressions makes it hard to reason about whether some combination of
        // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
        // single expression be used for iframe[src], object[src], etc., we ensure that the value
        // that's used is assigned or constructed by some JS code somewhere that is more testable or
        // make it obvious that you bound the value to some user controlled value.  This helps reduce
        // the load when auditing for XSS issues.
        if (trustedContext && concat.length > 1) {
          $interpolateMinErr.throwNoconcat(text);
        }

        if (!mustHaveExpression || expressions.length) {
          var compute = function compute(values) {
            for (var i = 0, ii = expressions.length; i < ii; i++) {
              if (allOrNothing && isUndefined(values[i])) return;
              concat[expressionPositions[i]] = values[i];
            }
            return concat.join('');
          };

          var getValue = function getValue(value) {
            return trustedContext ? $sce.getTrusted(trustedContext, value) : $sce.valueOf(value);
          };

          return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);

            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }

              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }
          }, {
            // all of these properties are undocumented for now
            exp: text, //just for compatibility with regular watchers created via $watch
            expressions: expressions,
            $$watchDelegate: function $$watchDelegate(scope, listener) {
              var lastValue;
              return scope.$watchGroup(parseFns, /** @this */function interpolateFnWatcher(values, oldValues) {
                var currValue = compute(values);
                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
                lastValue = currValue;
              });
            }
          });
        }

        function parseStringifyInterceptor(value) {
          try {
            value = getValue(value);
            return allOrNothing && !isDefined(value) ? value : stringify(value);
          } catch (err) {
            $exceptionHandler($interpolateMinErr.interr(text, err));
          }
        }
      }

      /**
       * @ngdoc method
       * @name $interpolate#startSymbol
       * @description
       * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
       *
       * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
       * the symbol.
       *
       * @returns {string} start symbol.
       */
      $interpolate.startSymbol = function () {
        return startSymbol;
      };

      /**
       * @ngdoc method
       * @name $interpolate#endSymbol
       * @description
       * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
       *
       * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
       * the symbol.
       *
       * @returns {string} end symbol.
       */
      $interpolate.endSymbol = function () {
        return endSymbol;
      };

      return $interpolate;
    }];
  }

  /** @this */
  function $IntervalProvider() {
    this.$get = ['$rootScope', '$window', '$q', '$$q', '$browser', function ($rootScope, $window, $q, $$q, $browser) {
      var intervals = {};

      /**
       * @ngdoc service
       * @name $interval
       *
       * @description
       * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
       * milliseconds.
       *
       * The return value of registering an interval function is a promise. This promise will be
       * notified upon each tick of the interval, and will be resolved after `count` iterations, or
       * run indefinitely if `count` is not defined. The value of the notification will be the
       * number of iterations that have run.
       * To cancel an interval, call `$interval.cancel(promise)`.
       *
       * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
       * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
       * time.
       *
       * <div class="alert alert-warning">
       * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
       * with them.  In particular they are not automatically destroyed when a controller's scope or a
       * directive's element are destroyed.
       * You should take this into consideration and make sure to always cancel the interval at the
       * appropriate moment.  See the example below for more details on how and when to do this.
       * </div>
       *
       * @param {function()} fn A function that should be called repeatedly. If no additional arguments
       *   are passed (see below), the function is called with the current iteration count.
       * @param {number} delay Number of milliseconds between each function call.
       * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
       *   indefinitely.
       * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
       *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
       * @param {...*=} Pass additional parameters to the executed function.
       * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
       *
       * @example
       * <example module="intervalExample" name="interval-service">
       * <file name="index.html">
       *   <script>
       *     angular.module('intervalExample', [])
       *       .controller('ExampleController', ['$scope', '$interval',
       *         function($scope, $interval) {
       *           $scope.format = 'M/d/yy h:mm:ss a';
       *           $scope.blood_1 = 100;
       *           $scope.blood_2 = 120;
       *
       *           var stop;
       *           $scope.fight = function() {
       *             // Don't start a new fight if we are already fighting
       *             if ( angular.isDefined(stop) ) return;
       *
       *             stop = $interval(function() {
       *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
       *                 $scope.blood_1 = $scope.blood_1 - 3;
       *                 $scope.blood_2 = $scope.blood_2 - 4;
       *               } else {
       *                 $scope.stopFight();
       *               }
       *             }, 100);
       *           };
       *
       *           $scope.stopFight = function() {
       *             if (angular.isDefined(stop)) {
       *               $interval.cancel(stop);
       *               stop = undefined;
       *             }
       *           };
       *
       *           $scope.resetFight = function() {
       *             $scope.blood_1 = 100;
       *             $scope.blood_2 = 120;
       *           };
       *
       *           $scope.$on('$destroy', function() {
       *             // Make sure that the interval is destroyed too
       *             $scope.stopFight();
       *           });
       *         }])
       *       // Register the 'myCurrentTime' directive factory method.
       *       // We inject $interval and dateFilter service since the factory method is DI.
       *       .directive('myCurrentTime', ['$interval', 'dateFilter',
       *         function($interval, dateFilter) {
       *           // return the directive link function. (compile function not needed)
       *           return function(scope, element, attrs) {
       *             var format,  // date format
       *                 stopTime; // so that we can cancel the time updates
       *
       *             // used to update the UI
       *             function updateTime() {
       *               element.text(dateFilter(new Date(), format));
       *             }
       *
       *             // watch the expression, and update the UI on change.
       *             scope.$watch(attrs.myCurrentTime, function(value) {
       *               format = value;
       *               updateTime();
       *             });
       *
       *             stopTime = $interval(updateTime, 1000);
       *
       *             // listen on DOM destroy (removal) event, and cancel the next UI update
       *             // to prevent updating time after the DOM element was removed.
       *             element.on('$destroy', function() {
       *               $interval.cancel(stopTime);
       *             });
       *           }
       *         }]);
       *   </script>
       *
       *   <div>
       *     <div ng-controller="ExampleController">
       *       <label>Date format: <input ng-model="format"></label> <hr/>
       *       Current time is: <span my-current-time="format"></span>
       *       <hr/>
       *       Blood 1 : <font color='red'>{{blood_1}}</font>
       *       Blood 2 : <font color='red'>{{blood_2}}</font>
       *       <button type="button" data-ng-click="fight()">Fight</button>
       *       <button type="button" data-ng-click="stopFight()">StopFight</button>
       *       <button type="button" data-ng-click="resetFight()">resetFight</button>
       *     </div>
       *   </div>
       *
       * </file>
       * </example>
       */
      function interval(fn, delay, count, invokeApply) {
        var hasParams = arguments.length > 4,
            args = hasParams ? sliceArgs(arguments, 4) : [],
            setInterval = $window.setInterval,
            clearInterval = $window.clearInterval,
            iteration = 0,
            skipApply = isDefined(invokeApply) && !invokeApply,
            deferred = (skipApply ? $$q : $q).defer(),
            promise = deferred.promise;

        count = isDefined(count) ? count : 0;

        promise.$$intervalId = setInterval(function tick() {
          if (skipApply) {
            $browser.defer(callback);
          } else {
            $rootScope.$evalAsync(callback);
          }
          deferred.notify(iteration++);

          if (count > 0 && iteration >= count) {
            deferred.resolve(iteration);
            clearInterval(promise.$$intervalId);
            delete intervals[promise.$$intervalId];
          }

          if (!skipApply) $rootScope.$apply();
        }, delay);

        intervals[promise.$$intervalId] = deferred;

        return promise;

        function callback() {
          if (!hasParams) {
            fn(iteration);
          } else {
            fn.apply(null, args);
          }
        }
      }

      /**
       * @ngdoc method
       * @name $interval#cancel
       *
       * @description
       * Cancels a task associated with the `promise`.
       *
       * @param {Promise=} promise returned by the `$interval` function.
       * @returns {boolean} Returns `true` if the task was successfully canceled.
       */
      interval.cancel = function (promise) {
        if (promise && promise.$$intervalId in intervals) {
          // Interval cancels should not report as unhandled promise.
          markQExceptionHandled(intervals[promise.$$intervalId].promise);
          intervals[promise.$$intervalId].reject('canceled');
          $window.clearInterval(promise.$$intervalId);
          delete intervals[promise.$$intervalId];
          return true;
        }
        return false;
      };

      return interval;
    }];
  }

  /**
   * @ngdoc service
   * @name $jsonpCallbacks
   * @requires $window
   * @description
   * This service handles the lifecycle of callbacks to handle JSONP requests.
   * Override this service if you wish to customise where the callbacks are stored and
   * how they vary compared to the requested url.
   */
  var $jsonpCallbacksProvider = /** @this */function $jsonpCallbacksProvider() {
    this.$get = function () {
      var callbacks = angular.callbacks;
      var callbackMap = {};

      function _createCallback(callbackId) {
        var callback = function callback(data) {
          callback.data = data;
          callback.called = true;
        };
        callback.id = callbackId;
        return callback;
      }

      return {
        /**
         * @ngdoc method
         * @name $jsonpCallbacks#createCallback
         * @param {string} url the url of the JSONP request
         * @returns {string} the callback path to send to the server as part of the JSONP request
         * @description
         * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
         * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
         */
        createCallback: function createCallback(url) {
          var callbackId = '_' + (callbacks.$$counter++).toString(36);
          var callbackPath = 'angular.callbacks.' + callbackId;
          var callback = _createCallback(callbackId);
          callbackMap[callbackPath] = callbacks[callbackId] = callback;
          return callbackPath;
        },
        /**
         * @ngdoc method
         * @name $jsonpCallbacks#wasCalled
         * @param {string} callbackPath the path to the callback that was sent in the JSONP request
         * @returns {boolean} whether the callback has been called, as a result of the JSONP response
         * @description
         * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
         * callback that was passed in the request.
         */
        wasCalled: function wasCalled(callbackPath) {
          return callbackMap[callbackPath].called;
        },
        /**
         * @ngdoc method
         * @name $jsonpCallbacks#getResponse
         * @param {string} callbackPath the path to the callback that was sent in the JSONP request
         * @returns {*} the data received from the response via the registered callback
         * @description
         * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
         * in the JSONP response.
         */
        getResponse: function getResponse(callbackPath) {
          return callbackMap[callbackPath].data;
        },
        /**
         * @ngdoc method
         * @name $jsonpCallbacks#removeCallback
         * @param {string} callbackPath the path to the callback that was sent in the JSONP request
         * @description
         * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
         * completed or timed-out.
         */
        removeCallback: function removeCallback(callbackPath) {
          var callback = callbackMap[callbackPath];
          delete callbacks[callback.id];
          delete callbackMap[callbackPath];
        }
      };
    };
  };

  /**
   * @ngdoc service
   * @name $locale
   *
   * @description
   * $locale service provides localization rules for various AngularJS components. As of right now the
   * only public api is:
   *
   * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
   */

  var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
      DEFAULT_PORTS = { 'http': 80, 'https': 443, 'ftp': 21 };
  var $locationMinErr = minErr('$location');

  /**
   * Encode path using encodeUriSegment, ignoring forward slashes
   *
   * @param {string} path Path to encode
   * @returns {string}
   */
  function encodePath(path) {
    var segments = path.split('/'),
        i = segments.length;

    while (i--) {
      // decode forward slashes to prevent them from being double encoded
      segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
    }

    return segments.join('/');
  }

  function decodePath(path, html5Mode) {
    var segments = path.split('/'),
        i = segments.length;

    while (i--) {
      segments[i] = decodeURIComponent(segments[i]);
      if (html5Mode) {
        // encode forward slashes to prevent them from being mistaken for path separators
        segments[i] = segments[i].replace(/\//g, '%2F');
      }
    }

    return segments.join('/');
  }

  function parseAbsoluteUrl(absoluteUrl, locationObj) {
    var parsedUrl = urlResolve(absoluteUrl);

    locationObj.$$protocol = parsedUrl.protocol;
    locationObj.$$host = parsedUrl.hostname;
    locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
  }

  var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
  function parseAppUrl(url, locationObj, html5Mode) {

    if (DOUBLE_SLASH_REGEX.test(url)) {
      throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
    }

    var prefixed = url.charAt(0) !== '/';
    if (prefixed) {
      url = '/' + url;
    }
    var match = urlResolve(url);
    var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
    locationObj.$$path = decodePath(path, html5Mode);
    locationObj.$$search = parseKeyValue(match.search);
    locationObj.$$hash = decodeURIComponent(match.hash);

    // make sure path starts with '/';
    if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
      locationObj.$$path = '/' + locationObj.$$path;
    }
  }

  function startsWith(str, search) {
    return str.slice(0, search.length) === search;
  }

  /**
   *
   * @param {string} base
   * @param {string} url
   * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
   *                   the expected string.
   */
  function stripBaseUrl(base, url) {
    if (startsWith(url, base)) {
      return url.substr(base.length);
    }
  }

  function stripHash(url) {
    var index = url.indexOf('#');
    return index === -1 ? url : url.substr(0, index);
  }

  function trimEmptyHash(url) {
    return url.replace(/(#.+)|#$/, '$1');
  }

  function stripFile(url) {
    return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
  }

  /* return the server only (scheme://host:port) */
  function serverBase(url) {
    return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
  }

  /**
   * LocationHtml5Url represents a URL
   * This object is exposed as $location service when HTML5 mode is enabled and supported
   *
   * @constructor
   * @param {string} appBase application base URL
   * @param {string} appBaseNoFile application base URL stripped of any filename
   * @param {string} basePrefix URL path prefix
   */
  function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
    this.$$html5 = true;
    basePrefix = basePrefix || '';
    parseAbsoluteUrl(appBase, this);

    /**
     * Parse given HTML5 (regular) URL string into properties
     * @param {string} url HTML5 URL
     * @private
     */
    this.$$parse = function (url) {
      var pathUrl = stripBaseUrl(appBaseNoFile, url);
      if (!isString(pathUrl)) {
        throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url, appBaseNoFile);
      }

      parseAppUrl(pathUrl, this, true);

      if (!this.$$path) {
        this.$$path = '/';
      }

      this.$$compose();
    };

    /**
     * Compose url and update `absUrl` property
     * @private
     */
    this.$$compose = function () {
      var search = toKeyValue(this.$$search),
          hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

      this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
      this.$$absUrl = appBaseNoFile + this.$$url.substr(1); // first char is always '/'

      this.$$urlUpdatedByLocation = true;
    };

    this.$$parseLinkUrl = function (url, relHref) {
      if (relHref && relHref[0] === '#') {
        // special case for links to hash fragments:
        // keep the old url and only replace the hash fragment
        this.hash(relHref.slice(1));
        return true;
      }
      var appUrl, prevAppUrl;
      var rewrittenUrl;

      if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
        prevAppUrl = appUrl;
        if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
          rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
        } else {
          rewrittenUrl = appBase + prevAppUrl;
        }
      } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
        rewrittenUrl = appBaseNoFile + appUrl;
      } else if (appBaseNoFile === url + '/') {
        rewrittenUrl = appBaseNoFile;
      }
      if (rewrittenUrl) {
        this.$$parse(rewrittenUrl);
      }
      return !!rewrittenUrl;
    };
  }

  /**
   * LocationHashbangUrl represents URL
   * This object is exposed as $location service when developer doesn't opt into html5 mode.
   * It also serves as the base class for html5 mode fallback on legacy browsers.
   *
   * @constructor
   * @param {string} appBase application base URL
   * @param {string} appBaseNoFile application base URL stripped of any filename
   * @param {string} hashPrefix hashbang prefix
   */
  function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {

    parseAbsoluteUrl(appBase, this);

    /**
     * Parse given hashbang URL into properties
     * @param {string} url Hashbang URL
     * @private
     */
    this.$$parse = function (url) {
      var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
      var withoutHashUrl;

      if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {

        // The rest of the URL starts with a hash so we have
        // got either a hashbang path or a plain hash fragment
        withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
        if (isUndefined(withoutHashUrl)) {
          // There was no hashbang prefix so we just have a hash fragment
          withoutHashUrl = withoutBaseUrl;
        }
      } else {
        // There was no hashbang path nor hash fragment:
        // If we are in HTML5 mode we use what is left as the path;
        // Otherwise we ignore what is left
        if (this.$$html5) {
          withoutHashUrl = withoutBaseUrl;
        } else {
          withoutHashUrl = '';
          if (isUndefined(withoutBaseUrl)) {
            appBase = url;
            /** @type {?} */this.replace();
          }
        }
      }

      parseAppUrl(withoutHashUrl, this, false);

      this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);

      this.$$compose();

      /*
       * In Windows, on an anchor node on documents loaded from
       * the filesystem, the browser will return a pathname
       * prefixed with the drive name ('/C:/path') when a
       * pathname without a drive is set:
       *  * a.setAttribute('href', '/foo')
       *   * a.pathname === '/C:/foo' //true
       *
       * Inside of AngularJS, we're always using pathnames that
       * do not include drive names for routing.
       */
      function removeWindowsDriveName(path, url, base) {
        /*
        Matches paths for file protocol on windows,
        such as /C:/foo/bar, and captures only /foo/bar.
        */
        var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;

        var firstPathSegmentMatch;

        //Get the relative path from the input URL.
        if (startsWith(url, base)) {
          url = url.replace(base, '');
        }

        // The input URL intentionally contains a first path segment that ends with a colon.
        if (windowsFilePathExp.exec(url)) {
          return path;
        }

        firstPathSegmentMatch = windowsFilePathExp.exec(path);
        return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
      }
    };

    /**
     * Compose hashbang URL and update `absUrl` property
     * @private
     */
    this.$$compose = function () {
      var search = toKeyValue(this.$$search),
          hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

      this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
      this.$$absUrl = appBase + (this.$$url ? hashPrefix + this.$$url : '');

      this.$$urlUpdatedByLocation = true;
    };

    this.$$parseLinkUrl = function (url, relHref) {
      if (stripHash(appBase) === stripHash(url)) {
        this.$$parse(url);
        return true;
      }
      return false;
    };
  }

  /**
   * LocationHashbangUrl represents URL
   * This object is exposed as $location service when html5 history api is enabled but the browser
   * does not support it.
   *
   * @constructor
   * @param {string} appBase application base URL
   * @param {string} appBaseNoFile application base URL stripped of any filename
   * @param {string} hashPrefix hashbang prefix
   */
  function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
    this.$$html5 = true;
    LocationHashbangUrl.apply(this, arguments);

    this.$$parseLinkUrl = function (url, relHref) {
      if (relHref && relHref[0] === '#') {
        // special case for links to hash fragments:
        // keep the old url and only replace the hash fragment
        this.hash(relHref.slice(1));
        return true;
      }

      var rewrittenUrl;
      var appUrl;

      if (appBase === stripHash(url)) {
        rewrittenUrl = url;
      } else if (appUrl = stripBaseUrl(appBaseNoFile, url)) {
        rewrittenUrl = appBase + hashPrefix + appUrl;
      } else if (appBaseNoFile === url + '/') {
        rewrittenUrl = appBaseNoFile;
      }
      if (rewrittenUrl) {
        this.$$parse(rewrittenUrl);
      }
      return !!rewrittenUrl;
    };

    this.$$compose = function () {
      var search = toKeyValue(this.$$search),
          hash = this.$$hash ? '#' + encodeUriSegment(this.$$hash) : '';

      this.$$url = encodePath(this.$$path) + (search ? '?' + search : '') + hash;
      // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
      this.$$absUrl = appBase + hashPrefix + this.$$url;

      this.$$urlUpdatedByLocation = true;
    };
  }

  var locationPrototype = {

    /**
     * Ensure absolute URL is initialized.
     * @private
     */
    $$absUrl: '',

    /**
     * Are we in html5 mode?
     * @private
     */
    $$html5: false,

    /**
     * Has any change been replacing?
     * @private
     */
    $$replace: false,

    /**
     * @ngdoc method
     * @name $location#absUrl
     *
     * @description
     * This method is getter only.
     *
     * Return full URL representation with all segments encoded according to rules specified in
     * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var absUrl = $location.absUrl();
     * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
     * ```
     *
     * @return {string} full URL
     */
    absUrl: locationGetter('$$absUrl'),

    /**
     * @ngdoc method
     * @name $location#url
     *
     * @description
     * This method is getter / setter.
     *
     * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
     *
     * Change path, search and hash, when called with parameter and return `$location`.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var url = $location.url();
     * // => "/some/path?foo=bar&baz=xoxo"
     * ```
     *
     * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
     * @return {string} url
     */
    url: function url(_url) {
      if (isUndefined(_url)) {
        return this.$$url;
      }

      var match = PATH_MATCH.exec(_url);
      if (match[1] || _url === '') this.path(decodeURIComponent(match[1]));
      if (match[2] || match[1] || _url === '') this.search(match[3] || '');
      this.hash(match[5] || '');

      return this;
    },

    /**
     * @ngdoc method
     * @name $location#protocol
     *
     * @description
     * This method is getter only.
     *
     * Return protocol of current URL.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var protocol = $location.protocol();
     * // => "http"
     * ```
     *
     * @return {string} protocol of current URL
     */
    protocol: locationGetter('$$protocol'),

    /**
     * @ngdoc method
     * @name $location#host
     *
     * @description
     * This method is getter only.
     *
     * Return host of current URL.
     *
     * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var host = $location.host();
     * // => "example.com"
     *
     * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
     * host = $location.host();
     * // => "example.com"
     * host = location.host;
     * // => "example.com:8080"
     * ```
     *
     * @return {string} host of current URL.
     */
    host: locationGetter('$$host'),

    /**
     * @ngdoc method
     * @name $location#port
     *
     * @description
     * This method is getter only.
     *
     * Return port of current URL.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var port = $location.port();
     * // => 80
     * ```
     *
     * @return {Number} port
     */
    port: locationGetter('$$port'),

    /**
     * @ngdoc method
     * @name $location#path
     *
     * @description
     * This method is getter / setter.
     *
     * Return path of current URL when called without any parameter.
     *
     * Change path when called with parameter and return `$location`.
     *
     * Note: Path should always begin with forward slash (/), this method will add the forward slash
     * if it is missing.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var path = $location.path();
     * // => "/some/path"
     * ```
     *
     * @param {(string|number)=} path New path
     * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
     */
    path: locationGetterSetter('$$path', function (path) {
      path = path !== null ? path.toString() : '';
      return path.charAt(0) === '/' ? path : '/' + path;
    }),

    /**
     * @ngdoc method
     * @name $location#search
     *
     * @description
     * This method is getter / setter.
     *
     * Return search part (as object) of current URL when called without any parameter.
     *
     * Change search part when called with parameter and return `$location`.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var searchObject = $location.search();
     * // => {foo: 'bar', baz: 'xoxo'}
     *
     * // set foo to 'yipee'
     * $location.search('foo', 'yipee');
     * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
     * ```
     *
     * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
     * hash object.
     *
     * When called with a single argument the method acts as a setter, setting the `search` component
     * of `$location` to the specified value.
     *
     * If the argument is a hash object containing an array of values, these values will be encoded
     * as duplicate search parameters in the URL.
     *
     * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
     * will override only a single search property.
     *
     * If `paramValue` is an array, it will override the property of the `search` component of
     * `$location` specified via the first argument.
     *
     * If `paramValue` is `null`, the property specified via the first argument will be deleted.
     *
     * If `paramValue` is `true`, the property specified via the first argument will be added with no
     * value nor trailing equal sign.
     *
     * @return {Object} If called with no arguments returns the parsed `search` object. If called with
     * one or more arguments returns `$location` object itself.
     */
    search: function search(_search, paramValue) {
      switch (arguments.length) {
        case 0:
          return this.$$search;
        case 1:
          if (isString(_search) || isNumber(_search)) {
            _search = _search.toString();
            this.$$search = parseKeyValue(_search);
          } else if (isObject(_search)) {
            _search = copy(_search, {});
            // remove object undefined or null properties
            forEach(_search, function (value, key) {
              if (value == null) delete _search[key];
            });

            this.$$search = _search;
          } else {
            throw $locationMinErr('isrcharg', 'The first argument of the `$location#search()` call must be a string or an object.');
          }
          break;
        default:
          if (isUndefined(paramValue) || paramValue === null) {
            delete this.$$search[_search];
          } else {
            this.$$search[_search] = paramValue;
          }
      }

      this.$$compose();
      return this;
    },

    /**
     * @ngdoc method
     * @name $location#hash
     *
     * @description
     * This method is getter / setter.
     *
     * Returns the hash fragment when called without any parameters.
     *
     * Changes the hash fragment when called with a parameter and returns `$location`.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
     * var hash = $location.hash();
     * // => "hashValue"
     * ```
     *
     * @param {(string|number)=} hash New hash fragment
     * @return {string} hash
     */
    hash: locationGetterSetter('$$hash', function (hash) {
      return hash !== null ? hash.toString() : '';
    }),

    /**
     * @ngdoc method
     * @name $location#replace
     *
     * @description
     * If called, all changes to $location during the current `$digest` will replace the current history
     * record, instead of adding a new one.
     */
    replace: function replace() {
      this.$$replace = true;
      return this;
    }
  };

  forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function (Location) {
    Location.prototype = Object.create(locationPrototype);

    /**
     * @ngdoc method
     * @name $location#state
     *
     * @description
     * This method is getter / setter.
     *
     * Return the history state object when called without any parameter.
     *
     * Change the history state object when called with one parameter and return `$location`.
     * The state object is later passed to `pushState` or `replaceState`.
     *
     * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
     * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
     * older browsers (like IE9 or Android < 4.0), don't use this method.
     *
     * @param {object=} state State object for pushState or replaceState
     * @return {object} state
     */
    Location.prototype.state = function (state) {
      if (!arguments.length) {
        return this.$$state;
      }

      if (Location !== LocationHtml5Url || !this.$$html5) {
        throw $locationMinErr('nostate', 'History API state support is available only ' + 'in HTML5 mode and only in browsers supporting HTML5 History API');
      }
      // The user might modify `stateObject` after invoking `$location.state(stateObject)`
      // but we're changing the $$state reference to $browser.state() during the $digest
      // so the modification window is narrow.
      this.$$state = isUndefined(state) ? null : state;
      this.$$urlUpdatedByLocation = true;

      return this;
    };
  });

  function locationGetter(property) {
    return (/** @this */function () {
        return this[property];
      }
    );
  }

  function locationGetterSetter(property, preprocess) {
    return (/** @this */function (value) {
        if (isUndefined(value)) {
          return this[property];
        }

        this[property] = preprocess(value);
        this.$$compose();

        return this;
      }
    );
  }

  /**
   * @ngdoc service
   * @name $location
   *
   * @requires $rootElement
   *
   * @description
   * The $location service parses the URL in the browser address bar (based on the
   * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
   * available to your application. Changes to the URL in the address bar are reflected into
   * $location service and changes to $location are reflected into the browser address bar.
   *
   * **The $location service:**
   *
   * - Exposes the current URL in the browser address bar, so you can
   *   - Watch and observe the URL.
   *   - Change the URL.
   * - Synchronizes the URL with the browser when the user
   *   - Changes the address bar.
   *   - Clicks the back or forward button (or clicks a History link).
   *   - Clicks on a link.
   * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
   *
   * For more information see {@link guide/$location Developer Guide: Using $location}
   */

  /**
   * @ngdoc provider
   * @name $locationProvider
   * @this
   *
   * @description
   * Use the `$locationProvider` to configure how the application deep linking paths are stored.
   */
  function $LocationProvider() {
    var hashPrefix = '!',
        html5Mode = {
      enabled: false,
      requireBase: true,
      rewriteLinks: true
    };

    /**
     * @ngdoc method
     * @name $locationProvider#hashPrefix
     * @description
     * The default value for the prefix is `'!'`.
     * @param {string=} prefix Prefix for hash part (containing path and search)
     * @returns {*} current value if used as getter or itself (chaining) if used as setter
     */
    this.hashPrefix = function (prefix) {
      if (isDefined(prefix)) {
        hashPrefix = prefix;
        return this;
      } else {
        return hashPrefix;
      }
    };

    /**
     * @ngdoc method
     * @name $locationProvider#html5Mode
     * @description
     * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
     *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
     *   properties:
     *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
     *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
     *     support `pushState`.
     *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
     *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
     *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
     *     See the {@link guide/$location $location guide for more information}
     *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
     *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
     *     only happen on links with an attribute that matches the given string. For example, if set
     *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
     *     Note that [attribute name normalization](guide/directive#normalization) does not apply
     *     here, so `'internalLink'` will **not** match `'internal-link'`.
     *
     * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
     */
    this.html5Mode = function (mode) {
      if (isBoolean(mode)) {
        html5Mode.enabled = mode;
        return this;
      } else if (isObject(mode)) {

        if (isBoolean(mode.enabled)) {
          html5Mode.enabled = mode.enabled;
        }

        if (isBoolean(mode.requireBase)) {
          html5Mode.requireBase = mode.requireBase;
        }

        if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
          html5Mode.rewriteLinks = mode.rewriteLinks;
        }

        return this;
      } else {
        return html5Mode;
      }
    };

    /**
     * @ngdoc event
     * @name $location#$locationChangeStart
     * @eventType broadcast on root scope
     * @description
     * Broadcasted before a URL will change.
     *
     * This change can be prevented by calling
     * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
     * details about event object. Upon successful change
     * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
     *
     * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
     * the browser supports the HTML5 History API.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {string} newUrl New URL
     * @param {string=} oldUrl URL that was before it was changed.
     * @param {string=} newState New history state object
     * @param {string=} oldState History state object that was before it was changed.
     */

    /**
     * @ngdoc event
     * @name $location#$locationChangeSuccess
     * @eventType broadcast on root scope
     * @description
     * Broadcasted after a URL was changed.
     *
     * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
     * the browser supports the HTML5 History API.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {string} newUrl New URL
     * @param {string=} oldUrl URL that was before it was changed.
     * @param {string=} newState New history state object
     * @param {string=} oldState History state object that was before it was changed.
     */

    this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window', function ($rootScope, $browser, $sniffer, $rootElement, $window) {
      var $location,
          LocationMode,
          baseHref = $browser.baseHref(),
          // if base[href] is undefined, it defaults to ''
      initialUrl = $browser.url(),
          appBase;

      if (html5Mode.enabled) {
        if (!baseHref && html5Mode.requireBase) {
          throw $locationMinErr('nobase', '$location in HTML5 mode requires a <base> tag to be present!');
        }
        appBase = serverBase(initialUrl) + (baseHref || '/');
        LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
      } else {
        appBase = stripHash(initialUrl);
        LocationMode = LocationHashbangUrl;
      }
      var appBaseNoFile = stripFile(appBase);

      $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
      $location.$$parseLinkUrl(initialUrl, initialUrl);

      $location.$$state = $browser.state();

      var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

      function setBrowserUrlWithFallback(url, replace, state) {
        var oldUrl = $location.url();
        var oldState = $location.$$state;
        try {
          $browser.url(url, replace, state);

          // Make sure $location.state() returns referentially identical (not just deeply equal)
          // state object; this makes possible quick checking if the state changed in the digest
          // loop. Checking deep equality would be too expensive.
          $location.$$state = $browser.state();
        } catch (e) {
          // Restore old values if pushState fails
          $location.url(oldUrl);
          $location.$$state = oldState;

          throw e;
        }
      }

      $rootElement.on('click', function (event) {
        var rewriteLinks = html5Mode.rewriteLinks;
        // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
        // currently we open nice url link and redirect then

        if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;

        var elm = jqLite(event.target);

        // traverse the DOM up to find first A tag
        while (nodeName_(elm[0]) !== 'a') {
          // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
          if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
        }

        if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;

        var absHref = elm.prop('href');
        // get the actual href attribute - see
        // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
        var relHref = elm.attr('href') || elm.attr('xlink:href');

        if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
          // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
          // an animation.
          absHref = urlResolve(absHref.animVal).href;
        }

        // Ignore when url is started with javascript: or mailto:
        if (IGNORE_URI_REGEXP.test(absHref)) return;

        if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
          if ($location.$$parseLinkUrl(absHref, relHref)) {
            // We do a preventDefault for all urls that are part of the AngularJS application,
            // in html5mode and also without, so that we are able to abort navigation without
            // getting double entries in the location history.
            event.preventDefault();
            // update location manually
            if ($location.absUrl() !== $browser.url()) {
              $rootScope.$apply();
              // hack to work around FF6 bug 684208 when scenario runner clicks on links
              $window.angular['ff-684208-preventDefault'] = true;
            }
          }
        }
      });

      // rewrite hashbang url <> html5 url
      if (trimEmptyHash($location.absUrl()) !== trimEmptyHash(initialUrl)) {
        $browser.url($location.absUrl(), true);
      }

      var initializing = true;

      // update $location when $browser url changes
      $browser.onUrlChange(function (newUrl, newState) {

        if (!startsWith(newUrl, appBaseNoFile)) {
          // If we are navigating outside of the app then force a reload
          $window.location.href = newUrl;
          return;
        }

        $rootScope.$evalAsync(function () {
          var oldUrl = $location.absUrl();
          var oldState = $location.$$state;
          var defaultPrevented;
          newUrl = trimEmptyHash(newUrl);
          $location.$$parse(newUrl);
          $location.$$state = newState;

          defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl, newState, oldState).defaultPrevented;

          // if the location was changed by a `$locationChangeStart` handler then stop
          // processing this location change
          if ($location.absUrl() !== newUrl) return;

          if (defaultPrevented) {
            $location.$$parse(oldUrl);
            $location.$$state = oldState;
            setBrowserUrlWithFallback(oldUrl, false, oldState);
          } else {
            initializing = false;
            afterLocationChange(oldUrl, oldState);
          }
        });
        if (!$rootScope.$$phase) $rootScope.$digest();
      });

      // update browser
      $rootScope.$watch(function $locationWatch() {
        if (initializing || $location.$$urlUpdatedByLocation) {
          $location.$$urlUpdatedByLocation = false;

          var oldUrl = trimEmptyHash($browser.url());
          var newUrl = trimEmptyHash($location.absUrl());
          var oldState = $browser.state();
          var currentReplace = $location.$$replace;
          var urlOrStateChanged = oldUrl !== newUrl || $location.$$html5 && $sniffer.history && oldState !== $location.$$state;

          if (initializing || urlOrStateChanged) {
            initializing = false;

            $rootScope.$evalAsync(function () {
              var newUrl = $location.absUrl();
              var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl, $location.$$state, oldState).defaultPrevented;

              // if the location was changed by a `$locationChangeStart` handler then stop
              // processing this location change
              if ($location.absUrl() !== newUrl) return;

              if (defaultPrevented) {
                $location.$$parse(oldUrl);
                $location.$$state = oldState;
              } else {
                if (urlOrStateChanged) {
                  setBrowserUrlWithFallback(newUrl, currentReplace, oldState === $location.$$state ? null : $location.$$state);
                }
                afterLocationChange(oldUrl, oldState);
              }
            });
          }
        }

        $location.$$replace = false;

        // we don't need to return anything because $evalAsync will make the digest loop dirty when
        // there is a change
      });

      return $location;

      function afterLocationChange(oldUrl, oldState) {
        $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl, $location.$$state, oldState);
      }
    }];
  }

  /**
   * @ngdoc service
   * @name $log
   * @requires $window
   *
   * @description
   * Simple service for logging. Default implementation safely writes the message
   * into the browser's console (if present).
   *
   * The main purpose of this service is to simplify debugging and troubleshooting.
   *
   * To reveal the location of the calls to `$log` in the JavaScript console,
   * you can "blackbox" the AngularJS source in your browser:
   *
   * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
   * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
   *
   * Note: Not all browsers support blackboxing.
   *
   * The default is to log `debug` messages. You can use
   * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
   *
   * @example
     <example module="logExample" name="log-service">
       <file name="script.js">
         angular.module('logExample', [])
           .controller('LogController', ['$scope', '$log', function($scope, $log) {
             $scope.$log = $log;
             $scope.message = 'Hello World!';
           }]);
       </file>
       <file name="index.html">
         <div ng-controller="LogController">
           <p>Reload this page with open console, enter text and hit the log button...</p>
           <label>Message:
           <input type="text" ng-model="message" /></label>
           <button ng-click="$log.log(message)">log</button>
           <button ng-click="$log.warn(message)">warn</button>
           <button ng-click="$log.info(message)">info</button>
           <button ng-click="$log.error(message)">error</button>
           <button ng-click="$log.debug(message)">debug</button>
         </div>
       </file>
     </example>
   */

  /**
   * @ngdoc provider
   * @name $logProvider
   * @this
   *
   * @description
   * Use the `$logProvider` to configure how the application logs messages
   */
  function $LogProvider() {
    var debug = true,
        self = this;

    /**
     * @ngdoc method
     * @name $logProvider#debugEnabled
     * @description
     * @param {boolean=} flag enable or disable debug level messages
     * @returns {*} current value if used as getter or itself (chaining) if used as setter
     */
    this.debugEnabled = function (flag) {
      if (isDefined(flag)) {
        debug = flag;
        return this;
      } else {
        return debug;
      }
    };

    this.$get = ['$window', function ($window) {
      // Support: IE 9-11, Edge 12-14+
      // IE/Edge display errors in such a way that it requires the user to click in 4 places
      // to see the stack trace. There is no way to feature-detect it so there's a chance
      // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
      // break apps. Other browsers display errors in a sensible way and some of them map stack
      // traces along source maps if available so it makes sense to let browsers display it
      // as they want.
      var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);

      return {
        /**
         * @ngdoc method
         * @name $log#log
         *
         * @description
         * Write a log message
         */
        log: consoleLog('log'),

        /**
         * @ngdoc method
         * @name $log#info
         *
         * @description
         * Write an information message
         */
        info: consoleLog('info'),

        /**
         * @ngdoc method
         * @name $log#warn
         *
         * @description
         * Write a warning message
         */
        warn: consoleLog('warn'),

        /**
         * @ngdoc method
         * @name $log#error
         *
         * @description
         * Write an error message
         */
        error: consoleLog('error'),

        /**
         * @ngdoc method
         * @name $log#debug
         *
         * @description
         * Write a debug message
         */
        debug: function () {
          var fn = consoleLog('debug');

          return function () {
            if (debug) {
              fn.apply(self, arguments);
            }
          };
        }()
      };

      function formatError(arg) {
        if (isError(arg)) {
          if (arg.stack && formatStackTrace) {
            arg = arg.message && arg.stack.indexOf(arg.message) === -1 ? 'Error: ' + arg.message + '\n' + arg.stack : arg.stack;
          } else if (arg.sourceURL) {
            arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
          }
        }
        return arg;
      }

      function consoleLog(type) {
        var console = $window.console || {},
            logFn = console[type] || console.log || noop;

        return function () {
          var args = [];
          forEach(arguments, function (arg) {
            args.push(formatError(arg));
          });
          // Support: IE 9 only
          // console methods don't inherit from Function.prototype in IE 9 so we can't
          // call `logFn.apply(console, args)` directly.
          return Function.prototype.apply.call(logFn, console, args);
        };
      }
    }];
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   *     Any commits to this file should be reviewed with security in mind.  *
   *   Changes to this file can potentially create security vulnerabilities. *
   *          An approval from 2 Core members with history of modifying      *
   *                         this file is required.                          *
   *                                                                         *
   *  Does the change somehow allow for arbitrary javascript to be executed? *
   *    Or allows for someone to change the prototype of built-in objects?   *
   *     Or gives undesired access to variables likes document or window?    *
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  var $parseMinErr = minErr('$parse');

  var objectValueOf = {}.constructor.prototype.valueOf;

  // Sandboxing AngularJS Expressions
  // ------------------------------
  // AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
  // various means such as obtaining a reference to native JS functions like the Function constructor.
  //
  // As an example, consider the following AngularJS expression:
  //
  //   {}.toString.constructor('alert("evil JS code")')
  //
  // It is important to realize that if you create an expression from a string that contains user provided
  // content then it is possible that your application contains a security vulnerability to an XSS style attack.
  //
  // See https://docs.angularjs.org/guide/security


  function getStringValue(name) {
    // Property names must be strings. This means that non-string objects cannot be used
    // as keys in an object. Any non-string object, including a number, is typecasted
    // into a string via the toString method.
    // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
    //
    // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
    // to a string. It's not always possible. If `name` is an object and its `toString` method is
    // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
    //
    // TypeError: Cannot convert object to primitive value
    //
    // For performance reasons, we don't catch this error here and allow it to propagate up the call
    // stack. Note that you'll get the same error in JavaScript if you try to access a property using
    // such a 'broken' object as a key.
    return name + '';
  }

  var OPERATORS = createMap();
  forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function (operator) {
    OPERATORS[operator] = true;
  });
  var ESCAPE = { 'n': '\n', 'f': '\f', 'r': '\r', 't': '\t', 'v': '\v', '\'': '\'', '"': '"' };

  /////////////////////////////////////////


  /**
   * @constructor
   */
  var Lexer = function Lexer(options) {
    this.options = options;
  };

  Lexer.prototype = {
    constructor: Lexer,

    lex: function lex(text) {
      this.text = text;
      this.index = 0;
      this.tokens = [];

      while (this.index < this.text.length) {
        var ch = this.text.charAt(this.index);
        if (ch === '"' || ch === '\'') {
          this.readString(ch);
        } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
          this.readNumber();
        } else if (this.isIdentifierStart(this.peekMultichar())) {
          this.readIdent();
        } else if (this.is(ch, '(){}[].,;:?')) {
          this.tokens.push({ index: this.index, text: ch });
          this.index++;
        } else if (this.isWhitespace(ch)) {
          this.index++;
        } else {
          var ch2 = ch + this.peek();
          var ch3 = ch2 + this.peek(2);
          var op1 = OPERATORS[ch];
          var op2 = OPERATORS[ch2];
          var op3 = OPERATORS[ch3];
          if (op1 || op2 || op3) {
            var token = op3 ? ch3 : op2 ? ch2 : ch;
            this.tokens.push({ index: this.index, text: token, operator: true });
            this.index += token.length;
          } else {
            this.throwError('Unexpected next character ', this.index, this.index + 1);
          }
        }
      }
      return this.tokens;
    },

    is: function is(ch, chars) {
      return chars.indexOf(ch) !== -1;
    },

    peek: function peek(i) {
      var num = i || 1;
      return this.index + num < this.text.length ? this.text.charAt(this.index + num) : false;
    },

    isNumber: function isNumber(ch) {
      return '0' <= ch && ch <= '9' && typeof ch === 'string';
    },

    isWhitespace: function isWhitespace(ch) {
      // IE treats non-breaking space as \u00A0
      return ch === ' ' || ch === '\r' || ch === '\t' || ch === '\n' || ch === '\v' || ch === '\xA0';
    },

    isIdentifierStart: function isIdentifierStart(ch) {
      return this.options.isIdentifierStart ? this.options.isIdentifierStart(ch, this.codePointAt(ch)) : this.isValidIdentifierStart(ch);
    },

    isValidIdentifierStart: function isValidIdentifierStart(ch) {
      return 'a' <= ch && ch <= 'z' || 'A' <= ch && ch <= 'Z' || '_' === ch || ch === '$';
    },

    isIdentifierContinue: function isIdentifierContinue(ch) {
      return this.options.isIdentifierContinue ? this.options.isIdentifierContinue(ch, this.codePointAt(ch)) : this.isValidIdentifierContinue(ch);
    },

    isValidIdentifierContinue: function isValidIdentifierContinue(ch, cp) {
      return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
    },

    codePointAt: function codePointAt(ch) {
      if (ch.length === 1) return ch.charCodeAt(0);
      // eslint-disable-next-line no-bitwise
      return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
    },

    peekMultichar: function peekMultichar() {
      var ch = this.text.charAt(this.index);
      var peek = this.peek();
      if (!peek) {
        return ch;
      }
      var cp1 = ch.charCodeAt(0);
      var cp2 = peek.charCodeAt(0);
      if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
        return ch + peek;
      }
      return ch;
    },

    isExpOperator: function isExpOperator(ch) {
      return ch === '-' || ch === '+' || this.isNumber(ch);
    },

    throwError: function throwError(error, start, end) {
      end = end || this.index;
      var colStr = isDefined(start) ? 's ' + start + '-' + this.index + ' [' + this.text.substring(start, end) + ']' : ' ' + end;
      throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].', error, colStr, this.text);
    },

    readNumber: function readNumber() {
      var number = '';
      var start = this.index;
      while (this.index < this.text.length) {
        var ch = lowercase(this.text.charAt(this.index));
        if (ch === '.' || this.isNumber(ch)) {
          number += ch;
        } else {
          var peekCh = this.peek();
          if (ch === 'e' && this.isExpOperator(peekCh)) {
            number += ch;
          } else if (this.isExpOperator(ch) && peekCh && this.isNumber(peekCh) && number.charAt(number.length - 1) === 'e') {
            number += ch;
          } else if (this.isExpOperator(ch) && (!peekCh || !this.isNumber(peekCh)) && number.charAt(number.length - 1) === 'e') {
            this.throwError('Invalid exponent');
          } else {
            break;
          }
        }
        this.index++;
      }
      this.tokens.push({
        index: start,
        text: number,
        constant: true,
        value: Number(number)
      });
    },

    readIdent: function readIdent() {
      var start = this.index;
      this.index += this.peekMultichar().length;
      while (this.index < this.text.length) {
        var ch = this.peekMultichar();
        if (!this.isIdentifierContinue(ch)) {
          break;
        }
        this.index += ch.length;
      }
      this.tokens.push({
        index: start,
        text: this.text.slice(start, this.index),
        identifier: true
      });
    },

    readString: function readString(quote) {
      var start = this.index;
      this.index++;
      var string = '';
      var rawString = quote;
      var escape = false;
      while (this.index < this.text.length) {
        var ch = this.text.charAt(this.index);
        rawString += ch;
        if (escape) {
          if (ch === 'u') {
            var hex = this.text.substring(this.index + 1, this.index + 5);
            if (!hex.match(/[\da-f]{4}/i)) {
              this.throwError('Invalid unicode escape [\\u' + hex + ']');
            }
            this.index += 4;
            string += String.fromCharCode(parseInt(hex, 16));
          } else {
            var rep = ESCAPE[ch];
            string = string + (rep || ch);
          }
          escape = false;
        } else if (ch === '\\') {
          escape = true;
        } else if (ch === quote) {
          this.index++;
          this.tokens.push({
            index: start,
            text: rawString,
            constant: true,
            value: string
          });
          return;
        } else {
          string += ch;
        }
        this.index++;
      }
      this.throwError('Unterminated quote', start);
    }
  };

  var AST = function AST(lexer, options) {
    this.lexer = lexer;
    this.options = options;
  };

  AST.Program = 'Program';
  AST.ExpressionStatement = 'ExpressionStatement';
  AST.AssignmentExpression = 'AssignmentExpression';
  AST.ConditionalExpression = 'ConditionalExpression';
  AST.LogicalExpression = 'LogicalExpression';
  AST.BinaryExpression = 'BinaryExpression';
  AST.UnaryExpression = 'UnaryExpression';
  AST.CallExpression = 'CallExpression';
  AST.MemberExpression = 'MemberExpression';
  AST.Identifier = 'Identifier';
  AST.Literal = 'Literal';
  AST.ArrayExpression = 'ArrayExpression';
  AST.Property = 'Property';
  AST.ObjectExpression = 'ObjectExpression';
  AST.ThisExpression = 'ThisExpression';
  AST.LocalsExpression = 'LocalsExpression';

  // Internal use only
  AST.NGValueParameter = 'NGValueParameter';

  AST.prototype = {
    ast: function ast(text) {
      this.text = text;
      this.tokens = this.lexer.lex(text);

      var value = this.program();

      if (this.tokens.length !== 0) {
        this.throwError('is an unexpected token', this.tokens[0]);
      }

      return value;
    },

    program: function program() {
      var body = [];
      while (true) {
        if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']')) body.push(this.expressionStatement());
        if (!this.expect(';')) {
          return { type: AST.Program, body: body };
        }
      }
    },

    expressionStatement: function expressionStatement() {
      return { type: AST.ExpressionStatement, expression: this.filterChain() };
    },

    filterChain: function filterChain() {
      var left = this.expression();
      while (this.expect('|')) {
        left = this.filter(left);
      }
      return left;
    },

    expression: function expression() {
      return this.assignment();
    },

    assignment: function assignment() {
      var result = this.ternary();
      if (this.expect('=')) {
        if (!isAssignable(result)) {
          throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
        }

        result = { type: AST.AssignmentExpression, left: result, right: this.assignment(), operator: '=' };
      }
      return result;
    },

    ternary: function ternary() {
      var test = this.logicalOR();
      var alternate;
      var consequent;
      if (this.expect('?')) {
        alternate = this.expression();
        if (this.consume(':')) {
          consequent = this.expression();
          return { type: AST.ConditionalExpression, test: test, alternate: alternate, consequent: consequent };
        }
      }
      return test;
    },

    logicalOR: function logicalOR() {
      var left = this.logicalAND();
      while (this.expect('||')) {
        left = { type: AST.LogicalExpression, operator: '||', left: left, right: this.logicalAND() };
      }
      return left;
    },

    logicalAND: function logicalAND() {
      var left = this.equality();
      while (this.expect('&&')) {
        left = { type: AST.LogicalExpression, operator: '&&', left: left, right: this.equality() };
      }
      return left;
    },

    equality: function equality() {
      var left = this.relational();
      var token;
      while (token = this.expect('==', '!=', '===', '!==')) {
        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.relational() };
      }
      return left;
    },

    relational: function relational() {
      var left = this.additive();
      var token;
      while (token = this.expect('<', '>', '<=', '>=')) {
        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.additive() };
      }
      return left;
    },

    additive: function additive() {
      var left = this.multiplicative();
      var token;
      while (token = this.expect('+', '-')) {
        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.multiplicative() };
      }
      return left;
    },

    multiplicative: function multiplicative() {
      var left = this.unary();
      var token;
      while (token = this.expect('*', '/', '%')) {
        left = { type: AST.BinaryExpression, operator: token.text, left: left, right: this.unary() };
      }
      return left;
    },

    unary: function unary() {
      var token;
      if (token = this.expect('+', '-', '!')) {
        return { type: AST.UnaryExpression, operator: token.text, prefix: true, argument: this.unary() };
      } else {
        return this.primary();
      }
    },

    primary: function primary() {
      var primary;
      if (this.expect('(')) {
        primary = this.filterChain();
        this.consume(')');
      } else if (this.expect('[')) {
        primary = this.arrayDeclaration();
      } else if (this.expect('{')) {
        primary = this.object();
      } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
        primary = copy(this.selfReferential[this.consume().text]);
      } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
        primary = { type: AST.Literal, value: this.options.literals[this.consume().text] };
      } else if (this.peek().identifier) {
        primary = this.identifier();
      } else if (this.peek().constant) {
        primary = this.constant();
      } else {
        this.throwError('not a primary expression', this.peek());
      }

      var next;
      while (next = this.expect('(', '[', '.')) {
        if (next.text === '(') {
          primary = { type: AST.CallExpression, callee: primary, arguments: this.parseArguments() };
          this.consume(')');
        } else if (next.text === '[') {
          primary = { type: AST.MemberExpression, object: primary, property: this.expression(), computed: true };
          this.consume(']');
        } else if (next.text === '.') {
          primary = { type: AST.MemberExpression, object: primary, property: this.identifier(), computed: false };
        } else {
          this.throwError('IMPOSSIBLE');
        }
      }
      return primary;
    },

    filter: function filter(baseExpression) {
      var args = [baseExpression];
      var result = { type: AST.CallExpression, callee: this.identifier(), arguments: args, filter: true };

      while (this.expect(':')) {
        args.push(this.expression());
      }

      return result;
    },

    parseArguments: function parseArguments() {
      var args = [];
      if (this.peekToken().text !== ')') {
        do {
          args.push(this.filterChain());
        } while (this.expect(','));
      }
      return args;
    },

    identifier: function identifier() {
      var token = this.consume();
      if (!token.identifier) {
        this.throwError('is not a valid identifier', token);
      }
      return { type: AST.Identifier, name: token.text };
    },

    constant: function constant() {
      // TODO check that it is a constant
      return { type: AST.Literal, value: this.consume().value };
    },

    arrayDeclaration: function arrayDeclaration() {
      var elements = [];
      if (this.peekToken().text !== ']') {
        do {
          if (this.peek(']')) {
            // Support trailing commas per ES5.1.
            break;
          }
          elements.push(this.expression());
        } while (this.expect(','));
      }
      this.consume(']');

      return { type: AST.ArrayExpression, elements: elements };
    },

    object: function object() {
      var properties = [],
          property;
      if (this.peekToken().text !== '}') {
        do {
          if (this.peek('}')) {
            // Support trailing commas per ES5.1.
            break;
          }
          property = { type: AST.Property, kind: 'init' };
          if (this.peek().constant) {
            property.key = this.constant();
            property.computed = false;
            this.consume(':');
            property.value = this.expression();
          } else if (this.peek().identifier) {
            property.key = this.identifier();
            property.computed = false;
            if (this.peek(':')) {
              this.consume(':');
              property.value = this.expression();
            } else {
              property.value = property.key;
            }
          } else if (this.peek('[')) {
            this.consume('[');
            property.key = this.expression();
            this.consume(']');
            property.computed = true;
            this.consume(':');
            property.value = this.expression();
          } else {
            this.throwError('invalid key', this.peek());
          }
          properties.push(property);
        } while (this.expect(','));
      }
      this.consume('}');

      return { type: AST.ObjectExpression, properties: properties };
    },

    throwError: function throwError(msg, token) {
      throw $parseMinErr('syntax', 'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].', token.text, msg, token.index + 1, this.text, this.text.substring(token.index));
    },

    consume: function consume(e1) {
      if (this.tokens.length === 0) {
        throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
      }

      var token = this.expect(e1);
      if (!token) {
        this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
      }
      return token;
    },

    peekToken: function peekToken() {
      if (this.tokens.length === 0) {
        throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
      }
      return this.tokens[0];
    },

    peek: function peek(e1, e2, e3, e4) {
      return this.peekAhead(0, e1, e2, e3, e4);
    },

    peekAhead: function peekAhead(i, e1, e2, e3, e4) {
      if (this.tokens.length > i) {
        var token = this.tokens[i];
        var t = token.text;
        if (t === e1 || t === e2 || t === e3 || t === e4 || !e1 && !e2 && !e3 && !e4) {
          return token;
        }
      }
      return false;
    },

    expect: function expect(e1, e2, e3, e4) {
      var token = this.peek(e1, e2, e3, e4);
      if (token) {
        this.tokens.shift();
        return token;
      }
      return false;
    },

    selfReferential: {
      'this': { type: AST.ThisExpression },
      '$locals': { type: AST.LocalsExpression }
    }
  };

  function ifDefined(v, d) {
    return typeof v !== 'undefined' ? v : d;
  }

  function plusFn(l, r) {
    if (typeof l === 'undefined') return r;
    if (typeof r === 'undefined') return l;
    return l + r;
  }

  function isStateless($filter, filterName) {
    var fn = $filter(filterName);
    return !fn.$stateful;
  }

  var PURITY_ABSOLUTE = 1;
  var PURITY_RELATIVE = 2;

  // Detect nodes which could depend on non-shallow state of objects
  function isPure(node, parentIsPure) {
    switch (node.type) {
      // Computed members might invoke a stateful toString()
      case AST.MemberExpression:
        if (node.computed) {
          return false;
        }
        break;

      // Unary always convert to primative
      case AST.UnaryExpression:
        return PURITY_ABSOLUTE;

      // The binary + operator can invoke a stateful toString().
      case AST.BinaryExpression:
        return node.operator !== '+' ? PURITY_ABSOLUTE : false;

      // Functions / filters probably read state from within objects
      case AST.CallExpression:
        return false;
    }

    return undefined === parentIsPure ? PURITY_RELATIVE : parentIsPure;
  }

  function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
    var allConstants;
    var argsToWatch;
    var isStatelessFilter;

    var astIsPure = ast.isPure = isPure(ast, parentIsPure);

    switch (ast.type) {
      case AST.Program:
        allConstants = true;
        forEach(ast.body, function (expr) {
          findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
          allConstants = allConstants && expr.expression.constant;
        });
        ast.constant = allConstants;
        break;
      case AST.Literal:
        ast.constant = true;
        ast.toWatch = [];
        break;
      case AST.UnaryExpression:
        findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
        ast.constant = ast.argument.constant;
        ast.toWatch = ast.argument.toWatch;
        break;
      case AST.BinaryExpression:
        findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
        ast.constant = ast.left.constant && ast.right.constant;
        ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
        break;
      case AST.LogicalExpression:
        findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
        ast.constant = ast.left.constant && ast.right.constant;
        ast.toWatch = ast.constant ? [] : [ast];
        break;
      case AST.ConditionalExpression:
        findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
        ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
        ast.toWatch = ast.constant ? [] : [ast];
        break;
      case AST.Identifier:
        ast.constant = false;
        ast.toWatch = [ast];
        break;
      case AST.MemberExpression:
        findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
        if (ast.computed) {
          findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
        }
        ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
        ast.toWatch = ast.constant ? [] : [ast];
        break;
      case AST.CallExpression:
        isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
        allConstants = isStatelessFilter;
        argsToWatch = [];
        forEach(ast.arguments, function (expr) {
          findConstantAndWatchExpressions(expr, $filter, astIsPure);
          allConstants = allConstants && expr.constant;
          argsToWatch.push.apply(argsToWatch, expr.toWatch);
        });
        ast.constant = allConstants;
        ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
        break;
      case AST.AssignmentExpression:
        findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
        ast.constant = ast.left.constant && ast.right.constant;
        ast.toWatch = [ast];
        break;
      case AST.ArrayExpression:
        allConstants = true;
        argsToWatch = [];
        forEach(ast.elements, function (expr) {
          findConstantAndWatchExpressions(expr, $filter, astIsPure);
          allConstants = allConstants && expr.constant;
          argsToWatch.push.apply(argsToWatch, expr.toWatch);
        });
        ast.constant = allConstants;
        ast.toWatch = argsToWatch;
        break;
      case AST.ObjectExpression:
        allConstants = true;
        argsToWatch = [];
        forEach(ast.properties, function (property) {
          findConstantAndWatchExpressions(property.value, $filter, astIsPure);
          allConstants = allConstants && property.value.constant;
          argsToWatch.push.apply(argsToWatch, property.value.toWatch);
          if (property.computed) {
            //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
            findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
            allConstants = allConstants && property.key.constant;
            argsToWatch.push.apply(argsToWatch, property.key.toWatch);
          }
        });
        ast.constant = allConstants;
        ast.toWatch = argsToWatch;
        break;
      case AST.ThisExpression:
        ast.constant = false;
        ast.toWatch = [];
        break;
      case AST.LocalsExpression:
        ast.constant = false;
        ast.toWatch = [];
        break;
    }
  }

  function getInputs(body) {
    if (body.length !== 1) return;
    var lastExpression = body[0].expression;
    var candidate = lastExpression.toWatch;
    if (candidate.length !== 1) return candidate;
    return candidate[0] !== lastExpression ? candidate : undefined;
  }

  function isAssignable(ast) {
    return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
  }

  function assignableAST(ast) {
    if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
      return { type: AST.AssignmentExpression, left: ast.body[0].expression, right: { type: AST.NGValueParameter }, operator: '=' };
    }
  }

  function isLiteral(ast) {
    return ast.body.length === 0 || ast.body.length === 1 && (ast.body[0].expression.type === AST.Literal || ast.body[0].expression.type === AST.ArrayExpression || ast.body[0].expression.type === AST.ObjectExpression);
  }

  function isConstant(ast) {
    return ast.constant;
  }

  function ASTCompiler($filter) {
    this.$filter = $filter;
  }

  ASTCompiler.prototype = {
    compile: function compile(ast) {
      var self = this;
      this.state = {
        nextId: 0,
        filters: {},
        fn: { vars: [], body: [], own: {} },
        assign: { vars: [], body: [], own: {} },
        inputs: []
      };
      findConstantAndWatchExpressions(ast, self.$filter);
      var extra = '';
      var assignable;
      this.stage = 'assign';
      if (assignable = assignableAST(ast)) {
        this.state.computing = 'assign';
        var result = this.nextId();
        this.recurse(assignable, result);
        this.return_(result);
        extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
      }
      var toWatch = getInputs(ast.body);
      self.stage = 'inputs';
      forEach(toWatch, function (watch, key) {
        var fnKey = 'fn' + key;
        self.state[fnKey] = { vars: [], body: [], own: {} };
        self.state.computing = fnKey;
        var intoId = self.nextId();
        self.recurse(watch, intoId);
        self.return_(intoId);
        self.state.inputs.push({ name: fnKey, isPure: watch.isPure });
        watch.watchId = key;
      });
      this.state.computing = 'fn';
      this.stage = 'main';
      this.recurse(ast);
      var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' + this.filterPrefix() + 'var fn=' + this.generateFunction('fn', 's,l,a,i') + extra + this.watchFns() + 'return fn;';

      // eslint-disable-next-line no-new-func
      var fn = new Function('$filter', 'getStringValue', 'ifDefined', 'plus', fnString)(this.$filter, getStringValue, ifDefined, plusFn);
      this.state = this.stage = undefined;
      return fn;
    },

    USE: 'use',

    STRICT: 'strict',

    watchFns: function watchFns() {
      var result = [];
      var inputs = this.state.inputs;
      var self = this;
      forEach(inputs, function (input) {
        result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
        if (input.isPure) {
          result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
        }
      });
      if (inputs.length) {
        result.push('fn.inputs=[' + inputs.map(function (i) {
          return i.name;
        }).join(',') + '];');
      }
      return result.join('');
    },

    generateFunction: function generateFunction(name, params) {
      return 'function(' + params + '){' + this.varsPrefix(name) + this.body(name) + '};';
    },

    filterPrefix: function filterPrefix() {
      var parts = [];
      var self = this;
      forEach(this.state.filters, function (id, filter) {
        parts.push(id + '=$filter(' + self.escape(filter) + ')');
      });
      if (parts.length) return 'var ' + parts.join(',') + ';';
      return '';
    },

    varsPrefix: function varsPrefix(section) {
      return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
    },

    body: function body(section) {
      return this.state[section].body.join('');
    },

    recurse: function recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
      var left,
          right,
          self = this,
          args,
          expression,
          computed;
      recursionFn = recursionFn || noop;
      if (!skipWatchIdCheck && isDefined(ast.watchId)) {
        intoId = intoId || this.nextId();
        this.if_('i', this.lazyAssign(intoId, this.computedMember('i', ast.watchId)), this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true));
        return;
      }
      switch (ast.type) {
        case AST.Program:
          forEach(ast.body, function (expression, pos) {
            self.recurse(expression.expression, undefined, undefined, function (expr) {
              right = expr;
            });
            if (pos !== ast.body.length - 1) {
              self.current().body.push(right, ';');
            } else {
              self.return_(right);
            }
          });
          break;
        case AST.Literal:
          expression = this.escape(ast.value);
          this.assign(intoId, expression);
          recursionFn(intoId || expression);
          break;
        case AST.UnaryExpression:
          this.recurse(ast.argument, undefined, undefined, function (expr) {
            right = expr;
          });
          expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
          this.assign(intoId, expression);
          recursionFn(expression);
          break;
        case AST.BinaryExpression:
          this.recurse(ast.left, undefined, undefined, function (expr) {
            left = expr;
          });
          this.recurse(ast.right, undefined, undefined, function (expr) {
            right = expr;
          });
          if (ast.operator === '+') {
            expression = this.plus(left, right);
          } else if (ast.operator === '-') {
            expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
          } else {
            expression = '(' + left + ')' + ast.operator + '(' + right + ')';
          }
          this.assign(intoId, expression);
          recursionFn(expression);
          break;
        case AST.LogicalExpression:
          intoId = intoId || this.nextId();
          self.recurse(ast.left, intoId);
          self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
          recursionFn(intoId);
          break;
        case AST.ConditionalExpression:
          intoId = intoId || this.nextId();
          self.recurse(ast.test, intoId);
          self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
          recursionFn(intoId);
          break;
        case AST.Identifier:
          intoId = intoId || this.nextId();
          if (nameId) {
            nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
            nameId.computed = false;
            nameId.name = ast.name;
          }
          self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)), function () {
            self.if_(self.stage === 'inputs' || 's', function () {
              if (create && create !== 1) {
                self.if_(self.isNull(self.nonComputedMember('s', ast.name)), self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
              }
              self.assign(intoId, self.nonComputedMember('s', ast.name));
            });
          }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name)));
          recursionFn(intoId);
          break;
        case AST.MemberExpression:
          left = nameId && (nameId.context = this.nextId()) || this.nextId();
          intoId = intoId || this.nextId();
          self.recurse(ast.object, left, undefined, function () {
            self.if_(self.notNull(left), function () {
              if (ast.computed) {
                right = self.nextId();
                self.recurse(ast.property, right);
                self.getStringValue(right);
                if (create && create !== 1) {
                  self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
                }
                expression = self.computedMember(left, right);
                self.assign(intoId, expression);
                if (nameId) {
                  nameId.computed = true;
                  nameId.name = right;
                }
              } else {
                if (create && create !== 1) {
                  self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
                }
                expression = self.nonComputedMember(left, ast.property.name);
                self.assign(intoId, expression);
                if (nameId) {
                  nameId.computed = false;
                  nameId.name = ast.property.name;
                }
              }
            }, function () {
              self.assign(intoId, 'undefined');
            });
            recursionFn(intoId);
          }, !!create);
          break;
        case AST.CallExpression:
          intoId = intoId || this.nextId();
          if (ast.filter) {
            right = self.filter(ast.callee.name);
            args = [];
            forEach(ast.arguments, function (expr) {
              var argument = self.nextId();
              self.recurse(expr, argument);
              args.push(argument);
            });
            expression = right + '(' + args.join(',') + ')';
            self.assign(intoId, expression);
            recursionFn(intoId);
          } else {
            right = self.nextId();
            left = {};
            args = [];
            self.recurse(ast.callee, right, left, function () {
              self.if_(self.notNull(right), function () {
                forEach(ast.arguments, function (expr) {
                  self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function (argument) {
                    args.push(argument);
                  });
                });
                if (left.name) {
                  expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
                } else {
                  expression = right + '(' + args.join(',') + ')';
                }
                self.assign(intoId, expression);
              }, function () {
                self.assign(intoId, 'undefined');
              });
              recursionFn(intoId);
            });
          }
          break;
        case AST.AssignmentExpression:
          right = this.nextId();
          left = {};
          this.recurse(ast.left, undefined, left, function () {
            self.if_(self.notNull(left.context), function () {
              self.recurse(ast.right, right);
              expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
              self.assign(intoId, expression);
              recursionFn(intoId || expression);
            });
          }, 1);
          break;
        case AST.ArrayExpression:
          args = [];
          forEach(ast.elements, function (expr) {
            self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function (argument) {
              args.push(argument);
            });
          });
          expression = '[' + args.join(',') + ']';
          this.assign(intoId, expression);
          recursionFn(intoId || expression);
          break;
        case AST.ObjectExpression:
          args = [];
          computed = false;
          forEach(ast.properties, function (property) {
            if (property.computed) {
              computed = true;
            }
          });
          if (computed) {
            intoId = intoId || this.nextId();
            this.assign(intoId, '{}');
            forEach(ast.properties, function (property) {
              if (property.computed) {
                left = self.nextId();
                self.recurse(property.key, left);
              } else {
                left = property.key.type === AST.Identifier ? property.key.name : '' + property.key.value;
              }
              right = self.nextId();
              self.recurse(property.value, right);
              self.assign(self.member(intoId, left, property.computed), right);
            });
          } else {
            forEach(ast.properties, function (property) {
              self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function (expr) {
                args.push(self.escape(property.key.type === AST.Identifier ? property.key.name : '' + property.key.value) + ':' + expr);
              });
            });
            expression = '{' + args.join(',') + '}';
            this.assign(intoId, expression);
          }
          recursionFn(intoId || expression);
          break;
        case AST.ThisExpression:
          this.assign(intoId, 's');
          recursionFn(intoId || 's');
          break;
        case AST.LocalsExpression:
          this.assign(intoId, 'l');
          recursionFn(intoId || 'l');
          break;
        case AST.NGValueParameter:
          this.assign(intoId, 'v');
          recursionFn(intoId || 'v');
          break;
      }
    },

    getHasOwnProperty: function getHasOwnProperty(element, property) {
      var key = element + '.' + property;
      var own = this.current().own;
      if (!own.hasOwnProperty(key)) {
        own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
      }
      return own[key];
    },

    assign: function assign(id, value) {
      if (!id) return;
      this.current().body.push(id, '=', value, ';');
      return id;
    },

    filter: function filter(filterName) {
      if (!this.state.filters.hasOwnProperty(filterName)) {
        this.state.filters[filterName] = this.nextId(true);
      }
      return this.state.filters[filterName];
    },

    ifDefined: function ifDefined(id, defaultValue) {
      return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
    },

    plus: function plus(left, right) {
      return 'plus(' + left + ',' + right + ')';
    },

    return_: function return_(id) {
      this.current().body.push('return ', id, ';');
    },

    if_: function if_(test, alternate, consequent) {
      if (test === true) {
        alternate();
      } else {
        var body = this.current().body;
        body.push('if(', test, '){');
        alternate();
        body.push('}');
        if (consequent) {
          body.push('else{');
          consequent();
          body.push('}');
        }
      }
    },

    not: function not(expression) {
      return '!(' + expression + ')';
    },

    isNull: function isNull(expression) {
      return expression + '==null';
    },

    notNull: function notNull(expression) {
      return expression + '!=null';
    },

    nonComputedMember: function nonComputedMember(left, right) {
      var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
      var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
      if (SAFE_IDENTIFIER.test(right)) {
        return left + '.' + right;
      } else {
        return left + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
      }
    },

    computedMember: function computedMember(left, right) {
      return left + '[' + right + ']';
    },

    member: function member(left, right, computed) {
      if (computed) return this.computedMember(left, right);
      return this.nonComputedMember(left, right);
    },

    getStringValue: function getStringValue(item) {
      this.assign(item, 'getStringValue(' + item + ')');
    },

    lazyRecurse: function lazyRecurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
      var self = this;
      return function () {
        self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
      };
    },

    lazyAssign: function lazyAssign(id, value) {
      var self = this;
      return function () {
        self.assign(id, value);
      };
    },

    stringEscapeRegex: /[^ a-zA-Z0-9]/g,

    stringEscapeFn: function stringEscapeFn(c) {
      return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
    },

    escape: function escape(value) {
      if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
      if (isNumber(value)) return value.toString();
      if (value === true) return 'true';
      if (value === false) return 'false';
      if (value === null) return 'null';
      if (typeof value === 'undefined') return 'undefined';

      throw $parseMinErr('esc', 'IMPOSSIBLE');
    },

    nextId: function nextId(skip, init) {
      var id = 'v' + this.state.nextId++;
      if (!skip) {
        this.current().vars.push(id + (init ? '=' + init : ''));
      }
      return id;
    },

    current: function current() {
      return this.state[this.state.computing];
    }
  };

  function ASTInterpreter($filter) {
    this.$filter = $filter;
  }

  ASTInterpreter.prototype = {
    compile: function compile(ast) {
      var self = this;
      findConstantAndWatchExpressions(ast, self.$filter);
      var assignable;
      var assign;
      if (assignable = assignableAST(ast)) {
        assign = this.recurse(assignable);
      }
      var toWatch = getInputs(ast.body);
      var inputs;
      if (toWatch) {
        inputs = [];
        forEach(toWatch, function (watch, key) {
          var input = self.recurse(watch);
          input.isPure = watch.isPure;
          watch.input = input;
          inputs.push(input);
          watch.watchId = key;
        });
      }
      var expressions = [];
      forEach(ast.body, function (expression) {
        expressions.push(self.recurse(expression.expression));
      });
      var fn = ast.body.length === 0 ? noop : ast.body.length === 1 ? expressions[0] : function (scope, locals) {
        var lastValue;
        forEach(expressions, function (exp) {
          lastValue = exp(scope, locals);
        });
        return lastValue;
      };
      if (assign) {
        fn.assign = function (scope, value, locals) {
          return assign(scope, locals, value);
        };
      }
      if (inputs) {
        fn.inputs = inputs;
      }
      return fn;
    },

    recurse: function recurse(ast, context, create) {
      var left,
          right,
          self = this,
          args;
      if (ast.input) {
        return this.inputs(ast.input, ast.watchId);
      }
      switch (ast.type) {
        case AST.Literal:
          return this.value(ast.value, context);
        case AST.UnaryExpression:
          right = this.recurse(ast.argument);
          return this['unary' + ast.operator](right, context);
        case AST.BinaryExpression:
          left = this.recurse(ast.left);
          right = this.recurse(ast.right);
          return this['binary' + ast.operator](left, right, context);
        case AST.LogicalExpression:
          left = this.recurse(ast.left);
          right = this.recurse(ast.right);
          return this['binary' + ast.operator](left, right, context);
        case AST.ConditionalExpression:
          return this['ternary?:'](this.recurse(ast.test), this.recurse(ast.alternate), this.recurse(ast.consequent), context);
        case AST.Identifier:
          return self.identifier(ast.name, context, create);
        case AST.MemberExpression:
          left = this.recurse(ast.object, false, !!create);
          if (!ast.computed) {
            right = ast.property.name;
          }
          if (ast.computed) right = this.recurse(ast.property);
          return ast.computed ? this.computedMember(left, right, context, create) : this.nonComputedMember(left, right, context, create);
        case AST.CallExpression:
          args = [];
          forEach(ast.arguments, function (expr) {
            args.push(self.recurse(expr));
          });
          if (ast.filter) right = this.$filter(ast.callee.name);
          if (!ast.filter) right = this.recurse(ast.callee, true);
          return ast.filter ? function (scope, locals, assign, inputs) {
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(args[i](scope, locals, assign, inputs));
            }
            var value = right.apply(undefined, values, inputs);
            return context ? { context: undefined, name: undefined, value: value } : value;
          } : function (scope, locals, assign, inputs) {
            var rhs = right(scope, locals, assign, inputs);
            var value;
            if (rhs.value != null) {
              var values = [];
              for (var i = 0; i < args.length; ++i) {
                values.push(args[i](scope, locals, assign, inputs));
              }
              value = rhs.value.apply(rhs.context, values);
            }
            return context ? { value: value } : value;
          };
        case AST.AssignmentExpression:
          left = this.recurse(ast.left, true, 1);
          right = this.recurse(ast.right);
          return function (scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            var rhs = right(scope, locals, assign, inputs);
            lhs.context[lhs.name] = rhs;
            return context ? { value: rhs } : rhs;
          };
        case AST.ArrayExpression:
          args = [];
          forEach(ast.elements, function (expr) {
            args.push(self.recurse(expr));
          });
          return function (scope, locals, assign, inputs) {
            var value = [];
            for (var i = 0; i < args.length; ++i) {
              value.push(args[i](scope, locals, assign, inputs));
            }
            return context ? { value: value } : value;
          };
        case AST.ObjectExpression:
          args = [];
          forEach(ast.properties, function (property) {
            if (property.computed) {
              args.push({ key: self.recurse(property.key),
                computed: true,
                value: self.recurse(property.value)
              });
            } else {
              args.push({ key: property.key.type === AST.Identifier ? property.key.name : '' + property.key.value,
                computed: false,
                value: self.recurse(property.value)
              });
            }
          });
          return function (scope, locals, assign, inputs) {
            var value = {};
            for (var i = 0; i < args.length; ++i) {
              if (args[i].computed) {
                value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
              } else {
                value[args[i].key] = args[i].value(scope, locals, assign, inputs);
              }
            }
            return context ? { value: value } : value;
          };
        case AST.ThisExpression:
          return function (scope) {
            return context ? { value: scope } : scope;
          };
        case AST.LocalsExpression:
          return function (scope, locals) {
            return context ? { value: locals } : locals;
          };
        case AST.NGValueParameter:
          return function (scope, locals, assign) {
            return context ? { value: assign } : assign;
          };
      }
    },

    'unary+': function unary(argument, context) {
      return function (scope, locals, assign, inputs) {
        var arg = argument(scope, locals, assign, inputs);
        if (isDefined(arg)) {
          arg = +arg;
        } else {
          arg = 0;
        }
        return context ? { value: arg } : arg;
      };
    },
    'unary-': function unary(argument, context) {
      return function (scope, locals, assign, inputs) {
        var arg = argument(scope, locals, assign, inputs);
        if (isDefined(arg)) {
          arg = -arg;
        } else {
          arg = -0;
        }
        return context ? { value: arg } : arg;
      };
    },
    'unary!': function unary(argument, context) {
      return function (scope, locals, assign, inputs) {
        var arg = !argument(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary+': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        var arg = plusFn(lhs, rhs);
        return context ? { value: arg } : arg;
      };
    },
    'binary-': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
        return context ? { value: arg } : arg;
      };
    },
    'binary*': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary/': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary%': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary===': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary!==': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary==': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        // eslint-disable-next-line eqeqeq
        var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary!=': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        // eslint-disable-next-line eqeqeq
        var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary<': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary>': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary<=': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary>=': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary&&': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'binary||': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    'ternary?:': function ternary(test, alternate, consequent, context) {
      return function (scope, locals, assign, inputs) {
        var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
        return context ? { value: arg } : arg;
      };
    },
    value: function value(_value2, context) {
      return function () {
        return context ? { context: undefined, name: undefined, value: _value2 } : _value2;
      };
    },
    identifier: function identifier(name, context, create) {
      return function (scope, locals, assign, inputs) {
        var base = locals && name in locals ? locals : scope;
        if (create && create !== 1 && base && base[name] == null) {
          base[name] = {};
        }
        var value = base ? base[name] : undefined;
        if (context) {
          return { context: base, name: name, value: value };
        } else {
          return value;
        }
      };
    },
    computedMember: function computedMember(left, right, context, create) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs;
        var value;
        if (lhs != null) {
          rhs = right(scope, locals, assign, inputs);
          rhs = getStringValue(rhs);
          if (create && create !== 1) {
            if (lhs && !lhs[rhs]) {
              lhs[rhs] = {};
            }
          }
          value = lhs[rhs];
        }
        if (context) {
          return { context: lhs, name: rhs, value: value };
        } else {
          return value;
        }
      };
    },
    nonComputedMember: function nonComputedMember(left, right, context, create) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        if (create && create !== 1) {
          if (lhs && lhs[right] == null) {
            lhs[right] = {};
          }
        }
        var value = lhs != null ? lhs[right] : undefined;
        if (context) {
          return { context: lhs, name: right, value: value };
        } else {
          return value;
        }
      };
    },
    inputs: function inputs(input, watchId) {
      return function (scope, value, locals, inputs) {
        if (inputs) return inputs[watchId];
        return input(scope, value, locals);
      };
    }
  };

  /**
   * @constructor
   */
  function Parser(lexer, $filter, options) {
    this.ast = new AST(lexer, options);
    this.astCompiler = options.csp ? new ASTInterpreter($filter) : new ASTCompiler($filter);
  }

  Parser.prototype = {
    constructor: Parser,

    parse: function parse(text) {
      var ast = this.getAst(text);
      var fn = this.astCompiler.compile(ast.ast);
      fn.literal = isLiteral(ast.ast);
      fn.constant = isConstant(ast.ast);
      fn.oneTime = ast.oneTime;
      return fn;
    },

    getAst: function getAst(exp) {
      var oneTime = false;
      exp = exp.trim();

      if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
        oneTime = true;
        exp = exp.substring(2);
      }
      return {
        ast: this.ast.ast(exp),
        oneTime: oneTime
      };
    }
  };

  function getValueOf(value) {
    return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
  }

  ///////////////////////////////////

  /**
   * @ngdoc service
   * @name $parse
   * @kind function
   *
   * @description
   *
   * Converts AngularJS {@link guide/expression expression} into a function.
   *
   * ```js
   *   var getter = $parse('user.name');
   *   var setter = getter.assign;
   *   var context = {user:{name:'AngularJS'}};
   *   var locals = {user:{name:'local'}};
   *
   *   expect(getter(context)).toEqual('AngularJS');
   *   setter(context, 'newValue');
   *   expect(context.user.name).toEqual('newValue');
   *   expect(getter(context, locals)).toEqual('local');
   * ```
   *
   *
   * @param {string} expression String expression to compile.
   * @returns {function(context, locals)} a function which represents the compiled expression:
   *
   *    * `context` – `{object}` – an object against which any expressions embedded in the strings
   *      are evaluated against (typically a scope object).
   *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
   *      `context`.
   *
   *    The returned function also has the following properties:
   *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
   *        literal.
   *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
   *        constant literals.
   *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
   *        set to a function to change its value on the given context.
   *
   */

  /**
   * @ngdoc provider
   * @name $parseProvider
   * @this
   *
   * @description
   * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
   *  service.
   */
  function $ParseProvider() {
    var cache = createMap();
    var literals = {
      'true': true,
      'false': false,
      'null': null,
      'undefined': undefined
    };
    var identStart, identContinue;

    /**
     * @ngdoc method
     * @name $parseProvider#addLiteral
     * @description
     *
     * Configure $parse service to add literal values that will be present as literal at expressions.
     *
     * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
     * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
     *
     **/
    this.addLiteral = function (literalName, literalValue) {
      literals[literalName] = literalValue;
    };

    /**
     * @ngdoc method
     * @name $parseProvider#setIdentifierFns
     *
     * @description
     *
     * Allows defining the set of characters that are allowed in AngularJS expressions. The function
     * `identifierStart` will get called to know if a given character is a valid character to be the
     * first character for an identifier. The function `identifierContinue` will get called to know if
     * a given character is a valid character to be a follow-up identifier character. The functions
     * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
     * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
     * mind that the `string` parameter can be two characters long depending on the character
     * representation. It is expected for the function to return `true` or `false`, whether that
     * character is allowed or not.
     *
     * Since this function will be called extensively, keep the implementation of these functions fast,
     * as the performance of these functions have a direct impact on the expressions parsing speed.
     *
     * @param {function=} identifierStart The function that will decide whether the given character is
     *   a valid identifier start character.
     * @param {function=} identifierContinue The function that will decide whether the given character is
     *   a valid identifier continue character.
     */
    this.setIdentifierFns = function (identifierStart, identifierContinue) {
      identStart = identifierStart;
      identContinue = identifierContinue;
      return this;
    };

    this.$get = ['$filter', function ($filter) {
      var noUnsafeEval = csp().noUnsafeEval;
      var $parseOptions = {
        csp: noUnsafeEval,
        literals: copy(literals),
        isIdentifierStart: isFunction(identStart) && identStart,
        isIdentifierContinue: isFunction(identContinue) && identContinue
      };
      $parse.$$getAst = $$getAst;
      return $parse;

      function $parse(exp, interceptorFn) {
        var parsedExpression, cacheKey;

        switch (typeof exp === 'undefined' ? 'undefined' : _typeof(exp)) {
          case 'string':
            exp = exp.trim();
            cacheKey = exp;

            parsedExpression = cache[cacheKey];

            if (!parsedExpression) {
              var lexer = new Lexer($parseOptions);
              var parser = new Parser(lexer, $filter, $parseOptions);
              parsedExpression = parser.parse(exp);
              if (parsedExpression.constant) {
                parsedExpression.$$watchDelegate = constantWatchDelegate;
              } else if (parsedExpression.oneTime) {
                parsedExpression.$$watchDelegate = parsedExpression.literal ? oneTimeLiteralWatchDelegate : oneTimeWatchDelegate;
              } else if (parsedExpression.inputs) {
                parsedExpression.$$watchDelegate = inputsWatchDelegate;
              }
              cache[cacheKey] = parsedExpression;
            }
            return addInterceptor(parsedExpression, interceptorFn);

          case 'function':
            return addInterceptor(exp, interceptorFn);

          default:
            return addInterceptor(noop, interceptorFn);
        }
      }

      function $$getAst(exp) {
        var lexer = new Lexer($parseOptions);
        var parser = new Parser(lexer, $filter, $parseOptions);
        return parser.getAst(exp).ast;
      }

      function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {

        if (newValue == null || oldValueOfValue == null) {
          // null/undefined
          return newValue === oldValueOfValue;
        }

        if ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object') {

          // attempt to convert the value to a primitive type
          // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
          //             be cheaply dirty-checked
          newValue = getValueOf(newValue);

          if ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' && !compareObjectIdentity) {
            // objects/arrays are not supported - deep-watching them would be too expensive
            return false;
          }

          // fall-through to the primitive equality check
        }

        //Primitive or NaN
        // eslint-disable-next-line no-self-compare
        return newValue === oldValueOfValue || newValue !== newValue && oldValueOfValue !== oldValueOfValue;
      }

      function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
        var inputExpressions = parsedExpression.inputs;
        var lastResult;

        if (inputExpressions.length === 1) {
          var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
          inputExpressions = inputExpressions[0];
          return scope.$watch(function expressionInputWatch(scope) {
            var newInputValue = inputExpressions(scope);
            if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
              lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
              oldInputValueOf = newInputValue && getValueOf(newInputValue);
            }
            return lastResult;
          }, listener, objectEquality, prettyPrintExpression);
        }

        var oldInputValueOfValues = [];
        var oldInputValues = [];
        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
          oldInputValues[i] = null;
        }

        return scope.$watch(function expressionInputsWatch(scope) {
          var changed = false;

          for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
            var newInputValue = inputExpressions[i](scope);
            if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
              oldInputValues[i] = newInputValue;
              oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
            }
          }

          if (changed) {
            lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
          }

          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }

      function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
        var unwatch, lastValue;
        if (parsedExpression.inputs) {
          unwatch = inputsWatchDelegate(scope, oneTimeListener, objectEquality, parsedExpression, prettyPrintExpression);
        } else {
          unwatch = scope.$watch(oneTimeWatch, oneTimeListener, objectEquality);
        }
        return unwatch;

        function oneTimeWatch(scope) {
          return parsedExpression(scope);
        }
        function oneTimeListener(value, old, scope) {
          lastValue = value;
          if (isFunction(listener)) {
            listener(value, old, scope);
          }
          if (isDefined(value)) {
            scope.$$postDigest(function () {
              if (isDefined(lastValue)) {
                unwatch();
              }
            });
          }
        }
      }

      function oneTimeLiteralWatchDelegate(scope, listener, objectEquality, parsedExpression) {
        var unwatch, lastValue;
        unwatch = scope.$watch(function oneTimeWatch(scope) {
          return parsedExpression(scope);
        }, function oneTimeListener(value, old, scope) {
          lastValue = value;
          if (isFunction(listener)) {
            listener(value, old, scope);
          }
          if (isAllDefined(value)) {
            scope.$$postDigest(function () {
              if (isAllDefined(lastValue)) unwatch();
            });
          }
        }, objectEquality);

        return unwatch;

        function isAllDefined(value) {
          var allDefined = true;
          forEach(value, function (val) {
            if (!isDefined(val)) allDefined = false;
          });
          return allDefined;
        }
      }

      function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
        var unwatch = scope.$watch(function constantWatch(scope) {
          unwatch();
          return parsedExpression(scope);
        }, listener, objectEquality);
        return unwatch;
      }

      function addInterceptor(parsedExpression, interceptorFn) {
        if (!interceptorFn) return parsedExpression;
        var watchDelegate = parsedExpression.$$watchDelegate;
        var useInputs = false;

        var regularWatch = watchDelegate !== oneTimeLiteralWatchDelegate && watchDelegate !== oneTimeWatchDelegate;

        var fn = regularWatch ? function regularInterceptedExpression(scope, locals, assign, inputs) {
          var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
          return interceptorFn(value, scope, locals);
        } : function oneTimeInterceptedExpression(scope, locals, assign, inputs) {
          var value = parsedExpression(scope, locals, assign, inputs);
          var result = interceptorFn(value, scope, locals);
          // we only return the interceptor's result if the
          // initial value is defined (for bind-once)
          return isDefined(value) ? result : value;
        };

        // Propagate $$watchDelegates other then inputsWatchDelegate
        useInputs = !parsedExpression.inputs;
        if (watchDelegate && watchDelegate !== inputsWatchDelegate) {
          fn.$$watchDelegate = watchDelegate;
          fn.inputs = parsedExpression.inputs;
        } else if (!interceptorFn.$stateful) {
          // Treat interceptor like filters - assume non-stateful by default and use the inputsWatchDelegate
          fn.$$watchDelegate = inputsWatchDelegate;
          fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
        }

        if (fn.inputs) {
          fn.inputs = fn.inputs.map(function (e) {
            // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
            // potentially non-pure interceptor function.
            if (e.isPure === PURITY_RELATIVE) {
              return function depurifier(s) {
                return e(s);
              };
            }
            return e;
          });
        }

        return fn;
      }
    }];
  }

  /**
   * @ngdoc service
   * @name $q
   * @requires $rootScope
   *
   * @description
   * A service that helps you run functions asynchronously, and use their return values (or exceptions)
   * when they are done processing.
   *
   * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
   * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
   *
   * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
   * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
   *
   * ## $q constructor
   *
   * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
   * function as the first argument. This is similar to the native Promise implementation from ES6,
   * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
   *
   * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
   * available yet.
   *
   * It can be used like so:
   *
   * ```js
   *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
   *   // are available in the current lexical scope (they could have been injected or passed in).
   *
   *   function asyncGreet(name) {
   *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
   *     return $q(function(resolve, reject) {
   *       setTimeout(function() {
   *         if (okToGreet(name)) {
   *           resolve('Hello, ' + name + '!');
   *         } else {
   *           reject('Greeting ' + name + ' is not allowed.');
   *         }
   *       }, 1000);
   *     });
   *   }
   *
   *   var promise = asyncGreet('Robin Hood');
   *   promise.then(function(greeting) {
   *     alert('Success: ' + greeting);
   *   }, function(reason) {
   *     alert('Failed: ' + reason);
   *   });
   * ```
   *
   * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
   *
   * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
   *
   * However, the more traditional CommonJS-style usage is still available, and documented below.
   *
   * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
   * interface for interacting with an object that represents the result of an action that is
   * performed asynchronously, and may or may not be finished at any given point in time.
   *
   * From the perspective of dealing with error handling, deferred and promise APIs are to
   * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
   *
   * ```js
   *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
   *   // are available in the current lexical scope (they could have been injected or passed in).
   *
   *   function asyncGreet(name) {
   *     var deferred = $q.defer();
   *
   *     setTimeout(function() {
   *       deferred.notify('About to greet ' + name + '.');
   *
   *       if (okToGreet(name)) {
   *         deferred.resolve('Hello, ' + name + '!');
   *       } else {
   *         deferred.reject('Greeting ' + name + ' is not allowed.');
   *       }
   *     }, 1000);
   *
   *     return deferred.promise;
   *   }
   *
   *   var promise = asyncGreet('Robin Hood');
   *   promise.then(function(greeting) {
   *     alert('Success: ' + greeting);
   *   }, function(reason) {
   *     alert('Failed: ' + reason);
   *   }, function(update) {
   *     alert('Got notification: ' + update);
   *   });
   * ```
   *
   * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
   * comes in the way of guarantees that promise and deferred APIs make, see
   * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
   *
   * Additionally the promise api allows for composition that is very hard to do with the
   * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
   * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
   * section on serial or parallel joining of promises.
   *
   * ## The Deferred API
   *
   * A new instance of deferred is constructed by calling `$q.defer()`.
   *
   * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
   * that can be used for signaling the successful or unsuccessful completion, as well as the status
   * of the task.
   *
   * **Methods**
   *
   * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
   *   constructed via `$q.reject`, the promise will be rejected instead.
   * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
   *   resolving it with a rejection constructed via `$q.reject`.
   * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
   *   multiple times before the promise is either resolved or rejected.
   *
   * **Properties**
   *
   * - promise – `{Promise}` – promise object associated with this deferred.
   *
   *
   * ## The Promise API
   *
   * A new promise instance is created when a deferred instance is created and can be retrieved by
   * calling `deferred.promise`.
   *
   * The purpose of the promise object is to allow for interested parties to get access to the result
   * of the deferred task when it completes.
   *
   * **Methods**
   *
   * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
   *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
   *   as soon as the result is available. The callbacks are called with a single argument: the result
   *   or rejection reason. Additionally, the notify callback may be called zero or more times to
   *   provide a progress indication, before the promise is resolved or rejected.
   *
   *   This method *returns a new promise* which is resolved or rejected via the return value of the
   *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
   *   with the value which is resolved in that promise using
   *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
   *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
   *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
   *   arguments are optional.
   *
   * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
   *
   * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
   *   but to do so without modifying the final value. This is useful to release resources or do some
   *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
   *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
   *   more information.
   *
   * ## Chaining promises
   *
   * Because calling the `then` method of a promise returns a new derived promise, it is easily
   * possible to create a chain of promises:
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     return result + 1;
   *   });
   *
   *   // promiseB will be resolved immediately after promiseA is resolved and its value
   *   // will be the result of promiseA incremented by 1
   * ```
   *
   * It is possible to create chains of any length and since a promise can be resolved with another
   * promise (which will defer its resolution further), it is possible to pause/defer resolution of
   * the promises at any point in the chain. This makes it possible to implement powerful APIs like
   * $http's response interceptors.
   *
   *
   * ## Differences between Kris Kowal's Q and $q
   *
   *  There are two main differences:
   *
   * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
   *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
   *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
   * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
   *   all the important functionality needed for common async tasks.
   *
   * ## Testing
   *
   *  ```js
   *    it('should simulate promise', inject(function($q, $rootScope) {
   *      var deferred = $q.defer();
   *      var promise = deferred.promise;
   *      var resolvedValue;
   *
   *      promise.then(function(value) { resolvedValue = value; });
   *      expect(resolvedValue).toBeUndefined();
   *
   *      // Simulate resolving of promise
   *      deferred.resolve(123);
   *      // Note that the 'then' function does not get called synchronously.
   *      // This is because we want the promise API to always be async, whether or not
   *      // it got called synchronously or asynchronously.
   *      expect(resolvedValue).toBeUndefined();
   *
   *      // Propagate promise resolution to 'then' functions using $apply().
   *      $rootScope.$apply();
   *      expect(resolvedValue).toEqual(123);
   *    }));
   *  ```
   *
   * @param {function(function, function)} resolver Function which is responsible for resolving or
   *   rejecting the newly created promise. The first parameter is a function which resolves the
   *   promise, the second parameter is a function which rejects the promise.
   *
   * @returns {Promise} The newly created promise.
   */
  /**
   * @ngdoc provider
   * @name $qProvider
   * @this
   *
   * @description
   */
  function $QProvider() {
    var errorOnUnhandledRejections = true;
    this.$get = ['$rootScope', '$exceptionHandler', function ($rootScope, $exceptionHandler) {
      return qFactory(function (callback) {
        $rootScope.$evalAsync(callback);
      }, $exceptionHandler, errorOnUnhandledRejections);
    }];

    /**
     * @ngdoc method
     * @name $qProvider#errorOnUnhandledRejections
     * @kind function
     *
     * @description
     * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
     * This feature is enabled by default.
     *
     * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
     * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
     *    chaining otherwise.
     */
    this.errorOnUnhandledRejections = function (value) {
      if (isDefined(value)) {
        errorOnUnhandledRejections = value;
        return this;
      } else {
        return errorOnUnhandledRejections;
      }
    };
  }

  /** @this */
  function $$QProvider() {
    var errorOnUnhandledRejections = true;
    this.$get = ['$browser', '$exceptionHandler', function ($browser, $exceptionHandler) {
      return qFactory(function (callback) {
        $browser.defer(callback);
      }, $exceptionHandler, errorOnUnhandledRejections);
    }];

    this.errorOnUnhandledRejections = function (value) {
      if (isDefined(value)) {
        errorOnUnhandledRejections = value;
        return this;
      } else {
        return errorOnUnhandledRejections;
      }
    };
  }

  /**
   * Constructs a promise manager.
   *
   * @param {function(function)} nextTick Function for executing functions in the next turn.
   * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
   *     debugging purposes.
   * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
   *     promises rejections.
   * @returns {object} Promise manager.
   */
  function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
    var $qMinErr = minErr('$q', TypeError);
    var queueSize = 0;
    var checkQueue = [];

    /**
     * @ngdoc method
     * @name ng.$q#defer
     * @kind function
     *
     * @description
     * Creates a `Deferred` object which represents a task which will finish in the future.
     *
     * @returns {Deferred} Returns a new instance of deferred.
     */
    function defer() {
      return new Deferred();
    }

    function Deferred() {
      var promise = this.promise = new Promise();
      //Non prototype methods necessary to support unbound execution :/
      this.resolve = function (val) {
        resolvePromise(promise, val);
      };
      this.reject = function (reason) {
        rejectPromise(promise, reason);
      };
      this.notify = function (progress) {
        notifyPromise(promise, progress);
      };
    }

    function Promise() {
      this.$$state = { status: 0 };
    }

    extend(Promise.prototype, {
      then: function then(onFulfilled, onRejected, progressBack) {
        if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
          return this;
        }
        var result = new Promise();

        this.$$state.pending = this.$$state.pending || [];
        this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
        if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);

        return result;
      },

      'catch': function _catch(callback) {
        return this.then(null, callback);
      },

      'finally': function _finally(callback, progressBack) {
        return this.then(function (value) {
          return handleCallback(value, resolve, callback);
        }, function (error) {
          return handleCallback(error, reject, callback);
        }, progressBack);
      }
    });

    function processQueue(state) {
      var fn, promise, pending;

      pending = state.pending;
      state.processScheduled = false;
      state.pending = undefined;
      try {
        for (var i = 0, ii = pending.length; i < ii; ++i) {
          markQStateExceptionHandled(state);
          promise = pending[i][0];
          fn = pending[i][state.status];
          try {
            if (isFunction(fn)) {
              resolvePromise(promise, fn(state.value));
            } else if (state.status === 1) {
              resolvePromise(promise, state.value);
            } else {
              rejectPromise(promise, state.value);
            }
          } catch (e) {
            rejectPromise(promise, e);
            // This error is explicitly marked for being passed to the $exceptionHandler
            if (e && e.$$passToExceptionHandler === true) {
              exceptionHandler(e);
            }
          }
        }
      } finally {
        --queueSize;
        if (errorOnUnhandledRejections && queueSize === 0) {
          nextTick(processChecks);
        }
      }
    }

    function processChecks() {
      // eslint-disable-next-line no-unmodified-loop-condition
      while (!queueSize && checkQueue.length) {
        var toCheck = checkQueue.shift();
        if (!isStateExceptionHandled(toCheck)) {
          markQStateExceptionHandled(toCheck);
          var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
          if (isError(toCheck.value)) {
            exceptionHandler(toCheck.value, errorMessage);
          } else {
            exceptionHandler(errorMessage);
          }
        }
      }
    }

    function scheduleProcessQueue(state) {
      if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
        if (queueSize === 0 && checkQueue.length === 0) {
          nextTick(processChecks);
        }
        checkQueue.push(state);
      }
      if (state.processScheduled || !state.pending) return;
      state.processScheduled = true;
      ++queueSize;
      nextTick(function () {
        processQueue(state);
      });
    }

    function resolvePromise(promise, val) {
      if (promise.$$state.status) return;
      if (val === promise) {
        $$reject(promise, $qMinErr('qcycle', 'Expected promise to be resolved with value other than itself \'{0}\'', val));
      } else {
        $$resolve(promise, val);
      }
    }

    function $$resolve(promise, val) {
      var then;
      var done = false;
      try {
        if (isObject(val) || isFunction(val)) then = val.then;
        if (isFunction(then)) {
          promise.$$state.status = -1;
          then.call(val, doResolve, doReject, doNotify);
        } else {
          promise.$$state.value = val;
          promise.$$state.status = 1;
          scheduleProcessQueue(promise.$$state);
        }
      } catch (e) {
        doReject(e);
      }

      function doResolve(val) {
        if (done) return;
        done = true;
        $$resolve(promise, val);
      }
      function doReject(val) {
        if (done) return;
        done = true;
        $$reject(promise, val);
      }
      function doNotify(progress) {
        notifyPromise(promise, progress);
      }
    }

    function rejectPromise(promise, reason) {
      if (promise.$$state.status) return;
      $$reject(promise, reason);
    }

    function $$reject(promise, reason) {
      promise.$$state.value = reason;
      promise.$$state.status = 2;
      scheduleProcessQueue(promise.$$state);
    }

    function notifyPromise(promise, progress) {
      var callbacks = promise.$$state.pending;

      if (promise.$$state.status <= 0 && callbacks && callbacks.length) {
        nextTick(function () {
          var callback, result;
          for (var i = 0, ii = callbacks.length; i < ii; i++) {
            result = callbacks[i][0];
            callback = callbacks[i][3];
            try {
              notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
            } catch (e) {
              exceptionHandler(e);
            }
          }
        });
      }
    }

    /**
     * @ngdoc method
     * @name $q#reject
     * @kind function
     *
     * @description
     * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
     * used to forward rejection in a chain of promises. If you are dealing with the last promise in
     * a promise chain, you don't need to worry about it.
     *
     * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
     * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
     * a promise error callback and you want to forward the error to the promise derived from the
     * current promise, you have to "rethrow" the error by returning a rejection constructed via
     * `reject`.
     *
     * ```js
     *   promiseB = promiseA.then(function(result) {
     *     // success: do something and resolve promiseB
     *     //          with the old or a new result
     *     return result;
     *   }, function(reason) {
     *     // error: handle the error if possible and
     *     //        resolve promiseB with newPromiseOrValue,
     *     //        otherwise forward the rejection to promiseB
     *     if (canHandle(reason)) {
     *      // handle the error and recover
     *      return newPromiseOrValue;
     *     }
     *     return $q.reject(reason);
     *   });
     * ```
     *
     * @param {*} reason Constant, message, exception or an object representing the rejection reason.
     * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
     */
    function reject(reason) {
      var result = new Promise();
      rejectPromise(result, reason);
      return result;
    }

    function handleCallback(value, resolver, callback) {
      var callbackOutput = null;
      try {
        if (isFunction(callback)) callbackOutput = callback();
      } catch (e) {
        return reject(e);
      }
      if (isPromiseLike(callbackOutput)) {
        return callbackOutput.then(function () {
          return resolver(value);
        }, reject);
      } else {
        return resolver(value);
      }
    }

    /**
     * @ngdoc method
     * @name $q#when
     * @kind function
     *
     * @description
     * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
     * This is useful when you are dealing with an object that might or might not be a promise, or if
     * the promise comes from a source that can't be trusted.
     *
     * @param {*} value Value or a promise
     * @param {Function=} successCallback
     * @param {Function=} errorCallback
     * @param {Function=} progressCallback
     * @returns {Promise} Returns a promise of the passed value or promise
     */

    function when(value, callback, errback, progressBack) {
      var result = new Promise();
      resolvePromise(result, value);
      return result.then(callback, errback, progressBack);
    }

    /**
     * @ngdoc method
     * @name $q#resolve
     * @kind function
     *
     * @description
     * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
     *
     * @param {*} value Value or a promise
     * @param {Function=} successCallback
     * @param {Function=} errorCallback
     * @param {Function=} progressCallback
     * @returns {Promise} Returns a promise of the passed value or promise
     */
    var resolve = when;

    /**
     * @ngdoc method
     * @name $q#all
     * @kind function
     *
     * @description
     * Combines multiple promises into a single promise that is resolved when all of the input
     * promises are resolved.
     *
     * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
     * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
     *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
     *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
     *   with the same rejection value.
     */

    function all(promises) {
      var result = new Promise(),
          counter = 0,
          results = isArray(promises) ? [] : {};

      forEach(promises, function (promise, key) {
        counter++;
        when(promise).then(function (value) {
          results[key] = value;
          if (! --counter) resolvePromise(result, results);
        }, function (reason) {
          rejectPromise(result, reason);
        });
      });

      if (counter === 0) {
        resolvePromise(result, results);
      }

      return result;
    }

    /**
     * @ngdoc method
     * @name $q#race
     * @kind function
     *
     * @description
     * Returns a promise that resolves or rejects as soon as one of those promises
     * resolves or rejects, with the value or reason from that promise.
     *
     * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
     * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
     * resolves or rejects, with the value or reason from that promise.
     */

    function race(promises) {
      var deferred = defer();

      forEach(promises, function (promise) {
        when(promise).then(deferred.resolve, deferred.reject);
      });

      return deferred.promise;
    }

    function $Q(resolver) {
      if (!isFunction(resolver)) {
        throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
      }

      var promise = new Promise();

      function resolveFn(value) {
        resolvePromise(promise, value);
      }

      function rejectFn(reason) {
        rejectPromise(promise, reason);
      }

      resolver(resolveFn, rejectFn);

      return promise;
    }

    // Let's make the instanceof operator work for promises, so that
    // `new $q(fn) instanceof $q` would evaluate to true.
    $Q.prototype = Promise.prototype;

    $Q.defer = defer;
    $Q.reject = reject;
    $Q.when = when;
    $Q.resolve = resolve;
    $Q.all = all;
    $Q.race = race;

    return $Q;
  }

  function isStateExceptionHandled(state) {
    return !!state.pur;
  }
  function markQStateExceptionHandled(state) {
    state.pur = true;
  }
  function markQExceptionHandled(q) {
    markQStateExceptionHandled(q.$$state);
  }

  /** @this */
  function $$RAFProvider() {
    //rAF
    this.$get = ['$window', '$timeout', function ($window, $timeout) {
      var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame;

      var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;

      var rafSupported = !!requestAnimationFrame;
      var raf = rafSupported ? function (fn) {
        var id = requestAnimationFrame(fn);
        return function () {
          cancelAnimationFrame(id);
        };
      } : function (fn) {
        var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
        return function () {
          $timeout.cancel(timer);
        };
      };

      raf.supported = rafSupported;

      return raf;
    }];
  }

  /**
   * DESIGN NOTES
   *
   * The design decisions behind the scope are heavily favored for speed and memory consumption.
   *
   * The typical use of scope is to watch the expressions, which most of the time return the same
   * value as last time so we optimize the operation.
   *
   * Closures construction is expensive in terms of speed as well as memory:
   *   - No closures, instead use prototypical inheritance for API
   *   - Internal state needs to be stored on scope directly, which means that private state is
   *     exposed as $$____ properties
   *
   * Loop operations are optimized by using while(count--) { ... }
   *   - This means that in order to keep the same order of execution as addition we have to add
   *     items to the array at the beginning (unshift) instead of at the end (push)
   *
   * Child scopes are created and removed often
   *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
   *
   * There are fewer watches than observers. This is why you don't want the observer to be implemented
   * in the same way as watch. Watch requires return of the initialization function which is expensive
   * to construct.
   */

  /**
   * @ngdoc provider
   * @name $rootScopeProvider
   * @description
   *
   * Provider for the $rootScope service.
   */

  /**
   * @ngdoc method
   * @name $rootScopeProvider#digestTtl
   * @description
   *
   * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that the dependencies between `$watch`s will result in
   * several digest iterations. However if an application needs more than the default 10 digest
   * iterations for its model to stabilize then you should investigate what is causing the model to
   * continuously change during the digest.
   *
   * Increasing the TTL could have performance implications, so you should not change it without
   * proper justification.
   *
   * @param {number} limit The number of digest iterations.
   */

  /**
   * @ngdoc service
   * @name $rootScope
   * @this
   *
   * @description
   *
   * Every application has a single root {@link ng.$rootScope.Scope scope}.
   * All other scopes are descendant scopes of the root scope. Scopes provide separation
   * between the model and the view, via a mechanism for watching the model for changes.
   * They also provide event emission/broadcast and subscription facility. See the
   * {@link guide/scope developer guide on scopes}.
   */
  function $RootScopeProvider() {
    var TTL = 10;
    var $rootScopeMinErr = minErr('$rootScope');
    var lastDirtyWatch = null;
    var applyAsyncId = null;

    this.digestTtl = function (value) {
      if (arguments.length) {
        TTL = value;
      }
      return TTL;
    };

    function createChildScopeClass(parent) {
      function ChildScope() {
        this.$$watchers = this.$$nextSibling = this.$$childHead = this.$$childTail = null;
        this.$$listeners = {};
        this.$$listenerCount = {};
        this.$$watchersCount = 0;
        this.$id = nextUid();
        this.$$ChildScope = null;
      }
      ChildScope.prototype = parent;
      return ChildScope;
    }

    this.$get = ['$exceptionHandler', '$parse', '$browser', function ($exceptionHandler, $parse, $browser) {

      function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
      }

      function cleanUpScope($scope) {

        // Support: IE 9 only
        if (msie === 9) {
          // There is a memory leak in IE9 if all child scopes are not disconnected
          // completely when a scope is destroyed. So this code will recurse up through
          // all this scopes children
          //
          // See issue https://github.com/angular/angular.js/issues/10706
          if ($scope.$$childHead) {
            cleanUpScope($scope.$$childHead);
          }
          if ($scope.$$nextSibling) {
            cleanUpScope($scope.$$nextSibling);
          }
        }

        // The code below works around IE9 and V8's memory leaks
        //
        // See:
        // - https://code.google.com/p/v8/issues/detail?id=2073#c26
        // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
        // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

        $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead = $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
      }

      /**
       * @ngdoc type
       * @name $rootScope.Scope
       *
       * @description
       * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
       * {@link auto.$injector $injector}. Child scopes are created using the
       * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
       * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
       * an in-depth introduction and usage examples.
       *
       *
       * ## Inheritance
       * A scope can inherit from a parent scope, as in this example:
       * ```js
           var parent = $rootScope;
           var child = parent.$new();
            parent.salutation = "Hello";
           expect(child.salutation).toEqual('Hello');
            child.salutation = "Welcome";
           expect(child.salutation).toEqual('Welcome');
           expect(parent.salutation).toEqual('Hello');
       * ```
       *
       * When interacting with `Scope` in tests, additional helper methods are available on the
       * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
       * details.
       *
       *
       * @param {Object.<string, function()>=} providers Map of service factory which need to be
       *                                       provided for the current scope. Defaults to {@link ng}.
       * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
       *                              append/override services provided by `providers`. This is handy
       *                              when unit-testing and having the need to override a default
       *                              service.
       * @returns {Object} Newly created scope.
       *
       */
      function Scope() {
        this.$id = nextUid();
        this.$$phase = this.$parent = this.$$watchers = this.$$nextSibling = this.$$prevSibling = this.$$childHead = this.$$childTail = null;
        this.$root = this;
        this.$$destroyed = false;
        this.$$listeners = {};
        this.$$listenerCount = {};
        this.$$watchersCount = 0;
        this.$$isolateBindings = null;
      }

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$id
       *
       * @description
       * Unique scope ID (monotonically increasing) useful for debugging.
       */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$parent
       *
       * @description
       * Reference to the parent scope.
       */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

      Scope.prototype = {
        constructor: Scope,
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$new
         * @kind function
         *
         * @description
         * Creates a new child {@link ng.$rootScope.Scope scope}.
         *
         * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
         * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
         *
         * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
         * desired for the scope and its child scopes to be permanently detached from the parent and
         * thus stop participating in model change detection and listener notification by invoking.
         *
         * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
         *         parent scope. The scope is isolated, as it can not see parent scope properties.
         *         When creating widgets, it is useful for the widget to not accidentally read parent
         *         state.
         *
         * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
         *                              of the newly created scope. Defaults to `this` scope if not provided.
         *                              This is used when creating a transclude scope to correctly place it
         *                              in the scope hierarchy while maintaining the correct prototypical
         *                              inheritance.
         *
         * @returns {Object} The newly created child scope.
         *
         */
        $new: function $new(isolate, parent) {
          var child;

          parent = parent || this;

          if (isolate) {
            child = new Scope();
            child.$root = this.$root;
          } else {
            // Only create a child scope class if somebody asks for one,
            // but cache it to allow the VM to optimize lookups.
            if (!this.$$ChildScope) {
              this.$$ChildScope = createChildScopeClass(this);
            }
            child = new this.$$ChildScope();
          }
          child.$parent = parent;
          child.$$prevSibling = parent.$$childTail;
          if (parent.$$childHead) {
            parent.$$childTail.$$nextSibling = child;
            parent.$$childTail = child;
          } else {
            parent.$$childHead = parent.$$childTail = child;
          }

          // When the new scope is not isolated or we inherit from `this`, and
          // the parent scope is destroyed, the property `$$destroyed` is inherited
          // prototypically. In all other cases, this property needs to be set
          // when the parent scope is destroyed.
          // The listener needs to be added after the parent is set
          if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);

          return child;
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$watch
         * @kind function
         *
         * @description
         * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
         *
         * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
         *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
         *   its value when executed multiple times with the same input because it may be executed multiple
         *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
         *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
         * - The `listener` is called only when the value from the current `watchExpression` and the
         *   previous call to `watchExpression` are not equal (with the exception of the initial run,
         *   see below). Inequality is determined according to reference inequality,
         *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
         *    via the `!==` Javascript operator, unless `objectEquality == true`
         *   (see next point)
         * - When `objectEquality == true`, inequality of the `watchExpression` is determined
         *   according to the {@link angular.equals} function. To save the value of the object for
         *   later comparison, the {@link angular.copy} function is used. This therefore means that
         *   watching complex objects will have adverse memory and performance implications.
         * - This should not be used to watch for changes in objects that are
         *   or contain [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
         * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
         *   This is achieved by rerunning the watchers until no changes are detected. The rerun
         *   iteration limit is 10 to prevent an infinite loop deadlock.
         *
         *
         * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
         * you can register a `watchExpression` function with no `listener`. (Be prepared for
         * multiple calls to your `watchExpression` because it will execute multiple times in a
         * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
         *
         * After a watcher is registered with the scope, the `listener` fn is called asynchronously
         * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
         * watcher. In rare cases, this is undesirable because the listener is called when the result
         * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
         * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
         * listener was called due to initialization.
         *
         *
         *
         * @example
         * ```js
             // let's assume that scope was dependency injected as the $rootScope
             var scope = $rootScope;
             scope.name = 'misko';
             scope.counter = 0;
              expect(scope.counter).toEqual(0);
             scope.$watch('name', function(newValue, oldValue) {
               scope.counter = scope.counter + 1;
             });
             expect(scope.counter).toEqual(0);
              scope.$digest();
             // the listener is always called during the first $digest loop after it was registered
             expect(scope.counter).toEqual(1);
              scope.$digest();
             // but now it will not be called unless the value changes
             expect(scope.counter).toEqual(1);
              scope.name = 'adam';
             scope.$digest();
             expect(scope.counter).toEqual(2);
                // Using a function as a watchExpression
             var food;
             scope.foodCounter = 0;
             expect(scope.foodCounter).toEqual(0);
             scope.$watch(
               // This function returns the value being watched. It is called for each turn of the $digest loop
               function() { return food; },
               // This is the change listener, called when the value returned from the above function changes
               function(newValue, oldValue) {
                 if ( newValue !== oldValue ) {
                   // Only increment the counter if the value changed
                   scope.foodCounter = scope.foodCounter + 1;
                 }
               }
             );
             // No digest has been run so the counter will be zero
             expect(scope.foodCounter).toEqual(0);
              // Run the digest but since food has not changed count will still be zero
             scope.$digest();
             expect(scope.foodCounter).toEqual(0);
              // Update food and run digest.  Now the counter will increment
             food = 'cheeseburger';
             scope.$digest();
             expect(scope.foodCounter).toEqual(1);
          * ```
         *
         *
         *
         * @param {(function()|string)} watchExpression Expression that is evaluated on each
         *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
         *    a call to the `listener`.
         *
         *    - `string`: Evaluated as {@link guide/expression expression}
         *    - `function(scope)`: called with current `scope` as a parameter.
         * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
         *    of `watchExpression` changes.
         *
         *    - `newVal` contains the current value of the `watchExpression`
         *    - `oldVal` contains the previous value of the `watchExpression`
         *    - `scope` refers to the current scope
         * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
         *     comparing for reference equality.
         * @returns {function()} Returns a deregistration function for this listener.
         */
        $watch: function $watch(watchExp, listener, objectEquality, prettyPrintExpression) {
          var get = $parse(watchExp);
          var fn = isFunction(listener) ? listener : noop;

          if (get.$$watchDelegate) {
            return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
          }
          var scope = this,
              array = scope.$$watchers,
              watcher = {
            fn: fn,
            last: initWatchVal,
            get: get,
            exp: prettyPrintExpression || watchExp,
            eq: !!objectEquality
          };

          lastDirtyWatch = null;

          if (!array) {
            array = scope.$$watchers = [];
            array.$$digestWatchIndex = -1;
          }
          // we use unshift since we use a while loop in $digest for speed.
          // the while loop reads in reverse order.
          array.unshift(watcher);
          array.$$digestWatchIndex++;
          incrementWatchersCount(this, 1);

          return function deregisterWatch() {
            var index = arrayRemove(array, watcher);
            if (index >= 0) {
              incrementWatchersCount(scope, -1);
              if (index < array.$$digestWatchIndex) {
                array.$$digestWatchIndex--;
              }
            }
            lastDirtyWatch = null;
          };
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$watchGroup
         * @kind function
         *
         * @description
         * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
         * If any one expression in the collection changes the `listener` is executed.
         *
         * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
         *   values are examined for changes on every call to `$digest`.
         * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
         *
         * `$watchGroup` is more performant than watching each expression individually, and should be
         * used when the listener does not need to know which expression has changed.
         * If the listener needs to know which expression has changed,
         * {@link ng.$rootScope.Scope#$watch $watch()} or
         * {@link ng.$rootScope.Scope#$watchCollection $watchCollection()} should be used.
         *
         * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
         * watched using {@link ng.$rootScope.Scope#$watch $watch()}
         *
         * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
         *    expression in `watchExpressions` changes
         *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
         *    those of `watchExpression`
         *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
         *    those of `watchExpression`.
         *
         *    Note that `newValues` and `oldValues` reflect the differences in each **individual**
         *    expression, and not the difference of the values between each call of the listener.
         *    That means the difference between `newValues` and `oldValues` cannot be used to determine
         *    which expression has changed / remained stable:
         *
         *    ```js
         *
         *    $scope.$watchGroup(['v1', 'v2'], function(newValues, oldValues) {
         *      console.log(newValues, oldValues);
         *    });
         *
         *    // newValues, oldValues initially
         *    // [undefined, undefined], [undefined, undefined]
         *
         *    $scope.v1 = 'a';
         *    $scope.v2 = 'a';
         *
         *    // ['a', 'a'], [undefined, undefined]
         *
         *    $scope.v2 = 'b'
         *
         *    // v1 hasn't changed since it became `'a'`, therefore its oldValue is still `undefined`
         *    // ['a', 'b'], [undefined, 'a']
         *
         *    ```
         *
         *    The `scope` refers to the current scope.
         * @returns {function()} Returns a de-registration function for all listeners.
         */
        $watchGroup: function $watchGroup(watchExpressions, listener) {
          var oldValues = new Array(watchExpressions.length);
          var newValues = new Array(watchExpressions.length);
          var deregisterFns = [];
          var self = this;
          var changeReactionScheduled = false;
          var firstRun = true;

          if (!watchExpressions.length) {
            // No expressions means we call the listener ASAP
            var shouldCall = true;
            self.$evalAsync(function () {
              if (shouldCall) listener(newValues, newValues, self);
            });
            return function deregisterWatchGroup() {
              shouldCall = false;
            };
          }

          if (watchExpressions.length === 1) {
            // Special case size of one
            return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
              newValues[0] = value;
              oldValues[0] = oldValue;
              listener(newValues, value === oldValue ? newValues : oldValues, scope);
            });
          }

          forEach(watchExpressions, function (expr, i) {
            var unwatchFn = self.$watch(expr, function watchGroupSubAction(value, oldValue) {
              newValues[i] = value;
              oldValues[i] = oldValue;
              if (!changeReactionScheduled) {
                changeReactionScheduled = true;
                self.$evalAsync(watchGroupAction);
              }
            });
            deregisterFns.push(unwatchFn);
          });

          function watchGroupAction() {
            changeReactionScheduled = false;

            if (firstRun) {
              firstRun = false;
              listener(newValues, newValues, self);
            } else {
              listener(newValues, oldValues, self);
            }
          }

          return function deregisterWatchGroup() {
            while (deregisterFns.length) {
              deregisterFns.shift()();
            }
          };
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$watchCollection
         * @kind function
         *
         * @description
         * Shallow watches the properties of an object and fires whenever any of the properties change
         * (for arrays, this implies watching the array items; for object maps, this implies watching
         * the properties). If a change is detected, the `listener` callback is fired.
         *
         * - The `obj` collection is observed via standard $watch operation and is examined on every
         *   call to $digest() to see if any items have been added, removed, or moved.
         * - The `listener` is called whenever anything within the `obj` has changed. Examples include
         *   adding, removing, and moving items belonging to an object or array.
         *
         *
         * @example
         * ```js
            $scope.names = ['igor', 'matias', 'misko', 'james'];
            $scope.dataCount = 4;
             $scope.$watchCollection('names', function(newNames, oldNames) {
              $scope.dataCount = newNames.length;
            });
             expect($scope.dataCount).toEqual(4);
            $scope.$digest();
             //still at 4 ... no changes
            expect($scope.dataCount).toEqual(4);
             $scope.names.pop();
            $scope.$digest();
             //now there's been a change
            expect($scope.dataCount).toEqual(3);
         * ```
         *
         *
         * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
         *    expression value should evaluate to an object or an array which is observed on each
         *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
         *    collection will trigger a call to the `listener`.
         *
         * @param {function(newCollection, oldCollection, scope)} listener a callback function called
         *    when a change is detected.
         *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
         *    - The `oldCollection` object is a copy of the former collection data.
         *      Due to performance considerations, the`oldCollection` value is computed only if the
         *      `listener` function declares two or more arguments.
         *    - The `scope` argument refers to the current scope.
         *
         * @returns {function()} Returns a de-registration function for this listener. When the
         *    de-registration function is executed, the internal watch operation is terminated.
         */
        $watchCollection: function $watchCollection(obj, listener) {
          $watchCollectionInterceptor.$stateful = true;

          var self = this;
          // the current value, updated on each dirty-check run
          var newValue;
          // a shallow copy of the newValue from the last dirty-check run,
          // updated to match newValue during dirty-check run
          var oldValue;
          // a shallow copy of the newValue from when the last change happened
          var veryOldValue;
          // only track veryOldValue if the listener is asking for it
          var trackVeryOldValue = listener.length > 1;
          var changeDetected = 0;
          var changeDetector = $parse(obj, $watchCollectionInterceptor);
          var internalArray = [];
          var internalObject = {};
          var initRun = true;
          var oldLength = 0;

          function $watchCollectionInterceptor(_value) {
            newValue = _value;
            var newLength, key, bothNaN, newItem, oldItem;

            // If the new value is undefined, then return undefined as the watch may be a one-time watch
            if (isUndefined(newValue)) return;

            if (!isObject(newValue)) {
              // if primitive
              if (oldValue !== newValue) {
                oldValue = newValue;
                changeDetected++;
              }
            } else if (isArrayLike(newValue)) {
              if (oldValue !== internalArray) {
                // we are transitioning from something which was not an array into array.
                oldValue = internalArray;
                oldLength = oldValue.length = 0;
                changeDetected++;
              }

              newLength = newValue.length;

              if (oldLength !== newLength) {
                // if lengths do not match we need to trigger change notification
                changeDetected++;
                oldValue.length = oldLength = newLength;
              }
              // copy the items to oldValue and look for changes.
              for (var i = 0; i < newLength; i++) {
                oldItem = oldValue[i];
                newItem = newValue[i];

                // eslint-disable-next-line no-self-compare
                bothNaN = oldItem !== oldItem && newItem !== newItem;
                if (!bothNaN && oldItem !== newItem) {
                  changeDetected++;
                  oldValue[i] = newItem;
                }
              }
            } else {
              if (oldValue !== internalObject) {
                // we are transitioning from something which was not an object into object.
                oldValue = internalObject = {};
                oldLength = 0;
                changeDetected++;
              }
              // copy the items to oldValue and look for changes.
              newLength = 0;
              for (key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  newLength++;
                  newItem = newValue[key];
                  oldItem = oldValue[key];

                  if (key in oldValue) {
                    // eslint-disable-next-line no-self-compare
                    bothNaN = oldItem !== oldItem && newItem !== newItem;
                    if (!bothNaN && oldItem !== newItem) {
                      changeDetected++;
                      oldValue[key] = newItem;
                    }
                  } else {
                    oldLength++;
                    oldValue[key] = newItem;
                    changeDetected++;
                  }
                }
              }
              if (oldLength > newLength) {
                // we used to have more keys, need to find them and destroy them.
                changeDetected++;
                for (key in oldValue) {
                  if (!hasOwnProperty.call(newValue, key)) {
                    oldLength--;
                    delete oldValue[key];
                  }
                }
              }
            }
            return changeDetected;
          }

          function $watchCollectionAction() {
            if (initRun) {
              initRun = false;
              listener(newValue, newValue, self);
            } else {
              listener(newValue, veryOldValue, self);
            }

            // make a copy for the next time a collection is changed
            if (trackVeryOldValue) {
              if (!isObject(newValue)) {
                //primitive
                veryOldValue = newValue;
              } else if (isArrayLike(newValue)) {
                veryOldValue = new Array(newValue.length);
                for (var i = 0; i < newValue.length; i++) {
                  veryOldValue[i] = newValue[i];
                }
              } else {
                // if object
                veryOldValue = {};
                for (var key in newValue) {
                  if (hasOwnProperty.call(newValue, key)) {
                    veryOldValue[key] = newValue[key];
                  }
                }
              }
            }
          }

          return this.$watch(changeDetector, $watchCollectionAction);
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$digest
         * @kind function
         *
         * @description
         * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
         * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
         * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
         * until no more listeners are firing. This means that it is possible to get into an infinite
         * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
         * iterations exceeds 10.
         *
         * Usually, you don't call `$digest()` directly in
         * {@link ng.directive:ngController controllers} or in
         * {@link ng.$compileProvider#directive directives}.
         * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
         * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
         *
         * If you want to be notified whenever `$digest()` is called,
         * you can register a `watchExpression` function with
         * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
         *
         * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
         *
         * @example
         * ```js
             var scope = ...;
             scope.name = 'misko';
             scope.counter = 0;
              expect(scope.counter).toEqual(0);
             scope.$watch('name', function(newValue, oldValue) {
               scope.counter = scope.counter + 1;
             });
             expect(scope.counter).toEqual(0);
              scope.$digest();
             // the listener is always called during the first $digest loop after it was registered
             expect(scope.counter).toEqual(1);
              scope.$digest();
             // but now it will not be called unless the value changes
             expect(scope.counter).toEqual(1);
              scope.name = 'adam';
             scope.$digest();
             expect(scope.counter).toEqual(2);
         * ```
         *
         */
        $digest: function $digest() {
          var watch,
              value,
              last,
              fn,
              get,
              watchers,
              dirty,
              ttl = TTL,
              next,
              current,
              target = this,
              watchLog = [],
              logIdx,
              asyncTask;

          beginPhase('$digest');
          // Check for changes to browser url that happened in sync before the call to $digest
          $browser.$$checkUrlChange();

          if (this === $rootScope && applyAsyncId !== null) {
            // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
            // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
            $browser.defer.cancel(applyAsyncId);
            flushApplyAsync();
          }

          lastDirtyWatch = null;

          do {
            // "while dirty" loop
            dirty = false;
            current = target;

            // It's safe for asyncQueuePosition to be a local variable here because this loop can't
            // be reentered recursively. Calling $digest from a function passed to $evalAsync would
            // lead to a '$digest already in progress' error.
            for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
              try {
                asyncTask = asyncQueue[asyncQueuePosition];
                fn = asyncTask.fn;
                fn(asyncTask.scope, asyncTask.locals);
              } catch (e) {
                $exceptionHandler(e);
              }
              lastDirtyWatch = null;
            }
            asyncQueue.length = 0;

            traverseScopesLoop: do {
              // "traverse the scopes" loop
              if (watchers = current.$$watchers) {
                // process our watches
                watchers.$$digestWatchIndex = watchers.length;
                while (watchers.$$digestWatchIndex--) {
                  try {
                    watch = watchers[watchers.$$digestWatchIndex];
                    // Most common watches are on primitives, in which case we can short
                    // circuit it with === operator, only when === fails do we use .equals
                    if (watch) {
                      get = watch.get;
                      if ((value = get(current)) !== (last = watch.last) && !(watch.eq ? equals(value, last) : isNumberNaN(value) && isNumberNaN(last))) {
                        dirty = true;
                        lastDirtyWatch = watch;
                        watch.last = watch.eq ? copy(value, null) : value;
                        fn = watch.fn;
                        fn(value, last === initWatchVal ? value : last, current);
                        if (ttl < 5) {
                          logIdx = 4 - ttl;
                          if (!watchLog[logIdx]) watchLog[logIdx] = [];
                          watchLog[logIdx].push({
                            msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                            newVal: value,
                            oldVal: last
                          });
                        }
                      } else if (watch === lastDirtyWatch) {
                        // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                        // have already been tested.
                        dirty = false;
                        break traverseScopesLoop;
                      }
                    }
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                }
              }

              // Insanity Warning: scope depth-first traversal
              // yes, this code is a bit crazy, but it works and we have tests to prove it!
              // this piece should be kept in sync with the traversal in $broadcast
              if (!(next = current.$$watchersCount && current.$$childHead || current !== target && current.$$nextSibling)) {
                while (current !== target && !(next = current.$$nextSibling)) {
                  current = current.$parent;
                }
              }
            } while (current = next);

            // `break traverseScopesLoop;` takes us to here

            if ((dirty || asyncQueue.length) && !ttl--) {
              clearPhase();
              throw $rootScopeMinErr('infdig', '{0} $digest() iterations reached. Aborting!\n' + 'Watchers fired in the last 5 iterations: {1}', TTL, watchLog);
            }
          } while (dirty || asyncQueue.length);

          clearPhase();

          // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
          while (postDigestQueuePosition < postDigestQueue.length) {
            try {
              postDigestQueue[postDigestQueuePosition++]();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          postDigestQueue.length = postDigestQueuePosition = 0;

          // Check for changes to browser url that happened during the $digest
          // (for which no event is fired; e.g. via `history.pushState()`)
          $browser.$$checkUrlChange();
        },

        /**
         * @ngdoc event
         * @name $rootScope.Scope#$destroy
         * @eventType broadcast on scope being destroyed
         *
         * @description
         * Broadcasted when a scope and its children are being destroyed.
         *
         * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
         * clean up DOM bindings before an element is removed from the DOM.
         */

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$destroy
         * @kind function
         *
         * @description
         * Removes the current scope (and all of its children) from the parent scope. Removal implies
         * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
         * propagate to the current scope and its children. Removal also implies that the current
         * scope is eligible for garbage collection.
         *
         * The `$destroy()` is usually used by directives such as
         * {@link ng.directive:ngRepeat ngRepeat} for managing the
         * unrolling of the loop.
         *
         * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
         * Application code can register a `$destroy` event handler that will give it a chance to
         * perform any necessary cleanup.
         *
         * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
         * clean up DOM bindings before an element is removed from the DOM.
         */
        $destroy: function $destroy() {
          // We can't destroy a scope that has been already destroyed.
          if (this.$$destroyed) return;
          var parent = this.$parent;

          this.$broadcast('$destroy');
          this.$$destroyed = true;

          if (this === $rootScope) {
            //Remove handlers attached to window when $rootScope is removed
            $browser.$$applicationDestroyed();
          }

          incrementWatchersCount(this, -this.$$watchersCount);
          for (var eventName in this.$$listenerCount) {
            decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
          }

          // sever all the references to parent scopes (after this cleanup, the current scope should
          // not be retained by any of our references and should be eligible for garbage collection)
          if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
          if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
          if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
          if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

          // Disable listeners, watchers and apply/digest methods
          this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
          this.$on = this.$watch = this.$watchGroup = function () {
            return noop;
          };
          this.$$listeners = {};

          // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
          this.$$nextSibling = null;
          cleanUpScope(this);
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$eval
         * @kind function
         *
         * @description
         * Executes the `expression` on the current scope and returns the result. Any exceptions in
         * the expression are propagated (uncaught). This is useful when evaluating AngularJS
         * expressions.
         *
         * @example
         * ```js
             var scope = ng.$rootScope.Scope();
             scope.a = 1;
             scope.b = 2;
              expect(scope.$eval('a+b')).toEqual(3);
             expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
         * ```
         *
         * @param {(string|function())=} expression An AngularJS expression to be executed.
         *
         *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
         *    - `function(scope)`: execute the function with the current `scope` parameter.
         *
         * @param {(object)=} locals Local variables object, useful for overriding values in scope.
         * @returns {*} The result of evaluating the expression.
         */
        $eval: function $eval(expr, locals) {
          return $parse(expr)(this, locals);
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$evalAsync
         * @kind function
         *
         * @description
         * Executes the expression on the current scope at a later point in time.
         *
         * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
         * that:
         *
         *   - it will execute after the function that scheduled the evaluation (preferably before DOM
         *     rendering).
         *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
         *     `expression` execution.
         *
         * Any exceptions from the execution of the expression are forwarded to the
         * {@link ng.$exceptionHandler $exceptionHandler} service.
         *
         * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
         * will be scheduled. However, it is encouraged to always call code that changes the model
         * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
         *
         * @param {(string|function())=} expression An AngularJS expression to be executed.
         *
         *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
         *    - `function(scope)`: execute the function with the current `scope` parameter.
         *
         * @param {(object)=} locals Local variables object, useful for overriding values in scope.
         */
        $evalAsync: function $evalAsync(expr, locals) {
          // if we are outside of an $digest loop and this is the first time we are scheduling async
          // task also schedule async auto-flush
          if (!$rootScope.$$phase && !asyncQueue.length) {
            $browser.defer(function () {
              if (asyncQueue.length) {
                $rootScope.$digest();
              }
            });
          }

          asyncQueue.push({ scope: this, fn: $parse(expr), locals: locals });
        },

        $$postDigest: function $$postDigest(fn) {
          postDigestQueue.push(fn);
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$apply
         * @kind function
         *
         * @description
         * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
         * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
         * Because we are calling into the AngularJS framework we need to perform proper scope life
         * cycle of {@link ng.$exceptionHandler exception handling},
         * {@link ng.$rootScope.Scope#$digest executing watches}.
         *
         * **Life cycle: Pseudo-Code of `$apply()`**
         *
         * ```js
             function $apply(expr) {
               try {
                 return $eval(expr);
               } catch (e) {
                 $exceptionHandler(e);
               } finally {
                 $root.$digest();
               }
             }
         * ```
         *
         *
         * Scope's `$apply()` method transitions through the following stages:
         *
         * 1. The {@link guide/expression expression} is executed using the
         *    {@link ng.$rootScope.Scope#$eval $eval()} method.
         * 2. Any exceptions from the execution of the expression are forwarded to the
         *    {@link ng.$exceptionHandler $exceptionHandler} service.
         * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
         *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
         *
         *
         * @param {(string|function())=} exp An AngularJS expression to be executed.
         *
         *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
         *    - `function(scope)`: execute the function with current `scope` parameter.
         *
         * @returns {*} The result of evaluating the expression.
         */
        $apply: function $apply(expr) {
          try {
            beginPhase('$apply');
            try {
              return this.$eval(expr);
            } finally {
              clearPhase();
            }
          } catch (e) {
            $exceptionHandler(e);
          } finally {
            try {
              $rootScope.$digest();
            } catch (e) {
              $exceptionHandler(e);
              // eslint-disable-next-line no-unsafe-finally
              throw e;
            }
          }
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$applyAsync
         * @kind function
         *
         * @description
         * Schedule the invocation of $apply to occur at a later time. The actual time difference
         * varies across browsers, but is typically around ~10 milliseconds.
         *
         * This can be used to queue up multiple expressions which need to be evaluated in the same
         * digest.
         *
         * @param {(string|function())=} exp An AngularJS expression to be executed.
         *
         *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
         *    - `function(scope)`: execute the function with current `scope` parameter.
         */
        $applyAsync: function $applyAsync(expr) {
          var scope = this;
          if (expr) {
            applyAsyncQueue.push($applyAsyncExpression);
          }
          expr = $parse(expr);
          scheduleApplyAsync();

          function $applyAsyncExpression() {
            scope.$eval(expr);
          }
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$on
         * @kind function
         *
         * @description
         * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
         * discussion of event life cycle.
         *
         * The event listener function format is: `function(event, args...)`. The `event` object
         * passed into the listener has the following attributes:
         *
         *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
         *     `$broadcast`-ed.
         *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
         *     event propagates through the scope hierarchy, this property is set to null.
         *   - `name` - `{string}`: name of the event.
         *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
         *     further event propagation (available only for events that were `$emit`-ed).
         *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
         *     to true.
         *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
         *
         * @param {string} name Event name to listen on.
         * @param {function(event, ...args)} listener Function to call when the event is emitted.
         * @returns {function()} Returns a deregistration function for this listener.
         */
        $on: function $on(name, listener) {
          var namedListeners = this.$$listeners[name];
          if (!namedListeners) {
            this.$$listeners[name] = namedListeners = [];
          }
          namedListeners.push(listener);

          var current = this;
          do {
            if (!current.$$listenerCount[name]) {
              current.$$listenerCount[name] = 0;
            }
            current.$$listenerCount[name]++;
          } while (current = current.$parent);

          var self = this;
          return function () {
            var indexOfListener = namedListeners.indexOf(listener);
            if (indexOfListener !== -1) {
              // Use delete in the hope of the browser deallocating the memory for the array entry,
              // while not shifting the array indexes of other listeners.
              // See issue https://github.com/angular/angular.js/issues/16135
              delete namedListeners[indexOfListener];
              decrementListenerCount(self, 1, name);
            }
          };
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$emit
         * @kind function
         *
         * @description
         * Dispatches an event `name` upwards through the scope hierarchy notifying the
         * registered {@link ng.$rootScope.Scope#$on} listeners.
         *
         * The event life cycle starts at the scope on which `$emit` was called. All
         * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
         * notified. Afterwards, the event traverses upwards toward the root scope and calls all
         * registered listeners along the way. The event will stop propagating if one of the listeners
         * cancels it.
         *
         * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
         * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
         *
         * @param {string} name Event name to emit.
         * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
         * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
         */
        $emit: function $emit(name, args) {
          var empty = [],
              namedListeners,
              scope = this,
              _stopPropagation = false,
              event = {
            name: name,
            targetScope: scope,
            stopPropagation: function stopPropagation() {
              _stopPropagation = true;
            },
            preventDefault: function preventDefault() {
              event.defaultPrevented = true;
            },
            defaultPrevented: false
          },
              listenerArgs = concat([event], arguments, 1),
              i,
              length;

          do {
            namedListeners = scope.$$listeners[name] || empty;
            event.currentScope = scope;
            for (i = 0, length = namedListeners.length; i < length; i++) {

              // if listeners were deregistered, defragment the array
              if (!namedListeners[i]) {
                namedListeners.splice(i, 1);
                i--;
                length--;
                continue;
              }
              try {
                //allow all listeners attached to the current scope to run
                namedListeners[i].apply(null, listenerArgs);
              } catch (e) {
                $exceptionHandler(e);
              }
            }
            //if any listener on the current scope stops propagation, prevent bubbling
            if (_stopPropagation) {
              break;
            }
            //traverse upwards
            scope = scope.$parent;
          } while (scope);

          event.currentScope = null;

          return event;
        },

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$broadcast
         * @kind function
         *
         * @description
         * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
         * registered {@link ng.$rootScope.Scope#$on} listeners.
         *
         * The event life cycle starts at the scope on which `$broadcast` was called. All
         * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
         * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
         * scope and calls all registered listeners along the way. The event cannot be canceled.
         *
         * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
         * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
         *
         * @param {string} name Event name to broadcast.
         * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
         * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
         */
        $broadcast: function $broadcast(name, args) {
          var target = this,
              current = target,
              next = target,
              event = {
            name: name,
            targetScope: target,
            preventDefault: function preventDefault() {
              event.defaultPrevented = true;
            },
            defaultPrevented: false
          };

          if (!target.$$listenerCount[name]) return event;

          var listenerArgs = concat([event], arguments, 1),
              listeners,
              i,
              length;

          //down while you can, then up and next sibling or up and next sibling until back at root
          while (current = next) {
            event.currentScope = current;
            listeners = current.$$listeners[name] || [];
            for (i = 0, length = listeners.length; i < length; i++) {
              // if listeners were deregistered, defragment the array
              if (!listeners[i]) {
                listeners.splice(i, 1);
                i--;
                length--;
                continue;
              }

              try {
                listeners[i].apply(null, listenerArgs);
              } catch (e) {
                $exceptionHandler(e);
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $digest
            // (though it differs due to having the extra check for $$listenerCount)
            if (!(next = current.$$listenerCount[name] && current.$$childHead || current !== target && current.$$nextSibling)) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          }

          event.currentScope = null;
          return event;
        }
      };

      var $rootScope = new Scope();

      //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
      var asyncQueue = $rootScope.$$asyncQueue = [];
      var postDigestQueue = $rootScope.$$postDigestQueue = [];
      var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];

      var postDigestQueuePosition = 0;

      return $rootScope;

      function beginPhase(phase) {
        if ($rootScope.$$phase) {
          throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
        }

        $rootScope.$$phase = phase;
      }

      function clearPhase() {
        $rootScope.$$phase = null;
      }

      function incrementWatchersCount(current, count) {
        do {
          current.$$watchersCount += count;
        } while (current = current.$parent);
      }

      function decrementListenerCount(current, count, name) {
        do {
          current.$$listenerCount[name] -= count;

          if (current.$$listenerCount[name] === 0) {
            delete current.$$listenerCount[name];
          }
        } while (current = current.$parent);
      }

      /**
       * function used as an initial value for watchers.
       * because it's unique we can easily tell it apart from other values
       */
      function initWatchVal() {}

      function flushApplyAsync() {
        while (applyAsyncQueue.length) {
          try {
            applyAsyncQueue.shift()();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
        applyAsyncId = null;
      }

      function scheduleApplyAsync() {
        if (applyAsyncId === null) {
          applyAsyncId = $browser.defer(function () {
            $rootScope.$apply(flushApplyAsync);
          });
        }
      }
    }];
  }

  /**
   * @ngdoc service
   * @name $rootElement
   *
   * @description
   * The root element of AngularJS application. This is either the element where {@link
   * ng.directive:ngApp ngApp} was declared or the element passed into
   * {@link angular.bootstrap}. The element represents the root element of application. It is also the
   * location where the application's {@link auto.$injector $injector} service gets
   * published, and can be retrieved using `$rootElement.injector()`.
   */

  // the implementation is in angular.bootstrap

  /**
   * @this
   * @description
   * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
   */
  function $$SanitizeUriProvider() {
    var aHrefSanitizationWhitelist = /^\s*(https?|s?ftp|mailto|tel|file):/,
        imgSrcSanitizationWhitelist = /^\s*((https?|ftp|file|blob):|data:image\/)/;

    /**
     * @description
     * Retrieves or overrides the default regular expression that is used for whitelisting of safe
     * urls during a[href] sanitization.
     *
     * The sanitization is a security measure aimed at prevent XSS attacks via html links.
     *
     * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
     * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationWhitelist`
     * regular expression. If a match is found, the original url is written into the dom. Otherwise,
     * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
     *
     * @param {RegExp=} regexp New regexp to whitelist urls with.
     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
     *    chaining otherwise.
     */
    this.aHrefSanitizationWhitelist = function (regexp) {
      if (isDefined(regexp)) {
        aHrefSanitizationWhitelist = regexp;
        return this;
      }
      return aHrefSanitizationWhitelist;
    };

    /**
     * @description
     * Retrieves or overrides the default regular expression that is used for whitelisting of safe
     * urls during img[src] sanitization.
     *
     * The sanitization is a security measure aimed at prevent XSS attacks via html links.
     *
     * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
     * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationWhitelist`
     * regular expression. If a match is found, the original url is written into the dom. Otherwise,
     * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
     *
     * @param {RegExp=} regexp New regexp to whitelist urls with.
     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
     *    chaining otherwise.
     */
    this.imgSrcSanitizationWhitelist = function (regexp) {
      if (isDefined(regexp)) {
        imgSrcSanitizationWhitelist = regexp;
        return this;
      }
      return imgSrcSanitizationWhitelist;
    };

    this.$get = function () {
      return function sanitizeUri(uri, isImage) {
        var regex = isImage ? imgSrcSanitizationWhitelist : aHrefSanitizationWhitelist;
        var normalizedVal;
        normalizedVal = urlResolve(uri && uri.trim()).href;
        if (normalizedVal !== '' && !normalizedVal.match(regex)) {
          return 'unsafe:' + normalizedVal;
        }
        return uri;
      };
    };
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   *     Any commits to this file should be reviewed with security in mind.  *
   *   Changes to this file can potentially create security vulnerabilities. *
   *          An approval from 2 Core members with history of modifying      *
   *                         this file is required.                          *
   *                                                                         *
   *  Does the change somehow allow for arbitrary javascript to be executed? *
   *    Or allows for someone to change the prototype of built-in objects?   *
   *     Or gives undesired access to variables likes document or window?    *
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  /* exported $SceProvider, $SceDelegateProvider */

  var $sceMinErr = minErr('$sce');

  var SCE_CONTEXTS = {
    // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
    HTML: 'html',

    // Style statements or stylesheets. Currently unused in AngularJS.
    CSS: 'css',

    // An URL used in a context where it does not refer to a resource that loads code. Currently
    // unused in AngularJS.
    URL: 'url',

    // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
    // code. (e.g. ng-include, script src binding, templateUrl)
    RESOURCE_URL: 'resourceUrl',

    // Script. Currently unused in AngularJS.
    JS: 'js'
  };

  // Helper functions follow.

  var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;

  function snakeToCamel(name) {
    return name.replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
  }

  function adjustMatcher(matcher) {
    if (matcher === 'self') {
      return matcher;
    } else if (isString(matcher)) {
      // Strings match exactly except for 2 wildcards - '*' and '**'.
      // '*' matches any character except those from the set ':/.?&'.
      // '**' matches any character (like .* in a RegExp).
      // More than 2 *'s raises an error as it's ill defined.
      if (matcher.indexOf('***') > -1) {
        throw $sceMinErr('iwcard', 'Illegal sequence *** in string matcher.  String: {0}', matcher);
      }
      matcher = escapeForRegexp(matcher).replace(/\\\*\\\*/g, '.*').replace(/\\\*/g, '[^:/.?&;]*');
      return new RegExp('^' + matcher + '$');
    } else if (isRegExp(matcher)) {
      // The only other type of matcher allowed is a Regexp.
      // Match entire URL / disallow partial matches.
      // Flags are reset (i.e. no global, ignoreCase or multiline)
      return new RegExp('^' + matcher.source + '$');
    } else {
      throw $sceMinErr('imatcher', 'Matchers may only be "self", string patterns or RegExp objects');
    }
  }

  function adjustMatchers(matchers) {
    var adjustedMatchers = [];
    if (isDefined(matchers)) {
      forEach(matchers, function (matcher) {
        adjustedMatchers.push(adjustMatcher(matcher));
      });
    }
    return adjustedMatchers;
  }

  /**
   * @ngdoc service
   * @name $sceDelegate
   * @kind function
   *
   * @description
   *
   * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
   * Contextual Escaping (SCE)} services to AngularJS.
   *
   * For an overview of this service and the functionnality it provides in AngularJS, see the main
   * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
   * SCE works in their application, which shouldn't be needed in most cases.
   *
   * <div class="alert alert-danger">
   * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
   * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
   * changes to this service will also influence users, so be extra careful and document your changes.
   * </div>
   *
   * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
   * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
   * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
   * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
   * work because `$sce` delegates to `$sceDelegate` for these operations.
   *
   * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
   *
   * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
   * can override it completely to change the behavior of `$sce`, the common case would
   * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
   * your own whitelists and blacklists for trusting URLs used for loading AngularJS resources such as
   * templates.  Refer {@link ng.$sceDelegateProvider#resourceUrlWhitelist
   * $sceDelegateProvider.resourceUrlWhitelist} and {@link
   * ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist}
   */

  /**
   * @ngdoc provider
   * @name $sceDelegateProvider
   * @this
   *
   * @description
   *
   * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
   * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
   *
   * The `$sceDelegateProvider` allows one to get/set the whitelists and blacklists used to ensure
   * that the URLs used for sourcing AngularJS templates and other script-running URLs are safe (all
   * places that use the `$sce.RESOURCE_URL` context). See
   * {@link ng.$sceDelegateProvider#resourceUrlWhitelist $sceDelegateProvider.resourceUrlWhitelist}
   * and
   * {@link ng.$sceDelegateProvider#resourceUrlBlacklist $sceDelegateProvider.resourceUrlBlacklist},
   *
   * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
   * Strict Contextual Escaping (SCE)}.
   *
   * **Example**:  Consider the following case. <a name="example"></a>
   *
   * - your app is hosted at url `http://myapp.example.com/`
   * - but some of your templates are hosted on other domains you control such as
   *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
   * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
   *
   * Here is what a secure configuration for this scenario might look like:
   *
   * ```
   *  angular.module('myApp', []).config(function($sceDelegateProvider) {
   *    $sceDelegateProvider.resourceUrlWhitelist([
   *      // Allow same origin resource loads.
   *      'self',
   *      // Allow loading from our assets domain.  Notice the difference between * and **.
   *      'http://srv*.assets.example.com/**'
   *    ]);
   *
   *    // The blacklist overrides the whitelist so the open redirect here is blocked.
   *    $sceDelegateProvider.resourceUrlBlacklist([
   *      'http://myapp.example.com/clickThru**'
   *    ]);
   *  });
   * ```
   * Note that an empty whitelist will block every resource URL from being loaded, and will require
   * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
   * requested by {@link ng.$templateRequest $templateRequest} that are present in
   * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
   * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
   * from that whitelist. This helps to mitigate the security impact of certain types of issues, like
   * for instance attacker-controlled `ng-includes`.
   */

  function $SceDelegateProvider() {
    this.SCE_CONTEXTS = SCE_CONTEXTS;

    // Resource URLs can also be trusted by policy.
    var resourceUrlWhitelist = ['self'],
        resourceUrlBlacklist = [];

    /**
     * @ngdoc method
     * @name $sceDelegateProvider#resourceUrlWhitelist
     * @kind function
     *
     * @param {Array=} whitelist When provided, replaces the resourceUrlWhitelist with the value
     *     provided.  This must be an array or null.  A snapshot of this array is used so further
     *     changes to the array are ignored.
     *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
     *     allowed in this array.
     *
     * @return {Array} The currently set whitelist array.
     *
     * @description
     * Sets/Gets the whitelist of trusted resource URLs.
     *
     * The **default value** when no whitelist has been explicitly set is `['self']` allowing only
     * same origin resource requests.
     *
     * <div class="alert alert-warning">
     * **Note:** the default whitelist of 'self' is not recommended if your app shares its origin
     * with other apps! It is a good idea to limit it to only your application's directory.
     * </div>
     */
    this.resourceUrlWhitelist = function (value) {
      if (arguments.length) {
        resourceUrlWhitelist = adjustMatchers(value);
      }
      return resourceUrlWhitelist;
    };

    /**
     * @ngdoc method
     * @name $sceDelegateProvider#resourceUrlBlacklist
     * @kind function
     *
     * @param {Array=} blacklist When provided, replaces the resourceUrlBlacklist with the value
     *     provided.  This must be an array or null.  A snapshot of this array is used so further
     *     changes to the array are ignored.</p><p>
     *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
     *     allowed in this array.</p><p>
     *     The typical usage for the blacklist is to **block
     *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
     *     these would otherwise be trusted but actually return content from the redirected domain.
     *     </p><p>
     *     Finally, **the blacklist overrides the whitelist** and has the final say.
     *
     * @return {Array} The currently set blacklist array.
     *
     * @description
     * Sets/Gets the blacklist of trusted resource URLs.
     *
     * The **default value** when no whitelist has been explicitly set is the empty array (i.e. there
     * is no blacklist.)
     */

    this.resourceUrlBlacklist = function (value) {
      if (arguments.length) {
        resourceUrlBlacklist = adjustMatchers(value);
      }
      return resourceUrlBlacklist;
    };

    this.$get = ['$injector', function ($injector) {

      var htmlSanitizer = function htmlSanitizer(html) {
        throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
      };

      if ($injector.has('$sanitize')) {
        htmlSanitizer = $injector.get('$sanitize');
      }

      function matchUrl(matcher, parsedUrl) {
        if (matcher === 'self') {
          return urlIsSameOrigin(parsedUrl);
        } else {
          // definitely a regex.  See adjustMatchers()
          return !!matcher.exec(parsedUrl.href);
        }
      }

      function isResourceUrlAllowedByPolicy(url) {
        var parsedUrl = urlResolve(url.toString());
        var i,
            n,
            allowed = false;
        // Ensure that at least one item from the whitelist allows this url.
        for (i = 0, n = resourceUrlWhitelist.length; i < n; i++) {
          if (matchUrl(resourceUrlWhitelist[i], parsedUrl)) {
            allowed = true;
            break;
          }
        }
        if (allowed) {
          // Ensure that no item from the blacklist blocked this url.
          for (i = 0, n = resourceUrlBlacklist.length; i < n; i++) {
            if (matchUrl(resourceUrlBlacklist[i], parsedUrl)) {
              allowed = false;
              break;
            }
          }
        }
        return allowed;
      }

      function generateHolderType(Base) {
        var holderType = function TrustedValueHolderType(trustedValue) {
          this.$$unwrapTrustedValue = function () {
            return trustedValue;
          };
        };
        if (Base) {
          holderType.prototype = new Base();
        }
        holderType.prototype.valueOf = function sceValueOf() {
          return this.$$unwrapTrustedValue();
        };
        holderType.prototype.toString = function sceToString() {
          return this.$$unwrapTrustedValue().toString();
        };
        return holderType;
      }

      var trustedValueHolderBase = generateHolderType(),
          byType = {};

      byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.URL] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

      /**
       * @ngdoc method
       * @name $sceDelegate#trustAs
       *
       * @description
       * Returns a trusted representation of the parameter for the specified context. This trusted
       * object will later on be used as-is, without any security check, by bindings or directives
       * that require this security context.
       * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
       * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
       * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
       * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
       * security risk.
       *
       * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
       * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
       * escaping.
       *
       * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
       *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
       *
       * @param {*} value The value that should be considered trusted.
       * @return {*} A trusted representation of value, that can be used in the given context.
       */
      function trustAs(type, trustedValue) {
        var Constructor = byType.hasOwnProperty(type) ? byType[type] : null;
        if (!Constructor) {
          throw $sceMinErr('icontext', 'Attempted to trust a value in invalid context. Context: {0}; Value: {1}', type, trustedValue);
        }
        if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
          return trustedValue;
        }
        // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
        // mutable objects, we ensure here that the value passed in is actually a string.
        if (typeof trustedValue !== 'string') {
          throw $sceMinErr('itype', 'Attempted to trust a non-string value in a content requiring a string: Context: {0}', type);
        }
        return new Constructor(trustedValue);
      }

      /**
       * @ngdoc method
       * @name $sceDelegate#valueOf
       *
       * @description
       * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
       * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
       * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
       *
       * If the passed parameter is not a value that had been returned by {@link
       * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
       *
       * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
       *     call or anything else.
       * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
       *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
       *     `value` unchanged.
       */
      function valueOf(maybeTrusted) {
        if (maybeTrusted instanceof trustedValueHolderBase) {
          return maybeTrusted.$$unwrapTrustedValue();
        } else {
          return maybeTrusted;
        }
      }

      /**
       * @ngdoc method
       * @name $sceDelegate#getTrusted
       *
       * @description
       * Takes any input, and either returns a value that's safe to use in the specified context, or
       * throws an exception.
       *
       * In practice, there are several cases. When given a string, this function runs checks
       * and sanitization to make it safe without prior assumptions. When given the result of a {@link
       * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`} call, it returns the originally supplied
       * value if that value's context is valid for this call's context. Finally, this function can
       * also throw when there is no way to turn `maybeTrusted` in a safe value (e.g., no sanitization
       * is available or possible.)
       *
       * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
       * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
       *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
       * @return {*} A version of the value that's safe to use in the given context, or throws an
       *     exception if this is impossible.
       */
      function getTrusted(type, maybeTrusted) {
        if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
          return maybeTrusted;
        }
        var constructor = byType.hasOwnProperty(type) ? byType[type] : null;
        // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
        // as-is.
        if (constructor && maybeTrusted instanceof constructor) {
          return maybeTrusted.$$unwrapTrustedValue();
        }
        // Otherwise, if we get here, then we may either make it safe, or throw an exception. This
        // depends on the context: some are sanitizatible (HTML), some use whitelists (RESOURCE_URL),
        // some are impossible to do (JS). This step isn't implemented for CSS and URL, as AngularJS
        // has no corresponding sinks.
        if (type === SCE_CONTEXTS.RESOURCE_URL) {
          // RESOURCE_URL uses a whitelist.
          if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
            return maybeTrusted;
          } else {
            throw $sceMinErr('insecurl', 'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}', maybeTrusted.toString());
          }
        } else if (type === SCE_CONTEXTS.HTML) {
          // htmlSanitizer throws its own error when no sanitizer is available.
          return htmlSanitizer(maybeTrusted);
        }
        // Default error when the $sce service has no way to make the input safe.
        throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
      }

      return { trustAs: trustAs,
        getTrusted: getTrusted,
        valueOf: valueOf };
    }];
  }

  /**
   * @ngdoc provider
   * @name $sceProvider
   * @this
   *
   * @description
   *
   * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
   * -   enable/disable Strict Contextual Escaping (SCE) in a module
   * -   override the default implementation with a custom delegate
   *
   * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
   */

  /**
   * @ngdoc service
   * @name $sce
   * @kind function
   *
   * @description
   *
   * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
   *
   * ## Strict Contextual Escaping
   *
   * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
   * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
   * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
   *
   * ### Overview
   *
   * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
   * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
   * run security checks on them (sanitizations, whitelists, depending on context), or throw when it
   * cannot guarantee the security of the result. That behavior depends strongly on contexts: HTML
   * can be sanitized, but template URLs cannot, for instance.
   *
   * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
   * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
   * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
   * render the input as-is, you will need to mark it as trusted for that context before attempting
   * to bind it.
   *
   * As of version 1.2, AngularJS ships with SCE enabled by default.
   *
   * ### In practice
   *
   * Here's an example of a binding in a privileged context:
   *
   * ```
   * <input ng-model="userHtml" aria-label="User input">
   * <div ng-bind-html="userHtml"></div>
   * ```
   *
   * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
   * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
   * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
   * articles, etc. via bindings. (HTML is just one example of a context where rendering user
   * controlled input creates security vulnerabilities.)
   *
   * For the case of HTML, you might use a library, either on the client side, or on the server side,
   * to sanitize unsafe HTML before binding to the value and rendering it in the document.
   *
   * How would you ensure that every place that used these types of bindings was bound to a value that
   * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
   * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
   * properties/fields and forgot to update the binding to the sanitized value?
   *
   * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
   * any similar validation process, unless there's a good reason to trust the given value in this
   * context.  That trust is formalized with a function call. This means that as a developer, you
   * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
   * you just need to ensure the values you mark as trusted indeed are safe - because they were
   * received from your server, sanitized by your library, etc. You can organize your codebase to
   * help with this - perhaps allowing only the files in a specific directory to do this.
   * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
   * becomes a more manageable task.
   *
   * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
   * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
   * build the trusted versions of your values.
   *
   * ### How does it work?
   *
   * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
   * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
   * a way to enforce the required security context in your data sink. Directives use {@link
   * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
   * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
   * when binding without directives, AngularJS will understand the context of your bindings
   * automatically.
   *
   * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
   * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
   * simplified):
   *
   * ```
   * var ngBindHtmlDirective = ['$sce', function($sce) {
   *   return function(scope, element, attr) {
   *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
   *       element.html(value || '');
   *     });
   *   };
   * }];
   * ```
   *
   * ### Impact on loading templates
   *
   * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
   * `templateUrl`'s specified by {@link guide/directive directives}.
   *
   * By default, AngularJS only loads templates from the same domain and protocol as the application
   * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
   * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
   * protocols, you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist
   * them} or {@link ng.$sce#trustAsResourceUrl wrap it} into a trusted value.
   *
   * *Please note*:
   * The browser's
   * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
   * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
   * policy apply in addition to this and may further restrict whether the template is successfully
   * loaded.  This means that without the right CORS policy, loading templates from a different domain
   * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
   * browsers.
   *
   * ### This feels like too much overhead
   *
   * It's important to remember that SCE only applies to interpolation expressions.
   *
   * If your expressions are constant literals, they're automatically trusted and you don't need to
   * call `$sce.trustAs` on them (e.g.
   * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works. The `$sceDelegate` will
   * also use the `$sanitize` service if it is available when binding untrusted values to
   * `$sce.HTML` context. AngularJS provides an implementation in `angular-sanitize.js`, and if you
   * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
   * your application.
   *
   * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
   * templates in `ng-include` from your application's domain without having to even know about SCE.
   * It blocks loading templates from other domains or loading templates over http from an https
   * served document.  You can change these by setting your own custom {@link
   * ng.$sceDelegateProvider#resourceUrlWhitelist whitelists} and {@link
   * ng.$sceDelegateProvider#resourceUrlBlacklist blacklists} for matching such URLs.
   *
   * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
   * application that's secure and can be audited to verify that with much more ease than bolting
   * security onto an application later.
   *
   * <a name="contexts"></a>
   * ### What trusted context types are supported?
   *
   * | Context             | Notes          |
   * |---------------------|----------------|
   * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered, and the {@link ngSanitize.$sanitize $sanitize} service is available (implemented by the {@link ngSanitize ngSanitize} module) this will sanitize the value instead of throwing an error. |
   * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently, no bindings require this context. Feel free to use it in your own directives. |
   * | `$sce.URL`          | For URLs that are safe to follow as links.  Currently unused (`<a href=`, `<img src=`, and some others sanitize their urls and don't constitute an SCE context.) |
   * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG`, `VIDEO`, `AUDIO`, `SOURCE`, and `TRACK` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` does (it's not just the URL that matters, but also what is at the end of it), and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` are required. |
   * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently, no bindings require this context.  Feel free to use it in your own directives. |
   *
   *
   * Be aware that `a[href]` and `img[src]` automatically sanitize their URLs and do not pass them
   * through {@link ng.$sce#getTrusted $sce.getTrusted}. There's no CSS-, URL-, or JS-context bindings
   * in AngularJS currently, so their corresponding `$sce.trustAs` functions aren't useful yet. This
   * might evolve.
   *
   * ### Format of items in {@link ng.$sceDelegateProvider#resourceUrlWhitelist resourceUrlWhitelist}/{@link ng.$sceDelegateProvider#resourceUrlBlacklist Blacklist} <a name="resourceUrlPatternItem"></a>
   *
   *  Each element in these arrays must be one of the following:
   *
   *  - **'self'**
   *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
   *      domain** as the application document using the **same protocol**.
   *  - **String** (except the special value `'self'`)
   *    - The string is matched against the full *normalized / absolute URL* of the resource
   *      being tested (substring matches are not good enough.)
   *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
   *      match themselves.
   *    - `*`: matches zero or more occurrences of any character other than one of the following 6
   *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
   *      in a whitelist.
   *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
   *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
   *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
   *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
   *      http://foo.example.com/templates/**).
   *  - **RegExp** (*see caveat below*)
   *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
   *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
   *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
   *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
   *      small number of cases.  A `.` character in the regex used when matching the scheme or a
   *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
   *      is highly recommended to use the string patterns and only fall back to regular expressions
   *      as a last resort.
   *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
   *      matched against the **entire** *normalized / absolute URL* of the resource being tested
   *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
   *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
   *    - If you are generating your JavaScript from some other templating engine (not
   *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
   *      remember to escape your regular expression (and be aware that you might need more than
   *      one level of escaping depending on your templating engine and the way you interpolated
   *      the value.)  Do make use of your platform's escaping mechanism as it might be good
   *      enough before coding your own.  E.g. Ruby has
   *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
   *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
   *      Javascript lacks a similar built in function for escaping.  Take a look at Google
   *      Closure library's [goog.string.regExpEscape(s)](
   *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
   *
   * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
   *
   * ### Show me an example using SCE.
   *
   * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
   * <file name="index.html">
   *   <div ng-controller="AppController as myCtrl">
   *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
   *     <b>User comments</b><br>
   *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
   *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
   *     exploit.
   *     <div class="well">
   *       <div ng-repeat="userComment in myCtrl.userComments">
   *         <b>{{userComment.name}}</b>:
   *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
   *         <br>
   *       </div>
   *     </div>
   *   </div>
   * </file>
   *
   * <file name="script.js">
   *   angular.module('mySceApp', ['ngSanitize'])
   *     .controller('AppController', ['$http', '$templateCache', '$sce',
   *       function AppController($http, $templateCache, $sce) {
   *         var self = this;
   *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
   *           self.userComments = response.data;
   *         });
   *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
   *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
   *             'sanitization.&quot;">Hover over this text.</span>');
   *       }]);
   * </file>
   *
   * <file name="test_data.json">
   * [
   *   { "name": "Alice",
   *     "htmlComment":
   *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
   *   },
   *   { "name": "Bob",
   *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
   *   }
   * ]
   * </file>
   *
   * <file name="protractor.js" type="protractor">
   *   describe('SCE doc demo', function() {
   *     it('should sanitize untrusted values', function() {
   *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
   *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
   *     });
   *
   *     it('should NOT sanitize explicitly trusted values', function() {
   *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
   *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
   *           'sanitization.&quot;">Hover over this text.</span>');
   *     });
   *   });
   * </file>
   * </example>
   *
   *
   *
   * ## Can I disable SCE completely?
   *
   * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
   * for little coding overhead.  It will be much harder to take an SCE disabled application and
   * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
   * for cases where you have a lot of existing code that was written before SCE was introduced and
   * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
   * you are writing a library, you will cause security bugs applications using it.
   *
   * That said, here's how you can completely disable SCE:
   *
   * ```
   * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
   *   // Completely disable SCE.  For demonstration purposes only!
   *   // Do not use in new projects or libraries.
   *   $sceProvider.enabled(false);
   * });
   * ```
   *
   */

  function $SceProvider() {
    var enabled = true;

    /**
     * @ngdoc method
     * @name $sceProvider#enabled
     * @kind function
     *
     * @param {boolean=} value If provided, then enables/disables SCE application-wide.
     * @return {boolean} True if SCE is enabled, false otherwise.
     *
     * @description
     * Enables/disables SCE and returns the current value.
     */
    this.enabled = function (value) {
      if (arguments.length) {
        enabled = !!value;
      }
      return enabled;
    };

    /* Design notes on the default implementation for SCE.
     *
     * The API contract for the SCE delegate
     * -------------------------------------
     * The SCE delegate object must provide the following 3 methods:
     *
     * - trustAs(contextEnum, value)
     *     This method is used to tell the SCE service that the provided value is OK to use in the
     *     contexts specified by contextEnum.  It must return an object that will be accepted by
     *     getTrusted() for a compatible contextEnum and return this value.
     *
     * - valueOf(value)
     *     For values that were not produced by trustAs(), return them as is.  For values that were
     *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
     *     trustAs is wrapping the given values into some type, this operation unwraps it when given
     *     such a value.
     *
     * - getTrusted(contextEnum, value)
     *     This function should return the a value that is safe to use in the context specified by
     *     contextEnum or throw and exception otherwise.
     *
     * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
     * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
     * instance, an implementation could maintain a registry of all trusted objects by context.  In
     * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
     * return the same object passed in if it was found in the registry under a compatible context or
     * throw an exception otherwise.  An implementation might only wrap values some of the time based
     * on some criteria.  getTrusted() might return a value and not throw an exception for special
     * constants or objects even if not wrapped.  All such implementations fulfill this contract.
     *
     *
     * A note on the inheritance model for SCE contexts
     * ------------------------------------------------
     * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
     * is purely an implementation details.
     *
     * The contract is simply this:
     *
     *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
     *     will also succeed.
     *
     * Inheritance happens to capture this in a natural way. In some future, we may not use
     * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
     * be aware of this detail.
     */

    this.$get = ['$parse', '$sceDelegate', function ($parse, $sceDelegate) {
      // Support: IE 9-11 only
      // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
      // the "expression(javascript expression)" syntax which is insecure.
      if (enabled && msie < 8) {
        throw $sceMinErr('iequirks', 'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' + 'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' + 'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
      }

      var sce = shallowCopy(SCE_CONTEXTS);

      /**
       * @ngdoc method
       * @name $sce#isEnabled
       * @kind function
       *
       * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
       *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
       *
       * @description
       * Returns a boolean indicating if SCE is enabled.
       */
      sce.isEnabled = function () {
        return enabled;
      };
      sce.trustAs = $sceDelegate.trustAs;
      sce.getTrusted = $sceDelegate.getTrusted;
      sce.valueOf = $sceDelegate.valueOf;

      if (!enabled) {
        sce.trustAs = sce.getTrusted = function (type, value) {
          return value;
        };
        sce.valueOf = identity;
      }

      /**
       * @ngdoc method
       * @name $sce#parseAs
       *
       * @description
       * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
       * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
       * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
       * *result*)}
       *
       * @param {string} type The SCE context in which this result will be used.
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */
      sce.parseAs = function sceParseAs(type, expr) {
        var parsed = $parse(expr);
        if (parsed.literal && parsed.constant) {
          return parsed;
        } else {
          return $parse(expr, function (value) {
            return sce.getTrusted(type, value);
          });
        }
      };

      /**
       * @ngdoc method
       * @name $sce#trustAs
       *
       * @description
       * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
       * wrapped object that represents your value, and the trust you have in its safety for the given
       * context. AngularJS can then use that value as-is in bindings of the specified secure context.
       * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
       * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
       *
       * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
       *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
       *
       * @param {*} value The value that that should be considered trusted.
       * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
       *     in the context you specified.
       */

      /**
       * @ngdoc method
       * @name $sce#trustAsHtml
       *
       * @description
       * Shorthand method.  `$sce.trustAsHtml(value)` →
       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
       *
       * @param {*} value The value to mark as trusted for `$sce.HTML` context.
       * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
       *     in `$sce.HTML` context (like `ng-bind-html`).
       */

      /**
       * @ngdoc method
       * @name $sce#trustAsCss
       *
       * @description
       * Shorthand method.  `$sce.trustAsCss(value)` →
       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
       *
       * @param {*} value The value to mark as trusted for `$sce.CSS` context.
       * @return {*} A wrapped version of value that can be used as a trusted variant
       *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
       *     almost no reasons to use this function so far.
       */

      /**
       * @ngdoc method
       * @name $sce#trustAsUrl
       *
       * @description
       * Shorthand method.  `$sce.trustAsUrl(value)` →
       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
       *
       * @param {*} value The value to mark as trusted for `$sce.URL` context.
       * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
       *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
       *     to use this function so far.
       */

      /**
       * @ngdoc method
       * @name $sce#trustAsResourceUrl
       *
       * @description
       * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
       *
       * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
       * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
       *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
       *     bindings, ...)
       */

      /**
       * @ngdoc method
       * @name $sce#trustAsJs
       *
       * @description
       * Shorthand method.  `$sce.trustAsJs(value)` →
       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
       *
       * @param {*} value The value to mark as trusted for `$sce.JS` context.
       * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
       *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
       *     use this function so far.
       */

      /**
       * @ngdoc method
       * @name $sce#getTrusted
       *
       * @description
       * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
       * takes any input, and either returns a value that's safe to use in the specified context,
       * or throws an exception. This function is aware of trusted values created by the `trustAs`
       * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
       * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
       * safe value (e.g., no sanitization is available or possible.)
       *
       * @param {string} type The context in which this value is to be used.
       * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
       *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
       * @return {*} A version of the value that's safe to use in the given context, or throws an
       *     exception if this is impossible.
       */

      /**
       * @ngdoc method
       * @name $sce#getTrustedHtml
       *
       * @description
       * Shorthand method.  `$sce.getTrustedHtml(value)` →
       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
       *
       * @param {*} value The value to pass to `$sce.getTrusted`.
       * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
       */

      /**
       * @ngdoc method
       * @name $sce#getTrustedCss
       *
       * @description
       * Shorthand method.  `$sce.getTrustedCss(value)` →
       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
       *
       * @param {*} value The value to pass to `$sce.getTrusted`.
       * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
       */

      /**
       * @ngdoc method
       * @name $sce#getTrustedUrl
       *
       * @description
       * Shorthand method.  `$sce.getTrustedUrl(value)` →
       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
       *
       * @param {*} value The value to pass to `$sce.getTrusted`.
       * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
       */

      /**
       * @ngdoc method
       * @name $sce#getTrustedResourceUrl
       *
       * @description
       * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
       *
       * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
       * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
       */

      /**
       * @ngdoc method
       * @name $sce#getTrustedJs
       *
       * @description
       * Shorthand method.  `$sce.getTrustedJs(value)` →
       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
       *
       * @param {*} value The value to pass to `$sce.getTrusted`.
       * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
       */

      /**
       * @ngdoc method
       * @name $sce#parseAsHtml
       *
       * @description
       * Shorthand method.  `$sce.parseAsHtml(expression string)` →
       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
       *
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */

      /**
       * @ngdoc method
       * @name $sce#parseAsCss
       *
       * @description
       * Shorthand method.  `$sce.parseAsCss(value)` →
       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
       *
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */

      /**
       * @ngdoc method
       * @name $sce#parseAsUrl
       *
       * @description
       * Shorthand method.  `$sce.parseAsUrl(value)` →
       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
       *
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */

      /**
       * @ngdoc method
       * @name $sce#parseAsResourceUrl
       *
       * @description
       * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
       *
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */

      /**
       * @ngdoc method
       * @name $sce#parseAsJs
       *
       * @description
       * Shorthand method.  `$sce.parseAsJs(value)` →
       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
       *
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */

      // Shorthand delegations.
      var parse = sce.parseAs,
          getTrusted = sce.getTrusted,
          trustAs = sce.trustAs;

      forEach(SCE_CONTEXTS, function (enumValue, name) {
        var lName = lowercase(name);
        sce[snakeToCamel('parse_as_' + lName)] = function (expr) {
          return parse(enumValue, expr);
        };
        sce[snakeToCamel('get_trusted_' + lName)] = function (value) {
          return getTrusted(enumValue, value);
        };
        sce[snakeToCamel('trust_as_' + lName)] = function (value) {
          return trustAs(enumValue, value);
        };
      });

      return sce;
    }];
  }

  /* exported $SnifferProvider */

  /**
   * !!! This is an undocumented "private" service !!!
   *
   * @name $sniffer
   * @requires $window
   * @requires $document
   * @this
   *
   * @property {boolean} history Does the browser support html5 history api ?
   * @property {boolean} transitions Does the browser support CSS transition events ?
   * @property {boolean} animations Does the browser support CSS animation events ?
   *
   * @description
   * This is very simple implementation of testing browser's features.
   */
  function $SnifferProvider() {
    this.$get = ['$window', '$document', function ($window, $document) {
      var eventSupport = {},

      // Chrome Packaged Apps are not allowed to access `history.pushState`.
      // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
      // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
      // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
      // (see https://developer.chrome.com/apps/manifest/sandbox).
      // (NW.js apps have access to Chrome APIs, but do support `history`.)
      isNw = $window.nw && $window.nw.process,
          isChromePackagedApp = !isNw && $window.chrome && ($window.chrome.app && $window.chrome.app.runtime || !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
          hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
          android = toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
          boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
          document = $document[0] || {},
          bodyStyle = document.body && document.body.style,
          transitions = false,
          animations = false;

      if (bodyStyle) {
        // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
        // Mentioned browsers need a -webkit- prefix for transitions & animations.
        transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
        animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
      }

      return {
        // Android has history.pushState, but it does not update location correctly
        // so let's not use the history API at all.
        // http://code.google.com/p/android/issues/detail?id=17471
        // https://github.com/angular/angular.js/issues/904

        // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
        // so let's not use the history API also
        // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
        history: !!(hasHistoryPushState && !(android < 4) && !boxee),
        hasEvent: function hasEvent(event) {
          // Support: IE 9-11 only
          // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
          // it. In particular the event is not fired when backspace or delete key are pressed or
          // when cut operation is performed.
          // IE10+ implements 'input' event but it erroneously fires under various situations,
          // e.g. when placeholder changes, or a form is focused.
          if (event === 'input' && msie) return false;

          if (isUndefined(eventSupport[event])) {
            var divElm = document.createElement('div');
            eventSupport[event] = 'on' + event in divElm;
          }

          return eventSupport[event];
        },
        csp: csp(),
        transitions: transitions,
        animations: animations,
        android: android
      };
    }];
  }

  var $templateRequestMinErr = minErr('$compile');

  /**
   * @ngdoc provider
   * @name $templateRequestProvider
   * @this
   *
   * @description
   * Used to configure the options passed to the {@link $http} service when making a template request.
   *
   * For example, it can be used for specifying the "Accept" header that is sent to the server, when
   * requesting a template.
   */
  function $TemplateRequestProvider() {

    var httpOptions;

    /**
     * @ngdoc method
     * @name $templateRequestProvider#httpOptions
     * @description
     * The options to be passed to the {@link $http} service when making the request.
     * You can use this to override options such as the "Accept" header for template requests.
     *
     * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
     * options if not overridden here.
     *
     * @param {string=} value new value for the {@link $http} options.
     * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
     */
    this.httpOptions = function (val) {
      if (val) {
        httpOptions = val;
        return this;
      }
      return httpOptions;
    };

    /**
     * @ngdoc service
     * @name $templateRequest
     *
     * @description
     * The `$templateRequest` service runs security checks then downloads the provided template using
     * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
     * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
     * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
     * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
     * when `tpl` is of type string and `$templateCache` has the matching entry.
     *
     * If you want to pass custom options to the `$http` service, such as setting the Accept header you
     * can configure this via {@link $templateRequestProvider#httpOptions}.
     *
     * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
     * as {@link ngInclude} to download and cache templates.
     *
     * 3rd party modules should use `$templateRequest` if their services or directives are loading
     * templates.
     *
     * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
     * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
     *
     * @return {Promise} a promise for the HTTP response data of the given URL.
     *
     * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
     */
    this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce', function ($exceptionHandler, $templateCache, $http, $q, $sce) {

      function handleRequestFn(tpl, ignoreRequestError) {
        handleRequestFn.totalPendingRequests++;

        // We consider the template cache holds only trusted templates, so
        // there's no need to go through whitelisting again for keys that already
        // are included in there. This also makes AngularJS accept any script
        // directive, no matter its name. However, we still need to unwrap trusted
        // types.
        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
          tpl = $sce.getTrustedResourceUrl(tpl);
        }

        var transformResponse = $http.defaults && $http.defaults.transformResponse;

        if (isArray(transformResponse)) {
          transformResponse = transformResponse.filter(function (transformer) {
            return transformer !== defaultHttpResponseTransform;
          });
        } else if (transformResponse === defaultHttpResponseTransform) {
          transformResponse = null;
        }

        return $http.get(tpl, extend({
          cache: $templateCache,
          transformResponse: transformResponse
        }, httpOptions)).finally(function () {
          handleRequestFn.totalPendingRequests--;
        }).then(function (response) {
          $templateCache.put(tpl, response.data);
          return response.data;
        }, handleError);

        function handleError(resp) {
          if (!ignoreRequestError) {
            resp = $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})', tpl, resp.status, resp.statusText);

            $exceptionHandler(resp);
          }

          return $q.reject(resp);
        }
      }

      handleRequestFn.totalPendingRequests = 0;

      return handleRequestFn;
    }];
  }

  /** @this */
  function $$TestabilityProvider() {
    this.$get = ['$rootScope', '$browser', '$location', function ($rootScope, $browser, $location) {

      /**
       * @name $testability
       *
       * @description
       * The private $$testability service provides a collection of methods for use when debugging
       * or by automated test and debugging tools.
       */
      var testability = {};

      /**
       * @name $$testability#findBindings
       *
       * @description
       * Returns an array of elements that are bound (via ng-bind or {{}})
       * to expressions matching the input.
       *
       * @param {Element} element The element root to search from.
       * @param {string} expression The binding expression to match.
       * @param {boolean} opt_exactMatch If true, only returns exact matches
       *     for the expression. Filters and whitespace are ignored.
       */
      testability.findBindings = function (element, expression, opt_exactMatch) {
        var bindings = element.getElementsByClassName('ng-binding');
        var matches = [];
        forEach(bindings, function (binding) {
          var dataBinding = angular.element(binding).data('$binding');
          if (dataBinding) {
            forEach(dataBinding, function (bindingName) {
              if (opt_exactMatch) {
                var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
                if (matcher.test(bindingName)) {
                  matches.push(binding);
                }
              } else {
                if (bindingName.indexOf(expression) !== -1) {
                  matches.push(binding);
                }
              }
            });
          }
        });
        return matches;
      };

      /**
       * @name $$testability#findModels
       *
       * @description
       * Returns an array of elements that are two-way found via ng-model to
       * expressions matching the input.
       *
       * @param {Element} element The element root to search from.
       * @param {string} expression The model expression to match.
       * @param {boolean} opt_exactMatch If true, only returns exact matches
       *     for the expression.
       */
      testability.findModels = function (element, expression, opt_exactMatch) {
        var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
        for (var p = 0; p < prefixes.length; ++p) {
          var attributeEquals = opt_exactMatch ? '=' : '*=';
          var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
          var elements = element.querySelectorAll(selector);
          if (elements.length) {
            return elements;
          }
        }
      };

      /**
       * @name $$testability#getLocation
       *
       * @description
       * Shortcut for getting the location in a browser agnostic way. Returns
       *     the path, search, and hash. (e.g. /path?a=b#hash)
       */
      testability.getLocation = function () {
        return $location.url();
      };

      /**
       * @name $$testability#setLocation
       *
       * @description
       * Shortcut for navigating to a location without doing a full page reload.
       *
       * @param {string} url The location url (path, search and hash,
       *     e.g. /path?a=b#hash) to go to.
       */
      testability.setLocation = function (url) {
        if (url !== $location.url()) {
          $location.url(url);
          $rootScope.$digest();
        }
      };

      /**
       * @name $$testability#whenStable
       *
       * @description
       * Calls the callback when $timeout and $http requests are completed.
       *
       * @param {function} callback
       */
      testability.whenStable = function (callback) {
        $browser.notifyWhenNoOutstandingRequests(callback);
      };

      return testability;
    }];
  }

  /** @this */
  function $TimeoutProvider() {
    this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler', function ($rootScope, $browser, $q, $$q, $exceptionHandler) {

      var deferreds = {};

      /**
       * @ngdoc service
       * @name $timeout
       *
       * @description
       * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
       * block and delegates any exceptions to
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * The return value of calling `$timeout` is a promise, which will be resolved when
       * the delay has passed and the timeout function, if provided, is executed.
       *
       * To cancel a timeout request, call `$timeout.cancel(promise)`.
       *
       * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
       * synchronously flush the queue of deferred functions.
       *
       * If you only want a promise that will be resolved after some specified delay
       * then you can call `$timeout` without the `fn` function.
       *
       * @param {function()=} fn A function, whose execution should be delayed.
       * @param {number=} [delay=0] Delay in milliseconds.
       * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
       *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
       * @param {...*=} Pass additional parameters to the executed function.
       * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
       *   will be resolved with the return value of the `fn` function.
       *
       */
      function timeout(fn, delay, invokeApply) {
        if (!isFunction(fn)) {
          invokeApply = delay;
          delay = fn;
          fn = noop;
        }

        var args = sliceArgs(arguments, 3),
            skipApply = isDefined(invokeApply) && !invokeApply,
            deferred = (skipApply ? $$q : $q).defer(),
            promise = deferred.promise,
            timeoutId;

        timeoutId = $browser.defer(function () {
          try {
            deferred.resolve(fn.apply(null, args));
          } catch (e) {
            deferred.reject(e);
            $exceptionHandler(e);
          } finally {
            delete deferreds[promise.$$timeoutId];
          }

          if (!skipApply) $rootScope.$apply();
        }, delay);

        promise.$$timeoutId = timeoutId;
        deferreds[timeoutId] = deferred;

        return promise;
      }

      /**
       * @ngdoc method
       * @name $timeout#cancel
       *
       * @description
       * Cancels a task associated with the `promise`. As a result of this, the promise will be
       * resolved with a rejection.
       *
       * @param {Promise=} promise Promise returned by the `$timeout` function.
       * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
       *   canceled.
       */
      timeout.cancel = function (promise) {
        if (promise && promise.$$timeoutId in deferreds) {
          // Timeout cancels should not report an unhandled promise.
          markQExceptionHandled(deferreds[promise.$$timeoutId].promise);
          deferreds[promise.$$timeoutId].reject('canceled');
          delete deferreds[promise.$$timeoutId];
          return $browser.defer.cancel(promise.$$timeoutId);
        }
        return false;
      };

      return timeout;
    }];
  }

  // NOTE:  The usage of window and document instead of $window and $document here is
  // deliberate.  This service depends on the specific behavior of anchor nodes created by the
  // browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
  // cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
  // doesn't know about mocked locations and resolves URLs to the real document - which is
  // exactly the behavior needed here.  There is little value is mocking these out for this
  // service.
  var urlParsingNode = window.document.createElement('a');
  var originUrl = urlResolve(window.location.href);

  /**
   *
   * Implementation Notes for non-IE browsers
   * ----------------------------------------
   * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
   * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
   * URL will be resolved into an absolute URL in the context of the application document.
   * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
   * properties are all populated to reflect the normalized URL.  This approach has wide
   * compatibility - Safari 1+, Mozilla 1+ etc.  See
   * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
   *
   * Implementation Notes for IE
   * ---------------------------
   * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
   * browsers.  However, the parsed components will not be set if the URL assigned did not specify
   * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
   * work around that by performing the parsing in a 2nd step by taking a previously normalized
   * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
   * properties such as protocol, hostname, port, etc.
   *
   * References:
   *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
   *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
   *   http://url.spec.whatwg.org/#urlutils
   *   https://github.com/angular/angular.js/pull/2902
   *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
   *
   * @kind function
   * @param {string} url The URL to be parsed.
   * @description Normalizes and parses a URL.
   * @returns {object} Returns the normalized URL as a dictionary.
   *
   *   | member name   | Description    |
   *   |---------------|----------------|
   *   | href          | A normalized version of the provided URL if it was not an absolute URL |
   *   | protocol      | The protocol including the trailing colon                              |
   *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
   *   | search        | The search params, minus the question mark                             |
   *   | hash          | The hash string, minus the hash symbol
   *   | hostname      | The hostname
   *   | port          | The port, without ":"
   *   | pathname      | The pathname, beginning with "/"
   *
   */
  function urlResolve(url) {
    var href = url;

    // Support: IE 9-11 only
    if (msie) {
      // Normalize before parse.  Refer Implementation Notes on why this is
      // done in two steps on IE.
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  /**
   * Parse a request URL and determine whether this is a same-origin request as the application document.
   *
   * @param {string|object} requestUrl The url of the request as a string that will be resolved
   * or a parsed URL object.
   * @returns {boolean} Whether the request is for the same origin as the application document.
   */
  function urlIsSameOrigin(requestUrl) {
    var parsed = isString(requestUrl) ? urlResolve(requestUrl) : requestUrl;
    return parsed.protocol === originUrl.protocol && parsed.host === originUrl.host;
  }

  /**
   * @ngdoc service
   * @name $window
   * @this
   *
   * @description
   * A reference to the browser's `window` object. While `window`
   * is globally available in JavaScript, it causes testability problems, because
   * it is a global variable. In AngularJS we always refer to it through the
   * `$window` service, so it may be overridden, removed or mocked for testing.
   *
   * Expressions, like the one defined for the `ngClick` directive in the example
   * below, are evaluated with respect to the current scope.  Therefore, there is
   * no risk of inadvertently coding in a dependency on a global value in such an
   * expression.
   *
   * @example
     <example module="windowExample" name="window-service">
       <file name="index.html">
         <script>
           angular.module('windowExample', [])
             .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
               $scope.greeting = 'Hello, World!';
               $scope.doGreeting = function(greeting) {
                 $window.alert(greeting);
               };
             }]);
         </script>
         <div ng-controller="ExampleController">
           <input type="text" ng-model="greeting" aria-label="greeting" />
           <button ng-click="doGreeting(greeting)">ALERT</button>
         </div>
       </file>
       <file name="protractor.js" type="protractor">
        it('should display the greeting in the input box', function() {
         element(by.model('greeting')).sendKeys('Hello, E2E Tests');
         // If we click the button it will block the test runner
         // element(':button').click();
        });
       </file>
     </example>
   */
  function $WindowProvider() {
    this.$get = valueFn(window);
  }

  /**
   * @name $$cookieReader
   * @requires $document
   *
   * @description
   * This is a private service for reading cookies used by $http and ngCookies
   *
   * @return {Object} a key/value map of the current cookies
   */
  function $$CookieReader($document) {
    var rawDocument = $document[0] || {};
    var lastCookies = {};
    var lastCookieString = '';

    function safeGetCookie(rawDocument) {
      try {
        return rawDocument.cookie || '';
      } catch (e) {
        return '';
      }
    }

    function safeDecodeURIComponent(str) {
      try {
        return decodeURIComponent(str);
      } catch (e) {
        return str;
      }
    }

    return function () {
      var cookieArray, cookie, i, index, name;
      var currentCookieString = safeGetCookie(rawDocument);

      if (currentCookieString !== lastCookieString) {
        lastCookieString = currentCookieString;
        cookieArray = lastCookieString.split('; ');
        lastCookies = {};

        for (i = 0; i < cookieArray.length; i++) {
          cookie = cookieArray[i];
          index = cookie.indexOf('=');
          if (index > 0) {
            //ignore nameless cookies
            name = safeDecodeURIComponent(cookie.substring(0, index));
            // the first value that is seen for a cookie is the most
            // specific one.  values for the same cookie name that
            // follow are for less specific paths.
            if (isUndefined(lastCookies[name])) {
              lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
            }
          }
        }
      }
      return lastCookies;
    };
  }

  $$CookieReader.$inject = ['$document'];

  /** @this */
  function $$CookieReaderProvider() {
    this.$get = $$CookieReader;
  }

  /* global currencyFilter: true,
   dateFilter: true,
   filterFilter: true,
   jsonFilter: true,
   limitToFilter: true,
   lowercaseFilter: true,
   numberFilter: true,
   orderByFilter: true,
   uppercaseFilter: true,
   */

  /**
   * @ngdoc provider
   * @name $filterProvider
   * @description
   *
   * Filters are just functions which transform input to an output. However filters need to be
   * Dependency Injected. To achieve this a filter definition consists of a factory function which is
   * annotated with dependencies and is responsible for creating a filter function.
   *
   * <div class="alert alert-warning">
   * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
   * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   * (`myapp_subsection_filterx`).
   * </div>
   *
   * ```js
   *   // Filter registration
   *   function MyModule($provide, $filterProvider) {
   *     // create a service to demonstrate injection (not always needed)
   *     $provide.value('greet', function(name){
   *       return 'Hello ' + name + '!';
   *     });
   *
   *     // register a filter factory which uses the
   *     // greet service to demonstrate DI.
   *     $filterProvider.register('greet', function(greet){
   *       // return the filter function which uses the greet service
   *       // to generate salutation
   *       return function(text) {
   *         // filters need to be forgiving so check input validity
   *         return text && greet(text) || text;
   *       };
   *     });
   *   }
   * ```
   *
   * The filter function is registered with the `$injector` under the filter name suffix with
   * `Filter`.
   *
   * ```js
   *   it('should be the same instance', inject(
   *     function($filterProvider) {
   *       $filterProvider.register('reverse', function(){
   *         return ...;
   *       });
   *     },
   *     function($filter, reverseFilter) {
   *       expect($filter('reverse')).toBe(reverseFilter);
   *     });
   * ```
   *
   *
   * For more information about how AngularJS filters work, and how to create your own filters, see
   * {@link guide/filter Filters} in the AngularJS Developer Guide.
   */

  /**
   * @ngdoc service
   * @name $filter
   * @kind function
   * @description
   * Filters are used for formatting data displayed to the user.
   *
   * They can be used in view templates, controllers or services. AngularJS comes
   * with a collection of [built-in filters](api/ng/filter), but it is easy to
   * define your own as well.
   *
   * The general syntax in templates is as follows:
   *
   * ```html
   * {{ expression [| filter_name[:parameter_value] ... ] }}
   * ```
   *
   * @param {String} name Name of the filter function to retrieve
   * @return {Function} the filter function
   * @example
     <example name="$filter" module="filterExample">
       <file name="index.html">
         <div ng-controller="MainCtrl">
          <h3>{{ originalText }}</h3>
          <h3>{{ filteredText }}</h3>
         </div>
       </file>
  
       <file name="script.js">
        angular.module('filterExample', [])
        .controller('MainCtrl', function($scope, $filter) {
          $scope.originalText = 'hello';
          $scope.filteredText = $filter('uppercase')($scope.originalText);
        });
       </file>
     </example>
    */
  $FilterProvider.$inject = ['$provide'];
  /** @this */
  function $FilterProvider($provide) {
    var suffix = 'Filter';

    /**
     * @ngdoc method
     * @name $filterProvider#register
     * @param {string|Object} name Name of the filter function, or an object map of filters where
     *    the keys are the filter names and the values are the filter factories.
     *
     *    <div class="alert alert-warning">
     *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
     *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
     *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
     *    (`myapp_subsection_filterx`).
     *    </div>
      * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
     * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
     *    of the registered filter instances.
     */
    function register(name, factory) {
      if (isObject(name)) {
        var filters = {};
        forEach(name, function (filter, key) {
          filters[key] = register(key, filter);
        });
        return filters;
      } else {
        return $provide.factory(name + suffix, factory);
      }
    }
    this.register = register;

    this.$get = ['$injector', function ($injector) {
      return function (name) {
        return $injector.get(name + suffix);
      };
    }];

    ////////////////////////////////////////

    /* global
      currencyFilter: false,
      dateFilter: false,
      filterFilter: false,
      jsonFilter: false,
      limitToFilter: false,
      lowercaseFilter: false,
      numberFilter: false,
      orderByFilter: false,
      uppercaseFilter: false
    */

    register('currency', currencyFilter);
    register('date', dateFilter);
    register('filter', filterFilter);
    register('json', jsonFilter);
    register('limitTo', limitToFilter);
    register('lowercase', lowercaseFilter);
    register('number', numberFilter);
    register('orderBy', orderByFilter);
    register('uppercase', uppercaseFilter);
  }

  /**
   * @ngdoc filter
   * @name filter
   * @kind function
   *
   * @description
   * Selects a subset of items from `array` and returns it as a new array.
   *
   * @param {Array} array The source array.
   * <div class="alert alert-info">
   *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
   * </div>
   * @param {string|Object|function()} expression The predicate to be used for selecting items from
   *   `array`.
   *
   *   Can be one of:
   *
   *   - `string`: The string is used for matching against the contents of the `array`. All strings or
   *     objects with string properties in `array` that match this string will be returned. This also
   *     applies to nested object properties.
   *     The predicate can be negated by prefixing the string with `!`.
   *
   *   - `Object`: A pattern object can be used to filter specific properties on objects contained
   *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
   *     which have property `name` containing "M" and property `phone` containing "1". A special
   *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
   *     against any property of the object or its nested object properties. That's equivalent to the
   *     simple substring match with a `string` as described above. The special property name can be
   *     overwritten, using the `anyPropertyKey` parameter.
   *     The predicate can be negated by prefixing the string with `!`.
   *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
   *     not containing "M".
   *
   *     Note that a named property will match properties on the same level only, while the special
   *     `$` property will match properties on the same level or deeper. E.g. an array item like
   *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
   *     **will** be matched by `{$: 'John'}`.
   *
   *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
   *     The function is called for each element of the array, with the element, its index, and
   *     the entire array itself as arguments.
   *
   *     The final result is an array of those elements that the predicate returned true for.
   *
   * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
   *     determining if values retrieved using `expression` (when it is not a function) should be
   *     considered a match based on the expected value (from the filter expression) and actual
   *     value (from the object in the array).
   *
   *   Can be one of:
   *
   *   - `function(actual, expected)`:
   *     The function will be given the object value and the predicate value to compare and
   *     should return true if both values should be considered equal.
   *
   *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
   *     This is essentially strict comparison of expected and actual.
   *
   *   - `false`: A short hand for a function which will look for a substring match in a case
   *     insensitive way. Primitive values are converted to strings. Objects are not compared against
   *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
   *
   *
   *   Defaults to `false`.
   *
   * @param {string} [anyPropertyKey] The special property name that matches against any property.
   *     By default `$`.
   *
   * @example
     <example name="filter-filter">
       <file name="index.html">
         <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                  {name:'Mary', phone:'800-BIG-MARY'},
                                  {name:'Mike', phone:'555-4321'},
                                  {name:'Adam', phone:'555-5678'},
                                  {name:'Julie', phone:'555-8765'},
                                  {name:'Juliette', phone:'555-5678'}]"></div>
  
         <label>Search: <input ng-model="searchText"></label>
         <table id="searchTextResults">
           <tr><th>Name</th><th>Phone</th></tr>
           <tr ng-repeat="friend in friends | filter:searchText">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
           </tr>
         </table>
         <hr>
         <label>Any: <input ng-model="search.$"></label> <br>
         <label>Name only <input ng-model="search.name"></label><br>
         <label>Phone only <input ng-model="search.phone"></label><br>
         <label>Equality <input type="checkbox" ng-model="strict"></label><br>
         <table id="searchObjResults">
           <tr><th>Name</th><th>Phone</th></tr>
           <tr ng-repeat="friendObj in friends | filter:search:strict">
             <td>{{friendObj.name}}</td>
             <td>{{friendObj.phone}}</td>
           </tr>
         </table>
       </file>
       <file name="protractor.js" type="protractor">
         var expectFriendNames = function(expectedNames, key) {
           element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
             arr.forEach(function(wd, i) {
               expect(wd.getText()).toMatch(expectedNames[i]);
             });
           });
         };
  
         it('should search across all fields when filtering with a string', function() {
           var searchText = element(by.model('searchText'));
           searchText.clear();
           searchText.sendKeys('m');
           expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
  
           searchText.clear();
           searchText.sendKeys('76');
           expectFriendNames(['John', 'Julie'], 'friend');
         });
  
         it('should search in specific fields when filtering with a predicate object', function() {
           var searchAny = element(by.model('search.$'));
           searchAny.clear();
           searchAny.sendKeys('i');
           expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
         });
         it('should use a equal comparison when comparator is true', function() {
           var searchName = element(by.model('search.name'));
           var strict = element(by.model('strict'));
           searchName.clear();
           searchName.sendKeys('Julie');
           strict.click();
           expectFriendNames(['Julie'], 'friendObj');
         });
       </file>
     </example>
   */

  function filterFilter() {
    return function (array, expression, comparator, anyPropertyKey) {
      if (!isArrayLike(array)) {
        if (array == null) {
          return array;
        } else {
          throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
        }
      }

      anyPropertyKey = anyPropertyKey || '$';
      var expressionType = getTypeForFilter(expression);
      var predicateFn;
      var matchAgainstAnyProp;

      switch (expressionType) {
        case 'function':
          predicateFn = expression;
          break;
        case 'boolean':
        case 'null':
        case 'number':
        case 'string':
          matchAgainstAnyProp = true;
        // falls through
        case 'object':
          predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
          break;
        default:
          return array;
      }

      return Array.prototype.filter.call(array, predicateFn);
    };
  }

  // Helper functions for `filterFilter`
  function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
    var shouldMatchPrimitives = isObject(expression) && anyPropertyKey in expression;
    var predicateFn;

    if (comparator === true) {
      comparator = equals;
    } else if (!isFunction(comparator)) {
      comparator = function comparator(actual, expected) {
        if (isUndefined(actual)) {
          // No substring matching against `undefined`
          return false;
        }
        if (actual === null || expected === null) {
          // No substring matching against `null`; only match against `null`
          return actual === expected;
        }
        if (isObject(expected) || isObject(actual) && !hasCustomToString(actual)) {
          // Should not compare primitives against objects, unless they have custom `toString` method
          return false;
        }

        actual = lowercase('' + actual);
        expected = lowercase('' + expected);
        return actual.indexOf(expected) !== -1;
      };
    }

    predicateFn = function predicateFn(item) {
      if (shouldMatchPrimitives && !isObject(item)) {
        return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
      }
      return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
    };

    return predicateFn;
  }

  function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
    var actualType = getTypeForFilter(actual);
    var expectedType = getTypeForFilter(expected);

    if (expectedType === 'string' && expected.charAt(0) === '!') {
      return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
    } else if (isArray(actual)) {
      // In case `actual` is an array, consider it a match
      // if ANY of it's items matches `expected`
      return actual.some(function (item) {
        return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
      });
    }

    switch (actualType) {
      case 'object':
        var key;
        if (matchAgainstAnyProp) {
          for (key in actual) {
            // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
            // See: https://github.com/angular/angular.js/issues/15644
            if (key.charAt && key.charAt(0) !== '$' && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
              return true;
            }
          }
          return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
        } else if (expectedType === 'object') {
          for (key in expected) {
            var expectedVal = expected[key];
            if (isFunction(expectedVal) || isUndefined(expectedVal)) {
              continue;
            }

            var matchAnyProperty = key === anyPropertyKey;
            var actualVal = matchAnyProperty ? actual : actual[key];
            if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
              return false;
            }
          }
          return true;
        } else {
          return comparator(actual, expected);
        }
      case 'function':
        return false;
      default:
        return comparator(actual, expected);
    }
  }

  // Used for easily differentiating between `null` and actual `object`
  function getTypeForFilter(val) {
    return val === null ? 'null' : typeof val === 'undefined' ? 'undefined' : _typeof(val);
  }

  var MAX_DIGITS = 22;
  var DECIMAL_SEP = '.';
  var ZERO_CHAR = '0';

  /**
   * @ngdoc filter
   * @name currency
   * @kind function
   *
   * @description
   * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
   * symbol for current locale is used.
   *
   * @param {number} amount Input to filter.
   * @param {string=} symbol Currency symbol or identifier to be displayed.
   * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
   * @returns {string} Formatted number.
   *
   *
   * @example
     <example module="currencyExample" name="currency-filter">
       <file name="index.html">
         <script>
           angular.module('currencyExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.amount = 1234.56;
             }]);
         </script>
         <div ng-controller="ExampleController">
           <input type="number" ng-model="amount" aria-label="amount"> <br>
           default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
           custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
           no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
         </div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should init with 1234.56', function() {
           expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
           expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
           expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
         });
         it('should update', function() {
           if (browser.params.browser === 'safari') {
             // Safari does not understand the minus key. See
             // https://github.com/angular/protractor/issues/481
             return;
           }
           element(by.model('amount')).clear();
           element(by.model('amount')).sendKeys('-1234');
           expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
           expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
           expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
         });
       </file>
     </example>
   */
  currencyFilter.$inject = ['$locale'];
  function currencyFilter($locale) {
    var formats = $locale.NUMBER_FORMATS;
    return function (amount, currencySymbol, fractionSize) {
      if (isUndefined(currencySymbol)) {
        currencySymbol = formats.CURRENCY_SYM;
      }

      if (isUndefined(fractionSize)) {
        fractionSize = formats.PATTERNS[1].maxFrac;
      }

      // If the currency symbol is empty, trim whitespace around the symbol
      var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;

      // if null or undefined pass it through
      return amount == null ? amount : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).replace(currencySymbolRe, currencySymbol);
    };
  }

  /**
   * @ngdoc filter
   * @name number
   * @kind function
   *
   * @description
   * Formats a number as text.
   *
   * If the input is null or undefined, it will just be returned.
   * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
   * If the input is not a number an empty string is returned.
   *
   *
   * @param {number|string} number Number to format.
   * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
   * If this is not provided then the fraction size is computed from the current locale's number
   * formatting pattern. In the case of the default locale, it will be 3.
   * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
   *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
   *                   include "," group separators after each third digit).
   *
   * @example
     <example module="numberFilterExample" name="number-filter">
       <file name="index.html">
         <script>
           angular.module('numberFilterExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.val = 1234.56789;
             }]);
         </script>
         <div ng-controller="ExampleController">
           <label>Enter number: <input ng-model='val'></label><br>
           Default formatting: <span id='number-default'>{{val | number}}</span><br>
           No fractions: <span>{{val | number:0}}</span><br>
           Negative number: <span>{{-val | number:4}}</span>
         </div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should format numbers', function() {
           expect(element(by.id('number-default')).getText()).toBe('1,234.568');
           expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
           expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
         });
  
         it('should update', function() {
           element(by.model('val')).clear();
           element(by.model('val')).sendKeys('3374.333');
           expect(element(by.id('number-default')).getText()).toBe('3,374.333');
           expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
           expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
        });
       </file>
     </example>
   */
  numberFilter.$inject = ['$locale'];
  function numberFilter($locale) {
    var formats = $locale.NUMBER_FORMATS;
    return function (number, fractionSize) {

      // if null or undefined pass it through
      return number == null ? number : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize);
    };
  }

  /**
   * Parse a number (as a string) into three components that can be used
   * for formatting the number.
   *
   * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
   *
   * @param  {string} numStr The number to parse
   * @return {object} An object describing this number, containing the following keys:
   *  - d : an array of digits containing leading zeros as necessary
   *  - i : the number of the digits in `d` that are to the left of the decimal point
   *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
   *
   */
  function parse(numStr) {
    var exponent = 0,
        digits,
        numberOfIntegerDigits;
    var i, j, zeros;

    // Decimal point?
    if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
      numStr = numStr.replace(DECIMAL_SEP, '');
    }

    // Exponential form?
    if ((i = numStr.search(/e/i)) > 0) {
      // Work out the exponent.
      if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
      numberOfIntegerDigits += +numStr.slice(i + 1);
      numStr = numStr.substring(0, i);
    } else if (numberOfIntegerDigits < 0) {
      // There was no decimal point or exponent so it is an integer.
      numberOfIntegerDigits = numStr.length;
    }

    // Count the number of leading zeros.
    for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) {/* empty */}

    if (i === (zeros = numStr.length)) {
      // The digits are all zero.
      digits = [0];
      numberOfIntegerDigits = 1;
    } else {
      // Count the number of trailing zeros
      zeros--;
      while (numStr.charAt(zeros) === ZERO_CHAR) {
        zeros--;
      } // Trailing zeros are insignificant so ignore them
      numberOfIntegerDigits -= i;
      digits = [];
      // Convert string to array of digits without leading/trailing zeros.
      for (j = 0; i <= zeros; i++, j++) {
        digits[j] = +numStr.charAt(i);
      }
    }

    // If the number overflows the maximum allowed digits then use an exponent.
    if (numberOfIntegerDigits > MAX_DIGITS) {
      digits = digits.splice(0, MAX_DIGITS - 1);
      exponent = numberOfIntegerDigits - 1;
      numberOfIntegerDigits = 1;
    }

    return { d: digits, e: exponent, i: numberOfIntegerDigits };
  }

  /**
   * Round the parsed number to the specified number of decimal places
   * This function changed the parsedNumber in-place
   */
  function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = isUndefined(fractionSize) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];

    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) {
        digits[i] = 0;
      }
    }

    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) {
      digits.push(0);
    } // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function (carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
  }

  /**
   * Format a number into a string
   * @param  {number} number       The number to format
   * @param  {{
   *           minFrac, // the minimum number of digits required in the fraction part of the number
   *           maxFrac, // the maximum number of digits required in the fraction part of the number
   *           gSize,   // number of digits in each group of separated digits
   *           lgSize,  // number of digits in the last group of digits before the decimal separator
   *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
   *           posPre,  // the string to go in front of a positive number
   *           negSuf,  // the string to go after a negative number (e.g. `)`)
   *           posSuf   // the string to go after a positive number
   *         }} pattern
   * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
   * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
   * @param  {[type]} fractionSize The size of the fractional part of the number
   * @return {string}              The number formatted as a string
   */
  function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {

    if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';

    var isInfinity = !isFinite(number);
    var isZero = false;
    var numStr = Math.abs(number) + '',
        formattedText = '',
        parsedNumber;

    if (isInfinity) {
      formattedText = '\u221E';
    } else {
      parsedNumber = parse(numStr);

      roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);

      var digits = parsedNumber.d;
      var integerLen = parsedNumber.i;
      var exponent = parsedNumber.e;
      var decimals = [];
      isZero = digits.reduce(function (isZero, d) {
        return isZero && !d;
      }, true);

      // pad zeros for small numbers
      while (integerLen < 0) {
        digits.unshift(0);
        integerLen++;
      }

      // extract decimals digits
      if (integerLen > 0) {
        decimals = digits.splice(integerLen, digits.length);
      } else {
        decimals = digits;
        digits = [0];
      }

      // format the integer digits with grouping separators
      var groups = [];
      if (digits.length >= pattern.lgSize) {
        groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
      }
      while (digits.length > pattern.gSize) {
        groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
      }
      if (digits.length) {
        groups.unshift(digits.join(''));
      }
      formattedText = groups.join(groupSep);

      // append the decimal digits
      if (decimals.length) {
        formattedText += decimalSep + decimals.join('');
      }

      if (exponent) {
        formattedText += 'e+' + exponent;
      }
    }
    if (number < 0 && !isZero) {
      return pattern.negPre + formattedText + pattern.negSuf;
    } else {
      return pattern.posPre + formattedText + pattern.posSuf;
    }
  }

  function padNumber(num, digits, trim, negWrap) {
    var neg = '';
    if (num < 0 || negWrap && num <= 0) {
      if (negWrap) {
        num = -num + 1;
      } else {
        num = -num;
        neg = '-';
      }
    }
    num = '' + num;
    while (num.length < digits) {
      num = ZERO_CHAR + num;
    }if (trim) {
      num = num.substr(num.length - digits);
    }
    return neg + num;
  }

  function dateGetter(name, size, offset, trim, negWrap) {
    offset = offset || 0;
    return function (date) {
      var value = date['get' + name]();
      if (offset > 0 || value > -offset) {
        value += offset;
      }
      if (value === 0 && offset === -12) value = 12;
      return padNumber(value, size, trim, negWrap);
    };
  }

  function dateStrGetter(name, shortForm, standAlone) {
    return function (date, formats) {
      var value = date['get' + name]();
      var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
      var get = uppercase(propPrefix + name);

      return formats[get][value];
    };
  }

  function timeZoneGetter(date, formats, offset) {
    var zone = -1 * offset;
    var paddedZone = zone >= 0 ? '+' : '';

    paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) + padNumber(Math.abs(zone % 60), 2);

    return paddedZone;
  }

  function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = new Date(year, 0, 1).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, (dayOfWeekOnFirst <= 4 ? 5 : 12) - dayOfWeekOnFirst);
  }

  function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
    // 4 = index of Thursday
    datetime.getDate() + (4 - datetime.getDay()));
  }

  function weekGetter(size) {
    return function (date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
          thisThurs = getThursdayThisWeek(date);

      var diff = +thisThurs - +firstThurs,
          result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
    };
  }

  function ampmGetter(date, formats) {
    return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
  }

  function eraGetter(date, formats) {
    return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
  }

  function longEraGetter(date, formats) {
    return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
  }

  var DATE_FORMATS = {
    yyyy: dateGetter('FullYear', 4, 0, false, true),
    yy: dateGetter('FullYear', 2, 0, true, true),
    y: dateGetter('FullYear', 1, 0, false, true),
    MMMM: dateStrGetter('Month'),
    MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
    M: dateGetter('Month', 1, 1),
    LLLL: dateStrGetter('Month', false, true),
    dd: dateGetter('Date', 2),
    d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
    H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
    h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
    m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
    s: dateGetter('Seconds', 1),
    // while ISO 8601 requires fractions to be prefixed with `.` or `,`
    // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
    sss: dateGetter('Milliseconds', 3),
    EEEE: dateStrGetter('Day'),
    EEE: dateStrGetter('Day', true),
    a: ampmGetter,
    Z: timeZoneGetter,
    ww: weekGetter(2),
    w: weekGetter(1),
    G: eraGetter,
    GG: eraGetter,
    GGG: eraGetter,
    GGGG: longEraGetter
  };

  var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
      NUMBER_STRING = /^-?\d+$/;

  /**
   * @ngdoc filter
   * @name date
   * @kind function
   *
   * @description
   *   Formats `date` to a string based on the requested `format`.
   *
   *   `format` string can be composed of the following elements:
   *
   *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
   *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
   *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
   *   * `'MMMM'`: Month in year (January-December)
   *   * `'MMM'`: Month in year (Jan-Dec)
   *   * `'MM'`: Month in year, padded (01-12)
   *   * `'M'`: Month in year (1-12)
   *   * `'LLLL'`: Stand-alone month in year (January-December)
   *   * `'dd'`: Day in month, padded (01-31)
   *   * `'d'`: Day in month (1-31)
   *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
   *   * `'EEE'`: Day in Week, (Sun-Sat)
   *   * `'HH'`: Hour in day, padded (00-23)
   *   * `'H'`: Hour in day (0-23)
   *   * `'hh'`: Hour in AM/PM, padded (01-12)
   *   * `'h'`: Hour in AM/PM, (1-12)
   *   * `'mm'`: Minute in hour, padded (00-59)
   *   * `'m'`: Minute in hour (0-59)
   *   * `'ss'`: Second in minute, padded (00-59)
   *   * `'s'`: Second in minute (0-59)
   *   * `'sss'`: Millisecond in second, padded (000-999)
   *   * `'a'`: AM/PM marker
   *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
   *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
   *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
   *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
   *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
   *
   *   `format` string can also be one of the following predefined
   *   {@link guide/i18n localizable formats}:
   *
   *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
   *     (e.g. Sep 3, 2010 12:05:08 PM)
   *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
   *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
   *     (e.g. Friday, September 3, 2010)
   *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
   *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
   *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
   *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
   *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
   *
   *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
   *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
   *   (e.g. `"h 'o''clock'"`).
   *
   *   Any other characters in the `format` string will be output as-is.
   *
   * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
   *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
   *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
   *    specified in the string input, the time is considered to be in the local timezone.
   * @param {string=} format Formatting rules (see Description). If not specified,
   *    `mediumDate` is used.
   * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
   *    continental US time zone abbreviations, but for general use, use a time zone offset, for
   *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
   *    If not specified, the timezone of the browser will be used.
   * @returns {string} Formatted string or the input if input is not recognized as date/millis.
   *
   * @example
     <example name="filter-date">
       <file name="index.html">
         <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
             <span>{{1288323623006 | date:'medium'}}</span><br>
         <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
            <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
         <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
            <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
         <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
            <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
       </file>
       <file name="protractor.js" type="protractor">
         it('should format date', function() {
           expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
              toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
           expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
              toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
           expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
              toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
           expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
              toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
         });
       </file>
     </example>
   */
  dateFilter.$inject = ['$locale'];
  function dateFilter($locale) {

    var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
    // 1        2       3         4          5          6          7          8  9     10      11
    function jsonStringToDate(string) {
      var match;
      if (match = string.match(R_ISO8601_STR)) {
        var date = new Date(0),
            tzHour = 0,
            tzMin = 0,
            dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
            timeSetter = match[8] ? date.setUTCHours : date.setHours;

        if (match[9]) {
          tzHour = toInt(match[9] + match[10]);
          tzMin = toInt(match[9] + match[11]);
        }
        dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
        var h = toInt(match[4] || 0) - tzHour;
        var m = toInt(match[5] || 0) - tzMin;
        var s = toInt(match[6] || 0);
        var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
        timeSetter.call(date, h, m, s, ms);
        return date;
      }
      return string;
    }

    return function (date, format, timezone) {
      var text = '',
          parts = [],
          fn,
          match;

      format = format || 'mediumDate';
      format = $locale.DATETIME_FORMATS[format] || format;
      if (isString(date)) {
        date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
      }

      if (isNumber(date)) {
        date = new Date(date);
      }

      if (!isDate(date) || !isFinite(date.getTime())) {
        return date;
      }

      while (format) {
        match = DATE_FORMATS_SPLIT.exec(format);
        if (match) {
          parts = concat(parts, match, 1);
          format = parts.pop();
        } else {
          parts.push(format);
          format = null;
        }
      }

      var dateTimezoneOffset = date.getTimezoneOffset();
      if (timezone) {
        dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
        date = convertTimezoneToLocal(date, timezone, true);
      }
      forEach(parts, function (value) {
        fn = DATE_FORMATS[value];
        text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset) : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
      });

      return text;
    };
  }

  /**
   * @ngdoc filter
   * @name json
   * @kind function
   *
   * @description
   *   Allows you to convert a JavaScript object into JSON string.
   *
   *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
   *   the binding is automatically converted to JSON.
   *
   * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
   * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
   * @returns {string} JSON string.
   *
   *
   * @example
     <example name="filter-json">
       <file name="index.html">
         <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
         <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
       </file>
       <file name="protractor.js" type="protractor">
         it('should jsonify filtered objects', function() {
           expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
           expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
         });
       </file>
     </example>
   *
   */
  function jsonFilter() {
    return function (object, spacing) {
      if (isUndefined(spacing)) {
        spacing = 2;
      }
      return toJson(object, spacing);
    };
  }

  /**
   * @ngdoc filter
   * @name lowercase
   * @kind function
   * @description
   * Converts string to lowercase.
   *
   * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
   *
   * @see angular.lowercase
   */
  var lowercaseFilter = valueFn(lowercase);

  /**
   * @ngdoc filter
   * @name uppercase
   * @kind function
   * @description
   * Converts string to uppercase.
   * @example
     <example module="uppercaseFilterExample" name="filter-uppercase">
       <file name="index.html">
         <script>
           angular.module('uppercaseFilterExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.title = 'This is a title';
             }]);
         </script>
         <div ng-controller="ExampleController">
           <!-- This title should be formatted normally -->
           <h1>{{title}}</h1>
           <!-- This title should be capitalized -->
           <h1>{{title | uppercase}}</h1>
         </div>
       </file>
     </example>
   */
  var uppercaseFilter = valueFn(uppercase);

  /**
   * @ngdoc filter
   * @name limitTo
   * @kind function
   *
   * @description
   * Creates a new array or string containing only a specified number of elements. The elements are
   * taken from either the beginning or the end of the source array, string or number, as specified by
   * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
   * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
   * it is converted to a string.
   *
   * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
   * @param {string|number} limit - The length of the returned array or string. If the `limit` number
   *     is positive, `limit` number of items from the beginning of the source array/string are copied.
   *     If the number is negative, `limit` number  of items from the end of the source array/string
   *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
   *     the input will be returned unchanged.
   * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
   *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
   * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
   *     less than `limit` elements.
   *
   * @example
     <example module="limitToExample" name="limit-to-filter">
       <file name="index.html">
         <script>
           angular.module('limitToExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.numbers = [1,2,3,4,5,6,7,8,9];
               $scope.letters = "abcdefghi";
               $scope.longNumber = 2345432342;
               $scope.numLimit = 3;
               $scope.letterLimit = 3;
               $scope.longNumberLimit = 3;
             }]);
         </script>
         <div ng-controller="ExampleController">
           <label>
              Limit {{numbers}} to:
              <input type="number" step="1" ng-model="numLimit">
           </label>
           <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
           <label>
              Limit {{letters}} to:
              <input type="number" step="1" ng-model="letterLimit">
           </label>
           <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
           <label>
              Limit {{longNumber}} to:
              <input type="number" step="1" ng-model="longNumberLimit">
           </label>
           <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
         </div>
       </file>
       <file name="protractor.js" type="protractor">
         var numLimitInput = element(by.model('numLimit'));
         var letterLimitInput = element(by.model('letterLimit'));
         var longNumberLimitInput = element(by.model('longNumberLimit'));
         var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
         var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
         var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
  
         it('should limit the number array to first three items', function() {
           expect(numLimitInput.getAttribute('value')).toBe('3');
           expect(letterLimitInput.getAttribute('value')).toBe('3');
           expect(longNumberLimitInput.getAttribute('value')).toBe('3');
           expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
           expect(limitedLetters.getText()).toEqual('Output letters: abc');
           expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
         });
  
         // There is a bug in safari and protractor that doesn't like the minus key
         // it('should update the output when -3 is entered', function() {
         //   numLimitInput.clear();
         //   numLimitInput.sendKeys('-3');
         //   letterLimitInput.clear();
         //   letterLimitInput.sendKeys('-3');
         //   longNumberLimitInput.clear();
         //   longNumberLimitInput.sendKeys('-3');
         //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
         //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
         //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
         // });
  
         it('should not exceed the maximum size of input array', function() {
           numLimitInput.clear();
           numLimitInput.sendKeys('100');
           letterLimitInput.clear();
           letterLimitInput.sendKeys('100');
           longNumberLimitInput.clear();
           longNumberLimitInput.sendKeys('100');
           expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
           expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
           expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
         });
       </file>
     </example>
  */
  function limitToFilter() {
    return function (input, limit, begin) {
      if (Math.abs(Number(limit)) === Infinity) {
        limit = Number(limit);
      } else {
        limit = toInt(limit);
      }
      if (isNumberNaN(limit)) return input;

      if (isNumber(input)) input = input.toString();
      if (!isArrayLike(input)) return input;

      begin = !begin || isNaN(begin) ? 0 : toInt(begin);
      begin = begin < 0 ? Math.max(0, input.length + begin) : begin;

      if (limit >= 0) {
        return sliceFn(input, begin, begin + limit);
      } else {
        if (begin === 0) {
          return sliceFn(input, limit, input.length);
        } else {
          return sliceFn(input, Math.max(0, begin + limit), begin);
        }
      }
    };
  }

  function sliceFn(input, begin, end) {
    if (isString(input)) return input.slice(begin, end);

    return slice.call(input, begin, end);
  }

  /**
   * @ngdoc filter
   * @name orderBy
   * @kind function
   *
   * @description
   * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
   * function based on the values computed using the `expression` predicate.
   *
   * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
   * `[{id: 'bar'}, {id: 'foo'}]`.
   *
   * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
   * String, etc).
   *
   * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
   * for the preceding one. The `expression` is evaluated against each item and the output is used
   * for comparing with other items.
   *
   * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
   * ascending order.
   *
   * The comparison is done using the `comparator` function. If none is specified, a default, built-in
   * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
   * strings alphabetically).
   *
   * ### Under the hood
   *
   * Ordering the specified `collection` happens in two phases:
   *
   * 1. All items are passed through the predicate (or predicates), and the returned values are saved
   *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
   *    through a predicate that extracts the value of the `label` property, would be transformed to:
   *    ```
   *    {
   *      value: 'foo',
   *      type: 'string',
   *      index: ...
   *    }
   *    ```
   * 2. The comparator function is used to sort the items, based on the derived values, types and
   *    indices.
   *
   * If you use a custom comparator, it will be called with pairs of objects of the form
   * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
   * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
   * second, or `1` otherwise.
   *
   * In order to ensure that the sorting will be deterministic across platforms, if none of the
   * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
   * dummy predicate that returns the item's index as `value`.
   * (If you are using a custom comparator, make sure it can handle this predicate as well.)
   *
   * If a custom comparator still can't distinguish between two items, then they will be sorted based
   * on their index using the built-in comparator.
   *
   * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
   * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
   * it to the comparator. The following rules govern the conversion:
   *
   * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
   *    used instead.<br />
   *    (If the object has a `valueOf()` method that returns another object, then the returned object
   *    will be used in subsequent steps.)
   * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
   *    returns a primitive, its return value will be used instead.<br />
   *    (If the object has a `toString()` method that returns another object, then the returned object
   *    will be used in subsequent steps.)
   * 3. No conversion; the object itself is used.
   *
   * ### The default comparator
   *
   * The default, built-in comparator should be sufficient for most usecases. In short, it compares
   * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
   * using their index in the original collection, and sorts values of different types by type.
   *
   * More specifically, it follows these steps to determine the relative order of items:
   *
   * 1. If the compared values are of different types, compare the types themselves alphabetically.
   * 2. If both values are of type `string`, compare them alphabetically in a case- and
   *    locale-insensitive way.
   * 3. If both values are objects, compare their indices instead.
   * 4. Otherwise, return:
   *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
   *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
   *    -  `1`, otherwise.
   *
   * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
   *           saved as numbers and not strings.
   * **Note:** For the purpose of sorting, `null` values are treated as the string `'null'` (i.e.
   *           `type: 'string'`, `value: 'null'`). This may cause unexpected sort order relative to
   *           other values.
   *
   * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
   * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
   *    predicates) to be used by the comparator to determine the order of elements.
   *
   *    Can be one of:
   *
   *    - `Function`: A getter function. This function will be called with each item as argument and
   *      the return value will be used for sorting.
   *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
   *      result will be used for sorting. For example, use `'label'` to sort by a property called
   *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
   *      property.<br />
   *      (The result of a constant expression is interpreted as a property name to be used for
   *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
   *      property called `special name`.)<br />
   *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
   *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
   *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
   *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
   *      relative order of two items, the next predicate is used as a tie-breaker.
   *
   * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
   *
   * @param {boolean=} reverse - If `true`, reverse the sorting order.
   * @param {(Function)=} comparator - The comparator function used to determine the relative order of
   *    value pairs. If omitted, the built-in comparator will be used.
   *
   * @returns {Array} - The sorted array.
   *
   *
   * @example
   * ### Ordering a table with `ngRepeat`
   *
   * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
   * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
   * it defaults to the built-in comparator.
   *
     <example name="orderBy-static" module="orderByExample1">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Phone Number</th>
               <th>Age</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'-age'">
               <td>{{friend.name}}</td>
               <td>{{friend.phone}}</td>
               <td>{{friend.age}}</td>
             </tr>
           </table>
         </div>
       </file>
       <file name="script.js">
         angular.module('orderByExample1', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.friends = [
               {name: 'John',   phone: '555-1212',  age: 10},
               {name: 'Mary',   phone: '555-9876',  age: 19},
               {name: 'Mike',   phone: '555-4321',  age: 21},
               {name: 'Adam',   phone: '555-5678',  age: 35},
               {name: 'Julie',  phone: '555-8765',  age: 29}
             ];
           }]);
       </file>
       <file name="style.css">
         .friends {
           border-collapse: collapse;
         }
  
         .friends th {
           border-bottom: 1px solid;
         }
         .friends td, .friends th {
           border-left: 1px solid;
           padding: 5px 10px;
         }
         .friends td:first-child, .friends th:first-child {
           border-left: none;
         }
       </file>
       <file name="protractor.js" type="protractor">
         // Element locators
         var names = element.all(by.repeater('friends').column('friend.name'));
  
         it('should sort friends by age in reverse order', function() {
           expect(names.get(0).getText()).toBe('Adam');
           expect(names.get(1).getText()).toBe('Julie');
           expect(names.get(2).getText()).toBe('Mike');
           expect(names.get(3).getText()).toBe('Mary');
           expect(names.get(4).getText()).toBe('John');
         });
       </file>
     </example>
   * <hr />
   *
   * @example
   * ### Changing parameters dynamically
   *
   * All parameters can be changed dynamically. The next example shows how you can make the columns of
   * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
   *
     <example name="orderBy-dynamic" module="orderByExample2">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
           <hr/>
           <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
           <hr/>
           <table class="friends">
             <tr>
               <th>
                 <button ng-click="sortBy('name')">Name</button>
                 <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
               </th>
               <th>
                 <button ng-click="sortBy('phone')">Phone Number</button>
                 <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
               </th>
               <th>
                 <button ng-click="sortBy('age')">Age</button>
                 <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
               </th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
               <td>{{friend.name}}</td>
               <td>{{friend.phone}}</td>
               <td>{{friend.age}}</td>
             </tr>
           </table>
         </div>
       </file>
       <file name="script.js">
         angular.module('orderByExample2', [])
           .controller('ExampleController', ['$scope', function($scope) {
             var friends = [
               {name: 'John',   phone: '555-1212',  age: 10},
               {name: 'Mary',   phone: '555-9876',  age: 19},
               {name: 'Mike',   phone: '555-4321',  age: 21},
               {name: 'Adam',   phone: '555-5678',  age: 35},
               {name: 'Julie',  phone: '555-8765',  age: 29}
             ];
  
             $scope.propertyName = 'age';
             $scope.reverse = true;
             $scope.friends = friends;
  
             $scope.sortBy = function(propertyName) {
               $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
               $scope.propertyName = propertyName;
             };
           }]);
       </file>
       <file name="style.css">
         .friends {
           border-collapse: collapse;
         }
  
         .friends th {
           border-bottom: 1px solid;
         }
         .friends td, .friends th {
           border-left: 1px solid;
           padding: 5px 10px;
         }
         .friends td:first-child, .friends th:first-child {
           border-left: none;
         }
  
         .sortorder:after {
           content: '\25b2';   // BLACK UP-POINTING TRIANGLE
         }
         .sortorder.reverse:after {
           content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
         }
       </file>
       <file name="protractor.js" type="protractor">
         // Element locators
         var unsortButton = element(by.partialButtonText('unsorted'));
         var nameHeader = element(by.partialButtonText('Name'));
         var phoneHeader = element(by.partialButtonText('Phone'));
         var ageHeader = element(by.partialButtonText('Age'));
         var firstName = element(by.repeater('friends').column('friend.name').row(0));
         var lastName = element(by.repeater('friends').column('friend.name').row(4));
  
         it('should sort friends by some property, when clicking on the column header', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           phoneHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Mary');
  
           nameHeader.click();
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('Mike');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Adam');
         });
  
         it('should sort friends in reverse order, when clicking on the same column', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Adam');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
         });
  
         it('should restore the original order, when clicking "Set to unsorted"', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           unsortButton.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Julie');
         });
       </file>
     </example>
   * <hr />
   *
   * @example
   * ### Using `orderBy` inside a controller
   *
   * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
   * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
   * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
   *
     <example name="orderBy-call-manually" module="orderByExample3">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
           <hr/>
           <button ng-click="sortBy(null)">Set to unsorted</button>
           <hr/>
           <table class="friends">
             <tr>
               <th>
                 <button ng-click="sortBy('name')">Name</button>
                 <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
               </th>
               <th>
                 <button ng-click="sortBy('phone')">Phone Number</button>
                 <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
               </th>
               <th>
                 <button ng-click="sortBy('age')">Age</button>
                 <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
               </th>
             </tr>
             <tr ng-repeat="friend in friends">
               <td>{{friend.name}}</td>
               <td>{{friend.phone}}</td>
               <td>{{friend.age}}</td>
             </tr>
           </table>
         </div>
       </file>
       <file name="script.js">
         angular.module('orderByExample3', [])
           .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
             var friends = [
               {name: 'John',   phone: '555-1212',  age: 10},
               {name: 'Mary',   phone: '555-9876',  age: 19},
               {name: 'Mike',   phone: '555-4321',  age: 21},
               {name: 'Adam',   phone: '555-5678',  age: 35},
               {name: 'Julie',  phone: '555-8765',  age: 29}
             ];
  
             $scope.propertyName = 'age';
             $scope.reverse = true;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
  
             $scope.sortBy = function(propertyName) {
               $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                   ? !$scope.reverse : false;
               $scope.propertyName = propertyName;
               $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
             };
           }]);
       </file>
       <file name="style.css">
         .friends {
           border-collapse: collapse;
         }
  
         .friends th {
           border-bottom: 1px solid;
         }
         .friends td, .friends th {
           border-left: 1px solid;
           padding: 5px 10px;
         }
         .friends td:first-child, .friends th:first-child {
           border-left: none;
         }
  
         .sortorder:after {
           content: '\25b2';   // BLACK UP-POINTING TRIANGLE
         }
         .sortorder.reverse:after {
           content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
         }
       </file>
       <file name="protractor.js" type="protractor">
         // Element locators
         var unsortButton = element(by.partialButtonText('unsorted'));
         var nameHeader = element(by.partialButtonText('Name'));
         var phoneHeader = element(by.partialButtonText('Phone'));
         var ageHeader = element(by.partialButtonText('Age'));
         var firstName = element(by.repeater('friends').column('friend.name').row(0));
         var lastName = element(by.repeater('friends').column('friend.name').row(4));
  
         it('should sort friends by some property, when clicking on the column header', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           phoneHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Mary');
  
           nameHeader.click();
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('Mike');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Adam');
         });
  
         it('should sort friends in reverse order, when clicking on the same column', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Adam');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
         });
  
         it('should restore the original order, when clicking "Set to unsorted"', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           unsortButton.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Julie');
         });
       </file>
     </example>
   * <hr />
   *
   * @example
   * ### Using a custom comparator
   *
   * If you have very specific requirements about the way items are sorted, you can pass your own
   * comparator function. For example, you might need to compare some strings in a locale-sensitive
   * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
   * argument - passing `false` retains the default sorting order, i.e. ascending.)
   *
     <example name="orderBy-custom-comparator" module="orderByExample4">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <div class="friends-container custom-comparator">
             <h3>Locale-sensitive Comparator</h3>
             <table class="friends">
               <tr>
                 <th>Name</th>
                 <th>Favorite Letter</th>
               </tr>
               <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
                 <td>{{friend.name}}</td>
                 <td>{{friend.favoriteLetter}}</td>
               </tr>
             </table>
           </div>
           <div class="friends-container default-comparator">
             <h3>Default Comparator</h3>
             <table class="friends">
               <tr>
                 <th>Name</th>
                 <th>Favorite Letter</th>
               </tr>
               <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
                 <td>{{friend.name}}</td>
                 <td>{{friend.favoriteLetter}}</td>
               </tr>
             </table>
           </div>
         </div>
       </file>
       <file name="script.js">
         angular.module('orderByExample4', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.friends = [
               {name: 'John',   favoriteLetter: 'Ä'},
               {name: 'Mary',   favoriteLetter: 'Ü'},
               {name: 'Mike',   favoriteLetter: 'Ö'},
               {name: 'Adam',   favoriteLetter: 'H'},
               {name: 'Julie',  favoriteLetter: 'Z'}
             ];
  
             $scope.localeSensitiveComparator = function(v1, v2) {
               // If we don't get strings, just compare by index
               if (v1.type !== 'string' || v2.type !== 'string') {
                 return (v1.index < v2.index) ? -1 : 1;
               }
  
               // Compare strings alphabetically, taking locale into account
               return v1.value.localeCompare(v2.value);
             };
           }]);
       </file>
       <file name="style.css">
         .friends-container {
           display: inline-block;
           margin: 0 30px;
         }
  
         .friends {
           border-collapse: collapse;
         }
  
         .friends th {
           border-bottom: 1px solid;
         }
         .friends td, .friends th {
           border-left: 1px solid;
           padding: 5px 10px;
         }
         .friends td:first-child, .friends th:first-child {
           border-left: none;
         }
       </file>
       <file name="protractor.js" type="protractor">
         // Element locators
         var container = element(by.css('.custom-comparator'));
         var names = container.all(by.repeater('friends').column('friend.name'));
  
         it('should sort friends by favorite letter (in correct alphabetical order)', function() {
           expect(names.get(0).getText()).toBe('John');
           expect(names.get(1).getText()).toBe('Adam');
           expect(names.get(2).getText()).toBe('Mike');
           expect(names.get(3).getText()).toBe('Mary');
           expect(names.get(4).getText()).toBe('Julie');
         });
       </file>
     </example>
   *
   */
  orderByFilter.$inject = ['$parse'];
  function orderByFilter($parse) {
    return function (array, sortPredicate, reverseOrder, compareFn) {

      if (array == null) return array;
      if (!isArrayLike(array)) {
        throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
      }

      if (!isArray(sortPredicate)) {
        sortPredicate = [sortPredicate];
      }
      if (sortPredicate.length === 0) {
        sortPredicate = ['+'];
      }

      var predicates = processPredicates(sortPredicate);

      var descending = reverseOrder ? -1 : 1;

      // Define the `compare()` function. Use a default comparator if none is specified.
      var compare = isFunction(compareFn) ? compareFn : defaultCompare;

      // The next three lines are a version of a Swartzian Transform idiom from Perl
      // (sometimes called the Decorate-Sort-Undecorate idiom)
      // See https://en.wikipedia.org/wiki/Schwartzian_transform
      var compareValues = Array.prototype.map.call(array, getComparisonObject);
      compareValues.sort(doComparison);
      array = compareValues.map(function (item) {
        return item.value;
      });

      return array;

      function getComparisonObject(value, index) {
        // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
        // This will be used to keep the sort stable when none of the input predicates can
        // distinguish between two elements.
        return {
          value: value,
          tieBreaker: { value: index, type: 'number', index: index },
          predicateValues: predicates.map(function (predicate) {
            return getPredicateValue(predicate.get(value), index);
          })
        };
      }

      function doComparison(v1, v2) {
        for (var i = 0, ii = predicates.length; i < ii; i++) {
          var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
          if (result) {
            return result * predicates[i].descending * descending;
          }
        }

        return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
      }
    };

    function processPredicates(sortPredicates) {
      return sortPredicates.map(function (predicate) {
        var descending = 1,
            get = identity;

        if (isFunction(predicate)) {
          get = predicate;
        } else if (isString(predicate)) {
          if (predicate.charAt(0) === '+' || predicate.charAt(0) === '-') {
            descending = predicate.charAt(0) === '-' ? -1 : 1;
            predicate = predicate.substring(1);
          }
          if (predicate !== '') {
            get = $parse(predicate);
            if (get.constant) {
              var key = get();
              get = function get(value) {
                return value[key];
              };
            }
          }
        }
        return { get: get, descending: descending };
      });
    }

    function isPrimitive(value) {
      switch (typeof value === 'undefined' ? 'undefined' : _typeof(value)) {
        case 'number': /* falls through */
        case 'boolean': /* falls through */
        case 'string':
          return true;
        default:
          return false;
      }
    }

    function objectValue(value) {
      // If `valueOf` is a valid function use that
      if (isFunction(value.valueOf)) {
        value = value.valueOf();
        if (isPrimitive(value)) return value;
      }
      // If `toString` is a valid function and not the one from `Object.prototype` use that
      if (hasCustomToString(value)) {
        value = value.toString();
        if (isPrimitive(value)) return value;
      }

      return value;
    }

    function getPredicateValue(value, index) {
      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
      if (value === null) {
        type = 'string';
        value = 'null';
      } else if (type === 'object') {
        value = objectValue(value);
      }
      return { value: value, type: type, index: index };
    }

    function defaultCompare(v1, v2) {
      var result = 0;
      var type1 = v1.type;
      var type2 = v2.type;

      if (type1 === type2) {
        var value1 = v1.value;
        var value2 = v2.value;

        if (type1 === 'string') {
          // Compare strings case-insensitively
          value1 = value1.toLowerCase();
          value2 = value2.toLowerCase();
        } else if (type1 === 'object') {
          // For basic objects, use the position of the object
          // in the collection instead of the value
          if (isObject(value1)) value1 = v1.index;
          if (isObject(value2)) value2 = v2.index;
        }

        if (value1 !== value2) {
          result = value1 < value2 ? -1 : 1;
        }
      } else {
        result = type1 < type2 ? -1 : 1;
      }

      return result;
    }
  }

  function ngDirective(directive) {
    if (isFunction(directive)) {
      directive = {
        link: directive
      };
    }
    directive.restrict = directive.restrict || 'AC';
    return valueFn(directive);
  }

  /**
   * @ngdoc directive
   * @name a
   * @restrict E
   *
   * @description
   * Modifies the default behavior of the html a tag so that the default action is prevented when
   * the href attribute is empty.
   *
   * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
   */
  var htmlAnchorDirective = valueFn({
    restrict: 'E',
    compile: function compile(element, attr) {
      if (!attr.href && !attr.xlinkHref) {
        return function (scope, element) {
          // If the linked element is not an anchor tag anymore, do nothing
          if (element[0].nodeName.toLowerCase() !== 'a') return;

          // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
          var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ? 'xlink:href' : 'href';
          element.on('click', function (event) {
            // if we have no href url, then don't navigate anywhere.
            if (!element.attr(href)) {
              event.preventDefault();
            }
          });
        };
      }
    }
  });

  /**
   * @ngdoc directive
   * @name ngHref
   * @restrict A
   * @priority 99
   *
   * @description
   * Using AngularJS markup like `{{hash}}` in an href attribute will
   * make the link go to the wrong URL if the user clicks it before
   * AngularJS has a chance to replace the `{{hash}}` markup with its
   * value. Until AngularJS replaces the markup the link will be broken
   * and will most likely return a 404 error. The `ngHref` directive
   * solves this problem.
   *
   * The wrong way to write it:
   * ```html
   * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
   * ```
   *
   * The correct way to write it:
   * ```html
   * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
   * ```
   *
   * @element A
   * @param {template} ngHref any string which can contain `{{}}` markup.
   *
   * @example
   * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
   * in links and their different behaviors:
      <example name="ng-href">
        <file name="index.html">
          <input ng-model="value" /><br />
          <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
          <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
          <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
          <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
          <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
          <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
        </file>
        <file name="protractor.js" type="protractor">
          it('should execute ng-click but not reload when href without value', function() {
            element(by.id('link-1')).click();
            expect(element(by.model('value')).getAttribute('value')).toEqual('1');
            expect(element(by.id('link-1')).getAttribute('href')).toBe('');
          });
  
          it('should execute ng-click but not reload when href empty string', function() {
            element(by.id('link-2')).click();
            expect(element(by.model('value')).getAttribute('value')).toEqual('2');
            expect(element(by.id('link-2')).getAttribute('href')).toBe('');
          });
  
          it('should execute ng-click and change url when ng-href specified', function() {
            expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
  
            element(by.id('link-3')).click();
  
            // At this point, we navigate away from an AngularJS page, so we need
            // to use browser.driver to get the base webdriver.
  
            browser.wait(function() {
              return browser.driver.getCurrentUrl().then(function(url) {
                return url.match(/\/123$/);
              });
            }, 5000, 'page should navigate to /123');
          });
  
          it('should execute ng-click but not reload when href empty string and name specified', function() {
            element(by.id('link-4')).click();
            expect(element(by.model('value')).getAttribute('value')).toEqual('4');
            expect(element(by.id('link-4')).getAttribute('href')).toBe('');
          });
  
          it('should execute ng-click but not reload when no href but name specified', function() {
            element(by.id('link-5')).click();
            expect(element(by.model('value')).getAttribute('value')).toEqual('5');
            expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
          });
  
          it('should only change url when only ng-href', function() {
            element(by.model('value')).clear();
            element(by.model('value')).sendKeys('6');
            expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
  
            element(by.id('link-6')).click();
  
            // At this point, we navigate away from an AngularJS page, so we need
            // to use browser.driver to get the base webdriver.
            browser.wait(function() {
              return browser.driver.getCurrentUrl().then(function(url) {
                return url.match(/\/6$/);
              });
            }, 5000, 'page should navigate to /6');
          });
        </file>
      </example>
   */

  /**
   * @ngdoc directive
   * @name ngSrc
   * @restrict A
   * @priority 99
   *
   * @description
   * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
   * work right: The browser will fetch from the URL with the literal
   * text `{{hash}}` until AngularJS replaces the expression inside
   * `{{hash}}`. The `ngSrc` directive solves this problem.
   *
   * The buggy way to write it:
   * ```html
   * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
   * ```
   *
   * The correct way to write it:
   * ```html
   * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
   * ```
   *
   * @element IMG
   * @param {template} ngSrc any string which can contain `{{}}` markup.
   */

  /**
   * @ngdoc directive
   * @name ngSrcset
   * @restrict A
   * @priority 99
   *
   * @description
   * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
   * work right: The browser will fetch from the URL with the literal
   * text `{{hash}}` until AngularJS replaces the expression inside
   * `{{hash}}`. The `ngSrcset` directive solves this problem.
   *
   * The buggy way to write it:
   * ```html
   * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
   * ```
   *
   * The correct way to write it:
   * ```html
   * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
   * ```
   *
   * @element IMG
   * @param {template} ngSrcset any string which can contain `{{}}` markup.
   */

  /**
   * @ngdoc directive
   * @name ngDisabled
   * @restrict A
   * @priority 100
   *
   * @description
   *
   * This directive sets the `disabled` attribute on the element (typically a form control,
   * e.g. `input`, `button`, `select` etc.) if the
   * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
   *
   * A special directive is necessary because we cannot use interpolation inside the `disabled`
   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
   *
   * @example
      <example name="ng-disabled">
        <file name="index.html">
          <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
          <button ng-model="button" ng-disabled="checked">Button</button>
        </file>
        <file name="protractor.js" type="protractor">
          it('should toggle button', function() {
            expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
            element(by.model('checked')).click();
            expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
          });
        </file>
      </example>
   *
   * @element INPUT
   * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
   *     then the `disabled` attribute will be set on the element
   */

  /**
   * @ngdoc directive
   * @name ngChecked
   * @restrict A
   * @priority 100
   *
   * @description
   * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
   *
   * Note that this directive should not be used together with {@link ngModel `ngModel`},
   * as this can lead to unexpected behavior.
   *
   * A special directive is necessary because we cannot use interpolation inside the `checked`
   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
   *
   * @example
      <example name="ng-checked">
        <file name="index.html">
          <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
          <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
        </file>
        <file name="protractor.js" type="protractor">
          it('should check both checkBoxes', function() {
            expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
            element(by.model('leader')).click();
            expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
          });
        </file>
      </example>
   *
   * @element INPUT
   * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
   *     then the `checked` attribute will be set on the element
   */

  /**
   * @ngdoc directive
   * @name ngReadonly
   * @restrict A
   * @priority 100
   *
   * @description
   *
   * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
   * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
   * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
   *
   * A special directive is necessary because we cannot use interpolation inside the `readonly`
   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
   *
   * @example
      <example name="ng-readonly">
        <file name="index.html">
          <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
          <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
        </file>
        <file name="protractor.js" type="protractor">
          it('should toggle readonly attr', function() {
            expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
            element(by.model('checked')).click();
            expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
          });
        </file>
      </example>
   *
   * @element INPUT
   * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
   *     then special attribute "readonly" will be set on the element
   */

  /**
   * @ngdoc directive
   * @name ngSelected
   * @restrict A
   * @priority 100
   *
   * @description
   *
   * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
   *
   * A special directive is necessary because we cannot use interpolation inside the `selected`
   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
   *
   * <div class="alert alert-warning">
   *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
   *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
   *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
   *   selected options.
   * </div>
   *
   * @example
      <example name="ng-selected">
        <file name="index.html">
          <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
          <select aria-label="ngSelected demo">
            <option>Hello!</option>
            <option id="greet" ng-selected="selected">Greetings!</option>
          </select>
        </file>
        <file name="protractor.js" type="protractor">
          it('should select Greetings!', function() {
            expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
            element(by.model('selected')).click();
            expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
          });
        </file>
      </example>
   *
   * @element OPTION
   * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
   *     then special attribute "selected" will be set on the element
   */

  /**
   * @ngdoc directive
   * @name ngOpen
   * @restrict A
   * @priority 100
   *
   * @description
   *
   * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
   *
   * A special directive is necessary because we cannot use interpolation inside the `open`
   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
   *
   * ## A note about browser compatibility
   *
   * Internet Explorer and Edge do not support the `details` element, it is
   * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
   *
   * @example
       <example name="ng-open">
         <file name="index.html">
           <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
           <details id="details" ng-open="open">
              <summary>List</summary>
              <ul>
                <li>Apple</li>
                <li>Orange</li>
                <li>Durian</li>
              </ul>
           </details>
         </file>
         <file name="protractor.js" type="protractor">
           it('should toggle open', function() {
             expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
             element(by.model('open')).click();
             expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
           });
         </file>
       </example>
   *
   * @element DETAILS
   * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
   *     then special attribute "open" will be set on the element
   */

  var ngAttributeAliasDirectives = {};

  // boolean attrs are evaluated
  forEach(BOOLEAN_ATTR, function (propName, attrName) {
    // binding to multiple is not supported
    if (propName === 'multiple') return;

    function defaultLinkFn(scope, element, attr) {
      scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
        attr.$set(attrName, !!value);
      });
    }

    var normalized = directiveNormalize('ng-' + attrName);
    var linkFn = defaultLinkFn;

    if (propName === 'checked') {
      linkFn = function linkFn(scope, element, attr) {
        // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
        if (attr.ngModel !== attr[normalized]) {
          defaultLinkFn(scope, element, attr);
        }
      };
    }

    ngAttributeAliasDirectives[normalized] = function () {
      return {
        restrict: 'A',
        priority: 100,
        link: linkFn
      };
    };
  });

  // aliased input attrs are evaluated
  forEach(ALIASED_ATTR, function (htmlAttr, ngAttr) {
    ngAttributeAliasDirectives[ngAttr] = function () {
      return {
        priority: 100,
        link: function link(scope, element, attr) {
          //special case ngPattern when a literal regular expression value
          //is used as the expression (this way we don't have to watch anything).
          if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
            var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
            if (match) {
              attr.$set('ngPattern', new RegExp(match[1], match[2]));
              return;
            }
          }

          scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
            attr.$set(ngAttr, value);
          });
        }
      };
    };
  });

  // ng-src, ng-srcset, ng-href are interpolated
  forEach(['src', 'srcset', 'href'], function (attrName) {
    var normalized = directiveNormalize('ng-' + attrName);
    ngAttributeAliasDirectives[normalized] = function () {
      return {
        priority: 99, // it needs to run after the attributes are interpolated
        link: function link(scope, element, attr) {
          var propName = attrName,
              name = attrName;

          if (attrName === 'href' && toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
            name = 'xlinkHref';
            attr.$attr[name] = 'xlink:href';
            propName = null;
          }

          attr.$observe(normalized, function (value) {
            if (!value) {
              if (attrName === 'href') {
                attr.$set(name, null);
              }
              return;
            }

            attr.$set(name, value);

            // Support: IE 9-11 only
            // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
            // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
            // to set the property as well to achieve the desired effect.
            // We use attr[attrName] value since $set can sanitize the url.
            if (msie && propName) element.prop(propName, attr[name]);
          });
        }
      };
    };
  });

  /* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
   */
  var nullFormCtrl = {
    $addControl: noop,
    $$renameControl: nullFormRenameControl,
    $removeControl: noop,
    $setValidity: noop,
    $setDirty: noop,
    $setPristine: noop,
    $setSubmitted: noop
  },
      PENDING_CLASS = 'ng-pending',
      SUBMITTED_CLASS = 'ng-submitted';

  function nullFormRenameControl(control, name) {
    control.$name = name;
  }

  /**
   * @ngdoc type
   * @name form.FormController
   *
   * @property {boolean} $pristine True if user has not interacted with the form yet.
   * @property {boolean} $dirty True if user has already interacted with the form.
   * @property {boolean} $valid True if all of the containing forms and controls are valid.
   * @property {boolean} $invalid True if at least one containing control or form is invalid.
   * @property {boolean} $submitted True if user has submitted the form even if its invalid.
   *
   * @property {Object} $pending An object hash, containing references to controls or forms with
   *  pending validators, where:
   *
   *  - keys are validations tokens (error names).
   *  - values are arrays of controls or forms that have a pending validator for the given error name.
   *
   * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
   *
   * @property {Object} $error An object hash, containing references to controls or forms with failing
   *  validators, where:
   *
   *  - keys are validation tokens (error names),
   *  - values are arrays of controls or forms that have a failing validator for the given error name.
   *
   *  Built-in validation tokens:
   *  - `email`
   *  - `max`
   *  - `maxlength`
   *  - `min`
   *  - `minlength`
   *  - `number`
   *  - `pattern`
   *  - `required`
   *  - `url`
   *  - `date`
   *  - `datetimelocal`
   *  - `time`
   *  - `week`
   *  - `month`
   *
   * @description
   * `FormController` keeps track of all its controls and nested forms as well as the state of them,
   * such as being valid/invalid or dirty/pristine.
   *
   * Each {@link ng.directive:form form} directive creates an instance
   * of `FormController`.
   *
   */
  //asks for $scope to fool the BC controller module
  FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
  function FormController($element, $attrs, $scope, $animate, $interpolate) {
    this.$$controls = [];

    // init state
    this.$error = {};
    this.$$success = {};
    this.$pending = undefined;
    this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
    this.$dirty = false;
    this.$pristine = true;
    this.$valid = true;
    this.$invalid = false;
    this.$submitted = false;
    this.$$parentForm = nullFormCtrl;

    this.$$element = $element;
    this.$$animate = $animate;

    setupValidity(this);
  }

  FormController.prototype = {
    /**
     * @ngdoc method
     * @name form.FormController#$rollbackViewValue
     *
     * @description
     * Rollback all form controls pending updates to the `$modelValue`.
     *
     * Updates may be pending by a debounced event or because the input is waiting for a some future
     * event defined in `ng-model-options`. This method is typically needed by the reset button of
     * a form that uses `ng-model-options` to pend updates.
     */
    $rollbackViewValue: function $rollbackViewValue() {
      forEach(this.$$controls, function (control) {
        control.$rollbackViewValue();
      });
    },

    /**
     * @ngdoc method
     * @name form.FormController#$commitViewValue
     *
     * @description
     * Commit all form controls pending updates to the `$modelValue`.
     *
     * Updates may be pending by a debounced event or because the input is waiting for a some future
     * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
     * usually handles calling this in response to input events.
     */
    $commitViewValue: function $commitViewValue() {
      forEach(this.$$controls, function (control) {
        control.$commitViewValue();
      });
    },

    /**
     * @ngdoc method
     * @name form.FormController#$addControl
     * @param {object} control control object, either a {@link form.FormController} or an
     * {@link ngModel.NgModelController}
     *
     * @description
     * Register a control with the form. Input elements using ngModelController do this automatically
     * when they are linked.
     *
     * Note that the current state of the control will not be reflected on the new parent form. This
     * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
     * state.
     *
     * However, if the method is used programmatically, for example by adding dynamically created controls,
     * or controls that have been previously removed without destroying their corresponding DOM element,
     * it's the developers responsibility to make sure the current state propagates to the parent form.
     *
     * For example, if an input control is added that is already `$dirty` and has `$error` properties,
     * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
     */
    $addControl: function $addControl(control) {
      // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
      // and not added to the scope.  Now we throw an error.
      assertNotHasOwnProperty(control.$name, 'input');
      this.$$controls.push(control);

      if (control.$name) {
        this[control.$name] = control;
      }

      control.$$parentForm = this;
    },

    // Private API: rename a form control
    $$renameControl: function $$renameControl(control, newName) {
      var oldName = control.$name;

      if (this[oldName] === control) {
        delete this[oldName];
      }
      this[newName] = control;
      control.$name = newName;
    },

    /**
     * @ngdoc method
     * @name form.FormController#$removeControl
     * @param {object} control control object, either a {@link form.FormController} or an
     * {@link ngModel.NgModelController}
     *
     * @description
     * Deregister a control from the form.
     *
     * Input elements using ngModelController do this automatically when they are destroyed.
     *
     * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
     * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
     * different from case to case. For example, removing the only `$dirty` control from a form may or
     * may not mean that the form is still `$dirty`.
     */
    $removeControl: function $removeControl(control) {
      if (control.$name && this[control.$name] === control) {
        delete this[control.$name];
      }
      forEach(this.$pending, function (value, name) {
        // eslint-disable-next-line no-invalid-this
        this.$setValidity(name, null, control);
      }, this);
      forEach(this.$error, function (value, name) {
        // eslint-disable-next-line no-invalid-this
        this.$setValidity(name, null, control);
      }, this);
      forEach(this.$$success, function (value, name) {
        // eslint-disable-next-line no-invalid-this
        this.$setValidity(name, null, control);
      }, this);

      arrayRemove(this.$$controls, control);
      control.$$parentForm = nullFormCtrl;
    },

    /**
     * @ngdoc method
     * @name form.FormController#$setDirty
     *
     * @description
     * Sets the form to a dirty state.
     *
     * This method can be called to add the 'ng-dirty' class and set the form to a dirty
     * state (ng-dirty class). This method will also propagate to parent forms.
     */
    $setDirty: function $setDirty() {
      this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
      this.$$animate.addClass(this.$$element, DIRTY_CLASS);
      this.$dirty = true;
      this.$pristine = false;
      this.$$parentForm.$setDirty();
    },

    /**
     * @ngdoc method
     * @name form.FormController#$setPristine
     *
     * @description
     * Sets the form to its pristine state.
     *
     * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
     * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
     * state to false.
     *
     * This method will also propagate to all the controls contained in this form.
     *
     * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
     * saving or resetting it.
     */
    $setPristine: function $setPristine() {
      this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
      this.$dirty = false;
      this.$pristine = true;
      this.$submitted = false;
      forEach(this.$$controls, function (control) {
        control.$setPristine();
      });
    },

    /**
     * @ngdoc method
     * @name form.FormController#$setUntouched
     *
     * @description
     * Sets the form to its untouched state.
     *
     * This method can be called to remove the 'ng-touched' class and set the form controls to their
     * untouched state (ng-untouched class).
     *
     * Setting a form controls back to their untouched state is often useful when setting the form
     * back to its pristine state.
     */
    $setUntouched: function $setUntouched() {
      forEach(this.$$controls, function (control) {
        control.$setUntouched();
      });
    },

    /**
     * @ngdoc method
     * @name form.FormController#$setSubmitted
     *
     * @description
     * Sets the form to its submitted state.
     */
    $setSubmitted: function $setSubmitted() {
      this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
      this.$submitted = true;
      this.$$parentForm.$setSubmitted();
    }
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setValidity
   *
   * @description
   * Change the validity state of the form, and notify the parent form (if any).
   *
   * Application developers will rarely need to call this method directly. It is used internally, by
   * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
   * control's validity state to the parent `FormController`.
   *
   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
   *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
   *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
   *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
   *        class name. Example: `myError` will result in `ng-valid-my-error` and
   *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
   *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
   *        Skipped is used by AngularJS when validators do not run because of parse errors and when
   *        `$asyncValidators` do not run because any of the `$validators` failed.
   * @param {NgModelController | FormController} controller - The controller whose validity state is
   *        triggering the change.
   */
  addSetValidityMethod({
    clazz: FormController,
    set: function set(object, property, controller) {
      var list = object[property];
      if (!list) {
        object[property] = [controller];
      } else {
        var index = list.indexOf(controller);
        if (index === -1) {
          list.push(controller);
        }
      }
    },
    unset: function unset(object, property, controller) {
      var list = object[property];
      if (!list) {
        return;
      }
      arrayRemove(list, controller);
      if (list.length === 0) {
        delete object[property];
      }
    }
  });

  /**
   * @ngdoc directive
   * @name ngForm
   * @restrict EAC
   *
   * @description
   * Nestable alias of {@link ng.directive:form `form`} directive. HTML
   * does not allow nesting of form elements. It is useful to nest forms, for example if the validity of a
   * sub-group of controls needs to be determined.
   *
   * Note: the purpose of `ngForm` is to group controls,
   * but not to be a replacement for the `<form>` tag with all of its capabilities
   * (e.g. posting to the server, ...).
   *
   * @param {string=} ngForm|name Name of the form. If specified, the form controller will be published into
   *                       related scope, under this name.
   *
   */

  /**
  * @ngdoc directive
  * @name form
  * @restrict E
  *
  * @description
  * Directive that instantiates
  * {@link form.FormController FormController}.
  *
  * If the `name` attribute is specified, the form controller is published onto the current scope under
  * this name.
  *
  * ## Alias: {@link ng.directive:ngForm `ngForm`}
  *
  * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
  * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
  * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
  * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
  * of controls needs to be determined.
  *
  * ## CSS classes
  *  - `ng-valid` is set if the form is valid.
  *  - `ng-invalid` is set if the form is invalid.
  *  - `ng-pending` is set if the form is pending.
  *  - `ng-pristine` is set if the form is pristine.
  *  - `ng-dirty` is set if the form is dirty.
  *  - `ng-submitted` is set if the form was submitted.
  *
  * Keep in mind that ngAnimate can detect each of these classes when added and removed.
  *
  *
  * ## Submitting a form and preventing the default action
  *
  * Since the role of forms in client-side AngularJS applications is different than in classical
  * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
  * page reload that sends the data to the server. Instead some javascript logic should be triggered
  * to handle the form submission in an application-specific way.
  *
  * For this reason, AngularJS prevents the default action (form submission to the server) unless the
  * `<form>` element has an `action` attribute specified.
  *
  * You can use one of the following two ways to specify what javascript method should be called when
  * a form is submitted:
  *
  * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
  * - {@link ng.directive:ngClick ngClick} directive on the first
   *  button or input field of type submit (input[type=submit])
  *
  * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
  * or {@link ng.directive:ngClick ngClick} directives.
  * This is because of the following form submission rules in the HTML specification:
  *
  * - If a form has only one input field then hitting enter in this field triggers form submit
  * (`ngSubmit`)
  * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
  * doesn't trigger submit
  * - if a form has one or more input fields and one or more buttons or input[type=submit] then
  * hitting enter in any of the input fields will trigger the click handler on the *first* button or
  * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
  *
  * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
  * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
  * to have access to the updated model.
  *
  * @animations
  * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
  * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
  * other validations that are performed within the form. Animations in ngForm are similar to how
  * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
  * as JS animations.
  *
  * The following example shows a simple way to utilize CSS transitions to style a form element
  * that has been rendered as invalid after it has been validated:
  *
  * <pre>
  * //be sure to include ngAnimate as a module to hook into more
  * //advanced animations
  * .my-form {
  *   transition:0.5s linear all;
  *   background: white;
  * }
  * .my-form.ng-invalid {
  *   background: red;
  *   color:white;
  * }
  * </pre>
  *
  * @example
     <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
       <file name="index.html">
        <script>
          angular.module('formExample', [])
            .controller('FormController', ['$scope', function($scope) {
              $scope.userType = 'guest';
            }]);
        </script>
        <style>
         .my-form {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-form.ng-invalid {
           background: red;
         }
        </style>
        <form name="myForm" ng-controller="FormController" class="my-form">
          userType: <input name="input" ng-model="userType" required>
          <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
          <code>userType = {{userType}}</code><br>
          <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
          <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
          <code>myForm.$valid = {{myForm.$valid}}</code><br>
          <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
         </form>
       </file>
       <file name="protractor.js" type="protractor">
         it('should initialize to model', function() {
           var userType = element(by.binding('userType'));
           var valid = element(by.binding('myForm.input.$valid'));
            expect(userType.getText()).toContain('guest');
           expect(valid.getText()).toContain('true');
         });
          it('should be invalid if empty', function() {
           var userType = element(by.binding('userType'));
           var valid = element(by.binding('myForm.input.$valid'));
           var userInput = element(by.model('userType'));
            userInput.clear();
           userInput.sendKeys('');
            expect(userType.getText()).toEqual('userType =');
           expect(valid.getText()).toContain('false');
         });
       </file>
     </example>
  *
  * @param {string=} name Name of the form. If specified, the form controller will be published into
  *                       related scope, under this name.
  */
  var formDirectiveFactory = function formDirectiveFactory(isNgForm) {
    return ['$timeout', '$parse', function ($timeout, $parse) {
      var formDirective = {
        name: 'form',
        restrict: isNgForm ? 'EAC' : 'E',
        require: ['form', '^^?form'], //first is the form's own ctrl, second is an optional parent form
        controller: FormController,
        compile: function ngFormCompile(formElement, attr) {
          // Setup initial state of the control
          formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);

          var nameAttr = attr.name ? 'name' : isNgForm && attr.ngForm ? 'ngForm' : false;

          return {
            pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
              var controller = ctrls[0];

              // if `action` attr is not present on the form, prevent the default action (submission)
              if (!('action' in attr)) {
                // we can't use jq events because if a form is destroyed during submission the default
                // action is not prevented. see #1238
                //
                // IE 9 is not affected because it doesn't fire a submit event and try to do a full
                // page reload if the form was destroyed by submission of the form via a click handler
                // on a button in the form. Looks like an IE9 specific bug.
                var handleFormSubmission = function handleFormSubmission(event) {
                  scope.$apply(function () {
                    controller.$commitViewValue();
                    controller.$setSubmitted();
                  });

                  event.preventDefault();
                };

                formElement[0].addEventListener('submit', handleFormSubmission);

                // unregister the preventDefault listener so that we don't not leak memory but in a
                // way that will achieve the prevention of the default action.
                formElement.on('$destroy', function () {
                  $timeout(function () {
                    formElement[0].removeEventListener('submit', handleFormSubmission);
                  }, 0, false);
                });
              }

              var parentFormCtrl = ctrls[1] || controller.$$parentForm;
              parentFormCtrl.$addControl(controller);

              var setter = nameAttr ? getSetter(controller.$name) : noop;

              if (nameAttr) {
                setter(scope, controller);
                attr.$observe(nameAttr, function (newValue) {
                  if (controller.$name === newValue) return;
                  setter(scope, undefined);
                  controller.$$parentForm.$$renameControl(controller, newValue);
                  setter = getSetter(controller.$name);
                  setter(scope, controller);
                });
              }
              formElement.on('$destroy', function () {
                controller.$$parentForm.$removeControl(controller);
                setter(scope, undefined);
                extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
              });
            }
          };
        }
      };

      return formDirective;

      function getSetter(expression) {
        if (expression === '') {
          //create an assignable expression, so forms with an empty name can be renamed later
          return $parse('this[""]').assign;
        }
        return $parse(expression).assign || noop;
      }
    }];
  };

  var formDirective = formDirectiveFactory();
  var ngFormDirective = formDirectiveFactory(true);

  // helper methods
  function setupValidity(instance) {
    instance.$$classCache = {};
    instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
  }
  function addSetValidityMethod(context) {
    var clazz = context.clazz,
        set = context.set,
        unset = context.unset;

    clazz.prototype.$setValidity = function (validationErrorKey, state, controller) {
      if (isUndefined(state)) {
        createAndSet(this, '$pending', validationErrorKey, controller);
      } else {
        unsetAndCleanup(this, '$pending', validationErrorKey, controller);
      }
      if (!isBoolean(state)) {
        unset(this.$error, validationErrorKey, controller);
        unset(this.$$success, validationErrorKey, controller);
      } else {
        if (state) {
          unset(this.$error, validationErrorKey, controller);
          set(this.$$success, validationErrorKey, controller);
        } else {
          set(this.$error, validationErrorKey, controller);
          unset(this.$$success, validationErrorKey, controller);
        }
      }
      if (this.$pending) {
        cachedToggleClass(this, PENDING_CLASS, true);
        this.$valid = this.$invalid = undefined;
        toggleValidationCss(this, '', null);
      } else {
        cachedToggleClass(this, PENDING_CLASS, false);
        this.$valid = isObjectEmpty(this.$error);
        this.$invalid = !this.$valid;
        toggleValidationCss(this, '', this.$valid);
      }

      // re-read the state as the set/unset methods could have
      // combined state in this.$error[validationError] (used for forms),
      // where setting/unsetting only increments/decrements the value,
      // and does not replace it.
      var combinedState;
      if (this.$pending && this.$pending[validationErrorKey]) {
        combinedState = undefined;
      } else if (this.$error[validationErrorKey]) {
        combinedState = false;
      } else if (this.$$success[validationErrorKey]) {
        combinedState = true;
      } else {
        combinedState = null;
      }

      toggleValidationCss(this, validationErrorKey, combinedState);
      this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
    };

    function createAndSet(ctrl, name, value, controller) {
      if (!ctrl[name]) {
        ctrl[name] = {};
      }
      set(ctrl[name], value, controller);
    }

    function unsetAndCleanup(ctrl, name, value, controller) {
      if (ctrl[name]) {
        unset(ctrl[name], value, controller);
      }
      if (isObjectEmpty(ctrl[name])) {
        ctrl[name] = undefined;
      }
    }

    function cachedToggleClass(ctrl, className, switchValue) {
      if (switchValue && !ctrl.$$classCache[className]) {
        ctrl.$$animate.addClass(ctrl.$$element, className);
        ctrl.$$classCache[className] = true;
      } else if (!switchValue && ctrl.$$classCache[className]) {
        ctrl.$$animate.removeClass(ctrl.$$element, className);
        ctrl.$$classCache[className] = false;
      }
    }

    function toggleValidationCss(ctrl, validationErrorKey, isValid) {
      validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';

      cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
      cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
    }
  }

  function isObjectEmpty(obj) {
    if (obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false;
        }
      }
    }
    return true;
  }

  /* global
    VALID_CLASS: false,
    INVALID_CLASS: false,
    PRISTINE_CLASS: false,
    DIRTY_CLASS: false,
    ngModelMinErr: false
  */

  // Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
  var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
  // See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
  // Note: We are being more lenient, because browsers are too.
  //   1. Scheme
  //   2. Slashes
  //   3. Username
  //   4. Password
  //   5. Hostname
  //   6. Port
  //   7. Path
  //   8. Query
  //   9. Fragment
  //                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
  var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
  // eslint-disable-next-line max-len
  var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
  var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
  var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
  var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
  var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
  var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
  var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;

  var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
  var PARTIAL_VALIDATION_TYPES = createMap();
  forEach('date,datetime-local,month,time,week'.split(','), function (type) {
    PARTIAL_VALIDATION_TYPES[type] = true;
  });

  var inputType = {

    /**
     * @ngdoc input
     * @name input[text]
     *
     * @description
     * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
     *
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} required Adds `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
     *    minlength.
     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
     *    any length.
     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
     *    that contains the regular expression body that will be converted to a regular expression
     *    as in the ngPattern directive.
     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
     *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
     *    If the expression evaluates to a RegExp object, then this is used directly.
     *    If the expression evaluates to a string, then it will be converted to a RegExp
     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
     *    `new RegExp('^abc$')`.<br />
     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
     *    start at the index of the last search's match, thus not taking the whole input value into
     *    account.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
     *    This parameter is ignored for input[type=password] controls, which will never trim the
     *    input.
     *
     * @example
        <example name="text-input-directive" module="textInputExample">
          <file name="index.html">
           <script>
             angular.module('textInputExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.example = {
                   text: 'guest',
                   word: /^\s*\w*\s*$/
                 };
               }]);
           </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Single word:
               <input type="text" name="input" ng-model="example.text"
                      ng-pattern="example.word" required ng-trim="false">
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.pattern">
                 Single word only!</span>
             </div>
             <code>text = {{example.text}}</code><br/>
             <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
             <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
             <code>myForm.$valid = {{myForm.$valid}}</code><br/>
             <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
            </form>
          </file>
          <file name="protractor.js" type="protractor">
            var text = element(by.binding('example.text'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('example.text'));
             it('should initialize to model', function() {
              expect(text.getText()).toContain('guest');
              expect(valid.getText()).toContain('true');
            });
             it('should be invalid if empty', function() {
              input.clear();
              input.sendKeys('');
               expect(text.getText()).toEqual('text =');
              expect(valid.getText()).toContain('false');
            });
             it('should be invalid if multi word', function() {
              input.clear();
              input.sendKeys('hello world');
               expect(valid.getText()).toContain('false');
            });
          </file>
        </example>
     */
    'text': textInputType,

    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));
         // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }
         it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });
         it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
         it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
    'date': createDateInputType('date', DATE_REGEXP, createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']), 'yyyy-MM-dd'),

    /**
     * @ngdoc input
     * @name input[datetime-local]
     *
     * @description
     * Input with datetime validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
     * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
     *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
     *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
     *   Note that `min` will also add native HTML5 constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
     *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
     *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
     *   Note that `max` will also add native HTML5 constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="datetimelocal-input-directive" module="dateExample">
     <file name="index.html">
       <script>
         angular.module('dateExample', [])
           .controller('DateController', ['$scope', function($scope) {
             $scope.example = {
               value: new Date(2010, 11, 28, 14, 57)
             };
           }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
         <label for="exampleInput">Pick a date between in 2013:</label>
         <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
             placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
         <div role="alert">
           <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
           <span class="error" ng-show="myForm.input.$error.datetimelocal">
               Not a valid date!</span>
         </div>
         <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
         <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
         <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
       var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
       var valid = element(by.binding('myForm.input.$valid'));
        // currently protractor/webdriver does not support
       // sending keys to all known HTML5 input controls
       // for various browsers (https://github.com/angular/protractor/issues/562).
       function setInput(val) {
         // set the value of the element and force validation.
         var scr = "var ipt = document.getElementById('exampleInput'); " +
         "ipt.value = '" + val + "';" +
         "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
         browser.executeScript(scr);
       }
        it('should initialize to model', function() {
         expect(value.getText()).toContain('2010-12-28T14:57:00');
         expect(valid.getText()).toContain('myForm.input.$valid = true');
       });
        it('should be invalid if empty', function() {
         setInput('');
         expect(value.getText()).toEqual('value =');
         expect(valid.getText()).toContain('myForm.input.$valid = false');
       });
        it('should be invalid if over max', function() {
         setInput('2015-01-01T23:59:00');
         expect(value.getText()).toContain('');
         expect(valid.getText()).toContain('myForm.input.$valid = false');
       });
     </file>
     </example>
     */
    'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP, createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']), 'yyyy-MM-ddTHH:mm:ss.sss'),

    /**
     * @ngdoc input
     * @name input[time]
     *
     * @description
     * Input with time validation and transformation. In browsers that do not yet support
     * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
     * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
     * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
     *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
     *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
     *   native HTML5 constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
     *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
     *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
     *   native HTML5 constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
     *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
     *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="time-input-directive" module="timeExample">
     <file name="index.html">
       <script>
        angular.module('timeExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(1970, 0, 1, 14, 57, 0)
            };
          }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a time between 8am and 5pm:</label>
          <input type="time" id="exampleInput" name="input" ng-model="example.value"
              placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.time">
                Not a valid date!</span>
          </div>
          <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
          <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
          <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
          <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
          <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "HH:mm:ss"'));
        var valid = element(by.binding('myForm.input.$valid'));
         // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }
         it('should initialize to model', function() {
          expect(value.getText()).toContain('14:57:00');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });
         it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
         it('should be invalid if over max', function() {
          setInput('23:59:00');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
    'time': createDateInputType('time', TIME_REGEXP, createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']), 'HH:mm:ss.sss'),

    /**
     * @ngdoc input
     * @name input[week]
     *
     * @description
     * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
     * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
     * week format (yyyy-W##), for example: `2013-W02`.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
     *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
     *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
     *   native HTML5 constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
     *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
     *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
     *   native HTML5 constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="week-input-directive" module="weekExample">
     <file name="index.html">
       <script>
       angular.module('weekExample', [])
         .controller('DateController', ['$scope', function($scope) {
           $scope.example = {
             value: new Date(2013, 0, 3)
           };
         }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
         <label>Pick a date between in 2013:
           <input id="exampleInput" type="week" name="input" ng-model="example.value"
                  placeholder="YYYY-W##" min="2012-W32"
                  max="2013-W52" required />
         </label>
         <div role="alert">
           <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
           <span class="error" ng-show="myForm.input.$error.week">
               Not a valid date!</span>
         </div>
         <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
         <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
         <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
       var value = element(by.binding('example.value | date: "yyyy-Www"'));
       var valid = element(by.binding('myForm.input.$valid'));
        // currently protractor/webdriver does not support
       // sending keys to all known HTML5 input controls
       // for various browsers (https://github.com/angular/protractor/issues/562).
       function setInput(val) {
         // set the value of the element and force validation.
         var scr = "var ipt = document.getElementById('exampleInput'); " +
         "ipt.value = '" + val + "';" +
         "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
         browser.executeScript(scr);
       }
        it('should initialize to model', function() {
         expect(value.getText()).toContain('2013-W01');
         expect(valid.getText()).toContain('myForm.input.$valid = true');
       });
        it('should be invalid if empty', function() {
         setInput('');
         expect(value.getText()).toEqual('value =');
         expect(valid.getText()).toContain('myForm.input.$valid = false');
       });
        it('should be invalid if over max', function() {
         setInput('2015-W01');
         expect(value.getText()).toContain('');
         expect(valid.getText()).toContain('myForm.input.$valid = false');
       });
     </file>
     </example>
     */
    'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),

    /**
     * @ngdoc input
     * @name input[month]
     *
     * @description
     * Input with month validation and transformation. In browsers that do not yet support
     * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
     * month format (yyyy-MM), for example: `2009-01`.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     * If the model is not set to the first of the month, the next view to model update will set it
     * to the first of the month.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
     *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
     *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
     *   native HTML5 constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
     *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
     *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
     *   native HTML5 constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
      * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="month-input-directive" module="monthExample">
     <file name="index.html">
       <script>
        angular.module('monthExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2013, 9, 1)
            };
          }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
         <label for="exampleInput">Pick a month in 2013:</label>
         <input id="exampleInput" type="month" name="input" ng-model="example.value"
            placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
         <div role="alert">
           <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
           <span class="error" ng-show="myForm.input.$error.month">
              Not a valid month!</span>
         </div>
         <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
         <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
         <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM"'));
        var valid = element(by.binding('myForm.input.$valid'));
         // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }
         it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });
         it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
         it('should be invalid if over max', function() {
          setInput('2015-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
    'month': createDateInputType('month', MONTH_REGEXP, createDateParser(MONTH_REGEXP, ['yyyy', 'MM']), 'yyyy-MM'),

    /**
     * @ngdoc input
     * @name input[number]
     *
     * @description
     * Text input with number validation and transformation. Sets the `number` validation
     * error if not a valid number.
     *
     * <div class="alert alert-warning">
     * The model must always be of type `number` otherwise AngularJS will throw an error.
     * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
     * error docs for more information and an example of how to convert your model if necessary.
     * </div>
     *
     * ## Issues with HTML5 constraint validation
     *
     * In browsers that follow the
     * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
     * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
     * If a non-number is entered in the input, the browser will report the value as an empty string,
     * which means the view / model values in `ngModel` and subsequently the scope value
     * will also be an empty string.
     *
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
     *    Can be interpolated.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
     *    Can be interpolated.
     * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
     *    but does not trigger HTML5 native validation. Takes an expression.
     * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
     *    but does not trigger HTML5 native validation. Takes an expression.
     * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
     *    Can be interpolated.
     * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
     *    but does not trigger HTML5 native validation. Takes an expression.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
     *    minlength.
     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
     *    any length.
     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
     *    that contains the regular expression body that will be converted to a regular expression
     *    as in the ngPattern directive.
     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
     *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
     *    If the expression evaluates to a RegExp object, then this is used directly.
     *    If the expression evaluates to a string, then it will be converted to a RegExp
     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
     *    `new RegExp('^abc$')`.<br />
     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
     *    start at the index of the last search's match, thus not taking the whole input value into
     *    account.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
        <example name="number-input-directive" module="numberExample">
          <file name="index.html">
           <script>
             angular.module('numberExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.example = {
                   value: 12
                 };
               }]);
           </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Number:
               <input type="number" name="input" ng-model="example.value"
                      min="0" max="99" required>
            </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.number">
                 Not valid number!</span>
             </div>
             <tt>value = {{example.value}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
            </form>
          </file>
          <file name="protractor.js" type="protractor">
            var value = element(by.binding('example.value'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('example.value'));
             it('should initialize to model', function() {
              expect(value.getText()).toContain('12');
              expect(valid.getText()).toContain('true');
            });
             it('should be invalid if empty', function() {
              input.clear();
              input.sendKeys('');
              expect(value.getText()).toEqual('value =');
              expect(valid.getText()).toContain('false');
            });
             it('should be invalid if over max', function() {
              input.clear();
              input.sendKeys('123');
              expect(value.getText()).toEqual('value =');
              expect(valid.getText()).toContain('false');
            });
          </file>
        </example>
     */
    'number': numberInputType,

    /**
     * @ngdoc input
     * @name input[url]
     *
     * @description
     * Text input with URL validation. Sets the `url` validation error key if the content is not a
     * valid URL.
     *
     * <div class="alert alert-warning">
     * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
     * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
     * the built-in validators (see the {@link guide/forms Forms guide})
     * </div>
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
     *    minlength.
     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
     *    any length.
     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
     *    that contains the regular expression body that will be converted to a regular expression
     *    as in the ngPattern directive.
     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
     *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
     *    If the expression evaluates to a RegExp object, then this is used directly.
     *    If the expression evaluates to a string, then it will be converted to a RegExp
     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
     *    `new RegExp('^abc$')`.<br />
     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
     *    start at the index of the last search's match, thus not taking the whole input value into
     *    account.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
        <example name="url-input-directive" module="urlExample">
          <file name="index.html">
           <script>
             angular.module('urlExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.url = {
                   text: 'http://google.com'
                 };
               }]);
           </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>URL:
               <input type="url" name="input" ng-model="url.text" required>
             <label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.url">
                 Not valid url!</span>
             </div>
             <tt>text = {{url.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
            </form>
          </file>
          <file name="protractor.js" type="protractor">
            var text = element(by.binding('url.text'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('url.text'));
             it('should initialize to model', function() {
              expect(text.getText()).toContain('http://google.com');
              expect(valid.getText()).toContain('true');
            });
             it('should be invalid if empty', function() {
              input.clear();
              input.sendKeys('');
               expect(text.getText()).toEqual('text =');
              expect(valid.getText()).toContain('false');
            });
             it('should be invalid if not url', function() {
              input.clear();
              input.sendKeys('box');
               expect(valid.getText()).toContain('false');
            });
          </file>
        </example>
     */
    'url': urlInputType,

    /**
     * @ngdoc input
     * @name input[email]
     *
     * @description
     * Text input with email validation. Sets the `email` validation error key if not a valid email
     * address.
     *
     * <div class="alert alert-warning">
     * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
     * used in Chromium. If you need stricter validation (e.g. requiring a top-level domain), you can
     * use `ng-pattern` or modify the built-in validators (see the {@link guide/forms Forms guide})
     * </div>
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
     *    minlength.
     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
     *    any length.
     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
     *    that contains the regular expression body that will be converted to a regular expression
     *    as in the ngPattern directive.
     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
     *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
     *    If the expression evaluates to a RegExp object, then this is used directly.
     *    If the expression evaluates to a string, then it will be converted to a RegExp
     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
     *    `new RegExp('^abc$')`.<br />
     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
     *    start at the index of the last search's match, thus not taking the whole input value into
     *    account.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
        <example name="email-input-directive" module="emailExample">
          <file name="index.html">
           <script>
             angular.module('emailExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.email = {
                   text: 'me@example.com'
                 };
               }]);
           </script>
             <form name="myForm" ng-controller="ExampleController">
               <label>Email:
                 <input type="email" name="input" ng-model="email.text" required>
               </label>
               <div role="alert">
                 <span class="error" ng-show="myForm.input.$error.required">
                   Required!</span>
                 <span class="error" ng-show="myForm.input.$error.email">
                   Not valid email!</span>
               </div>
               <tt>text = {{email.text}}</tt><br/>
               <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
               <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
               <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
               <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
               <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
             </form>
           </file>
          <file name="protractor.js" type="protractor">
            var text = element(by.binding('email.text'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('email.text'));
             it('should initialize to model', function() {
              expect(text.getText()).toContain('me@example.com');
              expect(valid.getText()).toContain('true');
            });
             it('should be invalid if empty', function() {
              input.clear();
              input.sendKeys('');
              expect(text.getText()).toEqual('text =');
              expect(valid.getText()).toContain('false');
            });
             it('should be invalid if not email', function() {
              input.clear();
              input.sendKeys('xxx');
               expect(valid.getText()).toContain('false');
            });
          </file>
        </example>
     */
    'email': emailInputType,

    /**
     * @ngdoc input
     * @name input[radio]
     *
     * @description
     * HTML radio button.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string} value The value to which the `ngModel` expression should be set when selected.
     *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
     *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
     *    is selected. Should be used instead of the `value` attribute if you need
     *    a non-string `ngModel` (`boolean`, `array`, ...).
     *
     * @example
        <example name="radio-input-directive" module="radioExample">
          <file name="index.html">
           <script>
             angular.module('radioExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.color = {
                   name: 'blue'
                 };
                 $scope.specialValue = {
                   "id": "12345",
                   "value": "green"
                 };
               }]);
           </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>
               <input type="radio" ng-model="color.name" value="red">
               Red
             </label><br/>
             <label>
               <input type="radio" ng-model="color.name" ng-value="specialValue">
               Green
             </label><br/>
             <label>
               <input type="radio" ng-model="color.name" value="blue">
               Blue
             </label><br/>
             <tt>color = {{color.name | json}}</tt><br/>
            </form>
            Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
          </file>
          <file name="protractor.js" type="protractor">
            it('should change state', function() {
              var inputs = element.all(by.model('color.name'));
              var color = element(by.binding('color.name'));
               expect(color.getText()).toContain('blue');
               inputs.get(0).click();
              expect(color.getText()).toContain('red');
               inputs.get(1).click();
              expect(color.getText()).toContain('green');
            });
          </file>
        </example>
     */
    'radio': radioInputType,

    /**
     * @ngdoc input
     * @name input[range]
     *
     * @description
     * Native range input with validation and transformation.
     *
     * The model for the range input must always be a `Number`.
     *
     * IE9 and other browsers that do not support the `range` type fall back
     * to a text input without any default values for `min`, `max` and `step`. Model binding,
     * validation and number parsing are nevertheless supported.
     *
     * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
     * in a way that never allows the input to hold an invalid value. That means:
     * - any non-numerical value is set to `(max + min) / 2`.
     * - any numerical value that is less than the current min val, or greater than the current max val
     * is set to the min / max val respectively.
     * - additionally, the current `step` is respected, so the nearest value that satisfies a step
     * is used.
     *
     * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
     * for more info.
     *
     * This has the following consequences for AngularJS:
     *
     * Since the element value should always reflect the current model value, a range input
     * will set the bound ngModel expression to the value that the browser has set for the
     * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
     * if the application sets `model.value = null`, the browser will set the input to `'50'`.
     * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
     *
     * That means the model for range will immediately be set to `50` after `ngModel` has been
     * initialized. It also means a range input can never have the required error.
     *
     * This does not only affect changes to the model value, but also to the values of the `min`,
     * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
     * the input value, AngularJS will also update the model value.
     *
     * Automatic value adjustment also means that a range input element can never have the `required`,
     * `min`, or `max` errors.
     *
     * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
     * when the step value changes dynamically - they do not adjust the element value correctly, but
     * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
     * error on the input, and set the model to `undefined`.
     *
     * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
     * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
     * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
     *
     * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
     *                  than `min`. Can be interpolated.
     * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
     *                  Can be interpolated.
     * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
     *                  Can be interpolated.
     * @param {string=} ngChange AngularJS expression to be executed when the ngModel value changes due
     *                  to user interaction with the input element.
     * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
     *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
     *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
     *
     * @example
        <example name="range-input-directive" module="rangeExample">
          <file name="index.html">
            <script>
              angular.module('rangeExample', [])
                .controller('ExampleController', ['$scope', function($scope) {
                  $scope.value = 75;
                  $scope.min = 10;
                  $scope.max = 90;
                }]);
            </script>
            <form name="myForm" ng-controller="ExampleController">
               Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
              <hr>
              Model as number: <input type="number" ng-model="value"><br>
              Min: <input type="number" ng-model="min"><br>
              Max: <input type="number" ng-model="max"><br>
              value = <code>{{value}}</code><br/>
              myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
              myForm.range.$error = <code>{{myForm.range.$error}}</code>
            </form>
          </file>
        </example>
      * ## Range Input with ngMin & ngMax attributes
      * @example
        <example name="range-input-directive-ng" module="rangeExample">
          <file name="index.html">
            <script>
              angular.module('rangeExample', [])
                .controller('ExampleController', ['$scope', function($scope) {
                  $scope.value = 75;
                  $scope.min = 10;
                  $scope.max = 90;
                }]);
            </script>
            <form name="myForm" ng-controller="ExampleController">
              Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
              <hr>
              Model as number: <input type="number" ng-model="value"><br>
              Min: <input type="number" ng-model="min"><br>
              Max: <input type="number" ng-model="max"><br>
              value = <code>{{value}}</code><br/>
              myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
              myForm.range.$error = <code>{{myForm.range.$error}}</code>
            </form>
          </file>
        </example>
      */
    'range': rangeInputType,

    /**
     * @ngdoc input
     * @name input[checkbox]
     *
     * @description
     * HTML checkbox.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
     * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
        <example name="checkbox-input-directive" module="checkboxExample">
          <file name="index.html">
           <script>
             angular.module('checkboxExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.checkboxModel = {
                  value1 : true,
                  value2 : 'YES'
                };
               }]);
           </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Value1:
               <input type="checkbox" ng-model="checkboxModel.value1">
             </label><br/>
             <label>Value2:
               <input type="checkbox" ng-model="checkboxModel.value2"
                      ng-true-value="'YES'" ng-false-value="'NO'">
              </label><br/>
             <tt>value1 = {{checkboxModel.value1}}</tt><br/>
             <tt>value2 = {{checkboxModel.value2}}</tt><br/>
            </form>
          </file>
          <file name="protractor.js" type="protractor">
            it('should change state', function() {
              var value1 = element(by.binding('checkboxModel.value1'));
              var value2 = element(by.binding('checkboxModel.value2'));
               expect(value1.getText()).toContain('true');
              expect(value2.getText()).toContain('YES');
               element(by.model('checkboxModel.value1')).click();
              element(by.model('checkboxModel.value2')).click();
               expect(value1.getText()).toContain('false');
              expect(value2.getText()).toContain('NO');
            });
          </file>
        </example>
     */
    'checkbox': checkboxInputType,

    'hidden': noop,
    'button': noop,
    'submit': noop,
    'reset': noop,
    'file': noop
  };

  function stringBasedInputType(ctrl) {
    ctrl.$formatters.push(function (value) {
      return ctrl.$isEmpty(value) ? value : value.toString();
    });
  }

  function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    stringBasedInputType(ctrl);
  }

  function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    var type = lowercase(element[0].type);

    // In composition mode, users are still inputting intermediate text buffer,
    // hold the listener until composition is done.
    // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
    if (!$sniffer.android) {
      var composing = false;

      element.on('compositionstart', function () {
        composing = true;
      });

      element.on('compositionend', function () {
        composing = false;
        listener();
      });
    }

    var timeout;

    var listener = function listener(ev) {
      if (timeout) {
        $browser.defer.cancel(timeout);
        timeout = null;
      }
      if (composing) return;
      var value = element.val(),
          event = ev && ev.type;

      // By default we will trim the value
      // If the attribute ng-trim exists we will avoid trimming
      // If input type is 'password', the value is never trimmed
      if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
        value = trim(value);
      }

      // If a control is suffering from bad input (due to native validators), browsers discard its
      // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
      // control's value is the same empty value twice in a row.
      if (ctrl.$viewValue !== value || value === '' && ctrl.$$hasNativeValidators) {
        ctrl.$setViewValue(value, event);
      }
    };

    // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
    // input event on backspace, delete or cut
    if ($sniffer.hasEvent('input')) {
      element.on('input', listener);
    } else {
      var deferListener = function deferListener(ev, input, origValue) {
        if (!timeout) {
          timeout = $browser.defer(function () {
            timeout = null;
            if (!input || input.value !== origValue) {
              listener(ev);
            }
          });
        }
      };

      element.on('keydown', /** @this */function (event) {
        var key = event.keyCode;

        // ignore
        //    command            modifiers                   arrows
        if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) return;

        deferListener(event, this, this.value);
      });

      // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
      if ($sniffer.hasEvent('paste')) {
        element.on('paste cut drop', deferListener);
      }
    }

    // if user paste into input using mouse on older browser
    // or form autocomplete on newer browser, we need "change" event to catch it
    element.on('change', listener);

    // Some native input types (date-family) have the ability to change validity without
    // firing any input/change events.
    // For these event types, when native validators are present and the browser supports the type,
    // check for validity changes on various DOM events.
    if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
      element.on(PARTIAL_VALIDATION_EVENTS, /** @this */function (ev) {
        if (!timeout) {
          var validity = this[VALIDITY_STATE_PROPERTY];
          var origBadInput = validity.badInput;
          var origTypeMismatch = validity.typeMismatch;
          timeout = $browser.defer(function () {
            timeout = null;
            if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
              listener(ev);
            }
          });
        }
      });
    }

    ctrl.$render = function () {
      // Workaround for Firefox validation #12102.
      var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
      if (element.val() !== value) {
        element.val(value);
      }
    };
  }

  function weekParser(isoWeek, existingDate) {
    if (isDate(isoWeek)) {
      return isoWeek;
    }

    if (isString(isoWeek)) {
      WEEK_REGEXP.lastIndex = 0;
      var parts = WEEK_REGEXP.exec(isoWeek);
      if (parts) {
        var year = +parts[1],
            week = +parts[2],
            hours = 0,
            minutes = 0,
            seconds = 0,
            milliseconds = 0,
            firstThurs = getFirstThursdayOfYear(year),
            addDays = (week - 1) * 7;

        if (existingDate) {
          hours = existingDate.getHours();
          minutes = existingDate.getMinutes();
          seconds = existingDate.getSeconds();
          milliseconds = existingDate.getMilliseconds();
        }

        return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
      }
    }

    return NaN;
  }

  function createDateParser(regexp, mapping) {
    return function (iso, date) {
      var parts, map;

      if (isDate(iso)) {
        return iso;
      }

      if (isString(iso)) {
        // When a date is JSON'ified to wraps itself inside of an extra
        // set of double quotes. This makes the date parsing code unable
        // to match the date string and parse it as a date.
        if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
          iso = iso.substring(1, iso.length - 1);
        }
        if (ISO_DATE_REGEXP.test(iso)) {
          return new Date(iso);
        }
        regexp.lastIndex = 0;
        parts = regexp.exec(iso);

        if (parts) {
          parts.shift();
          if (date) {
            map = {
              yyyy: date.getFullYear(),
              MM: date.getMonth() + 1,
              dd: date.getDate(),
              HH: date.getHours(),
              mm: date.getMinutes(),
              ss: date.getSeconds(),
              sss: date.getMilliseconds() / 1000
            };
          } else {
            map = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 };
          }

          forEach(parts, function (part, index) {
            if (index < mapping.length) {
              map[mapping[index]] = +part;
            }
          });
          return new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
        }
      }

      return NaN;
    };
  }

  function createDateInputType(type, regexp, parseDate, format) {
    return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter) {
      badInputChecker(scope, element, attr, ctrl);
      baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
      var timezone = ctrl && ctrl.$options.getOption('timezone');
      var previousDate;

      ctrl.$$parserName = type;
      ctrl.$parsers.push(function (value) {
        if (ctrl.$isEmpty(value)) return null;
        if (regexp.test(value)) {
          // Note: We cannot read ctrl.$modelValue, as there might be a different
          // parser/formatter in the processing chain so that the model
          // contains some different data format!
          var parsedDate = parseDate(value, previousDate);
          if (timezone) {
            parsedDate = convertTimezoneToLocal(parsedDate, timezone);
          }
          return parsedDate;
        }
        return undefined;
      });

      ctrl.$formatters.push(function (value) {
        if (value && !isDate(value)) {
          throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
        }
        if (isValidDate(value)) {
          previousDate = value;
          if (previousDate && timezone) {
            previousDate = convertTimezoneToLocal(previousDate, timezone, true);
          }
          return $filter('date')(value, format, timezone);
        } else {
          previousDate = null;
          return '';
        }
      });

      if (isDefined(attr.min) || attr.ngMin) {
        var minVal;
        ctrl.$validators.min = function (value) {
          return !isValidDate(value) || isUndefined(minVal) || parseDate(value) >= minVal;
        };
        attr.$observe('min', function (val) {
          minVal = parseObservedDateValue(val);
          ctrl.$validate();
        });
      }

      if (isDefined(attr.max) || attr.ngMax) {
        var maxVal;
        ctrl.$validators.max = function (value) {
          return !isValidDate(value) || isUndefined(maxVal) || parseDate(value) <= maxVal;
        };
        attr.$observe('max', function (val) {
          maxVal = parseObservedDateValue(val);
          ctrl.$validate();
        });
      }

      function isValidDate(value) {
        // Invalid Date: getTime() returns NaN
        return value && !(value.getTime && value.getTime() !== value.getTime());
      }

      function parseObservedDateValue(val) {
        return isDefined(val) && !isDate(val) ? parseDate(val) || undefined : val;
      }
    };
  }

  function badInputChecker(scope, element, attr, ctrl) {
    var node = element[0];
    var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
    if (nativeValidation) {
      ctrl.$parsers.push(function (value) {
        var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
        return validity.badInput || validity.typeMismatch ? undefined : value;
      });
    }
  }

  function numberFormatterParser(ctrl) {
    ctrl.$$parserName = 'number';
    ctrl.$parsers.push(function (value) {
      if (ctrl.$isEmpty(value)) return null;
      if (NUMBER_REGEXP.test(value)) return parseFloat(value);
      return undefined;
    });

    ctrl.$formatters.push(function (value) {
      if (!ctrl.$isEmpty(value)) {
        if (!isNumber(value)) {
          throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
        }
        value = value.toString();
      }
      return value;
    });
  }

  function parseNumberAttrVal(val) {
    if (isDefined(val) && !isNumber(val)) {
      val = parseFloat(val);
    }
    return !isNumberNaN(val) ? val : undefined;
  }

  function isNumberInteger(num) {
    // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
    // (minus the assumption that `num` is a number)

    // eslint-disable-next-line no-bitwise
    return (num | 0) === num;
  }

  function countDecimals(num) {
    var numString = num.toString();
    var decimalSymbolIndex = numString.indexOf('.');

    if (decimalSymbolIndex === -1) {
      if (-1 < num && num < 1) {
        // It may be in the exponential notation format (`1e-X`)
        var match = /e-(\d+)$/.exec(numString);

        if (match) {
          return Number(match[1]);
        }
      }

      return 0;
    }

    return numString.length - decimalSymbolIndex - 1;
  }

  function isValidForStep(viewValue, stepBase, step) {
    // At this point `stepBase` and `step` are expected to be non-NaN values
    // and `viewValue` is expected to be a valid stringified number.
    var value = Number(viewValue);

    var isNonIntegerValue = !isNumberInteger(value);
    var isNonIntegerStepBase = !isNumberInteger(stepBase);
    var isNonIntegerStep = !isNumberInteger(step);

    // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
    // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
    if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
      var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
      var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
      var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;

      var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
      var multiplier = Math.pow(10, decimalCount);

      value = value * multiplier;
      stepBase = stepBase * multiplier;
      step = step * multiplier;

      if (isNonIntegerValue) value = Math.round(value);
      if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
      if (isNonIntegerStep) step = Math.round(step);
    }

    return (value - stepBase) % step === 0;
  }

  function numberInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    badInputChecker(scope, element, attr, ctrl);
    numberFormatterParser(ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

    var minVal;
    var maxVal;

    if (isDefined(attr.min) || attr.ngMin) {
      ctrl.$validators.min = function (value) {
        return ctrl.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
      };

      attr.$observe('min', function (val) {
        minVal = parseNumberAttrVal(val);
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      });
    }

    if (isDefined(attr.max) || attr.ngMax) {
      ctrl.$validators.max = function (value) {
        return ctrl.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
      };

      attr.$observe('max', function (val) {
        maxVal = parseNumberAttrVal(val);
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      });
    }

    if (isDefined(attr.step) || attr.ngStep) {
      var stepVal;
      ctrl.$validators.step = function (modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) || isValidForStep(viewValue, minVal || 0, stepVal);
      };

      attr.$observe('step', function (val) {
        stepVal = parseNumberAttrVal(val);
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      });
    }
  }

  function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    badInputChecker(scope, element, attr, ctrl);
    numberFormatterParser(ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);

    var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
        minVal = supportsRange ? 0 : undefined,
        maxVal = supportsRange ? 100 : undefined,
        stepVal = supportsRange ? 1 : undefined,
        validity = element[0].validity,
        hasMinAttr = isDefined(attr.min),
        hasMaxAttr = isDefined(attr.max),
        hasStepAttr = isDefined(attr.step);

    var originalRender = ctrl.$render;

    ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
    //Browsers that implement range will set these values automatically, but reading the adjusted values after
    //$render would cause the min / max validators to be applied with the wrong value
    function rangeRender() {
      originalRender();
      ctrl.$setViewValue(element.val());
    } : originalRender;

    if (hasMinAttr) {
      ctrl.$validators.min = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMinValidator() {
        return true;
      } :
      // non-support browsers validate the min val
      function minValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
      };

      setInitialValueAndObserver('min', minChange);
    }

    if (hasMaxAttr) {
      ctrl.$validators.max = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMaxValidator() {
        return true;
      } :
      // non-support browsers validate the max val
      function maxValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
      };

      setInitialValueAndObserver('max', maxChange);
    }

    if (hasStepAttr) {
      ctrl.$validators.step = supportsRange ? function nativeStepValidator() {
        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
        // input element value to a valid value). It's possible that other browsers set the stepMismatch
        // validity error instead, so we can at least report an error in that case.
        return !validity.stepMismatch;
      } :
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
      function stepValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) || isValidForStep(viewValue, minVal || 0, stepVal);
      };

      setInitialValueAndObserver('step', stepChange);
    }

    function setInitialValueAndObserver(htmlAttrName, changeFn) {
      // interpolated attributes set the attribute value only after a digest, but we need the
      // attribute value when the input is first rendered, so that the browser can adjust the
      // input value based on the min/max value
      element.attr(htmlAttrName, attr[htmlAttrName]);
      attr.$observe(htmlAttrName, changeFn);
    }

    function minChange(val) {
      minVal = parseNumberAttrVal(val);
      // ignore changes before model is initialized
      if (isNumberNaN(ctrl.$modelValue)) {
        return;
      }

      if (supportsRange) {
        var elVal = element.val();
        // IE11 doesn't set the el val correctly if the minVal is greater than the element value
        if (minVal > elVal) {
          elVal = minVal;
          element.val(elVal);
        }
        ctrl.$setViewValue(elVal);
      } else {
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    }

    function maxChange(val) {
      maxVal = parseNumberAttrVal(val);
      // ignore changes before model is initialized
      if (isNumberNaN(ctrl.$modelValue)) {
        return;
      }

      if (supportsRange) {
        var elVal = element.val();
        // IE11 doesn't set the el val correctly if the maxVal is less than the element value
        if (maxVal < elVal) {
          element.val(maxVal);
          // IE11 and Chrome don't set the value to the minVal when max < min
          elVal = maxVal < minVal ? minVal : maxVal;
        }
        ctrl.$setViewValue(elVal);
      } else {
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    }

    function stepChange(val) {
      stepVal = parseNumberAttrVal(val);
      // ignore changes before model is initialized
      if (isNumberNaN(ctrl.$modelValue)) {
        return;
      }

      // Some browsers don't adjust the input value correctly, but set the stepMismatch error
      if (supportsRange && ctrl.$viewValue !== element.val()) {
        ctrl.$setViewValue(element.val());
      } else {
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    }
  }

  function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    // Note: no badInputChecker here by purpose as `url` is only a validation
    // in browsers, i.e. we can always read out input.value even if it is not valid!
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    stringBasedInputType(ctrl);

    ctrl.$$parserName = 'url';
    ctrl.$validators.url = function (modelValue, viewValue) {
      var value = modelValue || viewValue;
      return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
    };
  }

  function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    // Note: no badInputChecker here by purpose as `url` is only a validation
    // in browsers, i.e. we can always read out input.value even if it is not valid!
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    stringBasedInputType(ctrl);

    ctrl.$$parserName = 'email';
    ctrl.$validators.email = function (modelValue, viewValue) {
      var value = modelValue || viewValue;
      return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
    };
  }

  function radioInputType(scope, element, attr, ctrl) {
    var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
    // make the name unique, if not defined
    if (isUndefined(attr.name)) {
      element.attr('name', nextUid());
    }

    var listener = function listener(ev) {
      var value;
      if (element[0].checked) {
        value = attr.value;
        if (doTrim) {
          value = trim(value);
        }
        ctrl.$setViewValue(value, ev && ev.type);
      }
    };

    element.on('click', listener);

    ctrl.$render = function () {
      var value = attr.value;
      if (doTrim) {
        value = trim(value);
      }
      element[0].checked = value === ctrl.$viewValue;
    };

    attr.$observe('value', ctrl.$render);
  }

  function parseConstantExpr($parse, context, name, expression, fallback) {
    var parseFn;
    if (isDefined(expression)) {
      parseFn = $parse(expression);
      if (!parseFn.constant) {
        throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' + '`{1}`.', name, expression);
      }
      return parseFn(context);
    }
    return fallback;
  }

  function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
    var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
    var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);

    var listener = function listener(ev) {
      ctrl.$setViewValue(element[0].checked, ev && ev.type);
    };

    element.on('click', listener);

    ctrl.$render = function () {
      element[0].checked = ctrl.$viewValue;
    };

    // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
    // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
    // it to a boolean.
    ctrl.$isEmpty = function (value) {
      return value === false;
    };

    ctrl.$formatters.push(function (value) {
      return equals(value, trueValue);
    });

    ctrl.$parsers.push(function (value) {
      return value ? trueValue : falseValue;
    });
  }

  /**
   * @ngdoc directive
   * @name textarea
   * @restrict E
   *
   * @description
   * HTML textarea element control with AngularJS data-binding. The data-binding and validation
   * properties of this element are exactly the same as those of the
   * {@link ng.directive:input input element}.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
   *    length.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *
   * @knownIssue
   *
   * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
   * insert the placeholder value as the textarea's content. If the placeholder value contains
   * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
   * the value of the by-then-removed text node. This doesn't affect the functionality of the
   * textarea, but can be undesirable.
   *
   * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
   * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
   * find more details on `ngAttr` in the
   * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
   * Developer Guide.
   */

  /**
   * @ngdoc directive
   * @name input
   * @restrict E
   *
   * @description
   * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
   * input state control, and validation.
   * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
   *
   * <div class="alert alert-warning">
   * **Note:** Not every feature offered is available for all input types.
   * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {boolean=} ngRequired Sets `required` attribute if set to true
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
   *    length.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="input-directive" module="inputExample">
        <file name="index.html">
         <script>
            angular.module('inputExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.user = {name: 'guest', last: 'visitor'};
              }]);
         </script>
         <div ng-controller="ExampleController">
           <form name="myForm">
             <label>
                User name:
                <input type="text" name="userName" ng-model="user.name" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.userName.$error.required">
                Required!</span>
             </div>
             <label>
                Last name:
                <input type="text" name="lastName" ng-model="user.last"
                ng-minlength="3" ng-maxlength="10">
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.lastName.$error.minlength">
                 Too short!</span>
               <span class="error" ng-show="myForm.lastName.$error.maxlength">
                 Too long!</span>
             </div>
           </form>
           <hr>
           <tt>user = {{user}}</tt><br/>
           <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
           <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
           <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
           <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
           <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
         </div>
        </file>
        <file name="protractor.js" type="protractor">
          var user = element(by.exactBinding('user'));
          var userNameValid = element(by.binding('myForm.userName.$valid'));
          var lastNameValid = element(by.binding('myForm.lastName.$valid'));
          var lastNameError = element(by.binding('myForm.lastName.$error'));
          var formValid = element(by.binding('myForm.$valid'));
          var userNameInput = element(by.model('user.name'));
          var userLastInput = element(by.model('user.last'));
  
          it('should initialize to model', function() {
            expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
            expect(userNameValid.getText()).toContain('true');
            expect(formValid.getText()).toContain('true');
          });
  
          it('should be invalid if empty when required', function() {
            userNameInput.clear();
            userNameInput.sendKeys('');
  
            expect(user.getText()).toContain('{"last":"visitor"}');
            expect(userNameValid.getText()).toContain('false');
            expect(formValid.getText()).toContain('false');
          });
  
          it('should be valid if empty when min length is set', function() {
            userLastInput.clear();
            userLastInput.sendKeys('');
  
            expect(user.getText()).toContain('{"name":"guest","last":""}');
            expect(lastNameValid.getText()).toContain('true');
            expect(formValid.getText()).toContain('true');
          });
  
          it('should be invalid if less than required min length', function() {
            userLastInput.clear();
            userLastInput.sendKeys('xx');
  
            expect(user.getText()).toContain('{"name":"guest"}');
            expect(lastNameValid.getText()).toContain('false');
            expect(lastNameError.getText()).toContain('minlength');
            expect(formValid.getText()).toContain('false');
          });
  
          it('should be invalid if longer than max length', function() {
            userLastInput.clear();
            userLastInput.sendKeys('some ridiculously long name');
  
            expect(user.getText()).toContain('{"name":"guest"}');
            expect(lastNameValid.getText()).toContain('false');
            expect(lastNameError.getText()).toContain('maxlength');
            expect(formValid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  var inputDirective = ['$browser', '$sniffer', '$filter', '$parse', function ($browser, $sniffer, $filter, $parse) {
    return {
      restrict: 'E',
      require: ['?ngModel'],
      link: {
        pre: function pre(scope, element, attr, ctrls) {
          if (ctrls[0]) {
            (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer, $browser, $filter, $parse);
          }
        }
      }
    };
  }];

  var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
  /**
   * @ngdoc directive
   * @name ngValue
   * @restrict A
   * @priority 100
   *
   * @description
   * Binds the given expression to the value of the element.
   *
   * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
   * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
   * {@link select `select`} parent element) is set to the bound value. It is especially useful
   * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
   *
   * It can also be used to achieve one-way binding of a given expression to an input element
   * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
   *
   * @element ANY
   * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
   * and `value` property of the element.
   *
   * @example
      <example name="ngValue-directive" module="valueExample">
        <file name="index.html">
         <script>
            angular.module('valueExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.names = ['pizza', 'unicorns', 'robots'];
                $scope.my = { favorite: 'unicorns' };
              }]);
         </script>
          <form ng-controller="ExampleController">
            <h2>Which is your favorite?</h2>
              <label ng-repeat="name in names" for="{{name}}">
                {{name}}
                <input type="radio"
                       ng-model="my.favorite"
                       ng-value="name"
                       id="{{name}}"
                       name="favorite">
              </label>
            <div>You chose {{my.favorite}}</div>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var favorite = element(by.binding('my.favorite'));
  
          it('should initialize to model', function() {
            expect(favorite.getText()).toContain('unicorns');
          });
          it('should bind the values to the inputs', function() {
            element.all(by.model('my.favorite')).get(0).click();
            expect(favorite.getText()).toContain('pizza');
          });
        </file>
      </example>
   */
  var ngValueDirective = function ngValueDirective() {
    /**
     *  inputs use the value attribute as their default value if the value property is not set.
     *  Once the value property has been set (by adding input), it will not react to changes to
     *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
     *  makes it possible to use ngValue as a sort of one-way bind.
     */
    function updateElementValue(element, attr, value) {
      // Support: IE9 only
      // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
      var propValue = isDefined(value) ? value : msie === 9 ? '' : null;
      element.prop('value', propValue);
      attr.$set('value', value);
    }

    return {
      restrict: 'A',
      priority: 100,
      compile: function compile(tpl, tplAttr) {
        if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
          return function ngValueConstantLink(scope, elm, attr) {
            var value = scope.$eval(attr.ngValue);
            updateElementValue(elm, attr, value);
          };
        } else {
          return function ngValueLink(scope, elm, attr) {
            scope.$watch(attr.ngValue, function valueWatchAction(value) {
              updateElementValue(elm, attr, value);
            });
          };
        }
      }
    };
  };

  /**
   * @ngdoc directive
   * @name ngBind
   * @restrict AC
   *
   * @description
   * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
   * with the value of a given expression, and to update the text content when the value of that
   * expression changes.
   *
   * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
   * `{{ expression }}` which is similar but less verbose.
   *
   * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
   * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
   * element attribute, it makes the bindings invisible to the user while the page is loading.
   *
   * An alternative solution to this problem would be using the
   * {@link ng.directive:ngCloak ngCloak} directive.
   *
   *
   * @element ANY
   * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
   *
   * @example
   * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
     <example module="bindExample" name="ng-bind">
       <file name="index.html">
         <script>
           angular.module('bindExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.name = 'Whirled';
             }]);
         </script>
         <div ng-controller="ExampleController">
           <label>Enter name: <input type="text" ng-model="name"></label><br>
           Hello <span ng-bind="name"></span>!
         </div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-bind', function() {
           var nameInput = element(by.model('name'));
  
           expect(element(by.binding('name')).getText()).toBe('Whirled');
           nameInput.clear();
           nameInput.sendKeys('world');
           expect(element(by.binding('name')).getText()).toBe('world');
         });
       </file>
     </example>
   */
  var ngBindDirective = ['$compile', function ($compile) {
    return {
      restrict: 'AC',
      compile: function ngBindCompile(templateElement) {
        $compile.$$addBindingClass(templateElement);
        return function ngBindLink(scope, element, attr) {
          $compile.$$addBindingInfo(element, attr.ngBind);
          element = element[0];
          scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
            element.textContent = stringify(value);
          });
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngBindTemplate
   *
   * @description
   * The `ngBindTemplate` directive specifies that the element
   * text content should be replaced with the interpolation of the template
   * in the `ngBindTemplate` attribute.
   * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
   * expressions. This directive is needed since some HTML elements
   * (such as TITLE and OPTION) cannot contain SPAN elements.
   *
   * @element ANY
   * @param {string} ngBindTemplate template of form
   *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
   *
   * @example
   * Try it here: enter text in text box and watch the greeting change.
     <example module="bindExample" name="ng-bind-template">
       <file name="index.html">
         <script>
           angular.module('bindExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.salutation = 'Hello';
               $scope.name = 'World';
             }]);
         </script>
         <div ng-controller="ExampleController">
          <label>Salutation: <input type="text" ng-model="salutation"></label><br>
          <label>Name: <input type="text" ng-model="name"></label><br>
          <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
         </div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-bind', function() {
           var salutationElem = element(by.binding('salutation'));
           var salutationInput = element(by.model('salutation'));
           var nameInput = element(by.model('name'));
  
           expect(salutationElem.getText()).toBe('Hello World!');
  
           salutationInput.clear();
           salutationInput.sendKeys('Greetings');
           nameInput.clear();
           nameInput.sendKeys('user');
  
           expect(salutationElem.getText()).toBe('Greetings user!');
         });
       </file>
     </example>
   */
  var ngBindTemplateDirective = ['$interpolate', '$compile', function ($interpolate, $compile) {
    return {
      compile: function ngBindTemplateCompile(templateElement) {
        $compile.$$addBindingClass(templateElement);
        return function ngBindTemplateLink(scope, element, attr) {
          var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
          $compile.$$addBindingInfo(element, interpolateFn.expressions);
          element = element[0];
          attr.$observe('ngBindTemplate', function (value) {
            element.textContent = isUndefined(value) ? '' : value;
          });
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngBindHtml
   *
   * @description
   * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
   * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
   * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
   * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
   * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
   *
   * You may also bypass sanitization for values you know are safe. To do so, bind to
   * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
   * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
   *
   * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
   * will have an exception (instead of an exploit.)
   *
   * @element ANY
   * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
   *
   * @example
  
     <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
       <file name="index.html">
         <div ng-controller="ExampleController">
          <p ng-bind-html="myHTML"></p>
         </div>
       </file>
  
       <file name="script.js">
         angular.module('bindHtmlExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.myHTML =
                'I am an <code>HTML</code>string with ' +
                '<a href="#">links!</a> and other <em>stuff</em>';
           }]);
       </file>
  
       <file name="protractor.js" type="protractor">
         it('should check ng-bind-html', function() {
           expect(element(by.binding('myHTML')).getText()).toBe(
               'I am an HTMLstring with links! and other stuff');
         });
       </file>
     </example>
   */
  var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function ($sce, $parse, $compile) {
    return {
      restrict: 'A',
      compile: function ngBindHtmlCompile(tElement, tAttrs) {
        var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
        var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
          // Unwrap the value to compare the actual inner safe value, not the wrapper object.
          return $sce.valueOf(val);
        });
        $compile.$$addBindingClass(tElement);

        return function ngBindHtmlLink(scope, element, attr) {
          $compile.$$addBindingInfo(element, attr.ngBindHtml);

          scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
            // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
            var value = ngBindHtmlGetter(scope);
            element.html($sce.getTrustedHtml(value) || '');
          });
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngChange
   * @restrict A
   *
   * @description
   * Evaluate the given expression when the user changes the input.
   * The expression is evaluated immediately, unlike the JavaScript onchange event
   * which only triggers at the end of a change (usually, when the user leaves the
   * form element or presses the return key).
   *
   * The `ngChange` expression is only evaluated when a change in the input value causes
   * a new value to be committed to the model.
   *
   * It will not be evaluated:
   * * if the value returned from the `$parsers` transformation pipeline has not changed
   * * if the input has continued to be invalid since the model will stay `null`
   * * if the model is changed programmatically and not by a change to the input value
   *
   *
   * Note, this directive requires `ngModel` to be present.
   *
   * @element ANY
   * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
   * in input value.
   *
   * @example
   * <example name="ngChange-directive" module="changeExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('changeExample', [])
   *         .controller('ExampleController', ['$scope', function($scope) {
   *           $scope.counter = 0;
   *           $scope.change = function() {
   *             $scope.counter++;
   *           };
   *         }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
   *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
   *       <label for="ng-change-example2">Confirmed</label><br />
   *       <tt>debug = {{confirmed}}</tt><br/>
   *       <tt>counter = {{counter}}</tt><br/>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     var counter = element(by.binding('counter'));
   *     var debug = element(by.binding('confirmed'));
   *
   *     it('should evaluate the expression if changing from view', function() {
   *       expect(counter.getText()).toContain('0');
   *
   *       element(by.id('ng-change-example1')).click();
   *
   *       expect(counter.getText()).toContain('1');
   *       expect(debug.getText()).toContain('true');
   *     });
   *
   *     it('should not evaluate the expression if changing from model', function() {
   *       element(by.id('ng-change-example2')).click();
  
   *       expect(counter.getText()).toContain('0');
   *       expect(debug.getText()).toContain('true');
   *     });
   *   </file>
   * </example>
   */
  var ngChangeDirective = valueFn({
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attr, ctrl) {
      ctrl.$viewChangeListeners.push(function () {
        scope.$eval(attr.ngChange);
      });
    }
  });

  /* exported
    ngClassDirective,
    ngClassEvenDirective,
    ngClassOddDirective
  */

  function classDirective(name, selector) {
    name = 'ngClass' + name;
    var indexWatchExpression;

    return ['$parse', function ($parse) {
      return {
        restrict: 'AC',
        link: function link(scope, element, attr) {
          var expression = attr[name].trim();
          var isOneTime = expression.charAt(0) === ':' && expression.charAt(1) === ':';

          var watchInterceptor = isOneTime ? toFlatValue : toClassString;
          var watchExpression = $parse(expression, watchInterceptor);
          var watchAction = isOneTime ? ngClassOneTimeWatchAction : ngClassWatchAction;

          var classCounts = element.data('$classCounts');
          var oldModulo = true;
          var oldClassString;

          if (!classCounts) {
            // Use createMap() to prevent class assumptions involving property
            // names in Object.prototype
            classCounts = createMap();
            element.data('$classCounts', classCounts);
          }

          if (name !== 'ngClass') {
            if (!indexWatchExpression) {
              indexWatchExpression = $parse('$index', function moduloTwo($index) {
                // eslint-disable-next-line no-bitwise
                return $index & 1;
              });
            }

            scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
          }

          scope.$watch(watchExpression, watchAction, isOneTime);

          function addClasses(classString) {
            classString = digestClassCounts(split(classString), 1);
            attr.$addClass(classString);
          }

          function removeClasses(classString) {
            classString = digestClassCounts(split(classString), -1);
            attr.$removeClass(classString);
          }

          function updateClasses(oldClassString, newClassString) {
            var oldClassArray = split(oldClassString);
            var newClassArray = split(newClassString);

            var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
            var toAddArray = arrayDifference(newClassArray, oldClassArray);

            var toRemoveString = digestClassCounts(toRemoveArray, -1);
            var toAddString = digestClassCounts(toAddArray, 1);

            attr.$addClass(toAddString);
            attr.$removeClass(toRemoveString);
          }

          function digestClassCounts(classArray, count) {
            var classesToUpdate = [];

            forEach(classArray, function (className) {
              if (count > 0 || classCounts[className]) {
                classCounts[className] = (classCounts[className] || 0) + count;
                if (classCounts[className] === +(count > 0)) {
                  classesToUpdate.push(className);
                }
              }
            });

            return classesToUpdate.join(' ');
          }

          function ngClassIndexWatchAction(newModulo) {
            // This watch-action should run before the `ngClass[OneTime]WatchAction()`, thus it
            // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
            // `ngClass[OneTime]WatchAction()` will update the classes.
            if (newModulo === selector) {
              addClasses(oldClassString);
            } else {
              removeClasses(oldClassString);
            }

            oldModulo = newModulo;
          }

          function ngClassOneTimeWatchAction(newClassValue) {
            var newClassString = toClassString(newClassValue);

            if (newClassString !== oldClassString) {
              ngClassWatchAction(newClassString);
            }
          }

          function ngClassWatchAction(newClassString) {
            if (oldModulo === selector) {
              updateClasses(oldClassString, newClassString);
            }

            oldClassString = newClassString;
          }
        }
      };
    }];

    // Helpers
    function arrayDifference(tokens1, tokens2) {
      if (!tokens1 || !tokens1.length) return [];
      if (!tokens2 || !tokens2.length) return tokens1;

      var values = [];

      outer: for (var i = 0; i < tokens1.length; i++) {
        var token = tokens1[i];
        for (var j = 0; j < tokens2.length; j++) {
          if (token === tokens2[j]) continue outer;
        }
        values.push(token);
      }

      return values;
    }

    function split(classString) {
      return classString && classString.split(' ');
    }

    function toClassString(classValue) {
      var classString = classValue;

      if (isArray(classValue)) {
        classString = classValue.map(toClassString).join(' ');
      } else if (isObject(classValue)) {
        classString = Object.keys(classValue).filter(function (key) {
          return classValue[key];
        }).join(' ');
      }

      return classString;
    }

    function toFlatValue(classValue) {
      var flatValue = classValue;

      if (isArray(classValue)) {
        flatValue = classValue.map(toFlatValue);
      } else if (isObject(classValue)) {
        var hasUndefined = false;

        flatValue = Object.keys(classValue).filter(function (key) {
          var value = classValue[key];

          if (!hasUndefined && isUndefined(value)) {
            hasUndefined = true;
          }

          return value;
        });

        if (hasUndefined) {
          // Prevent the `oneTimeLiteralWatchInterceptor` from unregistering
          // the watcher, by including at least one `undefined` value.
          flatValue.push(undefined);
        }
      }

      return flatValue;
    }
  }

  /**
   * @ngdoc directive
   * @name ngClass
   * @restrict AC
   * @element ANY
   *
   * @description
   * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
   * an expression that represents all classes to be added.
   *
   * The directive operates in three different ways, depending on which of three types the expression
   * evaluates to:
   *
   * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
   * names.
   *
   * 2. If the expression evaluates to an object, then for each key-value pair of the
   * object with a truthy value the corresponding key is used as a class name.
   *
   * 3. If the expression evaluates to an array, each element of the array should either be a string as in
   * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
   * to give you more control over what CSS classes appear. See the code below for an example of this.
   *
   *
   * The directive won't add duplicate classes if a particular class was already set.
   *
   * When the expression changes, the previously added classes are removed and only then are the
   * new classes added.
   *
   * @knownIssue
   * You should not use {@link guide/interpolation interpolation} in the value of the `class`
   * attribute, when using the `ngClass` directive on the same element.
   * See {@link guide/interpolation#known-issues here} for more info.
   *
   * @animations
   * | Animation                        | Occurs                              |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
   * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
   *
   * ### ngClass and pre-existing CSS3 Transitions/Animations
     The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
     Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
     any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
     to view the step by step details of {@link $animate#addClass $animate.addClass} and
     {@link $animate#removeClass $animate.removeClass}.
   *
   * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
   *   of the evaluation can be a string representing space delimited class
   *   names, an array, or a map of class names to boolean values. In the case of a map, the
   *   names of the properties whose values are truthy will be added as css classes to the
   *   element.
   *
   * @example
   * ### Basic
     <example name="ng-class">
       <file name="index.html">
         <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
         <label>
            <input type="checkbox" ng-model="deleted">
            deleted (apply "strike" class)
         </label><br>
         <label>
            <input type="checkbox" ng-model="important">
            important (apply "bold" class)
         </label><br>
         <label>
            <input type="checkbox" ng-model="error">
            error (apply "has-error" class)
         </label>
         <hr>
         <p ng-class="style">Using String Syntax</p>
         <input type="text" ng-model="style"
                placeholder="Type: bold strike red" aria-label="Type: bold strike red">
         <hr>
         <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
         <input ng-model="style1"
                placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
         <input ng-model="style2"
                placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
         <input ng-model="style3"
                placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
         <hr>
         <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
         <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
         <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
       </file>
       <file name="style.css">
         .strike {
             text-decoration: line-through;
         }
         .bold {
             font-weight: bold;
         }
         .red {
             color: red;
         }
         .has-error {
             color: red;
             background-color: yellow;
         }
         .orange {
             color: orange;
         }
       </file>
       <file name="protractor.js" type="protractor">
         var ps = element.all(by.css('p'));
  
         it('should let you toggle the class', function() {
  
           expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
           expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
  
           element(by.model('important')).click();
           expect(ps.first().getAttribute('class')).toMatch(/bold/);
  
           element(by.model('error')).click();
           expect(ps.first().getAttribute('class')).toMatch(/has-error/);
         });
  
         it('should let you toggle string example', function() {
           expect(ps.get(1).getAttribute('class')).toBe('');
           element(by.model('style')).clear();
           element(by.model('style')).sendKeys('red');
           expect(ps.get(1).getAttribute('class')).toBe('red');
         });
  
         it('array example should have 3 classes', function() {
           expect(ps.get(2).getAttribute('class')).toBe('');
           element(by.model('style1')).sendKeys('bold');
           element(by.model('style2')).sendKeys('strike');
           element(by.model('style3')).sendKeys('red');
           expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
         });
  
         it('array with map example should have 2 classes', function() {
           expect(ps.last().getAttribute('class')).toBe('');
           element(by.model('style4')).sendKeys('bold');
           element(by.model('warning')).click();
           expect(ps.last().getAttribute('class')).toBe('bold orange');
         });
       </file>
     </example>
  
     @example
     ### Animations
  
     The example below demonstrates how to perform animations using ngClass.
  
     <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
       <file name="index.html">
        <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
        <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
        <br>
        <span class="base-class" ng-class="myVar">Sample Text</span>
       </file>
       <file name="style.css">
         .base-class {
           transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
         }
  
         .base-class.my-class {
           color: red;
           font-size:3em;
         }
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-class', function() {
           expect(element(by.css('.base-class')).getAttribute('class')).not.
             toMatch(/my-class/);
  
           element(by.id('setbtn')).click();
  
           expect(element(by.css('.base-class')).getAttribute('class')).
             toMatch(/my-class/);
  
           element(by.id('clearbtn')).click();
  
           expect(element(by.css('.base-class')).getAttribute('class')).not.
             toMatch(/my-class/);
         });
       </file>
     </example>
   */
  var ngClassDirective = classDirective('', true);

  /**
   * @ngdoc directive
   * @name ngClassOdd
   * @restrict AC
   *
   * @description
   * The `ngClassOdd` and `ngClassEven` directives work exactly as
   * {@link ng.directive:ngClass ngClass}, except they work in
   * conjunction with `ngRepeat` and take effect only on odd (even) rows.
   *
   * This directive can be applied only within the scope of an
   * {@link ng.directive:ngRepeat ngRepeat}.
   *
   * @element ANY
   * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
   *   of the evaluation can be a string representing space delimited class names or an array.
   *
   * @example
     <example name="ng-class-odd">
       <file name="index.html">
          <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
            <li ng-repeat="name in names">
             <span ng-class-odd="'odd'" ng-class-even="'even'">
               {{name}}
             </span>
            </li>
          </ol>
       </file>
       <file name="style.css">
         .odd {
           color: red;
         }
         .even {
           color: blue;
         }
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-class-odd and ng-class-even', function() {
           expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
             toMatch(/odd/);
           expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
             toMatch(/even/);
         });
       </file>
     </example>
   */
  var ngClassOddDirective = classDirective('Odd', 0);

  /**
   * @ngdoc directive
   * @name ngClassEven
   * @restrict AC
   *
   * @description
   * The `ngClassOdd` and `ngClassEven` directives work exactly as
   * {@link ng.directive:ngClass ngClass}, except they work in
   * conjunction with `ngRepeat` and take effect only on odd (even) rows.
   *
   * This directive can be applied only within the scope of an
   * {@link ng.directive:ngRepeat ngRepeat}.
   *
   * @element ANY
   * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
   *   result of the evaluation can be a string representing space delimited class names or an array.
   *
   * @example
     <example name="ng-class-even">
       <file name="index.html">
          <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
            <li ng-repeat="name in names">
             <span ng-class-odd="'odd'" ng-class-even="'even'">
               {{name}} &nbsp; &nbsp; &nbsp;
             </span>
            </li>
          </ol>
       </file>
       <file name="style.css">
         .odd {
           color: red;
         }
         .even {
           color: blue;
         }
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-class-odd and ng-class-even', function() {
           expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
             toMatch(/odd/);
           expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
             toMatch(/even/);
         });
       </file>
     </example>
   */
  var ngClassEvenDirective = classDirective('Even', 1);

  /**
   * @ngdoc directive
   * @name ngCloak
   * @restrict AC
   *
   * @description
   * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
   * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
   * directive to avoid the undesirable flicker effect caused by the html template display.
   *
   * The directive can be applied to the `<body>` element, but the preferred usage is to apply
   * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
   * of the browser view.
   *
   * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
   * `angular.min.js`.
   * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
   *
   * ```css
   * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
   *   display: none !important;
   * }
   * ```
   *
   * When this css rule is loaded by the browser, all html elements (including their children) that
   * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
   * during the compilation of the template it deletes the `ngCloak` element attribute, making
   * the compiled element visible.
   *
   * For the best result, the `angular.js` script must be loaded in the head section of the html
   * document; alternatively, the css rule above must be included in the external stylesheet of the
   * application.
   *
   * @element ANY
   *
   * @example
     <example name="ng-cloak">
       <file name="index.html">
          <div id="template1" ng-cloak>{{ 'hello' }}</div>
          <div id="template2" class="ng-cloak">{{ 'world' }}</div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should remove the template directive and css class', function() {
           expect($('#template1').getAttribute('ng-cloak')).
             toBeNull();
           expect($('#template2').getAttribute('ng-cloak')).
             toBeNull();
         });
       </file>
     </example>
   *
   */
  var ngCloakDirective = ngDirective({
    compile: function compile(element, attr) {
      attr.$set('ngCloak', undefined);
      element.removeClass('ng-cloak');
    }
  });

  /**
   * @ngdoc directive
   * @name ngController
   *
   * @description
   * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
   * supports the principles behind the Model-View-Controller design pattern.
   *
   * MVC components in angular:
   *
   * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
   *   are accessed through bindings.
   * * View — The template (HTML with data bindings) that is rendered into the View.
   * * Controller — The `ngController` directive specifies a Controller class; the class contains business
   *   logic behind the application to decorate the scope with functions and values
   *
   * Note that you can also attach controllers to the DOM by declaring it in a route definition
   * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
   * again using `ng-controller` in the template itself.  This will cause the controller to be attached
   * and executed twice.
   *
   * @element ANY
   * @scope
   * @priority 500
   * @param {expression} ngController Name of a constructor function registered with the current
   * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
   * that on the current scope evaluates to a constructor function.
   *
   * The controller instance can be published into a scope property by specifying
   * `ng-controller="as propertyName"`.
   *
   * If the current `$controllerProvider` is configured to use globals (via
   * {@link ng.$controllerProvider#allowGlobals `$controllerProvider.allowGlobals()` }), this may
   * also be the name of a globally accessible constructor function (deprecated, not recommended).
   *
   * @example
   * Here is a simple form for editing user contact information. Adding, removing, clearing, and
   * greeting are methods declared on the controller (see source tab). These methods can
   * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
   * in the View without the need for a manual update.
   *
   * Two different declaration styles are included below:
   *
   * * one binds methods and properties directly onto the controller using `this`:
   * `ng-controller="SettingsController1 as settings"`
   * * one injects `$scope` into the controller:
   * `ng-controller="SettingsController2"`
   *
   * The second option is more common in the AngularJS community, and is generally used in boilerplates
   * and in this guide. However, there are advantages to binding properties directly to the controller
   * and avoiding scope.
   *
   * * Using `controller as` makes it obvious which controller you are accessing in the template when
   * multiple controllers apply to an element.
   * * If you are writing your controllers as classes you have easier access to the properties and
   * methods, which will appear on the scope, from inside the controller code.
   * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
   * inheritance masking primitives.
   *
   * This example demonstrates the `controller as` syntax.
   *
   * <example name="ngControllerAs" module="controllerAsExample">
   *   <file name="index.html">
   *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
   *      <label>Name: <input type="text" ng-model="settings.name"/></label>
   *      <button ng-click="settings.greet()">greet</button><br/>
   *      Contact:
   *      <ul>
   *        <li ng-repeat="contact in settings.contacts">
   *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
   *             <option>phone</option>
   *             <option>email</option>
   *          </select>
   *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
   *          <button ng-click="settings.clearContact(contact)">clear</button>
   *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
   *        </li>
   *        <li><button ng-click="settings.addContact()">add</button></li>
   *     </ul>
   *    </div>
   *   </file>
   *   <file name="app.js">
   *    angular.module('controllerAsExample', [])
   *      .controller('SettingsController1', SettingsController1);
   *
   *    function SettingsController1() {
   *      this.name = 'John Smith';
   *      this.contacts = [
   *        {type: 'phone', value: '408 555 1212'},
   *        {type: 'email', value: 'john.smith@example.org'}
   *      ];
   *    }
   *
   *    SettingsController1.prototype.greet = function() {
   *      alert(this.name);
   *    };
   *
   *    SettingsController1.prototype.addContact = function() {
   *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
   *    };
   *
   *    SettingsController1.prototype.removeContact = function(contactToRemove) {
   *     var index = this.contacts.indexOf(contactToRemove);
   *      this.contacts.splice(index, 1);
   *    };
   *
   *    SettingsController1.prototype.clearContact = function(contact) {
   *      contact.type = 'phone';
   *      contact.value = '';
   *    };
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     it('should check controller as', function() {
   *       var container = element(by.id('ctrl-as-exmpl'));
   *         expect(container.element(by.model('settings.name'))
   *           .getAttribute('value')).toBe('John Smith');
   *
   *       var firstRepeat =
   *           container.element(by.repeater('contact in settings.contacts').row(0));
   *       var secondRepeat =
   *           container.element(by.repeater('contact in settings.contacts').row(1));
   *
   *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
   *           .toBe('408 555 1212');
   *
   *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
   *           .toBe('john.smith@example.org');
   *
   *       firstRepeat.element(by.buttonText('clear')).click();
   *
   *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
   *           .toBe('');
   *
   *       container.element(by.buttonText('add')).click();
   *
   *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
   *           .element(by.model('contact.value'))
   *           .getAttribute('value'))
   *           .toBe('yourname@example.org');
   *     });
   *   </file>
   * </example>
   *
   * This example demonstrates the "attach to `$scope`" style of controller.
   *
   * <example name="ngController" module="controllerExample">
   *  <file name="index.html">
   *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
   *     <label>Name: <input type="text" ng-model="name"/></label>
   *     <button ng-click="greet()">greet</button><br/>
   *     Contact:
   *     <ul>
   *       <li ng-repeat="contact in contacts">
   *         <select ng-model="contact.type" id="select_{{$index}}">
   *            <option>phone</option>
   *            <option>email</option>
   *         </select>
   *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
   *         <button ng-click="clearContact(contact)">clear</button>
   *         <button ng-click="removeContact(contact)">X</button>
   *       </li>
   *       <li>[ <button ng-click="addContact()">add</button> ]</li>
   *    </ul>
   *   </div>
   *  </file>
   *  <file name="app.js">
   *   angular.module('controllerExample', [])
   *     .controller('SettingsController2', ['$scope', SettingsController2]);
   *
   *   function SettingsController2($scope) {
   *     $scope.name = 'John Smith';
   *     $scope.contacts = [
   *       {type:'phone', value:'408 555 1212'},
   *       {type:'email', value:'john.smith@example.org'}
   *     ];
   *
   *     $scope.greet = function() {
   *       alert($scope.name);
   *     };
   *
   *     $scope.addContact = function() {
   *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
   *     };
   *
   *     $scope.removeContact = function(contactToRemove) {
   *       var index = $scope.contacts.indexOf(contactToRemove);
   *       $scope.contacts.splice(index, 1);
   *     };
   *
   *     $scope.clearContact = function(contact) {
   *       contact.type = 'phone';
   *       contact.value = '';
   *     };
   *   }
   *  </file>
   *  <file name="protractor.js" type="protractor">
   *    it('should check controller', function() {
   *      var container = element(by.id('ctrl-exmpl'));
   *
   *      expect(container.element(by.model('name'))
   *          .getAttribute('value')).toBe('John Smith');
   *
   *      var firstRepeat =
   *          container.element(by.repeater('contact in contacts').row(0));
   *      var secondRepeat =
   *          container.element(by.repeater('contact in contacts').row(1));
   *
   *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
   *          .toBe('408 555 1212');
   *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
   *          .toBe('john.smith@example.org');
   *
   *      firstRepeat.element(by.buttonText('clear')).click();
   *
   *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
   *          .toBe('');
   *
   *      container.element(by.buttonText('add')).click();
   *
   *      expect(container.element(by.repeater('contact in contacts').row(2))
   *          .element(by.model('contact.value'))
   *          .getAttribute('value'))
   *          .toBe('yourname@example.org');
   *    });
   *  </file>
   *</example>
  
   */
  var ngControllerDirective = [function () {
    return {
      restrict: 'A',
      scope: true,
      controller: '@',
      priority: 500
    };
  }];

  /**
   * @ngdoc directive
   * @name ngCsp
   *
   * @restrict A
   * @element ANY
   * @description
   *
   * AngularJS has some features that can conflict with certain restrictions that are applied when using
   * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
   *
   * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
   * features.
   *
   * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
   *
   *
   * The following default rules in CSP affect AngularJS:
   *
   * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
   * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
   * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
   * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
   * weaken the protections offered by CSP.)
   *
   * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
   * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
   * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
   * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
   * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
   * it is generally not recommended as it would weaken the protections offered by CSP.)
   *
   * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
   * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
   * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
   * CSP error to be logged in the console:
   *
   * ```
   * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
   * script in the following Content Security Policy directive: "default-src 'self'". Note that
   * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
   * ```
   *
   * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
   * directive on an element of the HTML document that appears before the `<script>` tag that loads
   * the `angular.js` file.
   *
   * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
   *
   * You can specify which of the CSP related AngularJS features should be deactivated by providing
   * a value for the `ng-csp` attribute. The options are as follows:
   *
   * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
   *
   * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
   *
   * You can use these values in the following combinations:
   *
   *
   * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
   * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
   * versions of AngularJS.
   *
   * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
   * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
   * versions of AngularJS.
   *
   * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
   * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
   *
   * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
   * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
   *
   * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
   * styles nor use eval, which is the same as an empty: ng-csp.
   * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
   *
   * @example
   *
   * This example shows how to apply the `ngCsp` directive to the `html` tag.
     ```html
       <!doctype html>
       <html ng-app ng-csp>
       ...
       ...
       </html>
     ```
  
    <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
    <example name="example.csp" module="cspExample" ng-csp="true">
      <file name="index.html">
        <div ng-controller="MainController as ctrl">
          <div>
            <button ng-click="ctrl.inc()" id="inc">Increment</button>
            <span id="counter">
              {{ctrl.counter}}
            </span>
          </div>
  
          <div>
            <button ng-click="ctrl.evil()" id="evil">Evil</button>
            <span id="evilError">
              {{ctrl.evilError}}
            </span>
          </div>
        </div>
      </file>
      <file name="script.js">
         angular.module('cspExample', [])
           .controller('MainController', function MainController() {
              this.counter = 0;
              this.inc = function() {
                this.counter++;
              };
              this.evil = function() {
                try {
                  eval('1+2'); // eslint-disable-line no-eval
                } catch (e) {
                  this.evilError = e.message;
                }
              };
            });
      </file>
      <file name="protractor.js" type="protractor">
        var util, webdriver;
  
        var incBtn = element(by.id('inc'));
        var counter = element(by.id('counter'));
        var evilBtn = element(by.id('evil'));
        var evilError = element(by.id('evilError'));
  
        function getAndClearSevereErrors() {
          return browser.manage().logs().get('browser').then(function(browserLog) {
            return browserLog.filter(function(logEntry) {
              return logEntry.level.value > webdriver.logging.Level.WARNING.value;
            });
          });
        }
  
        function clearErrors() {
          getAndClearSevereErrors();
        }
  
        function expectNoErrors() {
          getAndClearSevereErrors().then(function(filteredLog) {
            expect(filteredLog.length).toEqual(0);
            if (filteredLog.length) {
              console.log('browser console errors: ' + util.inspect(filteredLog));
            }
          });
        }
  
        function expectError(regex) {
          getAndClearSevereErrors().then(function(filteredLog) {
            var found = false;
            filteredLog.forEach(function(log) {
              if (log.message.match(regex)) {
                found = true;
              }
            });
            if (!found) {
              throw new Error('expected an error that matches ' + regex);
            }
          });
        }
  
        beforeEach(function() {
          util = require('util');
          webdriver = require('selenium-webdriver');
        });
  
        // For now, we only test on Chrome,
        // as Safari does not load the page with Protractor's injected scripts,
        // and Firefox webdriver always disables content security policy (#6358)
        if (browser.params.browser !== 'chrome') {
          return;
        }
  
        it('should not report errors when the page is loaded', function() {
          // clear errors so we are not dependent on previous tests
          clearErrors();
          // Need to reload the page as the page is already loaded when
          // we come here
          browser.driver.getCurrentUrl().then(function(url) {
            browser.get(url);
          });
          expectNoErrors();
        });
  
        it('should evaluate expressions', function() {
          expect(counter.getText()).toEqual('0');
          incBtn.click();
          expect(counter.getText()).toEqual('1');
          expectNoErrors();
        });
  
        it('should throw and report an error when using "eval"', function() {
          evilBtn.click();
          expect(evilError.getText()).toMatch(/Content Security Policy/);
          expectError(/Content Security Policy/);
        });
      </file>
    </example>
    */

  // `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
  // we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
  // fn that looks for the `ng-csp` attribute anywhere in the current doc.

  /**
   * @ngdoc directive
   * @name ngClick
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * The ngClick directive allows you to specify custom behavior when
   * an element is clicked.
   *
   * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
   * click. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-click">
       <file name="index.html">
        <button ng-click="count = count + 1" ng-init="count=0">
          Increment
        </button>
        <span>
          count: {{count}}
        </span>
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-click', function() {
           expect(element(by.binding('count')).getText()).toMatch('0');
           element(by.css('button')).click();
           expect(element(by.binding('count')).getText()).toMatch('1');
         });
       </file>
     </example>
   */
  /*
   * A collection of directives that allows creation of custom event handlers that are defined as
   * AngularJS expressions and are compiled and executed within the current scope.
   */
  var ngEventDirectives = {};

  // For events that might fire synchronously during DOM manipulation
  // we need to execute their event handlers asynchronously using $evalAsync,
  // so that they are not executed in an inconsistent state.
  var forceAsyncEvents = {
    'blur': true,
    'focus': true
  };
  forEach('click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '), function (eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', function ($parse, $rootScope) {
      return {
        restrict: 'A',
        compile: function compile($element, attr) {
          // NOTE:
          // We expose the powerful `$event` object on the scope that provides access to the Window,
          // etc. This is OK, because expressions are not sandboxed any more (and the expression
          // sandbox was never meant to be a security feature anyway).
          var fn = $parse(attr[directiveName]);
          return function ngEventHandler(scope, element) {
            element.on(eventName, function (event) {
              var callback = function callback() {
                fn(scope, { $event: event });
              };
              if (forceAsyncEvents[eventName] && $rootScope.$$phase) {
                scope.$evalAsync(callback);
              } else {
                scope.$apply(callback);
              }
            });
          };
        }
      };
    }];
  });

  /**
   * @ngdoc directive
   * @name ngDblclick
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
   *
   * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
   * a dblclick. (The Event object is available as `$event`)
   *
   * @example
     <example name="ng-dblclick">
       <file name="index.html">
        <button ng-dblclick="count = count + 1" ng-init="count=0">
          Increment (on double click)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMousedown
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * The ngMousedown directive allows you to specify custom behavior on mousedown event.
   *
   * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
   * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mousedown">
       <file name="index.html">
        <button ng-mousedown="count = count + 1" ng-init="count=0">
          Increment (on mouse down)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMouseup
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on mouseup event.
   *
   * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
   * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mouseup">
       <file name="index.html">
        <button ng-mouseup="count = count + 1" ng-init="count=0">
          Increment (on mouse up)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMouseover
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on mouseover event.
   *
   * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
   * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mouseover">
       <file name="index.html">
        <button ng-mouseover="count = count + 1" ng-init="count=0">
          Increment (when mouse is over)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMouseenter
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on mouseenter event.
   *
   * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
   * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mouseenter">
       <file name="index.html">
        <button ng-mouseenter="count = count + 1" ng-init="count=0">
          Increment (when mouse enters)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMouseleave
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on mouseleave event.
   *
   * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
   * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mouseleave">
       <file name="index.html">
        <button ng-mouseleave="count = count + 1" ng-init="count=0">
          Increment (when mouse leaves)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMousemove
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on mousemove event.
   *
   * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
   * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mousemove">
       <file name="index.html">
        <button ng-mousemove="count = count + 1" ng-init="count=0">
          Increment (when mouse moves)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngKeydown
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on keydown event.
   *
   * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
   * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
   *
   * @example
     <example name="ng-keydown">
       <file name="index.html">
        <input ng-keydown="count = count + 1" ng-init="count=0">
        key down count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngKeyup
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on keyup event.
   *
   * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
   * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
   *
   * @example
     <example name="ng-keyup">
       <file name="index.html">
         <p>Typing in the input box below updates the key count</p>
         <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
  
         <p>Typing in the input box below updates the keycode</p>
         <input ng-keyup="event=$event">
         <p>event keyCode: {{ event.keyCode }}</p>
         <p>event altKey: {{ event.altKey }}</p>
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngKeypress
   * @restrict A
   * @element ANY
   *
   * @description
   * Specify custom behavior on keypress event.
   *
   * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
   * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
   * and can be interrogated for keyCode, altKey, etc.)
   *
   * @example
     <example name="ng-keypress">
       <file name="index.html">
        <input ng-keypress="count = count + 1" ng-init="count=0">
        key press count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngSubmit
   * @restrict A
   * @element form
   * @priority 0
   *
   * @description
   * Enables binding AngularJS expressions to onsubmit events.
   *
   * Additionally it prevents the default action (which for form means sending the request to the
   * server and reloading the current page), but only if the form does not contain `action`,
   * `data-action`, or `x-action` attributes.
   *
   * <div class="alert alert-warning">
   * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
   * `ngSubmit` handlers together. See the
   * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
   * for a detailed discussion of when `ngSubmit` may be triggered.
   * </div>
   *
   * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
   * ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example module="submitExample" name="ng-submit">
       <file name="index.html">
        <script>
          angular.module('submitExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.list = [];
              $scope.text = 'hello';
              $scope.submit = function() {
                if ($scope.text) {
                  $scope.list.push(this.text);
                  $scope.text = '';
                }
              };
            }]);
        </script>
        <form ng-submit="submit()" ng-controller="ExampleController">
          Enter text and hit enter:
          <input type="text" ng-model="text" name="text" />
          <input type="submit" id="submit" value="Submit" />
          <pre>list={{list}}</pre>
        </form>
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-submit', function() {
           expect(element(by.binding('list')).getText()).toBe('list=[]');
           element(by.css('#submit')).click();
           expect(element(by.binding('list')).getText()).toContain('hello');
           expect(element(by.model('text')).getAttribute('value')).toBe('');
         });
         it('should ignore empty strings', function() {
           expect(element(by.binding('list')).getText()).toBe('list=[]');
           element(by.css('#submit')).click();
           element(by.css('#submit')).click();
           expect(element(by.binding('list')).getText()).toContain('hello');
          });
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngFocus
   * @restrict A
   * @element window, input, select, textarea, a
   * @priority 0
   *
   * @description
   * Specify custom behavior on focus event.
   *
   * Note: As the `focus` event is executed synchronously when calling `input.focus()`
   * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
   * during an `$apply` to ensure a consistent state.
   *
   * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
   * focus. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
   * See {@link ng.directive:ngClick ngClick}
   */

  /**
   * @ngdoc directive
   * @name ngBlur
   * @restrict A
   * @element window, input, select, textarea, a
   * @priority 0
   *
   * @description
   * Specify custom behavior on blur event.
   *
   * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
   * an element has lost focus.
   *
   * Note: As the `blur` event is executed synchronously also during DOM manipulations
   * (e.g. removing a focussed input),
   * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
   * during an `$apply` to ensure a consistent state.
   *
   * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
   * blur. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
   * See {@link ng.directive:ngClick ngClick}
   */

  /**
   * @ngdoc directive
   * @name ngCopy
   * @restrict A
   * @element window, input, select, textarea, a
   * @priority 0
   *
   * @description
   * Specify custom behavior on copy event.
   *
   * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
   * copy. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-copy">
       <file name="index.html">
        <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
        copied: {{copied}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngCut
   * @restrict A
   * @element window, input, select, textarea, a
   * @priority 0
   *
   * @description
   * Specify custom behavior on cut event.
   *
   * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
   * cut. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-cut">
       <file name="index.html">
        <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
        cut: {{cut}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngPaste
   * @restrict A
   * @element window, input, select, textarea, a
   * @priority 0
   *
   * @description
   * Specify custom behavior on paste event.
   *
   * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
   * paste. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-paste">
       <file name="index.html">
        <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
        pasted: {{paste}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngIf
   * @restrict A
   * @multiElement
   *
   * @description
   * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
   * {expression}. If the expression assigned to `ngIf` evaluates to a false
   * value then the element is removed from the DOM, otherwise a clone of the
   * element is reinserted into the DOM.
   *
   * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
   * element in the DOM rather than changing its visibility via the `display` css property.  A common
   * case when this difference is significant is when using css selectors that rely on an element's
   * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
   *
   * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
   * is created when the element is restored.  The scope created within `ngIf` inherits from
   * its parent scope using
   * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
   * An important implication of this is if `ngModel` is used within `ngIf` to bind to
   * a javascript primitive defined in the parent scope. In this case any modifications made to the
   * variable within the child scope will override (hide) the value in the parent scope.
   *
   * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
   * is if an element's class attribute is directly modified after it's compiled, using something like
   * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
   * the added class will be lost because the original compiled state is used to regenerate the element.
   *
   * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
   * and `leave` effects.
   *
   * @animations
   * | Animation                        | Occurs                               |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
   * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
   *
   * @element ANY
   * @scope
   * @priority 600
   * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
   *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
   *     element is added to the DOM tree.
   *
   * @example
    <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
      <file name="index.html">
        <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
        Show when checked:
        <span ng-if="checked" class="animate-if">
          This is removed when the checkbox is unchecked.
        </span>
      </file>
      <file name="animations.css">
        .animate-if {
          background:white;
          border:1px solid black;
          padding:10px;
        }
  
        .animate-if.ng-enter, .animate-if.ng-leave {
          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
        }
  
        .animate-if.ng-enter,
        .animate-if.ng-leave.ng-leave-active {
          opacity:0;
        }
  
        .animate-if.ng-leave,
        .animate-if.ng-enter.ng-enter-active {
          opacity:1;
        }
      </file>
    </example>
   */
  var ngIfDirective = ['$animate', '$compile', function ($animate, $compile) {
    return {
      multiElement: true,
      transclude: 'element',
      priority: 600,
      terminal: true,
      restrict: 'A',
      $$tlb: true,
      link: function link($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {

          if (value) {
            if (!childScope) {
              $transclude(function (clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).done(function (response) {
                if (response !== false) previousElements = null;
              });
              block = null;
            }
          }
        });
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngInclude
   * @restrict ECA
   * @scope
   * @priority -400
   *
   * @description
   * Fetches, compiles and includes an external HTML fragment.
   *
   * By default, the template URL is restricted to the same domain and protocol as the
   * application document. This is done by calling {@link $sce#getTrustedResourceUrl
   * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
   * you may either {@link ng.$sceDelegateProvider#resourceUrlWhitelist whitelist them} or
   * {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to AngularJS's {@link
   * ng.$sce Strict Contextual Escaping}.
   *
   * In addition, the browser's
   * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
   * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
   * policy may further restrict whether the template is successfully loaded.
   * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
   * access on some browsers.
   *
   * @animations
   * | Animation                        | Occurs                              |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
   * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
   *
   * The enter and leave animation occur concurrently.
   *
   * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
   *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
   * @param {string=} onload Expression to evaluate when a new partial is loaded.
   *                  <div class="alert alert-warning">
   *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
   *                  a function with the name on the window element, which will usually throw a
   *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
   *                  different form that {@link guide/directive#normalization matches} `onload`.
   *                  </div>
     *
   * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
   *                  $anchorScroll} to scroll the viewport after the content is loaded.
   *
   *                  - If the attribute is not set, disable scrolling.
   *                  - If the attribute is set without value, enable scrolling.
   *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
   *
   * @example
    <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
      <file name="index.html">
       <div ng-controller="ExampleController">
         <select ng-model="template" ng-options="t.name for t in templates">
          <option value="">(blank)</option>
         </select>
         url of the template: <code>{{template.url}}</code>
         <hr/>
         <div class="slide-animate-container">
           <div class="slide-animate" ng-include="template.url"></div>
         </div>
       </div>
      </file>
      <file name="script.js">
        angular.module('includeExample', ['ngAnimate'])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.templates =
              [{ name: 'template1.html', url: 'template1.html'},
               { name: 'template2.html', url: 'template2.html'}];
            $scope.template = $scope.templates[0];
          }]);
       </file>
      <file name="template1.html">
        Content of template1.html
      </file>
      <file name="template2.html">
        Content of template2.html
      </file>
      <file name="animations.css">
        .slide-animate-container {
          position:relative;
          background:white;
          border:1px solid black;
          height:40px;
          overflow:hidden;
        }
  
        .slide-animate {
          padding:10px;
        }
  
        .slide-animate.ng-enter, .slide-animate.ng-leave {
          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
  
          position:absolute;
          top:0;
          left:0;
          right:0;
          bottom:0;
          display:block;
          padding:10px;
        }
  
        .slide-animate.ng-enter {
          top:-50px;
        }
        .slide-animate.ng-enter.ng-enter-active {
          top:0;
        }
  
        .slide-animate.ng-leave {
          top:0;
        }
        .slide-animate.ng-leave.ng-leave-active {
          top:50px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        var templateSelect = element(by.model('template'));
        var includeElem = element(by.css('[ng-include]'));
  
        it('should load template1.html', function() {
          expect(includeElem.getText()).toMatch(/Content of template1.html/);
        });
  
        it('should load template2.html', function() {
          if (browser.params.browser === 'firefox') {
            // Firefox can't handle using selects
            // See https://github.com/angular/protractor/issues/480
            return;
          }
          templateSelect.click();
          templateSelect.all(by.css('option')).get(2).click();
          expect(includeElem.getText()).toMatch(/Content of template2.html/);
        });
  
        it('should change to blank', function() {
          if (browser.params.browser === 'firefox') {
            // Firefox can't handle using selects
            return;
          }
          templateSelect.click();
          templateSelect.all(by.css('option')).get(0).click();
          expect(includeElem.isPresent()).toBe(false);
        });
      </file>
    </example>
   */

  /**
   * @ngdoc event
   * @name ngInclude#$includeContentRequested
   * @eventType emit on the scope ngInclude was declared in
   * @description
   * Emitted every time the ngInclude content is requested.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {String} src URL of content to load.
   */

  /**
   * @ngdoc event
   * @name ngInclude#$includeContentLoaded
   * @eventType emit on the current ngInclude scope
   * @description
   * Emitted every time the ngInclude content is reloaded.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {String} src URL of content to load.
   */

  /**
   * @ngdoc event
   * @name ngInclude#$includeContentError
   * @eventType emit on the scope ngInclude was declared in
   * @description
   * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {String} src URL of content to load.
   */
  var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate', function ($templateRequest, $anchorScroll, $animate) {
    return {
      restrict: 'ECA',
      priority: 400,
      terminal: true,
      transclude: 'element',
      controller: angular.noop,
      compile: function compile(element, attr) {
        var srcExp = attr.ngInclude || attr.src,
            onloadExp = attr.onload || '',
            autoScrollExp = attr.autoscroll;

        return function (scope, $element, $attr, ctrl, $transclude) {
          var changeCounter = 0,
              currentScope,
              previousElement,
              currentElement;

          var cleanupLastIncludeContent = function cleanupLastIncludeContent() {
            if (previousElement) {
              previousElement.remove();
              previousElement = null;
            }
            if (currentScope) {
              currentScope.$destroy();
              currentScope = null;
            }
            if (currentElement) {
              $animate.leave(currentElement).done(function (response) {
                if (response !== false) previousElement = null;
              });
              previousElement = currentElement;
              currentElement = null;
            }
          };

          scope.$watch(srcExp, function ngIncludeWatchAction(src) {
            var afterAnimation = function afterAnimation(response) {
              if (response !== false && isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
                $anchorScroll();
              }
            };
            var thisChangeId = ++changeCounter;

            if (src) {
              //set the 2nd param to true to ignore the template request error so that the inner
              //contents and scope can be cleaned up.
              $templateRequest(src, true).then(function (response) {
                if (scope.$$destroyed) return;

                if (thisChangeId !== changeCounter) return;
                var newScope = scope.$new();
                ctrl.template = response;

                // Note: This will also link all children of ng-include that were contained in the original
                // html. If that content contains controllers, ... they could pollute/change the scope.
                // However, using ng-include on an element with additional content does not make sense...
                // Note: We can't remove them in the cloneAttchFn of $transclude as that
                // function is called before linking the content, which would apply child
                // directives to non existing elements.
                var clone = $transclude(newScope, function (clone) {
                  cleanupLastIncludeContent();
                  $animate.enter(clone, null, $element).done(afterAnimation);
                });

                currentScope = newScope;
                currentElement = clone;

                currentScope.$emit('$includeContentLoaded', src);
                scope.$eval(onloadExp);
              }, function () {
                if (scope.$$destroyed) return;

                if (thisChangeId === changeCounter) {
                  cleanupLastIncludeContent();
                  scope.$emit('$includeContentError', src);
                }
              });
              scope.$emit('$includeContentRequested', src);
            } else {
              cleanupLastIncludeContent();
              ctrl.template = null;
            }
          });
        };
      }
    };
  }];

  // This directive is called during the $transclude call of the first `ngInclude` directive.
  // It will replace and compile the content of the element with the loaded template.
  // We need this directive so that the element content is already filled when
  // the link function of another directive on the same element as ngInclude
  // is called.
  var ngIncludeFillContentDirective = ['$compile', function ($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function link(scope, $element, $attr, ctrl) {
        if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope, function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, { futureParentElement: $element });
          return;
        }

        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngInit
   * @restrict AC
   * @priority 450
   * @element ANY
   *
   * @param {expression} ngInit {@link guide/expression Expression} to eval.
   *
   * @description
   * The `ngInit` directive allows you to evaluate an expression in the
   * current scope.
   *
   * <div class="alert alert-danger">
   * This directive can be abused to add unnecessary amounts of logic into your templates.
   * There are only a few appropriate uses of `ngInit`:
   * <ul>
   *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
   *     as seen in the demo below.</li>
   *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
   *   <li>injecting data via server side scripting.</li>
   * </ul>
   *
   * Besides these few cases, you should use {@link guide/component Components} or
   * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
   * </div>
   *
   * <div class="alert alert-warning">
   * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
   * sure you have parentheses to ensure correct operator precedence:
   * <pre class="prettyprint">
   * `<div ng-init="test1 = ($index | toString)"></div>`
   * </pre>
   * </div>
   *
   * @example
     <example module="initExample" name="ng-init">
       <file name="index.html">
     <script>
       angular.module('initExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.list = [['a', 'b'], ['c', 'd']];
         }]);
     </script>
     <div ng-controller="ExampleController">
       <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
         <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
            <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
         </div>
       </div>
     </div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should alias index positions', function() {
           var elements = element.all(by.css('.example-init'));
           expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
           expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
           expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
           expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
         });
       </file>
     </example>
   */
  var ngInitDirective = ngDirective({
    priority: 450,
    compile: function compile() {
      return {
        pre: function pre(scope, element, attrs) {
          scope.$eval(attrs.ngInit);
        }
      };
    }
  });

  /**
   * @ngdoc directive
   * @name ngList
   * @restrict A
   * @priority 100
   *
   * @param {string=} ngList optional delimiter that should be used to split the value.
   *
   * @description
   * Text input that converts between a delimited string and an array of strings. The default
   * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
   * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
   *
   * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
   * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
   *   list item is respected. This implies that the user of the directive is responsible for
   *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
   *   tab or newline character.
   * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
   *   when joining the list items back together) and whitespace around each list item is stripped
   *   before it is added to the model.
   *
   * @example
   * ### Validation
   *
   * <example name="ngList-directive" module="listExample">
   *   <file name="app.js">
   *      angular.module('listExample', [])
   *        .controller('ExampleController', ['$scope', function($scope) {
   *          $scope.names = ['morpheus', 'neo', 'trinity'];
   *        }]);
   *   </file>
   *   <file name="index.html">
   *    <form name="myForm" ng-controller="ExampleController">
   *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
   *      <span role="alert">
   *        <span class="error" ng-show="myForm.namesInput.$error.required">
   *        Required!</span>
   *      </span>
   *      <br>
   *      <tt>names = {{names}}</tt><br/>
   *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
   *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
   *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
   *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
   *     </form>
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     var listInput = element(by.model('names'));
   *     var names = element(by.exactBinding('names'));
   *     var valid = element(by.binding('myForm.namesInput.$valid'));
   *     var error = element(by.css('span.error'));
   *
   *     it('should initialize to model', function() {
   *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
   *       expect(valid.getText()).toContain('true');
   *       expect(error.getCssValue('display')).toBe('none');
   *     });
   *
   *     it('should be invalid if empty', function() {
   *       listInput.clear();
   *       listInput.sendKeys('');
   *
   *       expect(names.getText()).toContain('');
   *       expect(valid.getText()).toContain('false');
   *       expect(error.getCssValue('display')).not.toBe('none');
   *     });
   *   </file>
   * </example>
   *
   * @example
   * ### Splitting on newline
   *
   * <example name="ngList-directive-newlines">
   *   <file name="index.html">
   *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
   *    <pre>{{ list | json }}</pre>
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     it("should split the text by newlines", function() {
   *       var listInput = element(by.model('list'));
   *       var output = element(by.binding('list | json'));
   *       listInput.sendKeys('abc\ndef\nghi');
   *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
   *     });
   *   </file>
   * </example>
   *
   */
  var ngListDirective = function ngListDirective() {
    return {
      restrict: 'A',
      priority: 100,
      require: 'ngModel',
      link: function link(scope, element, attr, ctrl) {
        var ngList = attr.ngList || ', ';
        var trimValues = attr.ngTrim !== 'false';
        var separator = trimValues ? trim(ngList) : ngList;

        var parse = function parse(viewValue) {
          // If the viewValue is invalid (say required but empty) it will be `undefined`
          if (isUndefined(viewValue)) return;

          var list = [];

          if (viewValue) {
            forEach(viewValue.split(separator), function (value) {
              if (value) list.push(trimValues ? trim(value) : value);
            });
          }

          return list;
        };

        ctrl.$parsers.push(parse);
        ctrl.$formatters.push(function (value) {
          if (isArray(value)) {
            return value.join(ngList);
          }

          return undefined;
        });

        // Override the standard $isEmpty because an empty array means the input is empty.
        ctrl.$isEmpty = function (value) {
          return !value || !value.length;
        };
      }
    };
  };

  /* global VALID_CLASS: true,
    INVALID_CLASS: true,
    PRISTINE_CLASS: true,
    DIRTY_CLASS: true,
    UNTOUCHED_CLASS: true,
    TOUCHED_CLASS: true,
    PENDING_CLASS: true,
    addSetValidityMethod: true,
    setupValidity: true,
    defaultModelOptions: false
  */

  var VALID_CLASS = 'ng-valid',
      INVALID_CLASS = 'ng-invalid',
      PRISTINE_CLASS = 'ng-pristine',
      DIRTY_CLASS = 'ng-dirty',
      UNTOUCHED_CLASS = 'ng-untouched',
      TOUCHED_CLASS = 'ng-touched',
      EMPTY_CLASS = 'ng-empty',
      NOT_EMPTY_CLASS = 'ng-not-empty';

  var ngModelMinErr = minErr('ngModel');

  /**
   * @ngdoc type
   * @name ngModel.NgModelController
   * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
   * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
   * is set.
   *
   * @property {*} $modelValue The value in the model that the control is bound to.
   *
   * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
   *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
      `$viewValue`} from the DOM, usually via user input.
      See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
      Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
  
    The functions are called in array order, each passing
      its return value through to the next. The last return value is forwarded to the
      {@link ngModel.NgModelController#$validators `$validators`} collection.
  
    Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
      `$viewValue`}.
  
    Returning `undefined` from a parser means a parse error occurred. In that case,
      no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
      will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
      is set to `true`. The parse error is stored in `ngModel.$error.parse`.
  
    This simple example shows a parser that would convert text input value to lowercase:
   * ```js
   * function parse(value) {
   *   if (value) {
   *     return value.toLowerCase();
   *   }
   * }
   * ngModelController.$parsers.push(parse);
   * ```
  
   *
   * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
      the bound ngModel expression changes programmatically. The `$formatters` are not called when the
      value of the control is changed by user interaction.
  
    Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
      `$modelValue`} for display in the control.
  
    The functions are called in reverse array order, each passing the value through to the
      next. The last return value is used as the actual DOM value.
  
    This simple example shows a formatter that would convert the model value to uppercase:
  
   * ```js
   * function format(value) {
   *   if (value) {
   *     return value.toUpperCase();
   *   }
   * }
   * ngModel.$formatters.push(format);
   * ```
   *
   * @property {Object.<string, function>} $validators A collection of validators that are applied
   *      whenever the model value changes. The key value within the object refers to the name of the
   *      validator while the function refers to the validation operation. The validation operation is
   *      provided with the model value as an argument and must return a true or false value depending
   *      on the response of that validation.
   *
   * ```js
   * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
   *   var value = modelValue || viewValue;
   *   return /[0-9]+/.test(value) &&
   *          /[a-z]+/.test(value) &&
   *          /[A-Z]+/.test(value) &&
   *          /\W+/.test(value);
   * };
   * ```
   *
   * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
   *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
   *      is expected to return a promise when it is run during the model validation process. Once the promise
   *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
   *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
   *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
   *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
   *      will only run once all synchronous validators have passed.
   *
   * Please note that if $http is used then it is important that the server returns a success HTTP response code
   * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
   *
   * ```js
   * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
   *   var value = modelValue || viewValue;
   *
   *   // Lookup user by username
   *   return $http.get('/api/users/' + value).
   *      then(function resolved() {
   *        //username exists, this means validation fails
   *        return $q.reject('exists');
   *      }, function rejected() {
   *        //username does not exist, therefore this validation passes
   *        return true;
   *      });
   * };
   * ```
   *
   * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
   *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
   *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
   *     It is called with no arguments, and its return value is ignored.
   *     This can be used in place of additional $watches against the model value.
   *
   * @property {Object} $error An object hash with all failing validator ids as keys.
   * @property {Object} $pending An object hash with all pending validator ids as keys.
   *
   * @property {boolean} $untouched True if control has not lost focus yet.
   * @property {boolean} $touched True if control has lost focus.
   * @property {boolean} $pristine True if user has not interacted with the control yet.
   * @property {boolean} $dirty True if user has already interacted with the control.
   * @property {boolean} $valid True if there is no error.
   * @property {boolean} $invalid True if at least one error on the control.
   * @property {string} $name The name attribute of the control.
   *
   * @description
   *
   * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
   * The controller contains services for data-binding, validation, CSS updates, and value formatting
   * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
   * listening to DOM events.
   * Such DOM related logic should be provided by other directives which make use of
   * `NgModelController` for data-binding to control elements.
   * AngularJS provides this DOM logic for most {@link input `input`} elements.
   * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
   * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
   *
   * @example
   * ### Custom Control Example
   * This example shows how to use `NgModelController` with a custom control to achieve
   * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
   * collaborate together to achieve the desired result.
   *
   * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
   * contents be edited in place by the user.
   *
   * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
   * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
   * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
   * that content using the `$sce` service.
   *
   * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
      <file name="style.css">
        [contenteditable] {
          border: 1px solid black;
          background-color: white;
          min-height: 20px;
        }
  
        .ng-invalid {
          border: 1px solid red;
        }
  
      </file>
      <file name="script.js">
        angular.module('customControl', ['ngSanitize']).
          directive('contenteditable', ['$sce', function($sce) {
            return {
              restrict: 'A', // only activate on element attribute
              require: '?ngModel', // get a hold of NgModelController
              link: function(scope, element, attrs, ngModel) {
                if (!ngModel) return; // do nothing if no ng-model
  
                // Specify how UI should be updated
                ngModel.$render = function() {
                  element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
                };
  
                // Listen for change events to enable binding
                element.on('blur keyup change', function() {
                  scope.$evalAsync(read);
                });
                read(); // initialize
  
                // Write data to the model
                function read() {
                  var html = element.html();
                  // When we clear the content editable the browser leaves a <br> behind
                  // If strip-br attribute is provided then we strip this out
                  if (attrs.stripBr && html === '<br>') {
                    html = '';
                  }
                  ngModel.$setViewValue(html);
                }
              }
            };
          }]);
      </file>
      <file name="index.html">
        <form name="myForm">
         <div contenteditable
              name="myWidget" ng-model="userContent"
              strip-br="true"
              required>Change me!</div>
          <span ng-show="myForm.myWidget.$error.required">Required!</span>
         <hr>
         <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
      it('should data-bind and become invalid', function() {
        if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
          // SafariDriver can't handle contenteditable
          // and Firefox driver can't clear contenteditables very well
          return;
        }
        var contentEditable = element(by.css('[contenteditable]'));
        var content = 'Change me!';
  
        expect(contentEditable.getText()).toEqual(content);
  
        contentEditable.clear();
        contentEditable.sendKeys(protractor.Key.BACK_SPACE);
        expect(contentEditable.getText()).toEqual('');
        expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
      });
      </file>
   * </example>
   *
   *
   */
  NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
  function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
    this.$viewValue = Number.NaN;
    this.$modelValue = Number.NaN;
    this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
    this.$validators = {};
    this.$asyncValidators = {};
    this.$parsers = [];
    this.$formatters = [];
    this.$viewChangeListeners = [];
    this.$untouched = true;
    this.$touched = false;
    this.$pristine = true;
    this.$dirty = false;
    this.$valid = true;
    this.$invalid = false;
    this.$error = {}; // keep invalid keys here
    this.$$success = {}; // keep valid keys here
    this.$pending = undefined; // keep pending keys here
    this.$name = $interpolate($attr.name || '', false)($scope);
    this.$$parentForm = nullFormCtrl;
    this.$options = defaultModelOptions;
    this.$$updateEvents = '';
    // Attach the correct context to the event handler function for updateOn
    this.$$updateEventHandler = this.$$updateEventHandler.bind(this);

    this.$$parsedNgModel = $parse($attr.ngModel);
    this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
    this.$$ngModelGet = this.$$parsedNgModel;
    this.$$ngModelSet = this.$$parsedNgModelAssign;
    this.$$pendingDebounce = null;
    this.$$parserValid = undefined;

    this.$$currentValidationRunId = 0;

    // https://github.com/angular/angular.js/issues/15833
    // Prevent `$$scope` from being iterated over by `copy` when NgModelController is deep watched
    Object.defineProperty(this, '$$scope', { value: $scope });
    this.$$attr = $attr;
    this.$$element = $element;
    this.$$animate = $animate;
    this.$$timeout = $timeout;
    this.$$parse = $parse;
    this.$$q = $q;
    this.$$exceptionHandler = $exceptionHandler;

    setupValidity(this);
    setupModelWatcher(this);
  }

  NgModelController.prototype = {
    $$initGetterSetters: function $$initGetterSetters() {
      if (this.$options.getOption('getterSetter')) {
        var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
            invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');

        this.$$ngModelGet = function ($scope) {
          var modelValue = this.$$parsedNgModel($scope);
          if (isFunction(modelValue)) {
            modelValue = invokeModelGetter($scope);
          }
          return modelValue;
        };
        this.$$ngModelSet = function ($scope, newValue) {
          if (isFunction(this.$$parsedNgModel($scope))) {
            invokeModelSetter($scope, { $$$p: newValue });
          } else {
            this.$$parsedNgModelAssign($scope, newValue);
          }
        };
      } else if (!this.$$parsedNgModel.assign) {
        throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}', this.$$attr.ngModel, startingTag(this.$$element));
      }
    },

    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$render
     *
     * @description
     * Called when the view needs to be updated. It is expected that the user of the ng-model
     * directive will implement this method.
     *
     * The `$render()` method is invoked in the following situations:
     *
     * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
     *   committed value then `$render()` is called to update the input control.
     * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
     *   the `$viewValue` are different from last time.
     *
     * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
     * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
     * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
     * invoked if you only change a property on the objects.
     */
    $render: noop,

    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$isEmpty
     *
     * @description
     * This is called when we need to determine if the value of an input is empty.
     *
     * For instance, the required directive does this to work out if the input has data or not.
     *
     * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
     *
     * You can override this for input directives whose concept of being empty is different from the
     * default. The `checkboxInputType` directive does this because in its case a value of `false`
     * implies empty.
     *
     * @param {*} value The value of the input to check for emptiness.
     * @returns {boolean} True if `value` is "empty".
     */
    $isEmpty: function $isEmpty(value) {
      // eslint-disable-next-line no-self-compare
      return isUndefined(value) || value === '' || value === null || value !== value;
    },

    $$updateEmptyClasses: function $$updateEmptyClasses(value) {
      if (this.$isEmpty(value)) {
        this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
        this.$$animate.addClass(this.$$element, EMPTY_CLASS);
      } else {
        this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
        this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
      }
    },

    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setPristine
     *
     * @description
     * Sets the control to its pristine state.
     *
     * This method can be called to remove the `ng-dirty` class and set the control to its pristine
     * state (`ng-pristine` class). A model is considered to be pristine when the control
     * has not been changed from when first compiled.
     */
    $setPristine: function $setPristine() {
      this.$dirty = false;
      this.$pristine = true;
      this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
      this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
    },

    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setDirty
     *
     * @description
     * Sets the control to its dirty state.
     *
     * This method can be called to remove the `ng-pristine` class and set the control to its dirty
     * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
     * from when first compiled.
     */
    $setDirty: function $setDirty() {
      this.$dirty = true;
      this.$pristine = false;
      this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
      this.$$animate.addClass(this.$$element, DIRTY_CLASS);
      this.$$parentForm.$setDirty();
    },

    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setUntouched
     *
     * @description
     * Sets the control to its untouched state.
     *
     * This method can be called to remove the `ng-touched` class and set the control to its
     * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
     * by default, however this function can be used to restore that state if the model has
     * already been touched by the user.
     */
    $setUntouched: function $setUntouched() {
      this.$touched = false;
      this.$untouched = true;
      this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
    },

    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setTouched
     *
     * @description
     * Sets the control to its touched state.
     *
     * This method can be called to remove the `ng-untouched` class and set the control to its
     * touched state (`ng-touched` class). A model is considered to be touched when the user has
     * first focused the control element and then shifted focus away from the control (blur event).
     */
    $setTouched: function $setTouched() {
      this.$touched = true;
      this.$untouched = false;
      this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
    },

    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$rollbackViewValue
     *
     * @description
     * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
     * which may be caused by a pending debounced event or because the input is waiting for some
     * future event.
     *
     * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
     * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
     * sync with the ngModel's `$modelValue`.
     *
     * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
     * and reset the input to the last committed view value.
     *
     * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
     * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
     * dirty checking mechanism is not able to tell whether the model has actually changed or not.
     *
     * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
     * input which may have such events pending. This is important in order to make sure that the
     * input field will be updated with the new model value and any pending operations are cancelled.
     *
     * @example
     * <example name="ng-model-cancel-update" module="cancel-update-example">
     *   <file name="app.js">
     *     angular.module('cancel-update-example', [])
     *
     *     .controller('CancelUpdateController', ['$scope', function($scope) {
     *       $scope.model = {value1: '', value2: ''};
     *
     *       $scope.setEmpty = function(e, value, rollback) {
     *         if (e.keyCode === 27) {
     *           e.preventDefault();
     *           if (rollback) {
     *             $scope.myForm[value].$rollbackViewValue();
     *           }
     *           $scope.model[value] = '';
     *         }
     *       };
     *     }]);
     *   </file>
     *   <file name="index.html">
     *     <div ng-controller="CancelUpdateController">
     *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
     *       empty them. Follow these steps and observe the difference:</p>
     *       <ol>
     *         <li>Type something in the input. You will see that the model is not yet updated</li>
     *         <li>Press the Escape key.
     *           <ol>
     *             <li> In the first example, nothing happens, because the model is already '', and no
     *             update is detected. If you blur the input, the model will be set to the current view.
     *             </li>
     *             <li> In the second example, the pending update is cancelled, and the input is set back
     *             to the last committed view value (''). Blurring the input does nothing.
     *             </li>
     *           </ol>
     *         </li>
     *       </ol>
     *
     *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
     *         <div>
     *           <p id="inputDescription1">Without $rollbackViewValue():</p>
     *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
     *                  ng-keydown="setEmpty($event, 'value1')">
     *           value1: "{{ model.value1 }}"
     *         </div>
     *
     *         <div>
     *           <p id="inputDescription2">With $rollbackViewValue():</p>
     *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
     *                  ng-keydown="setEmpty($event, 'value2', true)">
     *           value2: "{{ model.value2 }}"
     *         </div>
     *       </form>
     *     </div>
     *   </file>
         <file name="style.css">
            div {
              display: table-cell;
            }
            div:nth-child(1) {
              padding-right: 30px;
            }
           </file>
     * </example>
     */
    $rollbackViewValue: function $rollbackViewValue() {
      this.$$timeout.cancel(this.$$pendingDebounce);
      this.$viewValue = this.$$lastCommittedViewValue;
      this.$render();
    },

    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$validate
     *
     * @description
     * Runs each of the registered validators (first synchronous validators and then
     * asynchronous validators).
     * If the validity changes to invalid, the model will be set to `undefined`,
     * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
     * If the validity changes to valid, it will set the model to the last available valid
     * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
     */
    $validate: function $validate() {
      // ignore $validate before model is initialized
      if (isNumberNaN(this.$modelValue)) {
        return;
      }

      var viewValue = this.$$lastCommittedViewValue;
      // Note: we use the $$rawModelValue as $modelValue might have been
      // set to undefined during a view -> model update that found validation
      // errors. We can't parse the view here, since that could change
      // the model although neither viewValue nor the model on the scope changed
      var modelValue = this.$$rawModelValue;

      var prevValid = this.$valid;
      var prevModelValue = this.$modelValue;

      var allowInvalid = this.$options.getOption('allowInvalid');

      var that = this;
      this.$$runValidators(modelValue, viewValue, function (allValid) {
        // If there was no change in validity, don't update the model
        // This prevents changing an invalid modelValue to undefined
        if (!allowInvalid && prevValid !== allValid) {
          // Note: Don't check this.$valid here, as we could have
          // external validators (e.g. calculated on the server),
          // that just call $setValidity and need the model value
          // to calculate their validity.
          that.$modelValue = allValid ? modelValue : undefined;

          if (that.$modelValue !== prevModelValue) {
            that.$$writeModelToScope();
          }
        }
      });
    },

    $$runValidators: function $$runValidators(modelValue, viewValue, doneCallback) {
      this.$$currentValidationRunId++;
      var localValidationRunId = this.$$currentValidationRunId;
      var that = this;

      // check parser error
      if (!processParseErrors()) {
        validationDone(false);
        return;
      }
      if (!processSyncValidators()) {
        validationDone(false);
        return;
      }
      processAsyncValidators();

      function processParseErrors() {
        var errorKey = that.$$parserName || 'parse';
        if (isUndefined(that.$$parserValid)) {
          setValidity(errorKey, null);
        } else {
          if (!that.$$parserValid) {
            forEach(that.$validators, function (v, name) {
              setValidity(name, null);
            });
            forEach(that.$asyncValidators, function (v, name) {
              setValidity(name, null);
            });
          }
          // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
          setValidity(errorKey, that.$$parserValid);
          return that.$$parserValid;
        }
        return true;
      }

      function processSyncValidators() {
        var syncValidatorsValid = true;
        forEach(that.$validators, function (validator, name) {
          var result = Boolean(validator(modelValue, viewValue));
          syncValidatorsValid = syncValidatorsValid && result;
          setValidity(name, result);
        });
        if (!syncValidatorsValid) {
          forEach(that.$asyncValidators, function (v, name) {
            setValidity(name, null);
          });
          return false;
        }
        return true;
      }

      function processAsyncValidators() {
        var validatorPromises = [];
        var allValid = true;
        forEach(that.$asyncValidators, function (validator, name) {
          var promise = validator(modelValue, viewValue);
          if (!isPromiseLike(promise)) {
            throw ngModelMinErr('nopromise', 'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
          }
          setValidity(name, undefined);
          validatorPromises.push(promise.then(function () {
            setValidity(name, true);
          }, function () {
            allValid = false;
            setValidity(name, false);
          }));
        });
        if (!validatorPromises.length) {
          validationDone(true);
        } else {
          that.$$q.all(validatorPromises).then(function () {
            validationDone(allValid);
          }, noop);
        }
      }

      function setValidity(name, isValid) {
        if (localValidationRunId === that.$$currentValidationRunId) {
          that.$setValidity(name, isValid);
        }
      }

      function validationDone(allValid) {
        if (localValidationRunId === that.$$currentValidationRunId) {

          doneCallback(allValid);
        }
      }
    },

    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$commitViewValue
     *
     * @description
     * Commit a pending update to the `$modelValue`.
     *
     * Updates may be pending by a debounced event or because the input is waiting for a some future
     * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
     * usually handles calling this in response to input events.
     */
    $commitViewValue: function $commitViewValue() {
      var viewValue = this.$viewValue;

      this.$$timeout.cancel(this.$$pendingDebounce);

      // If the view value has not changed then we should just exit, except in the case where there is
      // a native validator on the element. In this case the validation state may have changed even though
      // the viewValue has stayed empty.
      if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
        return;
      }
      this.$$updateEmptyClasses(viewValue);
      this.$$lastCommittedViewValue = viewValue;

      // change to dirty
      if (this.$pristine) {
        this.$setDirty();
      }
      this.$$parseAndValidate();
    },

    $$parseAndValidate: function $$parseAndValidate() {
      var viewValue = this.$$lastCommittedViewValue;
      var modelValue = viewValue;
      var that = this;

      this.$$parserValid = isUndefined(modelValue) ? undefined : true;

      if (this.$$parserValid) {
        for (var i = 0; i < this.$parsers.length; i++) {
          modelValue = this.$parsers[i](modelValue);
          if (isUndefined(modelValue)) {
            this.$$parserValid = false;
            break;
          }
        }
      }
      if (isNumberNaN(this.$modelValue)) {
        // this.$modelValue has not been touched yet...
        this.$modelValue = this.$$ngModelGet(this.$$scope);
      }
      var prevModelValue = this.$modelValue;
      var allowInvalid = this.$options.getOption('allowInvalid');
      this.$$rawModelValue = modelValue;

      if (allowInvalid) {
        this.$modelValue = modelValue;
        writeToModelIfNeeded();
      }

      // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
      // This can happen if e.g. $setViewValue is called from inside a parser
      this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function (allValid) {
        if (!allowInvalid) {
          // Note: Don't check this.$valid here, as we could have
          // external validators (e.g. calculated on the server),
          // that just call $setValidity and need the model value
          // to calculate their validity.
          that.$modelValue = allValid ? modelValue : undefined;
          writeToModelIfNeeded();
        }
      });

      function writeToModelIfNeeded() {
        if (that.$modelValue !== prevModelValue) {
          that.$$writeModelToScope();
        }
      }
    },

    $$writeModelToScope: function $$writeModelToScope() {
      this.$$ngModelSet(this.$$scope, this.$modelValue);
      forEach(this.$viewChangeListeners, function (listener) {
        try {
          listener();
        } catch (e) {
          // eslint-disable-next-line no-invalid-this
          this.$$exceptionHandler(e);
        }
      }, this);
    },

    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setViewValue
     *
     * @description
     * Update the view value.
     *
     * This method should be called when a control wants to change the view value; typically,
     * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
     * directive calls it when the value of the input changes and {@link ng.directive:select select}
     * calls it when an option is selected.
     *
     * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
     * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
     * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
     * `$asyncValidators` are called and the value is applied to `$modelValue`.
     * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
     * all the registered change listeners, in the `$viewChangeListeners` list are called.
     *
     * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
     * and the `default` trigger is not listed, all those actions will remain pending until one of the
     * `updateOn` events is triggered on the DOM element.
     * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
     * directive is used with a custom debounce for this particular event.
     * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
     * is specified, once the timer runs out.
     *
     * When used with standard inputs, the view value will always be a string (which is in some cases
     * parsed into another type, such as a `Date` object for `input[date]`.)
     * However, custom controls might also pass objects to this method. In this case, we should make
     * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
     * perform a deep watch of objects, it only looks for a change of identity. If you only change
     * the property of the object then ngModel will not realize that the object has changed and
     * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
     * not change properties of the copy once it has been passed to `$setViewValue`.
     * Otherwise you may cause the model value on the scope to change incorrectly.
     *
     * <div class="alert alert-info">
     * In any case, the value passed to the method should always reflect the current value
     * of the control. For example, if you are calling `$setViewValue` for an input element,
     * you should pass the input DOM value. Otherwise, the control and the scope model become
     * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
     * the control's DOM value in any way. If we want to change the control's DOM value
     * programmatically, we should update the `ngModel` scope expression. Its new value will be
     * picked up by the model controller, which will run it through the `$formatters`, `$render` it
     * to update the DOM, and finally call `$validate` on it.
     * </div>
     *
     * @param {*} value value from the view.
     * @param {string} trigger Event that triggered the update.
     */
    $setViewValue: function $setViewValue(value, trigger) {
      this.$viewValue = value;
      if (this.$options.getOption('updateOnDefault')) {
        this.$$debounceViewValueCommit(trigger);
      }
    },

    $$debounceViewValueCommit: function $$debounceViewValueCommit(trigger) {
      var debounceDelay = this.$options.getOption('debounce');

      if (isNumber(debounceDelay[trigger])) {
        debounceDelay = debounceDelay[trigger];
      } else if (isNumber(debounceDelay['default'])) {
        debounceDelay = debounceDelay['default'];
      }

      this.$$timeout.cancel(this.$$pendingDebounce);
      var that = this;
      if (debounceDelay > 0) {
        // this fails if debounceDelay is an object
        this.$$pendingDebounce = this.$$timeout(function () {
          that.$commitViewValue();
        }, debounceDelay);
      } else if (this.$$scope.$root.$$phase) {
        this.$commitViewValue();
      } else {
        this.$$scope.$apply(function () {
          that.$commitViewValue();
        });
      }
    },

    /**
     * @ngdoc method
     *
     * @name ngModel.NgModelController#$overrideModelOptions
     *
     * @description
     *
     * Override the current model options settings programmatically.
     *
     * The previous `ModelOptions` value will not be modified. Instead, a
     * new `ModelOptions` object will inherit from the previous one overriding
     * or inheriting settings that are defined in the given parameter.
     *
     * See {@link ngModelOptions} for information about what options can be specified
     * and how model option inheritance works.
     *
     * <div class="alert alert-warning">
     * **Note:** this function only affects the options set on the `ngModelController`,
     * and not the options on the {@link ngModelOptions} directive from which they might have been
     * obtained initially.
     * </div>
     *
     * <div class="alert alert-danger">
     * **Note:** it is not possible to override the `getterSetter` option.
     * </div>
     *
     * @param {Object} options a hash of settings to override the previous options
     *
     */
    $overrideModelOptions: function $overrideModelOptions(options) {
      this.$options = this.$options.createChild(options);
      this.$$setUpdateOnEvents();
    },

    /**
     * @ngdoc method
     *
     * @name  ngModel.NgModelController#$processModelValue
      * @description
     *
     * Runs the model -> view pipeline on the current
     * {@link ngModel.NgModelController#$modelValue $modelValue}.
     *
     * The following actions are performed by this method:
     *
     * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
     * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
     * - the `ng-empty` or `ng-not-empty` class is set on the element
     * - if the `$viewValue` has changed:
     *   - {@link ngModel.NgModelController#$render $render} is called on the control
     *   - the {@link ngModel.NgModelController#$validators $validators} are run and
     *   the validation status is set.
     *
     * This method is called by ngModel internally when the bound scope value changes.
     * Application developers usually do not have to call this function themselves.
     *
     * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
     * formatted and the `$modelValue` must be run through the `$formatters` again.
     *
     * @example
     * Consider a text input with an autocomplete list (for fruit), where the items are
     * objects with a name and an id.
     * A user enters `ap` and then selects `Apricot` from the list.
     * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
     * but the rendered value will still be `ap`.
     * The widget can then call `ctrl.$processModelValue()` to run the model -> view
     * pipeline again, which formats the object to the string `Apricot`,
     * then updates the `$viewValue`, and finally renders it in the DOM.
     *
     * <example module="inputExample" name="ng-model-process">
       <file name="index.html">
        <div ng-controller="inputController" style="display: flex;">
          <div style="margin-right: 30px;">
            Search Fruit:
            <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
          </div>
          <div>
            Model:<br>
            <pre>{{selectedFruit | json}}</pre>
          </div>
        </div>
       </file>
       <file name="app.js">
        angular.module('inputExample', [])
          .controller('inputController', function($scope) {
            $scope.items = [
              {name: 'Apricot', id: 443},
              {name: 'Clementine', id: 972},
              {name: 'Durian', id: 169},
              {name: 'Jackfruit', id: 982},
              {name: 'Strawberry', id: 863}
            ];
          })
          .component('basicAutocomplete', {
            bindings: {
              items: '<',
              onSelect: '&'
            },
            templateUrl: 'autocomplete.html',
            controller: function($element, $scope) {
              var that = this;
              var ngModel;
               that.$postLink = function() {
                ngModel = $element.find('input').controller('ngModel');
                 ngModel.$formatters.push(function(value) {
                  return (value && value.name) || value;
                });
                 ngModel.$parsers.push(function(value) {
                  var match = value;
                  for (var i = 0; i < that.items.length; i++) {
                    if (that.items[i].name === value) {
                      match = that.items[i];
                      break;
                    }
                  }
                   return match;
                });
              };
               that.selectItem = function(item) {
                ngModel.$setViewValue(item);
                ngModel.$processModelValue();
                that.onSelect({item: item});
              };
            }
          });
       </file>
       <file name="autocomplete.html">
         <div>
           <input type="search" ng-model="$ctrl.searchTerm" />
           <ul>
             <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
               <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
             </li>
           </ul>
         </div>
       </file>
     * </example>
     *
     */
    $processModelValue: function $processModelValue() {
      var viewValue = this.$$format();

      if (this.$viewValue !== viewValue) {
        this.$$updateEmptyClasses(viewValue);
        this.$viewValue = this.$$lastCommittedViewValue = viewValue;
        this.$render();
        // It is possible that model and view value have been updated during render
        this.$$runValidators(this.$modelValue, this.$viewValue, noop);
      }
    },

    /**
     * This method is called internally to run the $formatters on the $modelValue
     */
    $$format: function $$format() {
      var formatters = this.$formatters,
          idx = formatters.length;

      var viewValue = this.$modelValue;
      while (idx--) {
        viewValue = formatters[idx](viewValue);
      }

      return viewValue;
    },

    /**
     * This method is called internally when the bound scope value changes.
     */
    $$setModelValue: function $$setModelValue(modelValue) {
      this.$modelValue = this.$$rawModelValue = modelValue;
      this.$$parserValid = undefined;
      this.$processModelValue();
    },

    $$setUpdateOnEvents: function $$setUpdateOnEvents() {
      if (this.$$updateEvents) {
        this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
      }

      this.$$updateEvents = this.$options.getOption('updateOn');
      if (this.$$updateEvents) {
        this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
      }
    },

    $$updateEventHandler: function $$updateEventHandler(ev) {
      this.$$debounceViewValueCommit(ev && ev.type);
    }
  };

  function setupModelWatcher(ctrl) {
    // model -> value
    // Note: we cannot use a normal scope.$watch as we want to detect the following:
    // 1. scope value is 'a'
    // 2. user enters 'b'
    // 3. ng-change kicks in and reverts scope value to 'a'
    //    -> scope value did not change since the last digest as
    //       ng-change executes in apply phase
    // 4. view should be changed back to 'a'
    ctrl.$$scope.$watch(function ngModelWatch(scope) {
      var modelValue = ctrl.$$ngModelGet(scope);

      // if scope model value and ngModel value are out of sync
      // This cannot be moved to the action function, because it would not catch the
      // case where the model is changed in the ngChange function or the model setter
      if (modelValue !== ctrl.$modelValue && (
      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
      // eslint-disable-next-line no-self-compare
      ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)) {
        ctrl.$$setModelValue(modelValue);
      }

      return modelValue;
    });
  }

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setValidity
   *
   * @description
   * Change the validity state, and notify the form.
   *
   * This method can be called within $parsers/$formatters or a custom validation implementation.
   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
   *
   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
   *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
   *                          Skipped is used by AngularJS when validators do not run because of parse errors and
   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
   */
  addSetValidityMethod({
    clazz: NgModelController,
    set: function set(object, property) {
      object[property] = true;
    },
    unset: function unset(object, property) {
      delete object[property];
    }
  });

  /**
   * @ngdoc directive
   * @name ngModel
   * @restrict A
   * @priority 1
   * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
   *
   * @description
   * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
   * property on the scope using {@link ngModel.NgModelController NgModelController},
   * which is created and exposed by this directive.
   *
   * `ngModel` is responsible for:
   *
   * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
   *   require.
   * - Providing validation behavior (i.e. required, number, email, url).
   * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
   * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
   *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
   * - Registering the control with its parent {@link ng.directive:form form}.
   *
   * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
   * current scope. If the property doesn't already exist on this scope, it will be created
   * implicitly and added to the scope.
   *
   * For best practices on using `ngModel`, see:
   *
   *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
   *
   * For basic examples, how to use `ngModel`, see:
   *
   *  - {@link ng.directive:input input}
   *    - {@link input[text] text}
   *    - {@link input[checkbox] checkbox}
   *    - {@link input[radio] radio}
   *    - {@link input[number] number}
   *    - {@link input[email] email}
   *    - {@link input[url] url}
   *    - {@link input[date] date}
   *    - {@link input[datetime-local] datetime-local}
   *    - {@link input[time] time}
   *    - {@link input[month] month}
   *    - {@link input[week] week}
   *  - {@link ng.directive:select select}
   *  - {@link ng.directive:textarea textarea}
   *
   * ## Complex Models (objects or collections)
   *
   * By default, `ngModel` watches the model by reference, not value. This is important to know when
   * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
   * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
   *
   * The model must be assigned an entirely new object or collection before a re-rendering will occur.
   *
   * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
   * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
   * if the select is given the `multiple` attribute.
   *
   * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
   * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
   * not trigger a re-rendering of the model.
   *
   * ## CSS classes
   * The following CSS classes are added and removed on the associated input/select/textarea element
   * depending on the validity of the model.
   *
   *  - `ng-valid`: the model is valid
   *  - `ng-invalid`: the model is invalid
   *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
   *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
   *  - `ng-pristine`: the control hasn't been interacted with yet
   *  - `ng-dirty`: the control has been interacted with
   *  - `ng-touched`: the control has been blurred
   *  - `ng-untouched`: the control hasn't been blurred
   *  - `ng-pending`: any `$asyncValidators` are unfulfilled
   *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
   *     by the {@link ngModel.NgModelController#$isEmpty} method
   *  - `ng-not-empty`: the view contains a non-empty value
   *
   * Keep in mind that ngAnimate can detect each of these classes when added and removed.
   *
   * @animations
   * Animations within models are triggered when any of the associated CSS classes are added and removed
   * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
   * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
   * The animations that are triggered within ngModel are similar to how they work in ngClass and
   * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
   *
   * The following example shows a simple way to utilize CSS transitions to style an input element
   * that has been rendered as invalid after it has been validated:
   *
   * <pre>
   * //be sure to include ngAnimate as a module to hook into more
   * //advanced animations
   * .my-input {
   *   transition:0.5s linear all;
   *   background: white;
   * }
   * .my-input.ng-invalid {
   *   background: red;
   *   color:white;
   * }
   * </pre>
   *
   * @example
   * ### Basic Usage
   * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
       <file name="index.html">
         <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.val = '1';
            }]);
         </script>
         <style>
           .my-input {
             transition:all linear 0.5s;
             background: transparent;
           }
           .my-input.ng-invalid {
             color:white;
             background: red;
           }
         </style>
         <p id="inputDescription">
          Update input to see transitions when valid/invalid.
          Integer is a valid value.
         </p>
         <form name="testForm" ng-controller="ExampleController">
           <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                  aria-describedby="inputDescription" />
         </form>
       </file>
   * </example>
   *
   * @example
   * ### Binding to a getter/setter
   *
   * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
   * function that returns a representation of the model when called with zero arguments, and sets
   * the internal state of a model when called with an argument. It's sometimes useful to use this
   * for models that have an internal representation that's different from what the model exposes
   * to the view.
   *
   * <div class="alert alert-success">
   * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
   * frequently than other parts of your code.
   * </div>
   *
   * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
   * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
   * a `<form>`, which will enable this behavior for all `<input>`s within it. See
   * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
   *
   * The following example shows how to use `ngModel` with a getter/setter:
   *
   * @example
   * <example name="ngModel-getter-setter" module="getterSetterExample">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <form name="userForm">
             <label>Name:
               <input type="text" name="userName"
                      ng-model="user.name"
                      ng-model-options="{ getterSetter: true }" />
             </label>
           </form>
           <pre>user.name = <span ng-bind="user.name()"></span></pre>
         </div>
       </file>
       <file name="app.js">
         angular.module('getterSetterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             var _name = 'Brian';
             $scope.user = {
               name: function(newName) {
                // Note that newName can be undefined for two reasons:
                // 1. Because it is called as a getter and thus called with no arguments
                // 2. Because the property should actually be set to undefined. This happens e.g. if the
                //    input is invalid
                return arguments.length ? (_name = newName) : _name;
               }
             };
           }]);
       </file>
   * </example>
   */
  var ngModelDirective = ['$rootScope', function ($rootScope) {
    return {
      restrict: 'A',
      require: ['ngModel', '^?form', '^?ngModelOptions'],
      controller: NgModelController,
      // Prelink needs to run before any input directive
      // so that we can set the NgModelOptions in NgModelController
      // before anyone else uses it.
      priority: 1,
      compile: function ngModelCompile(element) {
        // Setup initial state of the control
        element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);

        return {
          pre: function ngModelPreLink(scope, element, attr, ctrls) {
            var modelCtrl = ctrls[0],
                formCtrl = ctrls[1] || modelCtrl.$$parentForm,
                optionsCtrl = ctrls[2];

            if (optionsCtrl) {
              modelCtrl.$options = optionsCtrl.$options;
            }

            modelCtrl.$$initGetterSetters();

            // notify others, especially parent forms
            formCtrl.$addControl(modelCtrl);

            attr.$observe('name', function (newValue) {
              if (modelCtrl.$name !== newValue) {
                modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
              }
            });

            scope.$on('$destroy', function () {
              modelCtrl.$$parentForm.$removeControl(modelCtrl);
            });
          },
          post: function ngModelPostLink(scope, element, attr, ctrls) {
            var modelCtrl = ctrls[0];
            modelCtrl.$$setUpdateOnEvents();

            function setTouched() {
              modelCtrl.$setTouched();
            }

            element.on('blur', function () {
              if (modelCtrl.$touched) return;

              if ($rootScope.$$phase) {
                scope.$evalAsync(setTouched);
              } else {
                scope.$apply(setTouched);
              }
            });
          }
        };
      }
    };
  }];

  /* exported defaultModelOptions */
  var defaultModelOptions;
  var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

  /**
   * @ngdoc type
   * @name ModelOptions
   * @description
   * A container for the options set by the {@link ngModelOptions} directive
   */
  function ModelOptions(options) {
    this.$$options = options;
  }

  ModelOptions.prototype = {

    /**
     * @ngdoc method
     * @name ModelOptions#getOption
     * @param {string} name the name of the option to retrieve
     * @returns {*} the value of the option
     * @description
     * Returns the value of the given option
     */
    getOption: function getOption(name) {
      return this.$$options[name];
    },

    /**
     * @ngdoc method
     * @name ModelOptions#createChild
     * @param {Object} options a hash of options for the new child that will override the parent's options
     * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
     */
    createChild: function createChild(options) {
      var inheritAll = false;

      // make a shallow copy
      options = extend({}, options);

      // Inherit options from the parent if specified by the value `"$inherit"`
      forEach(options, /* @this */function (option, key) {
        if (option === '$inherit') {
          if (key === '*') {
            inheritAll = true;
          } else {
            options[key] = this.$$options[key];
            // `updateOn` is special so we must also inherit the `updateOnDefault` option
            if (key === 'updateOn') {
              options.updateOnDefault = this.$$options.updateOnDefault;
            }
          }
        } else {
          if (key === 'updateOn') {
            // If the `updateOn` property contains the `default` event then we have to remove
            // it from the event list and set the `updateOnDefault` flag.
            options.updateOnDefault = false;
            options[key] = trim(option.replace(DEFAULT_REGEXP, function () {
              options.updateOnDefault = true;
              return ' ';
            }));
          }
        }
      }, this);

      if (inheritAll) {
        // We have a property of the form: `"*": "$inherit"`
        delete options['*'];
        defaults(options, this.$$options);
      }

      // Finally add in any missing defaults
      defaults(options, defaultModelOptions.$$options);

      return new ModelOptions(options);
    }
  };

  defaultModelOptions = new ModelOptions({
    updateOn: '',
    updateOnDefault: true,
    debounce: 0,
    getterSetter: false,
    allowInvalid: false,
    timezone: null
  });

  /**
   * @ngdoc directive
   * @name ngModelOptions
   * @restrict A
   * @priority 10
   *
   * @description
   * This directive allows you to modify the behaviour of {@link ngModel} directives within your
   * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
   * directives will use the options of their nearest `ngModelOptions` ancestor.
   *
   * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
   * an AngularJS expression. This expression should evaluate to an object, whose properties contain
   * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
   *
   * ## Inheriting Options
   *
   * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
   * directive by giving it the value of `"$inherit"`.
   * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
   * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
   * will be used.
   *
   * For example given the following fragment of HTML
   *
   *
   * ```html
   * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
   *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
   *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
   *   </form>
   * </div>
   * ```
   *
   * the `input` element will have the following settings
   *
   * ```js
   * { allowInvalid: true, updateOn: 'default', debounce: 0 }
   * ```
   *
   * Notice that the `debounce` setting was not inherited and used the default value instead.
   *
   * You can specify that all undefined settings are automatically inherited from an ancestor by
   * including a property with key of `"*"` and value of `"$inherit"`.
   *
   * For example given the following fragment of HTML
   *
   *
   * ```html
   * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
   *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
   *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
   *   </form>
   * </div>
   * ```
   *
   * the `input` element will have the following settings
   *
   * ```js
   * { allowInvalid: true, updateOn: 'default', debounce: 200 }
   * ```
   *
   * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
   *
   * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
   * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
   *
   *
   * ## Triggering and debouncing model updates
   *
   * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
   * trigger a model update and/or a debouncing delay so that the actual update only takes place when
   * a timer expires; this timer will be reset after another change takes place.
   *
   * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
   * be different from the value in the actual model. This means that if you update the model you
   * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
   * order to make sure it is synchronized with the model and that any debounced action is canceled.
   *
   * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
   * method is by making sure the input is placed inside a form that has a `name` attribute. This is
   * important because `form` controllers are published to the related scope under the name in their
   * `name` attribute.
   *
   * Any pending changes will take place immediately when an enclosing form is submitted via the
   * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
   * to have access to the updated model.
   *
   * ### Overriding immediate updates
   *
   * The following example shows how to override immediate updates. Changes on the inputs within the
   * form will update the model only when the control loses focus (blur event). If `escape` key is
   * pressed while the input field is focused, the value is reset to the value in the current model.
   *
   * <example name="ngModelOptions-directive-blur" module="optionsExample">
   *   <file name="index.html">
   *     <div ng-controller="ExampleController">
   *       <form name="userForm">
   *         <label>
   *           Name:
   *           <input type="text" name="userName"
   *                  ng-model="user.name"
   *                  ng-model-options="{ updateOn: 'blur' }"
   *                  ng-keyup="cancel($event)" />
   *         </label><br />
   *         <label>
   *           Other data:
   *           <input type="text" ng-model="user.data" />
   *         </label><br />
   *       </form>
   *       <pre>user.name = <span ng-bind="user.name"></span></pre>
   *     </div>
   *   </file>
   *   <file name="app.js">
   *     angular.module('optionsExample', [])
   *       .controller('ExampleController', ['$scope', function($scope) {
   *         $scope.user = { name: 'say', data: '' };
   *
   *         $scope.cancel = function(e) {
   *           if (e.keyCode === 27) {
   *             $scope.userForm.userName.$rollbackViewValue();
   *           }
   *         };
   *       }]);
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     var model = element(by.binding('user.name'));
   *     var input = element(by.model('user.name'));
   *     var other = element(by.model('user.data'));
   *
   *     it('should allow custom events', function() {
   *       input.sendKeys(' hello');
   *       input.click();
   *       expect(model.getText()).toEqual('say');
   *       other.click();
   *       expect(model.getText()).toEqual('say hello');
   *     });
   *
   *     it('should $rollbackViewValue when model changes', function() {
   *       input.sendKeys(' hello');
   *       expect(input.getAttribute('value')).toEqual('say hello');
   *       input.sendKeys(protractor.Key.ESCAPE);
   *       expect(input.getAttribute('value')).toEqual('say');
   *       other.click();
   *       expect(model.getText()).toEqual('say');
   *     });
   *   </file>
   * </example>
   *
   * ### Debouncing updates
   *
   * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
   * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
   *
   * <example name="ngModelOptions-directive-debounce" module="optionsExample">
   *   <file name="index.html">
   *     <div ng-controller="ExampleController">
   *       <form name="userForm">
   *         Name:
   *         <input type="text" name="userName"
   *                ng-model="user.name"
   *                ng-model-options="{ debounce: 1000 }" />
   *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
   *       </form>
   *       <pre>user.name = <span ng-bind="user.name"></span></pre>
   *     </div>
   *   </file>
   *   <file name="app.js">
   *     angular.module('optionsExample', [])
   *       .controller('ExampleController', ['$scope', function($scope) {
   *         $scope.user = { name: 'say' };
   *       }]);
   *   </file>
   * </example>
   *
   *
   * ## Model updates and validation
   *
   * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
   * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
   * the model will still be updated even if the value is invalid.
   *
   *
   * ## Connecting to the scope
   *
   * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
   * on the scope refers to a "getter/setter" function rather than the value itself.
   *
   * The following example shows how to bind to getter/setters:
   *
   * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
   *   <file name="index.html">
   *     <div ng-controller="ExampleController">
   *       <form name="userForm">
   *         <label>
   *           Name:
   *           <input type="text" name="userName"
   *                  ng-model="user.name"
   *                  ng-model-options="{ getterSetter: true }" />
   *         </label>
   *       </form>
   *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
   *     </div>
   *   </file>
   *   <file name="app.js">
   *     angular.module('getterSetterExample', [])
   *       .controller('ExampleController', ['$scope', function($scope) {
   *         var _name = 'Brian';
   *         $scope.user = {
   *           name: function(newName) {
   *             return angular.isDefined(newName) ? (_name = newName) : _name;
   *           }
   *         };
   *       }]);
   *   </file>
   * </example>
   *
   *
   * ## Specifying timezones
   *
   * You can specify the timezone that date/time input directives expect by providing its name in the
   * `timezone` property.
   *
   *
   * ## Programmatically changing options
   *
   * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
   * watched for changes. However, it is possible to override the options on a single
   * {@link ngModel.NgModelController} instance with
   * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
   *
   *
   * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
   *   and its descendents. Valid keys are:
   *   - `updateOn`: string specifying which event should the input be bound to. You can set several
   *     events using an space delimited list. There is a special event called `default` that
   *     matches the default events belonging to the control. These are the events that are bound to
   *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
   *
   *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
   *     since different control types use different default events.
   *
   *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
   *     Triggering and debouncing model updates}.
   *
   *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
   *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
   *     custom value for each event. For example:
   *     ```
   *     ng-model-options="{
   *       updateOn: 'default blur click',
   *       debounce: { 'default': 500, 'blur': 0 }
   *     }"
   *     ```
   *
   *     "default" also applies to all events that are listed in `updateOn` but are not
   *     listed in `debounce`, i.e. "click" would also be debounced by 500 milliseconds.
   *
   *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
   *     not validate correctly instead of the default behavior of setting the model to undefined.
   *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
   *     `ngModel` as getters/setters.
   *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
   *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
   *     continental US time zone abbreviations, but for general use, use a time zone offset, for
   *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
   *     If not specified, the timezone of the browser will be used.
   *
   */
  var ngModelOptionsDirective = function ngModelOptionsDirective() {
    NgModelOptionsController.$inject = ['$attrs', '$scope'];
    function NgModelOptionsController($attrs, $scope) {
      this.$$attrs = $attrs;
      this.$$scope = $scope;
    }
    NgModelOptionsController.prototype = {
      $onInit: function $onInit() {
        var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
        var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);

        this.$options = parentOptions.createChild(modelOptionsDefinition);
      }
    };

    return {
      restrict: 'A',
      // ngModelOptions needs to run before ngModel and input directives
      priority: 10,
      require: { parentCtrl: '?^^ngModelOptions' },
      bindToController: true,
      controller: NgModelOptionsController
    };
  };

  // shallow copy over values from `src` that are not already specified on `dst`
  function defaults(dst, src) {
    forEach(src, function (value, key) {
      if (!isDefined(dst[key])) {
        dst[key] = value;
      }
    });
  }

  /**
   * @ngdoc directive
   * @name ngNonBindable
   * @restrict AC
   * @priority 1000
   * @element ANY
   *
   * @description
   * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
   * DOM element, including directives on the element itself that have a lower priority than
   * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
   * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
   * that displays snippets of code, for instance.
   *
   * @example
   * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
   * but the one wrapped in `ngNonBindable` is left alone.
   *
    <example name="ng-non-bindable">
      <file name="index.html">
        <div>Normal: {{1 + 2}}</div>
        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
      </file>
      <file name="protractor.js" type="protractor">
       it('should check ng-non-bindable', function() {
         expect(element(by.binding('1 + 2')).getText()).toContain('3');
         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
       });
      </file>
    </example>
   */
  var ngNonBindableDirective = ngDirective({ terminal: true, priority: 1000 });

  /* exported ngOptionsDirective */

  /* global jqLiteRemove */

  var ngOptionsMinErr = minErr('ngOptions');

  /**
   * @ngdoc directive
   * @name ngOptions
   * @restrict A
   *
   * @description
   *
   * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
   * elements for the `<select>` element using the array or object obtained by evaluating the
   * `ngOptions` comprehension expression.
   *
   * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
   * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
   * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
   * comprehension expression
   * - reduced memory consumption by not creating a new scope for each repeated instance
   * - increased render speed by creating the options in a documentFragment instead of individually
   *
   * When an item in the `<select>` menu is selected, the array element or object property
   * represented by the selected option will be bound to the model identified by the `ngModel`
   * directive.
   *
   * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
   * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
   * option. See example below for demonstration.
   *
   * ## Complex Models (objects or collections)
   *
   * By default, `ngModel` watches the model by reference, not value. This is important to know when
   * binding the select to a model that is an object or a collection.
   *
   * One issue occurs if you want to preselect an option. For example, if you set
   * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
   * because the objects are not identical. So by default, you should always reference the item in your collection
   * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
   *
   * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
   * of the item not by reference, but by the result of the `track by` expression. For example, if your
   * collection items have an id property, you would `track by item.id`.
   *
   * A different issue with objects or collections is that ngModel won't detect if an object property or
   * a collection item changes. For that reason, `ngOptions` additionally watches the model using
   * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
   * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
   * has not changed identity, but only a property on the object or an item in the collection changes.
   *
   * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
   * if the model is an array). This means that changing a property deeper than the first level inside the
   * object/collection will not trigger a re-rendering.
   *
   * ## `select` **`as`**
   *
   * Using `select` **`as`** will bind the result of the `select` expression to the model, but
   * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
   * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
   * is used, the result of that expression will be set as the value of the `option` and `select` elements.
   *
   *
   * ### `select` **`as`** and **`track by`**
   *
   * <div class="alert alert-warning">
   * Be careful when using `select` **`as`** and **`track by`** in the same expression.
   * </div>
   *
   * Given this array of items on the $scope:
   *
   * ```js
   * $scope.items = [{
   *   id: 1,
   *   label: 'aLabel',
   *   subItem: { name: 'aSubItem' }
   * }, {
   *   id: 2,
   *   label: 'bLabel',
   *   subItem: { name: 'bSubItem' }
   * }];
   * ```
   *
   * This will work:
   *
   * ```html
   * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
   * ```
   * ```js
   * $scope.selected = $scope.items[0];
   * ```
   *
   * but this will not work:
   *
   * ```html
   * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
   * ```
   * ```js
   * $scope.selected = $scope.items[0].subItem;
   * ```
   *
   * In both examples, the **`track by`** expression is applied successfully to each `item` in the
   * `items` array. Because the selected option has been set programmatically in the controller, the
   * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
   * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
   * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
   * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
   * is not matched against any `<option>` and the `<select>` appears as having no selected value.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {comprehension_expression} ngOptions in one of the following forms:
   *
   *   * for array data sources:
   *     * `label` **`for`** `value` **`in`** `array`
   *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
   *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
   *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
   *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
   *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
   *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
   *        (for including a filter with `track by`)
   *   * for object data sources:
   *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
   *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
   *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
   *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
   *     * `select` **`as`** `label` **`group by`** `group`
   *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
   *     * `select` **`as`** `label` **`disable when`** `disable`
   *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
   *
   * Where:
   *
   *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
   *   * `value`: local variable which will refer to each item in the `array` or each property value
   *      of `object` during iteration.
   *   * `key`: local variable which will refer to a property name in `object` during iteration.
   *   * `label`: The result of this expression will be the label for `<option>` element. The
   *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
   *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
   *      element. If not specified, `select` expression will default to `value`.
   *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
   *      DOM element.
   *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
   *      element. Return `true` to disable.
   *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
   *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
   *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
   *      even when the options are recreated (e.g. reloaded from the server).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required The control is considered valid only if value is entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
   * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
   *
   * @example
      <example module="selectExample" name="select">
        <file name="index.html">
          <script>
          angular.module('selectExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.colors = [
                {name:'black', shade:'dark'},
                {name:'white', shade:'light', notAnOption: true},
                {name:'red', shade:'dark'},
                {name:'blue', shade:'dark', notAnOption: true},
                {name:'yellow', shade:'light', notAnOption: false}
              ];
              $scope.myColor = $scope.colors[2]; // red
            }]);
          </script>
          <div ng-controller="ExampleController">
            <ul>
              <li ng-repeat="color in colors">
                <label>Name: <input ng-model="color.name"></label>
                <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
                <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
              </li>
              <li>
                <button ng-click="colors.push({})">add</button>
              </li>
            </ul>
            <hr/>
            <label>Color (null not allowed):
              <select ng-model="myColor" ng-options="color.name for color in colors"></select>
            </label><br/>
            <label>Color (null allowed):
            <span  class="nullable">
              <select ng-model="myColor" ng-options="color.name for color in colors">
                <option value="">-- choose color --</option>
              </select>
            </span></label><br/>
  
            <label>Color grouped by shade:
              <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
              </select>
            </label><br/>
  
            <label>Color grouped by shade, with some disabled:
              <select ng-model="myColor"
                    ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
              </select>
            </label><br/>
  
  
  
            Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
            <br/>
            <hr/>
            Currently selected: {{ {selected_color:myColor} }}
            <div style="border:solid 1px black; height:20px"
                 ng-style="{'background-color':myColor.name}">
            </div>
          </div>
        </file>
        <file name="protractor.js" type="protractor">
           it('should check ng-options', function() {
             expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
             element.all(by.model('myColor')).first().click();
             element.all(by.css('select[ng-model="myColor"] option')).first().click();
             expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
             element(by.css('.nullable select[ng-model="myColor"]')).click();
             element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
             expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
           });
        </file>
      </example>
   */

  /* eslint-disable max-len */
  //                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
  var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
  // 1: value expression (valueFn)
  // 2: label expression (displayFn)
  // 3: group by expression (groupByFn)
  // 4: disable when expression (disableWhenFn)
  // 5: array item variable name
  // 6: object item key variable name
  // 7: object item value variable name
  // 8: collection expression
  // 9: track by expression
  /* eslint-enable */

  var ngOptionsDirective = ['$compile', '$document', '$parse', function ($compile, $document, $parse) {

    function parseOptionsExpression(optionsExp, selectElement, scope) {

      var match = optionsExp.match(NG_OPTIONS_REGEXP);
      if (!match) {
        throw ngOptionsMinErr('iexp', 'Expected expression in form of ' + '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' + ' but got \'{0}\'. Element: {1}', optionsExp, startingTag(selectElement));
      }

      // Extract the parts from the ngOptions expression

      // The variable name for the value of the item in the collection
      var valueName = match[5] || match[7];
      // The variable name for the key of the item in the collection
      var keyName = match[6];

      // An expression that generates the viewValue for an option if there is a label expression
      var selectAs = / as /.test(match[0]) && match[1];
      // An expression that is used to track the id of each object in the options collection
      var trackBy = match[9];
      // An expression that generates the viewValue for an option if there is no label expression
      var valueFn = $parse(match[2] ? match[1] : valueName);
      var selectAsFn = selectAs && $parse(selectAs);
      var viewValueFn = selectAsFn || valueFn;
      var trackByFn = trackBy && $parse(trackBy);

      // Get the value by which we are going to track the option
      // if we have a trackFn then use that (passing scope and locals)
      // otherwise just hash the given viewValue
      var getTrackByValueFn = trackBy ? function (value, locals) {
        return trackByFn(scope, locals);
      } : function getHashOfValue(value) {
        return hashKey(value);
      };
      var getTrackByValue = function getTrackByValue(value, key) {
        return getTrackByValueFn(value, getLocals(value, key));
      };

      var displayFn = $parse(match[2] || match[1]);
      var groupByFn = $parse(match[3] || '');
      var disableWhenFn = $parse(match[4] || '');
      var valuesFn = $parse(match[8]);

      var locals = {};
      var getLocals = keyName ? function (value, key) {
        locals[keyName] = key;
        locals[valueName] = value;
        return locals;
      } : function (value) {
        locals[valueName] = value;
        return locals;
      };

      function Option(selectValue, viewValue, label, group, disabled) {
        this.selectValue = selectValue;
        this.viewValue = viewValue;
        this.label = label;
        this.group = group;
        this.disabled = disabled;
      }

      function getOptionValuesKeys(optionValues) {
        var optionValuesKeys;

        if (!keyName && isArrayLike(optionValues)) {
          optionValuesKeys = optionValues;
        } else {
          // if object, extract keys, in enumeration order, unsorted
          optionValuesKeys = [];
          for (var itemKey in optionValues) {
            if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
              optionValuesKeys.push(itemKey);
            }
          }
        }
        return optionValuesKeys;
      }

      return {
        trackBy: trackBy,
        getTrackByValue: getTrackByValue,
        getWatchables: $parse(valuesFn, function (optionValues) {
          // Create a collection of things that we would like to watch (watchedArray)
          // so that they can all be watched using a single $watchCollection
          // that only runs the handler once if anything changes
          var watchedArray = [];
          optionValues = optionValues || [];

          var optionValuesKeys = getOptionValuesKeys(optionValues);
          var optionValuesLength = optionValuesKeys.length;
          for (var index = 0; index < optionValuesLength; index++) {
            var key = optionValues === optionValuesKeys ? index : optionValuesKeys[index];
            var value = optionValues[key];

            var locals = getLocals(value, key);
            var selectValue = getTrackByValueFn(value, locals);
            watchedArray.push(selectValue);

            // Only need to watch the displayFn if there is a specific label expression
            if (match[2] || match[1]) {
              var label = displayFn(scope, locals);
              watchedArray.push(label);
            }

            // Only need to watch the disableWhenFn if there is a specific disable expression
            if (match[4]) {
              var disableWhen = disableWhenFn(scope, locals);
              watchedArray.push(disableWhen);
            }
          }
          return watchedArray;
        }),

        getOptions: function getOptions() {

          var optionItems = [];
          var selectValueMap = {};

          // The option values were already computed in the `getWatchables` fn,
          // which must have been called to trigger `getOptions`
          var optionValues = valuesFn(scope) || [];
          var optionValuesKeys = getOptionValuesKeys(optionValues);
          var optionValuesLength = optionValuesKeys.length;

          for (var index = 0; index < optionValuesLength; index++) {
            var key = optionValues === optionValuesKeys ? index : optionValuesKeys[index];
            var value = optionValues[key];
            var locals = getLocals(value, key);
            var viewValue = viewValueFn(scope, locals);
            var selectValue = getTrackByValueFn(viewValue, locals);
            var label = displayFn(scope, locals);
            var group = groupByFn(scope, locals);
            var disabled = disableWhenFn(scope, locals);
            var optionItem = new Option(selectValue, viewValue, label, group, disabled);

            optionItems.push(optionItem);
            selectValueMap[selectValue] = optionItem;
          }

          return {
            items: optionItems,
            selectValueMap: selectValueMap,
            getOptionFromViewValue: function getOptionFromViewValue(value) {
              return selectValueMap[getTrackByValue(value)];
            },
            getViewValueFromOption: function getViewValueFromOption(option) {
              // If the viewValue could be an object that may be mutated by the application,
              // we need to make a copy and not return the reference to the value on the option.
              return trackBy ? copy(option.viewValue) : option.viewValue;
            }
          };
        }
      };
    }

    // Support: IE 9 only
    // We can't just jqLite('<option>') since jqLite is not smart enough
    // to create it in <select> and IE barfs otherwise.
    var optionTemplate = window.document.createElement('option'),
        optGroupTemplate = window.document.createElement('optgroup');

    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          selectCtrl.hasEmptyOption = true;
          selectCtrl.emptyOption = children.eq(i);
          break;
        }
      }

      // The empty option will be compiled and rendered before we first generate the options
      selectElement.empty();

      var providedEmptyOption = !!selectCtrl.emptyOption;

      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');

      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      // Overwrite the implementation. ngOptions doesn't use hashes
      selectCtrl.generateUnknownOptionValue = function (val) {
        return '?';
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {

        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
          var option = options.getOptionFromViewValue(value);

          // Make sure to remove the selected attribute from the previously selected option
          // Otherwise, screen readers might get confused
          if (selectedOption) selectedOption.removeAttribute('selected');

          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              selectCtrl.removeUnknownOption();

              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }

            option.element.setAttribute('selected', 'selected');
          } else {
            selectCtrl.selectUnknownOrEmptyOption(value);
          }
        };

        selectCtrl.readValue = function readNgOptionsValue() {

          var selectedOption = options.selectValueMap[selectElement.val()];

          if (selectedOption && !selectedOption.disabled) {
            selectCtrl.unselectEmptyOption();
            selectCtrl.removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        // FIXME: When a user selects an option, this watch will fire needlessly
        if (ngOptions.trackBy) {
          scope.$watch(function () {
            return ngOptions.getTrackByValue(ngModelCtrl.$viewValue);
          }, function () {
            ngModelCtrl.$render();
          });
        }
      } else {

        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];

          options.items.forEach(function (option) {
            if (option.element.selected && !includes(selectedOptions, option)) {
              option.element.selected = false;
            }
          });
        };

        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
              selections = [];

          forEach(selectedValues, function (value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });

          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {

          scope.$watchCollection(function () {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function (value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function () {
            ngModelCtrl.$render();
          });
        }
      }

      if (providedEmptyOption) {

        // compile the element since there might be bindings in it
        $compile(selectCtrl.emptyOption)(scope);

        selectElement.prepend(selectCtrl.emptyOption);

        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
          // This means the empty option has currently no actual DOM node, probably because
          // it has been modified by a transclusion directive.
          selectCtrl.hasEmptyOption = false;

          // Redefine the registerOption function, which will catch
          // options that are added by ngIf etc. (rendering of the node is async because of
          // lazy transclusion)
          selectCtrl.registerOption = function (optionScope, optionEl) {
            if (optionEl.val() === '') {
              selectCtrl.hasEmptyOption = true;
              selectCtrl.emptyOption = optionEl;
              selectCtrl.emptyOption.removeClass('ng-scope');
              // This ensures the new empty option is selected if previously no option was selected
              ngModelCtrl.$render();

              optionEl.on('$destroy', function () {
                var needsRerender = selectCtrl.$isEmptyOptionSelected();

                selectCtrl.hasEmptyOption = false;
                selectCtrl.emptyOption = undefined;

                if (needsRerender) ngModelCtrl.$render();
              });
            }
          };
        } else {
          // remove the class, which is added automatically because we recompile the element and it
          // becomes the compilation root
          selectCtrl.emptyOption.removeClass('ng-scope');
        }
      }

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }

      function getAndUpdateSelectedOption(viewValue) {
        var option = options.getOptionFromViewValue(viewValue);
        var element = option && option.element;

        if (element && !element.selected) element.selected = true;

        return option;
      }

      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // Support: IE 11 only, Edge 12-13 only
        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        element.value = option.selectValue;
      }

      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {

          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }

        options = ngOptions.getOptions();

        var groupElementMap = {};

        options.items.forEach(function addOption(option) {
          var groupElement;

          if (isDefined(option.group)) {

            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];

            if (!groupElement) {

              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? 'null' : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }

            addOptionElement(option, groupElement);
          } else {

            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });

        selectElement[0].appendChild(listFragment);

        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }
      }
    }

    return {
      restrict: 'A',
      terminal: true,
      require: ['select', 'ngModel'],
      link: {
        pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
          // Deactivate the SelectController.register method to prevent
          // option directives from accidentally registering themselves
          // (and unwanted $destroy handlers etc.)
          ctrls[0].registerOption = noop;
        },
        post: ngOptionsPostLink
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngPluralize
   * @restrict EA
   *
   * @description
   * `ngPluralize` is a directive that displays messages according to en-US localization rules.
   * These rules are bundled with angular.js, but can be overridden
   * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
   * by specifying the mappings between
   * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
   * and the strings to be displayed.
   *
   * ## Plural categories and explicit number rules
   * There are two
   * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
   * in AngularJS's default en-US locale: "one" and "other".
   *
   * While a plural category may match many numbers (for example, in en-US locale, "other" can match
   * any number that is not 1), an explicit number rule can only match one number. For example, the
   * explicit number rule for "3" matches the number 3. There are examples of plural categories
   * and explicit number rules throughout the rest of this documentation.
   *
   * ## Configuring ngPluralize
   * You configure ngPluralize by providing 2 attributes: `count` and `when`.
   * You can also provide an optional attribute, `offset`.
   *
   * The value of the `count` attribute can be either a string or an {@link guide/expression
   * AngularJS expression}; these are evaluated on the current scope for its bound value.
   *
   * The `when` attribute specifies the mappings between plural categories and the actual
   * string to be displayed. The value of the attribute should be a JSON object.
   *
   * The following example shows how to configure ngPluralize:
   *
   * ```html
   * <ng-pluralize count="personCount"
                   when="{'0': 'Nobody is viewing.',
   *                      'one': '1 person is viewing.',
   *                      'other': '{} people are viewing.'}">
   * </ng-pluralize>
   *```
   *
   * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
   * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
   * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
   * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
   * show "a dozen people are viewing".
   *
   * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
   * into pluralized strings. In the previous example, AngularJS will replace `{}` with
   * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
   * for <span ng-non-bindable>{{numberExpression}}</span>.
   *
   * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
   * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
   *
   * ## Configuring ngPluralize with offset
   * The `offset` attribute allows further customization of pluralized text, which can result in
   * a better user experience. For example, instead of the message "4 people are viewing this document",
   * you might display "John, Kate and 2 others are viewing this document".
   * The offset attribute allows you to offset a number by any desired value.
   * Let's take a look at an example:
   *
   * ```html
   * <ng-pluralize count="personCount" offset=2
   *               when="{'0': 'Nobody is viewing.',
   *                      '1': '{{person1}} is viewing.',
   *                      '2': '{{person1}} and {{person2}} are viewing.',
   *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
   *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
   * </ng-pluralize>
   * ```
   *
   * Notice that we are still using two plural categories(one, other), but we added
   * three explicit number rules 0, 1 and 2.
   * When one person, perhaps John, views the document, "John is viewing" will be shown.
   * When three people view the document, no explicit number rule is found, so
   * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
   * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
   * is shown.
   *
   * Note that when you specify offsets, you must provide explicit number rules for
   * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
   * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
   * plural categories "one" and "other".
   *
   * @param {string|expression} count The variable to be bound to.
   * @param {string} when The mapping between plural category to its corresponding strings.
   * @param {number=} offset Offset to deduct from the total number.
   *
   * @example
      <example module="pluralizeExample" name="ng-pluralize">
        <file name="index.html">
          <script>
            angular.module('pluralizeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.person1 = 'Igor';
                $scope.person2 = 'Misko';
                $scope.personCount = 1;
              }]);
          </script>
          <div ng-controller="ExampleController">
            <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
            <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
            <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
  
            <!--- Example with simple pluralization rules for en locale --->
            Without Offset:
            <ng-pluralize count="personCount"
                          when="{'0': 'Nobody is viewing.',
                                 'one': '1 person is viewing.',
                                 'other': '{} people are viewing.'}">
            </ng-pluralize><br>
  
            <!--- Example with offset --->
            With Offset(2):
            <ng-pluralize count="personCount" offset=2
                          when="{'0': 'Nobody is viewing.',
                                 '1': '{{person1}} is viewing.',
                                 '2': '{{person1}} and {{person2}} are viewing.',
                                 'one': '{{person1}}, {{person2}} and one other person are viewing.',
                                 'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
            </ng-pluralize>
          </div>
        </file>
        <file name="protractor.js" type="protractor">
          it('should show correct pluralized string', function() {
            var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
            var withOffset = element.all(by.css('ng-pluralize')).get(1);
            var countInput = element(by.model('personCount'));
  
            expect(withoutOffset.getText()).toEqual('1 person is viewing.');
            expect(withOffset.getText()).toEqual('Igor is viewing.');
  
            countInput.clear();
            countInput.sendKeys('0');
  
            expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
            expect(withOffset.getText()).toEqual('Nobody is viewing.');
  
            countInput.clear();
            countInput.sendKeys('2');
  
            expect(withoutOffset.getText()).toEqual('2 people are viewing.');
            expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
  
            countInput.clear();
            countInput.sendKeys('3');
  
            expect(withoutOffset.getText()).toEqual('3 people are viewing.');
            expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
  
            countInput.clear();
            countInput.sendKeys('4');
  
            expect(withoutOffset.getText()).toEqual('4 people are viewing.');
            expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
          });
          it('should show data-bound names', function() {
            var withOffset = element.all(by.css('ng-pluralize')).get(1);
            var personCount = element(by.model('personCount'));
            var person1 = element(by.model('person1'));
            var person2 = element(by.model('person2'));
            personCount.clear();
            personCount.sendKeys('4');
            person1.clear();
            person1.sendKeys('Di');
            person2.clear();
            person2.sendKeys('Vojta');
            expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
          });
        </file>
      </example>
   */
  var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function ($locale, $interpolate, $log) {
    var BRACE = /{}/g,
        IS_WHEN = /^when(Minus)?(.+)$/;

    return {
      link: function link(scope, element, attr) {
        var numberExp = attr.count,
            whenExp = attr.$attr.when && element.attr(attr.$attr.when),
            // we have {{}} in attrs
        offset = attr.offset || 0,
            whens = scope.$eval(whenExp) || {},
            whensExpFns = {},
            startSymbol = $interpolate.startSymbol(),
            endSymbol = $interpolate.endSymbol(),
            braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
            watchRemover = angular.noop,
            lastCount;

        forEach(attr, function (expression, attributeName) {
          var tmpMatch = IS_WHEN.exec(attributeName);
          if (tmpMatch) {
            var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
            whens[whenKey] = element.attr(attr.$attr[attributeName]);
          }
        });
        forEach(whens, function (expression, key) {
          whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
        });

        scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
          var count = parseFloat(newVal);
          var countIsNaN = isNumberNaN(count);

          if (!countIsNaN && !(count in whens)) {
            // If an explicit number rule such as 1, 2, 3... is defined, just use it.
            // Otherwise, check it against pluralization rules in $locale service.
            count = $locale.pluralCat(count - offset);
          }

          // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
          // In JS `NaN !== NaN`, so we have to explicitly check.
          if (count !== lastCount && !(countIsNaN && isNumberNaN(lastCount))) {
            watchRemover();
            var whenExpFn = whensExpFns[count];
            if (isUndefined(whenExpFn)) {
              if (newVal != null) {
                $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
              }
              watchRemover = noop;
              updateElementText();
            } else {
              watchRemover = scope.$watch(whenExpFn, updateElementText);
            }
            lastCount = count;
          }
        });

        function updateElementText(newText) {
          element.text(newText || '');
        }
      }
    };
  }];

  /* exported ngRepeatDirective */

  /**
   * @ngdoc directive
   * @name ngRepeat
   * @multiElement
   * @restrict A
   *
   * @description
   * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
   * instance gets its own scope, where the given loop variable is set to the current collection item,
   * and `$index` is set to the item index or key.
   *
   * Special properties are exposed on the local scope of each template instance, including:
   *
   * | Variable  | Type            | Details                                                                     |
   * |-----------|-----------------|-----------------------------------------------------------------------------|
   * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
   * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
   * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
   * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
   * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
   * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
   *
   * <div class="alert alert-info">
   *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
   *   This may be useful when, for instance, nesting ngRepeats.
   * </div>
   *
   *
   * ## Iterating over object properties
   *
   * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
   * syntax:
   *
   * ```js
   * <div ng-repeat="(key, value) in myObj"> ... </div>
   * ```
   *
   * However, there are a few limitations compared to array iteration:
   *
   * - The JavaScript specification does not define the order of keys
   *   returned for an object, so AngularJS relies on the order returned by the browser
   *   when running `for key in myObj`. Browsers generally follow the strategy of providing
   *   keys in the order in which they were defined, although there are exceptions when keys are deleted
   *   and reinstated. See the
   *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
   *
   * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
   *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
   *
   * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
   *   objects, and will throw an error if used with one.
   *
   * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
   * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
   * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
   * or implement a `$watch` on the object yourself.
   *
   *
   * ## Tracking and Duplicates
   *
   * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
   * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
   *
   * * When an item is added, a new instance of the template is added to the DOM.
   * * When an item is removed, its template instance is removed from the DOM.
   * * When items are reordered, their respective templates are reordered in the DOM.
   *
   * To minimize creation of DOM elements, `ngRepeat` uses a function
   * to "keep track" of all items in the collection and their corresponding DOM elements.
   * For example, if an item is added to the collection, `ngRepeat` will know that all other items
   * already have DOM elements, and will not re-render them.
   *
   * All different types of tracking functions, their syntax, and and their support for duplicate
   * items in collections can be found in the
   * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
   *
   * <div class="alert alert-success">
   * **Best Practice:** If you are working with objects that have a unique identifier property, you
   * should track by this identifier instead of the object instance,
   * e.g. `item in items track by item.id`.
   * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
   * it has already rendered, even if the JavaScript objects in the collection have been substituted
   * for new ones. For large collections, this significantly improves rendering performance.
   * </div>
   *
   * ### Effects of DOM Element re-use
   *
   * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
   * automatically update any active bindings on the template. However, other
   * functionality will not be updated, because the element is not re-created:
   *
   * - Directives are not re-compiled
   * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
   * updated if they have stabilized.
   *
   * The above affects all kinds of element re-use due to tracking, but may be especially visible
   * when tracking by `$index` due to the way ngRepeat re-uses elements.
   *
   * The following example shows the effects of different actions with tracking:
  
    <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
      <file name="script.js">
        angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
          var friends = [
            {name:'John', age:25},
            {name:'Mary', age:40},
            {name:'Peter', age:85}
          ];
  
          $scope.removeFirst = function() {
            $scope.friends.shift();
          };
  
          $scope.updateAge = function() {
            $scope.friends.forEach(function(el) {
              el.age = el.age + 5;
            });
          };
  
          $scope.copy = function() {
            $scope.friends = angular.copy($scope.friends);
          };
  
          $scope.reset = function() {
            $scope.friends = angular.copy(friends);
          };
  
          $scope.reset();
        });
      </file>
      <file name="index.html">
        <div ng-controller="repeatController">
          <ol>
            <li>When you click "Update Age", only the first list updates the age, because all others have
            a one-time binding on the age property. If you then click "Copy", the current friend list
            is copied, and now the second list updates the age, because the identity of the collection items
            has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
            items are already known according to their tracking functions.
            </li>
            <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
            due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
            DOM element for the new first collection item, and so on. Since the age property is one-time
            bound, the value remains from the collection item which was previously at this index.
            </li>
          </ol>
  
          <button ng-click="removeFirst()">Remove First</button>
          <button ng-click="updateAge()">Update Age</button>
          <button ng-click="copy()">Copy</button>
          <br><button ng-click="reset()">Reset List</button>
          <br>
          <code>track by $id(friend)</code> (default):
          <ul class="example-animate-container">
            <li class="animate-repeat" ng-repeat="friend in friends">
              {{friend.name}} is {{friend.age}} years old.
            </li>
          </ul>
          <code>track by $id(friend)</code> (default), with age one-time binding:
          <ul class="example-animate-container">
            <li class="animate-repeat" ng-repeat="friend in friends">
              {{friend.name}} is {{::friend.age}} years old.
            </li>
          </ul>
          <code>track by friend.name</code>, with age one-time binding:
          <ul class="example-animate-container">
            <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
              {{friend.name}}  is {{::friend.age}} years old.
            </li>
          </ul>
          <code>track by $index</code>, with age one-time binding:
          <ul class="example-animate-container">
            <li class="animate-repeat" ng-repeat="friend in friends track by $index">
              {{friend.name}} is {{::friend.age}} years old.
            </li>
          </ul>
        </div>
      </file>
      <file name="animations.css">
        .example-animate-container {
          background:white;
          border:1px solid black;
          list-style:none;
          margin:0;
          padding:0 10px;
        }
  
        .animate-repeat {
          line-height:30px;
          list-style:none;
          box-sizing:border-box;
        }
  
        .animate-repeat.ng-move,
        .animate-repeat.ng-enter,
        .animate-repeat.ng-leave {
          transition:all linear 0.5s;
        }
  
        .animate-repeat.ng-leave.ng-leave-active,
        .animate-repeat.ng-move,
        .animate-repeat.ng-enter {
          opacity:0;
          max-height:0;
        }
  
        .animate-repeat.ng-leave,
        .animate-repeat.ng-move.ng-move-active,
        .animate-repeat.ng-enter.ng-enter-active {
          opacity:1;
          max-height:30px;
        }
      </file>
    </example>
  
   *
   * ## Special repeat start and end points
   * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
   * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
   * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
   * up to and including the ending HTML tag where **ng-repeat-end** is placed.
   *
   * The example below makes use of this feature:
   * ```html
   *   <header ng-repeat-start="item in items">
   *     Header {{ item }}
   *   </header>
   *   <div class="body">
   *     Body {{ item }}
   *   </div>
   *   <footer ng-repeat-end>
   *     Footer {{ item }}
   *   </footer>
   * ```
   *
   * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
   * ```html
   *   <header>
   *     Header A
   *   </header>
   *   <div class="body">
   *     Body A
   *   </div>
   *   <footer>
   *     Footer A
   *   </footer>
   *   <header>
   *     Header B
   *   </header>
   *   <div class="body">
   *     Body B
   *   </div>
   *   <footer>
   *     Footer B
   *   </footer>
   * ```
   *
   * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
   * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
   *
   * @animations
   * | Animation                        | Occurs                              |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
   * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
   * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
   *
   * See the example below for defining CSS animations with ngRepeat.
   *
   * @element ANY
   * @scope
   * @priority 1000
   * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
   *   formats are currently supported:
   *
   *   * `variable in expression` – where variable is the user defined loop variable and `expression`
   *     is a scope expression giving the collection to enumerate.
   *
   *     For example: `album in artist.albums`.
   *
   *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
   *     and `expression` is the scope expression giving the collection to enumerate.
   *
   *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
   *
   *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
   *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
   *     is specified, ng-repeat associates elements by identity. It is an error to have
   *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
   *     mapped to the same DOM element, which is not possible.)
   *
   *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
   *     This implies that the DOM elements will be associated by item identity in the collection.
   *
   *     The built-in `$id()` function can be used to assign a unique
   *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
   *     with the corresponding item in the collection by identity. Moving the same object would move
   *     the DOM element in the same way in the DOM.
   *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
   *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
   *
   *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
   *     id, for example with a function, or using a property on the collection items.
   *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
   *     e.g. database id. In this case the object identity does not matter. Two objects are considered
   *     equivalent as long as their `id` property is same.
   *     Tracking by unique identifier is the most performant way and should be used whenever possible.
   *
   *     *$index*: This special property tracks the collection items by their index, and
   *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
   *     be used for a performance improvement if no unique identfier is available and the identity of
   *     the collection items cannot be easily computed. It also allows duplicates.
   *
   *     <div class="alert alert-warning">
   *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
   *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
   *       more info.
   *     </div>
   *
   *     <div class="alert alert-warning">
   *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
   *       `item in items | filter:searchText as results  track by item.id`
   *     </div>
   *
   *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
   *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
   *     when a filter is active on the repeater, but the filtered result set is empty.
   *
   *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
   *     the items have been processed through the filter.
   *
   *     Please note that `as [variable name] is not an operator but rather a part of ngRepeat
   *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
   *
   *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
   *
   * @example
   * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
   * results by name or by age. New (entering) and removed (leaving) items are animated.
    <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
      <file name="index.html">
        <div ng-controller="repeatController">
          I have {{friends.length}} friends. They are:
          <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
          <ul class="example-animate-container">
            <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
              [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
            </li>
            <li class="animate-repeat" ng-if="results.length === 0">
              <strong>No results found...</strong>
            </li>
          </ul>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
          $scope.friends = [
            {name:'John', age:25, gender:'boy'},
            {name:'Jessie', age:30, gender:'girl'},
            {name:'Johanna', age:28, gender:'girl'},
            {name:'Joy', age:15, gender:'girl'},
            {name:'Mary', age:28, gender:'girl'},
            {name:'Peter', age:95, gender:'boy'},
            {name:'Sebastian', age:50, gender:'boy'},
            {name:'Erika', age:27, gender:'girl'},
            {name:'Patrick', age:40, gender:'boy'},
            {name:'Samantha', age:60, gender:'girl'}
          ];
        });
      </file>
      <file name="animations.css">
        .example-animate-container {
          background:white;
          border:1px solid black;
          list-style:none;
          margin:0;
          padding:0 10px;
        }
  
        .animate-repeat {
          line-height:30px;
          list-style:none;
          box-sizing:border-box;
        }
  
        .animate-repeat.ng-move,
        .animate-repeat.ng-enter,
        .animate-repeat.ng-leave {
          transition:all linear 0.5s;
        }
  
        .animate-repeat.ng-leave.ng-leave-active,
        .animate-repeat.ng-move,
        .animate-repeat.ng-enter {
          opacity:0;
          max-height:0;
        }
  
        .animate-repeat.ng-leave,
        .animate-repeat.ng-move.ng-move-active,
        .animate-repeat.ng-enter.ng-enter-active {
          opacity:1;
          max-height:30px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        var friends = element.all(by.repeater('friend in friends'));
  
        it('should render initial data set', function() {
          expect(friends.count()).toBe(10);
          expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
          expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
          expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
          expect(element(by.binding('friends.length')).getText())
              .toMatch("I have 10 friends. They are:");
        });
  
         it('should update repeater when filter predicate changes', function() {
           expect(friends.count()).toBe(10);
  
           element(by.model('q')).sendKeys('ma');
  
           expect(friends.count()).toBe(2);
           expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
           expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
         });
        </file>
      </example>
   */
  var ngRepeatDirective = ['$parse', '$animate', '$compile', function ($parse, $animate, $compile) {
    var NG_REMOVED = '$$NG_REMOVED';
    var ngRepeatMinErr = minErr('ngRepeat');

    var updateScope = function updateScope(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
      // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
      scope[valueIdentifier] = value;
      if (keyIdentifier) scope[keyIdentifier] = key;
      scope.$index = index;
      scope.$first = index === 0;
      scope.$last = index === arrayLength - 1;
      scope.$middle = !(scope.$first || scope.$last);
      // eslint-disable-next-line no-bitwise
      scope.$odd = !(scope.$even = (index & 1) === 0);
    };

    var getBlockStart = function getBlockStart(block) {
      return block.clone[0];
    };

    var getBlockEnd = function getBlockEnd(block) {
      return block.clone[block.clone.length - 1];
    };

    return {
      restrict: 'A',
      multiElement: true,
      transclude: 'element',
      priority: 1000,
      terminal: true,
      $$tlb: true,
      compile: function ngRepeatCompile($element, $attr) {
        var expression = $attr.ngRepeat;
        var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);

        var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

        if (!match) {
          throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.', expression);
        }

        var lhs = match[1];
        var rhs = match[2];
        var aliasAs = match[3];
        var trackByExp = match[4];

        match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);

        if (!match) {
          throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.', lhs);
        }
        var valueIdentifier = match[3] || match[1];
        var keyIdentifier = match[2];

        if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) || /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
          throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.', aliasAs);
        }

        var trackByExpGetter, trackByIdExpFn, trackByIdArrayFn, trackByIdObjFn;
        var hashFnLocals = { $id: hashKey };

        if (trackByExp) {
          trackByExpGetter = $parse(trackByExp);
        } else {
          trackByIdArrayFn = function trackByIdArrayFn(key, value) {
            return hashKey(value);
          };
          trackByIdObjFn = function trackByIdObjFn(key) {
            return key;
          };
        }

        return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {

          if (trackByExpGetter) {
            trackByIdExpFn = function trackByIdExpFn(key, value, index) {
              // assign key, value, and $index to the locals so that they can be used in hash functions
              if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
              hashFnLocals[valueIdentifier] = value;
              hashFnLocals.$index = index;
              return trackByExpGetter($scope, hashFnLocals);
            };
          }

          // Store a list of elements from previous run. This is a hash where key is the item from the
          // iterator, and the value is objects with following properties.
          //   - scope: bound scope
          //   - clone: previous element.
          //   - index: position
          //
          // We are using no-proto object so that we don't need to guard against inherited props via
          // hasOwnProperty.
          var lastBlockMap = createMap();

          //watch props
          $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
            var index,
                length,
                previousNode = $element[0],
                // node that cloned nodes should be inserted after
            // initialized to the comment node anchor
            nextNode,

            // Same as lastBlockMap but it has the current state. It will become the
            // lastBlockMap on the next iteration.
            nextBlockMap = createMap(),
                collectionLength,
                key,
                value,
                // key/value of iteration
            trackById,
                trackByIdFn,
                collectionKeys,
                block,
                // last object information {scope, element, id}
            nextBlockOrder,
                elementsToRemove;

            if (aliasAs) {
              $scope[aliasAs] = collection;
            }

            if (isArrayLike(collection)) {
              collectionKeys = collection;
              trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
            } else {
              trackByIdFn = trackByIdExpFn || trackByIdObjFn;
              // if object, extract keys, in enumeration order, unsorted
              collectionKeys = [];
              for (var itemKey in collection) {
                if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                  collectionKeys.push(itemKey);
                }
              }
            }

            collectionLength = collectionKeys.length;
            nextBlockOrder = new Array(collectionLength);

            // locate existing items
            for (index = 0; index < collectionLength; index++) {
              key = collection === collectionKeys ? index : collectionKeys[index];
              value = collection[key];
              trackById = trackByIdFn(key, value, index);
              if (lastBlockMap[trackById]) {
                // found previously seen block
                block = lastBlockMap[trackById];
                delete lastBlockMap[trackById];
                nextBlockMap[trackById] = block;
                nextBlockOrder[index] = block;
              } else if (nextBlockMap[trackById]) {
                // if collision detected. restore lastBlockMap and throw an error
                forEach(nextBlockOrder, function (block) {
                  if (block && block.scope) lastBlockMap[block.id] = block;
                });
                throw ngRepeatMinErr('dupes', 'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}', expression, trackById, value);
              } else {
                // new never before seen block
                nextBlockOrder[index] = { id: trackById, scope: undefined, clone: undefined };
                nextBlockMap[trackById] = true;
              }
            }

            // remove leftover items
            for (var blockKey in lastBlockMap) {
              block = lastBlockMap[blockKey];
              elementsToRemove = getBlockNodes(block.clone);
              $animate.leave(elementsToRemove);
              if (elementsToRemove[0].parentNode) {
                // if the element was not removed yet because of pending animation, mark it as deleted
                // so that we can ignore it later
                for (index = 0, length = elementsToRemove.length; index < length; index++) {
                  elementsToRemove[index][NG_REMOVED] = true;
                }
              }
              block.scope.$destroy();
            }

            // we are not using forEach for perf reasons (trying to avoid #call)
            for (index = 0; index < collectionLength; index++) {
              key = collection === collectionKeys ? index : collectionKeys[index];
              value = collection[key];
              block = nextBlockOrder[index];

              if (block.scope) {
                // if we have already seen this object, then we need to reuse the
                // associated scope/element

                nextNode = previousNode;

                // skip nodes that are already pending removal via leave animation
                do {
                  nextNode = nextNode.nextSibling;
                } while (nextNode && nextNode[NG_REMOVED]);

                if (getBlockStart(block) !== nextNode) {
                  // existing item which got moved
                  $animate.move(getBlockNodes(block.clone), null, previousNode);
                }
                previousNode = getBlockEnd(block);
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              } else {
                // new item which we don't know about
                $transclude(function ngRepeatTransclude(clone, scope) {
                  block.scope = scope;
                  // http://jsperf.com/clone-vs-createcomment
                  var endNode = ngRepeatEndComment.cloneNode(false);
                  clone[clone.length++] = endNode;

                  $animate.enter(clone, null, previousNode);
                  previousNode = endNode;
                  // Note: We only need the first/last node of the cloned nodes.
                  // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                  // by a directive with templateUrl when its template arrives.
                  block.clone = clone;
                  nextBlockMap[block.id] = block;
                  updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                });
              }
            }
            lastBlockMap = nextBlockMap;
          });
        };
      }
    };
  }];

  var NG_HIDE_CLASS = 'ng-hide';
  var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
  /**
   * @ngdoc directive
   * @name ngShow
   * @multiElement
   *
   * @description
   * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
   * the `ngShow` attribute.
   *
   * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
   * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
   * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
   * {@link ng.directive:ngCsp ngCsp}).
   *
   * ```html
   * <!-- when $scope.myValue is truthy (element is visible) -->
   * <div ng-show="myValue"></div>
   *
   * <!-- when $scope.myValue is falsy (element is hidden) -->
   * <div ng-show="myValue" class="ng-hide"></div>
   * ```
   *
   * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
   * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
   * CSS class is removed from the element causing the element not to appear hidden.
   *
   * ## Why is `!important` used?
   *
   * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
   * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
   * simple as changing the display style on a HTML list item would make hidden elements appear
   * visible. This also becomes a bigger issue when dealing with CSS frameworks.
   *
   * By using `!important`, the show and hide behavior will work as expected despite any clash between
   * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
   * developer chooses to override the styling to change how to hide an element then it is just a
   * matter of using `!important` in their own CSS code.
   *
   * ### Overriding `.ng-hide`
   *
   * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
   * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
   * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
   * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
   *
   * ```css
   * .ng-hide:not(.ng-hide-animate) {
   *   /&#42; These are just alternative ways of hiding an element &#42;/
   *   display: block!important;
   *   position: absolute;
   *   top: -9999px;
   *   left: -9999px;
   * }
   * ```
   *
   * By default you don't need to override anything in CSS and the animations will work around the
   * display style.
   *
   * @animations
   * | Animation                                           | Occurs                                                                                                        |
   * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
   * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
   * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
   *
   * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
   * directive expression is true and false. This system works like the animation system present with
   * `ngClass` except that you must also include the `!important` flag to override the display
   * property so that the elements are not actually hidden during the animation.
   *
   * ```css
   * /&#42; A working example can be found at the bottom of this page. &#42;/
   * .my-element.ng-hide-add, .my-element.ng-hide-remove {
   *   transition: all 0.5s linear;
   * }
   *
   * .my-element.ng-hide-add { ... }
   * .my-element.ng-hide-add.ng-hide-add-active { ... }
   * .my-element.ng-hide-remove { ... }
   * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
   * ```
   *
   * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
   * to block during animation states - ngAnimate will automatically handle the style toggling for you.
   *
   * @element ANY
   * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
   *                            element is shown/hidden respectively.
   *
   * @example
   * A simple example, animating the element's opacity:
   *
    <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
      <file name="index.html">
        Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
        <div class="check-element animate-show-hide" ng-show="checked">
          I show up when your checkbox is checked.
        </div>
      </file>
      <file name="animations.css">
        .animate-show-hide.ng-hide {
          opacity: 0;
        }
  
        .animate-show-hide.ng-hide-add,
        .animate-show-hide.ng-hide-remove {
          transition: all linear 0.5s;
        }
  
        .check-element {
          border: 1px solid black;
          opacity: 1;
          padding: 10px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        it('should check ngShow', function() {
          var checkbox = element(by.model('checked'));
          var checkElem = element(by.css('.check-element'));
  
          expect(checkElem.isDisplayed()).toBe(false);
          checkbox.click();
          expect(checkElem.isDisplayed()).toBe(true);
        });
      </file>
    </example>
   *
   * <hr />
   * @example
   * A more complex example, featuring different show/hide animations:
   *
    <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
      <file name="index.html">
        Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
        <div class="check-element funky-show-hide" ng-show="checked">
          I show up when your checkbox is checked.
        </div>
      </file>
      <file name="animations.css">
        body {
          overflow: hidden;
          perspective: 1000px;
        }
  
        .funky-show-hide.ng-hide-add {
          transform: rotateZ(0);
          transform-origin: right;
          transition: all 0.5s ease-in-out;
        }
  
        .funky-show-hide.ng-hide-add.ng-hide-add-active {
          transform: rotateZ(-135deg);
        }
  
        .funky-show-hide.ng-hide-remove {
          transform: rotateY(90deg);
          transform-origin: left;
          transition: all 0.5s ease;
        }
  
        .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
          transform: rotateY(0);
        }
  
        .check-element {
          border: 1px solid black;
          opacity: 1;
          padding: 10px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        it('should check ngShow', function() {
          var checkbox = element(by.model('checked'));
          var checkElem = element(by.css('.check-element'));
  
          expect(checkElem.isDisplayed()).toBe(false);
          checkbox.click();
          expect(checkElem.isDisplayed()).toBe(true);
        });
      </file>
    </example>
   */
  var ngShowDirective = ['$animate', function ($animate) {
    return {
      restrict: 'A',
      multiElement: true,
      link: function link(scope, element, attr) {
        scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
          // we're adding a temporary, animation-specific class for ng-hide since this way
          // we can control when the element is actually displayed on screen without having
          // to have a global/greedy CSS selector that breaks when other animations are run.
          // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
          $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
          });
        });
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngHide
   * @multiElement
   *
   * @description
   * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
   * the `ngHide` attribute.
   *
   * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
   * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
   * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
   * {@link ng.directive:ngCsp ngCsp}).
   *
   * ```html
   * <!-- when $scope.myValue is truthy (element is hidden) -->
   * <div ng-hide="myValue" class="ng-hide"></div>
   *
   * <!-- when $scope.myValue is falsy (element is visible) -->
   * <div ng-hide="myValue"></div>
   * ```
   *
   * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
   * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
   * CSS class is removed from the element causing the element not to appear hidden.
   *
   * ## Why is `!important` used?
   *
   * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
   * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
   * simple as changing the display style on a HTML list item would make hidden elements appear
   * visible. This also becomes a bigger issue when dealing with CSS frameworks.
   *
   * By using `!important`, the show and hide behavior will work as expected despite any clash between
   * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
   * developer chooses to override the styling to change how to hide an element then it is just a
   * matter of using `!important` in their own CSS code.
   *
   * ### Overriding `.ng-hide`
   *
   * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
   * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
   * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
   * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
   *
   * ```css
   * .ng-hide:not(.ng-hide-animate) {
   *   /&#42; These are just alternative ways of hiding an element &#42;/
   *   display: block!important;
   *   position: absolute;
   *   top: -9999px;
   *   left: -9999px;
   * }
   * ```
   *
   * By default you don't need to override in CSS anything and the animations will work around the
   * display style.
   *
   * @animations
   * | Animation                                           | Occurs                                                                                                     |
   * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
   * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
   * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
   *
   * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
   * directive expression is true and false. This system works like the animation system present with
   * `ngClass` except that you must also include the `!important` flag to override the display
   * property so that the elements are not actually hidden during the animation.
   *
   * ```css
   * /&#42; A working example can be found at the bottom of this page. &#42;/
   * .my-element.ng-hide-add, .my-element.ng-hide-remove {
   *   transition: all 0.5s linear;
   * }
   *
   * .my-element.ng-hide-add { ... }
   * .my-element.ng-hide-add.ng-hide-add-active { ... }
   * .my-element.ng-hide-remove { ... }
   * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
   * ```
   *
   * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
   * to block during animation states - ngAnimate will automatically handle the style toggling for you.
   *
   * @element ANY
   * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
   *                            element is hidden/shown respectively.
   *
   * @example
   * A simple example, animating the element's opacity:
   *
    <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
      <file name="index.html">
        Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
        <div class="check-element animate-show-hide" ng-hide="checked">
          I hide when your checkbox is checked.
        </div>
      </file>
      <file name="animations.css">
        .animate-show-hide.ng-hide {
          opacity: 0;
        }
  
        .animate-show-hide.ng-hide-add,
        .animate-show-hide.ng-hide-remove {
          transition: all linear 0.5s;
        }
  
        .check-element {
          border: 1px solid black;
          opacity: 1;
          padding: 10px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        it('should check ngHide', function() {
          var checkbox = element(by.model('checked'));
          var checkElem = element(by.css('.check-element'));
  
          expect(checkElem.isDisplayed()).toBe(true);
          checkbox.click();
          expect(checkElem.isDisplayed()).toBe(false);
        });
      </file>
    </example>
   *
   * <hr />
   * @example
   * A more complex example, featuring different show/hide animations:
   *
    <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
      <file name="index.html">
        Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
        <div class="check-element funky-show-hide" ng-hide="checked">
          I hide when your checkbox is checked.
        </div>
      </file>
      <file name="animations.css">
        body {
          overflow: hidden;
          perspective: 1000px;
        }
  
        .funky-show-hide.ng-hide-add {
          transform: rotateZ(0);
          transform-origin: right;
          transition: all 0.5s ease-in-out;
        }
  
        .funky-show-hide.ng-hide-add.ng-hide-add-active {
          transform: rotateZ(-135deg);
        }
  
        .funky-show-hide.ng-hide-remove {
          transform: rotateY(90deg);
          transform-origin: left;
          transition: all 0.5s ease;
        }
  
        .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
          transform: rotateY(0);
        }
  
        .check-element {
          border: 1px solid black;
          opacity: 1;
          padding: 10px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        it('should check ngHide', function() {
          var checkbox = element(by.model('checked'));
          var checkElem = element(by.css('.check-element'));
  
          expect(checkElem.isDisplayed()).toBe(true);
          checkbox.click();
          expect(checkElem.isDisplayed()).toBe(false);
        });
      </file>
    </example>
   */
  var ngHideDirective = ['$animate', function ($animate) {
    return {
      restrict: 'A',
      multiElement: true,
      link: function link(scope, element, attr) {
        scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
          // The comment inside of the ngShowDirective explains why we add and
          // remove a temporary class for the show/hide animation
          $animate[value ? 'addClass' : 'removeClass'](element, NG_HIDE_CLASS, {
            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
          });
        });
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngStyle
   * @restrict AC
   *
   * @description
   * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
   *
   * @knownIssue
   * You should not use {@link guide/interpolation interpolation} in the value of the `style`
   * attribute, when using the `ngStyle` directive on the same element.
   * See {@link guide/interpolation#known-issues here} for more info.
   *
   * @element ANY
   * @param {expression} ngStyle
   *
   * {@link guide/expression Expression} which evals to an
   * object whose keys are CSS style names and values are corresponding values for those CSS
   * keys.
   *
   * Since some CSS style names are not valid keys for an object, they must be quoted.
   * See the 'background-color' style in the example below.
   *
   * @example
     <example name="ng-style">
       <file name="index.html">
          <input type="button" value="set color" ng-click="myStyle={color:'red'}">
          <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
          <input type="button" value="clear" ng-click="myStyle={}">
          <br/>
          <span ng-style="myStyle">Sample Text</span>
          <pre>myStyle={{myStyle}}</pre>
       </file>
       <file name="style.css">
         span {
           color: black;
         }
       </file>
       <file name="protractor.js" type="protractor">
         var colorSpan = element(by.css('span'));
  
         it('should check ng-style', function() {
           expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
           element(by.css('input[value=\'set color\']')).click();
           expect(colorSpan.getCssValue('color')).toBe('rgba(255, 0, 0, 1)');
           element(by.css('input[value=clear]')).click();
           expect(colorSpan.getCssValue('color')).toBe('rgba(0, 0, 0, 1)');
         });
       </file>
     </example>
   */
  var ngStyleDirective = ngDirective(function (scope, element, attr) {
    scope.$watch(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
      if (oldStyles && newStyles !== oldStyles) {
        forEach(oldStyles, function (val, style) {
          element.css(style, '');
        });
      }
      if (newStyles) element.css(newStyles);
    }, true);
  });

  /**
   * @ngdoc directive
   * @name ngSwitch
   * @restrict EA
   *
   * @description
   * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
   * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
   * as specified in the template.
   *
   * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
   * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
   * matches the value obtained from the evaluated expression. In other words, you define a container element
   * (where you place the directive), place an expression on the **`on="..."` attribute**
   * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
   * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
   * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
   * attribute is displayed.
   *
   * <div class="alert alert-info">
   * Be aware that the attribute values to match against cannot be expressions. They are interpreted
   * as literal string values to match against.
   * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
   * value of the expression `$scope.someVal`.
   * </div>
  
   * @animations
   * | Animation                        | Occurs                              |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
   * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
   *
   * @usage
   *
   * ```
   * <ANY ng-switch="expression">
   *   <ANY ng-switch-when="matchValue1">...</ANY>
   *   <ANY ng-switch-when="matchValue2">...</ANY>
   *   <ANY ng-switch-default>...</ANY>
   * </ANY>
   * ```
   *
   *
   * @scope
   * @priority 1200
   * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
   * On child elements add:
   *
   * * `ngSwitchWhen`: the case statement to match against. If match then this
   *   case will be displayed. If the same match appears multiple times, all the
   *   elements will be displayed. It is possible to associate multiple values to
   *   the same `ngSwitchWhen` by defining the optional attribute
   *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
   *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
   *   if any of the `ngSwitch` evaluates to any of these tokens.
   * * `ngSwitchDefault`: the default case when no other case match. If there
   *   are multiple default cases, all of them will be displayed when no other
   *   case match.
   *
   *
   * @example
    <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
      <file name="index.html">
        <div ng-controller="ExampleController">
          <select ng-model="selection" ng-options="item for item in items">
          </select>
          <code>selection={{selection}}</code>
          <hr/>
          <div class="animate-switch-container"
            ng-switch on="selection">
              <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
              <div class="animate-switch" ng-switch-when="home">Home Span</div>
              <div class="animate-switch" ng-switch-default>default</div>
          </div>
        </div>
      </file>
      <file name="script.js">
        angular.module('switchExample', ['ngAnimate'])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.items = ['settings', 'home', 'options', 'other'];
            $scope.selection = $scope.items[0];
          }]);
      </file>
      <file name="animations.css">
        .animate-switch-container {
          position:relative;
          background:white;
          border:1px solid black;
          height:40px;
          overflow:hidden;
        }
  
        .animate-switch {
          padding:10px;
        }
  
        .animate-switch.ng-animate {
          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
  
          position:absolute;
          top:0;
          left:0;
          right:0;
          bottom:0;
        }
  
        .animate-switch.ng-leave.ng-leave-active,
        .animate-switch.ng-enter {
          top:-50px;
        }
        .animate-switch.ng-leave,
        .animate-switch.ng-enter.ng-enter-active {
          top:0;
        }
      </file>
      <file name="protractor.js" type="protractor">
        var switchElem = element(by.css('[ng-switch]'));
        var select = element(by.model('selection'));
  
        it('should start in settings', function() {
          expect(switchElem.getText()).toMatch(/Settings Div/);
        });
        it('should change to home', function() {
          select.all(by.css('option')).get(1).click();
          expect(switchElem.getText()).toMatch(/Home Span/);
        });
        it('should change to settings via "options"', function() {
          select.all(by.css('option')).get(2).click();
          expect(switchElem.getText()).toMatch(/Settings Div/);
        });
        it('should select default', function() {
          select.all(by.css('option')).get(3).click();
          expect(switchElem.getText()).toMatch(/default/);
        });
      </file>
    </example>
   */
  var ngSwitchDirective = ['$animate', '$compile', function ($animate, $compile) {
    return {
      require: 'ngSwitch',

      // asks for $scope to fool the BC controller module
      controller: ['$scope', function NgSwitchController() {
        this.cases = {};
      }],
      link: function link(scope, element, attr, ngSwitchController) {
        var watchExpr = attr.ngSwitch || attr.on,
            selectedTranscludes = [],
            selectedElements = [],
            previousLeaveAnimations = [],
            selectedScopes = [];

        var spliceFactory = function spliceFactory(array, index) {
          return function (response) {
            if (response !== false) array.splice(index, 1);
          };
        };

        scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
          var i, ii;

          // Start with the last, in case the array is modified during the loop
          while (previousLeaveAnimations.length) {
            $animate.cancel(previousLeaveAnimations.pop());
          }

          for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
            var selected = getBlockNodes(selectedElements[i].clone);
            selectedScopes[i].$destroy();
            var runner = previousLeaveAnimations[i] = $animate.leave(selected);
            runner.done(spliceFactory(previousLeaveAnimations, i));
          }

          selectedElements.length = 0;
          selectedScopes.length = 0;

          if (selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?']) {
            forEach(selectedTranscludes, function (selectedTransclude) {
              selectedTransclude.transclude(function (caseElement, selectedScope) {
                selectedScopes.push(selectedScope);
                var anchor = selectedTransclude.element;
                caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
                var block = { clone: caseElement };

                selectedElements.push(block);
                $animate.enter(caseElement, anchor.parent(), anchor);
              });
            });
          }
        });
      }
    };
  }];

  var ngSwitchWhenDirective = ngDirective({
    transclude: 'element',
    priority: 1200,
    require: '^ngSwitch',
    multiElement: true,
    link: function link(scope, element, attrs, ctrl, $transclude) {

      var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
      // Filter duplicate cases
      function (element, index, array) {
        return array[index - 1] !== element;
      });

      forEach(cases, function (whenCase) {
        ctrl.cases['!' + whenCase] = ctrl.cases['!' + whenCase] || [];
        ctrl.cases['!' + whenCase].push({ transclude: $transclude, element: element });
      });
    }
  });

  var ngSwitchDefaultDirective = ngDirective({
    transclude: 'element',
    priority: 1200,
    require: '^ngSwitch',
    multiElement: true,
    link: function link(scope, element, attr, ctrl, $transclude) {
      ctrl.cases['?'] = ctrl.cases['?'] || [];
      ctrl.cases['?'].push({ transclude: $transclude, element: element });
    }
  });

  /**
   * @ngdoc directive
   * @name ngTransclude
   * @restrict EAC
   *
   * @description
   * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
   *
   * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
   * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
   *
   * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
   * content of this element will be removed before the transcluded content is inserted.
   * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
   * content in the case that no transcluded content is provided.
   *
   * @element ANY
   *
   * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
   *                                               or its value is the same as the name of the attribute then the default slot is used.
   *
   * @example
   * ### Basic transclusion
   * This example demonstrates basic transclusion of content into a component directive.
   * <example name="simpleTranscludeExample" module="transcludeExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('transcludeExample', [])
   *        .directive('pane', function(){
   *           return {
   *             restrict: 'E',
   *             transclude: true,
   *             scope: { title:'@' },
   *             template: '<div style="border: 1px solid black;">' +
   *                         '<div style="background-color: gray">{{title}}</div>' +
   *                         '<ng-transclude></ng-transclude>' +
   *                       '</div>'
   *           };
   *       })
   *       .controller('ExampleController', ['$scope', function($scope) {
   *         $scope.title = 'Lorem Ipsum';
   *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
   *       }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <input ng-model="title" aria-label="title"> <br/>
   *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
   *       <pane title="{{title}}"><span>{{text}}</span></pane>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *      it('should have transcluded', function() {
   *        var titleElement = element(by.model('title'));
   *        titleElement.clear();
   *        titleElement.sendKeys('TITLE');
   *        var textElement = element(by.model('text'));
   *        textElement.clear();
   *        textElement.sendKeys('TEXT');
   *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
   *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
   *      });
   *   </file>
   * </example>
   *
   * @example
   * ### Transclude fallback content
   * This example shows how to use `NgTransclude` with fallback content, that
   * is displayed if no transcluded content is provided.
   *
   * <example module="transcludeFallbackContentExample" name="ng-transclude">
   * <file name="index.html">
   * <script>
   * angular.module('transcludeFallbackContentExample', [])
   * .directive('myButton', function(){
   *             return {
   *               restrict: 'E',
   *               transclude: true,
   *               scope: true,
   *               template: '<button style="cursor: pointer;">' +
   *                           '<ng-transclude>' +
   *                             '<b style="color: red;">Button1</b>' +
   *                           '</ng-transclude>' +
   *                         '</button>'
   *             };
   *         });
   * </script>
   * <!-- fallback button content -->
   * <my-button id="fallback"></my-button>
   * <!-- modified button content -->
   * <my-button id="modified">
   *   <i style="color: green;">Button2</i>
   * </my-button>
   * </file>
   * <file name="protractor.js" type="protractor">
   * it('should have different transclude element content', function() {
   *          expect(element(by.id('fallback')).getText()).toBe('Button1');
   *          expect(element(by.id('modified')).getText()).toBe('Button2');
   *        });
   * </file>
   * </example>
   *
   * @example
   * ### Multi-slot transclusion
   * This example demonstrates using multi-slot transclusion in a component directive.
   * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
   *   <file name="index.html">
   *    <style>
   *      .title, .footer {
   *        background-color: gray
   *      }
   *    </style>
   *    <div ng-controller="ExampleController">
   *      <input ng-model="title" aria-label="title"> <br/>
   *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
   *      <pane>
   *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
   *        <pane-body><p>{{text}}</p></pane-body>
   *      </pane>
   *    </div>
   *   </file>
   *   <file name="app.js">
   *    angular.module('multiSlotTranscludeExample', [])
   *     .directive('pane', function() {
   *        return {
   *          restrict: 'E',
   *          transclude: {
   *            'title': '?paneTitle',
   *            'body': 'paneBody',
   *            'footer': '?paneFooter'
   *          },
   *          template: '<div style="border: 1px solid black;">' +
   *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
   *                      '<div ng-transclude="body"></div>' +
   *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
   *                    '</div>'
   *        };
   *    })
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.title = 'Lorem Ipsum';
   *      $scope.link = 'https://google.com';
   *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
   *    }]);
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *      it('should have transcluded the title and the body', function() {
   *        var titleElement = element(by.model('title'));
   *        titleElement.clear();
   *        titleElement.sendKeys('TITLE');
   *        var textElement = element(by.model('text'));
   *        textElement.clear();
   *        textElement.sendKeys('TEXT');
   *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
   *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
   *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
   *      });
   *   </file>
   * </example>
   */
  var ngTranscludeMinErr = minErr('ngTransclude');
  var ngTranscludeDirective = ['$compile', function ($compile) {
    return {
      restrict: 'EAC',
      compile: function ngTranscludeCompile(tElement) {

        // Remove and cache any original content to act as a fallback
        var fallbackLinkFn = $compile(tElement.contents());
        tElement.empty();

        return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {

          if (!$transclude) {
            throw ngTranscludeMinErr('orphan', 'Illegal use of ngTransclude directive in the template! ' + 'No parent directive that requires a transclusion found. ' + 'Element: {0}', startingTag($element));
          }

          // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
          if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
            $attrs.ngTransclude = '';
          }
          var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

          // If the slot is required and no transclusion content is provided then this call will throw an error
          $transclude(ngTranscludeCloneAttachFn, null, slotName);

          // If the slot is optional and no transclusion content is provided then use the fallback content
          if (slotName && !$transclude.isSlotFilled(slotName)) {
            useFallbackContent();
          }

          function ngTranscludeCloneAttachFn(clone, transcludedScope) {
            if (clone.length && notWhitespace(clone)) {
              $element.append(clone);
            } else {
              useFallbackContent();
              // There is nothing linked against the transcluded scope since no content was available,
              // so it should be safe to clean up the generated scope.
              transcludedScope.$destroy();
            }
          }

          function useFallbackContent() {
            // Since this is the fallback content rather than the transcluded content,
            // we link against the scope of this directive rather than the transcluded scope
            fallbackLinkFn($scope, function (clone) {
              $element.append(clone);
            });
          }

          function notWhitespace(nodes) {
            for (var i = 0, ii = nodes.length; i < ii; i++) {
              var node = nodes[i];
              if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
                return true;
              }
            }
          }
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name script
   * @restrict E
   *
   * @description
   * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
   * template can be used by {@link ng.directive:ngInclude `ngInclude`},
   * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
   * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
   * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
   *
   * @param {string} type Must be set to `'text/ng-template'`.
   * @param {string} id Cache name of the template.
   *
   * @example
    <example  name="script-tag">
      <file name="index.html">
        <script type="text/ng-template" id="/tpl.html">
          Content of the template.
        </script>
  
        <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
        <div id="tpl-content" ng-include src="currentTpl"></div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should load template defined inside script tag', function() {
          element(by.css('#tpl-link')).click();
          expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
        });
      </file>
    </example>
   */
  var scriptDirective = ['$templateCache', function ($templateCache) {
    return {
      restrict: 'E',
      terminal: true,
      compile: function compile(element, attr) {
        if (attr.type === 'text/ng-template') {
          var templateUrl = attr.id,
              text = element[0].text;

          $templateCache.put(templateUrl, text);
        }
      }
    };
  }];

  /* exported selectDirective, optionDirective */

  var noopNgModelController = { $setViewValue: noop, $render: noop };

  function setOptionSelectedStatus(optionEl, value) {
    optionEl.prop('selected', value);
    /**
     * When unselecting an option, setting the property to null / false should be enough
     * However, screenreaders might react to the selected attribute instead, see
     * https://github.com/angular/angular.js/issues/14419
     * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
     * or null
     */
    optionEl.attr('selected', value);
  }

  /**
   * @ngdoc type
   * @name  select.SelectController
   *
   * @description
   * The controller for the {@link ng.select select} directive. The controller exposes
   * a few utility methods that can be used to augment the behavior of a regular or an
   * {@link ng.ngOptions ngOptions} select element.
   *
   * @example
   * ### Set a custom error when the unknown option is selected
   *
   * This example sets a custom error "unknownValue" on the ngModelController
   * when the select element's unknown option is selected, i.e. when the model is set to a value
   * that is not matched by any option.
   *
   * <example name="select-unknown-value-error" module="staticSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="testSelect"> Single select: </label><br>
   *     <select name="testSelect" ng-model="selected" unknown-value-error>
   *       <option value="option-1">Option 1</option>
   *       <option value="option-2">Option 2</option>
   *     </select><br>
   *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
   *       Error: The current model doesn't match any option</span><br>
   *
   *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
   *   </form>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('staticSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.selected = null;
   *
   *      $scope.forceUnknownOption = function() {
   *        $scope.selected = 'nonsense';
   *      };
   *   }])
   *   .directive('unknownValueError', function() {
   *     return {
   *       require: ['ngModel', 'select'],
   *       link: function(scope, element, attrs, ctrls) {
   *         var ngModelCtrl = ctrls[0];
   *         var selectCtrl = ctrls[1];
   *
   *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
   *           if (selectCtrl.$isUnknownOptionSelected()) {
   *             return false;
   *           }
   *
   *           return true;
   *         };
   *       }
   *
   *     };
   *   });
   * </file>
   *</example>
   *
   *
   * @example
   * ### Set the "required" error when the unknown option is selected.
   *
   * By default, the "required" error on the ngModelController is only set on a required select
   * when the empty option is selected. This example adds a custom directive that also sets the
   * error when the unknown option is selected.
   *
   * <example name="select-unknown-value-required" module="staticSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="testSelect"> Select: </label><br>
   *     <select name="testSelect" ng-model="selected" required unknown-value-required>
   *       <option value="option-1">Option 1</option>
   *       <option value="option-2">Option 2</option>
   *     </select><br>
   *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
   *
   *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
   *   </form>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('staticSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.selected = null;
   *
   *      $scope.forceUnknownOption = function() {
   *        $scope.selected = 'nonsense';
   *      };
   *   }])
   *   .directive('unknownValueRequired', function() {
   *     return {
   *       priority: 1, // This directive must run after the required directive has added its validator
   *       require: ['ngModel', 'select'],
   *       link: function(scope, element, attrs, ctrls) {
   *         var ngModelCtrl = ctrls[0];
   *         var selectCtrl = ctrls[1];
   *
   *         var originalRequiredValidator = ngModelCtrl.$validators.required;
   *
   *         ngModelCtrl.$validators.required = function() {
   *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
   *             return false;
   *           }
   *
   *           return originalRequiredValidator.apply(this, arguments);
   *         };
   *       }
   *     };
   *   });
   * </file>
   * <file name="protractor.js" type="protractor">
   *  it('should show the error message when the unknown option is selected', function() {
  
        var error = element(by.className('error'));
  
        expect(error.getText()).toBe('Error: Please select a value');
  
        element(by.cssContainingText('option', 'Option 1')).click();
  
        expect(error.isPresent()).toBe(false);
  
        element(by.tagName('button')).click();
  
        expect(error.getText()).toBe('Error: Please select a value');
      });
   * </file>
   *</example>
   *
   *
   */
  var SelectController = ['$element', '$scope', /** @this */function ($element, $scope) {

    var self = this,
        optionsMap = new NgMap();

    self.selectValueMap = {}; // Keys are the hashed values, values the original values

    // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
    self.ngModelCtrl = noopNgModelController;
    self.multiple = false;

    // The "unknown" option is one that is prepended to the list if the viewValue
    // does not match any of the options. When it is rendered the value of the unknown
    // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
    //
    // Support: IE 9 only
    // We can't just jqLite('<option>') since jqLite is not smart enough
    // to create it in <select> and IE barfs otherwise.
    self.unknownOption = jqLite(window.document.createElement('option'));

    // The empty option is an option with the value '' that the application developer can
    // provide inside the select. It is always selectable and indicates that a "null" selection has
    // been made by the user.
    // If the select has an empty option, and the model of the select is set to "undefined" or "null",
    // the empty option is selected.
    // If the model is set to a different unmatched value, the unknown option is rendered and
    // selected, i.e both are present, because a "null" selection and an unknown value are different.
    self.hasEmptyOption = false;
    self.emptyOption = undefined;

    self.renderUnknownOption = function (val) {
      var unknownVal = self.generateUnknownOptionValue(val);
      self.unknownOption.val(unknownVal);
      $element.prepend(self.unknownOption);
      setOptionSelectedStatus(self.unknownOption, true);
      $element.val(unknownVal);
    };

    self.updateUnknownOption = function (val) {
      var unknownVal = self.generateUnknownOptionValue(val);
      self.unknownOption.val(unknownVal);
      setOptionSelectedStatus(self.unknownOption, true);
      $element.val(unknownVal);
    };

    self.generateUnknownOptionValue = function (val) {
      return '? ' + hashKey(val) + ' ?';
    };

    self.removeUnknownOption = function () {
      if (self.unknownOption.parent()) self.unknownOption.remove();
    };

    self.selectEmptyOption = function () {
      if (self.emptyOption) {
        $element.val('');
        setOptionSelectedStatus(self.emptyOption, true);
      }
    };

    self.unselectEmptyOption = function () {
      if (self.hasEmptyOption) {
        setOptionSelectedStatus(self.emptyOption, false);
      }
    };

    $scope.$on('$destroy', function () {
      // disable unknown option so that we don't do work when the whole select is being destroyed
      self.renderUnknownOption = noop;
    });

    // Read the value of the select control, the implementation of this changes depending
    // upon whether the select can have multiple values and whether ngOptions is at work.
    self.readValue = function readSingleValue() {
      var val = $element.val();
      // ngValue added option values are stored in the selectValueMap, normal interpolations are not
      var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;

      if (self.hasOption(realVal)) {
        return realVal;
      }

      return null;
    };

    // Write the value to the select control, the implementation of this changes depending
    // upon whether the select can have multiple values and whether ngOptions is at work.
    self.writeValue = function writeSingleValue(value) {
      // Make sure to remove the selected attribute from the previously selected option
      // Otherwise, screen readers might get confused
      var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
      if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);

      if (self.hasOption(value)) {
        self.removeUnknownOption();

        var hashedVal = hashKey(value);
        $element.val(hashedVal in self.selectValueMap ? hashedVal : value);

        // Set selected attribute and property on selected option for screen readers
        var selectedOption = $element[0].options[$element[0].selectedIndex];
        setOptionSelectedStatus(jqLite(selectedOption), true);
      } else {
        self.selectUnknownOrEmptyOption(value);
      }
    };

    // Tell the select control that an option, with the given value, has been added
    self.addOption = function (value, element) {
      // Skip comment nodes, as they only pollute the `optionsMap`
      if (element[0].nodeType === NODE_TYPE_COMMENT) return;

      assertNotHasOwnProperty(value, '"option value"');
      if (value === '') {
        self.hasEmptyOption = true;
        self.emptyOption = element;
      }
      var count = optionsMap.get(value) || 0;
      optionsMap.set(value, count + 1);
      // Only render at the end of a digest. This improves render performance when many options
      // are added during a digest and ensures all relevant options are correctly marked as selected
      scheduleRender();
    };

    // Tell the select control that an option, with the given value, has been removed
    self.removeOption = function (value) {
      var count = optionsMap.get(value);
      if (count) {
        if (count === 1) {
          optionsMap.delete(value);
          if (value === '') {
            self.hasEmptyOption = false;
            self.emptyOption = undefined;
          }
        } else {
          optionsMap.set(value, count - 1);
        }
      }
    };

    // Check whether the select control has an option matching the given value
    self.hasOption = function (value) {
      return !!optionsMap.get(value);
    };

    /**
     * @ngdoc method
     * @name select.SelectController#$hasEmptyOption
     *
     * @description
     *
     * Returns `true` if the select element currently has an empty option
     * element, i.e. an option that signifies that the select is empty / the selection is null.
     *
     */
    self.$hasEmptyOption = function () {
      return self.hasEmptyOption;
    };

    /**
     * @ngdoc method
     * @name select.SelectController#$isUnknownOptionSelected
     *
     * @description
     *
     * Returns `true` if the select element's unknown option is selected. The unknown option is added
     * and automatically selected whenever the select model doesn't match any option.
     *
     */
    self.$isUnknownOptionSelected = function () {
      // Presence of the unknown option means it is selected
      return $element[0].options[0] === self.unknownOption[0];
    };

    /**
     * @ngdoc method
     * @name select.SelectController#$isEmptyOptionSelected
     *
     * @description
     *
     * Returns `true` if the select element has an empty option and this empty option is currently
     * selected. Returns `false` if the select element has no empty option or it is not selected.
     *
     */
    self.$isEmptyOptionSelected = function () {
      return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
    };

    self.selectUnknownOrEmptyOption = function (value) {
      if (value == null && self.emptyOption) {
        self.removeUnknownOption();
        self.selectEmptyOption();
      } else if (self.unknownOption.parent().length) {
        self.updateUnknownOption(value);
      } else {
        self.renderUnknownOption(value);
      }
    };

    var renderScheduled = false;
    function scheduleRender() {
      if (renderScheduled) return;
      renderScheduled = true;
      $scope.$$postDigest(function () {
        renderScheduled = false;
        self.ngModelCtrl.$render();
      });
    }

    var updateScheduled = false;
    function scheduleViewValueUpdate(renderAfter) {
      if (updateScheduled) return;

      updateScheduled = true;

      $scope.$$postDigest(function () {
        if ($scope.$$destroyed) return;

        updateScheduled = false;
        self.ngModelCtrl.$setViewValue(self.readValue());
        if (renderAfter) self.ngModelCtrl.$render();
      });
    }

    self.registerOption = function (optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {

      if (optionAttrs.$attr.ngValue) {
        // The value attribute is set by ngValue
        var oldVal,
            hashedVal = NaN;
        optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {

          var removal;
          var previouslySelected = optionElement.prop('selected');

          if (isDefined(hashedVal)) {
            self.removeOption(oldVal);
            delete self.selectValueMap[hashedVal];
            removal = true;
          }

          hashedVal = hashKey(newVal);
          oldVal = newVal;
          self.selectValueMap[hashedVal] = newVal;
          self.addOption(newVal, optionElement);
          // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
          // from firing a second time. Other $observers on value will also get the result of the
          // ngValue expression, not the hashed value
          optionElement.attr('value', hashedVal);

          if (removal && previouslySelected) {
            scheduleViewValueUpdate();
          }
        });
      } else if (interpolateValueFn) {
        // The value attribute is interpolated
        optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
          // This method is overwritten in ngOptions and has side-effects!
          self.readValue();

          var removal;
          var previouslySelected = optionElement.prop('selected');

          if (isDefined(oldVal)) {
            self.removeOption(oldVal);
            removal = true;
          }
          oldVal = newVal;
          self.addOption(newVal, optionElement);

          if (removal && previouslySelected) {
            scheduleViewValueUpdate();
          }
        });
      } else if (interpolateTextFn) {
        // The text content is interpolated
        optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
          optionAttrs.$set('value', newVal);
          var previouslySelected = optionElement.prop('selected');
          if (oldVal !== newVal) {
            self.removeOption(oldVal);
          }
          self.addOption(newVal, optionElement);

          if (oldVal && previouslySelected) {
            scheduleViewValueUpdate();
          }
        });
      } else {
        // The value attribute is static
        self.addOption(optionAttrs.value, optionElement);
      }

      optionAttrs.$observe('disabled', function (newVal) {

        // Since model updates will also select disabled options (like ngOptions),
        // we only have to handle options becoming disabled, not enabled

        if (newVal === 'true' || newVal && optionElement.prop('selected')) {
          if (self.multiple) {
            scheduleViewValueUpdate(true);
          } else {
            self.ngModelCtrl.$setViewValue(null);
            self.ngModelCtrl.$render();
          }
        }
      });

      optionElement.on('$destroy', function () {
        var currentValue = self.readValue();
        var removeValue = optionAttrs.value;

        self.removeOption(removeValue);
        scheduleRender();

        if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 || currentValue === removeValue) {
          // When multiple (selected) options are destroyed at the same time, we don't want
          // to run a model update for each of them. Instead, run a single update in the $$postDigest
          scheduleViewValueUpdate(true);
        }
      });
    };
  }];

  /**
   * @ngdoc directive
   * @name select
   * @restrict E
   *
   * @description
   * HTML `select` element with AngularJS data-binding.
   *
   * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
   * between the scope and the `<select>` control (including setting default values).
   * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
   * {@link ngOptions `ngOptions`} directives.
   *
   * When an item in the `<select>` menu is selected, the value of the selected option will be bound
   * to the model identified by the `ngModel` directive. With static or repeated options, this is
   * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
   * Value and textContent can be interpolated.
   *
   * The {@link select.SelectController select controller} exposes utility functions that can be used
   * to manipulate the select's behavior.
   *
   * ## Matching model and option values
   *
   * In general, the match between the model and an option is evaluated by strictly comparing the model
   * value against the value of the available options.
   *
   * If you are setting the option value with the option's `value` attribute, or textContent, the
   * value will always be a `string` which means that the model value must also be a string.
   * Otherwise the `select` directive cannot match them correctly.
   *
   * To bind the model to a non-string value, you can use one of the following strategies:
   * - the {@link ng.ngOptions `ngOptions`} directive
   *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
   * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
   *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
   * - model $parsers / $formatters to convert the string value
   *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
   *
   * If the viewValue of `ngModel` does not match any of the options, then the control
   * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
   *
   * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
   * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
   * option. See example below for demonstration.
   *
   * ## Choosing between `ngRepeat` and `ngOptions`
   *
   * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
   * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
   * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
   * comprehension expression
   * - reduced memory consumption by not creating a new scope for each repeated instance
   * - increased render speed by creating the options in a documentFragment instead of individually
   *
   * Specifically, select with repeated options slows down significantly starting at 2000 options in
   * Chrome and Internet Explorer / Edge.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} multiple Allows multiple options to be selected. The selected values will be
   *     bound to the model as an array.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds required attribute and required validation constraint to
   * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
   * when you want to data-bind to the required attribute.
   * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
   *    interaction with the select element.
   * @param {string=} ngOptions sets the options that the select is populated with and defines what is
   * set on the model on selection. See {@link ngOptions `ngOptions`}.
   * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
   * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
   *
   *
   * @knownIssue
   *
   * In Firefox, the select model is only updated when the select element is blurred. For example,
   * when switching between options with the keyboard, the select model is only set to the
   * currently selected option when the select is blurred, e.g via tab key or clicking the mouse
   * outside the select.
   *
   * This is due to an ambiguity in the select element specification. See the
   * [issue on the Firefox bug tracker](https://bugzilla.mozilla.org/show_bug.cgi?id=126379)
   * for more information, and this
   * [Github comment for a workaround](https://github.com/angular/angular.js/issues/9134#issuecomment-130800488)
   *
   * @example
   * ### Simple `select` elements with static options
   *
   * <example name="static-select" module="staticSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="singleSelect"> Single select: </label><br>
   *     <select name="singleSelect" ng-model="data.singleSelect">
   *       <option value="option-1">Option 1</option>
   *       <option value="option-2">Option 2</option>
   *     </select><br>
   *
   *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
   *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
   *       <option value="">---Please select---</option> <!-- not selected / blank option -->
   *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
   *       <option value="option-2">Option 2</option>
   *     </select><br>
   *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
   *     <tt>singleSelect = {{data.singleSelect}}</tt>
   *
   *     <hr>
   *     <label for="multipleSelect"> Multiple select: </label><br>
   *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
   *       <option value="option-1">Option 1</option>
   *       <option value="option-2">Option 2</option>
   *       <option value="option-3">Option 3</option>
   *     </select><br>
   *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
   *   </form>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('staticSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.data = {
   *       singleSelect: null,
   *       multipleSelect: [],
   *       option1: 'option-1'
   *      };
   *
   *      $scope.forceUnknownOption = function() {
   *        $scope.data.singleSelect = 'nonsense';
   *      };
   *   }]);
   * </file>
   *</example>
   *
   * @example
   * ### Using `ngRepeat` to generate `select` options
   * <example name="select-ngrepeat" module="ngrepeatSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="repeatSelect"> Repeat select: </label>
   *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
   *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
   *     </select>
   *   </form>
   *   <hr>
   *   <tt>model = {{data.model}}</tt><br/>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('ngrepeatSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.data = {
   *       model: null,
   *       availableOptions: [
   *         {id: '1', name: 'Option A'},
   *         {id: '2', name: 'Option B'},
   *         {id: '3', name: 'Option C'}
   *       ]
   *      };
   *   }]);
   * </file>
   *</example>
   *
   * @example
   * ### Using `ngValue` to bind the model to an array of objects
   * <example name="select-ngvalue" module="ngvalueSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="ngvalueselect"> ngvalue select: </label>
   *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
   *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
   *     </select>
   *   </form>
   *   <hr>
   *   <pre>model = {{data.model | json}}</pre><br/>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('ngvalueSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.data = {
   *       model: null,
   *       availableOptions: [
             {value: 'myString', name: 'string'},
             {value: 1, name: 'integer'},
             {value: true, name: 'boolean'},
             {value: null, name: 'null'},
             {value: {prop: 'value'}, name: 'object'},
             {value: ['a'], name: 'array'}
   *       ]
   *      };
   *   }]);
   * </file>
   *</example>
   *
   * @example
   * ### Using `select` with `ngOptions` and setting a default value
   * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
   *
   * <example name="select-with-default-values" module="defaultValueSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="mySelect">Make a choice:</label>
   *     <select name="mySelect" id="mySelect"
   *       ng-options="option.name for option in data.availableOptions track by option.id"
   *       ng-model="data.selectedOption"></select>
   *   </form>
   *   <hr>
   *   <tt>option = {{data.selectedOption}}</tt><br/>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('defaultValueSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.data = {
   *       availableOptions: [
   *         {id: '1', name: 'Option A'},
   *         {id: '2', name: 'Option B'},
   *         {id: '3', name: 'Option C'}
   *       ],
   *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
   *       };
   *   }]);
   * </file>
   *</example>
   *
   * @example
   * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
   *
   * <example name="select-with-non-string-options" module="nonStringSelect">
   *   <file name="index.html">
   *     <select ng-model="model.id" convert-to-number>
   *       <option value="0">Zero</option>
   *       <option value="1">One</option>
   *       <option value="2">Two</option>
   *     </select>
   *     {{ model }}
   *   </file>
   *   <file name="app.js">
   *     angular.module('nonStringSelect', [])
   *       .run(function($rootScope) {
   *         $rootScope.model = { id: 2 };
   *       })
   *       .directive('convertToNumber', function() {
   *         return {
   *           require: 'ngModel',
   *           link: function(scope, element, attrs, ngModel) {
   *             ngModel.$parsers.push(function(val) {
   *               return parseInt(val, 10);
   *             });
   *             ngModel.$formatters.push(function(val) {
   *               return '' + val;
   *             });
   *           }
   *         };
   *       });
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     it('should initialize to model', function() {
   *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
   *     });
   *   </file>
   * </example>
   *
   */
  var selectDirective = function selectDirective() {

    return {
      restrict: 'E',
      require: ['select', '?ngModel'],
      controller: SelectController,
      priority: 1,
      link: {
        pre: selectPreLink,
        post: selectPostLink
      }
    };

    function selectPreLink(scope, element, attr, ctrls) {

      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      // if ngModel is not defined, we don't need to do anything but set the registerOption
      // function to noop, so options don't get added internally
      if (!ngModelCtrl) {
        selectCtrl.registerOption = noop;
        return;
      }

      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function () {
        selectCtrl.removeUnknownOption();
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {
        selectCtrl.multiple = true;

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function (option) {
            if (option.selected && !option.disabled) {
              var val = option.value;
              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          forEach(element.find('option'), function (option) {
            var shouldBeSelected = !!value && (includes(value, option.value) || includes(value, selectCtrl.selectValueMap[option.value]));
            var currentlySelected = option.selected;

            // Support: IE 9-11 only, Edge 12-15+
            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
            // will de-select already selected options if "selected" on those options was set
            // more than once (i.e. when the options were already selected)
            // So we only modify the selected property if necessary.
            // Note: this behavior cannot be replicated via unit tests because it only shows in the
            // actual user interface.
            if (shouldBeSelected !== currentlySelected) {
              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
            }
          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView,
            lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function (value) {
          return !value || value.length === 0;
        };
      }
    }

    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;

      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function () {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
  };

  // The option directive is purely designed to communicate the existence (or lack of)
  // of dynamically created (and destroyed) option elements to their containing select
  // directive via its controller.
  var optionDirective = ['$interpolate', function ($interpolate) {
    return {
      restrict: 'E',
      priority: 100,
      compile: function compile(element, attr) {
        var interpolateValueFn, interpolateTextFn;

        if (isDefined(attr.ngValue)) {
          // Will be handled by registerOption
        } else if (isDefined(attr.value)) {
          // If the value attribute is defined, check if it contains an interpolation
          interpolateValueFn = $interpolate(attr.value, true);
        } else {
          // If the value attribute is not defined then we fall back to the
          // text content of the option element, which may be interpolated
          interpolateTextFn = $interpolate(element.text(), true);
          if (!interpolateTextFn) {
            attr.$set('value', element.text());
          }
        }

        return function (scope, element, attr) {
          // This is an optimization over using ^^ since we don't want to have to search
          // all the way to the root of the DOM for every single option element
          var selectCtrlName = '$selectController',
              parent = element.parent(),
              selectCtrl = parent.data(selectCtrlName) || parent.parent().data(selectCtrlName); // in case we are in optgroup

          if (selectCtrl) {
            selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
          }
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngRequired
   * @restrict A
   *
   * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
   *                                `required` attribute to the element and adds the `required`
   *                                {@link ngModel.NgModelController#$validators `validator`}.
   *
   * @description
   *
   * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
   * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
   * applied to custom controls.
   *
   * The directive sets the `required` attribute on the element if the AngularJS expression inside
   * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
   * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
   * for more info.
   *
   * The validator will set the `required` error key to true if the `required` attribute is set and
   * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
   * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
   * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
   * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
   *
   * @example
   * <example name="ngRequiredDirective" module="ngRequiredExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('ngRequiredExample', [])
   *         .controller('ExampleController', ['$scope', function($scope) {
   *           $scope.required = true;
   *         }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <form name="form">
   *         <label for="required">Toggle required: </label>
   *         <input type="checkbox" ng-model="required" id="required" />
   *         <br>
   *         <label for="input">This input must be filled if `required` is true: </label>
   *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
   *         <hr>
   *         required error set? = <code>{{form.input.$error.required}}</code><br>
   *         model = <code>{{model}}</code>
   *       </form>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
         var required = element(by.binding('form.input.$error.required'));
         var model = element(by.binding('model'));
         var input = element(by.id('input'));
  
         it('should set the required error', function() {
           expect(required.getText()).toContain('true');
  
           input.sendKeys('123');
           expect(required.getText()).not.toContain('true');
           expect(model.getText()).toContain('123');
         });
   *   </file>
   * </example>
   */
  var requiredDirective = function requiredDirective() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link(scope, elm, attr, ctrl) {
        if (!ctrl) return;
        attr.required = true; // force truthy in case we are on non input element

        ctrl.$validators.required = function (modelValue, viewValue) {
          return !attr.required || !ctrl.$isEmpty(viewValue);
        };

        attr.$observe('required', function () {
          ctrl.$validate();
        });
      }
    };
  };

  /**
   * @ngdoc directive
   * @name ngPattern
   * @restrict A
   *
   * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
   *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
   *                                      more details.
   *
   * @description
   *
   * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
   * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
   *
   * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
   * does not match a RegExp which is obtained from the `ngPattern` attribute value:
   * - the value is an AngularJS expression:
   *   - If the expression evaluates to a RegExp object, then this is used directly.
   *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
   *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
   * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
   *
   * <div class="alert alert-info">
   * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   * start at the index of the last search's match, thus not taking the whole input value into
   * account.
   * </div>
   *
   * <div class="alert alert-info">
   * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
   * differences:
   * <ol>
   *   <li>
   *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
   *     not available.
   *   </li>
   *   <li>
   *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
   *     interpolated.
   *   </li>
   * </ol>
   * </div>
   *
   * @example
   * <example name="ngPatternDirective" module="ngPatternExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('ngPatternExample', [])
   *         .controller('ExampleController', ['$scope', function($scope) {
   *           $scope.regex = '\\d+';
   *         }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <form name="form">
   *         <label for="regex">Set a pattern (regex string): </label>
   *         <input type="text" ng-model="regex" id="regex" />
   *         <br>
   *         <label for="input">This input is restricted by the current pattern: </label>
   *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
   *         <hr>
   *         input valid? = <code>{{form.input.$valid}}</code><br>
   *         model = <code>{{model}}</code>
   *       </form>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
         var model = element(by.binding('model'));
         var input = element(by.id('input'));
  
         it('should validate the input with the default pattern', function() {
           input.sendKeys('aaa');
           expect(model.getText()).not.toContain('aaa');
  
           input.clear().then(function() {
             input.sendKeys('123');
             expect(model.getText()).toContain('123');
           });
         });
   *   </file>
   * </example>
   */
  var patternDirective = function patternDirective() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link(scope, elm, attr, ctrl) {
        if (!ctrl) return;

        var regexp,
            patternExp = attr.ngPattern || attr.pattern;
        attr.$observe('pattern', function (regex) {
          if (isString(regex) && regex.length > 0) {
            regex = new RegExp('^' + regex + '$');
          }

          if (regex && !regex.test) {
            throw minErr('ngPattern')('noregexp', 'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp, regex, startingTag(elm));
          }

          regexp = regex || undefined;
          ctrl.$validate();
        });

        ctrl.$validators.pattern = function (modelValue, viewValue) {
          // HTML5 pattern constraint validates the input value, so we validate the viewValue
          return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
        };
      }
    };
  };

  /**
   * @ngdoc directive
   * @name ngMaxlength
   * @restrict A
   *
   * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
   *                                 parsable into a `Number`. Used as value for the `maxlength`
   *                                 {@link ngModel.NgModelController#$validators validator}.
   *
   * @description
   *
   * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
   * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
   *
   * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
   * is longer than the integer obtained by evaluating the AngularJS expression given in the
   * `ngMaxlength` attribute value.
   *
   * <div class="alert alert-info">
   * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
   * differences:
   * <ol>
   *   <li>
   *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
   *     validation is not available.
   *   </li>
   *   <li>
   *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
   *     interpolated.
   *   </li>
   * </ol>
   * </div>
   *
   * @example
   * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('ngMaxlengthExample', [])
   *         .controller('ExampleController', ['$scope', function($scope) {
   *           $scope.maxlength = 5;
   *         }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <form name="form">
   *         <label for="maxlength">Set a maxlength: </label>
   *         <input type="number" ng-model="maxlength" id="maxlength" />
   *         <br>
   *         <label for="input">This input is restricted by the current maxlength: </label>
   *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
   *         <hr>
   *         input valid? = <code>{{form.input.$valid}}</code><br>
   *         model = <code>{{model}}</code>
   *       </form>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
         var model = element(by.binding('model'));
         var input = element(by.id('input'));
  
         it('should validate the input with the default maxlength', function() {
           input.sendKeys('abcdef');
           expect(model.getText()).not.toContain('abcdef');
  
           input.clear().then(function() {
             input.sendKeys('abcde');
             expect(model.getText()).toContain('abcde');
           });
         });
   *   </file>
   * </example>
   */
  var maxlengthDirective = function maxlengthDirective() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link(scope, elm, attr, ctrl) {
        if (!ctrl) return;

        var maxlength = -1;
        attr.$observe('maxlength', function (value) {
          var intVal = toInt(value);
          maxlength = isNumberNaN(intVal) ? -1 : intVal;
          ctrl.$validate();
        });
        ctrl.$validators.maxlength = function (modelValue, viewValue) {
          return maxlength < 0 || ctrl.$isEmpty(viewValue) || viewValue.length <= maxlength;
        };
      }
    };
  };

  /**
   * @ngdoc directive
   * @name ngMinlength
   * @restrict A
   *
   * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
   *                                 parsable into a `Number`. Used as value for the `minlength`
   *                                 {@link ngModel.NgModelController#$validators validator}.
   *
   * @description
   *
   * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
   * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
   *
   * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
   * is shorter than the integer obtained by evaluating the AngularJS expression given in the
   * `ngMinlength` attribute value.
   *
   * <div class="alert alert-info">
   * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
   * differences:
   * <ol>
   *   <li>
   *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
   *     validation is not available.
   *   </li>
   *   <li>
   *     The `ngMinlength` value must be an expression, while the `minlength` value must be
   *     interpolated.
   *   </li>
   * </ol>
   * </div>
   *
   * @example
   * <example name="ngMinlengthDirective" module="ngMinlengthExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('ngMinlengthExample', [])
   *         .controller('ExampleController', ['$scope', function($scope) {
   *           $scope.minlength = 3;
   *         }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <form name="form">
   *         <label for="minlength">Set a minlength: </label>
   *         <input type="number" ng-model="minlength" id="minlength" />
   *         <br>
   *         <label for="input">This input is restricted by the current minlength: </label>
   *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
   *         <hr>
   *         input valid? = <code>{{form.input.$valid}}</code><br>
   *         model = <code>{{model}}</code>
   *       </form>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
         var model = element(by.binding('model'));
         var input = element(by.id('input'));
  
         it('should validate the input with the default minlength', function() {
           input.sendKeys('ab');
           expect(model.getText()).not.toContain('ab');
  
           input.sendKeys('abc');
           expect(model.getText()).toContain('abc');
         });
   *   </file>
   * </example>
   */
  var minlengthDirective = function minlengthDirective() {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link(scope, elm, attr, ctrl) {
        if (!ctrl) return;

        var minlength = 0;
        attr.$observe('minlength', function (value) {
          minlength = toInt(value) || 0;
          ctrl.$validate();
        });
        ctrl.$validators.minlength = function (modelValue, viewValue) {
          return ctrl.$isEmpty(viewValue) || viewValue.length >= minlength;
        };
      }
    };
  };

  if (window.angular.bootstrap) {
    // AngularJS is already loaded, so we can return here...
    if (window.console) {
      console.log('WARNING: Tried to load AngularJS more than once.');
    }
    return;
  }

  // try to bind to jquery now so that one can write jqLite(fn)
  // but we will rebind on bootstrap again.
  bindJQuery();

  publishExternalAPI(angular);

  angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    function getDecimals(n) {
      n = n + '';
      var i = n.indexOf('.');
      return i == -1 ? 0 : n.length - i - 1;
    }

    function getVF(n, opt_precision) {
      var v = opt_precision;

      if (undefined === v) {
        v = Math.min(getDecimals(n), 3);
      }

      var base = Math.pow(10, v);
      var f = (n * base | 0) % base;
      return { v: v, f: f };
    }

    $provide.value("$locale", {
      "DATETIME_FORMATS": {
        "AMPMS": ["AM", "PM"],
        "DAY": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "ERANAMES": ["Before Christ", "Anno Domini"],
        "ERAS": ["BC", "AD"],
        "FIRSTDAYOFWEEK": 6,
        "MONTH": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "SHORTDAY": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        "SHORTMONTH": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        "STANDALONEMONTH": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "WEEKENDRANGE": [5, 6],
        "fullDate": "EEEE, MMMM d, y",
        "longDate": "MMMM d, y",
        "medium": "MMM d, y h:mm:ss a",
        "mediumDate": "MMM d, y",
        "mediumTime": "h:mm:ss a",
        "short": "M/d/yy h:mm a",
        "shortDate": "M/d/yy",
        "shortTime": "h:mm a"
      },
      "NUMBER_FORMATS": {
        "CURRENCY_SYM": "$",
        "DECIMAL_SEP": ".",
        "GROUP_SEP": ",",
        "PATTERNS": [{
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        }, {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": '-\xA4',
          "negSuf": "",
          "posPre": '\xA4',
          "posSuf": ""
        }]
      },
      "id": "en-us",
      "localeID": "en_US",
      "pluralCat": function pluralCat(n, opt_precision) {
        var i = n | 0;var vf = getVF(n, opt_precision);if (i == 1 && vf.v == 0) {
          return PLURAL_CATEGORY.ONE;
        }return PLURAL_CATEGORY.OTHER;
      }
    });
  }]);

  jqLite(function () {
    angularInit(window.document, bootstrap);
  });
})(window);

!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend('<style type="text/css">@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}</style>');

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
(function (global, factory) {

	"use strict";

	if (( false ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ? factory(global, true) : function (w) {
			if (!w.document) {
				throw new Error("jQuery requires a window with a document");
			}
			return factory(w);
		};
	} else {
		factory(global);
	}

	// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function (window, noGlobal) {

	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";

	var arr = [];

	var document = window.document;

	var getProto = Object.getPrototypeOf;

	var _slice = arr.slice;

	var concat = arr.concat;

	var push = arr.push;

	var indexOf = arr.indexOf;

	var class2type = {};

	var toString = class2type.toString;

	var hasOwn = class2type.hasOwnProperty;

	var fnToString = hasOwn.toString;

	var ObjectFunctionString = fnToString.call(Object);

	var support = {};

	var isFunction = function isFunction(obj) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		return typeof obj === "function" && typeof obj.nodeType !== "number";
	};

	var isWindow = function isWindow(obj) {
		return obj != null && obj === obj.window;
	};

	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval(code, doc, node) {
		doc = doc || document;

		var i,
		    script = doc.createElement("script");

		script.text = code;
		if (node) {
			for (i in preservedScriptAttributes) {
				if (node[i]) {
					script[i] = node[i];
				}
			}
		}
		doc.head.appendChild(script).parentNode.removeChild(script);
	}

	function toType(obj) {
		if (obj == null) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module


	var version = "3.3.1",


	// Define a local copy of jQuery
	jQuery = function jQuery(selector, context) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init(selector, context);
	},


	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

	jQuery.fn = jQuery.prototype = {

		// The current version of jQuery being used
		jquery: version,

		constructor: jQuery,

		// The default length of a jQuery object is 0
		length: 0,

		toArray: function toArray() {
			return _slice.call(this);
		},

		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function get(num) {

			// Return all the elements in a clean array
			if (num == null) {
				return _slice.call(this);
			}

			// Return just the one element from the set
			return num < 0 ? this[num + this.length] : this[num];
		},

		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function pushStack(elems) {

			// Build a new jQuery matched element set
			var ret = jQuery.merge(this.constructor(), elems);

			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;

			// Return the newly-formed element set
			return ret;
		},

		// Execute a callback for every element in the matched set.
		each: function each(callback) {
			return jQuery.each(this, callback);
		},

		map: function map(callback) {
			return this.pushStack(jQuery.map(this, function (elem, i) {
				return callback.call(elem, i, elem);
			}));
		},

		slice: function slice() {
			return this.pushStack(_slice.apply(this, arguments));
		},

		first: function first() {
			return this.eq(0);
		},

		last: function last() {
			return this.eq(-1);
		},

		eq: function eq(i) {
			var len = this.length,
			    j = +i + (i < 0 ? len : 0);
			return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
		},

		end: function end() {
			return this.prevObject || this.constructor();
		},

		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};

	jQuery.extend = jQuery.fn.extend = function () {
		var options,
		    name,
		    src,
		    copy,
		    copyIsArray,
		    clone,
		    target = arguments[0] || {},
		    i = 1,
		    length = arguments.length,
		    deep = false;

		// Handle a deep copy situation
		if (typeof target === "boolean") {
			deep = target;

			// Skip the boolean and the target
			target = arguments[i] || {};
			i++;
		}

		// Handle case when target is a string or something (possible in deep copy)
		if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== "object" && !isFunction(target)) {
			target = {};
		}

		// Extend jQuery itself if only one argument is passed
		if (i === length) {
			target = this;
			i--;
		}

		for (; i < length; i++) {

			// Only deal with non-null/undefined values
			if ((options = arguments[i]) != null) {

				// Extend the base object
				for (name in options) {
					src = target[name];
					copy = options[name];

					// Prevent never-ending loop
					if (target === copy) {
						continue;
					}

					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {

						if (copyIsArray) {
							copyIsArray = false;
							clone = src && Array.isArray(src) ? src : [];
						} else {
							clone = src && jQuery.isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						target[name] = jQuery.extend(deep, clone, copy);

						// Don't bring in undefined values
					} else if (copy !== undefined) {
						target[name] = copy;
					}
				}
			}
		}

		// Return the modified object
		return target;
	};

	jQuery.extend({

		// Unique for each copy of jQuery on the page
		expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

		// Assume jQuery is ready without the ready module
		isReady: true,

		error: function error(msg) {
			throw new Error(msg);
		},

		noop: function noop() {},

		isPlainObject: function isPlainObject(obj) {
			var proto, Ctor;

			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if (!obj || toString.call(obj) !== "[object Object]") {
				return false;
			}

			proto = getProto(obj);

			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if (!proto) {
				return true;
			}

			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
			return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
		},

		isEmptyObject: function isEmptyObject(obj) {

			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;

			for (name in obj) {
				return false;
			}
			return true;
		},

		// Evaluates a script in a global context
		globalEval: function globalEval(code) {
			DOMEval(code);
		},

		each: function each(obj, callback) {
			var length,
			    i = 0;

			if (isArrayLike(obj)) {
				length = obj.length;
				for (; i < length; i++) {
					if (callback.call(obj[i], i, obj[i]) === false) {
						break;
					}
				}
			} else {
				for (i in obj) {
					if (callback.call(obj[i], i, obj[i]) === false) {
						break;
					}
				}
			}

			return obj;
		},

		// Support: Android <=4.0 only
		trim: function trim(text) {
			return text == null ? "" : (text + "").replace(rtrim, "");
		},

		// results is for internal usage only
		makeArray: function makeArray(arr, results) {
			var ret = results || [];

			if (arr != null) {
				if (isArrayLike(Object(arr))) {
					jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
				} else {
					push.call(ret, arr);
				}
			}

			return ret;
		},

		inArray: function inArray(elem, arr, i) {
			return arr == null ? -1 : indexOf.call(arr, elem, i);
		},

		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function merge(first, second) {
			var len = +second.length,
			    j = 0,
			    i = first.length;

			for (; j < len; j++) {
				first[i++] = second[j];
			}

			first.length = i;

			return first;
		},

		grep: function grep(elems, callback, invert) {
			var callbackInverse,
			    matches = [],
			    i = 0,
			    length = elems.length,
			    callbackExpect = !invert;

			// Go through the array, only saving the items
			// that pass the validator function
			for (; i < length; i++) {
				callbackInverse = !callback(elems[i], i);
				if (callbackInverse !== callbackExpect) {
					matches.push(elems[i]);
				}
			}

			return matches;
		},

		// arg is for internal usage only
		map: function map(elems, callback, arg) {
			var length,
			    value,
			    i = 0,
			    ret = [];

			// Go through the array, translating each of the items to their new values
			if (isArrayLike(elems)) {
				length = elems.length;
				for (; i < length; i++) {
					value = callback(elems[i], i, arg);

					if (value != null) {
						ret.push(value);
					}
				}

				// Go through every key on the object,
			} else {
				for (i in elems) {
					value = callback(elems[i], i, arg);

					if (value != null) {
						ret.push(value);
					}
				}
			}

			// Flatten any nested arrays
			return concat.apply([], ret);
		},

		// A global GUID counter for objects
		guid: 1,

		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	});

	if (typeof Symbol === "function") {
		jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
	}

	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (i, name) {
		class2type["[object " + name + "]"] = name.toLowerCase();
	});

	function isArrayLike(obj) {

		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
		    type = toType(obj);

		if (isFunction(obj) || isWindow(obj)) {
			return false;
		}

		return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
	}
	var Sizzle =
	/*!
  * Sizzle CSS Selector Engine v2.3.3
  * https://sizzlejs.com/
  *
  * Copyright jQuery Foundation and other contributors
  * Released under the MIT license
  * http://jquery.org/license
  *
  * Date: 2016-08-08
  */
	function (window) {

		var i,
		    support,
		    Expr,
		    getText,
		    isXML,
		    tokenize,
		    compile,
		    select,
		    outermostContext,
		    sortInput,
		    hasDuplicate,


		// Local document vars
		setDocument,
		    document,
		    docElem,
		    documentIsHTML,
		    rbuggyQSA,
		    rbuggyMatches,
		    matches,
		    contains,


		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		    preferredDoc = window.document,
		    dirruns = 0,
		    done = 0,
		    classCache = createCache(),
		    tokenCache = createCache(),
		    compilerCache = createCache(),
		    sortOrder = function sortOrder(a, b) {
			if (a === b) {
				hasDuplicate = true;
			}
			return 0;
		},


		// Instance methods
		hasOwn = {}.hasOwnProperty,
		    arr = [],
		    pop = arr.pop,
		    push_native = arr.push,
		    push = arr.push,
		    slice = arr.slice,

		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function indexOf(list, elem) {
			var i = 0,
			    len = list.length;
			for (; i < len; i++) {
				if (list[i] === elem) {
					return i;
				}
			}
			return -1;
		},
		    booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",


		// Regular expressions

		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",


		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",


		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
		    pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" + ")\\)|)",


		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp(whitespace + "+", "g"),
		    rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
		    rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
		    rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
		    rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),
		    rpseudo = new RegExp(pseudos),
		    ridentifier = new RegExp("^" + identifier + "$"),
		    matchExpr = {
			"ID": new RegExp("^#(" + identifier + ")"),
			"CLASS": new RegExp("^\\.(" + identifier + ")"),
			"TAG": new RegExp("^(" + identifier + "|[*])"),
			"ATTR": new RegExp("^" + attributes),
			"PSEUDO": new RegExp("^" + pseudos),
			"CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
			"bool": new RegExp("^(?:" + booleans + ")$", "i"),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
		},
		    rinputs = /^(?:input|select|textarea|button)$/i,
		    rheader = /^h\d$/i,
		    rnative = /^[^{]+\{\s*\[native \w/,


		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
		    rsibling = /[+~]/,


		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
		    funescape = function funescape(_, escaped, escapedWhitespace) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ? escaped : high < 0 ?
			// BMP codepoint
			String.fromCharCode(high + 0x10000) :
			// Supplemental Plane codepoint (surrogate pair)
			String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
		},


		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		    fcssescape = function fcssescape(ch, asCodePoint) {
			if (asCodePoint) {

				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if (ch === "\0") {
					return "\uFFFD";
				}

				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
			}

			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},


		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function unloadHandler() {
			setDocument();
		},
		    disabledAncestor = addCombinator(function (elem) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		}, { dir: "parentNode", next: "legend" });

		// Optimize for push.apply( _, NodeList )
		try {
			push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
			// Support: Android<4.0
			// Detect silently failing push.apply
			arr[preferredDoc.childNodes.length].nodeType;
		} catch (e) {
			push = { apply: arr.length ?

				// Leverage slice if possible
				function (target, els) {
					push_native.apply(target, slice.call(els));
				} :

				// Support: IE<9
				// Otherwise append directly
				function (target, els) {
					var j = target.length,
					    i = 0;
					// Can't trust NodeList.length
					while (target[j++] = els[i++]) {}
					target.length = j - 1;
				}
			};
		}

		function Sizzle(selector, context, results, seed) {
			var m,
			    i,
			    elem,
			    nid,
			    match,
			    groups,
			    newSelector,
			    newContext = context && context.ownerDocument,


			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;

			results = results || [];

			// Return early from calls with invalid selector or context
			if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {

				return results;
			}

			// Try to shortcut find operations (as opposed to filters) in HTML documents
			if (!seed) {

				if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
					setDocument(context);
				}
				context = context || document;

				if (documentIsHTML) {

					// If the selector is sufficiently simple, try using a "get*By*" DOM method
					// (excepting DocumentFragment context, where the methods don't exist)
					if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {

						// ID selector
						if (m = match[1]) {

							// Document context
							if (nodeType === 9) {
								if (elem = context.getElementById(m)) {

									// Support: IE, Opera, Webkit
									// TODO: identify versions
									// getElementById can match elements by name instead of ID
									if (elem.id === m) {
										results.push(elem);
										return results;
									}
								} else {
									return results;
								}

								// Element context
							} else {

								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {

									results.push(elem);
									return results;
								}
							}

							// Type selector
						} else if (match[2]) {
							push.apply(results, context.getElementsByTagName(selector));
							return results;

							// Class selector
						} else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {

							push.apply(results, context.getElementsByClassName(m));
							return results;
						}
					}

					// Take advantage of querySelectorAll
					if (support.qsa && !compilerCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {

						if (nodeType !== 1) {
							newContext = context;
							newSelector = selector;

							// qSA looks outside Element context, which is not what we want
							// Thanks to Andrew Dupont for this workaround technique
							// Support: IE <=8
							// Exclude object elements
						} else if (context.nodeName.toLowerCase() !== "object") {

							// Capture the context ID, setting it first if necessary
							if (nid = context.getAttribute("id")) {
								nid = nid.replace(rcssescape, fcssescape);
							} else {
								context.setAttribute("id", nid = expando);
							}

							// Prefix every selector in the list
							groups = tokenize(selector);
							i = groups.length;
							while (i--) {
								groups[i] = "#" + nid + " " + toSelector(groups[i]);
							}
							newSelector = groups.join(",");

							// Expand context for sibling selectors
							newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
						}

						if (newSelector) {
							try {
								push.apply(results, newContext.querySelectorAll(newSelector));
								return results;
							} catch (qsaError) {} finally {
								if (nid === expando) {
									context.removeAttribute("id");
								}
							}
						}
					}
				}
			}

			// All others
			return select(selector.replace(rtrim, "$1"), context, results, seed);
		}

		/**
   * Create key-value caches of limited size
   * @returns {function(string, object)} Returns the Object data after storing it on itself with
   *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
   *	deleting the oldest entry
   */
		function createCache() {
			var keys = [];

			function cache(key, value) {
				// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
				if (keys.push(key + " ") > Expr.cacheLength) {
					// Only keep the most recent entries
					delete cache[keys.shift()];
				}
				return cache[key + " "] = value;
			}
			return cache;
		}

		/**
   * Mark a function for special use by Sizzle
   * @param {Function} fn The function to mark
   */
		function markFunction(fn) {
			fn[expando] = true;
			return fn;
		}

		/**
   * Support testing using an element
   * @param {Function} fn Passed the created element and returns a boolean result
   */
		function assert(fn) {
			var el = document.createElement("fieldset");

			try {
				return !!fn(el);
			} catch (e) {
				return false;
			} finally {
				// Remove from its parent by default
				if (el.parentNode) {
					el.parentNode.removeChild(el);
				}
				// release memory in IE
				el = null;
			}
		}

		/**
   * Adds the same handler for all of the specified attrs
   * @param {String} attrs Pipe-separated list of attributes
   * @param {Function} handler The method that will be applied
   */
		function addHandle(attrs, handler) {
			var arr = attrs.split("|"),
			    i = arr.length;

			while (i--) {
				Expr.attrHandle[arr[i]] = handler;
			}
		}

		/**
   * Checks document order of two siblings
   * @param {Element} a
   * @param {Element} b
   * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
   */
		function siblingCheck(a, b) {
			var cur = b && a,
			    diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;

			// Use IE sourceIndex if available on both nodes
			if (diff) {
				return diff;
			}

			// Check if b follows a
			if (cur) {
				while (cur = cur.nextSibling) {
					if (cur === b) {
						return -1;
					}
				}
			}

			return a ? 1 : -1;
		}

		/**
   * Returns a function to use in pseudos for input types
   * @param {String} type
   */
		function createInputPseudo(type) {
			return function (elem) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === type;
			};
		}

		/**
   * Returns a function to use in pseudos for buttons
   * @param {String} type
   */
		function createButtonPseudo(type) {
			return function (elem) {
				var name = elem.nodeName.toLowerCase();
				return (name === "input" || name === "button") && elem.type === type;
			};
		}

		/**
   * Returns a function to use in pseudos for :enabled/:disabled
   * @param {Boolean} disabled true for :disabled; false for :enabled
   */
		function createDisabledPseudo(disabled) {

			// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
			return function (elem) {

				// Only certain elements can match :enabled or :disabled
				// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
				// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
				if ("form" in elem) {

					// Check for inherited disabledness on relevant non-disabled elements:
					// * listed form-associated elements in a disabled fieldset
					//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
					//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
					// * option elements in a disabled optgroup
					//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
					// All such elements have a "form" property.
					if (elem.parentNode && elem.disabled === false) {

						// Option elements defer to a parent optgroup if present
						if ("label" in elem) {
							if ("label" in elem.parentNode) {
								return elem.parentNode.disabled === disabled;
							} else {
								return elem.disabled === disabled;
							}
						}

						// Support: IE 6 - 11
						// Use the isDisabled shortcut property to check for disabled fieldset ancestors
						return elem.isDisabled === disabled ||

						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled && disabledAncestor(elem) === disabled;
					}

					return elem.disabled === disabled;

					// Try to winnow out elements that can't be disabled before trusting the disabled property.
					// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
					// even exist on them, let alone have a boolean value.
				} else if ("label" in elem) {
					return elem.disabled === disabled;
				}

				// Remaining elements are neither :enabled nor :disabled
				return false;
			};
		}

		/**
   * Returns a function to use in pseudos for positionals
   * @param {Function} fn
   */
		function createPositionalPseudo(fn) {
			return markFunction(function (argument) {
				argument = +argument;
				return markFunction(function (seed, matches) {
					var j,
					    matchIndexes = fn([], seed.length, argument),
					    i = matchIndexes.length;

					// Match elements found at the specified indexes
					while (i--) {
						if (seed[j = matchIndexes[i]]) {
							seed[j] = !(matches[j] = seed[j]);
						}
					}
				});
			});
		}

		/**
   * Checks a node for validity as a Sizzle context
   * @param {Element|Object=} context
   * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
   */
		function testContext(context) {
			return context && typeof context.getElementsByTagName !== "undefined" && context;
		}

		// Expose support vars for convenience
		support = Sizzle.support = {};

		/**
   * Detects XML nodes
   * @param {Element|Object} elem An element or a document
   * @returns {Boolean} True iff elem is a non-HTML XML node
   */
		isXML = Sizzle.isXML = function (elem) {
			// documentElement is verified for cases where it doesn't yet exist
			// (such as loading iframes in IE - #4833)
			var documentElement = elem && (elem.ownerDocument || elem).documentElement;
			return documentElement ? documentElement.nodeName !== "HTML" : false;
		};

		/**
   * Sets document-related variables once based on the current document
   * @param {Element|Object} [doc] An element or document object to use to set the document
   * @returns {Object} Returns the current document
   */
		setDocument = Sizzle.setDocument = function (node) {
			var hasCompare,
			    subWindow,
			    doc = node ? node.ownerDocument || node : preferredDoc;

			// Return early if doc is invalid or already selected
			if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
				return document;
			}

			// Update global variables
			document = doc;
			docElem = document.documentElement;
			documentIsHTML = !isXML(document);

			// Support: IE 9-11, Edge
			// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
			if (preferredDoc !== document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {

				// Support: IE 11, Edge
				if (subWindow.addEventListener) {
					subWindow.addEventListener("unload", unloadHandler, false);

					// Support: IE 9 - 10 only
				} else if (subWindow.attachEvent) {
					subWindow.attachEvent("onunload", unloadHandler);
				}
			}

			/* Attributes
   ---------------------------------------------------------------------- */

			// Support: IE<8
			// Verify that getAttribute really returns attributes and not properties
			// (excepting IE8 booleans)
			support.attributes = assert(function (el) {
				el.className = "i";
				return !el.getAttribute("className");
			});

			/* getElement(s)By*
   ---------------------------------------------------------------------- */

			// Check if getElementsByTagName("*") returns only elements
			support.getElementsByTagName = assert(function (el) {
				el.appendChild(document.createComment(""));
				return !el.getElementsByTagName("*").length;
			});

			// Support: IE<9
			support.getElementsByClassName = rnative.test(document.getElementsByClassName);

			// Support: IE<10
			// Check if getElementById returns elements by name
			// The broken getElementById methods don't pick up programmatically-set names,
			// so use a roundabout getElementsByName test
			support.getById = assert(function (el) {
				docElem.appendChild(el).id = expando;
				return !document.getElementsByName || !document.getElementsByName(expando).length;
			});

			// ID filter and find
			if (support.getById) {
				Expr.filter["ID"] = function (id) {
					var attrId = id.replace(runescape, funescape);
					return function (elem) {
						return elem.getAttribute("id") === attrId;
					};
				};
				Expr.find["ID"] = function (id, context) {
					if (typeof context.getElementById !== "undefined" && documentIsHTML) {
						var elem = context.getElementById(id);
						return elem ? [elem] : [];
					}
				};
			} else {
				Expr.filter["ID"] = function (id) {
					var attrId = id.replace(runescape, funescape);
					return function (elem) {
						var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
						return node && node.value === attrId;
					};
				};

				// Support: IE 6 - 7 only
				// getElementById is not reliable as a find shortcut
				Expr.find["ID"] = function (id, context) {
					if (typeof context.getElementById !== "undefined" && documentIsHTML) {
						var node,
						    i,
						    elems,
						    elem = context.getElementById(id);

						if (elem) {

							// Verify the id attribute
							node = elem.getAttributeNode("id");
							if (node && node.value === id) {
								return [elem];
							}

							// Fall back on getElementsByName
							elems = context.getElementsByName(id);
							i = 0;
							while (elem = elems[i++]) {
								node = elem.getAttributeNode("id");
								if (node && node.value === id) {
									return [elem];
								}
							}
						}

						return [];
					}
				};
			}

			// Tag
			Expr.find["TAG"] = support.getElementsByTagName ? function (tag, context) {
				if (typeof context.getElementsByTagName !== "undefined") {
					return context.getElementsByTagName(tag);

					// DocumentFragment nodes don't have gEBTN
				} else if (support.qsa) {
					return context.querySelectorAll(tag);
				}
			} : function (tag, context) {
				var elem,
				    tmp = [],
				    i = 0,

				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName(tag);

				// Filter out possible comments
				if (tag === "*") {
					while (elem = results[i++]) {
						if (elem.nodeType === 1) {
							tmp.push(elem);
						}
					}

					return tmp;
				}
				return results;
			};

			// Class
			Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
				if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
					return context.getElementsByClassName(className);
				}
			};

			/* QSA/matchesSelector
   ---------------------------------------------------------------------- */

			// QSA and matchesSelector support

			// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
			rbuggyMatches = [];

			// qSa(:focus) reports false when true (Chrome 21)
			// We allow this because of a bug in IE8/9 that throws an error
			// whenever `document.activeElement` is accessed on an iframe
			// So, we allow :focus to pass through QSA all the time to avoid the IE error
			// See https://bugs.jquery.com/ticket/13378
			rbuggyQSA = [];

			if (support.qsa = rnative.test(document.querySelectorAll)) {
				// Build QSA regex
				// Regex strategy adopted from Diego Perini
				assert(function (el) {
					// Select is set to empty string on purpose
					// This is to test IE's treatment of not explicitly
					// setting a boolean content attribute,
					// since its presence should be enough
					// https://bugs.jquery.com/ticket/12359
					docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";

					// Support: IE8, Opera 11-12.16
					// Nothing should be selected when empty strings follow ^= or $= or *=
					// The test attribute must be unknown in Opera but "safe" for WinRT
					// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
					if (el.querySelectorAll("[msallowcapture^='']").length) {
						rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
					}

					// Support: IE8
					// Boolean attributes and "value" are not treated correctly
					if (!el.querySelectorAll("[selected]").length) {
						rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
					}

					// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
					if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
						rbuggyQSA.push("~=");
					}

					// Webkit/Opera - :checked should return selected option elements
					// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
					// IE8 throws error here and will not see later tests
					if (!el.querySelectorAll(":checked").length) {
						rbuggyQSA.push(":checked");
					}

					// Support: Safari 8+, iOS 8+
					// https://bugs.webkit.org/show_bug.cgi?id=136851
					// In-page `selector#id sibling-combinator selector` fails
					if (!el.querySelectorAll("a#" + expando + "+*").length) {
						rbuggyQSA.push(".#.+[+~]");
					}
				});

				assert(function (el) {
					el.innerHTML = "<a href='' disabled='disabled'></a>" + "<select disabled='disabled'><option/></select>";

					// Support: Windows 8 Native Apps
					// The type and name attributes are restricted during .innerHTML assignment
					var input = document.createElement("input");
					input.setAttribute("type", "hidden");
					el.appendChild(input).setAttribute("name", "D");

					// Support: IE8
					// Enforce case-sensitivity of name attribute
					if (el.querySelectorAll("[name=d]").length) {
						rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
					}

					// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
					// IE8 throws error here and will not see later tests
					if (el.querySelectorAll(":enabled").length !== 2) {
						rbuggyQSA.push(":enabled", ":disabled");
					}

					// Support: IE9-11+
					// IE's :disabled selector does not pick up the children of disabled fieldsets
					docElem.appendChild(el).disabled = true;
					if (el.querySelectorAll(":disabled").length !== 2) {
						rbuggyQSA.push(":enabled", ":disabled");
					}

					// Opera 10-11 does not throw on post-comma invalid pseudos
					el.querySelectorAll("*,:x");
					rbuggyQSA.push(",.*:");
				});
			}

			if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) {

				assert(function (el) {
					// Check to see if it's possible to do matchesSelector
					// on a disconnected node (IE 9)
					support.disconnectedMatch = matches.call(el, "*");

					// This should fail with an exception
					// Gecko does not error, returns false instead
					matches.call(el, "[s!='']:x");
					rbuggyMatches.push("!=", pseudos);
				});
			}

			rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
			rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

			/* Contains
   ---------------------------------------------------------------------- */
			hasCompare = rnative.test(docElem.compareDocumentPosition);

			// Element contains another
			// Purposefully self-exclusive
			// As in, an element does not contain itself
			contains = hasCompare || rnative.test(docElem.contains) ? function (a, b) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
				    bup = b && b.parentNode;
				return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
			} : function (a, b) {
				if (b) {
					while (b = b.parentNode) {
						if (b === a) {
							return true;
						}
					}
				}
				return false;
			};

			/* Sorting
   ---------------------------------------------------------------------- */

			// Document order sorting
			sortOrder = hasCompare ? function (a, b) {

				// Flag for duplicate removal
				if (a === b) {
					hasDuplicate = true;
					return 0;
				}

				// Sort on method existence if only one input has compareDocumentPosition
				var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
				if (compare) {
					return compare;
				}

				// Calculate position if both inputs belong to the same document
				compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) :

				// Otherwise we know they are disconnected
				1;

				// Disconnected nodes
				if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {

					// Choose the first element that is related to our preferred document
					if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
						return -1;
					}
					if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
						return 1;
					}

					// Maintain original order
					return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
				}

				return compare & 4 ? -1 : 1;
			} : function (a, b) {
				// Exit early if the nodes are identical
				if (a === b) {
					hasDuplicate = true;
					return 0;
				}

				var cur,
				    i = 0,
				    aup = a.parentNode,
				    bup = b.parentNode,
				    ap = [a],
				    bp = [b];

				// Parentless nodes are either documents or disconnected
				if (!aup || !bup) {
					return a === document ? -1 : b === document ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;

					// If the nodes are siblings, we can do a quick check
				} else if (aup === bup) {
					return siblingCheck(a, b);
				}

				// Otherwise we need full lists of their ancestors for comparison
				cur = a;
				while (cur = cur.parentNode) {
					ap.unshift(cur);
				}
				cur = b;
				while (cur = cur.parentNode) {
					bp.unshift(cur);
				}

				// Walk down the tree looking for a discrepancy
				while (ap[i] === bp[i]) {
					i++;
				}

				return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck(ap[i], bp[i]) :

				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
			};

			return document;
		};

		Sizzle.matches = function (expr, elements) {
			return Sizzle(expr, null, null, elements);
		};

		Sizzle.matchesSelector = function (elem, expr) {
			// Set document vars if needed
			if ((elem.ownerDocument || elem) !== document) {
				setDocument(elem);
			}

			// Make sure that attribute selectors are quoted
			expr = expr.replace(rattributeQuotes, "='$1']");

			if (support.matchesSelector && documentIsHTML && !compilerCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) {

				try {
					var ret = matches.call(elem, expr);

					// IE 9's matchesSelector returns false on disconnected nodes
					if (ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11) {
						return ret;
					}
				} catch (e) {}
			}

			return Sizzle(expr, document, null, [elem]).length > 0;
		};

		Sizzle.contains = function (context, elem) {
			// Set document vars if needed
			if ((context.ownerDocument || context) !== document) {
				setDocument(context);
			}
			return contains(context, elem);
		};

		Sizzle.attr = function (elem, name) {
			// Set document vars if needed
			if ((elem.ownerDocument || elem) !== document) {
				setDocument(elem);
			}

			var fn = Expr.attrHandle[name.toLowerCase()],

			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;

			return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
		};

		Sizzle.escape = function (sel) {
			return (sel + "").replace(rcssescape, fcssescape);
		};

		Sizzle.error = function (msg) {
			throw new Error("Syntax error, unrecognized expression: " + msg);
		};

		/**
   * Document sorting and removing duplicates
   * @param {ArrayLike} results
   */
		Sizzle.uniqueSort = function (results) {
			var elem,
			    duplicates = [],
			    j = 0,
			    i = 0;

			// Unless we *know* we can detect duplicates, assume their presence
			hasDuplicate = !support.detectDuplicates;
			sortInput = !support.sortStable && results.slice(0);
			results.sort(sortOrder);

			if (hasDuplicate) {
				while (elem = results[i++]) {
					if (elem === results[i]) {
						j = duplicates.push(i);
					}
				}
				while (j--) {
					results.splice(duplicates[j], 1);
				}
			}

			// Clear input after sorting to release objects
			// See https://github.com/jquery/sizzle/pull/225
			sortInput = null;

			return results;
		};

		/**
   * Utility function for retrieving the text value of an array of DOM nodes
   * @param {Array|Element} elem
   */
		getText = Sizzle.getText = function (elem) {
			var node,
			    ret = "",
			    i = 0,
			    nodeType = elem.nodeType;

			if (!nodeType) {
				// If no nodeType, this is expected to be an array
				while (node = elem[i++]) {
					// Do not traverse comment nodes
					ret += getText(node);
				}
			} else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
				// Use textContent for elements
				// innerText usage removed for consistency of new lines (jQuery #11153)
				if (typeof elem.textContent === "string") {
					return elem.textContent;
				} else {
					// Traverse its children
					for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
						ret += getText(elem);
					}
				}
			} else if (nodeType === 3 || nodeType === 4) {
				return elem.nodeValue;
			}
			// Do not include comment or processing instruction nodes

			return ret;
		};

		Expr = Sizzle.selectors = {

			// Can be adjusted by the user
			cacheLength: 50,

			createPseudo: markFunction,

			match: matchExpr,

			attrHandle: {},

			find: {},

			relative: {
				">": { dir: "parentNode", first: true },
				" ": { dir: "parentNode" },
				"+": { dir: "previousSibling", first: true },
				"~": { dir: "previousSibling" }
			},

			preFilter: {
				"ATTR": function ATTR(match) {
					match[1] = match[1].replace(runescape, funescape);

					// Move the given value to match[3] whether quoted or unquoted
					match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);

					if (match[2] === "~=") {
						match[3] = " " + match[3] + " ";
					}

					return match.slice(0, 4);
				},

				"CHILD": function CHILD(match) {
					/* matches from matchExpr["CHILD"]
     	1 type (only|nth|...)
     	2 what (child|of-type)
     	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
     	4 xn-component of xn+y argument ([+-]?\d*n|)
     	5 sign of xn-component
     	6 x of xn-component
     	7 sign of y-component
     	8 y of y-component
     */
					match[1] = match[1].toLowerCase();

					if (match[1].slice(0, 3) === "nth") {
						// nth-* requires argument
						if (!match[3]) {
							Sizzle.error(match[0]);
						}

						// numeric x and y parameters for Expr.filter.CHILD
						// remember that false/true cast respectively to 0/1
						match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
						match[5] = +(match[7] + match[8] || match[3] === "odd");

						// other types prohibit arguments
					} else if (match[3]) {
						Sizzle.error(match[0]);
					}

					return match;
				},

				"PSEUDO": function PSEUDO(match) {
					var excess,
					    unquoted = !match[6] && match[2];

					if (matchExpr["CHILD"].test(match[0])) {
						return null;
					}

					// Accept quoted arguments as-is
					if (match[3]) {
						match[2] = match[4] || match[5] || "";

						// Strip excess characters from unquoted arguments
					} else if (unquoted && rpseudo.test(unquoted) && (
					// Get excess from tokenize (recursively)
					excess = tokenize(unquoted, true)) && (
					// advance to the next closing parenthesis
					excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {

						// excess is a negative index
						match[0] = match[0].slice(0, excess);
						match[2] = unquoted.slice(0, excess);
					}

					// Return only captures needed by the pseudo filter method (type and argument)
					return match.slice(0, 3);
				}
			},

			filter: {

				"TAG": function TAG(nodeNameSelector) {
					var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
					return nodeNameSelector === "*" ? function () {
						return true;
					} : function (elem) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
				},

				"CLASS": function CLASS(className) {
					var pattern = classCache[className + " "];

					return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
						return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
					});
				},

				"ATTR": function ATTR(name, operator, check) {
					return function (elem) {
						var result = Sizzle.attr(elem, name);

						if (result == null) {
							return operator === "!=";
						}
						if (!operator) {
							return true;
						}

						result += "";

						return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
					};
				},

				"CHILD": function CHILD(type, what, argument, first, last) {
					var simple = type.slice(0, 3) !== "nth",
					    forward = type.slice(-4) !== "last",
					    ofType = what === "of-type";

					return first === 1 && last === 0 ?

					// Shortcut for :nth-*(n)
					function (elem) {
						return !!elem.parentNode;
					} : function (elem, context, xml) {
						var cache,
						    uniqueCache,
						    outerCache,
						    node,
						    nodeIndex,
						    start,
						    dir = simple !== forward ? "nextSibling" : "previousSibling",
						    parent = elem.parentNode,
						    name = ofType && elem.nodeName.toLowerCase(),
						    useCache = !xml && !ofType,
						    diff = false;

						if (parent) {

							// :(first|last|only)-(child|of-type)
							if (simple) {
								while (dir) {
									node = elem;
									while (node = node[dir]) {
										if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {

											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}

							start = [forward ? parent.firstChild : parent.lastChild];

							// non-xml :nth-child(...) stores cache data on `parent`
							if (forward && useCache) {

								// Seek `elem` from a previously-cached index

								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[expando] || (node[expando] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

								cache = uniqueCache[type] || [];
								nodeIndex = cache[0] === dirruns && cache[1];
								diff = nodeIndex && cache[2];
								node = nodeIndex && parent.childNodes[nodeIndex];

								while (node = ++nodeIndex && node && node[dir] || (

								// Fallback to seeking `elem` from the start
								diff = nodeIndex = 0) || start.pop()) {

									// When found, cache indexes on `parent` and break
									if (node.nodeType === 1 && ++diff && node === elem) {
										uniqueCache[type] = [dirruns, nodeIndex, diff];
										break;
									}
								}
							} else {
								// Use previously-cached element index if available
								if (useCache) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[expando] || (node[expando] = {});

									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

									cache = uniqueCache[type] || [];
									nodeIndex = cache[0] === dirruns && cache[1];
									diff = nodeIndex;
								}

								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if (diff === false) {
									// Use the same loop as above to seek `elem` from the start
									while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {

										if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {

											// Cache the index of each encountered element
											if (useCache) {
												outerCache = node[expando] || (node[expando] = {});

												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});

												uniqueCache[type] = [dirruns, diff];
											}

											if (node === elem) {
												break;
											}
										}
									}
								}
							}

							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || diff % first === 0 && diff / first >= 0;
						}
					};
				},

				"PSEUDO": function PSEUDO(pseudo, argument) {
					// pseudo-class names are case-insensitive
					// http://www.w3.org/TR/selectors/#pseudo-classes
					// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
					// Remember that setFilters inherits from pseudos
					var args,
					    fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);

					// The user may use createPseudo to indicate that
					// arguments are needed to create the filter function
					// just as Sizzle does
					if (fn[expando]) {
						return fn(argument);
					}

					// But maintain support for old signatures
					if (fn.length > 1) {
						args = [pseudo, pseudo, "", argument];
						return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
							var idx,
							    matched = fn(seed, argument),
							    i = matched.length;
							while (i--) {
								idx = indexOf(seed, matched[i]);
								seed[idx] = !(matches[idx] = matched[i]);
							}
						}) : function (elem) {
							return fn(elem, 0, args);
						};
					}

					return fn;
				}
			},

			pseudos: {
				// Potentially complex pseudos
				"not": markFunction(function (selector) {
					// Trim the selector passed to compile
					// to avoid treating leading and trailing
					// spaces as combinators
					var input = [],
					    results = [],
					    matcher = compile(selector.replace(rtrim, "$1"));

					return matcher[expando] ? markFunction(function (seed, matches, context, xml) {
						var elem,
						    unmatched = matcher(seed, null, xml, []),
						    i = seed.length;

						// Match elements unmatched by `matcher`
						while (i--) {
							if (elem = unmatched[i]) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) : function (elem, context, xml) {
						input[0] = elem;
						matcher(input, null, xml, results);
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
				}),

				"has": markFunction(function (selector) {
					return function (elem) {
						return Sizzle(selector, elem).length > 0;
					};
				}),

				"contains": markFunction(function (text) {
					text = text.replace(runescape, funescape);
					return function (elem) {
						return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
					};
				}),

				// "Whether an element is represented by a :lang() selector
				// is based solely on the element's language value
				// being equal to the identifier C,
				// or beginning with the identifier C immediately followed by "-".
				// The matching of C against the element's language value is performed case-insensitively.
				// The identifier C does not have to be a valid language name."
				// http://www.w3.org/TR/selectors/#lang-pseudo
				"lang": markFunction(function (lang) {
					// lang value must be a valid identifier
					if (!ridentifier.test(lang || "")) {
						Sizzle.error("unsupported lang: " + lang);
					}
					lang = lang.replace(runescape, funescape).toLowerCase();
					return function (elem) {
						var elemLang;
						do {
							if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {

								elemLang = elemLang.toLowerCase();
								return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
							}
						} while ((elem = elem.parentNode) && elem.nodeType === 1);
						return false;
					};
				}),

				// Miscellaneous
				"target": function target(elem) {
					var hash = window.location && window.location.hash;
					return hash && hash.slice(1) === elem.id;
				},

				"root": function root(elem) {
					return elem === docElem;
				},

				"focus": function focus(elem) {
					return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
				},

				// Boolean properties
				"enabled": createDisabledPseudo(false),
				"disabled": createDisabledPseudo(true),

				"checked": function checked(elem) {
					// In CSS3, :checked should return both checked and selected elements
					// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
					var nodeName = elem.nodeName.toLowerCase();
					return nodeName === "input" && !!elem.checked || nodeName === "option" && !!elem.selected;
				},

				"selected": function selected(elem) {
					// Accessing this property makes selected-by-default
					// options in Safari work properly
					if (elem.parentNode) {
						elem.parentNode.selectedIndex;
					}

					return elem.selected === true;
				},

				// Contents
				"empty": function empty(elem) {
					// http://www.w3.org/TR/selectors/#empty-pseudo
					// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
					//   but not by others (comment: 8; processing instruction: 7; etc.)
					// nodeType < 6 works because attributes (2) do not appear as children
					for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
						if (elem.nodeType < 6) {
							return false;
						}
					}
					return true;
				},

				"parent": function parent(elem) {
					return !Expr.pseudos["empty"](elem);
				},

				// Element/input types
				"header": function header(elem) {
					return rheader.test(elem.nodeName);
				},

				"input": function input(elem) {
					return rinputs.test(elem.nodeName);
				},

				"button": function button(elem) {
					var name = elem.nodeName.toLowerCase();
					return name === "input" && elem.type === "button" || name === "button";
				},

				"text": function text(elem) {
					var attr;
					return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && (

					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					(attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
				},

				// Position-in-collection
				"first": createPositionalPseudo(function () {
					return [0];
				}),

				"last": createPositionalPseudo(function (matchIndexes, length) {
					return [length - 1];
				}),

				"eq": createPositionalPseudo(function (matchIndexes, length, argument) {
					return [argument < 0 ? argument + length : argument];
				}),

				"even": createPositionalPseudo(function (matchIndexes, length) {
					var i = 0;
					for (; i < length; i += 2) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				}),

				"odd": createPositionalPseudo(function (matchIndexes, length) {
					var i = 1;
					for (; i < length; i += 2) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				}),

				"lt": createPositionalPseudo(function (matchIndexes, length, argument) {
					var i = argument < 0 ? argument + length : argument;
					for (; --i >= 0;) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				}),

				"gt": createPositionalPseudo(function (matchIndexes, length, argument) {
					var i = argument < 0 ? argument + length : argument;
					for (; ++i < length;) {
						matchIndexes.push(i);
					}
					return matchIndexes;
				})
			}
		};

		Expr.pseudos["nth"] = Expr.pseudos["eq"];

		// Add button/input type pseudos
		for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
			Expr.pseudos[i] = createInputPseudo(i);
		}
		for (i in { submit: true, reset: true }) {
			Expr.pseudos[i] = createButtonPseudo(i);
		}

		// Easy API for creating new setFilters
		function setFilters() {}
		setFilters.prototype = Expr.filters = Expr.pseudos;
		Expr.setFilters = new setFilters();

		tokenize = Sizzle.tokenize = function (selector, parseOnly) {
			var matched,
			    match,
			    tokens,
			    type,
			    soFar,
			    groups,
			    preFilters,
			    cached = tokenCache[selector + " "];

			if (cached) {
				return parseOnly ? 0 : cached.slice(0);
			}

			soFar = selector;
			groups = [];
			preFilters = Expr.preFilter;

			while (soFar) {

				// Comma and first run
				if (!matched || (match = rcomma.exec(soFar))) {
					if (match) {
						// Don't consume trailing commas as valid
						soFar = soFar.slice(match[0].length) || soFar;
					}
					groups.push(tokens = []);
				}

				matched = false;

				// Combinators
				if (match = rcombinators.exec(soFar)) {
					matched = match.shift();
					tokens.push({
						value: matched,
						// Cast descendant combinators to space
						type: match[0].replace(rtrim, " ")
					});
					soFar = soFar.slice(matched.length);
				}

				// Filters
				for (type in Expr.filter) {
					if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
						matched = match.shift();
						tokens.push({
							value: matched,
							type: type,
							matches: match
						});
						soFar = soFar.slice(matched.length);
					}
				}

				if (!matched) {
					break;
				}
			}

			// Return the length of the invalid excess
			// if we're just parsing
			// Otherwise, throw an error or return tokens
			return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) :
			// Cache the tokens
			tokenCache(selector, groups).slice(0);
		};

		function toSelector(tokens) {
			var i = 0,
			    len = tokens.length,
			    selector = "";
			for (; i < len; i++) {
				selector += tokens[i].value;
			}
			return selector;
		}

		function addCombinator(matcher, combinator, base) {
			var dir = combinator.dir,
			    skip = combinator.next,
			    key = skip || dir,
			    checkNonElements = base && key === "parentNode",
			    doneName = done++;

			return combinator.first ?
			// Check against closest ancestor/preceding element
			function (elem, context, xml) {
				while (elem = elem[dir]) {
					if (elem.nodeType === 1 || checkNonElements) {
						return matcher(elem, context, xml);
					}
				}
				return false;
			} :

			// Check against all ancestor/preceding elements
			function (elem, context, xml) {
				var oldCache,
				    uniqueCache,
				    outerCache,
				    newCache = [dirruns, doneName];

				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if (xml) {
					while (elem = elem[dir]) {
						if (elem.nodeType === 1 || checkNonElements) {
							if (matcher(elem, context, xml)) {
								return true;
							}
						}
					}
				} else {
					while (elem = elem[dir]) {
						if (elem.nodeType === 1 || checkNonElements) {
							outerCache = elem[expando] || (elem[expando] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});

							if (skip && skip === elem.nodeName.toLowerCase()) {
								elem = elem[dir] || elem;
							} else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {

								// Assign to newCache so results back-propagate to previous elements
								return newCache[2] = oldCache[2];
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[key] = newCache;

								// A match means we're done; a fail means we have to keep checking
								if (newCache[2] = matcher(elem, context, xml)) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
		}

		function elementMatcher(matchers) {
			return matchers.length > 1 ? function (elem, context, xml) {
				var i = matchers.length;
				while (i--) {
					if (!matchers[i](elem, context, xml)) {
						return false;
					}
				}
				return true;
			} : matchers[0];
		}

		function multipleContexts(selector, contexts, results) {
			var i = 0,
			    len = contexts.length;
			for (; i < len; i++) {
				Sizzle(selector, contexts[i], results);
			}
			return results;
		}

		function condense(unmatched, map, filter, context, xml) {
			var elem,
			    newUnmatched = [],
			    i = 0,
			    len = unmatched.length,
			    mapped = map != null;

			for (; i < len; i++) {
				if (elem = unmatched[i]) {
					if (!filter || filter(elem, context, xml)) {
						newUnmatched.push(elem);
						if (mapped) {
							map.push(i);
						}
					}
				}
			}

			return newUnmatched;
		}

		function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
			if (postFilter && !postFilter[expando]) {
				postFilter = setMatcher(postFilter);
			}
			if (postFinder && !postFinder[expando]) {
				postFinder = setMatcher(postFinder, postSelector);
			}
			return markFunction(function (seed, results, context, xml) {
				var temp,
				    i,
				    elem,
				    preMap = [],
				    postMap = [],
				    preexisting = results.length,


				// Get initial elements from seed or context
				elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),


				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems,
				    matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || (seed ? preFilter : preexisting || postFilter) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results : matcherIn;

				// Find primary matches
				if (matcher) {
					matcher(matcherIn, matcherOut, context, xml);
				}

				// Apply postFilter
				if (postFilter) {
					temp = condense(matcherOut, postMap);
					postFilter(temp, [], context, xml);

					// Un-match failing elements by moving them back to matcherIn
					i = temp.length;
					while (i--) {
						if (elem = temp[i]) {
							matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
						}
					}
				}

				if (seed) {
					if (postFinder || preFilter) {
						if (postFinder) {
							// Get the final matcherOut by condensing this intermediate into postFinder contexts
							temp = [];
							i = matcherOut.length;
							while (i--) {
								if (elem = matcherOut[i]) {
									// Restore matcherIn since elem is not yet a final match
									temp.push(matcherIn[i] = elem);
								}
							}
							postFinder(null, matcherOut = [], temp, xml);
						}

						// Move matched elements from seed to results to keep them synchronized
						i = matcherOut.length;
						while (i--) {
							if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) {

								seed[temp] = !(results[temp] = elem);
							}
						}
					}

					// Add elements to results, through postFinder if defined
				} else {
					matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
					if (postFinder) {
						postFinder(null, results, matcherOut, xml);
					} else {
						push.apply(results, matcherOut);
					}
				}
			});
		}

		function matcherFromTokens(tokens) {
			var checkContext,
			    matcher,
			    j,
			    len = tokens.length,
			    leadingRelative = Expr.relative[tokens[0].type],
			    implicitRelative = leadingRelative || Expr.relative[" "],
			    i = leadingRelative ? 1 : 0,


			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator(function (elem) {
				return elem === checkContext;
			}, implicitRelative, true),
			    matchAnyContext = addCombinator(function (elem) {
				return indexOf(checkContext, elem) > -1;
			}, implicitRelative, true),
			    matchers = [function (elem, context, xml) {
				var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			}];

			for (; i < len; i++) {
				if (matcher = Expr.relative[tokens[i].type]) {
					matchers = [addCombinator(elementMatcher(matchers), matcher)];
				} else {
					matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

					// Return special upon seeing a positional matcher
					if (matcher[expando]) {
						// Find the next relative operator (if any) for proper handling
						j = ++i;
						for (; j < len; j++) {
							if (Expr.relative[tokens[j].type]) {
								break;
							}
						}
						return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
					}
					matchers.push(matcher);
				}
			}

			return elementMatcher(matchers);
		}

		function matcherFromGroupMatchers(elementMatchers, setMatchers) {
			var bySet = setMatchers.length > 0,
			    byElement = elementMatchers.length > 0,
			    superMatcher = function superMatcher(seed, context, xml, results, outermost) {
				var elem,
				    j,
				    matcher,
				    matchedCount = 0,
				    i = "0",
				    unmatched = seed && [],
				    setMatched = [],
				    contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]("*", outermost),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
				    len = elems.length;

				if (outermost) {
					outermostContext = context === document || context || outermost;
				}

				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for (; i !== len && (elem = elems[i]) != null; i++) {
					if (byElement && elem) {
						j = 0;
						if (!context && elem.ownerDocument !== document) {
							setDocument(elem);
							xml = !documentIsHTML;
						}
						while (matcher = elementMatchers[j++]) {
							if (matcher(elem, context || document, xml)) {
								results.push(elem);
								break;
							}
						}
						if (outermost) {
							dirruns = dirrunsUnique;
						}
					}

					// Track unmatched elements for set filters
					if (bySet) {
						// They will have gone through all possible matchers
						if (elem = !matcher && elem) {
							matchedCount--;
						}

						// Lengthen the array for every element, matched or not
						if (seed) {
							unmatched.push(elem);
						}
					}
				}

				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;

				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if (bySet && i !== matchedCount) {
					j = 0;
					while (matcher = setMatchers[j++]) {
						matcher(unmatched, setMatched, context, xml);
					}

					if (seed) {
						// Reintegrate element matches to eliminate the need for sorting
						if (matchedCount > 0) {
							while (i--) {
								if (!(unmatched[i] || setMatched[i])) {
									setMatched[i] = pop.call(results);
								}
							}
						}

						// Discard index placeholder values to get only actual matches
						setMatched = condense(setMatched);
					}

					// Add matches to results
					push.apply(results, setMatched);

					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {

						Sizzle.uniqueSort(results);
					}
				}

				// Override manipulation of globals by nested matchers
				if (outermost) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}

				return unmatched;
			};

			return bySet ? markFunction(superMatcher) : superMatcher;
		}

		compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
			var i,
			    setMatchers = [],
			    elementMatchers = [],
			    cached = compilerCache[selector + " "];

			if (!cached) {
				// Generate a function of recursive functions that can be used to check each element
				if (!match) {
					match = tokenize(selector);
				}
				i = match.length;
				while (i--) {
					cached = matcherFromTokens(match[i]);
					if (cached[expando]) {
						setMatchers.push(cached);
					} else {
						elementMatchers.push(cached);
					}
				}

				// Cache the compiled function
				cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

				// Save selector and tokenization
				cached.selector = selector;
			}
			return cached;
		};

		/**
   * A low-level selection function that works with Sizzle's compiled
   *  selector functions
   * @param {String|Function} selector A selector or a pre-compiled
   *  selector function built with Sizzle.compile
   * @param {Element} context
   * @param {Array} [results]
   * @param {Array} [seed] A set of elements to match against
   */
		select = Sizzle.select = function (selector, context, results, seed) {
			var i,
			    tokens,
			    token,
			    type,
			    find,
			    compiled = typeof selector === "function" && selector,
			    match = !seed && tokenize(selector = compiled.selector || selector);

			results = results || [];

			// Try to minimize operations if there is only one selector in the list and no seed
			// (the latter of which guarantees us context)
			if (match.length === 1) {

				// Reduce context if the leading compound selector is an ID
				tokens = match[0] = match[0].slice(0);
				if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {

					context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
					if (!context) {
						return results;

						// Precompiled matchers will still verify ancestry, so step up a level
					} else if (compiled) {
						context = context.parentNode;
					}

					selector = selector.slice(tokens.shift().value.length);
				}

				// Fetch a seed set for right-to-left matching
				i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
				while (i--) {
					token = tokens[i];

					// Abort if we hit a combinator
					if (Expr.relative[type = token.type]) {
						break;
					}
					if (find = Expr.find[type]) {
						// Search, expanding context for leading sibling combinators
						if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {

							// If seed is empty or no tokens remain, we can return early
							tokens.splice(i, 1);
							selector = seed.length && toSelector(tokens);
							if (!selector) {
								push.apply(results, seed);
								return results;
							}

							break;
						}
					}
				}
			}

			// Compile and execute a filtering function if one is not provided
			// Provide `match` to avoid retokenization if we modified the selector above
			(compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
			return results;
		};

		// One-time assignments

		// Sort stability
		support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

		// Support: Chrome 14-35+
		// Always assume duplicates if they aren't passed to the comparison function
		support.detectDuplicates = !!hasDuplicate;

		// Initialize against the default document
		setDocument();

		// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
		// Detached nodes confoundingly follow *each other*
		support.sortDetached = assert(function (el) {
			// Should return 1, but returns 4 (following)
			return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
		});

		// Support: IE<8
		// Prevent attribute/property "interpolation"
		// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
		if (!assert(function (el) {
			el.innerHTML = "<a href='#'></a>";
			return el.firstChild.getAttribute("href") === "#";
		})) {
			addHandle("type|href|height|width", function (elem, name, isXML) {
				if (!isXML) {
					return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
				}
			});
		}

		// Support: IE<9
		// Use defaultValue in place of getAttribute("value")
		if (!support.attributes || !assert(function (el) {
			el.innerHTML = "<input/>";
			el.firstChild.setAttribute("value", "");
			return el.firstChild.getAttribute("value") === "";
		})) {
			addHandle("value", function (elem, name, isXML) {
				if (!isXML && elem.nodeName.toLowerCase() === "input") {
					return elem.defaultValue;
				}
			});
		}

		// Support: IE<9
		// Use getAttributeNode to fetch booleans when getAttribute lies
		if (!assert(function (el) {
			return el.getAttribute("disabled") == null;
		})) {
			addHandle(booleans, function (elem, name, isXML) {
				var val;
				if (!isXML) {
					return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
				}
			});
		}

		return Sizzle;
	}(window);

	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;

	// Deprecated
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;

	var dir = function dir(elem, _dir, until) {
		var matched = [],
		    truncate = until !== undefined;

		while ((elem = elem[_dir]) && elem.nodeType !== 9) {
			if (elem.nodeType === 1) {
				if (truncate && jQuery(elem).is(until)) {
					break;
				}
				matched.push(elem);
			}
		}
		return matched;
	};

	var _siblings = function _siblings(n, elem) {
		var matched = [];

		for (; n; n = n.nextSibling) {
			if (n.nodeType === 1 && n !== elem) {
				matched.push(n);
			}
		}

		return matched;
	};

	var rneedsContext = jQuery.expr.match.needsContext;

	function nodeName(elem, name) {

		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	};
	var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

	// Implement the identical functionality for filter and not
	function winnow(elements, qualifier, not) {
		if (isFunction(qualifier)) {
			return jQuery.grep(elements, function (elem, i) {
				return !!qualifier.call(elem, i, elem) !== not;
			});
		}

		// Single element
		if (qualifier.nodeType) {
			return jQuery.grep(elements, function (elem) {
				return elem === qualifier !== not;
			});
		}

		// Arraylike of elements (jQuery, arguments, Array)
		if (typeof qualifier !== "string") {
			return jQuery.grep(elements, function (elem) {
				return indexOf.call(qualifier, elem) > -1 !== not;
			});
		}

		// Filtered directly for both simple and complex selectors
		return jQuery.filter(qualifier, elements, not);
	}

	jQuery.filter = function (expr, elems, not) {
		var elem = elems[0];

		if (not) {
			expr = ":not(" + expr + ")";
		}

		if (elems.length === 1 && elem.nodeType === 1) {
			return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
		}

		return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
			return elem.nodeType === 1;
		}));
	};

	jQuery.fn.extend({
		find: function find(selector) {
			var i,
			    ret,
			    len = this.length,
			    self = this;

			if (typeof selector !== "string") {
				return this.pushStack(jQuery(selector).filter(function () {
					for (i = 0; i < len; i++) {
						if (jQuery.contains(self[i], this)) {
							return true;
						}
					}
				}));
			}

			ret = this.pushStack([]);

			for (i = 0; i < len; i++) {
				jQuery.find(selector, self[i], ret);
			}

			return len > 1 ? jQuery.uniqueSort(ret) : ret;
		},
		filter: function filter(selector) {
			return this.pushStack(winnow(this, selector || [], false));
		},
		not: function not(selector) {
			return this.pushStack(winnow(this, selector || [], true));
		},
		is: function is(selector) {
			return !!winnow(this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
		}
	});

	// Initialize a jQuery object


	// A central reference to the root jQuery(document)
	var rootjQuery,


	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	    init = jQuery.fn.init = function (selector, context, root) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if (!selector) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if (typeof selector === "string") {
			if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [null, selector, null];
			} else {
				match = rquickExpr.exec(selector);
			}

			// Match html or make sure no context is specified for #id
			if (match && (match[1] || !context)) {

				// HANDLE: $(html) -> $(array)
				if (match[1]) {
					context = context instanceof jQuery ? context[0] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));

					// HANDLE: $(html, props)
					if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
						for (match in context) {

							// Properties of context are called as methods if possible
							if (isFunction(this[match])) {
								this[match](context[match]);

								// ...and otherwise set as attributes
							} else {
								this.attr(match, context[match]);
							}
						}
					}

					return this;

					// HANDLE: $(#id)
				} else {
					elem = document.getElementById(match[2]);

					if (elem) {

						// Inject the element directly into the jQuery object
						this[0] = elem;
						this.length = 1;
					}
					return this;
				}

				// HANDLE: $(expr, $(...))
			} else if (!context || context.jquery) {
				return (context || root).find(selector);

				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor(context).find(selector);
			}

			// HANDLE: $(DOMElement)
		} else if (selector.nodeType) {
			this[0] = selector;
			this.length = 1;
			return this;

			// HANDLE: $(function)
			// Shortcut for document ready
		} else if (isFunction(selector)) {
			return root.ready !== undefined ? root.ready(selector) :

			// Execute immediately if ready is not present
			selector(jQuery);
		}

		return jQuery.makeArray(selector, this);
	};

	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;

	// Initialize central reference
	rootjQuery = jQuery(document);

	var rparentsprev = /^(?:parents|prev(?:Until|All))/,


	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

	jQuery.fn.extend({
		has: function has(target) {
			var targets = jQuery(target, this),
			    l = targets.length;

			return this.filter(function () {
				var i = 0;
				for (; i < l; i++) {
					if (jQuery.contains(this, targets[i])) {
						return true;
					}
				}
			});
		},

		closest: function closest(selectors, context) {
			var cur,
			    i = 0,
			    l = this.length,
			    matched = [],
			    targets = typeof selectors !== "string" && jQuery(selectors);

			// Positional selectors never match, since there's no _selection_ context
			if (!rneedsContext.test(selectors)) {
				for (; i < l; i++) {
					for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {

						// Always skip document fragments
						if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {

							matched.push(cur);
							break;
						}
					}
				}
			}

			return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
		},

		// Determine the position of an element within the set
		index: function index(elem) {

			// No argument, return index in parent
			if (!elem) {
				return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
			}

			// Index in selector
			if (typeof elem === "string") {
				return indexOf.call(jQuery(elem), this[0]);
			}

			// Locate the position of the desired element
			return indexOf.call(this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[0] : elem);
		},

		add: function add(selector, context) {
			return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
		},

		addBack: function addBack(selector) {
			return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
		}
	});

	function sibling(cur, dir) {
		while ((cur = cur[dir]) && cur.nodeType !== 1) {}
		return cur;
	}

	jQuery.each({
		parent: function parent(elem) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function parents(elem) {
			return dir(elem, "parentNode");
		},
		parentsUntil: function parentsUntil(elem, i, until) {
			return dir(elem, "parentNode", until);
		},
		next: function next(elem) {
			return sibling(elem, "nextSibling");
		},
		prev: function prev(elem) {
			return sibling(elem, "previousSibling");
		},
		nextAll: function nextAll(elem) {
			return dir(elem, "nextSibling");
		},
		prevAll: function prevAll(elem) {
			return dir(elem, "previousSibling");
		},
		nextUntil: function nextUntil(elem, i, until) {
			return dir(elem, "nextSibling", until);
		},
		prevUntil: function prevUntil(elem, i, until) {
			return dir(elem, "previousSibling", until);
		},
		siblings: function siblings(elem) {
			return _siblings((elem.parentNode || {}).firstChild, elem);
		},
		children: function children(elem) {
			return _siblings(elem.firstChild);
		},
		contents: function contents(elem) {
			if (nodeName(elem, "iframe")) {
				return elem.contentDocument;
			}

			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if (nodeName(elem, "template")) {
				elem = elem.content || elem;
			}

			return jQuery.merge([], elem.childNodes);
		}
	}, function (name, fn) {
		jQuery.fn[name] = function (until, selector) {
			var matched = jQuery.map(this, fn, until);

			if (name.slice(-5) !== "Until") {
				selector = until;
			}

			if (selector && typeof selector === "string") {
				matched = jQuery.filter(selector, matched);
			}

			if (this.length > 1) {

				// Remove duplicates
				if (!guaranteedUnique[name]) {
					jQuery.uniqueSort(matched);
				}

				// Reverse order for parents* and prev-derivatives
				if (rparentsprev.test(name)) {
					matched.reverse();
				}
			}

			return this.pushStack(matched);
		};
	});
	var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

	// Convert String-formatted options into Object-formatted ones
	function createOptions(options) {
		var object = {};
		jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
			object[flag] = true;
		});
		return object;
	}

	/*
  * Create a callback list using the following parameters:
  *
  *	options: an optional list of space-separated options that will change how
  *			the callback list behaves or a more traditional option object
  *
  * By default a callback list will act like an event callback list and can be
  * "fired" multiple times.
  *
  * Possible options:
  *
  *	once:			will ensure the callback list can only be fired once (like a Deferred)
  *
  *	memory:			will keep track of previous values and will call any callback added
  *					after the list has been fired right away with the latest "memorized"
  *					values (like a Deferred)
  *
  *	unique:			will ensure a callback can only be added once (no duplicate in the list)
  *
  *	stopOnFalse:	interrupt callings when a callback returns false
  *
  */
	jQuery.Callbacks = function (options) {

		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);

		var // Flag to know if list is currently firing
		firing,


		// Last fire value for non-forgettable lists
		memory,


		// Flag to know if list was already fired
		_fired,


		// Flag to prevent firing
		_locked,


		// Actual callback list
		list = [],


		// Queue of execution data for repeatable lists
		queue = [],


		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,


		// Fire callbacks
		fire = function fire() {

			// Enforce single-firing
			_locked = _locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			_fired = firing = true;
			for (; queue.length; firingIndex = -1) {
				memory = queue.shift();
				while (++firingIndex < list.length) {

					// Run callback and check for early termination
					if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if (!options.memory) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if (_locked) {

				// Keep an empty list if we have data for future add calls
				if (memory) {
					list = [];

					// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},


		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function add() {
				if (list) {

					// If we have memory from a past run, we should fire after adding
					if (memory && !firing) {
						firingIndex = list.length - 1;
						queue.push(memory);
					}

					(function add(args) {
						jQuery.each(args, function (_, arg) {
							if (isFunction(arg)) {
								if (!options.unique || !self.has(arg)) {
									list.push(arg);
								}
							} else if (arg && arg.length && toType(arg) !== "string") {

								// Inspect recursively
								add(arg);
							}
						});
					})(arguments);

					if (memory && !firing) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function remove() {
				jQuery.each(arguments, function (_, arg) {
					var index;
					while ((index = jQuery.inArray(arg, list, index)) > -1) {
						list.splice(index, 1);

						// Handle firing indexes
						if (index <= firingIndex) {
							firingIndex--;
						}
					}
				});
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function has(fn) {
				return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function empty() {
				if (list) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function disable() {
				_locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function disabled() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function lock() {
				_locked = queue = [];
				if (!memory && !firing) {
					list = memory = "";
				}
				return this;
			},
			locked: function locked() {
				return !!_locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function fireWith(context, args) {
				if (!_locked) {
					args = args || [];
					args = [context, args.slice ? args.slice() : args];
					queue.push(args);
					if (!firing) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function fire() {
				self.fireWith(this, arguments);
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function fired() {
				return !!_fired;
			}
		};

		return self;
	};

	function Identity(v) {
		return v;
	}
	function Thrower(ex) {
		throw ex;
	}

	function adoptValue(value, resolve, reject, noValue) {
		var method;

		try {

			// Check for promise aspect first to privilege synchronous behavior
			if (value && isFunction(method = value.promise)) {
				method.call(value).done(resolve).fail(reject);

				// Other thenables
			} else if (value && isFunction(method = value.then)) {
				method.call(value, resolve, reject);

				// Other non-thenables
			} else {

				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply(undefined, [value].slice(noValue));
			}

			// For Promises/A+, convert exceptions into rejections
			// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
			// Deferred#then to conditionally suppress rejection.
		} catch (value) {

			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply(undefined, [value]);
		}
	}

	jQuery.extend({

		Deferred: function Deferred(func) {
			var tuples = [

			// action, add listener, callbacks,
			// ... .then handlers, argument index, [final state]
			["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
			    _state = "pending",
			    _promise = {
				state: function state() {
					return _state;
				},
				always: function always() {
					deferred.done(arguments).fail(arguments);
					return this;
				},
				"catch": function _catch(fn) {
					return _promise.then(null, fn);
				},

				// Keep pipe for back-compat
				pipe: function pipe() /* fnDone, fnFail, fnProgress */{
					var fns = arguments;

					return jQuery.Deferred(function (newDefer) {
						jQuery.each(tuples, function (i, tuple) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[tuple[1]](function () {
								var returned = fn && fn.apply(this, arguments);
								if (returned && isFunction(returned.promise)) {
									returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
								} else {
									newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
								}
							});
						});
						fns = null;
					}).promise();
				},
				then: function then(onFulfilled, onRejected, onProgress) {
					var maxDepth = 0;
					function resolve(depth, deferred, handler, special) {
						return function () {
							var that = this,
							    args = arguments,
							    mightThrow = function mightThrow() {
								var returned, then;

								// Support: Promises/A+ section 2.3.3.3.3
								// https://promisesaplus.com/#point-59
								// Ignore double-resolution attempts
								if (depth < maxDepth) {
									return;
								}

								returned = handler.apply(that, args);

								// Support: Promises/A+ section 2.3.1
								// https://promisesaplus.com/#point-48
								if (returned === deferred.promise()) {
									throw new TypeError("Thenable self-resolution");
								}

								// Support: Promises/A+ sections 2.3.3.1, 3.5
								// https://promisesaplus.com/#point-54
								// https://promisesaplus.com/#point-75
								// Retrieve `then` only once
								then = returned && (

								// Support: Promises/A+ section 2.3.4
								// https://promisesaplus.com/#point-64
								// Only check objects and functions for thenability
								(typeof returned === "undefined" ? "undefined" : _typeof(returned)) === "object" || typeof returned === "function") && returned.then;

								// Handle a returned thenable
								if (isFunction(then)) {

									// Special processors (notify) just wait for resolution
									if (special) {
										then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));

										// Normal processors (resolve) also hook into progress
									} else {

										// ...and disregard older resolution values
										maxDepth++;

										then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
									}

									// Handle all other returned values
								} else {

									// Only substitute handlers pass on context
									// and multiple values (non-spec behavior)
									if (handler !== Identity) {
										that = undefined;
										args = [returned];
									}

									// Process the value(s)
									// Default process is resolve
									(special || deferred.resolveWith)(that, args);
								}
							},


							// Only normal processors (resolve) catch and reject exceptions
							process = special ? mightThrow : function () {
								try {
									mightThrow();
								} catch (e) {

									if (jQuery.Deferred.exceptionHook) {
										jQuery.Deferred.exceptionHook(e, process.stackTrace);
									}

									// Support: Promises/A+ section 2.3.3.3.4.1
									// https://promisesaplus.com/#point-61
									// Ignore post-resolution exceptions
									if (depth + 1 >= maxDepth) {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if (handler !== Thrower) {
											that = undefined;
											args = [e];
										}

										deferred.rejectWith(that, args);
									}
								}
							};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if (depth) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if (jQuery.Deferred.getStackHook) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout(process);
							}
						};
					}

					return jQuery.Deferred(function (newDefer) {

						// progress_handlers.add( ... )
						tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));

						// fulfilled_handlers.add( ... )
						tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));

						// rejected_handlers.add( ... )
						tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
					}).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function promise(obj) {
					return obj != null ? jQuery.extend(obj, _promise) : _promise;
				}
			},
			    deferred = {};

			// Add list-specific methods
			jQuery.each(tuples, function (i, tuple) {
				var list = tuple[2],
				    stateString = tuple[5];

				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				_promise[tuple[1]] = list.add;

				// Handle state
				if (stateString) {
					list.add(function () {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						_state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[3 - i][2].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[3 - i][3].disable,

					// progress_callbacks.lock
					tuples[0][2].lock,

					// progress_handlers.lock
					tuples[0][3].lock);
				}

				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add(tuple[3].fire);

				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[tuple[0]] = function () {
					deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
					return this;
				};

				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[tuple[0] + "With"] = list.fireWith;
			});

			// Make the deferred a promise
			_promise.promise(deferred);

			// Call given func if any
			if (func) {
				func.call(deferred, deferred);
			}

			// All done!
			return deferred;
		},

		// Deferred helper
		when: function when(singleValue) {
			var

			// count of uncompleted subordinates
			remaining = arguments.length,


			// count of unprocessed arguments
			i = remaining,


			// subordinate fulfillment data
			resolveContexts = Array(i),
			    resolveValues = _slice.call(arguments),


			// the master Deferred
			master = jQuery.Deferred(),


			// subordinate callback factory
			updateFunc = function updateFunc(i) {
				return function (value) {
					resolveContexts[i] = this;
					resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;
					if (! --remaining) {
						master.resolveWith(resolveContexts, resolveValues);
					}
				};
			};

			// Single- and empty arguments are adopted like Promise.resolve
			if (remaining <= 1) {
				adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject, !remaining);

				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if (master.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {

					return master.then();
				}
			}

			// Multiple arguments are aggregated like Promise.all array elements
			while (i--) {
				adoptValue(resolveValues[i], updateFunc(i), master.reject);
			}

			return master.promise();
		}
	});

	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

	jQuery.Deferred.exceptionHook = function (error, stack) {

		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
			window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
		}
	};

	jQuery.readyException = function (error) {
		window.setTimeout(function () {
			throw error;
		});
	};

	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();

	jQuery.fn.ready = function (fn) {

		readyList.then(fn)

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch(function (error) {
			jQuery.readyException(error);
		});

		return this;
	};

	jQuery.extend({

		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,

		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,

		// Handle when the DOM is ready
		ready: function ready(wait) {

			// Abort if there are pending holds or we're already ready
			if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
				return;
			}

			// Remember that the DOM is ready
			jQuery.isReady = true;

			// If a normal DOM Ready event fired, decrement, and wait if need be
			if (wait !== true && --jQuery.readyWait > 0) {
				return;
			}

			// If there are functions bound, to execute
			readyList.resolveWith(document, [jQuery]);
		}
	});

	jQuery.ready.then = readyList.then;

	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener("DOMContentLoaded", completed);
		window.removeEventListener("load", completed);
		jQuery.ready();
	}

	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {

		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout(jQuery.ready);
	} else {

		// Use the handy event callback
		document.addEventListener("DOMContentLoaded", completed);

		// A fallback to window.onload, that will always work
		window.addEventListener("load", completed);
	}

	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
		var i = 0,
		    len = elems.length,
		    bulk = key == null;

		// Sets many values
		if (toType(key) === "object") {
			chainable = true;
			for (i in key) {
				access(elems, fn, i, key[i], true, emptyGet, raw);
			}

			// Sets one value
		} else if (value !== undefined) {
			chainable = true;

			if (!isFunction(value)) {
				raw = true;
			}

			if (bulk) {

				// Bulk operations run against the entire set
				if (raw) {
					fn.call(elems, value);
					fn = null;

					// ...except when executing function values
				} else {
					bulk = fn;
					fn = function fn(elem, key, value) {
						return bulk.call(jQuery(elem), value);
					};
				}
			}

			if (fn) {
				for (; i < len; i++) {
					fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
				}
			}
		}

		if (chainable) {
			return elems;
		}

		// Gets
		if (bulk) {
			return fn.call(elems);
		}

		return len ? fn(elems[0], key) : emptyGet;
	};

	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
	    rdashAlpha = /-([a-z])/g;

	// Used by camelCase as callback to replace()
	function fcamelCase(all, letter) {
		return letter.toUpperCase();
	}

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase(string) {
		return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
	}
	var acceptData = function acceptData(owner) {

		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
	};

	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}

	Data.uid = 1;

	Data.prototype = {

		cache: function cache(owner) {

			// Check if the owner object already has a cache
			var value = owner[this.expando];

			// If not, create one
			if (!value) {
				value = {};

				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if (acceptData(owner)) {

					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if (owner.nodeType) {
						owner[this.expando] = value;

						// Otherwise secure it in a non-enumerable property
						// configurable must be true to allow the property to be
						// deleted when data is removed
					} else {
						Object.defineProperty(owner, this.expando, {
							value: value,
							configurable: true
						});
					}
				}
			}

			return value;
		},
		set: function set(owner, data, value) {
			var prop,
			    cache = this.cache(owner);

			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if (typeof data === "string") {
				cache[camelCase(data)] = value;

				// Handle: [ owner, { properties } ] args
			} else {

				// Copy the properties one-by-one to the cache object
				for (prop in data) {
					cache[camelCase(prop)] = data[prop];
				}
			}
			return cache;
		},
		get: function get(owner, key) {
			return key === undefined ? this.cache(owner) :

			// Always use camelCase key (gh-2257)
			owner[this.expando] && owner[this.expando][camelCase(key)];
		},
		access: function access(owner, key, value) {

			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if (key === undefined || key && typeof key === "string" && value === undefined) {

				return this.get(owner, key);
			}

			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set(owner, key, value);

			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function remove(owner, key) {
			var i,
			    cache = owner[this.expando];

			if (cache === undefined) {
				return;
			}

			if (key !== undefined) {

				// Support array or space separated string of keys
				if (Array.isArray(key)) {

					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map(camelCase);
				} else {
					key = camelCase(key);

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
				}

				i = key.length;

				while (i--) {
					delete cache[key[i]];
				}
			}

			// Remove the expando if there's no more data
			if (key === undefined || jQuery.isEmptyObject(cache)) {

				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if (owner.nodeType) {
					owner[this.expando] = undefined;
				} else {
					delete owner[this.expando];
				}
			}
		},
		hasData: function hasData(owner) {
			var cache = owner[this.expando];
			return cache !== undefined && !jQuery.isEmptyObject(cache);
		}
	};
	var dataPriv = new Data();

	var dataUser = new Data();

	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	    rmultiDash = /[A-Z]/g;

	function getData(data) {
		if (data === "true") {
			return true;
		}

		if (data === "false") {
			return false;
		}

		if (data === "null") {
			return null;
		}

		// Only convert to a number if it doesn't change the string
		if (data === +data + "") {
			return +data;
		}

		if (rbrace.test(data)) {
			return JSON.parse(data);
		}

		return data;
	}

	function dataAttr(elem, key, data) {
		var name;

		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if (data === undefined && elem.nodeType === 1) {
			name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
			data = elem.getAttribute(name);

			if (typeof data === "string") {
				try {
					data = getData(data);
				} catch (e) {}

				// Make sure we set the data so it isn't changed later
				dataUser.set(elem, key, data);
			} else {
				data = undefined;
			}
		}
		return data;
	}

	jQuery.extend({
		hasData: function hasData(elem) {
			return dataUser.hasData(elem) || dataPriv.hasData(elem);
		},

		data: function data(elem, name, _data) {
			return dataUser.access(elem, name, _data);
		},

		removeData: function removeData(elem, name) {
			dataUser.remove(elem, name);
		},

		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function _data(elem, name, data) {
			return dataPriv.access(elem, name, data);
		},

		_removeData: function _removeData(elem, name) {
			dataPriv.remove(elem, name);
		}
	});

	jQuery.fn.extend({
		data: function data(key, value) {
			var i,
			    name,
			    data,
			    elem = this[0],
			    attrs = elem && elem.attributes;

			// Gets all values
			if (key === undefined) {
				if (this.length) {
					data = dataUser.get(elem);

					if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
						i = attrs.length;
						while (i--) {

							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if (attrs[i]) {
								name = attrs[i].name;
								if (name.indexOf("data-") === 0) {
									name = camelCase(name.slice(5));
									dataAttr(elem, name, data[name]);
								}
							}
						}
						dataPriv.set(elem, "hasDataAttrs", true);
					}
				}

				return data;
			}

			// Sets multiple values
			if ((typeof key === "undefined" ? "undefined" : _typeof(key)) === "object") {
				return this.each(function () {
					dataUser.set(this, key);
				});
			}

			return access(this, function (value) {
				var data;

				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if (elem && value === undefined) {

					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get(elem, key);
					if (data !== undefined) {
						return data;
					}

					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr(elem, key);
					if (data !== undefined) {
						return data;
					}

					// We tried really hard, but the data doesn't exist.
					return;
				}

				// Set the data...
				this.each(function () {

					// We always store the camelCased key
					dataUser.set(this, key, value);
				});
			}, null, value, arguments.length > 1, null, true);
		},

		removeData: function removeData(key) {
			return this.each(function () {
				dataUser.remove(this, key);
			});
		}
	});

	jQuery.extend({
		queue: function queue(elem, type, data) {
			var queue;

			if (elem) {
				type = (type || "fx") + "queue";
				queue = dataPriv.get(elem, type);

				// Speed up dequeue by getting out quickly if this is just a lookup
				if (data) {
					if (!queue || Array.isArray(data)) {
						queue = dataPriv.access(elem, type, jQuery.makeArray(data));
					} else {
						queue.push(data);
					}
				}
				return queue || [];
			}
		},

		dequeue: function dequeue(elem, type) {
			type = type || "fx";

			var queue = jQuery.queue(elem, type),
			    startLength = queue.length,
			    fn = queue.shift(),
			    hooks = jQuery._queueHooks(elem, type),
			    next = function next() {
				jQuery.dequeue(elem, type);
			};

			// If the fx queue is dequeued, always remove the progress sentinel
			if (fn === "inprogress") {
				fn = queue.shift();
				startLength--;
			}

			if (fn) {

				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if (type === "fx") {
					queue.unshift("inprogress");
				}

				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call(elem, next, hooks);
			}

			if (!startLength && hooks) {
				hooks.empty.fire();
			}
		},

		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function _queueHooks(elem, type) {
			var key = type + "queueHooks";
			return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
				empty: jQuery.Callbacks("once memory").add(function () {
					dataPriv.remove(elem, [type + "queue", key]);
				})
			});
		}
	});

	jQuery.fn.extend({
		queue: function queue(type, data) {
			var setter = 2;

			if (typeof type !== "string") {
				data = type;
				type = "fx";
				setter--;
			}

			if (arguments.length < setter) {
				return jQuery.queue(this[0], type);
			}

			return data === undefined ? this : this.each(function () {
				var queue = jQuery.queue(this, type, data);

				// Ensure a hooks for this queue
				jQuery._queueHooks(this, type);

				if (type === "fx" && queue[0] !== "inprogress") {
					jQuery.dequeue(this, type);
				}
			});
		},
		dequeue: function dequeue(type) {
			return this.each(function () {
				jQuery.dequeue(this, type);
			});
		},
		clearQueue: function clearQueue(type) {
			return this.queue(type || "fx", []);
		},

		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function promise(type, obj) {
			var tmp,
			    count = 1,
			    defer = jQuery.Deferred(),
			    elements = this,
			    i = this.length,
			    resolve = function resolve() {
				if (! --count) {
					defer.resolveWith(elements, [elements]);
				}
			};

			if (typeof type !== "string") {
				obj = type;
				type = undefined;
			}
			type = type || "fx";

			while (i--) {
				tmp = dataPriv.get(elements[i], type + "queueHooks");
				if (tmp && tmp.empty) {
					count++;
					tmp.empty.add(resolve);
				}
			}
			resolve();
			return defer.promise(obj);
		}
	});
	var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

	var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");

	var cssExpand = ["Top", "Right", "Bottom", "Left"];

	var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" || elem.style.display === "" &&

		// Otherwise, check computed style
		// Support: Firefox <=43 - 45
		// Disconnected elements can have computed display: none, so first confirm that elem is
		// in the document.
		jQuery.contains(elem.ownerDocument, elem) && jQuery.css(elem, "display") === "none";
	};

	var swap = function swap(elem, options, callback, args) {
		var ret,
		    name,
		    old = {};

		// Remember the old values, and insert the new ones
		for (name in options) {
			old[name] = elem.style[name];
			elem.style[name] = options[name];
		}

		ret = callback.apply(elem, args || []);

		// Revert the old values
		for (name in options) {
			elem.style[name] = old[name];
		}

		return ret;
	};

	function adjustCSS(elem, prop, valueParts, tween) {
		var adjusted,
		    scale,
		    maxIterations = 20,
		    currentValue = tween ? function () {
			return tween.cur();
		} : function () {
			return jQuery.css(elem, prop, "");
		},
		    initial = currentValue(),
		    unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),


		// Starting value computation is required for potential unit mismatches
		initialInUnit = (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));

		if (initialInUnit && initialInUnit[3] !== unit) {

			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;

			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[3];

			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;

			while (maxIterations--) {

				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style(elem, prop, initialInUnit + unit);
				if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
			}

			initialInUnit = initialInUnit * 2;
			jQuery.style(elem, prop, initialInUnit + unit);

			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}

		if (valueParts) {
			initialInUnit = +initialInUnit || +initial || 0;

			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
			if (tween) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}

	var defaultDisplayMap = {};

	function getDefaultDisplay(elem) {
		var temp,
		    doc = elem.ownerDocument,
		    nodeName = elem.nodeName,
		    display = defaultDisplayMap[nodeName];

		if (display) {
			return display;
		}

		temp = doc.body.appendChild(doc.createElement(nodeName));
		display = jQuery.css(temp, "display");

		temp.parentNode.removeChild(temp);

		if (display === "none") {
			display = "block";
		}
		defaultDisplayMap[nodeName] = display;

		return display;
	}

	function showHide(elements, show) {
		var display,
		    elem,
		    values = [],
		    index = 0,
		    length = elements.length;

		// Determine new display value for elements that need to change
		for (; index < length; index++) {
			elem = elements[index];
			if (!elem.style) {
				continue;
			}

			display = elem.style.display;
			if (show) {

				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if (display === "none") {
					values[index] = dataPriv.get(elem, "display") || null;
					if (!values[index]) {
						elem.style.display = "";
					}
				}
				if (elem.style.display === "" && isHiddenWithinTree(elem)) {
					values[index] = getDefaultDisplay(elem);
				}
			} else {
				if (display !== "none") {
					values[index] = "none";

					// Remember what we're overwriting
					dataPriv.set(elem, "display", display);
				}
			}
		}

		// Set the display of the elements in a second loop to avoid constant reflow
		for (index = 0; index < length; index++) {
			if (values[index] != null) {
				elements[index].style.display = values[index];
			}
		}

		return elements;
	}

	jQuery.fn.extend({
		show: function show() {
			return showHide(this, true);
		},
		hide: function hide() {
			return showHide(this);
		},
		toggle: function toggle(state) {
			if (typeof state === "boolean") {
				return state ? this.show() : this.hide();
			}

			return this.each(function () {
				if (isHiddenWithinTree(this)) {
					jQuery(this).show();
				} else {
					jQuery(this).hide();
				}
			});
		}
	});
	var rcheckableType = /^(?:checkbox|radio)$/i;

	var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i;

	var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {

		// Support: IE <=9 only
		option: [1, "<select multiple='multiple'>", "</select>"],

		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [1, "<table>", "</table>"],
		col: [2, "<table><colgroup>", "</colgroup></table>"],
		tr: [2, "<table><tbody>", "</tbody></table>"],
		td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

		_default: [0, "", ""]
	};

	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;

	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;

	function getAll(context, tag) {

		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;

		if (typeof context.getElementsByTagName !== "undefined") {
			ret = context.getElementsByTagName(tag || "*");
		} else if (typeof context.querySelectorAll !== "undefined") {
			ret = context.querySelectorAll(tag || "*");
		} else {
			ret = [];
		}

		if (tag === undefined || tag && nodeName(context, tag)) {
			return jQuery.merge([context], ret);
		}

		return ret;
	}

	// Mark scripts as having already been evaluated
	function setGlobalEval(elems, refElements) {
		var i = 0,
		    l = elems.length;

		for (; i < l; i++) {
			dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
		}
	}

	var rhtml = /<|&#?\w+;/;

	function buildFragment(elems, context, scripts, selection, ignored) {
		var elem,
		    tmp,
		    tag,
		    wrap,
		    contains,
		    j,
		    fragment = context.createDocumentFragment(),
		    nodes = [],
		    i = 0,
		    l = elems.length;

		for (; i < l; i++) {
			elem = elems[i];

			if (elem || elem === 0) {

				// Add nodes directly
				if (toType(elem) === "object") {

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

					// Convert non-html into a text node
				} else if (!rhtml.test(elem)) {
					nodes.push(context.createTextNode(elem));

					// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild(context.createElement("div"));

					// Deserialize a standard representation
					tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
					wrap = wrapMap[tag] || wrapMap._default;
					tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

					// Descend through wrappers to the right content
					j = wrap[0];
					while (j--) {
						tmp = tmp.lastChild;
					}

					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge(nodes, tmp.childNodes);

					// Remember the top-level container
					tmp = fragment.firstChild;

					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}

		// Remove wrapper from fragment
		fragment.textContent = "";

		i = 0;
		while (elem = nodes[i++]) {

			// Skip elements already in the context collection (trac-4087)
			if (selection && jQuery.inArray(elem, selection) > -1) {
				if (ignored) {
					ignored.push(elem);
				}
				continue;
			}

			contains = jQuery.contains(elem.ownerDocument, elem);

			// Append to fragment
			tmp = getAll(fragment.appendChild(elem), "script");

			// Preserve script evaluation history
			if (contains) {
				setGlobalEval(tmp);
			}

			// Capture executables
			if (scripts) {
				j = 0;
				while (elem = tmp[j++]) {
					if (rscriptType.test(elem.type || "")) {
						scripts.push(elem);
					}
				}
			}
		}

		return fragment;
	}

	(function () {
		var fragment = document.createDocumentFragment(),
		    div = fragment.appendChild(document.createElement("div")),
		    input = document.createElement("input");

		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute("type", "radio");
		input.setAttribute("checked", "checked");
		input.setAttribute("name", "t");

		div.appendChild(input);

		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
	})();
	var documentElement = document.documentElement;

	var rkeyEvent = /^key/,
	    rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	    rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

	function returnTrue() {
		return true;
	}

	function returnFalse() {
		return false;
	}

	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch (err) {}
	}

	function _on(elem, types, selector, data, fn, one) {
		var origFn, type;

		// Types can be a map of types/handlers
		if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {

			// ( types-Object, selector, data )
			if (typeof selector !== "string") {

				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for (type in types) {
				_on(elem, type, selector, data, types[type], one);
			}
			return elem;
		}

		if (data == null && fn == null) {

			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if (fn == null) {
			if (typeof selector === "string") {

				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {

				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if (fn === false) {
			fn = returnFalse;
		} else if (!fn) {
			return elem;
		}

		if (one === 1) {
			origFn = fn;
			fn = function fn(event) {

				// Can use an empty set, since event contains the info
				jQuery().off(event);
				return origFn.apply(this, arguments);
			};

			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
		}
		return elem.each(function () {
			jQuery.event.add(this, types, fn, data, selector);
		});
	}

	/*
  * Helper functions for managing events -- not part of the public interface.
  * Props to Dean Edwards' addEvent library for many of the ideas.
  */
	jQuery.event = {

		global: {},

		add: function add(elem, types, handler, data, selector) {

			var handleObjIn,
			    eventHandle,
			    tmp,
			    events,
			    t,
			    handleObj,
			    special,
			    handlers,
			    type,
			    namespaces,
			    origType,
			    elemData = dataPriv.get(elem);

			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if (!elemData) {
				return;
			}

			// Caller can pass in an object of custom data in lieu of the handler
			if (handler.handler) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}

			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if (selector) {
				jQuery.find.matchesSelector(documentElement, selector);
			}

			// Make sure that the handler has a unique ID, used to find/remove it later
			if (!handler.guid) {
				handler.guid = jQuery.guid++;
			}

			// Init the element's event structure and main handler, if this is the first
			if (!(events = elemData.events)) {
				events = elemData.events = {};
			}
			if (!(eventHandle = elemData.handle)) {
				eventHandle = elemData.handle = function (e) {

					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
				};
			}

			// Handle multiple events separated by a space
			types = (types || "").match(rnothtmlwhite) || [""];
			t = types.length;
			while (t--) {
				tmp = rtypenamespace.exec(types[t]) || [];
				type = origType = tmp[1];
				namespaces = (tmp[2] || "").split(".").sort();

				// There *must* be a type, no attaching namespace-only handlers
				if (!type) {
					continue;
				}

				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[type] || {};

				// If selector defined, determine special event api type, otherwise given type
				type = (selector ? special.delegateType : special.bindType) || type;

				// Update special based on newly reset type
				special = jQuery.event.special[type] || {};

				// handleObj is passed to all event handlers
				handleObj = jQuery.extend({
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test(selector),
					namespace: namespaces.join(".")
				}, handleObjIn);

				// Init the event handler queue if we're the first
				if (!(handlers = events[type])) {
					handlers = events[type] = [];
					handlers.delegateCount = 0;

					// Only use addEventListener if the special events handler returns false
					if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {

						if (elem.addEventListener) {
							elem.addEventListener(type, eventHandle);
						}
					}
				}

				if (special.add) {
					special.add.call(elem, handleObj);

					if (!handleObj.handler.guid) {
						handleObj.handler.guid = handler.guid;
					}
				}

				// Add to the element's handler list, delegates in front
				if (selector) {
					handlers.splice(handlers.delegateCount++, 0, handleObj);
				} else {
					handlers.push(handleObj);
				}

				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[type] = true;
			}
		},

		// Detach an event or set of events from an element
		remove: function remove(elem, types, handler, selector, mappedTypes) {

			var j,
			    origCount,
			    tmp,
			    events,
			    t,
			    handleObj,
			    special,
			    handlers,
			    type,
			    namespaces,
			    origType,
			    elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

			if (!elemData || !(events = elemData.events)) {
				return;
			}

			// Once for each type.namespace in types; type may be omitted
			types = (types || "").match(rnothtmlwhite) || [""];
			t = types.length;
			while (t--) {
				tmp = rtypenamespace.exec(types[t]) || [];
				type = origType = tmp[1];
				namespaces = (tmp[2] || "").split(".").sort();

				// Unbind all events (on this namespace, if provided) for the element
				if (!type) {
					for (type in events) {
						jQuery.event.remove(elem, type + types[t], handler, selector, true);
					}
					continue;
				}

				special = jQuery.event.special[type] || {};
				type = (selector ? special.delegateType : special.bindType) || type;
				handlers = events[type] || [];
				tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

				// Remove matching events
				origCount = j = handlers.length;
				while (j--) {
					handleObj = handlers[j];

					if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
						handlers.splice(j, 1);

						if (handleObj.selector) {
							handlers.delegateCount--;
						}
						if (special.remove) {
							special.remove.call(elem, handleObj);
						}
					}
				}

				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if (origCount && !handlers.length) {
					if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {

						jQuery.removeEvent(elem, type, elemData.handle);
					}

					delete events[type];
				}
			}

			// Remove data and the expando if it's no longer used
			if (jQuery.isEmptyObject(events)) {
				dataPriv.remove(elem, "handle events");
			}
		},

		dispatch: function dispatch(nativeEvent) {

			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix(nativeEvent);

			var i,
			    j,
			    ret,
			    matched,
			    handleObj,
			    handlerQueue,
			    args = new Array(arguments.length),
			    handlers = (dataPriv.get(this, "events") || {})[event.type] || [],
			    special = jQuery.event.special[event.type] || {};

			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[0] = event;

			for (i = 1; i < arguments.length; i++) {
				args[i] = arguments[i];
			}

			event.delegateTarget = this;

			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if (special.preDispatch && special.preDispatch.call(this, event) === false) {
				return;
			}

			// Determine handlers
			handlerQueue = jQuery.event.handlers.call(this, event, handlers);

			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
				event.currentTarget = matched.elem;

				j = 0;
				while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {

					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) {

						event.handleObj = handleObj;
						event.data = handleObj.data;

						ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);

						if (ret !== undefined) {
							if ((event.result = ret) === false) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}

			// Call the postDispatch hook for the mapped type
			if (special.postDispatch) {
				special.postDispatch.call(this, event);
			}

			return event.result;
		},

		handlers: function handlers(event, _handlers) {
			var i,
			    handleObj,
			    sel,
			    matchedHandlers,
			    matchedSelectors,
			    handlerQueue = [],
			    delegateCount = _handlers.delegateCount,
			    cur = event.target;

			// Find delegate handlers
			if (delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!(event.type === "click" && event.button >= 1)) {

				for (; cur !== this; cur = cur.parentNode || this) {

					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
						matchedHandlers = [];
						matchedSelectors = {};
						for (i = 0; i < delegateCount; i++) {
							handleObj = _handlers[i];

							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";

							if (matchedSelectors[sel] === undefined) {
								matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
							}
							if (matchedSelectors[sel]) {
								matchedHandlers.push(handleObj);
							}
						}
						if (matchedHandlers.length) {
							handlerQueue.push({ elem: cur, handlers: matchedHandlers });
						}
					}
				}
			}

			// Add the remaining (directly-bound) handlers
			cur = this;
			if (delegateCount < _handlers.length) {
				handlerQueue.push({ elem: cur, handlers: _handlers.slice(delegateCount) });
			}

			return handlerQueue;
		},

		addProp: function addProp(name, hook) {
			Object.defineProperty(jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,

				get: isFunction(hook) ? function () {
					if (this.originalEvent) {
						return hook(this.originalEvent);
					}
				} : function () {
					if (this.originalEvent) {
						return this.originalEvent[name];
					}
				},

				set: function set(value) {
					Object.defineProperty(this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					});
				}
			});
		},

		fix: function fix(originalEvent) {
			return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
		},

		special: {
			load: {

				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {

				// Fire native event if possible so blur/focus sequence is correct
				trigger: function trigger() {
					if (this !== safeActiveElement() && this.focus) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function trigger() {
					if (this === safeActiveElement() && this.blur) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {

				// For checkbox, fire native event so checked state will be right
				trigger: function trigger() {
					if (this.type === "checkbox" && this.click && nodeName(this, "input")) {
						this.click();
						return false;
					}
				},

				// For cross-browser consistency, don't fire native .click() on links
				_default: function _default(event) {
					return nodeName(event.target, "a");
				}
			},

			beforeunload: {
				postDispatch: function postDispatch(event) {

					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if (event.result !== undefined && event.originalEvent) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};

	jQuery.removeEvent = function (elem, type, handle) {

		// This "if" is needed for plain objects
		if (elem.removeEventListener) {
			elem.removeEventListener(type, handle);
		}
	};

	jQuery.Event = function (src, props) {

		// Allow instantiation without the 'new' keyword
		if (!(this instanceof jQuery.Event)) {
			return new jQuery.Event(src, props);
		}

		// Event object
		if (src && src.type) {
			this.originalEvent = src;
			this.type = src.type;

			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&

			// Support: Android <=2.3 only
			src.returnValue === false ? returnTrue : returnFalse;

			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;

			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;

			// Event type
		} else {
			this.type = src;
		}

		// Put explicitly provided properties onto the event object
		if (props) {
			jQuery.extend(this, props);
		}

		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();

		// Mark it as fixed
		this[jQuery.expando] = true;
	};

	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,

		preventDefault: function preventDefault() {
			var e = this.originalEvent;

			this.isDefaultPrevented = returnTrue;

			if (e && !this.isSimulated) {
				e.preventDefault();
			}
		},
		stopPropagation: function stopPropagation() {
			var e = this.originalEvent;

			this.isPropagationStopped = returnTrue;

			if (e && !this.isSimulated) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function stopImmediatePropagation() {
			var e = this.originalEvent;

			this.isImmediatePropagationStopped = returnTrue;

			if (e && !this.isSimulated) {
				e.stopImmediatePropagation();
			}

			this.stopPropagation();
		}
	};

	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each({
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,

		which: function which(event) {
			var button = event.button;

			// Add which for key events
			if (event.which == null && rkeyEvent.test(event.type)) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
				if (button & 1) {
					return 1;
				}

				if (button & 2) {
					return 3;
				}

				if (button & 4) {
					return 2;
				}

				return 0;
			}

			return event.which;
		}
	}, jQuery.event.addProp);

	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each({
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function (orig, fix) {
		jQuery.event.special[orig] = {
			delegateType: fix,
			bindType: fix,

			handle: function handle(event) {
				var ret,
				    target = this,
				    related = event.relatedTarget,
				    handleObj = event.handleObj;

				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if (!related || related !== target && !jQuery.contains(target, related)) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply(this, arguments);
					event.type = fix;
				}
				return ret;
			}
		};
	});

	jQuery.fn.extend({

		on: function on(types, selector, data, fn) {
			return _on(this, types, selector, data, fn);
		},
		one: function one(types, selector, data, fn) {
			return _on(this, types, selector, data, fn, 1);
		},
		off: function off(types, selector, fn) {
			var handleObj, type;
			if (types && types.preventDefault && types.handleObj) {

				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
				return this;
			}
			if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {

				// ( types-object [, selector] )
				for (type in types) {
					this.off(type, selector, types[type]);
				}
				return this;
			}
			if (selector === false || typeof selector === "function") {

				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if (fn === false) {
				fn = returnFalse;
			}
			return this.each(function () {
				jQuery.event.remove(this, types, fn, selector);
			});
		}
	});

	var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,


	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,


	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	    rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget(elem, content) {
		if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {

			return jQuery(elem).children("tbody")[0] || elem;
		}

		return elem;
	}

	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript(elem) {
		elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
		return elem;
	}
	function restoreScript(elem) {
		if ((elem.type || "").slice(0, 5) === "true/") {
			elem.type = elem.type.slice(5);
		} else {
			elem.removeAttribute("type");
		}

		return elem;
	}

	function cloneCopyEvent(src, dest) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

		if (dest.nodeType !== 1) {
			return;
		}

		// 1. Copy private data: events, handlers, etc.
		if (dataPriv.hasData(src)) {
			pdataOld = dataPriv.access(src);
			pdataCur = dataPriv.set(dest, pdataOld);
			events = pdataOld.events;

			if (events) {
				delete pdataCur.handle;
				pdataCur.events = {};

				for (type in events) {
					for (i = 0, l = events[type].length; i < l; i++) {
						jQuery.event.add(dest, type, events[type][i]);
					}
				}
			}
		}

		// 2. Copy user data
		if (dataUser.hasData(src)) {
			udataOld = dataUser.access(src);
			udataCur = jQuery.extend({}, udataOld);

			dataUser.set(dest, udataCur);
		}
	}

	// Fix IE bugs, see support tests
	function fixInput(src, dest) {
		var nodeName = dest.nodeName.toLowerCase();

		// Fails to persist the checked state of a cloned checkbox or radio button.
		if (nodeName === "input" && rcheckableType.test(src.type)) {
			dest.checked = src.checked;

			// Fails to return the selected option to the default selected state when cloning options
		} else if (nodeName === "input" || nodeName === "textarea") {
			dest.defaultValue = src.defaultValue;
		}
	}

	function domManip(collection, args, callback, ignored) {

		// Flatten any nested arrays
		args = concat.apply([], args);

		var fragment,
		    first,
		    scripts,
		    hasScripts,
		    node,
		    doc,
		    i = 0,
		    l = collection.length,
		    iNoClone = l - 1,
		    value = args[0],
		    valueIsFunction = isFunction(value);

		// We can't cloneNode fragments that contain checked, in WebKit
		if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
			return collection.each(function (index) {
				var self = collection.eq(index);
				if (valueIsFunction) {
					args[0] = value.call(this, index, self.html());
				}
				domManip(self, args, callback, ignored);
			});
		}

		if (l) {
			fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
			first = fragment.firstChild;

			if (fragment.childNodes.length === 1) {
				fragment = first;
			}

			// Require either new content or an interest in ignored elements to invoke the callback
			if (first || ignored) {
				scripts = jQuery.map(getAll(fragment, "script"), disableScript);
				hasScripts = scripts.length;

				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for (; i < l; i++) {
					node = fragment;

					if (i !== iNoClone) {
						node = jQuery.clone(node, true, true);

						// Keep references to cloned scripts for later restoration
						if (hasScripts) {

							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge(scripts, getAll(node, "script"));
						}
					}

					callback.call(collection[i], node, i);
				}

				if (hasScripts) {
					doc = scripts[scripts.length - 1].ownerDocument;

					// Reenable scripts
					jQuery.map(scripts, restoreScript);

					// Evaluate executable scripts on first document insertion
					for (i = 0; i < hasScripts; i++) {
						node = scripts[i];
						if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {

							if (node.src && (node.type || "").toLowerCase() !== "module") {

								// Optional AJAX dependency, but won't run scripts if not present
								if (jQuery._evalUrl) {
									jQuery._evalUrl(node.src);
								}
							} else {
								DOMEval(node.textContent.replace(rcleanScript, ""), doc, node);
							}
						}
					}
				}
			}
		}

		return collection;
	}

	function _remove(elem, selector, keepData) {
		var node,
		    nodes = selector ? jQuery.filter(selector, elem) : elem,
		    i = 0;

		for (; (node = nodes[i]) != null; i++) {
			if (!keepData && node.nodeType === 1) {
				jQuery.cleanData(getAll(node));
			}

			if (node.parentNode) {
				if (keepData && jQuery.contains(node.ownerDocument, node)) {
					setGlobalEval(getAll(node, "script"));
				}
				node.parentNode.removeChild(node);
			}
		}

		return elem;
	}

	jQuery.extend({
		htmlPrefilter: function htmlPrefilter(html) {
			return html.replace(rxhtmlTag, "<$1></$2>");
		},

		clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
			var i,
			    l,
			    srcElements,
			    destElements,
			    clone = elem.cloneNode(true),
			    inPage = jQuery.contains(elem.ownerDocument, elem);

			// Fix IE cloning issues
			if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {

				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll(clone);
				srcElements = getAll(elem);

				for (i = 0, l = srcElements.length; i < l; i++) {
					fixInput(srcElements[i], destElements[i]);
				}
			}

			// Copy the events from the original to the clone
			if (dataAndEvents) {
				if (deepDataAndEvents) {
					srcElements = srcElements || getAll(elem);
					destElements = destElements || getAll(clone);

					for (i = 0, l = srcElements.length; i < l; i++) {
						cloneCopyEvent(srcElements[i], destElements[i]);
					}
				} else {
					cloneCopyEvent(elem, clone);
				}
			}

			// Preserve script evaluation history
			destElements = getAll(clone, "script");
			if (destElements.length > 0) {
				setGlobalEval(destElements, !inPage && getAll(elem, "script"));
			}

			// Return the cloned set
			return clone;
		},

		cleanData: function cleanData(elems) {
			var data,
			    elem,
			    type,
			    special = jQuery.event.special,
			    i = 0;

			for (; (elem = elems[i]) !== undefined; i++) {
				if (acceptData(elem)) {
					if (data = elem[dataPriv.expando]) {
						if (data.events) {
							for (type in data.events) {
								if (special[type]) {
									jQuery.event.remove(elem, type);

									// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent(elem, type, data.handle);
								}
							}
						}

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[dataPriv.expando] = undefined;
					}
					if (elem[dataUser.expando]) {

						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[dataUser.expando] = undefined;
					}
				}
			}
		}
	});

	jQuery.fn.extend({
		detach: function detach(selector) {
			return _remove(this, selector, true);
		},

		remove: function remove(selector) {
			return _remove(this, selector);
		},

		text: function text(value) {
			return access(this, function (value) {
				return value === undefined ? jQuery.text(this) : this.empty().each(function () {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						this.textContent = value;
					}
				});
			}, null, value, arguments.length);
		},

		append: function append() {
			return domManip(this, arguments, function (elem) {
				if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
					var target = manipulationTarget(this, elem);
					target.appendChild(elem);
				}
			});
		},

		prepend: function prepend() {
			return domManip(this, arguments, function (elem) {
				if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
					var target = manipulationTarget(this, elem);
					target.insertBefore(elem, target.firstChild);
				}
			});
		},

		before: function before() {
			return domManip(this, arguments, function (elem) {
				if (this.parentNode) {
					this.parentNode.insertBefore(elem, this);
				}
			});
		},

		after: function after() {
			return domManip(this, arguments, function (elem) {
				if (this.parentNode) {
					this.parentNode.insertBefore(elem, this.nextSibling);
				}
			});
		},

		empty: function empty() {
			var elem,
			    i = 0;

			for (; (elem = this[i]) != null; i++) {
				if (elem.nodeType === 1) {

					// Prevent memory leaks
					jQuery.cleanData(getAll(elem, false));

					// Remove any remaining nodes
					elem.textContent = "";
				}
			}

			return this;
		},

		clone: function clone(dataAndEvents, deepDataAndEvents) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

			return this.map(function () {
				return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
			});
		},

		html: function html(value) {
			return access(this, function (value) {
				var elem = this[0] || {},
				    i = 0,
				    l = this.length;

				if (value === undefined && elem.nodeType === 1) {
					return elem.innerHTML;
				}

				// See if we can take a shortcut and just use innerHTML
				if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {

					value = jQuery.htmlPrefilter(value);

					try {
						for (; i < l; i++) {
							elem = this[i] || {};

							// Remove element nodes and prevent memory leaks
							if (elem.nodeType === 1) {
								jQuery.cleanData(getAll(elem, false));
								elem.innerHTML = value;
							}
						}

						elem = 0;

						// If using innerHTML throws an exception, use the fallback method
					} catch (e) {}
				}

				if (elem) {
					this.empty().append(value);
				}
			}, null, value, arguments.length);
		},

		replaceWith: function replaceWith() {
			var ignored = [];

			// Make the changes, replacing each non-ignored context element with the new content
			return domManip(this, arguments, function (elem) {
				var parent = this.parentNode;

				if (jQuery.inArray(this, ignored) < 0) {
					jQuery.cleanData(getAll(this));
					if (parent) {
						parent.replaceChild(elem, this);
					}
				}

				// Force callback invocation
			}, ignored);
		}
	});

	jQuery.each({
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function (name, original) {
		jQuery.fn[name] = function (selector) {
			var elems,
			    ret = [],
			    insert = jQuery(selector),
			    last = insert.length - 1,
			    i = 0;

			for (; i <= last; i++) {
				elems = i === last ? this : this.clone(true);
				jQuery(insert[i])[original](elems);

				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply(ret, elems.get());
			}

			return this.pushStack(ret);
		};
	});
	var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

	var getStyles = function getStyles(elem) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if (!view || !view.opener) {
			view = window;
		}

		return view.getComputedStyle(elem);
	};

	var rboxStyle = new RegExp(cssExpand.join("|"), "i");

	(function () {

		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {

			// This is a singleton, we need to execute it only once
			if (!div) {
				return;
			}

			container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
			div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
			documentElement.appendChild(container).appendChild(div);

			var divStyle = window.getComputedStyle(div);
			pixelPositionVal = divStyle.top !== "1%";

			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			div.style.position = "absolute";
			scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

			documentElement.removeChild(container);

			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}

		function roundPixelMeasures(measure) {
			return Math.round(parseFloat(measure));
		}

		var pixelPositionVal,
		    boxSizingReliableVal,
		    scrollboxSizeVal,
		    pixelBoxStylesVal,
		    reliableMarginLeftVal,
		    container = document.createElement("div"),
		    div = document.createElement("div");

		// Finish early in limited (non-browser) environments
		if (!div.style) {
			return;
		}

		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode(true).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";

		jQuery.extend(support, {
			boxSizingReliable: function boxSizingReliable() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function pixelBoxStyles() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function pixelPosition() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function reliableMarginLeft() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function scrollboxSize() {
				computeStyleTests();
				return scrollboxSizeVal;
			}
		});
	})();

	function curCSS(elem, name, computed) {
		var width,
		    minWidth,
		    maxWidth,
		    ret,


		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

		computed = computed || getStyles(elem);

		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if (computed) {
			ret = computed.getPropertyValue(name) || computed[name];

			if (ret === "" && !jQuery.contains(elem.ownerDocument, elem)) {
				ret = jQuery.style(elem, name);
			}

			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {

				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;

				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;

				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}

		return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" : ret;
	}

	function addGetHookIf(conditionFn, hookFn) {

		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function get() {
				if (conditionFn()) {

					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}

				// Hook needed; redefine it so that the support test is not executed again.
				return (this.get = hookFn).apply(this, arguments);
			}
		};
	}

	var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	    rcustomProp = /^--/,
	    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	    cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},
	    cssPrefixes = ["Webkit", "Moz", "ms"],
	    emptyStyle = document.createElement("div").style;

	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName(name) {

		// Shortcut for names that are not vendor prefixed
		if (name in emptyStyle) {
			return name;
		}

		// Check for vendor prefixed names
		var capName = name[0].toUpperCase() + name.slice(1),
		    i = cssPrefixes.length;

		while (i--) {
			name = cssPrefixes[i] + capName;
			if (name in emptyStyle) {
				return name;
			}
		}
	}

	// Return a property mapped along what jQuery.cssProps suggests or to
	// a vendor prefixed property.
	function finalPropName(name) {
		var ret = jQuery.cssProps[name];
		if (!ret) {
			ret = jQuery.cssProps[name] = vendorPropName(name) || name;
		}
		return ret;
	}

	function setPositiveNumber(elem, value, subtract) {

		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec(value);
		return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
	}

	function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
		var i = dimension === "width" ? 1 : 0,
		    extra = 0,
		    delta = 0;

		// Adjustment may not be necessary
		if (box === (isBorderBox ? "border" : "content")) {
			return 0;
		}

		for (; i < 4; i += 2) {

			// Both box models exclude margin
			if (box === "margin") {
				delta += jQuery.css(elem, box + cssExpand[i], true, styles);
			}

			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if (!isBorderBox) {

				// Add padding
				delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

				// For "border" or "margin", add border
				if (box !== "padding") {
					delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

					// But still keep track of it otherwise
				} else {
					extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
				}

				// If we get here with a border-box (content + padding + border), we're seeking "content" or
				// "padding" or "margin"
			} else {

				// For "content", subtract padding
				if (box === "content") {
					delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
				}

				// For "content" or "padding", subtract border
				if (box !== "margin") {
					delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
				}
			}
		}

		// Account for positive content-box scroll gutter when requested by providing computedVal
		if (!isBorderBox && computedVal >= 0) {

			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5));
		}

		return delta;
	}

	function getWidthOrHeight(elem, dimension, extra) {

		// Start with computed style
		var styles = getStyles(elem),
		    val = curCSS(elem, dimension, styles),
		    isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box",
		    valueIsBorderBox = isBorderBox;

		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if (rnumnonpx.test(val)) {
			if (!extra) {
				return val;
			}
			val = "auto";
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = valueIsBorderBox && (support.boxSizingReliable() || val === elem.style[dimension]);

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		if (val === "auto" || !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") {

			val = elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)];

			// offsetWidth/offsetHeight provide border-box values
			valueIsBorderBox = true;
		}

		// Normalize "" and auto
		val = parseFloat(val) || 0;

		// Adjust for the element's box model
		return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles,

		// Provide the current computed size to request scroll gutter calculation (gh-3589)
		val) + "px";
	}

	jQuery.extend({

		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function get(elem, computed) {
					if (computed) {

						// We should always get a number back from opacity
						var ret = curCSS(elem, "opacity");
						return ret === "" ? "1" : ret;
					}
				}
			}
		},

		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},

		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},

		// Get and set the style property on a DOM Node
		style: function style(elem, name, value, extra) {

			// Don't set styles on text and comment nodes
			if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
				return;
			}

			// Make sure that we're working with the right name
			var ret,
			    type,
			    hooks,
			    origName = camelCase(name),
			    isCustomProp = rcustomProp.test(name),
			    style = elem.style;

			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if (!isCustomProp) {
				name = finalPropName(origName);
			}

			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

			// Check if we're setting a value
			if (value !== undefined) {
				type = typeof value === "undefined" ? "undefined" : _typeof(value);

				// Convert "+=" or "-=" to relative numbers (#7345)
				if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
					value = adjustCSS(elem, name, ret);

					// Fixes bug #9237
					type = "number";
				}

				// Make sure that null and NaN values aren't set (#7116)
				if (value == null || value !== value) {
					return;
				}

				// If a number was passed in, add the unit (except for certain CSS properties)
				if (type === "number") {
					value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
				}

				// background-* props affect original clone's values
				if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
					style[name] = "inherit";
				}

				// If a hook was provided, use that value, otherwise just set the specified value
				if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {

					if (isCustomProp) {
						style.setProperty(name, value);
					} else {
						style[name] = value;
					}
				}
			} else {

				// If a hook was provided get the non-computed value from there
				if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {

					return ret;
				}

				// Otherwise just get the value from the style object
				return style[name];
			}
		},

		css: function css(elem, name, extra, styles) {
			var val,
			    num,
			    hooks,
			    origName = camelCase(name),
			    isCustomProp = rcustomProp.test(name);

			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if (!isCustomProp) {
				name = finalPropName(origName);
			}

			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

			// If a hook was provided get the computed value from there
			if (hooks && "get" in hooks) {
				val = hooks.get(elem, true, extra);
			}

			// Otherwise, if a way to get the computed value exists, use that
			if (val === undefined) {
				val = curCSS(elem, name, styles);
			}

			// Convert "normal" to computed value
			if (val === "normal" && name in cssNormalTransform) {
				val = cssNormalTransform[name];
			}

			// Make numeric if forced or a qualifier was provided and val looks numeric
			if (extra === "" || extra) {
				num = parseFloat(val);
				return extra === true || isFinite(num) ? num || 0 : val;
			}

			return val;
		}
	});

	jQuery.each(["height", "width"], function (i, dimension) {
		jQuery.cssHooks[dimension] = {
			get: function get(elem, computed, extra) {
				if (computed) {

					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test(jQuery.css(elem, "display")) && (

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
						return getWidthOrHeight(elem, dimension, extra);
					}) : getWidthOrHeight(elem, dimension, extra);
				}
			},

			set: function set(elem, value, extra) {
				var matches,
				    styles = getStyles(elem),
				    isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box",
				    subtract = extra && boxModelAdjustment(elem, dimension, extra, isBorderBox, styles);

				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if (isBorderBox && support.scrollboxSize() === styles.position) {
					subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
				}

				// Convert to pixels if value adjustment is needed
				if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {

					elem.style[dimension] = value;
					value = jQuery.css(elem, dimension);
				}

				return setPositiveNumber(elem, value, subtract);
			}
		};
	});

	jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
		if (computed) {
			return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function () {
				return elem.getBoundingClientRect().left;
			})) + "px";
		}
	});

	// These hooks are used by animate to expand properties
	jQuery.each({
		margin: "",
		padding: "",
		border: "Width"
	}, function (prefix, suffix) {
		jQuery.cssHooks[prefix + suffix] = {
			expand: function expand(value) {
				var i = 0,
				    expanded = {},


				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split(" ") : [value];

				for (; i < 4; i++) {
					expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
				}

				return expanded;
			}
		};

		if (prefix !== "margin") {
			jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
		}
	});

	jQuery.fn.extend({
		css: function css(name, value) {
			return access(this, function (elem, name, value) {
				var styles,
				    len,
				    map = {},
				    i = 0;

				if (Array.isArray(name)) {
					styles = getStyles(elem);
					len = name.length;

					for (; i < len; i++) {
						map[name[i]] = jQuery.css(elem, name[i], false, styles);
					}

					return map;
				}

				return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
			}, name, value, arguments.length > 1);
		}
	});

	function Tween(elem, options, prop, end, easing) {
		return new Tween.prototype.init(elem, options, prop, end, easing);
	}
	jQuery.Tween = Tween;

	Tween.prototype = {
		constructor: Tween,
		init: function init(elem, options, prop, end, easing, unit) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
		},
		cur: function cur() {
			var hooks = Tween.propHooks[this.prop];

			return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
		},
		run: function run(percent) {
			var eased,
			    hooks = Tween.propHooks[this.prop];

			if (this.options.duration) {
				this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
			} else {
				this.pos = eased = percent;
			}
			this.now = (this.end - this.start) * eased + this.start;

			if (this.options.step) {
				this.options.step.call(this.elem, this.now, this);
			}

			if (hooks && hooks.set) {
				hooks.set(this);
			} else {
				Tween.propHooks._default.set(this);
			}
			return this;
		}
	};

	Tween.prototype.init.prototype = Tween.prototype;

	Tween.propHooks = {
		_default: {
			get: function get(tween) {
				var result;

				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
					return tween.elem[tween.prop];
				}

				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css(tween.elem, tween.prop, "");

				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function set(tween) {

				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if (jQuery.fx.step[tween.prop]) {
					jQuery.fx.step[tween.prop](tween);
				} else if (tween.elem.nodeType === 1 && (tween.elem.style[jQuery.cssProps[tween.prop]] != null || jQuery.cssHooks[tween.prop])) {
					jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
				} else {
					tween.elem[tween.prop] = tween.now;
				}
			}
		}
	};

	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function set(tween) {
			if (tween.elem.nodeType && tween.elem.parentNode) {
				tween.elem[tween.prop] = tween.now;
			}
		}
	};

	jQuery.easing = {
		linear: function linear(p) {
			return p;
		},
		swing: function swing(p) {
			return 0.5 - Math.cos(p * Math.PI) / 2;
		},
		_default: "swing"
	};

	jQuery.fx = Tween.prototype.init;

	// Back compat <1.8 extension point
	jQuery.fx.step = {};

	var fxNow,
	    inProgress,
	    rfxtypes = /^(?:toggle|show|hide)$/,
	    rrun = /queueHooks$/;

	function schedule() {
		if (inProgress) {
			if (document.hidden === false && window.requestAnimationFrame) {
				window.requestAnimationFrame(schedule);
			} else {
				window.setTimeout(schedule, jQuery.fx.interval);
			}

			jQuery.fx.tick();
		}
	}

	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout(function () {
			fxNow = undefined;
		});
		return fxNow = Date.now();
	}

	// Generate parameters to create a standard animation
	function genFx(type, includeWidth) {
		var which,
		    i = 0,
		    attrs = { height: type };

		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for (; i < 4; i += 2 - includeWidth) {
			which = cssExpand[i];
			attrs["margin" + which] = attrs["padding" + which] = type;
		}

		if (includeWidth) {
			attrs.opacity = attrs.width = type;
		}

		return attrs;
	}

	function createTween(value, prop, animation) {
		var tween,
		    collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
		    index = 0,
		    length = collection.length;
		for (; index < length; index++) {
			if (tween = collection[index].call(animation, prop, value)) {

				// We're done with this property
				return tween;
			}
		}
	}

	function defaultPrefilter(elem, props, opts) {
		var prop,
		    value,
		    toggle,
		    hooks,
		    oldfire,
		    propTween,
		    restoreDisplay,
		    display,
		    isBox = "width" in props || "height" in props,
		    anim = this,
		    orig = {},
		    style = elem.style,
		    hidden = elem.nodeType && isHiddenWithinTree(elem),
		    dataShow = dataPriv.get(elem, "fxshow");

		// Queue-skipping animations hijack the fx hooks
		if (!opts.queue) {
			hooks = jQuery._queueHooks(elem, "fx");
			if (hooks.unqueued == null) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function () {
					if (!hooks.unqueued) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;

			anim.always(function () {

				// Ensure the complete handler is called before this completes
				anim.always(function () {
					hooks.unqueued--;
					if (!jQuery.queue(elem, "fx").length) {
						hooks.empty.fire();
					}
				});
			});
		}

		// Detect show/hide animations
		for (prop in props) {
			value = props[prop];
			if (rfxtypes.test(value)) {
				delete props[prop];
				toggle = toggle || value === "toggle";
				if (value === (hidden ? "hide" : "show")) {

					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if (value === "show" && dataShow && dataShow[prop] !== undefined) {
						hidden = true;

						// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
			}
		}

		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject(props);
		if (!propTween && jQuery.isEmptyObject(orig)) {
			return;
		}

		// Restrict "overflow" and "display" styles during box animations
		if (isBox && elem.nodeType === 1) {

			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [style.overflow, style.overflowX, style.overflowY];

			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if (restoreDisplay == null) {
				restoreDisplay = dataPriv.get(elem, "display");
			}
			display = jQuery.css(elem, "display");
			if (display === "none") {
				if (restoreDisplay) {
					display = restoreDisplay;
				} else {

					// Get nonempty value(s) by temporarily forcing visibility
					showHide([elem], true);
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css(elem, "display");
					showHide([elem]);
				}
			}

			// Animate inline elements as inline-block
			if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
				if (jQuery.css(elem, "float") === "none") {

					// Restore the original display value at the end of pure show/hide animations
					if (!propTween) {
						anim.done(function () {
							style.display = restoreDisplay;
						});
						if (restoreDisplay == null) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}

		if (opts.overflow) {
			style.overflow = "hidden";
			anim.always(function () {
				style.overflow = opts.overflow[0];
				style.overflowX = opts.overflow[1];
				style.overflowY = opts.overflow[2];
			});
		}

		// Implement show/hide animations
		propTween = false;
		for (prop in orig) {

			// General show/hide setup for this element animation
			if (!propTween) {
				if (dataShow) {
					if ("hidden" in dataShow) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
				}

				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if (toggle) {
					dataShow.hidden = !hidden;
				}

				// Show elements before animating them
				if (hidden) {
					showHide([elem], true);
				}

				/* eslint-disable no-loop-func */

				anim.done(function () {

					/* eslint-enable no-loop-func */

					// The final step of a "hide" animation is actually hiding the element
					if (!hidden) {
						showHide([elem]);
					}
					dataPriv.remove(elem, "fxshow");
					for (prop in orig) {
						jQuery.style(elem, prop, orig[prop]);
					}
				});
			}

			// Per-property setup
			propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
			if (!(prop in dataShow)) {
				dataShow[prop] = propTween.start;
				if (hidden) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}

	function propFilter(props, specialEasing) {
		var index, name, easing, value, hooks;

		// camelCase, specialEasing and expand cssHook pass
		for (index in props) {
			name = camelCase(index);
			easing = specialEasing[name];
			value = props[index];
			if (Array.isArray(value)) {
				easing = value[1];
				value = props[index] = value[0];
			}

			if (index !== name) {
				props[name] = value;
				delete props[index];
			}

			hooks = jQuery.cssHooks[name];
			if (hooks && "expand" in hooks) {
				value = hooks.expand(value);
				delete props[name];

				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for (index in value) {
					if (!(index in props)) {
						props[index] = value[index];
						specialEasing[index] = easing;
					}
				}
			} else {
				specialEasing[name] = easing;
			}
		}
	}

	function Animation(elem, properties, options) {
		var result,
		    stopped,
		    index = 0,
		    length = Animation.prefilters.length,
		    deferred = jQuery.Deferred().always(function () {

			// Don't match elem in the :animated selector
			delete tick.elem;
		}),
		    tick = function tick() {
			if (stopped) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
			    remaining = Math.max(0, animation.startTime + animation.duration - currentTime),


			// Support: Android 2.3 only
			// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
			temp = remaining / animation.duration || 0,
			    percent = 1 - temp,
			    index = 0,
			    length = animation.tweens.length;

			for (; index < length; index++) {
				animation.tweens[index].run(percent);
			}

			deferred.notifyWith(elem, [animation, percent, remaining]);

			// If there's more to do, yield
			if (percent < 1 && length) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if (!length) {
				deferred.notifyWith(elem, [animation, 1, 0]);
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith(elem, [animation]);
			return false;
		},
		    animation = deferred.promise({
			elem: elem,
			props: jQuery.extend({}, properties),
			opts: jQuery.extend(true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function createTween(prop, end) {
				var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
				animation.tweens.push(tween);
				return tween;
			},
			stop: function stop(gotoEnd) {
				var index = 0,


				// If we are going to the end, we want to run all the tweens
				// otherwise we skip this part
				length = gotoEnd ? animation.tweens.length : 0;
				if (stopped) {
					return this;
				}
				stopped = true;
				for (; index < length; index++) {
					animation.tweens[index].run(1);
				}

				// Resolve when we played the last frame; otherwise, reject
				if (gotoEnd) {
					deferred.notifyWith(elem, [animation, 1, 0]);
					deferred.resolveWith(elem, [animation, gotoEnd]);
				} else {
					deferred.rejectWith(elem, [animation, gotoEnd]);
				}
				return this;
			}
		}),
		    props = animation.props;

		propFilter(props, animation.opts.specialEasing);

		for (; index < length; index++) {
			result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
			if (result) {
				if (isFunction(result.stop)) {
					jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
				}
				return result;
			}
		}

		jQuery.map(props, createTween, animation);

		if (isFunction(animation.opts.start)) {
			animation.opts.start.call(elem, animation);
		}

		// Attach callbacks from options
		animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);

		jQuery.fx.timer(jQuery.extend(tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		}));

		return animation;
	}

	jQuery.Animation = jQuery.extend(Animation, {

		tweeners: {
			"*": [function (prop, value) {
				var tween = this.createTween(prop, value);
				adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
				return tween;
			}]
		},

		tweener: function tweener(props, callback) {
			if (isFunction(props)) {
				callback = props;
				props = ["*"];
			} else {
				props = props.match(rnothtmlwhite);
			}

			var prop,
			    index = 0,
			    length = props.length;

			for (; index < length; index++) {
				prop = props[index];
				Animation.tweeners[prop] = Animation.tweeners[prop] || [];
				Animation.tweeners[prop].unshift(callback);
			}
		},

		prefilters: [defaultPrefilter],

		prefilter: function prefilter(callback, prepend) {
			if (prepend) {
				Animation.prefilters.unshift(callback);
			} else {
				Animation.prefilters.push(callback);
			}
		}
	});

	jQuery.speed = function (speed, easing, fn) {
		var opt = speed && (typeof speed === "undefined" ? "undefined" : _typeof(speed)) === "object" ? jQuery.extend({}, speed) : {
			complete: fn || !fn && easing || isFunction(speed) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction(easing) && easing
		};

		// Go to the end state if fx are off
		if (jQuery.fx.off) {
			opt.duration = 0;
		} else {
			if (typeof opt.duration !== "number") {
				if (opt.duration in jQuery.fx.speeds) {
					opt.duration = jQuery.fx.speeds[opt.duration];
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}

		// Normalize opt.queue - true/undefined/null -> "fx"
		if (opt.queue == null || opt.queue === true) {
			opt.queue = "fx";
		}

		// Queueing
		opt.old = opt.complete;

		opt.complete = function () {
			if (isFunction(opt.old)) {
				opt.old.call(this);
			}

			if (opt.queue) {
				jQuery.dequeue(this, opt.queue);
			}
		};

		return opt;
	};

	jQuery.fn.extend({
		fadeTo: function fadeTo(speed, to, easing, callback) {

			// Show any hidden elements after setting opacity to 0
			return this.filter(isHiddenWithinTree).css("opacity", 0).show()

			// Animate to the value specified
			.end().animate({ opacity: to }, speed, easing, callback);
		},
		animate: function animate(prop, speed, easing, callback) {
			var empty = jQuery.isEmptyObject(prop),
			    optall = jQuery.speed(speed, easing, callback),
			    doAnimation = function doAnimation() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation(this, jQuery.extend({}, prop), optall);

				// Empty animations, or finishing resolves immediately
				if (empty || dataPriv.get(this, "finish")) {
					anim.stop(true);
				}
			};
			doAnimation.finish = doAnimation;

			return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
		},
		stop: function stop(type, clearQueue, gotoEnd) {
			var stopQueue = function stopQueue(hooks) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop(gotoEnd);
			};

			if (typeof type !== "string") {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if (clearQueue && type !== false) {
				this.queue(type || "fx", []);
			}

			return this.each(function () {
				var dequeue = true,
				    index = type != null && type + "queueHooks",
				    timers = jQuery.timers,
				    data = dataPriv.get(this);

				if (index) {
					if (data[index] && data[index].stop) {
						stopQueue(data[index]);
					}
				} else {
					for (index in data) {
						if (data[index] && data[index].stop && rrun.test(index)) {
							stopQueue(data[index]);
						}
					}
				}

				for (index = timers.length; index--;) {
					if (timers[index].elem === this && (type == null || timers[index].queue === type)) {

						timers[index].anim.stop(gotoEnd);
						dequeue = false;
						timers.splice(index, 1);
					}
				}

				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if (dequeue || !gotoEnd) {
					jQuery.dequeue(this, type);
				}
			});
		},
		finish: function finish(type) {
			if (type !== false) {
				type = type || "fx";
			}
			return this.each(function () {
				var index,
				    data = dataPriv.get(this),
				    queue = data[type + "queue"],
				    hooks = data[type + "queueHooks"],
				    timers = jQuery.timers,
				    length = queue ? queue.length : 0;

				// Enable finishing flag on private data
				data.finish = true;

				// Empty the queue first
				jQuery.queue(this, type, []);

				if (hooks && hooks.stop) {
					hooks.stop.call(this, true);
				}

				// Look for any active animations, and finish them
				for (index = timers.length; index--;) {
					if (timers[index].elem === this && timers[index].queue === type) {
						timers[index].anim.stop(true);
						timers.splice(index, 1);
					}
				}

				// Look for any animations in the old queue and finish them
				for (index = 0; index < length; index++) {
					if (queue[index] && queue[index].finish) {
						queue[index].finish.call(this);
					}
				}

				// Turn off finishing flag
				delete data.finish;
			});
		}
	});

	jQuery.each(["toggle", "show", "hide"], function (i, name) {
		var cssFn = jQuery.fn[name];
		jQuery.fn[name] = function (speed, easing, callback) {
			return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
		};
	});

	// Generate shortcuts for custom animations
	jQuery.each({
		slideDown: genFx("show"),
		slideUp: genFx("hide"),
		slideToggle: genFx("toggle"),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function (name, props) {
		jQuery.fn[name] = function (speed, easing, callback) {
			return this.animate(props, speed, easing, callback);
		};
	});

	jQuery.timers = [];
	jQuery.fx.tick = function () {
		var timer,
		    i = 0,
		    timers = jQuery.timers;

		fxNow = Date.now();

		for (; i < timers.length; i++) {
			timer = timers[i];

			// Run the timer and safely remove it when done (allowing for external removal)
			if (!timer() && timers[i] === timer) {
				timers.splice(i--, 1);
			}
		}

		if (!timers.length) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};

	jQuery.fx.timer = function (timer) {
		jQuery.timers.push(timer);
		jQuery.fx.start();
	};

	jQuery.fx.interval = 13;
	jQuery.fx.start = function () {
		if (inProgress) {
			return;
		}

		inProgress = true;
		schedule();
	};

	jQuery.fx.stop = function () {
		inProgress = null;
	};

	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,

		// Default speed
		_default: 400
	};

	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function (time, type) {
		time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
		type = type || "fx";

		return this.queue(type, function (next, hooks) {
			var timeout = window.setTimeout(next, time);
			hooks.stop = function () {
				window.clearTimeout(timeout);
			};
		});
	};

	(function () {
		var input = document.createElement("input"),
		    select = document.createElement("select"),
		    opt = select.appendChild(document.createElement("option"));

		input.type = "checkbox";

		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";

		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;

		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement("input");
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	})();

	var boolHook,
	    attrHandle = jQuery.expr.attrHandle;

	jQuery.fn.extend({
		attr: function attr(name, value) {
			return access(this, jQuery.attr, name, value, arguments.length > 1);
		},

		removeAttr: function removeAttr(name) {
			return this.each(function () {
				jQuery.removeAttr(this, name);
			});
		}
	});

	jQuery.extend({
		attr: function attr(elem, name, value) {
			var ret,
			    hooks,
			    nType = elem.nodeType;

			// Don't get/set attributes on text, comment and attribute nodes
			if (nType === 3 || nType === 8 || nType === 2) {
				return;
			}

			// Fallback to prop when attributes are not supported
			if (typeof elem.getAttribute === "undefined") {
				return jQuery.prop(elem, name, value);
			}

			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
				hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
			}

			if (value !== undefined) {
				if (value === null) {
					jQuery.removeAttr(elem, name);
					return;
				}

				if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
					return ret;
				}

				elem.setAttribute(name, value + "");
				return value;
			}

			if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
				return ret;
			}

			ret = jQuery.find.attr(elem, name);

			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},

		attrHooks: {
			type: {
				set: function set(elem, value) {
					if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
						var val = elem.value;
						elem.setAttribute("type", value);
						if (val) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},

		removeAttr: function removeAttr(elem, value) {
			var name,
			    i = 0,


			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match(rnothtmlwhite);

			if (attrNames && elem.nodeType === 1) {
				while (name = attrNames[i++]) {
					elem.removeAttribute(name);
				}
			}
		}
	});

	// Hooks for boolean attributes
	boolHook = {
		set: function set(elem, value, name) {
			if (value === false) {

				// Remove boolean attributes when set to false
				jQuery.removeAttr(elem, name);
			} else {
				elem.setAttribute(name, name);
			}
			return name;
		}
	};

	jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (i, name) {
		var getter = attrHandle[name] || jQuery.find.attr;

		attrHandle[name] = function (elem, name, isXML) {
			var ret,
			    handle,
			    lowercaseName = name.toLowerCase();

			if (!isXML) {

				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[lowercaseName];
				attrHandle[lowercaseName] = ret;
				ret = getter(elem, name, isXML) != null ? lowercaseName : null;
				attrHandle[lowercaseName] = handle;
			}
			return ret;
		};
	});

	var rfocusable = /^(?:input|select|textarea|button)$/i,
	    rclickable = /^(?:a|area)$/i;

	jQuery.fn.extend({
		prop: function prop(name, value) {
			return access(this, jQuery.prop, name, value, arguments.length > 1);
		},

		removeProp: function removeProp(name) {
			return this.each(function () {
				delete this[jQuery.propFix[name] || name];
			});
		}
	});

	jQuery.extend({
		prop: function prop(elem, name, value) {
			var ret,
			    hooks,
			    nType = elem.nodeType;

			// Don't get/set properties on text, comment and attribute nodes
			if (nType === 3 || nType === 8 || nType === 2) {
				return;
			}

			if (nType !== 1 || !jQuery.isXMLDoc(elem)) {

				// Fix name and attach hooks
				name = jQuery.propFix[name] || name;
				hooks = jQuery.propHooks[name];
			}

			if (value !== undefined) {
				if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
					return ret;
				}

				return elem[name] = value;
			}

			if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
				return ret;
			}

			return elem[name];
		},

		propHooks: {
			tabIndex: {
				get: function get(elem) {

					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr(elem, "tabindex");

					if (tabindex) {
						return parseInt(tabindex, 10);
					}

					if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
						return 0;
					}

					return -1;
				}
			}
		},

		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	});

	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if (!support.optSelected) {
		jQuery.propHooks.selected = {
			get: function get(elem) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if (parent && parent.parentNode) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function set(elem) {

				/* eslint no-unused-expressions: "off" */

				var parent = elem.parentNode;
				if (parent) {
					parent.selectedIndex;

					if (parent.parentNode) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}

	jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
		jQuery.propFix[this.toLowerCase()] = this;
	});

	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse(value) {
		var tokens = value.match(rnothtmlwhite) || [];
		return tokens.join(" ");
	}

	function getClass(elem) {
		return elem.getAttribute && elem.getAttribute("class") || "";
	}

	function classesToArray(value) {
		if (Array.isArray(value)) {
			return value;
		}
		if (typeof value === "string") {
			return value.match(rnothtmlwhite) || [];
		}
		return [];
	}

	jQuery.fn.extend({
		addClass: function addClass(value) {
			var classes,
			    elem,
			    cur,
			    curValue,
			    clazz,
			    j,
			    finalValue,
			    i = 0;

			if (isFunction(value)) {
				return this.each(function (j) {
					jQuery(this).addClass(value.call(this, j, getClass(this)));
				});
			}

			classes = classesToArray(value);

			if (classes.length) {
				while (elem = this[i++]) {
					curValue = getClass(elem);
					cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

					if (cur) {
						j = 0;
						while (clazz = classes[j++]) {
							if (cur.indexOf(" " + clazz + " ") < 0) {
								cur += clazz + " ";
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse(cur);
						if (curValue !== finalValue) {
							elem.setAttribute("class", finalValue);
						}
					}
				}
			}

			return this;
		},

		removeClass: function removeClass(value) {
			var classes,
			    elem,
			    cur,
			    curValue,
			    clazz,
			    j,
			    finalValue,
			    i = 0;

			if (isFunction(value)) {
				return this.each(function (j) {
					jQuery(this).removeClass(value.call(this, j, getClass(this)));
				});
			}

			if (!arguments.length) {
				return this.attr("class", "");
			}

			classes = classesToArray(value);

			if (classes.length) {
				while (elem = this[i++]) {
					curValue = getClass(elem);

					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

					if (cur) {
						j = 0;
						while (clazz = classes[j++]) {

							// Remove *all* instances
							while (cur.indexOf(" " + clazz + " ") > -1) {
								cur = cur.replace(" " + clazz + " ", " ");
							}
						}

						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse(cur);
						if (curValue !== finalValue) {
							elem.setAttribute("class", finalValue);
						}
					}
				}
			}

			return this;
		},

		toggleClass: function toggleClass(value, stateVal) {
			var type = typeof value === "undefined" ? "undefined" : _typeof(value),
			    isValidValue = type === "string" || Array.isArray(value);

			if (typeof stateVal === "boolean" && isValidValue) {
				return stateVal ? this.addClass(value) : this.removeClass(value);
			}

			if (isFunction(value)) {
				return this.each(function (i) {
					jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
				});
			}

			return this.each(function () {
				var className, i, self, classNames;

				if (isValidValue) {

					// Toggle individual class names
					i = 0;
					self = jQuery(this);
					classNames = classesToArray(value);

					while (className = classNames[i++]) {

						// Check each className given, space separated list
						if (self.hasClass(className)) {
							self.removeClass(className);
						} else {
							self.addClass(className);
						}
					}

					// Toggle whole class name
				} else if (value === undefined || type === "boolean") {
					className = getClass(this);
					if (className) {

						// Store className if set
						dataPriv.set(this, "__className__", className);
					}

					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if (this.setAttribute) {
						this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
					}
				}
			});
		},

		hasClass: function hasClass(selector) {
			var className,
			    elem,
			    i = 0;

			className = " " + selector + " ";
			while (elem = this[i++]) {
				if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
					return true;
				}
			}

			return false;
		}
	});

	var rreturn = /\r/g;

	jQuery.fn.extend({
		val: function val(value) {
			var hooks,
			    ret,
			    valueIsFunction,
			    elem = this[0];

			if (!arguments.length) {
				if (elem) {
					hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];

					if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
						return ret;
					}

					ret = elem.value;

					// Handle most common string cases
					if (typeof ret === "string") {
						return ret.replace(rreturn, "");
					}

					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}

				return;
			}

			valueIsFunction = isFunction(value);

			return this.each(function (i) {
				var val;

				if (this.nodeType !== 1) {
					return;
				}

				if (valueIsFunction) {
					val = value.call(this, i, jQuery(this).val());
				} else {
					val = value;
				}

				// Treat null/undefined as ""; convert numbers to string
				if (val == null) {
					val = "";
				} else if (typeof val === "number") {
					val += "";
				} else if (Array.isArray(val)) {
					val = jQuery.map(val, function (value) {
						return value == null ? "" : value + "";
					});
				}

				hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

				// If set returns undefined, fall back to normal setting
				if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
					this.value = val;
				}
			});
		}
	});

	jQuery.extend({
		valHooks: {
			option: {
				get: function get(elem) {

					var val = jQuery.find.attr(elem, "value");
					return val != null ? val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse(jQuery.text(elem));
				}
			},
			select: {
				get: function get(elem) {
					var value,
					    option,
					    i,
					    options = elem.options,
					    index = elem.selectedIndex,
					    one = elem.type === "select-one",
					    values = one ? null : [],
					    max = one ? index + 1 : options.length;

					if (index < 0) {
						i = max;
					} else {
						i = one ? index : 0;
					}

					// Loop through all the selected options
					for (; i < max; i++) {
						option = options[i];

						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ((option.selected || i === index) &&

						// Don't return options that are disabled or in a disabled optgroup
						!option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {

							// Get the specific value for the option
							value = jQuery(option).val();

							// We don't need an array for one selects
							if (one) {
								return value;
							}

							// Multi-Selects return an array
							values.push(value);
						}
					}

					return values;
				},

				set: function set(elem, value) {
					var optionSet,
					    option,
					    options = elem.options,
					    values = jQuery.makeArray(value),
					    i = options.length;

					while (i--) {
						option = options[i];

						/* eslint-disable no-cond-assign */

						if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
							optionSet = true;
						}

						/* eslint-enable no-cond-assign */
					}

					// Force browsers to behave consistently when non-matching value is set
					if (!optionSet) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	});

	// Radios and checkboxes getter/setter
	jQuery.each(["radio", "checkbox"], function () {
		jQuery.valHooks[this] = {
			set: function set(elem, value) {
				if (Array.isArray(value)) {
					return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
				}
			}
		};
		if (!support.checkOn) {
			jQuery.valHooks[this].get = function (elem) {
				return elem.getAttribute("value") === null ? "on" : elem.value;
			};
		}
	});

	// Return jQuery for attributes-only inclusion


	support.focusin = "onfocusin" in window;

	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	    stopPropagationCallback = function stopPropagationCallback(e) {
		e.stopPropagation();
	};

	jQuery.extend(jQuery.event, {

		trigger: function trigger(event, data, elem, onlyHandlers) {

			var i,
			    cur,
			    tmp,
			    bubbleType,
			    ontype,
			    handle,
			    special,
			    lastElement,
			    eventPath = [elem || document],
			    type = hasOwn.call(event, "type") ? event.type : event,
			    namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];

			cur = lastElement = tmp = elem = elem || document;

			// Don't do events on text and comment nodes
			if (elem.nodeType === 3 || elem.nodeType === 8) {
				return;
			}

			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if (rfocusMorph.test(type + jQuery.event.triggered)) {
				return;
			}

			if (type.indexOf(".") > -1) {

				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split(".");
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf(":") < 0 && "on" + type;

			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : _typeof(event)) === "object" && event);

			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join(".");
			event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;

			// Clean up the event in case it is being reused
			event.result = undefined;
			if (!event.target) {
				event.target = elem;
			}

			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ? [event] : jQuery.makeArray(data, [event]);

			// Allow special events to draw outside the lines
			special = jQuery.event.special[type] || {};
			if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
				return;
			}

			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {

				bubbleType = special.delegateType || type;
				if (!rfocusMorph.test(bubbleType + type)) {
					cur = cur.parentNode;
				}
				for (; cur; cur = cur.parentNode) {
					eventPath.push(cur);
					tmp = cur;
				}

				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if (tmp === (elem.ownerDocument || document)) {
					eventPath.push(tmp.defaultView || tmp.parentWindow || window);
				}
			}

			// Fire handlers on the event path
			i = 0;
			while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
				lastElement = cur;
				event.type = i > 1 ? bubbleType : special.bindType || type;

				// jQuery handler
				handle = (dataPriv.get(cur, "events") || {})[event.type] && dataPriv.get(cur, "handle");
				if (handle) {
					handle.apply(cur, data);
				}

				// Native handler
				handle = ontype && cur[ontype];
				if (handle && handle.apply && acceptData(cur)) {
					event.result = handle.apply(cur, data);
					if (event.result === false) {
						event.preventDefault();
					}
				}
			}
			event.type = type;

			// If nobody prevented the default action, do it now
			if (!onlyHandlers && !event.isDefaultPrevented()) {

				if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {

					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if (ontype && isFunction(elem[type]) && !isWindow(elem)) {

						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ontype];

						if (tmp) {
							elem[ontype] = null;
						}

						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;

						if (event.isPropagationStopped()) {
							lastElement.addEventListener(type, stopPropagationCallback);
						}

						elem[type]();

						if (event.isPropagationStopped()) {
							lastElement.removeEventListener(type, stopPropagationCallback);
						}

						jQuery.event.triggered = undefined;

						if (tmp) {
							elem[ontype] = tmp;
						}
					}
				}
			}

			return event.result;
		},

		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function simulate(type, elem, event) {
			var e = jQuery.extend(new jQuery.Event(), event, {
				type: type,
				isSimulated: true
			});

			jQuery.event.trigger(e, null, elem);
		}

	});

	jQuery.fn.extend({

		trigger: function trigger(type, data) {
			return this.each(function () {
				jQuery.event.trigger(type, data, this);
			});
		},
		triggerHandler: function triggerHandler(type, data) {
			var elem = this[0];
			if (elem) {
				return jQuery.event.trigger(type, data, elem, true);
			}
		}
	});

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if (!support.focusin) {
		jQuery.each({ focus: "focusin", blur: "focusout" }, function (orig, fix) {

			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function handler(event) {
				jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
			};

			jQuery.event.special[fix] = {
				setup: function setup() {
					var doc = this.ownerDocument || this,
					    attaches = dataPriv.access(doc, fix);

					if (!attaches) {
						doc.addEventListener(orig, handler, true);
					}
					dataPriv.access(doc, fix, (attaches || 0) + 1);
				},
				teardown: function teardown() {
					var doc = this.ownerDocument || this,
					    attaches = dataPriv.access(doc, fix) - 1;

					if (!attaches) {
						doc.removeEventListener(orig, handler, true);
						dataPriv.remove(doc, fix);
					} else {
						dataPriv.access(doc, fix, attaches);
					}
				}
			};
		});
	}
	var location = window.location;

	var nonce = Date.now();

	var rquery = /\?/;

	// Cross-browser xml parsing
	jQuery.parseXML = function (data) {
		var xml;
		if (!data || typeof data !== "string") {
			return null;
		}

		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = new window.DOMParser().parseFromString(data, "text/xml");
		} catch (e) {
			xml = undefined;
		}

		if (!xml || xml.getElementsByTagName("parsererror").length) {
			jQuery.error("Invalid XML: " + data);
		}
		return xml;
	};

	var rbracket = /\[\]$/,
	    rCRLF = /\r?\n/g,
	    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	    rsubmittable = /^(?:input|select|textarea|keygen)/i;

	function buildParams(prefix, obj, traditional, add) {
		var name;

		if (Array.isArray(obj)) {

			// Serialize array item.
			jQuery.each(obj, function (i, v) {
				if (traditional || rbracket.test(prefix)) {

					// Treat each array item as a scalar.
					add(prefix, v);
				} else {

					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
				}
			});
		} else if (!traditional && toType(obj) === "object") {

			// Serialize object item.
			for (name in obj) {
				buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
			}
		} else {

			// Serialize scalar item.
			add(prefix, obj);
		}
	}

	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function (a, traditional) {
		var prefix,
		    s = [],
		    add = function add(key, valueOrFunction) {

			// If value is a function, invoke it and use its return value
			var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;

			s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
		};

		// If an array was passed in, assume that it is an array of form elements.
		if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {

			// Serialize the form elements
			jQuery.each(a, function () {
				add(this.name, this.value);
			});
		} else {

			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for (prefix in a) {
				buildParams(prefix, a[prefix], traditional, add);
			}
		}

		// Return the resulting serialization
		return s.join("&");
	};

	jQuery.fn.extend({
		serialize: function serialize() {
			return jQuery.param(this.serializeArray());
		},
		serializeArray: function serializeArray() {
			return this.map(function () {

				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop(this, "elements");
				return elements ? jQuery.makeArray(elements) : this;
			}).filter(function () {
				var type = this.type;

				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
			}).map(function (i, elem) {
				var val = jQuery(this).val();

				if (val == null) {
					return null;
				}

				if (Array.isArray(val)) {
					return jQuery.map(val, function (val) {
						return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
					});
				}

				return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
			}).get();
		}
	});

	var r20 = /%20/g,
	    rhash = /#.*$/,
	    rantiCache = /([?&])_=[^&]*/,
	    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,


	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	    rnoContent = /^(?:GET|HEAD)$/,
	    rprotocol = /^\/\//,


	/* Prefilters
  * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
  * 2) These are called:
  *    - BEFORE asking for a transport
  *    - AFTER param serialization (s.data is a string if s.processData is true)
  * 3) key is the dataType
  * 4) the catchall symbol "*" can be used
  * 5) execution will start with transport dataType and THEN continue down to "*" if needed
  */
	prefilters = {},


	/* Transports bindings
  * 1) key is the dataType
  * 2) the catchall symbol "*" can be used
  * 3) selection will start with transport dataType and THEN go to "*" if needed
  */
	transports = {},


	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat("*"),


	// Anchor tag for parsing the document origin
	originAnchor = document.createElement("a");
	originAnchor.href = location.href;

	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports(structure) {

		// dataTypeExpression is optional and defaults to "*"
		return function (dataTypeExpression, func) {

			if (typeof dataTypeExpression !== "string") {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}

			var dataType,
			    i = 0,
			    dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

			if (isFunction(func)) {

				// For each dataType in the dataTypeExpression
				while (dataType = dataTypes[i++]) {

					// Prepend if requested
					if (dataType[0] === "+") {
						dataType = dataType.slice(1) || "*";
						(structure[dataType] = structure[dataType] || []).unshift(func);

						// Otherwise append
					} else {
						(structure[dataType] = structure[dataType] || []).push(func);
					}
				}
			}
		};
	}

	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {

		var inspected = {},
		    seekingTransport = structure === transports;

		function inspect(dataType) {
			var selected;
			inspected[dataType] = true;
			jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
				var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
				if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {

					options.dataTypes.unshift(dataTypeOrTransport);
					inspect(dataTypeOrTransport);
					return false;
				} else if (seekingTransport) {
					return !(selected = dataTypeOrTransport);
				}
			});
			return selected;
		}

		return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
	}

	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend(target, src) {
		var key,
		    deep,
		    flatOptions = jQuery.ajaxSettings.flatOptions || {};

		for (key in src) {
			if (src[key] !== undefined) {
				(flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
			}
		}
		if (deep) {
			jQuery.extend(true, target, deep);
		}

		return target;
	}

	/* Handles responses to an ajax request:
  * - finds the right dataType (mediates between content-type and expected dataType)
  * - returns the corresponding response
  */
	function ajaxHandleResponses(s, jqXHR, responses) {

		var ct,
		    type,
		    finalDataType,
		    firstDataType,
		    contents = s.contents,
		    dataTypes = s.dataTypes;

		// Remove auto dataType and get content-type in the process
		while (dataTypes[0] === "*") {
			dataTypes.shift();
			if (ct === undefined) {
				ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
			}
		}

		// Check if we're dealing with a known content-type
		if (ct) {
			for (type in contents) {
				if (contents[type] && contents[type].test(ct)) {
					dataTypes.unshift(type);
					break;
				}
			}
		}

		// Check to see if we have a response for the expected dataType
		if (dataTypes[0] in responses) {
			finalDataType = dataTypes[0];
		} else {

			// Try convertible dataTypes
			for (type in responses) {
				if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
					finalDataType = type;
					break;
				}
				if (!firstDataType) {
					firstDataType = type;
				}
			}

			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}

		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if (finalDataType) {
			if (finalDataType !== dataTypes[0]) {
				dataTypes.unshift(finalDataType);
			}
			return responses[finalDataType];
		}
	}

	/* Chain conversions given the request and the original response
  * Also sets the responseXXX fields on the jqXHR instance
  */
	function ajaxConvert(s, response, jqXHR, isSuccess) {
		var conv2,
		    current,
		    conv,
		    tmp,
		    prev,
		    converters = {},


		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

		// Create converters map with lowercased keys
		if (dataTypes[1]) {
			for (conv in s.converters) {
				converters[conv.toLowerCase()] = s.converters[conv];
			}
		}

		current = dataTypes.shift();

		// Convert to each sequential dataType
		while (current) {

			if (s.responseFields[current]) {
				jqXHR[s.responseFields[current]] = response;
			}

			// Apply the dataFilter if provided
			if (!prev && isSuccess && s.dataFilter) {
				response = s.dataFilter(response, s.dataType);
			}

			prev = current;
			current = dataTypes.shift();

			if (current) {

				// There's only work to do if current dataType is non-auto
				if (current === "*") {

					current = prev;

					// Convert response if prev dataType is non-auto and differs from current
				} else if (prev !== "*" && prev !== current) {

					// Seek a direct converter
					conv = converters[prev + " " + current] || converters["* " + current];

					// If none found, seek a pair
					if (!conv) {
						for (conv2 in converters) {

							// If conv2 outputs current
							tmp = conv2.split(" ");
							if (tmp[1] === current) {

								// If prev can be converted to accepted input
								conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
								if (conv) {

									// Condense equivalence converters
									if (conv === true) {
										conv = converters[conv2];

										// Otherwise, insert the intermediate dataType
									} else if (converters[conv2] !== true) {
										current = tmp[0];
										dataTypes.unshift(tmp[1]);
									}
									break;
								}
							}
						}
					}

					// Apply converter (if not an equivalence)
					if (conv !== true) {

						// Unless errors are allowed to bubble, catch and return them
						if (conv && s.throws) {
							response = conv(response);
						} else {
							try {
								response = conv(response);
							} catch (e) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}

		return { state: "success", data: response };
	}

	jQuery.extend({

		// Counter for holding the number of active queries
		active: 0,

		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},

		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test(location.protocol),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",

			/*
   timeout: 0,
   data: null,
   dataType: null,
   username: null,
   password: null,
   cache: null,
   throws: false,
   traditional: false,
   headers: {},
   */

			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},

			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},

			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},

			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {

				// Convert anything to text
				"* text": String,

				// Text to html (true = no transformation)
				"text html": true,

				// Evaluate text as a json expression
				"text json": JSON.parse,

				// Parse text as xml
				"text xml": jQuery.parseXML
			},

			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},

		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function ajaxSetup(target, settings) {
			return settings ?

			// Building a settings object
			ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :

			// Extending ajaxSettings
			ajaxExtend(jQuery.ajaxSettings, target);
		},

		ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
		ajaxTransport: addToPrefiltersOrTransports(transports),

		// Main method
		ajax: function ajax(url, options) {

			// If url is an object, simulate pre-1.5 signature
			if ((typeof url === "undefined" ? "undefined" : _typeof(url)) === "object") {
				options = url;
				url = undefined;
			}

			// Force options to be an object
			options = options || {};

			var transport,


			// URL without anti-cache param
			cacheURL,


			// Response headers
			responseHeadersString,
			    responseHeaders,


			// timeout handle
			timeoutTimer,


			// Url cleanup var
			urlAnchor,


			// Request state (becomes false upon send and true upon completion)
			completed,


			// To know if global events are to be dispatched
			fireGlobals,


			// Loop variable
			i,


			// uncached part of the url
			uncached,


			// Create the final options object
			s = jQuery.ajaxSetup({}, options),


			// Callbacks context
			callbackContext = s.context || s,


			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,


			// Deferreds
			deferred = jQuery.Deferred(),
			    completeDeferred = jQuery.Callbacks("once memory"),


			// Status-dependent callbacks
			_statusCode = s.statusCode || {},


			// Headers (they are sent all at once)
			requestHeaders = {},
			    requestHeadersNames = {},


			// Default abort message
			strAbort = "canceled",


			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function getResponseHeader(key) {
					var match;
					if (completed) {
						if (!responseHeaders) {
							responseHeaders = {};
							while (match = rheaders.exec(responseHeadersString)) {
								responseHeaders[match[1].toLowerCase()] = match[2];
							}
						}
						match = responseHeaders[key.toLowerCase()];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function getAllResponseHeaders() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function setRequestHeader(name, value) {
					if (completed == null) {
						name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
						requestHeaders[name] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function overrideMimeType(type) {
					if (completed == null) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function statusCode(map) {
					var code;
					if (map) {
						if (completed) {

							// Execute the appropriate callbacks
							jqXHR.always(map[jqXHR.status]);
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for (code in map) {
								_statusCode[code] = [_statusCode[code], map[code]];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function abort(statusText) {
					var finalText = statusText || strAbort;
					if (transport) {
						transport.abort(finalText);
					}
					done(0, finalText);
					return this;
				}
			};

			// Attach deferreds
			deferred.promise(jqXHR);

			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");

			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;

			// Extract dataTypes list
			s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];

			// A cross-domain request is in order when the origin doesn't match the current origin.
			if (s.crossDomain == null) {
				urlAnchor = document.createElement("a");

				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;

					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
				} catch (e) {

					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}

			// Convert data if not already a string
			if (s.data && s.processData && typeof s.data !== "string") {
				s.data = jQuery.param(s.data, s.traditional);
			}

			// Apply prefilters
			inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

			// If request was aborted inside a prefilter, stop there
			if (completed) {
				return jqXHR;
			}

			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;

			// Watch for a new set of requests
			if (fireGlobals && jQuery.active++ === 0) {
				jQuery.event.trigger("ajaxStart");
			}

			// Uppercase the type
			s.type = s.type.toUpperCase();

			// Determine if request has content
			s.hasContent = !rnoContent.test(s.type);

			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace(rhash, "");

			// More options handling for requests with no content
			if (!s.hasContent) {

				// Remember the hash so we can put it back
				uncached = s.url.slice(cacheURL.length);

				// If data is available and should be processed, append data to url
				if (s.data && (s.processData || typeof s.data === "string")) {
					cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}

				// Add or update anti-cache param if needed
				if (s.cache === false) {
					cacheURL = cacheURL.replace(rantiCache, "$1");
					uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++ + uncached;
				}

				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;

				// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
				s.data = s.data.replace(r20, "+");
			}

			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if (s.ifModified) {
				if (jQuery.lastModified[cacheURL]) {
					jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
				}
				if (jQuery.etag[cacheURL]) {
					jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
				}
			}

			// Set the correct header, if data is being sent
			if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
				jqXHR.setRequestHeader("Content-Type", s.contentType);
			}

			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);

			// Check for headers option
			for (i in s.headers) {
				jqXHR.setRequestHeader(i, s.headers[i]);
			}

			// Allow custom headers/mimetypes and early abort
			if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {

				// Abort if not done already and return
				return jqXHR.abort();
			}

			// Aborting is no longer a cancellation
			strAbort = "abort";

			// Install callbacks on deferreds
			completeDeferred.add(s.complete);
			jqXHR.done(s.success);
			jqXHR.fail(s.error);

			// Get transport
			transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

			// If no transport, we auto-abort
			if (!transport) {
				done(-1, "No Transport");
			} else {
				jqXHR.readyState = 1;

				// Send global event
				if (fireGlobals) {
					globalEventContext.trigger("ajaxSend", [jqXHR, s]);
				}

				// If request was aborted inside ajaxSend, stop there
				if (completed) {
					return jqXHR;
				}

				// Timeout
				if (s.async && s.timeout > 0) {
					timeoutTimer = window.setTimeout(function () {
						jqXHR.abort("timeout");
					}, s.timeout);
				}

				try {
					completed = false;
					transport.send(requestHeaders, done);
				} catch (e) {

					// Rethrow post-completion exceptions
					if (completed) {
						throw e;
					}

					// Propagate others as results
					done(-1, e);
				}
			}

			// Callback for when everything is done
			function done(status, nativeStatusText, responses, headers) {
				var isSuccess,
				    success,
				    error,
				    response,
				    modified,
				    statusText = nativeStatusText;

				// Ignore repeat invocations
				if (completed) {
					return;
				}

				completed = true;

				// Clear timeout if it exists
				if (timeoutTimer) {
					window.clearTimeout(timeoutTimer);
				}

				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;

				// Cache response headers
				responseHeadersString = headers || "";

				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;

				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;

				// Get response data
				if (responses) {
					response = ajaxHandleResponses(s, jqXHR, responses);
				}

				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert(s, response, jqXHR, isSuccess);

				// If successful, handle type chaining
				if (isSuccess) {

					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if (s.ifModified) {
						modified = jqXHR.getResponseHeader("Last-Modified");
						if (modified) {
							jQuery.lastModified[cacheURL] = modified;
						}
						modified = jqXHR.getResponseHeader("etag");
						if (modified) {
							jQuery.etag[cacheURL] = modified;
						}
					}

					// if no content
					if (status === 204 || s.type === "HEAD") {
						statusText = "nocontent";

						// if not modified
					} else if (status === 304) {
						statusText = "notmodified";

						// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {

					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if (status || !statusText) {
						statusText = "error";
						if (status < 0) {
							status = 0;
						}
					}
				}

				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = (nativeStatusText || statusText) + "";

				// Success/Error
				if (isSuccess) {
					deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
				} else {
					deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
				}

				// Status-dependent callbacks
				jqXHR.statusCode(_statusCode);
				_statusCode = undefined;

				if (fireGlobals) {
					globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
				}

				// Complete
				completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

				if (fireGlobals) {
					globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

					// Handle the global AJAX counter
					if (! --jQuery.active) {
						jQuery.event.trigger("ajaxStop");
					}
				}
			}

			return jqXHR;
		},

		getJSON: function getJSON(url, data, callback) {
			return jQuery.get(url, data, callback, "json");
		},

		getScript: function getScript(url, callback) {
			return jQuery.get(url, undefined, callback, "script");
		}
	});

	jQuery.each(["get", "post"], function (i, method) {
		jQuery[method] = function (url, data, callback, type) {

			// Shift arguments if data argument was omitted
			if (isFunction(data)) {
				type = type || callback;
				callback = data;
				data = undefined;
			}

			// The url can be an options object (which then must have .url)
			return jQuery.ajax(jQuery.extend({
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject(url) && url));
		};
	});

	jQuery._evalUrl = function (url) {
		return jQuery.ajax({
			url: url,

			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		});
	};

	jQuery.fn.extend({
		wrapAll: function wrapAll(html) {
			var wrap;

			if (this[0]) {
				if (isFunction(html)) {
					html = html.call(this[0]);
				}

				// The elements to wrap the target around
				wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

				if (this[0].parentNode) {
					wrap.insertBefore(this[0]);
				}

				wrap.map(function () {
					var elem = this;

					while (elem.firstElementChild) {
						elem = elem.firstElementChild;
					}

					return elem;
				}).append(this);
			}

			return this;
		},

		wrapInner: function wrapInner(html) {
			if (isFunction(html)) {
				return this.each(function (i) {
					jQuery(this).wrapInner(html.call(this, i));
				});
			}

			return this.each(function () {
				var self = jQuery(this),
				    contents = self.contents();

				if (contents.length) {
					contents.wrapAll(html);
				} else {
					self.append(html);
				}
			});
		},

		wrap: function wrap(html) {
			var htmlIsFunction = isFunction(html);

			return this.each(function (i) {
				jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
			});
		},

		unwrap: function unwrap(selector) {
			this.parent(selector).not("body").each(function () {
				jQuery(this).replaceWith(this.childNodes);
			});
			return this;
		}
	});

	jQuery.expr.pseudos.hidden = function (elem) {
		return !jQuery.expr.pseudos.visible(elem);
	};
	jQuery.expr.pseudos.visible = function (elem) {
		return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
	};

	jQuery.ajaxSettings.xhr = function () {
		try {
			return new window.XMLHttpRequest();
		} catch (e) {}
	};

	var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	    xhrSupported = jQuery.ajaxSettings.xhr();

	support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
	support.ajax = xhrSupported = !!xhrSupported;

	jQuery.ajaxTransport(function (options) {
		var _callback, errorCallback;

		// Cross domain only allowed if supported through XMLHttpRequest
		if (support.cors || xhrSupported && !options.crossDomain) {
			return {
				send: function send(headers, complete) {
					var i,
					    xhr = options.xhr();

					xhr.open(options.type, options.url, options.async, options.username, options.password);

					// Apply custom fields if provided
					if (options.xhrFields) {
						for (i in options.xhrFields) {
							xhr[i] = options.xhrFields[i];
						}
					}

					// Override mime type if needed
					if (options.mimeType && xhr.overrideMimeType) {
						xhr.overrideMimeType(options.mimeType);
					}

					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if (!options.crossDomain && !headers["X-Requested-With"]) {
						headers["X-Requested-With"] = "XMLHttpRequest";
					}

					// Set headers
					for (i in headers) {
						xhr.setRequestHeader(i, headers[i]);
					}

					// Callback
					_callback = function callback(type) {
						return function () {
							if (_callback) {
								_callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;

								if (type === "abort") {
									xhr.abort();
								} else if (type === "error") {

									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if (typeof xhr.status !== "number") {
										complete(0, "error");
									} else {
										complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status, xhr.statusText);
									}
								} else {
									complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									(xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText }, xhr.getAllResponseHeaders());
								}
							}
						};
					};

					// Listen to events
					xhr.onload = _callback();
					errorCallback = xhr.onerror = xhr.ontimeout = _callback("error");

					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if (xhr.onabort !== undefined) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function () {

							// Check readyState before timeout as it changes
							if (xhr.readyState === 4) {

								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout(function () {
									if (_callback) {
										errorCallback();
									}
								});
							}
						};
					}

					// Create the abort callback
					_callback = _callback("abort");

					try {

						// Do send the request (this may raise an exception)
						xhr.send(options.hasContent && options.data || null);
					} catch (e) {

						// #14683: Only rethrow if this hasn't been notified as an error yet
						if (_callback) {
							throw e;
						}
					}
				},

				abort: function abort() {
					if (_callback) {
						_callback();
					}
				}
			};
		}
	});

	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter(function (s) {
		if (s.crossDomain) {
			s.contents.script = false;
		}
	});

	// Install script dataType
	jQuery.ajaxSetup({
		accepts: {
			script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function textScript(text) {
				jQuery.globalEval(text);
				return text;
			}
		}
	});

	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter("script", function (s) {
		if (s.cache === undefined) {
			s.cache = false;
		}
		if (s.crossDomain) {
			s.type = "GET";
		}
	});

	// Bind script tag hack transport
	jQuery.ajaxTransport("script", function (s) {

		// This transport only deals with cross domain requests
		if (s.crossDomain) {
			var script, _callback2;
			return {
				send: function send(_, complete) {
					script = jQuery("<script>").prop({
						charset: s.scriptCharset,
						src: s.url
					}).on("load error", _callback2 = function callback(evt) {
						script.remove();
						_callback2 = null;
						if (evt) {
							complete(evt.type === "error" ? 404 : 200, evt.type);
						}
					});

					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild(script[0]);
				},
				abort: function abort() {
					if (_callback2) {
						_callback2();
					}
				}
			};
		}
	});

	var oldCallbacks = [],
	    rjsonp = /(=)\?(?=&|$)|\?\?/;

	// Default jsonp settings
	jQuery.ajaxSetup({
		jsonp: "callback",
		jsonpCallback: function jsonpCallback() {
			var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce++;
			this[callback] = true;
			return callback;
		}
	});

	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {

		var callbackName,
		    overwritten,
		    responseContainer,
		    jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");

		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if (jsonProp || s.dataTypes[0] === "jsonp") {

			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;

			// Insert callback into url or form data
			if (jsonProp) {
				s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
			} else if (s.jsonp !== false) {
				s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
			}

			// Use data converter to retrieve json after script execution
			s.converters["script json"] = function () {
				if (!responseContainer) {
					jQuery.error(callbackName + " was not called");
				}
				return responseContainer[0];
			};

			// Force json dataType
			s.dataTypes[0] = "json";

			// Install callback
			overwritten = window[callbackName];
			window[callbackName] = function () {
				responseContainer = arguments;
			};

			// Clean-up function (fires after converters)
			jqXHR.always(function () {

				// If previous value didn't exist - remove it
				if (overwritten === undefined) {
					jQuery(window).removeProp(callbackName);

					// Otherwise restore preexisting value
				} else {
					window[callbackName] = overwritten;
				}

				// Save back as free
				if (s[callbackName]) {

					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;

					// Save the callback name for future use
					oldCallbacks.push(callbackName);
				}

				// Call if it was a function and we have a response
				if (responseContainer && isFunction(overwritten)) {
					overwritten(responseContainer[0]);
				}

				responseContainer = overwritten = undefined;
			});

			// Delegate to script
			return "script";
		}
	});

	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = function () {
		var body = document.implementation.createHTMLDocument("").body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	}();

	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function (data, context, keepScripts) {
		if (typeof data !== "string") {
			return [];
		}
		if (typeof context === "boolean") {
			keepScripts = context;
			context = false;
		}

		var base, parsed, scripts;

		if (!context) {

			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if (support.createHTMLDocument) {
				context = document.implementation.createHTMLDocument("");

				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement("base");
				base.href = document.location.href;
				context.head.appendChild(base);
			} else {
				context = document;
			}
		}

		parsed = rsingleTag.exec(data);
		scripts = !keepScripts && [];

		// Single tag
		if (parsed) {
			return [context.createElement(parsed[1])];
		}

		parsed = buildFragment([data], context, scripts);

		if (scripts && scripts.length) {
			jQuery(scripts).remove();
		}

		return jQuery.merge([], parsed.childNodes);
	};

	/**
  * Load a url into a page
  */
	jQuery.fn.load = function (url, params, callback) {
		var selector,
		    type,
		    response,
		    self = this,
		    off = url.indexOf(" ");

		if (off > -1) {
			selector = stripAndCollapse(url.slice(off));
			url = url.slice(0, off);
		}

		// If it's a function
		if (isFunction(params)) {

			// We assume that it's the callback
			callback = params;
			params = undefined;

			// Otherwise, build a param string
		} else if (params && (typeof params === "undefined" ? "undefined" : _typeof(params)) === "object") {
			type = "POST";
		}

		// If we have elements to modify, make the request
		if (self.length > 0) {
			jQuery.ajax({
				url: url,

				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			}).done(function (responseText) {

				// Save response for use in complete callback
				response = arguments;

				self.html(selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :

				// Otherwise use the full result
				responseText);

				// If the request succeeds, this function gets "data", "status", "jqXHR"
				// but they are ignored because response was set above.
				// If it fails, this function gets "jqXHR", "status", "error"
			}).always(callback && function (jqXHR, status) {
				self.each(function () {
					callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
				});
			});
		}

		return this;
	};

	// Attach a bunch of functions for handling common AJAX events
	jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (i, type) {
		jQuery.fn[type] = function (fn) {
			return this.on(type, fn);
		};
	});

	jQuery.expr.pseudos.animated = function (elem) {
		return jQuery.grep(jQuery.timers, function (fn) {
			return elem === fn.elem;
		}).length;
	};

	jQuery.offset = {
		setOffset: function setOffset(elem, options, i) {
			var curPosition,
			    curLeft,
			    curCSSTop,
			    curTop,
			    curOffset,
			    curCSSLeft,
			    calculatePosition,
			    position = jQuery.css(elem, "position"),
			    curElem = jQuery(elem),
			    props = {};

			// Set position first, in-case top/left are set even on static elem
			if (position === "static") {
				elem.style.position = "relative";
			}

			curOffset = curElem.offset();
			curCSSTop = jQuery.css(elem, "top");
			curCSSLeft = jQuery.css(elem, "left");
			calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;

			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if (calculatePosition) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
			} else {
				curTop = parseFloat(curCSSTop) || 0;
				curLeft = parseFloat(curCSSLeft) || 0;
			}

			if (isFunction(options)) {

				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call(elem, i, jQuery.extend({}, curOffset));
			}

			if (options.top != null) {
				props.top = options.top - curOffset.top + curTop;
			}
			if (options.left != null) {
				props.left = options.left - curOffset.left + curLeft;
			}

			if ("using" in options) {
				options.using.call(elem, props);
			} else {
				curElem.css(props);
			}
		}
	};

	jQuery.fn.extend({

		// offset() relates an element's border box to the document origin
		offset: function offset(options) {

			// Preserve chaining for setter
			if (arguments.length) {
				return options === undefined ? this : this.each(function (i) {
					jQuery.offset.setOffset(this, options, i);
				});
			}

			var rect,
			    win,
			    elem = this[0];

			if (!elem) {
				return;
			}

			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if (!elem.getClientRects().length) {
				return { top: 0, left: 0 };
			}

			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},

		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function position() {
			if (!this[0]) {
				return;
			}

			var offsetParent,
			    offset,
			    doc,
			    elem = this[0],
			    parentOffset = { top: 0, left: 0 };

			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if (jQuery.css(elem, "position") === "fixed") {

				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
			} else {
				offset = this.offset();

				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {

					offsetParent = offsetParent.parentNode;
				}
				if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {

					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery(offsetParent).offset();
					parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
					parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
				}
			}

			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
				left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
			};
		},

		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function offsetParent() {
			return this.map(function () {
				var offsetParent = this.offsetParent;

				while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
					offsetParent = offsetParent.offsetParent;
				}

				return offsetParent || documentElement;
			});
		}
	});

	// Create scrollLeft and scrollTop methods
	jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
		var top = "pageYOffset" === prop;

		jQuery.fn[method] = function (val) {
			return access(this, function (elem, method, val) {

				// Coalesce documents and windows
				var win;
				if (isWindow(elem)) {
					win = elem;
				} else if (elem.nodeType === 9) {
					win = elem.defaultView;
				}

				if (val === undefined) {
					return win ? win[prop] : elem[method];
				}

				if (win) {
					win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
				} else {
					elem[method] = val;
				}
			}, method, val, arguments.length);
		};
	});

	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each(["top", "left"], function (i, prop) {
		jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
			if (computed) {
				computed = curCSS(elem, prop);

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
			}
		});
	});

	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
		jQuery.each({ padding: "inner" + name, content: type, "": "outer" + name }, function (defaultExtra, funcName) {

			// Margin is only for outerHeight, outerWidth
			jQuery.fn[funcName] = function (margin, value) {
				var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
				    extra = defaultExtra || (margin === true || value === true ? "margin" : "border");

				return access(this, function (elem, type, value) {
					var doc;

					if (isWindow(elem)) {

						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
					}

					// Get document width or height
					if (elem.nodeType === 9) {
						doc = elem.documentElement;

						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
					}

					return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css(elem, type, extra) :

					// Set width or height on the element
					jQuery.style(elem, type, value, extra);
				}, type, chainable ? margin : undefined, chainable);
			};
		});
	});

	jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (i, name) {

		// Handle event binding
		jQuery.fn[name] = function (data, fn) {
			return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
		};
	});

	jQuery.fn.extend({
		hover: function hover(fnOver, fnOut) {
			return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
		}
	});

	jQuery.fn.extend({

		bind: function bind(types, data, fn) {
			return this.on(types, null, data, fn);
		},
		unbind: function unbind(types, fn) {
			return this.off(types, null, fn);
		},

		delegate: function delegate(selector, types, data, fn) {
			return this.on(types, selector, data, fn);
		},
		undelegate: function undelegate(selector, types, fn) {

			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
		}
	});

	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function (fn, context) {
		var tmp, args, proxy;

		if (typeof context === "string") {
			tmp = fn[context];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if (!isFunction(fn)) {
			return undefined;
		}

		// Simulated bind
		args = _slice.call(arguments, 2);
		proxy = function proxy() {
			return fn.apply(context || this, args.concat(_slice.call(arguments)));
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	};

	jQuery.holdReady = function (hold) {
		if (hold) {
			jQuery.readyWait++;
		} else {
			jQuery.ready(true);
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;

	jQuery.now = Date.now;

	jQuery.isNumeric = function (obj) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type(obj);
		return (type === "number" || type === "string") &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN(obj - parseFloat(obj));
	};

	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.

	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}

	var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,


	// Map over the $ in case of overwrite
	_$ = window.$;

	jQuery.noConflict = function (deep) {
		if (window.$ === jQuery) {
			window.$ = _$;
		}

		if (deep && window.jQuery === jQuery) {
			window.jQuery = _jQuery;
		}

		return jQuery;
	};

	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if (!noGlobal) {
		window.jQuery = window.$ = jQuery;
	}

	return jQuery;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module)))

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(17),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hashClear = __webpack_require__(333),
    hashDelete = __webpack_require__(334),
    hashGet = __webpack_require__(335),
    hashHas = __webpack_require__(336),
    hashSet = __webpack_require__(337);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(17),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(17),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MapCache = __webpack_require__(60),
    setCacheAdd = __webpack_require__(359),
    setCacheHas = __webpack_require__(360);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache();
    while (++index < length) {
        this.add(values[index]);
    }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getNative = __webpack_require__(17),
    root = __webpack_require__(10);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseProperty = __webpack_require__(97);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var copyObject = __webpack_require__(28),
    keys = __webpack_require__(23);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var copyObject = __webpack_require__(28),
    keysIn = __webpack_require__(77);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Stack = __webpack_require__(61),
    arrayEach = __webpack_require__(90),
    assignValue = __webpack_require__(39),
    baseAssign = __webpack_require__(276),
    baseAssignIn = __webpack_require__(277),
    cloneBuffer = __webpack_require__(311),
    copyArray = __webpack_require__(316),
    copySymbols = __webpack_require__(317),
    copySymbolsIn = __webpack_require__(318),
    getAllKeys = __webpack_require__(101),
    getAllKeysIn = __webpack_require__(328),
    getTag = __webpack_require__(29),
    initCloneArray = __webpack_require__(338),
    initCloneByTag = __webpack_require__(339),
    initCloneObject = __webpack_require__(340),
    isArray = __webpack_require__(4),
    isBuffer = __webpack_require__(75),
    isMap = __webpack_require__(381),
    isObject = __webpack_require__(13),
    isSet = __webpack_require__(382),
    keys = __webpack_require__(23);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(13);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();

module.exports = baseCreate;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseEach = __webpack_require__(27);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function (value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseEach = __webpack_require__(27);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function (value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while (fromRight ? index-- : ++index < length) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayPush = __webpack_require__(62),
    isFlattenable = __webpack_require__(341);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createBaseFor = __webpack_require__(322);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(22),
    isObjectLike = __webpack_require__(14);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Stack = __webpack_require__(61),
    equalArrays = __webpack_require__(99),
    equalByTag = __webpack_require__(325),
    equalObjects = __webpack_require__(326),
    getTag = __webpack_require__(29),
    isArray = __webpack_require__(4),
    isBuffer = __webpack_require__(75),
    isTypedArray = __webpack_require__(114);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getTag = __webpack_require__(29),
    isObjectLike = __webpack_require__(14);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Stack = __webpack_require__(61),
    baseIsEqual = __webpack_require__(65);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isFunction = __webpack_require__(113),
    isMasked = __webpack_require__(343),
    isObject = __webpack_require__(13),
    toSource = __webpack_require__(110);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getTag = __webpack_require__(29),
    isObjectLike = __webpack_require__(14);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(22),
    isLength = __webpack_require__(76),
    isObjectLike = __webpack_require__(14);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(13),
    isPrototype = __webpack_require__(71),
    nativeKeysIn = __webpack_require__(357);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseEach = __webpack_require__(27),
    isArrayLike = __webpack_require__(18);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function (value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsMatch = __webpack_require__(289),
    getMatchData = __webpack_require__(329),
    matchesStrictComparable = __webpack_require__(106);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function (object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsEqual = __webpack_require__(65),
    get = __webpack_require__(379),
    hasIn = __webpack_require__(112),
    isKey = __webpack_require__(70),
    isStrictComparable = __webpack_require__(105),
    matchesStrictComparable = __webpack_require__(106),
    toKey = __webpack_require__(30);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function (object) {
    var objValue = get(object, path);
    return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var basePickBy = __webpack_require__(298),
    hasIn = __webpack_require__(112);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function (value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGet = __webpack_require__(64),
    baseSet = __webpack_require__(302),
    castPath = __webpack_require__(41);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
    var index = -1,
        length = paths.length,
        result = {};

    while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
        }
    }
    return result;
}

module.exports = basePickBy;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGet = __webpack_require__(64);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function (object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function (value, index, collection) {
    accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var identity = __webpack_require__(46),
    overRest = __webpack_require__(108),
    setToString = __webpack_require__(109);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assignValue = __webpack_require__(39),
    castPath = __webpack_require__(41),
    isIndex = __webpack_require__(43),
    isObject = __webpack_require__(13),
    toKey = __webpack_require__(30);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var constant = __webpack_require__(374),
    defineProperty = __webpack_require__(98),
    identity = __webpack_require__(46);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : length + start;
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : end - start >>> 0;
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(21),
    arrayMap = __webpack_require__(93),
    isArray = __webpack_require__(4),
    isSymbol = __webpack_require__(47);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}

module.exports = baseToString;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */
function baseZipObject(props, values, assignFunc) {
  var index = -1,
      length = props.length,
      valsLength = values.length,
      result = {};

  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

module.exports = baseZipObject;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var identity = __webpack_require__(46);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseSlice = __webpack_require__(304);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}

module.exports = castSlice;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var root = __webpack_require__(10);

/** Detect free variable `exports`. */
var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)(module)))

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cloneArrayBuffer = __webpack_require__(67);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(21);

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cloneArrayBuffer = __webpack_require__(67);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var copyObject = __webpack_require__(28),
    getSymbols = __webpack_require__(68);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var copyObject = __webpack_require__(28),
    getSymbolsIn = __webpack_require__(103);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var root = __webpack_require__(10);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseRest = __webpack_require__(301),
    isIterateeCall = __webpack_require__(104);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArrayLike = __webpack_require__(18);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var castSlice = __webpack_require__(310),
    hasUnicode = __webpack_require__(69),
    stringToArray = __webpack_require__(369),
    toString = __webpack_require__(49);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function (string) {
    string = toString(string);

    var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;

    var chr = strSymbols ? strSymbols[0] : string.charAt(0);

    var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIteratee = __webpack_require__(16),
    isArrayLike = __webpack_require__(18),
    keys = __webpack_require__(23);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function (collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function predicate(key) {
        return iteratee(iterable[key], key, iterable);
      };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(21),
    Uint8Array = __webpack_require__(89),
    eq = __webpack_require__(45),
    equalArrays = __webpack_require__(99),
    mapToArray = __webpack_require__(354),
    setToArray = __webpack_require__(361);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getAllKeys = __webpack_require__(101);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var flatten = __webpack_require__(378),
    overRest = __webpack_require__(108),
    setToString = __webpack_require__(109);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetAllKeys = __webpack_require__(95),
    getSymbolsIn = __webpack_require__(103),
    keysIn = __webpack_require__(77);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isStrictComparable = __webpack_require__(105),
    keys = __webpack_require__(23);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
    var result = keys(object),
        length = result.length;

    while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
    }
    return result;
}

module.exports = getMatchData;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(21);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var castPath = __webpack_require__(41),
    isArguments = __webpack_require__(74),
    isArray = __webpack_require__(4),
    isIndex = __webpack_require__(43),
    isLength = __webpack_require__(76),
    toKey = __webpack_require__(30);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}

module.exports = hasPath;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__(44);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__(44);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__(44);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var nativeCreate = __webpack_require__(44);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cloneArrayBuffer = __webpack_require__(67),
    cloneDataView = __webpack_require__(312),
    cloneRegExp = __webpack_require__(313),
    cloneSymbol = __webpack_require__(314),
    cloneTypedArray = __webpack_require__(315);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag:case float64Tag:
    case int8Tag:case int16Tag:case int32Tag:
    case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor();

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor();

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseCreate = __webpack_require__(279),
    getPrototype = __webpack_require__(102),
    isPrototype = __webpack_require__(71);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}

module.exports = initCloneObject;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Symbol = __webpack_require__(21),
    isArguments = __webpack_require__(74),
    isArray = __webpack_require__(4);

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
    return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var coreJsData = __webpack_require__(319);

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__(40);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__(40);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__(40);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assocIndexOf = __webpack_require__(40);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Hash = __webpack_require__(265),
    ListCache = __webpack_require__(38),
    Map = __webpack_require__(59);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__(42);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__(42);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__(42);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getMapData = __webpack_require__(42);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var memoize = __webpack_require__(386);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function (key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var overArg = __webpack_require__(107);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ListCache = __webpack_require__(38);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

module.exports = stackClear;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ListCache = __webpack_require__(38),
    Map = __webpack_require__(59),
    MapCache = __webpack_require__(60);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asciiSize = __webpack_require__(274),
    hasUnicode = __webpack_require__(69),
    unicodeSize = __webpack_require__(371);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
    return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
}

module.exports = stringSize;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asciiToArray = __webpack_require__(275),
    hasUnicode = __webpack_require__(69),
    unicodeToArray = __webpack_require__(372);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
}

module.exports = stringToArray;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var memoizeCapped = __webpack_require__(355);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function (string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
      result.push('');
    }
  string.replace(rePropName, function (match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
  });
  return result;
});

module.exports = stringToPath;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
        ++result;
    }
    return result;
}

module.exports = unicodeSize;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
    return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = __webpack_require__(49),
    upperFirst = __webpack_require__(393);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

module.exports = constant;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(111);

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toString = __webpack_require__(49);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = toString(string);
  return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
}

module.exports = escapeRegExp;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayEvery = __webpack_require__(271),
    baseEvery = __webpack_require__(280),
    baseIteratee = __webpack_require__(16),
    isArray = __webpack_require__(4),
    isIterateeCall = __webpack_require__(104);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseFlatten = __webpack_require__(283);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGet = __webpack_require__(64);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsEqual = __webpack_require__(65);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsMap = __webpack_require__(288),
    baseUnary = __webpack_require__(66),
    nodeUtil = __webpack_require__(72);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseIsSet = __webpack_require__(291),
    baseUnary = __webpack_require__(66),
    nodeUtil = __webpack_require__(72);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseGetTag = __webpack_require__(22),
    isArray = __webpack_require__(4),
    isObjectLike = __webpack_require__(14);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
    return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
}

module.exports = isString;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var arrayMap = __webpack_require__(93),
    baseIteratee = __webpack_require__(16),
    baseMap = __webpack_require__(294),
    isArray = __webpack_require__(4);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseAssignValue = __webpack_require__(63),
    baseForOwn = __webpack_require__(94),
    baseIteratee = __webpack_require__(16);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function (value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MapCache = __webpack_require__(60);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function memoized() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var basePick = __webpack_require__(297),
    flatRest = __webpack_require__(327);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function (object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseProperty = __webpack_require__(97),
    basePropertyDeep = __webpack_require__(299),
    isKey = __webpack_require__(70),
    toKey = __webpack_require__(30);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toNumber = __webpack_require__(392);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toFinite = __webpack_require__(390);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? remainder ? result - remainder : result : 0;
}

module.exports = toInteger;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = __webpack_require__(13),
    isSymbol = __webpack_require__(47);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = toNumber;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createCaseFirst = __webpack_require__(323);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assignValue = __webpack_require__(39),
    baseZipObject = __webpack_require__(307);

/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return baseZipObject(props || [], values || [], assignValue);
}

module.exports = zipObject;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {

/**!
 * AngularJS file upload directives and services. Supports: file upload/drop/paste, resume, cancel/abort,
 * progress, resize, thumbnail, preview, validation and CORS
 * FileAPI Flash shim for old browsers not supporting FormData
 * @author  Danial  <danial.farid@gmail.com>
 * @version 12.2.13
 */

(function () {
  /** @namespace FileAPI.noContentTimeout */

  function patchXHR(fnName, newFn) {
    window.XMLHttpRequest.prototype[fnName] = newFn(window.XMLHttpRequest.prototype[fnName]);
  }

  function redefineProp(xhr, prop, fn) {
    try {
      Object.defineProperty(xhr, prop, { get: fn });
    } catch (e) {/*ignore*/
    }
  }

  if (!window.FileAPI) {
    window.FileAPI = {};
  }

  if (!window.XMLHttpRequest) {
    throw 'AJAX is not supported. XMLHttpRequest is not defined.';
  }

  FileAPI.shouldLoad = !window.FormData || FileAPI.forceLoad;
  if (FileAPI.shouldLoad) {
    var initializeUploadListener = function initializeUploadListener(xhr) {
      if (!xhr.__listeners) {
        if (!xhr.upload) xhr.upload = {};
        xhr.__listeners = [];
        var origAddEventListener = xhr.upload.addEventListener;
        xhr.upload.addEventListener = function (t, fn) {
          xhr.__listeners[t] = fn;
          if (origAddEventListener) origAddEventListener.apply(this, arguments);
        };
      }
    };

    patchXHR('open', function (orig) {
      return function (m, url, b) {
        initializeUploadListener(this);
        this.__url = url;
        try {
          orig.apply(this, [m, url, b]);
        } catch (e) {
          if (e.message.indexOf('Access is denied') > -1) {
            this.__origError = e;
            orig.apply(this, [m, '_fix_for_ie_crossdomain__', b]);
          }
        }
      };
    });

    patchXHR('getResponseHeader', function (orig) {
      return function (h) {
        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(h) : orig == null ? null : orig.apply(this, [h]);
      };
    });

    patchXHR('getAllResponseHeaders', function (orig) {
      return function () {
        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : orig == null ? null : orig.apply(this);
      };
    });

    patchXHR('abort', function (orig) {
      return function () {
        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : orig == null ? null : orig.apply(this);
      };
    });

    patchXHR('setRequestHeader', function (orig) {
      return function (header, value) {
        if (header === '__setXHR_') {
          initializeUploadListener(this);
          var val = value(this);
          // fix for angular < 1.2.0
          if (val instanceof Function) {
            val(this);
          }
        } else {
          this.__requestHeaders = this.__requestHeaders || {};
          this.__requestHeaders[header] = value;
          orig.apply(this, arguments);
        }
      };
    });

    patchXHR('send', function (orig) {
      return function () {
        var xhr = this;
        if (arguments[0] && arguments[0].__isFileAPIShim) {
          var formData = arguments[0];
          var config = {
            url: xhr.__url,
            jsonp: false, //removes the callback form param
            cache: true, //removes the ?fileapiXXX in the url
            complete: function complete(err, fileApiXHR) {
              if (err && angular.isString(err) && err.indexOf('#2174') !== -1) {
                // this error seems to be fine the file is being uploaded properly.
                err = null;
              }
              xhr.__completed = true;
              if (!err && xhr.__listeners.load) xhr.__listeners.load({
                type: 'load',
                loaded: xhr.__loaded,
                total: xhr.__total,
                target: xhr,
                lengthComputable: true
              });
              if (!err && xhr.__listeners.loadend) xhr.__listeners.loadend({
                type: 'loadend',
                loaded: xhr.__loaded,
                total: xhr.__total,
                target: xhr,
                lengthComputable: true
              });
              if (err === 'abort' && xhr.__listeners.abort) xhr.__listeners.abort({
                type: 'abort',
                loaded: xhr.__loaded,
                total: xhr.__total,
                target: xhr,
                lengthComputable: true
              });
              if (fileApiXHR.status !== undefined) redefineProp(xhr, 'status', function () {
                return fileApiXHR.status === 0 && err && err !== 'abort' ? 500 : fileApiXHR.status;
              });
              if (fileApiXHR.statusText !== undefined) redefineProp(xhr, 'statusText', function () {
                return fileApiXHR.statusText;
              });
              redefineProp(xhr, 'readyState', function () {
                return 4;
              });
              if (fileApiXHR.response !== undefined) redefineProp(xhr, 'response', function () {
                return fileApiXHR.response;
              });
              var resp = fileApiXHR.responseText || (err && fileApiXHR.status === 0 && err !== 'abort' ? err : undefined);
              redefineProp(xhr, 'responseText', function () {
                return resp;
              });
              redefineProp(xhr, 'response', function () {
                return resp;
              });
              if (err) redefineProp(xhr, 'err', function () {
                return err;
              });
              xhr.__fileApiXHR = fileApiXHR;
              if (xhr.onreadystatechange) xhr.onreadystatechange();
              if (xhr.onload) xhr.onload();
            },
            progress: function progress(e) {
              e.target = xhr;
              if (xhr.__listeners.progress) xhr.__listeners.progress(e);
              xhr.__total = e.total;
              xhr.__loaded = e.loaded;
              if (e.total === e.loaded) {
                // fix flash issue that doesn't call complete if there is no response text from the server
                var _this = this;
                setTimeout(function () {
                  if (!xhr.__completed) {
                    xhr.getAllResponseHeaders = function () {};
                    _this.complete(null, { status: 204, statusText: 'No Content' });
                  }
                }, FileAPI.noContentTimeout || 10000);
              }
            },
            headers: xhr.__requestHeaders
          };
          config.data = {};
          config.files = {};
          for (var i = 0; i < formData.data.length; i++) {
            var item = formData.data[i];
            if (item.val != null && item.val.name != null && item.val.size != null && item.val.type != null) {
              config.files[item.key] = item.val;
            } else {
              config.data[item.key] = item.val;
            }
          }

          setTimeout(function () {
            if (!FileAPI.hasFlash) {
              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
            }
            xhr.__fileApiXHR = FileAPI.upload(config);
          }, 1);
        } else {
          if (this.__origError) {
            throw this.__origError;
          }
          orig.apply(xhr, arguments);
        }
      };
    });
    window.XMLHttpRequest.__isFileAPIShim = true;
    window.FormData = FormData = function FormData() {
      return {
        append: function append(key, val, name) {
          if (val.__isFileAPIBlobShim) {
            val = val.data[0];
          }
          this.data.push({
            key: key,
            val: val,
            name: name
          });
        },
        data: [],
        __isFileAPIShim: true
      };
    };

    window.Blob = Blob = function Blob(b) {
      return {
        data: b,
        __isFileAPIBlobShim: true
      };
    };
  }
})();

(function () {
  /** @namespace FileAPI.forceLoad */
  /** @namespace window.FileAPI.jsUrl */
  /** @namespace window.FileAPI.jsPath */

  function isInputTypeFile(elem) {
    return elem[0].tagName.toLowerCase() === 'input' && elem.attr('type') && elem.attr('type').toLowerCase() === 'file';
  }

  function hasFlash() {
    try {
      var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
      if (fo) return true;
    } catch (e) {
      if (navigator.mimeTypes['application/x-shockwave-flash'] !== undefined) return true;
    }
    return false;
  }

  function getOffset(obj) {
    var left = 0,
        top = 0;

    if (window.jQuery) {
      return jQuery(obj).offset();
    }

    if (obj.offsetParent) {
      do {
        left += obj.offsetLeft - obj.scrollLeft;
        top += obj.offsetTop - obj.scrollTop;
        obj = obj.offsetParent;
      } while (obj);
    }
    return {
      left: left,
      top: top
    };
  }

  if (FileAPI.shouldLoad) {
    FileAPI.hasFlash = hasFlash();

    //load FileAPI
    if (FileAPI.forceLoad) {
      FileAPI.html5 = false;
    }

    if (!FileAPI.upload) {
      var jsUrl,
          basePath,
          script = document.createElement('script'),
          allScripts = document.getElementsByTagName('script'),
          i,
          index,
          src;
      if (window.FileAPI.jsUrl) {
        jsUrl = window.FileAPI.jsUrl;
      } else if (window.FileAPI.jsPath) {
        basePath = window.FileAPI.jsPath;
      } else {
        for (i = 0; i < allScripts.length; i++) {
          src = allScripts[i].src;
          index = src.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/);
          if (index > -1) {
            basePath = src.substring(0, index + 1);
            break;
          }
        }
      }

      if (FileAPI.staticPath == null) FileAPI.staticPath = basePath;
      script.setAttribute('src', jsUrl || basePath + 'FileAPI.min.js');
      document.getElementsByTagName('head')[0].appendChild(script);
    }

    FileAPI.ngfFixIE = function (elem, fileElem, changeFn) {
      if (!hasFlash()) {
        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
      }
      var fixInputStyle = function fixInputStyle() {
        var label = fileElem.parent();
        if (elem.attr('disabled')) {
          if (label) label.removeClass('js-fileapi-wrapper');
        } else {
          if (!fileElem.attr('__ngf_flash_')) {
            fileElem.unbind('change');
            fileElem.unbind('click');
            fileElem.bind('change', function (evt) {
              fileApiChangeFn.apply(this, [evt]);
              changeFn.apply(this, [evt]);
            });
            fileElem.attr('__ngf_flash_', 'true');
          }
          label.addClass('js-fileapi-wrapper');
          if (!isInputTypeFile(elem)) {
            label.css('position', 'absolute').css('top', getOffset(elem[0]).top + 'px').css('left', getOffset(elem[0]).left + 'px').css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px').css('filter', 'alpha(opacity=0)').css('display', elem.css('display')).css('overflow', 'hidden').css('z-index', '900000').css('visibility', 'visible');
            fileElem.css('width', elem[0].offsetWidth + 'px').css('height', elem[0].offsetHeight + 'px').css('position', 'absolute').css('top', '0px').css('left', '0px');
          }
        }
      };

      elem.bind('mouseenter', fixInputStyle);

      var fileApiChangeFn = function fileApiChangeFn(evt) {
        var files = FileAPI.getFiles(evt);
        //just a double check for #233
        for (var i = 0; i < files.length; i++) {
          if (files[i].size === undefined) files[i].size = 0;
          if (files[i].name === undefined) files[i].name = 'file';
          if (files[i].type === undefined) files[i].type = 'undefined';
        }
        if (!evt.target) {
          evt.target = {};
        }
        evt.target.files = files;
        // if evt.target.files is not writable use helper field
        if (evt.target.files !== files) {
          evt.__files_ = files;
        }
        (evt.__files_ || evt.target.files).item = function (i) {
          return (evt.__files_ || evt.target.files)[i] || null;
        };
      };
    };

    FileAPI.disableFileInput = function (elem, disable) {
      if (disable) {
        elem.removeClass('js-fileapi-wrapper');
      } else {
        elem.addClass('js-fileapi-wrapper');
      }
    };
  }
})();

if (!window.FileReader) {
  window.FileReader = function () {
    var _this = this,
        loadStarted = false;
    this.listeners = {};
    this.addEventListener = function (type, fn) {
      _this.listeners[type] = _this.listeners[type] || [];
      _this.listeners[type].push(fn);
    };
    this.removeEventListener = function (type, fn) {
      if (_this.listeners[type]) _this.listeners[type].splice(_this.listeners[type].indexOf(fn), 1);
    };
    this.dispatchEvent = function (evt) {
      var list = _this.listeners[evt.type];
      if (list) {
        for (var i = 0; i < list.length; i++) {
          list[i].call(_this, evt);
        }
      }
    };
    this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;

    var constructEvent = function constructEvent(type, evt) {
      var e = { type: type, target: _this, loaded: evt.loaded, total: evt.total, error: evt.error };
      if (evt.result != null) e.target.result = evt.result;
      return e;
    };
    var listener = function listener(evt) {
      if (!loadStarted) {
        loadStarted = true;
        if (_this.onloadstart) _this.onloadstart(constructEvent('loadstart', evt));
      }
      var e;
      if (evt.type === 'load') {
        if (_this.onloadend) _this.onloadend(constructEvent('loadend', evt));
        e = constructEvent('load', evt);
        if (_this.onload) _this.onload(e);
        _this.dispatchEvent(e);
      } else if (evt.type === 'progress') {
        e = constructEvent('progress', evt);
        if (_this.onprogress) _this.onprogress(e);
        _this.dispatchEvent(e);
      } else {
        e = constructEvent('error', evt);
        if (_this.onerror) _this.onerror(e);
        _this.dispatchEvent(e);
      }
    };
    this.readAsDataURL = function (file) {
      FileAPI.readAsDataURL(file, listener);
    };
    this.readAsText = function (file) {
      FileAPI.readAsText(file, listener);
    };
  };
}

/**!
 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
 * progress, resize, thumbnail, preview, validation and CORS
 * @author  Danial  <danial.farid@gmail.com>
 * @version 12.2.13
 */

if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
  window.XMLHttpRequest.prototype.setRequestHeader = function (orig) {
    return function (header, value) {
      if (header === '__setXHR_') {
        var val = value(this);
        // fix for angular < 1.2.0
        if (val instanceof Function) {
          val(this);
        }
      } else {
        orig.apply(this, arguments);
      }
    };
  }(window.XMLHttpRequest.prototype.setRequestHeader);
}

var ngFileUpload = angular.module('ngFileUpload', []);

ngFileUpload.version = '12.2.13';

ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
  var upload = this;
  upload.promisesCount = 0;

  this.isResumeSupported = function () {
    return window.Blob && window.Blob.prototype.slice;
  };

  var resumeSupported = this.isResumeSupported();

  function sendHttp(config) {
    config.method = config.method || 'POST';
    config.headers = config.headers || {};

    var deferred = config._deferred = config._deferred || $q.defer();
    var promise = deferred.promise;

    function notifyProgress(e) {
      if (deferred.notify) {
        deferred.notify(e);
      }
      if (promise.progressFunc) {
        $timeout(function () {
          promise.progressFunc(e);
        });
      }
    }

    function getNotifyEvent(n) {
      if (config._start != null && resumeSupported) {
        return {
          loaded: n.loaded + config._start,
          total: config._file && config._file.size || n.total,
          type: n.type, config: config,
          lengthComputable: true, target: n.target
        };
      } else {
        return n;
      }
    }

    if (!config.disableProgress) {
      config.headers.__setXHR_ = function () {
        return function (xhr) {
          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
          config.__XHR = xhr;
          if (config.xhrFn) config.xhrFn(xhr);
          xhr.upload.addEventListener('progress', function (e) {
            e.config = config;
            notifyProgress(getNotifyEvent(e));
          }, false);
          //fix for firefox not firing upload progress end, also IE8-9
          xhr.upload.addEventListener('load', function (e) {
            if (e.lengthComputable) {
              e.config = config;
              notifyProgress(getNotifyEvent(e));
            }
          }, false);
        };
      };
    }

    function uploadWithAngular() {
      $http(config).then(function (r) {
        if (resumeSupported && config._chunkSize && !config._finished && config._file) {
          var fileSize = config._file && config._file.size || 0;
          notifyProgress({
            loaded: Math.min(config._end, fileSize),
            total: fileSize,
            config: config,
            type: 'progress'
          });
          upload.upload(config, true);
        } else {
          if (config._finished) delete config._finished;
          deferred.resolve(r);
        }
      }, function (e) {
        deferred.reject(e);
      }, function (n) {
        deferred.notify(n);
      });
    }

    if (!resumeSupported) {
      uploadWithAngular();
    } else if (config._chunkSize && config._end && !config._finished) {
      config._start = config._end;
      config._end += config._chunkSize;
      uploadWithAngular();
    } else if (config.resumeSizeUrl) {
      $http.get(config.resumeSizeUrl).then(function (resp) {
        if (config.resumeSizeResponseReader) {
          config._start = config.resumeSizeResponseReader(resp.data);
        } else {
          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
        }
        if (config._chunkSize) {
          config._end = config._start + config._chunkSize;
        }
        uploadWithAngular();
      }, function (e) {
        throw e;
      });
    } else if (config.resumeSize) {
      config.resumeSize().then(function (size) {
        config._start = size;
        if (config._chunkSize) {
          config._end = config._start + config._chunkSize;
        }
        uploadWithAngular();
      }, function (e) {
        throw e;
      });
    } else {
      if (config._chunkSize) {
        config._start = 0;
        config._end = config._start + config._chunkSize;
      }
      uploadWithAngular();
    }

    promise.success = function (fn) {
      promise.then(function (response) {
        fn(response.data, response.status, response.headers, config);
      });
      return promise;
    };

    promise.error = function (fn) {
      promise.then(null, function (response) {
        fn(response.data, response.status, response.headers, config);
      });
      return promise;
    };

    promise.progress = function (fn) {
      promise.progressFunc = fn;
      promise.then(null, null, function (n) {
        fn(n);
      });
      return promise;
    };
    promise.abort = promise.pause = function () {
      if (config.__XHR) {
        $timeout(function () {
          config.__XHR.abort();
        });
      }
      return promise;
    };
    promise.xhr = function (fn) {
      config.xhrFn = function (origXhrFn) {
        return function () {
          if (origXhrFn) origXhrFn.apply(promise, arguments);
          fn.apply(promise, arguments);
        };
      }(config.xhrFn);
      return promise;
    };

    upload.promisesCount++;
    if (promise['finally'] && promise['finally'] instanceof Function) {
      promise['finally'](function () {
        upload.promisesCount--;
      });
    }
    return promise;
  }

  this.isUploadInProgress = function () {
    return upload.promisesCount > 0;
  };

  this.rename = function (file, name) {
    file.ngfName = name;
    return file;
  };

  this.jsonBlob = function (val) {
    if (val != null && !angular.isString(val)) {
      val = JSON.stringify(val);
    }
    var blob = new window.Blob([val], { type: 'application/json' });
    blob._ngfBlob = true;
    return blob;
  };

  this.json = function (val) {
    return angular.toJson(val);
  };

  function copy(obj) {
    var clone = {};
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        clone[key] = obj[key];
      }
    }
    return clone;
  }

  this.isFile = function (file) {
    return file != null && (file instanceof window.Blob || file.flashId && file.name && file.size);
  };

  this.upload = function (config, internal) {
    function toResumeFile(file, formData) {
      if (file._ngfBlob) return file;
      config._file = config._file || file;
      if (config._start != null && resumeSupported) {
        if (config._end && config._end >= file.size) {
          config._finished = true;
          config._end = file.size;
        }
        var slice = file.slice(config._start, config._end || file.size);
        slice.name = file.name;
        slice.ngfName = file.ngfName;
        if (config._chunkSize) {
          formData.append('_chunkSize', config._chunkSize);
          formData.append('_currentChunkSize', config._end - config._start);
          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
          formData.append('_totalSize', config._file.size);
        }
        return slice;
      }
      return file;
    }

    function addFieldToFormData(formData, val, key) {
      if (val !== undefined) {
        if (angular.isDate(val)) {
          val = val.toISOString();
        }
        if (angular.isString(val)) {
          formData.append(key, val);
        } else if (upload.isFile(val)) {
          var file = toResumeFile(val, formData);
          var split = key.split(',');
          if (split[1]) {
            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
            key = split[0];
          }
          config._fileKey = config._fileKey || key;
          formData.append(key, file, file.ngfName || file.name);
        } else {
          if (angular.isObject(val)) {
            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;

            val.$$ngfCircularDetection = true;
            try {
              for (var k in val) {
                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
                  if (val.length && parseInt(k) > -1) {
                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
                  }
                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
                }
              }
            } finally {
              delete val.$$ngfCircularDetection;
            }
          } else {
            formData.append(key, val);
          }
        }
      }
    }

    function digestConfig() {
      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

      config.headers = config.headers || {};
      config.headers['Content-Type'] = undefined;
      config.transformRequest = config.transformRequest ? angular.isArray(config.transformRequest) ? config.transformRequest : [config.transformRequest] : [];
      config.transformRequest.push(function (data) {
        var formData = new window.FormData(),
            key;
        data = data || config.fields || {};
        if (config.file) {
          data.file = config.file;
        }
        for (key in data) {
          if (data.hasOwnProperty(key)) {
            var val = data[key];
            if (config.formDataAppender) {
              config.formDataAppender(formData, key, val);
            } else {
              addFieldToFormData(formData, val, key);
            }
          }
        }

        return formData;
      });
    }

    if (!internal) config = copy(config);
    if (!config._isDigested) {
      config._isDigested = true;
      digestConfig();
    }

    return sendHttp(config);
  };

  this.http = function (config) {
    config = copy(config);
    config.transformRequest = config.transformRequest || function (data) {
      if (window.ArrayBuffer && data instanceof window.ArrayBuffer || data instanceof window.Blob) {
        return data;
      }
      return $http.defaults.transformRequest[0].apply(this, arguments);
    };
    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

    return sendHttp(config);
  };

  this.translateScalars = function (str) {
    if (angular.isString(str)) {
      if (str.search(/kb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1024);
      } else if (str.search(/mb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1048576);
      } else if (str.search(/gb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
      } else if (str.search(/b/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1));
      } else if (str.search(/s/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1));
      } else if (str.search(/m/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1) * 60);
      } else if (str.search(/h/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1) * 3600);
      }
    }
    return str;
  };

  this.urlToBlob = function (url) {
    var defer = $q.defer();
    $http({ url: url, method: 'get', responseType: 'arraybuffer' }).then(function (resp) {
      var arrayBufferView = new Uint8Array(resp.data);
      var type = resp.headers('content-type') || 'image/WebP';
      var blob = new window.Blob([arrayBufferView], { type: type });
      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
      if (matches.length > 1) {
        blob.name = matches[1];
      }
      defer.resolve(blob);
    }, function (e) {
      defer.reject(e);
    });
    return defer.promise;
  };

  this.setDefaults = function (defaults) {
    this.defaults = defaults || {};
  };

  this.defaults = {};
  this.version = ngFileUpload.version;
}]);

ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
  var upload = UploadExif;
  upload.getAttrWithDefaults = function (attr, name) {
    if (attr[name] != null) return attr[name];
    var def = upload.defaults[name];
    return def == null ? def : angular.isString(def) ? def : JSON.stringify(def);
  };

  upload.attrGetter = function (name, attr, scope, params) {
    var attrVal = this.getAttrWithDefaults(attr, name);
    if (scope) {
      try {
        if (params) {
          return $parse(attrVal)(scope, params);
        } else {
          return $parse(attrVal)(scope);
        }
      } catch (e) {
        // hangle string value without single qoute
        if (name.search(/min|max|pattern/i)) {
          return attrVal;
        } else {
          throw e;
        }
      }
    } else {
      return attrVal;
    }
  };

  upload.shouldUpdateOn = function (type, attr, scope) {
    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
    if (modelOptions && modelOptions.updateOn) {
      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
    }
    return true;
  };

  upload.emptyPromise = function () {
    var d = $q.defer();
    var args = arguments;
    $timeout(function () {
      d.resolve.apply(d, args);
    });
    return d.promise;
  };

  upload.rejectPromise = function () {
    var d = $q.defer();
    var args = arguments;
    $timeout(function () {
      d.reject.apply(d, args);
    });
    return d.promise;
  };

  upload.happyPromise = function (promise, data) {
    var d = $q.defer();
    promise.then(function (result) {
      d.resolve(result);
    }, function (error) {
      $timeout(function () {
        throw error;
      });
      d.resolve(data);
    });
    return d.promise;
  };

  function applyExifRotations(files, attr, scope) {
    var promises = [upload.emptyPromise()];
    angular.forEach(files, function (f, i) {
      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, { $file: f })) {
        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
          files.splice(i, 1, fixedFile);
        }));
      }
    });
    return $q.all(promises);
  }

  function resizeFile(files, attr, scope, ngModel) {
    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
    if (resizeVal instanceof Function) {
      var defer = $q.defer();
      return resizeVal(files).then(function (p) {
        resizeWithParams(p, files, attr, scope, ngModel).then(function (r) {
          defer.resolve(r);
        }, function (e) {
          defer.reject(e);
        });
      }, function (e) {
        defer.reject(e);
      });
    } else {
      return resizeWithParams(resizeVal, files, attr, scope, ngModel);
    }
  }

  function resizeWithParams(params, files, attr, scope, ngModel) {
    var promises = [upload.emptyPromise()];

    function handleFile(f, i) {
      if (f.type.indexOf('image') === 0) {
        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
        params.resizeIf = function (width, height) {
          return upload.attrGetter('ngfResizeIf', attr, scope, { $width: width, $height: height, $file: f });
        };
        var promise = upload.resize(f, params);
        promises.push(promise);
        promise.then(function (resizedFile) {
          files.splice(i, 1, resizedFile);
        }, function (e) {
          f.$error = 'resize';
          (f.$errorMessages = f.$errorMessages || {}).resize = true;
          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
          ngModel.$ngfValidations.push({ name: 'resize', valid: false });
          upload.applyModelValidation(ngModel, files);
        });
      }
    }

    for (var i = 0; i < files.length; i++) {
      handleFile(files[i], i);
    }
    return $q.all(promises);
  }

  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
      attr.$$ngfPrevValidFiles = files;
      attr.$$ngfPrevInvalidFiles = invalidFiles;
      var file = files && files.length ? files[0] : null;
      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;

      if (ngModel) {
        upload.applyModelValidation(ngModel, files);
        ngModel.$setViewValue(isSingleModel ? file : files);
      }

      if (fileChange) {
        $parse(fileChange)(scope, {
          $files: files,
          $file: file,
          $newFiles: newFiles,
          $duplicateFiles: dupFiles,
          $invalidFiles: invalidFiles,
          $invalidFile: invalidFile,
          $event: evt
        });
      }

      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
      if (invalidModel) {
        $timeout(function () {
          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
        });
      }
      $timeout(function () {
        // scope apply changes
      });
    }

    var allNewFiles,
        dupFiles = [],
        prevValidFiles,
        prevInvalidFiles,
        invalids = [],
        valids = [];

    function removeDuplicates() {
      function equals(f1, f2) {
        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) && f1.type === f2.type;
      }

      function isInPrevFiles(f) {
        var j;
        for (j = 0; j < prevValidFiles.length; j++) {
          if (equals(f, prevValidFiles[j])) {
            return true;
          }
        }
        for (j = 0; j < prevInvalidFiles.length; j++) {
          if (equals(f, prevInvalidFiles[j])) {
            return true;
          }
        }
        return false;
      }

      if (files) {
        allNewFiles = [];
        dupFiles = [];
        for (var i = 0; i < files.length; i++) {
          if (isInPrevFiles(files[i])) {
            dupFiles.push(files[i]);
          } else {
            allNewFiles.push(files[i]);
          }
        }
      }
    }

    function toArray(v) {
      return angular.isArray(v) ? v : [v];
    }

    function resizeAndUpdate() {
      function updateModel() {
        $timeout(function () {
          update(keep ? prevValidFiles.concat(valids) : valids, keep ? prevInvalidFiles.concat(invalids) : invalids, files, dupFiles, isSingleModel);
        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
      }

      var resizingFiles = validateAfterResize ? allNewFiles : valids;
      resizeFile(resizingFiles, attr, scope, ngModel).then(function () {
        if (validateAfterResize) {
          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope).then(function (validationResult) {
            valids = validationResult.validsFiles;
            invalids = validationResult.invalidsFiles;
            updateModel();
          });
        } else {
          updateModel();
        }
      }, function () {
        for (var i = 0; i < resizingFiles.length; i++) {
          var f = resizingFiles[i];
          if (f.$error === 'resize') {
            var index = valids.indexOf(f);
            if (index > -1) {
              valids.splice(index, 1);
              invalids.push(f);
            }
            updateModel();
          }
        }
      });
    }

    prevValidFiles = attr.$$ngfPrevValidFiles || [];
    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
    if (ngModel && ngModel.$modelValue) {
      prevValidFiles = toArray(ngModel.$modelValue);
    }

    var keep = upload.attrGetter('ngfKeep', attr, scope);
    allNewFiles = (files || []).slice(0);
    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
      removeDuplicates(attr, scope);
    }

    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);

    if (keep && !allNewFiles.length) return;

    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
      $files: files,
      $file: files && files.length ? files[0] : null,
      $newFiles: allNewFiles,
      $duplicateFiles: dupFiles,
      $event: evt
    });

    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);

    var options = upload.attrGetter('ngfModelOptions', attr, scope);
    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope).then(function (validationResult) {
      if (noDelay) {
        update(allNewFiles, [], files, dupFiles, isSingleModel);
      } else {
        if ((!options || !options.allowInvalid) && !validateAfterResize) {
          valids = validationResult.validFiles;
          invalids = validationResult.invalidFiles;
        } else {
          valids = allNewFiles;
        }
        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
          applyExifRotations(valids, attr, scope).then(function () {
            resizeAndUpdate();
          });
        } else {
          resizeAndUpdate();
        }
      }
    });
  };

  return upload;
}]);

ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
  var generatedElems = [];

  function isDelayedClickSupported(ua) {
    // fix for android native browser < 4.4 and safari windows
    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
    if (m && m.length > 2) {
      var v = Upload.defaults.androidFixMinorVersion || 4;
      return parseInt(m[1]) < 4 || parseInt(m[1]) === v && parseInt(m[2]) < v;
    }

    // safari on windows
    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
  }

  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
    /** @namespace attr.ngfSelect */
    /** @namespace attr.ngfChange */
    /** @namespace attr.ngModel */
    /** @namespace attr.ngfModelOptions */
    /** @namespace attr.ngfMultiple */
    /** @namespace attr.ngfCapture */
    /** @namespace attr.ngfValidate */
    /** @namespace attr.ngfKeep */
    var attrGetter = function attrGetter(name, scope) {
      return upload.attrGetter(name, attr, scope);
    };

    function isInputTypeFile() {
      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
    }

    function fileChangeAttr() {
      return attrGetter('ngfChange') || attrGetter('ngfSelect');
    }

    function changeFn(evt) {
      if (upload.shouldUpdateOn('change', attr, scope)) {
        var fileList = evt.__files_ || evt.target && evt.target.files,
            files = [];
        /* Handle duplicate call in  IE11 */
        if (!fileList) return;
        for (var i = 0; i < fileList.length; i++) {
          files.push(fileList[i]);
        }
        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), files.length ? files : null, evt);
      }
    }

    upload.registerModelChangeValidator(ngModel, attr, scope);

    var unwatches = [];
    if (attrGetter('ngfMultiple')) {
      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
      }));
    }
    if (attrGetter('ngfCapture')) {
      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
        fileElem.attr('capture', attrGetter('ngfCapture', scope));
      }));
    }
    if (attrGetter('ngfAccept')) {
      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
        fileElem.attr('accept', attrGetter('ngfAccept', scope));
      }));
    }
    unwatches.push(attr.$observe('accept', function () {
      fileElem.attr('accept', attrGetter('accept'));
    }));
    function bindAttrToFileInput(fileElem, label) {
      function updateId(val) {
        fileElem.attr('id', 'ngf-' + val);
        label.attr('id', 'ngf-label-' + val);
      }

      for (var i = 0; i < elem[0].attributes.length; i++) {
        var attribute = elem[0].attributes[i];
        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
          if (attribute.name === 'id') {
            updateId(attribute.value);
            unwatches.push(attr.$observe('id', updateId));
          } else {
            fileElem.attr(attribute.name, !attribute.value && (attribute.name === 'required' || attribute.name === 'multiple') ? attribute.name : attribute.value);
          }
        }
      }
    }

    function createFileInput() {
      if (isInputTypeFile()) {
        return elem;
      }

      var fileElem = angular.element('<input type="file">');

      var label = angular.element('<label>upload</label>');
      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden').css('width', '0px').css('height', '0px').css('border', 'none').css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
      bindAttrToFileInput(fileElem, label);

      generatedElems.push({ el: elem, ref: label });

      document.body.appendChild(label.append(fileElem)[0]);

      return fileElem;
    }

    function clickHandler(evt) {
      if (elem.attr('disabled')) return false;
      if (attrGetter('ngfSelectDisabled', scope)) return;

      var r = detectSwipe(evt);
      // prevent the click if it is a swipe
      if (r != null) return r;

      resetModel(evt);

      // fix for md when the element is removed from the DOM and added back #460
      try {
        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
          generatedElems.push({ el: elem, ref: fileElem.parent() });
          document.body.appendChild(fileElem.parent()[0]);
          fileElem.bind('change', changeFn);
        }
      } catch (e) {/*ignore*/
      }

      if (isDelayedClickSupported(navigator.userAgent)) {
        setTimeout(function () {
          fileElem[0].click();
        }, 0);
      } else {
        fileElem[0].click();
      }

      return false;
    }

    var initialTouchStartY = 0;
    var initialTouchStartX = 0;

    function detectSwipe(evt) {
      var touches = evt.changedTouches || evt.originalEvent && evt.originalEvent.changedTouches;
      if (touches) {
        if (evt.type === 'touchstart') {
          initialTouchStartX = touches[0].clientX;
          initialTouchStartY = touches[0].clientY;
          return true; // don't block event default
        } else {
          // prevent scroll from triggering event
          if (evt.type === 'touchend') {
            var currentX = touches[0].clientX;
            var currentY = touches[0].clientY;
            if (Math.abs(currentX - initialTouchStartX) > 20 || Math.abs(currentY - initialTouchStartY) > 20) {
              evt.stopPropagation();
              evt.preventDefault();
              return false;
            }
          }
          return true;
        }
      }
    }

    var fileElem = elem;

    function resetModel(evt) {
      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
        fileElem.val(null);
        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
      }
    }

    if (!isInputTypeFile()) {
      fileElem = createFileInput();
    }
    fileElem.bind('change', changeFn);

    if (!isInputTypeFile()) {
      elem.bind('click touchstart touchend', clickHandler);
    } else {
      elem.bind('click', resetModel);
    }

    function ie10SameFileSelectFix(evt) {
      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
        if (!fileElem[0].parentNode) {
          fileElem = null;
          return;
        }
        evt.preventDefault();
        evt.stopPropagation();
        fileElem.unbind('click');
        var clone = fileElem.clone();
        fileElem.replaceWith(clone);
        fileElem = clone;
        fileElem.attr('__ngf_ie10_Fix_', 'true');
        fileElem.bind('change', changeFn);
        fileElem.bind('click', ie10SameFileSelectFix);
        fileElem[0].click();
        return false;
      } else {
        fileElem.removeAttr('__ngf_ie10_Fix_');
      }
    }

    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
      fileElem.bind('click', ie10SameFileSelectFix);
    }

    if (ngModel) ngModel.$formatters.push(function (val) {
      if (val == null || val.length === 0) {
        if (fileElem.val()) {
          fileElem.val(null);
        }
      }
      return val;
    });

    scope.$on('$destroy', function () {
      if (!isInputTypeFile()) fileElem.parent().remove();
      angular.forEach(unwatches, function (unwatch) {
        unwatch();
      });
    });

    $timeout(function () {
      for (var i = 0; i < generatedElems.length; i++) {
        var g = generatedElems[i];
        if (!document.body.contains(g.el[0])) {
          generatedElems.splice(i, 1);
          g.ref.remove();
        }
      }
    });

    if (window.FileAPI && window.FileAPI.ngfFixIE) {
      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
    }
  }

  return {
    restrict: 'AEC',
    require: '?ngModel',
    link: function link(scope, elem, attr, ngModel) {
      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
    }
  };
}]);

(function () {

  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
    var upload = UploadBase;
    upload.base64DataUrl = function (file) {
      if (angular.isArray(file)) {
        var d = $q.defer(),
            count = 0;
        angular.forEach(file, function (f) {
          upload.dataUrl(f, true)['finally'](function () {
            count++;
            if (count === file.length) {
              var urls = [];
              angular.forEach(file, function (ff) {
                urls.push(ff.$ngfDataUrl);
              });
              d.resolve(urls, file);
            }
          });
        });
        return d.promise;
      } else {
        return upload.dataUrl(file, true);
      }
    };
    upload.dataUrl = function (file, disallowObjectUrl) {
      if (!file) return upload.emptyPromise(file, file);
      if (disallowObjectUrl && file.$ngfDataUrl != null || !disallowObjectUrl && file.$ngfBlobUrl != null) {
        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
      }
      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
      if (p) return p;

      var deferred = $q.defer();
      $timeout(function () {
        if (window.FileReader && file && (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) && (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
          //prefer URL.createObjectURL for handling refrences to files of all sizes
          //since it doesn´t build a large string in memory
          var URL = window.URL || window.webkitURL;
          if (URL && URL.createObjectURL && !disallowObjectUrl) {
            var url;
            try {
              url = URL.createObjectURL(file);
            } catch (e) {
              $timeout(function () {
                file.$ngfBlobUrl = '';
                deferred.reject();
              });
              return;
            }
            $timeout(function () {
              file.$ngfBlobUrl = url;
              if (url) {
                deferred.resolve(url, file);
                upload.blobUrls = upload.blobUrls || [];
                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
                upload.blobUrls.push({ url: url, size: file.size });
                upload.blobUrlsTotalSize += file.size || 0;
                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
                  var obj = upload.blobUrls.splice(0, 1)[0];
                  URL.revokeObjectURL(obj.url);
                  upload.blobUrlsTotalSize -= obj.size;
                }
              }
            });
          } else {
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
              $timeout(function () {
                file.$ngfDataUrl = e.target.result;
                deferred.resolve(e.target.result, file);
                $timeout(function () {
                  delete file.$ngfDataUrl;
                }, 1000);
              });
            };
            fileReader.onerror = function () {
              $timeout(function () {
                file.$ngfDataUrl = '';
                deferred.reject();
              });
            };
            fileReader.readAsDataURL(file);
          }
        } else {
          $timeout(function () {
            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
            deferred.reject();
          });
        }
      });

      if (disallowObjectUrl) {
        p = file.$$ngfDataUrlPromise = deferred.promise;
      } else {
        p = file.$$ngfBlobUrlPromise = deferred.promise;
      }
      p['finally'](function () {
        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
      });
      return p;
    };
    return upload;
  }]);

  function getTagType(el) {
    if (el.tagName.toLowerCase() === 'img') return 'image';
    if (el.tagName.toLowerCase() === 'audio') return 'audio';
    if (el.tagName.toLowerCase() === 'video') return 'video';
    return (/./
    );
  }

  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
    function constructDataUrl(file) {
      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
        $timeout(function () {
          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
          if (isBackground) {
            elem.css('background-image', 'url(\'' + (src || '') + '\')');
          } else {
            elem.attr('src', src);
          }
          if (src) {
            elem.removeClass('ng-hide');
          } else {
            elem.addClass('ng-hide');
          }
        });
      });
    }

    $timeout(function () {
      var unwatch = scope.$watch(attr[directiveName], function (file) {
        var size = resizeParams;
        if (directiveName === 'ngfThumbnail') {
          if (!size) {
            size = {
              width: elem[0].naturalWidth || elem[0].clientWidth,
              height: elem[0].naturalHeight || elem[0].clientHeight
            };
          }
          if (size.width === 0 && window.getComputedStyle) {
            var style = getComputedStyle(elem[0]);
            if (style.width && style.width.indexOf('px') > -1 && style.height && style.height.indexOf('px') > -1) {
              size = {
                width: parseInt(style.width.slice(0, -2)),
                height: parseInt(style.height.slice(0, -2))
              };
            }
          }
        }

        if (angular.isString(file)) {
          elem.removeClass('ng-hide');
          if (isBackground) {
            return elem.css('background-image', 'url(\'' + file + '\')');
          } else {
            return elem.attr('src', file);
          }
        }
        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 && (!isBackground || file.type.indexOf('image') === 0)) {
          if (size && Upload.isResizeSupported()) {
            size.resizeIf = function (width, height) {
              return Upload.attrGetter('ngfResizeIf', attr, scope, { $width: width, $height: height, $file: file });
            };
            Upload.resize(file, size).then(function (f) {
              constructDataUrl(f);
            }, function (e) {
              throw e;
            });
          } else {
            constructDataUrl(file);
          }
        } else {
          elem.addClass('ng-hide');
        }
      });

      scope.$on('$destroy', function () {
        unwatch();
      });
    });
  }

  /** @namespace attr.ngfSrc */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function link(scope, elem, attr) {
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc', Upload.attrGetter('ngfResize', attr, scope), false);
      }
    };
  }]);

  /** @namespace attr.ngfBackground */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function link(scope, elem, attr) {
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground', Upload.attrGetter('ngfResize', attr, scope), true);
      }
    };
  }]);

  /** @namespace attr.ngfThumbnail */
  /** @namespace attr.ngfAsBackground */
  /** @namespace attr.ngfSize */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function link(scope, elem, attr) {
        var size = Upload.attrGetter('ngfSize', attr, scope);
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size, Upload.attrGetter('ngfAsBackground', attr, scope));
      }
    };
  }]);

  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
  }]);

  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
    return function (file, disallowObjectUrl, trustedUrl) {
      if (angular.isString(file)) {
        return $sce.trustAsResourceUrl(file);
      }
      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
      if (file && !src) {
        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
          file.$ngfDataUrlFilterInProgress = true;
          UploadDataUrl.dataUrl(file, disallowObjectUrl);
        }
        return '';
      }
      if (file) delete file.$ngfDataUrlFilterInProgress;
      return (file && src ? trustedUrl ? $sce.trustAsResourceUrl(src) : src : file) || '';
    };
  }]);
})();

ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
  var upload = UploadDataUrl;

  function globStringToRegex(str) {
    var regexp = '',
        excludes = [];
    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
      regexp = str.substring(1, str.length - 1);
    } else {
      var split = str.split(',');
      if (split.length > 1) {
        for (var i = 0; i < split.length; i++) {
          var r = globStringToRegex(split[i]);
          if (r.regexp) {
            regexp += '(' + r.regexp + ')';
            if (i < split.length - 1) {
              regexp += '|';
            }
          } else {
            excludes = excludes.concat(r.excludes);
          }
        }
      } else {
        if (str.indexOf('!') === 0) {
          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
        } else {
          if (str.indexOf('.') === 0) {
            str = '*' + str;
          }
          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
        }
      }
    }
    return { regexp: regexp, excludes: excludes };
  }

  upload.validatePattern = function (file, val) {
    if (!val) {
      return true;
    }
    var pattern = globStringToRegex(val),
        valid = true;
    if (pattern.regexp && pattern.regexp.length) {
      var regexp = new RegExp(pattern.regexp, 'i');
      valid = file.type != null && regexp.test(file.type) || file.name != null && regexp.test(file.name);
    }
    var len = pattern.excludes.length;
    while (len--) {
      var exclude = new RegExp(pattern.excludes[len], 'i');
      valid = valid && (file.type == null || exclude.test(file.type)) && (file.name == null || exclude.test(file.name));
    }
    return valid;
  };

  upload.ratioToFloat = function (val) {
    var r = val.toString(),
        xIndex = r.search(/[x:]/i);
    if (xIndex > -1) {
      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
    } else {
      r = parseFloat(r);
    }
    return r;
  };

  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
    if (ngModel) {
      ngModel.$formatters.push(function (files) {
        if (ngModel.$dirty) {
          var filesArray = files;
          if (files && !angular.isArray(files)) {
            filesArray = [files];
          }
          upload.validate(filesArray, 0, ngModel, attr, scope).then(function () {
            upload.applyModelValidation(ngModel, filesArray);
          });
        }
        return files;
      });
    }
  };

  function markModelAsDirty(ngModel, files) {
    if (files != null && !ngModel.$dirty) {
      if (ngModel.$setDirty) {
        ngModel.$setDirty();
      } else {
        ngModel.$dirty = true;
      }
    }
  }

  upload.applyModelValidation = function (ngModel, files) {
    markModelAsDirty(ngModel, files);
    angular.forEach(ngModel.$ngfValidations, function (validation) {
      ngModel.$setValidity(validation.name, validation.valid);
    });
  };

  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
    var val = upload.attrGetter(dName, attr, scope, { $file: file });
    if (val == null) {
      val = upload.attrGetter('ngfValidate', attr, scope, { $file: file });
      if (val) {
        var split = (validationName || name).split('.');
        val = val[split[0]];
        if (split.length > 1) {
          val = val && val[split[1]];
        }
      }
    }
    return val;
  };

  upload.validate = function (files, prevLength, ngModel, attr, scope) {
    ngModel = ngModel || {};
    ngModel.$ngfValidations = ngModel.$ngfValidations || [];

    angular.forEach(ngModel.$ngfValidations, function (v) {
      v.valid = true;
    });

    var attrGetter = function attrGetter(name, params) {
      return upload.attrGetter(name, attr, scope, params);
    };

    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);

    if (files == null || files.length === 0) {
      return upload.emptyPromise({ 'validFiles': files, 'invalidFiles': [] });
    }

    files = files.length === undefined ? [files] : files.slice(0);
    var invalidFiles = [];

    function validateSync(name, validationName, fn) {
      if (files) {
        var i = files.length,
            valid = null;
        while (i--) {
          var file = files[i];
          if (file) {
            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
            if (val != null) {
              if (!fn(file, val, i)) {
                if (ignoredErrors.indexOf(name) === -1) {
                  file.$error = name;
                  (file.$errorMessages = file.$errorMessages || {})[name] = true;
                  file.$errorParam = val;
                  if (invalidFiles.indexOf(file) === -1) {
                    invalidFiles.push(file);
                  }
                  if (!runAllValidation) {
                    files.splice(i, 1);
                  }
                  valid = false;
                } else {
                  files.splice(i, 1);
                }
              }
            }
          }
        }
        if (valid !== null) {
          ngModel.$ngfValidations.push({ name: name, valid: valid });
        }
      }
    }

    validateSync('pattern', null, upload.validatePattern);
    validateSync('minSize', 'size.min', function (file, val) {
      return file.size + 0.1 >= upload.translateScalars(val);
    });
    validateSync('maxSize', 'size.max', function (file, val) {
      return file.size - 0.1 <= upload.translateScalars(val);
    });
    var totalSize = 0;
    validateSync('maxTotalSize', null, function (file, val) {
      totalSize += file.size;
      if (totalSize > upload.translateScalars(val)) {
        files.splice(0, files.length);
        return false;
      }
      return true;
    });

    validateSync('validateFn', null, function (file, r) {
      return r === true || r === null || r === '';
    });

    if (!files.length) {
      return upload.emptyPromise({ 'validFiles': [], 'invalidFiles': invalidFiles });
    }

    function validateAsync(name, validationName, type, asyncFn, fn) {
      function resolveResult(defer, file, val) {
        function resolveInternal(fn) {
          if (fn()) {
            if (ignoredErrors.indexOf(name) === -1) {
              file.$error = name;
              (file.$errorMessages = file.$errorMessages || {})[name] = true;
              file.$errorParam = val;
              if (invalidFiles.indexOf(file) === -1) {
                invalidFiles.push(file);
              }
              if (!runAllValidation) {
                var i = files.indexOf(file);
                if (i > -1) files.splice(i, 1);
              }
              defer.resolve(false);
            } else {
              var j = files.indexOf(file);
              if (j > -1) files.splice(j, 1);
              defer.resolve(true);
            }
          } else {
            defer.resolve(true);
          }
        }

        if (val != null) {
          asyncFn(file, val).then(function (d) {
            resolveInternal(function () {
              return !fn(d, val);
            });
          }, function () {
            resolveInternal(function () {
              return attrGetter('ngfValidateForce', { $file: file });
            });
          });
        } else {
          defer.resolve(true);
        }
      }

      var promises = [upload.emptyPromise(true)];
      if (files) {
        files = files.length === undefined ? [files] : files;
        angular.forEach(files, function (file) {
          var defer = $q.defer();
          promises.push(defer.promise);
          if (type && (file.type == null || file.type.search(type) !== 0)) {
            defer.resolve(true);
            return;
          }
          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
            upload.imageDimensions(file).then(function (d) {
              resolveResult(defer, file, attrGetter('ngfDimensions', { $file: file, $width: d.width, $height: d.height }));
            }, function () {
              defer.resolve(false);
            });
          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
            upload.mediaDuration(file).then(function (d) {
              resolveResult(defer, file, attrGetter('ngfDuration', { $file: file, $duration: d }));
            }, function () {
              defer.resolve(false);
            });
          } else {
            resolveResult(defer, file, upload.getValidationAttr(attr, scope, name, validationName, file));
          }
        });
      }
      var deffer = $q.defer();
      $q.all(promises).then(function (values) {
        var isValid = true;
        for (var i = 0; i < values.length; i++) {
          if (!values[i]) {
            isValid = false;
            break;
          }
        }
        ngModel.$ngfValidations.push({ name: name, valid: isValid });
        deffer.resolve(isValid);
      });
      return deffer.promise;
    }

    var deffer = $q.defer();
    var promises = [];

    promises.push(validateAsync('maxHeight', 'height.max', /image/, this.imageDimensions, function (d, val) {
      return d.height <= val;
    }));
    promises.push(validateAsync('minHeight', 'height.min', /image/, this.imageDimensions, function (d, val) {
      return d.height >= val;
    }));
    promises.push(validateAsync('maxWidth', 'width.max', /image/, this.imageDimensions, function (d, val) {
      return d.width <= val;
    }));
    promises.push(validateAsync('minWidth', 'width.min', /image/, this.imageDimensions, function (d, val) {
      return d.width >= val;
    }));
    promises.push(validateAsync('dimensions', null, /image/, function (file, val) {
      return upload.emptyPromise(val);
    }, function (r) {
      return r;
    }));
    promises.push(validateAsync('ratio', null, /image/, this.imageDimensions, function (d, val) {
      var split = val.toString().split(','),
          valid = false;
      for (var i = 0; i < split.length; i++) {
        if (Math.abs(d.width / d.height - upload.ratioToFloat(split[i])) < 0.01) {
          valid = true;
        }
      }
      return valid;
    }));
    promises.push(validateAsync('maxRatio', 'ratio.max', /image/, this.imageDimensions, function (d, val) {
      return d.width / d.height - upload.ratioToFloat(val) < 0.0001;
    }));
    promises.push(validateAsync('minRatio', 'ratio.min', /image/, this.imageDimensions, function (d, val) {
      return d.width / d.height - upload.ratioToFloat(val) > -0.0001;
    }));
    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/, this.mediaDuration, function (d, val) {
      return d <= upload.translateScalars(val);
    }));
    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/, this.mediaDuration, function (d, val) {
      return d >= upload.translateScalars(val);
    }));
    promises.push(validateAsync('duration', null, /audio|video/, function (file, val) {
      return upload.emptyPromise(val);
    }, function (r) {
      return r;
    }));

    promises.push(validateAsync('validateAsyncFn', null, null, function (file, val) {
      return val;
    }, function (r) {
      return r === true || r === null || r === '';
    }));

    $q.all(promises).then(function () {

      if (runAllValidation) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          if (file.$error) {
            files.splice(i--, 1);
          }
        }
      }

      runAllValidation = false;
      validateSync('maxFiles', null, function (file, val, i) {
        return prevLength + i < val;
      });

      deffer.resolve({ 'validFiles': files, 'invalidFiles': invalidFiles });
    });
    return deffer.promise;
  };

  upload.imageDimensions = function (file) {
    if (file.$ngfWidth && file.$ngfHeight) {
      var d = $q.defer();
      $timeout(function () {
        d.resolve({ width: file.$ngfWidth, height: file.$ngfHeight });
      });
      return d.promise;
    }
    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;

    var deferred = $q.defer();
    $timeout(function () {
      if (file.type.indexOf('image') !== 0) {
        deferred.reject('not image');
        return;
      }
      upload.dataUrl(file).then(function (dataUrl) {
        var img = angular.element('<img>').attr('src', dataUrl).css('visibility', 'hidden').css('position', 'fixed').css('max-width', 'none !important').css('max-height', 'none !important');

        function success() {
          var width = img[0].naturalWidth || img[0].clientWidth;
          var height = img[0].naturalHeight || img[0].clientHeight;
          img.remove();
          file.$ngfWidth = width;
          file.$ngfHeight = height;
          deferred.resolve({ width: width, height: height });
        }

        function error() {
          img.remove();
          deferred.reject('load error');
        }

        img.on('load', success);
        img.on('error', error);

        var secondsCounter = 0;
        function checkLoadErrorInCaseOfNoCallback() {
          $timeout(function () {
            if (img[0].parentNode) {
              if (img[0].clientWidth) {
                success();
              } else if (secondsCounter++ > 10) {
                error();
              } else {
                checkLoadErrorInCaseOfNoCallback();
              }
            }
          }, 1000);
        }

        checkLoadErrorInCaseOfNoCallback();

        angular.element(document.getElementsByTagName('body')[0]).append(img);
      }, function () {
        deferred.reject('load error');
      });
    });

    file.$ngfDimensionPromise = deferred.promise;
    file.$ngfDimensionPromise['finally'](function () {
      delete file.$ngfDimensionPromise;
    });
    return file.$ngfDimensionPromise;
  };

  upload.mediaDuration = function (file) {
    if (file.$ngfDuration) {
      var d = $q.defer();
      $timeout(function () {
        d.resolve(file.$ngfDuration);
      });
      return d.promise;
    }
    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;

    var deferred = $q.defer();
    $timeout(function () {
      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
        deferred.reject('not media');
        return;
      }
      upload.dataUrl(file).then(function (dataUrl) {
        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>').attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');

        function success() {
          var duration = el[0].duration;
          file.$ngfDuration = duration;
          el.remove();
          deferred.resolve(duration);
        }

        function error() {
          el.remove();
          deferred.reject('load error');
        }

        el.on('loadedmetadata', success);
        el.on('error', error);
        var count = 0;

        function checkLoadError() {
          $timeout(function () {
            if (el[0].parentNode) {
              if (el[0].duration) {
                success();
              } else if (count > 10) {
                error();
              } else {
                checkLoadError();
              }
            }
          }, 1000);
        }

        checkLoadError();

        angular.element(document.body).append(el);
      }, function () {
        deferred.reject('load error');
      });
    });

    file.$ngfDurationPromise = deferred.promise;
    file.$ngfDurationPromise['finally'](function () {
      delete file.$ngfDurationPromise;
    });
    return file.$ngfDurationPromise;
  };
  return upload;
}]);

ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
  var upload = UploadValidate;

  /**
   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
   * images to fit into a certain area.
   * Source:  http://stackoverflow.com/a/14731922
   *
   * @param {Number} srcWidth Source area width
   * @param {Number} srcHeight Source area height
   * @param {Number} maxWidth Nestable area maximum available width
   * @param {Number} maxHeight Nestable area maximum available height
   * @return {Object} { width, height }
   */
  var calculateAspectRatioFit = function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) : Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return {
      width: srcWidth * ratio, height: srcHeight * ratio,
      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
    };
  };

  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
  var resize = function resize(imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
    var deferred = $q.defer();
    var canvasElement = document.createElement('canvas');
    var imageElement = document.createElement('img');
    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
    document.body.appendChild(imageElement);

    imageElement.onload = function () {
      var imgWidth = imageElement.width,
          imgHeight = imageElement.height;
      imageElement.parentNode.removeChild(imageElement);
      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
        deferred.reject('resizeIf');
        return;
      }
      try {
        if (ratio) {
          var ratioFloat = upload.ratioToFloat(ratio);
          var imgRatio = imgWidth / imgHeight;
          if (imgRatio < ratioFloat) {
            width = imgWidth;
            height = width / ratioFloat;
          } else {
            height = imgHeight;
            width = height * ratioFloat;
          }
        }
        if (!width) {
          width = imgWidth;
        }
        if (!height) {
          height = imgHeight;
        }
        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
        canvasElement.width = Math.min(dimensions.width, width);
        canvasElement.height = Math.min(dimensions.height, height);
        var context = canvasElement.getContext('2d');
        context.drawImage(imageElement, Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2), dimensions.width, dimensions.height);
        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
      } catch (e) {
        deferred.reject(e);
      }
    };
    imageElement.onerror = function () {
      imageElement.parentNode.removeChild(imageElement);
      deferred.reject();
    };
    imageElement.src = imagen;
    return deferred.promise;
  };

  upload.dataUrltoBlob = function (dataurl, name, origSize) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    var blob = new window.Blob([u8arr], { type: mime });
    blob.name = name;
    blob.$ngfOrigSize = origSize;
    return blob;
  };

  upload.isResizeSupported = function () {
    var elem = document.createElement('canvas');
    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
  };

  if (upload.isResizeSupported()) {
    // add name getter to the blob constructor prototype
    Object.defineProperty(window.Blob.prototype, 'name', {
      get: function get() {
        return this.$ngfName;
      },
      set: function set(v) {
        this.$ngfName = v;
      },
      configurable: true
    });
  }

  upload.resize = function (file, options) {
    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);

    var deferred = $q.defer();
    upload.dataUrl(file, true).then(function (url) {
      resize(url, options.width, options.height, options.quality, options.type || file.type, options.ratio, options.centerCrop, options.resizeIf).then(function (dataUrl) {
        if (file.type === 'image/jpeg' && options.restoreExif !== false) {
          try {
            dataUrl = upload.restoreExif(url, dataUrl);
          } catch (e) {
            setTimeout(function () {
              throw e;
            }, 1);
          }
        }
        try {
          var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
          deferred.resolve(blob);
        } catch (e) {
          deferred.reject(e);
        }
      }, function (r) {
        if (r === 'resizeIf') {
          deferred.resolve(file);
        }
        deferred.reject(r);
      });
    }, function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  };

  return upload;
}]);

(function () {
  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q', function ($parse, $timeout, $window, Upload, $http, $q) {
    return {
      restrict: 'AEC',
      require: '?ngModel',
      link: function link(scope, elem, attr, ngModel) {
        linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
      }
    };
  }]);

  ngFileUpload.directive('ngfNoFileDrop', function () {
    return function (scope, elem) {
      if (dropAvailable()) elem.css('display', 'none');
    };
  });

  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
    return function (scope, elem, attr) {
      if (dropAvailable()) {
        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
        $timeout(function () {
          model(scope);
          if (model.assign) {
            model.assign(scope, true);
          }
        });
      }
    };
  }]);

  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
    var available = dropAvailable();

    var attrGetter = function attrGetter(name, scope, params) {
      return upload.attrGetter(name, attr, scope, params);
    };

    if (attrGetter('dropAvailable')) {
      $timeout(function () {
        if (scope[attrGetter('dropAvailable')]) {
          scope[attrGetter('dropAvailable')].value = available;
        } else {
          scope[attrGetter('dropAvailable')] = available;
        }
      });
    }
    if (!available) {
      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
        elem.css('display', 'none');
      }
      return;
    }

    function isDisabled() {
      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
    }

    if (attrGetter('ngfSelect') == null) {
      upload.registerModelChangeValidator(ngModel, attr, scope);
    }

    var leaveTimeout = null;
    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
    var dragOverDelay = 1;
    var actualDragOverClass;

    elem[0].addEventListener('dragover', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      // handling dragover events from the Chrome download bar
      if (navigator.userAgent.indexOf('Chrome') > -1) {
        var b = evt.dataTransfer.effectAllowed;
        evt.dataTransfer.dropEffect = 'move' === b || 'linkMove' === b ? 'move' : 'copy';
      }
      $timeout.cancel(leaveTimeout);
      if (!actualDragOverClass) {
        actualDragOverClass = 'C';
        calculateDragOverClass(scope, attr, evt, function (clazz) {
          actualDragOverClass = clazz;
          elem.addClass(actualDragOverClass);
          attrGetter('ngfDrag', scope, { $isDragging: true, $class: actualDragOverClass, $event: evt });
        });
      }
    }, false);
    elem[0].addEventListener('dragenter', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
    }, false);
    elem[0].addEventListener('dragleave', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      leaveTimeout = $timeout(function () {
        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
        actualDragOverClass = null;
        attrGetter('ngfDrag', scope, { $isDragging: false, $event: evt });
      }, dragOverDelay || 100);
    }, false);
    elem[0].addEventListener('drop', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
      actualDragOverClass = null;
      extractFilesAndUpdateModel(evt.dataTransfer, evt, 'dropUrl');
    }, false);
    elem[0].addEventListener('paste', function (evt) {
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && attrGetter('ngfEnableFirefoxPaste', scope)) {
        evt.preventDefault();
      }
      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
      extractFilesAndUpdateModel(evt.clipboardData || evt.originalEvent.clipboardData, evt, 'pasteUrl');
    }, false);

    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && attrGetter('ngfEnableFirefoxPaste', scope)) {
      elem.attr('contenteditable', true);
      elem.on('keypress', function (e) {
        if (!e.metaKey && !e.ctrlKey) {
          e.preventDefault();
        }
      });
    }

    function extractFilesAndUpdateModel(source, evt, updateOnType) {
      if (!source) return;
      // html needs to be calculated on the same process otherwise the data will be wiped
      // after promise resolve or setTimeout.
      var html;
      try {
        html = source && source.getData && source.getData('text/html');
      } catch (e) {/* Fix IE11 that throw error calling getData */
      }
      extractFiles(source.items, source.files, attrGetter('ngfAllowDir', scope) !== false, attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
        if (files.length) {
          updateModel(files, evt);
        } else {
          extractFilesFromHtml(updateOnType, html).then(function (files) {
            updateModel(files, evt);
          });
        }
      });
    }

    function updateModel(files, evt) {
      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
    }

    function extractFilesFromHtml(updateOn, html) {
      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
      var urls = [];
      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
        urls.push(src);
      });
      var promises = [],
          files = [];
      if (urls.length) {
        angular.forEach(urls, function (url) {
          promises.push(upload.urlToBlob(url).then(function (blob) {
            files.push(blob);
          }));
        });
        var defer = $q.defer();
        $q.all(promises).then(function () {
          defer.resolve(files);
        }, function (e) {
          defer.reject(e);
        });
        return defer.promise;
      }
      return upload.emptyPromise();
    }

    function calculateDragOverClass(scope, attr, evt, callback) {
      var obj = attrGetter('ngfDragOverClass', scope, { $event: evt }),
          dClass = 'dragover';
      if (angular.isString(obj)) {
        dClass = obj;
      } else if (obj) {
        if (obj.delay) dragOverDelay = obj.delay;
        if (obj.accept || obj.reject) {
          var items = evt.dataTransfer.items;
          if (items == null || !items.length) {
            dClass = obj.accept;
          } else {
            var pattern = obj.pattern || attrGetter('ngfPattern', scope, { $event: evt });
            var len = items.length;
            while (len--) {
              if (!upload.validatePattern(items[len], pattern)) {
                dClass = obj.reject;
                break;
              } else {
                dClass = obj.accept;
              }
            }
          }
        }
      }
      callback(dClass);
    }

    function extractFiles(items, fileList, allowDir, multiple) {
      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
      if (maxFiles == null) {
        maxFiles = Number.MAX_VALUE;
      }
      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
      if (maxTotalSize == null) {
        maxTotalSize = Number.MAX_VALUE;
      }
      var includeDir = attrGetter('ngfIncludeDir', scope);
      var files = [],
          totalSize = 0;

      function traverseFileTree(entry, path) {
        var defer = $q.defer();
        if (entry != null) {
          if (entry.isDirectory) {
            var promises = [upload.emptyPromise()];
            if (includeDir) {
              var file = { type: 'directory' };
              file.name = file.path = (path || '') + entry.name;
              files.push(file);
            }
            var dirReader = entry.createReader();
            var entries = [];
            var readEntries = function readEntries() {
              dirReader.readEntries(function (results) {
                try {
                  if (!results.length) {
                    angular.forEach(entries.slice(0), function (e) {
                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
                      }
                    });
                    $q.all(promises).then(function () {
                      defer.resolve();
                    }, function (e) {
                      defer.reject(e);
                    });
                  } else {
                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
                    readEntries();
                  }
                } catch (e) {
                  defer.reject(e);
                }
              }, function (e) {
                defer.reject(e);
              });
            };
            readEntries();
          } else {
            entry.file(function (file) {
              try {
                file.path = (path ? path : '') + file.name;
                if (includeDir) {
                  file = upload.rename(file, file.path);
                }
                files.push(file);
                totalSize += file.size;
                defer.resolve();
              } catch (e) {
                defer.reject(e);
              }
            }, function (e) {
              defer.reject(e);
            });
          }
        }
        return defer.promise;
      }

      var promises = [upload.emptyPromise()];

      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
        for (var i = 0; i < items.length; i++) {
          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
            var entry = items[i].webkitGetAsEntry();
            if (entry.isDirectory && !allowDir) {
              continue;
            }
            if (entry != null) {
              promises.push(traverseFileTree(entry));
            }
          } else {
            var f = items[i].getAsFile();
            if (f != null) {
              files.push(f);
              totalSize += f.size;
            }
          }
          if (files.length > maxFiles || totalSize > maxTotalSize || !multiple && files.length > 0) break;
        }
      } else {
        if (fileList != null) {
          for (var j = 0; j < fileList.length; j++) {
            var file = fileList.item(j);
            if (file.type || file.size > 0) {
              files.push(file);
              totalSize += file.size;
            }
            if (files.length > maxFiles || totalSize > maxTotalSize || !multiple && files.length > 0) break;
          }
        }
      }

      var defer = $q.defer();
      $q.all(promises).then(function () {
        if (!multiple && !includeDir && files.length) {
          var i = 0;
          while (files[i] && files[i].type === 'directory') {
            i++;
          }defer.resolve([files[i]]);
        } else {
          defer.resolve(files);
        }
      }, function (e) {
        defer.reject(e);
      });

      return defer.promise;
    }
  }

  function dropAvailable() {
    var div = document.createElement('div');
    return 'draggable' in div && 'ondrop' in div && !/Edge\/12./i.test(navigator.userAgent);
  }
})();

// customized version of https://github.com/exif-js/exif-js
ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
  var upload = UploadResize;

  upload.isExifSupported = function () {
    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
  };

  function applyTransform(ctx, orientation, width, height) {
    switch (orientation) {
      case 2:
        return ctx.transform(-1, 0, 0, 1, width, 0);
      case 3:
        return ctx.transform(-1, 0, 0, -1, width, height);
      case 4:
        return ctx.transform(1, 0, 0, -1, 0, height);
      case 5:
        return ctx.transform(0, 1, 1, 0, 0, 0);
      case 6:
        return ctx.transform(0, 1, -1, 0, height, 0);
      case 7:
        return ctx.transform(0, -1, -1, 0, height, width);
      case 8:
        return ctx.transform(0, -1, 1, 0, 0, width);
    }
  }

  upload.readOrientation = function (file) {
    var defer = $q.defer();
    var reader = new FileReader();
    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
    reader.readAsArrayBuffer(slicedFile);
    reader.onerror = function (e) {
      return defer.reject(e);
    };
    reader.onload = function (e) {
      var result = { orientation: 1 };
      var view = new DataView(this.result);
      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);

      var length = view.byteLength,
          offset = 2;
      while (offset < length) {
        var marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);

          var little = view.getUint16(offset += 6, false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          var tags = view.getUint16(offset, little);
          offset += 2;
          for (var i = 0; i < tags; i++) {
            if (view.getUint16(offset + i * 12, little) === 0x0112) {
              var orientation = view.getUint16(offset + i * 12 + 8, little);
              if (orientation >= 2 && orientation <= 8) {
                view.setUint16(offset + i * 12 + 8, 1, little);
                result.fixedArrayBuffer = e.target.result;
              }
              result.orientation = orientation;
              return defer.resolve(result);
            }
          }
        } else if ((marker & 0xFF00) !== 0xFF00) break;else offset += view.getUint16(offset, false);
      }
      return defer.resolve(result);
    };
    return defer.promise;
  };

  function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  upload.applyExifRotation = function (file) {
    if (file.type.indexOf('image/jpeg') !== 0) {
      return upload.emptyPromise(file);
    }

    var deferred = $q.defer();
    upload.readOrientation(file).then(function (result) {
      if (result.orientation < 2 || result.orientation > 8) {
        return deferred.resolve(file);
      }
      upload.dataUrl(file, true).then(function (url) {
        var canvas = document.createElement('canvas');
        var img = document.createElement('img');

        img.onload = function () {
          try {
            canvas.width = result.orientation > 4 ? img.height : img.width;
            canvas.height = result.orientation > 4 ? img.width : img.height;
            var ctx = canvas.getContext('2d');
            applyTransform(ctx, result.orientation, img.width, img.height);
            ctx.drawImage(img, 0, 0);
            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
            var blob = upload.dataUrltoBlob(dataUrl, file.name);
            deferred.resolve(blob);
          } catch (e) {
            return deferred.reject(e);
          }
        };
        img.onerror = function () {
          deferred.reject();
        };
        img.src = url;
      }, function (e) {
        deferred.reject(e);
      });
    }, function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  };

  upload.restoreExif = function (orig, resized) {
    var ExifRestorer = {};

    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '=';

    ExifRestorer.encode64 = function (input) {
      var output = '',
          chr1,
          chr2,
          chr3 = '',
          enc1,
          enc2,
          enc3,
          enc4 = '',
          i = 0;

      do {
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];

        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output = output + this.KEY_STR.charAt(enc1) + this.KEY_STR.charAt(enc2) + this.KEY_STR.charAt(enc3) + this.KEY_STR.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);

      return output;
    };

    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
      if (origFileBase64.match('data:image/jpeg;base64,')) {
        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
      }

      var rawImage = this.decode64(origFileBase64);
      var segments = this.slice2Segments(rawImage);

      var image = this.exifManipulation(resizedFileBase64, segments);

      return 'data:image/jpeg;base64,' + this.encode64(image);
    };

    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
      var exifArray = this.getExifArray(segments),
          newImageArray = this.insertExif(resizedFileBase64, exifArray);
      return new Uint8Array(newImageArray);
    };

    ExifRestorer.getExifArray = function (segments) {
      var seg;
      for (var x = 0; x < segments.length; x++) {
        seg = segments[x];
        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
          {
            return seg;
          }
      }
      return [];
    };

    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
          buf = this.decode64(imageData),
          separatePoint = buf.indexOf(255, 3),
          mae = buf.slice(0, separatePoint),
          ato = buf.slice(separatePoint),
          array = mae;

      array = array.concat(exifArray);
      array = array.concat(ato);
      return array;
    };

    ExifRestorer.slice2Segments = function (rawImageArray) {
      var head = 0,
          segments = [];

      while (1) {
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
          break;
        }
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
          head += 2;
        } else {
          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
              endPoint = head + length + 2,
              seg = rawImageArray.slice(head, endPoint);
          segments.push(seg);
          head = endPoint;
        }
        if (head > rawImageArray.length) {
          break;
        }
      }

      return segments;
    };

    ExifRestorer.decode64 = function (input) {
      var chr1,
          chr2,
          chr3 = '',
          enc1,
          enc2,
          enc3,
          enc4 = '',
          i = 0,
          buf = [];

      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
      var base64test = /[^A-Za-z0-9\+\/\=]/g;
      if (base64test.exec(input)) {
        console.log('There were invalid base64 characters in the input text.\n' + 'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' + 'Expect errors in decoding.');
      }
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

      do {
        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
        enc4 = this.KEY_STR.indexOf(input.charAt(i++));

        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;

        buf.push(chr1);

        if (enc3 !== 64) {
          buf.push(chr2);
        }
        if (enc4 !== 64) {
          buf.push(chr3);
        }

        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);

      return buf;
    };

    return ExifRestorer.restore(orig, resized); //<= EXIF
  };

  return upload;
}]);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(263)))

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * uiCropper v1.0.4
 * https://crackerakiua.github.io/ui-cropper/
 *
 * Copyright (c) 2017 Alex Kaul
 * License: MIT
 *
 * Generated at Wednesday, August 16th, 2017, 6:07:49 PM
 */
(function () {
    angular.module('uiCropper', []);

    angular.module('uiCropper').factory('cropAreaCircle', ['cropArea', function (CropArea) {
        var CropAreaCircle = function CropAreaCircle() {
            CropArea.apply(this, arguments);

            this._boxResizeBaseSize = 25;
            this._boxResizeNormalRatio = 1;
            this._boxResizeHoverRatio = 1.2;
            this._iconMoveNormalRatio = 0.9;
            this._iconMoveHoverRatio = 1.2;

            this._boxResizeNormalSize = this._boxResizeBaseSize * this._boxResizeNormalRatio;
            this._boxResizeHoverSize = this._boxResizeBaseSize * this._boxResizeHoverRatio;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
            this._posResizeStartX = 0;
            this._posResizeStartY = 0;
            this._posResizeStartSize = 0;

            this._boxResizeIsHover = false;
            this._areaIsHover = false;
            this._boxResizeIsDragging = false;
            this._areaIsDragging = false;
        };

        CropAreaCircle.prototype = new CropArea();

        CropAreaCircle.prototype.getType = function () {
            return 'circle';
        };

        CropAreaCircle.prototype._calcCirclePerimeterCoords = function (angleDegrees) {
            var hSize = this._size.w / 2;
            var angleRadians = angleDegrees * (Math.PI / 180),
                circlePerimeterX = this.getCenterPoint().x + hSize * Math.cos(angleRadians),
                circlePerimeterY = this.getCenterPoint().y + hSize * Math.sin(angleRadians);
            return [circlePerimeterX, circlePerimeterY];
        };

        CropAreaCircle.prototype._calcResizeIconCenterCoords = function () {
            return this._calcCirclePerimeterCoords(-45);
        };

        CropAreaCircle.prototype._isCoordWithinArea = function (coord) {
            return Math.sqrt((coord[0] - this.getCenterPoint().x) * (coord[0] - this.getCenterPoint().x) + (coord[1] - this.getCenterPoint().y) * (coord[1] - this.getCenterPoint().y)) < this._size.w / 2;
        };
        CropAreaCircle.prototype._isCoordWithinBoxResize = function (coord) {
            var resizeIconCenterCoords = this._calcResizeIconCenterCoords();
            var hSize = this._boxResizeHoverSize / 2;
            return coord[0] > resizeIconCenterCoords[0] - hSize && coord[0] < resizeIconCenterCoords[0] + hSize && coord[1] > resizeIconCenterCoords[1] - hSize && coord[1] < resizeIconCenterCoords[1] + hSize;
        };

        CropAreaCircle.prototype._drawArea = function (ctx, centerCoords, size) {
            ctx.arc(centerCoords.x, centerCoords.y, size.w / 2, 0, 2 * Math.PI);
        };

        CropAreaCircle.prototype.draw = function () {
            CropArea.prototype.draw.apply(this, arguments);

            // draw move icon
            var center = this.getCenterPoint();
            this._cropCanvas.drawIconMove([center.x, center.y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio);

            // draw resize cubes
            this._cropCanvas.drawIconResizeBoxNESW(this._calcResizeIconCenterCoords(), this._boxResizeBaseSize, this._boxResizeIsHover ? this._boxResizeHoverRatio : this._boxResizeNormalRatio);
        };

        CropAreaCircle.prototype.processMouseMove = function (mouseCurX, mouseCurY) {
            var cursor = 'default';
            var res = false;

            this._boxResizeIsHover = false;
            this._areaIsHover = false;

            if (this._areaIsDragging) {
                this.setCenterPointOnMove({
                    x: mouseCurX - this._posDragStartX,
                    y: mouseCurY - this._posDragStartY
                });
                this._areaIsHover = true;
                cursor = 'move';
                res = true;
                this._events.trigger('area-move');
            } else if (this._boxResizeIsDragging) {
                cursor = 'nesw-resize';
                var iFR, iFX, iFY;
                iFX = mouseCurX - this._posResizeStartX;
                iFY = this._posResizeStartY - mouseCurY;
                if (iFX > iFY) {
                    iFR = this._posResizeStartSize.w + iFY * 2;
                } else {
                    iFR = this._posResizeStartSize.w + iFX * 2;
                }

                var newNO = {},
                    newSE = {};

                newNO.x = this.getCenterPoint().x - iFR * 0.5;
                newSE.x = this.getCenterPoint().x + iFR * 0.5;

                newNO.y = this.getCenterPoint().y - iFR * 0.5;
                newSE.y = this.getCenterPoint().y + iFR * 0.5;

                this.circleOnMove(newNO, newSE);
                this._boxResizeIsHover = true;
                res = true;
                this._events.trigger('area-resize');
            } else if (this._isCoordWithinBoxResize([mouseCurX, mouseCurY])) {
                cursor = 'nesw-resize';
                this._areaIsHover = false;
                this._boxResizeIsHover = true;
                res = true;
            } else if (this._isCoordWithinArea([mouseCurX, mouseCurY])) {
                cursor = 'move';
                this._areaIsHover = true;
                res = true;
            }

            //this._dontDragOutside();
            angular.element(this._ctx.canvas).css({
                'cursor': cursor
            });

            return res;
        };

        CropAreaCircle.prototype.processMouseDown = function (mouseDownX, mouseDownY) {
            if (this._isCoordWithinBoxResize([mouseDownX, mouseDownY])) {
                this._areaIsDragging = false;
                this._areaIsHover = false;
                this._boxResizeIsDragging = true;
                this._boxResizeIsHover = true;
                this._posResizeStartX = mouseDownX;
                this._posResizeStartY = mouseDownY;
                this._posResizeStartSize = this._size;
                this._events.trigger('area-resize-start');
            } else if (this._isCoordWithinArea([mouseDownX, mouseDownY])) {
                this._areaIsDragging = true;
                this._areaIsHover = true;
                this._boxResizeIsDragging = false;
                this._boxResizeIsHover = false;
                var center = this.getCenterPoint();
                this._posDragStartX = mouseDownX - center.x;
                this._posDragStartY = mouseDownY - center.y;
                this._events.trigger('area-move-start');
            }
        };

        CropAreaCircle.prototype.processMouseUp = function () /*mouseUpX, mouseUpY*/{
            if (this._areaIsDragging) {
                this._areaIsDragging = false;
                this._events.trigger('area-move-end');
            }
            if (this._boxResizeIsDragging) {
                this._boxResizeIsDragging = false;
                this._events.trigger('area-resize-end');
            }
            this._areaIsHover = false;
            this._boxResizeIsHover = false;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
        };

        return CropAreaCircle;
    }]);

    angular.module('uiCropper').factory('cropAreaRectangle', ['cropArea', function (CropArea) {
        var CropAreaRectangle = function CropAreaRectangle() {
            CropArea.apply(this, arguments);

            this._resizeCtrlBaseRadius = 15;
            this._resizeCtrlNormalRatio = 0.6;
            this._resizeCtrlHoverRatio = 0.70;
            this._iconMoveNormalRatio = 0.9;
            this._iconMoveHoverRatio = 1.2;

            this._resizeCtrlNormalRadius = this._resizeCtrlBaseRadius * this._resizeCtrlNormalRatio;
            this._resizeCtrlHoverRadius = this._resizeCtrlBaseRadius * this._resizeCtrlHoverRatio;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
            this._posResizeStartX = 0;
            this._posResizeStartY = 0;
            this._posResizeStartSize = {
                w: 0,
                h: 0
            };

            this._resizeCtrlIsHover = -1;
            this._areaIsHover = false;
            this._resizeCtrlIsDragging = -1;
            this._areaIsDragging = false;
        };

        CropAreaRectangle.prototype = new CropArea();

        // return a type string
        CropAreaRectangle.prototype.getType = function () {
            return 'rectangle';
        };

        CropAreaRectangle.prototype._calcRectangleCorners = function () {
            var size = this.getSize();
            var se = this.getSouthEastBound();
            return [[size.x, size.y], //northwest
            [se.x, size.y], //northeast
            [size.x, se.y], //southwest
            [se.x, se.y] //southeast
            ];
        };

        CropAreaRectangle.prototype._calcRectangleDimensions = function () {
            var size = this.getSize();
            var se = this.getSouthEastBound();
            return {
                left: size.x,
                top: size.y,
                right: se.x,
                bottom: se.y
            };
        };

        CropAreaRectangle.prototype._isCoordWithinArea = function (coord) {
            var rectangleDimensions = this._calcRectangleDimensions();
            return coord[0] >= rectangleDimensions.left && coord[0] <= rectangleDimensions.right && coord[1] >= rectangleDimensions.top && coord[1] <= rectangleDimensions.bottom;
        };

        CropAreaRectangle.prototype._isCoordWithinResizeCtrl = function (coord) {
            var resizeIconsCenterCoords = this._calcRectangleCorners();
            var res = -1;
            for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
                var resizeIconCenterCoords = resizeIconsCenterCoords[i];
                if (coord[0] > resizeIconCenterCoords[0] - this._resizeCtrlHoverRadius && coord[0] < resizeIconCenterCoords[0] + this._resizeCtrlHoverRadius && coord[1] > resizeIconCenterCoords[1] - this._resizeCtrlHoverRadius && coord[1] < resizeIconCenterCoords[1] + this._resizeCtrlHoverRadius) {
                    res = i;
                    break;
                }
            }
            return res;
        };

        CropAreaRectangle.prototype._drawArea = function (ctx, center, size) {
            ctx.rect(size.x, size.y, size.w, size.h);
        };

        CropAreaRectangle.prototype.draw = function () {
            CropArea.prototype.draw.apply(this, arguments);

            var center = this.getCenterPoint();
            // draw move icon
            this._cropCanvas.drawIconMove([center.x, center.y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio);

            // draw resize thumbs
            var resizeIconsCenterCoords = this._calcRectangleCorners();
            for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
                var resizeIconCenterCoords = resizeIconsCenterCoords[i];
                this._cropCanvas.drawIconResizeBoxBase(resizeIconCenterCoords, this._resizeCtrlBaseRadius, this._resizeCtrlIsHover === i ? this._resizeCtrlHoverRatio : this._resizeCtrlNormalRatio);
            }
        };

        CropAreaRectangle.prototype.processMouseMove = function (mouseCurX, mouseCurY) {
            var cursor = 'default';
            var res = false;

            this._resizeCtrlIsHover = -1;
            this._areaIsHover = false;

            if (this._areaIsDragging) {
                this.setCenterPointOnMove({
                    x: mouseCurX - this._posDragStartX,
                    y: mouseCurY - this._posDragStartY
                });
                this._areaIsHover = true;
                cursor = 'move';
                res = true;
                this._events.trigger('area-move');
            } else if (this._resizeCtrlIsDragging > -1) {
                var s = this.getSize();
                var se = this.getSouthEastBound();
                var posX = mouseCurX;
                switch (this._resizeCtrlIsDragging) {
                    case 0:
                        // Top Left
                        if (this._aspect) {
                            posX = se.x - (se.y - mouseCurY) * this._aspect;
                        }
                        this.setSizeByCorners({
                            x: posX,
                            y: mouseCurY
                        }, {
                            x: se.x,
                            y: se.y
                        });
                        cursor = 'nwse-resize';
                        break;
                    case 1:
                        // Top Right
                        if (this._aspect) {
                            posX = s.x + (se.y - mouseCurY) * this._aspect;
                        }
                        this.setSizeByCorners({
                            x: s.x,
                            y: mouseCurY
                        }, {
                            x: posX,
                            y: se.y
                        });
                        cursor = 'nesw-resize';
                        break;
                    case 2:
                        // Bottom Left
                        if (this._aspect) {
                            posX = se.x - (mouseCurY - s.y) * this._aspect;
                        }
                        this.setSizeByCorners({
                            x: posX,
                            y: s.y
                        }, {
                            x: se.x,
                            y: mouseCurY
                        });
                        cursor = 'nesw-resize';
                        break;
                    case 3:
                        // Bottom Right
                        if (this._aspect) {
                            posX = s.x + (mouseCurY - s.y) * this._aspect;
                        }
                        this.setSizeByCorners({
                            x: s.x,
                            y: s.y
                        }, {
                            x: posX,
                            y: mouseCurY
                        });
                        cursor = 'nwse-resize';
                        break;
                }

                this._resizeCtrlIsHover = this._resizeCtrlIsDragging;
                res = true;
                this._events.trigger('area-resize');
            } else {
                var hoveredResizeBox = this._isCoordWithinResizeCtrl([mouseCurX, mouseCurY]);
                if (hoveredResizeBox > -1) {
                    switch (hoveredResizeBox) {
                        case 0:
                            cursor = 'nwse-resize';
                            break;
                        case 1:
                            cursor = 'nesw-resize';
                            break;
                        case 2:
                            cursor = 'nesw-resize';
                            break;
                        case 3:
                            cursor = 'nwse-resize';
                            break;
                    }
                    this._areaIsHover = false;
                    this._resizeCtrlIsHover = hoveredResizeBox;
                    res = true;
                } else if (this._isCoordWithinArea([mouseCurX, mouseCurY])) {
                    cursor = 'move';
                    this._areaIsHover = true;
                    res = true;
                }
            }

            angular.element(this._ctx.canvas).css({
                'cursor': cursor
            });

            return res;
        };

        CropAreaRectangle.prototype.processMouseDown = function (mouseDownX, mouseDownY) {
            var isWithinResizeCtrl = this._isCoordWithinResizeCtrl([mouseDownX, mouseDownY]);
            if (isWithinResizeCtrl > -1) {
                this._areaIsDragging = false;
                this._areaIsHover = false;
                this._resizeCtrlIsDragging = isWithinResizeCtrl;
                this._resizeCtrlIsHover = isWithinResizeCtrl;
                this._posResizeStartX = mouseDownX;
                this._posResizeStartY = mouseDownY;
                this._posResizeStartSize = this._size;
                this._events.trigger('area-resize-start');
            } else if (this._isCoordWithinArea([mouseDownX, mouseDownY])) {
                this._areaIsDragging = true;
                this._areaIsHover = true;
                this._resizeCtrlIsDragging = -1;
                this._resizeCtrlIsHover = -1;
                var center = this.getCenterPoint();
                this._posDragStartX = mouseDownX - center.x;
                this._posDragStartY = mouseDownY - center.y;
                this._events.trigger('area-move-start');
            }
        };

        CropAreaRectangle.prototype.processMouseUp = function () /*mouseUpX, mouseUpY*/{
            if (this._areaIsDragging) {
                this._areaIsDragging = false;
                this._events.trigger('area-move-end');
            }
            if (this._resizeCtrlIsDragging > -1) {
                this._resizeCtrlIsDragging = -1;
                this._events.trigger('area-resize-end');
            }
            this._areaIsHover = false;
            this._resizeCtrlIsHover = -1;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
        };

        return CropAreaRectangle;
    }]);

    angular.module('uiCropper').factory('cropAreaSquare', ['cropArea', function (CropArea) {
        var CropAreaSquare = function CropAreaSquare() {
            CropArea.apply(this, arguments);

            this._resizeCtrlBaseRadius = 15;
            this._resizeCtrlNormalRatio = 0.6;
            this._resizeCtrlHoverRatio = 0.70;
            this._iconMoveNormalRatio = 0.9;
            this._iconMoveHoverRatio = 1.2;

            this._resizeCtrlNormalRadius = this._resizeCtrlBaseRadius * this._resizeCtrlNormalRatio;
            this._resizeCtrlHoverRadius = this._resizeCtrlBaseRadius * this._resizeCtrlHoverRatio;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
            this._posResizeStartX = 0;
            this._posResizeStartY = 0;
            this._posResizeStartSize = 0;

            this._resizeCtrlIsHover = -1;
            this._areaIsHover = false;
            this._resizeCtrlIsDragging = -1;
            this._areaIsDragging = false;
        };

        CropAreaSquare.prototype = new CropArea();

        CropAreaSquare.prototype.getType = function () {
            return 'square';
        };

        CropAreaSquare.prototype._calcSquareCorners = function () {
            var size = this.getSize(),
                se = this.getSouthEastBound();
            return [[size.x, size.y], //northwest
            [se.x, size.y], //northeast
            [size.x, se.y], //southwest
            [se.x, se.y] //southeast
            ];
        };

        CropAreaSquare.prototype._calcSquareDimensions = function () {
            var size = this.getSize(),
                se = this.getSouthEastBound();
            return {
                left: size.x,
                top: size.y,
                right: se.x,
                bottom: se.y
            };
        };

        CropAreaSquare.prototype._isCoordWithinArea = function (coord) {
            var squareDimensions = this._calcSquareDimensions();
            return coord[0] >= squareDimensions.left && coord[0] <= squareDimensions.right && coord[1] >= squareDimensions.top && coord[1] <= squareDimensions.bottom;
        };

        CropAreaSquare.prototype._isCoordWithinResizeCtrl = function (coord) {
            var resizeIconsCenterCoords = this._calcSquareCorners();
            var res = -1;
            for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
                var resizeIconCenterCoords = resizeIconsCenterCoords[i];
                if (coord[0] > resizeIconCenterCoords[0] - this._resizeCtrlHoverRadius && coord[0] < resizeIconCenterCoords[0] + this._resizeCtrlHoverRadius && coord[1] > resizeIconCenterCoords[1] - this._resizeCtrlHoverRadius && coord[1] < resizeIconCenterCoords[1] + this._resizeCtrlHoverRadius) {
                    res = i;
                    break;
                }
            }
            return res;
        };

        CropAreaSquare.prototype._drawArea = function (ctx, centerCoords, size) {
            ctx.rect(size.x, size.y, size.w, size.h);
        };

        CropAreaSquare.prototype.draw = function () {
            CropArea.prototype.draw.apply(this, arguments);

            // draw move icon
            var center = this.getCenterPoint();
            this._cropCanvas.drawIconMove([center.x, center.y], this._areaIsHover ? this._iconMoveHoverRatio : this._iconMoveNormalRatio);

            // draw resize cubes
            var resizeIconsCenterCoords = this._calcSquareCorners();
            for (var i = 0, len = resizeIconsCenterCoords.length; i < len; i++) {
                var resizeIconCenterCoords = resizeIconsCenterCoords[i];
                this._cropCanvas.drawIconResizeBoxBase(resizeIconCenterCoords, this._resizeCtrlBaseRadius, this._resizeCtrlIsHover === i ? this._resizeCtrlHoverRatio : this._resizeCtrlNormalRatio);
            }
        };

        CropAreaSquare.prototype._clampPoint = function (x, y) {
            var size = this._ctx.canvas.width;

            if (x < 0) {
                y -= Math.abs(x);
                x = 0;
            }

            if (y < 0) {
                x -= Math.abs(y);
                y = 0;
            }

            if (x > size) {
                y -= size - x;
                x = size;
            }

            if (y > size) {
                x -= size - y;
                y = size;
            }

            return {
                x: x,
                y: y
            };
        };

        CropAreaSquare.prototype.processMouseMove = function (mouseCurX, mouseCurY) {
            var cursor = 'default';
            var res = false;

            this._resizeCtrlIsHover = -1;
            this._areaIsHover = false;

            if (this._areaIsDragging) {
                this.setCenterPointOnMove({
                    x: mouseCurX - this._posDragStartX,
                    y: mouseCurY - this._posDragStartY
                });
                this._areaIsHover = true;
                cursor = 'move';
                res = true;
                this._events.trigger('area-move');
            } else if (this._resizeCtrlIsDragging > -1) {
                var xMulti, yMulti;
                switch (this._resizeCtrlIsDragging) {
                    case 0:
                        // Top Left
                        xMulti = -1;
                        yMulti = -1;
                        cursor = 'nwse-resize';
                        break;
                    case 1:
                        // Top Right
                        xMulti = 1;
                        yMulti = -1;
                        cursor = 'nesw-resize';
                        break;
                    case 2:
                        // Bottom Left
                        xMulti = -1;
                        yMulti = 1;
                        cursor = 'nesw-resize';
                        break;
                    case 3:
                        // Bottom Right
                        xMulti = 1;
                        yMulti = 1;
                        cursor = 'nwse-resize';
                        break;
                }
                var iFX = (mouseCurX - this._posResizeStartX) * xMulti,
                    iFY = (mouseCurY - this._posResizeStartY) * yMulti,
                    iFR;
                if (iFX > iFY) {
                    iFR = this._posResizeStartSize.w + iFY;
                } else {
                    iFR = this._posResizeStartSize.w + iFX;
                }
                var newSize = Math.max(this._minSize.w, iFR),
                    newNO = {},
                    newSE = {},
                    newSO = {},
                    newNE = {},
                    s = this.getSize(),
                    se = this.getSouthEastBound();

                switch (this._resizeCtrlIsDragging) {
                    case 0:
                        // Top Left
                        newNO.x = se.x - newSize;
                        newNO.y = se.y - newSize;

                        newNO = this._clampPoint(newNO.x, newNO.y);

                        this.setSizeByCorners(newNO, {
                            x: se.x,
                            y: se.y
                        });

                        cursor = 'nwse-resize';
                        break;
                    case 1:
                        // Top Right

                        newNE.x = s.x + newSize;
                        newNE.y = se.y - newSize;

                        newNE = this._clampPoint(newNE.x, newNE.y);

                        this.setSizeByCorners({
                            x: s.x,
                            y: newNE.y
                        }, {
                            x: newNE.x,
                            y: se.y
                        });

                        cursor = 'nesw-resize';
                        break;
                    case 2:
                        // Bottom Left
                        newSO.x = se.x - newSize;
                        newSO.y = s.y + newSize;

                        newSO = this._clampPoint(newSO.x, newSO.y);

                        this.setSizeByCorners({
                            x: newSO.x,
                            y: s.y
                        }, {
                            x: se.x,
                            y: newSO.y
                        });

                        cursor = 'nesw-resize';
                        break;
                    case 3:
                        // Bottom Right

                        newSE.x = s.x + newSize;
                        newSE.y = s.y + newSize;

                        newSE = this._clampPoint(newSE.x, newSE.y);

                        this.setSizeByCorners({
                            x: s.x,
                            y: s.y
                        }, newSE);

                        cursor = 'nwse-resize';
                        break;
                }
                this._resizeCtrlIsHover = this._resizeCtrlIsDragging;
                res = true;
                this._events.trigger('area-resize');
            } else {
                var hoveredResizeBox = this._isCoordWithinResizeCtrl([mouseCurX, mouseCurY]);
                if (hoveredResizeBox > -1) {
                    switch (hoveredResizeBox) {
                        case 0:
                            cursor = 'nwse-resize';
                            break;
                        case 1:
                            cursor = 'nesw-resize';
                            break;
                        case 2:
                            cursor = 'nesw-resize';
                            break;
                        case 3:
                            cursor = 'nwse-resize';
                            break;
                    }
                    this._areaIsHover = false;
                    this._resizeCtrlIsHover = hoveredResizeBox;
                    res = true;
                } else if (this._isCoordWithinArea([mouseCurX, mouseCurY])) {
                    cursor = 'move';
                    this._areaIsHover = true;
                    res = true;
                }
            }

            angular.element(this._ctx.canvas).css({
                'cursor': cursor
            });

            return res;
        };

        CropAreaSquare.prototype.processMouseDown = function (mouseDownX, mouseDownY) {
            var isWithinResizeCtrl = this._isCoordWithinResizeCtrl([mouseDownX, mouseDownY]);
            if (isWithinResizeCtrl > -1) {
                this._areaIsDragging = false;
                this._areaIsHover = false;
                this._resizeCtrlIsDragging = isWithinResizeCtrl;
                this._resizeCtrlIsHover = isWithinResizeCtrl;
                this._posResizeStartX = mouseDownX;
                this._posResizeStartY = mouseDownY;
                this._posResizeStartSize = this._size;
                this._events.trigger('area-resize-start');
            } else if (this._isCoordWithinArea([mouseDownX, mouseDownY])) {
                this._areaIsDragging = true;
                this._areaIsHover = true;
                this._resizeCtrlIsDragging = -1;
                this._resizeCtrlIsHover = -1;
                var center = this.getCenterPoint();
                this._posDragStartX = mouseDownX - center.x;
                this._posDragStartY = mouseDownY - center.y;
                this._events.trigger('area-move-start');
            }
        };

        CropAreaSquare.prototype.processMouseUp = function () /*mouseUpX, mouseUpY*/{
            if (this._areaIsDragging) {
                this._areaIsDragging = false;
                this._events.trigger('area-move-end');
            }
            if (this._resizeCtrlIsDragging > -1) {
                this._resizeCtrlIsDragging = -1;
                this._events.trigger('area-resize-end');
            }
            this._areaIsHover = false;
            this._resizeCtrlIsHover = -1;

            this._posDragStartX = 0;
            this._posDragStartY = 0;
        };

        return CropAreaSquare;
    }]);

    angular.module('uiCropper').factory('cropArea', ['cropCanvas', function (CropCanvas) {
        var CropArea = function CropArea(ctx, events) {
            this._ctx = ctx;
            this._events = events;

            this._minSize = {
                x: 0,
                y: 0,
                w: 80,
                h: 80
            };

            this._initSize = undefined;
            this._initCoords = undefined;
            this._allowCropResizeOnCorners = false;

            this._forceAspectRatio = false;
            this._aspect = null;

            this._cropCanvas = new CropCanvas(ctx);

            this._image = new Image();
            this._size = {
                x: 0,
                y: 0,
                w: 150,
                h: 150
            };
        };

        /* GETTERS/SETTERS */

        CropArea.prototype.setAllowCropResizeOnCorners = function (bool) {
            this._allowCropResizeOnCorners = bool;
        };
        CropArea.prototype.getImage = function () {
            return this._image;
        };
        CropArea.prototype.setImage = function (image) {
            this._image = image;
        };
        CropArea.prototype.setForceAspectRatio = function (force) {
            this._forceAspectRatio = force;
        };
        CropArea.prototype.setAspect = function (aspect) {
            this._aspect = aspect;
        };
        CropArea.prototype.getAspect = function () {
            return this._aspect;
        };
        CropArea.prototype.getCanvasSize = function () {
            return {
                w: this._ctx.canvas.width,
                h: this._ctx.canvas.height
            };
        };
        CropArea.prototype.getSize = function () {
            return this._size;
        };
        CropArea.prototype.setSize = function (size) {
            size = this._processSize(size);
            this._size = this._preventBoundaryCollision(size);
        };
        CropArea.prototype.setSizeOnMove = function (size) {
            size = this._processSize(size);
            if (this._allowCropResizeOnCorners) {
                this._size = this._preventBoundaryCollision(size);
            } else {
                this._size = this._allowMouseOutsideCanvas(size);
            }
        };
        CropArea.prototype.circleOnMove = function (northWestCorner, southEastCorner) {
            var size = {
                x: northWestCorner.x,
                y: northWestCorner.y,
                w: southEastCorner.x - northWestCorner.x,
                h: southEastCorner.y - northWestCorner.y
            };
            var canvasH = this._ctx.canvas.height,
                canvasW = this._ctx.canvas.width;
            if (size.w > canvasW || size.h > canvasH) {
                if (canvasW < canvasH) {
                    size.w = canvasW;
                    size.h = canvasW;
                } else {
                    size.w = canvasH;
                    size.h = canvasH;
                }
            }
            if (size.x + size.w > canvasW) {
                size.x = canvasW - size.w;
            }
            if (size.y + size.h > canvasH) {
                size.y = canvasH - size.h;
            }
            if (size.x < 0) {
                size.x = 0;
            }
            if (size.y < 0) {
                size.y = 0;
            }
            if (this._minSize.w > size.w) {
                size.w = this._minSize.w;
                size.x = this._size.x;
            }
            if (this._minSize.h > size.h) {
                size.h = this._minSize.h;
                size.y = this._size.y;
            }
            this._size = size;
        };

        CropArea.prototype.setSizeByCorners = function (northWestCorner, southEastCorner) {

            var size = {
                x: northWestCorner.x,
                y: northWestCorner.y,
                w: southEastCorner.x - northWestCorner.x,
                h: southEastCorner.y - northWestCorner.y
            };
            this.setSize(size);
        };

        CropArea.prototype.getSouthEastBound = function () {
            return this._southEastBound(this.getSize());
        };

        CropArea.prototype.setMinSize = function (size) {
            this._minSize = this._processSize(size);
            this.setSize(this._minSize);
        };

        CropArea.prototype.getMinSize = function () {
            return this._minSize;
        };

        CropArea.prototype.getCenterPoint = function () {
            var s = this.getSize();
            return {
                x: s.x + s.w / 2,
                y: s.y + s.h / 2
            };
        };

        CropArea.prototype.setCenterPoint = function (point) {
            var s = this.getSize();
            this.setSize({
                x: point.x - s.w / 2,
                y: point.y - s.h / 2,
                w: s.w,
                h: s.h
            });
        };

        CropArea.prototype.setCenterPointOnMove = function (point) {
            var s = this.getSize();
            this.setSizeOnMove({
                x: point.x - s.w / 2,
                y: point.y - s.h / 2,
                w: s.w,
                h: s.h
            });
        };

        CropArea.prototype.setInitSize = function (size) {
            this._initSize = this._processSize(size);
            this.setSize(this._initSize);
        };

        CropArea.prototype.getInitSize = function () {
            return this._initSize;
        };

        CropArea.prototype.setInitCoords = function (coords) {
            //add h/w-data to coords-object
            coords.h = this.getSize().h;
            coords.w = this.getSize().w;
            this._initCoords = this._processSize(coords);
            this.setSize(this._initCoords);
        };

        CropArea.prototype.getInitCoords = function () {
            return this._initCoords;
        };

        // return a type string
        CropArea.prototype.getType = function () {
            //default to circle
            return 'circle';
        };

        /* FUNCTIONS */
        CropArea.prototype._allowMouseOutsideCanvas = function (size) {
            var canvasH = this._ctx.canvas.height,
                canvasW = this._ctx.canvas.width;
            var newSize = {
                w: size.w,
                h: size.h
            };
            if (size.x < 0) {
                newSize.x = 0;
            } else if (size.x + size.w > canvasW) {
                newSize.x = canvasW - size.w;
            } else {
                newSize.x = size.x;
            }
            if (size.y < 0) {
                newSize.y = 0;
            } else if (size.y + size.h > canvasH) {
                newSize.y = canvasH - size.h;
            } else {
                newSize.y = size.y;
            }
            return newSize;
        };

        CropArea.prototype._preventBoundaryCollision = function (size) {
            var canvasH = this._ctx.canvas.height,
                canvasW = this._ctx.canvas.width;

            var nw = {
                x: size.x,
                y: size.y
            };
            var se = this._southEastBound(size);

            // check northwest corner
            if (nw.x < 0) {
                nw.x = 0;
            }
            if (nw.y < 0) {
                nw.y = 0;
            }

            // check southeast corner
            if (se.x > canvasW) {
                se.x = canvasW;
            }
            if (se.y > canvasH) {
                se.y = canvasH;
            }

            var newSizeWidth = this._forceAspectRatio ? size.w : se.x - nw.x,
                newSizeHeight = this._forceAspectRatio ? size.h : se.y - nw.y;

            if (newSizeHeight > canvasH) {
                newSizeHeight = canvasH;
            }

            // save rectangle scale
            if (this._aspect) {
                newSizeWidth = newSizeHeight * this._aspect;
                if (nw.x + newSizeWidth > canvasW) {
                    newSizeWidth = canvasW - nw.x;
                    newSizeHeight = newSizeWidth / this._aspect;
                    if (this._minSize.w > newSizeWidth) {
                        newSizeWidth = this._minSize.w;
                    }
                    if (this._minSize.h > newSizeHeight) {
                        newSizeHeight = this._minSize.h;
                    }
                    nw.x = canvasW - newSizeWidth;
                }
                if (nw.y + newSizeHeight > canvasH) {
                    nw.y = canvasH - newSizeHeight;
                }
            }

            // save square scale
            if (this._forceAspectRatio) {
                newSizeWidth = newSizeHeight;
                if (nw.x + newSizeWidth > canvasW) {
                    newSizeWidth = canvasW - nw.x;
                    if (newSizeWidth < this._minSize.w) {
                        newSizeWidth = this._minSize.w;
                    }
                    newSizeHeight = newSizeWidth;
                }
            }

            var newSize = {
                x: nw.x,
                y: nw.y,
                w: newSizeWidth,
                h: newSizeHeight
            };

            //check size (if < min, adjust nw corner)
            if (newSize.w < this._minSize.w && !this._forceAspectRatio) {
                newSize.w = this._minSize.w;
                se = this._southEastBound(newSize);
                //adjust se corner, if it's out of bounds
                if (se.x > canvasW) {
                    se.x = canvasW;
                    //adjust nw corner according to min width
                    nw.x = Math.max(se.x - canvasW, se.x - this._minSize.w);
                    newSize = {
                        x: nw.x,
                        y: nw.y,
                        w: se.x - nw.x,
                        h: se.y - nw.y
                    };
                }
            }

            if (newSize.h < this._minSize.h && !this._forceAspectRatio) {
                newSize.h = this._minSize.h;
                se = this._southEastBound(newSize);

                if (se.y > canvasH) {
                    se.y = canvasH;
                    //adjust nw corner according to min height
                    nw.y = Math.max(se.y - canvasH, se.y - this._minSize.h);
                    newSize = {
                        x: nw.x,
                        y: nw.y,
                        w: se.x - nw.x,
                        h: se.y - nw.y
                    };
                }
            }

            if (this._forceAspectRatio) {
                //check if outside SE bound
                se = this._southEastBound(newSize);
                if (se.y > canvasH) {
                    newSize.y = canvasH - newSize.h;
                }
                if (se.x > canvasW) {
                    newSize.x = canvasW - newSize.w;
                }
            }

            return newSize;
        };

        CropArea.prototype._dontDragOutside = function () {
            var h = this._ctx.canvas.height,
                w = this._ctx.canvas.width;

            if (this._width > w) {
                this._width = w;
            }
            if (this._height > h) {
                this._height = h;
            }
            if (this._x < this._width / 2) {
                this._x = this._width / 2;
            }
            if (this._x > w - this._width / 2) {
                this._x = w - this._width / 2;
            }
            if (this._y < this._height / 2) {
                this._y = this._height / 2;
            }
            if (this._y > h - this._height / 2) {
                this._y = h - this._height / 2;
            }
        };

        CropArea.prototype._drawArea = function () {};

        CropArea.prototype._processSize = function (size) {
            // make this polymorphic to accept a single floating point number
            // for square-like sizes (including circle)
            if (typeof size === 'number') {
                size = {
                    w: size,
                    h: size
                };
            }
            var width = size.w;
            if (this._aspect) {
                width = size.h * this._aspect;
            }
            return {
                x: typeof size.x === 'undefined' ? this.getSize().x : size.x,
                y: typeof size.y === 'undefined' ? this.getSize().y : size.y,
                w: width || this._minSize.w,
                h: size.h || this._minSize.h
            };
        };

        CropArea.prototype._southEastBound = function (size) {
            return {
                x: size.x + size.w,
                y: size.y + size.h
            };
        };

        CropArea.prototype.draw = function () {
            // draw crop area
            this._cropCanvas.drawCropArea(this._image, this.getCenterPoint(), this._size, this._drawArea);
        };

        CropArea.prototype.processMouseMove = function () {};

        CropArea.prototype.processMouseDown = function () {};

        CropArea.prototype.processMouseUp = function () {};

        return CropArea;
    }]);

    angular.module('uiCropper').factory('cropCanvas', [function () {
        // Shape = Array of [x,y]; [0, 0] - center
        var shapeArrowNW = [[-0.5, -2], [-3, -4.5], [-0.5, -7], [-7, -7], [-7, -0.5], [-4.5, -3], [-2, -0.5]];
        var shapeArrowNE = [[0.5, -2], [3, -4.5], [0.5, -7], [7, -7], [7, -0.5], [4.5, -3], [2, -0.5]];
        var shapeArrowSW = [[-0.5, 2], [-3, 4.5], [-0.5, 7], [-7, 7], [-7, 0.5], [-4.5, 3], [-2, 0.5]];
        var shapeArrowSE = [[0.5, 2], [3, 4.5], [0.5, 7], [7, 7], [7, 0.5], [4.5, 3], [2, 0.5]];
        var shapeArrowN = [[-1.5, -2.5], [-1.5, -6], [-5, -6], [0, -11], [5, -6], [1.5, -6], [1.5, -2.5]];
        var shapeArrowW = [[-2.5, -1.5], [-6, -1.5], [-6, -5], [-11, 0], [-6, 5], [-6, 1.5], [-2.5, 1.5]];
        var shapeArrowS = [[-1.5, 2.5], [-1.5, 6], [-5, 6], [0, 11], [5, 6], [1.5, 6], [1.5, 2.5]];
        var shapeArrowE = [[2.5, -1.5], [6, -1.5], [6, -5], [11, 0], [6, 5], [6, 1.5], [2.5, 1.5]];

        // Colors
        var colors = {
            areaOutline: '#fff',
            resizeBoxStroke: '#bababa',
            resizeBoxFill: '#444',
            resizeBoxArrowFill: '#fff',
            resizeCircleStroke: '#bababa',
            resizeCircleFill: '#444',
            moveIconFill: '#fff'
        };

        var cropper = {
            strokeWidth: 1
        };

        return function (ctx) {

            /* Base functions */

            // Calculate Point
            var calcPoint = function calcPoint(point, offset, scale) {
                return [scale * point[0] + offset[0], scale * point[1] + offset[1]];
            };

            // Draw Filled Polygon
            var drawFilledPolygon = function drawFilledPolygon(shape, fillStyle, centerCoords, scale) {
                ctx.save();
                ctx.fillStyle = fillStyle;
                ctx.beginPath();
                var pc,
                    pc0 = calcPoint(shape[0], centerCoords, scale);
                ctx.moveTo(pc0[0], pc0[1]);

                for (var p in shape) {
                    if (p > 0) {
                        pc = calcPoint(shape[p], centerCoords, scale);
                        ctx.lineTo(pc[0], pc[1]);
                    }
                }

                ctx.lineTo(pc0[0], pc0[1]);
                ctx.fill();
                ctx.closePath();
                ctx.restore();
            };

            /* Icons */

            this.drawIconMove = function (centerCoords, scale) {
                drawFilledPolygon(shapeArrowN, colors.moveIconFill, centerCoords, scale);
                drawFilledPolygon(shapeArrowW, colors.moveIconFill, centerCoords, scale);
                drawFilledPolygon(shapeArrowS, colors.moveIconFill, centerCoords, scale);
                drawFilledPolygon(shapeArrowE, colors.moveIconFill, centerCoords, scale);
            };

            this.drawIconResizeCircle = function (centerCoords, circleRadius, scale) {
                var scaledCircleRadius = circleRadius * scale;
                ctx.save();
                ctx.strokeStyle = colors.resizeCircleStroke;
                ctx.lineWidth = cropper.strokeWidth;
                ctx.fillStyle = colors.resizeCircleFill;
                ctx.beginPath();
                ctx.arc(centerCoords[0], centerCoords[1], scaledCircleRadius, 0, 2 * Math.PI);
                ctx.fill();
                ctx.stroke();
                ctx.closePath();
                ctx.restore();
            };

            this.drawIconResizeBoxBase = function (centerCoords, boxSize, scale) {
                var scaledBoxSize = boxSize * scale;
                ctx.save();
                ctx.strokeStyle = colors.resizeBoxStroke;
                ctx.lineWidth = cropper.strokeWidth;
                ctx.fillStyle = colors.resizeBoxFill;
                ctx.fillRect(centerCoords[0] - scaledBoxSize / 2, centerCoords[1] - scaledBoxSize / 2, scaledBoxSize, scaledBoxSize);
                ctx.strokeRect(centerCoords[0] - scaledBoxSize / 2, centerCoords[1] - scaledBoxSize / 2, scaledBoxSize, scaledBoxSize);
                ctx.restore();
            };
            this.drawIconResizeBoxNESW = function (centerCoords, boxSize, scale) {
                this.drawIconResizeBoxBase(centerCoords, boxSize, scale);
                drawFilledPolygon(shapeArrowNE, colors.resizeBoxArrowFill, centerCoords, scale);
                drawFilledPolygon(shapeArrowSW, colors.resizeBoxArrowFill, centerCoords, scale);
            };
            this.drawIconResizeBoxNWSE = function (centerCoords, boxSize, scale) {
                this.drawIconResizeBoxBase(centerCoords, boxSize, scale);
                drawFilledPolygon(shapeArrowNW, colors.resizeBoxArrowFill, centerCoords, scale);
                drawFilledPolygon(shapeArrowSE, colors.resizeBoxArrowFill, centerCoords, scale);
            };

            /* Crop Area */

            this.drawCropArea = function (image, centerCoords, size, fnDrawClipPath) {
                var xRatio = Math.abs(image.width / ctx.canvas.width),
                    yRatio = Math.abs(image.height / ctx.canvas.height),
                    xLeft = Math.abs(centerCoords.x - size.w / 2),
                    yTop = Math.abs(centerCoords.y - size.h / 2);

                ctx.save();
                ctx.strokeStyle = colors.areaOutline;
                ctx.lineWidth = cropper.strokeWidth;
                ctx.setLineDash([5, 5]);
                ctx.beginPath();
                fnDrawClipPath(ctx, centerCoords, size);
                ctx.stroke();
                ctx.clip();

                // draw part of original image
                if (size.w > 0) {
                    ctx.drawImage(image, xLeft * xRatio, yTop * yRatio, Math.abs(size.w * xRatio), Math.abs(size.h * yRatio), xLeft, yTop, Math.abs(size.w), Math.abs(size.h));
                }

                ctx.beginPath();
                fnDrawClipPath(ctx, centerCoords, size);
                ctx.stroke();
                ctx.clip();

                ctx.restore();
            };
        };
    }]);

    /**
     * EXIF service is based on the exif-js library (https://github.com/jseidelin/exif-js)
     */
    /*eslint-disable */
    //Disable eslint as this is a 3rd party lib
    angular.module('uiCropper').service('cropEXIF', [function () {
        var debug = false;

        var ExifTags = this.Tags = {

            // version tags
            0x9000: 'ExifVersion', // EXIF version
            0xA000: 'FlashpixVersion', // Flashpix format version

            // colorspace tags
            0xA001: 'ColorSpace', // Color space information tag

            // image configuration
            0xA002: 'PixelXDimension', // Valid width of meaningful image
            0xA003: 'PixelYDimension', // Valid height of meaningful image
            0x9101: 'ComponentsConfiguration', // Information about channels
            0x9102: 'CompressedBitsPerPixel', // Compressed bits per pixel

            // user information
            0x927C: 'MakerNote', // Any desired information written by the manufacturer
            0x9286: 'UserComment', // Comments by user

            // related file
            0xA004: 'RelatedSoundFile', // Name of related sound file

            // date and time
            0x9003: 'DateTimeOriginal', // Date and time when the original image was generated
            0x9004: 'DateTimeDigitized', // Date and time when the image was stored digitally
            0x9290: 'SubsecTime', // Fractions of seconds for DateTime
            0x9291: 'SubsecTimeOriginal', // Fractions of seconds for DateTimeOriginal
            0x9292: 'SubsecTimeDigitized', // Fractions of seconds for DateTimeDigitized

            // picture-taking conditions
            0x829A: 'ExposureTime', // Exposure time (in seconds)
            0x829D: 'FNumber', // F number
            0x8822: 'ExposureProgram', // Exposure program
            0x8824: 'SpectralSensitivity', // Spectral sensitivity
            0x8827: 'ISOSpeedRatings', // ISO speed rating
            0x8828: 'OECF', // Optoelectric conversion factor
            0x9201: 'ShutterSpeedValue', // Shutter speed
            0x9202: 'ApertureValue', // Lens aperture
            0x9203: 'BrightnessValue', // Value of brightness
            0x9204: 'ExposureBias', // Exposure bias
            0x9205: 'MaxApertureValue', // Smallest F number of lens
            0x9206: 'SubjectDistance', // Distance to subject in meters
            0x9207: 'MeteringMode', // Metering mode
            0x9208: 'LightSource', // Kind of light source
            0x9209: 'Flash', // Flash status
            0x9214: 'SubjectArea', // Location and area of main subject
            0x920A: 'FocalLength', // Focal length of the lens in mm
            0xA20B: 'FlashEnergy', // Strobe energy in BCPS
            0xA20C: 'SpatialFrequencyResponse', //
            0xA20E: 'FocalPlaneXResolution', // Number of pixels in width direction per FocalPlaneResolutionUnit
            0xA20F: 'FocalPlaneYResolution', // Number of pixels in height direction per FocalPlaneResolutionUnit
            0xA210: 'FocalPlaneResolutionUnit', // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
            0xA214: 'SubjectLocation', // Location of subject in image
            0xA215: 'ExposureIndex', // Exposure index selected on camera
            0xA217: 'SensingMethod', // Image sensor type
            0xA300: 'FileSource', // Image source (3 == DSC)
            0xA301: 'SceneType', // Scene type (1 == directly photographed)
            0xA302: 'CFAPattern', // Color filter array geometric pattern
            0xA401: 'CustomRendered', // Special processing
            0xA402: 'ExposureMode', // Exposure mode
            0xA403: 'WhiteBalance', // 1 = auto white balance, 2 = manual
            0xA404: 'DigitalZoomRation', // Digital zoom ratio
            0xA405: 'FocalLengthIn35mmFilm', // Equivalent foacl length assuming 35mm film camera (in mm)
            0xA406: 'SceneCaptureType', // Type of scene
            0xA407: 'GainControl', // Degree of overall image gain adjustment
            0xA408: 'Contrast', // Direction of contrast processing applied by camera
            0xA409: 'Saturation', // Direction of saturation processing applied by camera
            0xA40A: 'Sharpness', // Direction of sharpness processing applied by camera
            0xA40B: 'DeviceSettingDescription', //
            0xA40C: 'SubjectDistanceRange', // Distance to subject

            // other tags
            0xA005: 'InteroperabilityIFDPointer',
            0xA420: 'ImageUniqueID' // Identifier assigned uniquely to each image
        };

        var TiffTags = this.TiffTags = {
            0x0100: 'ImageWidth',
            0x0101: 'ImageHeight',
            0x8769: 'ExifIFDPointer',
            0x8825: 'GPSInfoIFDPointer',
            0xA005: 'InteroperabilityIFDPointer',
            0x0102: 'BitsPerSample',
            0x0103: 'Compression',
            0x0106: 'PhotometricInterpretation',
            0x0112: 'Orientation',
            0x0115: 'SamplesPerPixel',
            0x011C: 'PlanarConfiguration',
            0x0212: 'YCbCrSubSampling',
            0x0213: 'YCbCrPositioning',
            0x011A: 'XResolution',
            0x011B: 'YResolution',
            0x0128: 'ResolutionUnit',
            0x0111: 'StripOffsets',
            0x0116: 'RowsPerStrip',
            0x0117: 'StripByteCounts',
            0x0201: 'JPEGInterchangeFormat',
            0x0202: 'JPEGInterchangeFormatLength',
            0x012D: 'TransferFunction',
            0x013E: 'WhitePoint',
            0x013F: 'PrimaryChromaticities',
            0x0211: 'YCbCrCoefficients',
            0x0214: 'ReferenceBlackWhite',
            0x0132: 'DateTime',
            0x010E: 'ImageDescription',
            0x010F: 'Make',
            0x0110: 'Model',
            0x0131: 'Software',
            0x013B: 'Artist',
            0x8298: 'Copyright'
        };

        var GPSTags = this.GPSTags = {
            0x0000: 'GPSVersionID',
            0x0001: 'GPSLatitudeRef',
            0x0002: 'GPSLatitude',
            0x0003: 'GPSLongitudeRef',
            0x0004: 'GPSLongitude',
            0x0005: 'GPSAltitudeRef',
            0x0006: 'GPSAltitude',
            0x0007: 'GPSTimeStamp',
            0x0008: 'GPSSatellites',
            0x0009: 'GPSStatus',
            0x000A: 'GPSMeasureMode',
            0x000B: 'GPSDOP',
            0x000C: 'GPSSpeedRef',
            0x000D: 'GPSSpeed',
            0x000E: 'GPSTrackRef',
            0x000F: 'GPSTrack',
            0x0010: 'GPSImgDirectionRef',
            0x0011: 'GPSImgDirection',
            0x0012: 'GPSMapDatum',
            0x0013: 'GPSDestLatitudeRef',
            0x0014: 'GPSDestLatitude',
            0x0015: 'GPSDestLongitudeRef',
            0x0016: 'GPSDestLongitude',
            0x0017: 'GPSDestBearingRef',
            0x0018: 'GPSDestBearing',
            0x0019: 'GPSDestDistanceRef',
            0x001A: 'GPSDestDistance',
            0x001B: 'GPSProcessingMethod',
            0x001C: 'GPSAreaInformation',
            0x001D: 'GPSDateStamp',
            0x001E: 'GPSDifferential'
        };

        var StringValues = this.StringValues = {
            ExposureProgram: {
                0: 'Not defined',
                1: 'Manual',
                2: 'Normal program',
                3: 'Aperture priority',
                4: 'Shutter priority',
                5: 'Creative program',
                6: 'Action program',
                7: 'Portrait mode',
                8: 'Landscape mode'
            },
            MeteringMode: {
                0: 'Unknown',
                1: 'Average',
                2: 'CenterWeightedAverage',
                3: 'Spot',
                4: 'MultiSpot',
                5: 'Pattern',
                6: 'Partial',
                255: 'Other'
            },
            LightSource: {
                0: 'Unknown',
                1: 'Daylight',
                2: 'Fluorescent',
                3: 'Tungsten (incandescent light)',
                4: 'Flash',
                9: 'Fine weather',
                10: 'Cloudy weather',
                11: 'Shade',
                12: 'Daylight fluorescent (D 5700 - 7100K)',
                13: 'Day white fluorescent (N 4600 - 5400K)',
                14: 'Cool white fluorescent (W 3900 - 4500K)',
                15: 'White fluorescent (WW 3200 - 3700K)',
                17: 'Standard light A',
                18: 'Standard light B',
                19: 'Standard light C',
                20: 'D55',
                21: 'D65',
                22: 'D75',
                23: 'D50',
                24: 'ISO studio tungsten',
                255: 'Other'
            },
            Flash: {
                0x0000: 'Flash did not fire',
                0x0001: 'Flash fired',
                0x0005: 'Strobe return light not detected',
                0x0007: 'Strobe return light detected',
                0x0009: 'Flash fired, compulsory flash mode',
                0x000D: 'Flash fired, compulsory flash mode, return light not detected',
                0x000F: 'Flash fired, compulsory flash mode, return light detected',
                0x0010: 'Flash did not fire, compulsory flash mode',
                0x0018: 'Flash did not fire, auto mode',
                0x0019: 'Flash fired, auto mode',
                0x001D: 'Flash fired, auto mode, return light not detected',
                0x001F: 'Flash fired, auto mode, return light detected',
                0x0020: 'No flash function',
                0x0041: 'Flash fired, red-eye reduction mode',
                0x0045: 'Flash fired, red-eye reduction mode, return light not detected',
                0x0047: 'Flash fired, red-eye reduction mode, return light detected',
                0x0049: 'Flash fired, compulsory flash mode, red-eye reduction mode',
                0x004D: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
                0x004F: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
                0x0059: 'Flash fired, auto mode, red-eye reduction mode',
                0x005D: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
                0x005F: 'Flash fired, auto mode, return light detected, red-eye reduction mode'
            },
            SensingMethod: {
                1: 'Not defined',
                2: 'One-chip color area sensor',
                3: 'Two-chip color area sensor',
                4: 'Three-chip color area sensor',
                5: 'Color sequential area sensor',
                7: 'Trilinear sensor',
                8: 'Color sequential linear sensor'
            },
            SceneCaptureType: {
                0: 'Standard',
                1: 'Landscape',
                2: 'Portrait',
                3: 'Night scene'
            },
            SceneType: {
                1: 'Directly photographed'
            },
            CustomRendered: {
                0: 'Normal process',
                1: 'Custom process'
            },
            WhiteBalance: {
                0: 'Auto white balance',
                1: 'Manual white balance'
            },
            GainControl: {
                0: 'None',
                1: 'Low gain up',
                2: 'High gain up',
                3: 'Low gain down',
                4: 'High gain down'
            },
            Contrast: {
                0: 'Normal',
                1: 'Soft',
                2: 'Hard'
            },
            Saturation: {
                0: 'Normal',
                1: 'Low saturation',
                2: 'High saturation'
            },
            Sharpness: {
                0: 'Normal',
                1: 'Soft',
                2: 'Hard'
            },
            SubjectDistanceRange: {
                0: 'Unknown',
                1: 'Macro',
                2: 'Close view',
                3: 'Distant view'
            },
            FileSource: {
                3: 'DSC'
            },

            Components: {
                0: '',
                1: 'Y',
                2: 'Cb',
                3: 'Cr',
                4: 'R',
                5: 'G',
                6: 'B'
            }
        };

        function addEvent(element, event, handler) {
            if (element.addEventListener) {
                element.addEventListener(event, handler, false);
            } else if (element.attachEvent) {
                element.attachEvent('on' + event, handler);
            }
        }

        function imageHasData(img) {
            return !!img.exifdata;
        }

        function base64ToArrayBuffer(base64, contentType) {
            contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
            base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
            var binary = atob(base64);
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }
            return buffer;
        }

        function objectURLToBlob(url, callback) {
            var http = new XMLHttpRequest();
            http.open('GET', url, true);
            http.responseType = 'blob';
            http.onload = function (e) {
                if (this.status === 200 || this.status === 0) {
                    callback(this.response);
                }
            };
            http.send();
        }

        function getImageData(img, callback) {
            function handleBinaryFile(binFile) {
                var data = findEXIFinJPEG(binFile);
                var iptcdata = findIPTCinJPEG(binFile);
                img.exifdata = data || {};
                img.iptcdata = iptcdata || {};
                if (callback) {
                    callback.call(img);
                }
            }

            var fileReader = new FileReader();

            if (img.src) {

                if (/^data\:/i.test(img.src)) {
                    // Data URI
                    var arrayBuffer = base64ToArrayBuffer(img.src);
                    handleBinaryFile(arrayBuffer);
                } else if (/^blob\:/i.test(img.src)) {
                    // Object URL
                    fileReader.onload = function (e) {
                        handleBinaryFile(e.target.result);
                    };
                    objectURLToBlob(img.src, function (blob) {
                        fileReader.readAsArrayBuffer(blob);
                    });
                }
                var http = new XMLHttpRequest();
                http.onload = function () {
                    if (this.status === 200 || this.status === 0) {
                        handleBinaryFile(http.response);
                    } else {
                        throw 'Could not load image';
                    }
                    http = null;
                };
                http.open('GET', img.src, true);
                http.responseType = 'arraybuffer';
                try {
                    http.send(null);
                } catch (e) {}
            } else if (window.FileReader && (img instanceof window.Blob || img instanceof window.File)) {
                fileReader.onload = function (e) {
                    if (debug) {
                        console.log('Got file of length ' + e.target.result.byteLength);
                    }
                    handleBinaryFile(e.target.result);
                };

                fileReader.readAsArrayBuffer(img);
            }
        }

        function findEXIFinJPEG(file) {
            var dataView = new DataView(file);

            if (debug) {
                console.log('Got file of length ' + file.byteLength);
            }
            if (dataView.getUint8(0) !== 0xFF || dataView.getUint8(1) !== 0xD8) {
                if (debug) {
                    console.log('Not a valid JPEG');
                }
                return false; // not a valid jpeg
            }

            var offset = 2,
                length = file.byteLength,
                marker;

            while (offset < length) {
                if (dataView.getUint8(offset) !== 0xFF) {
                    if (debug) {
                        console.log('Not a valid marker at offset ' + offset + ', found: ' + dataView.getUint8(offset));
                    }
                    return false; // not a valid marker, something is wrong
                }

                marker = dataView.getUint8(offset + 1);
                if (debug) {
                    console.log(marker);
                }

                // we could implement handling for other markers here,
                // but we're only looking for 0xFFE1 for EXIF data

                if (marker === 225) {
                    if (debug) {
                        console.log('Found 0xFFE1 marker');
                    }

                    return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

                    // offset += 2 + file.getShortAt(offset+2, true);
                } else {
                    offset += 2 + dataView.getUint16(offset + 2);
                }
            }
        }

        function findIPTCinJPEG(file) {
            var dataView = new DataView(file);

            if (debug) {
                console.log('Got file of length ' + file.byteLength);
            }
            if (dataView.getUint8(0) !== 0xFF || dataView.getUint8(1) !== 0xD8) {
                if (debug) {
                    console.log('Not a valid JPEG');
                }
                return false; // not a valid jpeg
            }

            var offset = 2,
                length = file.byteLength;

            var isFieldSegmentStart = function isFieldSegmentStart(dataView, offset) {
                return dataView.getUint8(offset) === 0x38 && dataView.getUint8(offset + 1) === 0x42 && dataView.getUint8(offset + 2) === 0x49 && dataView.getUint8(offset + 3) === 0x4D && dataView.getUint8(offset + 4) === 0x04 && dataView.getUint8(offset + 5) === 0x04;
            };

            while (offset < length) {

                if (isFieldSegmentStart(dataView, offset)) {

                    // Get the length of the name header (which is padded to an even number of bytes)
                    var nameHeaderLength = dataView.getUint8(offset + 7);
                    if (nameHeaderLength % 2 !== 0) {
                        nameHeaderLength += 1;
                    }
                    // Check for pre photoshop 6 format
                    if (nameHeaderLength === 0) {
                        // Always 4
                        nameHeaderLength = 4;
                    }

                    var startOffset = offset + 8 + nameHeaderLength;
                    var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

                    return readIPTCData(file, startOffset, sectionLength);
                }

                // Not the marker, continue searching
                offset++;
            }
        }

        var IptcFieldMap = {
            0x78: 'caption',
            0x6E: 'credit',
            0x19: 'keywords',
            0x37: 'dateCreated',
            0x50: 'byline',
            0x55: 'bylineTitle',
            0x7A: 'captionWriter',
            0x69: 'headline',
            0x74: 'copyright',
            0x0F: 'category'
        };

        function readIPTCData(file, startOffset, sectionLength) {
            var dataView = new DataView(file);
            var data = {};
            var fieldValue, fieldName, dataSize, segmentType, segmentSize;
            var segmentStartPos = startOffset;
            while (segmentStartPos < startOffset + sectionLength) {
                if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
                    segmentType = dataView.getUint8(segmentStartPos + 2);
                    if (segmentType in IptcFieldMap) {
                        dataSize = dataView.getInt16(segmentStartPos + 3);
                        segmentSize = dataSize + 5;
                        fieldName = IptcFieldMap[segmentType];
                        fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                        // Check if we already stored a value with this name
                        if (data.hasOwnProperty(fieldName)) {
                            // Value already stored with this name, create multivalue field
                            if (data[fieldName] instanceof Array) {
                                data[fieldName].push(fieldValue);
                            } else {
                                data[fieldName] = [data[fieldName], fieldValue];
                            }
                        } else {
                            data[fieldName] = fieldValue;
                        }
                    }
                }
                segmentStartPos++;
            }
            return data;
        }

        function readTags(file, tiffStart, dirStart, strings, bigEnd) {
            var entries = file.getUint16(dirStart, !bigEnd),
                tags = {},
                entryOffset,
                tag,
                i;

            for (i = 0; i < entries; i++) {
                entryOffset = dirStart + i * 12 + 2;
                tag = strings[file.getUint16(entryOffset, !bigEnd)];
                if (!tag && debug) {
                    console.log('Unknown tag: ' + file.getUint16(entryOffset, !bigEnd));
                }
                tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
            }
            return tags;
        }

        function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
            var type = file.getUint16(entryOffset + 2, !bigEnd),
                numValues = file.getUint32(entryOffset + 4, !bigEnd),
                valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart,
                offset,
                vals,
                val,
                n,
                numerator,
                denominator;

            switch (type) {
                case 1: // byte, 8-bit unsigned int
                case 7:
                    // undefined, 8-bit byte, value depending on field
                    if (numValues === 1) {
                        return file.getUint8(entryOffset + 8, !bigEnd);
                    }
                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;

                case 2:
                    // ascii, 8-bit byte
                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
                    return getStringFromDB(file, offset, numValues - 1);

                case 3:
                    // short, 16 bit int
                    if (numValues === 1) {
                        return file.getUint16(entryOffset + 8, !bigEnd);
                    }
                    offset = numValues > 2 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
                    }
                    return vals;

                case 4:
                    // long, 32 bit int
                    if (numValues === 1) {
                        return file.getUint32(entryOffset + 8, !bigEnd);
                    }
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;

                case 5:
                    // rational = two long values, first is numerator, second is denominator
                    if (numValues === 1) {
                        numerator = file.getUint32(valueOffset, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4, !bigEnd);
                        val = {}; //@TODO need to inspect if this fix is really working
                        val.numerator = numerator;
                        val.denominator = denominator;
                        return val;
                    }
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
                        vals[n] = {}; //@TODO need to inspect if this fix is really working
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;

                case 9:
                    // slong, 32 bit signed int
                    if (numValues === 1) {
                        return file.getInt32(entryOffset + 8, !bigEnd);
                    }
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;

                case 10:
                    // signed rational, two slongs, first is numerator, second is denominator
                    if (numValues === 1) {
                        return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
                    }
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
                    }
                    return vals;
            }
        }

        function getStringFromDB(buffer, start, length) {
            var outstr = '';
            for (var n = start; n < start + length; n++) {
                outstr += String.fromCharCode(buffer.getUint8(n));
            }
            return outstr;
        }

        function readEXIFData(file, start) {
            if (getStringFromDB(file, start, 4) !== 'Exif') {
                if (debug) {
                    console.log('Not valid EXIF data! ' + getStringFromDB(file, start, 4));
                }
                return false;
            }

            var bigEnd,
                tags,
                tag,
                exifData,
                gpsData,
                tiffOffset = start + 6;

            // test for TIFF validity and endianness
            if (file.getUint16(tiffOffset) === 0x4949) {
                bigEnd = false;
            } else if (file.getUint16(tiffOffset) === 0x4D4D) {
                bigEnd = true;
            } else {
                if (debug) {
                    console.log('Not valid TIFF data! (no 0x4949 or 0x4D4D)');
                }
                return false;
            }

            if (file.getUint16(tiffOffset + 2, !bigEnd) !== 0x002A) {
                if (debug) {
                    console.log('Not valid TIFF data! (no 0x002A)');
                }
                return false;
            }

            var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);

            if (firstIFDOffset < 0x00000008) {
                if (debug) {
                    console.log('Not valid TIFF data! (First offset less than 8)', file.getUint32(tiffOffset + 4, !bigEnd));
                }
                return false;
            }

            tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

            if (tags.ExifIFDPointer) {
                exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
                for (tag in exifData) {
                    switch (tag) {
                        case 'LightSource':
                        case 'Flash':
                        case 'MeteringMode':
                        case 'ExposureProgram':
                        case 'SensingMethod':
                        case 'SceneCaptureType':
                        case 'SceneType':
                        case 'CustomRendered':
                        case 'WhiteBalance':
                        case 'GainControl':
                        case 'Contrast':
                        case 'Saturation':
                        case 'Sharpness':
                        case 'SubjectDistanceRange':
                        case 'FileSource':
                            exifData[tag] = StringValues[tag][exifData[tag]];
                            break;

                        case 'ExifVersion':
                        case 'FlashpixVersion':
                            exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                            break;

                        case 'ComponentsConfiguration':
                            exifData[tag] = StringValues.Components[exifData[tag][0]] + StringValues.Components[exifData[tag][1]] + StringValues.Components[exifData[tag][2]] + StringValues.Components[exifData[tag][3]];
                            break;
                    }
                    tags[tag] = exifData[tag];
                }
            }

            if (tags.GPSInfoIFDPointer) {
                gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
                for (tag in gpsData) {
                    switch (tag) {
                        case 'GPSVersionID':
                            gpsData[tag] = gpsData[tag][0] + '.' + gpsData[tag][1] + '.' + gpsData[tag][2] + '.' + gpsData[tag][3];
                            break;
                    }
                    tags[tag] = gpsData[tag];
                }
            }

            return tags;
        }

        this.getData = function (img, callback) {
            if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) {
                return false;
            }

            if (!imageHasData(img)) {
                getImageData(img, callback);
            } else {
                if (callback) {
                    callback.call(img);
                }
            }
            return true;
        };

        this.getTag = function (img, tag) {
            if (!imageHasData(img)) {
                return;
            }
            return img.exifdata[tag];
        };

        this.getAllTags = function (img) {
            if (!imageHasData(img)) {
                return {};
            }
            var a,
                data = img.exifdata,
                tags = {};
            for (a in data) {
                if (data.hasOwnProperty(a)) {
                    tags[a] = data[a];
                }
            }
            return tags;
        };

        this.pretty = function (img) {
            if (!imageHasData(img)) {
                return '';
            }
            var a,
                data = img.exifdata,
                strPretty = '';
            for (a in data) {
                if (data.hasOwnProperty(a)) {
                    if (_typeof(data[a]) === 'object') {
                        if (data[a] instanceof Number) {
                            strPretty += a + ' : ' + data[a] + ' [' + data[a].numerator + '/' + data[a].denominator + ']\r\n';
                        } else {
                            strPretty += a + ' : [' + data[a].length + ' values]\r\n';
                        }
                    } else {
                        strPretty += a + ' : ' + data[a] + '\r\n';
                    }
                }
            }
            return strPretty;
        };

        this.readFromBinaryFile = function (file) {
            return findEXIFinJPEG(file);
        };
    }]);

    angular.module('uiCropper').factory('cropHost', ['$document', '$q', 'cropAreaCircle', 'cropAreaSquare', 'cropAreaRectangle', 'cropEXIF', function ($document, $q, CropAreaCircle, CropAreaSquare, CropAreaRectangle, cropEXIF) {
        /* STATIC FUNCTIONS */
        var colorPaletteLength = 8;

        // Get Element's Offset
        var getElementOffset = function getElementOffset(elem) {
            var box = elem.getBoundingClientRect();

            var body = document.body;
            var docElem = document.documentElement;

            var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;

            var clientTop = docElem.clientTop || body.clientTop || 0;
            var clientLeft = docElem.clientLeft || body.clientLeft || 0;

            var top = box.top + scrollTop - clientTop;
            var left = box.left + scrollLeft - clientLeft;

            return {
                top: Math.round(top),
                left: Math.round(left)
            };
        };

        return function (elCanvas, opts, events) {
            /* PRIVATE VARIABLES */

            // Object Pointers
            var ctx = null,
                image = null,
                theArea = null,
                initMax = null,
                isAspectRatio = null,
                self = this,


            // Dimensions
            minCanvasDims = [100, 100],
                maxCanvasDims = [300, 300],
                scalemode = null,


            // Result Image size
            resImgSizeArray = [],
                resImgSize = {
                w: 200,
                h: 200
            },
                areaMinRelativeSize = null,


            // Result Image type
            resImgFormat = 'image/png',


            // Result Image quality
            resImgQuality = null,
                forceAspectRatio = false;

            /* PRIVATE FUNCTIONS */
            this.setInitMax = function (bool) {
                initMax = bool;
            };
            this.setAllowCropResizeOnCorners = function (bool) {
                theArea.setAllowCropResizeOnCorners(bool);
            };
            // Draw Scene
            function drawScene() {
                // clear canvas
                ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

                if (image !== null) {
                    // draw source image
                    ctx.drawImage(image, 0, 0, ctx.canvas.width, ctx.canvas.height);

                    ctx.save();

                    // and make it darker
                    ctx.fillStyle = 'rgba(0, 0, 0, 0.65)';
                    ctx.fillRect(0, 0, ctx.canvas.width, ctx.canvas.height);

                    ctx.restore();

                    // draw Area
                    theArea.draw();
                }
            }

            // Resets CropHost
            var resetCropHost = function resetCropHost() {
                if (image !== null) {
                    theArea.setImage(image);
                    var imageDims = [image.width, image.height],
                        imageRatio = image.width / image.height,
                        canvasDims = imageDims;

                    if (canvasDims[0] > maxCanvasDims[0]) {
                        canvasDims[0] = maxCanvasDims[0];
                        canvasDims[1] = canvasDims[0] / imageRatio;
                    } else if (canvasDims[0] < minCanvasDims[0]) {
                        canvasDims[0] = minCanvasDims[0];
                        canvasDims[1] = canvasDims[0] / imageRatio;
                    }
                    if (scalemode === 'fixed-height' && canvasDims[1] > maxCanvasDims[1]) {
                        canvasDims[1] = maxCanvasDims[1];
                        canvasDims[0] = canvasDims[1] * imageRatio;
                    } else if (canvasDims[1] < minCanvasDims[1]) {
                        canvasDims[1] = minCanvasDims[1];
                        canvasDims[0] = canvasDims[1] * imageRatio;
                    }
                    elCanvas.prop('width', canvasDims[0]).prop('height', canvasDims[1]);
                    if (scalemode === 'fixed-height') {
                        elCanvas.css({
                            'margin-left': -canvasDims[0] / 2 + 'px',
                            'margin-top': -canvasDims[1] / 2 + 'px'
                        });
                    }

                    var cw = ctx.canvas.width;
                    var ch = ctx.canvas.height;

                    var areaType = self.getAreaType();
                    // enforce 1:1 aspect ratio for square-like selections
                    if (areaType === 'circle' || areaType === 'square') {
                        if (ch < cw) {
                            cw = ch;
                        }
                        ch = cw;
                    } else if (areaType === 'rectangle' && isAspectRatio) {
                        var aspectRatio = theArea.getAspect(); // use `aspectRatio` instead of `resImgSize` dimensions bc `resImgSize` can be 'selection' string
                        if (cw / ch > aspectRatio) {
                            cw = aspectRatio * ch;
                        } else {
                            ch = aspectRatio * cw;
                        }
                    }

                    if (initMax) {
                        theArea.setSize({
                            w: cw,
                            h: ch
                        });
                    } else if (undefined !== theArea.getInitSize()) {
                        theArea.setSize({
                            w: Math.min(theArea.getInitSize().w, cw / 2),
                            h: Math.min(theArea.getInitSize().h, ch / 2)
                        });
                    } else {
                        theArea.setSize({
                            w: Math.min(200, cw / 2),
                            h: Math.min(200, ch / 2)
                        });
                    }

                    if (theArea.getInitCoords()) {
                        if (self.areaInitIsRelativeToImage) {
                            var ratio = image.width / canvasDims[0];
                            theArea.setSize({
                                w: theArea.getInitSize().w / ratio,
                                h: theArea.getInitSize().h / ratio,
                                x: theArea.getInitCoords().x / ratio,
                                y: theArea.getInitCoords().y / ratio
                            });
                        } else {
                            theArea.setSize({
                                w: theArea.getSize().w,
                                h: theArea.getSize().h,
                                x: theArea.getInitCoords().x,
                                y: theArea.getInitCoords().y
                            });
                        }
                    } else {
                        theArea.setCenterPoint({
                            x: ctx.canvas.width / 2,
                            y: ctx.canvas.height / 2
                        });
                    }
                } else {
                    elCanvas.prop('width', 0).prop('height', 0).css({
                        'margin-top': 0
                    });
                }

                drawScene();
            };

            var getChangedTouches = function getChangedTouches(event) {
                if (angular.isDefined(event.changedTouches)) {
                    return event.changedTouches;
                } else {
                    return event.originalEvent.changedTouches;
                }
            };

            var onMouseMove = function onMouseMove(e) {
                if (image !== null) {
                    var offset = getElementOffset(ctx.canvas),
                        pageX,
                        pageY;
                    if (e.type === 'touchmove') {
                        pageX = getChangedTouches(e)[0].pageX;
                        pageY = getChangedTouches(e)[0].pageY;
                    } else {
                        pageX = e.pageX;
                        pageY = e.pageY;
                    }
                    theArea.processMouseMove(pageX - offset.left, pageY - offset.top);
                    drawScene();
                }
            };

            var onMouseDown = function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
                if (image !== null) {
                    var offset = getElementOffset(ctx.canvas),
                        pageX,
                        pageY;
                    if (e.type === 'touchstart') {
                        pageX = getChangedTouches(e)[0].pageX;
                        pageY = getChangedTouches(e)[0].pageY;
                    } else {
                        pageX = e.pageX;
                        pageY = e.pageY;
                    }
                    theArea.processMouseDown(pageX - offset.left, pageY - offset.top);
                    drawScene();
                }
            };

            var onMouseUp = function onMouseUp(e) {
                if (image !== null) {
                    var offset = getElementOffset(ctx.canvas),
                        pageX,
                        pageY;
                    if (e.type === 'touchend') {
                        pageX = getChangedTouches(e)[0].pageX;
                        pageY = getChangedTouches(e)[0].pageY;
                    } else {
                        pageX = e.pageX;
                        pageY = e.pageY;
                    }
                    theArea.processMouseUp(pageX - offset.left, pageY - offset.top);
                    drawScene();
                }
            };

            var renderTempCanvas = function renderTempCanvas(ris, center) {
                var temp_ctx, temp_canvas;
                temp_canvas = angular.element('<canvas></canvas>')[0];
                temp_ctx = temp_canvas.getContext('2d');
                temp_canvas.width = ris.w;
                temp_canvas.height = ris.h;
                if (image !== null) {
                    var x = (center.x - theArea.getSize().w / 2) * (image.width / ctx.canvas.width),
                        y = (center.y - theArea.getSize().h / 2) * (image.height / ctx.canvas.height),
                        areaWidth = theArea.getSize().w * (image.width / ctx.canvas.width),
                        areaHeight = theArea.getSize().h * (image.height / ctx.canvas.height);

                    if (forceAspectRatio) {
                        temp_ctx.drawImage(image, x, y, areaWidth, areaHeight, 0, 0, ris.w, ris.h);
                    } else {
                        var aspectRatio = areaWidth / areaHeight;
                        var resultHeight, resultWidth;

                        if (aspectRatio > 1) {
                            resultWidth = ris.w;
                            resultHeight = resultWidth / aspectRatio;
                        } else {
                            resultHeight = ris.h;
                            resultWidth = resultHeight * aspectRatio;
                        }

                        temp_canvas.width = resultWidth;
                        temp_canvas.height = resultHeight;

                        temp_ctx.drawImage(image, x, y, areaWidth, areaHeight, 0, 0, Math.round(resultWidth), Math.round(resultHeight));
                    }
                }
                return temp_canvas;
            };

            var renderImageToDataURL = function renderImageToDataURL(getResultImageSize) {
                var temp_canvas,
                    retObj = {
                    dataURI: null,
                    imageData: null
                };
                temp_canvas = renderTempCanvas(getResultImageSize, theArea.getCenterPoint());
                if (image !== null) {
                    if (resImgQuality !== null) {
                        retObj.dataURI = temp_canvas.toDataURL(resImgFormat, resImgQuality);
                    } else {
                        retObj.dataURI = temp_canvas.toDataURL(resImgFormat);
                    }
                }
                return retObj;
            };

            this.getResultImage = function () {
                if (resImgSizeArray.length === 0) {
                    return renderImageToDataURL(this.getResultImageSize());
                }

                var arrayResultImages = [];
                for (var i = 0; i < resImgSizeArray.length; i++) {
                    arrayResultImages.push({
                        dataURI: renderImageToDataURL(resImgSizeArray[i]).dataURI,
                        w: resImgSizeArray[i].w,
                        h: resImgSizeArray[i].h
                    });
                }

                return arrayResultImages;
            };

            this.getResultImageDataBlob = function () {
                var temp_canvas,
                    _p = $q.defer();
                temp_canvas = renderTempCanvas(this.getResultImageSize(), theArea.getCenterPoint());
                if (resImgQuality !== null) {
                    temp_canvas.toBlob(function (blob) {
                        _p.resolve(blob);
                    }, resImgFormat, resImgQuality);
                } else {
                    temp_canvas.toBlob(function (blob) {
                        _p.resolve(blob);
                    }, resImgFormat);
                }

                return _p.promise;
            };

            this.getAreaCoords = function () {
                return theArea.getSize();
            };

            this.getArea = function () {
                return theArea;
            };

            this.setNewImageSource = function (imageSource) {
                image = null;
                resetCropHost();
                if (imageSource) {
                    var newImage = new Image();
                    newImage.onload = function () {
                        events.trigger('load-done');

                        cropEXIF.getData(newImage, function () {
                            var orientation = cropEXIF.getTag(newImage, 'Orientation');

                            if ([3, 6, 8].indexOf(orientation) > -1) {
                                var canvas = document.createElement('canvas'),
                                    ctx = canvas.getContext('2d'),
                                    cw = newImage.width,
                                    ch = newImage.height,
                                    cx = 0,
                                    cy = 0,
                                    deg = 0,
                                    rw = 0,
                                    rh = 0;
                                rw = cw;
                                rh = ch;
                                switch (orientation) {
                                    case 3:
                                        cx = -newImage.width;
                                        cy = -newImage.height;
                                        deg = 180;
                                        break;
                                    case 6:
                                        cw = newImage.height;
                                        ch = newImage.width;
                                        cy = -newImage.height;
                                        rw = ch;
                                        rh = cw;
                                        deg = 90;
                                        break;
                                    case 8:
                                        cw = newImage.height;
                                        ch = newImage.width;
                                        cx = -newImage.width;
                                        rw = ch;
                                        rh = cw;
                                        deg = 270;
                                        break;
                                }

                                //// canvas.toDataURL will only work if the canvas isn't too large. Resize to 1000px.
                                var maxWorH = 1000;
                                if (cw > maxWorH || ch > maxWorH) {
                                    var p = 0;
                                    if (cw > maxWorH) {
                                        p = maxWorH / cw;
                                        cw = maxWorH;
                                        ch = p * ch;
                                    } else if (ch > maxWorH) {
                                        p = maxWorH / ch;
                                        ch = maxWorH;
                                        cw = p * cw;
                                    }

                                    cy = p * cy;
                                    cx = p * cx;
                                    rw = p * rw;
                                    rh = p * rh;
                                }

                                canvas.width = cw;
                                canvas.height = ch;
                                ctx.rotate(deg * Math.PI / 180);
                                ctx.drawImage(newImage, cx, cy, rw, rh);

                                image = new Image();
                                image.onload = function () {
                                    resetCropHost();
                                    events.trigger('image-updated');
                                };

                                image.src = canvas.toDataURL(resImgFormat);
                            } else {
                                image = newImage;
                                events.trigger('image-updated');
                            }
                            resetCropHost();
                        });
                    };
                    newImage.onerror = function () {
                        events.trigger('load-error');
                    };
                    events.trigger('load-start');
                    if (imageSource instanceof window.Blob) {
                        newImage.src = URL.createObjectURL(imageSource);
                    } else {
                        if (imageSource.substring(0, 4).toLowerCase() === 'http' || imageSource.substring(0, 2) === '//') {
                            newImage.crossOrigin = 'anonymous';
                        }
                        newImage.src = imageSource;
                    }
                }
            };

            this.setMaxDimensions = function (width, height) {
                maxCanvasDims = [width, height];

                if (image !== null) {
                    var curWidth = ctx.canvas.width,
                        curHeight = ctx.canvas.height;

                    var imageDims = [image.width, image.height],
                        imageRatio = image.width / image.height,
                        canvasDims = imageDims;

                    if (canvasDims[0] > maxCanvasDims[0]) {
                        canvasDims[0] = maxCanvasDims[0];
                        canvasDims[1] = canvasDims[0] / imageRatio;
                    } else if (canvasDims[0] < minCanvasDims[0]) {
                        canvasDims[0] = minCanvasDims[0];
                        canvasDims[1] = canvasDims[0] / imageRatio;
                    }
                    if (scalemode === 'fixed-height' && canvasDims[1] > maxCanvasDims[1]) {
                        canvasDims[1] = maxCanvasDims[1];
                        canvasDims[0] = canvasDims[1] * imageRatio;
                    } else if (canvasDims[1] < minCanvasDims[1]) {
                        canvasDims[1] = minCanvasDims[1];
                        canvasDims[0] = canvasDims[1] * imageRatio;
                    }
                    elCanvas.prop('width', canvasDims[0]).prop('height', canvasDims[1]);

                    if (scalemode === 'fixed-height') {
                        elCanvas.css({
                            'margin-left': -canvasDims[0] / 2 + 'px',
                            'margin-top': -canvasDims[1] / 2 + 'px'
                        });
                    }

                    var ratioNewCurWidth = ctx.canvas.width / curWidth,
                        ratioNewCurHeight = ctx.canvas.height / curHeight,
                        ratioMin = Math.min(ratioNewCurWidth, ratioNewCurHeight);

                    //TODO: use top left corner point
                    var center = theArea.getCenterPoint();
                    theArea.setSize({
                        w: theArea.getSize().w * ratioMin,
                        h: theArea.getSize().h * ratioMin
                    });
                    theArea.setCenterPoint({
                        x: center.x * ratioNewCurWidth,
                        y: center.y * ratioNewCurHeight
                    });
                } else {
                    elCanvas.prop('width', 0).prop('height', 0).css({
                        'margin-top': 0
                    });
                }

                drawScene();
            };

            this.setAreaMinSize = function (size) {
                if (angular.isUndefined(size)) {
                    return;
                } else if (typeof size === 'number' || typeof size === 'string') {
                    size = {
                        w: parseInt(parseInt(size), 10),
                        h: parseInt(parseInt(size), 10)
                    };
                } else {
                    size = {
                        w: parseInt(size.w, 10),
                        h: parseInt(size.h, 10)
                    };
                }
                if (!isNaN(size.w) && !isNaN(size.h)) {
                    theArea.setMinSize(size);
                    drawScene();
                }
            };

            this.setAreaMinRelativeSize = function (size) {
                if (image === null || angular.isUndefined(size)) {
                    return;
                }

                var canvasSize = theArea.getCanvasSize();

                if (typeof size === 'number' || typeof size === 'string') {
                    areaMinRelativeSize = {
                        w: size,
                        h: size
                    };
                    size = {
                        w: canvasSize.w / (image.width / parseInt(parseInt(size), 10)),
                        h: canvasSize.h / (image.height / parseInt(parseInt(size), 10))
                    };
                } else {
                    areaMinRelativeSize = size;
                    size = {
                        w: canvasSize.w / (image.width / parseInt(parseInt(size.w), 10)),
                        h: canvasSize.h / (image.height / parseInt(parseInt(size.h), 10))
                    };
                }

                if (!isNaN(size.w) && !isNaN(size.h)) {
                    theArea.setMinSize(size);
                    drawScene();
                }
            };

            this.setAreaInitSize = function (size) {
                if (angular.isUndefined(size)) {
                    return;
                } else if (typeof size === 'number' || typeof size === 'string') {
                    size = {
                        w: parseInt(parseInt(size), 10),
                        h: parseInt(parseInt(size), 10)
                    };
                } else {
                    size = {
                        w: parseInt(size.w, 10),
                        h: parseInt(size.h, 10)
                    };
                }
                if (!isNaN(size.w) && !isNaN(size.h)) {
                    theArea.setInitSize(size);
                    drawScene();
                }
            };

            this.setAreaInitCoords = function (coords) {
                if (angular.isUndefined(coords)) {
                    return;
                } else {
                    coords = {
                        x: parseInt(coords.x, 10),
                        y: parseInt(coords.y, 10)
                    };
                }
                if (!isNaN(coords.x) && !isNaN(coords.y)) {
                    theArea.setInitCoords(coords);
                    drawScene();
                }
            };

            this.setMaxCanvasDimensions = function (maxCanvasDimensions) {
                if (!angular.isUndefined(maxCanvasDimensions)) {
                    var newMaxCanvasDims = [];
                    if (typeof maxCanvasDimensions === 'number' || typeof maxCanvasDimensions === 'string') {
                        newMaxCanvasDims = [parseInt(parseInt(maxCanvasDimensions), 10), parseInt(parseInt(maxCanvasDimensions), 10)];
                    } else {
                        newMaxCanvasDims = [parseInt(maxCanvasDimensions.w, 10), parseInt(maxCanvasDimensions.h, 10)];
                    }
                    if (!isNaN(newMaxCanvasDims[0]) && newMaxCanvasDims[0] > 0 && newMaxCanvasDims[0] > minCanvasDims[0] && !isNaN(newMaxCanvasDims[1]) && newMaxCanvasDims[1] > 0 && newMaxCanvasDims[1] > minCanvasDims[1]) {
                        maxCanvasDims = newMaxCanvasDims;
                    }
                }
            };

            this.setMinCanvasDimensions = function (minCanvasDimensions) {
                if (!angular.isUndefined(minCanvasDimensions)) {
                    var newMinCanvasDims = [];
                    if (typeof minCanvasDimensions === 'number' || typeof minCanvasDimensions === 'string') {
                        newMinCanvasDims = [parseInt(parseInt(minCanvasDimensions), 10), parseInt(parseInt(minCanvasDimensions), 10)];
                    } else {
                        newMinCanvasDims = [parseInt(minCanvasDimensions.w, 10), parseInt(minCanvasDimensions.h, 10)];
                    }
                    if (!isNaN(newMinCanvasDims[0]) && newMinCanvasDims[0] >= 0 && !isNaN(newMinCanvasDims[1]) && newMinCanvasDims[1] >= 0) {
                        minCanvasDims = newMinCanvasDims;
                    }
                }
            };

            this.setScalemode = function (value) {
                scalemode = value;
            };

            this.getScalemode = function () {
                return scalemode;
            };

            this.getResultImageSize = function () {
                if (resImgSize === 'selection') {
                    return theArea.getSize();
                }

                if (resImgSize === 'max') {
                    // We maximize the rendered size
                    var zoom = 1;
                    if (image && ctx && ctx.canvas) {
                        zoom = image.width / ctx.canvas.width;
                    }
                    var size = {
                        w: zoom * theArea.getSize().w,
                        h: zoom * theArea.getSize().h
                    };

                    if (areaMinRelativeSize) {
                        if (size.w < areaMinRelativeSize.w) {
                            size.w = areaMinRelativeSize.w;
                        }
                        if (size.h < areaMinRelativeSize.h) {
                            size.h = areaMinRelativeSize.h;
                        }
                    }

                    return size;
                }

                return resImgSize;
            };

            this.setResultImageSize = function (size) {
                if (angular.isArray(size)) {
                    resImgSizeArray = size.slice();
                    size = {
                        w: parseInt(size[0].w, 10),
                        h: parseInt(size[0].h, 10)
                    };
                    return;
                }
                if (angular.isUndefined(size)) {
                    return;
                }
                //allow setting of size to "selection" for mirroring selection's dimensions
                if (angular.isString(size)) {
                    resImgSize = size;
                    return;
                }
                //allow scalar values for square-like selection shapes
                if (angular.isNumber(size)) {
                    size = parseInt(size, 10);
                    size = {
                        w: size,
                        h: size
                    };
                }
                size = {
                    w: parseInt(size.w, 10),
                    h: parseInt(size.h, 10)
                };
                if (!isNaN(size.w) && !isNaN(size.h)) {
                    resImgSize = size;
                    drawScene();
                }
            };

            this.setResultImageFormat = function (format) {
                resImgFormat = format;
            };

            this.setResultImageQuality = function (quality) {
                quality = parseFloat(quality);
                if (!isNaN(quality) && quality >= 0 && quality <= 1) {
                    resImgQuality = quality;
                }
            };

            // returns a string of the selection area's type
            this.getAreaType = function () {
                return theArea.getType();
            };

            this.setAreaType = function (type) {
                var center = theArea.getCenterPoint();
                var curSize = theArea.getSize(),
                    curMinSize = theArea.getMinSize(),
                    curX = center.x,
                    curY = center.y;

                var AreaClass = CropAreaCircle;
                if (type === 'square') {
                    AreaClass = CropAreaSquare;
                } else if (type === 'rectangle') {
                    AreaClass = CropAreaRectangle;
                }
                theArea = new AreaClass(ctx, events);
                theArea.setMinSize(curMinSize);
                theArea.setSize(curSize);
                if (type === 'square' || type === 'circle') {
                    forceAspectRatio = true;
                    theArea.setForceAspectRatio(true);
                } else {
                    forceAspectRatio = false;
                    theArea.setForceAspectRatio(false);
                }

                //TODO: use top left point
                theArea.setCenterPoint({
                    x: curX,
                    y: curY
                });

                // resetCropHost();
                if (image !== null) {
                    theArea.setImage(image);
                }

                drawScene();
            };

            this.getDominantColor = function (uri) {
                var imageDC = new Image(),
                    colorThief = new ColorThief(),
                    dominantColor = null,
                    _p = $q.defer();
                imageDC.src = uri;
                imageDC.onload = function () {
                    dominantColor = colorThief.getColor(imageDC);
                    _p.resolve(dominantColor);
                };

                return _p.promise;
            };

            this.getPalette = function (uri) {
                var imageDC = new Image(),
                    colorThief = new ColorThief(),
                    palette = null,
                    _p = $q.defer();
                imageDC.src = uri;
                imageDC.onload = function () {
                    palette = colorThief.getPalette(imageDC, colorPaletteLength);
                    _p.resolve(palette);
                };

                return _p.promise;
            };

            this.setPaletteColorLength = function (lg) {
                colorPaletteLength = lg;
            };

            this.setAspect = function (aspect) {
                isAspectRatio = true;
                theArea.setAspect(aspect);
                var minSize = theArea.getMinSize();
                minSize.w = minSize.h * aspect;
                theArea.setMinSize(minSize);
                var size = theArea.getSize();
                size.w = size.h * aspect;
                theArea.setSize(size);
            };

            /* Life Cycle begins */

            // Init Context var
            ctx = elCanvas[0].getContext('2d');

            // Init CropArea
            theArea = new CropAreaCircle(ctx, events);

            // Init Mouse Event Listeners
            $document.on('mousemove', onMouseMove);
            elCanvas.on('mousedown', onMouseDown);
            $document.on('mouseup', onMouseUp);

            // Init Touch Event Listeners
            $document.on('touchmove', onMouseMove);
            elCanvas.on('touchstart', onMouseDown);
            $document.on('touchend', onMouseUp);

            // CropHost Destructor
            this.destroy = function () {
                $document.off('mousemove', onMouseMove);
                elCanvas.off('mousedown', onMouseDown);
                $document.off('mouseup', onMouseUp);

                $document.off('touchmove', onMouseMove);
                elCanvas.off('touchstart', onMouseDown);
                $document.off('touchend', onMouseUp);

                elCanvas.remove();
            };
        };
    }]);

    angular.module('uiCropper').factory('cropPubSub', [function () {
        return function () {
            var events = {};
            // Subscribe
            this.on = function (names, handler) {
                names.split(' ').forEach(function (name) {
                    if (!events[name]) {
                        events[name] = [];
                    }
                    events[name].push(handler);
                });
                return this;
            };
            // Publish
            this.trigger = function (name, args) {
                angular.forEach(events[name], function (handler) {
                    handler.call(null, args);
                });
                return this;
            };
        };
    }]);

    angular.module('uiCropper').directive('uiCropper', ['$timeout', 'cropHost', 'cropPubSub', function ($timeout, CropHost, CropPubSub) {
        return {
            restrict: 'E',
            scope: {
                image: '=',
                resultImage: '=',
                resultArrayImage: '=?',
                resultBlob: '=?',
                urlBlob: '=?',
                chargement: '=?',
                cropject: '=?',
                maxCanvasDimensions: '=?',
                minCanvasDimensions: '=?',
                canvasScalemode: '@?', /* String. If set to 'full-width' the directive uses all width available */
                /* and the canvas expands in height as much as it need to maintain the aspect ratio */
                /* if set to 'fixed-height', the directive is restricted by a parent element in height */

                changeOnFly: '=?',
                liveView: '=?',
                initMaxArea: '=?',
                areaCoords: '=?',
                areaType: '@',
                areaMinSize: '=?',
                areaInitSize: '=?',
                areaInitCoords: '=?',
                areaInitIsRelativeToImage: '=?', /* Boolean: If true the areaInitCoords and areaInitSize is scaled according to canvas size. */
                /* No matter how big/small the canvas is, the resultImage remains the same */
                /* Example: areaInitCoords are {x: 100, y: 100}, areaInitSize {w: 100, h: 100}   */
                /* Image is 1000x1000
                 /* if canvas is 500x500 Crop coordinates will be x: 50, y: 50, w: 50, h: 50 */
                /* if canvas is 100x100 crop coordinates will be x: 10, y: 10, w: 10, h: 10 */
                areaMinRelativeSize: '=?',
                resultImageSize: '=?',
                resultImageFormat: '@',
                resultImageQuality: '=?',

                aspectRatio: '=?',
                allowCropResizeOnCorners: '=?',

                dominantColor: '=?',
                paletteColor: '=?',
                paletteColorLength: '=?',

                onChange: '&',
                onLoadBegin: '&',
                onLoadDone: '&',
                onLoadError: '&'
            },
            template: '<canvas></canvas>',
            controller: ['$scope', function ($scope) {
                $scope.events = new CropPubSub();
            }],
            link: function link(scope, element) {
                // Init Events Manager
                var events = scope.events;

                // Init Crop Host
                var cropHost = new CropHost(element.find('canvas'), {}, events);

                if (scope.canvasScalemode) {
                    cropHost.setScalemode(scope.canvasScalemode);
                } else {
                    cropHost.setScalemode('fixed-height');
                }

                element.addClass(cropHost.getScalemode());

                // Store Result Image to check if it's changed
                var storedResultImage;

                var updateAreaCoords = function updateAreaCoords(scope) {
                    scope.areaCoords = cropHost.getAreaCoords();
                };

                var updateResultImage = function updateResultImage(scope, force, callback) {
                    if (scope.image !== '' && (!scope.liveView.block || force)) {
                        var resultImageObj = cropHost.getResultImage();
                        var resultImage;
                        if (angular.isArray(resultImageObj)) {
                            resultImage = resultImageObj[0].dataURI;
                            scope.resultArrayImage = resultImageObj;
                        } else {
                            resultImage = resultImageObj.dataURI;
                        }

                        var urlCreator = window.URL || window.webkitURL;
                        if (storedResultImage !== resultImage) {
                            storedResultImage = resultImage;
                            scope.resultImage = resultImage;
                            if (scope.liveView.callback) {
                                scope.liveView.callback(resultImage);
                            }
                            if (callback) {
                                callback(resultImage);
                            }
                            cropHost.getResultImageDataBlob().then(function (blob) {
                                scope.resultBlob = blob;
                                scope.urlBlob = urlCreator.createObjectURL(blob);
                            });

                            if (scope.resultImage) {
                                cropHost.getDominantColor(scope.resultImage).then(function (dominantColor) {
                                    scope.dominantColor = dominantColor;
                                });
                                cropHost.getPalette(scope.resultImage).then(function (palette) {
                                    scope.paletteColor = palette;
                                });
                            }

                            updateAreaCoords(scope);
                            scope.onChange({
                                $dataURI: scope.resultImage
                            });
                        }
                    }
                };

                if (scope.liveView && typeof scope.liveView.block === 'boolean') {
                    scope.liveView.render = function (callback) {
                        updateResultImage(scope, true, callback);
                    };
                } else {
                    scope.liveView = { block: false };
                }

                var updateCropject = function updateCropject(scope) {
                    var areaCoords = cropHost.getAreaCoords();

                    var dimRatio = {
                        x: cropHost.getArea().getImage().width / cropHost.getArea().getCanvasSize().w,
                        y: cropHost.getArea().getImage().height / cropHost.getArea().getCanvasSize().h
                    };

                    scope.cropject = {
                        canvasSize: cropHost.getArea().getCanvasSize(),
                        areaCoords: areaCoords,
                        cropWidth: areaCoords.w,
                        cropHeight: areaCoords.h,
                        cropTop: areaCoords.y,
                        cropLeft: areaCoords.x,
                        cropImageWidth: Math.round(areaCoords.w * dimRatio.x),
                        cropImageHeight: Math.round(areaCoords.h * dimRatio.y),
                        cropImageTop: Math.round(areaCoords.y * dimRatio.y),
                        cropImageLeft: Math.round(areaCoords.x * dimRatio.x)
                    };
                };

                // Wrapper to safely exec functions within $apply on a running $digest cycle
                var fnSafeApply = function fnSafeApply(fn) {
                    return function () {
                        $timeout(function () {
                            scope.$apply(function (scope) {
                                fn(scope);
                            });
                        });
                    };
                };

                // Will get the users language settings, and return the appropriate loading text
                var printLoadMsg = function printLoadMsg() {
                    var language = window.navigator.userLanguage || window.navigator.language;

                    switch (language) {
                        case 'nl':
                        case 'nl_NL':
                            return 'Aan het laden';

                        case 'fr':
                        case 'fr-FR':
                            return 'Chargement';

                        case 'es':
                        case 'es-ES':
                            return 'Cargando';

                        case 'ca':
                        case 'ca-ES':
                            return 'Càrrega';

                        case 'de':
                        case 'de-DE':
                            return 'Laden';

                        case 'pt':
                        case 'pt-BR':
                            return 'Carregando';

                        default:
                            return 'Loading';
                    }
                };

                if (!scope.chargement) {
                    scope.chargement = printLoadMsg();
                }
                var displayLoading = function displayLoading() {
                    element.append('<div class="loading"><span>' + scope.chargement + '...</span></div>');
                };

                // Setup CropHost Event Handlers
                events.on('load-start', fnSafeApply(function (scope) {
                    scope.onLoadBegin({});
                })).on('load-done', fnSafeApply(function (scope) {
                    var children = element.children();
                    angular.forEach(children, function (child) {
                        if (angular.element(child).hasClass('loading')) {
                            angular.element(child).remove();
                        }
                    });
                    updateCropject(scope);
                    scope.onLoadDone({});
                })).on('load-error', fnSafeApply(function (scope) {
                    scope.onLoadError({});
                })).on('area-move area-resize', fnSafeApply(function (scope) {
                    if (scope.changeOnFly === true) {
                        updateResultImage(scope);
                    }
                    updateCropject(scope);
                })).on('image-updated', fnSafeApply(function (scope) {
                    cropHost.setAreaMinRelativeSize(scope.areaMinRelativeSize);
                })).on('area-move-end area-resize-end image-updated', fnSafeApply(function (scope) {
                    updateResultImage(scope);
                    updateCropject(scope);
                }));

                // Sync CropHost with Directive's options
                scope.$watch('image', function (newVal) {
                    if (newVal) {
                        displayLoading();
                    }
                    // cancel timeout if necessary
                    if (scope.timeout !== null) {
                        $timeout.cancel(scope.timeout);
                    }
                    scope.timeout = $timeout(function () {
                        scope.timeout = null;
                        cropHost.setInitMax(scope.initMaxArea);
                        cropHost.setNewImageSource(scope.image);
                    }, 100);
                });
                scope.$watch('areaType', function () {
                    cropHost.setAreaType(scope.areaType);
                    updateResultImage(scope);
                });
                scope.$watch('areaMinSize', function () {
                    cropHost.setAreaMinSize(scope.areaMinSize);
                    updateResultImage(scope);
                });
                scope.$watch('areaMinRelativeSize', function () {
                    if (scope.image !== '') {
                        cropHost.setAreaMinRelativeSize(scope.areaMinRelativeSize);
                        updateResultImage(scope);
                    }
                });
                scope.$watch('areaInitSize', function () {
                    cropHost.setAreaInitSize(scope.areaInitSize);
                    updateResultImage(scope);
                });
                scope.$watch('areaInitCoords', function () {
                    cropHost.setAreaInitCoords(scope.areaInitCoords);
                    cropHost.areaInitIsRelativeToImage = scope.areaInitIsRelativeToImage;
                    updateResultImage(scope);
                });
                scope.$watch('maxCanvasDimensions', function () {
                    cropHost.setMaxCanvasDimensions(scope.maxCanvasDimensions);
                });
                scope.$watch('minCanvasDimensions', function () {
                    cropHost.setMinCanvasDimensions(scope.minCanvasDimensions);
                });
                scope.$watch('resultImageFormat', function () {
                    cropHost.setResultImageFormat(scope.resultImageFormat);
                    updateResultImage(scope);
                });
                scope.$watch('resultImageQuality', function () {
                    cropHost.setResultImageQuality(scope.resultImageQuality);
                    updateResultImage(scope);
                });
                scope.$watch('resultImageSize', function () {
                    cropHost.setResultImageSize(scope.resultImageSize);
                    updateResultImage(scope);
                });
                scope.$watch('paletteColorLength', function () {
                    cropHost.setPaletteColorLength(scope.paletteColorLength);
                });
                scope.$watch('aspectRatio', function () {
                    if (typeof scope.aspectRatio === 'string' && scope.aspectRatio !== '') {
                        scope.aspectRatio = parseInt(scope.aspectRatio);
                    }
                    if (scope.aspectRatio) {
                        cropHost.setAspect(scope.aspectRatio);
                    }
                });
                scope.$watch('allowCropResizeOnCorners', function () {
                    if (scope.allowCropResizeOnCorners) {
                        cropHost.setAllowCropResizeOnCorners(scope.allowCropResizeOnCorners);
                    }
                });

                // Update CropHost dimensions when the directive element is resized
                scope.$watch(function () {
                    if (cropHost.getScalemode() === 'fixed-height') {
                        return [element[0].clientWidth, element[0].clientHeight];
                    }
                    if (cropHost.getScalemode() === 'full-width') {
                        return element[0].clientWidth;
                    }
                }, function (value) {

                    if (cropHost.getScalemode() === 'fixed-height') {
                        if (value[0] > 0 && value[1] > 0) {
                            cropHost.setMaxDimensions(value[0], value[1]);
                            updateResultImage(scope);
                        }
                    }
                    if (cropHost.getScalemode() === 'full-width') {
                        if (value > 0) {
                            cropHost.setMaxDimensions(value);
                        }
                    }
                }, true);

                // Destroy CropHost Instance when the directive is destroying
                scope.$on('$destroy', function () {
                    cropHost.destroy();
                });
            }
        };
    }]);
})();

/* canvas-toBlob.js
 * A canvas.toBlob() implementation.
 * 2013-12-27
 * 
 * By Eli Grey, http://eligrey.com and Devin Samarin, https://github.com/eboyjr
 * License: X11/MIT
 *   See https://github.com/eligrey/canvas-toBlob.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, regexp: true, confusion: true, es5: true, vars: true, white: true,
  plusplus: true */

/*! @source http://purl.eligrey.com/github/canvas-toBlob.js/blob/master/canvas-toBlob.js */

(function (view) {
    "use strict";

    var Uint8Array = view.Uint8Array,
        HTMLCanvasElement = view.HTMLCanvasElement,
        canvas_proto = HTMLCanvasElement && HTMLCanvasElement.prototype,
        is_base64_regex = /\s*;\s*base64\s*(?:;|$)/i,
        to_data_url = "toDataURL",
        base64_ranks,
        decode_base64 = function decode_base64(base64) {
        var len = base64.length,
            buffer = new Uint8Array(len / 4 * 3 | 0),
            i = 0,
            outptr = 0,
            last = [0, 0],
            state = 0,
            save = 0,
            rank,
            code,
            undef;
        while (len--) {
            code = base64.charCodeAt(i++);
            rank = base64_ranks[code - 43];
            if (rank !== 255 && rank !== undef) {
                last[1] = last[0];
                last[0] = code;
                save = save << 6 | rank;
                state++;
                if (state === 4) {
                    buffer[outptr++] = save >>> 16;
                    if (last[1] !== 61 /* padding character */) {
                            buffer[outptr++] = save >>> 8;
                        }
                    if (last[0] !== 61 /* padding character */) {
                            buffer[outptr++] = save;
                        }
                    state = 0;
                }
            }
        }
        // 2/3 chance there's going to be some null bytes at the end, but that
        // doesn't really matter with most image formats.
        // If it somehow matters for you, truncate the buffer up outptr.
        return buffer;
    };
    if (Uint8Array) {
        base64_ranks = new Uint8Array([62, -1, -1, -1, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, -1, -1, -1, 0, -1, -1, -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, -1, -1, -1, -1, -1, -1, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51]);
    }
    if (HTMLCanvasElement && !canvas_proto.toBlob) {
        canvas_proto.toBlob = function (callback, type /*, ...args*/) {
            if (!type) {
                type = "image/png";
            }
            if (this.mozGetAsFile) {
                callback(this.mozGetAsFile("canvas", type));
                return;
            }
            if (this.msToBlob && /^\s*image\/png\s*(?:$|;)/i.test(type)) {
                callback(this.msToBlob());
                return;
            }

            var args = Array.prototype.slice.call(arguments, 1),
                dataURI = this[to_data_url].apply(this, args),
                header_end = dataURI.indexOf(","),
                data = dataURI.substring(header_end + 1),
                is_base64 = is_base64_regex.test(dataURI.substring(0, header_end)),
                blob;
            if (Blob.fake) {
                // no reason to decode a data: URI that's just going to become a data URI again
                blob = new Blob();
                if (is_base64) {
                    blob.encoding = "base64";
                } else {
                    blob.encoding = "URI";
                }
                blob.data = data;
                blob.size = data.length;
            } else if (Uint8Array) {
                if (is_base64) {
                    blob = new Blob([decode_base64(data)], {
                        type: type
                    });
                } else {
                    blob = new Blob([decodeURIComponent(data)], {
                        type: type
                    });
                }
            }
            if (typeof callback !== 'undefined') {
                callback(blob);
            }
        };

        if (canvas_proto.toDataURLHD) {
            canvas_proto.toBlobHD = function () {
                to_data_url = "toDataURLHD";
                var blob = this.toBlob();
                to_data_url = "toDataURL";
                return blob;
            };
        } else {
            canvas_proto.toBlobHD = canvas_proto.toBlob;
        }
    }
})(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content || undefined);

/*!
 * Color Thief v2.0
 * by Lokesh Dhakar - http://www.lokeshdhakar.com
 *
 * Thanks
 * ------
 * Nick Rabinowitz - For creating quantize.js.
 * John Schulz - For clean up and optimization. @JFSIII
 * Nathan Spady - For adding drag and drop support to the demo page.
 *
 * License
 * -------
 * Copyright 2011, 2015 Lokesh Dhakar
 * Released under the MIT license
 * https://raw.githubusercontent.com/lokesh/color-thief/master/LICENSE
 *
 */
(function () {
    /*!
     * Color Thief v2.0
     * by Lokesh Dhakar - http://www.lokeshdhakar.com
     *
     * Thanks
     * ------
     * Nick Rabinowitz - For creating quantize.js.
     * John Schulz - For clean up and optimization. @JFSIII
     * Nathan Spady - For adding drag and drop support to the demo page.
     *
     * License
     * -------
     * Copyright 2011, 2015 Lokesh Dhakar
     * Released under the MIT license
     * https://raw.githubusercontent.com/lokesh/color-thief/master/LICENSE
     *
     */

    /*
      CanvasImage Class
      Class that wraps the html image element and canvas.
      It also simplifies some of the canvas context manipulation
      with a set of helper functions.
    */
    var CanvasImage = function CanvasImage(image) {
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');

        document.body.appendChild(this.canvas);

        this.width = this.canvas.width = image.width;
        this.height = this.canvas.height = image.height;

        this.context.drawImage(image, 0, 0, this.width, this.height);
    };

    CanvasImage.prototype.clear = function () {
        this.context.clearRect(0, 0, this.width, this.height);
    };

    CanvasImage.prototype.update = function (imageData) {
        this.context.putImageData(imageData, 0, 0);
    };

    CanvasImage.prototype.getPixelCount = function () {
        return this.width * this.height;
    };

    CanvasImage.prototype.getImageData = function () {
        return this.context.getImageData(0, 0, this.width, this.height);
    };

    CanvasImage.prototype.removeCanvas = function () {
        this.canvas.parentNode.removeChild(this.canvas);
    };

    var ColorThief = function ColorThief() {};

    /*
     * getColor(sourceImage[, quality])
     * returns {r: num, g: num, b: num}
     *
     * Use the median cut algorithm provided by quantize.js to cluster similar
     * colors and return the base color from the largest cluster.
     *
     * Quality is an optional argument. It needs to be an integer. 1 is the highest quality settings.
     * 10 is the default. There is a trade-off between quality and speed. The bigger the number, the
     * faster a color will be returned but the greater the likelihood that it will not be the visually
     * most dominant color.
     *
     * */
    ColorThief.prototype.getColor = function (sourceImage, quality) {
        var palette = this.getPalette(sourceImage, 5, quality);
        var dominantColor = palette[0];
        return dominantColor;
    };

    /*
     * getPalette(sourceImage[, colorCount, quality])
     * returns array[ {r: num, g: num, b: num}, {r: num, g: num, b: num}, ...]
     *
     * Use the median cut algorithm provided by quantize.js to cluster similar colors.
     *
     * colorCount determines the size of the palette; the number of colors returned. If not set, it
     * defaults to 10.
     *
     * BUGGY: Function does not always return the requested amount of colors. It can be +/- 2.
     *
     * quality is an optional argument. It needs to be an integer. 1 is the highest quality settings.
     * 10 is the default. There is a trade-off between quality and speed. The bigger the number, the
     * faster the palette generation but the greater the likelihood that colors will be missed.
     *
     *
     */
    ColorThief.prototype.getPalette = function (sourceImage, colorCount, quality) {

        if (typeof colorCount === 'undefined') {
            colorCount = 10;
        }
        if (typeof quality === 'undefined' || quality < 1) {
            quality = 10;
        }

        // Create custom CanvasImage object
        var image = new CanvasImage(sourceImage);
        var imageData = image.getImageData();
        var pixels = imageData.data;
        var pixelCount = image.getPixelCount();

        // Store the RGB values in an array format suitable for quantize function
        var pixelArray = [];
        for (var i = 0, offset, r, g, b, a; i < pixelCount; i = i + quality) {
            offset = i * 4;
            r = pixels[offset + 0];
            g = pixels[offset + 1];
            b = pixels[offset + 2];
            a = pixels[offset + 3];
            // If pixel is mostly opaque and not white
            if (a >= 125) {
                if (!(r > 250 && g > 250 && b > 250)) {
                    pixelArray.push([r, g, b]);
                }
            }
        }

        // Send array to quantize function which clusters values
        // using median cut algorithm
        var cmap = MMCQ.quantize(pixelArray, colorCount);
        var palette = cmap ? cmap.palette() : null;

        // Clean up
        image.removeCanvas();

        return palette;
    };

    /*!
     * quantize.js Copyright 2008 Nick Rabinowitz.
     * Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
     */

    // fill out a couple protovis dependencies
    /*!
     * Block below copied from Protovis: http://mbostock.github.com/protovis/
     * Copyright 2010 Stanford Visualization Group
     * Licensed under the BSD License: http://www.opensource.org/licenses/bsd-license.php
     */
    if (!pv) {
        var pv = {
            map: function map(array, f) {
                var o = {};
                return f ? array.map(function (d, i) {
                    o.index = i;
                    return f.call(o, d);
                }) : array.slice();
            },
            naturalOrder: function naturalOrder(a, b) {
                return a < b ? -1 : a > b ? 1 : 0;
            },
            sum: function sum(array, f) {
                var o = {};
                return array.reduce(f ? function (p, d, i) {
                    o.index = i;
                    return p + f.call(o, d);
                } : function (p, d) {
                    return p + d;
                }, 0);
            },
            max: function max(array, f) {
                return Math.max.apply(null, f ? pv.map(array, f) : array);
            }
        };
    }

    /**
     * Basic Javascript port of the MMCQ (modified median cut quantization)
     * algorithm from the Leptonica library (http://www.leptonica.com/).
     * Returns a color map you can use to map original pixels to the reduced
     * palette. Still a work in progress.
     *
     * @author Nick Rabinowitz
     * @example
     // array of pixels as [R,G,B] arrays
    var myPixels = [[190,197,190], [202,204,200], [207,214,210], [211,214,211], [205,207,207]
                    // etc
                    ];
    var maxColors = 4;
     var cmap = MMCQ.quantize(myPixels, maxColors);
    var newPalette = cmap.palette();
    var newPixels = myPixels.map(function(p) {
        return cmap.map(p);
    });
      */
    var MMCQ = function () {
        // private constants
        var sigbits = 5,
            rshift = 8 - sigbits,
            maxIterations = 1000,
            fractByPopulations = 0.75;

        // get reduced-space color index for a pixel
        function getColorIndex(r, g, b) {
            return (r << 2 * sigbits) + (g << sigbits) + b;
        }

        // Simple priority queue
        function PQueue(comparator) {
            var contents = [],
                sorted = false;

            function sort() {
                contents.sort(comparator);
                sorted = true;
            }

            return {
                push: function push(o) {
                    contents.push(o);
                    sorted = false;
                },
                peek: function peek(index) {
                    if (!sorted) sort();
                    if (index === undefined) index = contents.length - 1;
                    return contents[index];
                },
                pop: function pop() {
                    if (!sorted) sort();
                    return contents.pop();
                },
                size: function size() {
                    return contents.length;
                },
                map: function map(f) {
                    return contents.map(f);
                },
                debug: function debug() {
                    if (!sorted) sort();
                    return contents;
                }
            };
        }

        // 3d color space box
        function VBox(r1, r2, g1, g2, b1, b2, histo) {
            var vbox = this;
            vbox.r1 = r1;
            vbox.r2 = r2;
            vbox.g1 = g1;
            vbox.g2 = g2;
            vbox.b1 = b1;
            vbox.b2 = b2;
            vbox.histo = histo;
        }
        VBox.prototype = {
            volume: function volume(force) {
                var vbox = this;
                if (!vbox._volume || force) {
                    vbox._volume = (vbox.r2 - vbox.r1 + 1) * (vbox.g2 - vbox.g1 + 1) * (vbox.b2 - vbox.b1 + 1);
                }
                return vbox._volume;
            },
            count: function count(force) {
                var vbox = this,
                    histo = vbox.histo;
                if (!vbox._count_set || force) {
                    var npix = 0,
                        i,
                        j,
                        k;
                    for (i = vbox.r1; i <= vbox.r2; i++) {
                        for (j = vbox.g1; j <= vbox.g2; j++) {
                            for (k = vbox.b1; k <= vbox.b2; k++) {
                                var index = getColorIndex(i, j, k);
                                npix += histo[index] || 0;
                            }
                        }
                    }
                    vbox._count = npix;
                    vbox._count_set = true;
                }
                return vbox._count;
            },
            copy: function copy() {
                var vbox = this;
                return new VBox(vbox.r1, vbox.r2, vbox.g1, vbox.g2, vbox.b1, vbox.b2, vbox.histo);
            },
            avg: function avg(force) {
                var vbox = this,
                    histo = vbox.histo;
                if (!vbox._avg || force) {
                    var ntot = 0,
                        mult = 1 << 8 - sigbits,
                        rsum = 0,
                        gsum = 0,
                        bsum = 0,
                        hval,
                        i,
                        j,
                        k,
                        histoindex;
                    for (i = vbox.r1; i <= vbox.r2; i++) {
                        for (j = vbox.g1; j <= vbox.g2; j++) {
                            for (k = vbox.b1; k <= vbox.b2; k++) {
                                histoindex = getColorIndex(i, j, k);
                                hval = histo[histoindex] || 0;
                                ntot += hval;
                                rsum += hval * (i + 0.5) * mult;
                                gsum += hval * (j + 0.5) * mult;
                                bsum += hval * (k + 0.5) * mult;
                            }
                        }
                    }
                    if (ntot) {
                        vbox._avg = [~~(rsum / ntot), ~~(gsum / ntot), ~~(bsum / ntot)];
                    } else {
                        //                    console.log('empty box');
                        vbox._avg = [~~(mult * (vbox.r1 + vbox.r2 + 1) / 2), ~~(mult * (vbox.g1 + vbox.g2 + 1) / 2), ~~(mult * (vbox.b1 + vbox.b2 + 1) / 2)];
                    }
                }
                return vbox._avg;
            },
            contains: function contains(pixel) {
                var vbox = this,
                    rval = pixel[0] >> rshift;
                gval = pixel[1] >> rshift;
                bval = pixel[2] >> rshift;
                return rval >= vbox.r1 && rval <= vbox.r2 && gval >= vbox.g1 && gval <= vbox.g2 && bval >= vbox.b1 && bval <= vbox.b2;
            }
        };

        // Color map
        function CMap() {
            this.vboxes = new PQueue(function (a, b) {
                return pv.naturalOrder(a.vbox.count() * a.vbox.volume(), b.vbox.count() * b.vbox.volume());
            });
        }
        CMap.prototype = {
            push: function push(vbox) {
                this.vboxes.push({
                    vbox: vbox,
                    color: vbox.avg()
                });
            },
            palette: function palette() {
                return this.vboxes.map(function (vb) {
                    return vb.color;
                });
            },
            size: function size() {
                return this.vboxes.size();
            },
            map: function map(color) {
                var vboxes = this.vboxes;
                for (var i = 0; i < vboxes.size(); i++) {
                    if (vboxes.peek(i).vbox.contains(color)) {
                        return vboxes.peek(i).color;
                    }
                }
                return this.nearest(color);
            },
            nearest: function nearest(color) {
                var vboxes = this.vboxes,
                    d1,
                    d2,
                    pColor;
                for (var i = 0; i < vboxes.size(); i++) {
                    d2 = Math.sqrt(Math.pow(color[0] - vboxes.peek(i).color[0], 2) + Math.pow(color[1] - vboxes.peek(i).color[1], 2) + Math.pow(color[2] - vboxes.peek(i).color[2], 2));
                    if (d2 < d1 || d1 === undefined) {
                        d1 = d2;
                        pColor = vboxes.peek(i).color;
                    }
                }
                return pColor;
            },
            forcebw: function forcebw() {
                // XXX: won't  work yet
                var vboxes = this.vboxes;
                vboxes.sort(function (a, b) {
                    return pv.naturalOrder(pv.sum(a.color), pv.sum(b.color));
                });

                // force darkest color to black if everything < 5
                var lowest = vboxes[0].color;
                if (lowest[0] < 5 && lowest[1] < 5 && lowest[2] < 5) vboxes[0].color = [0, 0, 0];

                // force lightest color to white if everything > 251
                var idx = vboxes.length - 1,
                    highest = vboxes[idx].color;
                if (highest[0] > 251 && highest[1] > 251 && highest[2] > 251) vboxes[idx].color = [255, 255, 255];
            }
        };

        // histo (1-d array, giving the number of pixels in
        // each quantized region of color space), or null on error
        function getHisto(pixels) {
            var histosize = 1 << 3 * sigbits,
                histo = new Array(histosize),
                index,
                rval,
                gval,
                bval;
            pixels.forEach(function (pixel) {
                rval = pixel[0] >> rshift;
                gval = pixel[1] >> rshift;
                bval = pixel[2] >> rshift;
                index = getColorIndex(rval, gval, bval);
                histo[index] = (histo[index] || 0) + 1;
            });
            return histo;
        }

        function vboxFromPixels(pixels, histo) {
            var rmin = 1000000,
                rmax = 0,
                gmin = 1000000,
                gmax = 0,
                bmin = 1000000,
                bmax = 0,
                rval,
                gval,
                bval;
            // find min/max
            pixels.forEach(function (pixel) {
                rval = pixel[0] >> rshift;
                gval = pixel[1] >> rshift;
                bval = pixel[2] >> rshift;
                if (rval < rmin) rmin = rval;else if (rval > rmax) rmax = rval;
                if (gval < gmin) gmin = gval;else if (gval > gmax) gmax = gval;
                if (bval < bmin) bmin = bval;else if (bval > bmax) bmax = bval;
            });
            return new VBox(rmin, rmax, gmin, gmax, bmin, bmax, histo);
        }

        function medianCutApply(histo, vbox) {
            if (!vbox.count()) return;

            var rw = vbox.r2 - vbox.r1 + 1,
                gw = vbox.g2 - vbox.g1 + 1,
                bw = vbox.b2 - vbox.b1 + 1,
                maxw = pv.max([rw, gw, bw]);
            // only one pixel, no split
            if (vbox.count() == 1) {
                return [vbox.copy()];
            }
            /* Find the partial sum arrays along the selected axis. */
            var total = 0,
                partialsum = [],
                lookaheadsum = [],
                i,
                j,
                k,
                sum,
                index;
            if (maxw == rw) {
                for (i = vbox.r1; i <= vbox.r2; i++) {
                    sum = 0;
                    for (j = vbox.g1; j <= vbox.g2; j++) {
                        for (k = vbox.b1; k <= vbox.b2; k++) {
                            index = getColorIndex(i, j, k);
                            sum += histo[index] || 0;
                        }
                    }
                    total += sum;
                    partialsum[i] = total;
                }
            } else if (maxw == gw) {
                for (i = vbox.g1; i <= vbox.g2; i++) {
                    sum = 0;
                    for (j = vbox.r1; j <= vbox.r2; j++) {
                        for (k = vbox.b1; k <= vbox.b2; k++) {
                            index = getColorIndex(j, i, k);
                            sum += histo[index] || 0;
                        }
                    }
                    total += sum;
                    partialsum[i] = total;
                }
            } else {
                /* maxw == bw */
                for (i = vbox.b1; i <= vbox.b2; i++) {
                    sum = 0;
                    for (j = vbox.r1; j <= vbox.r2; j++) {
                        for (k = vbox.g1; k <= vbox.g2; k++) {
                            index = getColorIndex(j, k, i);
                            sum += histo[index] || 0;
                        }
                    }
                    total += sum;
                    partialsum[i] = total;
                }
            }
            partialsum.forEach(function (d, i) {
                lookaheadsum[i] = total - d;
            });

            function doCut(color) {
                var dim1 = color + '1',
                    dim2 = color + '2',
                    left,
                    right,
                    vbox1,
                    vbox2,
                    d2,
                    count2 = 0;
                for (i = vbox[dim1]; i <= vbox[dim2]; i++) {
                    if (partialsum[i] > total / 2) {
                        vbox1 = vbox.copy();
                        vbox2 = vbox.copy();
                        left = i - vbox[dim1];
                        right = vbox[dim2] - i;
                        if (left <= right) d2 = Math.min(vbox[dim2] - 1, ~~(i + right / 2));else d2 = Math.max(vbox[dim1], ~~(i - 1 - left / 2));
                        // avoid 0-count boxes
                        while (!partialsum[d2]) {
                            d2++;
                        }count2 = lookaheadsum[d2];
                        while (!count2 && partialsum[d2 - 1]) {
                            count2 = lookaheadsum[--d2];
                        } // set dimensions
                        vbox1[dim2] = d2;
                        vbox2[dim1] = vbox1[dim2] + 1;
                        //                    console.log('vbox counts:', vbox.count(), vbox1.count(), vbox2.count());
                        return [vbox1, vbox2];
                    }
                }
            }
            // determine the cut planes
            return maxw == rw ? doCut('r') : maxw == gw ? doCut('g') : doCut('b');
        }

        function quantize(pixels, maxcolors) {
            // short-circuit
            if (!pixels.length || maxcolors < 2 || maxcolors > 256) {
                //            console.log('wrong number of maxcolors');
                return false;
            }

            // XXX: check color content and convert to grayscale if insufficient

            var histo = getHisto(pixels),
                histosize = 1 << 3 * sigbits;

            // check that we aren't below maxcolors already
            var nColors = 0;
            histo.forEach(function () {
                nColors++;
            });
            if (nColors <= maxcolors) {}
            // XXX: generate the new colors from the histo and return


            // get the beginning vbox from the colors
            var vbox = vboxFromPixels(pixels, histo),
                pq = new PQueue(function (a, b) {
                return pv.naturalOrder(a.count(), b.count());
            });
            pq.push(vbox);

            // inner function to do the iteration
            function iter(lh, target) {
                var ncolors = 1,
                    niters = 0,
                    vbox;
                while (niters < maxIterations) {
                    vbox = lh.pop();
                    if (!vbox.count()) {
                        /* just put it back */
                        lh.push(vbox);
                        niters++;
                        continue;
                    }
                    // do the cut
                    var vboxes = medianCutApply(histo, vbox),
                        vbox1 = vboxes[0],
                        vbox2 = vboxes[1];

                    if (!vbox1) {
                        //                    console.log("vbox1 not defined; shouldn't happen!");
                        return;
                    }
                    lh.push(vbox1);
                    if (vbox2) {
                        /* vbox2 can be null */
                        lh.push(vbox2);
                        ncolors++;
                    }
                    if (ncolors >= target) return;
                    if (niters++ > maxIterations) {
                        //                    console.log("infinite loop; perhaps too few pixels!");
                        return;
                    }
                }
            }

            // first set of colors, sorted by population
            iter(pq, fractByPopulations * maxcolors);

            // Re-sort by the product of pixel occupancy times the size in color space.
            var pq2 = new PQueue(function (a, b) {
                return pv.naturalOrder(a.count() * a.volume(), b.count() * b.volume());
            });
            while (pq.size()) {
                pq2.push(pq.pop());
            }

            // next set - generate the median cuts using the (npix * vol) sorting.
            iter(pq2, maxcolors - pq2.size());

            // calculate the actual colors
            var cmap = new CMap();
            while (pq2.size()) {
                cmap.push(pq2.pop());
            }

            return cmap;
        }

        return {
            quantize: quantize
        };
    }();

    /**
     * Export class to global
     */
    if (window) {
        window.ColorThief = ColorThief;
    };
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return ColorThief;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // for AMD loader
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = ColorThief; // for CommonJS
    } else {
        this.ColorThief = ColorThief;
    }
}).call(undefined);

/**
 * Mega pixel image rendering library for iOS6 Safari
 *
 * Fixes iOS6 Safari's image file rendering issue for large size image (over mega-pixel),
 * which causes unexpected subsampling when drawing it in canvas.
 * By using this library, you can safely render the image with proper stretching.
 *
 * Copyright (c) 2012 Shinichi Tomita <shinichi.tomita@gmail.com>
 * Released under the MIT license
 */
(function () {

    /**
     * Detect subsampling in loaded image.
     * In iOS, larger images than 2M pixels may be subsampled in rendering.
     */
    function detectSubsampling(img) {
        var iw = img.naturalWidth,
            ih = img.naturalHeight;
        if (iw * ih > 1024 * 1024) {
            // subsampling may happen over megapixel image
            var canvas = document.createElement('canvas');
            canvas.width = canvas.height = 1;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, -iw + 1, 0);
            // subsampled image becomes half smaller in rendering size.
            // check alpha channel value to confirm image is covering edge pixel or not.
            // if alpha value is 0 image is not covering, hence subsampled.
            return ctx.getImageData(0, 0, 1, 1).data[3] === 0;
        } else {
            return false;
        }
    }

    /**
     * Detecting vertical squash in loaded image.
     * Fixes a bug which squash image vertically while drawing into canvas for some images.
     */
    function detectVerticalSquash(img, iw, ih) {
        var canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = ih;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        var data = ctx.getImageData(0, 0, 1, ih).data;
        // search image edge pixel position in case it is squashed vertically.
        var sy = 0;
        var ey = ih;
        var py = ih;
        while (py > sy) {
            var alpha = data[(py - 1) * 4 + 3];
            if (alpha === 0) {
                ey = py;
            } else {
                sy = py;
            }
            py = ey + sy >> 1;
        }
        var ratio = py / ih;
        return ratio === 0 ? 1 : ratio;
    }

    /**
     * Rendering image element (with resizing) and get its data URL
     */
    function renderImageToDataURL(img, options, doSquash) {
        var canvas = document.createElement('canvas');
        renderImageToCanvas(img, canvas, options, doSquash);
        return canvas.toDataURL('image/jpeg', options.quality || 0.8);
    }

    /**
     * Rendering image element (with resizing) into the canvas element
     */
    function renderImageToCanvas(img, canvas, options, doSquash) {
        var iw = img.naturalWidth,
            ih = img.naturalHeight;
        if (iw + ih === false) {
            return;
        }
        var width = options.width,
            height = options.height;
        var ctx = canvas.getContext('2d');
        ctx.save();
        transformCoordinate(canvas, ctx, width, height, options.orientation);
        var subsampled = detectSubsampling(img);
        if (subsampled) {
            iw /= 2;
            ih /= 2;
        }
        var d = 1024; // size of tiling canvas
        var tmpCanvas = document.createElement('canvas');
        tmpCanvas.width = tmpCanvas.height = d;
        var tmpCtx = tmpCanvas.getContext('2d');
        var vertSquashRatio = doSquash ? detectVerticalSquash(img, iw, ih) : 1;
        var dw = Math.ceil(d * width / iw);
        var dh = Math.ceil(d * height / ih / vertSquashRatio);
        var sy = 0;
        var dy = 0;
        while (sy < ih) {
            var sx = 0;
            var dx = 0;
            while (sx < iw) {
                tmpCtx.clearRect(0, 0, d, d);
                tmpCtx.drawImage(img, -sx, -sy);
                ctx.drawImage(tmpCanvas, 0, 0, d, d, dx, dy, dw, dh);
                sx += d;
                dx += dw;
            }
            sy += d;
            dy += dh;
        }
        ctx.restore();
        tmpCanvas = tmpCtx = null;
    }

    /**
     * Transform canvas coordination according to specified frame size and orientation
     * Orientation value is from EXIF tag
     */
    function transformCoordinate(canvas, ctx, width, height, orientation) {
        switch (orientation) {
            case 5:
            case 6:
            case 7:
            case 8:
                canvas.width = height;
                canvas.height = width;
                break;
            default:
                canvas.width = width;
                canvas.height = height;
        }
        switch (orientation) {
            case 2:
                // horizontal flip
                ctx.translate(width, 0);
                ctx.scale(-1, 1);
                break;
            case 3:
                // 180 rotate left
                ctx.translate(width, height);
                ctx.rotate(Math.PI);
                break;
            case 4:
                // vertical flip
                ctx.translate(0, height);
                ctx.scale(1, -1);
                break;
            case 5:
                // vertical flip + 90 rotate right
                ctx.rotate(0.5 * Math.PI);
                ctx.scale(1, -1);
                break;
            case 6:
                // 90 rotate right
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(0, -height);
                break;
            case 7:
                // horizontal flip + 90 rotate right
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(width, -height);
                ctx.scale(-1, 1);
                break;
            case 8:
                // 90 rotate left
                ctx.rotate(-0.5 * Math.PI);
                ctx.translate(-width, 0);
                break;
            default:
                break;
        }
    }

    var URL = window.URL && window.URL.createObjectURL ? window.URL : window.webkitURL && window.webkitURL.createObjectURL ? window.webkitURL : null;

    /**
     * MegaPixImage class
     */
    function MegaPixImage(srcImage) {
        if (window.Blob && srcImage instanceof Blob) {
            if (!URL) {
                throw Error('No createObjectURL function found to create blob url');
            }
            var img = new Image();
            img.src = URL.createObjectURL(srcImage);
            this.blob = srcImage;
            srcImage = img;
        }
        if (!srcImage.naturalWidth && !srcImage.naturalHeight) {
            var _this = this;
            srcImage.onload = srcImage.onerror = function () {
                var listeners = _this.imageLoadListeners;
                if (listeners) {
                    _this.imageLoadListeners = null;
                    for (var i = 0, len = listeners.length; i < len; i++) {
                        listeners[i]();
                    }
                }
            };
            this.imageLoadListeners = [];
        }
        this.srcImage = srcImage;
    }

    /**
     * Rendering megapix image into specified target element
     */
    MegaPixImage.prototype.render = function (target, options, callback) {
        if (this.imageLoadListeners) {
            var _this = this;
            this.imageLoadListeners.push(function () {
                _this.render(target, options, callback);
            });
            return;
        }
        options = options || {};
        var imgWidth = this.srcImage.naturalWidth,
            imgHeight = this.srcImage.naturalHeight,
            width = options.width,
            height = options.height,
            maxWidth = options.maxWidth,
            maxHeight = options.maxHeight,
            doSquash = !this.blob || this.blob.type === 'image/jpeg';
        if (width && !height) {
            height = imgHeight * width / imgWidth << 0;
        } else if (height && !width) {
            width = imgWidth * height / imgHeight << 0;
        } else {
            width = imgWidth;
            height = imgHeight;
        }
        if (maxWidth && width > maxWidth) {
            width = maxWidth;
            height = imgHeight * width / imgWidth << 0;
        }
        if (maxHeight && height > maxHeight) {
            height = maxHeight;
            width = imgWidth * height / imgHeight << 0;
        }
        var opt = { width: width, height: height };
        for (var k in options) {
            opt[k] = options[k];
        }

        var tagName = target.tagName.toLowerCase();
        if (tagName === 'img') {
            target.src = renderImageToDataURL(this.srcImage, opt, doSquash);
        } else if (tagName === 'canvas') {
            renderImageToCanvas(this.srcImage, target, opt, doSquash);
        }
        if (typeof this.onrender === 'function') {
            this.onrender(target);
        }
        if (callback) {
            callback();
        }
        if (this.blob) {
            this.blob = null;
            URL.revokeObjectURL(this.srcImage.src);
        }
    };

    /**
     * Export class to global
     */
    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return MegaPixImage;
        }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // for AMD loader
    } else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') {
        module.exports = MegaPixImage; // for CommonJS
    } else {
        this.MegaPixImage = MegaPixImage;
    }
}).call(undefined);

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function __export(m) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}
/** @module common */ /** for typedoc */
__export(__webpack_require__(0));
__export(__webpack_require__(6));
__export(__webpack_require__(50));
__export(__webpack_require__(3));
__export(__webpack_require__(1));
__export(__webpack_require__(80));
__export(__webpack_require__(15));
__export(__webpack_require__(24));
//# sourceMappingURL=index.js.map

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * A factory which creates an onEnter, onExit or onRetain transition hook function
 *
 * The returned function invokes the (for instance) state.onEnter hook when the
 * state is being entered.
 *
 * @hidden
 */

function makeEnterExitRetainHook(hookName) {
    return function (transition, state) {
        var hookFn = state[hookName];
        return hookFn(transition, state);
    };
}
/**
 * The [[TransitionStateHookFn]] for onExit
 *
 * When the state is being exited, the state's .onExit function is invoked.
 *
 * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
 *
 * See: [[IHookRegistry.onExit]]
 */
var onExitHook = makeEnterExitRetainHook('onExit');
exports.registerOnExitHook = function (transitionService) {
    return transitionService.onExit({ exiting: function exiting(state) {
            return !!state.onExit;
        } }, onExitHook);
};
/**
 * The [[TransitionStateHookFn]] for onRetain
 *
 * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
 *
 * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
 *
 * See: [[IHookRegistry.onRetain]]
 */
var onRetainHook = makeEnterExitRetainHook('onRetain');
exports.registerOnRetainHook = function (transitionService) {
    return transitionService.onRetain({ retained: function retained(state) {
            return !!state.onRetain;
        } }, onRetainHook);
};
/**
 * The [[TransitionStateHookFn]] for onEnter
 *
 * When the state is being entered, the state's .onEnter function is invoked.
 *
 * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
 *
 * See: [[IHookRegistry.onEnter]]
 */
var onEnterHook = makeEnterExitRetainHook('onEnter');
exports.registerOnEnterHook = function (transitionService) {
    return transitionService.onEnter({ entering: function entering(state) {
            return !!state.onEnter;
        } }, onEnterHook);
};
//# sourceMappingURL=onEnterExitRetain.js.map

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module hooks */ /** */

var predicates_1 = __webpack_require__(1);
var coreservices_1 = __webpack_require__(6);
var targetState_1 = __webpack_require__(19);
/**
 * A [[TransitionHookFn]] that redirects to a different state or params
 *
 * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
 *
 * See [[StateDeclaration.redirectTo]]
 */
var redirectToHook = function redirectToHook(trans) {
    var redirect = trans.to().redirectTo;
    if (!redirect) return;
    var $state = trans.router.stateService;
    function handleResult(result) {
        if (!result) return;
        if (result instanceof targetState_1.TargetState) return result;
        if (predicates_1.isString(result)) return $state.target(result, trans.params(), trans.options());
        if (result['state'] || result['params']) return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
    }
    if (predicates_1.isFunction(redirect)) {
        return coreservices_1.services.$q.when(redirect(trans)).then(handleResult);
    }
    return handleResult(redirect);
};
exports.registerRedirectToHook = function (transitionService) {
    return transitionService.onStart({ to: function to(state) {
            return !!state.redirectTo;
        } }, redirectToHook);
};
//# sourceMappingURL=redirectTo.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module hooks */ /** for typedoc */

var common_1 = __webpack_require__(0);
var resolveContext_1 = __webpack_require__(53);
var hof_1 = __webpack_require__(3);
/**
 * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
 *
 * Registered using `transitionService.onStart({}, eagerResolvePath);`
 *
 * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
 *
 * See [[StateDeclaration.resolve]]
 */
var eagerResolvePath = function eagerResolvePath(trans) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to).resolvePath("EAGER", trans).then(common_1.noop);
};
exports.registerEagerResolvePath = function (transitionService) {
    return transitionService.onStart({}, eagerResolvePath, { priority: 1000 });
};
/**
 * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
 *
 * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState);`
 *
 * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
 *
 * See [[StateDeclaration.resolve]]
 */
var lazyResolveState = function lazyResolveState(trans, state) {
    return new resolveContext_1.ResolveContext(trans.treeChanges().to).subContext(state).resolvePath("LAZY", trans).then(common_1.noop);
};
exports.registerLazyResolveState = function (transitionService) {
    return transitionService.onEnter({ entering: hof_1.val(true) }, lazyResolveState, { priority: 1000 });
};
//# sourceMappingURL=resolve.js.map

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * A [[TransitionHookFn]] which updates the URL after a successful transition
 *
 * Registered using `transitionService.onSuccess({}, updateUrl);`
 */

var updateUrl = function updateUrl(transition) {
    var options = transition.options();
    var $state = transition.router.stateService;
    var $urlRouter = transition.router.urlRouter;
    // Dont update the url in these situations:
    // The transition was triggered by a URL sync (options.source === 'url')
    // The user doesn't want the url to update (options.location === false)
    // The destination state, and all parents have no navigable url
    if (options.source !== 'url' && options.location && $state.$current.navigable) {
        var urlOptions = { replace: options.location === 'replace' };
        $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
    }
    $urlRouter.update(true);
};
exports.registerUpdateUrl = function (transitionService) {
    return transitionService.onSuccess({}, updateUrl, { priority: 9999 });
};
//# sourceMappingURL=url.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/** @module hooks */ /** for typedoc */

var common_1 = __webpack_require__(0);
var coreservices_1 = __webpack_require__(6);
/**
 * A [[TransitionHookFn]] which waits for the views to load
 *
 * Registered using `transitionService.onStart({}, loadEnteringViews);`
 *
 * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
 * In angular 1, this includes loading the templates.
 */
var loadEnteringViews = function loadEnteringViews(transition) {
    var $q = coreservices_1.services.$q;
    var enteringViews = transition.views("entering");
    if (!enteringViews.length) return;
    return $q.all(enteringViews.map(function (view) {
        return $q.when(view.load());
    })).then(common_1.noop);
};
exports.registerLoadEnteringViews = function (transitionService) {
    return transitionService.onFinish({}, loadEnteringViews);
};
/**
 * A [[TransitionHookFn]] which activates the new views when a transition is successful.
 *
 * Registered using `transitionService.onSuccess({}, activateViews);`
 *
 * After a transition is complete, this hook deactivates the old views from the previous state,
 * and activates the new views from the destination state.
 *
 * See [[ViewService]]
 */
var activateViews = function activateViews(transition) {
    var enteringViews = transition.views("entering");
    var exitingViews = transition.views("exiting");
    if (!enteringViews.length && !exitingViews.length) return;
    var $view = transition.router.viewService;
    exitingViews.forEach(function (vc) {
        return $view.deactivateViewConfig(vc);
    });
    enteringViews.forEach(function (vc) {
        return $view.activateViewConfig(vc);
    });
    $view.sync();
};
exports.registerActivateViews = function (transitionService) {
    return transitionService.onSuccess({}, activateViews);
};
//# sourceMappingURL=views.js.map

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Core classes and interfaces
 *
 * The classes and interfaces that are core to ui-router and do not belong
 * to a more specific subsystem (such as resolve).
 *
 * @coreapi
 * @preferred
 * @module core
 */ /** for typedoc */


var UIRouterPluginBase = function () {
  function UIRouterPluginBase() {}
  UIRouterPluginBase.prototype.dispose = function (router) {};
  return UIRouterPluginBase;
}();
exports.UIRouterPluginBase = UIRouterPluginBase;
//# sourceMappingURL=interface.js.map

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function __export(m) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}
__export(__webpack_require__(25));
__export(__webpack_require__(120));
__export(__webpack_require__(121));
__export(__webpack_require__(81));
//# sourceMappingURL=index.js.map

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function __export(m) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}
/** @module path */ /** for typedoc */
__export(__webpack_require__(51));
__export(__webpack_require__(52));
//# sourceMappingURL=index.js.map

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function __export(m) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}
/** @module resolve */ /** for typedoc */
__export(__webpack_require__(122));
__export(__webpack_require__(31));
__export(__webpack_require__(53));
//# sourceMappingURL=index.js.map

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function __export(m) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}
__export(__webpack_require__(124));
__export(__webpack_require__(82));
__export(__webpack_require__(125));
__export(__webpack_require__(126));
__export(__webpack_require__(127));
__export(__webpack_require__(128));
__export(__webpack_require__(19));
//# sourceMappingURL=index.js.map

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}
/**
 * This module contains APIs related to a Transition.
 *
 * See:
 * - [[TransitionService]]
 * - [[Transition]]
 * - [[HookFn]], [[TransitionHookFn]], [[TransitionStateHookFn]], [[HookMatchCriteria]], [[HookResult]]
 *
 * @coreapi
 * @preferred
 * @module transition
 */ /** for typedoc */
__export(__webpack_require__(32));
__export(__webpack_require__(129));
__export(__webpack_require__(83));
__export(__webpack_require__(33));
__export(__webpack_require__(84));
__export(__webpack_require__(34));
__export(__webpack_require__(130));
__export(__webpack_require__(85));
//# sourceMappingURL=index.js.map

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function __export(m) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}
__export(__webpack_require__(54));
__export(__webpack_require__(131));
__export(__webpack_require__(132));
__export(__webpack_require__(133));
__export(__webpack_require__(134));
//# sourceMappingURL=index.js.map

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function __export(m) {
    for (var p in m) {
        if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }
}
__export(__webpack_require__(135));
//# sourceMappingURL=index.js.map

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function _class($state) {
	'ngInject';

	_classCallCheck(this, _class);

	this._$state = $state;

	return {
		STATUS: {
			ADD: 0,
			UPDATE: 1,
			DELETE: 2,
			STATIC: -1
		}
	};
};
_class.$inject = ["$state"];

exports.default = _class;
;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.navFooterComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _appNavFooter = __webpack_require__(705);

var _appNavFooter2 = _interopRequireDefault(_appNavFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var navFooterComponent = exports.navFooterComponent = {
	templateUrl: _appNavFooter2.default,

	controller: function () {
		function NavFooterComponent() {
			_classCallCheck(this, NavFooterComponent);
		}

		_createClass(NavFooterComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.currentYear = new Date().getFullYear();
			}
		}]);

		return NavFooterComponent;
	}()
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.navHeaderComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _appNavHeader = __webpack_require__(706);

var _appNavHeader2 = _interopRequireDefault(_appNavHeader);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var navHeaderComponent = exports.navHeaderComponent = {
	templateUrl: _appNavHeader2.default,
	// bindings: {
	// 	onLogOut : '&'
	// },
	controller: function () {
		HeaderController.$inject = ["$state", "$transitions", "AuthService", "DashboardService"];
		function HeaderController($state, $transitions, AuthService, DashboardService) {
			'ngInject';

			_classCallCheck(this, HeaderController);

			this.$state = $state;
			this.authService = AuthService;
			this.fetaures = [];
			this.dashboardService = DashboardService;
			this.onStateChangeSuccess.call(this);
			$transitions.onSuccess({}, this.onStateChangeSuccess.bind(this));
		}

		_createClass(HeaderController, [{
			key: 'onStateChangeSuccess',
			value: function onStateChangeSuccess() {
				var state = this.$state.current;
				this.stateName = this.$state.current.name;
				this.featureArray = this.getFeatureArray(state);
				this.featureName = this.featureArray.length > 0 ? this.featureArray[0] : 'dashboard';
				this.fetaures = [];
				this.activeMenuName = this.dashboardService.getActiveMenuName();
				if (!this.activeMenuName) {
					this._redirectToHomeBannerModule();
				}
			}
		}, {
			key: 'getFeatureArray',
			value: function getFeatureArray(currentName) {
				var state = this.$state.get(currentName);
				if (state && state.name != 'app.dashboard') {
					this.fetaures.unshift(state.breadcrumbName);
					this.getFeatureArray(state.parentState);
				}
				return this.fetaures;
			}
		}, {
			key: '$onInit',
			value: function $onInit() {
				this.stateName = this.$state.current.name;
				this.user = this.authService.getUser();
				this.accountOptions = [{
					title: 'Change Password',
					value: 'changePassword'
				}, {
					title: 'Logout',
					value: 'logout'
				}];
			}
		}, {
			key: 'onLogOut',
			value: function onLogOut() {
				var _this = this;

				this.authService.logout().then(function (result) {
					_this.$state.go('login');
					_this.isLoggedIn = false;
				});
			}
		}, {
			key: 'onOptionsClick',
			value: function onOptionsClick(item) {
				if (item.value == "logout") {
					this.onLogOut();
				} else if (item.value == "changePassword") {
					this.$state.go('app.dashboard.changePassword');
				}
			}

			//**************************************************** Private Methods **************************************************

		}, {
			key: '_redirectToHomeBannerModule',
			value: function _redirectToHomeBannerModule() {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: 'home-banner'
				});
			}
		}]);

		return HeaderController;
	}()
};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.appNav = undefined;

var _appNavHeader = __webpack_require__(413);

var _appNavFooter = __webpack_require__(412);

var _dropdown = __webpack_require__(222);

var _dropdown2 = _interopRequireDefault(_dropdown);

__webpack_require__(148);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appNav = exports.appNav = angular.module('common.app-nav', [_dropdown2.default]).component('appHeader', _appNavHeader.navHeaderComponent).component('appFooter', _appNavFooter.navFooterComponent).name;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.appComponent = undefined;

var _app = __webpack_require__(707);

var _app2 = _interopRequireDefault(_app);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appComponent = exports.appComponent = {
	templateUrl: _app2.default
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.app = undefined;

var _appNav = __webpack_require__(414);

var _appComponent = __webpack_require__(415);

var _components = __webpack_require__(433);

var _libs = __webpack_require__(537);

var app = exports.app = angular.module('common.app', [_appNav.appNav, _components.components, _libs.libs]).component('app', _appComponent.appComponent).config(["$stateProvider", function ($stateProvider) {
	'ngInject';

	$stateProvider.state('app', {
		url: '/',
		component: 'app'
	});
}]).run(["$state", "$location", "$transitions", "AuthService", "CompareObjectService", "toastr", "$anchorScroll", function ($state, $location, $transitions, AuthService, CompareObjectService, toastr, $anchorScroll) {
	$transitions.onStart({
		to: 'app'
	}, function (state) {
		if (AuthService.isAuthenticated()) {
			$state.go('app.dashboard.DynamicMenus', {
				url: 'home-banner'
			});
			return true;
		} else {
			$state.go('app.login');
			return false;
		}
	});

	$transitions.onSuccess({
		to: '*'
	}, function () {
		$anchorScroll();
	});
}]).name;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addressComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _address = __webpack_require__(708);

var _address2 = _interopRequireDefault(_address);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var addressComponent = exports.addressComponent = {
    bindings: {
        details: '<'
    },

    templateUrl: _address2.default,

    controller: function () {
        function AddressComponent() {
            'ngInject';

            _classCallCheck(this, AddressComponent);
        }

        _createClass(AddressComponent, [{
            key: '$onInit',
            value: function $onInit() {}
        }]);

        return AddressComponent;
    }()
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.address = undefined;

var _address = __webpack_require__(417);

__webpack_require__(149);

var address = exports.address = angular.module('common.components.address', []).component('address', _address.addressComponent).name;

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.autocompleteComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _autocomplete = __webpack_require__(709);

var _autocomplete2 = _interopRequireDefault(_autocomplete);

var _map = __webpack_require__(384);

var _map2 = _interopRequireDefault(_map);

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

var _last2 = __webpack_require__(48);

var _last3 = _interopRequireDefault(_last2);

var _clone = __webpack_require__(11);

var _clone2 = _interopRequireDefault(_clone);

var _escapeRegExp = __webpack_require__(376);

var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);

var _reduce = __webpack_require__(78);

var _reduce2 = _interopRequireDefault(_reduce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var autocompleteComponent = exports.autocompleteComponent = {
	bindings: {
		items: '<',
		defaultSelected: '<',
		onSelectItem: '&',
		onRemoveTag: '&',
		onAutocomplete: '&',
		placeholder: '@',
		defaultTextboxValue: '<',
		isDisabled: '@',
		isRequired: '@',
		minCharcterRequired: '@',
		templateUrl: '@',
		placeHolder: '@',
		onChangeText: '&',
		allowRepeat: '<'
	},
	templateUrl: _autocomplete2.default,
	controller: function () {
		AutocompleteComponent.$inject = ["$parse", "$timeout"];
		function AutocompleteComponent($parse, $timeout) {
			'ngInject';

			_classCallCheck(this, AutocompleteComponent);

			this.$parse = $parse;
			this.showCustomTemplate = false;
			this.isRequired = true;
			this.$timeout = $timeout;
			this.isEmptyResult = false;
		}

		_createClass(AutocompleteComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this._items = (0, _clone2.default)(this.items);
				this._isDisabled = this.$parse(this.isDisabled || 'false')(false);
				this.isRequired = _convertToBoolean(this.isRequired, this.$parse);
				this.searchText = this.defaultTextboxValue || '';
				this.tags = [];
				if (this.defaultSelected) {
					this.tags = this._getDefaultSubject(this.defaultSelected);
				}
				if (this.allowRepeat == undefined) {
					this.allowRepeat = false;
				}
				this.uniqIdForAutocompleteInput = this._getUniqIdForAutocompleteInput();
			}
		}, {
			key: 'resetSearchText',
			value: function resetSearchText() {
				if (this.searchText === ' ') {
					this.searchText = '';
				}
			}
		}, {
			key: 'onClick',
			value: function onClick(event) {
				var _this = this;

				var element = angular.element(event.target);
				if (element.hasClass('main-tag') || element.hasClass('autocomplete')) {
					this.$timeout(function () {
						angular.element(document.getElementById(_this.uniqIdForAutocompleteInput))[0].focus();
					}, 100);
				}
			}
		}, {
			key: '_getUniqIdForAutocompleteInput',
			value: function _getUniqIdForAutocompleteInput() {
				return 'autocomplete-' + this._getRandomId();
			}
		}, {
			key: '_getRandomId',
			value: function _getRandomId() {
				var idLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

				var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
				return (0, _reduce2.default)([].concat(_toConsumableArray(Array(idLength).keys())), function (id, index) {
					return id += possible.charAt(Math.floor(Math.random() * possible.length));
				}, 0);
			}
		}, {
			key: '_getDefaultSubject',
			value: function _getDefaultSubject(subjects) {
				var subjectsWithoutDeleted = (0, _filter2.default)(subjects, function (_ref) {
					var status = _ref.status;

					return status !== 2;
				});
				var _subjects = (0, _map2.default)(subjectsWithoutDeleted, function (sub) {
					return sub.name;
				});
				return _subjects;
			}
		}, {
			key: '_onItemSelect',
			value: function _onItemSelect(item) {
				if (this.tags.indexOf(item.name) === -1) {
					this.tags.push(item.name);
				}
				this.searchText = this.defaultTextboxValue || '';
				this.onSelectItem({
					$item: item
				});
			}
		}, {
			key: '_onTagRemove',
			value: function _onTagRemove($event) {
				this.tags = this.tags.filter(function (value) {
					return value !== $event.tag;
				});
				this.onRemoveTag({
					$event: $event.tag
				});
			}
		}, {
			key: 'onKeyDown',
			value: function onKeyDown($event) {
				if ($event.keyCode === 8) {
					if (this.searchText === "" || this.searchText === " ") {
						if (this.tags.length != 0) {
							var _last = _last(this.tags);
							this.tags = this.tags.filter(function (value) {
								return value !== _last;
							});
							this.onRemoveTag({
								$event: _last
							});
						}
					}
				}
			}
		}, {
			key: '_onChangeText',
			value: function _onChangeText() {
				this.onChangeText({
					$event: this.searchText
				});
			}
		}, {
			key: '$onChanges',
			value: function $onChanges(changes) {
				if (changes.defaultSelected && !changes.defaultSelected.isFirstChange()) {
					this.defaultSelected = changes.defaultSelected.currentValue;
					this.$onInit();
				}
				if (changes.isRequired) {
					this.isRequired = _convertToBoolean(changes.isRequired.currentValue, this.$parse);
				}
				if (changes.isDisabled) {
					this._isDisabled = _convertToBoolean(changes.isDisabled.currentValue, this.$parse);
				}
				if (changes.defaultTextboxValue) {
					this.searchText = changes.defaultTextboxValue.currentValue;
				}
			}
		}, {
			key: '_onAutocomplete',
			value: function _onAutocomplete(value) {
				return this.onAutocomplete({
					$event: value
				}).then(function (details) {
					if (details.length != 0) {
						return details;
					}
					return null;
				});
			}
		}, {
			key: '$onChanges',
			value: function $onChanges(changes) {
				if (changes && changes.items) {
					this.items = changes.items.currentValue;
				}
				this.$onInit();
			}
		}]);

		return AutocompleteComponent;
	}()
};
function _convertToBoolean(value, $parse) {
	return $parse(value)(false);
}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.autocomplete = undefined;

var _autocomplete = __webpack_require__(419);

var _indexNocss = __webpack_require__(241);

var _indexNocss2 = _interopRequireDefault(_indexNocss);

var _typeaheadFocus = __webpack_require__(421);

var _each = __webpack_require__(375);

var _each2 = _interopRequireDefault(_each);

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

__webpack_require__(150);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var autocomplete = exports.autocomplete = angular.module('common.components.autocomplete', [_indexNocss2.default]).component('autocomplete', _autocomplete.autocompleteComponent).directive('typeaheadFocus', _typeaheadFocus.typeaheadFocusDirective).filter('norepeat', function () {
	return function (items, tags, allowRepeat) {
		var filterItems = [];
		if (allowRepeat) {
			filterItems = items;
		} else {
			if (tags.length !== items.length) {
				(0, _each2.default)(items, function (item) {
					var filterObj = (0, _filter2.default)(tags, function (tag) {
						return tag === item.name;
					});
					if (filterObj.length === 0) {
						filterItems.push(item);
					}
				});
			}
		}
		return filterItems;
	};
}).filter('filterAutocompleteItems', function () {
	return function (items, searchText) {
		return _onChangeSearchText(items, searchText);
	};

	function _onChangeSearchText(items, searchText) {
		if (searchText && searchText !== ' ') {
			var regex = _getRegexForSearchText(searchText);
			return _getMatchResult(items, regex);
		} else {
			return items;
		}
	}

	function _getRegexForSearchText(searchText) {
		return new RegExp('^' + searchText, 'i');
	}

	function _getMatchResult(items, regex) {
		return items.filter(function (_ref) {
			var name = _ref.name;
			return regex.test(name);
		});
	}
}).name;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var typeaheadFocusDirective = exports.typeaheadFocusDirective = function typeaheadFocusDirective() {
  return {
    require: 'ngModel',
    link: function link(scope, element, attr, ngModel) {

      // Array of keyCode values for arrow keys
      var ARROW_KEYS = [37, 38, 39, 40];

      function manipulateViewValue(e) {
        /* we have to check to see if the arrow keys were in the input because if they were trying to select
         * a menu option in the typeahead, this may cause unexpected behavior if we were to execute the rest
         * of this function
         */
        if (ARROW_KEYS.indexOf(e.keyCode) >= 0) return;

        var viewValue = ngModel.$viewValue;

        //restore to null value so that the typeahead can detect a change
        if (ngModel.$viewValue == ' ') {
          ngModel.$setViewValue(null);
        }

        //force trigger the popup
        ngModel.$setViewValue(' ');

        //set the actual value in case there was already a value in the input
        ngModel.$setViewValue(viewValue || ' ');
      }

      /* trigger the popup on 'click' because 'focus'
       * is also triggered after the item selection.
       * also trigger when input is deleted via keyboard
       */
      element.bind('focus', manipulateViewValue);

      //compare function that treats the empty space as a match
      scope.$emptyOrMatch = function (actual, expected) {
        if (expected == ' ') {
          return true;
        }
        return actual ? actual.toString().toLowerCase().indexOf(expected.toLowerCase()) > -1 : false;
      };
    }
  };
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.basicInfoComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _basicInfo = __webpack_require__(710);

var _basicInfo2 = _interopRequireDefault(_basicInfo);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var basicInfoComponent = exports.basicInfoComponent = {
	bindings: {
		details: '<',
		county: '<',
		onSubmit: '&',
		onCancel: '&',
		onNext: '&',
		showNextButton: '@',
		showPreviousButton: '@',
		hidePhonePurpose: '@',
		parentSlug: '@'
	},

	templateUrl: _basicInfo2.default,

	controller: function () {
		BasicInfoComponent.$inject = ["$state", "$parse", "Constants", "CompareObjectService", "ModalService"];
		function BasicInfoComponent($state, $parse, Constants, CompareObjectService, ModalService) {
			'ngInject';

			_classCallCheck(this, BasicInfoComponent);

			this.$state = $state;
			this.$parse = $parse;
			this.constants = Constants;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
		}

		_createClass(BasicInfoComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.showNextButton = this.$parse(this.showNextButton || 'true')(true);
				this.showPreviousButton = this.$parse(this.showPreviousButton || 'true')(true);
				this.details = this.details || {};
				this.item = {
					name: '',
					number: '',
					extn: '',
					isFocused: false
				};

				if (this.details.phone.length === 0) {
					this.details.phone.push(angular.copy(this.item));
				}

				this.defaultCounties = this.details.serviceArea;
				this.saveData = angular.copy(this.details);
			}
		}, {
			key: 'onUpload',
			value: function onUpload(_ref) {
				var uuid = _ref.details.uuid;

				this.details.image = uuid;
			}
		}, {
			key: 'onAdd',
			value: function onAdd() {
				this.item.isFocused = true;
				this.details.phone.push(angular.copy(this.item));
			}
		}, {
			key: 'onDelete',
			value: function onDelete(index) {
				var item = this.details.phone[index];
				this.details.phone.splice(index, 1);
			}

			//category select function for autocomplete

		}, {
			key: 'onSelectItem',
			value: function onSelectItem(value) {
				var index = (0, _findIndex2.default)(this.details.serviceArea, function (_ref2) {
					var id = _ref2.id;
					return id === value.id;
				});
				if (index === -1) {
					value.status = this.constants.STATUS.ADD;
					this.details.serviceArea.push(value);
				} else {
					this.details.serviceArea[index].status = -1;
				}
			}

			//category remove function for autocomplete

		}, {
			key: 'onRemoveTag',
			value: function onRemoveTag(value) {
				var _this = this;

				var countyIndex = (0, _findIndex2.default)(this.details.serviceArea, function (_ref3) {
					var name = _ref3.name;
					return name === value;
				});
				this.details.serviceArea = this.details.serviceArea.reduce(function (county, value, index) {
					if (countyIndex === index) {
						if (_this.details.serviceArea[index].status !== _this.constants.STATUS.ADD) {
							value.status = _this.constants.STATUS.DELETE;
							county.push(value);
						}
					} else {
						county.push(value);
					}
					return county;
				}, []);
			}
		}, {
			key: 'onRemoveLogo',
			value: function onRemoveLogo() {
				this.details.image = "";
			}
		}, {
			key: '_onCancel',
			value: function _onCancel() {
				var _details = angular.copy(this.details);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},

						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}

				function onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return BasicInfoComponent;
	}()
};

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.basicInfo = undefined;

var _basicInfo = __webpack_require__(422);

var basicInfo = exports.basicInfo = angular.module('common.components.basicInfo', []).component('basicInfo', _basicInfo.basicInfoComponent).name;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.breadcrumbComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _breadcrumb = __webpack_require__(711);

var _breadcrumb2 = _interopRequireDefault(_breadcrumb);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var breadcrumbComponent = exports.breadcrumbComponent = {
	templateUrl: _breadcrumb2.default,

	bindings: {
		isSidebarOpen: '='
	},

	controller: function () {
		Breadcrumb.$inject = ["$state", "$transitions", "$stateParams", "BreadcrumbService"];
		function Breadcrumb($state, $transitions, $stateParams, BreadcrumbService) {
			'ngInject';

			_classCallCheck(this, Breadcrumb);

			this.$stateParams = $stateParams;
			this.breadcrumbs = [];
			this.$state = $state;
			this.breadcrumbService = BreadcrumbService;
			this.onStateChangeSuccess.call(this);
			$transitions.onSuccess({}, this.onStateChangeSuccess.bind(this));
		}

		_createClass(Breadcrumb, [{
			key: 'onStateChangeSuccess',
			value: function onStateChangeSuccess() {
				var state = this.$state.current;
				this.breadcrumbs = state.name !== 'Home' ? this.breadcrumbService.breadcrumbs : [];
			}
		}]);

		return Breadcrumb;
	}()
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.breadcrumb = undefined;

var _breadcrumb = __webpack_require__(424);

var _breadcrumb2 = __webpack_require__(426);

__webpack_require__(151);

var breadcrumb = exports.breadcrumb = angular.module('common.components.breadcrumb', []).component('breadcrumb', _breadcrumb.breadcrumbComponent).service('BreadcrumbService', _breadcrumb2.BreadcrumbService).name;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BreadcrumbService = exports.BreadcrumbService = function () {
    function BreadcrumbService() {
        'ngInject';

        _classCallCheck(this, BreadcrumbService);

        this.breadcrumbs = [];
    }

    _createClass(BreadcrumbService, [{
        key: 'setPageBreadcrumbs',
        value: function setPageBreadcrumbs(breadcrumbs) {
            this.breadcrumbs = this._setBreadcrumbsObject(breadcrumbs);
        }
    }, {
        key: '_setBreadcrumbsObject',
        value: function _setBreadcrumbsObject(breadcrumbs) {
            return breadcrumbs.map(function (_ref) {
                var slug = _ref.slug,
                    name = _ref.name,
                    displayName = _ref.display_name;
                return {
                    slug: slug,
                    name: name,
                    displayName: displayName
                };
            });
        }
    }]);

    return BreadcrumbService;
}();

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
							value: true
});
exports.characterCountComponent = undefined;

var _characterCount = __webpack_require__(712);

var _characterCount2 = _interopRequireDefault(_characterCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var characterCountComponent = exports.characterCountComponent = {
							bindings: {
														maxCount: '@',
														input: '<'
							},

							templateUrl: _characterCount2.default,

							controller: function CharacterCountComponent() {
														_classCallCheck(this, CharacterCountComponent);
							}
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.characterCount = undefined;

var _characterCount = __webpack_require__(427);

var characterCount = exports.characterCount = angular.module('common.components.characterCount', []).component('characterCount', _characterCount.characterCountComponent).name;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.checkboxTemplate1Component = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _checkboxTemplate = __webpack_require__(713);

var _checkboxTemplate2 = _interopRequireDefault(_checkboxTemplate);

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

var _every = __webpack_require__(377);

var _every2 = _interopRequireDefault(_every);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var checkboxTemplate1Component = exports.checkboxTemplate1Component = {
	bindings: {
		title: '@',
		options: '<',
		onChange: '&',
		isDisabled: '<'
	},

	templateUrl: _checkboxTemplate2.default,

	controller: function () {
		CheckboxTemplate1Component.$inject = ["$parse"];
		function CheckboxTemplate1Component($parse) {
			'ngInject';

			_classCallCheck(this, CheckboxTemplate1Component);

			this.$parse = $parse;
		}

		_createClass(CheckboxTemplate1Component, [{
			key: '$onInit',
			value: function $onInit() {
				if (this.isDisabled == undefined) {
					this.isDisabled = false;
				}

				var allSelected = (0, _every2.default)(this.options, ['isSelected', true]);
				if (allSelected === true) {
					this.selectionText = 'deselect all';
					this.selectCheckbox = true;
				} else {
					this.selectionText = 'select all';
					this.selectCheckbox = false;
				}
			}
		}, {
			key: '_onChange',
			value: function _onChange($event, option) {
				var allSelected = (0, _every2.default)(this.options, ['isSelected', true]);
				if (allSelected === true) {
					this.selectionText = 'deselect all';
					this.selectCheckbox = true;
				} else {
					this.selectionText = 'select all';
					this.selectCheckbox = false;
				}
				this.onChange({
					$event: this.options
				});
			}
		}, {
			key: 'onSelectCheckbox',
			value: function onSelectCheckbox() {
				var _this = this;

				this.options.map(function (option) {
					if (_this.selectCheckbox) {
						option.isSelected = true;
						_this.selectionText = 'deselect all';
					} else {
						option.isSelected = false;
						_this.selectionText = 'select all';
					}
				});
				this.onChange({
					$event: this.options
				});
			}
		}]);

		return CheckboxTemplate1Component;
	}()
};

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.checkboxTemplate1 = undefined;

var _checkboxTemplate = __webpack_require__(429);

__webpack_require__(152);

var checkboxTemplate1 = exports.checkboxTemplate1 = angular.module('checkboxTemplate1', []).component('checkboxTemplate1', _checkboxTemplate.checkboxTemplate1Component).name;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.checkboxComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _checkbox = __webpack_require__(714);

var _checkbox2 = _interopRequireDefault(_checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var checkboxComponent = exports.checkboxComponent = {
	bindings: {
		title: '@',
		options: '<',
		onChange: '&',
		isDisabled: '<'
	},
	templateUrl: _checkbox2.default,
	controller: function () {
		CheckboxComponent.$inject = ["$parse"];
		function CheckboxComponent($parse) {
			'ngInject';

			_classCallCheck(this, CheckboxComponent);

			this.$parse = $parse;
		}

		_createClass(CheckboxComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this._isDisabled = this.$parse(this.isDisabled || 'fasle')(false);
				this.name = new Date().getTime() + Math.random();
			}
		}, {
			key: '_onChange',
			value: function _onChange($event, option) {
				this.onChange({
					$event: {
						option: option
					}
				});
			}
		}]);

		return CheckboxComponent;
	}()
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.checkbox = undefined;

var _checkbox = __webpack_require__(431);

__webpack_require__(153);

var checkbox = exports.checkbox = angular.module('checkbox', []).component('checkbox', _checkbox.checkboxComponent).name;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.components = undefined;

var _breadcrumb = __webpack_require__(425);

var _sidebar = __webpack_require__(514);

var _overviewTemplate = __webpack_require__(484);

var _displayOverview = __webpack_require__(449);

var _uploadCoverPic = __webpack_require__(526);

var _modal = __webpack_require__(477);

var _displayCoverPic = __webpack_require__(447);

var _displaySquarePic = __webpack_require__(451);

var _formButtons = __webpack_require__(468);

var _inputValidation = __webpack_require__(475);

var _contentSequence = __webpack_require__(435);

var _autocomplete = __webpack_require__(420);

var _phoneTemplate = __webpack_require__(492);

var _highmaps = __webpack_require__(472);

var _basicInfo = __webpack_require__(423);

var _serviceInfo = __webpack_require__(512);

var _operationInfo = __webpack_require__(480);

var _otherInfo = __webpack_require__(482);

var _tag = __webpack_require__(521);

var _checkboxTemplate = __webpack_require__(430);

var _timepicker = __webpack_require__(524);

var _pagination = __webpack_require__(490);

var _daysOfOperation = __webpack_require__(445);

var _contentTemplate = __webpack_require__(438);

var _pageStatus = __webpack_require__(488);

var _characterCount = __webpack_require__(428);

var _featureMainPageTemplate = __webpack_require__(463);

var _reportRepository = __webpack_require__(505);

var _emptyTextValidation = __webpack_require__(461);

var _subFeatureRepository = __webpack_require__(519);

var _selectDropdown = __webpack_require__(510);

var _datepicker = __webpack_require__(443);

var _searchBox = __webpack_require__(508);

var _pageContentCount = __webpack_require__(486);

var _googleLocation = __webpack_require__(470);

var _editor = __webpack_require__(457);

var _radioButtons = __webpack_require__(494);

var _checkbox = __webpack_require__(432);

var _address = __webpack_require__(418);

var components = exports.components = angular.module('common.components', [_breadcrumb.breadcrumb, _sidebar.sidebar, _overviewTemplate.overviewTemplate, _displayOverview.displayOverview, _uploadCoverPic.uploadCoverPic, _modal.modal, _displayCoverPic.displayCoverPic, _displaySquarePic.displaySquarePic, _formButtons.formButtons, _inputValidation.inputValidation, _contentSequence.contentSequence, _autocomplete.autocomplete, _phoneTemplate.phoneTemplate, _highmaps.highmaps, _basicInfo.basicInfo, _serviceInfo.serviceInfo, _operationInfo.operationInfo, _otherInfo.otherInfo, _tag.tag, _checkboxTemplate.checkboxTemplate1, _timepicker.timepicker, _pagination.pagination, _daysOfOperation.daysOfOperation, _contentTemplate.contentTemplate, _pageStatus.pageStatus, _characterCount.characterCount, _featureMainPageTemplate.featureMainPageTemplate, _reportRepository.reportRepository, _emptyTextValidation.emptyTextValidation, _subFeatureRepository.subFeatureRepository, _emptyTextValidation.emptyTextValidation, _selectDropdown.selectDropdown, _datepicker.datepicker, _searchBox.searchBox, _pageContentCount.pageContentCount, _googleLocation.googleLocation, _editor.editor, _radioButtons.radioButtons, _checkbox.checkbox, _address.address]).name;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contentSequenceDirective = undefined;

var _contentSequence = __webpack_require__(715);

var _contentSequence2 = _interopRequireDefault(_contentSequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var contentSequenceDirective = exports.contentSequenceDirective = function contentSequenceDirective() {
    return {
        restrict: 'AE',

        scope: {
            title: '@',
            list: '<'
        },

        templateUrl: _contentSequence2.default,

        link: function link(scope) {
            // Parent element
            var ol = document.getElementById('slippylist');

            //before reorder (when `move` event encounter)
            ol.addEventListener('slip:beforereorder', function (e) {
                if (/demo-no-reorder/.test(e.target.className)) {
                    e.preventDefault();
                }
            }, false);

            //after reorder (when `mouseup` event encounter)
            ol.addEventListener('slip:reorder', function (e) {
                itemReorder(e.detail, scope.list);
                e.target.parentNode.insertBefore(e.target, e.detail.insertBefore);
                return false;
            }, false);

            //prevent `click + hold` event
            ol.addEventListener('slip:beforewait', function (e) {
                e.preventDefault();
            }, false);
            new Slip(ol);

            //change the order of the list
            function itemReorder(position, list) {
                var item = list[position.originalIndex];
                list.splice(position.originalIndex, 1);
                list.splice(position.spliceIndex, 0, item);
            }

            scope.buttonClick = function (button) {
                if (button.action) {
                    button.action();
                }
            };
        }
    };
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contentSequence = undefined;

var _contentSequence = __webpack_require__(434);

__webpack_require__(436);

var contentSequence = exports.contentSequence = angular.module('common.components.contentSequence', []).directive('contentSequence', _contentSequence.contentSequenceDirective).name;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/*
    Slip - swiping and reordering in lists of elements on touch screens, no fuss.

    Fires these events on list elements:

        • slip:swipe
            When swipe has been done and user has lifted finger off the screen.
            If you execute event.preventDefault() the element will be animated back to original position.
            Otherwise it will be animated off the list and set to display:none.

        • slip:beforeswipe
            Fired before first swipe movement starts.
            If you execute event.preventDefault() then element will not move at all.

        • slip:reorder
            Element has been dropped in new location. event.detail contains the location:
                • insertBefore: DOM node before which element has been dropped (null is the end of the list). Use with node.insertBefore().
                • spliceIndex: Index of element before which current element has been dropped, not counting the element iself.
                               For use with Array.splice() if the list is reflecting objects in some array.

        • slip:beforereorder
            When reordering movement starts.
            Element being reordered gets class `slip-reordering`.
            If you execute event.preventDefault() then element will not move at all.

        • slip:beforewait
            If you execute event.preventDefault() then reordering will begin immediately, blocking ability to scroll the page.

        • slip:tap
            When element was tapped without being swiped/reordered.

        • slip:cancelswipe
            Fired when the user stops dragging and the element returns to its original position.


    Usage:

        CSS:
            You should set `user-select:none` (and WebKit prefixes, sigh) on list elements,
            otherwise unstoppable and glitchy text selection in iOS will get in the way.

            You should set `overflow-x: hidden` on the container or body to prevent horizontal scrollbar
            appearing when elements are swiped off the list.


        var list = document.querySelector('ul#slippylist');
        new Slip(list);

        list.addEventListener('slip:beforeswipe', function(e) {
            if (shouldNotSwipe(e.target)) e.preventDefault();
        });

        list.addEventListener('slip:swipe', function(e) {
            // e.target swiped
            if (thatWasSwipeToRemove) {
                e.target.parentNode.removeChild(e.target);
            } else {
                e.preventDefault(); // will animate back to original position
            }
        });

        list.addEventListener('slip:beforereorder', function(e) {
            if (shouldNotReorder(e.target)) e.preventDefault();
        });

        list.addEventListener('slip:reorder', function(e) {
            // e.target reordered.
            if (reorderedOK) {
                e.target.parentNode.insertBefore(e.target, e.detail.insertBefore);
            } else {
                e.preventDefault();
            }
        });

    Requires:
        • Touch events
        • CSS transforms
        • Function.bind()

    Caveats:
        • Elements must not change size while reordering or swiping takes place (otherwise it will be visually out of sync)
*/
/*!
    Slip.js 1.2.0

    © 2014 Kornel Lesiński <kornel@geekhood.net>. All rights reserved.

    Redistribution and use in source and binary forms, with or without modification,
    are permitted provided that the following conditions are met:

    1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.

    2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and
       the following disclaimer in the documentation and/or other materials provided with the distribution.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
    INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
    DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
    SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
    SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
    WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE
    USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

window['Slip'] = function () {
    'use strict';

    var damnYouChrome = /Chrome\/[34]/.test(navigator.userAgent); // For bugs that can't be programmatically detected :( Intended to catch all versions of Chrome 30-40
    var needsBodyHandlerHack = damnYouChrome; // Otherwise I _sometimes_ don't get any touchstart events and only clicks instead.

    /* When dragging elements down in Chrome (tested 34-37) dragged element may appear below stationary elements.
       Looks like WebKit bug #61824, but iOS Safari doesn't have that problem. */
    var compositorDoesNotOrderLayers = damnYouChrome;

    // -webkit-mess
    var testElement = document.createElement('div');

    var transitionPrefix = "webkitTransition" in testElement.style ? "webkitTransition" : "transition";
    var transformPrefix = "webkitTransform" in testElement.style ? "webkitTransform" : "transform";
    var transformProperty = transformPrefix === "webkitTransform" ? "-webkit-transform" : "transform";
    var userSelectPrefix = "webkitUserSelect" in testElement.style ? "webkitUserSelect" : "userSelect";

    testElement.style[transformPrefix] = 'translateZ(0)';
    var hwLayerMagic = testElement.style[transformPrefix] ? 'translateZ(0) ' : '';
    var hwTopLayerMagic = testElement.style[transformPrefix] ? 'translateZ(1px) ' : '';
    testElement = null;

    var globalInstances = 0;
    var attachedBodyHandlerHack = false;
    var nullHandler = function nullHandler() {};

    function Slip(container, options) {
        if ('string' === typeof container) container = document.querySelector(container);
        if (!container || !container.addEventListener) throw new Error("Please specify DOM node to attach to");

        if (!this || this === window) return new Slip(container, options);

        this.options = options;

        // Functions used for as event handlers need usable `this` and must not change to be removable
        this.cancel = this.setState.bind(this, this.states.idle);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.onSelection = this.onSelection.bind(this);

        this.setState(this.states.idle);
        this.attach(container);
    }

    function getTransform(node) {
        var transform = node.style[transformPrefix];
        if (transform) {
            return {
                value: transform,
                original: transform
            };
        }

        if (window.getComputedStyle) {
            var style = window.getComputedStyle(node).getPropertyValue(transformProperty);
            if (style && style !== 'none') return { value: style, original: '' };
        }
        return { value: '', original: '' };
    }

    function findIndex(target, nodes) {
        var originalIndex = 0;
        var listCount = 0;

        for (var i = 0; i < nodes.length; i++) {
            if (nodes[i].nodeType === 1) {
                listCount++;
                if (nodes[i] === target.node) {
                    originalIndex = listCount - 1;
                }
            }
        }

        return originalIndex;
    }

    // All functions in states are going to be executed in context of Slip object
    Slip.prototype = {

        container: null,
        options: {},
        state: null,

        target: null, // the tapped/swiped/reordered node with height and backed up styles

        usingTouch: false, // there's no good way to detect touchscreen preference other than receiving a touch event (really, trust me).
        mouseHandlersAttached: false,

        startPosition: null, // x,y,time where first touch began
        latestPosition: null, // x,y,time where the finger is currently
        previousPosition: null, // x,y,time where the finger was ~100ms ago (for velocity calculation)

        canPreventScrolling: false,

        states: {
            idle: function idleStateInit() {
                this.target = null;
                this.usingTouch = false;
                this.removeMouseHandlers();

                return {
                    allowTextSelection: true
                };
            },

            undecided: function undecidedStateInit() {
                this.target.height = this.target.node.offsetHeight;
                this.target.node.style[transitionPrefix] = '';

                if (!this.dispatch(this.target.originalTarget, 'beforewait')) {
                    if (this.dispatch(this.target.originalTarget, 'beforereorder')) {
                        this.setState(this.states.reorder);
                    }
                } else {
                    var holdTimer = setTimeout(function () {
                        var move = this.getAbsoluteMovement();
                        if (this.canPreventScrolling && move.x < 15 && move.y < 25) {
                            if (this.dispatch(this.target.originalTarget, 'beforereorder')) {
                                this.setState(this.states.reorder);
                            }
                        }
                    }.bind(this), 300);
                }

                return {
                    leaveState: function leaveState() {
                        clearTimeout(holdTimer);
                    },

                    onMove: function onMove() {
                        var move = this.getAbsoluteMovement();

                        if (move.x > 20 && move.y < Math.max(100, this.target.height)) {
                            if (this.dispatch(this.target.originalTarget, 'beforeswipe')) {
                                this.setState(this.states.swipe);
                                return false;
                            } else {
                                this.setState(this.states.idle);
                            }
                        }
                        if (move.y > 20) {
                            this.setState(this.states.idle);
                        }

                        // Chrome likes sideways scrolling :(
                        if (move.x > move.y * 1.2) return false;
                    },

                    onLeave: function onLeave() {
                        this.setState(this.states.idle);
                    },

                    onEnd: function onEnd() {
                        var allowDefault = this.dispatch(this.target.originalTarget, 'tap');
                        this.setState(this.states.idle);
                        return allowDefault;
                    }
                };
            },

            swipe: function swipeStateInit() {
                var swipeSuccess = false;
                var container = this.container;

                var originalIndex = findIndex(this.target, this.container.childNodes);

                container.className += ' slip-swiping-container';
                function removeClass() {
                    container.className = container.className.replace(/(?:^| )slip-swiping-container/, '');
                }

                this.target.height = this.target.node.offsetHeight;

                return {
                    leaveState: function leaveState() {
                        if (swipeSuccess) {
                            this.animateSwipe(function (target) {
                                target.node.style[transformPrefix] = target.baseTransform.original;
                                target.node.style[transitionPrefix] = '';
                                if (this.dispatch(target.node, 'afterswipe')) {
                                    removeClass();
                                    return true;
                                } else {
                                    this.animateToZero(undefined, target);
                                }
                            }.bind(this));
                        } else {
                            this.animateToZero(removeClass);
                            this.dispatch(this.target.node, 'cancelswipe');
                        }
                    },

                    onMove: function onMove() {
                        var move = this.getTotalMovement();

                        if (Math.abs(move.y) < this.target.height + 20) {
                            this.target.node.style[transformPrefix] = 'translate(' + move.x + 'px,0) ' + hwLayerMagic + this.target.baseTransform.value;
                            return false;
                        } else {
                            this.setState(this.states.idle);
                        }
                    },

                    onLeave: function onLeave() {
                        this.state.onEnd.call(this);
                    },

                    onEnd: function onEnd() {
                        var dx = this.latestPosition.x - this.previousPosition.x;
                        var dy = this.latestPosition.y - this.previousPosition.y;
                        var velocity = Math.sqrt(dx * dx + dy * dy) / (this.latestPosition.time - this.previousPosition.time + 1);

                        var move = this.getAbsoluteMovement();
                        var swiped = velocity > 0.6 && move.time > 110;

                        var direction;
                        if (dx > 0) {
                            direction = "right";
                        } else {
                            direction = "left";
                        }

                        if (swiped) {
                            if (this.dispatch(this.target.node, 'swipe', { direction: direction, originalIndex: originalIndex })) {
                                swipeSuccess = true; // can't animate here, leaveState overrides anim
                            }
                        }
                        this.setState(this.states.idle);
                        return !swiped;
                    }
                };
            },

            reorder: function reorderStateInit() {
                this.target.height = this.target.node.offsetHeight;

                var nodes = this.container.childNodes;
                var originalIndex = findIndex(this.target, nodes);
                var mouseOutsideTimer;
                var zero = this.target.node.offsetTop + this.target.height / 2;
                var otherNodes = [];
                for (var i = 0; i < nodes.length; i++) {
                    if (nodes[i].nodeType != 1 || nodes[i] === this.target.node) continue;
                    var t = nodes[i].offsetTop;
                    nodes[i].style[transitionPrefix] = transformProperty + ' 0.2s ease-in-out';
                    otherNodes.push({
                        node: nodes[i],
                        baseTransform: getTransform(nodes[i]),
                        pos: t + (t < zero ? nodes[i].offsetHeight : 0) - zero
                    });
                }

                this.target.node.className += ' slip-reordering';
                this.target.node.style.zIndex = '99999';
                this.target.node.style[userSelectPrefix] = 'none';
                if (compositorDoesNotOrderLayers) {
                    // Chrome's compositor doesn't sort 2D layers
                    this.container.style.webkitTransformStyle = 'preserve-3d';
                }

                function setPosition() {
                    /*jshint validthis:true */

                    if (mouseOutsideTimer) {
                        // don't care where the mouse is as long as it moves
                        clearTimeout(mouseOutsideTimer);mouseOutsideTimer = null;
                    }

                    var move = this.getTotalMovement();
                    this.target.node.style[transformPrefix] = 'translate(0,' + move.y + 'px) ' + hwTopLayerMagic + this.target.baseTransform.value;

                    var height = this.target.height;
                    otherNodes.forEach(function (o) {
                        var off = 0;
                        if (o.pos < 0 && move.y < 0 && o.pos > move.y) {
                            off = height;
                        } else if (o.pos > 0 && move.y > 0 && o.pos < move.y) {
                            off = -height;
                        }
                        // FIXME: should change accelerated/non-accelerated state lazily
                        o.node.style[transformPrefix] = off ? 'translate(0,' + off + 'px) ' + hwLayerMagic + o.baseTransform.value : o.baseTransform.original;
                    });
                    return false;
                }

                setPosition.call(this);

                return {
                    leaveState: function leaveState() {
                        if (mouseOutsideTimer) clearTimeout(mouseOutsideTimer);

                        if (compositorDoesNotOrderLayers) {
                            this.container.style.webkitTransformStyle = '';
                        }

                        this.target.node.className = this.target.node.className.replace(/(?:^| )slip-reordering/, '');
                        this.target.node.style[userSelectPrefix] = '';

                        this.animateToZero(function (target) {
                            target.node.style.zIndex = '';
                        });
                        otherNodes.forEach(function (o) {
                            o.node.style[transformPrefix] = o.baseTransform.original;
                            o.node.style[transitionPrefix] = ''; // FIXME: animate to new position
                        });
                    },

                    onMove: setPosition,

                    onLeave: function onLeave() {
                        // don't let element get stuck if mouse left the window
                        // but don't cancel immediately as it'd be annoying near window edges
                        if (mouseOutsideTimer) clearTimeout(mouseOutsideTimer);
                        mouseOutsideTimer = setTimeout(function () {
                            mouseOutsideTimer = null;
                            this.cancel();
                        }.bind(this), 700);
                    },

                    onEnd: function onEnd() {
                        var move = this.getTotalMovement();
                        if (move.y < 0) {
                            for (var i = 0; i < otherNodes.length; i++) {
                                if (otherNodes[i].pos > move.y) {
                                    this.dispatch(this.target.node, 'reorder', { spliceIndex: i, insertBefore: otherNodes[i].node, originalIndex: originalIndex });
                                    break;
                                }
                            }
                        } else {
                            for (var i = otherNodes.length - 1; i >= 0; i--) {
                                if (otherNodes[i].pos < move.y) {
                                    this.dispatch(this.target.node, 'reorder', { spliceIndex: i + 1, insertBefore: otherNodes[i + 1] ? otherNodes[i + 1].node : null, originalIndex: originalIndex });
                                    break;
                                }
                            }
                        }
                        this.setState(this.states.idle);
                        return false;
                    }
                };
            }
        },

        attach: function attach(container) {
            globalInstances++;
            if (this.container) this.detach();

            // In some cases taps on list elements send *only* click events and no touch events. Spotted only in Chrome 32+
            // Having event listener on body seems to solve the issue (although AFAIK may disable smooth scrolling as a side-effect)
            if (!attachedBodyHandlerHack && needsBodyHandlerHack) {
                attachedBodyHandlerHack = true;
                document.body.addEventListener('touchstart', nullHandler, false);
            }

            this.container = container;
            this.otherNodes = [];

            // selection on iOS interferes with reordering
            document.addEventListener("selectionchange", this.onSelection, false);

            // cancel is called e.g. when iOS detects multitasking gesture
            this.container.addEventListener('touchcancel', this.cancel, false);
            this.container.addEventListener('touchstart', this.onTouchStart, false);
            this.container.addEventListener('touchmove', this.onTouchMove, false);
            this.container.addEventListener('touchend', this.onTouchEnd, false);
            this.container.addEventListener('mousedown', this.onMouseDown, false);
            // mousemove and mouseup are attached dynamically
        },

        detach: function detach() {
            this.cancel();

            this.container.removeEventListener('mousedown', this.onMouseDown, false);
            this.container.removeEventListener('touchend', this.onTouchEnd, false);
            this.container.removeEventListener('touchmove', this.onTouchMove, false);
            this.container.removeEventListener('touchstart', this.onTouchStart, false);
            this.container.removeEventListener('touchcancel', this.cancel, false);

            document.removeEventListener("selectionchange", this.onSelection, false);

            globalInstances--;
            if (!globalInstances && attachedBodyHandlerHack) {
                attachedBodyHandlerHack = false;
                document.body.removeEventListener('touchstart', nullHandler, false);
            }
        },

        setState: function setState(newStateCtor) {
            if (this.state) {
                if (this.state.ctor === newStateCtor) return;
                if (this.state.leaveState) this.state.leaveState.call(this);
            }

            // Must be re-entrant in case ctor changes state
            var prevState = this.state;
            var nextState = newStateCtor.call(this);
            if (this.state === prevState) {
                nextState.ctor = newStateCtor;
                this.state = nextState;
            }
        },

        findTargetNode: function findTargetNode(targetNode) {
            while (targetNode && targetNode.parentNode !== this.container) {
                targetNode = targetNode.parentNode;
            }
            return targetNode;
        },

        onSelection: function onSelection(e) {
            var isRelated = e.target === document || this.findTargetNode(e);
            if (!isRelated) return;

            if (e.cancelable || e.defaultPrevented) {
                if (!this.state.allowTextSelection) {
                    e.preventDefault();
                }
            } else {
                // iOS doesn't allow selection to be prevented
                this.setState(this.states.idle);
            }
        },

        addMouseHandlers: function addMouseHandlers() {
            // unlike touch events, mousemove/up is not conveniently fired on the same element,
            // but I don't need to listen to unrelated events all the time
            if (!this.mouseHandlersAttached) {
                this.mouseHandlersAttached = true;
                document.documentElement.addEventListener('mouseleave', this.onMouseLeave, false);
                window.addEventListener('mousemove', this.onMouseMove, true);
                window.addEventListener('mouseup', this.onMouseUp, true);
                window.addEventListener('blur', this.cancel, false);
            }
        },

        removeMouseHandlers: function removeMouseHandlers() {
            if (this.mouseHandlersAttached) {
                this.mouseHandlersAttached = false;
                document.documentElement.removeEventListener('mouseleave', this.onMouseLeave, false);
                window.removeEventListener('mousemove', this.onMouseMove, true);
                window.removeEventListener('mouseup', this.onMouseUp, true);
                window.removeEventListener('blur', this.cancel, false);
            }
        },

        onMouseLeave: function onMouseLeave(e) {
            if (this.usingTouch) return;

            if (e.target === document.documentElement || e.relatedTarget === document.documentElement) {
                if (this.state.onLeave) {
                    this.state.onLeave.call(this);
                }
            }
        },

        onMouseDown: function onMouseDown(e) {
            if (this.usingTouch || e.button != 0 || !this.setTarget(e)) return;

            this.addMouseHandlers(); // mouseup, etc.

            this.canPreventScrolling = true; // or rather it doesn't apply to mouse

            this.startAtPosition({
                x: e.clientX,
                y: e.clientY,
                time: e.timeStamp
            });
        },

        onTouchStart: function onTouchStart(e) {
            this.usingTouch = true;
            this.canPreventScrolling = true;

            // This implementation cares only about single touch
            if (e.touches.length > 1) {
                this.setState(this.states.idle);
                return;
            }

            if (!this.setTarget(e)) return;

            this.startAtPosition({
                x: e.touches[0].clientX,
                y: e.touches[0].clientY - window.scrollY,
                time: e.timeStamp
            });
        },

        setTarget: function setTarget(e) {
            var targetNode = this.findTargetNode(e.target);
            if (!targetNode) {
                this.setState(this.states.idle);
                return false;
            }

            //check for a scrollable parent
            var scrollContainer = targetNode.parentNode;
            while (scrollContainer) {
                if (scrollContainer.scrollHeight > scrollContainer.clientHeight && window.getComputedStyle(scrollContainer)['overflow-y'] != 'visible') break;else scrollContainer = scrollContainer.parentNode;
            }

            this.target = {
                originalTarget: e.target,
                node: targetNode,
                scrollContainer: scrollContainer,
                baseTransform: getTransform(targetNode)
            };
            return true;
        },

        startAtPosition: function startAtPosition(pos) {
            this.startPosition = this.previousPosition = this.latestPosition = pos;
            this.setState(this.states.undecided);
        },

        updatePosition: function updatePosition(e, pos) {
            this.latestPosition = pos;

            var triggerOffset = 40,
                offset = 0;

            var scrollable = this.target.scrollContainer || document.body,
                containerRect = scrollable.getBoundingClientRect(),
                targetRect = this.target.node.getBoundingClientRect(),
                bottomOffset = Math.min(containerRect.bottom, window.innerHeight) - targetRect.bottom,
                topOffset = targetRect.top - Math.max(containerRect.top, 0);

            if (bottomOffset < triggerOffset) {
                offset = triggerOffset - bottomOffset;
            } else if (topOffset < triggerOffset) {
                offset = topOffset - triggerOffset;
            }

            var prevScrollTop = scrollable.scrollTop;
            scrollable.scrollTop += offset;
            if (prevScrollTop != scrollable.scrollTop) this.startPosition.y += prevScrollTop - scrollable.scrollTop;

            if (this.state.onMove) {
                if (this.state.onMove.call(this) === false) {
                    e.preventDefault();
                }
            }

            // sample latestPosition 100ms for velocity
            if (this.latestPosition.time - this.previousPosition.time > 100) {
                this.previousPosition = this.latestPosition;
            }
        },

        onMouseMove: function onMouseMove(e) {
            this.updatePosition(e, {
                x: e.clientX,
                y: e.clientY,
                time: e.timeStamp
            });
        },

        onTouchMove: function onTouchMove(e) {
            this.updatePosition(e, {
                x: e.touches[0].clientX,
                y: e.touches[0].clientY - window.scrollY,
                time: e.timeStamp
            });

            // In Apple's touch model only the first move event after touchstart can prevent scrolling (and event.cancelable is broken)
            this.canPreventScrolling = false;
        },

        onMouseUp: function onMouseUp(e) {
            if (this.usingTouch || e.button !== 0) return;

            if (this.state.onEnd && false === this.state.onEnd.call(this)) {
                e.preventDefault();
            }
        },

        onTouchEnd: function onTouchEnd(e) {
            if (e.touches.length > 1) {
                this.cancel();
            } else if (this.state.onEnd && false === this.state.onEnd.call(this)) {
                e.preventDefault();
            }
        },

        getTotalMovement: function getTotalMovement() {
            return {
                x: this.latestPosition.x - this.startPosition.x,
                y: this.latestPosition.y - this.startPosition.y
            };
        },

        getAbsoluteMovement: function getAbsoluteMovement() {
            return {
                x: Math.abs(this.latestPosition.x - this.startPosition.x),
                y: Math.abs(this.latestPosition.y - this.startPosition.y),
                time: this.latestPosition.time - this.startPosition.time
            };
        },

        dispatch: function dispatch(targetNode, eventName, detail) {
            var event = document.createEvent('CustomEvent');
            if (event && event.initCustomEvent) {
                event.initCustomEvent('slip:' + eventName, true, true, detail);
            } else {
                event = document.createEvent('Event');
                event.initEvent('slip:' + eventName, true, true);
                event.detail = detail;
            }
            return targetNode.dispatchEvent(event);
        },

        getSiblings: function getSiblings(target) {
            var siblings = [];
            var tmp = target.node.nextSibling;
            while (tmp) {
                if (tmp.nodeType == 1) siblings.push({
                    node: tmp,
                    baseTransform: getTransform(tmp)
                });
                tmp = tmp.nextSibling;
            }
            return siblings;
        },

        animateToZero: function animateToZero(callback, target) {
            // save, because this.target/container could change during animation
            target = target || this.target;

            target.node.style[transitionPrefix] = transformProperty + ' 0.1s ease-out';
            target.node.style[transformPrefix] = 'translate(0,0) ' + hwLayerMagic + target.baseTransform.value;
            setTimeout(function () {
                target.node.style[transitionPrefix] = '';
                target.node.style[transformPrefix] = target.baseTransform.original;
                if (callback) callback.call(this, target);
            }.bind(this), 101);
        },

        animateSwipe: function animateSwipe(callback) {
            var target = this.target;
            var siblings = this.getSiblings(target);
            var emptySpaceTransform = 'translate(0,' + this.target.height + 'px) ' + hwLayerMagic + ' ';

            // FIXME: animate with real velocity
            target.node.style[transitionPrefix] = 'all 0.1s linear';
            target.node.style[transformPrefix] = ' translate(' + (this.getTotalMovement().x > 0 ? '' : '-') + '100%,0) ' + hwLayerMagic + target.baseTransform.value;

            setTimeout(function () {
                if (callback.call(this, target)) {
                    siblings.forEach(function (o) {
                        o.node.style[transitionPrefix] = '';
                        o.node.style[transformPrefix] = emptySpaceTransform + o.baseTransform.value;
                    });
                    setTimeout(function () {
                        siblings.forEach(function (o) {
                            o.node.style[transitionPrefix] = transformProperty + ' 0.1s ease-in-out';
                            o.node.style[transformPrefix] = 'translate(0,0) ' + hwLayerMagic + o.baseTransform.value;
                        });
                        setTimeout(function () {
                            siblings.forEach(function (o) {
                                o.node.style[transitionPrefix] = '';
                                o.node.style[transformPrefix] = o.baseTransform.original;
                            });
                        }, 101);
                    }, 1);
                }
            }.bind(this), 101);
        }
    };

    // AMD
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return Slip;
        }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
    return Slip;
}();

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.contentTemplateComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _contentTemplate = __webpack_require__(716);

var _contentTemplate2 = _interopRequireDefault(_contentTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var contentTemplateComponent = exports.contentTemplateComponent = {
	bindings: {
		details: '<',
		slugUrl: '@',
		disableButtons: '<',
		isOverviewExist: '@',
		pageName: '@',
		onCancel: '&',
		onSubmit: '&'
	},

	templateUrl: _contentTemplate2.default,
	controller: function () {
		ContentTemplateComponent.$inject = ["$parse", "CompareObjectService", "ModalService", "ContentService", "toastr"];
		function ContentTemplateComponent($parse, CompareObjectService, ModalService, ContentService, toastr) {
			'ngInject';

			_classCallCheck(this, ContentTemplateComponent);

			this.$parse = $parse;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.contentService = ContentService;
			this.toastr = toastr;
		}

		_createClass(ContentTemplateComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this._isOverviewExist = this.$parse(this.isOverviewExist || 'true')(true);
				this.editOverviewFormShow = false;
				this.disableOverviewButtons = false;

				if (this._isOverviewExist) {
					this.details.menuOverviewDetails.pageTitle = "Edit Overview";
					this.menuName = this.details.menuOverviewDetails.name;
					this.savedOverviewData = angular.copy(this.details.menuOverviewDetails);
				}
			}
		}]);

		return ContentTemplateComponent;
	}()
};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.contentTemplate = undefined;

var _contentTemplate = __webpack_require__(437);

var _contentTemplate2 = __webpack_require__(439);

__webpack_require__(154);

var contentTemplate = exports.contentTemplate = angular.module('common.components.contentTemplate', []).service('ContentService', _contentTemplate2.ContentService).component('contentTemplate', _contentTemplate.contentTemplateComponent).name;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContentService = exports.ContentService = ["$resource", "ApiService", function ContentService($resource, ApiService) {
    'ngInject';

    _classCallCheck(this, ContentService);

    this.$resource = $resource;
    this.apiService = ApiService;
}];

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var dateBeforeDirective = exports.dateBeforeDirective = ["defaultErrorMessageResolver", "DateService", function dateBeforeDirective(defaultErrorMessageResolver, DateService) {
    'ngInject';

    defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages) {
        errorMessages['dateBefore'] = 'End date should be greater than the start date';
    });

    return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
            dateBefore: '='
        },
        link: function link(scope, element, attrs, ngModel) {
            ngModel.$validators.dateBefore = function (value) {
                if (value && scope.dateBefore) {
                    var _date = DateService.convertDateToLocal(value).getTime();
                    var _dateBefore = DateService.convertDateToLocal(scope.dateBefore).getTime();
                    if (_dateBefore == _date || _dateBefore > _date) {
                        return false;
                    }
                }
                return true;
            };

            scope.$watch('dateBefore', function (value) {
                if (value) {
                    ngModel.$validate();
                }
            });
        }
    };
}];

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var dateRequiredDirective = exports.dateRequiredDirective = ["$parse", "defaultErrorMessageResolver", function dateRequiredDirective($parse, defaultErrorMessageResolver) {
  'ngInject';

  defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages) {
    errorMessages['dateRequired'] = 'Please select date';
  });
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function link(scope, element, attrs, ngModel) {
      ngModel.$validators.dateRequired = function (value) {
        //setTimeout(() => {
        var dateRequired = true;
        if (attrs.dateRequired) {
          dateRequired = $parse(attrs.dateRequired)(false);
        }
        if (dateRequired !== false) {
          if (!value) {
            return false;
          }
          return true;
        } else {
          return true;
        }
        // }, 100);
      };
    }
  };
}];

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.datepickerComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _datepicker = __webpack_require__(717);

var _datepicker2 = _interopRequireDefault(_datepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var datepickerComponent = exports.datepickerComponent = {
	bindings: {
		details: '<',
		onChange: '&'
	},
	templateUrl: _datepicker2.default,
	controller: function () {
		DatepickerComponent.$inject = ["defaultErrorMessageResolver"];
		function DatepickerComponent(defaultErrorMessageResolver) {
			'ngInject';

			_classCallCheck(this, DatepickerComponent);

			defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages) {
				errorMessages['dateRequired'] = 'Please select date';
			});
		}

		_createClass(DatepickerComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.datepickerOptions = {};
				this.startDatepickerOptions = {};
				this.endDatepickerOptions = {};
				//this.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
				//this.format = this.formats[1];
				if (!this.details) {
					this.details = {};
				}
				if (!this.details.hasOwnProperty('isRequired')) {
					this.details.isRequired = true;
				}
				// if(this.details.selectedDate) {
				// 	this.details.selectedDate = this.details.selectedDate.toString();
				// }
				if (this.details.range) {
					this.startDatePopupOpened = false;
					this.endDatePopupOpened = false;
					if (this.details.range.startDate.disablePreviousDates) {
						this.startDatepickerOptions.minDate = new Date();
					}
					if (this.details.range.endDate.disablePreviousDates) {
						this.endDatepickerOptions.minDate = new Date();
					}
					if (!this.details.range.startDate.hasOwnProperty('isRequired')) {
						this.details.range.startDate.isRequired = true;
					}
					if (!this.details.range.endDate.hasOwnProperty('isRequired')) {
						this.details.range.endDate.isRequired = true;
					}
					//disabled future dates
					if (this.details.range.startDate.disableFutureDates) {
						this.startDatepickerOptions.maxDate = new Date();
						this.startDatepickerOptions.maxDate.setDate(this.startDatepickerOptions.maxDate.getDate() - 1);
					}
					if (this.details.range.endDate.disableFutureDates) {
						this.endDatepickerOptions.maxDate = new Date();
						this.endDatepickerOptions.maxDate.setDate(this.endDatepickerOptions.maxDate.getDate() - 1);
					}
				} else {
					if (this.details.disablePreviousDates) {
						if (this.details.minDate) {
							this.datepickerOptions.minDate = new Date(this.details.minDate);
							this.datepickerOptions.minDate.setDate(this.datepickerOptions.minDate.getDate() + 1);
						} else {
							this.datepickerOptions.minDate = new Date();
						}
					}

					//disabled future dates
					if (this.details.disableFutureDates) {
						this.datepickerOptions.maxDate = new Date();
						this.datepickerOptions.maxDate.setDate(this.datepickerOptions.maxDate.getDate() - 1);
					}
				}
			}
		}, {
			key: 'open',
			value: function open() {
				if (!this.details.disableDate) this.opened = true;
			}
		}, {
			key: 'openStartDatePopup',
			value: function openStartDatePopup() {
				this.startDatePopupOpened = true;
			}
		}, {
			key: 'openEndDatePopup',
			value: function openEndDatePopup() {
				this.endDatePopupOpened = true;
			}
		}, {
			key: '$onChanges',
			value: function $onChanges(changes) {
				if (changes.details && changes.details.currentValue) {
					this.$onInit();
				}
			}
		}, {
			key: '_onChange',
			value: function _onChange(details) {
				if (this.details.range.endDate.endDateGreaterThanStartDate) {
					this.endDatepickerOptions.minDate = new Date(this.details.range.startDate.selectedDate);
					this.endDatepickerOptions.minDate.setDate(this.endDatepickerOptions.minDate.getDate() + 1);
				}
				this.onChange({
					details: details
				});
			}
		}]);

		return DatepickerComponent;
	}()

};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.datepicker = undefined;

var _datepickerPopup = __webpack_require__(216);

var _datepickerPopup2 = _interopRequireDefault(_datepickerPopup);

var _dateRequired = __webpack_require__(441);

var _dateBefore = __webpack_require__(440);

var _datepicker = __webpack_require__(442);

__webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var datepicker = exports.datepicker = angular.module('common.libs.datepicker', [_datepickerPopup2.default]).directive('dateRequired', _dateRequired.dateRequiredDirective).directive('dateBefore', _dateBefore.dateBeforeDirective).component('datepicker', _datepicker.datepickerComponent).name;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.daysOfOperationComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _daysOfOperation = __webpack_require__(718);

var _daysOfOperation2 = _interopRequireDefault(_daysOfOperation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var daysOfOperationComponent = exports.daysOfOperationComponent = {
	templateUrl: _daysOfOperation2.default,

	bindings: {
		details: '<'
	},

	controller: function () {
		function DaysOfOperationComponent() {
			_classCallCheck(this, DaysOfOperationComponent);
		}

		_createClass(DaysOfOperationComponent, [{
			key: '_getClass',
			value: function _getClass(day) {
				return this.details[day] === true ? 'activeDay' : 'inActiveDay';
			}
		}]);

		return DaysOfOperationComponent;
	}()
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.daysOfOperation = undefined;

var _daysOfOperation = __webpack_require__(444);

__webpack_require__(156);

var daysOfOperation = exports.daysOfOperation = angular.module('common.components.daysOfOperation', []).component('daysOfOperation', _daysOfOperation.daysOfOperationComponent).name;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.displayCoverPicComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _displayCoverPic = __webpack_require__(719);

var _displayCoverPic2 = _interopRequireDefault(_displayCoverPic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var displayCoverPicComponent = exports.displayCoverPicComponent = {
    bindings: {
        coverPicUrl: '@'
    },
    templateUrl: _displayCoverPic2.default,
    controller: function () {
        function DisplayCoverPicComponent() {
            _classCallCheck(this, DisplayCoverPicComponent);
        }

        _createClass(DisplayCoverPicComponent, [{
            key: '$onChanges',
            value: function $onChanges(changes) {
                if (changes.coverPicUrl && !changes.coverPicUrl.isFirstChange()) {
                    this.coverPicUrl = changes.coverPicUrl.currentValue;
                }
            }
        }]);

        return DisplayCoverPicComponent;
    }()
};

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.displayCoverPic = undefined;

var _ngImageLoad = __webpack_require__(116);

var _ngImageLoad2 = _interopRequireDefault(_ngImageLoad);

var _displayCoverPic = __webpack_require__(446);

__webpack_require__(157);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var displayCoverPic = exports.displayCoverPic = angular.module('common.components.displayCoverPic', [_ngImageLoad2.default]).component('displayCoverPic', _displayCoverPic.displayCoverPicComponent).config(["NgImageLoadServiceProvider", function (NgImageLoadServiceProvider) {
    'ngInject';

    NgImageLoadServiceProvider.preloadImage({
        key: 'coverPic',
        url: '/./images/cover-pic.jpg'
    });
}]).name;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.displayOverviewComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _displayOverview = __webpack_require__(720);

var _displayOverview2 = _interopRequireDefault(_displayOverview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var displayOverviewComponent = exports.displayOverviewComponent = {
	bindings: {
		details: '<',
		onEdit: '&',
		slugUrl: '@'
	},
	templateUrl: _displayOverview2.default,
	controller: function () {
		DisplayOverviewComponent.$inject = ["$state", "SlugService"];
		function DisplayOverviewComponent($state, SlugService) {
			'ngInject';

			_classCallCheck(this, DisplayOverviewComponent);

			this.$state = $state;
			this.slugService = SlugService;
		}

		_createClass(DisplayOverviewComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.overViewSlugUrl = this.slugService.getOverviewPageUrl(this.slugUrl);
			}
		}, {
			key: 'routeOveriviewPageUrl',
			value: function routeOveriviewPageUrl() {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: this.overViewSlugUrl
				});
			}
		}]);

		return DisplayOverviewComponent;
	}()
};

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.displayOverview = undefined;

var _displayOverview = __webpack_require__(448);

__webpack_require__(158);

var displayOverview = exports.displayOverview = angular.module('common.components.displayOverview', []).component('displayOverview', _displayOverview.displayOverviewComponent).name;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.displaySquarePicComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _displaySquarePic = __webpack_require__(721);

var _displaySquarePic2 = _interopRequireDefault(_displaySquarePic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var displaySquarePicComponent = exports.displaySquarePicComponent = {
    bindings: {
        coverPicUrl: '@'
    },
    templateUrl: _displaySquarePic2.default,
    controller: function () {
        function DisplaySquarePicComponent() {
            _classCallCheck(this, DisplaySquarePicComponent);
        }

        _createClass(DisplaySquarePicComponent, [{
            key: '$onChanges',
            value: function $onChanges(changes) {
                if (changes.coverPicUrl && !changes.coverPicUrl.isFirstChange()) {
                    this.coverPicUrl = changes.coverPicUrl.currentValue;
                }
            }
        }]);

        return DisplaySquarePicComponent;
    }()
};

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.displaySquarePic = undefined;

var _ngImageLoad = __webpack_require__(116);

var _ngImageLoad2 = _interopRequireDefault(_ngImageLoad);

var _displaySquarePic = __webpack_require__(450);

__webpack_require__(159);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var displaySquarePic = exports.displaySquarePic = angular.module('common.components.displaySquarePic', [_ngImageLoad2.default]).component('displaySquarePic', _displaySquarePic.displaySquarePicComponent).config(["NgImageLoadServiceProvider", function (NgImageLoadServiceProvider) {
    'ngInject';

    NgImageLoadServiceProvider.preloadImage({
        key: 'coverPic',
        url: '/./images/tompkins.png'
    });
}]).name;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorImageUploadModalComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

var _size = __webpack_require__(12);

var _size2 = _interopRequireDefault(_size);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _editorImageUploadModal = __webpack_require__(722);

var _editorImageUploadModal2 = _interopRequireDefault(_editorImageUploadModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var STATUS = {
    ADD: 0,
    DELETE: 2,
    STATIC: -1
};

var editorImageUploadModalComponent = exports.editorImageUploadModalComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl: _editorImageUploadModal2.default,

    controller: function () {
        EditorImageUploadModalComponent.$inject = ["ImageUploadService", "ModalService", "ApiService", "toastr"];
        function EditorImageUploadModalComponent(ImageUploadService, ModalService, ApiService, toastr) {
            'ngInject';

            _classCallCheck(this, EditorImageUploadModalComponent);

            this.imageUploadService = ImageUploadService;
            this.modalService = ModalService;
            this.apiService = ApiService;
            this.toastr = toastr;
        }

        _createClass(EditorImageUploadModalComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.contentId = this.resolve.details.data.id;
                this.disableButtons = true;
                this.isBrowseDisabled = false;
                this.selectedImage = "";
                this.selectedImageUuid = "";
                this.images = this._getImages();
                this.tabOptions = [{
                    id: 1,
                    name: 'upload image',
                    isSelected: true
                }, {
                    id: 2,
                    name: 'image library',
                    isSelected: false
                }];
                this.isEditOptionEnabled = false;
                this.showUploadedImage = false;
                this.showLoader = false;
                this.selectedTab = (0, _head2.default)((0, _filter2.default)(this.tabOptions, function (tabOption) {
                    return tabOption.isSelected;
                }));
                this.totalNumberOfImages = this._getTotalNumberOfImages();
                this.deletedImages = [];
            }
        }, {
            key: 'onChangeTab',
            value: function onChangeTab(tab) {
                var previousSelectedTab = (0, _head2.default)((0, _filter2.default)(this.tabOptions, function (tabOption) {
                    return tabOption.isSelected;
                }));
                this.selectedTab = (0, _head2.default)((0, _filter2.default)(this.tabOptions, function (_ref) {
                    var id = _ref.id;
                    return id === tab.id;
                }));
                previousSelectedTab.isSelected = false;
                this.selectedTab.isSelected = true;
                this.selectedImageUuid = "";
                this.disableButtons = true;
                this.isEditOptionEnabled = false;
                this.showUploadedImage = false;
            }
        }, {
            key: 'onChangeEdit',
            value: function onChangeEdit() {
                this.disableButtons = true;
                this.isEditOptionEnabled = !this.isEditOptionEnabled;
                this.images = this._getImages();
                this.deletedImages = [];
            }

            // on Image upload

        }, {
            key: 'onChangeFile',
            value: function onChangeFile() {
                this.isBrowseDisabled = true;
                var pattern = /^image/g;
                var isImage = pattern.test(this.selectedImage.type);
                if (this.selectedImage && isImage) {
                    _upload.call(this, this.selectedImage);
                } else {
                    this.toastr.error("Invalid image file");
                }

                function _upload(image) {
                    var _this = this;

                    this.showLoader = true;

                    this.imageUploadService.upload({
                        image: image,
                        name: this.selectedImage.name,
                        container: this.pageName
                    }).then(function (_ref2) {
                        var data = _ref2.data.data;

                        _this.showLoader = false;
                        var uuid = data.uuid;

                        _this.isBrowseDisabled = false;
                        _this.disableButtons = false;
                        _this.showUploadedImage = true;
                        _this.selectedImageUuid = uuid;
                        _this.images.unshift({ uuid: uuid, status: STATUS.ADD });
                        _this.totalNumberOfImages = _this._getTotalNumberOfImages();
                    }).then(function (_) {
                        _this.images = _this._setImages();
                        _this.resolve.details.getAllUpdatedContentImages(_this.images);
                    }).then(function (_) {
                        return _this.onSubmit();
                    }).catch(function (err) {
                        _this.toastr.error("Image upload failed");
                    });
                }
            }

            //on image select

        }, {
            key: 'onSelectImage',
            value: function onSelectImage(selectedUuid) {
                if (!this.isEditOptionEnabled) {
                    this.selectedImageUuid = selectedUuid;
                    this.disableButtons = false;
                } else {
                    this._setDeletedImages(selectedUuid);
                    this.disableButtons = (0, _size2.default)(this.deletedImages) > 0 ? false : true;
                }
            }

            //on Image delete

        }, {
            key: 'onDeleteImage',
            value: function onDeleteImage() {
                this._setImageStatusToDeleted();
                this.disableButtons = true;
                this.showUploadedImage = false;
                this.images = this._setImages();
                this.resolve.details.getAllUpdatedContentImages(this.images);
                this.resolve.details.getDeletedImageUuids(this.deletedImages);
                this.selectedImageUuid = "";
                this.close();
            }
        }, {
            key: 'getImageSrcPath',
            value: function getImageSrcPath(image) {
                return this.apiService.getResourceUrl('files/images/' + image);
            }
        }, {
            key: 'onCancel',
            value: function onCancel() {
                this.selectedImageUuid = "";
                this.disableButtons = true;
                this.isEditOptionEnabled ? this.onChangeEdit() : this.close();
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                this.resolve.details.getSelectedImage(this.selectedImageUuid);
                this.close();
            }
        }, {
            key: '_getTotalNumberOfImages',
            value: function _getTotalNumberOfImages() {
                return (0, _size2.default)((0, _filter2.default)(this.images, function (_ref3) {
                    var status = _ref3.status;
                    return status !== STATUS.DELETE;
                }));
            }
        }, {
            key: '_setDeletedImages',
            value: function _setDeletedImages(selectedUuid) {
                var selectedImage = (0, _find2.default)(this.images, function (_ref4) {
                    var uuid = _ref4.uuid;
                    return uuid === selectedUuid;
                });
                selectedImage.isSelected = !selectedImage.isSelected;
                selectedImage.isDeleted = selectedImage.isSelected;
                this.deletedImages = this._getDeletedImages();
            }
        }, {
            key: '_getDeletedImages',
            value: function _getDeletedImages() {
                return (0, _filter2.default)(this.images, function (_ref5) {
                    var isDeleted = _ref5.isDeleted;
                    return isDeleted;
                });
            }
        }, {
            key: '_setImageStatusToDeleted',
            value: function _setImageStatusToDeleted() {
                this.images = this.images.map(function (image) {
                    if (image.isDeleted && image.status !== STATUS.ADD) {
                        image.status = STATUS.DELETE;
                    }
                    return image;
                });
                this.images = (0, _filter2.default)(this.images, function (_ref6) {
                    var isDeleted = _ref6.isDeleted,
                        status = _ref6.status;
                    return status !== STATUS.ADD;
                });
            }
        }, {
            key: '_getImages',
            value: function _getImages() {
                return this.resolve.details.data.images.map(function (_ref7) {
                    var uuid = _ref7.uuid,
                        status = _ref7.status;
                    return { uuid: uuid, status: status, isSelected: false, isDeleted: false };
                });
            }
        }, {
            key: '_setImages',
            value: function _setImages() {
                return this.images.map(function (_ref8) {
                    var uuid = _ref8.uuid,
                        status = _ref8.status;
                    return { uuid: uuid, status: status };
                });
            }
        }]);

        return EditorImageUploadModalComponent;
    }()
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.editorImageUploadModal = undefined;

var _editorImageUploadModal = __webpack_require__(452);

var _ngFileUpload = __webpack_require__(79);

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

__webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var editorImageUploadModal = exports.editorImageUploadModal = angular.module('common.components.editor.editorImageUploadModal', [_ngFileUpload2.default]).component('editorImageUploadModal', _editorImageUploadModal.editorImageUploadModalComponent).name;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorVideoLinkModalComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _size = __webpack_require__(12);

var _size2 = _interopRequireDefault(_size);

var _editorVideoLinkModal = __webpack_require__(723);

var _editorVideoLinkModal2 = _interopRequireDefault(_editorVideoLinkModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var editorVideoLinkModalComponent = exports.editorVideoLinkModalComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl: _editorVideoLinkModal2.default,

    controller: function () {
        EditorVideoLinkModalComponent.$inject = ["$sce", "EditorService", "ModalService", "ApiService", "toastr"];
        function EditorVideoLinkModalComponent($sce, EditorService, ModalService, ApiService, toastr) {
            'ngInject';

            _classCallCheck(this, EditorVideoLinkModalComponent);

            this.$sce = $sce;
            this.editorService = EditorService;
            this.modalService = ModalService;
            this.apiService = ApiService;
            this.toastr = toastr;
        }

        _createClass(EditorVideoLinkModalComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.contentId = this.resolve.details.data.id;
                this.disableButtons = true;
                this.selectedLink = "";
                this.videos = this._getVideos();
                this.tabOptions = [{
                    id: 1,
                    name: 'upload video',
                    isSelected: true
                }, {
                    id: 2,
                    name: 'video library',
                    isSelected: false
                }];
                this.isEditOptionEnabled = false;
                this.showUploadedVideo = false;
                this.deletedVideos = [];
                this.selectedTab = (0, _head2.default)((0, _filter2.default)(this.tabOptions, function (tabOption) {
                    return tabOption.isSelected;
                }));
            }
        }, {
            key: 'onChangeTab',
            value: function onChangeTab(tab) {
                var previousSelectedTab = (0, _head2.default)((0, _filter2.default)(this.tabOptions, function (tabOption) {
                    return tabOption.isSelected;
                }));
                this.selectedTab = (0, _head2.default)((0, _filter2.default)(this.tabOptions, function (_ref) {
                    var id = _ref.id;
                    return id === tab.id;
                }));
                previousSelectedTab.isSelected = false;
                this.selectedTab.isSelected = true;
                this.selectedLink = "";
                this.disableButtons = true;
                this.isEditOptionEnabled = false;
                this.showUploadedVideo = false;
                this.invalidVideoLink = false;
                this.deletedVideos = [];
                this.videos = this._getVideos();
            }
        }, {
            key: 'onChangeEdit',
            value: function onChangeEdit() {
                this.disableButtons = true;
                this.isEditOptionEnabled = !this.isEditOptionEnabled;
                this.videos = this._getVideos();
            }
        }, {
            key: 'onInsertVideo',
            value: function onInsertVideo() {
                if (this._isGivenLinkValid()) {
                    this.disableButtons = false;
                    this.showUploadedVideo = true;
                    this.invalidVideoLink = false;
                    this.videos.unshift({ link: this.selectedLink });
                    this.resolve.details.getAllUpdatedContentVideos(this._setVideos(this.videos));
                    this.onSubmit();
                } else {
                    this.invalidVideoLink = true;
                }
            }
        }, {
            key: 'onSelectLink',
            value: function onSelectLink(selectedLink) {
                if (!this.isEditOptionEnabled) {
                    this.disableButtons = false;
                    this.selectedLink = selectedLink;
                } else {
                    this._setDeleteingVideos(selectedLink);
                    this.disableButtons = (0, _size2.default)(this.deletedVideos) > 0 ? false : true;
                }
            }
        }, {
            key: 'onDeleteVideo',
            value: function onDeleteVideo() {
                this.deletedVideos = this._getDeletedVideos();
                this.videos = this._getNonDeletedVideos();
                this.resolve.details.getDeletedLinks(this.deletedVideos);
                this.resolve.details.getAllUpdatedContentVideos(this._setVideos(this.videos));
                var successMessage = (0, _size2.default)(this.deletedVideos) > 0 ? 'links are deleted successfully.' : 'link is deleted successfully.';
                this.toastr.success(successMessage);
                this.close();
            }
        }, {
            key: 'onCancel',
            value: function onCancel() {
                this.selectedLink = "";
                this.disableButtons = true;
                this.isEditOptionEnabled ? this.onChangeEdit() : this.close();
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                this.resolve.details.getSelectedLink(this.selectedLink);
                this.close();
            }

            //--------------------------------------------------------------------PRIVATE METHODS------------------------------------------------

        }, {
            key: '_isGivenLinkValid',
            value: function _isGivenLinkValid() {
                if (this._isGivenLinkFromYoutube()) {
                    this.selectedLink = this._getModifiedYoutubeLink();
                }

                if (this._isGivenLinkFromVimeo()) {
                    this.selectedLink = this._getModifiedVimeoLink();
                }

                if (!this._checkIsLinkAlreadyAvailable()) {
                    return true;
                }

                return false;
            }
        }, {
            key: '_checkIsLinkAlreadyAvailable',
            value: function _checkIsLinkAlreadyAvailable() {
                var _this = this;

                return (0, _findIndex2.default)(this.videos, function (_ref2) {
                    var link = _ref2.link;
                    return link === _this.selectedLink;
                }) !== -1 ? true : false;
            }
        }, {
            key: '_isGivenLinkFromYoutube',
            value: function _isGivenLinkFromYoutube() {
                return this.selectedLink.indexOf("https://www.youtube.com/watch?v") === -1 ? false : true;
            }
        }, {
            key: '_getModifiedYoutubeLink',
            value: function _getModifiedYoutubeLink() {
                return this.selectedLink.replace('watch?v=', 'embed/');
            }
        }, {
            key: '_isGivenLinkFromVimeo',
            value: function _isGivenLinkFromVimeo() {
                return this.selectedLink.indexOf("vimeo.com") === -1 ? false : true;
            }
        }, {
            key: '_getModifiedVimeoLink',
            value: function _getModifiedVimeoLink() {
                var lastIndex = this.selectedLink.lastIndexOf('/');
                var vimeoVideoId = this.selectedLink.slice(lastIndex);
                return 'https://player.vimeo.com/video' + vimeoVideoId;
            }
        }, {
            key: '_setDeleteingVideos',
            value: function _setDeleteingVideos(selectedLink) {
                var selectedVideo = (0, _find2.default)(this.videos, function (_ref3) {
                    var link = _ref3.link;
                    return link === selectedLink;
                });
                selectedVideo.isSelected = !selectedVideo.isSelected;
                this.deletedVideos = this._getDeletedVideos();
            }
        }, {
            key: '_getVideos',
            value: function _getVideos() {
                return this.resolve.details.data.videos.map(function (_ref4) {
                    var link = _ref4.link;
                    return { link: link, isSelected: false };
                });
            }
        }, {
            key: '_setVideos',
            value: function _setVideos(videos) {
                return videos.map(function (_ref5) {
                    var link = _ref5.link;
                    return { link: link };
                });
            }
        }, {
            key: '_getDeletedVideos',
            value: function _getDeletedVideos() {
                return (0, _filter2.default)(this.videos, function (_ref6) {
                    var isSelected = _ref6.isSelected;
                    return isSelected;
                });
            }
        }, {
            key: '_getNonDeletedVideos',
            value: function _getNonDeletedVideos() {
                return (0, _filter2.default)(this.videos, function (_ref7) {
                    var isSelected = _ref7.isSelected;
                    return !isSelected;
                });
            }
        }]);

        return EditorVideoLinkModalComponent;
    }()
};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.editorVideoLinkModal = undefined;

var _editorVideoLinkModal = __webpack_require__(454);

__webpack_require__(161);

var editorVideoLinkModal = exports.editorVideoLinkModal = angular.module('common.components.editor.editorVideoLinkModal', []).component('editorVideoLinkModal', _editorVideoLinkModal.editorVideoLinkModalComponent).name;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.editorComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _editor = __webpack_require__(724);

var _editor2 = _interopRequireDefault(_editor);

var _clone = __webpack_require__(11);

var _clone2 = _interopRequireDefault(_clone);

var _reduce = __webpack_require__(78);

var _reduce2 = _interopRequireDefault(_reduce);

var _jodit = __webpack_require__(459);

var _jodit2 = _interopRequireDefault(_jodit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var editorComponent = exports.editorComponent = {
	bindings: {
		details: '<',
		disableButtons: '<',
		showFooterButtons: '@',
		pageTitle: '@',
		getEditorDetails: '&',
		editorFieldError: '@',
		onCancel: '&',
		onSubmit: '&'
	},

	templateUrl: _editor2.default,

	controller: function () {
		EditorComponent.$inject = ["$parse", "$timeout", "ModalService", "ApiService"];
		function EditorComponent($parse, $timeout, ModalService, ApiService) {
			'ngInject';

			_classCallCheck(this, EditorComponent);

			this.$parse = $parse;
			this.$timeout = $timeout;
			this.modalService = ModalService;
			this.apiService = ApiService;
		}

		_createClass(EditorComponent, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;

				this._editorFieldError = this.$parse(this.editorFieldError || 'false')(false);;
				this._showFooterButtons = this.$parse(this.showFooterButtons || 'true')(true);
				this.details = this.details || this._getBlankObject();

				this.pageTitle = this.pageTitle || 'Description';

				// Editor custo buttons for image and video uploading
				this.editor = new _jodit2.default("#editor", {
					buttons: this._getListOfEditorButtons(),
					buttonsMD: this._getListOfEditorButtons(),
					buttonsSM: this._getListOfEditorButtons(),
					buttonsXS: this._getListOfEditorButtons(),
					extraButtons: [this._getEditorExtraButtonForImageConfigObject(), this._getEditorExtraButtonForVideoConfigObject()],
					toolbarSticky: true,
					askBeforePasteHTML: false,
					askBeforePasteFromWord: false,
					preset: "inline"
				});
				this.editor.setEditorValue(this.details.description);

				this.editorWindow = angular.element(this.editor.editor);
				this.editorWindow.bind('blur', function (_) {
					//get Data on blur event
					_this._getEditorDetails();
				});
			}
		}, {
			key: '_getListOfEditorButtons',
			value: function _getListOfEditorButtons() {
				return ['paragraph', 'bold', 'italic', 'underline', 'link', 'ul', 'ol', 'undo', 'redo'];
			}
		}, {
			key: '_getEditorExtraButtonForImageConfigObject',
			value: function _getEditorExtraButtonForImageConfigObject() {
				var _this2 = this;

				return {
					name: 'insertImage',
					tooltip: 'Insert Image',
					iconURL: '/./images/image-editor-icon.png',
					exec: function exec(editor) {
						var parentDivId = _this2._getRandomId();
						editor.selection.insertHTML('<span id=\'' + parentDivId + '\'></span>');
						_this2._openEditorImageModal(parentDivId);
					}
				};
			}
		}, {
			key: '_getEditorExtraButtonForVideoConfigObject',
			value: function _getEditorExtraButtonForVideoConfigObject() {
				var _this3 = this;

				return {
					name: 'insertVideo',
					tooltip: 'Insert Video',
					iconURL: '/./images/video.png',
					exec: function exec(editor) {
						var parentDivId = _this3._getRandomId();
						editor.selection.insertHTML('<div id=\'' + parentDivId + '\'></div>');
						_this3._openEditorVideoModal(parentDivId);
					}
				};
			}
		}, {
			key: '_openEditorImageModal',
			value: function _openEditorImageModal(parentDivId) {
				var _this4 = this;

				this.modalService.open({
					component: 'editorImageUploadModal',
					backdrop: 'static',
					keyboard: false,
					details: {
						data: (0, _clone2.default)(this.details),
						getSelectedImage: function getSelectedImage(image) {
							var imageSrc = _this4.apiService.getResourceUrl('files/images/' + image);
							var parentElement = document.getElementById(parentDivId);
							parentElement.innerHTML = '<img src=\'' + imageSrc + '\' id=\'' + image + '\' class="' + image + '" style="border: 1px solid #ccc;margin:5px;">';
						},
						getDeletedImageUuids: function getDeletedImageUuids(deletedUuids) {
							deletedUuids.map(function (_ref) {
								var uuid = _ref.uuid;

								_this4._deleteElementFromDOM(uuid);
							});
						},
						getAllUpdatedContentImages: function getAllUpdatedContentImages(images) {
							return _this4.details.images = images;
						}
					}
				});
			}
		}, {
			key: '_openEditorVideoModal',
			value: function _openEditorVideoModal(parentDivId) {
				var _this5 = this;

				this.modalService.open({
					component: 'editorVideoLinkModal',
					backdrop: 'static',
					keyboard: false,
					details: {
						data: (0, _clone2.default)(this.details),
						getSelectedLink: function getSelectedLink(link) {
							var parentElement = document.getElementById(parentDivId);
							parentElement.innerHTML = '<div id="' + link + '" class="editor-video ' + link + '" align=\'center\'><iframe src="' + link + '" frameborder="0" allowfullscreen=""></iframe></div>';
						},
						getDeletedLinks: function getDeletedLinks(deletedLinks) {
							deletedLinks.map(function (_ref2) {
								var link = _ref2.link;

								_this5._deleteElementFromDOM(link);
							});
						},
						getAllUpdatedContentVideos: function getAllUpdatedContentVideos(videos) {
							return _this5.details.videos = videos;
						}
					}
				});
			}
		}, {
			key: '_deleteElementFromDOM',
			value: function _deleteElementFromDOM(element) {
				var elements = document.getElementsByClassName(element);
				while (elements.length > 0) {
					elements[0].parentNode.removeChild(elements[0]);
				}
			}
		}, {
			key: '_getEditorDetails',
			value: function _getEditorDetails() {
				var _this6 = this;

				this.details.description = this.editor.editor.innerHTML;
				this.$timeout(function (_) {
					return _this6._editorFieldError = _this6._validateEditorContent();
				});
				this.getEditorDetails({
					$event: this.details
				});
			}
		}, {
			key: '_getBlankObject',
			value: function _getBlankObject() {
				return {
					description: "",
					images: [],
					videos: []
				};
			}
		}, {
			key: '_getRandomId',
			value: function _getRandomId() {
				var idLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

				var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
				return (0, _reduce2.default)([].concat(_toConsumableArray(Array(idLength).keys())), function (id, index) {
					return id += possible.charAt(Math.floor(Math.random() * possible.length));
				}, 0);
			}
		}, {
			key: '_validateEditorContent',
			value: function _validateEditorContent() {
				return this.editor.editor.innerHTML.length > 0 ? false : true;
			}
		}, {
			key: '_onSubmit',
			value: function _onSubmit() {
				this._editorFieldError = this._validateEditorContent();
				this.details.description = this.editor.editor.innerHTML;
				if (!this._editorFieldError) {
					this.onSubmit();
				}
			}
		}, {
			key: '$onChanges',
			value: function $onChanges(changes) {
				if (changes && changes.editorFieldError) {
					this._editorFieldError = this.$parse(changes.editorFieldError.currentValue || 'true')(true);
				}
			}
		}]);

		return EditorComponent;
	}()
};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
   value: true
});
exports.editor = undefined;

var _editor = __webpack_require__(456);

var _editorImageUploadModal = __webpack_require__(453);

var _editorVideoLinkModal = __webpack_require__(455);

var _editor2 = __webpack_require__(458);

__webpack_require__(163);

__webpack_require__(162);

var editor = exports.editor = angular.module('common.components.editor', [_editorImageUploadModal.editorImageUploadModal, _editorVideoLinkModal.editorVideoLinkModal]).component('editor', _editor.editorComponent).service('EditorService', _editor2.EditorService).name;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditorService = exports.EditorService = function EditorService() {
    _classCallCheck(this, EditorService);
};

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise, process, module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * 
 *    jodit - Jodit is awesome and usefully wysiwyg editor with filebrowser
 *    Author: Chupurnov <chupurnov@gmail.com> (https://xdsoft.net/)
 *    Version: v3.1.28
 *    Url: https://xdsoft.net/jodit/
 *    License(s): SEE LICENSE IN <LICENSE>
 * 
 */
!function (e, t) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = t() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.Jodit = t() : e.Jodit = t();
}("undefined" != typeof self ? self : undefined, function () {
  return function (e) {
    function t(n) {
      if (o[n]) return o[n].exports;var i = o[n] = { i: n, l: !1, exports: {} };return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
    }var o = {};return t.m = e, t.c = o, t.d = function (e, o, n) {
      t.o(e, o) || Object.defineProperty(e, o, { configurable: !1, enumerable: !0, get: n });
    }, t.n = function (e) {
      var o = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };return t.d(o, "a", o), o;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "/build/", t(t.s = 20);
  }([function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = o(2),
        i = o(3),
        r = {},
        s = r.toString,
        a = r.hasOwnProperty;t.isIE = function () {
      return -1 != navigator.userAgent.indexOf("MSIE") || /rv:11.0/i.test(navigator.userAgent);
    };var l = 1;t.$$ = function (e, o) {
      var n;if (!/:scope/.test(e) || !t.isIE() || "undefined" != typeof HTMLDocument && o instanceof HTMLDocument) n = o.querySelectorAll(e);else {
        var i = o.id,
            r = i || "_selector_id_" + ("" + Math.random()).slice(2) + l++;e = e.replace(/:scope/g, "#" + r), !i && o.setAttribute("id", r), n = o.parentNode.querySelectorAll(e), i || o.removeAttribute("id");
      }return [].slice.call(n);
    }, t.isWindow = function (e) {
      return null !== e && e === e.window;
    }, t.type = function (e) {
      return null === e ? "null" : "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) || "function" == typeof e ? r[s.call(e)] || "object" : typeof e === "undefined" ? "undefined" : _typeof(e);
    }, t.each = function (e, t) {
      var o, n, i;if (Array.isArray(e)) {
        for (o = e.length, i = 0; o > i; i += 1) {
          if (!1 === t.call(e[i], i, e[i])) return !1;
        }
      } else for (n = Object.keys(e), i = 0; n.length > i; i += 1) {
        if (!1 === t.call(e[n[i]], n[i], e[n[i]])) return !1;
      }return e;
    }, t.each(["Boolean", "Number", "String", "Function", "Array", "Date", "RegExp", "Object", "Error", "Symbol", "HTMLDocument", "Window", "HTMLElement", "HTMLBodyElement", "Text", "DocumentFragment"], function (e, t) {
      r["[object " + t + "]"] = t.toLowerCase();
    }), t.inArray = function (e, t) {
      return -1 !== t.indexOf(e);
    }, t.isPlainObject = function (e) {
      return !("object" != (typeof e === "undefined" ? "undefined" : _typeof(e)) || e.nodeType || t.isWindow(e) || e.constructor && !a.call(e.constructor.prototype, "isPrototypeOf"));
    }, t.extend = function () {
      for (var e = [], o = 0; arguments.length > o; o++) {
        e[o] = arguments[o];
      }var n,
          i,
          r,
          s,
          a,
          l,
          c,
          d,
          u = e[0] || {},
          p = 1,
          f = e.length,
          h = !1;for ("boolean" == typeof u && (h = u, u = e[p] || {}, p += 1), "object" != (typeof u === "undefined" ? "undefined" : _typeof(u)) && "function" === t.type(u) && (u = {}), p === f && (u = this, p += 1), p; f > p; p += 1) {
        if (null !== (n = e[p]) && void 0 !== n) for (d = Object.keys(n), c = 0; d.length > c; c += 1) {
          i = d[c], r = u[i], s = n[i], u !== s && (h && s && (t.isPlainObject(s) || Array.isArray(s)) ? (a = Array.isArray(s), a ? (a = !1, l = r && Array.isArray(r) ? r : []) : l = r && t.isPlainObject(r) ? r : {}, u[i] = t.extend(h, l, s)) : void 0 !== s && (u[i] = s));
        }
      }return u;
    }, t.trim = function (e) {
      return e.replace(n.SPACE_REG_EXP_START, "").replace(n.SPACE_REG_EXP_END, "");
    }, t.colorToHex = function (e) {
      if ("rgba(0, 0, 0, 0)" === e || "" === e) return !1;if (!e) return "#000000";if ("#" === e.substr(0, 1)) return e;var t,
          o,
          n,
          i,
          r,
          s = /([\s\n\t\r]*?)rgb\((\d+), (\d+), (\d+)\)/.exec(e) || /([\s\n\t\r]*?)rgba\((\d+), (\d+), (\d+), ([\d.]+)\)/.exec(e);if (!s) return "#000000";for (o = parseInt(s[2], 10), n = parseInt(s[3], 10), i = parseInt(s[4], 10), r = i | n << 8 | o << 16, t = r.toString(16).toUpperCase(); 6 > t.length;) {
        t = "0" + t;
      }return s[1] + "#" + t;
    }, t.normalizeColor = function (e) {
      var o,
          n = ["#"],
          i = t.colorToHex(e);if (!i) return !1;if (i = t.trim(i.toUpperCase()), i = i.substr(1), 3 === i.length) {
        for (o = 0; 3 > o; o += 1) {
          n.push(i[o]), n.push(i[o]);
        }return n.join("");
      }return i.length > 6 && (i = i.substr(0, 6)), "#" + i;
    }, t.normalizeSize = function (e) {
      return (/^[0-9]+$/.test("" + e) ? e + "px" : "" + e
      );
    }, t.getContentWidth = function (e, t) {
      var o = function o(e) {
        return parseInt(e, 10);
      },
          n = t.getComputedStyle(e);return e.offsetWidth - o(n.getPropertyValue("padding-left") || "0") - o(n.getPropertyValue("padding-right") || "0");
    }, t.ctrlKey = function (e) {
      if (-1 !== navigator.userAgent.indexOf("Mac OS X")) {
        if (e.metaKey && !e.altKey) return !0;
      } else if (e.ctrlKey && !e.altKey) return !0;return !1;
    };var c = function c(e) {
      return "file:" === window.location.protocol && /^\/\//.test(e) && (e = "https:" + e), e;
    };t.appendScript = function (e, t, o, n) {
      void 0 === o && (o = "");var i = n.createElement("script");i.className = o, i.type = "text/javascript", i.charset = "utf-8", i.src = c(e), void 0 !== t && (i.onload = t), n.body.appendChild(i);
    }, t.dom = function (e, t) {
      if (e instanceof t.defaultView.HTMLElement) return e;var o = t.createElement("div");return o.innerHTML = e, o.firstChild === o.lastChild && o.firstChild ? o.firstChild : o;
    }, t.hexToRgb = function (e) {
      e = e.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (e, t, o, n) {
        return t + t + o + o + n + n;
      });var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);return t ? { r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16) } : null;
    }, t.clear = function (e, o) {
      return void 0 === o && (o = !1), e = t.trim(e).replace(n.INVISIBLE_SPACE_REG_EXP, "").replace(/[\s]*class=""/g, ""), o && (e = e.replace(/<p[^>]*>[\s\n\r\t]*(&nbsp;|<br>|<br\/>)?[\s\n\r\t]*<\/p>[\n\r]*/g, "")), e;
    }, t.htmlentities = function (e) {
      return e.replace(/</gi, "&lt;").replace(/>/gi, "&gt;").replace(/"/gi, "&quot;").replace(/'/gi, "&apos;");
    }, t.isURL = function (e) {
      return RegExp("^(https?:\\/\\/)((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$", "i").test(e);
    }, t.pathNormalize = function (e) {
      return e.replace(/([^:])[\\\/]+/g, "$1/");
    }, t.urlNormalize = function (e) {
      return e.replace(/([^:])[\\\/]+/g, "$1/");
    }, t.isHTML = function (e) {
      return (/<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/m.test(e)
      );
    }, t.isHTMLFromWord = function (e) {
      return -1 !== e.search(/<meta.*?Microsoft Excel\s[\d].*?>/) || -1 !== e.search(/<meta.*?Microsoft Word\s[\d].*?>/) || -1 !== e.search(/style="[^"]*mso-/) && -1 !== e.search(/<font/);
    }, t.humanSizeToBytes = function (e) {
      if (/^[0-9.]+$/.test("" + e)) return parseFloat(e);var t = e.substr(-2, 2).toUpperCase(),
          o = ["KB", "MB", "GB", "TB"],
          n = parseFloat(e.substr(0, e.length - 2));return -1 !== o.indexOf(t) ? n * Math.pow(1024, o.indexOf(t) + 1) : parseInt(e, 10);
    }, t.parseQuery = function (e) {
      var t,
          o,
          n = {},
          i = e.substr(1).split("&");for (t = 0; i.length > t; t += 1) {
        o = i[t].split("="), n[decodeURIComponent(o[0])] = decodeURIComponent(o[1] || "");
      }return n;
    }, t.convertMediaURLToVideoEmbed = function (e, o, n) {
      if (void 0 === o && (o = 400), void 0 === n && (n = 345), !t.isURL(e)) return e;var i = document.createElement("a"),
          r = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;switch (i.href = e, o || (o = 400), n || (n = 345), i.hostname) {case "www.vimeo.com":case "vimeo.com":
          return r.test(e) ? e.replace(r, '<iframe width="' + o + '" height="' + n + '" src="//player.vimeo.com/video/$1" frameborder="0" allowfullscreen></iframe>') : e;case "youtube.com":case "www.youtube.com":case "youtu.be":case "www.youtu.be":
          var s = i.search ? t.parseQuery(i.search) : { v: i.pathname.substr(1) };return s.v ? '<iframe width="' + o + '" height="' + n + '" src="//www.youtube.com/embed/' + s.v + '" frameborder="0" allowfullscreen></iframe>' : e;}return e;
    }, t.browser = function (e) {
      var t = navigator.userAgent.toLowerCase(),
          o = /(firefox)[\s\/]([\w.]+)/.exec(t) || /(chrome)[\s\/]([\w.]+)/.exec(t) || /(webkit)[\s\/]([\w.]+)/.exec(t) || /(opera)(?:.*version)[\s\/]([\w.]+)/.exec(t) || /(msie)[\s]([\w.]+)/.exec(t) || /(trident)\/([\w.]+)/.exec(t) || 0 > t.indexOf("compatible") || [];return "version" === e ? o[2] : "webkit" === e ? "chrome" === o[1] || "webkit" === o[1] : "ff" === e ? "firefox" === o[1] : "msie" === e ? "trident" === o[1] || "msie" === o[1] : o[1] === e;
    }, t.offset = function (e, o, n) {
      void 0 === n && (n = !1);var i,
          r,
          s = e.getBoundingClientRect(),
          a = e.ownerDocument,
          l = a.body,
          c = a.documentElement,
          d = a.defaultView || a.parentWindow,
          u = d.pageYOffset || c.scrollTop || l.scrollTop,
          p = d.pageXOffset || c.scrollLeft || l.scrollLeft,
          f = c.clientTop || l.clientTop || 0,
          h = c.clientLeft || l.clientLeft || 0;if (!n && o.options.iframe) {
        var m = t.offset(o.iframe, o, !0),
            v = m.top,
            g = m.left;i = s.top + v, r = s.left + g;
      } else i = s.top + u - f, r = s.left + p - h;return { top: Math.round(i), left: Math.round(r), width: s.width, height: s.height };
    }, t.camelCase = function (e) {
      return e.replace(/-(.)/g, function (e, t) {
        return t.toUpperCase();
      });
    }, t.fromCamelCase = function (e) {
      return e.replace(/([A-Z]+)/g, function (e, t) {
        return "-" + t.toLowerCase();
      });
    }, t.htmlspecialchars = function (e) {
      var t = document.createElement("div");return t.innerText = e, t.innerHTML;
    }, t.debounce = function (e, t, o, n) {
      3 === arguments.length && "boolean" != typeof o && (n = o, o = !1);var i = 0;return function () {
        var r = arguments;n = n || this, (o && !i || !t) && e.apply(n, r), t && (clearTimeout(i), i = window.setTimeout(function () {
          o || e.apply(n, r), i = 0;
        }, t));
      };
    }, t.throttle = function (e, t, o) {
      var n,
          i,
          _r,
          s = null;return function () {
        n = arguments, i = !0, o = o || this, s || (_r = function r() {
          i ? (e.apply(o, n), i = !1, s = setTimeout(_r, t)) : s = null;
        })();
      };
    }, t.normilizeCSSValue = function (e, t) {
      switch (e) {case "font-weight":
          return "bold" === t ? 700 : t;}return t;
    }, t.css = function (e, o, n, i) {
      void 0 === i && (i = !1);var r = /^left|top|bottom|right|width|min|max|height|margin|padding|font-size/i;if (t.isPlainObject(o) || void 0 !== n) {
        var s = function s(e, o, n) {
          void 0 !== n && null !== n && r.test(o) && /^[\-+]?[0-9.]+$/.test("" + n) && (n = parseInt("" + n, 10) + "px"), void 0 !== n && t.css(e, o, void 0, !0) !== t.normilizeCSSValue(o, n) && (e.style[o] = n);
        };if (t.isPlainObject(o)) {
          var a = Object.keys(o),
              l = void 0;for (l = 0; a.length > l; l += 1) {
            s(e, t.camelCase(a[l]), o[a[l]]);
          }
        } else s(e, t.camelCase(o), n);return "";
      }var c = t.fromCamelCase(o),
          d = e.ownerDocument,
          u = !!d && (d.defaultView || d.parentWindow),
          p = e.style[o],
          f = void 0 !== p && "" !== p ? p : u && !i ? u.getComputedStyle(e).getPropertyValue(c) : "";return r.test(o) && /^[\-+]?[0-9.]+px$/.test("" + f) && (f = parseInt(f, 10)), t.normilizeCSSValue(o, f);
    }, t.asArray = function (e) {
      return Array.isArray(e) ? e : [e];
    }, t.sprintf = function () {
      for (var e = [], t = 0; arguments.length > t; t++) {
        e[t] = arguments[t];
      }var o = /%%|%(\d+\$)?([-+#0 ]*)(\*\d+\$|\*|\d+)?(\.(\*\d+\$|\*|\d+))?([scboxXuidfegEG])/g,
          n = e,
          i = 0,
          r = n[i++],
          s = function s(e, t, o, n) {
        var i = t > e.length ? Array(1 + t - e.length >>> 0).join(o) : "";return n ? e + i : i + e;
      },
          a = function a(e, t, o, n, i) {
        var r = n - e.length;return r > 0 && (e = o || !i ? s(e, n, " ", o) : e.slice(0, t.length) + s("", r, "0", !0) + e.slice(t.length)), e;
      },
          l = function l(e, t, o, n, i, r, _l) {
        var c = e >>> 0;o = o && c && { 2: "0b", 8: "0", 16: "0x" }[t] || "";var d = o + s(c.toString(t), r || 0, "0", !1);return a(d, o, n, i, _l);
      },
          c = function c(e, t, o, n, i) {
        return null != n && (e = e.slice(0, n)), a(e, "", t, o, i);
      };return r.replace(o, function (e, t, o, r, d, u, p) {
        if ("%%" == e) return "%";for (var f = !1, h = "", m = !1, v = !1, g = 0; o && o.length > g; g++) {
          switch (o.charAt(g)) {case " ":
              h = " ";break;case "+":
              h = "+";break;case "-":
              f = !0;break;case "0":
              m = !0;break;case "#":
              v = !0;}
        }if (r = r ? "*" === r ? +n[i++] : "*" === ("" + r)[0] ? +n[("" + r).slice(1, -1)] : +r : 0, 0 > r && (r = -r, f = !0), !isFinite(r)) throw Error("sprintf: (minimum-)width must be finite");u = u ? "*" === u ? +n[i++] : "*" === u[0] ? +n[u.slice(1, -1)] : +u : "fFeE".indexOf(p) > -1 ? 6 : "d" == p ? 0 : void 0;var _ = t ? n[t.slice(0, -1)] : n[i++];switch (p) {case "s":
            return c(_ + "", f, r, u, m);case "c":
            return c(String.fromCharCode(+_), f, r, u, m);case "b":
            return l(_, 2, v, f, r, u, m);case "o":
            return l(_, 8, v, f, r, u, m);case "x":
            return l(_, 16, v, f, r, u, m);case "X":
            return l(_, 16, v, f, r, u, m).toUpperCase();case "u":
            return l(_, 10, v, f, r, u, m);case "i":case "d":
            var b = parseInt("" + _, 10),
                y = 0 > b ? "-" : h;return _ = y + s(Math.abs(b) + "", u, "0", !1), a(_, y, f, r, m);case "e":case "E":case "f":case "F":case "g":case "G":
            var b = +_,
                y = 0 > b ? "-" : h,
                w = ["toExponential", "toFixed", "toPrecision"]["efg".indexOf(p.toLowerCase())],
                C = ["toString", "toUpperCase"]["eEfFgG".indexOf(p) % 2];return _ = y + Math.abs(b)[w](u), a(_, y, f, r, m)[C]();default:
            return e;}
      });
    }, t.val = function (e, t, o) {
      var n = e.querySelector(t);return n ? (o && (n.value = o), n.value) : "";
    }, t.defaultLanguage = function (e) {
      return "auto" === e || void 0 === e ? document.documentElement.lang || navigator.language && navigator.language.substr(0, 2) || !!navigator.browserLanguage && navigator.browserLanguage.substr(0, 2) || "en" : e;
    }, t.normalizeNode = function (e) {
      if (e) {
        if (e.nodeType === Node.TEXT_NODE && null !== e.nodeValue && e.parentNode) for (; e.nextSibling && e.nextSibling.nodeType === Node.TEXT_NODE;) {
          null !== e.nextSibling.nodeValue && (e.nodeValue += e.nextSibling.nodeValue), e.nodeValue = e.nodeValue.replace(n.INVISIBLE_SPACE_REG_EXP, ""), e.parentNode.removeChild(e.nextSibling);
        } else t.normalizeNode(e.firstChild);t.normalizeNode(e.nextSibling);
      }
    }, t.cleanFromWord = function (e) {
      -1 !== e.indexOf("<html ") && (e = e.substring(e.indexOf("<html "), e.length), e = e.substring(0, e.lastIndexOf("</html>") + 7));var t = "";try {
        var o = document.createElement("div");o.innerHTML = e;var n = [];o.firstChild && i.Dom.all(o, function (e) {
          switch (e.nodeType) {case Node.ELEMENT_NODE:
              "FONT" === e.nodeName ? i.Dom.unwrap(e) : [].slice.call(e.attributes).forEach(function (t) {
                -1 === ["src", "href", "rel", "content"].indexOf(t.name.toLowerCase()) && e.removeAttribute(t.name);
              });break;case Node.TEXT_NODE:
              break;default:
              n.push(e);}
        }), n.forEach(function (e) {
          return e.parentNode && e.parentNode.removeChild(e);
        }), t = o.innerHTML;
      } catch (e) {}return t && (e = t), e.replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, "").replace(/<!--[^>]*>/g, "");
    }, t.applyStyles = function (e) {
      if (-1 === e.indexOf("<html ")) return e;e = e.substring(e.indexOf("<html "), e.length), e = e.substring(0, e.lastIndexOf("</html>") + 7);var o = document.createElement("iframe");o.style.display = "none", document.body.appendChild(o);var n = "",
          i = [],
          r = [];try {
        var s = o.contentDocument || o.contentWindow.document;s.open(), s.write(e), s.close(), s.styleSheets.length && (r = s.styleSheets[s.styleSheets.length - 1].cssRules);for (var a = 0; r.length > a; a += 1) {
          !function (e) {
            if ("" === r[e].selectorText) return "continue";i = t.$$(r[e].selectorText, s.body), i.forEach(function (t) {
              t.style.cssText += r[e].style.cssText.replace(/mso-[a-z\-]+:[\s]*[^;]+;/g, "").replace(/border[a-z\-]*:[\s]*[^;]+;/g, "");
            });
          }(a);
        }n = s.firstChild ? s.body.innerHTML : "";
      } catch (e) {} finally {
        o.parentNode && o.parentNode.removeChild(o);
      }return n && (e = n), e.replace(/<(\/)?(html|colgroup|col|o:p)[^>]*>/g, "").replace(/<!--[^>]*>/g, "");
    }, t.inView = function (e) {
      var t = e.getBoundingClientRect(),
          o = t.top,
          n = t.height,
          i = e.parentNode;do {
        if (i) {
          if (t = i.getBoundingClientRect(), t.bottom >= o == 0) return !1;if (t.top >= o + n) return !1;i = i.parentNode;
        }
      } while (i && i != document.body);return o <= document.documentElement.clientHeight;
    }, t.scrollIntoView = function (e, o) {
      t.inView(e) || (o.clientHeight !== o.scrollHeight && (o.scrollTop = e.offsetTop), t.inView(e) || e.scrollIntoView());
    };
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = o(2),
        i = o(0),
        r = o(8),
        s = r.Widget.TabsWidget,
        a = r.Widget.ImageSelectorWidget,
        l = o(5),
        c = function () {
      function e() {
        this.ownerDocument = document, this.ownerWindow = window, this.zIndex = 0, this.readonly = !1, this.activeButtonsInReadOnly = ["source", "fullsize", "print", "about", "dots"], this.toolbarButtonSize = "middle", this.theme = "default", this.saveModeInCookie = !1, this.spellcheck = !0, this.editorCssClass = !1, this.triggerChangeEvent = !0, this.width = "auto", this.height = "auto", this.minHeight = 100, this.direction = "", this.language = "auto", this.debugLanguage = !1, this.i18n = "en", this.tabIndex = -1, this.toolbar = !0, this.enter = n.PARAGRAPH, this.defaultMode = n.MODE_WYSIWYG, this.useSplitMode = !1, this.colors = { greyscale: ["#000000", "#434343", "#666666", "#999999", "#B7B7B7", "#CCCCCC", "#D9D9D9", "#EFEFEF", "#F3F3F3", "#FFFFFF"], palette: ["#980000", "#FF0000", "#FF9900", "#FFFF00", "#00F0F0", "#00FFFF", "#4A86E8", "#0000FF", "#9900FF", "#FF00FF"], full: ["#E6B8AF", "#F4CCCC", "#FCE5CD", "#FFF2CC", "#D9EAD3", "#D0E0E3", "#C9DAF8", "#CFE2F3", "#D9D2E9", "#EAD1DC", "#DD7E6B", "#EA9999", "#F9CB9C", "#FFE599", "#B6D7A8", "#A2C4C9", "#A4C2F4", "#9FC5E8", "#B4A7D6", "#D5A6BD", "#CC4125", "#E06666", "#F6B26B", "#FFD966", "#93C47D", "#76A5AF", "#6D9EEB", "#6FA8DC", "#8E7CC3", "#C27BA0", "#A61C00", "#CC0000", "#E69138", "#F1C232", "#6AA84F", "#45818E", "#3C78D8", "#3D85C6", "#674EA7", "#A64D79", "#85200C", "#990000", "#B45F06", "#BF9000", "#38761D", "#134F5C", "#1155CC", "#0B5394", "#351C75", "#733554", "#5B0F00", "#660000", "#783F04", "#7F6000", "#274E13", "#0C343D", "#1C4587", "#073763", "#20124D", "#4C1130"] }, this.colorPickerDefaultTab = "background", this.imageDefaultWidth = 300, this.removeButtons = [], this.disablePlugins = [], this.extraButtons = [], this.sizeLG = 900, this.sizeMD = 700, this.sizeSM = 400, this.buttons = ["source", "|", "bold", "strikethrough", "underline", "italic", "|", "ul", "ol", "|", "outdent", "indent", "|", "font", "fontsize", "brush", "paragraph", "|", "image", "video", "table", "link", "|", "align", "undo", "redo", "|", "hr", "eraser", "copyformat", "|", "symbol", "fullsize", "print", "about"], this.buttonsMD = ["source", "|", "bold", "italic", "|", "ul", "ol", "|", "font", "fontsize", "brush", "paragraph", "|", "image", "table", "link", "|", "align", "|", "undo", "redo", "|", "hr", "eraser", "copyformat", "fullsize", "dots"], this.buttonsSM = ["source", "|", "bold", "italic", "|", "ul", "ol", "|", "fontsize", "brush", "paragraph", "|", "image", "table", "link", "|", "align", "|", "undo", "redo", "|", "eraser", "copyformat", "fullsize", "dots"], this.buttonsXS = ["bold", "image", "|", "brush", "paragraph", "|", "align", "|", "undo", "redo", "|", "eraser", "dots"], this.events = {}, this.textIcons = !1;
      }return e;
    }();t.Config = c, c.prototype.controls = { print: { exec: function exec(e) {
          var t = window.open("", "PRINT");t && (e.options.iframe ? (e.events.fire("generateDocumentStructure.iframe", t.document), t.document.body.innerHTML = e.getEditorValue()) : (t.document.write("<html><head><title></title></head><body>" + e.getEditorValue() + "</body></html>"), t.document.close()), t.focus(), t.print(), t.close());
        }, mode: n.MODE_SOURCE + n.MODE_WYSIWYG }, about: { exec: function exec(e) {
          var t = e.getInstance("Dialog");t.setTitle(e.i18n("About Jodit")), t.setContent('<div class="jodit_about">                    <div>' + e.i18n("Jodit Editor") + " v." + e.getVersion() + " " + e.i18n("Free Non-commercial Version") + '</div><div><a href="http://xdsoft.net/jodit/" target="_blank">http://xdsoft.net/jodit/</a></div><div><a href="http://xdsoft.net/jodit/doc/" target="_blank">' + e.i18n("Jodit User's Guide") + "</a> " + e.i18n("contains detailed help for using") + "</div><div>" + e.i18n("For information about the license, please go to our website:") + '</div><div><a href="http://xdsoft.net/jodit/license.html" target="_blank">http://xdsoft.net/jodit/license.html</a></div><div><a href="http://xdsoft.net/jodit/#download" target="_blank">' + e.i18n("Buy full version") + "</a></div><div>" + e.i18n("Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.") + "</div></div>"), t.open();
        }, tooltip: "About Jodit", mode: n.MODE_SOURCE + n.MODE_WYSIWYG }, hr: { command: "insertHorizontalRule", tags: ["hr"], tooltip: "Insert Horizontal Line" }, image: { popup: function popup(e, t, o, n) {
          var r = function r(t) {
            e.selection.insertNode(i.dom('<img src="' + t + '"/>', e.editorDocument));
          },
              s = null;return t && t.nodeType !== Node.TEXT_NODE && ("IMG" === t.tagName || i.$$("img", t).length) && (s = "IMG" === t.tagName ? t : i.$$("img", t)[0]), a(e, { filebrowser: function filebrowser(e) {
              if (e.files && e.files.length) {
                var t = void 0;for (t = 0; e.files.length > t; t += 1) {
                  r(e.baseurl + e.files[t]);
                }
              }n();
            }, upload: function upload(e) {
              var t;if (e.files && e.files.length) for (t = 0; e.files.length > t; t += 1) {
                r(e.baseurl + e.files[t]);
              }n();
            }, url: function url(t, o) {
              var r = s || i.dom('<img src=""/>', e.editorDocument);r.setAttribute("src", t), r.setAttribute("alt", o), s || e.selection.insertNode(r), n();
            } }, s, n);
        }, tags: ["img"], tooltip: "Insert Image" }, video: { popup: function popup(e) {
          var t = i.dom('<form class="jodit_form">\n                        <input required name="code" placeholder="http://" type="url"/>\n                        <button type="submit">' + e.i18n("Insert") + "</button>\n                        </form>", e.ownerDocument),
              o = i.dom('<form class="jodit_form">\n                        <textarea required name="code" placeholder="' + e.i18n("Embed code") + '"></textarea>\n                        <button type="submit">' + e.i18n("Insert") + "</button>\n                        </form>", e.ownerDocument),
              n = {},
              r = e.selection.save(),
              a = function a(t) {
            e.selection.restore(r), e.selection.insertHTML(t);
          };return n[l.ToolbarIcon.getIcon("link") + "&nbsp;" + e.i18n("Link")] = t, n[l.ToolbarIcon.getIcon("source") + "&nbsp;" + e.i18n("Code")] = o, o.addEventListener("submit", function (e) {
            return e.preventDefault(), i.trim(i.val(o, "textarea[name=code]")) ? (a(i.val(o, "textarea[name=code]")), !1) : (o.querySelector("textarea[name=code]").focus(), o.querySelector("textarea[name=code]").classList.add("jodit_error"), !1);
          }), t.addEventListener("submit", function (e) {
            return e.preventDefault(), i.isURL(i.val(t, "input[name=code]")) ? (a(i.convertMediaURLToVideoEmbed(i.val(t, "input[name=code]"))), !1) : (t.querySelector("input[name=code]").focus(), t.querySelector("input[name=code]").classList.add("jodit_error"), !1);
          }), s(e, n);
        }, tags: ["iframe"], tooltip: "Insert youtube/vimeo video" } };
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.INVISIBLE_SPACE = "\uFEFF", t.INVISIBLE_SPACE_REG_EXP = /[\uFEFF]/g, t.SPACE_REG_EXP = /[\s\n\t\r\uFEFF\u200b]+/g, t.SPACE_REG_EXP_START = /^[\s\n\t\r\uFEFF\u200b]+/g, t.SPACE_REG_EXP_END = /[\s\n\t\r\uFEFF\u200b]+$/g, t.IS_BLOCK = /^(PRE|DIV|P|LI|H[1-6]|BLOCKQUOTE|TD|TH|TABLE|BODY|HTML)$/i, t.KEY_BACKSPACE = 8, t.KEY_TAB = 9, t.KEY_ENTER = 13, t.KEY_ESC = 27, t.KEY_LEFT = 37, t.KEY_TOP = 38, t.KEY_RIGHT = 39, t.KEY_BOTTOM = 40, t.KEY_DELETE = 46, t.KEY_F = 70, t.KEY_R = 82, t.KEY_Y = 89, t.KEY_Z = 90, t.KEY_F3 = 114, t.NEARBY = 5, t.ACCURACY = 10, t.BR = "br", t.PARAGRAPH = "P", t.MODE_WYSIWYG = 1, t.MODE_SOURCE = 2, t.MODE_SPLIT = 3, t.TEXT_PLAIN = -1 != navigator.userAgent.indexOf("MSIE") || /rv:11.0/i.test(navigator.userAgent) ? "text" : "text/plain", t.TEXT_HTML = -1 != navigator.userAgent.indexOf("MSIE") || /rv:11.0/i.test(navigator.userAgent) ? "text" : "text/html", t.MARKER_CLASS = "jodit_selection_marker", t.EMULATE_DBLCLICK_TIMEOUT = 300, t.JODIT_SELECTED_CELL_MARKER = "data-jodit-selected-cell";
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = o(2),
        i = o(0);t.Dom = function () {
      function e() {}return e.unwrap = function (e) {
        var t = e.parentNode,
            o = e;if (t) {
          for (; o.firstChild;) {
            t.insertBefore(o.firstChild, o);
          }t.removeChild(o);
        }
      }, e.each = function (t, o) {
        var n = t.firstChild;if (n) for (; n;) {
          if (!1 === o.call(n, n) || !1 === e.each(n, o)) return !1;n = e.next(n, function (e) {
            return !!e;
          }, t);
        }return !0;
      }, e.create = function (e, t, o) {
        var n;return e = e.toLowerCase(), "text" === e ? n = o.createTextNode("string" == typeof t ? t : "") : (n = o.createElement(e), void 0 !== t && (n.innerHTML = t)), n;
      }, e.replace = function (t, o, n, r, s) {
        void 0 === n && (n = !1), void 0 === r && (r = !1);var a = "string" == typeof o ? e.create(o, "", s) : o;if (!r) for (; t.firstChild;) {
          a.appendChild(t.firstChild);
        }return n && i.each(t.attributes, function (e, t) {
          a.setAttribute(t.name, t.nodeValue);
        }), t.parentNode && t.parentNode.replaceChild(a, t), a;
      }, e.isCell = function (t, o) {
        return e.isNode(t, o) && /^(td|th)$/i.test(t.nodeName);
      }, e.isImage = function (t, o) {
        return e.isNode(t, o) && /^(img|svg|picture|canvas)$/i.test(t.nodeName);
      }, e.isBlock = function (e) {
        return !!e && "string" == typeof e.nodeName && n.IS_BLOCK.test(e.nodeName);
      }, e.isInlineBlock = function (e) {
        return !!e && e.nodeType === Node.ELEMENT_NODE && -1 !== ["inline", "inline-block"].indexOf("" + i.css(e, "display"));
      }, e.canSplitBlock = function (e, t) {
        return e && e instanceof t.HTMLElement && this.isBlock(e) && !/^(TD|TH|CAPTION|FORM)$/.test(e.nodeName) && void 0 !== e.style && !/^(fixed|absolute)/i.test(e.style.position);
      }, e.prev = function (t, o, n, i) {
        return void 0 === i && (i = !0), e.find(t, o, n, !1, "previousSibling", !!i && "lastChild");
      }, e.next = function (t, o, n, i) {
        return void 0 === i && (i = !0), e.find(t, o, n, void 0, void 0, i ? "firstChild" : "");
      }, e.find = function (t, o, n, i, r, s) {
        if (void 0 === i && (i = !1), void 0 === r && (r = "nextSibling"), void 0 === s && (s = "firstChild"), i && o(t)) return t;var a,
            l = t;do {
          if (a = l[r], o(a)) return a || !1;if (s && a && a[s]) {
            var c = e.find(a[s], o, a, !0, r, s);if (c) return c;
          }a || (a = l.parentNode), l = a;
        } while (l && l !== n);return !1;
      }, e.findWithCurrent = function (t, o, n, i, r) {
        void 0 === i && (i = "nextSibling"), void 0 === r && (r = "firstChild");var s = t;do {
          if (o(s)) return s || !1;if (r && s && s[r]) {
            var a = e.findWithCurrent(s[r], o, s, i, r);if (a) return a;
          }for (; s && !s[i] && s !== n;) {
            s = s.parentNode;
          }s && s[i] && s !== n && (s = s[i]);
        } while (s && s !== n);return !1;
      }, e.isEmptyTextNode = function (e) {
        return e && e.nodeType === Node.TEXT_NODE && (!e.nodeValue || 0 === e.nodeValue.replace(n.INVISIBLE_SPACE_REG_EXP, "").length);
      }, e.isEmpty = function (t) {
        return !t || (t.nodeType === Node.TEXT_NODE ? null === t.nodeValue || 0 === i.trim(t.nodeValue).length : e.each(t, function (e) {
          if (e && e.nodeType === Node.TEXT_NODE && null !== e.nodeValue && 0 !== i.trim(e.nodeValue).length || e && e.nodeType === Node.ELEMENT_NODE && e.nodeName.match(/^(img|table)$/i)) return !1;
        }));
      }, e.isNode = function (e, t) {
        return "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) ? e instanceof t.Node : "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && "number" == typeof e.nodeType && "string" == typeof e.nodeName;
      }, e.up = function (e, t, o) {
        var n = e;if (!e) return !1;do {
          if (t(n)) return n;if (n === o || !n.parentNode) break;n = n.parentNode;
        } while (n && n !== o);return !1;
      }, e.closest = function (t, o, n) {
        var i;return i = "function" == typeof o ? o : o instanceof RegExp ? function (e) {
          return o.test(e.nodeName);
        } : function (e) {
          return RegExp("^(" + o + ")$", "i").test(e.nodeName);
        }, e.up(t, i, n);
      }, e.after = function (e, t) {
        var o = e.parentNode;o && (o.lastChild === e ? o.appendChild(t) : o.insertBefore(t, e.nextSibling));
      }, e.moveContent = function (e, t, o) {
        void 0 === o && (o = !1);var i = e.ownerDocument.createDocumentFragment();[].slice.call(e.childNodes).forEach(function (e) {
          e.nodeType === Node.TEXT_NODE && e.nodeValue === n.INVISIBLE_SPACE || i.appendChild(e);
        }), o && t.firstChild ? t.insertBefore(i, t.firstChild) : t.appendChild(i);
      }, e.all = function (t, o, n) {
        void 0 === n && (n = !1);var i = t.childNodes ? Array.prototype.slice.call(t.childNodes) : [];if (o(t)) return t;n && (i = i.reverse()), i.forEach(function (t) {
          e.all(t, o, n);
        });
      }, e.wrap = function (t, o, n) {
        var i,
            r = t,
            s = t,
            a = n.selection.save(),
            l = !1;do {
          l = !1, (i = e.prev(r, function (e) {
            return !!e;
          }, n.editor, !1)) && !e.isBlock(i) && (l = !0, r = i);
        } while (l);do {
          l = !1, (i = e.next(s, function (e) {
            return !!e;
          }, n.editor, !1)) && !e.isBlock(i) && (l = !0, s = i);
        } while (l);var c = "string" == typeof o ? e.create(o, "", n.editorDocument) : o;r.parentNode && r.parentNode.insertBefore(c, r);for (var d = r; d && (d = r.nextSibling, c.appendChild(r), r !== s && d);) {
          r = d;
        }return n.selection.restore(a), c;
      }, e.findInline = function (t, o, n) {
        var i = t,
            r = null;do {
          if (!i) break;if ((r = o ? i.previousSibling : i.nextSibling) || !i.parentNode || i.parentNode === n || !e.isInlineBlock(i.parentNode)) break;i = i.parentNode;
        } while (!r);for (; r && e.isInlineBlock(r) && (o ? r.lastChild : r.firstChild);) {
          r = o ? r.lastChild : r.firstChild;
        }return r;
      }, e.contains = function (e, t) {
        for (; t.parentNode;) {
          if (t.parentNode === e) return !0;t = t.parentNode;
        }return !1;
      }, e.isOrContains = function (t, o) {
        return o && t && (t === o || e.contains(t, o));
      }, e;
    }();
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = o(6);t.Component = function () {
      function e(e) {
        e && e instanceof n.Jodit && (this.jodit = e, e.components && e.components.push(this));
      }return e.prototype.destruct = function () {}, e;
    }();
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }(),
        i = this && this.__assign || Object.assign || function (e) {
      for (var t, o = 1, n = arguments.length; n > o; o++) {
        t = arguments[o];for (var i in t) {
          Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        }
      }return e;
    };Object.defineProperty(t, "__esModule", { value: !0 });var r = o(4),
        s = o(0),
        a = o(2),
        l = o(3),
        c = function (e) {
      function t(t, o, n) {
        void 0 === o && (o = "li"), void 0 === n && (n = "jodit_toolbar_btn");var i = e.call(this, t) || this;return i.parentToolbar = null, i.container = i.jodit.ownerDocument.createElement(o), i.container.classList.add(n), i;
      }return n(t, e), t;
    }(r.Component),
        d = function (e) {
      function t(t, o, n, i) {
        void 0 === i && (i = "jodit_toolbar_popup");var r = e.call(this, t, "div", i) || this;return r.target = o, r.current = n, r.className = i, r.close = function (e) {
          e && l.Dom.isOrContains(r.container, e) || (r.jodit.events.off("closeAllPopups", r.close), r.doClose(), r.container.parentNode && r.container.parentNode.removeChild(r.container), r.jodit.selection && r.jodit.selection.removeMarkers());
        }, r.jodit.events.on(r.container, "mousedown touchstart", function (e) {
          e.stopPropagation();
        }), r;
      }return n(t, e), t.prototype.doOpen = function (e) {
        e && (this.container.innerHTML = '<span class="jodit_popup_triangle"></span>', this.container.appendChild(s.dom(e, this.jodit.ownerDocument)), this.container.style.display = "block", this.container.style.marginLeft = null);
      }, t.prototype.open = function (e, t) {
        this.jodit.events.fire("beforeOpenPopup closeAllPopups", this), this.jodit.events.on("closeAllPopups", this.close), this.container.classList.add(this.className + "-open"), this.doOpen(e), this.target.appendChild(this.container), void 0 !== t && this.container.classList.toggle("jodit_right", t), this.jodit.events.fire("afterOpenPopup", this.container);
      }, t.prototype.doClose = function () {}, t;
    }(c);t.ToolbarPopup = d;var u = function (e) {
      function t(t, o, n, i) {
        void 0 === i && (i = "jodit_toolbar_list");var r = e.call(this, t, o, n, i) || this;return r.target = o, r.current = n, r.className = i, r.defaultControl = { template: function template(e, t, o) {
            return r.jodit.i18n(o);
          } }, r;
      }return n(t, e), t.prototype.doClose = function () {
        this.toolbar && this.toolbar.destruct();
      }, t.prototype.doOpen = function (e) {
        var t = this;this.toolbar = new v(this.jodit), s.each(e.list, function (o, n) {
          var r;if (void 0 !== t.jodit.options.controls[n]) r = new p(t.jodit, i({ name: "" + n }, t.jodit.options.controls[n]), t.current);else if (void 0 !== t.jodit.options.controls[o] && "object" == (typeof n === "undefined" ? "undefined" : _typeof(n))) r = new p(t.jodit, i({ name: "" + o }, t.jodit.options.controls[o], n), t.current);else {
            r = new p(t.jodit, { name: "" + o, exec: e.exec, command: e.command, isActive: e.isActiveChild, isDisable: e.isDisableChild, args: [e.args && e.args[0] || o, e.args && e.args[1] || n] }, t.current);var s = e.template || t.defaultControl.template;r.textBox.innerHTML = s(t.jodit, o, n);
          }t.toolbar.appendChild(r);
        }), this.container.appendChild(this.toolbar.container), this.container.style.marginLeft = null, this.toolbar.checkActiveButtons();
      }, t;
    }(d);t.ToolbarList = u;var p = function (e) {
      function t(t, o, n) {
        var i = e.call(this, t) || this;i.__disabled = !1, i.__actived = !1, i.checkActiveStatus = function (e, t) {
          var o = 0,
              n = 0;return Object.keys(e).forEach(function (r) {
            var a = e[r];"function" == typeof a ? a(i.jodit, "" + s.css(t, r)) && (o += 1) : -1 !== a.indexOf("" + s.css(t, r)) && (o += 1), n += 1;
          }), n === o;
        }, i.canActionCallback = function (e) {
          i.isDisable() || (i.disable = !e);
        }, i.control = o, i.target = n;var r = i.jodit.ownerDocument.createElement("a");if (i.container.appendChild(r), i.createTooltip(o, r), i.textBox = i.jodit.ownerDocument.createElement("span"), r.appendChild(i.textBox), o.list && r) {
          var a = i.jodit.ownerDocument.createElement("span");a.classList.add("jodit_with_dropdownlist-trigger"), i.container.classList.add("jodit_with_dropdownlist"), r.appendChild(a);
        }var l = o.name.replace(/[^a-zA-Z0-9]/g, "_");return i.createIcon(o, l), i.container.classList.add("jodit_toolbar_btn-" + l), i.jodit.events.on(i.container, "mousedown touchend", function (e) {
          if (e.stopImmediatePropagation(), e.preventDefault(), i.disable) return !1;if (o.list) {
            var t = new u(i.jodit, i.container, i.target);t.open(o), i.jodit.events.fire("closeAllPopups hidePopup", t.container);
          } else if (void 0 !== o.exec && "function" == typeof o.exec) o.exec(i.jodit, i.target || i.jodit.selection.current(), o, e, i.container), i.jodit.setEditorValue(), i.parentToolbar && i.parentToolbar.checkActiveButtons(), i.jodit.events.fire("closeAllPopups hidePopup");else if (void 0 !== o.popup && "function" == typeof o.popup) {
            var n = new d(i.jodit, i.container, i.target);n.open(o.popup(i.jodit, i.target || i.jodit.selection.current(), o, n.close)), i.jodit.events.fire("closeAllPopups hidePopup", n.container);
          } else (o.command || o.name) && (i.jodit.execCommand(o.command || o.name, o.args && o.args[0] || !1, o.args && o.args[1] || null), i.jodit.events.fire("closeAllPopups hidePopup"));
        }), i.jodit.events.on(s.camelCase("can-" + l), i.canActionCallback), i;
      }return n(t, e), Object.defineProperty(t.prototype, "disable", { get: function get() {
          return this.__disabled;
        }, set: function set(e) {
          this.__disabled = e, this.container.classList.toggle("jodit_disabled", e), e ? this.container.hasAttribute("disabled") || this.container.setAttribute("disabled", "disabled") : this.container.hasAttribute("disabled") && this.container.removeAttribute("disabled");
        }, enumerable: !0, configurable: !0 }), Object.defineProperty(t.prototype, "active", { get: function get() {
          return this.__actived;
        }, set: function set(e) {
          this.__actived = e, this.container.classList.toggle("jodit_active", e);
        }, enumerable: !0, configurable: !0 }), t.prototype.isDisable = function () {
        var e = void 0 === this.control || void 0 === this.control.mode ? a.MODE_WYSIWYG : this.control.mode,
            t = e === a.MODE_SPLIT || e === this.jodit.getRealMode();return "function" == typeof this.control.isDisable && (t = t && !this.control.isDisable(this.jodit, this.control, this)), this.jodit.options.readonly && -1 === this.jodit.options.activeButtonsInReadOnly.indexOf(this.control.name) && (t = !1), !t;
      }, t.prototype.isActive = function () {
        var e = this;if ("function" == typeof this.control.isActive) return this.control.isActive(this.jodit, this.control, this);var t = this.jodit.selection.current();if (!t) return !1;var o, n, i;return !(!(this.control.tags || this.control.options && this.control.options.tags) || (o = this.control.tags || this.control.options && this.control.options.tags, n = t, !l.Dom.up(n, function (e) {
          if (e && -1 !== o.indexOf(e.nodeName.toLowerCase())) return !0;
        }, this.jodit.editor))) || !(!(this.control.css || this.control.options && this.control.options.css) || (i = this.control.css || this.control.options && this.control.options.css, n = t, !l.Dom.up(n, function (t) {
          if (t && t.nodeType !== Node.TEXT_NODE) return e.checkActiveStatus(i, t);
        }, this.jodit.editor)));
      }, t.prototype.createTooltip = function (e, t) {
        e.tooltip && t.setAttribute("title", this.jodit.i18n(e.tooltip) + (e.hotkeys ? "<br>" + s.asArray(e.hotkeys).join(" ") : ""));
      }, t.prototype.createIcon = function (e, t) {
        if (this.jodit.options.textIcons) this.textBox.innerHTML = e.name;else if (this.control.iconURL) this.textBox.style.backgroundImage = "url(" + e.iconURL + ")";else if (m.exists(e.icon || e.name)) {
          var o = s.dom(m.getIcon(e.icon || e.name, "empty"), this.jodit.ownerDocument);o.classList.add("jodit_icon", "jodit_icon_" + t), this.textBox.appendChild(o);
        }
      }, t.prototype.destruct = function () {
        var e = this.control.name.replace(/[^a-zA-Z0-9]/g, "_");this.jodit.events.off(this.container), this.jodit.events.off(s.camelCase("can-" + e), this.canActionCallback);
      }, t;
    }(c);t.ToolbarButton = p;var f = function (e) {
      function t(t) {
        var o = e.call(this, t) || this;return o.container.classList.add("jodit_toolbar_btn-break"), o;
      }return n(t, e), t;
    }(c);t.ToolbarBreak = f;var h = function (e) {
      function t(t) {
        var o = e.call(this, t) || this;return o.container.classList.add("jodit_toolbar_btn-separator"), o;
      }return n(t, e), t;
    }(c);t.ToolbarSeparator = h;var m = function () {
      function e() {}return e.exists = function (t) {
        return void 0 !== e.icons[t];
      }, e.getIcon = function (t, o) {
        return void 0 === o && (o = "<span></span>"), void 0 !== e.icons[t] ? e.icons[t] : o;
      }, e.icons = {}, e;
    }();t.ToolbarIcon = m;var v = function (e) {
      function t(t) {
        var o = e.call(this, t, "ul", "jodit_toolbar") || this;return o.__buttons = [], o.__getControlType = function (e) {
          var t;return "string" != typeof e ? (t = i({ name: "empty" }, e), void 0 !== o.jodit.options.controls[t.name] && (t = i({}, o.jodit.options.controls[t.name], t))) : t = void 0 !== o.jodit.options.controls[e] ? i({ name: e }, o.jodit.options.controls[e]) : { name: e, command: e, tooltip: e }, t;
        }, o.checkActiveButtons = s.debounce(function () {
          o.__buttons.filter(function (e) {
            return e instanceof p;
          }).forEach(function (e) {
            e.disable = e.isDisable(), e.disable || (e.active = e.isActive()), "function" == typeof e.control.getLabel && e.control.getLabel(o.jodit, e.control, e);
          }), o.jodit.events.fire("updateToolbar");
        }, o.jodit.options.observer.timeout, !0), o.closeAll = function () {
          o.jodit.events.fire("closeAllPopups");
        }, o.afterOpen = function (e) {
          var t = s.offset(o.jodit.container, o.jodit, !0),
              n = s.offset(e, o.jodit, !0),
              i = s.css(e, "marginLeft"),
              r = 0;if (n.left + n.width > t.left + t.width && (r = -(n.left + n.width - (t.left + t.width)), s.css(e, { marginLeft: r + i }), n = s.offset(e, o.jodit, !0)), t.left > n.left && (n.left + n.width > t.left + t.width ? s.css(e, { width: t.width }) : (r = t.left - n.left, s.css(e, { marginLeft: r + i }))), r) {
            var a = e.querySelector(".jodit_popup_triangle");a && (a.style.marginLeft = -r + "px");
          }
        }, o.initEvents = function () {
          o.jodit.events.on(o.jodit.ownerWindow, "mousedown touchstart", o.closeAll).on("afterOpenPopup", o.afterOpen).on("mousedown mouseup keydown change afterSetMode focus afterInit readonly", o.checkActiveButtons);
        }, o.initEvents(), o;
      }return n(t, e), t.prototype.appendChild = function (e) {
        this.__buttons.push(e), e.parentToolbar = this, this.container.appendChild(e.container);
      }, t.prototype.removeChild = function (e) {
        var t = this.__buttons.indexOf(e);-1 !== t && (this.__buttons.splice(t, 1), e.container.parentNode === this.container && this.container.removeChild(e.container)), e.parentToolbar = null;
      }, t.prototype.build = function (e, t, o) {
        var n = this,
            i = !1;this.clear(), ("string" == typeof e ? e.split(/[,\s]+/) : e).map(this.__getControlType).forEach(function (e) {
          var t = null;if (-1 === n.jodit.options.removeButtons.indexOf(e.name)) {
            switch (e.name) {case "\n":
                t = new f(n.jodit);break;case "|":
                i || (i = !0, t = new h(n.jodit));break;default:
                i = !1, t = new p(n.jodit, e, o);}t && n.appendChild(t);
          }
        }), this.container.parentNode !== t && t.appendChild(this.container), this.checkActiveButtons();
      }, t.prototype.clear = function () {
        var e = this;this.__buttons.slice().forEach(function (t) {
          e.removeChild(t), t.destruct();
        }), this.__buttons.length = 0;
      }, t.prototype.destruct = function () {
        e.prototype.destruct.call(this), this.jodit.events.off(this.jodit.ownerWindow, "mousedown touchstart", this.closeAll).off("afterOpenPopup", this.afterOpen).off("mousedown mouseup keydown change afterSetMode focus afterInit readonly", this.checkActiveButtons), this.clear();
      }, t;
    }(c);t.ToolbarCollection = v;
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(4),
        r = o(13),
        s = o(10),
        a = o(11),
        l = o(3),
        c = o(12),
        d = o(2),
        u = o(0),
        p = o(0),
        f = o(5);t.Jodit = function (e) {
      function t(o, n) {
        var i = e.call(this) || this;i.version = "3.1.28", i.components = [], i.__modulesInstances = {}, i.__plugins = {}, i.__defaultStyleDisplayKey = "data-jodit-default-style-display", i.commands = {}, i.__whoLocked = "", i.isLocked = function () {
          return "" !== i.__whoLocked;
        }, i.isLockedNotBy = function (e) {
          return i.isLocked() && i.__whoLocked !== e;
        }, i.mode = d.MODE_WYSIWYG, i.getVersion = function () {
          return i.version;
        }, i.buffer = {}, i.events = new c.EventsNative();var s = function s() {};if (s.prototype = t.defaultOptions, i.options = new s(), void 0 !== n && "object" == (typeof n === "undefined" ? "undefined" : _typeof(n)) && Object.keys(n).forEach(function (e) {
          i.options[e] = "object" != _typeof(t.defaultOptions[e]) || Array.isArray(t.defaultOptions[e]) ? n[e] : u.extend(!0, {}, t.defaultOptions[e], n[e]);
        }), i.editorDocument = i.options.ownerDocument, i.editorWindow = i.options.ownerWindow, i.ownerDocument = i.options.ownerDocument, i.ownerWindow = i.options.ownerWindow, "string" == typeof o) try {
          i.element = i.ownerDocument.querySelector(o);
        } catch (e) {
          throw Error('String "' + o + '" should be valid HTML selector');
        } else i.element = o;if (!i.element || "object" != _typeof(i.element) || i.element.nodeType !== Node.ELEMENT_NODE || !i.element.cloneNode) throw Error('Element "' + o + '" should be string or HTMLElement instance');i.selection = new r.Select(i), i.uploader = new a.Uploader(i), i.container = u.dom('<div class="jodit_container" />', i.ownerDocument), i.container.classList.add("jodit_" + (i.options.theme || "default") + "_theme"), i.options.zIndex && (i.container.style.zIndex = "" + parseInt("" + i.options.zIndex, 10)), i.workplace = u.dom('<div class="jodit_workplace" />', i.ownerDocument), i.progress_bar = u.dom('<div class="jodit_progress_bar"><div></div></div>', i.ownerDocument), i.toolbar = new f.ToolbarCollection(i), i.toolbar.build(i.options.buttons.concat(i.options.extraButtons), i.container), i.container.classList.add("jodit_toolbar_size-" + (-1 !== ["middle", "large", "small"].indexOf(i.options.toolbarButtonSize.toLowerCase()) ? i.options.toolbarButtonSize.toLowerCase() : "middle")), i.options.textIcons && i.container.classList.add("jodit_text_icons"), i.events.on(i.ownerWindow, "resize", function () {
          i.events && i.events.fire("resize");
        }), i.container.appendChild(i.workplace), i.workplace.appendChild(i.progress_bar), i.element.parentNode && i.element.parentNode.insertBefore(i.container, i.element), i.helper = p, i.options.events && u.each(i.options.events, function (e, t) {
          i.events.on(e, t);
        }), i.id = i.element.getAttribute("id") || "" + new Date().getTime(), i.initPlugines(), i.__createEditor(), i.setElementValue(), t.instances[i.id] = i;try {
          i.editorDocument.execCommand("enableObjectResizing", !1, !1), i.editorDocument.execCommand("enableInlineTableEditing", !1, !1);
        } catch (e) {}return i.setMode(i.options.defaultMode), i.options.readonly && i.setReadOnly(!0), i.events.fire("afterInit", i), i;
      }return n(t, e), t.prototype.getInstance = function (e, o) {
        if (void 0 === t.modules[e]) throw Error("Need real module name");return void 0 === this.__modulesInstances[e] && (this.__modulesInstances[e] = new t.modules[e](this, o)), this.__modulesInstances[e];
      }, t.prototype.initPlugines = function () {
        var e = this,
            o = Array.isArray(this.options.disablePlugins) ? this.options.disablePlugins.map(function (e) {
          return e.toLowerCase();
        }) : this.options.disablePlugins.toLowerCase().split(/[\s,]+/);Object.keys(t.plugins).forEach(function (n) {
          -1 === o.indexOf(n.toLowerCase()) && (e.__plugins[n] = new t.plugins[n](e));
        });
      }, t.prototype.__createEditor = function () {
        var e = this;!1 !== this.events.fire("createEditor") && (this.editor = u.dom('<div class="jodit_wysiwyg" contenteditable aria-disabled="false" tabindex="' + this.options.tabIndex + '"></div>', this.ownerDocument), this.workplace.appendChild(this.ownerDocument.createTextNode("\n")), this.workplace.appendChild(this.editor), this.workplace.appendChild(this.ownerDocument.createTextNode("\n"))), this.options.editorCssClass && this.editor.classList.add(this.options.editorCssClass), this.events.on(this.editor, "keydown keyup keypress mousedown mouseup mousepress paste resize touchstart touchend focus blur", function (t) {
          if (!e.options.readonly && e.events && e.events.fire) {
            if (!1 === e.events.fire(t.type, t)) return !1;e.setEditorValue();
          }
        }), this.options.spellcheck && this.editor.setAttribute("spellcheck", "true"), this.options.direction && (this.editor.style.direction = "rtl" === this.options.direction.toLowerCase() ? "rtl" : "ltr"), this.element.style.display && this.element.setAttribute(this.__defaultStyleDisplayKey, this.element.style.display), this.element.style.display = "none", this.options.triggerChangeEvent && this.events.on("change", u.debounce(function () {
          e.events.fire(e.element, "change");
        }, this.options.observer.timeout));
      }, t.prototype.destruct = function () {
        var e = this;!1 !== this.events.fire("beforeDestruct") && this.editor && (this.element.hasAttribute(this.__defaultStyleDisplayKey) ? (this.element.style.display = this.element.getAttribute(this.__defaultStyleDisplayKey), this.element.removeAttribute(this.__defaultStyleDisplayKey)) : this.element.style.display = "", this.element.hasAttribute("style") && !this.element.getAttribute("style") && this.element.removeAttribute("style"), Object.keys(this.__plugins).forEach(function (t) {
          void 0 !== e.__plugins && void 0 !== e.__plugins[t] && void 0 !== e.__plugins[t].destruct && "function" == typeof e.__plugins[t].destruct && e.__plugins[t].destruct(), delete e.__plugins[t];
        }), this.components.forEach(function (e) {
          void 0 !== e.destruct && "function" == typeof e.destruct && e.destruct();
        }), delete this.selection, this.events.off(this.events), this.events.off(this.ownerWindow), this.events.off(this.element), this.events.off(this.editor), delete this.events, this.container.parentNode && this.container.parentNode.removeChild(this.container), delete this.container, delete this.editor, delete this.workplace, delete t.instances[this.id]);
      }, t.prototype.getElementValue = function () {
        return void 0 !== this.element.value ? this.element.value : this.element.innerHTML;
      }, t.prototype.getEditorValue = function () {
        var e;if (void 0 !== (e = this.events.fire("beforeGetValueFromEditor"))) return e;"<br>" === (e = this.editor ? this.editor.innerHTML.replace(d.INVISIBLE_SPACE_REG_EXP, "") : this.getElementValue()) && (e = "");var t = { value: e };return this.events.fire("afterGetValueFromEditor", t), t.value;
      }, t.prototype.setElementValue = function (e) {
        if ("string" != typeof e && void 0 !== e) throw Error("value must be string");void 0 !== e ? void 0 !== this.element.value ? this.element.value = e : this.element.innerHTML = e : e = this.getElementValue(), e !== this.getEditorValue() && this.setEditorValue(e);
      }, t.prototype.setEditorValue = function (e) {
        if (this.editor) {
          if ("string" != typeof e && void 0 !== e) throw Error("value must be string");void 0 !== e && this.editor.innerHTML !== e && (this.editor.innerHTML = e);var t = this.getElementValue(),
              o = this.getEditorValue();t !== o && (this.setElementValue(o), this.events.fire("change", t, o));
        }
      }, t.prototype.execCustomCommands = function (e, t, o) {
        var n = this;if (void 0 === t && (t = !1), void 0 === o && (o = null), e = e.toLowerCase(), void 0 !== this.commands[e]) {
          var i = void 0;return this.commands[e].forEach(function (r) {
            var s;s = "function" == typeof r ? r : r.exec;var a = s.call(n, e, t, o);void 0 !== a && (i = a);
          }), i;
        }
      }, t.prototype.registerCommand = function (e, t) {
        var o = this,
            n = e.toLowerCase();if (void 0 === this.commands[n] && (this.commands[n] = []), this.commands[n].push(t), "function" != typeof t) {
          var i = this.options.commandToHotkeys[n] || this.options.commandToHotkeys[e] || t.hotkeys;i && this.events.off(u.asArray(i).map(function (e) {
            return e + ".hotkey";
          }).join(" ")).on(u.asArray(i).map(function (e) {
            return e + ".hotkey";
          }).join(" "), function () {
            return o.execCommand(n);
          });
        }
      }, t.prototype.execCommand = function (e, t, o) {
        if (void 0 === t && (t = !1), void 0 === o && (o = null), !this.options.readonly) {
          var n;if (e = e.toLowerCase(), n = this.events.fire("beforeCommand", e, t, o), !1 !== n && (n = this.execCustomCommands(e, t, o)), !1 !== n) switch (this.selection.focus(), e) {case "selectall":
              this.selection.select(this.editor, !0);break;default:
              try {
                n = this.editorDocument.execCommand(e, t, o);
              } catch (e) {}}return this.events.fire("afterCommand", e, t, o), this.setEditorValue(), n;
        }
      }, t.prototype.lock = function (e) {
        this.__whoLocked = e, this.editor.classList.add("jodit_disabled");
      }, t.prototype.unlock = function () {
        this.__whoLocked = "", this.editor.classList.remove("jodit_disabled");
      }, t.prototype.getMode = function () {
        return this.mode;
      }, t.prototype.getRealMode = function () {
        return this.getMode() !== d.MODE_SPLIT ? this.getMode() : l.Dom.isOrContains(this.editor, this.ownerDocument.activeElement) || l.Dom.isOrContains(this.toolbar.container, this.ownerDocument.activeElement) ? d.MODE_WYSIWYG : d.MODE_SOURCE;
      }, t.prototype.setMode = function (e) {
        var t = this,
            o = { mode: e },
            n = ["jodit_wysiwyg_mode", "jodit_source_mode", "jodit_split_mode"];!1 !== this.events.fire("beforeSetMode", o) && (this.mode = u.inArray(o.mode, [d.MODE_SOURCE, d.MODE_WYSIWYG, d.MODE_SPLIT]) ? o.mode : d.MODE_WYSIWYG, this.options.saveModeInCookie && s.Cookie.set("jodit_default_mode", this.mode, 31), n.forEach(function (e) {
          t.container.classList.remove(e);
        }), this.container.classList.add(n[this.mode - 1]), this.events.fire("afterSetMode"));
      }, t.prototype.toggleMode = function () {
        var e = this.getMode();u.inArray(e + 1, [d.MODE_SOURCE, d.MODE_WYSIWYG, this.options.useSplitMode ? d.MODE_SPLIT : 9]) ? e += 1 : e = d.MODE_WYSIWYG, this.setMode(e);
      }, t.prototype.i18n = function (e) {
        for (var o = this, n = [], i = 1; arguments.length > i; i++) {
          n[i - 1] = arguments[i];
        }if (void 0 !== this.options && this.options.debugLanguage) return "{" + e + "}";var r;return r = void 0 !== this.options && void 0 !== t.lang[u.defaultLanguage(this.options.language)] ? t.lang[u.defaultLanguage(this.options.language)] : void 0 !== t.lang[u.defaultLanguage(t.defaultOptions.language)] ? t.lang[u.defaultLanguage(t.defaultOptions.language)] : t.lang.en, function (e) {
          return u.sprintf.apply(o, [e].concat(n));
        }(void 0 !== this.options && void 0 !== this.options.i18n[u.defaultLanguage(this.options.language)] && this.options.i18n[u.defaultLanguage(this.options.language)][e] ? this.options.i18n[u.defaultLanguage(this.options.language)][e] : "string" == typeof r[e] && r[e] ? r[e] : "string" == typeof t.lang.en[e] && t.lang.en[e] ? t.lang.en[e] : e);
      }, t.prototype.setReadOnly = function (e) {
        this.options.readonly = e, e ? this.editor && this.editor.removeAttribute("contenteditable") : this.editor && this.editor.setAttribute("contenteditable", "true"), this.events && this.events.fire("readonly", e);
      }, t.prototype.getReadOnly = function () {
        return this.options.readonly;
      }, t.plugins = {}, t.modules = {}, t.instances = {}, t.lang = {}, t;
    }(i.Component);
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }(),
        i = this && this.__assign || Object.assign || function (e) {
      for (var t, o = 1, n = arguments.length; n > o; o++) {
        t = arguments[o];for (var i in t) {
          Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        }
      }return e;
    };Object.defineProperty(t, "__esModule", { value: !0 });var r = o(6),
        s = o(4),
        a = o(1),
        l = o(0),
        c = o(5),
        d = o(2),
        u = o(12);a.Config.prototype.dialog = { zIndex: 100002, resizable: !0, draggable: !0, fullsize: !1, fullsizeButton: !1 };var p = function (e) {
      function t(t, o) {
        void 0 === o && (o = {});var n = e.call(this, t) || this;n.events = new u.EventsNative(), n.lockSelect = function () {
          n.dialogbox.classList.add("jodit_dialog_box-moved");
        }, n.unlockSelect = function () {
          n.dialogbox.classList.remove("jodit_dialog_box-moved");
        }, n.destinition = document.body, n.document = document, n.window = window, n.destroyAfterClose = !1, n.moved = !1, n.iSetMaximization = !1, n.resizeble = !1, n.draggable = !1, n.startX = 0, n.startY = 0, n.startPoint = { x: 0, y: 0, w: 0, h: 0 }, n.__isDestructed = !1, n.close = function (e) {
          n.__isDestructed || (e && (e.stopImmediatePropagation(), e.preventDefault()), n.jodit && n.jodit.events && n.jodit.events.fire(n, "beforeClose"), n.dialogbox.classList && n.dialogbox.classList.remove("active"), n.iSetMaximization && n.maximization(!1), n.destroyAfterClose && n.destruct(), n.jodit && n.jodit.events.fire(n, "afterClose"));
        }, t && t instanceof r.Jodit && (n.window = t.ownerWindow, n.document = t.ownerDocument, t.events.on("beforeDestruct", function () {
          n.destruct();
        }));var s = n;s.options = t && t.options ? t.options.dialog : a.Config.prototype.dialog, s.options = i({}, s.options, o), s.dialogbox = l.dom('<div style="z-index:' + s.options.zIndex + '" class="jodit jodit_dialog_box"><div class="jodit_dialog_overlay"></div><div class="jodit_dialog"><div class="jodit_dialog_header non-selected"><h4></h4><a href="javascript:void(0)" title="Close" class="jodit_close">' + (r.Jodit.modules.Toolbar ? r.Jodit.modules.ToolbarIcon.getIcon("cancel") : "&times;") + '</a></div><div class="jodit_dialog_content"></div><div class="jodit_dialog_footer"></div>' + (s.options.resizable ? '<div class="jodit_dialog_resizer"></div>' : "") + "</div></div>", n.document), t && t instanceof r.Jodit && s.dialogbox.setAttribute("data-editor_id", t.id), Object.defineProperty(s.dialogbox, "__jodit_dialog", { value: s }), s.dialog = s.dialogbox.querySelector(".jodit_dialog"), s.resizer = s.dialogbox.querySelector(".jodit_dialog_resizer"), s.jodit && s.jodit.options && s.jodit.options.textIcons && s.dialogbox.classList.add("jodit_text_icons"), s.dialogbox_header = s.dialogbox.querySelector(".jodit_dialog_header>h4"), s.dialogbox_content = s.dialogbox.querySelector(".jodit_dialog_content"), s.dialogbox_footer = s.dialogbox.querySelector(".jodit_dialog_footer"), s.dialogbox_close = s.dialogbox.querySelector(".jodit_dialog_header>a.jodit_close"), s.dialogbox_fullsize = l.dom('<a href="javascript:void(0)" class="jodit_dialog_header_fullsize">' + (r.Jodit.modules.ToolbarIcon.getIcon ? r.Jodit.modules.ToolbarIcon.getIcon(o.fullsize ? "fullsize" : "shrink") : "") + "</a>", n.document), s.destinition.appendChild(s.dialogbox), s.dialogbox.addEventListener("close_dialog", s.close), s.dialogbox_close.addEventListener("mousedown", s.close), s.dialogbox_fullsize.addEventListener("click", function () {
          var e = s.maximization();r.Jodit.modules.Toolbar && (s.dialogbox_fullsize.innerHTML = r.Jodit.modules.ToolbarIcon.getIcon(e ? "shrink" : "fullsize"));
        }), s.events.on(n.window, "mousemove", s.onMouseMove.bind(s)).on(n.window, "mouseup", s.onMouseUp.bind(s)).on(n.window, "keydown", s.onKeyDown.bind(s)).on(n.window, "resize", s.onResize.bind(s));var c = s.dialogbox.querySelector(".jodit_dialog_header");return c && c.addEventListener("mousedown", s.onHeaderMouseDown.bind(s)), s.options.resizable && s.resizer.addEventListener("mousedown", s.onResizerMouseDown.bind(s)), n;
      }return n(t, e), t.prototype.setSize = function (e, t) {
        e && l.css(this.dialog, "width", e), t && l.css(this.dialog, "height", t);
      }, t.prototype.setPosition = function (e, t) {
        var o = this.window.innerWidth,
            n = this.window.innerHeight,
            i = o / 2 - this.dialog.offsetWidth / 2,
            r = n / 2 - this.dialog.offsetHeight / 2;void 0 !== e && void 0 !== t && (this.offsetX = e, this.offsetY = t, this.moved = Math.abs(e - i) > 100 || Math.abs(t - r) > 100), this.dialog.style.left = (e || i) + "px", this.dialog.style.top = (t || r) + "px";
      }, t.prototype.setElements = function (e, t) {
        var o = this,
            n = [];l.asArray(t).forEach(function (t) {
          var i = l.dom(t, o.document);n.push(i), i.parentNode !== e && e.appendChild(i);
        }), [].slice.call(e.childNodes).forEach(function (t) {
          -1 === n.indexOf(t) && e.removeChild(t);
        });
      }, t.prototype.setTitle = function (e) {
        this.setElements(this.dialogbox_header, e);
      }, t.prototype.setContent = function (e) {
        this.setElements(this.dialogbox_content, e);
      }, t.prototype.setFooter = function (e) {
        this.setElements(this.dialogbox_footer, e), this.dialog.classList.toggle("with_footer", !!e);
      }, t.prototype.getMaxZIndexDialog = function () {
        var e,
            t,
            o = 0,
            n = this;return l.$$(".jodit_dialog_box", this.destinition).forEach(function (i) {
          e = i.__jodit_dialog, t = parseInt(l.css(i, "zIndex"), 10), e.isOpened() && !isNaN(t) && t > o && (n = e, o = t);
        }), n;
      }, t.prototype.setMaxZIndex = function () {
        var e = 0,
            t = 0;l.$$(".jodit_dialog_box", this.destinition).forEach(function (o) {
          t = parseInt(l.css(o, "zIndex"), 10), e = Math.max(isNaN(t) ? 0 : t, e);
        }), this.dialogbox.style.zIndex = "" + (e + 1);
      }, t.prototype.maximization = function (e) {
        return "boolean" != typeof e && (e = !this.dialogbox.classList.contains("jodit_dialog_box-fullsize")), this.dialogbox.classList.toggle("jodit_dialog_box-fullsize", e), [this.destinition, this.destinition.parentNode].forEach(function (t) {
          t && t.classList && t.classList.toggle("jodit_fullsize_box", e);
        }), this.iSetMaximization = e, e;
      }, t.prototype.open = function (e, t, o, n) {
        this.jodit && this.jodit.events && !1 === this.jodit.events.fire(this, "beforeOpen") || (this.destroyAfterClose = !0 === o, this.options.fullsizeButton && this.dialogbox_close.parentNode && this.dialogbox_close.parentNode.appendChild(this.dialogbox_fullsize), void 0 !== t && this.setTitle(t), e && this.setContent(e), this.dialogbox.classList.add("active"), n && this.dialogbox.classList.add("jodit_modal"), this.setPosition(this.offsetX, this.offsetY), this.setMaxZIndex(), this.options.fullsize && this.maximization(!0), this.jodit && this.jodit.events && this.jodit.events.fire(this, "afterOpen"));
      }, t.prototype.isOpened = function () {
        return !this.__isDestructed && this.dialogbox.classList.contains("active");
      }, t.prototype.onMouseUp = function () {
        (this.draggable || this.resizeble) && (this.draggable = !1, this.resizeble = !1, this.unlockSelect(), this.jodit && this.jodit.events && this.jodit.events.fire(this, "endResize endMove"));
      }, t.prototype.onHeaderMouseDown = function (e) {
        this.options.draggable && (this.draggable = !0, this.startX = e.clientX, this.startY = e.clientY, this.startPoint.x = l.css(this.dialog, "left"), this.startPoint.y = l.css(this.dialog, "top"), this.setMaxZIndex(), e.preventDefault(), this.lockSelect(), this.jodit && this.jodit.events && this.jodit.events.fire(this, "startMove"));
      }, t.prototype.onMouseMove = function (e) {
        this.draggable && this.options.draggable && (this.setPosition(this.startPoint.x + e.clientX - this.startX, this.startPoint.y + e.clientY - this.startY), this.jodit && this.jodit.events && this.jodit.events.fire(this, "move", e.clientX - this.startX, e.clientY - this.startY), e.stopImmediatePropagation(), e.preventDefault()), this.resizeble && this.options.resizable && (this.setSize(this.startPoint.w + e.clientX - this.startX, this.startPoint.h + e.clientY - this.startY), this.jodit && this.jodit.events && this.jodit.events.fire(this, "resizeDialog", e.clientX - this.startX, e.clientY - this.startY), e.stopImmediatePropagation(), e.preventDefault());
      }, t.prototype.onKeyDown = function (e) {
        if (this.isOpened() && e.which === d.KEY_ESC) {
          var t = this.getMaxZIndexDialog();t ? t.close() : this.close(), e.stopImmediatePropagation();
        }
      }, t.prototype.onResize = function () {
        !this.options.resizable || this.moved || !this.isOpened() || this.offsetX || this.offsetY || this.setPosition();
      }, t.prototype.destruct = function () {
        this.dialogbox && this.dialogbox.parentNode && this.dialogbox.parentNode.removeChild(this.dialogbox), delete this.dialogbox, this.events.destruct(), this.__isDestructed = !0;
      }, t.prototype.onResizerMouseDown = function (e) {
        this.resizeble = !0, this.startX = e.clientX, this.startY = e.clientY, this.startPoint.w = this.dialog.offsetWidth, this.startPoint.h = this.dialog.offsetHeight, this.lockSelect(), this.jodit.events && this.jodit.events.fire(this, "startResize");
      }, t;
    }(s.Component);t.Dialog = p, t.Alert = function (e, t, o, n) {
      void 0 === n && (n = "jodit_alert"), "function" == typeof t && (o = t, t = void 0);var i = new p(),
          s = l.dom('<div class="' + n + '"></div>', i.document),
          a = l.dom('<a href="javascript:void(0)" style="float:right;" class="jodit_button">' + c.ToolbarIcon.getIcon("cancel") + "<span>" + r.Jodit.prototype.i18n("Ok") + "</span></a>", i.document);return s.appendChild(l.dom(e, i.document)), a.addEventListener("click", function () {
        o && "function" == typeof o && !1 === o(i) || i.close();
      }), i.setFooter([a]), i.open(s, t || "&nbsp;", !0, !0), a.focus(), i;
    }, r.Jodit.Alert = t.Alert, t.Promt = function (e, t, o, n) {
      var i = new p(),
          s = l.dom('<a href="javascript:void(0)" style="float:right;" class="jodit_button">' + c.ToolbarIcon.getIcon("cancel") + "<span>" + r.Jodit.prototype.i18n("Cancel") + "</span></a>", i.document),
          a = l.dom('<a href="javascript:void(0)" style="float:left;" class="jodit_button">' + c.ToolbarIcon.getIcon("check") + "<span>" + r.Jodit.prototype.i18n("Ok") + "</span></a>", i.document),
          d = l.dom('<form class="jodit_promt"></form>', i.document),
          u = l.dom("<input autofocus/>", i.document),
          f = l.dom("<label></label>", i.document);"function" == typeof t && (o = t, t = void 0), n && u.setAttribute("placeholder", n), f.appendChild(l.dom(e, i.document)), d.appendChild(f), d.appendChild(u), s.addEventListener("click", i.close, !1);var h = function h() {
        o && "function" == typeof o && !1 === o(u.value) || i.close();
      };return a.addEventListener("click", h), d.addEventListener("submit", function () {
        return h(), !1;
      }), i.setFooter([a, s]), i.open(d, t || "&nbsp;", !0, !0), u.focus(), i;
    }, r.Jodit.Promt = t.Promt, t.Confirm = function (e, t, o) {
      var n = new p(),
          i = l.dom('<form class="jodit_promt"></form>', n.document),
          s = l.dom("<label></label>", n.document);"function" == typeof t && (o = t, t = void 0), s.appendChild(l.dom(e, n.document)), i.appendChild(s);var a = l.dom('<a href="javascript:void(0)" style="float:right;" class="jodit_button">' + c.ToolbarIcon.getIcon("cancel") + "<span>" + r.Jodit.prototype.i18n("Cancel") + "</span></a>", n.document);a.addEventListener("click", function () {
        o && o(!1), n.close();
      });var d = function d() {
        o && o(!0), n.close();
      },
          u = l.dom('<a href="javascript:void(0)" style="float:left;" class="jodit_button">' + c.ToolbarIcon.getIcon("check") + "<span>" + r.Jodit.prototype.i18n("Yes") + "</span></a>", n.document);return u.addEventListener("click", d), i.addEventListener("submit", function () {
        return d(), !1;
      }), n.setFooter([u, a]), n.open(i, t || "&nbsp;", !0, !0), u.focus(), n;
    }, r.Jodit.Confirm = t.Confirm;
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = o(6),
        i = o(0),
        r = o(3);!function (e) {
      e.ColorPickerWidget = function (e, t, o) {
        var s = i.normalizeColor(o),
            a = i.dom('<div class="jodit_colorpicker"></div>', e.ownerDocument),
            l = function l(e) {
          var t = [];return i.isPlainObject(e) ? Object.keys(e).forEach(function (o) {
            t.push('<div class="jodit_colorpicker_group jodit_colorpicker_group-' + o + '">'), t.push(l(e[o])), t.push("</div>");
          }) : Array.isArray(e) && e.forEach(function (e) {
            t.push("<a " + (s === e ? ' class="active" ' : "") + ' title="' + e + '" style="background-color:' + e + '" data-color="' + e + '" href="javascript:void(0)">' + (s === e ? n.Jodit.modules.ToolbarIcon.getIcon("eye") : "") + "</a>");
          }), t.join("");
        };return a.appendChild(i.dom("<div>" + l(e.options.colors) + "</div>", e.ownerDocument)), a.appendChild(i.dom('<a data-color="" href="javascript:void(0)">' + n.Jodit.modules.ToolbarIcon.getIcon("eraser") + "</a>", e.ownerDocument)), e.events.on(a, "mousedown touchstart", function (o) {
          o.stopPropagation();var s = o.target;if ("SVG" !== s.tagName.toUpperCase() && "PATH" !== s.tagName.toUpperCase() || !s.parentNode || (s = r.Dom.closest(s.parentNode, "A", e.editor)), "A" === s.tagName.toUpperCase()) {
            var l = a.querySelector("a.active");l && (l.classList.remove("active"), l.innerHTML = "");var c = s.getAttribute("data-color") || "";if (c) {
              s.innerHTML = n.Jodit.modules.ToolbarIcon.getIcon("eye"), s.classList.add("active");var d = i.hexToRgb(c);d && (s.firstChild.style.fill = "rgb(" + (255 - d.r) + "," + (255 - d.g) + "," + (255 - d.b) + ")");
            }t && "function" == typeof t && t(c), o.preventDefault();
          }
        }), a;
      }, e.TabsWidget = function (e, t, o) {
        var n = i.dom('<div class="jodit_tabs"></div>', e.ownerDocument),
            r = i.dom('<div class="jodit_tabs_wrapper"></div>', e.ownerDocument),
            s = i.dom('<div class="jodit_tabs_buttons"></div>', e.ownerDocument),
            a = {},
            l = "",
            c = 0;return n.appendChild(s), n.appendChild(r), i.each(t, function (t, n) {
          var d = i.dom('<div class="jodit_tab"></div>', e.ownerDocument),
              u = i.dom('<a href="javascript:void(0);"></a>', e.ownerDocument);l || (l = t), u.innerHTML = e.i18n(t), s.appendChild(u), d.appendChild("function" != typeof n ? i.dom(n, e.ownerDocument) : i.dom('<div class="jodit_tab_empty"></div>', e.ownerDocument)), r.appendChild(d), e.events.on(u, "mousedown touchstart", function (a) {
            return i.$$("a", s).forEach(function (e) {
              e.classList.remove("active");
            }), i.$$(".jodit_tab", r).forEach(function (e) {
              e.classList.remove("active");
            }), u.classList.add("active"), d.classList.add("active"), "function" == typeof n && n.call(e), a.stopPropagation(), o && (o.__activeTab = t), !1;
          }), a[t] = { button: u, tab: d }, c += 1;
        }), c ? (i.$$("a", s).forEach(function (e) {
          e.style.width = (100 / c).toFixed(10) + "%";
        }), o && o.__activeTab && a[o.__activeTab] ? (a[o.__activeTab].button.classList.add("active"), a[o.__activeTab].tab.classList.add("active")) : (a[l].button.classList.add("active"), a[l].tab.classList.add("active")), n) : n;
      }, e.ImageSelectorWidget = function (t, o, r, s) {
        var a,
            l = {};if (o.upload && t.options.uploader && t.options.uploader.url) {
          var c = i.dom('<div class="jodit_draganddrop_file_box"><strong>' + t.i18n("Drop image") + "</strong><span><br> " + t.i18n("or click") + '</span><input type="file" accept="image/*" tabindex="-1" dir="auto" multiple=""/></div>', t.ownerDocument);t.getInstance("Uploader").bind(c, function (e) {
            "function" == typeof o.upload && o.upload.call(t, { baseurl: e.baseurl, files: e.files });
          }, function (e) {
            t.events.fire("errorMessage", e.message);
          }), l[n.Jodit.modules.ToolbarIcon.getIcon("upload") + t.i18n("Upload")] = c;
        }if (o.filebrowser && (t.options.filebrowser.ajax.url || t.options.filebrowser.items.url) && (l[n.Jodit.modules.ToolbarIcon.getIcon("folder") + t.i18n("Browse")] = function () {
          s && s(), o.filebrowser && t.getInstance("FileBrowser").open(o.filebrowser);
        }), o.url) {
          var d = i.dom('<form onsubmit="return false;" class="jodit_form"><input type="text" required name="url" placeholder="http://"/><input type="text" name="text" placeholder="' + t.i18n("Alternative text") + '"/><div style="text-align: right"><button>' + t.i18n("Insert") + "</button></div></form>", t.ownerDocument),
              u = d.querySelector("button"),
              p = d.querySelector("input[name=url]");a = null, r && r.nodeType !== Node.TEXT_NODE && ("IMG" === r.tagName || i.$$("img", r).length) && (a = "IMG" === r.tagName ? r : i.$$("img", r)[0], i.val(d, "input[name=url]", a.getAttribute("src")), i.val(d, "input[name=text]", a.getAttribute("alt")), u.innerText = t.i18n("Update")), d.addEventListener("submit", function (e) {
            return e.preventDefault(), e.stopPropagation(), i.val(d, "input[name=url]") ? ("function" == typeof o.url && o.url.call(t, i.val(d, "input[name=url]"), i.val(d, "input[name=text]")), !1) : (p.focus(), p.classList.add("jodit_error"), !1);
          }, !1), l[n.Jodit.modules.ToolbarIcon.getIcon("link") + " URL"] = d;
        }return e.TabsWidget(t, l);
      };
    }(t.Widget || (t.Widget = {}));
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Component = o(4).Component, t.ContextMenu = o(19).ContextMenu, t.Cookie = o(10).Cookie;var n = o(7);t.Dialog = n.Dialog, t.Alert = n.Alert, t.Confirm = n.Confirm, t.Promt = n.Promt, t.Dom = o(3).Dom, t.EventsNative = o(12).EventsNative, t.FileBrowser = o(59).FileBrowser, t.Helpers = o(0), t.ImageEditor = o(60).ImageEditor, t.Observer = o(16).Observer, t.Select = o(13).Select, t.Snapshot = o(17).Snapshot, t.Table = o(15).Table;var i = o(5);t.ToolbarIcon = i.ToolbarIcon, t.ToolbarCollection = i.ToolbarCollection, t.ToolbarButton = i.ToolbarButton, t.Stack = o(18).Stack, t.Uploader = o(11).Uploader;
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(4);t.Cookie = function (e) {
      function t() {
        return null !== e && e.apply(this, arguments) || this;
      }return n(t, e), t.set = function (e, t, o) {
        var n, i;o ? (i = new Date(), i.setTime(i.getTime() + 24 * o * 60 * 60 * 1e3), n = "; expires=" + i.toUTCString()) : n = "", document.cookie = e + "=" + t + n + "; path=/";
      }, t.get = function (e) {
        var t,
            o,
            n = e + "=",
            i = document.cookie.split(";");for (t = 0; i.length > t; t += 1) {
          for (o = i[t]; " " === o.charAt(0);) {
            o = o.substring(1, o.length);
          }if (0 === o.indexOf(n)) return o.substring(n.length, o.length);
        }return null;
      }, t.remove = function (e) {
        t.set(e, "", -1);
      }, t;
    }(i.Component);
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(4),
        r = o(14),
        s = o(1),
        a = o(0),
        l = o(2),
        c = o(3);s.Config.prototype.enableDragAndDropFileToEditor = !0, s.Config.prototype.uploader = { url: "", headers: null, data: null, format: "json", prepareData: function prepareData(e) {
        return e;
      }, isSuccess: function isSuccess(e) {
        return e.success;
      }, getMessage: function getMessage(e) {
        return void 0 !== e.data.messages && Array.isArray(e.data.messages) ? e.data.messages.join(" ") : "";
      }, process: function process(e) {
        return e.data;
      }, error: function error(e) {
        this.jodit.events.fire("errorMessage", e.message, "error", 4e3);
      }, defaultHandlerSuccess: function defaultHandlerSuccess(e) {
        var t = this;e.files && e.files.length && e.files.forEach(function (o) {
          t.jodit.selection.insertImage(e.baseurl + o);
        });
      }, defaultHandlerError: function defaultHandlerError(e) {
        this.jodit.events.fire("errorMessage", e.message);
      } }, t.Uploader = function (e) {
      function t(t, o) {
        var n = e.call(this, t) || this;return n.path = "", n.source = "default", n.options = a.extend(!0, {}, s.Config.prototype.uploader, t.options.uploader, o), t.options.enableDragAndDropFileToEditor && t.options.uploader && t.options.uploader.url && t.events.on("afterInit", function () {
          n.bind(t.editor);
        }), n;
      }return n(t, e), t.prototype.buildData = function (e) {
        if (void 0 !== this.jodit.ownerWindow.FormData) {
          if (e instanceof FormData) return e;if ("string" == typeof e) return e;var t = new FormData();return Object.keys(e).forEach(function (o) {
            t.append(o, e[o]);
          }), t;
        }return e;
      }, t.prototype.send = function (e, t) {
        var o = this;this.__ajax = new r.Ajax(this.jodit, { xhr: function xhr() {
            var e = new XMLHttpRequest();return void 0 !== o.jodit.ownerWindow.FormData ? e.upload.addEventListener("progress", function (e) {
              if (e.lengthComputable) {
                var t = e.loaded / e.total;t *= 100, o.jodit.progress_bar.style.display = "block", o.jodit.progress_bar.style.width = t + "%", 100 === t && (o.jodit.progress_bar.style.display = "none");
              }
            }, !1) : o.jodit.progress_bar.style.display = "none", e;
          }, method: "POST", data: this.buildData(e), url: this.options.url, headers: this.options.headers, contentType: (void 0 === this.jodit.ownerWindow.FormData || "string" == typeof e) && "application/x-www-form-urlencoded; charset=UTF-8", dataType: this.options.format || "json" }), this.__ajax.send().then(t).catch(function (e) {
          o.options.error.call(o, e);
        });
      }, t.prototype.sendFiles = function (e, t, o, n) {
        var i = this;if (e) {
          var r,
              s,
              l,
              c,
              d = e.length,
              u = this;if (!d) return !1;s = new FormData(), s.append("path", u.path), s.append("source", u.source);var p;for (r = 0; d > r; r += 1) {
            if ((p = e[r]) && p.type) {
              var f = p.type.match(/\/([a-z0-9]+)/i);l = f[1] ? f[1].toLowerCase() : "", s.append("files[" + r + "]", e[r], e[r].name || ("" + Math.random()).replace(".", "") + "." + l);
            }
          }if (u.options.prepareData(s), n && n(s), u.options.data && a.isPlainObject(u.options.data)) for (c = Object.keys(u.options.data), r = 0; c.length > r; r += 1) {
            s.append(c[r], u.options.data[c[r]]);
          }u.send(s, function (e) {
            if (!i.options.isSuccess.call(u, e)) return void (o || u.options.defaultHandlerError).call(u, Error(u.options.getMessage(e)));"function" == typeof (t || u.options.defaultHandlerSuccess) && (t || u.options.defaultHandlerSuccess).call(u, u.options.process.call(u, e));
          });
        }
      }, t.prototype.setPath = function (e) {
        this.path = e;
      }, t.prototype.setSource = function (e) {
        this.source = e;
      }, t.dataURItoBlob = function (e) {
        var t,
            o = atob(e.split(",")[1]),
            n = e.split(",")[0].split(":")[1].split(";")[0],
            i = new ArrayBuffer(o.length),
            r = new Uint8Array(i);for (t = 0; o.length > t; t += 1) {
          r[t] = o.charCodeAt(t);
        }return new Blob([r], { type: n });
      }, t.prototype.bind = function (e, o, n) {
        var i = this,
            r = this,
            s = function s(e) {
          var s,
              d,
              u,
              p,
              f = function f(e) {
            d && (e.append("extension", u), e.append("mimetype", d.type));
          };if (e.clipboardData && e.clipboardData.files && e.clipboardData.files.length) return i.sendFiles(e.clipboardData.files, o, n), !1;if (a.browser("ff")) return void (e.clipboardData.types.length || e.clipboardData.types[0] === l.TEXT_PLAIN || (p = c.Dom.create("div", "", i.jodit.editorDocument), i.jodit.selection.insertNode(p), p.focus(), setTimeout(function () {
            var e = p.firstChild;if (e && e.hasAttribute("src")) {
              var i = e.getAttribute("src") || "";p.parentNode && p.parentNode.removeChild(p), r.sendFiles([t.dataURItoBlob(i)], o, n);
            }
          }, 200)));if (e.clipboardData && e.clipboardData.items && e.clipboardData.items.length) for (s = 0; e.clipboardData.items.length > s; s += 1) {
            if ("file" === e.clipboardData.items[s].kind && "image/png" === e.clipboardData.items[s].type) {
              if (d = e.clipboardData.items[s].getAsFile()) {
                var h = d.type.match(/\/([a-z0-9]+)/i);u = h[1] ? h[1].toLowerCase() : "", i.sendFiles([d], o, n, f);
              }e.preventDefault();break;
            }
          }
        };this.jodit.editor !== e ? r.jodit.events.on(e, "paste", s) : r.jodit.events.on("processPaste", s), r.jodit.events.on(e, "dragover", function (t) {
          e.classList.add("draghover"), t.preventDefault();
        }).on(e, "dragleave dragend", function (t) {
          e.classList.remove("draghover"), t.preventDefault();
        }).on(e, "drop", function (t) {
          if (e.classList.remove("draghover"), t.dataTransfer && t.dataTransfer.files && t.dataTransfer.files.length) t.preventDefault(), i.sendFiles(t.dataTransfer.files, o, n);else if (t.dataTransfer && t.dataTransfer.getData(l.TEXT_PLAIN) && "-" !== t.dataTransfer.getData(l.TEXT_PLAIN) && e === r.jodit.editor) {
            if (t.preventDefault(), t.stopPropagation(), !i.jodit.selection.insertCursorAtPoint(t.clientX, t.clientY)) return !1;if (o || i.options.defaultHandlerSuccess) {
              var s = { baseurl: "", files: [] };s.files = [t.dataTransfer.getData(l.TEXT_PLAIN)], (o || i.options.defaultHandlerSuccess).call(i, s);
            }t.preventDefault();
          }
        });var d = e.querySelector("input[type=file]");d && r.jodit.events.on(d, "change", function () {
          r.sendFiles(this.files, o, n);
        });
      }, t.prototype.uploadRemoteImage = function (e, t, o) {
        var n = this,
            i = this;i.send({ action: "fileUploadRemote", url: e }, function (e) {
          if (i.options.isSuccess.call(i, e)) "function" == typeof t ? t.call(i, n.options.process(e)) : n.options.defaultHandlerSuccess.call(i, n.options.process(e));else if ("function" == typeof (o || i.options.defaultHandlerError)) return void (o || n.options.defaultHandlerError).call(i, Error(i.options.getMessage(e)));
        });
      }, t;
    }(i.Component);
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = function () {
      function e() {
        this.__store = {};
      }return e.prototype.get = function (e, t) {
        if (void 0 !== this.__store[t]) return this.__store[t][e];
      }, e.prototype.indexOf = function (e, t, o) {
        var n = this.get(e, t);if (n) for (var i = 0; n.length > i; i += 1) {
          if (n[i].originalCallback === o) return i;
        }return !1;
      }, e.prototype.namespaces = function () {
        return Object.keys(this.__store);
      }, e.prototype.events = function (e) {
        return this.__store[e] ? Object.keys(this.__store[e]) : [];
      }, e.prototype.set = function (e, t, o, n) {
        void 0 === n && (n = !1), void 0 === this.__store[t] && (this.__store[t] = {}), void 0 === this.__store[t][e] && (this.__store[t][e] = []), n ? this.__store[t][e].unshift(o) : this.__store[t][e].push(o);
      }, e;
    }();t.EventsNative = function () {
      function e(e) {
        var t = this;this.__defaultNameSpace = "JoditEventDefaultNamespace", this.__key = "__JoditEventsNativeNamespaces", this.current = "", this.doc = document, this.prepareEvent = function (e) {
          e.cancelBubble || (e.type.match(/^touch/) && e.changedTouches && e.changedTouches.length && ["clientX", "clientY", "pageX", "pageY"].forEach(function (t) {
            Object.defineProperty(e, t, { value: e.changedTouches[0][t], enumerable: !0 });
          }), e.originalEvent || (e.originalEvent = e), "paste" === e.type && void 0 === e.clipboardData && t.doc.defaultView.clipboardData && Object.defineProperty(e, "clipboardData", { get: function get() {
              return t.doc.defaultView.clipboardData;
            }, enumerable: !0 }));
        }, this.__stopped = [], e && (this.doc = e);
      }return e.prototype.eachEvent = function (e, t) {
        var o = this;e.split(/[\s,]+/).forEach(function (e) {
          var n = e.split(".");t.call(o, n[0], n[1] || o.__defaultNameSpace);
        });
      }, e.prototype.getStore = function (e) {
        if (void 0 === e[this.__key]) {
          var t = new n();Object.defineProperty(e, this.__key, { enumerable: !1, configurable: !0, value: t });
        }return e[this.__key];
      }, e.prototype.clearStore = function (e) {
        void 0 !== e[this.__key] && delete e[this.__key];
      }, e.prototype.on = function (e, t, o, n, i) {
        var r = this;void 0 === i && (i = !1);var s = "string" == typeof e ? this : e,
            a = "string" == typeof t ? t : e,
            l = o;void 0 === l && "function" == typeof t && (l = t);var c = this.getStore(s);if ("string" != typeof a || "" === a) throw Error("Need events names");if ("function" != typeof l) throw Error("Need event handler");if (Array.isArray(s)) return s.forEach(function (e) {
          r.on(e, a, l, n);
        }), this;var d = "function" == typeof s.addEventListener,
            u = this,
            p = function p() {
          return l && l.apply(this, arguments);
        };return d && (p = function p(e) {
          if (u.prepareEvent(e), l && !1 === l.call(this, e)) return e.preventDefault(), e.stopImmediatePropagation(), !1;
        }, n && (p = function p(e) {
          u.prepareEvent(e);for (var t = e.target; t && t !== this;) {
            if (t.matches(n)) {
              if (l && !1 === l.call(t, e)) return e.preventDefault(), !1;return;
            }t = t.parentNode;
          }
        })), this.eachEvent(a, function (e, t) {
          if ("" === e) throw Error("Need event name");if (!1 === c.indexOf(e, t, l)) {
            var o = { event: e, originalCallback: l, syntheticCallback: p };c.set(e, t, o, i), t !== r.__defaultNameSpace && c.set(e, r.__defaultNameSpace, o, i), d && s.addEventListener(e, p, !1);
          }
        }), this;
      }, e.prototype.off = function (e, t, o) {
        var n = this,
            i = "string" == typeof e ? this : e,
            r = "string" == typeof t ? t : e,
            s = this.getStore(i),
            a = o;if ("string" != typeof r || !r) return s.namespaces().forEach(function (e) {
          n.off(i, "." + e);
        }), this.clearStore(i), this;void 0 === a && "function" == typeof t && (a = t);var l = "function" == typeof i.removeEventListener,
            c = function c(e) {
          l && i.removeEventListener(e.event, e.syntheticCallback, !1);
        },
            d = function d(e, t) {
          if ("" !== e) {
            var o = s.get(e, t);if (o && o.length) {
              var i = !1;if ("function" != typeof a) o.forEach(c), o.length = 0, i = !0;else {
                var r = s.indexOf(e, t, a);!1 !== r && (c(o[r]), o.splice(r, 1), i = !0);
              }i && t !== n.__defaultNameSpace && d(e, n.__defaultNameSpace);
            }
          } else s.events(t).forEach(function (e) {
            "" !== e && d(e, t);
          });
        };return this.eachEvent(r, function (e, t) {
          t === n.__defaultNameSpace ? s.namespaces().forEach(function (t) {
            d(e, t);
          }) : d(e, t);
        }), this;
      }, e.prototype.triggerNativeEvent = function (e, t) {
        var o = this.doc.createEvent("HTMLEvents");"string" == typeof t ? o.initEvent(t, !0, !0) : (o.initEvent(t.type, t.bubbles, t.cancelable), ["screenX", "screenY", "clientX", "clientY", "target", "srcElement", "currentTarget", "timeStamp", "which", "keyCode"].forEach(function (e) {
          Object.defineProperty(o, e, { value: t[e], enumerable: !0 });
        }), Object.defineProperty(o, "originalEvent", { value: t, enumerable: !0 })), e.dispatchEvent(o);
      }, e.prototype.stopPropagation = function (e, t) {
        var o = this,
            n = "string" == typeof e ? this : e,
            i = "string" == typeof e ? e : t;if ("string" != typeof i) throw Error("Need event names");var r = this.getStore(n);this.eachEvent(i, function (e, t) {
          var n = r.get(e, t);n && o.__stopped.push(n);
        });
      }, e.prototype.removeStop = function (e) {
        if (e) {
          var t = this.__stopped.indexOf(e);-1 !== t && this.__stopped.splice(t, 1);
        }
      }, e.prototype.isStopped = function (e) {
        return void 0 !== e && -1 !== this.__stopped.indexOf(e);
      }, e.prototype.fire = function (e, t) {
        for (var o = this, n = [], i = 2; arguments.length > i; i++) {
          n[i - 2] = arguments[i];
        }var r,
            s = void 0,
            a = "string" == typeof e ? this : e,
            l = "string" == typeof e ? e : t,
            c = "string" == typeof e ? [t].concat(n) : n,
            d = "function" == typeof a.dispatchEvent;if (!d && "string" != typeof l) throw Error("Need events names");var u = this.getStore(a);return "string" != typeof l && d ? this.triggerNativeEvent(a, t) : this.eachEvent(l, function (e, t) {
          if (d) o.triggerNativeEvent(a, e);else {
            var n = u.get(e, t);if (n) {
              o.current = e;try {
                n.every(function (e) {
                  return !o.isStopped(n) && (r = e.syntheticCallback.apply(a, c), void 0 !== r && (s = r), !0);
                });
              } finally {
                o.removeStop(n);
              }
            }
          }
        }), s;
      }, e.prototype.destruct = function () {
        this.off(this);
      }, e;
    }();
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(2),
        r = o(4),
        s = o(0),
        a = o(3);t.Select = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;return t.isMarker = function (e) {
          return a.Dom.isNode(e, t.jodit.editorWindow) && "SPAN" === e.tagName && e.hasAttribute("data-" + i.MARKER_CLASS);
        }, t.marker = function (e, o) {
          void 0 === e && (e = !1);var n = null;o && (n = o.cloneRange(), n.collapse(e));var r = t.jodit.editorDocument.createElement("span");return r.id = i.MARKER_CLASS + "_" + +new Date() + "_" + ("" + Math.random()).slice(2), r.style.lineHeight = "0", r.style.display = "none", r.setAttribute("data-" + i.MARKER_CLASS, e ? "start" : "end"), r.appendChild(t.jodit.editorDocument.createTextNode(i.INVISIBLE_SPACE)), n && n.insertNode(r), r;
        }, t.focus = function () {
          var e = t.jodit;if (!t.isFocused()) {
            if (e.options.iframe && s.isIE()) for (var o = 0; 1e5 > o && "complete" !== e.editorDocument.readyState;) {
              o++;
            }e.iframe && e.iframe.focus(), e.editorWindow.focus(), e.editor.focus();var n = e.editorWindow.getSelection(),
                r = e.editorDocument.createRange();if (!n.rangeCount || !t.current()) {
              var a = e.editor.firstChild;a || (a = e.editorDocument.createTextNode(i.INVISIBLE_SPACE), e.editor.appendChild(a)), r.selectNodeContents(a), r.collapse(!0), n.removeAllRanges(), n.addRange(r);
            }return !0;
          }return !1;
        }, t.eachSelection = function (e) {
          var o = t.jodit.editorWindow.getSelection();if (o.rangeCount) {
            var n = o.getRangeAt(0),
                i = [],
                r = n.endContainer === t.jodit.editor ? t.jodit.editor.childNodes[n.endOffset - 1] : n.endContainer;a.Dom.find(n.startContainer === t.jodit.editor ? t.jodit.editor.childNodes[n.startOffset] : n.startContainer, function (e) {
              return !e || a.Dom.isEmptyTextNode(e) || t.isMarker(e) || i.push(e), e === r;
            }, t.jodit.editor, !0, "nextSibling", !1), i.forEach(function (t) {
              e(t);
            });
          }
        }, t.applyCSS = function (e, o, n) {
          void 0 === o && (o = "span");var r,
              l = function l(e) {
            return null !== e && !a.Dom.isEmptyTextNode(e) && !t.isMarker(e);
          },
              c = function c(e) {
            return "FONT" !== e.nodeName && e.nodeType === Node.ELEMENT_NODE && (s.isPlainObject(n) && !1 !== s.each(n, function (t, o) {
              var n = s.css(e, t, void 0, !0);return null !== n && "" !== n && -1 !== o.indexOf(("" + n).toLowerCase());
            }) || "function" == typeof n && n(t.jodit, e));
          },
              d = function d(e) {
            return (RegExp("^" + e.nodeName + "$", "i").test(o) || !(!n || !c(e))) && l(e);
          },
              u = function u(t) {
            d(t) && ("SPAN" === t.nodeName && e && Object.keys(e).forEach(function (o) {
              0 === r || s.css(t, o) == s.normilizeCSSValue(o, e[o]) ? (s.css(t, o, ""), void 0 === r && (r = 0)) : (s.css(t, o, e[o]), void 0 === r && (r = 1));
            }), a.Dom.isBlock(t) || t.getAttribute("style") && "SPAN" === t.nodeName || (a.Dom.unwrap(t), void 0 === r && (r = 0)));
          };if (t.isCollapsed()) {
            var p = !1;if (t.current() && a.Dom.closest(t.current(), o, t.jodit.editor)) {
              p = !0;var f = a.Dom.closest(t.current(), o, t.jodit.editor);f && t.setCursorAfter(f);
            }if ("SPAN" === o.toUpperCase() || !p) {
              var h = a.Dom.create(o, i.INVISIBLE_SPACE, t.jodit.editorDocument);t.insertNode(h), "SPAN" === o.toUpperCase() && e && s.css(h, e), t.setCursorIn(h);
            }
          } else {
            var m = t.save();s.normalizeNode(t.jodit.editor.firstChild), t.jodit.editorDocument.execCommand("fontsize", !1, 7), s.$$('font[size="7"]', t.jodit.editor).forEach(function (n) {
              if (a.Dom.next(n, l, n.parentNode) || a.Dom.prev(n, l, n.parentNode) || !d(n.parentNode) || n.parentNode === t.jodit.editor || a.Dom.isBlock(n.parentNode) && !i.IS_BLOCK.test(o)) {
                if (n.firstChild && !a.Dom.next(n.firstChild, l, n) && !a.Dom.prev(n.firstChild, l, n) && d(n.firstChild)) u(n.firstChild);else if (a.Dom.closest(n, d, t.jodit.editor)) {
                  var c = t.jodit.editorDocument.createRange(),
                      p = a.Dom.closest(n, d, t.jodit.editor);c.setStartBefore(p), c.setEndBefore(n);var f = c.extractContents();f.textContent && s.trim(f.textContent).length || !f.firstChild || a.Dom.unwrap(f.firstChild), p.parentNode && p.parentNode.insertBefore(f, p), c.setStartAfter(n), c.setEndAfter(p);var h = c.extractContents();h.textContent && s.trim(h.textContent).length || !h.firstChild || a.Dom.unwrap(h.firstChild), a.Dom.after(p, h), u(p);
                } else {
                  var m = [],
                      v = void 0;n.firstChild && a.Dom.find(n.firstChild, function (e) {
                    return e && d(e) ? (void 0 === v && (v = !0), m.push(e)) : void 0 === v && (v = !1), !1;
                  }, n, !0), m.forEach(a.Dom.unwrap), v || (void 0 === r && (r = 1), 1 === r && s.css(a.Dom.replace(n, o, !1, !1, t.jodit.editorDocument), e && "SPAN" === o.toUpperCase() ? e : {}));
                }
              } else u(n.parentNode);n.parentNode && a.Dom.unwrap(n);
            }), t.restore(m);
          }
        }, t;
      }return n(t, e), t.prototype.insertCursorAtPoint = function (e, t) {
        var o,
            n = this.jodit.editorDocument;this.removeMarkers();try {
          var i = n.createRange();if (n.caretPositionFromPoint ? (o = n.caretPositionFromPoint(e, t), i.setStart(o.offsetNode, o.offset)) : this.jodit.editorDocument.caretRangeFromPoint && (o = this.jodit.editorDocument.caretRangeFromPoint(e, t), i = this.jodit.editorDocument.createRange(), i.setStart(o.startContainer, o.startOffset)), i && void 0 !== this.jodit.editorWindow.getSelection) {
            i.collapse(!0);var r = this.jodit.editorWindow.getSelection();r.removeAllRanges(), r.addRange(i);
          } else if (void 0 !== n.body.createTextRange) {
            var s = n.body.createTextRange();s.moveToPoint(e, t), s.select();
          }return !0;
        } catch (e) {}return !1;
      }, t.prototype.removeMarkers = function () {
        s.$$("span[data-" + i.MARKER_CLASS + "]", this.jodit.editor).forEach(function (e) {
          e.parentNode && e.parentNode.removeChild(e);
        });
      }, t.prototype.restore = function (e) {
        var t = this;if (void 0 === e && (e = []), Array.isArray(e)) {
          var o = this.jodit.editorWindow.getSelection();o.removeAllRanges(), e.forEach(function (e) {
            var n = t.jodit.editorDocument.createRange(),
                i = t.jodit.editor.querySelector("#" + e.endId),
                r = t.jodit.editor.querySelector("#" + e.startId);if (r) {
              if (e.collapsed || !i) {
                var s = r.previousSibling;s && s.nodeType === Node.TEXT_NODE ? n.setStart(s, s.nodeValue ? s.nodeValue.length : 0) : n.setStartBefore(r), r.parentNode && r.parentNode.removeChild(r), n.collapse(!0);
              } else n.setStartAfter(r), r.parentNode && r.parentNode.removeChild(r), n.setEndBefore(i), i.parentNode && i.parentNode.removeChild(i);o.addRange(n);
            }
          });
        }
      }, t.prototype.save = function () {
        var e = this.jodit.editorWindow.getSelection();if (!e.rangeCount) return [];var t,
            o,
            n,
            i = [],
            r = e.rangeCount,
            s = [];for (t = 0; r > t; t += 1) {
          s[t] = e.getRangeAt(t), s[t].collapsed ? (o = this.marker(!0, s[t]), i[t] = { startId: o.id, collapsed: !0, startMarker: o.outerHTML }) : (o = this.marker(!0, s[t]), n = this.marker(!1, s[t]), i[t] = { startId: o.id, endId: n.id, collapsed: !1, startMarker: o.outerHTML, endMarker: n.outerHTML });
        }for (e.removeAllRanges(), t = r - 1; t >= 0; --t) {
          var a = this.jodit.editorDocument.getElementById(i[t].startId);if (a) if (i[t].collapsed) s[t].setStartAfter(a), s[t].collapse(!0);else if (s[t].setStartBefore(a), i[t].endId) {
            var l = this.jodit.editorDocument.getElementById(i[t].endId);l && s[t].setEndAfter(l);
          }try {
            e.addRange(s[t].cloneRange());
          } catch (e) {}
        }return i;
      }, t.prototype.isCollapsed = function () {
        var e,
            t = this.jodit.editorWindow.getSelection();for (e = 0; t.rangeCount > e; e += 1) {
          if (!t.getRangeAt(e).collapsed) return !1;
        }return !0;
      }, t.prototype.isFocused = function () {
        return this.jodit.editorDocument.hasFocus && this.jodit.editorDocument.hasFocus() && this.jodit.editor === this.jodit.editorDocument.activeElement;
      }, t.prototype.current = function () {
        if (this.jodit.getRealMode() === i.MODE_WYSIWYG && void 0 !== this.jodit.editorWindow.getSelection) {
          var e = this.jodit.editorWindow.getSelection();if (e.rangeCount > 0) {
            var t = e.getRangeAt(0),
                o = t.startContainer;if (t.startContainer.nodeType !== Node.TEXT_NODE && t.startContainer === t.endContainer && t.startOffset !== t.endOffset && (o = t.startContainer.childNodes[t.startOffset]), a.Dom.isOrContains(this.jodit.editor, o)) return o;
          }
        }return !1;
      }, t.prototype.insertNode = function (e, t) {
        if (void 0 === t && (t = !0), !(e instanceof this.jodit.editorWindow.Node)) throw Error("Parameter node most be instance of Node");if (this.focus(), !this.jodit.editorWindow.getSelection) throw Error("Jodit does'n support this browser");var o = this.jodit.editorWindow.getSelection();if (this.isCollapsed() || this.jodit.execCommand("Delete"), o.rangeCount) {
          var n = o.getRangeAt(0);!function (e, t) {
            for (var o = t; o;) {
              if (o === e) return !0;o = o.parentNode;
            }return !1;
          }(this.jodit.editor, n.commonAncestorContainer) ? this.jodit.editor.appendChild(e) : (n.deleteContents(), n.insertNode(e));
        } else this.jodit.editor.appendChild(e);t && this.setCursorAfter(e), this.jodit.setEditorValue();
      }, t.prototype.insertHTML = function (e) {
        if ("" !== e) {
          var t,
              o,
              n = this.jodit.editorDocument.createElement("div"),
              i = this.jodit.editorDocument.createDocumentFragment();for (this.isFocused() || this.jodit.editor.focus(), e instanceof this.jodit.editorWindow.Node ? a.Dom.isNode(e, this.jodit.editorWindow) && n.appendChild(e) : n.innerHTML = "" + e, t = n.lastChild; n.firstChild;) {
            t = n.firstChild, i.appendChild(n.firstChild);
          }for (this.insertNode(i, !1), t ? this.setCursorAfter(t) : this.setCursorIn(i), o = this.jodit.editor.lastChild; o && o.nodeType === Node.TEXT_NODE && o.previousSibling && o.nodeValue && /^\s*$/.test(o.nodeValue);) {
            o = o.previousSibling;
          }t && (o && t === o && t.nodeType === Node.ELEMENT_NODE && this.jodit.editor.appendChild(this.jodit.editorDocument.createElement("br")), this.setCursorAfter(t));
        }
      }, t.prototype.insertImage = function (e, t) {
        void 0 === t && (t = {});var o,
            n = "string" == typeof e ? s.dom('<img src=""/>', this.jodit.editorDocument) : s.dom(e, this.jodit.editorDocument);this.isCollapsed() || this.jodit.execCommand("Delete"), "string" == typeof e && n.setAttribute("src", e), o = "" + this.jodit.options.imageDefaultWidth, o && "auto" !== o && 0 > (o + "").indexOf("px") && 0 > (o + "").indexOf("%") && (o += "px"), t.width = o, t && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && s.each(t, function (e, t) {
          n.style[t] = e;
        });var i = function i() {
          (n.offsetHeight > n.naturalHeight || n.offsetWidth > n.naturalWidth) && (n.style.width = "", n.style.height = ""), n.removeEventListener("load", i);
        };n.addEventListener("load", i), n.complete && i(), this.insertNode(n), this.jodit.events.fire("afterInsertImage", n);
      }, t.prototype.setCursorAfter = function (e) {
        var t = this;if (!(e instanceof this.jodit.editorWindow.Node)) throw Error("Parameter node most be instance of Node");if (!a.Dom.up(e, function (e) {
          return e === t.jodit.editor || e && e.parentNode === t.jodit.editor;
        }, this.jodit.editor)) throw Error("Node element must be in editor");var o = this.jodit.editorDocument.createRange(),
            n = this.jodit.editorDocument.createTextNode(i.INVISIBLE_SPACE);return e.nodeType !== Node.TEXT_NODE ? (o.setStartAfter(e), o.insertNode(n), o.selectNode(n)) : o.setStart(e, null !== e.nodeValue ? e.nodeValue.length : 0), o.collapse(!1), this.selectRange(o), n;
      }, t.prototype.cursorInTheEdge = function (e, t, o) {
        void 0 === e && (e = !1), void 0 === t && (t = !1), void 0 === o && (o = !1);var n = this.jodit.editorWindow.getSelection(),
            i = function i(e) {
          return e && !a.Dom.isEmptyTextNode(e);
        },
            r = t;if (!n.rangeCount) return !1;var s = n.getRangeAt(0),
            l = function () {
          return !1 === o ? e : !e;
        }() ? s.startContainer : s.endContainer;if (!1 === t) r = a.Dom.up(l, a.Dom.isBlock, this.jodit.editor);else if ("function" == typeof t) r = a.Dom.up(l, t, this.jodit.editor);else if (!a.Dom.isOrContains(t, s.startContainer)) return null;return !(!r || (l === r ? e ? 0 !== s.startOffset : s.endOffset !== [].slice.call(r.childNodes).filter(i).length : e ? l.nodeType === Node.TEXT_NODE && 0 !== s.startOffset || a.Dom.prev(l, i, r) : l.nodeType === Node.TEXT_NODE && (!s.startContainer.nodeValue || s.endOffset !== s.startContainer.nodeValue.length) || a.Dom.next(l, i, r)));
      }, t.prototype.setCursorBefore = function (e) {
        var t = this;if (!(e instanceof this.jodit.editorWindow.Node)) throw Error("Parameter node most be instance of Node");if (!a.Dom.up(e, function (e) {
          return e === t.jodit.editor || e && e.parentNode === t.jodit.editor;
        }, this.jodit.editor)) throw Error("Node element must be in editor");var o = this.jodit.editorDocument.createRange(),
            n = this.jodit.editorDocument.createTextNode(i.INVISIBLE_SPACE);return e.nodeType !== Node.TEXT_NODE ? (o.setStartBefore(e), o.insertNode(n), o.selectNode(n)) : o.setStart(e, null !== e.nodeValue ? e.nodeValue.length : 0), o.collapse(!0), this.selectRange(o), n;
      }, t.prototype.setCursorIn = function (e, t) {
        var o = this;if (void 0 === t && (t = !1), !(e instanceof this.jodit.editorWindow.Node)) throw Error("Parameter node most be instance of Node");if (!a.Dom.up(e, function (e) {
          return e === o.jodit.editor || e && e.parentNode === o.jodit.editor;
        }, this.jodit.editor)) throw Error("Node element must be in editor");var n = this.jodit.editorDocument.createRange(),
            r = e,
            s = e;do {
          if (r.nodeType === Node.TEXT_NODE) break;s = r, r = t ? r.firstChild : r.lastChild;
        } while (r);if (s === e && e.nodeType !== Node.TEXT_NODE) {
          var l = this.jodit.editorDocument.createTextNode(i.INVISIBLE_SPACE);e.appendChild(l), s = l;
        }return n.selectNodeContents(r || s), n.collapse(t), this.selectRange(n), s;
      }, t.prototype.selectRange = function (e) {
        var t = this.jodit.editorWindow.getSelection();t.removeAllRanges(), t.addRange(e), this.jodit.events.fire("changeSelection");
      }, t.prototype.select = function (e, t) {
        var o = this;if (void 0 === t && (t = !1), !(e instanceof this.jodit.editorWindow.Node)) throw Error("Parameter node most be instance of Node");if (!a.Dom.up(e, function (e) {
          return e === o.jodit.editor || e && e.parentNode === o.jodit.editor;
        }, this.jodit.editor)) throw Error("Node element must be in editor");var n = this.jodit.editorDocument.createRange();n[t ? "selectNodeContents" : "selectNode"](e), this.selectRange(n);
      }, t;
    }(r.Component);
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(0),
        s = o(4);i.Config.prototype.defaultAjaxOptions = { dataType: "json", method: "GET", url: "", data: null, contentType: "application/x-www-form-urlencoded; charset=UTF-8", headers: { "X-REQUESTED-WITH": "XMLHttpRequest" }, withCredentials: !0, xhr: function xhr() {
        return new ("undefined" == typeof XDomainRequest ? XMLHttpRequest : XDomainRequest)();
      } }, t.Ajax = function (e) {
      function t(t, o) {
        var n = e.call(this, t) || this;return n.options = r.extend(!0, {}, i.Config.prototype.defaultAjaxOptions, o), n.options.xhr && (n.xhr = n.options.xhr()), n;
      }return n(t, e), t.prototype.__buildParams = function (e, t) {
        if ("string" == typeof e || this.jodit.ownerWindow.FormData && e instanceof this.jodit.ownerWindow.FormData) return e;var o,
            n,
            i,
            r = [];for (o in e) {
          e.hasOwnProperty(o) && (n = t ? t + "[" + o + "]" : o, i = e[o], r.push("object" == (typeof i === "undefined" ? "undefined" : _typeof(i)) ? this.__buildParams(i, n) : encodeURIComponent(n) + "=" + encodeURIComponent(i)));
        }return r.join("&");
      }, t.prototype.abort = function () {
        return this.xhr.abort(), this;
      }, t.prototype.send = function () {
        var e = this;return new Promise(function (t, o) {
          var n = function n(t) {
            switch (e.options.dataType) {case "json":
                try {
                  t = JSON.parse(t);
                } catch (t) {
                  return void o.call(e.xhr, t);
                }}return t;
          };if (e.xhr.onabort = function () {
            o(Error(e.xhr.statusText));
          }, e.xhr.onerror = function () {
            o(Error(e.xhr.statusText));
          }, e.xhr.ontimeout = function () {
            o(Error(e.xhr.statusText));
          }, e.xhr.onload = function () {
            e.response = e.xhr.responseText, e.status = e.xhr.status, t.call(e.xhr, n(e.response));
          }, e.xhr.onreadystatechange = function () {
            if (e.xhr.readyState === XMLHttpRequest.DONE) {
              var i = e.xhr.responseText;e.response = i, e.status = e.xhr.status, 200 === e.xhr.status ? t.call(e.xhr, n(i)) : o.call(e.xhr, Error(e.xhr.statusText || e.jodit.i18n("Connection error!")));
            }
          }, e.xhr.withCredentials = e.options.withCredentials || !1, !e.options.url) throw Error("Need URL for AJAX request");e.xhr.open(e.options.method || "get", e.options.url, !0), e.options.contentType && e.xhr.setRequestHeader && e.xhr.setRequestHeader("Content-type", e.options.contentType), e.options.headers && e.xhr.setRequestHeader && r.each(e.options.headers, function (t, o) {
            e.xhr.setRequestHeader(t, o);
          }), setTimeout(function () {
            e.xhr.send(e.options.data ? e.__buildParams(e.options.data) : void 0);
          }, 0);
        });
      }, t;
    }(s.Component);
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = o(0),
        i = o(2),
        r = o(3);t.Table = function () {
      function e() {}return e.addSelected = function (e) {
        e.setAttribute(i.JODIT_SELECTED_CELL_MARKER, "1");
      }, e.restoreSelection = function (e) {
        e.removeAttribute(i.JODIT_SELECTED_CELL_MARKER);
      }, e.getAllSelectedCells = function (e) {
        return e ? n.$$("td[" + i.JODIT_SELECTED_CELL_MARKER + "],th[" + i.JODIT_SELECTED_CELL_MARKER + "]", e) : [];
      }, e.getRowsCount = function (e) {
        return e.rows.length;
      }, e.getColumnsCount = function (t) {
        return e.formalMatrix(t).reduce(function (e, t) {
          return Math.max(e, t.length);
        }, 0);
      }, e.formalMatrix = function (e, t) {
        for (var o = [[]], n = Array.prototype.slice.call(e.rows), i = 0, r = void 0; n.length > i; i += 1) {
          var s = Array.prototype.slice.call(n[i].cells);for (r = 0; s.length > r; r += 1) {
            if (!1 === function (e, n) {
              void 0 === o[n] && (o[n] = []);for (var i, r, s = e.colSpan, a = e.rowSpan, l = 0; o[n][l];) {
                l += 1;
              }for (r = 0; a > r; r += 1) {
                for (i = 0; s > i; i += 1) {
                  if (void 0 === o[n + r] && (o[n + r] = []), t && !1 === t(e, n + r, l + i, s, a)) return !1;o[n + r][l + i] = e;
                }
              }
            }(s[r], i)) return o;
          }
        }return o;
      }, e.formalCoordinate = function (t, o, n) {
        void 0 === n && (n = !1);var i = 0,
            r = 0,
            s = 1,
            a = 1;return e.formalMatrix(t, function (e, t, l, c, d) {
          if (o === e) return i = t, r = l, s = c || 1, a = d || 1, n && (r += (c || 1) - 1, i += (d || 1) - 1), !1;
        }), [i, r, s, a];
      }, e.appendRow = function (t, o, i) {
        void 0 === o && (o = !1), void 0 === i && (i = !0);var s,
            a = e.getColumnsCount(t),
            l = r.Dom.create("tr", "", t.ownerDocument);for (s = 0; a > s; s += 1) {
          l.appendChild(r.Dom.create("td", "", t.ownerDocument));
        }i && o && o.nextSibling ? o.parentNode && o.parentNode.insertBefore(l, o.nextSibling) : !i && o ? o.parentNode && o.parentNode.insertBefore(l, o) : (n.$$(":scope>tbody", t)[0] || t).appendChild(l);
      }, e.removeRow = function (t, o) {
        var i,
            s = e.formalMatrix(t),
            a = t.rows[o];n.each(s[o], function (e, n) {
          if (i = !1, 0 > o - 1 || s[o - 1][e] !== n) {
            if (s[o + 1] && s[o + 1][e] === n) {
              if (n.parentNode === a && n.parentNode.nextSibling) {
                i = !0;for (var l = e + 1; s[o + 1][l] === n;) {
                  l += 1;
                }var c = r.Dom.next(n.parentNode, function (e) {
                  return e && e.nodeType === Node.ELEMENT_NODE && "TR" === e.nodeName;
                }, t);s[o + 1][l] ? c.insertBefore(n, s[o + 1][l]) : c.appendChild(n);
              }
            } else n.parentNode && n.parentNode.removeChild(n);
          } else i = !0;if (i && (n.parentNode === a || n !== s[o][e - 1])) {
            var d = n.rowSpan;d - 1 > 1 ? n.setAttribute("rowspan", "" + (d - 1)) : n.removeAttribute("rowspan");
          }
        }), a && a.parentNode && a.parentNode.removeChild(a);
      }, e.appendColumn = function (t, o, n) {
        void 0 === n && (n = !0);var i,
            s = e.formalMatrix(t);for (void 0 === o && (o = e.getColumnsCount(t) - 1), i = 0; s.length > i; i += 1) {
          var a = r.Dom.create("td", "", t.ownerDocument),
              l = s[i][o],
              c = !1;n ? (s[i] && l && o + 1 >= s[i].length || l !== s[i][o + 1]) && (l.nextSibling ? l.parentNode && l.parentNode.insertBefore(a, l.nextSibling) : l.parentNode && l.parentNode.appendChild(a), c = !0) : (0 > o - 1 || s[i][o] !== s[i][o - 1] && s[i][o].parentNode) && (l.parentNode && l.parentNode.insertBefore(a, s[i][o]), c = !0), c || s[i][o].setAttribute("colspan", "" + (parseInt(s[i][o].getAttribute("colspan") || "1", 10) + 1));
        }
      }, e.removeColumn = function (t, o) {
        var i,
            r = e.formalMatrix(t);n.each(r, function (e, t) {
          var n = t[o];if (i = !1, 0 > o - 1 || r[e][o - 1] !== n ? t.length > o + 1 && r[e][o + 1] === n ? i = !0 : n.parentNode && n.parentNode.removeChild(n) : i = !0, i && (0 > e - 1 || n !== r[e - 1][o])) {
            var s = n.colSpan;s - 1 > 1 ? n.setAttribute("colspan", "" + (s - 1)) : n.removeAttribute("colspan");
          }
        });
      }, e.getSelectedBound = function (t, o) {
        var n,
            i,
            r,
            s = [[1 / 0, 1 / 0], [0, 0]],
            a = e.formalMatrix(t);for (n = 0; a.length > n; n += 1) {
          for (i = 0; a[n].length > i; i += 1) {
            -1 !== o.indexOf(a[n][i]) && (s[0][0] = Math.min(n, s[0][0]), s[0][1] = Math.min(i, s[0][1]), s[1][0] = Math.max(n, s[1][0]), s[1][1] = Math.max(i, s[1][1]));
          }
        }for (n = s[0][0]; s[1][0] >= n; n += 1) {
          for (r = 1, i = s[0][1]; s[1][1] >= i; i += 1) {
            for (; a[n][i - r] && a[n][i] === a[n][i - r];) {
              s[0][1] = Math.min(i - r, s[0][1]), s[1][1] = Math.max(i - r, s[1][1]), r += 1;
            }for (r = 1; a[n][i + r] && a[n][i] === a[n][i + r];) {
              s[0][1] = Math.min(i + r, s[0][1]), s[1][1] = Math.max(i + r, s[1][1]), r += 1;
            }for (r = 1; a[n - r] && a[n][i] === a[n - r][i];) {
              s[0][0] = Math.min(n - r, s[0][0]), s[1][0] = Math.max(n - r, s[1][0]), r += 1;
            }for (r = 1; a[n + r] && a[n][i] === a[n + r][i];) {
              s[0][0] = Math.min(n + r, s[0][0]), s[1][0] = Math.max(n + r, s[1][0]), r += 1;
            }
          }
        }return s;
      }, e.normalizeTable = function (t) {
        var o,
            n,
            i,
            r,
            s = [],
            a = e.formalMatrix(t);for (n = 0; a[0].length > n; n += 1) {
          for (i = 1e6, r = !1, o = 0; a.length > o; o += 1) {
            if (void 0 !== a[o][n]) {
              if (2 > a[o][n].colSpan) {
                r = !0;break;
              }i = Math.min(i, a[o][n].colSpan);
            }
          }if (!r) for (o = 0; a.length > o; o += 1) {
            void 0 !== a[o][n] && e.__mark(a[o][n], "colspan", a[o][n].colSpan - i + 1, s);
          }
        }for (o = 0; a.length > o; o += 1) {
          for (i = 1e6, r = !1, n = 0; a[o].length > n; n += 1) {
            if (void 0 !== a[o][n]) {
              if (2 > a[o][n].rowSpan) {
                r = !0;break;
              }i = Math.min(i, a[o][n].rowSpan);
            }
          }if (!r) for (n = 0; a[o].length > n; n += 1) {
            void 0 !== a[o][n] && e.__mark(a[o][n], "rowspan", a[o][n].rowSpan - i + 1, s);
          }
        }for (o = 0; a.length > o; o += 1) {
          for (n = 0; a[o].length > n; n += 1) {
            void 0 !== a[o][n] && (a[o][n].hasAttribute("rowspan") && 1 === a[o][n].rowSpan && a[o][n].removeAttribute("rowspan"), a[o][n].hasAttribute("colspan") && 1 === a[o][n].colSpan && a[o][n].removeAttribute("colspan"), a[o][n].hasAttribute("class") && !a[o][n].getAttribute("class") && a[o][n].removeAttribute("class"));
          }
        }e.__unmark(s);
      }, e.mergeSelected = function (t) {
        var o,
            r = e.getSelectedBound(t, e.getAllSelectedCells(t)),
            s = 0,
            a = null,
            l = 0,
            c = [],
            d = 0,
            u = 0,
            p = [];r && (r[0][0] - r[1][0] || r[0][1] - r[1][1]) && (e.formalMatrix(t, function (t, i, f, h, m) {
          if (!(r[0][0] > i || i > r[1][0] || r[0][1] > f || f > r[1][1])) {
            if (o = t, o.__i_am_already_was) return;o.__i_am_already_was = !0, i === r[0][0] && o.style.width && (s += o.offsetWidth), "" !== n.trim(t.innerHTML.replace(/<br(\/)?>/g, "")) && c.push(t.innerHTML), h > 1 && (d += h - 1), m > 1 && (u += m - 1), a ? e.__mark(o, "remove", 1, p) : (a = t, l = f);
          }
        }), d = r[1][1] - r[0][1] + 1, u = r[1][0] - r[0][0] + 1, a && (d > 1 && e.__mark(a, "colspan", d, p), u > 1 && e.__mark(a, "rowspan", u, p), s && (e.__mark(a, "width", (s / t.offsetWidth * 100).toFixed(i.ACCURACY) + "%", p), l && e.setColumnWidthByDelta(t, l, 0, !0, p)), a.innerHTML = c.join("<br/>"), delete a.__i_am_already_was, e.__unmark(p), e.normalizeTable(t), n.each([].slice.call(t.rows), function (e, t) {
          t.cells.length || t.parentNode.removeChild(t);
        })));
      }, e.splitHorizontal = function (t) {
        var o,
            n,
            i,
            s,
            a,
            l = [];e.getAllSelectedCells(t).forEach(function (c) {
          n = r.Dom.create("td", "", t.ownerDocument), n.appendChild(r.Dom.create("br", "", t.ownerDocument)), i = r.Dom.create("tr", "", t.ownerDocument), o = e.formalCoordinate(t, c), 2 > c.rowSpan ? (e.formalMatrix(t, function (t, n, i) {
            o[0] === n && o[1] !== i && t !== c && e.__mark(t, "rowspan", t.rowSpan + 1, l);
          }), r.Dom.after(r.Dom.closest(c, "tr", t), i), i.appendChild(n)) : (e.__mark(c, "rowspan", c.rowSpan - 1, l), e.formalMatrix(t, function (e, n, i) {
            n > o[0] && o[0] + c.rowSpan > n && o[1] > i && e.parentNode.rowIndex === n && (a = e), n > o[0] && e === c && (s = t.rows[n]);
          }), a ? r.Dom.after(a, n) : s.insertBefore(n, s.firstChild)), c.colSpan > 1 && e.__mark(n, "colspan", c.colSpan, l), e.__unmark(l), e.restoreSelection(c);
        }), this.normalizeTable(t);
      }, e.splitVertical = function (t) {
        var o,
            n,
            s,
            a = [];e.getAllSelectedCells(t).forEach(function (l) {
          o = e.formalCoordinate(t, l), 2 > l.colSpan ? e.formalMatrix(t, function (t, n, i) {
            o[1] === i && o[0] !== n && t !== l && e.__mark(t, "colspan", t.colSpan + 1, a);
          }) : e.__mark(l, "colspan", l.colSpan - 1, a), n = r.Dom.create("td", "", t.ownerDocument), n.appendChild(r.Dom.create("br", "", t.ownerDocument)), l.rowSpan > 1 && e.__mark(n, "rowspan", l.rowSpan, a);var c = l.offsetWidth;r.Dom.after(l, n), s = c / t.offsetWidth / 2, e.__mark(l, "width", (100 * s).toFixed(i.ACCURACY) + "%", a), e.__mark(n, "width", (100 * s).toFixed(i.ACCURACY) + "%", a), e.__unmark(a), e.restoreSelection(l);
        }), e.normalizeTable(t);
      }, e.__mark = function (e, t, o, n) {
        n.push(e), e.__marked_value || (e.__marked_value = {}), e.__marked_value[t] = void 0 === o ? 1 : o;
      }, e.__unmark = function (e) {
        e.forEach(function (e) {
          e.__marked_value && (n.each(e.__marked_value, function (t, o) {
            switch (t) {case "remove":
                e.parentNode && e.parentNode.removeChild(e);break;case "rowspan":
                o > 1 ? e.setAttribute("rowspan", o) : e.removeAttribute("rowspan");break;case "colspan":
                o > 1 ? e.setAttribute("colspan", o) : e.removeAttribute("colspan");break;case "width":
                e.style.width = o;}delete e.__marked_value[t];
          }), delete e.__marked_value);
        });
      }, e.setColumnWidthByDelta = function (t, o, n, r, s) {
        var a,
            l,
            c,
            d = e.formalMatrix(t);for (a = 0; d.length > a; a += 1) {
          l = d[a][o].offsetWidth, c = (l + n) / t.offsetWidth * 100, e.__mark(d[a][o], "width", c.toFixed(i.ACCURACY) + "%", s);
        }r || e.__unmark(s);
      }, e;
    }();
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(4),
        s = o(17),
        a = o(2),
        l = o(18),
        c = o(0);i.Config.prototype.observer = { timeout: 100 };var d = function () {
      function e(e, t, o) {
        this.observer = o, this.oldValue = e, this.newValue = t;
      }return e.prototype.execute = function () {}, e.prototype.undo = function () {
        this.observer.snapshot.restore(this.oldValue);
      }, e.prototype.redo = function () {
        this.observer.snapshot.restore(this.newValue);
      }, e;
    }();t.Command = d, t.Observer = function (e) {
      function t(t) {
        var o = e.call(this, t) || this;o.onChangeStack = function () {
          o.__newValue = o.snapshot.make(), s.Snapshot.equal(o.__newValue, o.__startValue) || (o.stack.execute(new d(o.__startValue, o.__newValue, o)), o.__startValue = o.__newValue);
        }, o.stack = new l.Stack(), o.stack.changed = function () {
          o.changed();
        }, o.snapshot = new s.Snapshot(t), o.__startValue = o.snapshot.make(), o.stack.changed();var n = c.debounce(o.onChangeStack, o.jodit.options.observer.timeout);return t.events.on("updateToolbar", function () {
          o.stack.changed();
        }).on("change", function () {
          o.snapshot.isBlocked || n();
        }), o;
      }return n(t, e), t.prototype.changed = function () {
        this.jodit.getMode() === a.MODE_WYSIWYG && (this.jodit.events.fire("canRedo", this.stack.canRedo()), this.jodit.events.fire("canUndo", this.stack.canUndo()));
      }, t.prototype.redo = function () {
        this.stack.redo();
      }, t.prototype.undo = function () {
        this.stack.undo();
      }, t;
    }(r.Component);
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(4);t.Snapshot = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;return t.isBlocked = !1, t;
      }return n(t, e), t.__countElementsBefore = function (e) {
        if (!e || !e.parentNode) return 0;var t,
            o = e.parentNode.childNodes,
            n = 0,
            i = null;for (t = 0; o.length > t; t += 1) {
          if (!i || o[t].nodeType === Node.TEXT_NODE && "" === o[t].textContent || i.nodeType === Node.TEXT_NODE && o[t].nodeType === Node.TEXT_NODE || (n += 1), o[t] === e) return n;i = o[t];
        }return 0;
      }, t.prototype.__decomposeHierarchyNodes = function (e) {
        var o = [];if (!e || !e.parentNode) return [];for (; e && e !== this.jodit.editor;) {
          e && o.push(t.__countElementsBefore(e)), e = e.parentNode;
        }return o.reverse();
      }, t.__strokeOffset = function (e, t) {
        for (; e && e.nodeType === Node.TEXT_NODE;) {
          (e = e.previousSibling) && e.nodeType === Node.TEXT_NODE && null !== e.textContent && (t += e.textContent.length);
        }return t;
      }, t.prototype.make = function () {
        var e = { html: "", range: { startContainer: [], startOffset: 0, endContainer: [], endOffset: 0 } };e.html = this.jodit.getEditorValue();var o = this.jodit.editorWindow.getSelection();if (o.rangeCount) {
          var n = o.getRangeAt(0);e.range = { startContainer: this.__decomposeHierarchyNodes(n.startContainer), startOffset: t.__strokeOffset(n.startContainer, n.startOffset), endContainer: this.__decomposeHierarchyNodes(n.endContainer), endOffset: t.__strokeOffset(n.endContainer, n.endOffset) };
        }return e;
      }, t.prototype.__restoreElementByLadder = function (e) {
        var t,
            o = this.jodit.editor;for (t = 0; o && e.length > t; t += 1) {
          o = o.childNodes[e[t]];
        }return o;
      }, t.equal = function (e, t) {
        return e.html === t.html && JSON.stringify(e.range) === JSON.stringify(t.range);
      }, t.prototype.restore = function (e) {
        this.isBlocked = !0, this.jodit.setEditorValue(e.html);try {
          if (e.range) {
            var t = this.jodit.editorWindow.getSelection(),
                o = this.jodit.editorDocument.createRange();o.setStart(this.__restoreElementByLadder(e.range.startContainer), e.range.startOffset), o.setEnd(this.__restoreElementByLadder(e.range.endContainer), e.range.endOffset), t.removeAllRanges(), t.addRange(o);
          }
        } catch (e) {}this.isBlocked = !1;
      }, t;
    }(i.Component);
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.Stack = function () {
      function e() {
        this.commands = [], this.stackPosition = -1, this.savePosition = -1;
      }return e.prototype.execute = function (e) {
        this.__clearRedo(), e.execute(), this.commands.push(e), this.stackPosition += 1, this.changed();
      }, e.prototype.undo = function () {
        this.commands[this.stackPosition] && this.commands[this.stackPosition].undo(), this.stackPosition -= 1, this.changed();
      }, e.prototype.canUndo = function () {
        return this.stackPosition >= 0;
      }, e.prototype.redo = function () {
        this.stackPosition += 1, this.commands[this.stackPosition] && this.commands[this.stackPosition].redo(), this.changed();
      }, e.prototype.canRedo = function () {
        return this.commands.length - 1 > this.stackPosition;
      }, e.prototype.save = function () {
        this.savePosition = this.stackPosition, this.changed();
      }, e.prototype.__clearRedo = function () {
        this.commands.length = this.stackPosition + 1;
      }, e.prototype.changed = function () {}, e;
    }();
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(4),
        r = o(0),
        s = o(5);t.ContextMenu = function (e) {
      function t(t) {
        var o = e.call(this, t) || this;return o.hide = function () {
          o.context.classList.remove("jodit_context_menu-show"), o.jodit.ownerWindow.removeEventListener("mouseup", o.hide);
        }, o.context = r.dom('<div class="jodit_context_menu"></div>', t.ownerDocument), o.jodit.ownerDocument.body.appendChild(o.context), o;
      }return n(t, e), t.prototype.show = function (e, t, o) {
        var n = this,
            i = this;Array.isArray(o) && (this.context.innerHTML = "", o.forEach(function (e) {
          if (e) {
            var t = r.dom('<a href="javascript:void(0)">' + (e.icon ? s.ToolbarIcon.getIcon(e.icon) : "") + "<span></span></a>", n.jodit.ownerDocument),
                o = t.querySelector("span");t.addEventListener("click", function (t) {
              return e.exec && e.exec.call(i, t), i.hide(), !1;
            }), o.innerText = i.jodit.i18n(e.title || ""), i.context.appendChild(t);
          }
        }), r.css(i.context, { left: e, top: t }), this.jodit.ownerWindow.addEventListener("mouseup", i.hide), this.context.classList.add("jodit_context_menu-show"));
      }, t;
    }(i.Component);
  }, function (e, t, o) {
    "use strict";
    o(21), o(22);var n = o(6),
        i = o(5),
        r = o(2),
        s = o(27),
        a = o(9),
        l = o(64),
        c = o(70),
        d = o(1);Object.keys(r).forEach(function (e) {
      n.Jodit[e] = r[e];
    });var u = function u(e) {
      return "__esModule" !== e;
    };Object.keys(c).filter(u).forEach(function (e) {
      i.ToolbarIcon.icons[e.replace("_", "-")] = c[e];
    }), Object.keys(a).filter(u).forEach(function (e) {
      n.Jodit.modules[e] = a[e];
    }), Object.keys(s).filter(u).forEach(function (e) {
      n.Jodit.plugins[e] = s[e];
    }), Object.keys(l).filter(u).forEach(function (e) {
      n.Jodit.lang[e] = l[e];
    }), n.Jodit.defaultOptions = new d.Config(), e.exports = n.Jodit;
  }, function (e, t) {}, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), o(23), o(24), function (e) {
      e.matches || (e.matches = void 0 !== e.matchesSelector ? e.matchesSelector : function (e) {
        var t = this.ownerDocument.querySelectorAll(e),
            o = this;return Array.prototype.some.call(t, function (e) {
          return e === o;
        });
      });
    }(Element.prototype);
  }, function (e, t) {
    "document" in window.self && ("classList" in document.createElement("_") && (!document.createElementNS || "classList" in document.createElementNS("http://www.w3.org/2000/svg", "g")) || function (e) {
      "use strict";
      if ("Element" in e) {
        var t = e.Element.prototype,
            o = Object,
            n = String.prototype.trim || function () {
          return this.replace(/^\s+|\s+$/g, "");
        },
            i = Array.prototype.indexOf || function (e) {
          for (var t = 0, o = this.length; o > t; t++) {
            if (t in this && this[t] === e) return t;
          }return -1;
        },
            r = function r(e, t) {
          this.name = e, this.code = DOMException[e], this.message = t;
        },
            s = function s(e, t) {
          if ("" === t) throw new r("SYNTAX_ERR", "An invalid or illegal string was specified");if (/\s/.test(t)) throw new r("INVALID_CHARACTER_ERR", "String contains an invalid character");return i.call(e, t);
        },
            a = function a(e) {
          for (var t = n.call(e.getAttribute("class") || ""), o = t ? t.split(/\s+/) : [], i = 0, r = o.length; r > i; i++) {
            this.push(o[i]);
          }this._updateClassName = function () {
            e.setAttribute("class", "" + this);
          };
        },
            l = a.prototype = [],
            c = function c() {
          return new a(this);
        };if (r.prototype = Error.prototype, l.item = function (e) {
          return this[e] || null;
        }, l.contains = function (e) {
          return e += "", -1 !== s(this, e);
        }, l.add = function () {
          var e,
              t = arguments,
              o = 0,
              n = t.length,
              i = !1;do {
            e = t[o] + "", -1 === s(this, e) && (this.push(e), i = !0);
          } while (++o < n);i && this._updateClassName();
        }, l.remove = function () {
          var e,
              t,
              o = arguments,
              n = 0,
              i = o.length,
              r = !1;do {
            for (e = o[n] + "", t = s(this, e); -1 !== t;) {
              this.splice(t, 1), r = !0, t = s(this, e);
            }
          } while (++n < i);r && this._updateClassName();
        }, l.toggle = function (e, t) {
          e += "";var o = this.contains(e),
              n = o ? !0 !== t && "remove" : !1 !== t && "add";return n && this[n](e), !0 === t || !1 === t ? t : !o;
        }, l.toString = function () {
          return this.join(" ");
        }, o.defineProperty) {
          var d = { get: c, enumerable: !0, configurable: !0 };try {
            o.defineProperty(t, "classList", d);
          } catch (e) {
            void 0 !== e.number && -2146823252 !== e.number || (d.enumerable = !1, o.defineProperty(t, "classList", d));
          }
        } else o.prototype.__defineGetter__ && t.__defineGetter__("classList", c);
      }
    }(window.self), function () {
      "use strict";
      var e = document.createElement("_");if (e.classList.add("c1", "c2"), !e.classList.contains("c2")) {
        var t = function t(e) {
          var t = DOMTokenList.prototype[e];DOMTokenList.prototype[e] = function (e) {
            var o,
                n = arguments.length;for (o = 0; n > o; o++) {
              e = arguments[o], t.call(this, e);
            }
          };
        };t("add"), t("remove");
      }if (e.classList.toggle("c3", !1), e.classList.contains("c3")) {
        var o = DOMTokenList.prototype.toggle;DOMTokenList.prototype.toggle = function (e, t) {
          return 1 in arguments && !this.contains(e) == !t ? t : o.call(this, e);
        };
      }e = null;
    }());
  }, function (e, t, o) {
    "use strict";
    e.exports = o(25).polyfill();
  }, function (e, t, o) {
    (function (t) {
      !function (t, o) {
        e.exports = function () {
          "use strict";
          function e(e) {
            var t = typeof e === "undefined" ? "undefined" : _typeof(e);return null !== e && ("object" === t || "function" === t);
          }function o(e) {
            return "function" == typeof e;
          }function n(e) {
            R = e;
          }function i(e) {
            H = e;
          }function r() {
            return void 0 !== B ? function () {
              B(a);
            } : s();
          }function s() {
            var e = setTimeout;return function () {
              return e(a, 1);
            };
          }function a() {
            for (var e = 0; P > e; e += 2) {
              (0, X[e])(X[e + 1]), X[e] = void 0, X[e + 1] = void 0;
            }P = 0;
          }function l(e, t) {
            var o = this,
                n = new this.constructor(d);void 0 === n[K] && D(n);var i = o._state;if (i) {
              var r = arguments[i - 1];H(function () {
                return x(i, n, r, o._result);
              });
            } else C(o, n, e, t);return n;
          }function c(e) {
            var t = this;if (e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.constructor === t) return e;var o = new t(d);return _(o, e), o;
          }function d() {}function u() {
            return new TypeError("You cannot resolve a promise with itself");
          }function p() {
            return new TypeError("A promises callback cannot return that same promise.");
          }function f(e) {
            try {
              return e.then;
            } catch (e) {
              return Q.error = e, Q;
            }
          }function h(e, t, o, n) {
            try {
              e.call(t, o, n);
            } catch (e) {
              return e;
            }
          }function m(e, t, o) {
            H(function (e) {
              var n = !1,
                  i = h(o, t, function (o) {
                n || (n = !0, t !== o ? _(e, o) : y(e, o));
              }, function (t) {
                n || (n = !0, w(e, t));
              }, "Settle: " + (e._label || " unknown promise"));!n && i && (n = !0, w(e, i));
            }, e);
          }function v(e, t) {
            t._state === J ? y(e, t._result) : t._state === Z ? w(e, t._result) : C(t, void 0, function (t) {
              return _(e, t);
            }, function (t) {
              return w(e, t);
            });
          }function g(e, t, n) {
            t.constructor === e.constructor && n === l && t.constructor.resolve === c ? v(e, t) : n === Q ? (w(e, Q.error), Q.error = null) : void 0 === n ? y(e, t) : o(n) ? m(e, t, n) : y(e, t);
          }function _(t, o) {
            t === o ? w(t, u()) : e(o) ? g(t, o, f(o)) : y(t, o);
          }function b(e) {
            e._onerror && e._onerror(e._result), j(e);
          }function y(e, t) {
            e._state === G && (e._result = t, e._state = J, 0 !== e._subscribers.length && H(j, e));
          }function w(e, t) {
            e._state === G && (e._state = Z, e._result = t, H(b, e));
          }function C(e, t, o, n) {
            var i = e._subscribers,
                r = i.length;e._onerror = null, i[r] = t, i[r + J] = o, i[r + Z] = n, 0 === r && e._state && H(j, e);
          }function j(e) {
            var t = e._subscribers,
                o = e._state;if (0 !== t.length) {
              for (var n = void 0, i = void 0, r = e._result, s = 0; t.length > s; s += 3) {
                n = t[s], i = t[s + o], n ? x(o, n, i, r) : i(r);
              }e._subscribers.length = 0;
            }
          }function E(e, t) {
            try {
              return e(t);
            } catch (e) {
              return Q.error = e, Q;
            }
          }function x(e, t, n, i) {
            var r = o(n),
                s = void 0,
                a = void 0,
                l = void 0,
                c = void 0;if (r) {
              if (s = E(n, i), s === Q ? (c = !0, a = s.error, s.error = null) : l = !0, t === s) return void w(t, p());
            } else s = i, l = !0;t._state !== G || (r && l ? _(t, s) : c ? w(t, a) : e === J ? y(t, s) : e === Z && w(t, s));
          }function q(e, t) {
            try {
              t(function (t) {
                _(e, t);
              }, function (t) {
                w(e, t);
              });
            } catch (t) {
              w(e, t);
            }
          }function T() {
            return ee++;
          }function D(e) {
            e[K] = ee++, e._state = void 0, e._result = void 0, e._subscribers = [];
          }function I() {
            return Error("Array Methods must be provided an Array");
          }function S(e) {
            return new te(this, e).promise;
          }function N(e) {
            var t = this;return new t(z(e) ? function (o, n) {
              for (var i = e.length, r = 0; i > r; r++) {
                t.resolve(e[r]).then(o, n);
              }
            } : function (e, t) {
              return t(new TypeError("You must pass an array to race."));
            });
          }function k(e) {
            var t = this,
                o = new t(d);return w(o, e), o;
          }function A() {
            throw new TypeError("You must pass a resolver function as the first argument to the promise constructor");
          }function L() {
            throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
          }function M() {
            var e = void 0;if (void 0 !== t) e = t;else if ("undefined" != typeof self) e = self;else try {
              e = Function("return this")();
            } catch (e) {
              throw Error("polyfill failed because global object is unavailable in this environment");
            }var o = e.Promise;if (o) {
              var n = null;try {
                n = Object.prototype.toString.call(o.resolve());
              } catch (e) {}if ("[object Promise]" === n && !o.cast) return;
            }e.Promise = oe;
          }var O = void 0;O = Array.isArray ? Array.isArray : function (e) {
            return "[object Array]" === Object.prototype.toString.call(e);
          };var z = O,
              P = 0,
              B = void 0,
              R = void 0,
              H = function H(e, t) {
            X[P] = e, X[P + 1] = t, 2 === (P += 2) && (R ? R(a) : $());
          },
              W = "undefined" != typeof window ? window : void 0,
              F = W || {},
              V = F.MutationObserver || F.WebKitMutationObserver,
              Y = "undefined" == typeof self && "undefined" != typeof process && "[object process]" === {}.toString.call(process),
              U = "undefined" != typeof Uint8ClampedArray && "undefined" != typeof importScripts && "undefined" != typeof MessageChannel,
              X = Array(1e3),
              $ = void 0;$ = Y ? function () {
            return function () {
              return process.nextTick(a);
            };
          }() : V ? function () {
            var e = 0,
                t = new V(a),
                o = document.createTextNode("");return t.observe(o, { characterData: !0 }), function () {
              o.data = e = ++e % 2;
            };
          }() : U ? function () {
            var e = new MessageChannel();return e.port1.onmessage = a, function () {
              return e.port2.postMessage(0);
            };
          }() : void 0 === W ? function () {
            try {
              var e = Function("return this")().require("vertx");return B = e.runOnLoop || e.runOnContext, r();
            } catch (e) {
              return s();
            }
          }() : s();var K = Math.random().toString(36).substring(2),
              G = void 0,
              J = 1,
              Z = 2,
              Q = { error: null },
              ee = 0,
              te = function () {
            function e(e, t) {
              this._instanceConstructor = e, this.promise = new e(d), this.promise[K] || D(this.promise), z(t) ? (this.length = t.length, this._remaining = t.length, this._result = Array(this.length), 0 === this.length ? y(this.promise, this._result) : (this.length = this.length || 0, this._enumerate(t), 0 === this._remaining && y(this.promise, this._result))) : w(this.promise, I());
            }return e.prototype._enumerate = function (e) {
              for (var t = 0; this._state === G && e.length > t; t++) {
                this._eachEntry(e[t], t);
              }
            }, e.prototype._eachEntry = function (e, t) {
              var o = this._instanceConstructor,
                  n = o.resolve;if (n === c) {
                var i = f(e);if (i === l && e._state !== G) this._settledAt(e._state, t, e._result);else if ("function" != typeof i) this._remaining--, this._result[t] = e;else if (o === oe) {
                  var r = new o(d);g(r, e, i), this._willSettleAt(r, t);
                } else this._willSettleAt(new o(function (t) {
                  return t(e);
                }), t);
              } else this._willSettleAt(n(e), t);
            }, e.prototype._settledAt = function (e, t, o) {
              var n = this.promise;n._state === G && (this._remaining--, e === Z ? w(n, o) : this._result[t] = o), 0 === this._remaining && y(n, this._result);
            }, e.prototype._willSettleAt = function (e, t) {
              var o = this;C(e, void 0, function (e) {
                return o._settledAt(J, t, e);
              }, function (e) {
                return o._settledAt(Z, t, e);
              });
            }, e;
          }(),
              oe = function () {
            function e(t) {
              this[K] = T(), this._result = this._state = void 0, this._subscribers = [], d !== t && ("function" != typeof t && A(), this instanceof e ? q(this, t) : L());
            }return e.prototype.catch = function (e) {
              return this.then(null, e);
            }, e.prototype.finally = function (e) {
              var t = this,
                  o = t.constructor;return t.then(function (t) {
                return o.resolve(e()).then(function () {
                  return t;
                });
              }, function (t) {
                return o.resolve(e()).then(function () {
                  throw t;
                });
              });
            }, e;
          }();return oe.prototype.then = l, oe.all = S, oe.race = N, oe.resolve = c, oe.reject = k, oe._setScheduler = n, oe._setAsap = i, oe._asap = H, oe.polyfill = M, oe.Promise = oe, oe;
        }();
      }();
    }).call(t, o(26));
  }, function (e, t) {
    var o;o = function () {
      return this;
    }();try {
      o = o || Function("return this")() || (0, eval)("this");
    } catch (e) {
      "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && (o = window);
    }e.exports = o;
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.addNewLine = o(28).addNewLine, t.autofocus = o(29).autofocus, t.backspace = o(30).backspace, t.bold = o(31).bold, t.cleanHTML = o(32).cleanHTML, t.color = o(33).color, o(34), t.enter = o(35).enter, t.errorMessages = o(36).errorMessages, t.font = o(37).font, t.formatBlock = o(38).formatBlock, t.fullsize = o(39).fullsize, t.iframe = o(40).iframe, t.indent = o(41).indent, t.imageInlineToolbar = o(42).imageInlineToolbar, t.imageProcessor = o(43).imageProcessor, t.imageProperties = o(44).imageProperties, t.inlinePopup = o(45).inlinePopup, t.justify = o(46).justify, t.link = o(47).link, t.mobile = o(48).mobile, t.orderedlist = o(49).orderedlist, t.paste = o(50).paste, t.placeholder = o(51).placeholder, t.redoundo = o(52).redoundo, t.resizer = o(53).resizer, t.size = o(54).size, t.source = o(55).source, t.symbols = o(56).symbols, t.hotkeys = o(57).hotkeys, t.table = o(58).TableProcessor, t.tableKeyboardNavigation = o(61).tableKeyboardNavigation, t.search = o(62).search, t.sticky = o(63).sticky;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      if (e.options.addNewLine) {
        var t,
            o,
            n = r.dom('<div role="button" tabIndex="-1" title="' + e.i18n("Break") + '" class="jodit-add-new-line"><span>' + s.ToolbarIcon.getIcon("enter") + "</span></div>", e.ownerDocument),
            i = n.querySelector("span"),
            c = RegExp("^(" + e.options.addNewLineTagsTriggers.join("|") + ")$", "i"),
            d = !1,
            u = !1,
            p = function p() {
          e.options.readonly || e.container.classList.contains("jodit_popup_active") || (clearTimeout(t), n.classList.toggle("jodit-add-new-line_after", !u), n.style.display = "block", n.style.width = e.editor.clientWidth + "px", d = !1);
        },
            f = function f() {
          clearTimeout(t), n.style.display = "none", d = !0;
        },
            h = function h(e) {
          return null !== e && l.Dom.isBlock(e) && !/^(img|table|iframe|hr)$/i.test(e.nodeName);
        },
            m = function m() {
          d || (clearTimeout(t), t = window.setTimeout(f, 500));
        };e.events.on("afterInit", function () {
          e.container.appendChild(n), e.events.on(n, "mousemove", function (e) {
            e.stopPropagation();
          }).on(i, "mousedown touchstart", function (t) {
            var n = e.editorDocument.createElement(e.options.enter);n.appendChild(e.editorDocument.createTextNode(a.INVISIBLE_SPACE)), u && o && o.parentNode ? o.parentNode.insertBefore(n, o) : e.editor.appendChild(n), e.selection.setCursorIn(n), e.setEditorValue(), f(), t.preventDefault();
          });
        }).on("change afterInit afterSetMode", r.debounce(function () {
          e.events.on(e.editor, "scroll", function () {
            f();
          }).on(e.container, "mouseleave", function () {
            m();
          }).on(e.editor, "mousemove", r.debounce(function (t) {
            var i = e.editorDocument.elementFromPoint(t.pageX - e.editorWindow.pageXOffset, t.pageY - e.editorWindow.pageYOffset);if (i && i !== n && l.Dom.isOrContains(e.editor, i)) {
              if (!((o = i) && o.nodeName.match(c) && l.Dom.isOrContains(e.editor, o) || (o = l.Dom.closest(o, c, e.editor)))) return void m();if (o.nodeName.match(c)) {
                var s = l.Dom.up(o, l.Dom.isBlock, e.editor);s && s !== e.editor && (o = s);
              }var a = r.offset(o, e),
                  d = !1;10 > Math.abs(t.pageY - a.top) && (d = a.top, u = !0), 10 > Math.abs(t.pageY - (a.top + a.height)) && (d = a.top + a.height, u = !1), !1 !== d && (u && !l.Dom.prev(o, h, e.editor) || !u && !l.Dom.next(o, h, e.editor)) ? (n.style.top = d + "px", p()) : (o = !1, m());
            }
          }, e.options.observer.timeout));
        }, e.options.observer.timeout));
      }
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(0),
        s = o(5),
        a = o(2),
        l = o(3);i.Config.prototype.addNewLine = !0, i.Config.prototype.addNewLineTagsTriggers = ["table", "iframe", "img", "hr", "jodit"], t.addNewLine = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t;e.events.on("afterInit", function () {
        e.options.autofocus && (e.options.observer.timeout ? t = window.setTimeout(e.selection.focus, 300) : e.selection.focus());
      }).on("beforeDestruct", function () {
        clearTimeout(t);
      });
    }Object.defineProperty(t, "__esModule", { value: !0 }), o(1).Config.prototype.autofocus = !1, t.autofocus = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t = function t(_t) {
        var o,
            n = _t;r.normalizeNode(_t);do {
          var a = n.innerHTML.replace(i.INVISIBLE_SPACE_REG_EXP, "");if (a.length && "<br>" !== a || s.Dom.isCell(n, e.editorWindow) || !n.parentNode || _t === e.editor) break;o = n.parentNode, n.parentNode.removeChild(n), n = o;
        } while (n && n !== e.editor);
      },
          o = function o(t, n, r) {
        if (t.node && t.node.nodeType === Node.TEXT_NODE && "string" == typeof t.node.nodeValue) {
          for (var a = n ? t.node.nodeValue.length : 0, l = a, c = t.node.nodeValue, d = n ? -1 : 1; a >= 0 && c.length >= a && c[a + (n ? -1 : 0)] === i.INVISIBLE_SPACE;) {
            a += d;
          }a !== l && (n ? c = c.substr(0, a) + c.substr(l) : (c = c.substr(0, l) + c.substr(a), a = l), t.node.nodeValue = c), r.setStart(t.node, a), r.collapse(!0), e.selection.selectRange(r);var u = s.Dom.findInline(t.node, n, e.editor);if (c.length) {
            if (n) {
              if (a) return t.node.nodeValue = c.substr(0, a - 1) + c.substr(a), t.node.nodeValue.length || (t.node.nodeValue = i.INVISIBLE_SPACE), r.setStart(t.node, a - 1), r.collapse(!0), e.selection.selectRange(r), !1;
            } else if (c.length > a) return t.node.nodeValue = c.substr(0, a) + c.substr(a + 1), t.node.nodeValue.length || (t.node.nodeValue = i.INVISIBLE_SPACE), r.setStart(t.node, a), r.collapse(!0), e.selection.selectRange(r), !1;
          } else r.setStartBefore(t.node), r.collapse(!0), e.selection.selectRange(r), t.node && t.node.parentNode && t.node.parentNode.removeChild(t.node), t.node = u;if (u && (s.Dom.isInlineBlock(u) && (u = n ? u.lastChild : u.firstChild), u && u.nodeType === Node.TEXT_NODE)) return t.node = u, o(t, n, r);
        }
      };e.events.on("afterCommand", function (t) {
        if ("delete" === t) {
          var o = e.selection.current();if (o && o.firstChild && "BR" === o.firstChild.nodeName && o.removeChild(o.firstChild), !r.trim(e.editor.innerText) && !e.editor.querySelector("img")) {
            e.editor.innerHTML = "";var n = e.selection.setCursorIn(e.editor);n.parentNode && n.parentNode.removeChild(n);
          }
        }
      }).on("keydown", function (n) {
        if (n.which === i.KEY_BACKSPACE || n.keyCode === i.KEY_DELETE) {
          var a = n.which === i.KEY_BACKSPACE;if (e.selection.isFocused() || e.selection.focus(), !e.selection.isCollapsed()) return e.execCommand("Delete"), !1;var l = e.editorWindow.getSelection(),
              c = !!l.rangeCount && l.getRangeAt(0);if (!c) return !1;var d = e.ownerDocument.createTextNode(i.INVISIBLE_SPACE),
              u = e.editorDocument.createElement("span");try {
            if (c.insertNode(d), !s.Dom.isOrContains(e.editor, d)) return !1;var p = s.Dom.up(d, s.Dom.isBlock, e.editor),
                f = s.Dom.findInline(d, a, e.editor);if (f) {
              var h = { node: f };if (!1 === o(h, a, c)) return !1;if ((f = h.node || d.parentNode) === e.editor) return !1;if (f && f.nodeName.match(/^(IMG|BR|IFRAME|SCRIPT|INPUT|TEXTAREA|TABLE|HR)$/)) return f.parentNode && f.parentNode.removeChild(f), !1;
            }if (p && p.nodeName.match(/^(TD)$/)) return !1;var m = a ? s.Dom.prev(f || d, s.Dom.isBlock, e.editor) : s.Dom.next(f || d, s.Dom.isBlock, e.editor);if (!m && p && p.parentNode) {
              m = e.editorDocument.createElement(e.options.enter);for (var h = p; h && h.parentNode && h.parentNode !== e.editor;) {
                h = h.parentNode;
              }h.parentNode && h.parentNode.insertBefore(m, h);
            }if (m) {
              var v = e.selection.setCursorIn(m, !a);e.selection.insertNode(u, !1), v.nodeType === Node.TEXT_NODE && v.nodeValue === i.INVISIBLE_SPACE && v.parentNode && v.parentNode.removeChild(v);
            }if (p) {
              if (t(p), m && p.parentNode && (p.nodeName === m.nodeName && p.parentNode && m.parentNode && p.parentNode !== e.editor && m.parentNode !== e.editor && p.parentNode !== m.parentNode && p.parentNode.nodeName === m.parentNode.nodeName && (p = p.parentNode, m = m.parentNode), s.Dom.moveContent(p, m, !a), r.normalizeNode(m)), m && "LI" === m.nodeName) {
                var g = s.Dom.closest(m, "Ul|OL", e.editor);if (g) {
                  var _ = g.nextSibling;_ && _.nodeName === g.nodeName && g !== _ && (s.Dom.moveContent(_, g, !a), _.parentNode && _.parentNode.removeChild(_));
                }
              }if (t(p), u) {
                var v = e.selection.setCursorBefore(u);v.parentNode && v.parentNode.removeChild(v);
              }return !1;
            }
          } finally {
            u.parentNode && u.parentNode.removeChild(u), d.parentNode && d.nodeValue === i.INVISIBLE_SPACE && d.parentNode.removeChild(d);
          }return !1;
        }
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(2),
        r = o(0),
        s = o(3);t.backspace = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t = function t(_t2) {
        var o = i({}, r.Jodit.defaultOptions.controls[_t2].css),
            n = {};Object.keys(o).forEach(function (e) {
          n[e] = Array.isArray(o[e]) ? o[e][0] : o[e];
        });var s = r.Jodit.defaultOptions.controls[_t2];return e.selection.applyCSS(n, s.tags ? s.tags[0] : void 0, s.css), e.setEditorValue(), !1;
      };e.registerCommand("bold", { exec: t, hotkeys: "ctrl+b" }), e.registerCommand("italic", { exec: t, hotkeys: "ctrl+i" }), e.registerCommand("underline", { exec: t, hotkeys: "ctrl+u" }), e.registerCommand("strikethrough", { exec: t });
    }var i = this && this.__assign || Object.assign || function (e) {
      for (var t, o = 1, n = arguments.length; n > o; o++) {
        t = arguments[o];for (var i in t) {
          Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        }
      }return e;
    };Object.defineProperty(t, "__esModule", { value: !0 });var r = o(6),
        s = o(1);s.Config.prototype.controls.bold = { tagRegExp: /^(strong|b)$/i, tags: ["strong", "b"], css: { "font-weight": ["bold", "700"] }, tooltip: "Bold" }, s.Config.prototype.controls.italic = { tagRegExp: /^(em|i)$/i, tags: ["em", "i"], css: { "font-style": "italic" }, tooltip: "Italic" }, s.Config.prototype.controls.underline = { tagRegExp: /^(u)$/i, tags: ["u"], css: { "text-decoration": "underline" }, tooltip: "Underline" }, s.Config.prototype.controls.strikethrough = { tagRegExp: /^(s)$/i, tags: ["s"], css: { "text-decoration": "line-through" }, tooltip: "Strike through" }, t.bold = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      if (e.options.cleanHTML.cleanOnPaste && e.events.on("processPaste", function (e, t) {
        return s.cleanFromWord(t);
      }), e.options.cleanHTML.allowTags) {
        var t = /([^\[]*)\[([^\]]+)]/,
            o = /[\s]*,[\s]*/,
            n = /^(.*)[\s]*=[\s]*(.*)$/,
            i = {};"string" == typeof e.options.cleanHTML.allowTags ? e.options.cleanHTML.allowTags.split(o).map(function (e) {
          e = s.trim(e);var r = t.exec(e),
              a = {},
              l = function l(e) {
            e = s.trim(e);var t = n.exec(e);t ? a[t[1]] = t[2] : a[e] = !0;
          };if (r) {
            var c = r[2].split(o);r[1] && (c.map(l), i[r[1].toUpperCase()] = a);
          } else i[e.toUpperCase()] = !0;
        }) : i = e.options.cleanHTML.allowTags, e.events.on("beforeSetElementValue", function (t) {
          if (e.getRealMode() === r.MODE_WYSIWYG) {
            var o = a.Dom.create("div", "", e.editorDocument),
                n = null,
                s = [],
                l = void 0,
                c = 0;for (o.innerHTML = t.value, o.firstChild && (n = o.firstChild); n;) {
              if (n && n.nodeName) if (i[n.nodeName]) {
                if (!0 !== i[n.nodeName] && n.attributes && n.attributes.length) {
                  for (l = [], c = 0; n.attributes.length > c; c += 1) {
                    (!i[n.nodeName][n.attributes[c].name] || !0 !== i[n.nodeName][n.attributes[c].name] && i[n.nodeName][n.attributes[c].name] !== n.attributes[c].value) && l.push(n.attributes[c].name);
                  }for (c = 0; l.length >= c; c += 1) {
                    n.removeAttribute(l[c]);
                  }
                }
              } else s.push(n);n = a.Dom.next(n, function (e) {
                return !!e;
              }, o, !0);
            }var d;for (c = 0; s.length > c; c += 1) {
              d = s[c].parentNode, s[c] && d && d.removeChild(s[c]);
            }t.value = o.innerHTML;
          }
        });
      }e.events.on("keyup", function () {
        if (e.selection.isCollapsed()) {
          var t = e.selection.current();if (t && t.nodeType === Node.TEXT_NODE && t.nodeValue !== r.INVISIBLE_SPACE) for (; t = a.Dom.findInline(t, !0, e.editor);) {
            t && t.nodeType === Node.TEXT_NODE && t.nodeValue && t.nodeValue.match(r.INVISIBLE_SPACE_REG_EXP) && (t.nodeValue = t.nodeValue.replace(r.INVISIBLE_SPACE_REG_EXP, ""));
          }
        }
      }).on("afterCommand", function (t) {
        var o,
            n,
            i = e.selection;switch (t.toLowerCase()) {case "inserthorizontalrule":
            (o = e.editor.querySelector("hr[id=null]")) && (n = a.Dom.next(o, a.Dom.isBlock, e.editor, !1), n || (n = a.Dom.create(e.options.enter, "", e.editorDocument)) && a.Dom.after(o, n), i.setCursorIn(n));break;case "removeformat":
            n = i.current();var l = function l(t) {
              switch (t.nodeType) {case Node.ELEMENT_NODE:
                  a.Dom.each(t, l), "FONT" === t.nodeName ? a.Dom.unwrap(t) : ([].slice.call(t.attributes).forEach(function (e) {
                    -1 === ["src", "href", "rel", "content"].indexOf(e.name.toLowerCase()) && t.removeAttribute(e.name);
                  }), s.normalizeNode(t));break;case Node.TEXT_NODE:
                  e.options.cleanHTML.replaceNBSP && t.nodeType === Node.TEXT_NODE && null !== t.nodeValue && t.nodeValue.match(r.SPACE_REG_EXP) && (t.nodeValue = t.nodeValue.replace(r.SPACE_REG_EXP, " "));break;default:
                  t.parentNode && t.parentNode.removeChild(t);}
            };if (i.isCollapsed()) for (; n && n.nodeType !== Node.ELEMENT_NODE && n !== e.editor;) {
              l(n), n && (n = n.parentNode);
            } else e.selection.eachSelection(function (e) {
              l(e);
            });}
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(2),
        s = o(0),
        a = o(3);i.Config.prototype.cleanHTML = { replaceNBSP: !0, cleanOnPaste: !0, allowTags: !1 }, i.Config.prototype.controls.eraser = { command: "removeFormat", tooltip: "Clear Formatting" }, t.cleanHTML = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t = function t(_t3, o, n) {
        var r = i.normalizeColor(n);switch (_t3) {case "background":
            e.selection.applyCSS({ backgroundColor: r || "" });break;case "forecolor":
            e.selection.applyCSS({ color: r || "" });}return e.setEditorValue(), !1;
      };e.registerCommand("forecolor", t), e.registerCommand("background", t);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(0),
        r = o(1),
        s = o(8),
        a = s.Widget.TabsWidget,
        l = s.Widget.ColorPickerWidget,
        c = o(3);r.Config.prototype.controls.brush = { isActive: function isActive(e, t, o) {
        var n = e.selection.current(),
            r = o.container.querySelector("svg");if (n) {
          var s = c.Dom.closest(n, function (t) {
            return c.Dom.isBlock(t) || c.Dom.isNode(t, e.editorWindow) && t.nodeType === Node.ELEMENT_NODE;
          }, e.editor) || e.editor,
              a = "" + i.css(s, "color"),
              l = "" + i.css(s, "background-color");if (a !== "" + i.css(e.editor, "color")) return r && (r.style.fill = a), !0;if (l !== "" + i.css(e.editor, "background-color")) return r && (r.style.fill = l), !0;
        }return r && r.style.fill && (r.style.fill = null), !1;
      }, popup: function popup(e, t, o, n) {
        var r,
            s = "",
            d = "",
            u = null;t && t !== e.editor && c.Dom.isNode(t, e.editorWindow) && t.nodeType === Node.ELEMENT_NODE && (s = "" + i.css(t, "color"), d = "" + i.css(t, "background-color"), u = t);var p = l(e, function (t) {
          u ? u.style.backgroundColor = t : e.execCommand("background", !1, t), n();
        }, d),
            f = l(e, function (t) {
          u ? u.style.color = t : e.execCommand("forecolor", !1, t), n();
        }, s);return r = "background" === e.options.colorPickerDefaultTab ? { Background: p, Text: f } : { Text: f, Background: p }, a(e, r, u);
      }, tooltip: "Fill color or set the text color" }, t.color = n;
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = o(1),
        i = o(3),
        r = o(0),
        s = ["fontWeight", "fontStyle", "fontSize", "color", "backgroundColor", "textDecorationLine", "fontFamily"],
        a = function a(e, t, o, n) {
      var i = r.css(o, t);return i == n[t] && (i = o.parentNode && o !== e.editor && o.parentNode !== e.editor ? a(e, t, o.parentNode, n) : void 0), i;
    },
        l = function l(e, t, o) {
      var n = {};return t && s.forEach(function (i) {
        n[i] = a(e, i, t, o);
      }), n;
    };n.Config.prototype.controls.copyformat = { exec: function exec(e, t) {
        if (t) if (e.buffer.copyformat) e.buffer.copyformat = !1, e.events.off(e.editor, "mouseup.copyformat");else {
          var o = {};s.forEach(function (t) {
            o[t] = r.css(e.editor, t);
          });var n = i.Dom.up(t, function (e) {
            return e && e.nodeType !== Node.TEXT_NODE;
          }, e.editor) || e.editor,
              a = l(e, n, o),
              c = function c() {
            e.buffer.copyformat = !1, e.selection.current() && e.selection.applyCSS(a), e.events.off(e.editor, "mouseup.copyformat");
          };e.events.on(e.editor, "mouseup.copyformat", c), e.buffer.copyformat = !0;
        }
      }, isActive: function isActive(e) {
        return !!e.buffer.copyformat;
      }, tooltip: "Paint format" };
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      e.events.on("keyup", function () {
        if (!e.options.readonly) {
          var t = e.selection.current();if (!1 !== t) {
            var o = s.Dom.up(t, function (t) {
              return t.tagName === e.options.enter.toUpperCase();
            }, e.editor);o && s.Dom.all(o, function (o) {
              o.nodeType === Node.TEXT_NODE && null !== o.nodeValue && r.INVISIBLE_SPACE_REG_EXP.test(o.nodeValue) && 0 !== o.nodeValue.replace(r.INVISIBLE_SPACE_REG_EXP, "").length && (o.nodeValue = o.nodeValue.replace(r.INVISIBLE_SPACE_REG_EXP, ""), o === t && e.selection.setCursorAfter(o));
            });
          }
        }
      }), e.events.on("keydown", function (o) {
        if (o.which === r.KEY_ENTER || o.keyCode === r.KEY_ENTER) {
          e.selection.isCollapsed() || e.execCommand("Delete"), e.selection.focus();var n = e.selection.current(),
              a = e.editorWindow.getSelection(),
              l = a.rangeCount ? a.getRangeAt(0) : e.editorDocument.createRange();n && n !== e.editor || (n = s.Dom.create("text", r.INVISIBLE_SPACE, e.editorDocument), a.rangeCount ? l.insertNode(n) : e.editor.appendChild(n), l.selectNode(n), l.collapse(!1), a.removeAllRanges(), a.addRange(l));var c = void 0,
              d = !!n && s.Dom.up(n, s.Dom.isBlock, e.editor);if (e.options.enter === r.BR || o.shiftKey || s.Dom.closest(n, "PRE|BLOCKQUOTE", e.editor)) {
            var u = s.Dom.create("br", void 0, e.editorDocument);return e.selection.insertNode(u), i.scrollIntoView(u, e.editor), !1;
          }if (!d && n && !s.Dom.prev(n, function (t) {
            return s.Dom.isBlock(t) || !!t && s.Dom.isImage(t, e.ownerWindow);
          }, e.editor)) {
            var p = n;s.Dom.up(p, function (t) {
              t && t.hasChildNodes() && t !== e.editor && (p = t);
            }, e.editor), d = s.Dom.wrap(p, e.options.enter, e), l = a.rangeCount ? a.getRangeAt(0) : e.editorDocument.createRange();
          }if (d) {
            if (!s.Dom.canSplitBlock(d, e.editorWindow)) {
              var u = e.editorDocument.createElement("br");return e.selection.insertNode(u, !1), e.selection.setCursorAfter(u), !1;
            }if ("LI" === d.nodeName && s.Dom.isEmpty(d)) {
              var f = s.Dom.closest(d, "ol|ul", e.editor);if (s.Dom.prev(d, function (e) {
                return e && "LI" === e.nodeName;
              }, f)) {
                if (s.Dom.next(d, function (e) {
                  return e && "LI" === e.nodeName;
                }, f)) {
                  var h = e.editorDocument.createRange();h.setStartBefore(f), h.setEndAfter(d);var m = h.extractContents();f.parentNode && f.parentNode.insertBefore(m, f), c = e.selection.setCursorBefore(f);
                } else c = e.selection.setCursorAfter(f);
              } else c = e.selection.setCursorBefore(f);return d.parentNode && d.parentNode.removeChild(d), t.insertParagraph(e, c), !i.$$("li", f).length && f.parentNode && f.parentNode.removeChild(f), !1;
            }if (e.selection.cursorInTheEdge(!0, d)) c = e.selection.setCursorBefore(d), t.insertParagraph(e, c, "LI" === d.nodeName ? "li" : e.options.enter), e.selection.setCursorIn(d, !0);else if (e.selection.cursorInTheEdge(!1, d)) c = e.selection.setCursorAfter(d), t.insertParagraph(e, c, "LI" === d.nodeName ? "li" : e.options.enter);else {
              var h = e.editorDocument.createRange();h.setStartBefore(d), h.setEnd(l.startContainer, l.startOffset);var m = h.extractContents();d.parentNode && d.parentNode.insertBefore(m, d), e.selection.setCursorIn(d, !0);
            }
          } else t.insertParagraph(e);return !1;
        }
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(0),
        r = o(2),
        s = o(3);t.insertParagraph = function (e, t, o) {
      o || (o = e.options.enter);var n = e.editorDocument.createElement(o);return n.appendChild(e.editorDocument.createTextNode(r.INVISIBLE_SPACE)), e.selection.insertNode(n, !1), e.selection.setCursorIn(n), t && t.parentNode && t.parentNode.removeChild(t), i.scrollIntoView(n, e.editor), n;
    }, t.enter = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      if (e.options.showMessageErrors) {
        var t,
            o = r.dom('<div class="jodit_error_box_for_messages"></div>', e.ownerDocument),
            n = function n() {
          t = 5, [].slice.call(o.childNodes).forEach(function (n) {
            r.css(o, "bottom", t + "px"), t += n.offsetWidth + e.options.showMessageErrorOffsetPx;
          });
        };e.workplace.appendChild(o), e.events.on("errorMessage", function (t, i, s) {
          var a = r.dom('<div class="active ' + (i || "") + '">' + t + "</div>", e.ownerDocument);o.appendChild(a), n(), setTimeout(function () {
            a.classList.remove("active"), setTimeout(function () {
              o.removeChild(a), n();
            }, 300);
          }, s || e.options.showMessageErrorTime);
        });
      }
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(0);i.Config.prototype.showMessageErrors = !0, i.Config.prototype.showMessageErrorTime = 3e3, i.Config.prototype.showMessageErrorOffsetPx = 3, t.errorMessages = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t = function t(_t4, o, n) {
        switch (_t4) {case "fontsize":
            e.selection.applyCSS({ fontSize: i.normalizeSize(n) });break;case "fontname":
            e.selection.applyCSS({ fontFamily: n });}return e.setEditorValue(), !1;
      };e.registerCommand("fontsize", t), e.registerCommand("fontname", t);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(0),
        r = o(1),
        s = o(3);r.Config.prototype.controls.fontsize = { command: "fontSize", list: ["8", "9", "10", "11", "12", "14", "16", "18", "24", "30", "36", "48", "60", "72", "96"], template: function template(e, t, o) {
        return o;
      }, tooltip: "Font size", isActiveChild: function isActiveChild(e, t) {
        var o = e.selection.current();if (o) {
          var n = s.Dom.closest(o, function (t) {
            return s.Dom.isBlock(t) || s.Dom.isNode(t, e.editorWindow) && t.nodeType === Node.ELEMENT_NODE;
          }, e.editor) || e.editor,
              r = i.css(n, "font-size");return !(!r || !t.args || "" + t.args[1] != "" + r);
        }return !1;
      }, isActive: function isActive(e) {
        var t = e.selection.current();if (t) {
          var o = s.Dom.closest(t, function (t) {
            return s.Dom.isBlock(t) || s.Dom.isNode(t, e.editorWindow) && t.nodeType === Node.ELEMENT_NODE;
          }, e.editor) || e.editor;return "" + i.css(o, "font-size") != "" + i.css(e.editor, "font-size");
        }return !1;
      } }, r.Config.prototype.controls.font = { command: "fontname", exec: function exec(e, t, o) {
        e.execCommand(o.command, !1, o.args ? o.args[0] : void 0);
      }, list: { "Helvetica,sans-serif": "Helvetica", "Arial,Helvetica,sans-serif": "Arial", "Georgia,serif": "Georgia", "Impact,Charcoal,sans-serif": "Impact", "Tahoma,Geneva,sans-serif": "Tahoma", "'Times New Roman',Times,serif": "Times New Roman", "Verdana,Geneva,sans-serif": "Verdana" }, template: function template(e, t, o) {
        return '<span style="font-family: ' + t + '">' + o + "</span>";
      }, isActiveChild: function isActiveChild(e, t) {
        var o = e.selection.current(),
            n = function n(e) {
          return e.toLowerCase().replace(/['"]+/g, "").replace(/[^a-z0-9]+/g, ",");
        };if (o) {
          var r = s.Dom.closest(o, function (t) {
            return s.Dom.isBlock(t) || s.Dom.isNode(t, e.editorWindow) && t.nodeType === Node.ELEMENT_NODE;
          }, e.editor) || e.editor,
              a = "" + i.css(r, "font-family");return !(!a || !t.args || n("" + t.args[0]) !== n(a));
        }return !1;
      }, isActive: function isActive(e) {
        var t = e.selection.current();if (t) {
          var o = s.Dom.closest(t, function (t) {
            return s.Dom.isBlock(t) || s.Dom.isNode(t, e.editorWindow) && t.nodeType === Node.ELEMENT_NODE;
          }, e.editor) || e.editor;return "" + i.css(o, "font-family") != "" + i.css(e.editor, "font-family");
        }return !1;
      }, tooltip: "Font family" }, t.font = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      e.registerCommand("formatblock", function (t, o, n) {
        e.selection.focus();var s = !1;if (e.selection.eachSelection(function (t) {
          var o = e.selection.save(),
              r = !!t && i.Dom.up(t, i.Dom.isBlock, e.editor);if (!r && t && (r = i.Dom.wrap(t, e.options.enter, e)), !r) return e.selection.restore(o), !1;r.tagName.match(/TD|TH|TBODY|TABLE|THEAD/i) ? e.selection.isCollapsed() ? i.Dom.wrap(t, n, e) : e.selection.applyCSS({}, n) : i.Dom.replace(r, n, !0, !1, e.editorDocument), s = !0, e.selection.restore(o);
        }), !s) {
          var a = i.Dom.create(n, r.INVISIBLE_SPACE, e.editorDocument);e.selection.insertNode(a, !1), e.selection.setCursorIn(a);
        }return e.setEditorValue(), !1;
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(3),
        r = o(2);o(1).Config.prototype.controls.paragraph = { command: "formatBlock", getLabel: function getLabel(e, t, o) {
        var n = e.selection.current();if (n && e.options.textIcons) {
          var r = i.Dom.closest(n, i.Dom.isBlock, e.editor) || e.editor,
              s = r.nodeName.toLowerCase();t.data && t.data.currentValue !== s && t.list && t.list[s] && (o.textBox.innerHTML = "<span>" + t.list[s] + "</span>", o.textBox.firstChild.classList.add("jodit_icon"), t.data.currentValue = s);
        }return !1;
      }, exec: function exec(e, t, o) {
        e.execCommand(o.command, !1, o.args ? o.args[0] : void 0);
      }, data: { currentValue: "left" }, list: { p: "Normal", h1: "Heading 1", h2: "Heading 2", h3: "Heading 3", h4: "Heading 4", blockquote: "Quote", pre: "Code" }, isActiveChild: function isActiveChild(e, t) {
        var o = e.selection.current();if (o) {
          var n = i.Dom.closest(o, i.Dom.isBlock, e.editor);return n && n !== e.editor && void 0 !== t.args && n.nodeName.toLowerCase() === t.args[0];
        }return !1;
      }, isActive: function isActive(e, t) {
        var o = e.selection.current();if (o) {
          var n = i.Dom.closest(o, i.Dom.isBlock, e.editor);return n && n !== e.editor && void 0 !== t.list && "p" !== n.nodeName.toLowerCase() && void 0 !== t.list[n.nodeName.toLowerCase()];
        }return !1;
      }, template: function template(e, t, o) {
        return "<" + t + ' class="jodit_list_element"><span>' + e.i18n(o) + "</span></" + t + "></li>";
      }, tooltip: "Insert format block" }, t.formatBlock = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t = !1,
          o = 0,
          n = 0,
          i = !1,
          a = function a() {
        e.events && (t ? (o = r.css(e.container, "height"), n = r.css(e.container, "width"), r.css(e.container, { height: e.ownerWindow.innerHeight, width: e.ownerWindow.innerWidth }), i = !0) : i && r.css(e.container, { height: o || "auto", width: n || "auto" }));
      },
          l = function l(o) {
        if (void 0 === o && (o = !e.container.classList.contains("jodit_fullsize")), t = o, e.container.classList.toggle("jodit_fullsize", o), e.toolbar) {
          r.css(e.toolbar.container, "width", "auto");var n = r.dom(s.ToolbarIcon.getIcon(o ? "shrink" : "fullsize"), e.ownerDocument),
              i = e.toolbar.container.querySelector(".jodit_toolbar_btn-fullsize a");i && (n.classList.add("jodit_icon"), i.innerHTML = "", i.appendChild(n));
        }if (e.options.globalFullsize) {
          for (var l = e.container.parentNode; l && !(l instanceof Document);) {
            l.classList.toggle("jodit_fullsize_box", o), l = l.parentNode;
          }a();
        }e.events.fire("afterResize");
      };e.options.fullsize && e.events.on("afterInit", function () {
        l(!0);
      }), e.options.globalFullsize && e.events.on(e.ownerWindow, "resize", a), e.events.on("toggleFullsize", l), e.events.on("beforeDestruct", function () {
        l(!1);
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(0),
        s = o(5),
        a = o(2);i.Config.prototype.fullsize = !1, i.Config.prototype.globalFullsize = !0, i.Config.prototype.controls.fullsize = { exec: function exec(e) {
        e.events.fire("toggleFullsize");
      }, tooltip: "Open editor in fullsize", mode: a.MODE_SOURCE + a.MODE_WYSIWYG }, t.fullsize = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      e.events.on("generateDocumentStructure.iframe", function (t) {
        if (t.open(), t.write('<!DOCTYPE html>\n                    <html dir="' + e.options.direction + '" class="jodit" lang="' + r.defaultLanguage(e.options.language) + '">\n                        <head>\n                            ' + (e.options.iframeBaseUrl ? '<base href="' + e.options.iframeBaseUrl + '"/>' : "") + '\n                        </head>\n                        <body class="jodit_wysiwyg" style="outline:none" contenteditable="true"></body>\n                    </html>'), t.close(), e.options.iframeCSSLinks && e.options.iframeCSSLinks.forEach(function (e) {
          var o = r.dom('<link rel="stylesheet" href="' + e + '">', t);t.head.appendChild(o);
        }), e.options.iframeStyle) {
          var o = t.createElement("style");o.innerHTML = e.options.iframeStyle, t.head.appendChild(o);
        }
      }).on("createEditor", function () {
        if (e.options.iframe) {
          e.iframe = e.ownerDocument.createElement("iframe"), e.iframe.style.display = "block", e.iframe.src = "about:blank", e.iframe.className = "jodit_wysiwyg_iframe", e.iframe.frameBorder = "0", e.iframe.setAttribute("allowtransparency", "true"), e.iframe.setAttribute("tabindex", "0"), e.iframe.setAttribute("frameborder", "0"), e.workplace.appendChild(e.iframe);var t = e.iframe.contentWindow.document;if (e.events.fire("generateDocumentStructure.iframe", t), e.editorDocument = t, e.editorWindow = e.iframe.contentWindow, e.editor = t.body, "auto" === e.options.height) {
            t.documentElement.style.overflowY = "hidden";var o = function o() {
              e.editor && r.css(e.iframe, "height", e.editor.offsetHeight);
            };e.events.on("change afterInit afterSetMode resize", o).on([e.iframe, e.editorWindow, t.documentElement], "load", o).on(t, "readystatechange DOMContentLoaded", o);
          }return r.css(e.editor, "minHeight", e.options.minHeight), function (e) {
            e.matches || (e.matches = Element.prototype.matches);
          }(e.editorWindow.Element.prototype), e.events.on(e.editorWindow, "mousedown click mouseup mousemove scroll", function (t) {
            e.events && e.events.fire && e.events.fire(window, t);
          }), !1;
        }
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(0);i.Config.prototype.iframe = !1, i.Config.prototype.iframeBaseUrl = !1, i.Config.prototype.iframeStyle = 'html{margin: 0px;}body{padding:10px;background:transparent;color:#000;position:relative;z-index: 2;user-select:auto;margin:0px;overflow:auto;}body:after{content:"";clear:both;display:block}table{width:100%;border: none;border-collapse:collapse;empty-cells: show;max-width: 100%;}th,td{padding: 2px 5px;border:1px solid #ccc;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}td[data-jodit-selected-cell],th[data-jodit-selected-cell]{border: 1px double #1e88e5}p{margin-top:0;}.jodit_editor .jodit_iframe_wrapper{display: block;clear: both;user-select: none;position: relative;}.jodit_editor .jodit_iframe_wrapper:after {position:absolute;content:"";z-index:1;top:0;left:0;right: 0;bottom: 0;cursor: pointer;display: block;background: rgba(0, 0, 0, 0);} .jodit_disabled{user-select: none;-o-user-select: none;-moz-user-select: none;-khtml-user-select: none;-webkit-user-select: none;-ms-user-select: none}', i.Config.prototype.iframeCSSLinks = [], t.iframe = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t = function t(_t5) {
        return e.selection.eachSelection(function (o) {
          var n = e.selection.save(),
              i = !!o && r.Dom.up(o, r.Dom.isBlock, e.editor);if (!i && o && (i = r.Dom.wrap(o, e.options.enter, e)), !i) return e.selection.restore(n), !1;if (i && i.style) {
            var s = i.style.marginLeft ? parseInt(i.style.marginLeft, 10) : 0;s += e.options.indentMargin * ("outdent" === _t5 ? -1 : 1), i.style.marginLeft = s > 0 ? s + "px" : "", i.getAttribute("style") || i.removeAttribute("style");
          }e.selection.restore(n);
        }), e.setEditorValue(), !1;
      };e.registerCommand("indent", { exec: t, hotkeys: "ctrl+]" }), e.registerCommand("outdent", { exec: t, hotkeys: "ctrl+[" });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(3);i.Config.prototype.controls.indent = { tooltip: "Increase Indent" }, i.Config.prototype.controls.outdent = { isDisable: function isDisable(e) {
        var t = e.selection.current();if (t) {
          var o = r.Dom.closest(t, r.Dom.isBlock, e.editor);if (o && o.style && o.style.marginLeft) return 0 >= parseInt(o.style.marginLeft, 10);
        }return !0;
      }, tooltip: "Decrease Indent" }, i.Config.prototype.indentMargin = 10, t.indent = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      e.events.on("click", function (e) {});
    }Object.defineProperty(t, "__esModule", { value: !0 }), t.imageInlineToolbar = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t,
          o = function o(_o) {
        e.events.off(_o, ".imageProcessor").on(_o, "dragstart.imageProcessor", function (e) {
          t = _o, e.preventDefault();
        }).on(_o, "mousedown.imageProcessor", function () {
          t = _o;
        });
      };e.events.on("afterInit", function () {
        e.events.on(e.editor, "mousemove", i.throttle(function (o) {
          t && e.selection.insertCursorAtPoint(o.clientX, o.clientY);
        }, e.options.observer.timeout)).on(window, "mouseup", function () {
          t = !1;
        }).on(e.editor, "mouseup", function (o) {
          var n,
              i = t;if (i && o.target !== i) {
            if (!1 === e.selection.insertCursorAtPoint(o.clientX, o.clientY)) return !1;n = !i.parentNode || "A" !== i.parentNode.tagName || i.parentNode.textContent && i.parentNode.textContent.length ? i : i.parentNode, n.parentNode && n.parentNode.removeChild(n), n && e.selection.insertImage(n), e.selection.select(n);
          }
        });
      }), e.events.on("change afterInit", i.debounce(function () {
        e.editor && i.$$("img", e.editor).forEach(function (t) {
          t[r] || (t[r] = !0, o(t), t.complete || t.addEventListener("load", function o() {
            e.events && e.events.fire && e.events.fire("resize"), t.removeEventListener("load", o);
          }));
        });
      }, e.options.observer.timeout));
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(0),
        r = "__jodit_imageprocessor_binded";t.imageProcessor = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t = function t(_t6) {
        if (!e.options.readonly) {
          var o,
              n = this,
              r = new a.Dialog(e),
              d = s.dom('<a href="javascript:void(0)" style="float:right;" class="jodit_button">' + l.ToolbarIcon.getIcon("cancel") + "<span>" + e.i18n("Cancel") + "</span></a>", e.ownerDocument),
              f = s.dom('<a href="javascript:void(0)" style="float:left;" class="jodit_button">' + l.ToolbarIcon.getIcon("check") + "<span>" + e.i18n("Ok") + "</span></a>", e.ownerDocument),
              h = { remove: s.dom('<a href="javascript:void(0)" class="jodit_button">' + l.ToolbarIcon.getIcon("bin") + " " + e.i18n("Delete") + "</a>", e.ownerDocument) },
              m = s.dom('<form class="jodit_properties"><div class="jodit_grid"><div class="jodit_col-lg-2-5"><div class="jodit_properties_view_box"><div style="' + (e.options.image.showPreview ? "" : "display:none") + '" class="jodit_properties_image_view"><img id="imageViewSrc" src="" alt=""/></div><div style="' + (e.options.image.editSize ? "" : "display:none") + '" class="jodit_form_group jodit_properties_image_sizes"><input type="number" id="imageWidth"/><a class="jodit_lock_helper jodit_lock_size" href="javascript:void(0)">' + l.ToolbarIcon.getIcon("lock") + '</a><input type="number" id="imageHeight"/></div></div></div><div id="tabsbox" class="jodit_col-lg-3-5"></div></div></form>', e.ownerDocument),
              v = s.dom('<div style="' + (e.options.image.editMargins ? "" : "display:none") + '" class="jodit_form_group"><label for="marginTop">' + e.i18n("Margins") + '</label><div class="jodit_grid"><input class="jodit_col-lg-1-5 margins" type="text" placeholder="' + e.i18n("top") + '" id="marginTop"/><a style="text-align: center;" class="jodit_lock_helper jodit_lock_margin jodit_col-lg-1-5" href="javascript:void(0)">' + l.ToolbarIcon.getIcon("lock") + '</a><input disabled="true" class="jodit_col-lg-1-5 margins" type="text" placeholder="' + e.i18n("right") + '" id="marginRight"/><input disabled="true" class="jodit_col-lg-1-5 margins" type="text" placeholder="' + e.i18n("bottom") + '" id="marginBottom"/><input disabled="true" class="jodit_col-lg-1-5 margins" type="text" placeholder="' + e.i18n("left") + '" id="marginLeft"/></div></div><div style="' + (e.options.image.editStyle ? "" : "display:none") + '" class="jodit_form_group"><label for="style">' + e.i18n("Styles") + '</label><input type="text" id="style"/></div><div style="' + (e.options.image.editClass ? "" : "display:none") + '" class="jodit_form_group"><label for="classes">' + e.i18n("Classes") + '</label><input type="text" id="classes"/></div><div style="' + (e.options.image.editId ? "" : "display:none") + '" class="jodit_form_group"><label for="id">Id</label><input type="text" id="id"/></div><div style="' + (e.options.image.editAlign ? "" : "display:none") + '" class="jodit_form_group"><label for="align">' + e.i18n("Align") + '</label><select class="select"  id="align"><option value="">' + e.i18n("--Not Set--") + '</option><option value="left">' + e.i18n("Left") + '</option><option value="center">' + e.i18n("Center") + '</option><option value="right">' + e.i18n("Right") + "</option></optgroup></select></div>", e.ownerDocument),
              g = s.dom('<div style="' + (e.options.image.editSrc ? "" : "display:none") + '" class="jodit_form_group"><label for="imageSrc">' + e.i18n("Src") + '</label><div class="jodit_input_group"><input type="text" id="imageSrc"/>' + (e.options.filebrowser.ajax.url || e.options.uploader.url ? '<div class="jodit_input_group-buttons">' + (e.options.filebrowser.ajax.url || e.options.uploader.url ? '<a class="jodit_button jodit_rechange" href="javascript:void(0)">' + l.ToolbarIcon.getIcon("image") + "</a>" : "") + (e.options.image.useImageEditor && void 0 !== i.Jodit.modules.ImageEditor && e.options.filebrowser.ajax.url ? '<a class="jodit_button jodit_use_image_editor" href="javascript:void(0)">' + l.ToolbarIcon.getIcon("crop") + "</a>" : "") + "</div>" : "") + '</div></div><div style="' + (e.options.image.editTitle ? "" : "display:none") + '" class="jodit_form_group"><label for="imageTitle">' + e.i18n("Title") + '</label><input type="text" id="imageTitle"/></div><div style="' + (e.options.image.editAlt ? "" : "display:none") + '" class="jodit_form_group"><label for="imageAlt">' + e.i18n("Alternative") + '</label><input type="text" id="imageAlt"/></div><div style="' + (e.options.image.editLink ? "" : "display:none") + '" class="jodit_form_group"><label for="imageLink">' + e.i18n("Link") + '</label><input type="text" id="imageLink"/></div><div style="' + (e.options.image.editLink ? "" : "display:none") + '" class="jodit_form_group"><input type="checkbox" id="imageLinkOpenInNewTab"/> ' + e.i18n("Open link in new tab") + "</div>", e.ownerDocument),
              _ = n.naturalWidth / n.naturalHeight || 1,
              b = m.querySelector("#imageWidth"),
              y = m.querySelector("#imageHeight"),
              w = function w() {
            n.style.cssFloat && -1 !== ["left", "right"].indexOf(n.style.cssFloat.toLowerCase()) ? s.val(m, "#align", s.css(n, "float")) : "block" === s.css(n, "display") && "auto" === n.style.marginLeft && "auto" === n.style.marginRight && s.val(m, "#align", "center");
          },
              C = function C() {
            s.val(m, "#id", n.getAttribute("id") || "");
          },
              j = function j() {
            s.val(m, "#style", n.getAttribute("style") || "");
          },
              E = function E() {
            s.val(m, "#classes", (n.getAttribute("class") || "").replace(/jodit_focused_image[\s]*/, ""));
          },
              x = function x() {
            if (e.options.image.editMargins) {
              var t = !1;s.$$(".margins", m).forEach(function (e) {
                var o = n.style[e.id];o && (/^[0-9]+(px)?$/.test(o) && (o = parseInt(o, 10)), e.value = "" + o || "", t || "marginTop" === e.id || e.value === s.val(m, "#marginTop") || (t = !0));
              }), N = !t;var o = m.querySelector(".jodit_lock_margin");o && (o.innerHTML = l.ToolbarIcon.getIcon(N ? "lock" : "unlock")), s.$$(".margins:not(#marginTop)", m).forEach(function (e) {
                return N ? e.setAttribute("disabled", "true") : e.removeAttribute("disabled");
              });
            }
          },
              q = function q() {
            b.value = "" + n.offsetWidth, y.value = "" + n.offsetHeight;
          },
              T = function T() {
            n.hasAttribute("title") && s.val(m, "#imageTitle", n.getAttribute("title") || ""), n.hasAttribute("alt") && s.val(m, "#imageAlt", n.getAttribute("alt") || "");var t = c.Dom.closest(n, "a", e.editor);t && (s.val(m, "#imageLink", t.getAttribute("href") || ""), m.querySelector("#imageLinkOpenInNewTab").checked = "_blank" === t.getAttribute("target"));
          },
              D = function D() {
            s.val(m, "#imageSrc", n.getAttribute("src") || "");var e = m.querySelector("#imageViewSrc");e && e.setAttribute("src", n.getAttribute("src") || "");
          },
              I = function I() {
            D(), T(), q(), x(), E(), C(), w(), j();
          },
              S = !0,
              N = !0,
              k = {},
              A = m.querySelector("#tabsbox");k[e.i18n("Image")] = g, k[e.i18n("Advansed")] = v, A && A.appendChild(u(e, k)), I(), e.events.on(r, "afterClose", function () {
            r.destruct(), n.parentNode && e.options.image.selectImageAfterClose && e.selection.select(n);
          }), h.remove.addEventListener("click", function () {
            n.parentNode && n.parentNode.removeChild(n), r.close();
          }), e.options.image.useImageEditor && s.$$(".jodit_use_image_editor", g).forEach(function (t) {
            e.events.on(t, "mousedown touchstart", function () {
              var t = n.getAttribute("src") || "",
                  o = e.ownerDocument.createElement("a"),
                  i = function i() {
                if (o.host !== location.host) return void a.Confirm(e.i18n("You can only edit your own images. Download this image on the host?"), function (t) {
                  t && e.uploader && e.uploader.uploadRemoteImage("" + o.href, function (t) {
                    a.Alert(e.i18n("The image has been successfully uploaded to the host!"), function () {
                      "string" == typeof t.newfilename && (n.setAttribute("src", t.baseurl + t.newfilename), D());
                    });
                  }, function (t) {
                    a.Alert(e.i18n("There was an error loading %s", t.message));
                  });
                });
              };o.href = t, e.getInstance("FileBrowser").getPathByUrl("" + o.href, function (i, r, s) {
                e.getInstance("FileBrowser").openImageEditor(o.href, r, i, s, function () {
                  var e = new Date().getTime();n.setAttribute("src", t + (-1 !== t.indexOf("?") ? "" : "?") + "&_tmp=" + e), D();
                }, function (e) {
                  a.Alert(e.message);
                });
              }, function (e) {
                a.Alert(e.message, i);
              });
            });
          }), s.$$(".jodit_rechange", g).forEach(function (t) {
            t.addEventListener("mousedown", function (o) {
              t.classList.toggle("active");var i = new l.ToolbarPopup(e, t);i.open(p(e, { upload: function upload(e) {
                  e.files && e.files.length && n.setAttribute("src", e.baseurl + e.files[0]), I(), i.close();
                }, filebrowser: function filebrowser(e) {
                  e && e.files && Array.isArray(e.files) && e.files.length && (n.setAttribute("src", e.files[0]), i.close(), I());
                } }, n, i.close), !0), o.stopPropagation();
            });
          });var L = m.querySelector(".jodit_lock_helper.jodit_lock_size"),
              M = m.querySelector(".jodit_lock_helper.jodit_lock_margin");return L && L.addEventListener("click", function () {
            S = !S, this.innerHTML = l.ToolbarIcon.getIcon(S ? "lock" : "unlock"), e.events.fire(b, "change");
          }), M && M.addEventListener("click", function () {
            N = !N, this.innerHTML = l.ToolbarIcon.getIcon(N ? "lock" : "unlock"), N ? s.$$(".margins", m).forEach(function (e) {
              e.matches("#marginTop") || e.setAttribute("disabled", "true");
            }) : s.$$(".margins", m).forEach(function (e) {
              e.matches("#marginTop") || e.removeAttribute("disabled");
            });
          }), e.events.on(s.$$("#imageWidth,#imageHeight", m), "change keydown mousedown paste", function (e) {
            S && (clearTimeout(o), o = window.setTimeout(function () {
              var t = parseInt(b.value, 10),
                  o = parseInt(y.value, 10);"imageWidth" === e.target.getAttribute("id") ? y.value = "" + Math.round(t / _) : b.value = "" + Math.round(o * _);
            }, 100));
          }), r.setTitle([e.i18n("Image properties"), h.remove]), r.setContent(m), d.addEventListener("click", function () {
            r.close();
          }), f.addEventListener("click", function () {
            if (e.options.image.editStyle && (s.val(m, "#style") ? n.setAttribute("style", s.val(m, "#style")) : n.removeAttribute("style")), !s.val(m, "#imageSrc")) return n.parentNode && n.parentNode.removeChild(n), void r.close();n.setAttribute("src", s.val(m, "#imageSrc")), s.val(m, "#imageTitle") ? n.setAttribute("title", s.val(m, "#imageTitle")) : n.removeAttribute("title"), s.val(m, "#imageAlt") ? n.setAttribute("alt", s.val(m, "#imageAlt")) : n.removeAttribute("alt");var t = c.Dom.closest(n, "a", e.editor);s.val(m, "#imageLink") ? (t || (t = c.Dom.wrap(n, "a", e)), t.setAttribute("href", s.val(m, "#imageLink")), m.querySelector("#imageLinkOpenInNewTab").checked ? t.setAttribute("target", "_blank") : t.removeAttribute("target")) : t && t.parentNode && t.parentNode.replaceChild(n, t);var o = function o(e) {
              return e = s.trim(e), /^[0-9]+$/.test(e) ? e + "px" : e;
            };s.css(n, { width: s.trim(b.value) ? o(b.value) : null, height: s.trim(y.value) ? o(y.value) : null }), e.options.image.editMargins && (N ? s.css(n, "margin", o(s.val(m, "#marginTop"))) : s.$$(".margins", m).forEach(function (e) {
              s.css(n, e.id, o(e.value));
            })), e.options.image.editClass && (s.val(m, "#classes") ? n.setAttribute("class", s.val(m, "#classes")) : n.removeAttribute("class")), e.options.image.editId && (s.val(m, "#id") ? n.setAttribute("id", s.val(m, "#id")) : n.removeAttribute("id"));var i = function i() {
              "block" === s.css(n, "display") && s.css(n, "display", ""), "auto" === n.style.marginLeft && "auto" === n.style.marginRight && (n.style.marginLeft = "", n.style.marginRight = "");
            };e.options.image.editAlign && (s.val(m, "#align") ? -1 !== ["right", "left"].indexOf(s.val(m, "#align").toLowerCase()) ? (s.css(n, "float", s.val(m, "#align")), i()) : (s.css(n, "float", ""), s.css(n, { display: "block", "margin-left": "auto", "margin-right": "auto" })) : (s.css(n, "float") && -1 !== ["right", "left"].indexOf(("" + s.css(n, "float")).toLowerCase()) && s.css(n, "float", ""), i())), n.getAttribute("style") || n.removeAttribute("style"), e.setEditorValue(), r.close();
          }), r.setFooter([f, d]), r.setSize(500), r.open(), _t6 && _t6.preventDefault(), !1;
        }
      };e.events.on("afterInit", function () {
        e.options.image.openOnDblClick ? e.events.on(e.editor, "dblclick", t, "img") : e.events.on(e.editor, "dblclick", function () {
          e.selection.select(this);
        }, "img");
      }).on("openImageProperties", function (e) {
        t.call(e);
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(6),
        r = o(1),
        s = o(0),
        a = o(7),
        l = o(5),
        c = o(3),
        d = o(8),
        u = d.Widget.TabsWidget,
        p = d.Widget.ImageSelectorWidget;r.Config.prototype.image = { openOnDblClick: !0, editSrc: !0, useImageEditor: !0, editTitle: !0, editAlt: !0, editLink: !0, editSize: !0, editMargins: !0, editClass: !0, editStyle: !0, editId: !0, editAlign: !0, showPreview: !0, selectImageAfterClose: !0 }, t.imageProperties = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t,
          o = new i.ToolbarCollection(e),
          n = s.dom('<div data-editor_id="' + e.id + '" class="jodit_toolbar_popup-inline"></div>', e.ownerDocument),
          r = function r(t) {
        e.container && e.container.classList && e.container.classList.toggle("jodit_popup_active", t);
      },
          l = function l(t) {
        t && t instanceof e.ownerWindow.Node && a.Dom.isOrContains(n, t) || (n.classList && n.classList.remove("active"), r(!1));
      },
          c = function c(t, i, a) {
        var l = t.tagName.toLowerCase();void 0 !== e.options.popup[l] && (n.innerHTML = '<span class="jodit_popup_triangle"></span>', o.build(e.options.popup[l], n, t), n.classList.add("active"), s.css(n, { left: i + "px", top: a + "px" }), n.style.marginLeft = -Math.round(n.offsetWidth / 2) + "px", r(!0), e.events.fire("afterOpenPopup", n, e.container));
      },
          d = function d(o, n, i) {
        e.options.readonly || (clearTimeout(t), e.options.observer.timeout ? t = setTimeout(c.bind(e, o, n, i), e.options.observer.timeout) : c(o, n, i));
      };e.events.on("hidePopup afterCommand keydown resize", l).on("showPopap", d).on("afterInit", function () {
        e.editorDocument.body.appendChild(n);var t = !1;e.events.on([e.ownerWindow, e.editor], "scroll", l).on(n, "mousedown", function (e) {
          e.stopPropagation();
        }).on(e.editor, "mousedown", function (o) {
          if ("IMG" === o.target.tagName || a.Dom.closest(o.target, "table|a", e.editor)) {
            var n = "IMG" === o.target.tagName ? o.target : a.Dom.closest(o.target, "table|a", e.editor),
                i = s.offset(n, e);d(n, Math.round(i.left + n.offsetWidth / 2), Math.round(i.top + n.offsetHeight)), t = !0;
          } else t = !1;
        }).on(e.ownerWindow, "mousedown", function () {
          t || l(), t = !1;
        });
      }).on("beforeDestruct", function () {
        n.parentNode && n.parentNode.removeChild(n), clearTimeout(t);
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(5),
        r = o(1),
        s = o(0),
        a = o(3),
        l = o(15),
        c = o(8),
        d = c.Widget.ColorPickerWidget,
        u = c.Widget.TabsWidget;r.Config.prototype.popup = { a: [{ name: "eye", tooltip: "Open link", exec: function exec(e, t) {
          var o = t.getAttribute("href");t && o && e.ownerWindow.open(o);
        } }, { name: "link", tooltip: "Edit link", icon: "pencil" }, "unlink", "brush"], img: [{ name: "bin", tooltip: "Delete", exec: function exec(e, t) {
          t.parentNode && t.parentNode.removeChild(t);
        } }, { name: "pencil", exec: function exec(e, t) {
          "img" === t.tagName.toLowerCase() && e.events.fire("openImageProperties", t);
        }, tooltip: "Edit" }, { name: "valign", list: ["Top", "Middle", "Bottom"], tooltip: "Vertical align", exec: function exec(e, t, o) {
          if ("img" === t.tagName.toLowerCase()) {
            var n = o.args && "string" == typeof o.args[1] ? o.args[1].toLowerCase() : "";s.css(t, "vertical-align", n);
          }
        } }, { name: "left", list: ["Left", "Right", "Center", "Normal"], exec: function exec(e, t, o) {
          if ("img" === t.tagName.toLowerCase()) {
            var n = function n() {
              "block" === s.css(t, "display") && s.css(t, "display", ""), "auto" === t.style.marginLeft && "auto" === t.style.marginRight && (t.style.marginLeft = "", t.style.marginRight = "");
            },
                i = o.args && "string" == typeof o.args[1] ? o.args[1].toLowerCase() : "";"normal" !== i ? -1 !== ["right", "left"].indexOf(i) ? (s.css(t, "float", i), n()) : (s.css(t, "float", ""), s.css(t, { display: "block", "margin-left": "auto", "margin-right": "auto" })) : (s.css(t, "float") && -1 !== ["right", "left"].indexOf(s.css(t, "float").toLowerCase()) && s.css(t, "float", ""), n());
          }
        }, tooltip: "Horizontal align" }], table: [{ name: "brush", popup: function popup(e, t, o, n) {
          var i,
              r,
              a,
              c,
              p,
              f,
              h = l.Table.getAllSelectedCells(t);return !!h.length && (c = s.css(h[0], "color"), f = s.css(h[0], "background-color"), p = s.css(h[0], "border-color"), i = d(e, function (e) {
            h.forEach(function (t) {
              s.css(t, "background-color", e);
            }), n();
          }, f), r = d(e, function (e) {
            h.forEach(function (t) {
              s.css(t, "color", e);
            }), n();
          }, c), a = d(e, function (e) {
            h.forEach(function (t) {
              s.css(t, "border-color", e);
            }), n();
          }, p), u(e, { Background: i, Text: r, Border: a }));
        }, tooltip: "Background" }, { name: "valign", list: ["Top", "Middle", "Bottom"], exec: function exec(e, t, o) {
          var n = o.args && "string" == typeof o.args[1] ? o.args[1].toLowerCase() : "";l.Table.getAllSelectedCells(t).forEach(function (e) {
            s.css(e, "vertical-align", n);
          });
        }, tooltip: "Vertical align" }, { name: "splitv", command: "tablesplitv", tooltip: "Split vertical" }, { name: "splitg", command: "tablesplitg", tooltip: "Split horizontal" }, "\n", { name: "merge", command: "tablemerge", tooltip: "Merge" }, { name: "addcolumn", list: { tableaddcolumnbefore: "Insert column before", tableaddcolumnafter: "Insert column after" }, exec: function exec(e, t, o) {
          e.execCommand(o.args && "string" == typeof o.args[0] ? o.args[0].toLowerCase() : "", !1, t);
        }, tooltip: "Add column" }, { name: "addrow", list: { tableaddrowbefore: "Insert row above", tableaddrowafter: "Insert row below" }, exec: function exec(e, t, o) {
          e.execCommand(o.args && "string" == typeof o.args[0] ? o.args[0].toLowerCase() : "", !1, t);
        }, tooltip: "Add row" }, { name: "bin", list: { tablebin: "Delete table", tablebinrow: "Delete row", tablebincolumn: "Delete column", tableempty: "Empty cell" }, exec: function exec(e, t, o) {
          e.execCommand(o.args && "string" == typeof o.args[0] ? o.args[0].toLowerCase() : "", !1, t);
        }, tooltip: "Delete" }] }, t.inlinePopup = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t = function t(_t7) {
        var o = function o(_o2) {
          if (_o2 instanceof e.editorWindow.HTMLElement) switch (_t7.toLowerCase()) {case "justifyfull":
              _o2.style.textAlign = "justify";break;case "justifyright":
              _o2.style.textAlign = "right";break;case "justifyleft":
              _o2.style.textAlign = "left";break;case "justifycenter":
              _o2.style.textAlign = "center";}
        };return e.selection.focus(), e.selection.eachSelection(function (t) {
          if (!t && e.editor.querySelector(".jodit_selected_cell")) return i.$$(".jodit_selected_cell", e.editor).forEach(o), !1;if (t instanceof e.editorWindow.Node) {
            var n = !!t && r.Dom.up(t, r.Dom.isBlock, e.editor);!n && t && (n = r.Dom.wrap(t, e.options.enter, e)), o(n);
          }
        }), !1;
      };e.registerCommand("justifyfull", t), e.registerCommand("justifyright", t), e.registerCommand("justifyleft", t), e.registerCommand("justifycenter", t);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(0),
        r = o(3),
        s = o(1),
        a = o(5);s.Config.prototype.controls.align = { name: "left", tooltip: "Align", getLabel: function getLabel(e, t, o) {
        var n = e.selection.current();if (n) {
          var s = r.Dom.closest(n, r.Dom.isBlock, e.editor) || e.editor,
              l = "" + i.css(s, "text-align");t.defaultValue && -1 !== t.defaultValue.indexOf(l) && (l = "left"), t.data && t.data.currentValue !== l && t.list && -1 !== t.list.indexOf(l) && (o.textBox.innerHTML = e.options.textIcons ? "<span>" + l + "</span>" : a.ToolbarIcon.getIcon(l, ""), o.textBox.firstChild.classList.add("jodit_icon"), t.data.currentValue = l);
        }return !1;
      }, isActive: function isActive(e, t) {
        var o = e.selection.current();if (o && t.defaultValue) {
          var n = r.Dom.closest(o, r.Dom.isBlock, e.editor) || e.editor;return -1 === t.defaultValue.indexOf("" + i.css(n, "text-align"));
        }return !1;
      }, defaultValue: ["left", "start", "inherit"], data: { currentValue: "left" }, list: ["center", "left", "right", "justify"] }, s.Config.prototype.controls.center = { command: "justifyCenter", tags: ["center"], css: { "text-align": "center" }, tooltip: "Align Center" }, s.Config.prototype.controls.justify = { command: "justifyFull", css: { "text-align": "justify" }, tooltip: "Align Justify" }, s.Config.prototype.controls.left = { command: "justifyLeft", css: { "text-align": "left" }, tooltip: "Align Left" }, s.Config.prototype.controls.right = { command: "justifyRight", css: { "text-align": "right" }, tooltip: "Align Right" }, t.justify = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      e.options.link.followOnDblClick && e.events.on("afterInit", function () {
        e.events.on(e.editor, "dblclick", function (e) {
          var t = this.getAttribute("href");t && (location.href = t, e.preventDefault());
        }, "a");
      }), e.options.link.processPastedLink && e.events.on("processPaste", function (t, o) {
        if (r.isURL(o)) {
          var n = r.convertMediaURLToVideoEmbed(o);if (n !== o) return r.dom(n, e.editorDocument);var i = e.editorDocument.createElement("a");return i.setAttribute("href", o), i.innerText = o, e.options.link.openLinkDialogAfterPost && setTimeout(function () {}, 100), i;
        }
      }), e.options.link.removeLinkAfterFormat && e.events.on("afterCommand", function (t) {
        var o,
            n,
            i = e.selection;"removeFormat" === t && (n = i.current(), n && "A" !== n.nodeName && (n = s.Dom.closest(n, "A", e.editor)), n && "A" === n.nodeName && (o = n.innerHTML === n.innerText ? s.Dom.create("text", n.innerText, e.editorDocument) : s.Dom.create("span", n.innerHTML, e.editorDocument), n.parentNode && (n.parentNode.replaceChild(o, n), e.selection.setCursorIn(o, !0))));
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(0),
        s = o(3);i.Config.prototype.link = { followOnDblClick: !0, processVideoLink: !0, processPastedLink: !0, openLinkDialogAfterPost: !0, removeLinkAfterFormat: !0 }, i.Config.prototype.controls.unlink = { exec: function exec(e, t) {
        var o = s.Dom.closest(t, "A", e.editor);o && s.Dom.unwrap(o), e.events.fire("hidePopup");
      } }, i.Config.prototype.controls.link = { popup: function popup(e, t, o, n) {
        var i = e.editorWindow.getSelection(),
            a = r.dom('<form class="jodit_form"><input required type="text" name="url" placeholder="http://" type="text"/><input name="text" placeholder="' + e.i18n("Text") + '" type="text"/><label><input name="target" type="checkbox"/> ' + e.i18n("Open in new tab") + '</label><label><input name="nofollow" type="checkbox"/> ' + e.i18n("No follow") + '</label><div style="text-align: right"><button class="jodit_unlink_button" type="button">' + e.i18n("Unlink") + '</button> &nbsp;&nbsp;<button class="jodit_link_insert_button" type="submit"></button></div><form/>', e.ownerDocument);t = !(!t || !s.Dom.closest(t, "A", e.editor)) && s.Dom.closest(t, "A", e.editor);var l = a.querySelector(".jodit_link_insert_button"),
            c = a.querySelector(".jodit_unlink_button");t ? (r.val(a, "input[name=url]", t.getAttribute("href") || ""), r.val(a, "input[name=text]", t.innerText), a.querySelector("input[name=target]").checked = "_blank" === t.getAttribute("target"), a.querySelector("input[name=nofollow]").checked = "nofollow" === t.getAttribute("rel"), l && (l.innerHTML = e.i18n("Update"))) : (c && (c.style.display = "none"), r.val(a, "input[name=text]", "" + i), l && (l.innerHTML = e.i18n("Insert")));var d = e.selection.save();return c && c.addEventListener("mousedown", function (o) {
          t && s.Dom.unwrap(t), e.selection.restore(d), n(), o.preventDefault();
        }), a.addEventListener("submit", function (o) {
          o.preventDefault(), e.selection.restore(d);var i = t || s.Dom.create("a", "", e.editorDocument);return r.val(a, "input[name=url]") ? (i.setAttribute("href", r.val(a, "input[name=url]")), i.innerText = r.val(a, "input[name=text]"), a.querySelector("input[name=target]").checked ? i.setAttribute("target", "_blank") : i.removeAttribute("target"), a.querySelector("input[name=nofollow]").checked ? i.setAttribute("rel", "nofollow") : i.removeAttribute("rel"), t || e.selection.insertNode(i), n(), !1) : (a.querySelector("input[name=url]").focus(), a.querySelector("input[name=url]").classList.add("jodit_error"), !1);
        }), a;
      }, tags: ["a"], tooltip: "Insert link" }, t.link = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t,
          o = 0,
          n = e.options.buttons;e.events.on("touchend", function (n) {
        n.changedTouches.length && (t = new Date().getTime()) - o > e.options.mobileTapTimeout && (o = t, e.selection.insertCursorAtPoint(n.changedTouches[0].clientX, n.changedTouches[0].clientY));
      }).on("getDiffButtons.mobile", function () {
        return e.options.buttons.filter(function (e) {
          return 0 > n.indexOf(e);
        });
      }).on("resize afterInit", function () {
        var t = e.container.offsetWidth;n = e.options.sizeLG > t ? e.options.sizeMD > t ? e.options.sizeSM > t ? e.options.buttonsXS : e.options.buttonsSM : e.options.buttonsMD : e.options.buttons, e.toolbar.build(n.concat(e.options.extraButtons), e.container);
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(5),
        s = o(2);i.Config.prototype.mobileTapTimeout = 300, i.Config.prototype.controls.dots = { mode: s.MODE_SOURCE + s.MODE_WYSIWYG, popup: function popup(e, t, o) {
        var n = o.data;return void 0 === n && (n = { container: e.ownerDocument.createElement("div"), toolbar: new r.ToolbarCollection(e), rebuild: function rebuild() {
            var t = e.events.fire("getDiffButtons.mobile");t && n && n.toolbar.build(t, n.container);
          } }, n.container.style.width = "100px", o.data = n), n.rebuild(), n.container;
      } }, t.mobile = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      e.events.on("afterCommand", function (t) {
        if (/insert(un)?orderedlist/i.test(t)) {
          var o = i.Dom.up(e.selection.current(), function (e) {
            return e && /^UL|OL$/i.test(e.nodeName);
          }, e.editor);if (o && o.parentNode && "P" === o.parentNode.nodeName) {
            var n = e.selection.save();i.Dom.unwrap(o.parentNode), [].slice.call(o.childNodes).forEach(function (e) {
              e.lastChild && e.lastChild.nodeType === Node.ELEMENT_NODE && "BR" === e.lastChild.nodeName && e.removeChild(e.lastChild);
            }), e.selection.restore(n);
          }e.setEditorValue();
        }
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(3),
        r = o(1);r.Config.prototype.controls.ul = { command: "insertUnorderedList", controlName: "ul", tags: ["ul"], tooltip: "Insert Unordered List" }, r.Config.prototype.controls.ol = { command: "insertOrderedList", controlName: "ol", tags: ["ol"], tooltip: "Insert Ordered List" }, t.orderedlist = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      e.events.on("paste", function (t) {
        if (!1 === e.events.fire("beforePaste", t)) return t.preventDefault(), !1;if (t && t.clipboardData && t.clipboardData.getData) {
          var o = void 0,
              n = t.clipboardData.types,
              i = "",
              r = "";if (Array.isArray(n)) for (o = 0; n.length > o; o += 1) {
            i += n[o] + ";";
          } else i = n;/text\/html/.test(i) ? r = t.clipboardData.getData("text/html") : /text\/rtf/.test(i) && s.browser("safari") ? r = t.clipboardData.getData("text/rtf") : /text\/plain/.test(i) && !s.browser("mozilla") && (r = s.htmlentities(t.clipboardData.getData(l.TEXT_PLAIN)).replace(/\n/g, "<br/>")), ("" !== r || r instanceof e.editorWindow.Node) && (r = e.events.fire("processPaste", t, r), ("string" == typeof r || r instanceof e.editorWindow.Node) && e.selection.insertHTML(r), t.preventDefault(), t.stopPropagation());
        }return !1 !== e.events.fire("afterPaste", t) && void 0;
      });var t = function t(e) {
        var t = document.createElement("div");return t.innerHTML = e, t.innerText;
      },
          o = function o(t, _o3, n, a, l) {
        void 0 === a && (a = "Clean"), void 0 === l && (l = "Insert only Text");var c = r.Confirm('<div style="word-break: normal; white-space: normal">' + t + "</div>", _o3, n),
            d = s.dom('<a href="javascript:void(0)" style="float:left;" class="jodit_button"><span>' + i.Jodit.prototype.i18n("Keep") + "</span></a>", c.document),
            u = s.dom('<a href="javascript:void(0)" style="float:left;" class="jodit_button"><span>' + i.Jodit.prototype.i18n(a) + "</span></a>", c.document),
            p = s.dom('<a href="javascript:void(0)" style="float:left;" class="jodit_button"><span>' + i.Jodit.prototype.i18n(l) + "</span></a>", c.document),
            f = s.dom('<a href="javascript:void(0)" style="float:right;" class="jodit_button"><span>' + i.Jodit.prototype.i18n("Cancel") + "</span></a>", c.document);return e.events.on(d, "click", function () {
          c.close(), n && n(!0);
        }), e.events.on(u, "click", function () {
          c.close(), n && n(!1);
        }), e.events.on(p, "click", function () {
          c.close(), n && n(0);
        }), e.events.on(f, "click", function () {
          c.close();
        }), c.setFooter([d, u, l ? p : "", f]), c;
      },
          n = function n(_n) {
        if (s.isHTML(_n)) return o(e.i18n("Your code is similar to HTML. Keep as HTML?"), e.i18n("Paste as HTML"), function (o) {
          !1 === o && (_n = s.htmlspecialchars(_n)), 0 === o && (_n = t(_n)), e.selection.insertHTML(_n), e.setEditorValue();
        }, "Insert as Text"), !1;
      };e.options.askBeforePasteHTML && e.events.on("beforePaste", function (e) {
        if (e && e.clipboardData && e.clipboardData.getData && e.clipboardData.getData(l.TEXT_PLAIN)) {
          var t = e.clipboardData.getData(l.TEXT_PLAIN);return n(t);
        }
      }), e.options.askBeforePasteFromWord && e.events.on("beforePaste", function (i) {
        if (i && i.clipboardData && i.clipboardData.getData && i.clipboardData.getData(l.TEXT_HTML)) {
          var r = function r(i) {
            if (s.isHTML(i)) return s.isHTMLFromWord(i) ? o(e.i18n("The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?"), e.i18n("Word Paste Detected"), function (o) {
              !0 === o && (i = s.applyStyles(i), e.options.beautifyHTML && e.ownerWindow.html_beautify && (i = e.ownerWindow.html_beautify(i))), !1 === o && (i = s.cleanFromWord(i)), 0 === o && (i = t(s.cleanFromWord(i))), e.selection.insertHTML(i), e.setEditorValue();
            }) : n(i), !1;
          };if (i.clipboardData.types && -1 !== i.clipboardData.types.indexOf("text/html")) {
            var a = i.clipboardData.getData(l.TEXT_HTML);return r(a);
          }var c = s.dom('<div tabindex="-1" style="left: -9999px; top: 0; width: 0; height: 100%; line-height: 140%; overflow: hidden; position: fixed; z-index: 2147483647; -ms-word-break: break-all;" contenteditable="true"></div>', e.ownerDocument);e.container.appendChild(c), c.focus();var d = 0,
              u = function u() {
            if (d += 1, c.childNodes && c.childNodes.length > 0) {
              var t = c.innerHTML;c.parentNode && c.parentNode.removeChild(c), !1 !== r(t) && e.selection.insertHTML(t);
            } else 5 > d ? setTimeout(function () {
              u();
            }, 20) : c.parentNode && c.parentNode.removeChild(c);
          };u();
        }
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(6),
        r = o(7),
        s = o(0),
        a = o(1),
        l = o(2);a.Config.prototype.askBeforePasteHTML = !0, a.Config.prototype.askBeforePasteFromWord = !0, t.paste = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      if (e.options.showPlaceholder) {
        this.destruct = function () {
          i.parentNode && i.parentNode.removeChild(i);
        };var t = function t() {
          if (i.parentNode && !e.options.readonly) {
            var t = 0,
                o = 0,
                n = e.editorWindow.getComputedStyle(e.editor);if (e.editor.firstChild && e.editor.firstChild.nodeType === Node.ELEMENT_NODE) {
              var r = e.editorWindow.getComputedStyle(e.editor.firstChild);t = parseInt(r.getPropertyValue("margin-top"), 10), o = parseInt(r.getPropertyValue("margin-left"), 10), i.style.fontSize = parseInt(r.getPropertyValue("font-size"), 10) + "px", i.style.lineHeight = r.getPropertyValue("line-height");
            } else i.style.fontSize = parseInt(n.getPropertyValue("font-size"), 10) + "px", i.style.lineHeight = n.getPropertyValue("line-height");s.css(i, { display: "block", marginTop: Math.max(parseInt(n.getPropertyValue("margin-top"), 10), t), marginLeft: Math.max(parseInt(n.getPropertyValue("margin-left"), 10), o) });
          }
        },
            o = function o() {
          i.parentNode && (i.style.display = "none");
        },
            n = s.debounce(function () {
          if (e.editor) return e.getRealMode() !== r.MODE_WYSIWYG ? o() : void (e.getEditorValue() ? o() : t());
        }, e.options.observer.timeout / 100),
            i = s.dom('<span style="display: none;" class="jodit_placeholder">' + e.i18n(e.options.placeholder) + "</span>", e.ownerDocument);"rtl" === e.options.direction && (i.style.right = "0px", i.style.direction = "rtl"), e.options.useInputsPlaceholder && e.element.hasAttribute("placeholder") && (i.innerHTML = e.element.getAttribute("placeholder") || ""), e.events.on("readonly", function (e) {
          e ? o() : n();
        }).on("afterInit", function () {
          e.workplace.appendChild(i), n(), e.events.fire("placeholder", i.innerHTML), e.events.on("change keyup mouseup keydown mousedown afterSetMode", function () {
            null !== i.parentNode && n();
          });
        });
      }
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(2),
        s = o(0);i.Config.prototype.showPlaceholder = !0, i.Config.prototype.useInputsPlaceholder = !0, i.Config.prototype.placeholder = "Type something", t.placeholder = n;
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(16),
        r = o(2),
        s = o(1),
        a = o(4);s.Config.prototype.controls.redo = { mode: r.MODE_SPLIT, tooltip: "Redo" }, s.Config.prototype.controls.undo = { mode: r.MODE_SPLIT, tooltip: "Undo" }, t.redoundo = function (e) {
      function t(t) {
        var o = e.call(this, t) || this;o.observer = new i.Observer(o.jodit);var n = function n() {
          t.events.fire("canRedo", o.observer.stack.canRedo()), t.events.fire("canUndo", o.observer.stack.canUndo());
        };t.events.on("afterSetMode", function () {
          t.getRealMode() === r.MODE_WYSIWYG && n();
        });var s = function s(e) {
          return t.getRealMode() === r.MODE_WYSIWYG && (o.observer.stack["can" + e.substr(0, 1).toUpperCase() + e.substr(1)]() && o.observer.stack[e](), n()), !1;
        };return t.registerCommand("redo", { exec: s, hotkeys: "ctrl+y,ctrl+shift+z" }), t.registerCommand("undo", { exec: s, hotkeys: "ctrl+z" }), o;
      }return n(t, e), t.prototype.destruct = function () {
        this.observer.destruct();
      }, t;
    }(a.Component);
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      var t,
          o,
          n,
          i,
          a,
          l,
          c,
          d,
          u,
          p,
          f,
          h = !1,
          m = !1,
          v = !1,
          g = s.dom('<div data-editor_id="' + e.id + '" style="display:none" class="jodit_resizer"><i class="jodit_resizer-topleft"></i><i class="jodit_resizer-topright"></i><i class="jodit_resizer-bottomright"></i><i class="jodit_resizer-bottomleft"></i></div>', e.ownerDocument),
          _ = function _() {
        m = !1, v = !1, o = null, g.style.display = "none";
      },
          b = function b() {
        if (v && o && g) {
          var t = s.offset(o, e),
              n = parseInt(g.style.left || "0", 10),
              i = parseInt(g.style.top || "0", 10),
              r = g.offsetWidth,
              a = g.offsetHeight;i === t.top - 1 && n === t.left - 1 && r === o.offsetWidth && a === o.offsetHeight || (g.style.top = t.top - 1 + "px", g.style.left = t.left - 1 + "px", g.style.width = o.offsetWidth + "px", g.style.height = o.offsetHeight + "px", e.events && (e.events.fire(o, "changesize"), isNaN(n) || e.events.fire("resize")));
        }
      },
          y = function y() {
        e.options.readonly || (v = !0, g.style.display = "block", b());
      },
          w = function w(t) {
        var n;if ("IFRAME" === t.tagName) if (t.parentNode && t.parentNode.getAttribute("data-jodit_iframe_wrapper")) t = t.parentNode;else {
          n = s.dom('<jodit data-jodit-temp="1" contenteditable="false" draggable="true" data-jodit_iframe_wrapper="1"></jodit>', e.editorDocument), n.style.display = "inline-block" === t.style.display ? "inline-block" : "block", n.style.width = t.offsetWidth + "px", n.style.height = t.offsetHeight + "px", t.parentNode && t.parentNode.insertBefore(n, t), n.appendChild(t);var i = t;e.events.on(n, "changesize", function () {
            i.setAttribute("width", n.offsetWidth + "px"), i.setAttribute("height", n.offsetHeight + "px");
          }), t = n;
        }var r;e.events.on(t, "dragstart", _).on(t, "mousedown", function (e) {
          s.isIE() && e.preventDefault();
        }).on(t, "mousedown touchstart", function () {
          h || (h = !0, o = t, y(), "IMG" !== o.tagName || o.complete || o.addEventListener("load", function e() {
            b(), o && o.removeEventListener("load", e);
          }), clearTimeout(r)), r = window.setTimeout(function () {
            h = !1;
          }, 400);
        });
      };s.$$("i", g).forEach(function (r) {
        e.events.on(r, "mousedown touchstart", function (s) {
          if (!o || !o.parentNode) return _(), !1;t = r, s.preventDefault(), s.stopImmediatePropagation(), a = o.offsetWidth, l = o.offsetHeight, c = a / l, m = !0, n = s.clientX, i = s.clientY, e.lock("resizer");
        });
      }), e.events.on("readonly", function (e) {
        e && _();
      }).on("beforeDestruct", function () {
        g.parentNode && g.parentNode.removeChild(g);
      }).on("afterInit", function () {
        e.editorDocument.body.appendChild(g), e.events.on(e.editor, "keydown", function (t) {
          v && t.keyCode === r.KEY_DELETE && o && "table" !== o.tagName.toLowerCase() && ("JODIT" !== o.tagName ? e.selection.select(o) : (o.parentNode && o.parentNode.removeChild(o), _(), t.preventDefault()));
        }).on(e.ownerWindow, "mousemove touchmove", function (r) {
          if (m) {
            if (p = r.clientX - n, f = r.clientY - i, !o) return;"IMG" === o.tagName ? p ? (u = a + (t.className.match(/left/) ? -1 : 1) * p, d = Math.round(u / c)) : (d = l + (t.className.match(/top/) ? -1 : 1) * f, u = Math.round(d * c)) : (u = a + (t.className.match(/left/) ? -1 : 1) * p, d = l + (t.className.match(/top/) ? -1 : 1) * f), u > e.options.resizer.min_width && (o.style.width = g.parentNode.offsetWidth > u ? u + "px" : "100%"), d > e.options.resizer.min_height && (o.style.height = d + "px"), b(), r.stopImmediatePropagation();
          }
        }).on(e.ownerWindow, "resize", function () {
          v && b();
        }).on(e.ownerWindow, "mouseup keydown touchend", function (t) {
          v && !h && (m ? (e.unlock(), m = !1, e.setEditorValue(), t.stopImmediatePropagation()) : _());
        }).on([e.ownerWindow, e.editor], "scroll", function () {
          v && !m && _();
        });
      }).on("afterGetValueFromEditor", function (e) {
        e.value = e.value.replace(/<jodit[^>]+data-jodit_iframe_wrapper[^>]+>(.*?<iframe[^>]+>[\s\n\r]*<\/iframe>.*?)<\/jodit>/gi, "$1");
      }).on("change afterInit afterSetMode", s.debounce(function () {
        v && (o && o.parentNode ? b() : _()), s.$$("img, table, iframe", e.editor).forEach(function (t) {
          e.getMode() !== r.MODE_SOURCE && !t.__jodit_resizer_binded && ("IFRAME" === t.tagName && e.options.useIframeResizer || "IMG" === t.tagName && e.options.useImageResizer || "TABLE" === t.tagName && e.options.useTableResizer) && (t.__jodit_resizer_binded = !0, w(t));
        });
      }, e.options.observer.timeout));
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(2),
        s = o(0);i.Config.prototype.useIframeResizer = !0, i.Config.prototype.useTableResizer = !0, i.Config.prototype.useImageResizer = !0, i.Config.prototype.resizer = { min_width: 10, min_height: 10 }, t.resizer = n;
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      if ("auto" !== e.options.height && (e.options.allowResizeX || e.options.allowResizeY)) {
        var t = i.dom('<div class="jodit_editor_resize" ><a href="javascript:void(0)"></a></div>', e.ownerDocument),
            o = { x: 0, y: 0, w: 0, h: 0 },
            n = !1;e.events.on(t, "mousedown touchstart", function (t) {
          n = !0, o.x = t.clientX, o.y = t.clientY, o.w = e.container.offsetWidth, o.h = e.container.offsetHeight, t.preventDefault();
        }).on(e.ownerWindow, "mousemove touchmove", i.throttle(function (t) {
          n && (i.css(e.container, { width: e.options.allowResizeX ? o.w + t.clientX - o.x : o.w, height: e.options.allowResizeY ? o.h + t.clientY - o.y : o.h }), e.events.fire("resize"));
        }, e.options.observer.timeout)).on(e.ownerWindow, "mouseup touchsend", function () {
          n && (n = !1);
        }).on("afterInit", function () {
          e.container.appendChild(t);
        });
      }e.events.on("afterInit", function () {
        i.css(e.editor, { minHeight: e.options.minHeight }), i.css(e.workplace, { width: e.options.width, height: e.options.height, minHeight: e.options.minHeight }), "auto" !== e.options.height && (i.css(e.editor, { minHeight: "100%" }), i.css(e.workplace, { height: "", minHeight: "" }), i.css(e.container, { height: e.options.height })), "auto" !== e.options.width && (i.css(e.workplace, { width: "" }), i.css(e.container, { width: e.options.width }));
      }, void 0, void 0, !0);
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(0),
        r = o(1);r.Config.prototype.allowResizeX = !1, r.Config.prototype.allowResizeY = !0, t.size = n;
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(2),
        s = o(0),
        a = o(4);i.Config.prototype.beautifyHTML = !0, i.Config.prototype.useAceEditor = !0, i.Config.prototype.sourceEditorNativeOptions = { showGutter: !1, theme: "ace/theme/idle_fingers", mode: "ace/mode/html", wrap: !0, highlightActiveLine: !0 }, i.Config.prototype.sourceEditorCDNUrlsJS = ["//cdnjs.cloudflare.com/ajax/libs/ace/1.2.8/ace.js", "//cdnjs.cloudflare.com/ajax/libs/ace/1.2.8/ext-emmet.js"], i.Config.prototype.beautifyHTMLCDNUrlsJS = ["//cdnjs.cloudflare.com/ajax/libs/js-beautify/1.6.14/beautify.min.js", "//cdnjs.cloudflare.com/ajax/libs/js-beautify/1.6.14/beautify-html.min.js"], i.Config.prototype.controls.source = { mode: r.MODE_SPLIT, exec: function exec(e) {
        e.toggleMode();
      }, isActive: function isActive(e) {
        return e.getRealMode() === r.MODE_SOURCE;
      }, tooltip: "Change mode" }, t.source = function (e) {
      function t(t) {
        var o = e.call(this, t) || this;return o.className = "jodit_ace_editor", o.loadNext = function (e, t, n, i) {
          if (void 0 === n && (n = "aceReady"), void 0 === i && (i = o.className), n && void 0 === t[e] && o.jodit && o.jodit.events) return o.jodit.events && o.jodit.events.fire(n), void (o.jodit.events && o.jodit.events.fire(o.jodit.ownerWindow, n));void 0 !== t[e] && s.appendScript(t[e], function () {
            o.loadNext(e + 1, t, n, i);
          }, i, o.jodit.ownerDocument);
        }, o.fromWYSIWYG = function (e) {
          if (void 0 === e && (e = !1), !o.__lock || !0 === e) {
            o.__lock = !0;var t = o.jodit.getEditorValue();t !== o.getMirrorValue() && o.setMirrorValue(t), o.__lock = !1;
          }
        }, o.__lock = !1, o.toWYSIWYG = function () {
          o.__lock || (o.__lock = !0, o.jodit.setEditorValue(o.getMirrorValue()), o.__lock = !1);
        }, o.autosize = function () {
          o.mirror.style.height = "auto", o.mirror.style.height = o.mirror.scrollHeight + "px";
        }, o.getNormalPosition = function (e, t) {
          for (var o = e; o > 0;) {
            if (o--, "<" === t[o] && void 0 !== t[o + 1] && t[o + 1].match(/[\w\/]+/i)) return o;if (">" === t[o]) return e;
          }return e;
        }, o.tempMarkerStart = "{start-jodit-selection}", o.tempMarkerEnd = "{end-jodit-selection}", o.__clear = function (e) {
          return e.replace(r.INVISIBLE_SPACE_REG_EXP, "");
        }, o.selInfo = [], o.getSelectionStart = function () {
          return o.mirror.selectionStart;
        }, o.getSelectionEnd = function () {
          return o.mirror.selectionEnd;
        }, o.setMirrorSelectionRange = function (e, t) {
          o.mirror.setSelectionRange(e, t);
        }, o.saveSelection = function () {
          if (o.jodit.getRealMode() === r.MODE_WYSIWYG) o.selInfo = o.jodit.selection.save() || [], o.jodit.setEditorValue(), o.fromWYSIWYG(!0);else {
            o.selInfo.length = 0;var e = o.getMirrorValue();if (o.getSelectionStart() === o.getSelectionEnd()) {
              var t = o.jodit.selection.marker(!0);o.selInfo[0] = { startId: t.id, collapsed: !0, startMarker: t.outerHTML };var n = o.getNormalPosition(o.getSelectionStart(), o.getMirrorValue());o.setMirrorValue(e.substr(0, n) + o.__clear(o.selInfo[0].startMarker) + e.substr(n));
            } else {
              var i = o.jodit.selection.marker(!0),
                  s = o.jodit.selection.marker(!1);o.selInfo[0] = { startId: i.id, endId: s.id, collapsed: !1, startMarker: o.__clear(i.outerHTML), endMarker: o.__clear(s.outerHTML) };var n = o.getNormalPosition(o.getSelectionStart(), e),
                  a = o.getNormalPosition(o.getSelectionEnd(), e);o.setMirrorValue(e.substr(0, n) + o.selInfo[0].startMarker + e.substr(n, a - n) + o.selInfo[0].endMarker + e.substr(a));
            }o.toWYSIWYG();
          }
        }, o.restoreSelection = function () {
          if (o.selInfo.length) {
            if (o.jodit.getRealMode() === r.MODE_WYSIWYG) return o.__lock = !0, o.jodit.selection.restore(o.selInfo), void (o.__lock = !1);var e = o.getMirrorValue();o.selInfo[0].startMarker && (e = e.replace(/<span[^>]+data-jodit_selection_marker="start"[^>]*>[<>]*?<\/span>/gim, o.tempMarkerStart)), o.selInfo[0].endMarker && (e = e.replace(/<span[^>]+data-jodit_selection_marker="end"[^>]*>[<>]*?<\/span>/gim, o.tempMarkerEnd)), o.jodit.ownerWindow.html_beautify && o.jodit.options.beautifyHTML && (e = o.jodit.ownerWindow.html_beautify(e));var t = e.indexOf(o.tempMarkerStart),
                n = t;e = e.replace(o.tempMarkerStart, ""), o.selInfo[0].collapsed && -1 !== t || (n = e.indexOf(o.tempMarkerEnd), -1 === t && (t = n)), e = e.replace(o.tempMarkerEnd, ""), o.setMirrorValue(e), o.setMirrorSelectionRange(t, n), o.toWYSIWYG(), o.setFocusToMirror();
          }
        }, o.mirrorContainer = s.dom('<div class="jodit_source"/>', o.jodit.ownerDocument), o.mirror = s.dom('<textarea class="jodit_source_mirror"/>', o.jodit.ownerDocument), t.events.on(o.mirror, "mousedown keydown touchstart input", s.debounce(o.toWYSIWYG, t.options.observer.timeout)).on(o.mirror, "change keydown mousedown touchstart input", s.debounce(o.autosize, t.options.observer.timeout)).on(o.mirror, "mousedown focus", function (e) {
          t.events.fire(e.type, e);
        }), t.events.on("aceInited", function () {
          t.options.readonly && o.aceEditor && o.aceEditor.setReadOnly(!0);
        }, void 0, void 0, !0).on("readonly", function (e) {
          e ? o.mirror.setAttribute("readonly", "true") : o.mirror.removeAttribute("readonly"), o.aceEditor && o.aceEditor.setReadOnly(e);
        }).on("placeholder", function (e) {
          o.mirror.setAttribute("placeholder", e);
        }).on("afterInit aceInited", function () {
          t.events.on("beforeSetMode", o.saveSelection).on("afterSetMode", o.restoreSelection);
        }).on("afterInit", function () {
          o.mirrorContainer.appendChild(o.mirror), t.workplace.appendChild(o.mirrorContainer), o.autosize(), t.options.beautifyHTML && void 0 === t.ownerWindow.html_beautify && !s.$$("script.beutyfy_html_jodit_helper", t.ownerDocument.body).length && o.loadNext(0, t.options.beautifyHTMLCDNUrlsJS, !1, "beutyfy_html_jodit_helper"), t.options.useAceEditor && o.replaceMirrorToACE();
        }).on("change afterInit", o.fromWYSIWYG), o;
      }return n(t, e), t.prototype.getMirrorValue = function () {
        return this.mirror.value;
      }, t.prototype.setMirrorValue = function (e) {
        this.mirror.value = e;
      }, t.prototype.setFocusToMirror = function () {
        this.mirror.focus();
      }, t.prototype.replaceMirrorToACE = function () {
        var e,
            t,
            o = this,
            n = this.jodit,
            i = function i() {
          t && n.getRealMode() === r.MODE_SOURCE && (n.events.fire("canRedo", t.hasRedo()), n.events.fire("canUndo", t.hasUndo()));
        },
            a = function a(t) {
          return e.session.getLine(t).length;
        },
            l = function l() {
          for (var t = e.session.getLength(), o = [], n = 0, i = 0; t > i; i++) {
            n += a(i), i > 0 && (n += 1), o[i] = n;
          }return o;
        },
            c = function c(e) {
          var t = l();if (t[0] >= e) return { row: 0, column: e };for (var o = 1, n = 1; t.length > n; n++) {
            e > t[n] && (o = n + 1);
          }return { row: o, column: e - t[o - 1] - 1 };
        },
            d = function d(t, o) {
          var n = c(t),
              i = c(o);e.getSelection().setSelectionRange({ start: n, end: i });
        },
            u = function u(e, t) {
          return l()[e] - a(e) + t;
        },
            p = function p() {
          if (void 0 === e && void 0 !== o.jodit.ownerWindow.ace) {
            var a = s.dom('<div class="jodit_source_mirror-fake"/>', o.jodit.ownerDocument);o.mirrorContainer.insertBefore(a, o.mirrorContainer.firstChild), o.aceEditor = e = o.jodit.ownerWindow.ace.edit(a), e.setTheme(n.options.sourceEditorNativeOptions.theme), e.renderer.setShowGutter(n.options.sourceEditorNativeOptions.showGutter), e.getSession().setMode(n.options.sourceEditorNativeOptions.mode), e.setHighlightActiveLine(n.options.sourceEditorNativeOptions.highlightActiveLine), e.getSession().setUseWrapMode(!0), e.setOption("indentedSoftWrap", !1), e.setOption("wrap", n.options.sourceEditorNativeOptions.wrap), e.$blockScrolling = 1 / 0, e.setOptions({ maxLines: 1 / 0 }), e.on("change", o.toWYSIWYG), e.on("focus", function (e) {
              n.events.fire("focus", e);
            }), e.on("mousedown", function (e) {
              n.events.fire("mousedown", e);
            }), o.mirror.style.display = "none", t = e.getSession().getUndoManager(), o.setMirrorValue = function (t) {
              e.setValue(n.options.beautifyHTML && n.ownerWindow.html_beautify ? n.ownerWindow.html_beautify(t) : t), e.clearSelection(), i();
            }, o.jodit.getRealMode() !== r.MODE_WYSIWYG && o.setMirrorValue(o.getMirrorValue()), o.getMirrorValue = function () {
              return e.getValue();
            }, o.setFocusToMirror = function () {
              e.focus();
            }, o.getSelectionStart = function () {
              var t = e.selection.getRange();return u(t.start.row, t.start.column);
            }, o.getSelectionEnd = function () {
              var t = e.selection.getRange();return u(t.end.row, t.end.column);
            }, o.setMirrorSelectionRange = function (e, t) {
              d(e, t);
            }, n.events.fire("aceInited", n);
          }
        };n.events.on(this.jodit.ownerWindow, "aceReady", p).on("aceReady", p).on("afterSetMode", function () {
          n.getRealMode() !== r.MODE_SOURCE && n.getMode() !== r.MODE_SPLIT || (o.fromWYSIWYG(), p());
        }).on("beforeCommand", function (o) {
          if (n.getRealMode() !== r.MODE_WYSIWYG && ("redo" === o || "undo" === o) && t) return t["has" + o.substr(0, 1).toUpperCase() + o.substr(1)] && e[o](), i(), !1;
        }), p(), void 0 !== this.jodit.ownerWindow.ace || s.$$("script." + this.className, this.jodit.ownerDocument.body).length || this.loadNext(0, n.options.sourceEditorCDNUrlsJS, "aceReady", this.className);
      }, t;
    }(a.Component);
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 });var n = o(1),
        i = o(7),
        r = o(0),
        s = o(2);n.Config.prototype.usePopupForSpecialCharacters = !1, n.Config.prototype.specialCharacters = ["!", "&quot;", "#", "$", "%", "&amp;", "'", "(", ")", "*", "+", "-", ".", "/", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ":", ";", "&lt;", "=", "&gt;", "?", "@", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "[", "]", "^", "_", "`", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "{", "|", "}", "~", "&euro;", "&lsquo;", "&rsquo;", "&ldquo;", "&rdquo;", "&ndash;", "&mdash;", "&iexcl;", "&cent;", "&pound;", "&curren;", "&yen;", "&brvbar;", "&sect;", "&uml;", "&copy;", "&ordf;", "&laquo;", "&raquo;", "&not;", "&reg;", "&macr;", "&deg;", "&sup2;", "&sup3;", "&acute;", "&micro;", "&para;", "&middot;", "&cedil;", "&sup1;", "&ordm;", "&frac14;", "&frac12;", "&frac34;", "&iquest;", "&Agrave;", "&Aacute;", "&Acirc;", "&Atilde;", "&Auml;", "&Aring;", "&AElig;", "&Ccedil;", "&Egrave;", "&Eacute;", "&Ecirc;", "&Euml;", "&Igrave;", "&Iacute;", "&Icirc;", "&Iuml;", "&ETH;", "&Ntilde;", "&Ograve;", "&Oacute;", "&Ocirc;", "&Otilde;", "&Ouml;", "&times;", "&Oslash;", "&Ugrave;", "&Uacute;", "&Ucirc;", "&Uuml;", "&Yacute;", "&THORN;", "&szlig;", "&agrave;", "&aacute;", "&acirc;", "&atilde;", "&auml;", "&aring;", "&aelig;", "&ccedil;", "&egrave;", "&eacute;", "&ecirc;", "&euml;", "&igrave;", "&iacute;", "&icirc;", "&iuml;", "&eth;", "&ntilde;", "&ograve;", "&oacute;", "&ocirc;", "&otilde;", "&ouml;", "&divide;", "&oslash;", "&ugrave;", "&uacute;", "&ucirc;", "&uuml;", "&yacute;", "&thorn;", "&yuml;", "&OElig;", "&oelig;", "&#372;", "&#374", "&#373", "&#375;", "&sbquo;", "&#8219;", "&bdquo;", "&hellip;", "&trade;", "&#9658;", "&bull;", "&rarr;", "&rArr;", "&hArr;", "&diams;", "&asymp;"], n.Config.prototype.controls.symbol = { icon: "omega", hotkeys: "ctrl+shift+i", tooltip: "Insert Special Character", popup: function popup(e, t, o, n) {
        var r = e.events.fire("generateSpecialCharactersTable.symbols");if (r) {
          if (e.options.usePopupForSpecialCharacters) {
            var s = e.ownerDocument.createElement("div");return s.classList.add("jodit_symbols"), s.appendChild(r), e.events.on(r, "close_dialog", n), s;
          }var a = i.Alert(r, e.i18n("Select Special Character"), void 0, "jodit_symbols"),
              l = r.querySelector("a");l && l.focus(), e.events.on("beforeDestruct", function () {
            a && a.close();
          });
        }
      } }, t.symbols = function () {
      function e(e) {
        var t = this;this.countInRow = 17, e.events.on("generateSpecialCharactersTable.symbols", function () {
          for (var o = r.dom('<div class="jodit_symbols-container"><div class="jodit_symbols-container_table"><table><tbody></tbody></table></div><div class="jodit_symbols-container_preview"><div class="jodit_symbols-preview"></div></div></div>', e.ownerDocument), n = o.querySelector(".jodit_symbols-preview"), i = o.querySelector("table"), a = i.tBodies[0], l = [], c = 0; e.options.specialCharacters.length > c;) {
            for (var d = e.ownerDocument.createElement("tr"), u = 0; t.countInRow > u && e.options.specialCharacters.length > c; u += 1, c += 1) {
              var p = e.ownerDocument.createElement("td"),
                  f = r.dom('<a data-index="' + c + '" data-index-j="' + u + '" href="javascript:void(0)" role="option" tabindex="-1">' + e.options.specialCharacters[c] + "</a>", e.ownerDocument);l.push(f), p.appendChild(f), d.appendChild(p);
            }a.appendChild(d);
          }var h = t;return e.events.on(l, "focus", function () {
            n.innerHTML = this.innerHTML;
          }).on(l, "mousedown", function (t) {
            this && "A" === this.nodeName && (e.selection.insertHTML(this.innerHTML), e.events.fire(this, "close_dialog"), t && t.preventDefault(), t && t.stopImmediatePropagation());
          }).on(l, "mouseenter", function () {
            this && "A" === this.nodeName && this.focus();
          }).on(l, "keydown", function (t) {
            var o = t.target;if (o && "A" === o.nodeName) {
              var n = parseInt(o.getAttribute("data-index") || "0", 0),
                  i = parseInt(o.getAttribute("data-index-j") || "0", 0),
                  r = void 0;switch (t.which) {case s.KEY_TOP:case s.KEY_BOTTOM:
                  r = t.which === s.KEY_TOP ? n - h.countInRow : n + h.countInRow, void 0 === l[r] && (r = t.which === s.KEY_TOP ? Math.floor(l.length / h.countInRow) * h.countInRow + i : i) > l.length - 1 && (r -= h.countInRow), l[r] && l[r].focus();break;case s.KEY_RIGHT:case s.KEY_LEFT:
                  r = t.which === s.KEY_LEFT ? n - 1 : n + 1, void 0 === l[r] && (r = t.which === s.KEY_LEFT ? l.length - 1 : 0), l[r] && l[r].focus();break;case s.KEY_ENTER:
                  e.events.fire(o, "mousedown"), t.stopImmediatePropagation(), t.preventDefault();}
            }
          }), o;
        });
      }return e;
    }();
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(4),
        s = o(0);i.Config.prototype.commandToHotkeys = { removeFormat: "ctrl+shift+m", insertOrderedList: "ctrl+shift+7", insertUnorderedList: "ctrl+shift+8", selectall: "ctrl+a" }, t.hotkeys = function (e) {
      function t(t) {
        var o = e.call(this, t) || this;return o.specialKeys = { 8: "backspace", 9: "tab", 10: "return", 13: "return", 16: "shift", 17: "ctrl", 18: "alt", 19: "pause", 20: "capslock", 27: "esc", 32: "space", 33: "pageup", 34: "pagedown", 35: "end", 36: "home", 37: "left", 38: "up", 39: "right", 40: "down", 45: "insert", 46: "del", 59: ";", 61: "=", 96: "0", 97: "1", 98: "2", 99: "3", 100: "4", 101: "5", 102: "6", 103: "7", 104: "8", 105: "9", 106: "*", 107: "+", 109: "-", 110: ".", 111: "/", 112: "f1", 113: "f2", 114: "f3", 115: "f4", 116: "f5", 117: "f6", 118: "f7", 119: "f8", 120: "f9", 121: "f10", 122: "f11", 123: "f12", 144: "numlock", 145: "scroll", 173: "-", 186: ";", 187: "=", 188: ",", 189: "-", 190: ".", 191: "/", 192: "`", 219: "[", 220: "\\", 221: "]", 222: "'" }, o.shiftNums = { "`": "~", 1: "!", 2: "@", 3: "#", 4: "$", 5: "%", 6: "^", 7: "&", 8: "*", 9: "(", 0: ")", "-": "_", "=": "+", ";": ": ", "'": '"', ",": "<", ".": ">", "/": "?", "\\": "|" }, o.possible = {}, o.onKeyPress = function (e) {
          var t = "keypress" !== e.type && o.specialKeys[e.which],
              n = String.fromCharCode(e.which).toLowerCase(),
              i = "";e.metaKey && !e.ctrlKey && (i += "ctrl+"), ["alt", "ctrl", "shift"].forEach(function (o) {
            e[o + "Key"] && t !== o && (i += o + "+");
          }), e.metaKey && i.indexOf("alt+ctrl+shift+") > -1 && (i = i.replace("alt+ctrl+shift+", "hyper+")), t ? o.possible[i + t] = !0 : (o.possible[i + n] = !0, o.shiftNums[n] && (o.possible[i + o.shiftNums[n]] = !0), "shift+" === i && (o.possible[o.shiftNums[n]] = !0));
        }, Object.keys(t.options.commandToHotkeys).forEach(function (e) {
          var o = t.options.commandToHotkeys[e];o && t.events.off(s.asArray(o).map(function (e) {
            return e + ".hotkey";
          }).join(" ")).on(s.asArray(o).map(function (e) {
            return e + ".hotkey";
          }).join(" "), function () {
            return t.execCommand(e);
          });
        }), t.events.on("afterInit", function () {
          var e = function e(_e) {
            var t = !0;if (Object.keys(o.possible).forEach(function (n) {
              !1 === o.jodit.events.fire(n, _e.type) && (t = !1);
            }), !t) return !1;
          },
              n = !1,
              i = o;t.events.on("keydown", function (o) {
            if (i.possible = {}, i.onKeyPress(o), !1 === e(o)) return n = !0, t.events.stopPropagation("keydown"), !1;
          }, void 0, void 0, !0).on("keyup", function (e) {
            if (n) return n = !1, t.events.stopPropagation("keyup"), !1;
          }, void 0, void 0, !0);
        }), o;
      }return n(t, e), t;
    }(r.Component);
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(2),
        r = o(0),
        s = o(1),
        a = o(9);s.Config.prototype.useTableProcessor = !0, s.Config.prototype.controls.table = { cols: 10, popup: function popup(e, t, o, n) {
        var i,
            s,
            a,
            l,
            c = 1,
            d = 1,
            u = o.cols || 10,
            p = r.dom('<form class="jodit_form jodit_form_inserter"><label><span>1</span> &times; <span>1</span></label><p class="jodit_form-container"></p></form>', e.ownerDocument),
            f = p.querySelectorAll("span")[0],
            h = p.querySelectorAll("span")[1],
            m = p.querySelector(".jodit_form-container"),
            v = [],
            g = function g(t) {
          var o = (t + 1) * u;if (v.length > o) {
            for (i = o; v.length > i; i += 1) {
              m.removeChild(v[i]), delete v[i];
            }v.length = o;
          }for (i = 0; o > i; i += 1) {
            v[i] || (l = e.ownerDocument.createElement("div"), l.setAttribute("data-index", "" + i), v.push(l));
          }v.forEach(function (e) {
            m.appendChild(e);
          }), m.style.width = v[0].offsetWidth * u + "px";
        };g(1), v[0].className = "hovered";var _ = function _(e, t) {
          var o = e.target;if (o && "DIV" === o.tagName) {
            if (a = void 0 === t || isNaN(t) ? parseInt(o.getAttribute("data-index") || "0", 10) : t || 0, c = Math.ceil((a + 1) / u), d = a % u + 1, g(c), d === u || u - 1 > d && u > 10) return u = d === u ? u + 1 : u - 1, _(e, d + (c - 1) * u - 1);for (i = 0; v.length > i; i += 1) {
              v[i].className = i % u + 1 > d || c < Math.ceil((i + 1) / u) ? "" : "hovered";
            }h.innerText = "" + d, f.innerText = "" + c;
          }
        };return m.addEventListener("mousemove", _), e.events.on(m, "touchstart mousedown", function (t) {
          var o = t.target;if (t.preventDefault(), t.stopImmediatePropagation(), "DIV" === o.tagName) {
            a = parseInt(o.getAttribute("data-index") || "0", 10), c = Math.ceil((a + 1) / u), d = a % u + 1;var r,
                l,
                p,
                f = e.editorDocument.createElement("table"),
                h = null,
                m = (100 / d).toFixed(7);for (i = 1; c >= i; i += 1) {
              for (r = e.editorDocument.createElement("tr"), s = 1; d >= s; s += 1) {
                l = e.editorDocument.createElement("td"), l.style.width = m + "%", h || (h = l), p = e.editorDocument.createElement("br"), l.appendChild(p), r.appendChild(e.editorDocument.createTextNode("\n")), r.appendChild(e.editorDocument.createTextNode("\t")), r.appendChild(l);
              }f.appendChild(e.editorDocument.createTextNode("\n")), f.appendChild(r);
            }e.selection.insertNode(e.editorDocument.createTextNode("\n")), e.selection.insertNode(f, !1), h && e.selection.setCursorIn(h), n();
          }
        }), p;
      }, tooltip: "Insert table" }, t.TableProcessor = function (e) {
      function t(o) {
        var n = e.call(this, o) || this;return n.__key = "table_processor_observer", n.__selectMode = !1, n.__resizerDelta = 0, n.__drag = !1, n.__addResizer = function () {
          if (!n.__resizerHandler && !(n.__resizerHandler = n.jodit.container.querySelector(".jodit_table_resizer"))) {
            n.__resizerHandler = r.dom('<div class="jodit_table_resizer"></div>', n.jodit.ownerDocument);var e = 0;n.jodit.events.on(n.__resizerHandler, "mousedown touchstart", function (t) {
              n.__drag = !0, e = t.clientX, n.jodit.lock(n.__key), n.__resizerHandler.classList.add("jodit_table_resizer-moved");var o,
                  r = n.__workTable.getBoundingClientRect();if (n.__minX = 0, n.__maxX = 1e6, null !== n.__wholeTable) r = n.__workTable.parentNode.getBoundingClientRect(), n.__minX = r.left, n.__maxX = r.left + r.width;else {
                var s = a.Table.formalCoordinate(n.__workTable, n.__workCell, !0);a.Table.formalMatrix(n.__workTable, function (e, t, r) {
                  s[1] === r && (o = e.getBoundingClientRect(), n.__minX = Math.max(o.left + i.NEARBY / 2, n.__minX)), s[1] + 1 === r && (o = e.getBoundingClientRect(), n.__maxX = Math.min(o.left + o.width - i.NEARBY / 2, n.__maxX));
                });
              }
            }).on(n.jodit.ownerWindow, "mousemove touchmoove", function (t) {
              if (n.__drag) {
                var o = t.clientX;n.__minX > o && (o = n.__minX), o > n.__maxX && (o = n.__maxX), n.__resizerDelta = o - e, n.__resizerHandler.style.left = o + "px", n.jodit.editorWindow.getSelection().removeAllRanges(), t.preventDefault && t.preventDefault();
              }
            }), n.jodit.container.appendChild(n.__resizerHandler);
          }
        }, n.onExecCommand = function (e) {
          if (/table(splitv|splitg|merge|empty|bin|binrow|bincolumn|addcolumn|addrow)/.test(e)) {
            e = e.replace("table", "");var t = a.Table.getAllSelectedCells(n.jodit.editor);if (t.length) {
              var o = t.shift();if (!o) return;var i = a.Dom.closest(o, "table", n.jodit.editor);switch (e) {case "splitv":
                  a.Table.splitVertical(i);break;case "splitg":
                  a.Table.splitHorizontal(i);break;case "merge":
                  a.Table.mergeSelected(i);break;case "empty":
                  a.Table.getAllSelectedCells(n.jodit.editor).forEach(function (e) {
                    return e.innerHTML = "";
                  });break;case "bin":
                  i.parentNode && i.parentNode.removeChild(i);break;case "binrow":
                  a.Table.removeRow(i, o.parentNode.rowIndex);break;case "bincolumn":
                  a.Table.removeColumn(i, o.cellIndex);break;case "addcolumnafter":case "addcolumnbefore":
                  a.Table.appendColumn(i, o.cellIndex, "addcolumnafter" === e);break;case "addrowafter":case "addrowbefore":
                  a.Table.appendRow(i, o.parentNode, "addrowafter" === e);}
            }return !1;
          }
        }, o.options.useTableProcessor ? (o.events.on(n.jodit.ownerWindow, "mouseup touchend", function () {
          if ((n.__selectMode || n.__drag) && (n.__selectMode = !1, n.jodit.unlock()), n.__resizerHandler && n.__drag) {
            if (n.__drag = !1, n.__resizerHandler.classList.remove("jodit_table_resizer-moved"), null === n.__wholeTable) {
              var e = [];a.Table.setColumnWidthByDelta(n.__workTable, a.Table.formalCoordinate(n.__workTable, n.__workCell, !0)[1], n.__resizerDelta, !0, e);var i = a.Dom.next(n.__workCell, t.isCell, n.__workCell.parentNode);a.Table.setColumnWidthByDelta(n.__workTable, a.Table.formalCoordinate(n.__workTable, i)[1], -n.__resizerDelta, !1, e);
            } else {
              var s = n.__workTable.offsetWidth,
                  l = r.getContentWidth(n.__workTable.parentNode, n.jodit.editorWindow);if (!1 === n.__wholeTable) n.__workTable.style.width = (s + n.__resizerDelta) / l * 100 + "%";else {
                var c = parseInt(n.jodit.editorWindow.getComputedStyle(n.__workTable).marginLeft || "0", 10);n.__workTable.style.width = (s - n.__resizerDelta) / l * 100 + "%", n.__workTable.style.marginLeft = (c + n.__resizerDelta) / l * 100 + "%";
              }
            }o.setEditorValue(), o.selection.focus();
          }
        }).on(n.jodit.ownerWindow, "scroll", function () {
          if (n.__drag) {
            var e = a.Dom.up(n.__workCell, function (e) {
              return e && "TABLE" === e.nodeName;
            }, o.editor);if (e) {
              var t = e.getBoundingClientRect();n.__resizerHandler.style.top = t.top + "px";
            }
          }
        }).on(n.jodit.ownerWindow, "mousedown touchend", function (e) {
          var t = a.Dom.closest(e.originalEvent.target, "TD|TH", n.jodit.editor),
              o = null;t instanceof n.jodit.editorWindow.HTMLTableCellElement && (o = a.Dom.closest(t, "table", n.jodit.editor)), o && n.__deSelectAll(o, t instanceof n.jodit.editorWindow.HTMLTableCellElement && t);
        }).on("afterGetValueFromEditor", function (e) {
          e.value = e.value.replace(RegExp("([s]*)" + i.JODIT_SELECTED_CELL_MARKER + '="1"', "g"), "");
        }).on("change afterCommand afterSetMode", function () {
          r.$$("table", o.editor).forEach(function (e) {
            e[n.__key] || n.observe(e);
          });
        }).on("beforeSetMode", function () {
          a.Table.getAllSelectedCells(o.editor).forEach(function (e) {
            a.Table.restoreSelection(e), a.Table.normalizeTable(a.Dom.closest(e, "table", o.editor));
          });
        }).on("keydown", function (e) {
          e.which === i.KEY_TAB && r.$$("table", o.editor).forEach(function (e) {
            n.__deSelectAll(e);
          });
        }).on("beforeCommand", n.onExecCommand.bind(n)), n) : n;
      }return n(t, e), t.prototype.__deSelectAll = function (e, t) {
        var o = a.Table.getAllSelectedCells(e || this.jodit.editor);o.length && r.each(o, function (e, o) {
          t && t === o || a.Table.restoreSelection(o);
        });
      }, t.isCell = function (e) {
        return !!e && /^TD|TH$/i.test(e.nodeName);
      }, t.prototype.__setWorkCell = function (e, t) {
        void 0 === t && (t = null), this.__wholeTable = t, this.__workCell = e, this.__workTable = a.Dom.up(e, function (e) {
          return e && "TABLE" === e.nodeName;
        }, this.jodit.editor);
      }, t.prototype.__calcResizerPosition = function (e, o, n, s) {
        void 0 === n && (n = 0), void 0 === s && (s = 0);var l = r.offset(o, this.jodit);if (n > i.NEARBY && l.width - n > i.NEARBY) this.__resizerHandler.style.display = "none";else {
          var c = r.offset(e, this.jodit);if (this.__resizerHandler.style.left = (n > i.NEARBY ? l.left + l.width : l.left) + s + "px", this.__resizerHandler.style.height = c.height + "px", this.__resizerHandler.style.top = c.top + "px", this.__resizerHandler.style.display = "block", n > i.NEARBY) this.__setWorkCell(o, !!a.Dom.next(o, t.isCell, o.parentNode) && null);else {
            var d = a.Dom.prev(o, t.isCell, o.parentNode);d ? this.__setWorkCell(d) : this.__setWorkCell(o, !0);
          }
        }
      }, t.prototype.observe = function (e) {
        var o = this;e[this.__key] = !0;var n;this.jodit.events.on(e, "mousedown touchstart", function (i) {
          if (!o.jodit.options.readonly) {
            var r = a.Dom.up(i.target, t.isCell, e);r && r instanceof o.jodit.editorWindow.HTMLElement && (r.firstChild || r.appendChild(a.Dom.create("br", "", o.jodit.editorDocument)), n = r, a.Table.addSelected(r), o.__selectMode = !0, o.jodit.lock(o.__key));
          }
        }).on(e, "mouseleave", function (e) {
          o.__resizerHandler && o.__resizerHandler !== e.relatedTarget && (o.__resizerHandler.style.display = "none");
        }).on(e, "mousemove touchmove", function (i) {
          if (!o.jodit.options.readonly && !o.__drag && !o.jodit.isLockedNotBy(o.__key)) {
            var s = a.Dom.up(i.target, t.isCell, e);if (s) if (o.__selectMode) {
              s !== n && (o.jodit.editorWindow.getSelection().removeAllRanges(), i.preventDefault && i.preventDefault()), o.__deSelectAll(e);for (var l = a.Table.getSelectedBound(e, [s, n]), c = a.Table.formalMatrix(e), d = l[0][0]; l[1][0] >= d; d += 1) {
                for (var u = l[0][1]; l[1][1] >= u; u += 1) {
                  a.Table.addSelected(c[d][u]);
                }
              }var p = c[l[1][0]][l[1][1]],
                  f = c[l[0][0]][l[0][1]];o.jodit.events.fire("showPopap", e, r.offset(f, o.jodit).left + Math.round((r.offset(p, o.jodit).left + p.offsetWidth - r.offset(f, o.jodit).left) / 2), r.offset(p, o.jodit).top + p.offsetHeight), i.stopPropagation();
            } else o.__calcResizerPosition(e, s, i.offsetX);
          }
        }), this.__addResizer();
      }, t;
    }(a.Component);
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }(),
        i = this && this.__assign || Object.assign || function (e) {
      for (var t, o = 1, n = arguments.length; n > o; o++) {
        t = arguments[o];for (var i in t) {
          Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        }
      }return e;
    };Object.defineProperty(t, "__esModule", { value: !0 });var r = o(6),
        s = o(4),
        a = o(7),
        l = o(1),
        c = o(0),
        d = o(5),
        u = o(19),
        p = o(11),
        f = o(14),
        h = o(2),
        m = o(10);l.Config.prototype.filebrowser = { filter: function filter(e, t) {
        return t = t.toLowerCase(), "string" == typeof e ? -1 !== e.toLowerCase().indexOf(t) : "string" == typeof e.name ? -1 !== e.name.toLowerCase().indexOf(t) : "string" != typeof e.file || -1 !== e.file.toLowerCase().indexOf(t);
      }, sortBy: "changed", sort: function sort(e, t, o) {
        var n,
            i,
            r = function r(e, t) {
          return t > e ? -1 : e > t ? 1 : 0;
        };if ("string" == typeof e) return r(e.toLowerCase(), t.toLowerCase());if (void 0 === e[o] || "name" === o) return "string" == typeof e.name ? r(e.name.toLowerCase(), t.name.toLowerCase()) : "string" == typeof e.file ? r(e.file.toLowerCase(), t.file.toLowerCase()) : 0;switch (o) {case "changed":
            return n = new Date(e.changed), i = new Date(t.changed), i.getTime() - n.getTime();case "size":
            return c.humanSizeToBytes(e.size) - c.humanSizeToBytes(t.size);}return 0;
      }, editImage: !0, preview: !0, showPreviewNavigation: !0, showSelectButtonInPreview: !0, contextMenu: !0, howLongShowMsg: 3e3, createNewFolder: !0, deleteFolder: !0, moveFolder: !0, moveFile: !0, showFoldersPanel: !0, width: 763, height: 400, buttons: ["upload", "remove", "update", "select", "edit", "tiles", "list", "filter", "sort"], view: "tiles", isSuccess: function isSuccess(e) {
        return e.success;
      }, getMessage: function getMessage(e) {
        return void 0 !== e.data.messages && Array.isArray(e.data.messages) ? e.data.messages.join(" ") : "";
      }, showFileName: !0, showFileSize: !0, showFileChangeTime: !0, getThumbTemplate: function getThumbTemplate(e, t, o) {
        var n,
            i = "",
            r = "",
            s = "" + new Date().getTime();return "string" == typeof e ? (i = e, r = e) : (void 0 !== e.file && (i = e.file, r = e.file), e.thumb && (r = e.thumb)), n = '<div class="' + g + '-info">\n            ' + (this.options.showFileName ? '<span class="' + g + '-info-filename">' + i + "</span>" : "") + "\n            " + (this.options.showFileSize && e.size ? '<span class="' + g + '-info-filesize">' + e.size + "</span>" : "") + "\n            " + (this.options.showFileChangeTime && e.changed ? '<span class="' + g + '-info-filechanged">' + e.changed + "</span>" : "") + "\n        </div>", '<a draggable="true" class="' + g + '" href="' + c.urlNormalize(t.baseurl + t.path + i) + '" data-source="' + o + '" data-path="' + c.pathNormalize(t.path ? t.path + "/" : "/") + '" data-name="' + i + '" title="' + i + '" data-url="' + c.urlNormalize(t.baseurl + t.path + i) + '">\n            <img src="' + c.urlNormalize(t.baseurl + t.path + r) + "?_tmst=" + s + '" alt="' + i + '"/>\n            ' + (this.options.showFileName || this.options.showFileSize && e.size || this.options.showFileChangeTime && e.changed ? n : "") + "\n        </a>";
      }, ajax: { url: "", async: !0, data: {}, cache: !0, contentType: "application/x-www-form-urlencoded; charset=UTF-8", method: "POST", processData: !0, dataType: "json", headers: {}, prepareData: function prepareData(e) {
          return e;
        }, process: function process(e) {
          return e;
        } }, create: { data: { action: "folderCreate" } }, getLocalFileByUrl: { data: { action: "getLocalFileByUrl" } }, resize: { data: { action: "imageResize" } }, crop: { data: { action: "imageCrop" } }, move: { data: { action: "fileMove" } }, remove: { data: { action: "fileRemove" } }, items: { data: { action: "files" } }, folder: { data: { action: "folders" } }, permissions: { data: { action: "permissions" } }, uploader: null };var v = "default",
        g = "jodit_filebrowser_files_item";t.FileBrowser = function (e) {
      function t(t) {
        var o = e.call(this, t) || this;o.currentPath = "", o.currentSource = v, o.currentBaseUrl = "", o.__currentPerpissions = null, o.view = "tiles", o.sortBy = "changed", o.dragger = !1, o.filterWord = "", o.getPathByUrl = function (e, t, n) {
          var i = o;o.options.getLocalFileByUrl.data.url = e, o.send("getLocalFileByUrl", function (e) {
            i.options.isSuccess(e) ? t(e.data.path, e.data.name, e.data.source) : n(Error(o.options.getMessage(e)));
          }, function (e) {
            n(e);
          });
        }, o.loadItems = function (e, t) {
          var n = o;n.options.items.data.path = e, n.options.items.data.source = t, n.options.items.url && (n.files.classList.add("active"), n.files.appendChild(n.loader.cloneNode(!0)), n.__ajax2 && n.__ajax2.abort && n.__ajax2.abort(), n.__ajax2 = n.send("items", function (e) {
            var t = n.options.items.process;if (t || (t = o.options.ajax.process), t) {
              var i = t.call(n, e);n.generateItemsBox(i.data.sources), n.someSelectedWasChanged();
            }
          }, function (e) {
            a.Alert(e.message), n.errorHandler(e);
          }));
        }, o.create = function (e, t, n) {
          o.options.create.data.source = n, o.options.create.data.path = t, o.options.create.data.name = e, o.send("create", function (e) {
            o.options.isSuccess(e) ? (o.currentPath = t, o.currentSource = n, o.loadTree(t, n)) : o.status(o.options.getMessage(e));
          }, function (e) {
            o.status(e.message);
          });
        }, o.move = function (e, t, n) {
          o.options.move.data.from = e, o.options.move.data.path = t, o.options.move.data.source = n, o.send("move", function (e) {
            o.options.isSuccess(e) ? o.loadTree(t, n) : o.status(o.options.getMessage(e));
          }, function (e) {
            o.status(e.message);
          });
        }, o.close = function () {
          o.dialog.close();
        }, o.open = function (e) {
          if (o.options.items.url) {
            var t = 0;o.jodit.events.off(o.files, "dblclick").on(o.files, "dblclick", o.onSelect(e), "a").on(o.files, "touchstart", function () {
              var n = new Date().getTime();h.EMULATE_DBLCLICK_TIMEOUT > n - t && o.onSelect(e)(), t = n;
            }, "a").off(o.buttons.select, "click").on(o.buttons.select, "click", o.onSelect(e)), o.loadTree(o.currentPath, o.currentSource);var n = [c.dom('<span class="jodit_dialog_header_title">' + o.jodit.i18n("File Browser") + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>", o.jodit.ownerDocument)],
                i = void 0,
                s = void 0;for (i = 0; o.options.buttons.length > i; i += 1) {
              var a = o.options.buttons[i];"string" == typeof a && void 0 !== o.buttons[a] && (o.options.editImage && void 0 !== r.Jodit.modules.ImageEditor || "edit" !== a) ? n.push(o.buttons[a]) : "function" == typeof a ? n.push(a.call(o)) : c.isPlainObject(a) && a.exec && a.name && (s = c.dom('<div class="jodit_button">' + d.ToolbarIcon.getIcon(a.icon || a.name || "") + "</div>", o.jodit.ownerDocument), n.push(s), s.addEventListener("click", a.exec));
            }o.dialog.open(o.browser, n);
          }
        }, o.errorHandler = function (e) {
          o.status(e instanceof Error ? o.jodit.i18n(e.message) : o.options.getMessage(e));
        }, o.uploadHandler = function () {
          o.loadItems(o.currentPath, o.currentSource);
        }, o.openImageEditor = function (e, t, n, i, r, s) {
          o.jodit.getInstance("ImageEditor").open(e, function (e, a, l, c) {
            void 0 === o.options[a.action] && (o.options[a.action] = {}), void 0 === o.options[a.action].data && (o.options[a.action].data = { action: a.action }), o.options[a.action].data.newname = e || t, o.options[a.action].data.box = a.box, o.options[a.action].data.path = n, o.options[a.action].data.name = t, o.options[a.action].data.source = i, o.send(a.action, function (e) {
              o.options.isSuccess(e) ? (o.loadTree(o.currentPath, o.currentSource), l(), r && r()) : (c(Error(o.options.getMessage(e))), s && s(Error(o.options.getMessage(e))));
            }, function (e) {
              c(e), s && s(e);
            });
          });
        }, o.draggable = !1, o.start = { top: 0, left: 0 }, o.client = { x: 0, y: 0 };var n = o,
            s = t.ownerDocument;n.options = c.extend(!0, {}, l.Config.prototype.filebrowser, n.jodit.options.filebrowser), n.dialog = new a.Dialog(t, { fullsizeButton: !0 }), n.loader = c.dom('<div class="jodit_filebrowser_loader"><i class="jodit_icon-loader"></i></div>', s), n.browser = c.dom('<div class="jodit_filebrowser non-selected">' + (n.options.showFoldersPanel ? '<div class="jodit_filebrowser_tree"></div>' : "") + '<div class="jodit_filebrowser_files"></div><div class="jodit_filebrowser_status"></div></div>', s), n.status_line = n.browser.querySelector(".jodit_filebrowser_status"), n.buttons = { upload: c.dom('<div class="jodit_uploadfile_button jodit_button">' + d.ToolbarIcon.getIcon("plus") + '<input type="file" accept="image/*" tabindex="-1" dir="auto" multiple=""/></div>', s), remove: c.dom('<div class="jodit_button disabled">' + d.ToolbarIcon.getIcon("bin") + "</div>", s), update: c.dom('<div class="jodit_button">' + d.ToolbarIcon.getIcon("update") + "</div>", s), select: c.dom('<div class="jodit_button disabled">' + d.ToolbarIcon.getIcon("check") + "</div>", s), edit: c.dom('<div class="jodit_button disabled">' + d.ToolbarIcon.getIcon("pencil") + "</div>", s), tiles: c.dom('<div class="jodit_button jodit_button_tiles disabled">' + d.ToolbarIcon.getIcon("th") + "</div>", s), list: c.dom('<div class="jodit_button disabled">' + d.ToolbarIcon.getIcon("th-list") + "</div>", s), filter: c.dom('<input class="jodit_input" placeholder="' + t.i18n("Filter") + '"/>', s), sort: c.dom('<select class="jodit_input"><option value="changed">' + t.i18n("Sort by changed") + '</option><option value="name">' + t.i18n("Sort by name") + '</option><option value="size">' + t.i18n("Sort by size") + "</option></select>", s) }, n.tree = n.browser.querySelector(".jodit_filebrowser_tree"), n.files = n.browser.querySelector(".jodit_filebrowser_files"), n.jodit.events.on([n.buttons.tiles, n.buttons.list], "click", function (e) {
          var t = e.currentTarget;t.classList.contains("jodit_button_tiles") ? (n.view = "tiles", n.buttons.list.classList.add("disabled")) : (n.view = "list", n.buttons.tiles.classList.add("disabled")), t.classList.remove("disabled"), n.files.classList.remove("jodit_filebrowser_files_view-tiles"), n.files.classList.remove("jodit_filebrowser_files_view-list"), n.files.classList.add("jodit_filebrowser_files_view-" + n.view), m.Cookie.set("jodit_filebrowser_view", n.view, 31);
        }).on(n.buttons.sort, "change", function () {
          n.sortBy = n.buttons.sort.value, m.Cookie.set("jodit_filebrowser_sortby", n.sortBy, 31), n.loadItems(n.currentPath, n.currentSource);
        }).on(n.buttons.sort, "click mousedown", function (e) {
          e.stopPropagation();
        }).on(n.buttons.filter, "click mousedown", function (e) {
          e.stopPropagation();
        }).on(n.buttons.filter, "keydown", c.debounce(function () {
          n.filterWord = n.buttons.filter.value, n.loadItems(n.currentPath, n.currentSource);
        }, 300)).on(n.buttons.remove, "click", function () {
          o.__getActiveElements().length && a.Confirm(t.i18n("Are you shure?"), "", function (e) {
            e && (o.__getActiveElements().forEach(function (e) {
              n.remove(n.currentPath, e.getAttribute("data-name") || "", e.getAttribute("data-source") || "");
            }), n.someSelectedWasChanged(), n.loadTree(n.currentPath, n.currentSource));
          });
        }).on(n.buttons.edit, "click", function () {
          var e = o.__getActiveElements();1 === e.length && n.openImageEditor(e[0].getAttribute("href") || "", e[0].getAttribute("data-name") || "", e[0].getAttribute("data-path") || "", e[0].getAttribute("data-source") || "");
        }).on(n.buttons.update, "click", function () {
          n.loadTree(o.currentPath, o.currentSource);
        }).on(n.tree, "click", function (e) {
          var o = this.parentNode,
              i = o.getAttribute("data-path") || "";return a.Confirm(t.i18n("Are you shure?"), "", function (e) {
            e && (n.remove(i, o.getAttribute("data-name") || "", o.getAttribute("data-source") || ""), n.loadTree(n.currentPath, n.currentSource));
          }), e.stopImmediatePropagation(), !1;
        }, "a>i.remove").on(n.tree, "click", function () {
          var e = this;this.classList.contains("addfolder") ? a.Promt(n.jodit.i18n("Enter Directory name"), n.jodit.i18n("Create directory"), function (t) {
            n.create(t, e.getAttribute("data-path") || "", e.getAttribute("data-source") || "");
          }, n.jodit.i18n("type name")) : (n.currentPath = this.getAttribute("data-path") || "", n.currentSource = this.getAttribute("data-source") || "", n.loadTree(n.currentPath, n.currentSource));
        }, "a").on(o.tree, "dragstart", function () {
          n.dragger = this;
        }, "a").on(o.tree, "drop", function () {
          if (n.options.moveFolder && n.dragger) {
            var e = n.dragger.getAttribute("data-path") || "";if (!n.options.moveFolder && n.dragger.classList.contains("jodit_filebrowser_tree_item")) return !1;if (n.dragger.classList.contains(g) && (e += n.dragger.getAttribute("data-name"), !n.options.moveFile)) return !1;n.move(e, this.getAttribute("data-path") || "", this.getAttribute("data-source") || "");
          }
        }, "a");var f = new u.ContextMenu(o.jodit);return n.jodit.events.on(n.files, "mousedown", function (e) {
          n.client.x = e.clientX, n.client.y = e.clientY, n.start = c.offset(this, n.jodit), n.draggable = this.cloneNode(!0), c.css(n.draggable, { "z-index": 1e14, position: "fixed", display: "none", left: n.start.left, top: n.start.top, width: this.offsetWidth, height: this.offsetHeight }), s.body.appendChild(n.draggable);
        }, "a>img").on(n.files, "dragstart", function (e) {
          n.dragger = this, e.dataTransfer.setData(h.TEXT_PLAIN, this.getAttribute("href") || ""), e.stopPropagation();
        }, "a").on(n.files, "contextmenu", function (e) {
          var t = this;if (n.options.contextMenu) {
            var o = this;return f.show(e.pageX, e.pageY, [!(!n.options.editImage || !n.canI("ImageResize") && !n.canI("ImageCrop")) && { icon: "pencil", title: "Edit", exec: function exec() {
                n.openImageEditor(o.getAttribute("href") || "", o.getAttribute("data-name") || "", o.getAttribute("data-path") || "", o.getAttribute("data-source") || "");
              } }, !!n.canI("FileRemove") && { icon: "bin", title: "Delete", exec: function exec() {
                n.remove(n.currentPath, o.getAttribute("data-name") || "", o.getAttribute("data-source") || ""), n.someSelectedWasChanged(), n.loadTree(n.currentPath, n.currentSource);
              } }, !!n.options.preview && { icon: "eye", title: "Preview", exec: function exec() {
                var e = o.getAttribute("href") || "",
                    i = new a.Dialog(n.jodit),
                    r = c.dom('<div class="jodit_filebrowser_preview"><i class="jodit_icon-loader"></i></div>', s),
                    l = n.buttons.select.cloneNode(!0),
                    u = s.createElement("img"),
                    p = function p() {
                  var a = function a() {
                    if (t.removeEventListener("load", a), r.innerHTML = "", n.options.showPreviewNavigation) {
                      var l = c.dom('<a href="javascript:void(0)" class="jodit_filebrowser_preview_navigation jodit_filebrowser_preview_navigation-next">' + d.ToolbarIcon.getIcon("angle-right") + "</a>", s),
                          f = c.dom('<a href="javascript:void(0)" class="jodit_filebrowser_preview_navigation jodit_filebrowser_preview_navigation-prev">' + d.ToolbarIcon.getIcon("angle-left") + "</a>", s);o.previousSibling && o.previousSibling.classList && o.previousSibling.classList.contains(g) && r.appendChild(f), o.nextSibling && o.nextSibling.classList && o.nextSibling.classList.contains(g) && r.appendChild(l), n.jodit.events.on([l, f], "click", function () {
                        o = this.classList.contains("jodit_filebrowser_preview_navigation-next") ? o.nextSibling : o.previousSibling, r.innerHTML = '<i class="jodit_icon-loader"></i>', e = o.getAttribute("href") || "", u.setAttribute("src", e), p();
                      });
                    }r.appendChild(u), i.setPosition();
                  };u.addEventListener("load", a), u.complete && a.call(u);
                };p(), u.setAttribute("src", e), i.setContent(r), n.options.showSelectButtonInPreview && (l.removeAttribute("disabled"), i.setTitle(l), l.addEventListener("click", function () {
                  c.$$("a.active", n.files).forEach(function (e) {
                    return e.classList.add("active");
                  }), o.classList.add("active"), n.jodit.events.fire(n.buttons.select, "click"), i.close();
                })), i.open();
              } }, { icon: "upload", title: "Download", exec: function exec() {
                o.getAttribute("href") && n.jodit.ownerWindow.open();
              } }]), e.stopPropagation(), e.preventDefault(), !1;
          }
        }, "a").on(n.files, "click", function (e) {
          c.ctrlKey(e) || (o.__getActiveElements().forEach(function (e) {
            e.classList.remove("active");
          }), n.someSelectedWasChanged());
        }).on(n.files, "click", function (e) {
          return c.ctrlKey(e) || n.__getActiveElements().forEach(function (e) {
            e.classList.remove("active");
          }), this.classList.toggle("active"), n.someSelectedWasChanged(), e.stopPropagation(), !1;
        }, "a").on(n.jodit.ownerDocument, "dragover", function (e) {
          n.isOpened() && n.draggable && void 0 !== e.clientX && c.css(n.draggable, { left: e.clientX + 20, top: e.clientY + 20, display: "block" });
        }).on(n.jodit.ownerWindow, "keydown", function (e) {
          n.isOpened() && e.which === h.KEY_DELETE && n.jodit.events.fire(n.buttons.remove, "click");
        }).on(n.jodit.ownerWindow, "mouseup dragend", function () {
          n.draggable && (n.draggable.parentNode && n.draggable.parentNode.removeChild(n.draggable), n.draggable = !1);
        }), o.dialog.setSize(o.options.width, o.options.height), o.options.getLocalFileByUrl = c.extend(!0, {}, o.options.ajax, o.options.getLocalFileByUrl), o.options.crop = c.extend(!0, {}, o.options.ajax, o.options.crop), o.options.resize = c.extend(!0, {}, o.options.ajax, o.options.resize), o.options.create = c.extend(!0, {}, o.options.ajax, o.options.create), o.options.move = c.extend(!0, {}, o.options.ajax, o.options.move), o.options.remove = c.extend(!0, {}, o.options.ajax, o.options.remove), o.options.folder = c.extend(!0, {}, o.options.ajax, o.options.folder), o.options.items = c.extend(!0, {}, o.options.ajax, o.options.items), o.options.permissions = c.extend(!0, {}, o.options.ajax, o.options.permissions), o.view = "list" === o.options.view ? "list" : "tiles", m.Cookie.get("jodit_filebrowser_view") && (o.view = "list" === m.Cookie.get("jodit_filebrowser_view") ? "list" : "tiles"), o.buttons[o.view].classList.remove("disabled"), o.files.classList.add("jodit_filebrowser_files_view-" + o.view), o.sortBy = -1 !== ["changed", "name", "size"].indexOf(o.options.sortBy) ? o.options.sortBy : "changed", m.Cookie.get("jodit_filebrowser_sortby") && (o.sortBy = -1 !== ["changed", "name", "size"].indexOf(m.Cookie.get("jodit_filebrowser_sortby") || "") ? m.Cookie.get("jodit_filebrowser_sortby") || "" : "changed"), o.buttons.sort.value = o.sortBy, o.currentBaseUrl = c.$$("base", o.jodit.editorDocument).length ? c.$$("base", o.jodit.editorDocument)[0].getAttribute("href") || "" : location.protocol + "//" + location.host, void 0 !== r.Jodit.modules.Uploader && (o.uploader = new p.Uploader(o.jodit, i({}, o.jodit.options.uploader, o.options.uploader ? o.options.uploader : {})), o.uploader.setPath(o.currentPath), o.uploader.setSource(o.currentSource), o.uploader.bind(o.browser, o.uploadHandler, o.errorHandler), o.uploader.bind(o.buttons.upload, o.uploadHandler, o.errorHandler)), o;
      }return n(t, e), t.prototype.canI = function (e) {
        return null !== this.__currentPerpissions && (void 0 === this.__currentPerpissions["allow" + e] || this.__currentPerpissions["allow" + e]);
      }, t.prototype.toggleButtonsByPermissions = function () {
        this.buttons.upload.classList.toggle("jodit_hidden", !this.canI("FileUpload")), this.buttons.remove.classList.toggle("jodit_hidden", !this.canI("FileRemove")), this.buttons.edit.classList.toggle("jodit_hidden", !this.canI("ImageResize") && !this.canI("ImageCrop"));
      }, t.prototype.isOpened = function () {
        return this.dialog.isOpened() && "none" !== this.browser.style.display;
      }, t.prototype.status = function (e, t) {
        var o = this;clearTimeout(this.statustimer), this.status_line.classList.remove("success"), this.status_line.classList.add("active"), this.status_line.innerHTML = e, t && this.status_line.classList.add("success"), this.statustimer = window.setTimeout(function () {
          o.status_line.classList.remove("active");
        }, this.options.howLongShowMsg);
      }, t.prototype.generateFolderTree = function (e) {
        var t = this,
            o = [];c.each(e, function (e, n) {
          e && e !== v && o.push('<div class="jodit_filebrowser_source_title">' + e + "</div>"), n.folders.forEach(function (i) {
            var r = '<a draggable="draggable" class="jodit_filebrowser_tree_item" href="javascript:void(0)" data-path="' + c.pathNormalize(n.path + i) + '/" data-source="' + e + '"><span>' + i + "</span>";t.options.deleteFolder && ".." !== i && "." !== i && (r += '<i class="remove" data-path="' + c.pathNormalize(n.path + i + "/") + '">&times;</i>'), r += "</a>", o.push(r);
          }), t.options.createNewFolder && t.canI("FolderCreate") && o.push('<a class="jodit_button addfolder" href="javascript:void(0)" data-path="' + c.pathNormalize(n.path + name) + '/" data-source="' + e + '">' + d.ToolbarIcon.getIcon("plus") + " " + t.jodit.i18n("Add folder") + "</a>");
        }), this.tree.innerHTML = o.join("");
      }, t.prototype.generateItemsBox = function (e) {
        var t = this,
            o = [];c.each(e, function (e, n) {
          e && e !== v && o.push('<div class="jodit_filebrowser_source_title">' + e + (n.path ? " - " + n.path : "") + "</div>"), n.files && n.files.length ? ("function" == typeof t.options.sort && n.files.sort(function (e, o) {
            return t.options.sort(e, o, t.sortBy, t.jodit);
          }), n.files.forEach(function (i) {
            (void 0 === t.options.filter || t.options.filter(i, t.filterWord)) && o.push(t.options.getThumbTemplate.call(t, i, n, e));
          })) : o.push("<div>" + t.jodit.i18n("There are no files") + "</div>");
        }), this.files.innerHTML = o.join("");
      }, t.prototype.__getActiveElements = function () {
        return c.$$(":scope>a.active", this.files);
      }, t.prototype.someSelectedWasChanged = function () {
        var e = this.__getActiveElements();this.buttons.remove.classList.toggle("disabled", !e.length), this.buttons.select.classList.toggle("disabled", !e.length), this.buttons.edit.classList.toggle("disabled", 1 !== e.length);
      }, t.prototype.send = function (e, t, o) {
        var n,
            i = c.extend(!0, {}, this.options.ajax, void 0 !== this.options[e] ? this.options[e] : this.options.ajax);return i.prepareData && (i.data = i.prepareData.call(this, i.data)), n = new f.Ajax(this.jodit, i), n.send().then(t).catch(o), n;
      }, t.prototype.loadPermissions = function (e, t, o) {
        var n = this,
            i = this;i.options.permissions.data.path = e, i.options.permissions.data.source = t, i.options.permissions.url ? (i.__permissions && i.__permissions.abort && i.__permissions.abort(), i.__permissions = i.send("permissions", function (e) {
          var t = i.options.permissions.process;if (t || (t = n.options.ajax.process), t) {
            var r = t.call(i, e);r.data.permissions && (n.__currentPerpissions = r.data.permissions, n.toggleButtonsByPermissions(), o());
          }
        }, function (e) {
          a.Alert(e.message), i.errorHandler(e), o();
        })) : o();
      }, t.prototype.loadTree = function (e, t) {
        var o = this;this.loadPermissions(e, t, function () {
          var n = o;n.options.folder.data.path = e, n.options.folder.data.source = t, n.uploader && (n.uploader.setPath(e), n.uploader.setSource(t)), n.options.showFoldersPanel && (n.options.folder.url ? (n.tree.classList.add("active"), n.tree.innerHTML = "", n.tree.appendChild(n.loader.cloneNode(!0)), n.__ajax && n.__ajax.abort && n.__ajax.abort(), n.__ajax = o.send("folder", function (e) {
            var t = n.options.folder.process;if (t || (t = o.options.ajax.process), t) {
              var i = t.call(n, e);n.generateFolderTree(i.data.sources);
            }
          }, function () {
            n.errorHandler(Error(n.jodit.i18n("Error on load folders")));
          })) : n.tree.classList.remove("active")), o.loadItems(e, t);
        });
      }, t.prototype.remove = function (e, t, o) {
        var n = this;this.options.remove.data.path = e, this.options.remove.data.name = t, this.options.remove.data.source = o, this.send("remove", function (e) {
          n.options.remove.process && (e = n.options.remove.process.call(n, e)), n.options.isSuccess(e) ? (n.someSelectedWasChanged(), n.status(n.options.getMessage(e), !0)) : n.status(n.options.getMessage(e));
        }, function (e) {
          n.status(e.message);
        });
      }, t.prototype.onSelect = function (e) {
        var t = this;return function () {
          var o = t.__getActiveElements();if (o.length) {
            var n = [];o.forEach(function (e) {
              var t = e.getAttribute("data-url");t && n.push(t);
            }), t.close(), "function" == typeof e && e({ baseurl: "", files: n });
          }return !1;
        };
      }, t;
    }(s.Component);
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(4),
        r = o(1),
        s = o(0),
        a = o(5),
        l = o(7);r.Config.prototype.imageeditor = { closeAfterSave: !1, width: "85%", height: "85%", crop: !0, resize: !0, resizeUseRatio: !0, resizeMinWidth: 20, resizeMinHeight: 20, cropUseRatio: !0, cropDefaultWidth: "70%", cropDefaultHeight: "70%" }, t.ImageEditor = function (e) {
      function t(t) {
        var o = e.call(this, t) || this;return o.resizeUseRatio = !0, o.cropUseRatio = !0, o.clicked = !1, o.activeTab = "resize", o.hide = function () {
          o.dialog.close();
        }, o.calcValueByPercent = function (e, t) {
          var o,
              n = "" + t,
              i = parseFloat("" + e);return (o = /^[\-+]?[0-9]+(px)?$/.exec(n)) ? parseInt(n, 10) : (o = /^([\-+]?[0-9.]+)%$/.exec(n), o ? Math.round(i * (parseFloat(o[1]) / 100)) : i || 0);
        }, o.calcCropBox = function () {
          var e = .8 * o.crop_box.parentNode.offsetWidth,
              t = .8 * o.crop_box.parentNode.offsetHeight,
              n = e,
              i = t;e > o.naturalWidth && t > o.naturalHeight ? (n = o.naturalWidth, i = o.naturalHeight) : o.ratio > e / t ? (n = e, i = o.naturalHeight * (e / o.naturalWidth)) : (n = o.naturalWidth * (t / o.naturalHeight), i = t), s.css(o.crop_box, { width: n, height: i });
        }, o.showCrop = function () {
          o.cropImage && (o.calcCropBox(), o.new_w = o.calcValueByPercent(o.cropImage.offsetWidth || o.image.offsetWidth, o.options.cropDefaultWidth), o.new_h = o.cropUseRatio ? o.new_w / o.ratio : o.calcValueByPercent(o.cropImage.offsetHeight || o.image.offsetHeight, o.options.cropDefaultHeight), s.css(o.cropHandler, { backgroundImage: "url(" + o.cropImage.getAttribute("src") + ")", width: o.new_w, height: o.new_h, left: (o.cropImage.offsetWidth || o.image.offsetWidth) / 2 - o.new_w / 2, top: (o.cropImage.offsetHeight || o.image.offsetHeight) / 2 - o.new_h / 2 }), o.jodit.events.fire(o.cropHandler, "updatesize"));
        }, o.cropBox = { x: 0, y: 0, w: 0, h: 0 }, o.updateCropBox = function () {
          if (o.cropImage) {
            var e = o.cropImage.offsetWidth / o.naturalWidth,
                t = o.cropImage.offsetHeight / o.naturalHeight;o.cropBox.x = s.css(o.cropHandler, "left") / e, o.cropBox.y = s.css(o.cropHandler, "top") / t, o.cropBox.w = o.cropHandler.offsetWidth / e, o.cropBox.h = o.cropHandler.offsetHeight / t, o.sizes.innerText = o.cropBox.w.toFixed(0) + "x" + o.cropBox.h.toFixed(0);
          }
        }, o.resizeBox = { w: 0, h: 0 }, o.updateResizeBox = function () {
          o.resizeBox.w = o.image.offsetWidth || o.naturalWidth, o.resizeBox.h = o.image.offsetHeight || o.naturalHeight;
        }, o.open = function (e, t) {
          var n = new Date().getTime();o.image = o.jodit.ownerDocument.createElement("img"), s.$$("img,.jodit_icon-loader", o.resize_box).forEach(function (e) {
            e.parentNode && e.parentNode.removeChild(e);
          }), s.$$("img,.jodit_icon-loader", o.crop_box).forEach(function (e) {
            e.parentNode && e.parentNode.removeChild(e);
          }), s.css(o.cropHandler, "background", "transparent"), o.onSave = t, o.resize_box.appendChild(s.dom('<i class="jodit_icon-loader"></i>', o.jodit.ownerDocument)), o.crop_box.appendChild(s.dom('<i class="jodit_icon-loader"></i>', o.jodit.ownerDocument)), /\?/.test(e) ? e += "&_tst=" + n : e += "?_tst=" + n, o.image.setAttribute("src", e), o.dialog.open();var i = function i() {
            o.image.removeEventListener("load", i), o.naturalWidth = o.image.naturalWidth, o.naturalHeight = o.image.naturalHeight, o.widthInput.value = "" + o.naturalWidth, o.heightInput.value = "" + o.naturalHeight, o.ratio = o.naturalWidth / o.naturalHeight, o.resize_box.appendChild(o.image), o.cropImage = o.image.cloneNode(), o.crop_box.appendChild(o.cropImage), s.$$(".jodit_icon-loader", o.editor).forEach(function (e) {
              e.parentNode && e.parentNode.removeChild(e);
            }), "crop" === o.activeTab && o.showCrop(), o.jodit.events.fire(o.resizeHandler, "updatesize"), o.jodit.events.fire(o.cropHandler, "updatesize"), o.dialog.setPosition(), o.jodit.events.fire("afterImageEditor");
          };o.image.addEventListener("load", i), o.image.complete && i();
        }, o.setHandlers = function () {
          var e = o;e.jodit.events.on([e.editor.querySelector(".jodit_bottomright"), e.cropHandler], "mousedown", function (t) {
            e.target = t.target || t.srcElement, t.preventDefault(), t.stopImmediatePropagation(), e.clicked = !0, e.start_x = t.clientX, e.start_y = t.clientY, "crop" === e.activeTab ? (e.top_x = s.css(e.cropHandler, "left"), e.top_y = s.css(e.cropHandler, "top"), e.width = e.cropHandler.offsetWidth, e.height = e.cropHandler.offsetHeight) : (e.width = e.image.offsetWidth, e.height = e.image.offsetHeight);
          }).off(o.jodit.ownerWindow, ".jodit_image_editor" + e.jodit.id).on(o.jodit.ownerWindow, "mousemove.jodit_image_editor" + e.jodit.id, s.throttle(function (t) {
            e.clicked && (e.diff_x = t.clientX - e.start_x, e.diff_y = t.clientY - e.start_y, "resize" === e.activeTab && e.resizeUseRatio || "crop" === e.activeTab && e.cropUseRatio ? e.diff_x ? (e.new_w = e.width + e.diff_x, e.new_h = Math.round(e.new_w / e.ratio)) : (e.new_h = e.height + e.diff_y, e.new_w = Math.round(e.new_h * e.ratio)) : (e.new_w = e.width + e.diff_x, e.new_h = e.height + e.diff_y), "resize" === e.activeTab ? (e.new_w > e.options.resizeMinWidth && (s.css(e.image, "width", e.new_w + "px"), e.widthInput.value = "" + e.new_w), e.new_h > e.options.resizeMinHeight && (s.css(e.image, "height", e.new_h + "px"), e.heightInput.value = "" + e.new_h), o.jodit.events.fire(e.resizeHandler, "updatesize")) : (e.target !== e.cropHandler ? (e.top_x + e.new_w > e.cropImage.offsetWidth && (e.new_w = e.cropImage.offsetWidth - e.top_x), e.top_y + e.new_h > e.cropImage.offsetHeight && (e.new_h = e.cropImage.offsetHeight - e.top_y), s.css(e.cropHandler, { width: e.new_w, height: e.new_h })) : (e.top_x + e.diff_x + e.cropHandler.offsetWidth > e.cropImage.offsetWidth && (e.diff_x = e.cropImage.offsetWidth - e.top_x - e.cropHandler.offsetWidth), s.css(e.cropHandler, "left", e.top_x + e.diff_x), e.top_y + e.diff_y + e.cropHandler.offsetHeight > e.cropImage.offsetHeight && (e.diff_y = e.cropImage.offsetHeight - e.top_y - e.cropHandler.offsetHeight), s.css(e.cropHandler, "top", e.top_y + e.diff_y)), o.jodit.events.fire(e.cropHandler, "updatesize")), t.stopImmediatePropagation());
          }, 5)).on(o.jodit.ownerWindow, "resize.jodit_image_editor" + e.jodit.id, function () {
            o.jodit.events.fire(e.resizeHandler, "updatesize"), e.showCrop(), o.jodit.events.fire(e.cropHandler, "updatesize");
          }).on(o.jodit.ownerWindow, "mouseup.jodit_image_editor" + e.jodit.id + " keydown.jodit_image_editor" + e.jodit.id, function (t) {
            e.clicked && (e.clicked = !1, t.stopImmediatePropagation());
          }), s.$$(".jodit_btn_group", e.editor).forEach(function (t) {
            var o = t.querySelector("input");e.jodit.events.on(t, "click change", function () {
              var n = this;s.$$("button", t).forEach(function (e) {
                return e.classList.remove("active");
              }), n.classList.add("active"), o.checked = !!n.getAttribute("data-yes"), e.jodit.events.fire(o, "change");
            }, "button");
          }), e.jodit.events.on(o.editor, "click", function () {
            s.$$(".jodit_image_editor_slider,.jodit_image_editor_area", e.editor).forEach(function (e) {
              return e.classList.remove("active");
            });var t = this.parentNode;t.classList.add("active"), e.activeTab = t.getAttribute("data-area") || "";var o = e.editor.querySelector(".jodit_image_editor_area.jodit_image_editor_area_" + e.activeTab);o && o.classList.add("active"), "crop" === e.activeTab && e.showCrop();
          }, ".jodit_image_editor_slider-title").on(e.widthInput, "change mousedown keydown", s.debounce(function () {
            var t,
                n = parseInt(e.widthInput.value, 10);n > e.jodit.options.resizer.min_width && (s.css(e.image, "width", n + "px"), e.resizeUseRatio && (t = Math.round(n / e.ratio)) > e.jodit.options.resizer.min_height && (s.css(e.image, "height", t + "px"), e.heightInput.value = "" + t)), o.jodit.events.fire(e.resizeHandler, "updatesize");
          }, 200)).on(e.heightInput, "change mousedown keydown", s.debounce(function () {
            var t,
                n = parseInt(e.heightInput.value, 10);n > e.jodit.options.resizer.min_height && (s.css(e.image, "height", n + "px"), e.resizeUseRatio && (t = Math.round(n * e.ratio)) > e.jodit.options.resizer.min_width && (s.css(e.image, "width", t + "px"), e.widthInput.value = "" + t)), o.jodit.events.fire(e.resizeHandler, "updatesize");
          }, 200));var t = e.editor.querySelector(".jodit_image_editor_keep_spect_ratio");t && t.addEventListener("change", function () {
            e.resizeUseRatio = t.checked;
          });var n = e.editor.querySelector(".jodit_image_editor_keep_spect_ratio_crop");n && n.addEventListener("change", function () {
            e.cropUseRatio = n.checked;
          }), e.jodit.events.on(e.resizeHandler, "updatesize", function () {
            s.css(e.resizeHandler, { top: 0, left: 0, width: (e.image.offsetWidth || e.naturalWidth) + "px", height: (e.image.offsetHeight || e.naturalHeight) + "px" }), o.updateResizeBox();
          }).on(e.cropHandler, "updatesize", function () {
            if (e.cropImage) {
              var t = s.css(e.cropHandler, "left"),
                  o = s.css(e.cropHandler, "top"),
                  n = e.cropHandler.offsetWidth,
                  i = e.cropHandler.offsetHeight;0 > t && (t = 0), 0 > o && (o = 0), t + n > e.cropImage.offsetWidth && (n = e.cropImage.offsetWidth - t, e.cropUseRatio && (i = n / e.ratio)), o + i > e.cropImage.offsetHeight && (i = e.cropImage.offsetHeight - o, e.cropUseRatio && (n = i * e.ratio)), s.css(e.cropHandler, { width: n, height: i, left: t, top: o, backgroundPosition: -t - 1 + "px " + (-o - 1) + "px", backgroundSize: e.cropImage.offsetWidth + "px " + e.cropImage.offsetHeight + "px" }), e.updateCropBox();
            }
          }), e.buttons.forEach(function (t) {
            t.addEventListener("mousedown", function (e) {
              e.stopImmediatePropagation();
            }), t.addEventListener("click", function () {
              var o = { action: e.activeTab, box: "resize" === e.activeTab ? e.resizeBox : e.cropBox };switch (t.getAttribute("data-action")) {case "saveas":
                  l.Promt(e.jodit.i18n("Enter new name"), e.jodit.i18n("Save in new file"), function (t) {
                    if (!s.trim(t)) return l.Alert(e.jodit.i18n("The name should not be empty")), !1;e.onSave(t, o, e.hide, function (e) {
                      l.Alert(e);
                    });
                  });break;case "save":
                  e.onSave(void 0, o, e.hide, function (e) {
                    l.Alert(e);
                  });break;case "reset":
                  "resize" === e.activeTab ? (s.css(e.image, { width: null, height: null }), e.widthInput.value = "" + e.naturalWidth, e.heightInput.value = "" + e.naturalHeight, e.jodit.events.fire(e.resizeHandler, "updatesize")) : e.showCrop();}
            });
          });
        }, o.options = t.options.imageeditor, o.resizeUseRatio = o.options.resizeUseRatio, o.cropUseRatio = o.options.cropUseRatio, o.buttons = [s.dom('<button data-action="reset" type="button" class="jodit_btn">' + a.ToolbarIcon.getIcon("update") + " " + t.i18n("Reset") + "</button>", t.ownerDocument), s.dom('<button data-action="save" type="button" class="jodit_btn jodit_btn_success">' + a.ToolbarIcon.getIcon("save") + " " + t.i18n("Save") + "</button>", t.ownerDocument), s.dom('<button data-action="saveas" type="button" class="jodit_btn jodit_btn_success">' + a.ToolbarIcon.getIcon("save") + " " + t.i18n("Save as ...") + "</button>", t.ownerDocument)], o.activeTab = o.options.resize ? "resize" : "crop", o.editor = s.dom('<form class="jodit_image_editor jodit_properties"><div class="jodit_grid"><div class="jodit_col-lg-3-4">' + (o.options.resize ? '<div class="jodit_image_editor_area jodit_image_editor_area_resize active">                                <div class="jodit_image_editor_box"></div>                                <div class="jodit_image_editor_resizer">                                    <i class="jodit_bottomright"></i>                                </div>                            </div>' : "") + (o.options.crop ? '<div class="jodit_image_editor_area jodit_image_editor_area_crop' + (o.options.resize ? "" : " active") + '">                                <div class="jodit_image_editor_box">                                    <div class="jodit_image_editor_croper">                                        <i class="jodit_bottomright"></i>                                        <i class="jodit_sizes"></i>                                    </div>                                </div>                            </div>' : "") + '</div><div class="jodit_col-lg-1-4">' + (o.options.resize ? '<div data-area="resize" class="jodit_image_editor_slider active">                                <div class="jodit_image_editor_slider-title">' + a.ToolbarIcon.getIcon("resize") + t.i18n("Resize") + '</div>                                <div class="jodit_image_editor_slider-content">                                    <div class="jodit_form_group">                                        <label for="jodit_image_editor_width">' + t.i18n("Width") + '</label>                                        <input type="number" class="jodit_image_editor_width"/>                                    </div>                                    <div class="jodit_form_group">                                        <label for="jodit_image_editor_height">' + t.i18n("Height") + '</label>                                        <input type="number" class="jodit_image_editor_height"/>                                    </div>                                    <div class="jodit_form_group">                                        <label>' + t.i18n("Keep Aspect Ratio") + '</label>                                        <div class="jodit_btn_group jodit_btn_radio_group">                                            <input ' + (o.resizeUseRatio ? "checked" : "") + ' type="checkbox" class="jodit_image_editor_keep_spect_ratio"/>                                            <button type="button"  data-yes="1" class="jodit_col6 jodit_btn jodit_btn_success ' + (o.resizeUseRatio ? "active" : "") + '">' + t.i18n("Yes") + '</button>                                            <button type="button" class="jodit_col6 jodit_btn' + (o.resizeUseRatio ? "" : "active") + '">' + t.i18n("No") + "</button>                                        </div>                                    </div>                                </div>                            </div>" : "") + (o.options.crop ? '<div data-area="crop" class="jodit_image_editor_slider' + (o.options.resize ? "" : " active") + '">                                <div class="jodit_image_editor_slider-title">' + a.ToolbarIcon.getIcon("crop") + t.i18n("Crop") + '</div>                                <div class="jodit_image_editor_slider-content">                                    <div class="jodit_form_group">                                        <label>' + t.i18n("Keep Aspect Ratio") + '</label>                                        <div class="jodit_btn_group jodit_btn_radio_group">                                            <input ' + (o.cropUseRatio ? "checked" : "") + ' type="checkbox" class="jodit_image_editor_keep_spect_ratio_crop"/>                                            <button type="button" data-yes="1" class="jodit_col6 jodit_btn jodit_btn_success ' + (o.cropUseRatio ? "active" : "") + '">' + t.i18n("Yes") + '</button>                                            <button type="button" class="jodit_col6 jodit_btn ' + (o.cropUseRatio ? "" : "active") + '">' + t.i18n("No") + "</button>                                        </div>                                    </div>                                </div>                            </div>" : "") + "</div></div></form>", t.ownerDocument), o.widthInput = o.editor.querySelector(".jodit_image_editor_width"), o.heightInput = o.editor.querySelector(".jodit_image_editor_height"), o.resize_box = o.editor.querySelector(".jodit_image_editor_area.jodit_image_editor_area_resize .jodit_image_editor_box"), o.crop_box = o.editor.querySelector(".jodit_image_editor_area.jodit_image_editor_area_crop .jodit_image_editor_box"), o.sizes = o.editor.querySelector(".jodit_image_editor_area.jodit_image_editor_area_crop .jodit_sizes"), o.resizeHandler = o.editor.querySelector(".jodit_image_editor_resizer"), o.cropHandler = o.editor.querySelector(".jodit_image_editor_croper"), o.dialog = new l.Dialog(t), o.dialog.setContent(o.editor), o.dialog.setSize(o.options.width, o.options.height), o.dialog.setTitle(o.buttons), o.setHandlers(), o;
      }return n(t, e), t;
    }(i.Component);
  }, function (e, t, o) {
    "use strict";
    function n(e) {
      e.events.on("keydown", function (t) {
        var o, n;if ((t.which === i.KEY_TAB || t.which === i.KEY_LEFT || t.which === i.KEY_RIGHT || t.which === i.KEY_TOP || t.which === i.KEY_BOTTOM) && (o = e.selection.current(), n = r.Dom.up(o, function (e) {
          return e && e.nodeName && /^td|th$/i.test(e.nodeName);
        }, e.editor))) {
          var s = e.editorWindow.getSelection(),
              a = s.rangeCount ? s.getRangeAt(0) : e.editorDocument.createRange();if (t.which === i.KEY_TAB || o === n || (t.which !== i.KEY_LEFT && t.which !== i.KEY_TOP || !(r.Dom.prev(o, function (e) {
            return t.which === i.KEY_TOP ? e && "BR" === e.nodeName : !!e;
          }, n) || t.which !== i.KEY_TOP && o.nodeType === Node.TEXT_NODE && 0 !== a.startOffset)) && (t.which !== i.KEY_RIGHT && t.which !== i.KEY_BOTTOM || !(r.Dom.next(o, function (e) {
            return t.which === i.KEY_BOTTOM ? e && "BR" === e.nodeName : !!e;
          }, n) || t.which !== i.KEY_BOTTOM && o.nodeType === Node.TEXT_NODE && o.nodeValue && a.startOffset !== o.nodeValue.length))) {
            var l = r.Dom.up(n, function (e) {
              return e && /^table$/i.test(e.nodeName);
            }, e.editor),
                c = null;switch (t.which) {case i.KEY_TAB:case i.KEY_LEFT:
                var d = t.which === i.KEY_LEFT || t.shiftKey ? "prev" : "next";(c = r.Dom[d](n, function (e) {
                  return e && /^td|th$/i.test(e.tagName);
                }, l)) || (r.Table.appendRow(l, "next" !== d && l.querySelector("tr"), "next" === d), c = r.Dom[d](n, function (t) {
                  return t && r.Dom.isCell(t, e.editorWindow);
                }, l));break;case i.KEY_TOP:case i.KEY_BOTTOM:
                var u = 0,
                    p = 0,
                    f = r.Table.formalMatrix(l, function (e, t, o) {
                  e === n && (u = t, p = o);
                });t.which === i.KEY_TOP ? void 0 !== f[u - 1] && (c = f[u - 1][p]) : void 0 !== f[u + 1] && (c = f[u + 1][p]);}if (c) {
              if (c.firstChild) t.which === i.KEY_TAB ? e.selection.select(c, !0) : e.selection.setCursorIn(c, t.which === i.KEY_RIGHT || t.which === i.KEY_BOTTOM);else {
                var h = r.Dom.create("br", "", e.editorDocument);c.appendChild(h), e.selection.setCursorBefore(h);
              }return !1;
            }
          }
        }
      });
    }Object.defineProperty(t, "__esModule", { value: !0 });var i = o(2),
        r = o(9);t.tableKeyboardNavigation = n;
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(1),
        r = o(0),
        s = o(9),
        a = o(2),
        l = o(2);i.Config.prototype.useSearch = !0, t.search = function (e) {
      function t(o) {
        var n = e.call(this, o) || this;if (n.template = '<div class="jodit_search"><div class="jodit_search_box"><div class="jodit_search_inputs"><input tabindex="0" class="jodit_search-query" placeholder="' + n.jodit.i18n("Search for") + '" type="text"/><input tabindex="0" class="jodit_search-replace" placeholder="' + n.jodit.i18n("Replace with") + '" type="text"/></div><div class="jodit_search_counts"><span>0/0</span></div><div class="jodit_search_buttons"><button tabindex="0" type="button" class="jodit_search_buttons-next">' + s.ToolbarIcon.getIcon("angle-down") + '</button><button tabindex="0" type="button" class="jodit_search_buttons-prev">' + s.ToolbarIcon.getIcon("angle-up") + '</button><button tabindex="0" type="button" class="jodit_search_buttons-cancel">' + s.ToolbarIcon.getIcon("cancel") + '</button><button tabindex="0" type="button" class="jodit_search_buttons-replace">' + n.jodit.i18n("Replace") + "</button></div></div></div>", n.eachMap = function (e, t, o) {
          s.Dom.findWithCurrent(e, function (e) {
            return !!e && !0 === t(e);
          }, n.jodit.editor, o ? "nextSibling" : "previousSibling", o ? "firstChild" : "lastChild");
        }, n.updateCounters = function () {
          if (n.isOpened) {
            n.counterBox.style.display = n.queryInput.value.length ? "inline-block" : "none";var e = n.jodit.editorWindow.getSelection(),
                t = e.rangeCount ? e.getRangeAt(0) : n.jodit.editorDocument.createRange(),
                o = n.calcCounts(n.queryInput.value, t);n.counterBox.innerText = o.join("/");
          }
        }, n.calcCounts = function (e, t) {
          void 0 === t && (t = !1);for (var o = 0, i = 0, r = [], s = !1, a = n.jodit.editor.firstChild; a && e.length;) {
            if (s = n.find(a, e, !0, 0, s || n.jodit.editorDocument.createRange())) {
              if (n.boundAlreadyWas(s, r)) break;r.push(s), a = s.startContainer, i += 1, t && n.boundAlreadyWas(t, [s]) && (o = i);
            } else a = null;
          }return [o, i];
        }, n.findAndReplace = function (e, t) {
          var o = n.jodit.editorWindow.getSelection(),
              i = o.rangeCount ? o.getRangeAt(0) : n.jodit.editorDocument.createRange(),
              r = n.find(e, t, !0, 0, i);if (r && r.startContainer && r.endContainer) {
            var s = n.jodit.editorDocument.createRange();try {
              if (r && r.startContainer && r.endContainer) {
                s.setStart(r.startContainer, r.startOffset), s.setEnd(r.endContainer, r.endOffset), s.deleteContents();var a = n.jodit.editorDocument.createTextNode(n.replaceInput.value);s.insertNode(a), n.jodit.selection.select(a), n.tryScrollToElement(a);
              }
            } catch (e) {}return !0;
          }return !1;
        }, n.findAndSelect = function (e, t, o) {
          var i = n.jodit.editorWindow.getSelection(),
              r = i.rangeCount ? i.getRangeAt(0) : n.jodit.editorDocument.createRange(),
              s = n.find(e, t, o, 0, r);if (s && s.startContainer && s.endContainer) {
            var a = n.jodit.editorDocument.createRange();try {
              a.setStart(s.startContainer, s.startOffset), a.setEnd(s.endContainer, s.endOffset), n.jodit.selection.selectRange(a);
            } catch (e) {}return n.tryScrollToElement(s.startContainer), n.current = s.startContainer, n.updateCounters(), !0;
          }return !1;
        }, n.find = function (e, o, i, a, l) {
          if (e && o.length) {
            var c = "",
                d = { startContainer: null, startOffset: null, endContainer: null, endOffset: null };if (n.eachMap(e, function (e) {
              if (e.nodeType === Node.TEXT_NODE && null !== e.nodeValue && e.nodeValue.length) {
                var n = e.nodeValue;i || e !== l.startContainer ? i && e === l.endContainer && (n = a ? n.substr(0, l.startOffset) : n.substr(l.endOffset)) : n = a ? n.substr(l.endOffset) : n.substr(0, l.startOffset);var u = i ? c + n : n + c,
                    p = t.findSomePartOfString(o, u, i);if (!1 !== p) {
                  var f = t.findSomePartOfString(o, n, i);!0 === f ? f = r.trim(o) : !1 === f && !0 === (f = t.findSomePartOfString(n, o, i)) && (f = r.trim(n));var h = t.getSomePartOfStringIndex(o, n, i) || 0;if ((i && !a || !i && a) && e.nodeValue.length - n.length > 0 && (h += e.nodeValue.length - n.length), null === d.startContainer && (d.startContainer = e, d.startOffset = h), !0 === p) return d.endContainer = e, d.endOffset = h, d.endOffset += f.length, !0;c = u;
                } else c = "", d = { startContainer: null, startOffset: null, endContainer: null, endOffset: null };
              } else s.Dom.isBlock(e) && "" !== c && (c = i ? c + " " : " " + c);return !1;
            }, i), d.startContainer && d.endContainer) return d;if (!a) return n.current = i ? n.jodit.editor.firstChild : n.jodit.editor.lastChild, n.find(n.current, o, i, a + 1, l);
          }return !1;
        }, n.isOpened = !1, n.open = function (e) {
          void 0 === e && (e = !1), n.isOpened || (n.searchBox.classList.add("jodit_search-active"), n.isOpened = !0), n.jodit.events.fire("hidePopup"), n.searchBox.classList.toggle("jodit_search-and-replace", e), n.current = n.jodit.selection.current(), n.selInfo = n.jodit.selection.save();var t = "" + n.jodit.ownerWindow.getSelection();t && (n.queryInput.value = t), n.updateCounters(), t ? n.queryInput.select() : n.queryInput.focus();
        }, n.selInfo = null, n.current = !1, n.close = function () {
          n.isOpened && (n.selInfo && (n.jodit.selection.restore(n.selInfo), n.selInfo = null), n.searchBox.classList.remove("jodit_search-active"), n.isOpened = !1);
        }, o.options.useSearch) {
          var i = n;i.searchBox = r.dom(i.template, o.ownerDocument), i.queryInput = i.searchBox.querySelector("input.jodit_search-query"), i.replaceInput = i.searchBox.querySelector("input.jodit_search-replace"), i.closeButton = i.searchBox.querySelector(".jodit_search_buttons-cancel"), i.nextButton = i.searchBox.querySelector(".jodit_search_buttons-next"), i.prevButton = i.searchBox.querySelector(".jodit_search_buttons-prev"), i.replaceButton = i.searchBox.querySelector(".jodit_search_buttons-replace"), i.counterBox = i.searchBox.querySelector(".jodit_search_counts span"), o.events.on(i.closeButton, "click", n.close).on(i.queryInput, "mousedown", function () {
            o.selection.isFocused() && (o.selection.removeMarkers(), i.selInfo = o.selection.save());
          }).on(i.replaceButton, "click", function (e) {
            i.findAndReplace(o.selection.current() || o.editor.firstChild, i.queryInput.value), n.updateCounters(), e.preventDefault(), e.stopImmediatePropagation();
          }).on([i.nextButton, i.prevButton], "click", function (e) {
            o.events.fire(i.nextButton === this ? "searchNext" : "searchPrevious"), e.preventDefault(), e.stopImmediatePropagation();
          }).on(n.queryInput, "keydown", r.debounce(function (e) {
            switch (e.which) {case a.KEY_ENTER:
                e.preventDefault(), e.stopImmediatePropagation(), o.events.fire("searchNext") && n.close();break;default:
                n.updateCounters();}
          }, n.jodit.options.observer.timeout)).on(n.jodit.container, "keydown", function (e) {
            if (o.getRealMode() === l.MODE_WYSIWYG) switch (e.which) {case a.KEY_ESC:
                n.close();break;case a.KEY_F3:
                i.queryInput.value && (o.events.fire(e.shiftKey ? "searchPrevious" : "searchNext"), e.preventDefault());}
          }).on("beforeSetMode", function () {
            n.close();
          }).on("afterInit", function () {
            o.workplace.appendChild(n.searchBox);
          }).on("keydown mousedown", function () {
            n.selInfo && (o.selection.removeMarkers(), n.selInfo = null), n.isOpened && (n.current = n.jodit.selection.current(), n.updateCounters());
          }).on("searchNext searchPrevious", function () {
            return i.findAndSelect(o.selection.current() || o.editor.firstChild, i.queryInput.value, "searchNext" === o.events.current);
          }).on("search", function (e, t) {
            void 0 === t && (t = !0), o.execCommand("search", e, t);
          }), o.registerCommand("search", { exec: function exec(e, t, n) {
              return void 0 === n && (n = !0), i.findAndSelect(o.selection.current() || o.editor.firstChild, t, n), !1;
            } }), o.registerCommand("openSearchDialog", { exec: function exec() {
              return i.open(), !1;
            }, hotkeys: "ctrl+f" }), o.registerCommand("openReplaceDialog", { exec: function exec() {
              return o.options.readonly || i.open(!0), !1;
            }, hotkeys: "ctrl+r" });
        }return n;
      }return n(t, e), t.getSomePartOfStringIndex = function (e, t, o) {
        return void 0 === o && (o = !0), this.findSomePartOfString(e, t, o, !0);
      }, t.findSomePartOfString = function (e, t, o, n) {
        void 0 === o && (o = !0), void 0 === n && (n = !1), e = r.trim(e.toLowerCase().replace(a.SPACE_REG_EXP, " ")), t = t.toLowerCase();for (var i = o ? 0 : t.length - 1, s = o ? 0 : e.length - 1, l = null, c = o ? 1 : -1, d = [], u = 0; void 0 !== t[i]; i += c) {
          var p = e[s] === t[i];if (p || null !== l && a.SPACE_REG_EXP.test(t[i]) ? (null !== l && o || (l = i), d.push(t[i]), p && (u += 1, s += c)) : (l = null, d.length = 0, u = 0, s = o ? 0 : e.length - 1), u === e.length) return !n || l;
        }return n ? null !== l && l : !!d.length && (o ? d.join("") : d.reverse().join(""));
      }, t.prototype.boundAlreadyWas = function (e, t) {
        return t.some(function (t) {
          return t.startContainer === e.startContainer && t.endContainer === e.endContainer && t.startOffset === e.startOffset && t.endOffset === e.endOffset;
        }, !1);
      }, t.prototype.tryScrollToElement = function (e) {
        var t = s.Dom.closest(e, function (e) {
          return e && e.nodeType === Node.ELEMENT_NODE;
        }, this.jodit.editor);t || (t = s.Dom.prev(e, function (e) {
          return e && e.nodeType === Node.ELEMENT_NODE;
        }, this.jodit.editor)), t && t !== this.jodit.editor && t.scrollIntoView();
      }, t;
    }(s.Component);
  }, function (e, t, o) {
    "use strict";
    var n = this && this.__extends || function () {
      var e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var o in t) {
          t.hasOwnProperty(o) && (e[o] = t[o]);
        }
      };return function (t, o) {
        function n() {
          this.constructor = t;
        }e(t, o), t.prototype = null === o ? Object.create(o) : (n.prototype = o.prototype, new n());
      };
    }();Object.defineProperty(t, "__esModule", { value: !0 });var i = o(0),
        r = o(4),
        s = o(1);s.Config.prototype.toolbarSticky = !0, s.Config.prototype.toolbarStickyOffset = 0, t.sticky = function (e) {
      function t(t) {
        var o = e.call(this, t) || this;return o.isToolbarSticked = !1, o.createDummy = function (e) {
          o.dummyBox || (o.dummyBox = o.jodit.ownerDocument.createElement("div"), o.dummyBox.classList.add("jodit_sticky-dummy_toolbar"), o.jodit.container.insertBefore(o.dummyBox, e));
        }, o.addSticky = function (e) {
          o.isToolbarSticked || (o.createDummy(e), o.jodit.container.classList.add("jodit_sticky"), o.isToolbarSticked = !0), i.css(e, { top: o.jodit.options.toolbarStickyOffset, width: o.jodit.container.offsetWidth }), i.css(o.dummyBox, { height: e.offsetHeight });
        }, o.removeSticky = function (e) {
          o.isToolbarSticked && (i.css(e, { width: "", top: "" }), o.jodit.container.classList.remove("jodit_sticky"), o.isToolbarSticked = !1);
        }, t.events.on("afterInit", function () {
          t.events.on(t.ownerWindow, "scroll wheel mousewheel resize", function () {
            var e = t.ownerWindow.pageYOffset || t.ownerDocument.documentElement.scrollTop,
                n = i.offset(t.container, t),
                r = e + t.options.toolbarStickyOffset > n.top && n.top + n.height > e + t.options.toolbarStickyOffset;t.options.toolbarSticky && (r ? o.addSticky(t.toolbar.container) : o.removeSticky(t.toolbar.container)), t.events.fire("toggleSticky", r);
          });
        }), o;
      }return n(t, e), t;
    }(r.Component);
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.de = o(65).default, t.en = o(66).default, t.fr = o(67).default, t.ru = o(68).default, t.ar = o(69).default;
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "Type something": "Schreibe etwas", "About Jodit": "Über Jodi", "Jodit Editor": "Jodit Editor", "Free Non-commercial Version": "Freie Nicht-kommerzielle Version", "Jodit User's Guide": "Jodit Benutzerhandbuch", "contains detailed help for using": "ausführliche Hilfe enthält für die Verwendung von", "For information about the license, please go to our website:": "Für Informationen über die Lizenz, gehen Sie bitte auf unsere Webseite:", "Buy full version": "Vollversion kaufen", "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright © XDSoft.net - Chupurnov Valeriy. Alle Rechte vorbehalten.", Anchor: "Anker", "Open in new tab": "In neuer Registerkarte öffnen", "Open editor in fullsize": "Editor öffnen in voller Größe", "Clear Formatting": "Formatierung löschen", "Fill color or set the text color": "Füllen Sie Farbe oder stellen Sie die Textfarbe", Redo: "Redo", Undo: "Rückgängig machen", Bold: "Fett gedruckt", Italic: "Kursiv", "Insert Unordered List": "Ungeordnete Liste einfügen", "Insert Ordered List": "Legen Sie Sortierte Liste", "Align Center": "einmitten", "Align Justify": "Begründen Voll", "Align Left": "Begründen links", "Align Right": "Begründen Rechts", "Insert Horizontal Line": "Legen Horizontale Linie", "Insert Image": "Bild einfügen", "Insert youtube/vimeo video": "Youtube/vimeo video einfügen", "Insert link": "Link einfügen", "Font size": "Schriftgröße", "Font family": "Schriftfamilie", "Insert format block": "Insert Format Block", Normal: "Normal", "Heading 1": "Überschrift 1", "Heading 2": "Überschrift 2", "Heading 3": "Überschrift 3", "Heading 4": "Überschrift 4", Quote: "Zitat", Code: "Code", Insert: "Einfügen", "Insert table": "Tabelle einfügen", "Decrease Indent": "Indent verringern", "Increase Indent": "Einrücken mehr", "Select Special Character": "Wählen Sie ein Sonderzeichen", "Insert Special Character": "Sonderzeichen einfügen", "Paint format": "Format klonen", "Change mode": "Änderungsmodus", Margins: "Die Margen", top: "oben", right: "Recht", bottom: "Boden", left: "links", Styles: "Styles", Classes: "Klassen", Align: "Ausrichten", Right: "Recht", Center: "Center", Left: "Links", "--Not Set--": "--Nicht eingestellt--", Src: "src", Title: "Titel", Alternative: "Alternative (alt)", Link: "Link", "Open link in new tab": "Link in neuem Tab öffnen", Image: "Image", Advansed: "Erweiterte", "Image properties": "Bildeigenschaften", Cancel: "Stornieren", Ok: "OK", "Your code is similar to HTML. Keep as HTML?": "Ihr Text, den Sie einfügen möchten, ähnelt HTML. Fügen Sie es als HTML ein?", "Paste as HTML": "Als HTML einfügen?", Keep: "Original speichern", Clean: "Aufräumen", "Insert as Text": "Einfügen als Text", "Word Paste Detected": "Vielleicht ist dies ein Fragment von Word oder Excel", "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Der Inhalt, den Sie einfügen, stammt aus einem Microsoft Word / Excel-Dokument. Möchten Sie das Format speichern oder löschen?", "Insert only Text": "Fügen Sie nur Text ein", "File Browser": "Dateibrowser", "Error on load list": "Fehler beim Ladeliste", "Error on load folders": "Fehler beim Laden Ordner", "Are you shure?": "Bist du sicher?", "Enter Directory name": "Geben Sie Verzeichnisname", "Create directory": "Verzeichnis erstellen", "type name": "Modellname", "Drop image": "Bild Tropfen", "or click": "oder klicken Sie auf", "Alternative text": "Alternativer Text", Browse: "Blättern", Upload: "Hochladen", Background: "Hintergrund", Text: "Text", Top: "Oben", Middle: "Mitte", Bottom: "Boden", "Insert column before": "Spalte einfügen vor", "Insert column after": "Spalte einfügen nach", "Insert row above": "Zeile einfügen oben", "Insert row below": "Zeile unterhalb einfügen", "Delete table": "Tabelle löschen", "Delete row": "Zeile löschen", "Delete column": "Spalte löschen", "Empty cell": "Leere Zelle" };
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "Type something": "Start writing...", "About Jodit": "", "Jodit Editor": "", "Free Non-commercial Version": "", "Jodit User's Guide": "", "contains detailed help for using": "", "For information about the license, please go to our website:": "", "Buy full version": "", "Copyright � XDSoft.net - Chupurnov Valeriy. All rights reserved.": "", Anchor: "", "Open in new tab": "", "Open editor in fullsize": "", "Clear Formatting": "", "Fill color or set the text color": "", Redo: "", Undo: "", Bold: "", Italic: "", "Insert Unordered List": "", "Insert Ordered List": "", "Align Center": "", "Align Justify": "", "Align Left": "", "Align Right": "", "Insert Horizontal Line": "", "Insert Image": "", "Insert youtube/vimeo video": "", "Insert link": "", "Font size": "", "Font family": "", "Insert format block": "", Normal: "", "Heading 1": "", "Heading 2": "", "Heading 3": "", "Heading 4": "", Quote: "", Code: "", Insert: "", "Insert table": "", "Paint format": "", "Change mode": "", Margins: "", top: "", right: "", bottom: "", left: "", Styles: "", Classes: "", Align: "", Right: "", Center: "", Left: "", "--Not Set--": "", Src: "", Title: "", Alternative: "", Link: "", "Open link in new tab": "", Image: "", Advansed: "", "Image properties": "", Cancel: "", Ok: "", "File Browser": "", "Error on load list": "", "Error on load folders": "", "Are you shure?": "", "Enter Directory name": "", "Create directory": "", "type name": "", "Drop image": "", "or click": "", "Alternative text": "", Upload: "", Browse: "", Background: "", Text: "", Top: "", Middle: "", Bottom: "", "Insert column before": "", "Insert column after": "", "Insert row above": "", "Insert row below": "", "Delete table": "", "Delete row": "", "Delete column": "", "Empty cell": "" };
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "Type something": "Ecrivez ici", "About Jodit": "A propos de Jodit", "Jodit Editor": "Editeur Jodit", "Free Non-commercial Version": "Version gratuite, non commerciale", "Jodit User's Guide": "Guide de l'utilisateur", "contains detailed help for using": "Aide détaillée à l'utilisation", "For information about the license, please go to our website:": "Consulter la licence sur notre site web:", "Buy full version": "Acheter la version complète", "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Copyright © XDSoft.net - Chupurnov Valeriy. Tous droits réservés.", Anchor: "Ancre", "Open in new tab": "Ouvrir dans un nouvel onglet", "Open editor in fullsize": "Ouvrir l'éditeur en pleine page", "Clear Formatting": "Supprimer le formattage", "Fill color or set the text color": "Modifier la couleur du fond ou du texte", Redo: "Refaire", Undo: "Défaire", Bold: "Gras", Italic: "Italique", "Insert Unordered List": "Liste non ordonnée", "Insert Ordered List": "Liste ordonnée", "Align Center": "Centrer", "Align Justify": "Justifier", "Align Left": "Aligner à gauche ", "Align Right": "Aligner à droite", "Insert Horizontal Line": "Insérer une ligne horizontale", "Insert Image": "Insérer une image", "Insert youtube/vimeo video": "Insérer une vidéo", "Insert link": "Insérer un lien", "Font size": "Taille des caractères", "Font family": "Famille des caractères", "Insert format block": "Bloc formatté", Normal: "Normal", "Heading 1": "Titre 1", "Heading 2": "Titre 2", "Heading 3": "Titre 3", "Heading 4": "Titre 4", Quote: "Citation", Code: "Code", Insert: "Insérer", "Insert table": "Insérer un tableau", "Decrease Indent": "Diminuer le retrait", "Increase Indent": "Retrait plus", "Select Special Character": "Sélectionnez un caractère spécial", "Insert Special Character": "Insérer un caractère spécial", "Paint format": "Cloner le format", "Change mode": "Mode wysiwyg <-> code html", Margins: "Marges", top: "haut", right: "droite", bottom: "Bas", left: "gauche", Styles: "Styles", Classes: "Classes", Align: "Alignement", Right: "Droite", Center: "Centre", Left: "Gauche", "--Not Set--": "--Non disponible--", Src: "Source", Title: "Titre", Alternative: "Alternative", Link: "Lien", "Open link in new tab": "Ouvrir le lien dans un nouvel onglet", Image: "Image", Advansed: "Avancé", "Image properties": "Propriétés de l'image", Cancel: "Effacer", Ok: "OK", "Your code is similar to HTML. Keep as HTML?": "Votre texte que vous essayez de coller est similaire au HTML. Collez-le en HTML?", "Paste as HTML": "Coller en HTML?", Keep: "Sauvegarder l'original", Clean: "Nettoyer", "Insert as Text": "Coller en tant que texte", "Word Paste Detected": "C'est peut-être un fragment de Word ou Excel", "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Le contenu que vous insérez provient d'un document Microsoft Word / Excel. Voulez-vous enregistrer le format ou l'effacer?", "Insert only Text": "Coller le texte seulement", "File Browser": "Explorateur de fichiers", "Error on load list": "Erreur de liste de chargement", "Error on load folders": "Erreur de dossier de chargement", "Are you shure?": "Etes-vous sûrs ?", "Enter Directory name": "Entrer le non de dossier", "Create directory": "Créer un dossier", "type name": "type de fichier", "Drop image": "Coller une image", "or click": "ou cliquer", "Alternative text": "Texte de remplacemement", Browse: "Chercher", Upload: "Charger", Background: "Arrière-plan", Text: "Texte", Top: "Haut", Middle: "Milieu", Bottom: "Bas", "Insert column before": "Insérer une colonne avant", "Insert column after": "Insérer une colonne après", "Insert row above": "Insérer une ligne en dessus", "Insert row below": "Insérer une ligne en dessous", "Delete table": "Supprimer le tableau", "Delete row": "Supprimer la ligne", "Delete column": "Supprimer la colonne", "Empty cell": "Vider la cellule" };
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "Type something": "Напишите что-либо", "About Jodit": "О Jodit", "Jodit Editor": "Редактор Jodit", "Free Non-commercial Version": "Версия для не коммерческого использования", "Jodit User's Guide": "Jodit Руководство пользователя", "contains detailed help for using": "содержит детальную информацию по использованию", "For information about the license, please go to our website:": "Для получения сведений о лицензии , пожалуйста, перейдите на наш сайт:", "Buy full version": "Купить полную версию", "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.": "Авторские права © XDSoft.net - Чупурнов Валерий. Все права защищены.", Anchor: "Анкор", "Open in new tab": "Открывать ссылку в новой вкладке", "Open editor in fullsize": "Открыть редактор в полном размере", "Clear Formatting": "Очистить форматирование", "Fill color or set the text color": "Цвет заливки или цвет текста", Redo: "Повтор", Undo: "Отмена", Bold: "Жирный", Italic: "Наклонный", "Insert Unordered List": "Вставка маркированного списка", "Insert Ordered List": "Вставить нумерованный список", "Align Center": "Выровнять по центру", "Align Justify": "Выровнять по ширине", "Align Left": "Выровнять по левому краю", "Align Right": "Выровнять по правому краю", "Insert Horizontal Line": "Вставить горизонтальную линию", "Insert Image": "Вставить изображение", "Insert youtube/vimeo video": "Вставьте видео", "Insert link": "Вставить ссылку", "Font size": "Размер шрифта", "Font family": "Шрифт", "Insert format block": "Вставить блочный элемент", Normal: "Нормальный текст", "Heading 1": "Заголовок 1", "Heading 2": "Заголовок 2", "Heading 3": "Заголовок 3", "Heading 4": "Заголовок 4", Quote: "Цитата", Code: "Код", Insert: "Вставить", "Insert table": "Вставить таблицу", "Decrease Indent": "Уменьшить отступ", "Increase Indent": "Увеличить отступ", "Select Special Character": "Выберите специальный символ", "Insert Special Character": "Вставить специальный символ", "Paint format": "Формат краски", "Change mode": "Источник", Margins: "Отступы", top: "сверху", right: "справа", bottom: "снизу", left: "слева", Styles: "Стили", Classes: "Классы", Align: "Выравнивание", Right: "По правому краю", Center: "По центру", Left: "По левому краю", "--Not Set--": "--не устанавливать--", Src: "src", Title: "Заголовок", Alternative: "Альтернативный текст (alt)", Link: "Ссылка", "Open link in new tab": "Открывать ссылку в новом окне", Image: "Изображение", Advansed: "Расширенные", "Image properties": "Свойства изображения", Cancel: "Отмена", Ok: "Ok", "Your code is similar to HTML. Keep as HTML?": "Ваш текст, который вы пытаетесь вставить похож на HTML. Вставить его как HTML?", "Paste as HTML": "Вставить как HTML?", Keep: "Сохранить оригинал", Clean: "Почистить", "Insert as Text": "Вставить как текст", "Insert only Text": "Вставить только текст", "Word Paste Detected": "Возможно это фрагмент Word или Excel", "The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?": "Контент который вы вставляете поступает из документа Microsoft Word / Excel. Вы хотите сохранить формат или очистить его?", "File Browser": "Браузер файлов", "Error on load list": "Ошибка при загрузке списка изображений", "Error on load folders": "Ошибка при загрузке списка директорий", "Are you shure?": "Вы уверены?", "Enter Directory name": "Введите название директории", "Create directory": "Создать директорию", "type name": "введите название", "Drop image": "Перетащите сюда изображение", "or click": "или нажмите", "Alternative text": "Альтернативный текст", Browse: "Сервер", Upload: "Загрузка", Background: "Фон", Text: "Текст", Top: " К верху", Middle: "По середине", Bottom: "К низу", "Insert column before": "Вставить столбец до", "Insert column after": "Вставить столбец после", "Insert row above": "Вставить ряд выше", "Insert row below": "Вставить ряд ниже", "Delete table": "Удалить таблицу", "Delete row": "Удалять ряд", "Delete column": "Удалить столбец", "Empty cell": "Отчистить ячейку" };
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.default = { "Type something": "إبدأ في الكتابة...", "About Jodit": "حول جوديت", "Jodit Editor": "محرر جوديت", "Free Non-commercial Version": "الإصدار الغير تجاري مجاني", "Jodit User's Guide": "دليل مستخدم جوديت", "contains detailed help for using": "يحتوي على مساعدة مفصلة للاستخدام", "For information about the license, please go to our website:": "للحصول على معلومات حول الترخيص، يرجى الذهاب لموقعنا:", "Buy full version": "شراء النسخة الكاملة", "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.": "حقوق الطبع والنشر © XDSoft.net - Chupurnov Valeriy. كل الحقوق محفوظة.", Anchor: "مِرْساة", "Open in new tab": "فتح في نافذة جديدة", "Open editor in fullsize": "فتح المحرر في الحجم الكامل", "Clear Formatting": "مسح التنسيق", "Fill color or set the text color": "ملء اللون أو تعيين لون النص", Redo: "إعادة", Undo: "تراجع", Bold: "عريض", Italic: "مائل", "Insert Unordered List": "إدراج قائمة غير مرتبة", "Insert Ordered List": "إدراج قائمة مرتبة", "Align Center": "محاذاة للوسط", "Align Justify": "محاذاة مثبتة", "Align Left": "محاذاة لليسار", "Align Right": "محاذاة لليمين", "Insert Horizontal Line": "إدراج خط أفقي", "Insert Image": "إدراج صورة", "Insert youtube/vimeo video": "إدراج فيديو يوتيوب/فيميو ", "Insert link": "إدراج رابط", "Font size": "حجم الخط", "Font family": "نوع الخط", "Insert format block": "إدراج كتلة تنسيق", Normal: "عادي", "Heading 1": "عنوان 1", "Heading 2": "عنوان 2", "Heading 3": "عنوان 3", "Heading 4": "عنوان 4", Quote: "إقتباس", Code: "كود", Insert: "إدراج", "Insert table": "إدراج جدول", "Decrease Indent": "تقليل المسافة البادئة", "Increase Indent": "زيادة المسافة البادئة", "Select Special Character": "تحديد أحرف خاصة", "Insert Special Character": "إدراج حرف خاص", "Paint format": "تنسيق الرسم", "Change mode": "تغيير الوضع", Margins: "هوامش", top: "أعلى", right: "يمين", bottom: "أسفل", left: "يسار", Styles: "الأنماط", Classes: "الطبقات", Align: "محاذاة", Right: "اليمين", Center: "الوسط", Left: "اليسار", "--Not Set--": "--غير مضبوط--", Src: "Src", Title: "العنوان", Alternative: "العنوان البديل", Link: "الرابط", "Open link in new tab": "افتح الرابط في نافذة جديدة", Image: "الصورة", Advansed: "متقدم", "Image properties": "خصائص الصورة", Cancel: "إلغاء", Ok: "حسنا", "File Browser": "متصفح الملفات", "Error on load list": "حدث خطأ في تحميل القائمة ", "Error on load folders": "حدث خطأ في تحميل المجلدات", "Are you shure?": "هل أنت واثق؟", "Enter Directory name": "أدخل اسم المجلد", "Create directory": "إنشاء مجلد", "type name": "أكتب إسم", "Drop image": "إسقاط صورة", "or click": "أو أنقر", "Alternative text": "النص البديل", Upload: "رفع", Browse: "تصفح", Background: "الخلفية", Text: "نص", Top: "أعلى", Middle: "الوسط", Bottom: "الأسفل", "Insert column before": "إدراج عمود قبل", "Insert column after": "إدراج عمود بعد", "Insert row above": "إدراج صف أعلى", "Insert row below": "إدراج صف أسفل", "Delete table": "حذف الجدول", "Delete row": "حذف الصف", "Delete column": "حذف العمود", "Empty cell": "خلية فارغة" };
  }, function (e, t, o) {
    "use strict";
    Object.defineProperty(t, "__esModule", { value: !0 }), t.about = o(71), t.addcolumn = o(72), t.addrow = o(73), t.angle_left = o(74), t.angle_down = o(75), t.angle_right = o(76), t.angle_up = o(77), t.arrows_alt = o(78), t.arrows_h = o(79), t.attachment = o(80), t.bin = o(81), t.dots = o(82), t.bold = o(83), t.brush = o(84), t.cancel = o(85), t.center = o(86), t.chain_broken = o(87), t.check_square = o(88), t.check = o(89), t.copyformat = o(90), t.crop = o(91), t.dedent = o(92), t.enter = o(93), t.eraser = o(94), t.eye = o(95), t.folder = o(96), t.font = o(97), t.fontsize = o(98), t.fullsize = o(99), t.hr = o(100), t.image = o(101), t.info_circle = o(102), t.italic = o(103), t.justify = o(104), t.left = o(105), t.link = o(106), t.lock = o(107), t.menu = o(108), t.merge = o(109), t.ol = o(110), t.paragraph = o(111), t.pencil = o(112), t.plus = o(113), t.redo = o(114), t.resize = o(115), t.resizer = o(116), t.right = o(117), t.save = o(118), t.shrink = o(119), t.source = o(120), t.splitg = o(121), t.splitv = o(122), t.strikethrough = o(123), t.table = o(124), t.th_list = o(125), t.th = o(126), t.ul = o(127), t.underline = o(128), t.undo = o(129), t.unlink = o(130), t.unlock = o(131), t.update = o(132), t.upload = o(133), t.valign = o(134), t.video = o(135), t.outdent = o(136), t.indent = o(137), t.print = o(138), t.omega = o(139);
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1088 1256v240q0 16-12 28t-28 12h-240q-16 0-28-12t-12-28v-240q0-16 12-28t28-12h240q16 0 28 12t12 28zm316-600q0 54-15.5 101t-35 76.5-55 59.5-57.5 43.5-61 35.5q-41 23-68.5 65t-27.5 67q0 17-12 32.5t-28 15.5h-240q-15 0-25.5-18.5t-10.5-37.5v-45q0-83 65-156.5t143-108.5q59-27 84-56t25-76q0-42-46.5-74t-107.5-32q-65 0-108 29-35 25-107 115-13 16-31 16-12 0-25-8l-164-125q-13-10-15.5-25t5.5-28q160-266 464-266 80 0 161 31t146 83 106 127.5 41 158.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 18.151 18.151"><g><g><path d="M6.237,16.546H3.649V1.604h5.916v5.728c0.474-0.122,0.968-0.194,1.479-0.194 c0.042,0,0.083,0.006,0.125,0.006V0H2.044v18.15h5.934C7.295,17.736,6.704,17.19,6.237,16.546z"></path><path d="M11.169,8.275c-2.723,0-4.938,2.215-4.938,4.938s2.215,4.938,4.938,4.938s4.938-2.215,4.938-4.938 S13.892,8.275,11.169,8.275z M11.169,16.81c-1.983,0-3.598-1.612-3.598-3.598c0-1.983,1.614-3.597,3.598-3.597 s3.597,1.613,3.597,3.597C14.766,15.198,13.153,16.81,11.169,16.81z"></path><polygon points="11.792,11.073 10.502,11.073 10.502,12.578 9.03,12.578 9.03,13.868 10.502,13.868 10.502,15.352 11.792,15.352 11.792,13.868 13.309,13.868 13.309,12.578 11.792,12.578 "></polygon></g></g></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 432 432"><g><g><polygon points="203.688,96 0,96 0,144 155.688,144 "></polygon><polygon points="155.719,288 0,288 0,336 203.719,336 "></polygon><rect x="252" y="96"></rect><rect></rect><rect x="252" y="288"></rect><rect y="384"></rect><path d="M97.844,230.125c-3.701-3.703-5.856-8.906-5.856-14.141s2.154-10.438,5.856-14.141l9.844-9.844H0v48h107.719 L97.844,230.125z"></path><polygon points="232,176 232,96 112,216 232,336 232,256 432,256 432,176 "></polygon></g></g></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1203 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1395 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1171 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1395 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1411 541l-355 355 355 355 144-144q29-31 70-14 39 17 39 59v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l144-144-355-355-355 355 144 144q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l144 144 355-355-355-355-144 144q-19 19-45 19-12 0-24-5-40-17-40-59v-448q0-26 19-45t45-19h448q42 0 59 40 17 39-14 69l-144 144 355 355 355-355-144-144q-31-30-14-69 17-40 59-40h448q26 0 45 19t19 45v448q0 42-39 59-13 5-25 5-26 0-45-19z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1792 896q0 26-19 45l-256 256q-19 19-45 19t-45-19-19-45v-128h-1024v128q0 26-19 45t-45 19-45-19l-256-256q-19-19-19-45t19-45l256-256q19-19 45-19t45 19 19 45v128h1024v-128q0-26 19-45t45-19 45 19l256 256q19 19 19 45z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1596 1385q0 117-79 196t-196 79q-135 0-235-100l-777-776q-113-115-113-271 0-159 110-270t269-111q158 0 273 113l605 606q10 10 10 22 0 16-30.5 46.5t-46.5 30.5q-13 0-23-10l-606-607q-79-77-181-77-106 0-179 75t-73 181q0 105 76 181l776 777q63 63 145 63 64 0 106-42t42-106q0-82-63-145l-581-581q-26-24-60-24-29 0-48 19t-19 48q0 32 25 59l410 410q10 10 10 22 0 16-31 47t-47 31q-12 0-22-10l-410-410q-63-61-63-149 0-82 57-139t139-57q88 0 149 63l581 581q100 98 100 235z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xml:space="preserve"><circle cx="12" cy="12" r="2.2"></circle><circle cx="12" cy="5" r="2.2"></circle><circle cx="12" cy="19" r="2.2"></circle></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M747 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-.5 159t-.5 158q0 8-1 67.5t-.5 96.5 4.5 83.5 12 66.5zm-14-746q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-.5 80t-.5 79q0 46 1 69zm-541 889l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5.5-34v-65.5q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68.5.5t67.5.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M896 1152q0-36-20-69-1-1-15.5-22.5t-25.5-38-25-44-21-50.5q-4-16-21-16t-21 16q-7 23-21 50.5t-25 44-25.5 38-15.5 22.5q-20 33-20 69 0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zm512-128q0 212-150 362t-362 150-362-150-150-362q0-145 81-275 6-9 62.5-90.5t101-151 99.5-178 83-201.5q9-30 34-47t51-17 51.5 17 33.5 47q28 93 83 201.5t99.5 178 101 151 62.5 90.5q81 127 81 275z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h896q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h640q26 0 45 19t19 45z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M503 1271l-256 256q-10 9-23 9-12 0-23-9-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zm169 41v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm-224-224q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm1264 128q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zm-617-724l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zm633 84q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm-544-544v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm407 151l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M813 1299l614-614q19-19 19-45t-19-45l-102-102q-19-19-45-19t-45 19l-467 467-211-211q-19-19-45-19t-45 19l-102 102q-19 19-19 45t19 45l358 358q19 19 45 19t45-19zm851-883v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1472 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zm231-489l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 16 16"><path d="M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M621 1280h595v-595zm-45-45l595-595h-595v595zm1152 77v192q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-224h-864q-14 0-23-9t-9-23v-864h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h192q14 0 23 9t9 23v224h851l246-247q10-9 23-9t23 9q9 10 9 23t-9 23l-247 246v851h224q14 0 23 9t9 23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zm1408 768v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 128 128" xml:space="preserve"><g><polygon points="112.4560547,23.3203125 112.4560547,75.8154297 31.4853516,75.8154297 31.4853516,61.953125 16.0131836,72.6357422 0.5410156,83.3164063 16.0131836,93.9990234 31.4853516,104.6796875 31.4853516,90.8183594 112.4560547,90.8183594 112.4560547,90.8339844 127.4589844,90.8339844 127.4589844,23.3203125 "></polygon></g></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M832 1408l336-384h-768l-336 384h768zm1013-1077q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zm-720-384q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zm848 384q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1728 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M789 559l-170 450q33 0 136.5 2t160.5 2q19 0 57-2-87-253-184-452zm-725 1105l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29 31-50.5l237-616 280-724h128q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15 34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 4-.5 13t-.5 13q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0 12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11 2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0 22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58 0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1744 1408q33 0 42 18.5t-11 44.5l-126 162q-20 26-49 26t-49-26l-126-162q-20-26-11-44.5t42-18.5h80v-1024h-80q-33 0-42-18.5t11-44.5l126-162q20-26 49-26t49 26l126 162q20 26 11 44.5t-42 18.5h-80v1024h80zm-1663-1279l54 27q12 5 211 5 44 0 132-2t132-2q36 0 107.5.5t107.5.5h293q6 0 21 .5t20.5 0 16-3 17.5-9 15-17.5l42-1q4 0 14 .5t14 .5q2 112 2 336 0 80-5 109-39 14-68 18-25-44-54-128-3-9-11-48t-14.5-73.5-7.5-35.5q-6-8-12-12.5t-15.5-6-13-2.5-18-.5-16.5.5q-17 0-66.5-.5t-74.5-.5-64 2-71 6q-9 81-8 136 0 94 2 388t2 455q0 16-2.5 71.5t0 91.5 12.5 69q40 21 124 42.5t120 37.5q5 40 5 50 0 14-3 29l-34 1q-76 2-218-8t-207-10q-50 0-151 9t-152 9q-3-51-3-52v-9q17-27 61.5-43t98.5-29 78-27q19-42 19-383 0-101-3-303t-3-303v-117q0-2 .5-15.5t.5-25-1-25.5-3-24-5-14q-11-12-162-12-33 0-93 12t-80 26q-19 13-34 72.5t-31.5 111-42.5 53.5q-42-26-56-44v-383z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M883 1056q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23zm781-864v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1600 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M576 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1024 384v448h-1408v-192l320-320 160 160 512-512zm96-704h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zm160 32v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1152 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zm-128-896v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zm640 416q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M384 1662l17-85q6-2 81.5-21.5t111.5-37.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm256-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm-384-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1520 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zm-703-705q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zm895 705q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M640 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zm832 96v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1664 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zm0-512v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 312.000000 312.000000"><g transform="translate(0.000000,312.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M50 3109 c0 -7 -11 -22 -25 -35 l-25 -23 0 -961 0 -961 32 -29 32 -30 501 -2 500 -3 3 -502 2 -502 31 -30 31 -31 958 0 958 0 23 25 c13 13 30 25 37 25 9 0 12 199 12 960 0 686 -3 960 -11 960 -6 0 -24 12 -40 28 l-29 27 -503 5 -502 5 -5 502 -5 503 -28 29 c-15 16 -27 34 -27 40 0 8 -274 11 -960 11 -710 0 -960 -3 -960 -11z m1738 -698 l2 -453 -40 -40 c-22 -22 -40 -43 -40 -47 0 -4 36 -42 79 -85 88 -87 82 -87 141 -23 l26 27 455 -2 454 -3 0 -775 0 -775 -775 0 -775 0 -3 450 -2 449 47 48 47 48 -82 80 c-44 44 -84 80 -87 80 -3 0 -25 -18 -48 -40 l-41 -40 -456 2 -455 3 -3 765 c-1 421 0 771 3 778 3 10 164 12 777 10 l773 -3 3 -454z"></path><path d="M607 2492 c-42 -42 -77 -82 -77 -87 0 -6 86 -96 190 -200 105 -104 190 -197 190 -205 0 -8 -41 -56 -92 -107 -65 -65 -87 -94 -77 -98 8 -3 138 -4 289 -3 l275 3 3 275 c1 151 0 281 -3 289 -4 10 -35 -14 -103 -82 -54 -53 -103 -97 -109 -97 -7 0 -99 88 -206 195 -107 107 -196 195 -198 195 -3 0 -39 -35 -82 -78z"></path><path d="M1470 1639 c-47 -49 -87 -91 -89 -94 -5 -6 149 -165 160 -165 9 0 189 179 189 188 0 12 -154 162 -165 161 -6 0 -48 -41 -95 -90z"></path><path d="M1797 1303 c-9 -8 -9 -568 0 -576 4 -4 50 36 103 88 54 52 101 95 106 95 5 0 95 -85 199 -190 104 -104 194 -190 200 -190 6 0 46 36 90 80 l79 79 -197 196 c-108 108 -197 199 -197 203 0 4 45 52 99 106 55 55 98 103 95 108 -6 10 -568 11 -577 1z"></path></g></svg>';
  }, function (e, t) {
    e.exports = '<svg role="img" viewBox="0 0 1792 1792"><path d="M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zm2-627v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zm1409 319v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm-1408-899v99h-335v-99h107q0-41 .5-122t.5-121v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zm1408 387v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1534 189v73q0 29-18.5 61t-42.5 32q-50 0-54 1-26 6-32 31-3 11-3 64v1152q0 25-18 43t-43 18h-108q-25 0-43-18t-18-43v-1218h-143v1218q0 25-17.5 43t-43.5 18h-108q-26 0-43.5-18t-17.5-43v-496q-147-12-245-59-126-58-192-179-64-117-64-259 0-166 88-286 88-118 209-159 111-37 417-37h479q25 0 43 18t18 43z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1664 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 14 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 24 24" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns"><title></title><desc></desc><defs></defs><g><g transform="translate(-251.000000, -443.000000)"><g transform="translate(215.000000, 119.000000)"></g><path d="M252,448 L256,448 L256,444 L252,444 L252,448 Z M257,448 L269,448 L269,446 L257,446 L257,448 Z M257,464 L269,464 L269,462 L257,462 L257,464 Z M270,444 L270,448 L274,448 L274,444 L270,444 Z M252,462 L252,466 L256,466 L256,462 L252,462 Z M270,462 L270,466 L274,466 L274,462 L270,462 Z M254,461 L256,461 L256,449 L254,449 L254,461 Z M270,461 L272,461 L272,449 L270,449 L270,461 Z"></path></g></g></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M844 472q0 60-19 113.5t-63 92.5-105 39q-76 0-138-57.5t-92-135.5-30-151q0-60 19-113.5t63-92.5 105-39q77 0 138.5 57.5t91.5 135 30 151.5zm-342 483q0 80-42 139t-119 59q-76 0-141.5-55.5t-100.5-133.5-35-152q0-80 42-139.5t119-59.5q76 0 141.5 55.5t100.5 134 35 152.5zm394-27q118 0 255 97.5t229 237 92 254.5q0 46-17 76.5t-48.5 45-64.5 20-76 5.5q-68 0-187.5-45t-182.5-45q-66 0-192.5 44.5t-200.5 44.5q-183 0-183-146 0-86 56-191.5t139.5-192.5 187.5-146 193-59zm239-211q-61 0-105-39t-63-92.5-19-113.5q0-74 30-151.5t91.5-135 138.5-57.5q61 0 105 39t63 92.5 19 113.5q0 73-30 151t-92 135.5-138 57.5zm432-104q77 0 119 59.5t42 139.5q0 74-35 152t-100.5 133.5-141.5 55.5q-77 0-119-59t-42-139q0-74 35-152.5t100.5-134 141.5-55.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zm0-384v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M512 1536h768v-384h-768v384zm896 0h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zm-384-928v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zm640 32v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M896 960v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45zm755-672q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M553 1399l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23t-10 23zm591-1067l-373 1291q-4 13-15.5 19.5t-23.5 2.5l-62-17q-13-4-19.5-15.5t-2.5-24.5l373-1291q4-13 15.5-19.5t23.5-2.5l62 17q13 4 19.5 15.5t2.5 24.5zm657 651l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 48 48"><path d="M6 42h4v-4h-4v4zm4-28h-4v4h4v-4zm-4 20h4v-4h-4v4zm8 8h4v-4h-4v4zm-4-36h-4v4h4v-4zm8 0h-4v4h4v-4zm16 0h-4v4h4v-4zm-8 8h-4v4h4v-4zm0-8h-4v4h4v-4zm12 28h4v-4h-4v4zm-16 8h4v-4h-4v4zm-16-16h36v-4h-36v4zm32-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-16 16h4v-4h-4v4zm8 8h4v-4h-4v4zm8 0h4v-4h-4v4z"></path><path d="M0 0h48v48h-48z" fill="none"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 48 48"><path d="M6 18h4v-4h-4v4zm0-8h4v-4h-4v4zm8 32h4v-4h-4v4zm0-16h4v-4h-4v4zm-8 0h4v-4h-4v4zm0 16h4v-4h-4v4zm0-8h4v-4h-4v4zm8-24h4v-4h-4v4zm24 24h4v-4h-4v4zm-16 8h4v-36h-4v36zm16 0h4v-4h-4v4zm0-16h4v-4h-4v4zm0-20v4h4v-4h-4zm0 12h4v-4h-4v4zm-8-8h4v-4h-4v4zm0 32h4v-4h-4v4zm0-16h4v-4h-4v4z"></path><path d="M0 0h48v48h-48z" fill="none"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1760 896q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1728zm-1277-64q-28-35-51-80-48-97-48-188 0-181 134-309 133-127 393-127 50 0 167 19 66 12 177 48 10 38 21 118 14 123 14 183 0 18-5 45l-12 3-84-6-14-2q-50-149-103-205-88-91-210-91-114 0-182 59-67 58-67 146 0 73 66 140t279 129q69 20 173 66 58 28 95 52h-743zm507 256h411q7 39 7 92 0 111-41 212-23 55-71 104-37 35-109 81-80 48-153 66-80 21-203 21-114 0-195-23l-140-40q-57-16-72-28-8-8-8-22v-13q0-108-2-156-1-30 0-68l2-37v-44l102-2q15 34 30 71t22.5 56 12.5 27q35 57 80 94 43 36 105 57 59 22 132 22 64 0 139-27 77-26 122-86 47-61 47-129 0-84-81-157-34-29-137-71z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M576 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm-512-768v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm512 384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm0-384v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zm128-320v1088q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1344q66 0 113 47t47 113z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm-1280-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm1280 512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm-640-1024v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm640 512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zm0-512v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm0-512q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm-1408-928q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zm1408 416v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zm0-512v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M176 223q-37-2-45-4l-3-88q13-1 40-1 60 0 112 4 132 7 166 7 86 0 168-3 116-4 146-5 56 0 86-2l-1 14 2 64v9q-60 9-124 9-60 0-79 25-13 14-13 132 0 13 .5 32.5t.5 25.5l1 229 14 280q6 124 51 202 35 59 96 92 88 47 177 47 104 0 191-28 56-18 99-51 48-36 65-64 36-56 53-114 21-73 21-229 0-79-3.5-128t-11-122.5-13.5-159.5l-4-59q-5-67-24-88-34-35-77-34l-100 2-14-3 2-86h84l205 10q76 3 196-10l18 2q6 38 6 51 0 7-4 31-45 12-84 13-73 11-79 17-15 15-15 41 0 7 1.5 27t1.5 31q8 19 22 396 6 195-15 304-15 76-41 122-38 65-112 123-75 57-182 89-109 33-255 33-167 0-284-46-119-47-179-122-61-76-83-195-16-80-16-237v-333q0-188-17-213-25-36-147-39zm1488 1409v-64q0-14-9-23t-23-9h-1472q-14 0-23 9t-9 23v64q0 14 9 23t23 9h1472q14 0 23-9t9-23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1664 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M503 1271l-256 256q-10 9-23 9-12 0-23-9-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zm169 41v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm-224-224q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm1264 128q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zm-617-724l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zm633 84q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zm-544-544v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zm407 151l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1728 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1344 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm256 0q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128-224v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h427q21 56 70.5 92t110.5 36h256q61 0 110.5-36t70.5-92h427q40 0 68 28t28 68zm-325-648q-17 40-59 40h-256v448q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-448h-256q-42 0-59-40-17-39 14-69l448-448q18-19 45-19t45 19l448 448q31 30 14 69z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1216 320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zm1408 768v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M352 832q0 14-9 23l-288 288q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-576q0-13 9.5-22.5t22.5-9.5q14 0 23 9l288 288q9 9 9 23zm1440 480v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zm0-384v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 1792 1792"><path d="M448 1536h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z"></path></svg>';
  }, function (e, t) {
    e.exports = '<svg viewBox="0 0 270 270"><path d="m240.443652,220.45085l-47.410809,0l0,-10.342138c13.89973,-8.43655 25.752896,-19.844464 34.686646,-33.469923c11.445525,-17.455846 17.496072,-37.709239 17.496072,-58.570077c0,-59.589197 -49.208516,-108.068714 -109.693558,-108.068714s-109.69263,48.479517 -109.69263,108.069628c0,20.860839 6.050547,41.113316 17.497001,58.570077c8.93375,13.625459 20.787845,25.032458 34.686646,33.469008l0,10.342138l-47.412666,0c-10.256959,0 -18.571354,8.191376 -18.571354,18.296574c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.98402,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574l0,-39.496814c0,-7.073455 -4.137698,-13.51202 -10.626529,-16.537358c-25.24497,-11.772016 -41.557118,-37.145704 -41.557118,-64.643625c0,-39.411735 32.545369,-71.476481 72.549922,-71.476481c40.004553,0 72.550851,32.064746 72.550851,71.476481c0,27.497006 -16.312149,52.87161 -41.557118,64.643625c-6.487902,3.026253 -10.6256,9.464818 -10.6256,16.537358l0,39.496814c0,10.105198 8.314395,18.296574 18.571354,18.296574l65.982163,0c10.256959,0 18.571354,-8.191376 18.571354,-18.296574c0,-10.105198 -8.314395,-18.296574 -18.571354,-18.296574z"></path></svg>';
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37), __webpack_require__(117), __webpack_require__(26)(module)))

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var emptyTextValidationDirective = exports.emptyTextValidationDirective = function emptyTextValidationDirective() {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function link(scope, element, attrs, ngModel) {
            ngModel.$parsers.push(function (value) {
                var modifiedInput = value;
                modifiedInput = modifiedInput.replace(/^ +/g, '');
                if (modifiedInput != value) {
                    ngModel.$setViewValue(modifiedInput);
                    ngModel.$render();
                }
                scope.$watch(ngModel, function () {
                    if (ngModel.$viewValue == "") {
                        ngModel.$$parsedNgModelAssign(scope, '');
                    }
                });
                return modifiedInput;
            });
        }
    };
};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.emptyTextValidation = undefined;

var _emptyTextValidation = __webpack_require__(460);

var emptyTextValidation = exports.emptyTextValidation = angular.module('common.libs.emptyTextValidation', []).directive('emptyTextValidation', _emptyTextValidation.emptyTextValidationDirective).name;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.featureMainPageTemplateComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _featureMainPageTemplate = __webpack_require__(725);

var _featureMainPageTemplate2 = _interopRequireDefault(_featureMainPageTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var featureMainPageTemplateComponent = exports.featureMainPageTemplateComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        isSubMenu: '@',
        showEditDeleteButtons: '@',
        menuName: '@',
        menuId: '@',
        onEditOverview: '&',
        onEditSequence: '&',
        onPublishStatus: '&'
    },

    templateUrl: _featureMainPageTemplate2.default,

    controller: function () {
        FeatureMainPageTemplateComponent.$inject = ["$state", "SlugService", "ModalService"];
        function FeatureMainPageTemplateComponent($state, SlugService, ModalService) {
            'ngInject';

            _classCallCheck(this, FeatureMainPageTemplateComponent);

            this.$state = $state;
            this.slugService = SlugService;
            this.modalService = ModalService;
        }

        _createClass(FeatureMainPageTemplateComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.showAddNewMenuButton = this.menuName === "PublicationsAndDocuments";
            }
        }, {
            key: 'routeSequencePageUrl',
            value: function routeSequencePageUrl() {
                var url = this.slugService.getSequencePageURL(this.slugUrl);

                this.$state.go('app.dashboard.DynamicMenus', {
                    url: url
                });
            }
        }, {
            key: 'routePublishPageUrl',
            value: function routePublishPageUrl(slug) {
                var url = this.slugService.getPublishPageURL(this.slugUrl);

                this.$state.go('app.dashboard.DynamicMenus', {
                    url: url
                });
            }
        }, {
            key: 'openNewMenuAddModal',
            value: function openNewMenuAddModal() {
                this.modalService.open({
                    backdrop: 'static',
                    keyboard: false,
                    component: 'newMenuAdd',
                    details: {
                        menuName: this.menuName,
                        menuId: this.menuId
                    }
                });
            }
        }]);

        return FeatureMainPageTemplateComponent;
    }()
};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.featureMainPageTemplate = undefined;

var _featureMainPageTemplate = __webpack_require__(462);

var _newMenuAdd = __webpack_require__(465);

__webpack_require__(164);

var featureMainPageTemplate = exports.featureMainPageTemplate = angular.module('common.components.featureMainPageTemplate', [_newMenuAdd.newMenuAdd]).component('featureMainPageTemplate', _featureMainPageTemplate.featureMainPageTemplateComponent).name;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newMenuAddComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _newMenuAdd = __webpack_require__(726);

var _newMenuAdd2 = _interopRequireDefault(_newMenuAdd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var newMenuAddComponent = exports.newMenuAddComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl: _newMenuAdd2.default,

    controller: function () {
        NewMenuAddComponent.$inject = ["$state", "NewMenuAddService", "toastr"];
        function NewMenuAddComponent($state, NewMenuAddService, toastr) {
            'ngInject';

            _classCallCheck(this, NewMenuAddComponent);

            this.$state = $state;
            this.newMenuAddService = NewMenuAddService;
            this.toastr = toastr;
        }

        _createClass(NewMenuAddComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = {
                    title: '',
                    description: '',
                    overview: '',
                    menuId: parseInt(this.resolve.details.menuId)
                };
                this.disableButtons = false;
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                var _this = this;

                this.disableButtons = true;
                this.newMenuAddService.addNewMenu(this.details).then(function (data) {
                    _this.toastr.success("New menu added successfully.");
                    _this.close();
                    _this.$state.reload();
                }).catch(function (err) {
                    //handle error
                    _this.toastr.error(err);
                    _this.disableButtons = false;
                });
            }
        }]);

        return NewMenuAddComponent;
    }()
};

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.newMenuAdd = undefined;

var _newMenuAdd = __webpack_require__(464);

var _newMenuAdd2 = __webpack_require__(466);

__webpack_require__(165);

var newMenuAdd = exports.newMenuAdd = angular.module('common.components.featureMainPageTemplate.newMenuAdd', []).component('newMenuAdd', _newMenuAdd.newMenuAddComponent).service('NewMenuAddService', _newMenuAdd2.NewMenuAddService).name;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewMenuAddService = exports.NewMenuAddService = function () {
    NewMenuAddService.$inject = ["$resource", "$cookies", "ApiService"];
    function NewMenuAddService($resource, $cookies, ApiService) {
        'ngInject';

        _classCallCheck(this, NewMenuAddService);

        this.$resource = $resource;
        this.apiService = ApiService;

        this.newMenuAddResourceUrl = this.apiService.getResourceUrl('cms/menus');
        this.newMenuAddResource = this.$resource(this.newMenuAddResourceUrl);
    }

    _createClass(NewMenuAddService, [{
        key: 'addNewMenu',
        value: function addNewMenu(details) {
            var _this = this;

            var promise = this.newMenuAddResource.save(this._setNewMenuDetails(details)).$promise;

            return promise.then(function (data) {
                return data;
            }).catch(function (err) {
                throw _this.apiService.getErrorMessage(err);
            });
        }
    }, {
        key: '_setNewMenuDetails',
        value: function _setNewMenuDetails(_ref) {
            var menu_id = _ref.menuId,
                title = _ref.title,
                overview = _ref.overview,
                description = _ref.description;

            return {
                menu_id: menu_id,
                title: title,
                overview: overview,
                description: description
            };
        }
    }]);

    return NewMenuAddService;
}();

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.formButtonsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _formButtons = __webpack_require__(727);

var _formButtons2 = _interopRequireDefault(_formButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var formButtonsComponent = exports.formButtonsComponent = {
	bindings: {
		disableButtons: '<',
		showCancelButton: '@',
		showPreviousButton: '@',
		showSubmitButton: '@',
		showNextButton: '@',
		showSavePublishButton: '@',
		showSavePublishTypeButton: '@',
		showRepublishButton: '<',
		onCancel: '&',
		onPrevious: '&',
		onNext: '&',
		onSavePublish: '&',
		onRepublish: '&'
	},
	templateUrl: _formButtons2.default,
	controller: function () {
		FormButtons.$inject = ["$parse"];
		function FormButtons($parse) {
			'ngInject';

			_classCallCheck(this, FormButtons);

			this.$parse = $parse;
			this.details = {
				displayCancelButton: true,
				displayPreviousButton: false,
				displaySubmitButton: true,
				displayNextButton: false,
				displaySavePublishButton: false,
				displaySavePublishTypeButton: false
			};
		}

		_createClass(FormButtons, [{
			key: '$onInit',
			value: function $onInit() {
				this.details.displayCancelButton = this.$parse(this.showCancelButton || 'true')(true);
				this.details.displayPreviousButton = this.$parse(this.showPreviousButton || 'false')(false);
				this.details.displayNextButton = this.$parse(this.showNextButton || 'false')(false);
				this.details.displaySubmitButton = this.$parse(this.showSubmitButton || 'true')(true);
				this.details.displaySavePublishButton = this.$parse(this.showSavePublishButton || 'false')(false);
				this.details.displaySavePublishTypeButton = this.$parse(this.showSavePublishTypeButton || 'false')(false);

				if (this.showRepublishButton) {
					this.details.displaySubmitButton = false;
					this.details.displaySavePublishButton = false;
				}
			}
		}]);

		return FormButtons;
	}()
};

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.formButtons = undefined;

var _formButtons = __webpack_require__(467);

__webpack_require__(166);

var formButtons = exports.formButtons = angular.module('common.components.formButtons', []).component('formButtons', _formButtons.formButtonsComponent).name;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.googleLocationComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _googleLocation = __webpack_require__(728);

var _googleLocation2 = _interopRequireDefault(_googleLocation);

var _size = __webpack_require__(12);

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var googleLocationComponent = exports.googleLocationComponent = {
    bindings: {
        getLocationDetails: '&',
        isRequired: '@',
        isError: '@',
        isDisabledLocation: '@'
    },
    templateUrl: _googleLocation2.default,
    controller: function () {
        GoogleLocationComponent.$inject = ["$parse", "$timeout", "defaultErrorMessageResolver", "GoogleLocationService"];
        function GoogleLocationComponent($parse, $timeout, defaultErrorMessageResolver, GoogleLocationService) {
            'ngInject';

            _classCallCheck(this, GoogleLocationComponent);

            this.$parse = $parse;
            this.$timeout = $timeout;
            this.googleLocationService = GoogleLocationService;
        }

        _createClass(GoogleLocationComponent, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this._isRequired = this.$parse(this.isRequired || 'false')(false);
                this._isError = this.$parse(this.isError || 'false')(false);
                this._isDisabledLocation = this.$parse(this.isDisabledLocation || 'false')(false);
                this.place = {};
                this.addressDetails = {};
                this.locationName = "";
                var autoComplete = void 0;
                var searchInput = "";
                this.$timeout(function () {
                    searchInput = document.getElementById("location");
                    autoComplete = new google.maps.places.Autocomplete(searchInput, { types: ['geocode'], componentRestrictions: { country: "us" } });
                    autoComplete.addListener('place_changed', getAddress.bind(_this));
                });

                function getAddress() {
                    var _this2 = this;

                    this.$timeout(function () {
                        _this2.place = autoComplete.getPlace();
                        _this2.addressDetails = {};
                        _this2.addressDetails.locationName = '';
                        if (_this2.place.address_components) {
                            _this2.addressDetails = _this2.googleLocationService.formatAddress(_this2.place);
                            _this2._isError = (0, _size2.default)(_this2.addressDetails.serviceAreas) > 0 ? false : true;
                            _this2._isDisabledLocation = true;
                        } else {
                            _this2._isError = true;
                        }

                        _this2.getLocationDetails({
                            details: _this2.addressDetails
                        });
                    });
                }
            }
        }, {
            key: 'onLocationChange',
            value: function onLocationChange() {
                this._isError = false;
            }
        }, {
            key: 'clearLocationInput',
            value: function clearLocationInput() {
                this._isDisabledLocation = false;
                this.addressDetails = {
                    serviceAreas: []
                };
                this.locationName = "";
                this._isError = false;
                this.getLocationDetails({
                    details: this.addressDetails
                });
            }
        }, {
            key: '$onChanges',
            value: function $onChanges(changes) {

                if (changes && changes.isError) {
                    this._isError = this.$parse(changes.isError.currentValue || "true")(true);
                }

                if (changes && changes.isDisabledLocation) {
                    this._isDisabledLocation = this.$parse(changes.isDisabledLocation.currentValue || 'true')(true);
                }
            }
        }]);

        return GoogleLocationComponent;
    }()
};

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.googleLocation = undefined;

var _googleLocation = __webpack_require__(469);

var _googleLocation2 = __webpack_require__(471);

__webpack_require__(167);

var googleLocation = exports.googleLocation = angular.module('common.components.googleLocation', []).component('googleLocation', _googleLocation.googleLocationComponent).service('GoogleLocationService', _googleLocation2.GoogleLocationService).name;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GoogleLocationService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleLocationService = exports.GoogleLocationService = function () {
    function GoogleLocationService() {
        _classCallCheck(this, GoogleLocationService);
    }

    _createClass(GoogleLocationService, [{
        key: 'formatAddress',
        value: function formatAddress(details) {
            var addressDetails = {
                serviceAreas: []
            };
            addressDetails.serviceAreas = details.address_components.reduce(function (serviceAreas, data) {
                var type = (0, _head2.default)(data.types);
                var address = {
                    type: '',
                    name: ''
                };

                switch (type) {
                    case 'country':
                        address.type = 'country';
                        address.name = data.short_name;
                        serviceAreas.push(address);
                        break;
                    case 'administrative_area_level_1':
                        address.type = 'state';
                        address.name = data.short_name;
                        serviceAreas.push(address);
                        break;
                    case 'administrative_area_level_2':
                        address.type = 'county';
                        address.name = data.long_name;
                        serviceAreas.push(address);
                        break;
                    case 'administrative_area_level_3':
                        address.type = 'town';
                        address.name = data.long_name;
                        serviceAreas.push(address);
                        break;
                    case 'locality':
                        address.type = 'village';
                        address.name = data.long_name;
                        serviceAreas.push(address);
                        break;
                    case 'neighborhood':
                        address.type = 'township';
                        address.name = data.long_name;
                        serviceAreas.push(address);
                        break;
                };

                return serviceAreas;
            }, []);

            addressDetails.lat = details.geometry.location.lat();
            addressDetails.lng = details.geometry.location.lng();

            return addressDetails;
        }
    }, {
        key: 'getLocationDetailsByPlaceName',
        value: function getLocationDetailsByPlaceName(placeName) {
            var geocoder = new google.maps.Geocoder();

            return new Promise(function (resolve, reject) {
                geocoder.geocode({ 'address': placeName }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        resolve(results);
                    } else {
                        reject('No results found');
                    }
                });
            });
        }
    }]);

    return GoogleLocationService;
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.highmaps = undefined;

var _highmaps = __webpack_require__(473);

var highmaps = exports.highmaps = angular.module('common.components.highmaps', []).service('HighmapsService', _highmaps.HighmapsService).name;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HighmapsService = exports.HighmapsService = function () {
    function HighmapsService() {
        _classCallCheck(this, HighmapsService);
    }

    _createClass(HighmapsService, [{
        key: "getCountyData",
        value: function getCountyData() {
            return {
                "title": "",
                "version": "1.0.0",
                "type": "FeatureCollection",
                "copyright": "Copyright (c) 2014 Highsoft AS, Based on data from The United States Census Bureau http://www.census.gov",
                "copyrightShort": "USA Census Bureau",
                "copyrightUrl": "http://www.census.gov",
                "crs": {
                    "type": "name",
                    "properties": {
                        "name": "urn:ogc:def:crs:EPSG:2260"
                    }
                },

                "features": [{
                    "type": "Feature",
                    "id": "US.NY.007",
                    "properties": {
                        "hc-group": "admin2", "hc-middle-x": 0.36, "hc-middle-y": 0.69, "hc-key": "us-ny-007", "hc-a2": "BR", "name": "Broome", "code": "36007"
                    },

                    "geometry": {
                        "type": "Polygon", "coordinates": [[[970, 961], [886, 962], [806, 964], [804, 1019], [811, 1019], [812, 1032], [806, 1058], [806, 1072], [803, 1085], [826, 1084], [861, 1086], [865, 1040], [870, 1036], [910, 1036], [910, 1020], [958, 1019], [956, 974], [961, 965], [970, 961]]]
                    }
                }, {
                    "type": "Feature",
                    "id": "US.NY.015",
                    "properties": {
                        "hc-group": "admin2", "hc-middle-x": 0.50, "hc-middle-y": 0.50, "hc-key": "us-ny-015", "hc-a2": "CH", "name": "Chemung", "code": "36015"
                    },

                    "geometry": {
                        "type": "Polygon", "coordinates": [[[695, 1050], [703, 1050], [712, 1049], [712, 1012], [706, 1012], [710, 981], [706, 966], [645, 968], [616, 969], [616, 976], [619, 1051], [619, 1053], [646, 1054], [669, 1054], [669, 1040], [680, 1040], [689, 1035], [694, 1040], [695, 1050]]]
                    }
                }, {
                    "type": "Feature",
                    "id": "US.NY.017",
                    "properties": {
                        "hc-group": "admin2", "hc-middle-x": 0.49, "hc-middle-y": 0.50, "hc-key": "us-ny-017", "hc-a2": "CH", "name": "Chenango", "code": "36017"
                    },

                    "geometry": {
                        "type": "Polygon", "coordinates": [[[959, 1054], [958, 1036], [958, 1019], [910, 1020], [910, 1036], [870, 1036], [865, 1040], [861, 1086], [860, 1109], [857, 1177], [957, 1182], [957, 1180], [986, 1181], [986, 1174], [978, 1160], [979, 1135], [970, 1125], [962, 1103], [968, 1083], [961, 1074], [963, 1066], [959, 1054]]]
                    }
                }, {
                    "type": "Feature",
                    "id": "US.NY.023",
                    "properties": {
                        "hc-group": "admin2", "hc-middle-x": 0.49, "hc-middle-y": 0.51, "hc-key": "us-ny-023", "hc-a2": "CO", "name": "Cortland", "code": "36023"
                    },

                    "geometry": {
                        "type": "Polygon", "coordinates": [[[856, 1197], [856, 1192], [857, 1177], [860, 1109], [861, 1086], [826, 1084], [803, 1085], [776, 1085], [776, 1085], [775, 1110], [774, 1149], [773, 1186], [773, 1192], [815, 1194], [856, 1197]]]
                    }
                }, {
                    "type": "Feature",
                    "id": "US.NY.025",
                    "properties": {
                        "hc-group": "admin2", "hc-middle-x": 0.47, "hc-middle-y": 0.43, "hc-key": "us-ny-025", "hc-a2": "DE", "name": "Delaware", "code": "36025"
                    },

                    "geometry": {
                        "type": "Polygon", "coordinates": [[[958, 1019], [958, 1036], [959, 1054], [983, 1057], [993, 1070], [1007, 1067], [1029, 1085], [1046, 1088], [1059, 1098], [1084, 1112], [1100, 1110], [1113, 1114], [1113, 1114], [1113, 1114], [1133, 1086], [1172, 1065], [1175, 1064], [1151, 1020], [1170, 1011], [1158, 1003], [1153, 1004], [1148, 996], [1098, 965], [1068, 948], [1017, 917], [1010, 923], [1000, 919], [992, 921], [990, 934], [984, 948], [981, 946], [970, 961], [961, 965], [956, 974], [958, 1019]]]
                    }
                }, {
                    "type": "Feature",
                    "id": "US.NY.077",
                    "properties": {
                        "hc-group": "admin2", "hc-middle-x": 0.52, "hc-middle-y": 0.39, "hc-key": "us-ny-077", "hc-a2": "OT", "name": "Otsego", "code": "36077"
                    },

                    "geometry": {
                        "type": "Polygon", "coordinates": [[[986, 1181], [996, 1193], [999, 1208], [997, 1219], [998, 1221], [1005, 1221], [1005, 1214], [1020, 1215], [1029, 1229], [1071, 1204], [1074, 1207], [1077, 1226], [1102, 1216], [1114, 1211], [1127, 1206], [1123, 1182], [1131, 1146], [1113, 1114], [1113, 1114], [1113, 1114], [1100, 1110], [1084, 1112], [1059, 1098], [1046, 1088], [1029, 1085], [1007, 1067], [993, 1070], [983, 1057], [959, 1054], [963, 1066], [961, 1074], [968, 1083], [962, 1103], [970, 1125], [979, 1135], [978, 1160], [986, 1174], [986, 1181]]]
                    }
                }, {
                    "type": "Feature",
                    "id": "US.NY.097",
                    "properties": {
                        "hc-group": "admin2", "hc-middle-x": 0.50, "hc-middle-y": 0.50, "hc-key": "us-ny-097", "hc-a2": "SC", "name": "Schuyler", "code": "36097"
                    },

                    "geometry": {
                        "type": "Polygon", "coordinates": [[[619, 1051], [589, 1050], [589, 1112], [615, 1112], [615, 1105], [637, 1105], [635, 1114], [636, 1128], [663, 1128], [680, 1128], [681, 1078], [679, 1051], [695, 1050], [694, 1040], [689, 1035], [680, 1040], [669, 1040], [669, 1054], [646, 1054], [619, 1053], [619, 1051]]]
                    }
                }, {
                    "type": "Feature",
                    "id": "US.NY.101",
                    "properties": {
                        "hc-group": "admin2", "hc-middle-x": 0.51, "hc-middle-y": 0.50, "hc-key": "us-ny-101", "hc-a2": "ST", "name": "Steuben", "code": "36101"
                    },

                    "geometry": {
                        "type": "Polygon", "coordinates": [[[506, 1143], [516, 1142], [534, 1141], [582, 1140], [580, 1117], [589, 1119], [589, 1112], [589, 1050], [619, 1051], [616, 976], [616, 969], [581, 969], [443, 974], [452, 1093], [455, 1113], [456, 1132], [469, 1131], [470, 1145], [506, 1143]]]
                    }
                }, {
                    "type": "Feature",
                    "id": "US.NY.107",
                    "properties": {
                        "hc-group": "admin2", "hc-middle-x": 0.50, "hc-middle-y": 0.69, "hc-key": "us-ny-107", "hc-a2": "TI", "name": "Tioga", "code": "36107"
                    },

                    "geometry": {
                        "type": "Polygon", "coordinates": [[[803, 1085], [806, 1072], [806, 1058], [812, 1032], [811, 1019], [804, 1019], [806, 964], [731, 965], [706, 966], [710, 981], [706, 1012], [712, 1012], [712, 1049], [726, 1049], [726, 1043], [739, 1043], [739, 1059], [754, 1059], [776, 1052], [778, 1072], [765, 1078], [767, 1085], [776, 1085], [776, 1085], [803, 1085]]]
                    }
                }, {
                    "type": "Feature",
                    "id": "US.NY.109",
                    "properties": {
                        "hc-group": "admin2", "hc-middle-x": 0.50, "hc-middle-y": 0.50, "hc-key": "us-ny-109", "hc-a2": "TO", "name": "Tompkins", "code": "36109"
                    },

                    "geometry": {
                        "type": "Polygon", "coordinates": [[[712, 1049], [703, 1050], [695, 1050], [679, 1051], [681, 1078], [680, 1128], [704, 1129], [697, 1134], [687, 1151], [732, 1151], [732, 1148], [774, 1149], [775, 1110], [776, 1085], [767, 1085], [765, 1078], [778, 1072], [776, 1052], [754, 1059], [739, 1059], [739, 1043], [726, 1043], [726, 1049], [712, 1049]]]
                    }
                }]
            };
        }
    }]);

    return HighmapsService;
}();

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var inputValidationDirective = exports.inputValidationDirective = ["$parse", "defaultErrorMessageResolver", function inputValidationDirective($parse, defaultErrorMessageResolver) {
	'ngInject';

	defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages) {
		errorMessages['inputValidation'] = 'Please enter a valid URL in the format of http(s)://www.google.com';
		errorMessages['email'] = 'Please enter a valid email address';
	});
	return {
		require: 'ngModel',
		restrict: 'A',
		link: function link(scope, element, attrs, ngModel) {
			var pattern;
			if (attrs.key === "email") {
				pattern = /([\w-\.]+)@((?:[\w-]+\.)+)([a-zA-Z]{2,4})/;
				ngModel.$validators.email = function (value) {
					return ngModel.$isEmpty(value) || pattern.test(value);
				};
			} else if (attrs.type === "url") {
				pattern = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
				ngModel.$validators.inputValidation = function (value) {
					return ngModel.$isEmpty(value) || pattern.test(value);
				};
			} else if (attrs.type === "text") {
				ngModel.$parsers.push(function (text) {
					var modifiedInput = text;

					if (modifiedInput) modifiedInput = modifiedInput.replace(/[^0-9]/g, '');

					if (modifiedInput != text) {
						ngModel.$setViewValue(modifiedInput);
						ngModel.$render();
					}
					return modifiedInput;
				});
				ngModel.$formatters.push(function (text) {
					var modifiedInput = text;

					if (modifiedInput) modifiedInput = modifiedInput.replace(/[^0-9]/g, '');

					if (modifiedInput != text) {
						ngModel.$setViewValue(modifiedInput);
						ngModel.$render();
					}
					return modifiedInput;
				});
			}
		}
	};
}];

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.inputValidation = undefined;

var _inputValidation = __webpack_require__(474);

var inputValidation = exports.inputValidation = angular.module('common.libs.inputvalidation', []).directive('inputValidation', _inputValidation.inputValidationDirective).name;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var modalComponent = exports.modalComponent = {
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	},
	template: '<div ng-include="$ctrl.resolve.templateUrl"></div>',
	controller: function () {
		function ModalComponent() {
			_classCallCheck(this, ModalComponent);
		}

		_createClass(ModalComponent, [{
			key: '$onInit',
			value: function $onInit() {
				if (!this.resolve.details) {
					this.resolve.details = {};
				}
				if (!this.resolve.details.bodyMessage) {
					this.resolve.details.bodyMessage = 'Are you sure you want to save the details?';
				}
			}
		}, {
			key: 'buttonClick',
			value: function buttonClick(button) {
				this.close();
				if (button.action) {
					button.action(this);
				}
			}
		}]);

		return ModalComponent;
	}()
};

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.modal = undefined;

var _modal = __webpack_require__(226);

var _modal2 = _interopRequireDefault(_modal);

var _modalService = __webpack_require__(478);

var _modalComponent = __webpack_require__(476);

__webpack_require__(168);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modal = exports.modal = angular.module('common.libs.modal', [_modal2.default]).component('modal', _modalComponent.modalComponent).service('ModalService', _modalService.ModalService).name;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ModalService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _modalWindow = __webpack_require__(729);

var _modalWindow2 = _interopRequireDefault(_modalWindow);

var _modal = __webpack_require__(730);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ModalService = exports.ModalService = function () {
	ModalService.$inject = ["$uibModal"];
	function ModalService($uibModal) {
		'ngInject';

		_classCallCheck(this, ModalService);

		this.$uibModal = $uibModal;
	}

	_createClass(ModalService, [{
		key: 'open',
		value: function open(_details2) {
			var _details = {
				component: _details2.component || 'modal',
				backdrop: _details2.backdrop || true,
				keyboard: _details2.keyboard || true,
				windowTemplateUrl: _details2.windowTemplateUrl || _modalWindow2.default,
				resolve: {
					details: function details() {
						return _details2.details;
					},
					buttons: function buttons() {
						return _details2.buttons;
					},
					templateUrl: function templateUrl() {
						return _details2.templateUrl || _modal2.default;
					}
				},
				size: _details2.size
			};
			var modalInstance = this.$uibModal.open(_details);
			modalInstance.result.catch(function (error) {
				if (error === "backdrop click") {} else {
					throw error;
				}
			});
			return modalInstance;
		}
	}]);

	return ModalService;
}();

// Example to use
/*
	this.modalService.open({
		details: {
			bodyMessage: 'Body Message'
		},
		buttons: [{
			name: 'cancel',
			action() {
				console.log('cancelled');
			}
		}, {
			name: 'submit',
			isPrimary: true,
			action() {
				console.log('closed');
			}
		}]
	});
*/

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.operationInfoComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _operationInfo = __webpack_require__(731);

var _operationInfo2 = _interopRequireDefault(_operationInfo);

var _zipObject = __webpack_require__(394);

var _zipObject2 = _interopRequireDefault(_zipObject);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var operationInfoComponent = exports.operationInfoComponent = {
	bindings: {
		details: '<',
		onSubmit: '&',
		onCancel: '&',
		onPrevious: '&',
		showNextButton: '@',
		showPreviousButton: '@',
		prevDetails: '<',
		newDetails: '<',
		parentSlug: '@'
	},

	templateUrl: _operationInfo2.default,

	controller: function () {
		OperationInfoComponent.$inject = ["$state", "$parse", "CompareObjectService", "ModalService"];
		function OperationInfoComponent($state, $parse, CompareObjectService, ModalService) {
			'ngInject';

			_classCallCheck(this, OperationInfoComponent);

			this.$state = $state;
			this.$parse = $parse;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
		}

		_createClass(OperationInfoComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.errorMsg = '';
				this._showNextButton = this.$parse(this.showNextButton || 'true')(true);
				this._showPreviousButton = this.$parse(this.showPreviousButton || 'true')(true);
				this.details = this.details || {
					hoursOfOperation: {
						startTime: '',
						endTime: '',
						isAllDay: false
					},
					daysOfOperation: ''
				};

				this.daysOfOperation = this.details.daysOfOperation || [{
					id: 1,
					displayName: 'Mon',
					name: 'monday',
					isSelected: false
				}, {
					id: 2,
					displayName: 'Tue',
					name: 'tuesday',
					isSelected: false
				}, {
					id: 3,
					displayName: 'Wed',
					name: 'wednesday',
					isSelected: false
				}, {
					id: 4,
					displayName: 'Thu',
					name: 'thursday',
					isSelected: false
				}, {
					id: 5,
					displayName: 'Fri',
					name: 'friday',
					isSelected: false
				}, {
					id: 6,
					displayName: 'Sat',
					name: 'saturday',
					isSelected: false
				}, {
					id: 7,
					displayName: 'Sun',
					name: 'sunday',
					isSelected: false
				}];

				this.hoursOfOperation = {
					range: {
						startTime: {
							title: 'start time',
							selectedTime: this.details.hoursOfOperation.startTime || new Date()
						},
						endTime: {
							title: 'end time',
							selectedTime: this.details.hoursOfOperation.endTime || new Date()
						}
					}
				};

				if (this.details.hoursOfOperation.isAllDay) {
					this.hoursOfOperation.range.startTime.isDisabled = true;
					this.hoursOfOperation.range.endTime.isDisabled = true;
				} else {
					this.hoursOfOperation.range.startTime.isDisabled = false;
					this.hoursOfOperation.range.endTime.isDisabled = false;
				}
			}
		}, {
			key: 'onChange',
			value: function onChange(items) {
				this.details.daysOfOperation = items;
			}
		}, {
			key: 'onAllDayCheckboxSelected',
			value: function onAllDayCheckboxSelected() {
				if (this.details.hoursOfOperation.isAllDay) {
					this.hoursOfOperation.range.startTime.isDisabled = true;
					this.hoursOfOperation.range.endTime.isDisabled = true;
				} else {
					this.hoursOfOperation.range.startTime.isDisabled = false;
					this.hoursOfOperation.range.endTime.isDisabled = false;
				}
			}
		}, {
			key: '_onCancel',
			value: function _onCancel() {
				this.saveData = angular.copy(this.prevDetails);
				var _details = angular.copy(this.newDetails);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);

				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},

						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}

				function onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}, {
			key: '_onSubmit',
			value: function _onSubmit() {
				this.details.hoursOfOperation.startTime = this.hoursOfOperation.range.startTime.selectedTime;
				this.details.hoursOfOperation.endTime = this.hoursOfOperation.range.endTime.selectedTime;
				var index = (0, _findIndex2.default)(this.details.daysOfOperation, 'isSelected');
				if (index !== -1) {
					this.errorMsg = '';
					this.onSubmit({
						$event: {
							operationInfo: this.details
						}
					});
				} else {
					this.errorMsg = 'This field is required';
				}
			}
		}]);

		return OperationInfoComponent;
	}()
};

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.operationInfo = undefined;

var _operationInfo = __webpack_require__(479);

var operationInfo = exports.operationInfo = angular.module('common.components.operationInfo', []).component('operationInfo', _operationInfo.operationInfoComponent).name;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.otherInfoComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _otherInfo = __webpack_require__(732);

var _otherInfo2 = _interopRequireDefault(_otherInfo);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var otherInfoComponent = exports.otherInfoComponent = {
	bindings: {
		details: '<',
		paymentMethodsList: '<',
		onSubmit: '&',
		onCancel: '&',
		onPrevious: '&',
		showNextButton: '@',
		showPreviousButton: '@',
		prevDetails: '<',
		newDetails: '<',
		parentSlug: '@'
	},

	templateUrl: _otherInfo2.default,

	controller: function () {
		OtherInfoComponent.$inject = ["$state", "$parse", "Constants", "CompareObjectService", "ModalService"];
		function OtherInfoComponent($state, $parse, Constants, CompareObjectService, ModalService) {
			'ngInject';

			_classCallCheck(this, OtherInfoComponent);

			this.$state = $state;
			this.$parse = $parse;
			this.constants = Constants;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
		}

		_createClass(OtherInfoComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this._showNextButton = this.$parse(this.showNextButton || 'true')(true);
				this.showPreviousButton = this.$parse(this.showPreviousButton || 'true')(true);
				this.details = this.details || {};
				this.defaultPaymentMethod = this.details.methodOfPayment;
				this.saveData = angular.copy(this.details);
			}

			//category select function for autocomplete

		}, {
			key: 'onSelectItem',
			value: function onSelectItem(value) {
				var index = (0, _findIndex2.default)(this.details.methodOfPayment, function (_ref) {
					var id = _ref.id;
					return id === value.id;
				});
				if (index === -1) {
					value.status = this.constants.STATUS.ADD;
					this.details.methodOfPayment.push(value);
				} else {
					this.details.methodOfPayment[index].status = -1;
				}
			}

			//category remove function for autocomplete

		}, {
			key: 'onRemoveTag',
			value: function onRemoveTag(value) {
				var _this = this;

				var paymentIndex = (0, _findIndex2.default)(this.details.methodOfPayment, function (_ref2) {
					var name = _ref2.name;
					return name === value;
				});
				this.details.methodOfPayment = this.details.methodOfPayment.reduce(function (payment, value, index) {
					if (paymentIndex === index) {
						if (_this.details.methodOfPayment[index].status !== _this.constants.STATUS.ADD) {
							value.status = _this.constants.STATUS.DELETE;
							payment.push(value);
						}
					} else {
						payment.push(value);
					}
					return payment;
				}, []);
			}
		}, {
			key: '_onCancel',
			value: function _onCancel() {
				this.saveData = angular.copy(this.prevDetails);
				var _details = angular.copy(this.newDetails);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);

				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},

						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}

				function onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}, {
			key: '_onSubmit',
			value: function _onSubmit() {
				this.onSubmit({
					$event: {
						otherInfo: this.details
					}
				});
			}
		}]);

		return OtherInfoComponent;
	}()
};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.otherInfo = undefined;

var _otherInfo = __webpack_require__(481);

var otherInfo = exports.otherInfo = angular.module('common.components.otherInfo', []).component('otherInfo', _otherInfo.otherInfoComponent).name;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.overviewTemplateComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _overviewTemplate = __webpack_require__(733);

var _overviewTemplate2 = _interopRequireDefault(_overviewTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var overviewTemplateComponent = exports.overviewTemplateComponent = {
	bindings: {
		details: '<',
		disableButtons: '<',
		pageName: '@',
		onCancel: '&',
		onSubmit: '&',
		onCoverPicUpload: '&',
		isDescriptionAvailable: '@'
	},

	templateUrl: _overviewTemplate2.default,

	controller: function () {
		OverviewTemplateComponent.$inject = ["$parse"];
		function OverviewTemplateComponent($parse) {
			'ngInject';

			_classCallCheck(this, OverviewTemplateComponent);

			this.$parse = $parse;
		}

		_createClass(OverviewTemplateComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.displayCoverPic = this.details.image ? true : false;
				this._isDescriptionAvailable = this.$parse(this.isDescriptionAvailable || 'true')(true);
				this.maxOverviewCharacterCount = 150;
				this.maxDescriptionCharacterCount = 2000;
			}
		}, {
			key: '_onCoverPicUpload',
			value: function _onCoverPicUpload(details) {
				this.onCoverPicUpload({ details: details });
			}
		}]);

		return OverviewTemplateComponent;
	}()
};

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.overviewTemplate = undefined;

var _overviewTemplate = __webpack_require__(483);

__webpack_require__(169);

var overviewTemplate = exports.overviewTemplate = angular.module('common.components.overviewTemplate', []).component('overviewTemplate', _overviewTemplate.overviewTemplateComponent).name;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pageContentCountComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pageContentCount = __webpack_require__(734);

var _pageContentCount2 = _interopRequireDefault(_pageContentCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pageContentCountComponent = exports.pageContentCountComponent = {
    bindings: {
        currentItemCount: '<',
        itemPerPage: '<',
        currentPage: '<',
        totalItems: '<'
    },

    templateUrl: _pageContentCount2.default,

    controller: function () {
        function PageContentCountComponent() {
            _classCallCheck(this, PageContentCountComponent);
        }

        _createClass(PageContentCountComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.currentTotalItems = this.itemPerPage * (this.currentPage - 1) + 1 + ' - ' + (this.itemPerPage * (this.currentPage - 1) + this.currentItemCount);
            }
        }, {
            key: '$onChanges',
            value: function $onChanges(changes) {
                this.$onInit();
            }
        }]);

        return PageContentCountComponent;
    }()
};

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pageContentCount = undefined;

var _pageContentCount = __webpack_require__(485);

var pageContentCount = exports.pageContentCount = angular.module('common.components.pageContentCount', []).component('pageContentCount', _pageContentCount.pageContentCountComponent).name;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.pageStatusComponent = undefined;

var _pageStatus = __webpack_require__(735);

var _pageStatus2 = _interopRequireDefault(_pageStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pageStatusComponent = exports.pageStatusComponent = {
	bindings: {
		list: '<',
		onChange: '&'
	},

	templateUrl: _pageStatus2.default,

	controller: function PageStatusComponent() {
		_classCallCheck(this, PageStatusComponent);
	}
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.pageStatus = undefined;

var _pageStatus = __webpack_require__(487);

__webpack_require__(170);

var pageStatus = exports.pageStatus = angular.module('common.components.pageStatus', []).component('pageStatus', _pageStatus.pageStatusComponent).name;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.paginationComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pagination = __webpack_require__(736);

var _pagination2 = _interopRequireDefault(_pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var paginationComponent = exports.paginationComponent = {
	bindings: {
		totalItems: '<',
		currentPage: '<',
		itemPerPage: '<',
		onChange: '&'
	},
	templateUrl: _pagination2.default,
	controller: function () {
		function PaginationComponent() {
			_classCallCheck(this, PaginationComponent);
		}

		_createClass(PaginationComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.maxSize = 3;
			}
		}, {
			key: '_onChange',
			value: function _onChange() {
				this.onChange({
					$event: this.currentPage
				});
			}
		}]);

		return PaginationComponent;
	}()
};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.pagination = undefined;

var _pagination = __webpack_require__(229);

var _pagination2 = _interopRequireDefault(_pagination);

var _pagination3 = __webpack_require__(489);

__webpack_require__(171);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pagination = exports.pagination = angular.module('common.libs.pagination', [_pagination2.default]).component('pagination', _pagination3.paginationComponent).name;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.phoneTemplateComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phoneTemplate = __webpack_require__(737);

var _phoneTemplate2 = _interopRequireDefault(_phoneTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var phoneTemplateComponent = exports.phoneTemplateComponent = {
	bindings: {
		details: '<',
		onAdd: '&',
		onDelete: '&',
		hidePhonePurpose: '@'
	},

	templateUrl: _phoneTemplate2.default,

	controller: function () {
		PhoneTemplateComponent.$inject = ["$timeout"];
		function PhoneTemplateComponent($timeout) {
			'ngInject';

			_classCallCheck(this, PhoneTemplateComponent);

			this.$timeout = $timeout;
		}

		_createClass(PhoneTemplateComponent, [{
			key: 'onFocus',
			value: function onFocus(label, index) {
				this.$timeout(function () {
					index !== 0 ? document.getElementById(label + '_' + index).focus() : true;
				});
			}
		}]);

		return PhoneTemplateComponent;
	}()
};

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.phoneTemplate = undefined;

var _phoneTemplate = __webpack_require__(491);

__webpack_require__(172);

var phoneTemplate = exports.phoneTemplate = angular.module('common.components.phoneTemplate', []).component('phoneTemplate', _phoneTemplate.phoneTemplateComponent).name;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});
exports.radioButtonsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _radioButtons = __webpack_require__(738);

var _radioButtons2 = _interopRequireDefault(_radioButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var radioButtonsComponent = exports.radioButtonsComponent = {
				bindings: {
								title: '@',
								options: '<',
								defaultSelectedOptionId: '@',
								onChange: '&',
								isRequired: '<'
				},

				templateUrl: _radioButtons2.default,

				controller: function () {
								RadioButtonsComponent.$inject = ["$parse"];
								function RadioButtonsComponent($parse) {
												'ngInject';

												_classCallCheck(this, RadioButtonsComponent);

												this.$parse = $parse;
								}

								_createClass(RadioButtonsComponent, [{
												key: '$onInit',
												value: function $onInit() {
																this.name = new Date().getTime() + Math.random();
																this._isRequired = this.$parse(this.isRequired || 'true')(true);
												}
								}, {
												key: '_onChange',
												value: function _onChange($event) {
																this.onChange({
																				$event: {
																								id: this.defaultSelectedOptionId
																				}
																});
												}
								}]);

								return RadioButtonsComponent;
				}()
};

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.radioButtons = undefined;

var _radioButtons = __webpack_require__(493);

__webpack_require__(173);

var radioButtons = exports.radioButtons = angular.module('common.components.radioButtons', []).component('radioButtons', _radioButtons.radioButtonsComponent).name;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportRepositoryAddComponent = exports.reportRepositoryAddComponent = {
	template: '\n                <report-repository-main \n                        details = "$ctrl.details"\n                        page-title=\'{{$ctrl.pageTitle}}\' \n                        is-short-details = "{{$ctrl.isShortDetails}}"\n\t\t\tdisable-buttons=\'$ctrl.disableButtons\'\n                        on-submit=\'$ctrl.onSubmit({$event: $event})\'\n                        on-cancel="$ctrl.onCancel({$event: $event})"\n                        service-area-list = "$ctrl.serviceAreaList"\n\t\t\tprogram-years = "$ctrl.programYears">\n                </report-repository-main>',

	bindings: {
		details: '<',
		pageTitle: "@",
		programYears: '<',
		serviceAreaList: '<',
		isShortDetails: '@',
		disableButtons: '<',
		onSubmit: '&',
		onCancel: '&'
	},
	//controller for ProgressReportsAddComponent
	controller: function ReportRepositoryAddComponent() {
		_classCallCheck(this, ReportRepositoryAddComponent);
	}
};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reportRepositoryAdd = undefined;

var _reportRepositoryAdd = __webpack_require__(495);

var reportRepositoryAdd = exports.reportRepositoryAdd = angular.module('common.components.reportRepository.reportRepositoryAdd', []).component('reportRepositoryAdd', _reportRepositoryAdd.reportRepositoryAddComponent).name;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reportRepositoryDetailsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reportRepositoryDetail = __webpack_require__(739);

var _reportRepositoryDetail2 = _interopRequireDefault(_reportRepositoryDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportRepositoryDetailsComponent = exports.reportRepositoryDetailsComponent = {
	bindings: {
		details: '<',
		onEdit: '&',
		onGoBack: '&',
		isShortDetails: '@'
	},
	templateUrl: _reportRepositoryDetail2.default,
	controller: function () {
		ReportRepositoryDetailsComponent.$inject = ["$parse"];
		function ReportRepositoryDetailsComponent($parse) {
			'ngInject';

			_classCallCheck(this, ReportRepositoryDetailsComponent);

			this.$parse = $parse;
		}

		_createClass(ReportRepositoryDetailsComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this._isShortDetails = this.$parse(this.isShortDetails || 'false')(false);
			}
		}]);

		return ReportRepositoryDetailsComponent;
	}()
};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reportRepositoryDetails = undefined;

var _reportRepositoryDetail = __webpack_require__(497);

var reportRepositoryDetails = exports.reportRepositoryDetails = angular.module('common.components.reportRepository.reportRepositoryDetails', []).component('reportRepositoryDetails', _reportRepositoryDetail.reportRepositoryDetailsComponent).name;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportRepositoryEditComponent = exports.reportRepositoryEditComponent = {
        template: '\n                <report-repository-main \n                        details = "$ctrl.details"\n\t\t\tpage-title=\'{{$ctrl.pageTitle}}\' \n                        disable-buttons=\'$ctrl.disableButtons\'\n                        is-short-details = "{{$ctrl.isShortDetails}}"\n                        on-submit=\'$ctrl.onSubmit({$event: $event})\'\n                        on-cancel="$ctrl.onCancel({$event: $event})"\n                        service-area-list = "$ctrl.serviceAreaList"\n\t\t\tprogram-years = "$ctrl.programYears">\n                </report-repository-main>',
        bindings: {
                details: '<',
                programYears: '<',
                serviceAreaList: '<',
                pageTitle: "@",
                disableButtons: '<',
                isShortDetails: '@',
                onSubmit: '&',
                onCancel: '&'
        },
        //controller for ProgressReportsEditComponent
        controller: function ReportRepositoryEditComponent() {
                _classCallCheck(this, ReportRepositoryEditComponent);
        }
};

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reportRepositoryEdit = undefined;

var _reportRepositoryEdit = __webpack_require__(499);

var reportRepositoryEdit = exports.reportRepositoryEdit = angular.module('common.components.reportRepository.reportRepositoryEdit', []).component('reportRepositoryEdit', _reportRepositoryEdit.reportRepositoryEditComponent).name;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reportRepositoryListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reportRepositoryList = __webpack_require__(740);

var _reportRepositoryList2 = _interopRequireDefault(_reportRepositoryList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportRepositoryListComponent = exports.reportRepositoryListComponent = {
	bindings: {
		details: '<',
		slugUrl: '@',
		pageTitle: '@',
		onEditOverview: '&',
		onEdit: '&',
		onDelete: '&',
		onViewDetails: '&'
	},

	templateUrl: _reportRepositoryList2.default,

	controller: function () {
		ReportRepositoryListComponent.$inject = ["$state", "SlugService"];
		function ReportRepositoryListComponent($state, SlugService) {
			'ngInject';

			_classCallCheck(this, ReportRepositoryListComponent);

			this.$state = $state;
			this.slugService = SlugService;
		}

		_createClass(ReportRepositoryListComponent, [{
			key: 'routeDetailsPageUrl',
			value: function routeDetailsPageUrl(slug) {
				var url = this.slugService.getDetailsPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeEditPageUrl',
			value: function routeEditPageUrl(slug) {
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeAddPageUrl',
			value: function routeAddPageUrl() {
				var url = this.slugService.getAddPageURL(this.slugUrl);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}]);

		return ReportRepositoryListComponent;
	}()
};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reportRepositoryList = undefined;

var _reportRepositoryList = __webpack_require__(501);

var reportRepositoryList = exports.reportRepositoryList = angular.module('common.components.reportRepository.reportRepositoryList', []).component('reportRepositoryList', _reportRepositoryList.reportRepositoryListComponent).name;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reportRepositoryMainComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reportRepository = __webpack_require__(741);

var _reportRepository2 = _interopRequireDefault(_reportRepository);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportRepositoryMainComponent = exports.reportRepositoryMainComponent = {
	templateUrl: _reportRepository2.default,

	//binding title, details and onSubmit function
	bindings: {
		programYears: '<',
		serviceAreaList: '<',
		pageTitle: '@',
		isShortDetails: '@',
		details: '<',
		onSubmit: '&',
		onCancel: '&',
		disableButtons: '<'
	},
	controller: function () {
		ReportRepositoryMainComponent.$inject = ["toastr", "$parse", "ReportRepositoryService"];
		function ReportRepositoryMainComponent(toastr, $parse, ReportRepositoryService) {
			'ngInject';

			_classCallCheck(this, ReportRepositoryMainComponent);

			this.toastr = toastr;
			this.$parse = $parse;
			this.reportRepositoryService = ReportRepositoryService;
		}

		_createClass(ReportRepositoryMainComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.isPdfRequired = this.details && this.details.uuid ? false : true;
				this._isShortDetails = this.$parse(this.isShortDetails || 'false')(false);
				this.fileName = this.details && this.details.name ? this.details.name : 'BROWSE';
			}
		}, {
			key: 'onFileChange',
			value: function onFileChange(file) {
				var _this = this;

				this.disableButtons = true;
				if (file && file.type === "application/pdf") {
					this.reportRepositoryService.uploadPdf(file).then(function (details) {
						_this.details.uuid = details.uuid;
						_this.fileName = file.name;
						_this.disableButtons = false;
					}).catch(function (err) {
						_this.toastr.error(err);
						_this.disableButtons = false;
					});
				} else {
					this.toastr.error("Invalid pdf file");
					this.disableButtons = false;
				}
			}
		}, {
			key: 'onDelete',
			value: function onDelete() {
				this.isPdfRequired = true;
				this.fileName = 'BROWSE';
				this.file = "";
			}
		}, {
			key: 'onChangeProgramYear',
			value: function onChangeProgramYear(id) {
				this.details.selectedProgramYearId = id;
			}
		}, {
			key: 'onChangeCounty',
			value: function onChangeCounty(id) {
				this.details.selectedServiceAreaId = id;
			}
		}]);

		return ReportRepositoryMainComponent;
	}()
};

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportRepositoryMain = undefined;

var _reportRepositoryMain = __webpack_require__(503);

var reportRepositoryMain = exports.reportRepositoryMain = angular.module('common.components.reportRepository.reportRepositoryMain', []).component("reportRepositoryMain", _reportRepositoryMain.reportRepositoryMainComponent).name;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
       value: true
});
exports.reportRepository = undefined;

var _reportRepositoryList = __webpack_require__(502);

var _reportRepositoryAdd = __webpack_require__(496);

var _reportRepositoryEdit = __webpack_require__(500);

var _reportRepositoryMain = __webpack_require__(504);

var _reportRepositoryDetail = __webpack_require__(498);

var _reportRepository = __webpack_require__(506);

__webpack_require__(174);

var reportRepository = exports.reportRepository = angular.module('common.components.reportRepository', [_reportRepositoryList.reportRepositoryList, _reportRepositoryAdd.reportRepositoryAdd, _reportRepositoryEdit.reportRepositoryEdit, _reportRepositoryMain.reportRepositoryMain, _reportRepositoryDetail.reportRepositoryDetails]).service('ReportRepositoryService', _reportRepository.ReportRepositoryService).name;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportRepositoryService = exports.ReportRepositoryService = function () {
	ReportRepositoryService.$inject = ["$resource", "ApiService", "Upload"];
	function ReportRepositoryService($resource, ApiService, Upload) {
		'ngInject';

		_classCallCheck(this, ReportRepositoryService);

		this.$resource = $resource;
		this.apiService = ApiService;
		this._upload = Upload;

		this.uploadPdfResourceUrl = this.apiService.getResourceUrl('upload-pdf');
	}

	_createClass(ReportRepositoryService, [{
		key: 'uploadPdf',
		value: function uploadPdf(pdf) {
			var _this = this;

			var promise = this._upload.upload({
				url: this.uploadPdfResourceUrl,
				data: {
					fileObj: pdf
				}
			});

			return promise.then(function (details) {
				return {
					uuid: details.data.data.uuid
				};
			}).catch(function (error) {
				throw _this.apiService.getErrorMessage(error);
			});
		}
	}]);

	return ReportRepositoryService;
}();

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.searchBoxComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _searchBox = __webpack_require__(742);

var _searchBox2 = _interopRequireDefault(_searchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var searchBoxComponent = exports.searchBoxComponent = {
    bindings: {
        onSearch: '&',
        placeholder: '@'
    },

    templateUrl: _searchBox2.default,

    controller: function () {
        function SearchBoxComponent() {
            _classCallCheck(this, SearchBoxComponent);
        }

        _createClass(SearchBoxComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.searchKey = '';
            }
        }, {
            key: '_onSearch',
            value: function _onSearch() {
                this.onSearch({
                    $event: this.searchKey
                });
            }
        }]);

        return SearchBoxComponent;
    }()
};

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.searchBox = undefined;

var _searchBoxComponent = __webpack_require__(507);

__webpack_require__(175);

var searchBox = exports.searchBox = angular.module('common.components.searchBox', []).component('searchBox', _searchBoxComponent.searchBoxComponent).name;

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});
exports.selectDropdownComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _selectDropdown = __webpack_require__(743);

var _selectDropdown2 = _interopRequireDefault(_selectDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var selectDropdownComponent = exports.selectDropdownComponent = {
        bindings: {
                list: '<',
                labelText: '@',
                selectedId: '<',
                defaultOption: '@',
                isOptionDisabled: '<',
                onChange: '&'
        },

        templateUrl: _selectDropdown2.default,

        controller: function () {
                SelectDropdownComponent.$inject = ["$parse"];
                function SelectDropdownComponent($parse) {
                        'ngInject';

                        _classCallCheck(this, SelectDropdownComponent);

                        this.$parse = $parse;
                }

                _createClass(SelectDropdownComponent, [{
                        key: '$onInit',
                        value: function $onInit() {
                                this.selectedId = this.selectedId || null;
                                this.isDisabled = !this.isOptionDisabled ? false : true;
                                this._displayRange = this.$parse(this.displayRange || 'false')(false);
                        }
                }]);

                return SelectDropdownComponent;
        }()
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.selectDropdown = undefined;

var _selectDropdown = __webpack_require__(509);

__webpack_require__(176);

var selectDropdown = exports.selectDropdown = angular.module('common.components.selectDropdown', []).component('selectDropdown', _selectDropdown.selectDropdownComponent).name;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.serviceInfoComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _serviceInfo = __webpack_require__(744);

var _serviceInfo2 = _interopRequireDefault(_serviceInfo);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _clone = __webpack_require__(11);

var _clone2 = _interopRequireDefault(_clone);

var _size = __webpack_require__(12);

var _size2 = _interopRequireDefault(_size);

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var serviceInfoComponent = exports.serviceInfoComponent = {
	bindings: {
		details: '<',
		serviceAreas: '<',
		serviceTypeList: '<',
		onSubmit: '&',
		onCancel: '&',
		onPrevious: '&',
		showNextButton: '@',
		showPreviousButton: '@',
		prevDetails: '<',
		newDetails: '<',
		parentSlug: '@'
	},

	templateUrl: _serviceInfo2.default,

	controller: function () {
		ServiceInfoComponent.$inject = ["$state", "$parse", "Constants", "CompareObjectService", "ModalService"];
		function ServiceInfoComponent($state, $parse, Constants, CompareObjectService, ModalService) {
			'ngInject';

			_classCallCheck(this, ServiceInfoComponent);

			this.$state = $state;
			this.$parse = $parse;
			this.constants = Constants;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
		}

		_createClass(ServiceInfoComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.defaultServiceTypes = (0, _clone2.default)(this.details.serviceInfo.serviceType);
				this.defaultServiceAreas = (0, _clone2.default)(this.details.serviceInfo.serviceArea);
				this._showNextButton = this.$parse(this.showNextButton || 'true')(true);
				this._showPreviousButton = this.$parse(this.showPreviousButton || 'true')(true);
				this.details = this.details || {};

				this.options = [{
					id: 1,
					title: 'Yes'
				}, {
					id: 2,
					title: 'No'
				}];

				if (!this.details.serviceInfo.costing) {
					this.defaultSelectedCostingOptionId = 1;
					this.details.serviceInfo.costing = 1;
				} else {
					this.defaultSelectedCostingOptionId = this.details.serviceInfo.costing;
				}

				this.costingOptions = [{
					id: 1,
					title: '$'
				}, {
					id: 2,
					title: '$$'
				}, {
					id: 3,
					title: '$$$'
				}];

				this.details.serviceInfo.specialRequirements = (0, _size2.default)(this.details.serviceInfo.specialRequirements) > 0 ? this.details.serviceInfo.specialRequirements : [{
					id: 'wheelchair_access',
					title: 'wheelchair access',
					isSelected: false
				}, {
					id: 'door_to_door',
					title: 'door to door',
					isSelected: false
				}, {
					id: 'door_through_door',
					title: 'door through door',
					isSelected: false
				}, {
					id: 'curb_to_curb',
					title: 'curb to curb',
					isSelected: false
				}];

				this.isCheckedDestinationForServiceAreaOption = [{
					id: 1,
					title: 'Search destination in service area',
					isSelected: this.details.serviceInfo.isCheckedDestinationForServiceArea,
					isDisabled: false
				}];
				this._enableDisabledDestinationCheckOption();

				this.defaultSelectedMedicaidOptionId = this.details.serviceInfo.medicaidSupport ? 1 : 2;
				this.defaultSelectedVeteranOptionId = this.details.serviceInfo.veteranSupport ? 1 : 2;

				this.details.serviceInfo.medicaidSupport = this.defaultSelectedMedicaidOptionId === 1 ? true : false;
				this.details.serviceInfo.veteranSupport = this.defaultSelectedVeteranOptionId === 1 ? true : false;
			}
		}, {
			key: 'onChangeCosting',
			value: function onChangeCosting(_ref) {
				var id = _ref.id;

				this.details.serviceInfo.costing = parseInt(id);
			}

			//category select function for autocomplete

		}, {
			key: 'onSelectItem',
			value: function onSelectItem(value) {
				var index = (0, _findIndex2.default)(this.details.serviceInfo.serviceType, function (_ref2) {
					var id = _ref2.id;
					return id === value.id;
				});
				var deletedServiceTypes = (0, _filter2.default)(this.details.serviceInfo.serviceType, ['status', 2]);
				if ((0, _size2.default)(this.details.serviceInfo.serviceType) === 0 || (0, _size2.default)(deletedServiceTypes) === (0, _size2.default)(this.details.serviceInfo.serviceType)) {
					if (value.name === "Private Transportation") {
						this.defaultSelectedCostingOptionId = 2;
						this.details.serviceInfo.costing = 2;
					} else if (value.name === "Paratransit") {
						this.defaultSelectedCostingOptionId = 3;
						this.details.serviceInfo.costing = 3;
					} else {
						this.defaultSelectedCostingOptionId = 1;
						this.details.serviceInfo.costing = 1;
					}
				}
				if (index === -1) {
					value.status = this.constants.STATUS.ADD;
					this.details.serviceInfo.serviceType.push(value);
				} else {
					this.details.serviceInfo.serviceType[index].status = -1;
				}

				this._enableDisabledDestinationCheckOption();
			}

			//category remove function for autocomplete

		}, {
			key: 'onRemoveTag',
			value: function onRemoveTag(value) {
				var _this = this;

				var index = (0, _findIndex2.default)(this.details.serviceInfo.serviceType, function (_ref3) {
					var name = _ref3.name;
					return name === value;
				});
				if (this.details.serviceInfo.serviceType[index].status !== 0) {
					this.details.serviceInfo.serviceType[index].status = this.constants.STATUS.DELETE;
				}
				var serviceTypeIndex = (0, _findIndex2.default)(this.details.serviceInfo.serviceType, function (_ref4) {
					var name = _ref4.name;
					return name === value;
				});
				this.details.serviceInfo.serviceType = this.details.serviceInfo.serviceType.reduce(function (serviceType, value, index) {
					if (serviceTypeIndex === index) {
						if (_this.details.serviceInfo.serviceType[index].status !== _this.constants.STATUS.ADD) {
							value.status = _this.constants.STATUS.DELETE;
							serviceType.push(value);
						}
					} else {
						serviceType.push(value);
					}
					return serviceType;
				}, []);

				this._enableDisabledDestinationCheckOption();
			}

			//category select function for autocomplete

		}, {
			key: 'onSelectServiceArea',
			value: function onSelectServiceArea(value) {
				var index = (0, _findIndex2.default)(this.details.serviceInfo.serviceArea, function (_ref5) {
					var id = _ref5.id;
					return id === value.id;
				});
				if (index === -1) {
					value.status = this.constants.STATUS.ADD;
					this.details.serviceInfo.serviceArea.push(value);
				} else {
					this.details.serviceInfo.serviceArea[index].status = -1;
				}
			}

			//category remove function for autocomplete

		}, {
			key: 'onRemoveServiceAreaTag',
			value: function onRemoveServiceAreaTag(value) {
				var _this2 = this;

				var serviceAreaIndex = (0, _findIndex2.default)(this.details.serviceInfo.serviceArea, function (_ref6) {
					var name = _ref6.name;
					return name === value;
				});
				this.details.serviceInfo.serviceArea = this.details.serviceInfo.serviceArea.reduce(function (serviceArea, value, index) {
					if (serviceAreaIndex === index) {
						if (_this2.details.serviceInfo.serviceArea[index].status !== _this2.constants.STATUS.ADD) {
							value.status = _this2.constants.STATUS.DELETE;
							serviceArea.push(value);
						}
					} else {
						serviceArea.push(value);
					}
					return serviceArea;
				}, []);
			}
		}, {
			key: 'onChangeMedicaid',
			value: function onChangeMedicaid(_ref7) {
				var id = _ref7.id;

				this.details.serviceInfo.medicaidSupport = id === '1' ? true : false;
			}
		}, {
			key: 'onChangeVeteran',
			value: function onChangeVeteran(_ref8) {
				var id = _ref8.id;

				this.details.serviceInfo.veteranSupport = id === '1' ? true : false;
			}
		}, {
			key: '_enableDisabledDestinationCheckOption',
			value: function _enableDisabledDestinationCheckOption() {
				var _this3 = this;

				var selectedServiceTypes = this.details.serviceInfo.serviceType.filter(function (serviceType) {
					return serviceType.status !== _this3.constants.STATUS.DELETE;
				});
				if ((0, _size2.default)(selectedServiceTypes) === 1 && (0, _head2.default)(selectedServiceTypes).name === "Public Transit") {
					(0, _head2.default)(this.isCheckedDestinationForServiceAreaOption).isSelected = false;
					(0, _head2.default)(this.isCheckedDestinationForServiceAreaOption).isDisabled = true;
				} else {
					(0, _head2.default)(this.isCheckedDestinationForServiceAreaOption).isDisabled = false;
				}
			}
		}, {
			key: '_onCancel',
			value: function _onCancel() {
				this.saveData = angular.copy(this.prevDetails);
				var _details = angular.copy(this.newDetails);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);

				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},

						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}

				function onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}, {
			key: '_onSubmit',
			value: function _onSubmit() {
				this.details.serviceInfo.isCheckedDestinationForServiceArea = (0, _head2.default)(this.isCheckedDestinationForServiceAreaOption).isSelected;
				this.onSubmit({
					$event: {
						serviceInfo: this.details.serviceInfo
					}
				});
			}
		}]);

		return ServiceInfoComponent;
	}()
};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.serviceInfo = undefined;

var _serviceInfo = __webpack_require__(511);

var serviceInfo = exports.serviceInfo = angular.module('common.components.serviceInfo', []).component('serviceInfo', _serviceInfo.serviceInfoComponent).name;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.sidebarComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _sidebar = __webpack_require__(745);

var _sidebar2 = _interopRequireDefault(_sidebar);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var sidebarComponent = exports.sidebarComponent = {
	templateUrl: _sidebar2.default,

	bindings: {
		list: '<',
		isSidebarOpen: '='
	},

	controller: function () {
		SidebarComponent.$inject = ["$state", "$transitions", "BreadcrumbService"];
		function SidebarComponent($state, $transitions, BreadcrumbService) {
			'ngInject';

			_classCallCheck(this, SidebarComponent);

			this.$state = $state;
			this.fetaures = [];
			this.breadcrumbService = BreadcrumbService;
			this.onStateChangeSuccess.call(this);
			$transitions.onSuccess({}, this.onStateChangeSuccess.bind(this));
		}

		_createClass(SidebarComponent, [{
			key: 'onStateChangeSuccess',
			value: function onStateChangeSuccess() {
				this.featureArray = this.getFeatureArray(this.$state.current);
				this.featureName = this.featureArray.length > 0 ? this.featureArray[0] : 'dashboard';
				this.fetaures = [];
			}
		}, {
			key: 'getFeatureArray',
			value: function getFeatureArray(currentName) {
				var state = this.$state.get(currentName);
				if (state && state.name != 'app.dashboard') {
					this.fetaures.unshift(state.breadcrumbName);
					this.getFeatureArray(state.parentState);
				}
				return this.fetaures;
			}
		}, {
			key: 'isMenuActive',
			value: function isMenuActive(name) {
				var breadcrumbs = this.breadcrumbService.breadcrumbs;
				var index = (0, _findIndex2.default)(breadcrumbs, { name: name });

				return index === -1 ? false : true;
			}
		}]);

		return SidebarComponent;
	}()
};

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.sidebar = undefined;

var _sidebar = __webpack_require__(513);

__webpack_require__(177);

var sidebar = exports.sidebar = angular.module('common.components.sidebar', []).component('sidebar', _sidebar.sidebarComponent).name;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subFeatureRepositoryDetailComponent = undefined;

var _subFeatureRepositoryDetail = __webpack_require__(746);

var _subFeatureRepositoryDetail2 = _interopRequireDefault(_subFeatureRepositoryDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var subFeatureRepositoryDetailComponent = exports.subFeatureRepositoryDetailComponent = {
  bindings: {
    details: '<',
    onEdit: '&'
    // onGoBack: '&'
  },
  templateUrl: _subFeatureRepositoryDetail2.default,
  controller: function SubFeatureRepositoryDetailComponent() {
    _classCallCheck(this, SubFeatureRepositoryDetailComponent);
  }
};

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.subFeatureRepositoryDetail = undefined;

var _subFeatureRepositoryDetail = __webpack_require__(515);

var subFeatureRepositoryDetail = exports.subFeatureRepositoryDetail = angular.module('common.components.subFeatureRepository.subFeatureRepositoryDetail', []).component('subFeatureRepositoryDetail', _subFeatureRepositoryDetail.subFeatureRepositoryDetailComponent).name;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
               value: true
});
exports.subFeatureRepositoryEditComponent = undefined;

var _subFeatureRepositoryEdit = __webpack_require__(747);

var _subFeatureRepositoryEdit2 = _interopRequireDefault(_subFeatureRepositoryEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var subFeatureRepositoryEditComponent = exports.subFeatureRepositoryEditComponent = {
               bindings: {
                              details: '<',
                              onSubmit: '&',
                              onCancel: '&',
                              pageTitle: '@',
                              disableButtons: '<'
               },
               templateUrl: _subFeatureRepositoryEdit2.default,
               controller: function subFeatureRepositoryEditComponent() {
                              _classCallCheck(this, subFeatureRepositoryEditComponent);
               }
};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.subFeatureRepositoryEdit = undefined;

var _subFeatureRepositoryEdit = __webpack_require__(517);

var subFeatureRepositoryEdit = exports.subFeatureRepositoryEdit = angular.module('common.components.subFeatureRepository.subFeatureRepositoryEdit', []).component('subFeatureRepositoryEdit', _subFeatureRepositoryEdit.subFeatureRepositoryEditComponent).name;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
       value: true
});
exports.subFeatureRepository = undefined;

var _subFeatureRepositoryDetail = __webpack_require__(516);

var _subFeatureRepositoryEdit = __webpack_require__(518);

__webpack_require__(178);

var subFeatureRepository = exports.subFeatureRepository = angular.module('common.components.subFeatureRepository', [_subFeatureRepositoryDetail.subFeatureRepositoryDetail, _subFeatureRepositoryEdit.subFeatureRepositoryEdit]).name;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tagComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tag = __webpack_require__(748);

var _tag2 = _interopRequireDefault(_tag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var tagComponent = exports.tagComponent = {
    templateUrl: _tag2.default,
    bindings: {
        items: '<',
        onRemove: '&'
    },
    controller: function () {
        function TagComponent() {
            _classCallCheck(this, TagComponent);
        }

        _createClass(TagComponent, [{
            key: 'remove',
            value: function remove(tag) {
                this.items = this.items.filter(function (name) {
                    return name !== tag;
                });
                this.onRemove({
                    $event: {
                        tag: tag
                    }
                });
            }
        }]);

        return TagComponent;
    }()
};

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.tag = undefined;

var _tag = __webpack_require__(520);

__webpack_require__(179);

var tag = exports.tag = angular.module('tag', []).component('tag', _tag.tagComponent).name;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var timeLesserDirective = exports.timeLesserDirective = ["defaultErrorMessageResolver", function timeLesserDirective(defaultErrorMessageResolver) {
    'ngInject';

    defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages) {
        errorMessages['timeLesser'] = 'End time should be greater than start time';
    });

    return {
        require: '^ngModel',
        restrict: 'A',
        scope: {
            timeLesser: '=',
            ngRequired: '='
        },
        link: function link(scope, element, attrs, ngModel) {
            ngModel.$validators.timeLesser = function (value) {
                if (value && scope.ngRequired) {
                    var _time = value;
                    var _timeLesser = scope.timeLesser;
                    if (_time <= _timeLesser) {
                        return false;
                    }
                }
                return true;
            };
            scope.$watch('timeLesser', function (value) {
                if (value) {
                    ngModel.$validate();
                }
            });
        }
    };
}];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timepickerComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _timepicker = __webpack_require__(749);

var _timepicker2 = _interopRequireDefault(_timepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var timepickerComponent = exports.timepickerComponent = {
    bindings: {
        details: '<',
        onTimeChange: '&'
    },
    templateUrl: _timepicker2.default,
    controller: function () {
        function TimepickerComponent() {
            _classCallCheck(this, TimepickerComponent);
        }

        _createClass(TimepickerComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.selectedTime = null;
                if (!this.details) {
                    this.details = {};
                }
                //part for single timepicker isRequired pending
                if (this.details.range) {
                    this.details.range.startTime.title = this.details.range.startTime.title || 'start time';

                    if (this.details.range && this.details.range.endTime) {
                        this.details.range.endTime.title = this.details.range.endTime.title || "end time";
                    }

                    if (!this.details.range.startTime.hasOwnProperty('isRequired')) {
                        this.details.range.startTime.isRequired = true;
                    }

                    if (this.details.range.endTime && !this.details.range.endTime.hasOwnProperty('isRequired')) {
                        this.details.range.endTime.isRequired = true;
                    }

                    this.startTimeOpened = false;
                    this.endTimeOpened = false;
                } else {
                    this.opened = false;
                }
            }
        }, {
            key: 'open',
            value: function open() {
                this.opened = !this.opened;
            }
        }, {
            key: 'openStartTime',
            value: function openStartTime() {
                this.startTimeOpened = !this.startTimeOpened;
            }
        }, {
            key: 'openEndTime',
            value: function openEndTime() {
                this.endTimeOpened = !this.endTimeOpened;
            }
        }, {
            key: '_onTimeChange',
            value: function _onTimeChange() {
                if (this.onTimeChange) {
                    this.onTimeChange();
                }
            }
        }]);

        return TimepickerComponent;
    }()
};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timepicker = undefined;

var _timepicker = __webpack_require__(239);

var _timepicker2 = _interopRequireDefault(_timepicker);

var _timepicker3 = __webpack_require__(523);

var _timeLesser = __webpack_require__(522);

__webpack_require__(180);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timepicker = exports.timepicker = angular.module('common.components.timepicker', [_timepicker2.default]).directive('timeLesser', _timeLesser.timeLesserDirective).component('timepicker', _timepicker3.timepickerComponent).run(["defaultErrorMessageResolver", function (defaultErrorMessageResolver) {
    'ngInject';

    defaultErrorMessageResolver.getErrorMessages().then(function (errorMessages) {
        errorMessages['hours'] = 'invalid hours';
        errorMessages['minutes'] = 'Invalid minutes';
        errorMessages['time'] = 'invalid time';
    });
}]).name;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uploadCoverPicComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uploadCoverPic = __webpack_require__(750);

var _uploadCoverPic2 = _interopRequireDefault(_uploadCoverPic);

var _uploadSquarePic = __webpack_require__(751);

var _uploadSquarePic2 = _interopRequireDefault(_uploadSquarePic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var uploadCoverPicComponent = exports.uploadCoverPicComponent = {
    bindings: {
        pageName: '@',
        onUpload: '&',
        type: '@',
        onRemove: '&',
        defaultCoverPic: '@',
        showSqurePhoto: '@',
        isDisable: '<',
        headingText: '@',
        isCoverPhotoRequired: '@',
        isRatioChange: '@'
    },
    template: '<div ng-include="$ctrl.templateUrl">',
    controller: function () {
        UploadCoverPicComponent.$inject = ["$timeout", "$parse", "ImageCropService", "ImageUploadService", "ApiService", "toastr", "$scope"];
        function UploadCoverPicComponent($timeout, $parse, ImageCropService, ImageUploadService, ApiService, toastr, $scope) {
            'ngInject';

            _classCallCheck(this, UploadCoverPicComponent);

            this.$timeout = $timeout;
            this.$parse = $parse;
            this.imageCropService = ImageCropService;
            this.imageUploadService = ImageUploadService;
            this.apiService = ApiService;
            this.toastr = toastr;
            this.$scope = $scope;
        }

        _createClass(UploadCoverPicComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this._isCoverPhotoRequired = this.$parse(this.isCoverPhotoRequired || 'false')(false);
                this._showSqurePhoto = this.$parse(this.showSqurePhoto || 'false')(false);
                this._isRatioChange = this.$parse(this.isRatioChange || 'false')(false);
                this.title = this.pageName;
                if (this.defaultCoverPic) {
                    this._isCoverPhotoRequired = false;
                }
                this.imageSrc = this.defaultCoverPic ? this.apiService.getImageUrl(this.defaultCoverPic) : this._getDefaultPath();
                this.selectedImage = '';
                this.removeClass = this.type === 'banner' ? 'remove-button-margin' : '';
                this.templateUrl = this._showSqurePhoto ? _uploadSquarePic2.default : _uploadCoverPic2.default;
                this.type = this.type ? this.type : this._showSqurePhoto ? "profile" : "cover";
                if (this.headingText) {
                    this.title = this.headingText;
                }
            }
        }, {
            key: '_getDefaultPath',
            value: function _getDefaultPath() {
                if (this.type === "staffProfile") {
                    return '/./images/Staff_default.jpg';
                }

                if (this._showSqurePhoto) {
                    return '/./images/placeholder.png';
                }

                return '/./images/cover-pic.jpg';
            }
        }, {
            key: 'onFileChange',
            value: function onFileChange() {
                var pattern = /^image/g;
                var isImage = pattern.test(this.selectedImage.type);
                if (this.selectedImage && isImage) {
                    this.type === 'profile' || this.type === 'siteLogo' ? _upload.call(this, this.selectedImage) : _cropImage.call(this);
                } else {
                    this.toastr.error("Invalid image file");
                }

                function _cropImage() {
                    this.imageCropService.cropImage({
                        image: this.selectedImage,
                        onCrop: _upload.bind(this),
                        onCancel: _onCancel.bind(this),
                        type: this.type
                    });
                }

                function _onCancel() {
                    if (this.defaultCoverPic === "") {
                        this.selectedImage = "";
                    }
                }

                function _upload(image) {
                    var _this = this;

                    this.imageUploadService.upload({
                        image: image,
                        name: this.selectedImage.name,
                        container: this.pageName
                    }).then(function (details) {
                        var _details = details.data.data;
                        _this.imageSrc = _this.apiService.getImageUrl(_details.uuid);
                        _this.fileName = _this.selectedImage.name;
                        _this.onUpload({
                            $event: {
                                details: _details
                            }
                        });
                        _this._isCoverPhotoRequired = false;
                    }).catch(function (err) {
                        _this.toastr.error("Image upload failed");
                    });
                }
            }
        }, {
            key: '_onRemove',
            value: function _onRemove() {
                this.fileName = '';
                this.selectedImage = '';
                this.defaultCoverPic = '';
                this.hideRemove = true;
                this.imageSrc = this._showSqurePhoto ? '/./images/placeholder.png' : '/./images/cover-pic.jpg';
                this._isCoverPhotoRequired = this.$parse(this.isCoverPhotoRequired || 'false')(false);
                this.onRemove();
            }
        }, {
            key: '$onChanges',
            value: function $onChanges(changes) {
                if (changes.defaultCoverPic) {
                    this.imageSrc = this.apiService.getImageUrl(changes.defaultCoverPic.currentValue);
                }
            }
        }]);

        return UploadCoverPicComponent;
    }()
};

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uploadCoverPic = undefined;

var _uploadCoverPic = __webpack_require__(525);

var _ngFileUpload = __webpack_require__(79);

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

__webpack_require__(181);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uploadCoverPic = exports.uploadCoverPic = angular.module('common.components.uploadCoverPic', [_ngFileUpload2.default]).component('uploadCoverPic', _uploadCoverPic.uploadCoverPicComponent).name;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.api = undefined;

var _api = __webpack_require__(528);

var api = exports.api = angular.module('common.libs.api', []).service('ApiService', _api.ApiService).name;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ApiService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isArray = __webpack_require__(4);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApiService = exports.ApiService = function () {
	ApiService.$inject = ["API_ENDPOINT", "$cookies", "$http"];
	function ApiService(API_ENDPOINT, $cookies, $http) {
		'ngInject';

		_classCallCheck(this, ApiService);

		this.$http = $http;
		this.$http.defaults.cache = false;
		this.$cookies = $cookies;
		this.API_ENDPOINT = API_ENDPOINT;
		this.setDefaultHeaders();
	}

	_createClass(ApiService, [{
		key: 'setDefaultHeaders',
		value: function setDefaultHeaders(headerVal) {
			this.$http.defaults.headers.common['Authorization'] = headerVal;
		}
	}, {
		key: 'removeDefaultHeaders',
		value: function removeDefaultHeaders() {
			this.$http.defaults.headers.common['Authorization'] = undefined;
		}
	}, {
		key: 'getResourceUrl',
		value: function getResourceUrl(path) {
			return this.API_ENDPOINT + path;
		}
	}, {
		key: 'getImageUrl',
		value: function getImageUrl(path) {
			return this.API_ENDPOINT + 'files/images/' + path;
		}
	}, {
		key: 'getErrorMessage',
		value: function getErrorMessage(details) {
			//return "Something went wrong";
			if (details.status === 500) {
				return "Something went wrong";
			} else {
				if ((0, _isArray2.default)(details.data.message)) {
					return details.data.message[0];
				} else {
					return details.data.message;
				}
			}
		}
	}]);

	return ApiService;
}();

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.compareObject = undefined;

var _compareObject = __webpack_require__(530);

var compareObject = exports.compareObject = angular.module('common.libs.compareObject', []).service('CompareObjectService', _compareObject.CompareObjectService).name;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CompareObjectService = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isEqual = __webpack_require__(380);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _forEach = __webpack_require__(111);

var _forEach2 = _interopRequireDefault(_forEach);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompareObjectService = exports.CompareObjectService = function () {
    /*
    * @method constructor - Setup base values used
    */
    function CompareObjectService() {
        _classCallCheck(this, CompareObjectService);

        this.updateValue = 1;
    }

    /*
    * @method setUpdateValue - sets the value to be assignes to status to signify update
    */


    _createClass(CompareObjectService, [{
        key: 'setUpdateValue',
        value: function setUpdateValue(value) {
            this.updateValue = value;
        }

        /*
        * @method shallowCompareHasChanged
        * @param obj1 original array
        * @param obj2 working copy/ modified array
        * @param isUpdate optional To add status attribute and set it to 1
        */

    }, {
        key: 'shallowCompareHasChanged',
        value: function shallowCompareHasChanged(obj1, obj2) {
            if ((0, _isEqual2.default)(obj1, obj2)) {
                return false;
            } else {
                return true;
            }
        }

        /**
        * @method checkTypeOfArray - Checks whether the object is type of Array 
        * @param value
        * @returns boolean
        **/

    }, {
        key: 'checkTypeOfArray',
        value: function checkTypeOfArray(value) {
            return Object.prototype.toString.call(value) == '[object Array]';
        }

        /**
        * @method checkTypeOfArray
        * @param value
        * @returns boolean
        **/

    }, {
        key: 'checkTypeOfObject',
        value: function checkTypeOfObject(value) {
            return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
        }

        /*
        * @method deepCompareArrayHasChanged
        * @param obj1 original array
        * @param obj2 working copy/ modified array
        * @param isUpdate optional To add status attribute and set it to 1
        * @returns boolean/array
        */

    }, {
        key: 'deepCompareArrayHasChanged',
        value: function deepCompareArrayHasChanged(obj1, obj2, isUpdate) {
            var _this = this;

            var changes,
                i,
                item,
                checkTypeOfObject = this.checkTypeOfObject;
            if ((0, _isEqual2.default)(obj1, obj2)) {
                return false;
            };
            changes = [];
            i = 0;
            (0, _forEach2.default)(obj2, function (value) {
                //            console.log("In deepCompareArray \t"+JSON.stringify(obj1[i])+"\n"+JSON.stringify(value)+"\n");
                if (obj1[i] && !(0, _isEqual2.default)(value, obj1[i])) {

                    if (isUpdate && checkTypeOfObject(value)) {
                        //                  console.log("In deepCompareArray \t"+JSON.stringify(obj1[i])+"\n"+JSON.stringify(value)+"\n");
                        _this.deepCompareObjectHasChanged(obj1[i], value, isUpdate);
                        if (value.status == -1) {
                            value.status = _this.updateValue;
                        }
                    }
                    changes.push(item);
                }
                i++;
            });
            if (!isUpdate) {
                return changes;
            } else {
                return true;
            }
        }

        /*
        * @method shallowCompareObjectHasChanged
        * @param obj1 original obj
        * @param obj2 working copy/ modified obj
        * @param isUpdate optional To add status attribute and set it to 1
        */

    }, {
        key: 'shallowCompareObjectHasChanged',
        value: function shallowCompareObjectHasChanged(obj1, obj2, isUpdate) {
            if ((0, _isEqual2.default)(obj1, obj2)) {
                if (isUpdate) {
                    obj2.status = -1;
                };
                return false;
            }

            if (!isUpdate) {
                return changes;
            } else {
                obj2.status = this.updateValue;
                return true;
            }
        }

        /*
        * @method deepCompareObjectHasChanged
        * @param obj1 original obj
        * @param obj2 working copy/ modified obj
        * @param isUpdate optional To add status attribute and set it to 1
        */

    }, {
        key: 'deepCompareObjectHasChanged',
        value: function deepCompareObjectHasChanged(obj1, obj2, isUpdate) {
            var _this2 = this;

            var changes;
            //        console.log(this.updateValue);
            if ((0, _isEqual2.default)(obj1, obj2)) {
                if (isUpdate) {
                    obj2.status = -1;
                };
                return false;
            }
            changes = [];
            (0, _forEach2.default)(obj2, function (value, key) {
                var obj = {};
                if (value && _this2.checkTypeOfArray(value)) {
                    if (isUpdate) {
                        _this2.deepCompareArrayHasChanged(obj1[key], obj2[key], isUpdate);
                        //                    console.log(JSON.stringify(obj1[key])+ "\n" + JSON.stringify(obj2[key]));
                    } else {
                        changes.concat(_this2.deepCompareArrayHasChanged(obj1[key], obj2[key]));
                    }
                } else if (value && _this2.checkTypeOfObject(value)) {
                    if (isUpdate) {
                        _this2.deepCompareObjectHasChanged(obj1[key], obj2[key], isUpdate);
                    } else {
                        changes.concat(_this2.deepCompareObjectHasChanged(obj1[key], obj2[key]));
                    }
                }
                if (!isUpdate && !(0, _isEqual2.default)(value, obj1[key])) {
                    obj[key] = value;
                    changes.push(obj);
                }
            });
            if (isUpdate) {
                if (obj2.status == -1) {
                    obj2.status = this.updateValue;
                }
                return true;
            } else {
                return changes;
            }
        }
    }]);

    return CompareObjectService;
}();

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.date = undefined;

var _date = __webpack_require__(532);

var date = exports.date = angular.module('common.libs.date', []).service('DateService', _date.DateService).name;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateService = exports.DateService = function () {
    function DateService() {
        _classCallCheck(this, DateService);
    }

    _createClass(DateService, [{
        key: "parseDateFromServerDate",
        value: function parseDateFromServerDate(date) {
            if (date) {
                var utcdate = new Date(date);
                var timeOffset = utcdate.getTimezoneOffset() * 60 * 1000;
                var time = utcdate.getTime() + timeOffset;
                utcdate = new Date(time);
                return utcdate;
            }
            return null;
        }
    }, {
        key: "parseDateToServerDate",
        value: function parseDateToServerDate(dateObj) {
            var hour = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
            var minute = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
            var seconds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

            return new Date(Date.UTC(dateObj.values.year, dateObj.values.month, dateObj.values.day, hour, minute, seconds)).toISOString();
        }
    }, {
        key: "convertDateToLocal",
        value: function convertDateToLocal(date) {
            if (date) {
                return new Date(date);
            }
            return null;
        }
    }, {
        key: "convertDate",
        value: function convertDate(date) {
            if (date) {
                return new Date(date).toISOString();
            }
            return null;
        }

        //To get current date or parse the given string to date

    }, {
        key: "getDate",
        value: function getDate() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

            var dateObj = {};
            if (typeof date === 'string') {
                dateObj.date = new Date(date);
                dateObj.values = this.getDateDetailsObject(dateObj.date);
                return dateObj;
            }
            dateObj.date = date ? new Date(date) : NaN;
            dateObj.values = this.getDateDetailsObject(dateObj.date);
            return dateObj;
        }

        //resetTime

    }, {
        key: "resetTime",
        value: function resetTime() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var _dateObj = this.getDate(date);
            var _hour = reset ? 0 : _dateObj.values.hour;
            var _minute = reset ? 0 : _dateObj.values.minute;

            return this.parseDateToServerDate(_dateObj, _hour, _minute);
        }
    }, {
        key: "resetDateTimeWithOtherTime",
        value: function resetDateTimeWithOtherTime() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
            var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var _dateObj = this.getDate(date);
            var _timeObj = this.getDate(time);
            var _hour = reset ? 0 : _timeObj.values.hour;
            var _minute = reset ? 0 : _timeObj.values.minute;

            return this.parseDateToServerDate(_dateObj, _hour, _minute);
        }

        //get day, month and fullyear from given date

    }, {
        key: "getDateDetailsObject",
        value: function getDateDetailsObject(date) {
            return {
                day: date ? date.getDate() : NaN,
                month: date ? date.getMonth() : NaN,
                year: date ? date.getFullYear() : NaN,
                hour: date ? date.getHours() : NaN,
                minute: date ? date.getMinutes() : NaN,
                sec: date ? date.getSeconds() : NaN,
                msec: date ? date.getMilliseconds() : NaN,
                dayId: date ? date.getDay() : NaN
            };
        }

        //To get difference between two dates

    }, {
        key: "getDateDifference",
        value: function getDateDifference() {
            var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

            startDate = new Date(new Date(this.getDate(startDate).date).setHours(0, 0, 0, 0));
            endDate = new Date(new Date(this.getDate(endDate).date).setHours(0, 0, 0, 0));

            var timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
            return diffDays;
        }

        //add days and return new Date

    }, {
        key: "addDays",
        value: function addDays() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var additionalDays = arguments[1];

            date = this.getDate(date).date;
            return new Date(date.setDate(date.getDate() + additionalDays));
        }

        //check given date is same or old

    }, {
        key: "isSameOrBefore",
        value: function isSameOrBefore() {
            var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

            startDate = this.getDate(startDate).date;
            endDate = this.getDate(endDate).date;

            return endDate <= startDate;
        }

        //check given dates are same or not

    }, {
        key: "isSame",
        value: function isSame() {
            var startDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var endDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

            startDate = new Date(startDate);
            endDate = new Date(endDate);

            return startDate.getTime() === endDate.getTime();
        }

        //change the year

    }, {
        key: "changeYear",
        value: function changeYear() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var newYear = arguments[1];

            date = this.getDate(date).date;
            return new Date(date.setFullYear(newYear));
        }

        //change the month

    }, {
        key: "changeMonth",
        value: function changeMonth() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var newMonth = arguments[1];

            date = this.getDate(date).date;
            return new Date(date.setMonth(newMonth));
        }

        //change the date

    }, {
        key: "changeDate",
        value: function changeDate() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var newDate = arguments[1];

            date = this.getDate(date).date;
            return new Date(date.setDate(newDate));
        }

        //change Hours

    }, {
        key: "changeHours",
        value: function changeHours() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var newHours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            date = this.getDate(date).date;
            return new Date(date.setHours(newHours));
        }

        //change Minutes

    }, {
        key: "changeMinutes",
        value: function changeMinutes() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
            var newMinutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

            date = this.getDate(date).date;
            return new Date(date.setMinutes(newMinutes));
        }

        //get all sundays of the month

    }, {
        key: "getAllSundays",
        value: function getAllSundays() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

            var d = new Date(date);
            var getTot = daysInMonth(d.getMonth(), d.getFullYear()); //Get total days in a month
            var sun = new Array(); //Declaring array for inserting Sundays

            for (var i = 1; i <= getTot; i++) {
                //looping through days in month
                var newDate = new Date(d.getFullYear(), d.getMonth(), i);
                if (newDate.getDay() == 0) {
                    //if Sunday
                    sun.push(newDate);
                }
            }
            function daysInMonth(month, year) {
                return new Date(year, month + 1, 0).getDate();
            }
            return sun;
        }

        //find All Sundays by given month and year

    }, {
        key: "getAllSundaysByMonth",
        value: function getAllSundaysByMonth(month, year) {
            var d = month + "/1/" + year;
            var date = new Date(d);
            return this.getAllSundays(date);
        }

        //get start Date Of Week

    }, {
        key: "getStartDateOfWeek",
        value: function getStartDateOfWeek() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

            date = this.getDate(date);
            var currentSundays = this.getAllSundaysByMonth(date.values.month + 1, date.values.year);
            if (currentSundays[0].getDate() === 1) {
                return this.getDate(currentSundays[0]);
            } else {
                var month = date.values.month === 0 ? 12 : date.values.month;
                var year = date.values.month === 0 ? date.values.year - 1 : date.values.year;
                var previousSundays = this.getAllSundaysByMonth(month, year);
                return this.getDate(previousSundays[previousSundays.length - 1]);
            }
        }

        //get next sunday

    }, {
        key: "getNextSunday",
        value: function getNextSunday() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();

            date = this.getDate(date);
            var nextSunday = new Date(date.date.getFullYear(), date.date.getMonth(), date.date.getDate() + (7 - date.date.getDay()));
            return this.getDate(nextSunday);
        }

        //get first day of the given month

    }, {
        key: "getFirstDayOfMonth",
        value: function getFirstDayOfMonth(month, year) {
            var d = month + "/01/" + year;
            var date = new Date(d);
            return this.getDate(date);
        }
    }]);

    return DateService;
}();

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.imageCrop = undefined;

__webpack_require__(396);

__webpack_require__(147);

var _imageCrop = __webpack_require__(534);

// this is done to resolve ColorThief not error in ui-cropper.js
// this is due to ui-cropper not compatible with webpack
__webpack_require__(201);
var imageCrop = exports.imageCrop = angular.module('imageCrop', ['uiCropper']).service('ImageCropService', _imageCrop.ImageCropService).name;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ImageCropService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _imageCrop = __webpack_require__(752);

var _imageCrop2 = _interopRequireDefault(_imageCrop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageCropService = exports.ImageCropService = function () {
    ImageCropService.$inject = ["ModalService"];
    function ImageCropService(ModalService) {
        'ngInject';

        _classCallCheck(this, ImageCropService);

        this.modalService = ModalService;
    }

    _createClass(ImageCropService, [{
        key: 'typeConfig',
        value: function typeConfig(type) {
            if (type === "cover") {
                return {
                    areaType: 'rectangle',
                    aspectRatio: 1.7,
                    resultImageSize: { w: 340, h: 200 }
                };
            } else if (type === "profile") {
                return {
                    areaType: 'square',
                    aspectRatio: 1,
                    resultImageSize: { w: 200, h: 200 }
                };
            } else if (type === "banner") {
                return {
                    areaType: 'rectangle',
                    aspectRatio: 2.52,
                    resultImageSize: { w: 1920, h: 760 }
                };
            } else if (type === "staffProfile") {
                return {
                    areaType: 'rectangle',
                    aspectRatio: 0.75,
                    resultImageSize: { w: 200, h: 266 }
                };
            }
        }
    }, {
        key: 'cropImage',
        value: function cropImage(details) {
            var modalInstane = this.modalService.open({
                details: {
                    image: details.image,
                    config: this.typeConfig(details.type),
                    onCancel: function onCancel() {
                        modalInstane.close();
                        if (details.onCancel) {
                            details.onCancel();
                        }
                    },
                    onCrop: function onCrop(image) {
                        if (details.onCrop) {
                            modalInstane.close();
                            details.onCrop(image);
                        }
                    }
                },
                backdrop: 'static',
                keyboard: true,
                templateUrl: _imageCrop2.default
            });
        }
    }]);

    return ImageCropService;
}();

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.imageUpload = undefined;

var _ngFileUpload = __webpack_require__(79);

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

var _imageUpload = __webpack_require__(536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var imageUpload = exports.imageUpload = angular.module('imageUpload', [_ngFileUpload2.default]).service('ImageUploadService', _imageUpload.ImageUploadService).name;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageUploadService = exports.ImageUploadService = function () {
    ImageUploadService.$inject = ["ApiService", "Upload"];
    function ImageUploadService(ApiService, Upload) {
        'ngInject';

        _classCallCheck(this, ImageUploadService);

        this.apiService = ApiService;
        this._upload = Upload;
    }

    _createClass(ImageUploadService, [{
        key: 'upload',
        value: function upload(details) {
            var resourceUrl = this.apiService.getResourceUrl('upload-image');
            return this._upload.upload({
                url: resourceUrl,
                data: {
                    container: details.container,
                    fileObj: details.image instanceof File ? details.image : this._upload.dataUrltoBlob(details.image, details.name)
                }
            });
        }
    }]);

    return ImageUploadService;
}();

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.libs = undefined;

var _api = __webpack_require__(527);

var _imageCrop = __webpack_require__(533);

var _imageUpload = __webpack_require__(535);

var _compareObject = __webpack_require__(529);

var _date = __webpack_require__(531);

var _slug = __webpack_require__(538);

var libs = exports.libs = angular.module('common.libs', [_api.api, _imageCrop.imageCrop, _imageUpload.imageUpload, _compareObject.compareObject, _date.date, _slug.slug]).name;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.slug = undefined;

var _slug = __webpack_require__(539);

var slug = exports.slug = angular.module('common.libs.slug', []).service('SlugService', _slug.SlugService).name;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SlugService = exports.SlugService = function () {
    function SlugService() {
        _classCallCheck(this, SlugService);
    }

    _createClass(SlugService, [{
        key: 'getSequencePageURL',
        value: function getSequencePageURL(slug) {
            return slug + '/sequence';
        }
    }, {
        key: 'getPublishPageURL',
        value: function getPublishPageURL(slug) {
            return slug + '/publish';
        }
    }, {
        key: 'getDetailsPageURL',
        value: function getDetailsPageURL(slug) {
            return slug + '/details';
        }
    }, {
        key: 'getEditPageURL',
        value: function getEditPageURL(slug) {
            return slug + '/edit';
        }
    }, {
        key: 'getAddPageURL',
        value: function getAddPageURL(slug) {
            return slug + '/add';
        }
    }, {
        key: 'getOverviewPageUrl',
        value: function getOverviewPageUrl(slug) {
            return slug + '/overview';
        }
    }, {
        key: 'removeResourceActionsFromSlugURL',
        value: function removeResourceActionsFromSlugURL(slug, action) {
            return slug.replace('/' + action, '');
        }
    }, {
        key: 'getContentDetailsURL',
        value: function getContentDetailsURL(slug, id) {
            return slug + '/' + id + '/details';
        }
    }]);

    return SlugService;
}();

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.aboutUs = undefined;

var _ourStaff = __webpack_require__(563);

var _inTheNews = __webpack_require__(552);

var _aboutUs = __webpack_require__(541);

__webpack_require__(187);

var aboutUs = exports.aboutUs = angular.module('components.aboutUs', [_ourStaff.ourStaff, _inTheNews.inTheNews]).service('AboutUsService', _aboutUs.AboutUsService).name;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.AboutUsService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

var _angularUiRouter = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AboutUsService = exports.AboutUsService = function () {
	AboutUsService.$inject = ["$resource", "ApiService", "Upload", "DateService"];
	function AboutUsService($resource, ApiService, Upload, DateService) {
		'ngInject';

		_classCallCheck(this, AboutUsService);

		this.$resource = $resource;
		this.apiService = ApiService;
		this._upload = Upload;
		this.dateService = DateService;

		this.aboutUsListResourceUrl = this.apiService.getResourceUrl('cms/menus/AboutUs');
		this.aboutUsSequenceResourceUrl = this.apiService.getResourceUrl('cms/menus/AboutUs/sequence');
		this.aboutUsOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/AboutUs');
		this.aboutUsPublishPageResourceUrl = this.apiService.getResourceUrl('cms/menus/AboutUs/publish');

		this.ourStaffMainResourceUrl = this.apiService.getResourceUrl('cms/menus/OurStaff');
		this.ourStaffSequenceResourceUrl = this.apiService.getResourceUrl('cms/staff/sequence');
		this.ourStaffResourceUrl = this.apiService.getResourceUrl('cms/staff/:content_id');
		this.ourStaffContactResourceUrl = this.apiService.getResourceUrl('cms/contact-us');
		this.advisoryCommitteeResourceUrl = this.apiService.getResourceUrl('cms/menus/AdvisoryCommittee');
		this.missionAndHistoryResourceUrl = this.apiService.getResourceUrl('cms/menus/MissionHistory');
		this.missionAndHistoryEditResourceUrl = this.apiService.getResourceUrl('cms/mission-history/:content_id');
		this.partnersAndStakeholdersResourceUrl = this.apiService.getResourceUrl('cms/menus/PartnersStakeholders');
		this.partnersAndStakeholdersEditResourceUrl = this.apiService.getResourceUrl('cms/partners-stakeholders/:content_id');
		this.ruralHealthNetworkResourceUrl = this.apiService.getResourceUrl('cms/menus/RuralHealthNetwork');
		this.ruralHealthNetworkEditResourceUrl = this.apiService.getResourceUrl('cms/rural-health-network/:content_id');
		this.advisoryCommitteeEditResourceUrl = this.apiService.getResourceUrl('cms/advisory-committee/:content_id');
		this.inTheNewsListResourceUrl = this.apiService.getResourceUrl('cms/menus/InTheNews');
		this.inTheNewsAddResourceUrl = this.apiService.getResourceUrl('cms/in-the-news');
		this.inTheNewsGetEditDeleteByIdResourceUrl = this.apiService.getResourceUrl('cms/in-the-news/:content_id');
		this.inTheNewsPublishUnpublishResourceUrl = this.apiService.getResourceUrl('cms/in-the-news/publish');
		// this.inTheNewsFilterResourceUrl = this.apiService.getResourceUrl('cms/menus/InTheNews/filter');

		this.ourStaffOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/OurStaff');
		this.inTheNewsOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/InTheNews');

		this.inTheNewsOverviewResource = this.$resource(this.inTheNewsOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.aboutUsListResource = this.$resource(this.aboutUsListResourceUrl);
		this.ourStaffMainResource = this.$resource(this.ourStaffMainResourceUrl);
		this.missionAndHistoryResource = this.$resource(this.missionAndHistoryResourceUrl);
		this.partnersAndStakeholdersResource = this.$resource(this.partnersAndStakeholdersResourceUrl);
		this.ruralHealthNetworkResource = this.$resource(this.ruralHealthNetworkResourceUrl);
		this.inTheNewsListResource = this.$resource(this.inTheNewsListResourceUrl);
		// this.inTheNewsFilterResource = this.$resource(this.inTheNewsFilterResourceUrl);

		this.advisoryCommitteeEditResource = this.$resource(this.advisoryCommitteeEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.aboutUsSequenceResource = this.$resource(this.aboutUsSequenceResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.aboutUsOverviewResource = this.$resource(this.aboutUsOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.ourStaffOverviewResource = this.$resource(this.ourStaffOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.ourStaffSequenceResource = this.$resource(this.ourStaffSequenceResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.aboutUsPublishPageResource = this.$resource(this.aboutUsPublishPageResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.ourStaffResource = this.$resource(this.ourStaffResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.ourStaffContactResource = this.$resource(this.ourStaffContactResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.advisoryCommitteeResource = this.$resource(this.advisoryCommitteeResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.missionAndHistoryEditResource = this.$resource(this.missionAndHistoryEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.partnersAndStakeholdersEditResource = this.$resource(this.partnersAndStakeholdersEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.ruralHealthNetworkEditResource = this.$resource(this.ruralHealthNetworkEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.inTheNewsAddResource = this.$resource(this.inTheNewsAddResourceUrl, null, {
			save: {
				method: 'POST'
			}
		});

		this.inTheNewsGetEditDeleteByIdResource = this.$resource(this.inTheNewsGetEditDeleteByIdResourceUrl, null, {
			get: {
				method: 'GET',
				params: {
					content_id: '@content_id'
				}
			},
			update: {
				method: 'PUT',
				params: {
					content_id: '@content_id'
				}
			},
			delete: {
				method: 'DELETE',
				params: {
					content_id: '@content_id'
				}
			}
		});

		this.inTheNewsPublishUnpublishResource = this.$resource(this.inTheNewsPublishUnpublishResourceUrl, null, {
			update: {
				method: 'POST'
			}
		});
	}

	/**
  * function for get overview
  * @return {object} 
  */


	_createClass(AboutUsService, [{
		key: '_getOverviewDetails',
		value: function _getOverviewDetails(details) {
			return {
				id: details.content_id,
				displayName: details.display_name,
				title: details.title,
				description: details.description,
				overview: details.overview,
				image: details.image,
				name: details.name
			};
		}

		/**
   * function for set overview
   * @return {object} 
   */

	}, {
		key: '_setOverviewObject',
		value: function _setOverviewObject(details) {
			return {
				title: details.title,
				description: details.description,
				overview: details.overview,
				image: details.image
			};
		}

		/**
   * function for get list
   * @return {array} 
   */

	}, {
		key: '_getContentDetailsMain',
		value: function _getContentDetailsMain(content) {
			return content.map(function (_ref) {
				var title = _ref.title,
				    description = _ref.description,
				    name = _ref.name;
				return { title: title, description: description, name: name };
			});
		}

		/**
   * function for get sequence list
   * @return {array} 
   */

	}, {
		key: '_getContentSequence',
		value: function _getContentSequence(value) {
			return value.map(function (content) {
				return {
					id: content.menu_id || content.content_id,
					sortOrder: content.sort_order,
					title: content.title || content.name
				};
			});
		}

		/**
   * function for set sequence staff
   * @return {array} 
   */

	}, {
		key: '_setContentSequenceStaff',
		value: function _setContentSequenceStaff(value) {
			return value.map(function (content) {
				return {
					content_id: content.id,
					sort_order: content.sortOrder
				};
			});
		}
	}, {
		key: '_getContentSequenceStaff',
		value: function _getContentSequenceStaff(value) {
			return value.map(function (content) {
				return {
					id: content.content_id,
					sortOrder: content.sort_order,
					title: content.name
				};
			});
		}

		/**
   * function for set sequence list
   * @return {array} 
   */

	}, {
		key: '_setContentSequence',
		value: function _setContentSequence(value) {
			return value.map(function (content) {
				return {
					menu_id: content.id,
					sort_order: content.sortOrder
					// title: content.title
				};
			});
		}

		//get publish status object for display

	}, {
		key: '_getPublishPageListObject',
		value: function _getPublishPageListObject(values) {
			return values.map(function (value) {
				return {
					id: value.menu_id,
					isActive: value.is_active,
					title: value.title
				};
			});
		}

		//set publish status object for update

	}, {
		key: '_setPublishPageListObject',
		value: function _setPublishPageListObject(values) {
			return values.map(function (value) {
				return {
					menu_id: value.id,
					is_active: value.isActive
				};
			});
		}
	}, {
		key: '_getStaffDetails',
		value: function _getStaffDetails(list) {
			return list.values.map(function (value) {
				return {
					lastName: value.last_name,
					firstName: value.first_name,
					designation: value.designation,
					id: value.content_id,
					image: value.image || "",
					slug: value.slug || ""
				};
			});
		}
	}, {
		key: '_setStaffDetails',
		value: function _setStaffDetails(value) {
			return {
				first_name: value.firstName,
				last_name: value.lastName,
				designation: value.designation,
				image: value.image
			};
		}
	}, {
		key: '_getContentDetails',
		value: function _getContentDetails(value) {
			return {
				id: value.content_id,
				description: value.description,
				images: this._getContentImagesObject(value.images) || [],
				videos: value.videos || []
			};
		}
	}, {
		key: '_getContentImagesObject',
		value: function _getContentImagesObject(values) {
			return values ? values.map(function (_ref2) {
				var uuid = _ref2.uuid;
				return { uuid: uuid, status: -1 };
			}) : [];
		}
	}, {
		key: '_setContentDetails',
		value: function _setContentDetails(value) {
			return {
				description: value.description,
				images: value.images || [],
				videos: value.videos || []
			};
		}
	}, {
		key: '_getNewsObject',
		value: function _getNewsObject(value) {
			return {
				id: value.content_id,
				title: value.title,
				description: value.description,
				images: this._getContentImagesObject(value.images) || [],
				videos: value.videos || [],
				publishAt: value.publish_at,
				firstName: value.first_name,
				lastName: value.last_name,
				newsDate: this.dateService.parseDateFromServerDate(value.news_date),
				slug: value.slug || ''
			};
		}
	}, {
		key: '_setNewsObject',
		value: function _setNewsObject(value) {
			return {
				title: value.title,
				description: value.description,
				images: value.images || [],
				videos: value.videos || [],
				news_date: this.dateService.parseDateToServerDate(value.newsDate, new Date().getHours(), new Date().getMinutes(), new Date().getSeconds()),
				is_active: value.isActive
			};
		}
	}, {
		key: '_getInTheNewsDetails',
		value: function _getInTheNewsDetails(list) {
			var _this = this;

			return list.values.map(function (value) {
				return _this._getNewsObject(value);
			});
		}
	}, {
		key: '_getYearDetails',
		value: function _getYearDetails(list) {
			return list.values.map(function (value) {
				return {
					id: value,
					name: value
				};
			});
		}
	}, {
		key: '_getStaffDetailsObject',
		value: function _getStaffDetailsObject(_ref3) {
			var content_id = _ref3.content_id,
			    first_name = _ref3.first_name,
			    last_name = _ref3.last_name,
			    designation = _ref3.designation,
			    _ref3$image = _ref3.image,
			    image = _ref3$image === undefined ? "" : _ref3$image;

			return {
				id: content_id,
				firstName: first_name,
				lastName: last_name,
				designation: designation,
				image: image
			};
		}
	}, {
		key: 'getOurStaffDetails',
		value: function getOurStaffDetails(details) {
			return {
				overview: this._getOverviewDetails(details.data.menuOverviewDetails),
				ourStaffList: this._getStaffDetails((0, _find2.default)(details.data.content, ['name', 'OurStaff']))
			};
		}

		/**
   * function to get our staff overview
   * @return {object} [information related to our staff overview]
   */

	}, {
		key: 'getOurStaffOverview',
		value: function getOurStaffOverview() {
			var _this2 = this;

			var promise = this.ourStaffOverviewResource.get().$promise;

			return promise.then(function (details) {
				return _this2._getOverviewDetails(details.data);
			}).catch(function (error) {
				throw _this2.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to edit our staff overview
   * @return {object} [information related to our staff overview]
   */

	}, {
		key: 'setOurStaffOverview',
		value: function setOurStaffOverview(details) {
			var _this3 = this;

			var promise = this.ourStaffOverviewResource.update(this._setOverviewObject(details)).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this3.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getOurStaffSequence',
		value: function getOurStaffSequence(_ref4) {
			var values = _ref4.data.content.values;

			return this._getContentSequence(values);
		}

		/**
   * function to edit about us sequence
   * @return {object} [information related to about us sequence for edit]
   */

	}, {
		key: 'setOurStaffSequence',
		value: function setOurStaffSequence(sequenceObj) {
			var promise = this.ourStaffSequenceResource.update(this._setContentSequenceStaff(sequenceObj)).$promise;

			return promise.then(function (response) {
				return response;
			});
		}
	}, {
		key: 'getInTheNewsDetails',
		value: function getInTheNewsDetails(details) {
			return {
				overview: this._getOverviewDetails(details.data.menuOverviewDetails),
				list: this._getInTheNewsDetails((0, _find2.default)(details.data.content, ['name', 'InTheNews'])),
				year: this._getYearDetails((0, _find2.default)(details.data.content, ['name', 'year'])),
				count: details.data.count
			};
		}
	}, {
		key: 'getInTheNewsOverview',
		value: function getInTheNewsOverview() {
			var _this4 = this;

			var promise = this.inTheNewsOverviewResource.get().$promise;

			return promise.then(function (details) {
				return _this4._getOverviewDetails(details.data);
			}).catch(function (error) {
				throw _this4.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updateInTheNewsOverview',
		value: function updateInTheNewsOverview(details) {
			var _this5 = this;

			var promise = this.inTheNewsOverviewResource.update(this._setOverviewObject(details)).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this5.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getNewsDetailsById',
		value: function getNewsDetailsById(details) {
			return this._getNewsObject(details.data);
		}
	}, {
		key: 'getInTheNewsFilterData',
		value: function getInTheNewsFilterData(_ref5, url) {
			var _this6 = this;

			var year = _ref5.year,
			    _ref5$filterDetails = _ref5.filterDetails,
			    limit = _ref5$filterDetails.limit,
			    pageId = _ref5$filterDetails.pageId,
			    isPublished = _ref5$filterDetails.isPublished;

			this.inTheNewsFilterResourceUrl = this.apiService.getResourceUrl('cms/menus/' + url);
			this.inTheNewsFilterResource = this.$resource(this.inTheNewsFilterResourceUrl);

			var promise = this.inTheNewsFilterResource.get({
				year: year,
				limit: limit,
				page_id: pageId,
				is_published: isPublished
			}).$promise;

			return promise.then(function (_ref6) {
				var data = _ref6.data;
				return {
					list: _this6._getInTheNewsDetails((0, _find2.default)(data.content, ['name', 'InTheNews'])),
					count: (0, _find2.default)(data.content, ['name', 'InTheNews']).count
				};
			}).catch(function (error) {
				throw _this6.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to delete news
   * @return {object} [information related to news for delete]
   */

	}, {
		key: 'deleteNews',
		value: function deleteNews(id) {
			var _this7 = this;

			var promise = this.inTheNewsGetEditDeleteByIdResource.delete({ content_id: id }).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (err) {
				throw _this7.apiService.getErrorMessage(err);
			});
		}

		/**
   * function to publish/unpublish news
   * @return {object} [information related to news for publish/unpublish]
   */

	}, {
		key: 'publishUnpublishNews',
		value: function publishUnpublishNews(id) {
			var _this8 = this;

			var promise = this.inTheNewsPublishUnpublishResource.update({
				content_id: id
			}).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this8.apiService.getErrorMessage(error);
			});
		}
	}]);

	return AboutUsService;
}();

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var inTheNewsAddComponent = exports.inTheNewsAddComponent = {

    //passing title and onSubmit function for binding in main component
    template: '\n            <in-the-news-main \n                page-title=\'Add News\'\n                parent-slug=\'{{$ctrl.parentSlug}}\' \n                disable-buttons=\'$ctrl.disableButtons\'\n                on-submit=\'$ctrl.onSubmit(details)\'\n                on-save-publish=\'$ctrl.onSavePublish(details)\'\n                show-republish-button=\'$ctrl.showRepublishButton\'\n                show-save-publish-type-button=\'$ctrl.showSavePublishTypeButton\'>\n            </in-the-news-main>',

    bindings: {
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for InTheNewsAddComponent
    controller: function () {
        InTheNewsAddComponent.$inject = ["$stateParams", "toastr", "$state", "AboutUsService", "DynamicMenusService", "SlugService"];
        function InTheNewsAddComponent($stateParams, toastr, $state, AboutUsService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, InTheNewsAddComponent);

            this.$stateParams = $stateParams;
            this.toastr = toastr;
            this.$state = $state;
            this.aboutUsService = AboutUsService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        _createClass(InTheNewsAddComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.showRepublishButton = false;
                this.showSavePublishTypeButton = true;
            }

            //function to add class details

        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                this.disableButtons = true;
                var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'add');
                details = this.aboutUsService._setNewsObject(details);

                // submit the request
                this.dynamicMenusService.addMenuDetailsByUrl(url, details).then(function (_ref) {
                    var id = _ref.data.content_id;

                    var contentDetailsUrl = _this.slugService.getContentDetailsURL(url, id);
                    _this.toastr.success('News added successfully');
                    _this._redirectToParentState(contentDetailsUrl);
                    _this.disableButtons = false;
                }).catch(function (err) {
                    _this.toastr.error(err);
                    _this.disableButtons = false;
                });
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }]);

        return InTheNewsAddComponent;
    }()
};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.inTheNewsAdd = undefined;

var _inTheNewsAdd = __webpack_require__(542);

var inTheNewsAdd = exports.inTheNewsAdd = angular.module('components.inTheNews.inTheNewsAdd', []).component('inTheNewsAdd', _inTheNewsAdd.inTheNewsAddComponent).name;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.inTheNewsDetailsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _inTheNewsDetails = __webpack_require__(753);

var _inTheNewsDetails2 = _interopRequireDefault(_inTheNewsDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var inTheNewsDetailsComponent = exports.inTheNewsDetailsComponent = {

    //binding details
    bindings: {
        details: '<',
        parentSlug: '@',
        slugUrl: '@'
    },

    templateUrl: _inTheNewsDetails2.default,

    //controller for InTheNewsDetailsComponent
    controller: function () {
        InTheNewsDetailsComponent.$inject = ["$state", "$sce", "AboutUsService"];
        function InTheNewsDetailsComponent($state, $sce, AboutUsService) {
            'ngInject';

            _classCallCheck(this, InTheNewsDetailsComponent);

            this.$state = $state;
            this.$sce = $sce;
            this.aboutUsService = AboutUsService;
        }

        _createClass(InTheNewsDetailsComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = this.aboutUsService.getNewsDetailsById(this.details);
                this.details.description = this.$sce.trustAsHtml(this.details.description);
            }
        }, {
            key: 'onGoBack',
            value: function onGoBack() {
                this._redirectToParentState(this.parentSlug);
            }
        }, {
            key: 'onEdit',
            value: function onEdit(id) {
                var url = this._getEditNewsSlugUrl();
                this._redirectToParentState(url);
            }
        }, {
            key: '_getEditNewsSlugUrl',
            value: function _getEditNewsSlugUrl() {
                return this.slugUrl.replace('/details', '/edit');
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }]);

        return InTheNewsDetailsComponent;
    }()
};

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.inTheNewsDetails = undefined;

var _inTheNewsDetails = __webpack_require__(544);

var inTheNewsDetails = exports.inTheNewsDetails = angular.module('components.inTheNews.inTheNewsDetails', []).component('inTheNewsDetails', _inTheNewsDetails.inTheNewsDetailsComponent).name;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var inTheNewsEditComponent = exports.inTheNewsEditComponent = {

    //passing title and onSubmit function for binding in main component
    template: '\n            <in-the-news-main \n                page-title=\'Edit News\'\n                parent-slug=\'{{$ctrl.parentSlug}}\' \n                details=\'$ctrl.details\'\n                disable-buttons=\'$ctrl.disableButtons\'\n                on-submit=\'$ctrl.onSubmit(details)\'\n                on-republish=\'$ctrl.onSubmit(details)\'\n                show-republish-button=\'$ctrl.showRepublishButton\'\n                show-save-publish-type-button=\'$ctrl.showSavePublishTypeButton\'>\n            </in-the-news-main>',

    bindings: {
        details: '<',
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for InTheNewsEditComponent
    controller: function () {
        InTheNewsEditComponent.$inject = ["toastr", "$state", "$stateParams", "AboutUsService", "CompareObjectService", "DynamicMenusService", "SlugService"];
        function InTheNewsEditComponent(toastr, $state, $stateParams, AboutUsService, CompareObjectService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, InTheNewsEditComponent);

            this.toastr = toastr;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.aboutUsService = AboutUsService;
            this.compareObjectService = CompareObjectService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        //storing old data in savedData


        _createClass(InTheNewsEditComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = this.aboutUsService.getNewsDetailsById(this.details);
                this.showRepublishButton = this.details.publishAt === null ? false : true;
                this.showSavePublishTypeButton = !this.showRepublishButton;
                this.savedData = angular.copy(this.details);
            }

            //comparing old and new data for update on submit function

        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                var _details = angular.copy(details);
                var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, _details, true);
                if (isUpdated) {
                    var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'edit');
                    _details = this.aboutUsService._setNewsObject(_details);

                    this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, _details).then(function (_ref) {
                        var data = _ref.data;

                        var contentDetailsUrl = _this.slugService.getDetailsPageURL(url);
                        _this.toastr.success('News updated successfully');
                        _this._redirectToParentState(contentDetailsUrl);
                        _this.disableButtons = false;
                    }).catch(function (err) {
                        _this.toastr.error(err);
                        _this.disableButtons = false;
                    });
                } else {
                    this.toastr.success('Nothing to update');
                    this._redirectToParentState(this.parentSlug);
                    this.disableButtons = false;
                }
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }]);

        return InTheNewsEditComponent;
    }()
};

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.inTheNewsEdit = undefined;

var _inTheNewsEdit = __webpack_require__(546);

var inTheNewsEdit = exports.inTheNewsEdit = angular.module('components.inTheNews.inTheNewsEdit', []).component('inTheNewsEdit', _inTheNewsEdit.inTheNewsEditComponent).name;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.inTheNewsListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _inTheNewsList = __webpack_require__(754);

var _inTheNewsList2 = _interopRequireDefault(_inTheNewsList);

var _inTheNewsPublishTemplate = __webpack_require__(755);

var _inTheNewsPublishTemplate2 = _interopRequireDefault(_inTheNewsPublishTemplate);

var _inTheNewsUnpublishTemplate = __webpack_require__(756);

var _inTheNewsUnpublishTemplate2 = _interopRequireDefault(_inTheNewsUnpublishTemplate);

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

var _size = __webpack_require__(12);

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var inTheNewsListComponent = exports.inTheNewsListComponent = {
    bindings: {
        details: '<',
        parentSlug: '@',
        slugUrl: '@'
    },

    templateUrl: _inTheNewsList2.default,

    controller: function () {
        InTheNewsListComponent.$inject = ["$state", "toastr", "ModalService", "AboutUsService", "DynamicMenusService", "SlugService"];
        function InTheNewsListComponent($state, toastr, ModalService, AboutUsService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, InTheNewsListComponent);

            this.$state = $state;
            this.toastr = toastr;
            this.modalService = ModalService;
            this.aboutUsService = AboutUsService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        _createClass(InTheNewsListComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = this.aboutUsService.getInTheNewsDetails(this.details);
                this.tabTemplateUrl = _inTheNewsPublishTemplate2.default;
                this.isPublishedClicked = true;
                this._setUnpublishNewsList();
                this.totalUnpublishedItems = this.unpublishedNewsList.length;
                this.year = null;
                this.currentPage = 1;
                this.itemPerPage = 10;
                this.filterDetails = {
                    'limit': this.itemPerPage,
                    'pageId': this.currentPage,
                    'isPublished': true
                };
                this.activeTab = "publish";
                this.selectedYearId = (0, _head2.default)(this.details.year).id;
                this._getPublishNewsList(this.selectedYearId);
            }
        }, {
            key: 'tabChange',
            value: function tabChange(status) {
                if (status === 'publish') {
                    this.activeTab = "publish";
                    this.currentPage = 1;
                    this.filterDetails.pageId = this.currentPage;
                    this.filterDetails.isPublished = true;
                    this.tabTemplateUrl = _inTheNewsPublishTemplate2.default;
                    this.isPublishedClicked = true;
                    this._getPublishNewsList(this.selectedYearId);
                } else {
                    this.activeTab = "unpublish";
                    this.currentPage = 1;
                    this.filterDetails.pageId = this.currentPage;
                    this.filterDetails.isPublished = false;
                    this.tabTemplateUrl = _inTheNewsUnpublishTemplate2.default;
                    this.isPublishedClicked = false;
                    this._getUnpublishNewsList();
                }
            }
        }, {
            key: 'onYearChange',
            value: function onYearChange(id) {
                this.selectedYearId = id;
                this.currentPage = 1;
                this.filterDetails.pageId = this.currentPage;
                this._getPublishNewsList(this.selectedYearId);
            }
        }, {
            key: 'routeAddPageUrl',
            value: function routeAddPageUrl() {
                var url = this.slugService.getAddPageURL(this.slugUrl);

                this.$state.go('app.dashboard.DynamicMenus', {
                    url: url
                });
            }
        }, {
            key: 'routeDetailsPageUrl',
            value: function routeDetailsPageUrl(slug) {
                var url = this.slugService.getDetailsPageURL(slug);

                this.$state.go('app.dashboard.DynamicMenus', {
                    url: url
                });
            }
        }, {
            key: 'routeEditPageUrl',
            value: function routeEditPageUrl(slug) {
                var url = this.slugService.getEditPageURL(slug);

                this.$state.go('app.dashboard.DynamicMenus', {
                    url: url
                });
            }
        }, {
            key: 'onChange',
            value: function onChange(pageNumber) {
                var _this = this;

                this.currentPage = pageNumber;
                this.filterDetails.limit = this.itemPerPage;
                this.filterDetails.pageId = this.currentPage;
                this.aboutUsService.getInTheNewsFilterData({ year: this.selectedYearId, filterDetails: this.filterDetails }, this.slugUrl).then(function (result) {
                    _this.details.list = result.list;
                    _this.activeTab === 'publish' ? _this._setPublishNewsList() : _this._setUnpublishNewsList();
                });
            }

            //on delete the news

        }, {
            key: 'onDelete',
            value: function onDelete(slug) {
                this.modalService.open({
                    details: {
                        bodyMessage: 'Are you sure you want to delete the news?'
                    },

                    buttons: [{
                        name: 'No'
                    }, {
                        name: 'Yes',
                        isPrimary: true,
                        action: onSubmit.bind(this)
                    }]
                });

                function onSubmit() {
                    var _this2 = this;

                    this.dynamicMenusService.deleteMenuDetailsByUrl(slug + '/delete').then(function (response) {
                        _this2.totalItems -= 1;
                        _this2.toastr.success("News Deleted successfully");
                    }).then(function (_) {
                        return _this2.activeTab === 'publish' ? _this2._getPublishNewsList(_this2.selectedYearId) : _this2._getUnpublishNewsList();
                    }).catch(function (err) {
                        _this2.toastr.error(err);
                    });
                }
            }
        }, {
            key: 'publishUnpublishNews',
            value: function publishUnpublishNews(id) {
                var _this3 = this;

                this.aboutUsService.publishUnpublishNews(id).then(function (response) {
                    var unpublishedItem = (0, _find2.default)(_this3.unpublishedNewsList, ['id', id]);
                    unpublishedItem.publishAt = new Date();
                    _this3.unpublishedNewsList = _this3.unpublishedNewsList.filter(function (detail) {
                        return detail.id !== id;
                    });
                    _this3.publishedNewsList.push(unpublishedItem);
                    _this3.totalUnpublishedItems -= 1;
                    _this3.toastr.success("News Published Successfully");
                    _this3.$state.go('app.dashboard.InTheNews');
                }).catch(function (err) {
                    _this3.toastr.error(err);
                });
            }
        }, {
            key: '_getPublishNewsList',
            value: function _getPublishNewsList(year) {
                var _this4 = this;

                this.aboutUsService.getInTheNewsFilterData({ year: year, filterDetails: this.filterDetails }, this.slugUrl).then(function (details) {
                    _this4.totalItems = details.count;
                    _this4.totalPublishedItems = _this4.totalItems;
                    _this4.publishedNewsList = details.list;
                });
            }
        }, {
            key: '_getUnpublishNewsList',
            value: function _getUnpublishNewsList() {
                var _this5 = this;

                this.aboutUsService.getInTheNewsFilterData({ year: this.selectedYearId, filterDetails: this.filterDetails }, this.slugUrl).then(function (details) {
                    _this5.totalItems = details.count;
                    _this5.totalUnpublishedItems = _this5.totalItems;
                    _this5.unpublishedNewsList = details.list;
                });
            }
        }, {
            key: '_setPublishNewsList',
            value: function _setPublishNewsList() {
                this.publishedNewsList = this.details.list.filter(function (item) {
                    return item.publishAt !== null;
                });
            }
        }, {
            key: '_setUnpublishNewsList',
            value: function _setUnpublishNewsList() {
                this.unpublishedNewsList = this.details.list.filter(function (item) {
                    return item.publishAt === null;
                });
            }
        }]);

        return InTheNewsListComponent;
    }()
};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.inTheNewsList = undefined;

var _inTheNewsList = __webpack_require__(548);

var inTheNewsList = exports.inTheNewsList = angular.module('components.aboutUs.inTheNews.inTheNewsList', []).component('inTheNewsList', _inTheNewsList.inTheNewsListComponent).name;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.inTheNewsMainComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(11);

var _clone2 = _interopRequireDefault(_clone);

var _inTheNewsTemplate = __webpack_require__(757);

var _inTheNewsTemplate2 = _interopRequireDefault(_inTheNewsTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var inTheNewsMainComponent = exports.inTheNewsMainComponent = {
	templateUrl: _inTheNewsTemplate2.default,

	//binding title, details and onSubmit function
	bindings: {
		pageTitle: '@',
		details: '<',
		onSubmit: '&',
		onSavePublish: '&',
		onRepublish: '&',
		disableButtons: '<',
		showRepublishButton: '<',
		showSavePublishTypeButton: '<',
		parentSlug: '@'
	},

	//controller for InTheNewsMainComponent
	controller: function () {
		InTheNewsMainComponent.$inject = ["$state", "$parse", "ModalService", "CompareObjectService", "DateService"];
		function InTheNewsMainComponent($state, $parse, ModalService, CompareObjectService, DateService) {
			'ngInject';

			_classCallCheck(this, InTheNewsMainComponent);

			this.$state = $state;
			this.$parse = $parse;
			this.modalService = ModalService;
			this.compareObjectService = CompareObjectService;
			this.dateService = DateService;
		}

		_createClass(InTheNewsMainComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.dateError = false;
				this.editorFieldError = false;
				this.details = this.details || {
					title: "",
					description: "",
					images: [],
					videos: [],
					newsDate: ""
				};

				this.newsDateDetails = {
					title: "News Date*",
					isRequired: true,
					selectedDate: this.details.newsDate
				};
				this.saveData = angular.copy(this.details);
			}
		}, {
			key: 'setEditorDetails',
			value: function setEditorDetails(editorDetails) {
				this.details = (0, _clone2.default)(editorDetails);
				this._checkEditorFieldError();
			}

			//on cancel function

		}, {
			key: 'onCancel',
			value: function onCancel() {
				var _details = angular.copy(this.details);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},

						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}

				function onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: '_onSubmit',
			value: function _onSubmit() {
				this._setNewsDate();
				this._checkEditorFieldError();

				if (!this.editorFieldError) {
					if (this.showRepublishButton) {
						this.details.isActive = true;
						this.onRepublish({
							details: this.details
						});
					} else {
						this.details.isActive = false;
						this.onSubmit({
							details: this.details
						});
					}
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}, {
			key: '_onSavePublish',
			value: function _onSavePublish() {
				this._setNewsDate();
				this._checkEditorFieldError();

				if (!this.dateError && !this.editorFieldError) {
					this.details.isActive = true;
					this.onSubmit({
						details: this.details
					});
				}
			}
		}, {
			key: '_onRepublish',
			value: function _onRepublish() {
				this._setNewsDate();
				this._checkEditorFieldError();

				if (!this.dateError && !this.editorFieldError) {
					this.details.isActive = true;
					this.onSubmit({
						details: this.details
					});
				}
			}
		}, {
			key: '_checkEditorFieldError',
			value: function _checkEditorFieldError() {
				this.editorFieldError = this.details.description.trim().length > 0 ? false : true;
			}
		}, {
			key: '_setNewsDate',
			value: function _setNewsDate() {
				if (this.newsDateDetails.selectedDate) {
					this.dateError = false;
					var date = this.dateService.getDate(this.newsDateDetails.selectedDate);
					this.details.newsDate = date;
				} else {
					this.dateError = true;
				}
			}
		}]);

		return InTheNewsMainComponent;
	}()
};

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inTheNewsMain = undefined;

var _inTheNewsMain = __webpack_require__(550);

var inTheNewsMain = exports.inTheNewsMain = angular.module('components.inTheNews.inTheNewsMain', []).component("inTheNewsMain", _inTheNewsMain.inTheNewsMainComponent).name;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.inTheNews = undefined;

var _inTheNewsList = __webpack_require__(549);

var _inTheNewsAdd = __webpack_require__(543);

var _inTheNewsEdit = __webpack_require__(547);

var _inTheNewsMain = __webpack_require__(551);

var _inTheNewsDetails = __webpack_require__(545);

var inTheNews = exports.inTheNews = angular.module('components.aboutUs.inTheNews', [_inTheNewsList.inTheNewsList, _inTheNewsAdd.inTheNewsAdd, _inTheNewsEdit.inTheNewsEdit, _inTheNewsMain.inTheNewsMain, _inTheNewsDetails.inTheNewsDetails]).name;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ourStaffAddComponent = exports.ourStaffAddComponent = {
    bindings: {
        slugUrl: '@',
        parentSlug: '@'
    },

    template: '\n        <our-staff-main\n            parent-slug=\'{{$ctrl.parentSlug}}\'\n            disable-buttons=\'$ctrl.disableButtons\'\n\t\t    on-submit=\'$ctrl.onSubmit(details)\'\n            page-title=\'Add New Staff\'\n        >\n        </our-staff-main>\n    ',

    controller: function () {
        OurStaffAddComponent.$inject = ["$state", "toastr", "AboutUsService", "DynamicMenusService", "SlugService"];
        function OurStaffAddComponent($state, toastr, AboutUsService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, OurStaffAddComponent);

            this.$state = $state;
            this.toastr = toastr;
            this.aboutUsService = AboutUsService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        _createClass(OurStaffAddComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.disableButtons = false;
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                this.disableButtons = true;
                var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'add');
                details = this.aboutUsService._setStaffDetails(details);

                this.dynamicMenusService.addMenuDetailsByUrl(url, details).then(function (_) {
                    _this.toastr.success("New Staff Added.");
                    _this._redirectToParentState(_this.parentSlug);
                }).catch(function (err) {
                    _this.toastr.error(err);
                    _this.disableButtons = false;
                });
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }]);

        return OurStaffAddComponent;
    }()
};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ourStaffAdd = undefined;

var _ourStaffAdd = __webpack_require__(553);

var ourStaffAdd = exports.ourStaffAdd = angular.module('components.aboutUs.ourStaff.ourStaffAdd', []).component('ourStaffAdd', _ourStaffAdd.ourStaffAddComponent).name;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ourStaffEditSequenceComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ourStaffEditSequence = __webpack_require__(758);

var _ourStaffEditSequence2 = _interopRequireDefault(_ourStaffEditSequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ourStaffEditSequenceComponent = exports.ourStaffEditSequenceComponent = {
	bindings: {
		details: '<',
		parentSlug: '@',
		slugUrl: '@'
	},
	templateUrl: _ourStaffEditSequence2.default,
	controller: function () {
		OurStaffEditSequenceComponent.$inject = ["$state", "toastr", "ModalService", "AboutUsService", "CompareObjectService"];
		function OurStaffEditSequenceComponent($state, toastr, ModalService, AboutUsService, CompareObjectService) {
			'ngInject';

			_classCallCheck(this, OurStaffEditSequenceComponent);

			this.$state = $state;
			this._toastr = toastr;
			this.modalService = ModalService;
			this.aboutUsService = AboutUsService;
			this.compareObjectService = CompareObjectService;
		}

		_createClass(OurStaffEditSequenceComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.aboutUsService.getOurStaffSequence(this.details);
				this.saveData = angular.copy(this.details);
			}

			//after submit set new sort Order

		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				var obj = angular.copy(this.details);
				obj.map(function (item, index) {
					item.sortOrder = _this.saveData[index].sortOrder;
					return item;
				});
				this.aboutUsService.setOurStaffSequence(obj).then(function (result) {
					_this._toastr.success("Content Sequence Changed");
					_this._redirectToParentState(_this.parentSlug);
				}).catch(function (err) {
					_this._toastr.error("something went wrong");
				});
			}

			//on cancel page must redirect to home banner page

		}, {
			key: 'onCancel',
			value: function onCancel() {
				var _details = angular.copy(this.details);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},
						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: _onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}

				function _onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return OurStaffEditSequenceComponent;
	}()
};

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ourStaffEditSequence = undefined;

var _ourStaffEditSequence = __webpack_require__(555);

var ourStaffEditSequence = exports.ourStaffEditSequence = angular.module('components.aboutUs.ourStaff.ourStaffEditSequence', []).component('ourStaffEditSequence', _ourStaffEditSequence.ourStaffEditSequenceComponent).name;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ourStaffEditComponent = exports.ourStaffEditComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        parentSlug: '@'
    },

    template: '\n        <our-staff-main\n            disable-buttons=\'$ctrl.disableButtons\'\n            details=\'$ctrl.details\'\n            parent-slug=\'{{$ctrl.parentSlug}}\'\n\t\t    on-submit=\'$ctrl.onSubmit(details)\'\n            page-title=\'Edit Staff\'\n        >\n        </our-staff-main>\n    ',

    controller: function () {
        OurStaffEditComponent.$inject = ["$state", "toastr", "AboutUsService", "DynamicMenusService"];
        function OurStaffEditComponent($state, toastr, AboutUsService, DynamicMenusService) {
            'ngInject';

            _classCallCheck(this, OurStaffEditComponent);

            this.$state = $state;
            this.toastr = toastr;
            this.aboutUsService = AboutUsService;
            this.dynamicMenusService = DynamicMenusService;
        }

        _createClass(OurStaffEditComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = this.aboutUsService._getStaffDetailsObject(this.details.data);
                this.disableButtons = false;
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                this.disableButtons = true;
                details = this.aboutUsService._setStaffDetails(details);

                this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, details).then(function (_) {
                    _this.toastr.success("Staff details updated successfully.");
                    _this._redirectToParentState(_this.parentSlug);
                }).catch(function (err) {
                    _this.toastr.error(err);
                    _this.disableButtons = false;
                });
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }]);

        return OurStaffEditComponent;
    }()
};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ourStaffEdit = undefined;

var _ourStaffEdit = __webpack_require__(557);

var ourStaffEdit = exports.ourStaffEdit = angular.module('components.aboutUs.ourStaff.ourStaffEdit', []).component('ourStaffEdit', _ourStaffEdit.ourStaffEditComponent).name;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ourStaffListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ourStaffList = __webpack_require__(759);

var _ourStaffList2 = _interopRequireDefault(_ourStaffList);

var _clone = __webpack_require__(11);

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ourStaffListComponent = exports.ourStaffListComponent = {
	bindings: {
		details: '<',
		slugUrl: '@'
	},
	templateUrl: _ourStaffList2.default,
	controller: function () {
		OurStaffListComponent.$inject = ["$state", "ModalService", "AboutUsService", "toastr", "ApiService", "DynamicMenusService", "SlugService"];
		function OurStaffListComponent($state, ModalService, AboutUsService, toastr, ApiService, DynamicMenusService, SlugService) {
			'ngInject';

			_classCallCheck(this, OurStaffListComponent);

			this.$state = $state;
			this.modalService = ModalService;
			this.apiService = ApiService;
			this.aboutUsService = AboutUsService;
			this.toastr = toastr;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		_createClass(OurStaffListComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.aboutUsService.getOurStaffDetails(this.details);
			}
		}, {
			key: 'routeAddPageUrl',
			value: function routeAddPageUrl() {
				var url = this.slugService.getAddPageURL(this.slugUrl);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeSequencePageUrl',
			value: function routeSequencePageUrl() {
				var url = this.slugService.getSequencePageURL(this.slugUrl);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeEditPageUrl',
			value: function routeEditPageUrl(slug) {
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'onDeleteStaff',
			value: function onDeleteStaff(slug) {
				this.modalService.open({
					details: {
						bodyMessage: 'Are you sure you want to delete staff?'
					},
					buttons: [{
						name: 'No'
					}, {
						name: 'Yes',
						isPrimary: true,
						action: _onDelete.bind(this, slug)
					}]
				});

				function _onDelete(slug) {
					var _this = this;

					this.dynamicMenusService.deleteMenuDetailsByUrl(slug + '/delete').then(function (details) {
						_this.toastr.success('staff deleted succesfully');
						_this.$state.reload();
					}).catch(function (error) {
						_this.toastr.error(error);
					});
				}
			}
		}, {
			key: '_getImage',
			value: function _getImage(image) {
				return image ? this.apiService.getResourceUrl('files/images/' + image) : '/./images/Staff_default.jpg';
			}
		}]);

		return OurStaffListComponent;
	}()
};

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ourStaffList = undefined;

var _ourStaffList = __webpack_require__(559);

var ourStaffList = exports.ourStaffList = angular.module('components.aboutUs.ourStaff.ourStaffList', []).component('ourStaffList', _ourStaffList.ourStaffListComponent).name;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ourStaffMainComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ourStaffTemplate = __webpack_require__(760);

var _ourStaffTemplate2 = _interopRequireDefault(_ourStaffTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ourStaffMainComponent = exports.ourStaffMainComponent = {
	bindings: {
		details: '<',
		pageTitle: '@',
		onSubmit: '&',
		parentSlug: '@'
	},

	templateUrl: _ourStaffTemplate2.default,

	controller: function () {
		OurStaffMainComponent.$inject = ["$state", "ModalService", "CompareObjectService"];
		function OurStaffMainComponent($state, ModalService, CompareObjectService) {
			'ngInject';

			_classCallCheck(this, OurStaffMainComponent);

			this.$state = $state;
			this.modalService = ModalService;
			this.compareObjectService = CompareObjectService;
		}

		_createClass(OurStaffMainComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.details || {
					firstName: "",
					lastName: "",
					image: "",
					designation: ""
				};
				this.saveData = angular.copy(this.details);
			}
		}, {
			key: '_onSubmit',
			value: function _onSubmit() {
				this.onSubmit({
					details: this.details
				});
			}
		}, {
			key: 'onUpload',
			value: function onUpload(_ref) {
				var uuid = _ref.details.uuid;

				this.details.image = uuid;
			}
		}, {
			key: 'onRemoveLogo',
			value: function onRemoveLogo() {
				this.details.image = "";
			}
		}, {
			key: 'onCancel',
			value: function onCancel() {
				var _details = angular.copy(this.details);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);

				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},

						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}

				function onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return OurStaffMainComponent;
	}()
};

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ourStaffMain = undefined;

var _ourStaffMain = __webpack_require__(561);

var ourStaffMain = exports.ourStaffMain = angular.module('components.aboutUs.ourStaff.ourStaffMain', []).component("ourStaffMain", _ourStaffMain.ourStaffMainComponent).name;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ourStaff = undefined;

var _ourStaffList = __webpack_require__(560);

var _ourStaffEditSequence = __webpack_require__(556);

var _ourStaffAdd = __webpack_require__(554);

var _ourStaffEdit = __webpack_require__(558);

var _ourStaffMain = __webpack_require__(562);

var ourStaff = exports.ourStaff = angular.module('components.aboutUs.ourStaff', [_ourStaffList.ourStaffList, _ourStaffEditSequence.ourStaffEditSequence, _ourStaffAdd.ourStaffAdd, _ourStaffEdit.ourStaffEdit, _ourStaffMain.ourStaffMain]).name;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.auth = undefined;

var _authService = __webpack_require__(565);

var _login = __webpack_require__(569);

var _resetPassword = __webpack_require__(571);

var _changePassword = __webpack_require__(567);

var auth = exports.auth = angular.module('auth', [_login.login, _resetPassword.resetPassword, _changePassword.changePassword]).service('AuthService', _authService.AuthService).run(["$transitions", "$state", "AuthService", "$location", function ($transitions, $state, AuthService, $location) {
	'ngInject';

	$transitions.onStart({
		to: 'app.login'
	}, function (state) {
		if (AuthService.isAuthenticated()) {
			$state.go('app.dashboard');
			return true;
		}
	});
}]).name;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.AuthService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthService = exports.AuthService = function () {
	AuthService.$inject = ["$resource", "ApiService", "$cookies", "$state", "$window"];
	function AuthService($resource, ApiService, $cookies, $state, $window) {
		'ngInject';

		_classCallCheck(this, AuthService);

		this.$resource = $resource;
		// this.$http = $http;
		this.apiService = ApiService;
		var loginUrl = this.apiService.getResourceUrl('login');
		var logoutUrl = this.apiService.getResourceUrl('logout');
		this.forgotPasswordResourceUrl = this.apiService.getResourceUrl('forgot-password');
		this.resetPasswordResourceUrl = this.apiService.getResourceUrl('password/reset/:token');
		var updatePasswordResourceUrl = this.apiService.getResourceUrl('password/change');
		this.loginState = false;
		this.$cookies = $cookies;
		this.$window = $window;
		this.authData = {};
		this.$state = $state;

		this.updatePasswordResource = this.$resource(updatePasswordResourceUrl, null, {
			update: {
				method: 'put'
			}
		});
		this.loginResource = this.$resource(loginUrl, null, {
			add: {
				method: 'post'
			}
		});
		this.logoutResource = this.$resource(logoutUrl, null, {
			add: {
				method: 'put'
			}
		});

		this.forgotPasswordResource = this.$resource(this.forgotPasswordResourceUrl, null, {
			save: {
				method: 'POST'
			}
		});
		this.resetPasswordResource = this.$resource(this.resetPasswordResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.loginRedirectRoute = '';
	}

	/*
 * @method getProduct
 * @returns 
 */


	_createClass(AuthService, [{
		key: 'getProduct',
		value: function getProduct() {
			return this.product;
		}
	}, {
		key: 'isAuthenticated',
		value: function isAuthenticated() {
			var session = this.$cookies.getObject('user');
			if (session) {
				this.authData = session;
				return true;
			} else {
				return false;
			}
			return false;
		}
	}, {
		key: 'getAuthorizationHeader',
		value: function getAuthorizationHeader() {
			var token = this.$cookies.get('token');
			var authHeader = '';
			if (token) {
				authHeader = 'JWT ' + token;
			}
			return authHeader;
		}
	}, {
		key: 'setHeader',
		value: function setHeader() {
			this.apiService.removeDefaultHeaders();
			var authHeader = this.getAuthorizationHeader();
			this.apiService.setDefaultHeaders(authHeader);
		}
	}, {
		key: 'login',
		value: function login(username, password) {
			var _this = this;

			var promise = this.loginResource.add({
				email: username,
				password: password
			}).$promise;

			return new Promise(function (resolve, reject) {
				promise.then(function (result) {
					_this.setUser(result.data.user);
					_this.$cookies.put('token', result.data.token);
					resolve();
				}, reject);
			});
		}
	}, {
		key: 'setLoginRedirect',
		value: function setLoginRedirect(_state) {
			this.loginRedirectRoute = _state;
		}
	}, {
		key: 'getLoginRedirect',
		value: function getLoginRedirect() {
			return this.loginRedirectRoute;
		}
	}, {
		key: 'removeCookies',
		value: function removeCookies() {
			this.loginState = false;
			this.$cookies.remove('user');
			this.$cookies.remove('token');
			this.$cookies.remove('menuList');
			//		this.setHeader();
		}
	}, {
		key: 'expireSession',
		value: function expireSession() {
			this.removeCookies();
			this.$state.go('app.login');
		}
	}, {
		key: 'logout',
		value: function logout() {
			var _this2 = this;

			var promise = this.logoutResource.add().$promise;
			return new Promise(function (resolve, reject) {
				promise.then(function (result) {
					_this2.expireSession();
					resolve();
				}, reject);
			});
		}
	}, {
		key: 'setUser',
		value: function setUser(data) {
			this.authData = data;
			this.authData.name = this.authData.first_name + ' ' + this.authData.last_name; //to do this.authData.name
			this.authData.image = this.authData.image ? this.apiService.getImageUrl(this.authData.image) : '';
			this.$cookies.putObject('user', this.authData);
		}
	}, {
		key: 'getUser',
		value: function getUser() {
			return this.$cookies.getObject('user');
		}
	}, {
		key: 'getUserRole',
		value: function getUserRole() {
			return {
				role: this.authData.role,
				isAdmin: this.authData.role && this.authData.role.indexOf('Admin') > 0 ? true : false
			};
		}
	}, {
		key: '_setEmailIdObj',
		value: function _setEmailIdObj(value) {
			return {
				email: value
			};
		}
	}, {
		key: 'setPasswordObject',
		value: function setPasswordObject(value) {
			return {
				old_password: value.currentPassword,
				new_password: value.newPassword,
				re_type_password: value.reTypePassword
			};
		}
	}, {
		key: '_setPasswordObj',
		value: function _setPasswordObj(value) {
			return {
				new_password: value.newPassword,
				re_type_password: value.confirmPassword
			};
		}
	}, {
		key: 'forgotPassword',
		value: function forgotPassword(data) {
			var _this3 = this;

			var promise = this.forgotPasswordResource.save(this._setEmailIdObj(data)).$promise;

			return promise.then(function (emailDetails) {
				return emailDetails.data;
			}).catch(function (error) {
				throw _this3.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'confirmToken',
		value: function confirmToken(token) {
			var promise = this.resetPasswordResource.get({
				token: token
			}).$promise;

			return promise.then(function (confirmDetails) {
				return confirmDetails.data;
			}).catch(function (error) {
				throw error;
			});
		}
	}, {
		key: 'updatePassword',
		value: function updatePassword(details) {
			var promise = this.updatePasswordResource.update(this.setPasswordObject(details)).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (_ref) {
				var data = _ref.data;

				throw data;
			});
		}
	}, {
		key: 'resetPassword',
		value: function resetPassword(token, details) {
			var _this4 = this;

			var promise = this.resetPasswordResource.update({ token: token }, this._setPasswordObj(details)).$promise;
			return promise.then(function (resetDetails) {
				return resetDetails.data;
			}).catch(function (error) {
				throw _this4.apiService.getErrorMessage(error);
			});
		}
	}]);

	return AuthService;
}();

;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.changePasswordComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _changePassword = __webpack_require__(761);

var _changePassword2 = _interopRequireDefault(_changePassword);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var changePasswordComponent = exports.changePasswordComponent = {
	templateUrl: _changePassword2.default,
	controller: function () {
		ChangePasswordComponent.$inject = ["$state", "AuthService", "toastr", "ModalService"];
		function ChangePasswordComponent($state, AuthService, toastr, ModalService) {
			'ngInject';

			_classCallCheck(this, ChangePasswordComponent);

			this.authService = AuthService;
			this.toastr = toastr;
			this.$state = $state;
			this.modalService = ModalService;
			//this.Constants = Constants;
		}

		_createClass(ChangePasswordComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.misMatchPassword = false;
				this.invalidOldPassword = false;
				this.invalidNewPassword = false;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				if (this.details.newPassword != this.details.reTypePassword) {
					this.invalidNewPassword = true;
					this.invalidNewPasswordErrorMessage = "New password and re-type password doesn't match";
				} else {
					this.disableButtons = true;
					this.authService.updatePassword(this.details).then(function (details) {
						_this.toastr.success("password updated successfully");
						_this.$state.go("app.dashboard.HomeBanner");
					}).catch(function (error) {
						_this.disableButtons = false;
						if (error.data) {
							var invalidOldPasswordError = (0, _find2.default)(error.data, ['key', "old_password"]);
							if (invalidOldPasswordError) {
								_this.invalidOldPassword = true;
								_this.invalidOldPasswordErrorMessage = invalidOldPasswordError.message;
							}
							var invalidNewPasswordError = (0, _find2.default)(error.data, ['key', "new_password"]);
							if (invalidNewPasswordError) {
								_this.invalidNewPassword = true;
								_this.invalidNewPasswordErrorMessage = invalidNewPasswordError.message;
							}
						} else {
							_this.invalidOldPassword = true;
							_this.invalidOldPasswordErrorMessage = error.message;
						}
					});
				}
			}
		}, {
			key: 'onCancel',
			value: function onCancel() {
				if (this.details === undefined) {
					this.$state.go("app.dashboard.HomeBanner");
				} else {
					var _onSubmit = function _onSubmit() {
						this.$state.go('app.dashboard');
					};

					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},
						buttons: [{
							name: 'No',
							action: function action() {}
						}, {
							name: 'Yes',
							isPrimary: true,
							action: _onSubmit.bind(this)
						}]
					});
				}
			}
		}]);

		return ChangePasswordComponent;
	}()
};

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.changePassword = undefined;

var _changePassword = __webpack_require__(566);

var changePassword = exports.changePassword = angular.module('components.auth.changePassword', []).component('changePassword', _changePassword.changePasswordComponent).config(["$stateProvider", function ($stateProvider) {
	'ngInject';

	$stateProvider.state('app.dashboard.changePassword', {
		url: '/dashboard/change-password',
		component: 'changePassword',
		breadcrumbName: 'change password',
		parentState: 'dashboard'
	});
}]).name;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loginComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _login = __webpack_require__(762);

var _login2 = _interopRequireDefault(_login);

var _capitalize = __webpack_require__(373);

var _capitalize2 = _interopRequireDefault(_capitalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var loginComponent = exports.loginComponent = {
    templateUrl: _login2.default,
    controller: function () {
        LoginComponent.$inject = ["$state", "AuthService", "$location", "toastr", "ApiService"];
        function LoginComponent($state, AuthService, $location, toastr, ApiService) {
            'ngInject';

            _classCallCheck(this, LoginComponent);

            this.$state = $state;
            this.authService = AuthService;
            this.toastr = toastr;
            this.apiService = ApiService;
            this.username = '';
            this.password = '';
            this.emailId = '';
            this.$location = $location;
            this.mismatchPswd = false;
            this.logo = "";
        }

        _createClass(LoginComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.forgotPasswordButtonDisabled = false;
            }
        }, {
            key: 'login',
            value: function login() {
                var _this = this;

                this.authService.login(this.username, this.password).then(function () {
                    var redirect = _this.authService.getLoginRedirect();
                    if (redirect.length > 0) {
                        _this.$location.url(redirect);
                        _this.authService.setLoginRedirect('');
                    } else {
                        _this.$state.go('app.dashboard.DynamicMenus', {
                            url: 'home-banner'
                        });
                    }
                }).catch(function (err) {
                    _this.errorMsg = (0, _capitalize2.default)(_this.apiService.getErrorMessage(err));
                });
            }
        }, {
            key: 'forgotPassword',
            value: function forgotPassword() {
                this.forgotPswd = true;
                this.successSubmit = false;
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                var _this2 = this;

                var email = this.emailId;
                this.forgotPasswordButtonDisabled = true;
                this.authService.forgotPassword(email).then(function (details) {
                    _this2.forgotPasswordButtonDisabled = false;
                    _this2.successSubmit = true;
                    _this2.toastr.success("link send on given email");
                }).catch(function (err) {
                    _this2.toastr.clear();
                    _this2.forgotPasswordButtonDisabled = false;
                    _this2.toastr.error(err);
                });
            }
        }, {
            key: 'hideForgotPswdView',
            value: function hideForgotPswdView() {
                this.forgotPswd = false;
                this.successSubmit = false;
            }
        }, {
            key: 'verifyEmailBackView',
            value: function verifyEmailBackView() {
                this.forgotPswd = false;
                this.successSubmit = false;
                this.emailId = "";
            }
        }, {
            key: 'submitVerifyForm',
            value: function submitVerifyForm() {
                this.onSubmit();
            }
        }]);

        return LoginComponent;
    }()
};

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.login = undefined;

var _login = __webpack_require__(568);

__webpack_require__(188);

var login = exports.login = angular.module('components.auth.login', []).component('login', _login.loginComponent).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	'ngInject';

	$stateProvider.state('app.login', {
		url: 'login',
		component: 'login'
	});
}]).name;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetPasswordComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _resetPassword = __webpack_require__(763);

var _resetPassword2 = _interopRequireDefault(_resetPassword);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var resetPasswordComponent = exports.resetPasswordComponent = {

    bindings: {
        isTokenValid: '<',
        token: '<'
    },

    templateUrl: _resetPassword2.default,

    controller: function () {
        ResetPasswordComponent.$inject = ["AuthService", "$timeout", "$state", "toastr"];
        function ResetPasswordComponent(AuthService, $timeout, $state, toastr) {
            'ngInject';

            _classCallCheck(this, ResetPasswordComponent);

            this.authService = AuthService;
            this.$timeout = $timeout;
            this.$state = $state;
            this.toastr = toastr;
        }

        _createClass(ResetPasswordComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.showResetForm = true;

                if (!this.isTokenValid) {
                    this.showResetForm = false;
                    this.showExpireToken = true;
                    this.showThankingMsg = false;
                }
            }
        }, {
            key: 'confirmReset',
            value: function confirmReset() {
                this.showResetForm = true;
                this.showConfirmReset = false;
            }
        }, {
            key: 'resetPassword',
            value: function resetPassword() {
                var _this = this;

                if (this.details.newPassword !== this.details.confirmPassword) {
                    this.mismatchPswd = true;
                } else {
                    this.authService.resetPassword(this.token, this.details).then(function (details) {
                        _this.showResetForm = false;
                        _this.showThankingMsg = true;
                    }).catch(function (error) {
                        _this.toastr.error(error);
                    });
                }
            }
        }]);

        return ResetPasswordComponent;
    }()
};

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.resetPassword = undefined;

var _resetPassword = __webpack_require__(570);

var resetPassword = exports.resetPassword = angular.module('components.auth.resetPassword', []).component('resetPassword', _resetPassword.resetPasswordComponent).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
	'ngInject';

	$stateProvider.state('resetPassword', {
		url: '/password/reset/:token',
		component: 'resetPassword',
		resolve: {
			isTokenValid: ["$stateParams", "AuthService", "$state", function isTokenValid($stateParams, AuthService, $state) {
				'ngInject';

				return AuthService.confirmToken(decodeURIComponent($stateParams.token)).then(function (details) {
					return details.isExpire === false ? true : false;
				}).catch(function (error) {
					if (error.status === 401) {
						$state.go('password', { token: $stateParams.token });
					}
					return true;
				});
			}],
			token: ["$stateParams", function token($stateParams) {
				'ngInject';

				return decodeURIComponent($stateParams.token);
			}]
		}
	});
}]).name;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.components = undefined;

var _auth = __webpack_require__(564);

var _dashboard = __webpack_require__(577);

var _homeBanner = __webpack_require__(601);

var _transportationAlternative = __webpack_require__(688);

var _planningResources = __webpack_require__(617);

var _aboutUs = __webpack_require__(540);

var _termsAndCondition = __webpack_require__(653);

var _privacyPolicy = __webpack_require__(622);

var _donation = __webpack_require__(580);

var _contactInfo = __webpack_require__(574);

var _serviceArea = __webpack_require__(644);

var _socialLinks = __webpack_require__(647);

var _socialShare = __webpack_require__(650);

var _tripPlanning = __webpack_require__(702);

var _rhnscnyLogo = __webpack_require__(637);

var _paymentMethods = __webpack_require__(615);

var _dynamicMenus = __webpack_require__(583);

var _editorTemplate = __webpack_require__(589);

var _editorTemplateOverview = __webpack_require__(586);

var _menuList = __webpack_require__(604);

var _menuSequence = __webpack_require__(607);

var _reportList = __webpack_require__(631);

var _reportView = __webpack_require__(634);

var _pagePublish = __webpack_require__(610);

var _reportEdit = __webpack_require__(628);

var _reportAdd = __webpack_require__(625);

var components = exports.components = angular.module('components', [_auth.auth, _dashboard.dashboard, _homeBanner.homeBanner, _transportationAlternative.transportationAlternative, _planningResources.planningResources, _aboutUs.aboutUs, _termsAndCondition.termsAndCondition, _privacyPolicy.privacyPolicy, _donation.donation, _contactInfo.contactInfo, _serviceArea.serviceAreaList, _socialLinks.socialLinks, _socialShare.socialShare, _tripPlanning.tripPlanning, _rhnscnyLogo.rhnscnyLogo, _paymentMethods.paymentMethods, _dynamicMenus.dynamicMenus, _editorTemplate.editorTemplate, _editorTemplateOverview.editorTemplateOverview, _menuList.menuList, _menuSequence.menuSequence, _reportList.reportList, _reportView.reportView, _pagePublish.pagePublish, _reportEdit.reportEdit, _reportAdd.reportAdd]).name;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.contactInfoComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _contactInfo = __webpack_require__(764);

var _contactInfo2 = _interopRequireDefault(_contactInfo);

var _clone = __webpack_require__(11);

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var contactInfoComponent = exports.contactInfoComponent = {
	bindings: {
		details: '<',
		parentSlug: '@'
	},

	templateUrl: _contactInfo2.default,

	controller: function () {
		ContactInfoComponent.$inject = ["$state", "toastr", "CompareObjectService", "ModalService", "ContactInfoService"];
		function ContactInfoComponent($state, toastr, CompareObjectService, ModalService, ContactInfoService) {
			'ngInject';

			_classCallCheck(this, ContactInfoComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.contactInfoService = ContactInfoService;
		}

		_createClass(ContactInfoComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.contactInfoService.getContactInfoObject(this.details);
				this.pageTitle = "Contact Info";
				this.savedData = angular.copy(this.details);
				this.emptyPhoneNumberDetailsObject = {
					number: '',
					extn: '',
					isFocused: false
				};
				this.disableButtons = false;
			}
		}, {
			key: 'onPhoneNumberAdd',
			value: function onPhoneNumberAdd() {
				this.emptyPhoneNumberDetailsObject.isFocused = true;
				this.details.phone.push(angular.copy(this.emptyPhoneNumberDetailsObject));
			}
		}, {
			key: 'onPhoneNumberDelete',
			value: function onPhoneNumberDelete(index) {
				var item = this.details.phone[index];
				this.details.phone.splice(index, 1);
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				this.disableButtons = true;
				this.contactInfoService.editContactInfo(this.details).then(function (_) {
					_this.toastr.success("Contact Information updated successfully.");
					_this.$state.reload();
				}).catch(function (err) {
					_this.disableButtons = false;
					_this.toastr.error(err);
				});
			}
		}, {
			key: 'onCancel',
			value: function onCancel() {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: 'home-banner'
				});
			}
		}]);

		return ContactInfoComponent;
	}()
};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.contactInfo = undefined;

var _contactInfo = __webpack_require__(573);

var _contactInfo2 = __webpack_require__(575);

__webpack_require__(189);

var contactInfo = exports.contactInfo = angular.module('components.contactInfo', []).service('ContactInfoService', _contactInfo2.ContactInfoService).component('contactInfo', _contactInfo.contactInfoComponent).name;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ContactInfoService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactInfoService = exports.ContactInfoService = function () {
    ContactInfoService.$inject = ["$resource", "ApiService"];
    function ContactInfoService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, ContactInfoService);

        this.$resource = $resource;
        this.apiService = ApiService;

        this.contactInfoResourceUrl = this.apiService.getResourceUrl('cms/menus/ContactInfo');
        this.editContactInfoResourceUrl = this.apiService.getResourceUrl('cms/contact-info');

        this.contactInfoResource = this.$resource(this.contactInfoResourceUrl);
        this.editContactInfoResource = this.$resource(this.editContactInfoResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }

    /************
     * To get Contact Info
     ***************/


    _createClass(ContactInfoService, [{
        key: 'getContactInfoObject',
        value: function getContactInfoObject(_ref) {
            var data = _ref.data;

            return this._getSubContentDetails((0, _find2.default)(data.content, ['name', 'ContactInfo']).values[0]);
        }

        /*************
         * To Update Contact Info
         *****************/

    }, {
        key: 'editContactInfo',
        value: function editContactInfo(details) {
            var _this = this;

            var contactDetails = this._setContactInfoDetails(details);
            var promise = this.editContactInfoResource.update(contactDetails).$promise;

            return promise.then(function (details) {
                return details;
            }).catch(function (err) {
                throw _this.apiService.getErrorMessage(err);
            });
        }

        //*************************************Private Methods********************************* */

    }, {
        key: '_getSubContentDetails',
        value: function _getSubContentDetails(value) {
            return {
                email: value.email || "",
                phone: this._getPhoneDetailsObject(value.phone),
                address: this._getAddressDetailsObject(value.address)
            };
        }
    }, {
        key: '_getPhoneDetailsObject',
        value: function _getPhoneDetailsObject(phone) {
            phone = Array.isArray(phone) ? phone : [phone];

            return phone.map(function (_ref2) {
                var extn = _ref2.extn,
                    number = _ref2.number;
                return {
                    extn: extn,
                    number: number
                };
            });
        }
    }, {
        key: '_setPhoneDetailsObject',
        value: function _setPhoneDetailsObject(phone) {
            return phone.map(function (_ref3) {
                var extn = _ref3.extn,
                    number = _ref3.number;
                return {
                    extn: extn,
                    number: number
                };
            });
        }
    }, {
        key: '_setContactInfoDetails',
        value: function _setContactInfoDetails(_ref4) {
            var email = _ref4.email,
                phone = _ref4.phone,
                address = _ref4.address;

            return {
                email: email,
                phone: this._setPhoneDetailsObject(phone),
                address: this._setAddressDetailsObject(address)
            };
        }
    }, {
        key: '_getAddressDetailsObject',
        value: function _getAddressDetailsObject() {
            var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return {
                addressLine1: address.address_line_1 || "",
                addressLine2: address.address_line_2 || "",
                stateName: address.state_name || "",
                cityName: address.city_name || "",
                zipCode: address.zip_code || ""
            };
        }
    }, {
        key: '_setAddressDetailsObject',
        value: function _setAddressDetailsObject(_ref5) {
            var address_line_1 = _ref5.addressLine1,
                address_line_2 = _ref5.addressLine2,
                state_name = _ref5.stateName,
                city_name = _ref5.cityName,
                zip_code = _ref5.zipCode;

            return {
                address_line_1: address_line_1,
                address_line_2: address_line_2,
                state_name: state_name,
                city_name: city_name,
                zip_code: zip_code
            };
        }
    }]);

    return ContactInfoService;
}();

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dashboardComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dashboard = __webpack_require__(765);

var _dashboard2 = _interopRequireDefault(_dashboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dashboardComponent = exports.dashboardComponent = {
    templateUrl: _dashboard2.default,

    bindings: {
        list: '<'
    },

    controller: function () {
        function DashboardComponent() {
            _classCallCheck(this, DashboardComponent);
        }

        _createClass(DashboardComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.isSidebarOpen = false;
            }
        }]);

        return DashboardComponent;
    }()
};

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dashboard = undefined;

var _dashboard = __webpack_require__(576);

var _dashboard2 = __webpack_require__(578);

__webpack_require__(190);

var dashboard = exports.dashboard = angular.module('components.dashboard', []).component('dashboard', _dashboard.dashboardComponent).config(["$stateProvider", function ($stateProvider) {
    'ngInject';

    $stateProvider.state('app.dashboard', {
        url: 'dashboard',
        parentState: 'dashboard',
        breadcrumbName: 'dashboard',
        component: 'dashboard',
        name: 'dashboard',
        resolve: {
            list: ["DashboardService", function list(DashboardService) {
                'ngInject';

                return DashboardService.getMenuList();
            }]
        }
    });
}]).service('DashboardService', _dashboard2.DashboardService).name;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.DashboardService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _last = __webpack_require__(48);

var _last2 = _interopRequireDefault(_last);

var _size = __webpack_require__(12);

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DashboardService = exports.DashboardService = function () {
	DashboardService.$inject = ["AuthService", "ApiService", "$resource", "$cookies", "BreadcrumbService"];
	function DashboardService(AuthService, ApiService, $resource, $cookies, BreadcrumbService) {
		'ngInject';

		_classCallCheck(this, DashboardService);

		this.authService = AuthService;
		this.apiService = ApiService;
		this.$resource = $resource;
		this.$cookies = $cookies;
		this.breadcrumbService = BreadcrumbService;

		this.menuListResourceUrl = this.apiService.getResourceUrl('cms/menus');
		this.menuListResource = this.$resource(this.menuListResourceUrl);
	}

	_createClass(DashboardService, [{
		key: '_getMenuDetails',
		value: function _getMenuDetails(value) {
			return {
				id: value.cms_menu_id,
				name: value.name,
				displayName: value.display_name,
				icon: value.icon,
				slug: value.slug || null
			};
		}
	}, {
		key: '_getMenuList1Details',
		value: function _getMenuList1Details(content) {
			var _this = this;

			return content.reduce(function (list, data) {
				if (data.menu_group === '1') {
					list = list.concat(_getListData.call(_this, data.value));
				}
				return list;
			}, []);

			function _getListData(data) {
				var _this2 = this;

				return data.map(function (value) {
					return _this2._getMenuDetails(value);
				});
			}
		}
	}, {
		key: '_getMenuList2Details',
		value: function _getMenuList2Details(content) {
			var _this3 = this;

			return content.reduce(function (list, data) {
				list = _getListData.call(_this3, data.value);
				return list;
			}, []);

			function _getListData(data) {
				var _this4 = this;

				return data.map(function (value) {
					return _this4._getMenuDetails(value);
				});
			}
		}
		/**
   * function to get menu list
   * @return {object} [information related to menu list]
   */

	}, {
		key: 'getMenuList',
		value: function getMenuList() {
			var _this5 = this;

			var menuListDetails = this.$cookies.get('menuList');
			if (!menuListDetails) {
				var promise = this.menuListResource.get().$promise;
				return promise.then(function (details) {
					var menulist = {
						menuList1: _this5._getMenuList1Details(details.data),
						menuList2: _this5._getMenuList2Details(details.data)
					};
					_this5.$cookies.put('menuList', JSON.stringify(menulist));
					return menulist;
				}).catch(function (error) {
					throw _this5.apiService.getErrorMessage(error);
				});
			} else {
				return JSON.parse(menuListDetails);
			}
		}
	}, {
		key: 'updateMenuSlug',
		value: function updateMenuSlug(_ref) {
			var name = _ref.name,
			    displayName = _ref.display_name,
			    updatedSlug = _ref.slug;

			var menuListDetails = JSON.parse(this.$cookies.get('menuList'));
			var menu = this._getMenuToUpdate(menuListDetails.menuList1, name);
			if (menu) {
				menu.slug = updatedSlug;
				menu.displayName = displayName;
				this.$cookies.put('menuList', JSON.stringify(menuListDetails));
			}
		}
	}, {
		key: 'getActiveMenuName',
		value: function getActiveMenuName() {
			var breadcrumbs = this.breadcrumbService.breadcrumbs;
			return (0, _size2.default)(breadcrumbs) > 0 ? (0, _last2.default)(breadcrumbs).displayName : null;
		}
	}, {
		key: '_getMenuToUpdate',
		value: function _getMenuToUpdate(menuList, menuName) {
			return (0, _find2.default)(menuList, { name: menuName });
		}
	}]);

	return DashboardService;
}();

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.donationComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _donation = __webpack_require__(766);

var _donation2 = _interopRequireDefault(_donation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var donationComponent = exports.donationComponent = {
	bindings: {
		details: '<',
		parentSlug: '@'
	},

	templateUrl: _donation2.default,

	controller: function () {
		DonationComponent.$inject = ["$state", "toastr", "CompareObjectService", "ModalService", "DonationService"];
		function DonationComponent($state, toastr, CompareObjectService, ModalService, DonationService) {
			'ngInject';

			_classCallCheck(this, DonationComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.donationService = DonationService;
		}

		_createClass(DonationComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.donationService.getDonationUrl(this.details);
				this.pageTitle = "Edit Donation Url";
				this.savedData = angular.copy(this.details);
			}
		}, {
			key: 'onCancel',
			value: function onCancel() {
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, false);

				if (isUpdated) {
					var _onSubmit = function _onSubmit() {
						this._redirectToParentState('home-banner');
					};

					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},
						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: _onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState('home-banner');
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				this.disableButtons = true;
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, true);

				if (isUpdated) {
					this.donationService.editDonation(this.details).then(function (_) {
						_this.toastr.success('Donation url is updated successfully');
						_this.disableButtons = false;
					}).catch(function (err) {
						_this.toastr.error(err);
						_this.disableButtons = false;
					});
				} else {
					this.toastr.success('Nothing to update');
					this.disableButtons = false;
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return DonationComponent;
	}()
};

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.donation = undefined;

var _donation = __webpack_require__(579);

var _donation2 = __webpack_require__(581);

var donation = exports.donation = angular.module('components.donation', []).service('DonationService', _donation2.DonationService).component('donation', _donation.donationComponent).name;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DonationService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DonationService = exports.DonationService = function () {
    DonationService.$inject = ["$resource", "ApiService"];
    function DonationService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, DonationService);

        this.$resource = $resource;
        this.apiService = ApiService;

        this.donationResourceUrl = this.apiService.getResourceUrl('cms/menus/Donation');
        this.editDonationResourceUrl = this.apiService.getResourceUrl('cms/donation');

        this.donationResource = this.$resource(this.donationResourceUrl);
        this.editDonationResource = this.$resource(this.editDonationResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }

    _createClass(DonationService, [{
        key: '_getSubContentDetails',
        value: function _getSubContentDetails(value) {
            return {
                id: value.content_id,
                url: value.url
            };
        }
    }, {
        key: '_setSubContentDetails',
        value: function _setSubContentDetails(value) {
            return {
                url: value.url
            };
        }

        /************
         * To get Donation
         ***************/

    }, {
        key: 'getDonationUrl',
        value: function getDonationUrl(details) {
            return this._getSubContentDetails((0, _find2.default)(details.data.content, ['name', 'Donation']).values[0]);
        }

        /*************
         * To Update Donation
         *****************/

    }, {
        key: 'editDonation',
        value: function editDonation(details) {
            var _this = this;

            var promise = this.editDonationResource.update(this._setSubContentDetails(details)).$promise;

            return promise.then(function (details) {
                return details;
            }).catch(function (err) {
                throw _this.apiService.getErrorMessage(err);
            });
        }
    }]);

    return DonationService;
}();

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dynamicMenusComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _last2 = __webpack_require__(48);

var _last3 = _interopRequireDefault(_last2);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

var _dynamicMenus = __webpack_require__(767);

var _dynamicMenus2 = _interopRequireDefault(_dynamicMenus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var dynamicMenusComponent = exports.dynamicMenusComponent = {
    bindings: {
        menuDetails: '<',
        slugUrl: '<'
    },

    templateUrl: _dynamicMenus2.default,

    controller: function () {
        DynamicMenusComponent.$inject = ["DynamicMenusService"];
        function DynamicMenusComponent(DynamicMenusService) {
            'ngInject';

            _classCallCheck(this, DynamicMenusComponent);

            this.dynamicMenusService = DynamicMenusService;
        }

        _createClass(DynamicMenusComponent, [{
            key: '$onInit',
            value: function $onInit() {
                if (this.menuDetails.data.breadcrumb) {
                    this.breadcrumb = this.menuDetails.data.breadcrumb;
                    this.activeMenu = (0, _last3.default)(this.breadcrumb).name;
                    this.parentState = this.dynamicMenusService.getParentStateObject();
                    this.parentSlug = this.parentState ? this.parentState.slug : '';
                    this.parentName = this.parentState ? this.parentState.name : '';
                    this.mainMenuName = (0, _head2.default)(this.breadcrumb).name;
                    this.menuId = this.menuDetails.data.menuOverviewDetails ? this.menuDetails.data.menuOverviewDetails.menu_id : null;
                }
            }

            //Menus listing Components

        }, {
            key: 'isMenuListComponent',
            value: function isMenuListComponent() {
                switch (this.activeMenu) {
                    case 'TransportationAlternatives':
                    case 'PlanningResources':
                    case 'GettherePrograms':
                    case 'PublicationsAndDocuments':
                    case 'AboutUs':
                        return true;
                    default:
                        return false;
                }
            }

            //Overview Components

        }, {
            key: 'isEditorTemplateOverviewComponent',
            value: function isEditorTemplateOverviewComponent() {
                switch (this.activeMenu) {
                    case 'TransportationAlternativesOverview':
                    case 'CallForHelpOverview':
                    case 'BicycleAndPedestrianOverview':
                    case 'RidesharingOverview':
                    case 'TransportationProvidersOverview':
                    case 'TelemedicineDeliveryProgramAssistanceOverview':
                    case 'GetthereProgramsOverview':
                    case 'ConnectionToCareOverview':
                    case 'GettingThereOverview':
                    case 'NewsRuralMobilityProjectOverview':
                    case 'PlanningAndTechnicalAssistanceOverview':
                    case 'VoucherProgramOverview':
                    case 'TravelTrainingGettingOverview':
                    case 'CallCenterOverview':
                    case 'AboutUsOverview':
                    case 'MissionHistoryOverview':
                    case 'RuralHealthNetworkOverview':
                    case 'PartnersStakeholdersOverview':
                    case 'AdvisoryCommitteeOverview':
                    case 'OurStaffOverview':
                    case 'PublicationsAndDocumentsOverview':
                    case 'ProgressReportsOverview':
                    case 'GetthereCallCenterStatisticsOverview':
                    case 'MilepostOverview':
                    case 'ThereConferenceMaterialsOverview':
                    case 'PlanningResourcesOverview':
                    case 'IndustryOverview':
                    case 'TransportationLinksOverview':
                    case 'GrantApplicationsOverview':
                    case 'OtherReferenceMaterialsFundingOverview':
                    case 'InTheNewsOverview':
                    case 'FtaFactSheetsAndCircularsOverview':
                    case 'DataMappingToolOverview':
                    case 'TransportationPlansOverview':
                    case 'Page1Overview':
                    case 'Page2Overview':
                    case 'Page3Overview':
                    case 'Page4Overview':
                    case 'Page5Overview':
                        return true;
                    default:
                        return this._isNewPageComponent("Overview");
                }
            }

            //Editor Components

        }, {
            key: 'isEditorTemplateComponent',
            value: function isEditorTemplateComponent() {
                switch (this.activeMenu) {
                    case 'TelemedicineDeliveryProgramAssistance':
                    case 'ConnectionToCare':
                    case 'GettingThere':
                    case 'NewsRuralMobilityProject':
                    case 'PlanningAndTechnicalAssistance':
                    case 'VoucherProgram':
                    case 'TravelTrainingGetting':
                    case 'CallCenter':
                    case 'MissionHistory':
                    case 'RuralHealthNetwork':
                    case 'PartnersStakeholders':
                    case 'AdvisoryCommittee':
                    case 'Industry':
                    case 'TransportationLinks':
                    case 'GrantApplications':
                    case 'OtherReferenceMaterialsFunding':
                    case 'Page1':
                    case 'Page2':
                    case 'Page3':
                    case 'Page4':
                    case 'Page5':
                        return true;
                    default:
                        return false;
                }
            }

            //Menu Sequence Components

        }, {
            key: 'isMenuSequenceComponent',
            value: function isMenuSequenceComponent() {
                switch (this.activeMenu) {
                    case 'TransportationAlternativesSequence':
                    case 'PlanningResourcesSequence':
                    case 'GetthereProgramsSequence':
                    case 'PublicationsAndDocumentsSequence':
                    case 'AboutUsSequence':
                        return true;
                    default:
                        return false;
                }
            }

            //Report List Components

        }, {
            key: 'isReportListComponent',
            value: function isReportListComponent() {
                switch (this.activeMenu) {
                    case 'ProgressReports':
                    case 'GetthereCallCenterStatistics':
                    case 'Milepost':
                    case 'ThereConferenceMaterials':
                    case 'FtaFactSheetsAndCirculars':
                    case 'TransportationPlans':
                        return true;
                    default:
                        return this._isNewReportListComponent();
                }
            }
        }, {
            key: '_isNewReportListComponent',
            value: function _isNewReportListComponent() {
                var selectedMenu = (0, _last3.default)(this.breadcrumb);
                var mainMenuPages = ["Overview", "Publish", "Sequence"];

                switch (this.parentName) {
                    case 'PublicationsAndDocuments':
                        var index = mainMenuPages.indexOf(selectedMenu.display_name);
                        return index !== -1 ? false : true;
                    default:
                        return false;
                }
            }

            //View Report Components

        }, {
            key: 'isReportViewComponent',
            value: function isReportViewComponent() {
                switch (this.activeMenu) {
                    case 'ProgressReportsDetails':
                    case 'MilepostDetails':
                    case 'ThereConferenceMaterialsDetails':
                    case 'GetthereCallCenterStatisticsDetails':
                    case 'FtaFactSheetsAndCircularsDetails':
                    case 'TransportationPlansDetails':
                        return true;
                    default:
                        return this._isNewPageComponent("Details");
                }
            }

            //Add Report Components

        }, {
            key: 'isReportAddComponent',
            value: function isReportAddComponent() {
                switch (this.activeMenu) {
                    case 'ProgressReportsAdd':
                    case 'MilepostAdd':
                    case 'GetthereCallCenterStatisticsAdd':
                    case 'ThereConferenceMaterialsAdd':
                    case 'FtaFactSheetsAndCircularsAdd':
                    case 'TransportationPlansAdd':
                        return true;
                    default:
                        return this._isNewPageComponent("Add");
                }
            }

            //Edit Report Components

        }, {
            key: 'isReportEditComponent',
            value: function isReportEditComponent() {
                switch (this.activeMenu) {
                    case 'ProgressReportsEdit':
                    case 'MilepostEdit':
                    case 'GetthereCallCenterStatisticsEdit':
                    case 'ThereConferenceMaterialsEdit':
                    case 'FtaFactSheetsAndCircularsEdit':
                    case 'TransportationPlansEdit':
                        return true;
                    default:
                        return this._isNewPageComponent("Edit");
                }
            }

            //Page publish status component

        }, {
            key: 'isPagePublishStatusComponent',
            value: function isPagePublishStatusComponent() {
                switch (this.activeMenu) {
                    case 'TransportationAlternativesPublish':
                    case 'PlanningResourcesPublish':
                    case 'GetthereProgramsPublish':
                    case 'PublicationsAndDocumentsPublish':
                    case 'AboutUsPublish':
                        return true;
                    default:
                        return false;
                }
            }
        }, {
            key: '_isNewPageComponent',
            value: function _isNewPageComponent(pageName) {
                var _last = (0, _last3.default)(this.breadcrumb),
                    displayName = _last.display_name;

                switch (this.mainMenuName) {
                    case "PublicationsAndDocuments":
                        return this.parentName !== "" && this.mainMenuName !== this.parentName && displayName === pageName ? true : false;
                    default:
                        return false;
                }
            }
        }]);

        return DynamicMenusComponent;
    }()
};

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dynamicMenus = undefined;

var _dynamicMenus = __webpack_require__(582);

var _dynamicMenus2 = __webpack_require__(584);

var dynamicMenus = exports.dynamicMenus = angular.module('components.dynamicMenus', []).service("DynamicMenusService", _dynamicMenus2.DynamicMenusService).component("dynamicMenus", _dynamicMenus.dynamicMenusComponent).config(["$stateProvider", "$urlMatcherFactoryProvider", function ($stateProvider, $urlMatcherFactoryProvider) {
    'ngInject';

    $urlMatcherFactoryProvider.type('url', {});

    $stateProvider.state('app.dashboard.DynamicMenus', {
        url: '/{url:url}',
        component: 'dynamicMenus',
        resolve: {
            menuDetails: ["$stateParams", "DynamicMenusService", function menuDetails($stateParams, DynamicMenusService) {
                'ngInject';

                return DynamicMenusService.getMenuDetailsByUrl($stateParams.url);
            }],
            slugUrl: ["$stateParams", function slugUrl($stateParams) {
                'ngInject';

                return $stateParams.url;
            }]
        }
    });
}]).name;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.DynamicMenusService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _size = __webpack_require__(12);

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DynamicMenusService = exports.DynamicMenusService = function () {
	DynamicMenusService.$inject = ["$resource", "ApiService", "BreadcrumbService"];
	function DynamicMenusService($resource, ApiService, BreadcrumbService) {
		'ngInject';

		_classCallCheck(this, DynamicMenusService);

		this.$resource = $resource;
		this.apiService = ApiService;
		this.breadcrumbService = BreadcrumbService;
	}

	//Get Menu Details By Slug Url


	_createClass(DynamicMenusService, [{
		key: 'getMenuDetailsByUrl',
		value: function getMenuDetailsByUrl(url) {
			var _this = this;

			this._setResourceUrl(url);

			var promise = this.dynamicPageResource.get().$promise;
			return promise.then(function (details) {
				details.data.breadcrumb ? _this.breadcrumbService.setPageBreadcrumbs(details.data.breadcrumb) : true;
				return details;
			}).catch(function (err) {
				throw _this.apiService.getErrorMessage(err);
			});
		}

		//Add Menu Details By Slug Url

	}, {
		key: 'addMenuDetailsByUrl',
		value: function addMenuDetailsByUrl(url, details) {
			var _this2 = this;

			this._setResourceUrl(url);

			var promise = this.dynamicPageResource.save(details).$promise;
			return promise.then(function (details) {
				return details;
			}).catch(function (err) {
				throw _this2.apiService.getErrorMessage(err);
			});
		}

		//Update Menu Details By Slug Url

	}, {
		key: 'updateMenuDetailsByUrl',
		value: function updateMenuDetailsByUrl(url, details) {
			var _this3 = this;

			this._setResourceUrl(url);

			var promise = this.dynamicPageResource.update(details).$promise;
			return promise.then(function (details) {
				return details;
			}).catch(function (err) {
				throw _this3.apiService.getErrorMessage(err);
			});
		}

		//Delete Menu Details By Slug Url

	}, {
		key: 'deleteMenuDetailsByUrl',
		value: function deleteMenuDetailsByUrl(url) {
			var _this4 = this;

			this._setResourceUrl(url);

			var promise = this.dynamicPageResource.delete().$promise;
			return promise.then(function (details) {
				return details;
			}).catch(function (err) {
				throw _this4.apiService.getErrorMessage(err);
			});
		}

		//Get Parent State Object

	}, {
		key: 'getParentStateObject',
		value: function getParentStateObject() {
			var breadcrumbs = this.breadcrumbService.breadcrumbs;
			var sizeOfBreadcrumbs = (0, _size2.default)(breadcrumbs);

			return sizeOfBreadcrumbs > 0 ? breadcrumbs[sizeOfBreadcrumbs - 1 - 1] : breadcrumbs[sizeOfBreadcrumbs];
		}
	}, {
		key: '_setResourceUrl',
		value: function _setResourceUrl(url) {
			this.dynamicPageResourceUrl = this.apiService.getResourceUrl('cms/menus/' + url);
			this.dynamicPageResource = this.$resource(this.dynamicPageResourceUrl, null, {
				update: {
					method: 'PUT'
				},
				delete: {
					method: 'DELETE'
				}
			});
		}
	}]);

	return DynamicMenusService;
}();

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.editorTemplateOverviewComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _editorTemplateOverview = __webpack_require__(768);

var _editorTemplateOverview2 = _interopRequireDefault(_editorTemplateOverview);

var _last = __webpack_require__(48);

var _last2 = _interopRequireDefault(_last);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var editorTemplateOverviewComponent = exports.editorTemplateOverviewComponent = {
	bindings: {
		details: '<',
		slugUrl: '@',
		parentSlug: '@',
		parentName: '@'
	},

	templateUrl: _editorTemplateOverview2.default,

	controller: function () {
		EditorTemplateOverviewComponent.$inject = ["$state", "$timeout", "toastr", "CompareObjectService", "ModalService", "EditorTemplateOverviewService", "DynamicMenusService", "DashboardService"];
		function EditorTemplateOverviewComponent($state, $timeout, toastr, CompareObjectService, ModalService, EditorTemplateOverviewService, DynamicMenusService, DashboardService) {
			'ngInject';

			_classCallCheck(this, EditorTemplateOverviewComponent);

			this.$state = $state;
			this.$timeout = $timeout;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.editorTemplateOverviewService = EditorTemplateOverviewService;
			this.dynamicMenusService = DynamicMenusService;
			this.dashboardService = DashboardService;
		}

		_createClass(EditorTemplateOverviewComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.editorTemplateOverviewService.getEditorContentOverviewDetails(this.details);
				this.isDescriptionAvailable = this._isDescriptionShowInOverview();
				this.details.pageTitle = "Edit Overview";
				this.savedData = angular.copy(this.details);
			}
		}, {
			key: 'onCoverPicUpload',
			value: function onCoverPicUpload(_ref) {
				var uuid = _ref.details.uuid;

				this.details.image = uuid;
			}
		}, {
			key: 'onCancel',
			value: function onCancel() {
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, false);

				if (isUpdated) {
					var _onSubmit = function _onSubmit() {
						this._redirectToParentState(this.parentSlug);
					};

					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},
						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: _onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, true);

				if (isUpdated) {
					this.editorTemplateOverviewService.updateEditorContentOverviewDetails(this.details, this.parentName).then(function (details) {
						_this.toastr.success('Overview updated successfully');
						var breadcrumb = details.breadcrumb;

						var menu = (0, _last2.default)(breadcrumb);
						_this._updateMenuList(menu);
						_this._redirectToParentState(menu.slug);
						_this._reloadMenuList();
						_this.disableButtons = false;
					}).catch(function (err) {
						_this.toastr.error(err);
						_this.disableButtons = false;
					});
				} else {
					this.toastr.success('Nothing to update');
					this._redirectToParentState(this.parentSlug);
					this.disableButtons = false;
				}
			}

			//-------------------------------------Private Methods----------------------------------------------------

		}, {
			key: '_updateMenuList',
			value: function _updateMenuList(menu) {
				this.dashboardService.updateMenuSlug(menu);
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}, {
			key: '_reloadMenuList',
			value: function _reloadMenuList() {
				var _this2 = this;

				this.$timeout(function () {
					_this2.$state.reload();
				}, 500);
			}

			// Display description in overview if true

		}, {
			key: '_isDescriptionShowInOverview',
			value: function _isDescriptionShowInOverview() {
				switch (this.parentName) {
					case 'TelemedicineDeliveryProgramAssistance':
					case 'ConnectionToCare':
					case 'GettingThere':
					case 'NewsRuralMobilityProject':
					case 'PlanningAndTechnicalAssistance':
					case 'VoucherProgram':
					case 'TravelTrainingGetting':
					case 'CallCenter':
					case 'MissionHistory':
					case 'RuralHealthNetwork':
					case 'PartnersStakeholders':
					case 'AdvisoryCommittee':
					case 'Industry':
					case 'TransportationLinks':
					case 'GrantApplications':
					case 'OtherReferenceMaterialsFunding':
					case 'Page1':
					case 'Page2':
					case 'Page3':
					case 'Page4':
					case 'Page5':
					case 'DataMappingTool':
						return false;
					default:
						return true;
				}
			}
		}]);

		return EditorTemplateOverviewComponent;
	}()
};

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorTemplateOverview = undefined;

var _editorTemplateOverview = __webpack_require__(585);

var _editorTemplateOverview2 = __webpack_require__(587);

var editorTemplateOverview = exports.editorTemplateOverview = angular.module('components.editorTemplateOverview', []).component('editorTemplateOverview', _editorTemplateOverview.editorTemplateOverviewComponent).service('EditorTemplateOverviewService', _editorTemplateOverview2.EditorTemplateOverviewService).name;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditorTemplateOverviewService = exports.EditorTemplateOverviewService = function () {
    EditorTemplateOverviewService.$inject = ["$resource", "ApiService"];
    function EditorTemplateOverviewService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, EditorTemplateOverviewService);

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    _createClass(EditorTemplateOverviewService, [{
        key: 'getEditorContentOverviewDetails',
        value: function getEditorContentOverviewDetails(details) {
            return this._getOverviewDetails(details.data);
        }
    }, {
        key: 'updateEditorContentOverviewDetails',
        value: function updateEditorContentOverviewDetails(details, moduleName) {
            var _this = this;

            this._setResourceUrl(moduleName);
            var promise = this.editorContentOverviewResource.update(this._setOverviewObject(details)).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (error) {
                throw _this.apiService.getErrorMessage(error);
            });
        }

        //*************************************Private Methods********************************** */

    }, {
        key: '_setResourceUrl',
        value: function _setResourceUrl(moduleName) {
            this.editorContentOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/' + moduleName);
            this.editorContentOverviewResource = this.$resource(this.editorContentOverviewResourceUrl, null, {
                update: {
                    method: 'PUT'
                }
            });
        }
    }, {
        key: '_getOverviewDetails',
        value: function _getOverviewDetails(details) {
            return {
                title: details.title,
                overview: details.overview,
                description: details.description,
                image: details.image,
                ada: details.ada || {}
            };
        }
    }, {
        key: '_setOverviewObject',
        value: function _setOverviewObject(details) {
            return {
                title: details.title,
                overview: details.overview,
                description: details.description,
                image: details.image,
                ada: details.ada || {}
            };
        }
    }]);

    return EditorTemplateOverviewService;
}();

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorTemplateComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _editorTemplate = __webpack_require__(769);

var _editorTemplate2 = _interopRequireDefault(_editorTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var editorTemplateComponent = exports.editorTemplateComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        menuName: '@',
        parentSlug: '@'
    },

    templateUrl: _editorTemplate2.default,

    controller: function () {
        EditorTemplateComponent.$inject = ["$state", "toastr", "CompareObjectService", "ModalService", "EditorTemplateService", "DashboardService"];
        function EditorTemplateComponent($state, toastr, CompareObjectService, ModalService, EditorTemplateService, DashboardService) {
            'ngInject';

            _classCallCheck(this, EditorTemplateComponent);

            this.$state = $state;
            this.toastr = toastr;
            this.compareObjectService = CompareObjectService;
            this.modalService = ModalService;
            this.editorTemplateService = EditorTemplateService;
            this.dashboardService = DashboardService;
        }

        _createClass(EditorTemplateComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.activeMenuName = this.dashboardService.getActiveMenuName();

                this.details = this.editorTemplateService.getEditorContentDetailsObject(this.details, this.menuName);
                this.details.pageTitle = 'Edit ' + this.activeMenuName;

                this.savedData = angular.copy(this.details.menuContentDetails);
            }
        }, {
            key: 'onCancel',
            value: function onCancel() {
                var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, false);

                if (isUpdated) {
                    var _onSubmit = function _onSubmit() {
                        this._redirectToParentState(this.parentSlug);
                    };

                    this.modalService.open({
                        details: {
                            bodyMessage: 'Changes done will be reverted. Continue?'
                        },
                        buttons: [{
                            name: 'No'
                        }, {
                            name: 'Yes',
                            isPrimary: true,
                            action: _onSubmit.bind(this)
                        }]
                    });
                } else {
                    this._redirectToParentState(this.parentSlug);
                }
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                var _this = this;

                this.disableButtons = true;
                var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, true);

                if (isUpdated) {
                    this.editorTemplateService.updatetEditorDetails(this.details.menuContentDetails, this.menuName).then(function (details) {
                        _this.toastr.success('data updated successfully');
                        _this._redirectToParentState(_this.parentSlug);
                    }).catch(function (err) {
                        _this.toastr.error(err);
                        _this.disableButtons = false;
                    });
                } else {
                    this.toastr.success('Nothing to update');
                    this._redirectToParentState(this.parentSlug);
                }
            }

            //*********************************************************Private Methods ***************************************** */

        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }]);

        return EditorTemplateComponent;
    }()
};

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorTemplate = undefined;

var _editorTemplate = __webpack_require__(588);

var _editorTemplate2 = __webpack_require__(590);

var editorTemplate = exports.editorTemplate = angular.module('components.editorTemplate', []).component('editorTemplate', _editorTemplate.editorTemplateComponent).service('EditorTemplateService', _editorTemplate2.EditorTemplateService).name;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditorTemplateService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditorTemplateService = exports.EditorTemplateService = function () {
    EditorTemplateService.$inject = ["$resource", "ApiService"];
    function EditorTemplateService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, EditorTemplateService);

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    _createClass(EditorTemplateService, [{
        key: 'updatetEditorDetails',
        value: function updatetEditorDetails(details, moduleName) {
            var _this = this;

            this._setResourceUrl(moduleName);
            var promise = this.editorEditResource.update({ content_id: details.id }, this._setMenuContentDetails(details)).$promise;

            return promise.then(function (details) {
                return details;
            }).catch(function (error) {
                throw _this.apiService.getErrorMessage(error);
            });
        }
    }, {
        key: 'getEditorContentDetailsObject',
        value: function getEditorContentDetailsObject(details, menuName) {
            return {
                menuOverviewDetails: this._getMenuOverviewDetails(details.data.menuOverviewDetails),
                menuContentDetails: this._getMenuContentDetails((0, _find2.default)(details.data.content, ['name', menuName]).values[0])
            };
        }

        // ***************************************************************Private Methods **************************************************************

    }, {
        key: '_setResourceUrl',
        value: function _setResourceUrl(moduleName) {
            this.editorEditResourceUrl = this.apiService.getResourceUrl('cms/editor-content/' + moduleName + '/:content_id');
            this.editorEditResource = this.$resource(this.editorEditResourceUrl, null, {
                update: {
                    method: 'PUT'
                }
            });
        }
    }, {
        key: '_setMenuContentDetails',
        value: function _setMenuContentDetails(value) {
            return {
                description: value.description,
                images: value.images || [],
                videos: value.videos || []
            };
        }
    }, {
        key: '_getMenuOverviewDetails',
        value: function _getMenuOverviewDetails(details) {
            return _defineProperty({
                id: details.content_id,
                displayName: details.display_name,
                title: details.title,
                description: details.description,
                overview: details.overview,
                image: details.image,
                name: details.name
            }, 'overview', details.overview);
        }
    }, {
        key: '_getMenuContentDetails',
        value: function _getMenuContentDetails(value) {
            return {
                id: value.content_id,
                description: value.description,
                images: this._getContentImagesObject(value.images) || [],
                videos: value.videos || []
            };
        }
    }, {
        key: '_getContentImagesObject',
        value: function _getContentImagesObject(values) {
            return values ? values.map(function (_ref2) {
                var uuid = _ref2.uuid;
                return { uuid: uuid, status: -1 };
            }) : [];
        }
    }]);

    return EditorTemplateService;
}();

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var homeBannerAddComponent = exports.homeBannerAddComponent = {

	//passing title and onSubmit function for binding in main component
	template: '\n\t\t<home-banner-main \n\t\t\tpage-title=\'Add Banner\'\n\t\t\tparent-slug=\'{{$ctrl.parentSlug}}\' \n\t\t\tdisable-buttons=\'$ctrl.disableButtons\'\n\t\t\ton-submit=\'$ctrl.onSubmit(details)\'>\n\t\t</home-banner-main>',

	bindings: {
		parentSlug: '@',
		slugUrl: '@'
	},

	//controller for HomeBannerAddComponent
	controller: function () {
		HomeBannerAddComponent.$inject = ["$stateParams", "toastr", "$state", "HomeBannerService", "DynamicMenusService", "SlugService"];
		function HomeBannerAddComponent($stateParams, toastr, $state, HomeBannerService, DynamicMenusService, SlugService) {
			'ngInject';

			_classCallCheck(this, HomeBannerAddComponent);

			this.$stateParams = $stateParams;
			this.toastr = toastr;
			this.$state = $state;
			this.homeBannerService = HomeBannerService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		//function to add class details


		_createClass(HomeBannerAddComponent, [{
			key: 'onSubmit',
			value: function onSubmit(details) {
				var _this = this;

				this.disableButtons = true;
				var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'add');
				details = this.homeBannerService._setBannerObject(details);

				// submit the request
				this.dynamicMenusService.addMenuDetailsByUrl(url, details).then(function (details) {
					_this.toastr.success('Banner added successfully');
					_this._redirectToParentState(_this.parentSlug);
					_this.disableButtons = false;
				}).catch(function (err) {
					_this.toastr.error(err);
					_this.disableButtons = false;
				});
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return HomeBannerAddComponent;
	}()
};

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.homeBannerAdd = undefined;

var _homeBannerAdd = __webpack_require__(591);

var homeBannerAdd = exports.homeBannerAdd = angular.module('components.homeBanner.homeBannerAdd', []).component('homeBannerAdd', _homeBannerAdd.homeBannerAddComponent).name;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.homeBannerEditSequenceComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _homeBannerEditSequence = __webpack_require__(770);

var _homeBannerEditSequence2 = _interopRequireDefault(_homeBannerEditSequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var homeBannerEditSequenceComponent = exports.homeBannerEditSequenceComponent = {
	bindings: {
		details: '<',
		parentSlug: '@',
		slugUrl: '@'
	},

	templateUrl: _homeBannerEditSequence2.default,

	controller: function () {
		HomeBannerEditSequenceComponent.$inject = ["$state", "toastr", "ModalService", "HomeBannerService", "CompareObjectService"];
		function HomeBannerEditSequenceComponent($state, toastr, ModalService, HomeBannerService, CompareObjectService) {
			'ngInject';

			_classCallCheck(this, HomeBannerEditSequenceComponent);

			this.$state = $state;
			this._toastr = toastr;
			this.modalService = ModalService;
			this.homeBannerService = HomeBannerService;
			this.compareObjectService = CompareObjectService;
		}

		_createClass(HomeBannerEditSequenceComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.homeBannerService.getHomeBannerEditSequence(this.details);
				this.saveData = angular.copy(this.details);
			}

			//after submit set new sort Order

		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				var obj = angular.copy(this.details);
				obj.map(function (item, index) {
					item.sortOrder = _this.saveData[index].sortOrder;
					return item;
				});
				this.homeBannerService.setHomeBannerEditSequence(obj).then(function (result) {
					_this._toastr.success("Content Sequence Changed");
					_this._redirectToParentState(_this.parentSlug);
				}).catch(function (err) {
					_this._toastr.error("something went wrong");
				});
			}

			//on cancel page must redirect to home banner page

		}, {
			key: 'onCancel',
			value: function onCancel() {
				var _details = angular.copy(this.details);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},
						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: _onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}

				function _onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return HomeBannerEditSequenceComponent;
	}()
};

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.homeBannerEditSequence = undefined;

var _homeBannerEditSequence = __webpack_require__(593);

var homeBannerEditSequence = exports.homeBannerEditSequence = angular.module('components.homeBanner.homeBannerEditSequence', []).component('homeBannerEditSequence', _homeBannerEditSequence.homeBannerEditSequenceComponent).name;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var homeBannerEditComponent = exports.homeBannerEditComponent = {

	//passing title and onSubmit function for binding in main component
	template: '\n\t\t<home-banner-main \n\t\t\tpage-title=\'Edit Banner\' \n\t\t\tdetails=\'$ctrl.details\'\n\t\t\tparent-slug=\'{{$ctrl.parentSlug}}\'\n\t\t\tdisable-buttons=\'$ctrl.disableButtons\'\n\t\t\ton-submit=\'$ctrl.onSubmit(details)\'>\n\t\t</home-banner-main>',

	bindings: {
		details: '<',
		parentSlug: '@',
		slugUrl: '@'
	},

	//controller for HomeBannerEditComponent
	controller: function () {
		HomeBannerEditComponent.$inject = ["toastr", "$state", "$stateParams", "HomeBannerService", "CompareObjectService", "DynamicMenusService"];
		function HomeBannerEditComponent(toastr, $state, $stateParams, HomeBannerService, CompareObjectService, DynamicMenusService) {
			'ngInject';

			_classCallCheck(this, HomeBannerEditComponent);

			this.toastr = toastr;
			this.$state = $state;
			this.$stateParams = $stateParams;
			this.homeBannerService = HomeBannerService;
			this.compareObjectService = CompareObjectService;
			this.dynamicMenusService = DynamicMenusService;
		}

		//storing old data in savedData


		_createClass(HomeBannerEditComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.homeBannerService.getBannerDetailsById(this.details);
				this.savedData = angular.copy(this.details);
			}

			//comparing old and new data for update on submit function

		}, {
			key: 'onSubmit',
			value: function onSubmit(details) {
				var _this = this;

				var _details = angular.copy(details);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, _details, true);
				if (isUpdated) {
					_details = this.homeBannerService._setBannerObject(_details);

					this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, _details).then(function (details) {
						_this.toastr.success('Banner updated successfully');
						_this._redirectToParentState(_this.parentSlug);
						_this.disableButtons = false;
					}).catch(function (err) {
						_this.toastr.error(err);
						_this.disableButtons = false;
					});
				} else {
					this.toastr.success('Nothing to update');
					this._redirectToParentState(this.parentSlug);
					this.disableButtons = false;
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return HomeBannerEditComponent;
	}()
};

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.homeBannerEdit = undefined;

var _homeBannerEdit = __webpack_require__(595);

var homeBannerEdit = exports.homeBannerEdit = angular.module('components.homeBanner.homeBannerEdit', []).component('homeBannerEdit', _homeBannerEdit.homeBannerEditComponent).name;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.homeBannerListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _homeBannerList = __webpack_require__(771);

var _homeBannerList2 = _interopRequireDefault(_homeBannerList);

var _homeBannerPublishTemplate = __webpack_require__(772);

var _homeBannerPublishTemplate2 = _interopRequireDefault(_homeBannerPublishTemplate);

var _homeBannerUnpublishTemplate = __webpack_require__(773);

var _homeBannerUnpublishTemplate2 = _interopRequireDefault(_homeBannerUnpublishTemplate);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var homeBannerListComponent = exports.homeBannerListComponent = {
	templateUrl: _homeBannerList2.default,

	bindings: {
		details: '<',
		slugUrl: '@'
	},

	controller: function () {
		HomeBannerListComponent.$inject = ["$state", "toastr", "ApiService", "ModalService", "HomeBannerService", "DynamicMenusService", "SlugService"];
		function HomeBannerListComponent($state, toastr, ApiService, ModalService, HomeBannerService, DynamicMenusService, SlugService) {
			'ngInject';

			_classCallCheck(this, HomeBannerListComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.apiService = ApiService;
			this.modalService = ModalService;
			this.homeBannerService = HomeBannerService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		_createClass(HomeBannerListComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.homeBannerService.getBannerList(this.details);
				this.step = 1;
				this.tabTemplateUrl = _homeBannerPublishTemplate2.default;
				this.isPublishedClicked = true;
			}
		}, {
			key: 'routeSequencePageUrl',
			value: function routeSequencePageUrl() {
				var url = this.slugService.getSequencePageURL(this.slugUrl);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeAddPageUrl',
			value: function routeAddPageUrl() {
				var url = this.slugService.getAddPageURL(this.slugUrl);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'tabChange',
			value: function tabChange(status) {
				if (status === 'publish') {
					this.tabTemplateUrl = _homeBannerPublishTemplate2.default;
					this.isPublishedClicked = true;
				} else {
					this.tabTemplateUrl = _homeBannerUnpublishTemplate2.default;
					this.isPublishedClicked = false;
				}
			}
		}, {
			key: 'routeEditPageUrl',
			value: function routeEditPageUrl(slug) {
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}

			//on delete the banner

		}, {
			key: 'onDelete',
			value: function onDelete(slug) {
				this.modalService.open({
					details: {
						bodyMessage: 'Are you sure you want to delete the banner?'
					},

					buttons: [{
						name: 'No'
					}, {
						name: 'Yes',
						isPrimary: true,
						action: onSubmit.bind(this)
					}]
				});

				function onSubmit() {
					var _this = this;

					var publishedIndex = '';
					var unpublishedIndex = '';
					this.dynamicMenusService.deleteMenuDetailsByUrl(slug + '/delete').then(function (_ref) {
						var data = _ref.data;

						var publishedIndex = (0, _findIndex2.default)(_this.details.publishedList, ['slug', slug]);
						if (publishedIndex !== -1) {
							_this.details.publishedList = _this.details.publishedList.filter(function (detail) {
								return detail.slug !== slug;
							});
						} else {
							_this.details.unPublishedList = _this.details.unPublishedList.filter(function (detail) {
								return detail.slug !== slug;
							});
						}
						_this.toastr.success("Banner Deleted successfully");
						_this.$state.go('app.dashboard.HomeBanner');
					}).catch(function (err) {
						_this.toastr.error(err);
					});
				}
			}

			//to publish or unpublish the banner

		}, {
			key: 'publishUnpublishBanner',
			value: function publishUnpublishBanner(id, isActive) {
				var _this2 = this;

				var publishedIndex = '';
				var unpublishedIndex = '';
				this.homeBannerService.publishUnpublishBanner(id, isActive).then(function (response) {
					if (isActive) {
						var publishedItem = (0, _find2.default)(_this2.details.publishedList, ['id', id]);
						publishedItem.isActive = false;
						_this2.details.publishedList = _this2.details.publishedList.filter(function (detail) {
							return detail.id !== id;
						});
						_this2.details.unPublishedList.push(publishedItem);
						_this2.tabTemplateUrl = _homeBannerUnpublishTemplate2.default;
						_this2.isPublishedClicked = false;
						_this2.toastr.success("Banner Unublished Successfully");
					} else {
						var unpublishedItem = (0, _find2.default)(_this2.details.unPublishedList, ['id', id]);
						unpublishedItem.isActive = true;
						_this2.details.unPublishedList = _this2.details.unPublishedList.filter(function (detail) {
							return detail.id !== id;
						});
						_this2.details.publishedList.push(unpublishedItem);
						_this2.tabTemplateUrl = _homeBannerPublishTemplate2.default;
						_this2.isPublishedClicked = true;
						_this2.toastr.success("Banner Published Successfully");
					}
					_this2.$state.go('app.dashboard.HomeBanner');
				}).catch(function (err) {
					_this2.toastr.error(err);
				});
			}
		}, {
			key: '_getImage',
			value: function _getImage(detail) {
				var image = detail.image;
				return image ? this.apiService.getResourceUrl('files/images/' + image) : '';
			}
		}]);

		return HomeBannerListComponent;
	}()
};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.homeBannerList = undefined;

var _homeBannerList = __webpack_require__(597);

var homeBannerList = exports.homeBannerList = angular.module('components.homeBanner.homeBannerList', []).component('homeBannerList', _homeBannerList.homeBannerListComponent).name;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.homeBannerMainComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _homeBannerTemplate = __webpack_require__(774);

var _homeBannerTemplate2 = _interopRequireDefault(_homeBannerTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var homeBannerMainComponent = exports.homeBannerMainComponent = {
	templateUrl: _homeBannerTemplate2.default,

	//binding title, details and onSubmit function
	bindings: {
		pageTitle: '@',
		details: '<',
		onSubmit: '&',
		disableButtons: '<',
		parentSlug: '@'
	},

	//controller for HomeBannerMainComponent
	controller: function () {
		HomeBannerMainComponent.$inject = ["$state", "ModalService", "CompareObjectService"];
		function HomeBannerMainComponent($state, ModalService, CompareObjectService) {
			'ngInject';

			_classCallCheck(this, HomeBannerMainComponent);

			this.$state = $state;
			this.modalService = ModalService;
			this.compareObjectService = CompareObjectService;
		}

		_createClass(HomeBannerMainComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.details || {
					title: "",
					description: "",
					buttonText: "",
					url: "",
					image: "",
					ada: {
						banner_image_text: ''
					}
				};
				this.saveData = angular.copy(this.details);
			}
		}, {
			key: 'onCoverPicUpload',
			value: function onCoverPicUpload(_ref) {
				var uuid = _ref.details.uuid;

				this.details.image = uuid;
			}

			//on cancel function

		}, {
			key: 'onCancel',
			value: function onCancel() {
				var _details = angular.copy(this.details);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},

						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}

				function onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}, {
			key: '_onSubmit',
			value: function _onSubmit() {
				this.onSubmit({
					details: this.details
				});
			}
		}]);

		return HomeBannerMainComponent;
	}()
};

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.homeBannerMain = undefined;

var _homeBannerMain = __webpack_require__(599);

var homeBannerMain = exports.homeBannerMain = angular.module('components.homeBanner.homeBannerMain', []).component("homeBannerMain", _homeBannerMain.homeBannerMainComponent).name;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.homeBanner = undefined;

var _homeBannerList = __webpack_require__(598);

var _homeBannerAdd = __webpack_require__(592);

var _homeBannerEdit = __webpack_require__(596);

var _homeBannerMain = __webpack_require__(600);

var _homeBannerEditSequence = __webpack_require__(594);

var _homeBanner = __webpack_require__(602);

__webpack_require__(191);

var homeBanner = exports.homeBanner = angular.module('components.homeBanner', [_homeBannerList.homeBannerList, _homeBannerAdd.homeBannerAdd, _homeBannerEdit.homeBannerEdit, _homeBannerMain.homeBannerMain, _homeBannerEditSequence.homeBannerEditSequence]).service('HomeBannerService', _homeBanner.HomeBannerService).name;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.HomeBannerService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeBannerService = exports.HomeBannerService = function () {
	HomeBannerService.$inject = ["$resource", "ApiService"];
	function HomeBannerService($resource, ApiService) {
		'ngInject';

		_classCallCheck(this, HomeBannerService);

		this.$resource = $resource;
		this.apiService = ApiService;

		this.bannerListResourceUrl = this.apiService.getResourceUrl('cms/menus/home-banner');
		this.bannerAddResourceUrl = this.apiService.getResourceUrl('cms/banner');
		this.bannerEditDeleteGetByIdResourceUrl = this.apiService.getResourceUrl('cms/banner/:content_id');
		this.bannerPublishUnpublishResourceUrl = this.apiService.getResourceUrl('cms/banner/publish/:content_id');
		this.bannerEditSequenceListResourceUrl = this.apiService.getResourceUrl('cms/banner/sequence');

		this.bannerListResource = this.$resource(this.bannerListResourceUrl);
		this.bannerAddResource = this.$resource(this.bannerAddResourceUrl, null, {
			save: {
				method: 'POST'
			}
		});
		this.bannerEditDeleteGetByIdResource = this.$resource(this.bannerEditDeleteGetByIdResourceUrl, null, {
			get: {
				method: 'GET',
				params: {
					content_id: '@content_id'
				}
			},
			update: {
				method: 'PUT',
				params: {
					content_id: '@content_id'
				}
			},
			delete: {
				method: 'DELETE',
				params: {
					content_id: '@content_id'
				}
			}
		});
		this.bannerPublishUnpublishResource = this.$resource(this.bannerPublishUnpublishResourceUrl, null, {
			update: {
				method: 'PUT',
				params: {
					content_id: '@content_id'
				}
			}
		});
		this.bannerEditSequenceListResource = this.$resource(this.bannerEditSequenceListResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
	}

	_createClass(HomeBannerService, [{
		key: '_getContentDetails',
		value: function _getContentDetails(content) {
			return content.reduce(function (list, value) {
				if (value.name === 'HomeBanner') {
					var publishedList = (0, _filter2.default)(value.values, 'is_active');
					var unPublishedList = (0, _filter2.default)(value.values, ['is_active', false]);

					list.publishedList = list.concat(_getListDetails(publishedList));
					list.unPublishedList = list.concat(_getListDetails(unPublishedList));
				}
				return list;
			}, []);

			function _getListDetails(data) {
				return data.map(function (value) {
					return {
						id: value.content_id,
						sortOrder: value.sort_order,
						isActive: value.is_active,
						title: value.details.title,
						image: value.details.image,
						url: value.details.url,
						description: value.details.description,
						buttonText: value.details.button_text,
						slug: value.slug || ""
					};
				});
			}
		}
	}, {
		key: '_getBannerObject',
		value: function _getBannerObject(value) {
			return {
				url: value.url,
				title: value.title,
				description: value.description,
				buttonText: value.button_text,
				image: value.image,
				ada: value.ada || {}
			};
		}
	}, {
		key: '_setBannerObject',
		value: function _setBannerObject(value) {
			return {
				url: value.url,
				title: value.title,
				description: value.description,
				button_text: value.buttonText,
				image: value.image,
				ada: value.ada || {}
			};
		}

		//get content sequence object for display

	}, {
		key: '_getContentSequence',
		value: function _getContentSequence(value) {
			return value.map(function (content) {
				return {
					id: content.content_id,
					sortOrder: content.sort_order,
					title: content.title
				};
			});
		}

		//set content sequence object for update

	}, {
		key: '_setContentSequence',
		value: function _setContentSequence(value) {
			return value.map(function (content) {
				return {
					content_id: content.id,
					sort_order: content.sortOrder,
					title: content.title
				};
			});
		}

		/**
   * function to get banner list
   * @return {object} [information related to banner list]
   */
		// getBannerList() {
		// 	const promise = this.bannerListResource.get().$promise;

		// 	return promise.then(details => this._getContentDetails(details.data.content))
		// 	.catch((error) => {
		// 		throw this.apiService.getErrorMessage(error);
		// 	});
		// }

	}, {
		key: 'getBannerList',
		value: function getBannerList(details) {
			return this._getContentDetails(details.data.content);
		}

		// getBannerDetailsById(id) {
		// 	const promise = this.bannerEditDeleteGetByIdResource.get({
		// 		content_id: id
		// 	}).$promise;

		// 	return promise.then(details => this._getBannerObject(details.data))
		// 		.catch((error) => {
		// 			throw this.apiService.getErrorMessage(error);
		// 		});
		// }

	}, {
		key: 'getBannerDetailsById',
		value: function getBannerDetailsById(details) {
			return this._getBannerObject(details.data);
		}

		/**
   * function to add banner
   * @return {object} [information related to banner for add]
   */
		// addBanner(details) {
		// 	const promise = this.bannerAddResource.save(this._setBannerObject(details)).$promise;

		// 	return promise.then(details => details.data)
		// 		.catch((error) => {
		// 			throw this.apiService.getErrorMessage(error);
		// 		});
		// }

		/**
   * function to edit banner
   * @return {object} [information related to banner for edit]
   */
		// updateBanner(details, id) {
		// 	const promise = this.bannerEditDeleteGetByIdResource.update({
		// 		content_id: id
		// 	}, this._setBannerObject(details)).$promise;

		// 	return promise.then(details => details.data)
		// 		.catch((error) => {
		// 			throw this.apiService.getErrorMessage(error);
		// 		});
		// }

		/**
   * function to delete banner
   * @return {object} [information related to banner for delete]
   */
		// deleteBanner(id) {
		// 	const promise = this.bannerEditDeleteGetByIdResource.delete({ content_id: id }).$promise;

		// 	return promise.then(details => details.data)
		// 		.catch((err) => {
		// 			throw this.apiService.getErrorMessage(err);
		// 		});
		// }

		/**
   * function to publish/unpublish banner
   * @return {object} [information related to banner for publish/unpublish]
   */

	}, {
		key: 'publishUnpublishBanner',
		value: function publishUnpublishBanner(id, isActive) {
			var _this = this;

			var promise = this.bannerPublishUnpublishResource.update({
				content_id: id
			}, { is_active: isActive }).$promise;

			return promise.then(function (details) {
				return _this._getContentDetails(details.data);
			}).catch(function (error) {
				throw _this.apiService.getErrorMessage(error);
			});
		}

		//get content sequence service
		// getHomeBannerEditSequence() {
		// 	const promise = this.bannerEditSequenceListResource.get().$promise;

		// 	return promise.then((details) => {
		// 		return this._getContentSequence(details.data);
		// 	});
		// }

	}, {
		key: 'getHomeBannerEditSequence',
		value: function getHomeBannerEditSequence(_ref) {
			var values = _ref.data.content.values;

			return this._getContentSequence(values);
		}

		//update content sequence service

	}, {
		key: 'setHomeBannerEditSequence',
		value: function setHomeBannerEditSequence(sequenceObj) {
			var obj = {};
			obj.sequence = this._setContentSequence(sequenceObj);

			var promise = this.bannerEditSequenceListResource.update(obj).$promise;

			return promise.then(function (response) {
				return response;
			});
		}
	}]);

	return HomeBannerService;
}();

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});
exports.menuListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _menuList = __webpack_require__(775);

var _menuList2 = _interopRequireDefault(_menuList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var menuListComponent = exports.menuListComponent = {
				bindings: {
								details: '<',
								slugUrl: '@',
								menuName: '@',
								menuId: '@'
				},

				templateUrl: _menuList2.default,

				controller: function () {
								MenuListComponent.$inject = ["$state", "MenuListService", "DashboardService"];
								function MenuListComponent($state, MenuListService, DashboardService) {
												'ngInject';

												_classCallCheck(this, MenuListComponent);

												this.$state = $state;
												this.menuListService = MenuListService;
												this.dashboardService = DashboardService;
								}

								_createClass(MenuListComponent, [{
												key: '$onInit',
												value: function $onInit() {
																this.details = this.menuListService.getMenuListDetails(this.details);
																this.activeMenuName = this.dashboardService.getActiveMenuName();
																this.details.pageTitle = this.activeMenuName + ' List';
												}
								}]);

								return MenuListComponent;
				}()
};

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.menuList = undefined;

var _menuList = __webpack_require__(603);

var _menuList2 = __webpack_require__(605);

var menuList = exports.menuList = angular.module('components.menuList', []).component('menuList', _menuList.menuListComponent).service('MenuListService', _menuList2.MenuListService).name;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MenuListService = exports.MenuListService = function () {
    MenuListService.$inject = ["$resource", "ApiService"];
    function MenuListService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, MenuListService);

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    _createClass(MenuListService, [{
        key: 'getMenuListDetails',
        value: function getMenuListDetails(details) {
            return {
                overview: this._getOverviewDetails(details.data.menuOverviewDetails),
                list: this._getContentDetails(details.data.children)
            };
        }

        //************************************************Private Methods*********************** */


    }, {
        key: '_getOverviewDetails',
        value: function _getOverviewDetails(details) {
            return {
                title: details.title,
                description: details.description,
                overview: details.overview,
                image: details.image
            };
        }
    }, {
        key: '_getContentDetails',
        value: function _getContentDetails(content) {
            return content.map(function (_ref) {
                var title = _ref.title,
                    overview = _ref.overview,
                    description = _ref.description,
                    name = _ref.name,
                    slug = _ref.slug;
                return { title: title, overview: overview, description: description, name: name, slug: slug };
            });
        }
    }]);

    return MenuListService;
}();

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.menuSequenceComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _menuSequence = __webpack_require__(776);

var _menuSequence2 = _interopRequireDefault(_menuSequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var menuSequenceComponent = exports.menuSequenceComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        menuName: '@',
        parentSlug: '@'
    },

    templateUrl: _menuSequence2.default,

    controller: function () {
        MenuSequenceComponent.$inject = ["$state", "toastr", "ModalService", "MenuSequenceService", "CompareObjectService"];
        function MenuSequenceComponent($state, toastr, ModalService, MenuSequenceService, CompareObjectService) {
            'ngInject';

            _classCallCheck(this, MenuSequenceComponent);

            this.$state = $state;
            this._toastr = toastr;
            this.modalService = ModalService;
            this.menuSequenceService = MenuSequenceService;
            this.compareObjectService = CompareObjectService;
        }

        _createClass(MenuSequenceComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = this.menuSequenceService.getMenuSequence(this.details);
                this.saveData = angular.copy(this.details);
            }

            //after submit set new sort Order

        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                var _this = this;

                var obj = angular.copy(this.details);
                obj.map(function (item, index) {
                    item.sortOrder = _this.saveData[index].sortOrder;
                    return item;
                });
                this.menuSequenceService.updateMenuSequence(obj, this.menuName).then(function (result) {
                    _this._toastr.success("Content Sequence Changed");
                    _this._redirectToParentState(_this.parentSlug);
                }).catch(function (err) {
                    _this._toastr.error("something went wrong");
                });
            }

            //on cancel page must redirect to home banner page

        }, {
            key: 'onCancel',
            value: function onCancel() {
                var _details = angular.copy(this.details);
                var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
                if (isUpdated) {
                    this.modalService.open({
                        details: {
                            bodyMessage: 'Changes done will be reverted. Continue?'
                        },
                        buttons: [{
                            name: 'No'
                        }, {
                            name: 'Yes',
                            isPrimary: true,
                            action: _onSubmit.bind(this)
                        }]
                    });
                } else {
                    this._redirectToParentState(this.parentSlug);
                }

                function _onSubmit() {
                    this._redirectToParentState(this.parentSlug);
                }
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }]);

        return MenuSequenceComponent;
    }()
};

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.menuSequence = undefined;

var _menuSequence = __webpack_require__(606);

var _menuSequence2 = __webpack_require__(608);

var menuSequence = exports.menuSequence = angular.module('components.menuSequence', []).component('menuSequence', _menuSequence.menuSequenceComponent).service('MenuSequenceService', _menuSequence2.MenuSequenceService).name;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MenuSequenceService = exports.MenuSequenceService = function () {
    MenuSequenceService.$inject = ["$resource", "ApiService"];
    function MenuSequenceService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, MenuSequenceService);

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    _createClass(MenuSequenceService, [{
        key: 'getMenuSequence',
        value: function getMenuSequence(details) {
            return this._getContentSequence(details.data);
        }
    }, {
        key: 'updateMenuSequence',
        value: function updateMenuSequence(sequenceObj, moduleName) {
            this._setResourceUrl(moduleName);
            var promise = this.menuSequenceResource.update(this._setContentSequence(sequenceObj)).$promise;

            return promise.then(function (response) {
                return response;
            });
        }

        //**********************************************************Private Methods******************************** */

    }, {
        key: '_setResourceUrl',
        value: function _setResourceUrl(moduleName) {
            this.menuSequenceResourceUrl = this.apiService.getResourceUrl('cms/menus/${moduleName}/sequence');
            this.menuSequenceResource = this.$resource(this.menuSequenceResourceUrl, null, {
                update: {
                    method: 'PUT'
                }
            });
        }
    }, {
        key: '_getContentSequence',
        value: function _getContentSequence(_ref) {
            var values = _ref.content.values;

            return values.map(function (content) {
                return {
                    id: content.menu_id,
                    sortOrder: content.sort_order,
                    title: content.title
                };
            });
        }
    }, {
        key: '_setContentSequence',
        value: function _setContentSequence(value) {
            return value.map(function (content) {
                return {
                    menu_id: content.id,
                    sort_order: content.sortOrder
                };
            });
        }
    }]);

    return MenuSequenceService;
}();

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pagePublishComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _pagePublish = __webpack_require__(777);

var _pagePublish2 = _interopRequireDefault(_pagePublish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var pagePublishComponent = exports.pagePublishComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        menuName: '@',
        parentSlug: '@',
        parentName: '@'
    },

    templateUrl: _pagePublish2.default,

    controller: function () {
        PagePublishComponent.$inject = ["$state", "toastr", "ModalService", "PagePublishService", "CompareObjectService"];
        function PagePublishComponent($state, toastr, ModalService, PagePublishService, CompareObjectService) {
            'ngInject';

            _classCallCheck(this, PagePublishComponent);

            this.$state = $state;
            this._toastr = toastr;
            this.modalService = ModalService;
            this.pagePublishService = PagePublishService;
            this.compareObjectService = CompareObjectService;
        }

        _createClass(PagePublishComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = this.pagePublishService.getPagePublishStatusDetails(this.details);
                this.saveData = angular.copy(this.details);
            }
        }, {
            key: 'onPageStatusListChange',
            value: function onPageStatusListChange(list) {
                this.publishPageStatusList = list;
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                var _this = this;

                this.pagePublishService.setPublishPageList(this.parentName, this.publishPageStatusList).then(function (result) {
                    _this._toastr.success("Page Status Changed");
                    _this._redirectToParentState(_this.parentSlug);
                }).catch(function (err) {
                    return _this._toastr.error(err);
                });
            }

            //on cancel page must redirect to home banner page

        }, {
            key: 'onCancel',
            value: function onCancel() {
                var _details = angular.copy(this.details);
                var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
                if (isUpdated) {
                    this.modalService.open({
                        details: {
                            bodyMessage: 'Changes done will be reverted. Continue?'
                        },
                        buttons: [{
                            name: 'No'
                        }, {
                            name: 'Yes',
                            isPrimary: true,
                            action: _onSubmit.bind(this)
                        }]
                    });
                } else {
                    this._redirectToParentState(this.parentSlug);
                }

                function _onSubmit() {
                    this._redirectToParentState(this.parentSlug);
                }
            }

            //************************************Private Methods************************** */

        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }]);

        return PagePublishComponent;
    }()
};

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pagePublish = undefined;

var _pagePublish = __webpack_require__(609);

var _pagePublish2 = __webpack_require__(611);

var pagePublish = exports.pagePublish = angular.module('components.pagePublish', []).component('pagePublish', _pagePublish.pagePublishComponent).service('PagePublishService', _pagePublish2.PagePublishService).name;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PagePublishService = exports.PagePublishService = function () {
    PagePublishService.$inject = ["$resource", "ApiService"];
    function PagePublishService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, PagePublishService);

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    _createClass(PagePublishService, [{
        key: 'getPagePublishStatusDetails',
        value: function getPagePublishStatusDetails(details) {
            return this._getPublishPageListObject(details.data.content);
        }
    }, {
        key: 'setPublishPageList',
        value: function setPublishPageList(menuName, list) {
            this._setResourceUrl(menuName);
            var promise = this.publishPageResource.update(this._setPublishPageListObject(list)).$promise;

            return promise.then(function (response) {
                return response;
            });
        }

        /*******************************************Private Methods************************************* */

    }, {
        key: '_setResourceUrl',
        value: function _setResourceUrl(menuName) {
            this.publishPageResourceUrl = this.apiService.getResourceUrl('cms/menus/' + menuName + '/publish');
            this.publishPageResource = this.$resource(this.publishPageResourceUrl, null, {
                update: {
                    method: 'PUT'
                }
            });
        }
    }, {
        key: '_getPublishPageListObject',
        value: function _getPublishPageListObject(_ref) {
            var values = _ref.values;

            return values.map(function (value) {
                return {
                    id: value.menu_id,
                    isActive: value.is_active,
                    title: value.title
                };
            });
        }
    }, {
        key: '_setPublishPageListObject',
        value: function _setPublishPageListObject(values) {
            return values.map(function (value) {
                return {
                    menu_id: value.id,
                    is_active: value.isActive
                };
            });
        }
    }]);

    return PagePublishService;
}();

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.paymentMethodsAddComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _paymentMethodsAdd = __webpack_require__(778);

var _paymentMethodsAdd2 = _interopRequireDefault(_paymentMethodsAdd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var paymentMethodsAddComponent = exports.paymentMethodsAddComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl: _paymentMethodsAdd2.default,

    controller: function () {
        PaymentMethodsAddComponent.$inject = ["PaymentMethodsService", "toastr"];
        function PaymentMethodsAddComponent(PaymentMethodsService, toastr) {
            'ngInject';

            _classCallCheck(this, PaymentMethodsAddComponent);

            this.toastr = toastr;
            this.paymentMethodsService = PaymentMethodsService;
        }

        _createClass(PaymentMethodsAddComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = {
                    paymentMethod: ''
                };
                this.disableSaveButton = false;
            }

            /*******************
             * Public Methods
             ***************/

        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                var _this = this;

                this.disableSaveButton = true;
                this.paymentMethodsService.addPaymentMethod(this.details).then(function (_) {
                    _this.toastr.success('Payment Method added successfully');
                    _this.disableSaveButton = false;
                    _this.close();
                }).then(function (_) {
                    return _this.resolve.details.reloadList();
                }).catch(function (err) {
                    _this.toastr.error(err);
                    _this.disableSaveButton = false;
                });
            }
        }]);

        return PaymentMethodsAddComponent;
    }()
};

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.paymentMethodsAdd = undefined;

var _paymentMethodsAdd = __webpack_require__(612);

var paymentMethodsAdd = exports.paymentMethodsAdd = angular.module('components.paymentMethods.paymentMethodsAdd', []).component('paymentMethodsAdd', _paymentMethodsAdd.paymentMethodsAddComponent).name;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.paymentMethodsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _paymentMethods = __webpack_require__(779);

var _paymentMethods2 = _interopRequireDefault(_paymentMethods);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var paymentMethodsComponent = exports.paymentMethodsComponent = {
    bindings: {
        details: '<'
    },

    templateUrl: _paymentMethods2.default,

    controller: function () {
        PaymentMethodsComponent.$inject = ["$state", "toastr", "CompareObjectService", "ModalService", "PaymentMethodsService"];
        function PaymentMethodsComponent($state, toastr, CompareObjectService, ModalService, PaymentMethodsService) {
            'ngInject';

            _classCallCheck(this, PaymentMethodsComponent);

            this.$state = $state;
            this.toastr = toastr;
            this.compareObjectService = CompareObjectService;
            this.modalService = ModalService;
            this.paymentMethodsService = PaymentMethodsService;
        }

        _createClass(PaymentMethodsComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.paymentMethods = this.paymentMethodsService.getPaymentMethods(this.details);
                this.pageTitle = "Edit Payment Method";

                this.details = {
                    paymentMethod: ''
                };
            }
        }, {
            key: 'onPaymentMethodsAdd',
            value: function onPaymentMethodsAdd() {
                var _this = this;

                this.modalService.open({
                    backdrop: 'static',
                    keyboard: false,
                    component: 'paymentMethodsAdd',
                    details: {
                        reloadList: function reloadList() {
                            _this.$state.reload();
                        }
                    }
                });
            }
        }]);

        return PaymentMethodsComponent;
    }()
};

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.paymentMethods = undefined;

var _paymentMethodsAdd = __webpack_require__(613);

var _paymentMethods = __webpack_require__(614);

var _paymentMethods2 = __webpack_require__(616);

__webpack_require__(192);

var paymentMethods = exports.paymentMethods = angular.module('components.PaymentMethods', [_paymentMethodsAdd.paymentMethodsAdd]).service('PaymentMethodsService', _paymentMethods2.PaymentMethodsService).component('paymentMethods', _paymentMethods.paymentMethodsComponent).name;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentMethodsService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentMethodsService = exports.PaymentMethodsService = function () {
    PaymentMethodsService.$inject = ["$resource", "ApiService"];
    function PaymentMethodsService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, PaymentMethodsService);

        this.$resource = $resource;
        this.apiService = ApiService;

        this.paymentMethodsListResourceUrl = this.apiService.getResourceUrl('cms/payment-methods');
        this.paymentMethodsListResource = this.$resource(this.paymentMethodsListResourceUrl);
    }

    _createClass(PaymentMethodsService, [{
        key: 'getPaymentMethods',
        value: function getPaymentMethods(_ref) {
            var data = _ref.data;

            return this._getPaymentMethodObject((0, _find2.default)(data.content, ['name', 'PaymentMethods']).values);
        }
    }, {
        key: 'addPaymentMethod',
        value: function addPaymentMethod(_ref2) {
            var _this = this;

            var payment_method = _ref2.paymentMethod;

            var promise = this.paymentMethodsListResource.save({ payment_method: payment_method }).$promise;

            return promise.then(function (details) {
                return details;
            }).catch(function (err) {
                throw _this.apiService.getErrorMessage(err);
            });
        }
    }, {
        key: '_getPaymentMethodObject',
        value: function _getPaymentMethodObject(values) {
            return values.map(function (value) {
                return {
                    id: value.payment_method_id,
                    name: value.payment_method
                };
            });
        }
    }]);

    return PaymentMethodsService;
}();

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.planningResources = undefined;

var _referenceMap = __webpack_require__(620);

var _planningResources = __webpack_require__(618);

__webpack_require__(193);

var planningResources = exports.planningResources = angular.module('components.planningResources', [_referenceMap.referenceMap]).service('PlanningResourcesService', _planningResources.PlanningResourcesService).name;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PlanningResourcesService = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angularUiRouter = __webpack_require__(56);

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PlanningResourcesService = exports.PlanningResourcesService = function () {
	PlanningResourcesService.$inject = ["$resource", "ApiService", "$cookies", "Upload"];
	function PlanningResourcesService($resource, ApiService, $cookies, Upload) {
		'ngInject';

		_classCallCheck(this, PlanningResourcesService);

		this.$resource = $resource;
		this.apiService = ApiService;
		this.$cookies = $cookies;
		this._upload = Upload;

		this.planningResourcesListResourceUrl = this.apiService.getResourceUrl('cms/menus/PlanningResources');
		this.planningResourcesOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/PlanningResources');
		this.planningResourcesSequenceResourceUrl = this.apiService.getResourceUrl('cms/menus/PlanningResources/sequence');
		this.planningResourcesPublishPageResourceUrl = this.apiService.getResourceUrl('cms/menus/PlanningResources/publish');
		this.planningResourcesDataMapplingToolListResourceUrl = this.apiService.getResourceUrl('cms/menus/DataMappingTool');
		this.planningResourcesDataMappingToolOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/DataMappingTool');
		this.planningResourcesDataMappingToolSequenceResourceUrl = this.apiService.getResourceUrl('cms/menus/DataMappingTool/sequence');
		this.planningResourcesCensusDataListResourceUrl = this.apiService.getResourceUrl('cms/menus/CensusData');
		this.planningResourcesDataMappingToolCensusDataOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/CensusData');
		this.planningResourceCensusDataUploadUrl = this.apiService.getResourceUrl('cms/census-data/upload');
		this.planningResourcesCensusDataPreviewResourceUrl = this.apiService.getResourceUrl('cms/census-data/:preview_id');
		this.planningResourcesCensusDataAddResourceUrl = this.apiService.getResourceUrl('cms/census-data');
		this.planningResourcesDataMappingToolCensusDataFiscleYearListResourceUrl = this.apiService.getResourceUrl('fiscal-year');
		this.planningResourceMobilityManagementDownloadTemplateResourceUrl = this.apiService.getResourceUrl('files/template/program-service-area');
		/**
   * mobility Management
   * 
   */
		this.planningResourceMobilityManagementUploadUrl = this.apiService.getResourceUrl('cms/program-service-area/upload');
		this.planningResourcesMobilityManagementListResourceUrl = this.apiService.getResourceUrl('cms/menus/ProgramServiceAreas');
		this.planningResourcesDataMappingToolMobiltyManagmentOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/ProgramServiceAreas');
		this.planningResourcesMobilityManagementAddResourceUrl = this.apiService.getResourceUrl('cms/program-service-area');
		this.planningResourcesMobilityManagementPreviewResourceUrl = this.apiService.getResourceUrl('cms/program-service-area/:preview_id');
		/**
   * transportation plans
   * 
   */
		this.planningResourcesTransportationPlansListResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationPlans');
		this.planningResourcesTransportationPlansOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/TransportationPlans');
		this.planningResourcesTransportationPlansDetailsResourceUrl = this.apiService.getResourceUrl('cms/transportation-plan/:id');
		this.planningResourcesFtaFactSheetsAndCircularsListResourceUrl = this.apiService.getResourceUrl('cms/menus/FtaFactSheetsAndCirculars');
		this.planningResourcesFtaFactSheetsAndCircularsDetailsResourceUrl = this.apiService.getResourceUrl('cms/fta-fact-sheets/:id');
		this.planningResourcesFtaFactSheetsAndCircularsOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/FtaFactSheetsAndCirculars');
		this.volunteerTransportationProgramsResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/VolunteerTransportationPrograms');
		this.transportationServicesResourceUrl = this.apiService.getResourceUrl('cms/mengetGs/overview/TransportationServices');
		this.getGrantApplicationsResourceUrl = this.apiService.getResourceUrl('cms/menus/GrantApplications');
		this.grantApplicationsEditResourceUrl = this.apiService.getResourceUrl('cms/grant-applications/:content_id');
		this.getOtherReferenceMaterialsFundingResourceUrl = this.apiService.getResourceUrl('cms/menus/OtherReferenceMaterialsFunding');
		this.otherReferenceMaterialsFundingEditResourceUrl = this.apiService.getResourceUrl('cms/reference-materials-funding/:content_id');
		this.getTransportationLinksResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationLinks');
		this.getIndustryResourceUrl = this.apiService.getResourceUrl('cms/menus/Industry');
		this.transportationLinksEditResourceUrl = this.apiService.getResourceUrl('cms/transportation-links/:content_id');
		this.industryEditResourceUrl = this.apiService.getResourceUrl('cms/industry/:content_id');

		this.planningResourcesMobilityManagementListResource = this.$resource(this.planningResourcesMobilityManagementListResourceUrl);
		this.planningResourcesListResource = this.$resource(this.planningResourcesListResourceUrl);
		this.planningResourcesDataMapplingToolListResource = this.$resource(this.planningResourcesDataMapplingToolListResourceUrl);
		this.planningResourcesCensusDataListResource = this.$resource(this.planningResourcesCensusDataListResourceUrl);
		this.planningResourcesDataMappingToolCensusDataFiscleYearListResource = this.$resource(this.planningResourcesDataMappingToolCensusDataFiscleYearListResourceUrl);
		this.planningResourcesCensusDataPreviewResource = this.$resource(this.planningResourcesCensusDataPreviewResourceUrl);
		this.planningResourcesCensusDataAddResource = this.$resource(this.planningResourcesCensusDataAddResourceUrl);
		this.planningResourcesMobilityManagementAddResource = this.$resource(this.planningResourcesMobilityManagementAddResourceUrl);
		this.planningResourcesMobilityManagementPreviewResource = this.$resource(this.planningResourcesMobilityManagementPreviewResourceUrl);
		this.planningResourcesTransportationPlansListResource = this.$resource(this.planningResourcesTransportationPlansListResourceUrl);

		this.referenceMapEditResourceUrl = this.apiService.getResourceUrl('cms/reference-map/:content_id');
		this.referenceMapEditResource = this.$resource(this.referenceMapEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.planningResourcesFtaFactSheetsAndCircularsListResource = this.$resource(this.planningResourcesFtaFactSheetsAndCircularsListResourceUrl);
		this.getIndustryResource = this.$resource(this.getIndustryResourceUrl);

		this.industryEditResource = this.$resource(this.industryEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.grantApplicationsEditResource = this.$resource(this.grantApplicationsEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.otherReferenceMaterialsFundingEditResource = this.$resource(this.otherReferenceMaterialsFundingEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.transportationLinksEditResource = this.$resource(this.transportationLinksEditResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.planningResourcesOverviewResource = this.$resource(this.planningResourcesOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesSequenceResource = this.$resource(this.planningResourcesSequenceResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesPublishPageResource = this.$resource(this.planningResourcesPublishPageResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesDataMappingToolOverviewResource = this.$resource(this.planningResourcesDataMappingToolOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesDataMappingToolSequenceResource = this.$resource(this.planningResourcesDataMappingToolSequenceResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesDataMappingToolCensusDataOverviewResource = this.$resource(this.planningResourcesDataMappingToolCensusDataOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourceMobilityManagementDownloadTemplateResource = this.$resource(this.planningResourceMobilityManagementDownloadTemplateResourceUrl);

		/**
   * mobility Management
   * 
   */
		this.planningResourcesDataMappingToolMobiltyManagmentOverviewResource = this.$resource(this.planningResourcesDataMappingToolMobiltyManagmentOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.planningResourcesTransportationPlansOverviewResource = this.$resource(this.planningResourcesTransportationPlansOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.planningResourcesFtaFactSheetsAndCircularsOverviewResource = this.$resource(this.planningResourcesFtaFactSheetsAndCircularsOverviewResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.planningResourcesFtaFactSheetsAndCircularsDetailsResource = this.$resource(this.planningResourcesFtaFactSheetsAndCircularsDetailsResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
		this.planningResourcesTransportationPlansDetailsResource = this.$resource(this.planningResourcesTransportationPlansDetailsResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.volunteerTransportationProgramsResource = this.$resource(this.volunteerTransportationProgramsResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.transportationServicesResource = this.$resource(this.transportationServicesResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.getGrantApplicationsResource = this.$resource(this.getGrantApplicationsResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.getOtherReferenceMaterialsFundingResource = this.$resource(this.getOtherReferenceMaterialsFundingResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});

		this.getTransportationLinksResource = this.$resource(this.getTransportationLinksResourceUrl, null, {
			update: {
				method: 'PUT'
			}
		});
	}

	/**
  * function for get overview
  * @return {object} 
  */


	_createClass(PlanningResourcesService, [{
		key: '_getOverviewDetails',
		value: function _getOverviewDetails(details) {
			return {
				title: details.title,
				description: details.description,
				image: details.image
			};
		}

		/**
   * function for set overview
   * @return {object} 
   */

	}, {
		key: '_setOverviewObject',
		value: function _setOverviewObject(details) {
			return {
				title: details.title,
				description: details.description,
				image: details.image
			};
		}

		/**
   * function for get list planning resources
   * @return {array} 
   */

	}, {
		key: '_getContentDetails',
		value: function _getContentDetails(content) {
			return content.map(function (_ref) {
				var title = _ref.title,
				    description = _ref.description,
				    name = _ref.name;
				return { title: title, description: description, name: name };
			});
		}

		/**
   * function for get sequence list
   * @return {array} 
   */

	}, {
		key: '_getContentSequence',
		value: function _getContentSequence(value) {
			return value.map(function (content) {
				return {
					id: content.menu_id,
					sortOrder: content.sort_order,
					title: content.title
				};
			});
		}

		/**
   * function for set sequence list
   * @return {array} 
   */

	}, {
		key: '_setContentSequence',
		value: function _setContentSequence(value) {
			return value.map(function (content) {
				return {
					menu_id: content.id,
					sort_order: content.sortOrder
					// title: content.title
				};
			});
		}

		//get publish status object for display

	}, {
		key: '_getPublishPageListObject',
		value: function _getPublishPageListObject(values) {
			return values.map(function (value) {
				return {
					id: value.menu_id,
					isActive: value.is_active,
					title: value.title
				};
			});
		}

		//set publish status object for update

	}, {
		key: '_setPublishPageListObject',
		value: function _setPublishPageListObject(values) {
			return values.map(function (value) {
				return {
					menu_id: value.id,
					is_active: value.isActive
				};
			});
		}

		/**
   * function to get planning resources list
   * @return {object} [information related to planning resources list]
   */

	}, {
		key: 'getPlanningResourcesDetails',
		value: function getPlanningResourcesDetails() {
			var _this = this;

			var promise = this.planningResourcesListResource.get().$promise;

			return promise.then(function (details) {
				return {
					overview: _this._getOverviewDetails(details.data.menuOverviewDetails),
					list: _this._getContentDetails(details.data.children)
				};
			}).catch(function (error) {
				throw _this.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to get planning resources overview
   * @return {object} [information related to planning resources overview]
   */

	}, {
		key: 'getPlanningResourcesOverview',
		value: function getPlanningResourcesOverview() {
			var _this2 = this;

			var promise = this.planningResourcesOverviewResource.get().$promise;

			return promise.then(function (details) {
				return _this2._getOverviewDetails(details.data);
			}).catch(function (error) {
				throw _this2.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to edit planning resources overview
   * @return {object} [information related to planning resources overview for edit]
   */

	}, {
		key: 'updatePlanningResourcesOverview',
		value: function updatePlanningResourcesOverview(details) {
			var _this3 = this;

			var promise = this.planningResourcesOverviewResource.update(this._setOverviewObject(details)).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this3.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to get planning resources sequence list
   * @return {object} [information related to planning resources sequence list]
   */

	}, {
		key: 'getPlanningResourcesSequence',
		value: function getPlanningResourcesSequence() {
			var _this4 = this;

			var promise = this.planningResourcesSequenceResource.get().$promise;

			return promise.then(function (details) {
				return _this4._getContentSequence(details.data);
			});
		}

		/**
   * function to edit planning resources sequence
   * @return {object} [information related to planning resources sequence for edit]
   */

	}, {
		key: 'setPlanningResourcesSequence',
		value: function setPlanningResourcesSequence(sequenceObj) {
			var promise = this.planningResourcesSequenceResource.update(this._setContentSequence(sequenceObj)).$promise;

			return promise.then(function (response) {
				return response;
			});
		}

		//get publish status list

	}, {
		key: 'getPlanningResourcesPublishPageList',
		value: function getPlanningResourcesPublishPageList() {
			var _this5 = this;

			var promise = this.planningResourcesPublishPageResource.get().$promise;

			return promise.then(function (details) {
				return _this5._getPublishPageListObject(details.data);
			});
		}

		//update publish status list

	}, {
		key: 'setPlanningResourcesPublishPageList',
		value: function setPlanningResourcesPublishPageList(list) {
			var promise = this.planningResourcesPublishPageResource.update(this._setPublishPageListObject(list)).$promise;

			return promise.then(function (response) {
				return response;
			});
		}

		/**
   * function to get planning resources Data mapping Tool list
   * @return {object} [information related to planning resources Data mapping Tool list]
   */

	}, {
		key: 'getPlanningResourcesDataMappingToolDetails',
		value: function getPlanningResourcesDataMappingToolDetails() {
			var _this6 = this;

			var promise = this.planningResourcesDataMapplingToolListResource.get().$promise;

			return promise.then(function (details) {
				return {
					overview: _this6._getOverviewDetails(details.data.menuOverviewDetails),
					list: _this6._getContentDetails(details.data.children)
				};
			}).catch(function (error) {
				throw _this6.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to get Data mapping tool overview
   * @return {object} [information related to Data mapping tool overview]
   */

	}, {
		key: 'getDataMappingToolOverview',
		value: function getDataMappingToolOverview() {
			var _this7 = this;

			var promise = this.planningResourcesDataMappingToolOverviewResource.get().$promise;

			return promise.then(function (details) {
				return _this7._getOverviewDetails(details.data);
			}).catch(function (error) {
				throw _this7.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to edit data Mapping tool overview
   * @return {object} [information related to data Mapping tool overview for edit]
   */

	}, {
		key: 'updateDataMappingToolOverview',
		value: function updateDataMappingToolOverview(details) {
			var _this8 = this;

			var promise = this.planningResourcesDataMappingToolOverviewResource.update(this._setOverviewObject(details)).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this8.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to get data mapping tool sequence list
   * @return {object} [information related to planning resources sequence list]
   */

	}, {
		key: 'getDataMappingToolSequence',
		value: function getDataMappingToolSequence() {
			var _this9 = this;

			var promise = this.planningResourcesDataMappingToolSequenceResource.get().$promise;

			return promise.then(function (details) {
				return _this9._getContentSequence(details.data);
			}).catch(function (error) {
				throw _this9.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to edit planning resources sequence
   * @return {object} [information related to planning resources sequence for edit]
   */

	}, {
		key: 'setDataMappingToolSequence',
		value: function setDataMappingToolSequence(sequenceObj) {
			var promise = this.planningResourcesDataMappingToolSequenceResource.update(this._setContentSequence(sequenceObj)).$promise;

			return promise.then(function (response) {
				return response;
			});
		}

		/**
   * function to get year list
   * @return {array} [information related available years list]
   */

	}, {
		key: 'geFiscleYearList',
		value: function geFiscleYearList(list) {
			return list.map(function (value) {
				return {
					id: value.fiscal_year_id,
					name: value.fiscal_year
				};
			});
		}

		/**
   * function to get census data map details list
   * @return {array} [information related census data map]
   */

	}, {
		key: '_getMapDetail',
		value: function _getMapDetail(list) {
			var _this10 = this;

			return list.map(function (value) {
				return {
					name: value.county_name,
					ownerOccupied: value.owner_occupied ? _this10._getVehiclesCountObject(value.owner_occupied) : {},
					renterOccupied: value.renter_occupied ? _this10._getVehiclesCountObject(value.renter_occupied) : {}
				};
			});
		}

		/**
   * function to get info related map
   * @return {object} [information related map]
   */

	}, {
		key: '_getVehiclesCountObject',
		value: function _getVehiclesCountObject(value) {
			return {
				oneVehicle: parseInt(value['1_vehicle']),
				noVehicle: parseInt(value['no_vehicle'])
			};
		}

		/**
   * function to get census data list
   * @return {array} [information census data  list]
   */

	}, {
		key: '_getCensusDataList',
		value: function _getCensusDataList(list) {
			var _this11 = this;

			return list.map(function (value) {
				return {
					uuid: value.uuid,
					fileName: value.mask_name,
					fiscleYear: value.fiscal_year,
					url: _this11.apiService.getResourceUrl('files/excel/' + value.uuid)
				};
			});
		}
	}, {
		key: '_getProgressDetails',
		value: function _getProgressDetails(list) {
			var _this12 = this;

			return list.map(function (value) {
				return {
					id: value.content_id,
					title: value.title,
					pdf: _this12.apiService.getResourceUrl('files/pdf/' + value.pdf),
					image: _this12.apiService.getImageUrl(value.image)
				};
			});
		}
	}, {
		key: '_getMobilityMapDetail',
		value: function _getMobilityMapDetail(list) {
			return list.map(function (_ref2) {
				var county_name = _ref2.county_name,
				    name = _ref2.name,
				    description = _ref2.description;
				return { countyName: county_name, description: description, name: name };
			});
		}
	}, {
		key: '_getMobiltyManagmentFileDetails',
		value: function _getMobiltyManagmentFileDetails(value) {
			return {
				maskName: value.mask_name,
				name: value.name,
				uuid: value.uuid,
				url: this.apiService.getResourceUrl('files/excel/' + value.uuid)
			};
		}
	}, {
		key: 'getReportDetailsdata',
		value: function getReportDetailsdata(details) {
			return {
				id: details.content_id,
				title: details.title,
				name: details.mask_name,
				uuid: details.pdf,
				url: this.apiService.getResourceUrl('files/pdf/' + details.pdf),
				image: this.apiService.getImageUrl(details.image)
			};
		}
	}, {
		key: 'setReportDetailsdata',
		value: function setReportDetailsdata(details) {
			return {
				title: details.title,
				pdf: details.uuid
			};
		}

		/**
   * function to get map details for preview
   * @return {object} [information map details for preview]
   */

	}, {
		key: 'getMapDeatilsById',
		value: function getMapDeatilsById(previewId) {
			var _this13 = this;

			var promise = this.planningResourcesCensusDataPreviewResource.get({ preview_id: previewId }).$promise;

			return promise.then(function (details) {
				return _this13._getMapDetail(details.data);
			}).catch(function (error) {
				throw _this13.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to get fiscle years
   * @return {array} [information available fiscle years]
   */

	}, {
		key: 'getFiscleYearList',
		value: function getFiscleYearList() {
			var _this14 = this;

			var promise = this.planningResourcesDataMappingToolCensusDataFiscleYearListResource.get().$promise;

			return promise.then(function (details) {
				return _this14.geFiscleYearList(details.data);
			}).catch(function (error) {
				throw _this14.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to get census Data list
   * @return {object} [information related to census Data list]
   */

	}, {
		key: 'getCensusDataDetails',
		value: function getCensusDataDetails() {
			var _this15 = this;

			var promise = this.planningResourcesCensusDataListResource.get().$promise;
			return promise.then(function (details) {
				return {
					overview: _this15._getOverviewDetails(details.data.menuOverviewDetails),
					censusDataList: _this15._getCensusDataList(details.data.content[0].values)

				};
			}).catch(function (error) {
				throw _this15.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to get census data overview
   * @return {object} [information related to census data overview]
   */

	}, {
		key: 'getCensusDataOverview',
		value: function getCensusDataOverview() {
			var _this16 = this;

			var promise = this.planningResourcesDataMappingToolCensusDataOverviewResource.get().$promise;

			return promise.then(function (details) {
				return _this16._getOverviewDetails(details.data);
			}).catch(function (error) {
				throw _this16.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to edit Census Data overview
   * @return {object} [information related to Census data for edit]
   */

	}, {
		key: 'updateCensusDataOverview',
		value: function updateCensusDataOverview(details) {
			var _this17 = this;

			var promise = this.planningResourcesDataMappingToolCensusDataOverviewResource.update(this._setOverviewObject(details)).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this17.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to delete rescord in Census Data
   * @return {object} [success info]
   */

	}, {
		key: 'deleteFile',
		value: function deleteFile(uuid) {
			var _this18 = this;

			var promise = this.planningResourcesCensusDataPreviewResource.delete({ preview_id: uuid }).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this18.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'uploadMapFile',
		value: function uploadMapFile(file) {
			var _this19 = this;

			var promise = this._upload.upload({
				url: this.planningResourceCensusDataUploadUrl,
				data: {
					fileObj: file
				}
			});

			return promise.then(function (details) {
				return {
					uuid: details.data.data.uuid,
					mapDetails: _this19._getMapDetail(details.data.data.content)
				};
			}).catch(function (error) {
				throw _this19.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'addMapDetails',
		value: function addMapDetails(fiscleYearId, uuid) {
			var _this20 = this;

			var promise = this.planningResourcesCensusDataAddResource.save({
				uuid: uuid,
				fiscal_year_id: fiscleYearId
			}).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this20.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'downloadMobilityManagementTemplate',
		value: function downloadMobilityManagementTemplate() {
			var _this21 = this;

			var promise = this.planningResourceMobilityManagementDownloadTemplateResource.get().$promise;

			return promise.then(function (details) {
				return details;
			}).catch(function (error) {
				throw _this21.apiService.getErrorMessage(error);
			});
		}

		/**
   * mobilty managment
   */

	}, {
		key: 'getMobilityManagmentetails',
		value: function getMobilityManagmentetails() {
			var _this22 = this;

			var promise = this.planningResourcesMobilityManagementListResource.get().$promise;
			return promise.then(function (details) {
				return {
					overview: _this22._getOverviewDetails(details.data.menuOverviewDetails),
					fileDetails: details.data.content[0].values && details.data.content[0].values.length > 0 ? _this22._getMobiltyManagmentFileDetails(details.data.content[0].values[0]) : {}

				};
			}).catch(function (error) {
				throw _this22.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getMobilityManagmentOverview',
		value: function getMobilityManagmentOverview() {
			var _this23 = this;

			var promise = this.planningResourcesDataMappingToolMobiltyManagmentOverviewResource.get().$promise;

			return promise.then(function (details) {
				return _this23._getOverviewDetails(details.data);
			}).catch(function (error) {
				throw _this23.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updateMobiltyManagmentOverview',
		value: function updateMobiltyManagmentOverview(details) {
			var _this24 = this;

			var promise = this.planningResourcesDataMappingToolMobiltyManagmentOverviewResource.update(this._setOverviewObject(details)).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this24.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'uploadMobilityManagmentMapFile',
		value: function uploadMobilityManagmentMapFile(file) {
			var _this25 = this;

			var promise = this._upload.upload({
				url: this.planningResourceMobilityManagementUploadUrl,
				data: {
					fileObj: file
				}
			});

			return promise.then(function (_ref3) {
				var data = _ref3.data.data;
				return {
					uuid: data.uuid,
					mapDetails: _this25._getMobilityMapDetail(data.content)
				};
			}).catch(function (error) {
				throw _this25.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'addMobiltyManagementMapDetails',
		value: function addMobiltyManagementMapDetails(uuid) {
			var _this26 = this;

			var promise = this.planningResourcesMobilityManagementAddResource.save({
				uuid: uuid
			}).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this26.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getMobilityManagmentMapDetails',
		value: function getMobilityManagmentMapDetails(uuid) {
			var _this27 = this;

			var promise = this.planningResourcesMobilityManagementPreviewResource.get({ preview_id: uuid }).$promise;

			return promise.then(function (details) {
				return {
					mapDetails: _this27._getMobilityMapDetail(details.data)
				};
			}).catch(function (error) {
				throw _this27.apiService.getErrorMessage(error);
			});
		}

		/**
   * function to delete rescord in mobility managment
   * @return {object} [success info]
   */

	}, {
		key: 'deleteProgramServiceData',
		value: function deleteProgramServiceData(uuid) {
			var _this28 = this;

			var promise = this.planningResourcesMobilityManagementPreviewResource.delete({ preview_id: uuid }).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this28.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getCensusDataDownloadUrl',
		value: function getCensusDataDownloadUrl() {
			var token = 'JWT=' + this.$cookies.get('token');
			return this.apiService.getResourceUrl('files/template/census-data?' + token);
		}
	}, {
		key: 'getMobilityManagementDownloadUrl',
		value: function getMobilityManagementDownloadUrl() {
			var token = 'JWT=' + this.$cookies.get('token');
			return this.apiService.getResourceUrl('files/template/program-service-area?' + token);
		}

		/**
   * Transportation plans
   */

	}, {
		key: 'getTransportationPlansDetails',
		value: function getTransportationPlansDetails() {
			var _this29 = this;

			var promise = this.planningResourcesTransportationPlansListResource.get().$promise;
			return promise.then(function (_ref4) {
				var data = _ref4.data;
				return {
					overview: _this29._getOverviewDetails(data.menuOverviewDetails),
					list: _this29._getProgressDetails((0, _head2.default)(data.content).values)

				};
			}).catch(function (error) {
				throw _this29.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getTransportationPlansOverview',
		value: function getTransportationPlansOverview() {
			var _this30 = this;

			var promise = this.planningResourcesTransportationPlansOverviewResource.get().$promise;

			return promise.then(function (details) {
				return _this30._getOverviewDetails(details.data);
			}).catch(function (error) {
				throw _this30.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updateTransportationPlansOverview',
		value: function updateTransportationPlansOverview(details) {
			var _this31 = this;

			var promise = this.planningResourcesTransportationPlansOverviewResource.update(this._setOverviewObject(details)).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this31.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'addTransportationPlansDetails',
		value: function addTransportationPlansDetails(details) {
			var _this32 = this;

			var promise = this.planningResourcesTransportationPlansDetailsResource.save(this.setReportDetailsdata(details)).$promise;
			return promise.then(function (_ref5) {
				var data = _ref5.data;
				return data;
			}).catch(function (error) {
				throw _this32.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updateTransportationPlansDetails',
		value: function updateTransportationPlansDetails(details) {
			var _this33 = this;

			var promise = this.planningResourcesTransportationPlansDetailsResource.update({ id: details.id }, this.setReportDetailsdata(details)).$promise;
			return promise.then(function (data) {
				return data;
			}).catch(function (error) {
				throw _this33.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getTransportationPlansDetailsById',
		value: function getTransportationPlansDetailsById(id) {
			var _this34 = this;

			var promise = this.planningResourcesTransportationPlansDetailsResource.get({ id: id }).$promise;
			return promise.then(function (_ref6) {
				var data = _ref6.data;
				return _this34.getReportDetailsdata(data);
			});
		}
	}, {
		key: 'deleteTransportationPlansDetails',
		value: function deleteTransportationPlansDetails(id) {
			var _this35 = this;

			var promise = this.planningResourcesTransportationPlansDetailsResource.delete({ id: id }).$promise;
			return promise.then(function (data) {
				return data;
			}).catch(function (error) {
				throw _this35.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getFtaFactSheetsAndCircularsDetails',
		value: function getFtaFactSheetsAndCircularsDetails() {
			var _this36 = this;

			var promise = this.planningResourcesFtaFactSheetsAndCircularsListResource.get().$promise;
			return promise.then(function (_ref7) {
				var data = _ref7.data;
				return {
					overview: _this36._getOverviewDetails(data.menuOverviewDetails),
					list: _this36._getProgressDetails((0, _head2.default)(data.content).values)

				};
			}).catch(function (error) {
				throw _this36.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getFtaFactSheetsAndCircularsDetailsById',
		value: function getFtaFactSheetsAndCircularsDetailsById(id) {
			var _this37 = this;

			var promise = this.planningResourcesFtaFactSheetsAndCircularsDetailsResource.get({ id: id }).$promise;
			return promise.then(function (_ref8) {
				var data = _ref8.data;
				return _this37.getReportDetailsdata(data);
			});
		}
	}, {
		key: 'updateFtaFactSheetsAndCircularsDetails',
		value: function updateFtaFactSheetsAndCircularsDetails(details) {
			var _this38 = this;

			var promise = this.planningResourcesFtaFactSheetsAndCircularsDetailsResource.update({ id: details.id }, this.setReportDetailsdata(details)).$promise;
			return promise.then(function (data) {
				return data;
			}).catch(function (error) {
				throw _this38.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'addFtaFactSheetsAndCircularsDetails',
		value: function addFtaFactSheetsAndCircularsDetails(details) {
			var _this39 = this;

			var promise = this.planningResourcesFtaFactSheetsAndCircularsDetailsResource.save(this.setReportDetailsdata(details)).$promise;
			return promise.then(function (_ref9) {
				var data = _ref9.data;
				return data;
			}).catch(function (error) {
				throw _this39.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getFtaFactSheetsAndCircularsOverview',
		value: function getFtaFactSheetsAndCircularsOverview() {
			var _this40 = this;

			var promise = this.planningResourcesFtaFactSheetsAndCircularsOverviewResource.get().$promise;

			return promise.then(function (details) {
				return _this40._getOverviewDetails(details.data);
			}).catch(function (error) {
				throw _this40.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updateFtaFactSheetsAndCircularsOverview',
		value: function updateFtaFactSheetsAndCircularsOverview(details) {
			var _this41 = this;

			var promise = this.planningResourcesFtaFactSheetsAndCircularsOverviewResource.update(this._setOverviewObject(details)).$promise;

			return promise.then(function (details) {
				return details.data;
			}).catch(function (error) {
				throw _this41.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'deleteFtaFactSheetsAndCircularsDetails',
		value: function deleteFtaFactSheetsAndCircularsDetails(id) {
			var _this42 = this;

			var promise = this.planningResourcesFtaFactSheetsAndCircularsDetailsResource.delete({ id: id }).$promise;
			return promise.then(function (data) {
				return data;
			}).catch(function (error) {
				throw _this42.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getVolunteerTransportationProgramsDetails',
		value: function getVolunteerTransportationProgramsDetails() {
			var _this43 = this;

			var promise = this.volunteerTransportationProgramsResource.get().$promise;

			return promise.then(function (details) {
				return _this43._getOverviewDetails(details.data);
			}).catch(function (error) {
				throw _this43.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updateVolunteerTransportationPrograms',
		value: function updateVolunteerTransportationPrograms(details) {
			var _this44 = this;

			var promise = this.volunteerTransportationProgramsResource.update(this._setOverviewObject(details)).$promise;

			return promise.then(function (details) {
				return details;
			}).catch(function (error) {
				throw _this44.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getTransportationServicesDetails',
		value: function getTransportationServicesDetails() {
			var _this45 = this;

			var promise = this.transportationServicesResource.get().$promise;

			return promise.then(function (details) {
				return _this45._getOverviewDetails(details.data);
			}).catch(function (error) {
				throw _this45.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updateTransportationServices',
		value: function updateTransportationServices(details) {
			var _this46 = this;

			var promise = this.transportationServicesResource.update(this._setOverviewObject(details)).$promise;

			return promise.then(function (details) {
				return details;
			}).catch(function (error) {
				throw _this46.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getGrantApplicationsDetails',
		value: function getGrantApplicationsDetails() {
			var _this47 = this;

			var promise = this.getGrantApplicationsResource.get().$promise;

			return promise.then(function (details) {
				return {
					menuOverviewDetails: _this47._getMenuOverviewDetails(details.data.menuOverviewDetails),
					menuContentDetails: _this47._getMenuContentDetails((0, _find2.default)(details.data.content, ['name', 'GrantApplications']).values[0])
				};
			}).catch(function (error) {
				throw _this47.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updatetGrantApplications',
		value: function updatetGrantApplications(details) {
			var _this48 = this;

			var promise = this.grantApplicationsEditResource.update({ content_id: details.id }, this._setMenuContentDetails(details)).$promise;

			return promise.then(function (details) {
				return details;
			}).catch(function (error) {
				throw _this48.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getIndustryDetails',
		value: function getIndustryDetails() {
			var _this49 = this;

			var promise = this.getIndustryResource.get().$promise;

			return promise.then(function (details) {
				return {
					menuOverviewDetails: _this49._getMenuOverviewDetails(details.data.menuOverviewDetails),
					menuContentDetails: _this49._getMenuContentDetails((0, _find2.default)(details.data.content, ['name', 'Industry']).values[0])
				};
			}).catch(function (error) {
				throw _this49.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updatetIndustry',
		value: function updatetIndustry(details) {
			var _this50 = this;

			var promise = this.industryEditResource.update({ content_id: details.id }, this._setMenuContentDetails(details)).$promise;

			return promise.then(function (details) {
				return details;
			}).catch(function (error) {
				throw _this50.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getOtherReferenceMaterialsFundingDetails',
		value: function getOtherReferenceMaterialsFundingDetails() {
			var _this51 = this;

			var promise = this.getOtherReferenceMaterialsFundingResource.get().$promise;

			return promise.then(function (details) {
				return {
					menuOverviewDetails: _this51._getMenuOverviewDetails(details.data.menuOverviewDetails),
					menuContentDetails: _this51._getMenuContentDetails((0, _find2.default)(details.data.content, ['name', 'OtherReferenceMaterialsFunding']).values[0])
				};
			}).catch(function (error) {
				throw _this51.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updateOtherReferenceMaterialsFunding',
		value: function updateOtherReferenceMaterialsFunding(details) {
			var _this52 = this;

			var promise = this.otherReferenceMaterialsFundingEditResource.update({ content_id: details.id }, this._setMenuContentDetails(details)).$promise;

			return promise.then(function (details) {
				return details;
			}).catch(function (error) {
				throw _this52.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getTransportationLinksDetails',
		value: function getTransportationLinksDetails() {
			var _this53 = this;

			var promise = this.getTransportationLinksResource.get().$promise;

			return promise.then(function (details) {
				return {
					menuOverviewDetails: _this53._getMenuOverviewDetails(details.data.menuOverviewDetails),
					menuContentDetails: _this53._getMenuContentDetails((0, _find2.default)(details.data.content, ['name', 'TransportationLinks']).values[0])
				};
			}).catch(function (error) {
				throw _this53.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'updateTransportationLinks',
		value: function updateTransportationLinks(details) {
			var _this54 = this;

			var promise = this.transportationLinksEditResource.update({ content_id: details.id }, this._setMenuContentDetails(details)).$promise;

			return promise.then(function (details) {
				return details;
			}).catch(function (error) {
				throw _this54.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: 'getReferenceMapDetailsObject',
		value: function getReferenceMapDetailsObject(_ref10) {
			var menuOverviewDetails = _ref10.menuOverviewDetails,
			    content = _ref10.content;

			var _content = _slicedToArray(content, 1),
			    data = _content[0];

			var values = data.values;

			var _values = _slicedToArray(values, 1),
			    details = _values[0];

			return {
				overview: this._getMenuOverviewDetails(menuOverviewDetails),
				contentId: details.content_id,
				embedCode: details.embed_code,
				description: details.description,
				images: details.images || [],
				videos: details.videos || [],
				slug: details.slug
			};
		}
	}, {
		key: 'updateReferenceMapDetails',
		value: function updateReferenceMapDetails(_ref11) {
			var _this55 = this;

			var contentId = _ref11.contentId,
			    embed_code = _ref11.embedCode,
			    description = _ref11.description,
			    images = _ref11.images,
			    videos = _ref11.videos;

			var promise = this.referenceMapEditResource.update({ content_id: contentId }, { embed_code: embed_code, description: description, images: images, videos: videos }).$promise;

			return promise.then(function (details) {
				return details;
			}).catch(function (error) {
				throw _this55.apiService.getErrorMessage(error);
			});
		}
	}, {
		key: '_getMenuOverviewDetails',
		value: function _getMenuOverviewDetails(details) {
			return {
				id: details.content_id,
				displayName: details.display_name,
				title: details.title,
				description: details.description,
				overview: details.overview,
				image: details.image,
				name: details.name
			};
		}
	}, {
		key: '_getMenuContentDetails',
		value: function _getMenuContentDetails(value) {
			return {
				id: value.content_id,
				description: value.description,
				images: this._getContentImagesObject(value.images) || [],
				videos: value.videos || []
			};
		}
	}, {
		key: '_getContentImagesObject',
		value: function _getContentImagesObject(values) {
			return values ? values.map(function (_ref12) {
				var uuid = _ref12.uuid;
				return { uuid: uuid, status: -1 };
			}) : [];
		}
	}, {
		key: '_setMenuContentDetails',
		value: function _setMenuContentDetails(value) {
			return {
				description: value.description,
				images: value.images || [],
				videos: value.videos || []
			};
		}
	}]);

	return PlanningResourcesService;
}();

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.referenceMapComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _referenceMap = __webpack_require__(780);

var _referenceMap2 = _interopRequireDefault(_referenceMap);

var _clone = __webpack_require__(11);

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var referenceMapComponent = exports.referenceMapComponent = {
    bindings: {
        details: '<',
        slugUrl: '@'
    },

    templateUrl: _referenceMap2.default,

    controller: function () {
        ReferenceMapComponent.$inject = ["$state", "PlanningResourcesService", "toastr"];
        function ReferenceMapComponent($state, PlanningResourcesService, toastr) {
            'ngInject';

            _classCallCheck(this, ReferenceMapComponent);

            this.$state = $state;
            this.planningResourcesService = PlanningResourcesService;
            this.toastr = toastr;
        }

        _createClass(ReferenceMapComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = this.planningResourcesService.getReferenceMapDetailsObject(this.details.data);
                this.pageTitle = "Reference maps";
                this.disableButtons = false;
                this.editorFieldError = false;
            }
        }, {
            key: 'setEditorDetails',
            value: function setEditorDetails(editorDetails) {
                this.details = (0, _clone2.default)(editorDetails);
                this._setEditorFieldError();
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                var _this = this;

                this.disableButtons = true;
                this._setEditorFieldError();

                if (!this.editorFieldError) {
                    this.planningResourcesService.updateReferenceMapDetails(this.details).then(function (_) {
                        _this.toastr.success('Data updated successfully');
                        _this.disableButtons = false;
                    }).catch(function (err) {
                        _this.toastr.error(err);
                        _this.disableButtons = false;
                        throw err;
                    });
                }
            }
        }, {
            key: 'onCancel',
            value: function onCancel() {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: 'home-banner'
                });
            }

            //****************************************************Private Methods************************************ */

        }, {
            key: '_setEditorFieldError',
            value: function _setEditorFieldError() {
                this.editorFieldError = this.details.description.trim().length > 0 ? false : true;
            }
        }]);

        return ReferenceMapComponent;
    }()
};

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.referenceMap = undefined;

var _referenceMap = __webpack_require__(619);

__webpack_require__(194);

var referenceMap = exports.referenceMap = angular.module('components.planningResources.referenceMap', []).component('referenceMap', _referenceMap.referenceMapComponent).name;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.privacyPolicyComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _privacyPolicy = __webpack_require__(781);

var _privacyPolicy2 = _interopRequireDefault(_privacyPolicy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var privacyPolicyComponent = exports.privacyPolicyComponent = {
	bindings: {
		details: '<'
	},

	templateUrl: _privacyPolicy2.default,

	controller: function () {
		PrivacyPolicyComponent.$inject = ["$state", "toastr", "CompareObjectService", "ModalService", "PrivacyPolicyService"];
		function PrivacyPolicyComponent($state, toastr, CompareObjectService, ModalService, PrivacyPolicyService) {
			'ngInject';

			_classCallCheck(this, PrivacyPolicyComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.PrivacyPolicyService = PrivacyPolicyService;
		}

		_createClass(PrivacyPolicyComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.PrivacyPolicyService.getPrivacyPolicyDetails(this.details);
				this.details.pageTitle = "Edit Privacy Policy";
				this.savedData = angular.copy(this.details.menuContentDetails);
			}
		}, {
			key: 'onCancel',
			value: function onCancel() {
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, false);

				if (isUpdated) {
					var _onSubmit = function _onSubmit() {
						this._redirectToParentState('home-banner');
					};

					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},
						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: _onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState('home-banner');
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				this.disableButtons = true;
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, true);

				if (isUpdated) {
					this.PrivacyPolicyService.editPrivacyPolicy(this.details.menuContentDetails).then(function (_) {
						_this.toastr.success('Privacy Policy is updated successfully');
						_this.disableButtons = false;
					}).catch(function (err) {
						_this.toastr.error(err);
						_this.disableButtons = false;
					});
				} else {
					this.toastr.success('Nothing to update');
					this.disableButtons = false;
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return PrivacyPolicyComponent;
	}()
};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.privacyPolicy = undefined;

var _privacyPolicy = __webpack_require__(621);

var _privacyPolicy2 = __webpack_require__(623);

var privacyPolicy = exports.privacyPolicy = angular.module('components.privacyPolicy', []).service('PrivacyPolicyService', _privacyPolicy2.PrivacyPolicyService).component('privacyPolicy', _privacyPolicy.privacyPolicyComponent).name;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivacyPolicyService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PrivacyPolicyService = exports.PrivacyPolicyService = function () {
  PrivacyPolicyService.$inject = ["$resource", "ApiService"];
  function PrivacyPolicyService($resource, ApiService) {
    'ngInject';

    _classCallCheck(this, PrivacyPolicyService);

    this.$resource = $resource;
    this.apiService = ApiService;

    this.privacyPolicyResourceUrl = this.apiService.getResourceUrl('cms/menus/PrivacyPolicy');
    this.editPrivacyPolicyResourceUrl = this.apiService.getResourceUrl('cms/privacy-policy');

    this.privacyPolicyResource = this.$resource(this.privacyPolicyResourceUrl);
    this.editPrivacyPolicyResource = this.$resource(this.editPrivacyPolicyResourceUrl, null, {
      update: {
        method: 'PUT'
      }
    });
  }

  _createClass(PrivacyPolicyService, [{
    key: '_getContentDetails',
    value: function _getContentDetails(value) {
      return {
        id: value.content_id,
        description: value.description,
        images: this._getContentImagesObject(value.images) || [],
        videos: value.videos || []
      };
    }
  }, {
    key: '_getContentImagesObject',
    value: function _getContentImagesObject(values) {
      return values ? values.map(function (_ref) {
        var uuid = _ref.uuid;
        return { uuid: uuid, status: -1 };
      }) : [];
    }
  }, {
    key: '_setContentDetails',
    value: function _setContentDetails(value) {
      return {
        description: value.description,
        images: value.images || [],
        videos: value.videos || []
      };
    }

    /************
     * To get Privacy & Policy
     ***************/

  }, {
    key: 'getPrivacyPolicyDetails',
    value: function getPrivacyPolicyDetails(_ref2) {
      var data = _ref2.data;

      return { menuContentDetails: this._getContentDetails((0, _find2.default)(data.content, ['name', 'PrivacyPolicy']).values[0]) };
    }

    /*************
     * To Update Privacy & Policy
     *****************/

  }, {
    key: 'editPrivacyPolicy',
    value: function editPrivacyPolicy(details) {
      var _this = this;

      var promise = this.editPrivacyPolicyResource.update(this._setContentDetails(details)).$promise;

      return promise.then(function (details) {
        return details;
      }).catch(function (err) {
        throw _this.apiService.getErrorMessage(err);
      });
    }
  }]);

  return PrivacyPolicyService;
}();

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportAddComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reportAdd = __webpack_require__(782);

var _reportAdd2 = _interopRequireDefault(_reportAdd);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportAddComponent = exports.reportAddComponent = {
    bindings: {
        menuName: '@',
        parentSlug: '@',
        slugUrl: '@'
    },

    templateUrl: _reportAdd2.default,

    controller: function () {
        ReportAddComponent.$inject = ["$state", "toastr", "ModalService", "ReportAddService", "DynamicMenusService", "CompareObjectService", "ReportEditService", "SlugService"];
        function ReportAddComponent($state, toastr, ModalService, ReportAddService, DynamicMenusService, CompareObjectService, ReportEditService, SlugService) {
            'ngInject';

            _classCallCheck(this, ReportAddComponent);

            this.$state = $state;
            this._toastr = toastr;
            this.modalService = ModalService;
            this.reportAddService = ReportAddService;
            this.compareObjectService = CompareObjectService;
            this.dynamicMenusService = DynamicMenusService;
            this.reportEditService = ReportEditService;
            this.slugService = SlugService;
        }

        _createClass(ReportAddComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.serviceAreaList = [];
                this.programYears = [];
                this.isShortDetails = this._isShortDetailsHaveReport();

                this._getServiceAreaList();
                this._getProgramYearList();

                this.details = this._getEmptyDetailsObject();
                this.saveData = angular.copy(this.details);
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                this.disableButtons = true;
                var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'add');
                details = this.reportAddService.setReportDetailsdata(details);

                this.dynamicMenusService.addMenuDetailsByUrl(url, details).then(function (_ref) {
                    var id = _ref.data.content_id;

                    var contentDetailsUrl = _this.slugService.getContentDetailsURL(url, id);
                    _this._toastr.success('data added successfully');
                    _this._redirectToParentState(contentDetailsUrl);
                }).catch(function (err) {
                    _this._toastr.error(err);
                    _this.disableButtons = false;
                });
            }
        }, {
            key: 'onCancel',
            value: function onCancel(details) {
                var _details = angular.copy(details);
                var isUpdated = details ? this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true) : false;
                if (isUpdated) {
                    this.modalService.open({
                        details: {
                            bodyMessage: 'Changes done will be reverted. Continue?'
                        },
                        buttons: [{
                            name: 'No'
                        }, {
                            name: 'Yes',
                            isPrimary: true,
                            action: _onSubmit.bind(this)
                        }]
                    });
                } else {
                    this._redirectToParentState(this.parentSlug);
                }

                function _onSubmit() {
                    this._redirectToParentState(this.parentSlug);
                }
            }

            /***********************************************Private Methods***************************************************** */

        }, {
            key: '_isShortDetailsHaveReport',
            value: function _isShortDetailsHaveReport() {
                return this.menuName === 'ProgressReportsAdd' ? false : true;
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }, {
            key: '_getServiceAreaList',
            value: function _getServiceAreaList() {
                var _this2 = this;

                this.reportEditService.getServiceAreaList().then(function (list) {
                    _this2.serviceAreaList = angular.copy(list);
                    _this2._addAllServiceAreaOption();
                });
            }
        }, {
            key: '_addAllServiceAreaOption',
            value: function _addAllServiceAreaOption() {
                this.serviceAreaList.unshift({
                    id: -1,
                    name: 'All County'
                });
            }
        }, {
            key: '_getProgramYearList',
            value: function _getProgramYearList() {
                var _this3 = this;

                this.reportEditService.getPrgoramYears().then(function (years) {
                    return _this3.programYears = years;
                });
            }
        }, {
            key: '_getEmptyDetailsObject',
            value: function _getEmptyDetailsObject() {
                var details = {
                    title: "",
                    uuid: ""
                };

                if (this.menuName === 'ProgressReportsAdd') {
                    details.selectedProgramYearId = "";
                    details.selectedCountyId = "";
                }

                return details;
            }
        }]);

        return ReportAddComponent;
    }()
};

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportAdd = undefined;

var _reportAdd = __webpack_require__(624);

var _reportAdd2 = __webpack_require__(626);

var reportAdd = exports.reportAdd = angular.module('components.reportAdd', []).component('reportAdd', _reportAdd.reportAddComponent).service('ReportAddService', _reportAdd2.ReportAddService).name;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportAddService = exports.ReportAddService = function () {
    ReportAddService.$inject = ["$resource", "ApiService"];
    function ReportAddService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, ReportAddService);

        this.$resource = $resource;
        this.apiService = ApiService;
    }

    _createClass(ReportAddService, [{
        key: "setReportDetailsdata",
        value: function setReportDetailsdata(_ref) {
            var _ref$title = _ref.title,
                title = _ref$title === undefined ? "" : _ref$title,
                _ref$uuid = _ref.uuid,
                uuid = _ref$uuid === undefined ? "" : _ref$uuid,
                _ref$selectedProgramY = _ref.selectedProgramYearId,
                selectedProgramYearId = _ref$selectedProgramY === undefined ? "" : _ref$selectedProgramY,
                _ref$selectedServiceA = _ref.selectedServiceAreaId,
                selectedServiceAreaId = _ref$selectedServiceA === undefined ? "" : _ref$selectedServiceA;

            var details = {
                title: title,
                pdf: uuid
            };

            if (selectedProgramYearId && selectedServiceAreaId) {
                details.service_area_id = selectedServiceAreaId;
                details.fiscal_year_id = selectedProgramYearId;
            }

            return details;
        }
    }]);

    return ReportAddService;
}();

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportEditComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reportEdit = __webpack_require__(783);

var _reportEdit2 = _interopRequireDefault(_reportEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportEditComponent = exports.reportEditComponent = {
    bindings: {
        details: '<',
        menuName: '@',
        slugUrl: '@',
        parentSlug: '@'
    },

    templateUrl: _reportEdit2.default,

    controller: function () {
        ReportEditComponent.$inject = ["$state", "ReportEditService", "toastr", "ModalService", "CompareObjectService", "DynamicMenusService", "SlugService"];
        function ReportEditComponent($state, ReportEditService, toastr, ModalService, CompareObjectService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, ReportEditComponent);

            this.$state = $state;
            this.reportEditService = ReportEditService;
            this.toastr = toastr;
            this.modalService = ModalService;
            this.compareObjectService = CompareObjectService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        _createClass(ReportEditComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.serviceAreaList = [];
                this.programYears = [];
                this.isShortDetails = this._isShortDetailsHaveReport();
                this._getServiceAreaList();
                this._getProgramYearList();

                this.details = this.reportEditService.getReportDetailsObject(this.details);
                this.saveData = angular.copy(this.details);
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                this.disableButtons = true;
                var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'edit');
                details = this.reportEditService.setProgressReportDetailsData(details);

                this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, details).then(function (details) {
                    var contentDetailsUrl = _this.slugService.getDetailsPageURL(url);
                    _this.toastr.success('data updated successfully');
                    _this._redirectToParentState(contentDetailsUrl);
                }).catch(function (err) {
                    _this.toastr.error(err);
                    _this.disableButtons = false;
                });
            }
        }, {
            key: 'onCancel',
            value: function onCancel(details) {
                var _details = angular.copy(details);
                var isUpdated = details ? this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true) : false;
                if (isUpdated) {
                    this.modalService.open({
                        details: {
                            bodyMessage: 'Changes done will be reverted. Continue?'
                        },
                        buttons: [{
                            name: 'No'
                        }, {
                            name: 'Yes',
                            isPrimary: true,
                            action: _onSubmit.bind(this)
                        }]
                    });
                } else {
                    this._redirectToParentState(this.parentSlug);
                }

                function _onSubmit() {
                    this._redirectToParentState(this.parentSlug);
                }
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }, {
            key: '_getServiceAreaList',
            value: function _getServiceAreaList() {
                var _this2 = this;

                this.reportEditService.getServiceAreaList().then(function (list) {
                    _this2.serviceAreaList = angular.copy(list);
                    _this2._addAllCountyOption();
                });
            }
        }, {
            key: '_addAllCountyOption',
            value: function _addAllCountyOption() {
                this.serviceAreaList.unshift({
                    id: -1,
                    name: 'All County'
                });
            }
        }, {
            key: '_isShortDetailsHaveReport',
            value: function _isShortDetailsHaveReport() {
                return this.menuName === 'ProgressReportsEdit' ? false : true;
            }
        }, {
            key: '_getProgramYearList',
            value: function _getProgramYearList() {
                var _this3 = this;

                this.reportEditService.getPrgoramYears().then(function (years) {
                    return _this3.programYears = years;
                });
            }
        }]);

        return ReportEditComponent;
    }()
};

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportEdit = undefined;

var _reportEdit = __webpack_require__(627);

var _reportEdit2 = __webpack_require__(629);

var reportEdit = exports.reportEdit = angular.module('components.reportEdit', []).component('reportEdit', _reportEdit.reportEditComponent).service('ReportEditService', _reportEdit2.ReportEditService).name;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReportEditService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportEditService = exports.ReportEditService = function () {
    ReportEditService.$inject = ["$resource", "ApiService"];
    function ReportEditService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, ReportEditService);

        this.$resource = $resource;
        this.apiService = ApiService;

        this.serviceAreaListResourceUrl = this.apiService.getResourceUrl('cms/progress-report/service-area');
        this.programYearResourceUrl = this.apiService.getResourceUrl('fiscal-year');
        this.addProgramYearResourceUrl = this.apiService.getResourceUrl('cms/fiscal-year');

        this.serviceAreaListResource = this.$resource(this.serviceAreaListResourceUrl);
        this.programYearResource = this.$resource(this.programYearResourceUrl);
        this.addProgramYearResource = this.$resource(this.addProgramYearResourceUrl);
    }

    _createClass(ReportEditService, [{
        key: 'getServiceAreaList',
        value: function getServiceAreaList() {
            var _this = this;

            var promise = this.serviceAreaListResource.get().$promise;

            return promise.then(function (_ref) {
                var data = _ref.data;
                return _this._getServiceAreaList(data);
            }).catch(function (error) {
                throw _this.apiService.getErrorMessage(error);
            });
        }
    }, {
        key: 'getPrgoramYears',
        value: function getPrgoramYears() {
            var _this2 = this;

            var currentYear = this._getCurrentYear();
            var promise = this.programYearResource.get().$promise;

            return promise.then(function (_ref2) {
                var data = _ref2.data;
                return _this2._getProgramYears(data);
            }).then(function (fiscalYearList) {
                return (0, _findIndex2.default)(fiscalYearList, { name: currentYear }) === -1 ? _this2.addProgramYear(currentYear) : fiscalYearList;
            }).catch(function (error) {
                throw _this2.apiService.getErrorMessage(error);
            });
        }
    }, {
        key: 'addProgramYear',
        value: function addProgramYear(fiscalYear) {
            var _this3 = this;

            var promise = this.addProgramYearResource.save({ fiscal_year: fiscalYear }).$promise;

            return promise.then(function (_ref3) {
                var data = _ref3.data;
                return _this3._getProgramYears(data);
            }).catch(function (error) {
                throw _this3.apiService.getErrorMessage(error);
            });;
        }
    }, {
        key: 'getReportDetailsObject',
        value: function getReportDetailsObject(_ref4) {
            var data = _ref4.data;

            return this._getProgressReportDetailsdata(data);
        }
    }, {
        key: 'setProgressReportDetailsData',
        value: function setProgressReportDetailsData(details) {
            return {
                title: details.title,
                service_area_id: details.selectedServiceAreaId,
                fiscal_year_id: details.selectedProgramYearId,
                pdf: details.uuid
            };
        }
    }, {
        key: '_getProgressReportDetailsdata',
        value: function _getProgressReportDetailsdata(details) {
            return {
                id: details.content_id,
                title: details.title,
                name: details.mask_name,
                selectedProgramYearId: details.fiscal_year_id,
                from: details.start_from,
                to: details.end_to,
                selectedServiceAreaId: details.service_area_id,
                countyName: details.county_name,
                image: this.apiService.getImageUrl(details.image),
                uuid: details.pdf,
                url: this.apiService.getResourceUrl('files/pdf/' + details.pdf)
            };
        }
    }, {
        key: '_getServiceAreaList',
        value: function _getServiceAreaList(list) {
            return list.map(function (details) {
                return {
                    id: details.service_area_id,
                    name: details.name + ' (' + details.state_code + ')'
                };
            });
        }
    }, {
        key: '_getProgramYears',
        value: function _getProgramYears(list) {
            return list.map(function (details) {
                return {
                    id: details.fiscal_year_id,
                    name: details.fiscal_year
                };
            });
        }
    }, {
        key: '_getCurrentYear',
        value: function _getCurrentYear() {
            return new Date().getFullYear();
        }
    }]);

    return ReportEditService;
}();

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reportList = __webpack_require__(784);

var _reportList2 = _interopRequireDefault(_reportList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportListComponent = exports.reportListComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        menuName: '@'
    },

    templateUrl: _reportList2.default,

    controller: function () {
        ReportListComponent.$inject = ["$state", "ReportListService", "DashboardService", "DynamicMenusService", "ModalService", "toastr"];
        function ReportListComponent($state, ReportListService, DashboardService, DynamicMenusService, ModalService, toastr) {
            'ngInject';

            _classCallCheck(this, ReportListComponent);

            this.$state = $state;
            this.reportListService = ReportListService;
            this.dashboardService = DashboardService;
            this.dynamicMenusService = DynamicMenusService;
            this.modalService = ModalService;
            this.toastr = toastr;
        }

        _createClass(ReportListComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = this.reportListService.getReportListObject(this.details, this.menuName);
                this.activeMenuName = this.dashboardService.getActiveMenuName();
                this.details.pageTitle = this.activeMenuName + ' List';
            }
        }, {
            key: 'onDelete',
            value: function onDelete(slug) {
                this.modalService.open({
                    details: {
                        bodyMessage: 'Are you sure you want to delete ?'
                    },
                    buttons: [{
                        name: 'No'
                    }, {
                        name: 'Yes',
                        isPrimary: true,
                        action: _onDelete.bind(this, slug)
                    }]
                });

                function _onDelete(slug) {
                    var _this = this;

                    this.dynamicMenusService.deleteMenuDetailsByUrl(slug + '/delete').then(function (details) {
                        _this.toastr.success('data deleted succesfully');
                        _this.$state.reload();
                    }).catch(function (error) {
                        _this.toastr.error(error);
                    });
                }
            }
        }]);

        return ReportListComponent;
    }()
};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportList = undefined;

var _reportList = __webpack_require__(630);

var _reportList2 = __webpack_require__(632);

var reportList = exports.reportList = angular.module('components.reportList', []).component('reportList', _reportList.reportListComponent).service('ReportListService', _reportList2.ReportListService).name;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ReportListService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportListService = exports.ReportListService = function () {
	ReportListService.$inject = ["$resource", "ApiService"];
	function ReportListService($resource, ApiService) {
		'ngInject';

		_classCallCheck(this, ReportListService);

		this.$resource = $resource;
		this.apiService = ApiService;
	}

	_createClass(ReportListService, [{
		key: 'getReportListObject',
		value: function getReportListObject(details, moduleName) {
			return {
				overview: this._getOverviewDetails(details.data.menuOverviewDetails),
				list: this._getSubContentDetails(details.data.content, moduleName)
			};
		}

		/*************************************************Private Methods************************ */

	}, {
		key: '_getSubContentDetails',
		value: function _getSubContentDetails(values, moduleName) {
			var details = (0, _filter2.default)(values, ['name', moduleName]);
			return _getListDetails.call(this, (0, _head2.default)(details).values);

			function _getListDetails(data) {
				var _this = this;

				return data.map(function (value) {
					return _this._getListObject(value);
				});
			}
		}
	}, {
		key: '_getOverviewDetails',
		value: function _getOverviewDetails(details) {
			return {
				title: details.title,
				description: details.description,
				image: details.image,
				overview: details.overview
			};
		}
	}, {
		key: '_getContentDetails',
		value: function _getContentDetails(content) {
			return content.map(function (_ref) {
				var title = _ref.title,
				    description = _ref.description,
				    name = _ref.name;
				return { title: title, description: description, name: name };
			});
		}
	}, {
		key: '_getListObject',
		value: function _getListObject(value) {
			return {
				id: value.content_id,
				image: this.apiService.getResourceUrl('files/images/' + value.image),
				pdf: this.apiService.getResourceUrl('files/pdf/' + value.pdf),
				title: value.title,
				slug: value.slug || ''
			};
		}
	}]);

	return ReportListService;
}();

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportViewComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _reportView = __webpack_require__(785);

var _reportView2 = _interopRequireDefault(_reportView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var reportViewComponent = exports.reportViewComponent = {
    bindings: {
        details: '<',
        menuName: '@',
        slugUrl: '@',
        parentSlug: '@'
    },

    templateUrl: _reportView2.default,

    controller: function () {
        ReportViewComponent.$inject = ["$state", "ReportViewService", "SlugService"];
        function ReportViewComponent($state, ReportViewService, SlugService) {
            'ngInject';

            _classCallCheck(this, ReportViewComponent);

            this.$state = $state;
            this.reportViewService = ReportViewService;
            this.slugService = SlugService;
        }

        _createClass(ReportViewComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = this.reportViewService.getReportDetailsObject(this.details);
                this.isShortDetails = this.menuName === 'ProgressReportsDetails' ? false : true;
            }
        }, {
            key: 'onGoBack',
            value: function onGoBack() {
                this._redirectToParentState(this.parentSlug);
            }
        }, {
            key: 'onEdit',
            value: function onEdit() {
                var slug = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'details');
                var url = this.slugService.getEditPageURL(slug);

                this.$state.go('app.dashboard.DynamicMenus', {
                    url: url
                });
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }]);

        return ReportViewComponent;
    }()
};

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.reportView = undefined;

var _reportView = __webpack_require__(633);

var _reportView2 = __webpack_require__(635);

var reportView = exports.reportView = angular.module('components.reportView', []).component('reportView', _reportView.reportViewComponent).service('ReportViewService', _reportView2.ReportViewService).name;

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
				value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReportViewService = exports.ReportViewService = function () {
				ReportViewService.$inject = ["ApiService"];
				function ReportViewService(ApiService) {
								'ngInject';

								_classCallCheck(this, ReportViewService);

								this.apiService = ApiService;
				}

				_createClass(ReportViewService, [{
								key: 'getReportDetailsObject',
								value: function getReportDetailsObject(_ref) {
												var data = _ref.data;

												return this._getProgressReportDetailsdata(data);
								}

								/**********************************Private Methods************************* */

				}, {
								key: '_getProgressReportDetailsdata',
								value: function _getProgressReportDetailsdata(details) {
												return {
																id: details.content_id,
																title: details.title,
																name: details.mask_name,
																selectedProgramYearId: details.fiscal_year_id,
																from: details.start_from,
																to: details.end_to,
																selectedServiceAreaId: details.service_area_id,
																serviceAreaName: details.name,
																image: this.apiService.getImageUrl(details.image),
																uuid: details.pdf,
																url: this.apiService.getResourceUrl('files/pdf/' + details.pdf)
												};
								}
				}]);

				return ReportViewService;
}();

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.rhnscnyLogoComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rhnscnyLogo = __webpack_require__(786);

var _rhnscnyLogo2 = _interopRequireDefault(_rhnscnyLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var rhnscnyLogoComponent = exports.rhnscnyLogoComponent = {
	bindings: {
		details: '<'
	},

	templateUrl: _rhnscnyLogo2.default,

	controller: function () {
		RhnscnyLogoComponent.$inject = ["$state", "ModalService", "CompareObjectService", "RhnscnyService", "toastr"];
		function RhnscnyLogoComponent($state, ModalService, CompareObjectService, RhnscnyService, toastr) {
			'ngInject';

			_classCallCheck(this, RhnscnyLogoComponent);

			this.$state = $state;
			this.modalService = ModalService;
			this.compareObjectService = CompareObjectService;
			this.rhnscnyService = RhnscnyService;
			this.toastr = toastr;
		}

		_createClass(RhnscnyLogoComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.rhnscnyLogoDetails = this.rhnscnyService.getRhnscnyLogo(this.details);
				this.pageTitle = "RHNSCNY Logo";
				this.disableButtons = false;
				this.savedData = angular.copy(this.rhnscnyLogoDetails);
			}
		}, {
			key: 'onlogoUpload',
			value: function onlogoUpload(_ref) {
				var uuid = _ref.details.uuid;

				this.rhnscnyLogoDetails.image = uuid;
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				this.disableButtons = true;
				// submit the request
				this.rhnscnyService.updateWebsiteLogo(this.rhnscnyLogoDetails).then(function (details) {
					_this.toastr.success('Website logo updated successfully');
					_this.disableButtons = false;
				}).catch(function (err) {
					_this.toastr.error(err);
					_this.disableButtons = false;
				});
			}
		}, {
			key: 'onCancel',
			value: function onCancel() {
				var _details = angular.copy(this.rhnscnyLogoDetails);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, _details, true);
				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},

						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState('home-banner');
				}

				function onSubmit() {
					this._redirectToParentState('home-banner');
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return RhnscnyLogoComponent;
	}()
};

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rhnscnyLogo = undefined;

var _rhnscnyLogo = __webpack_require__(636);

var _rhnscnyLogo2 = __webpack_require__(638);

__webpack_require__(195);

var rhnscnyLogo = exports.rhnscnyLogo = angular.module('components.rhnscnyLogo', []).service('RhnscnyService', _rhnscnyLogo2.RhnscnyService).component('rhnscnyLogo', _rhnscnyLogo.rhnscnyLogoComponent).name;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RhnscnyService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RhnscnyService = exports.RhnscnyService = function () {
    RhnscnyService.$inject = ["$resource", "ApiService"];
    function RhnscnyService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, RhnscnyService);

        this.$resource = $resource;
        this.apiService = ApiService;

        this.rhnscnyLogoResourceUrl = this.apiService.getResourceUrl('cms/menus/RHNSCNY');
        this.rhnscnyLogoEditResourceUrl = this.apiService.getResourceUrl('cms/:content_id/rhnscny-logo');
        this.rhnscnyLogoResource = this.$resource(this.rhnscnyLogoResourceUrl);
        this.rhnscnyLogoEditResource = this.$resource(this.rhnscnyLogoEditResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }

    //*************************************Public Methods********************* */


    _createClass(RhnscnyService, [{
        key: 'getRhnscnyLogo',
        value: function getRhnscnyLogo(_ref) {
            var data = _ref.data;

            return this._getContentDetails((0, _find2.default)(data.content, ['name', 'RHNSCNY']).values[0]);
        }
    }, {
        key: 'updateWebsiteLogo',
        value: function updateWebsiteLogo(_ref2) {
            var _this = this;

            var id = _ref2.id,
                image = _ref2.image;

            var promise = this.rhnscnyLogoEditResource.update({ content_id: id }, { image: image }).$promise;

            return promise.then(function (details) {
                return details;
            }).catch(function (err) {
                throw _this.apiService.getErrorMessage(err);
            });
        }

        //*************************************Private Methods********************* */

    }, {
        key: '_getContentDetails',
        value: function _getContentDetails(value) {
            return {
                id: value.content_id,
                image: value.image
            };
        }
    }]);

    return RhnscnyService;
}();

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.serviceAreaAddComponent = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _serviceAreaAdd = __webpack_require__(787);

var _serviceAreaAdd2 = _interopRequireDefault(_serviceAreaAdd);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _clone = __webpack_require__(11);

var _clone2 = _interopRequireDefault(_clone);

var _size = __webpack_require__(12);

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var serviceAreaAddComponent = exports.serviceAreaAddComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl: _serviceAreaAdd2.default,

    controller: function () {
        ServiceAreaAddComponent.$inject = ["ServiceAreaCountyService", "toastr", "GoogleLocationService"];
        function ServiceAreaAddComponent(ServiceAreaCountyService, toastr, GoogleLocationService) {
            'ngInject';

            _classCallCheck(this, ServiceAreaAddComponent);

            this.toastr = toastr;
            this.serviceAreaCountyService = ServiceAreaCountyService;
            this.googleLocationService = GoogleLocationService;
        }

        _createClass(ServiceAreaAddComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.serviceAreaDetails = {};
                this.disableSaveButton = true;
                this.isServiceAreaFieldHaveError = false;
                this.isLocationDisabled = false;
                this.selectedServiceAreaType = '';
                this.selectedServiceAreaName = '';
            }

            /*******************
             * Public Methods
             ***************/

        }, {
            key: 'getLocationDetails',
            value: function getLocationDetails(locationDetails) {
                this.serviceAreaDetails = (0, _clone2.default)(locationDetails);
                this.serviceAreaTypeOptions = this._getServiceAreaTypeOptions(locationDetails);
                this._validateServiceArea();
            }
        }, {
            key: '_validateServiceArea',
            value: function _validateServiceArea() {
                if (this.serviceAreaDetails.lat && this.serviceAreaDetails.lng) {
                    this.isServiceAreaFieldHaveError = (0, _size2.default)(this.serviceAreaTypeOptions) > 0 ? false : true;
                } else {
                    this.isServiceAreaFieldHaveError = false;
                }
            }
        }, {
            key: 'onChangeServiceAreaType',
            value: function onChangeServiceAreaType(_ref) {
                var type = _ref.id;

                this.disableSaveButton = false;
                this.selectedServiceAreaType = type;
                this.selectedServiceAreaName = this._getServiceAreaTypeName(type);
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                this.disableSaveButton = true;
                if (this.serviceAreaDetails && (0, _size2.default)(this.serviceAreaDetails.serviceAreas) > 0) {
                    this.selectedServiceAreaName = this._getFormattedServiceAreaNameIfItsCounty();
                    this._addServiceAreaCounty();
                    this.close();
                } else {
                    this.isLocationDisabled = false;
                    this.isServiceAreaFieldHaveError = true;
                    this.disableSaveButton = false;
                }
            }

            /******************* 
             * Private methods
            ***************/

        }, {
            key: '_addServiceAreaCounty',
            value: function _addServiceAreaCounty() {
                var _this = this;

                this._getLatlngDetailsByPlaceName(this.selectedServiceAreaName).then(function (details) {
                    return _this.serviceAreaCountyService.addServiceAreaCounty(details);
                }).then(function (_) {
                    return _this.toastr.success(_this.selectedServiceAreaName + ' added successfully.');
                }).then(function (_) {
                    return _this.resolve.details.reloadCountyList();
                }).catch(function (err) {
                    return _this.toastr.error(err);
                });
            }
        }, {
            key: '_getFormattedServiceAreaNameIfItsCounty',
            value: function _getFormattedServiceAreaNameIfItsCounty() {
                return this.selectedServiceAreaType === 'county' ? this._removeCountyWordFromServiceAreaCounty(this.selectedServiceAreaName) : this.selectedServiceAreaName;
            }
        }, {
            key: '_getLatlngDetailsByPlaceName',
            value: function _getLatlngDetailsByPlaceName(serviceAreaName) {
                var _this2 = this;

                var placeName = this._getFormattedPlaceName(serviceAreaName);

                return this.googleLocationService.getLocationDetailsByPlaceName(placeName).then(function (_ref2) {
                    var _ref3 = _slicedToArray(_ref2, 1),
                        details = _ref3[0];

                    var _details$geometry$loc = details.geometry.location,
                        lat = _details$geometry$loc.lat,
                        lng = _details$geometry$loc.lng;


                    return {
                        name: _this2.selectedServiceAreaName,
                        type: _this2.selectedServiceAreaType,
                        latlng: {
                            lat: lat(),
                            lng: lng()
                        },
                        stateCode: _this2._getInitialsByType('state')
                    };
                }).catch(function (err) {
                    _this2.isServiceAreaFieldHaveError = true;
                    throw err;
                });
            }
        }, {
            key: '_getFormattedPlaceName',
            value: function _getFormattedPlaceName(serviceAreaName) {
                var countryInitial = this._getInitialsByType('country');
                var stateInitial = this._getInitialsByType('state');

                var serviceAreas = this._getReverseOrderOfServiceTypeOptions();
                var index = this._getIndexOfSelectedServiceArea(serviceAreas, serviceAreaName);
                var areas = serviceAreas.splice(index);

                var placeName = _getPlaceName();

                function _getPlaceName() {
                    return areas.map(function (_ref4) {
                        var value = _ref4.value;
                        return value;
                    });
                }

                return placeName.join(',') + ',' + stateInitial + ',' + countryInitial;
            }
        }, {
            key: '_getIndexOfSelectedServiceArea',
            value: function _getIndexOfSelectedServiceArea(serviceAreas, serviceAreaName) {
                return (0, _findIndex2.default)(serviceAreas, { value: serviceAreaName });
            }
        }, {
            key: '_getReverseOrderOfServiceTypeOptions',
            value: function _getReverseOrderOfServiceTypeOptions() {
                var options = (0, _clone2.default)(this.serviceAreaTypeOptions);
                return options.reverse();
            }
        }, {
            key: '_getServiceAreaTypeName',
            value: function _getServiceAreaTypeName(type) {
                return (0, _find2.default)(this.serviceAreaTypeOptions, { id: type }).value;
            }
        }, {
            key: '_getInitialsByType',
            value: function _getInitialsByType(type) {
                return (0, _find2.default)(this.serviceAreaDetails.serviceAreas, { type: type }).name;
            }
        }, {
            key: '_getServiceAreaTypeOptions',
            value: function _getServiceAreaTypeOptions(_ref5) {
                var serviceAreas = _ref5.serviceAreas;

                return this.serviceAreaCountyService.getServiceAreaTypeOptions(serviceAreas);
            }
        }, {
            key: '_removeCountyWordFromServiceAreaCounty',
            value: function _removeCountyWordFromServiceAreaCounty(countyName) {
                return countyName.replace('County', '').trim();
            }
        }]);

        return ServiceAreaAddComponent;
    }()
};

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.serviceAreaAdd = undefined;

var _serviceAreaAdd = __webpack_require__(639);

var serviceAreaAdd = exports.serviceAreaAdd = angular.module('components.serviceArea.serviceAreaAdd', []).component('serviceAreaAdd', _serviceAreaAdd.serviceAreaAddComponent).name;

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.serviceAreaProvidersListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _serviceAreaProvidersList = __webpack_require__(788);

var _serviceAreaProvidersList2 = _interopRequireDefault(_serviceAreaProvidersList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var serviceAreaProvidersListComponent = exports.serviceAreaProvidersListComponent = {
    bindings: {
        resolve: '<',
        close: '&'
    },

    templateUrl: _serviceAreaProvidersList2.default,

    controller: function () {
        ServiceAreaProvidersListComponent.$inject = ["ServiceAreaCountyService", "ApiService"];
        function ServiceAreaProvidersListComponent(ServiceAreaCountyService, ApiService) {
            'ngInject';

            _classCallCheck(this, ServiceAreaProvidersListComponent);

            this.serviceAreaCountyService = ServiceAreaCountyService;
            this.apiService = ApiService;
        }

        _createClass(ServiceAreaProvidersListComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.serviceAreaId = this.resolve.details.serviceAreaId;
                this.list = [];
                this._setProvidersList();
            }

            //******************************************Private Methods********************************* */

            /**
             * ‘Presently we are just considering Transportation providers which are linked with a given service area, but we can display all the contents which are linked with a given service area’
             */

        }, {
            key: '_setProvidersList',
            value: function _setProvidersList() {
                var _this = this;

                this.serviceAreaCountyService.getContentLinkedWithServiceArea(this.serviceAreaId).then(function (details) {
                    _this.list = details;
                });
            }
        }, {
            key: '_getImage',
            value: function _getImage(image) {
                return image ? this.apiService.getResourceUrl('files/images/' + image) : '/./images/placeholder.png';
            }
        }]);

        return ServiceAreaProvidersListComponent;
    }()
};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.serviceAreaProvidersList = undefined;

var _serviceAreaProvidersList = __webpack_require__(641);

__webpack_require__(196);

var serviceAreaProvidersList = exports.serviceAreaProvidersList = angular.module('components.serviceArea.serviceAreaProvidersList', []).component('serviceAreaProvidersList', _serviceAreaProvidersList.serviceAreaProvidersListComponent).name;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.serviceAreaListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _serviceArea = __webpack_require__(789);

var _serviceArea2 = _interopRequireDefault(_serviceArea);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

var _size = __webpack_require__(12);

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var serviceAreaListComponent = exports.serviceAreaListComponent = {
    bindings: {
        details: '<'
    },

    templateUrl: _serviceArea2.default,

    controller: function () {
        ServiceAreaListComponent.$inject = ["$anchorScroll", "$state", "ServiceAreaCountyService", "ModalService", "toastr"];
        function ServiceAreaListComponent($anchorScroll, $state, ServiceAreaCountyService, ModalService, toastr) {
            'ngInject';

            _classCallCheck(this, ServiceAreaListComponent);

            this.$anchorScroll = $anchorScroll;
            this.$state = $state;
            this.serviceAreaCountyService = ServiceAreaCountyService;
            this.modalService = ModalService;
            this.toastr = toastr;
        }

        _createClass(ServiceAreaListComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.pageTitle = 'Service Area';
                this.serviceAreaList = this.serviceAreaCountyService.getServiceAreaList(this.details.data.content);
                if (this.serviceAreaList.length > 0) {
                    //By default tab is selected as County
                    this.serviceAreaList[0].isSelected = true;
                }
                this.selectedServiceAreas = this._getSelectedServiceAreaList();
                this.totalItems = (0, _head2.default)(this.serviceAreaList).count;
                this._resetPaginationConfigObject();
            }
        }, {
            key: 'onChange',
            value: function onChange(pageNumber) {
                var _this = this;

                this.currentPage = pageNumber;
                this._setFilterObject();
                this._getFilteredServiceAreaList().then(function (list) {
                    _this.selectedServiceAreas = angular.copy(list);
                });
            }
        }, {
            key: 'onServiceAreaAdd',
            value: function onServiceAreaAdd() {
                this._openServiceAreaAddModal();
            }
        }, {
            key: 'onChangeAreaType',
            value: function onChangeAreaType(areaType) {
                this._changeSelectedServiceAreaType(areaType);
                this._setSelectedAreaList();
                this._resetPaginationConfigObject();
            }
        }, {
            key: 'displayProvidersList',
            value: function displayProvidersList(serviceAreaId, providersLinked) {
                if (providersLinked > 0) {
                    this._openProvidersListModal(serviceAreaId);
                }
            }
        }, {
            key: 'onDeleteServiceArea',
            value: function onDeleteServiceArea(_ref) {
                var serviceAreaId = _ref.serviceAreaId,
                    providersLinked = _ref.providersLinked,
                    bicycleAndPedestrianLinked = _ref.bicycleAndPedestrianLinked,
                    mobilityManagerLinked = _ref.mobilityManagerLinked,
                    progressReportLinked = _ref.progressReportLinked,
                    ridesharingLinked = _ref.ridesharingLinked;

                var warningMessage = this._getWarningMessageForDeleteAction(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked);
                this.modalService.open({
                    details: {
                        bodyMessage: '' + warningMessage
                    },
                    buttons: [{
                        name: 'No'
                    }, {
                        name: 'Yes',
                        isPrimary: true,
                        action: _onDelete.bind(this, serviceAreaId)
                    }]
                });

                function _onDelete(serviceAreaId) {
                    var _this2 = this;

                    this.serviceAreaCountyService.deleteServiceArea(serviceAreaId).then(function (_) {
                        _this2.toastr.success("service area deleted successfully");
                        _this2.$state.reload();
                    }).catch(function (err) {
                        _this2.toastr.error(err);
                    });
                }
            }

            //*******************************************************Private Methods************************************ */

        }, {
            key: '_getWarningMessageForDeleteAction',
            value: function _getWarningMessageForDeleteAction(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked) {
                if (this._isServiceAreaNotLinkedToAnyModule(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked)) {
                    return 'Action can not be reverted back, Are you sure you want to delete it?';
                } else {
                    var message = this._getWarningMessageWithAffectedModuleDetails(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked);

                    return message;
                }
            }
        }, {
            key: '_isServiceAreaNotLinkedToAnyModule',
            value: function _isServiceAreaNotLinkedToAnyModule(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked) {
                return providersLinked === 0 && bicycleAndPedestrianLinked === 0 && mobilityManagerLinked === 0 && progressReportLinked === 0 && ridesharingLinked === 0;
            }
        }, {
            key: '_getWarningMessageWithAffectedModuleDetails',
            value: function _getWarningMessageWithAffectedModuleDetails(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked) {
                var warningMessage = [];

                if (providersLinked > 0) {
                    warningMessage = [providersLinked + ' Transportation provider(s)'].concat(_toConsumableArray(warningMessage));
                }

                if (bicycleAndPedestrianLinked > 0) {
                    warningMessage = [bicycleAndPedestrianLinked + ' Bicycle And Pedestrian'].concat(_toConsumableArray(warningMessage));
                }

                if (mobilityManagerLinked > 0) {
                    warningMessage = [mobilityManagerLinked + ' Mobility Manager(s)'].concat(_toConsumableArray(warningMessage));
                }

                if (progressReportLinked > 0) {
                    warningMessage = [progressReportLinked + ' Progress Report(s)'].concat(_toConsumableArray(warningMessage));
                }

                if (ridesharingLinked > 0) {
                    warningMessage = [ridesharingLinked + ' Ridesharing'].concat(_toConsumableArray(warningMessage));
                }

                return warningMessage.join(', ') + ' have been linked to this service area. Action can not be reverted back. Are you sure you want to delete this service area?';
            }
        }, {
            key: '_getSelectedServiceAreaList',
            value: function _getSelectedServiceAreaList() {
                var _getSelectedServiceAr = this._getSelectedServiceAreaTypeObject(),
                    values = _getSelectedServiceAr.values;

                return values;
            }
        }, {
            key: '_setFilterObject',
            value: function _setFilterObject() {
                this.filterDetails.limit = this.itemPerPage;
                this.filterDetails.pageId = this.currentPage;
            }
        }, {
            key: '_openServiceAreaAddModal',
            value: function _openServiceAreaAddModal() {
                var _this3 = this;

                this.modalService.open({
                    backdrop: 'static',
                    keyboard: false,
                    component: 'serviceAreaAdd',
                    details: {
                        reloadCountyList: function reloadCountyList() {
                            _this3.$state.reload();
                        }
                    }
                });
            }
        }, {
            key: '_openProvidersListModal',
            value: function _openProvidersListModal(serviceAreaId) {
                this.modalService.open({
                    backdrop: 'static',
                    keyboard: false,
                    component: 'serviceAreaProvidersList',
                    details: {
                        serviceAreaId: serviceAreaId
                    }
                });
            }
        }, {
            key: '_changeSelectedServiceAreaType',
            value: function _changeSelectedServiceAreaType(areaType) {
                var newSelectedAreaType = (0, _find2.default)(this.serviceAreaList, { serviceAreaType: areaType });
                var selectedAreaType = this._getSelectedServiceAreaTypeObject();

                selectedAreaType.isSelected = false;
                newSelectedAreaType.isSelected = true;
            }
        }, {
            key: '_getSelectedServiceAreaTypeObject',
            value: function _getSelectedServiceAreaTypeObject() {
                return (0, _find2.default)(this.serviceAreaList, { isSelected: true });
            }
        }, {
            key: '_setSelectedAreaList',
            value: function _setSelectedAreaList() {
                var _getSelectedServiceAr2 = this._getSelectedServiceAreaTypeObject(),
                    values = _getSelectedServiceAr2.values,
                    count = _getSelectedServiceAr2.count;

                this.selectedServiceAreas = values;
                this.totalItems = count;
            }
        }, {
            key: '_getFilteredServiceAreaList',
            value: function _getFilteredServiceAreaList() {
                var _getSelectedServiceAr3 = this._getSelectedServiceAreaTypeObject(),
                    serviceAreaType = _getSelectedServiceAr3.serviceAreaType;

                return this.serviceAreaCountyService.getFilteredServiceAreaListByServiceAreaType(this.filterDetails, serviceAreaType);
            }
        }, {
            key: '_resetPaginationConfigObject',
            value: function _resetPaginationConfigObject() {
                this.itemPerPage = 10;
                this.currentPage = 1;

                this.filterDetails = {
                    limit: this.itemPerPage,
                    pageId: this.currentPage
                };
            }
        }, {
            key: '_getServiceAreaTypeList',
            value: function _getServiceAreaTypeList() {
                return this.serviceAreaCountyService.getServiceAreaTypeList();
            }
        }]);

        return ServiceAreaListComponent;
    }()
};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.serviceAreaList = undefined;

var _serviceArea = __webpack_require__(643);

var _serviceArea2 = __webpack_require__(645);

var _serviceAreaAdd = __webpack_require__(640);

var _serviceAreaProvidersList = __webpack_require__(642);

__webpack_require__(197);

var serviceAreaList = exports.serviceAreaList = angular.module('components.serviceArea', [_serviceAreaAdd.serviceAreaAdd, _serviceAreaProvidersList.serviceAreaProvidersList]).service('ServiceAreaCountyService', _serviceArea2.ServiceAreaCountyService).component('serviceAreaList', _serviceArea.serviceAreaListComponent).name;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ServiceAreaCountyService = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

var _reduce = __webpack_require__(78);

var _reduce2 = _interopRequireDefault(_reduce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ServiceAreaCountyService = exports.ServiceAreaCountyService = function () {
    ServiceAreaCountyService.$inject = ["$resource", "$cookies", "ApiService"];
    function ServiceAreaCountyService($resource, $cookies, ApiService) {
        'ngInject';

        _classCallCheck(this, ServiceAreaCountyService);

        this.$resource = $resource;
        this.apiService = ApiService;

        this.serviceAreaResourceUrl = this.apiService.getResourceUrl('cms/program/service-area/:service_area_id');
        this.filterServiceAreaResourceUrl = this.apiService.getResourceUrl('cms/program/service-area/filter');
        this.serviceAreaLinkContentResourceUrl = this.apiService.getResourceUrl('cms/transportation-alternative/:service_area_id');
        this.serviceAreaLinkContentResource = this.$resource(this.serviceAreaLinkContentResourceUrl);

        this.serviceAreaResource = this.$resource(this.serviceAreaResourceUrl, null, {
            delete: {
                method: 'DELETE',
                params: {
                    service_area_id: '@service_area_id'
                }
            }
        });
        this.filterServiceAreaResource = this.$resource(this.filterServiceAreaResourceUrl);
    }

    _createClass(ServiceAreaCountyService, [{
        key: 'getServiceAreaList',
        value: function getServiceAreaList(_ref) {
            var _ref2 = _slicedToArray(_ref, 1),
                serviceAreaDetails = _ref2[0];

            return this._getServiceAreaDetailsObject(serviceAreaDetails.values);
        }
    }, {
        key: 'getFilteredServiceAreaListByServiceAreaType',
        value: function getFilteredServiceAreaListByServiceAreaType(_ref3, serviceAreaType) {
            var _this = this;

            var limit = _ref3.limit,
                pageId = _ref3.pageId;

            var promise = this.filterServiceAreaResource.get({
                limit: limit,
                page_id: pageId,
                service_area_type: serviceAreaType
            }).$promise;

            return promise.then(function (_ref4) {
                var data = _ref4.data;
                return _this._getFormattedServiceAreasObject(data);
            }).catch(function (err) {
                throw _this.apiService.getErrorMessage(err);
            });
        }
    }, {
        key: 'addServiceAreaCounty',
        value: function addServiceAreaCounty(details) {
            var _this2 = this;

            var promise = this.serviceAreaResource.save(this._setServiceAreaDetailsObject(details)).$promise;

            return promise.then(function (details) {
                return details;
            }).catch(function (err) {
                throw _this2.apiService.getErrorMessage(err);
            });
        }
    }, {
        key: 'getServiceAreaTypeList',
        value: function getServiceAreaTypeList() {
            return [{
                id: 1,
                name: 'county',
                count: 0,
                isSelected: true
            }, {
                id: 2,
                name: 'town',
                count: 0,
                isSelected: false
            }, {
                id: 3,
                name: 'village',
                count: 0,
                isSelected: false
            }, {
                id: 4,
                name: 'township',
                count: 0,
                isSelected: false
            }];
        }
    }, {
        key: 'deleteServiceArea',
        value: function deleteServiceArea(serviceAreaId) {
            var _this3 = this;

            var promise = this.serviceAreaResource.delete({ service_area_id: serviceAreaId }).$promise;

            return promise.then(function (details) {
                return details;
            }).catch(function (err) {
                throw _this3.apiService.getErrorMessage(err);
            });
        }
    }, {
        key: 'getServiceAreaTypeOptions',
        value: function getServiceAreaTypeOptions(serviceAreas) {
            var serviceAreaTypeList = this.getServiceAreaTypeList();
            return this._getOrderWiseServiceAreaOptionsList(serviceAreaTypeList, serviceAreas);
        }
    }, {
        key: 'getContentLinkedWithServiceArea',
        value: function getContentLinkedWithServiceArea(serviceAreaId) {
            var _this4 = this;

            var promise = this.serviceAreaLinkContentResource.get({ service_area_id: serviceAreaId }).$promise;

            return promise.then(function (_ref5) {
                var data = _ref5.data;
                return {
                    transportationProviders: _this4._getServiceAreaContentObject(data.transportation_providers)
                };
            }).catch(function (err) {
                throw _this4.apiService.getErrorMessage(err);
            });
        }
    }, {
        key: '_getServiceAreaContentObject',
        value: function _getServiceAreaContentObject(values) {
            var _this5 = this;

            return values.map(function (_ref6) {
                var contentId = _ref6.content_id,
                    details = _ref6.details,
                    serviceArea = _ref6.service_area;
                return {
                    contentId: contentId,
                    name: details.name,
                    image: details.image,
                    serviceArea: _this5._getServiceAreaObject(serviceArea)
                };
            });
        }
    }, {
        key: '_getServiceAreaObject',
        value: function _getServiceAreaObject(values) {
            return values.map(function (_ref7) {
                var serviceAreaId = _ref7.service_area_id,
                    name = _ref7.service_area_name;
                return {
                    serviceAreaId: serviceAreaId,
                    name: name
                };
            });
        }
    }, {
        key: '_setServiceAreaDetailsObject',
        value: function _setServiceAreaDetailsObject(_ref8) {
            var latlng = _ref8.latlng,
                name = _ref8.name,
                state_code = _ref8.stateCode,
                type = _ref8.type;

            return {
                name: name,
                latlng: latlng,
                state_code: state_code,
                type: type
            };
        }
    }, {
        key: '_getOrderWiseServiceAreaOptionsList',
        value: function _getOrderWiseServiceAreaOptionsList(serviceAreaTypeList, serviceAreas) {
            return (0, _reduce2.default)(serviceAreaTypeList, function (filteredServiceArea, _ref9) {
                var name = _ref9.name;

                var serviceAreaDetails = (0, _find2.default)(serviceAreas, { type: name });
                if (serviceAreaDetails) {
                    var title = serviceAreaDetails.type,
                        value = serviceAreaDetails.name;

                    filteredServiceArea.push({ id: title, title: title, value: value });
                }
                return filteredServiceArea;
            }, []);
        }
    }, {
        key: '_getServiceAreaDetailsObject',
        value: function _getServiceAreaDetailsObject(data) {
            var _this6 = this;

            return data.map(function (_ref10) {
                var serviceAreaType = _ref10.service_area_type,
                    count = _ref10.count,
                    values = _ref10.values;
                return {
                    serviceAreaType: serviceAreaType,
                    count: count,
                    values: _this6._getFormattedServiceAreasObject(values),
                    isSelected: false
                };
            });
        }
    }, {
        key: '_getFormattedServiceAreasObject',
        value: function _getFormattedServiceAreasObject(data) {
            return data.map(function (_ref11) {
                var serviceAreaId = _ref11.service_area_id,
                    name = _ref11.name,
                    providersLinked = _ref11.provider_linked,
                    stateCode = _ref11.state_code,
                    bicycleAndPedestrianLinked = _ref11.bicycle_and_pedestrian_linked,
                    mobilityManagerLinked = _ref11.mobility_manager_linked,
                    ridesharingLinked = _ref11.ridesharing_linked,
                    progressReportLinked = _ref11.progress_report_linked;
                return {
                    serviceAreaId: serviceAreaId,
                    name: name + ', ' + stateCode,
                    providersLinked: providersLinked,
                    ridesharingLinked: ridesharingLinked,
                    mobilityManagerLinked: mobilityManagerLinked,
                    bicycleAndPedestrianLinked: bicycleAndPedestrianLinked,
                    progressReportLinked: progressReportLinked
                };
            });
        }
    }]);

    return ServiceAreaCountyService;
}();

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.socialLinksComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _socialLinks = __webpack_require__(790);

var _socialLinks2 = _interopRequireDefault(_socialLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var socialLinksComponent = exports.socialLinksComponent = {
	bindings: {
		details: '<'
	},

	templateUrl: _socialLinks2.default,

	controller: function () {
		SocialLinksComponent.$inject = ["$state", "toastr", "CompareObjectService", "ModalService", "SocialLinksService"];
		function SocialLinksComponent($state, toastr, CompareObjectService, ModalService, SocialLinksService) {
			'ngInject';

			_classCallCheck(this, SocialLinksComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.socialLinksService = SocialLinksService;
		}

		_createClass(SocialLinksComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.socialLinksService.getSocialLinks(this.details);
				this.pageTitle = "Edit Social Links";
				this.savedData = angular.copy(this.details);
			}
		}, {
			key: 'onCancel',
			value: function onCancel() {
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, false);

				if (isUpdated) {
					var _onSubmit = function _onSubmit() {
						this._redirectToParentState('home-banner');
					};

					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},
						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: _onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState('home-banner');
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				this.disableButtons = true;
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, true);

				if (isUpdated) {
					this.socialLinksService.editSocialLinks(this.details).then(function (_) {
						_this.toastr.success('Social links are updated successfully');
						_this.disableButtons = false;
					}).catch(function (err) {
						_this.toastr.error(err);
						_this.disableButtons = false;
					});
				} else {
					this.toastr.success('Nothing to update');
					this.disableButtons = false;
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return SocialLinksComponent;
	}()
};

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.socialLinks = undefined;

var _socialLinks = __webpack_require__(646);

var _socialLinks2 = __webpack_require__(648);

__webpack_require__(198);

var socialLinks = exports.socialLinks = angular.module('components.socialLinks', []).service('SocialLinksService', _socialLinks2.SocialLinksService).component('socialLinks', _socialLinks.socialLinksComponent).name;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SocialLinksService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SocialLinksService = exports.SocialLinksService = function () {
    SocialLinksService.$inject = ["$resource", "ApiService"];
    function SocialLinksService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, SocialLinksService);

        this.$resource = $resource;
        this.apiService = ApiService;

        this.socialLinksResourceUrl = this.apiService.getResourceUrl('cms/menus/SocialLinks');
        this.editSocialLinksResourceUrl = this.apiService.getResourceUrl('cms/social-links');

        this.socialLinksResource = this.$resource(this.socialLinksResourceUrl);
        this.editSocialLinksResource = this.$resource(this.editSocialLinksResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }

    _createClass(SocialLinksService, [{
        key: '_getSubContentDetails',
        value: function _getSubContentDetails(_ref) {
            var socialLinks = _ref.social_links;

            return socialLinks.map(function (_ref2) {
                var name = _ref2.name,
                    url = _ref2.url;
                return { name: name, url: url };
            });
        }
    }, {
        key: '_setSubContentDetails',
        value: function _setSubContentDetails(value) {
            return {
                social_links: this._setSocialLinks(value)
            };
        }
    }, {
        key: '_setSocialLinks',
        value: function _setSocialLinks(values) {
            return values.map(function (_ref3) {
                var name = _ref3.name,
                    url = _ref3.url;
                return { name: name, url: url.trim() };
            });
        }

        /************
         * To get SocialLinks
         ***************/

    }, {
        key: 'getSocialLinks',
        value: function getSocialLinks(_ref4) {
            var data = _ref4.data;

            return this._getSubContentDetails((0, _find2.default)(data.content, ['name', 'SocialLinks']).values[0]);
        }

        /*************
         * To Update SocialLinks
         *****************/

    }, {
        key: 'editSocialLinks',
        value: function editSocialLinks(details) {
            var _this = this;

            var promise = this.editSocialLinksResource.update(this._setSubContentDetails(details)).$promise;

            return promise.then(function (details) {
                return details;
            }).catch(function (err) {
                throw _this.apiService.getErrorMessage(err);
            });
        }
    }]);

    return SocialLinksService;
}();

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.socialShareComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

var _socialShare = __webpack_require__(791);

var _socialShare2 = _interopRequireDefault(_socialShare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var socialShareComponent = exports.socialShareComponent = {
    bindings: {
        details: '<'
    },

    templateUrl: _socialShare2.default,

    controller: function () {
        SocialShareComponent.$inject = ["$state", "toastr", "CompareObjectService", "ModalService", "SocialShareService"];
        function SocialShareComponent($state, toastr, CompareObjectService, ModalService, SocialShareService) {
            'ngInject';

            _classCallCheck(this, SocialShareComponent);

            this.$state = $state;
            this.toastr = toastr;
            this.compareObjectService = CompareObjectService;
            this.modalService = ModalService;
            this.socialShareService = SocialShareService;
        }

        _createClass(SocialShareComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.details = this.socialShareService.getSocialShareAppIds(this.details);
                this.pageTitle = "Edit Social Share App Ids";
                this.showStepsForFacebookAppId = false;
                this.isFacebookAppIdIsInvalid = false;
                this.disableButtons = true;
                this.savedData = angular.copy(this.details);
            }
        }, {
            key: 'onChangeAppId',
            value: function onChangeAppId(appName) {
                var _this = this;

                this.disableButtons = false;
                switch (appName) {
                    case 'Facebook':
                        var facebookAppIdObject = (0, _head2.default)((0, _filter2.default)(this.details, function (_ref) {
                            var name = _ref.name;
                            return name === appName;
                        }));

                        if (facebookAppIdObject.appId) {
                            this.socialShareService.validateFacebookAppId(facebookAppIdObject.appId).then(function (details) {
                                facebookAppIdObject.isCorrect = true;
                                _this.isFacebookAppIdIsInvalid = false;
                                _this.disableButtons = false;
                            }).catch(function (err) {
                                facebookAppIdObject.isCorrect = false;
                                _this.isFacebookAppIdIsInvalid = true;
                                _this.disableButtons = true;
                            });
                        } else {
                            facebookAppIdObject.isCorrect = false;
                        }
                        break;
                }
            }
        }, {
            key: 'onCancel',
            value: function onCancel() {
                var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, false);

                if (isUpdated) {
                    var _onSubmit = function _onSubmit() {
                        this._redirectToParentState('home-banner');
                    };

                    this.modalService.open({
                        details: {
                            bodyMessage: 'Changes done will be reverted. Continue?'
                        },
                        buttons: [{
                            name: 'No'
                        }, {
                            name: 'Yes',
                            isPrimary: true,
                            action: _onSubmit.bind(this)
                        }]
                    });
                } else {
                    this._redirectToParentState('home-banner');
                }
            }
        }, {
            key: 'onSubmit',
            value: function onSubmit() {
                var _this2 = this;

                this.disableButtons = true;
                var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, true);

                if (isUpdated) {
                    this.socialShareService.editSocialShareAppIds(this.details).then(function (_) {
                        _this2.toastr.success('Social Share app ids are updated successfully');
                        _this2.disableButtons = false;
                    }).catch(function (err) {
                        _this2.toastr.error(err);
                        _this2.disableButtons = false;
                    });
                } else {
                    this.toastr.success('Nothing to update');
                    this.disableButtons = false;
                }
            }
        }, {
            key: '_showStepsForFacebookAppId',
            value: function _showStepsForFacebookAppId() {
                this.showStepsForFacebookAppId = !this.showStepsForFacebookAppId;
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }]);

        return SocialShareComponent;
    }()
};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.socialShare = undefined;

var _socialShare = __webpack_require__(649);

var _socialShare2 = __webpack_require__(651);

__webpack_require__(199);

var socialShare = exports.socialShare = angular.module('components.socialShare', []).service('SocialShareService', _socialShare2.SocialShareService).component('socialShare', _socialShare.socialShareComponent).name;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SocialShareService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SocialShareService = exports.SocialShareService = function () {
    SocialShareService.$inject = ["$resource", "ApiService"];
    function SocialShareService($resource, ApiService) {
        'ngInject';

        _classCallCheck(this, SocialShareService);

        this.$resource = $resource;
        this.apiService = ApiService;

        this.socialShareResourceUrl = this.apiService.getResourceUrl('cms/menus/SocialShare');
        this.editSocialShareResourceUrl = this.apiService.getResourceUrl('cms/social-share');

        this.socialShareResource = this.$resource(this.socialShareResourceUrl);
        this.editSocialShareResource = this.$resource(this.editSocialShareResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
    }

    _createClass(SocialShareService, [{
        key: '_getSubContentDetails',
        value: function _getSubContentDetails(_ref) {
            var socialShareAppIds = _ref.social_share_app_ids;

            return socialShareAppIds.map(function (_ref2) {
                var name = _ref2.name,
                    appId = _ref2.app_id;
                return { name: name, appId: appId, isCorrect: appId ? true : false };
            });
        }
    }, {
        key: '_setSubContentDetails',
        value: function _setSubContentDetails(value) {
            return {
                social_share_app_ids: this._setSocialShareAppIds(value)
            };
        }
    }, {
        key: '_setSocialShareAppIds',
        value: function _setSocialShareAppIds(values) {
            return values.map(function (_ref3) {
                var name = _ref3.name,
                    appId = _ref3.appId;
                return { name: name, app_id: appId.trim() };
            });
        }

        /************
         * To get SocialShare App Ids
         ***************/

    }, {
        key: 'getSocialShareAppIds',
        value: function getSocialShareAppIds(_ref4) {
            var data = _ref4.data;

            return this._getSubContentDetails((0, _find2.default)(data.content, ['name', 'SocialShare']).values[0]);
        }

        /*************
         * To Update SocialShare App Ids
         *****************/

    }, {
        key: 'editSocialShareAppIds',
        value: function editSocialShareAppIds(details) {
            var _this = this;

            var promise = this.editSocialShareResource.update(this._setSubContentDetails(details)).$promise;

            return promise.then(function (details) {
                return details;
            }).catch(function (err) {
                throw _this.apiService.getErrorMessage(err);
            });
        }
    }, {
        key: 'validateFacebookAppId',
        value: function validateFacebookAppId(appId) {
            var facebookAppIdValidationResourceUrl = 'https://graph.facebook.com/' + appId;
            var facebookAppIdValidationResource = this.$resource(facebookAppIdValidationResourceUrl);

            var promise = facebookAppIdValidationResource.get().$promise;

            return promise.then(function (details) {
                return details;
            });
        }
    }]);

    return SocialShareService;
}();

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.termsAndConditionComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _termsAndCondition = __webpack_require__(792);

var _termsAndCondition2 = _interopRequireDefault(_termsAndCondition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var termsAndConditionComponent = exports.termsAndConditionComponent = {
	bindings: {
		details: '<'
	},

	templateUrl: _termsAndCondition2.default,

	controller: function () {
		TermsAndConditionComponent.$inject = ["$state", "toastr", "CompareObjectService", "ModalService", "TermsAndConditionService"];
		function TermsAndConditionComponent($state, toastr, CompareObjectService, ModalService, TermsAndConditionService) {
			'ngInject';

			_classCallCheck(this, TermsAndConditionComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.termsAndConditionService = TermsAndConditionService;
		}

		_createClass(TermsAndConditionComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.termsAndConditionService.getTermsAndConditionObject(this.details);
				this.details.pageTitle = "Edit Terms & Conditions";
				this.savedData = angular.copy(this.details.menuContentDetails);
			}
		}, {
			key: 'onCancel',
			value: function onCancel() {
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, false);

				if (isUpdated) {
					var _onSubmit = function _onSubmit() {
						this._redirectToParentState('home-banner');
					};

					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},
						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: _onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState('home-banner');
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				this.disableButtons = true;
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, true);

				if (isUpdated) {
					this.termsAndConditionService.editTermsAndCondition(this.details.menuContentDetails).then(function (_) {
						_this.toastr.success('Terms And Conditions is updated successfully');
						_this.disableButtons = false;
					}).catch(function (err) {
						_this.toastr.error(err);
						_this.disableButtons = false;
					});
				} else {
					this.toastr.success('Nothing to update');
					this.disableButtons = false;
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return TermsAndConditionComponent;
	}()
};

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.termsAndCondition = undefined;

var _termsAndCondition = __webpack_require__(652);

var _termsAndCondition2 = __webpack_require__(654);

var termsAndCondition = exports.termsAndCondition = angular.module('components.termsAndCondition', []).service('TermsAndConditionService', _termsAndCondition2.TermsAndConditionService).component('termsAndCondition', _termsAndCondition.termsAndConditionComponent).name;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditionService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TermsAndConditionService = exports.TermsAndConditionService = function () {
  TermsAndConditionService.$inject = ["$resource", "ApiService"];
  function TermsAndConditionService($resource, ApiService) {
    'ngInject';

    _classCallCheck(this, TermsAndConditionService);

    this.$resource = $resource;
    this.apiService = ApiService;

    this.termsAndConditionResourceUrl = this.apiService.getResourceUrl('cms/menus/TermsAndCondition');
    this.editTermsAndConditionResourceUrl = this.apiService.getResourceUrl('cms/terms-and-condition');

    this.termsAndConditionResource = this.$resource(this.termsAndConditionResourceUrl);
    this.editTermsAndConditionResource = this.$resource(this.editTermsAndConditionResourceUrl, null, {
      update: {
        method: 'PUT'
      }
    });
  }

  _createClass(TermsAndConditionService, [{
    key: '_getContentDetails',
    value: function _getContentDetails(value) {
      return {
        id: value.content_id,
        description: value.description,
        images: this._getContentImagesObject(value.images) || [],
        videos: value.videos || []
      };
    }
  }, {
    key: '_getContentImagesObject',
    value: function _getContentImagesObject(values) {
      return values ? values.map(function (_ref) {
        var uuid = _ref.uuid;
        return { uuid: uuid, status: -1 };
      }) : [];
    }
  }, {
    key: '_setContentDetails',
    value: function _setContentDetails(value) {
      return {
        description: value.description,
        images: value.images || [],
        videos: value.videos || []
      };
    }

    /************
     * To get Terms & Condition
     ***************/

  }, {
    key: 'getTermsAndConditionObject',
    value: function getTermsAndConditionObject(_ref2) {
      var data = _ref2.data;

      return { menuContentDetails: this._getContentDetails((0, _find2.default)(data.content, ['name', 'TermsAndCondition']).values[0]) };
    }

    /*************
     * To Update Terms & Condition
     *****************/

  }, {
    key: 'editTermsAndCondition',
    value: function editTermsAndCondition(details) {
      var _this = this;

      var promise = this.editTermsAndConditionResource.update(this._setContentDetails(details)).$promise;

      return promise.then(function (details) {
        return details;
      }).catch(function (err) {
        throw _this.apiService.getErrorMessage(err);
      });
    }
  }]);

  return TermsAndConditionService;
}();

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bicyclePedestrianAddComponent = exports.bicyclePedestrianAddComponent = {

    //passing title and onSubmit function for binding in main component
    template: '\n        <bicycle-pedestrian-main\n            page-title=\'Add\'\n            parent-slug=\'{{$ctrl.parentSlug}}\'\n            disable-buttons=\'$ctrl.disableButtons\'\n            on-submit=\'$ctrl.onSubmit(details)\'\n            county=\'$ctrl.county\'>\n        </bicycle-pedestrian-main>',

    bindings: {
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for BicyclePedestrianAddComponent
    controller: function () {
        BicyclePedestrianAddComponent.$inject = ["$stateParams", "toastr", "$state", "TransportationAlternativeService", "DynamicMenusService", "SlugService"];
        function BicyclePedestrianAddComponent($stateParams, toastr, $state, TransportationAlternativeService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, BicyclePedestrianAddComponent);

            this.$stateParams = $stateParams;
            this.toastr = toastr;
            this.$state = $state;
            this.transportationAlternativeService = TransportationAlternativeService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        _createClass(BicyclePedestrianAddComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.county = [];
                this._getCountyList();
            }

            //function to add class details

        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                this.disableButtons = true;
                var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'add');
                details = this.transportationAlternativeService._setTemplate2DetailObject(details);

                // submit the request
                this.dynamicMenusService.addMenuDetailsByUrl(url, details).then(function (_ref) {
                    var id = _ref.data.content_id;

                    var contentDetailsUrl = _this.slugService.getContentDetailsURL(url, id);
                    _this.toastr.success('Data added successfully');
                    _this._redirectToParentState(contentDetailsUrl);
                    _this.disableButtons = false;
                }).catch(function (err) {
                    _this.toastr.error(err);
                    _this.disableButtons = false;
                });
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }, {
            key: '_getCountyList',
            value: function _getCountyList() {
                var _this2 = this;

                this.transportationAlternativeService.getCallForHelpCountyList().then(function (countyList) {
                    return _this2.county = countyList;
                });
            }
        }]);

        return BicyclePedestrianAddComponent;
    }()
};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bicyclePedestrianAdd = undefined;

var _bicyclePedestrianAdd = __webpack_require__(655);

var bicyclePedestrianAdd = exports.bicyclePedestrianAdd = angular.module('components.transportationAlternative.bicyclePedestrian.bicyclePedestrianAdd', []).component('bicyclePedestrianAdd', _bicyclePedestrianAdd.bicyclePedestrianAddComponent).name;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bicyclePedestrianDetailsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transportationAlternativeDetailsTemplate = __webpack_require__(796);

var _transportationAlternativeDetailsTemplate2 = _interopRequireDefault(_transportationAlternativeDetailsTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bicyclePedestrianDetailsComponent = exports.bicyclePedestrianDetailsComponent = {

	//binding details
	bindings: {
		details: '<',
		parentSlug: '@',
		slugUrl: '@'
	},

	templateUrl: _transportationAlternativeDetailsTemplate2.default,

	//controller for BicyclePedestrianDetailsComponent
	controller: function () {
		BicyclePedestrianDetailsComponent.$inject = ["$state", "ApiService", "TransportationAlternativeService", "SlugService"];
		function BicyclePedestrianDetailsComponent($state, ApiService, TransportationAlternativeService, SlugService) {
			'ngInject';

			_classCallCheck(this, BicyclePedestrianDetailsComponent);

			this.$state = $state;
			this.apiService = ApiService;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.slugService = SlugService;
		}

		_createClass(BicyclePedestrianDetailsComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.transportationAlternativeService.getBicyclePedestrianDetailsById(this.details);
			}
		}, {
			key: '_getImage',
			value: function _getImage(detail) {
				var image = detail.image;
				return image ? this.apiService.getResourceUrl('files/images/' + image) : '/./images/placeholder.png';
			}
		}, {
			key: 'onGoBack',
			value: function onGoBack() {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: this.parentSlug
				});
			}
		}, {
			key: 'onEdit',
			value: function onEdit() {
				var slug = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'details');
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}]);

		return BicyclePedestrianDetailsComponent;
	}()
};

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bicyclePedestrianDetails = undefined;

var _bicyclePedestrianDetails = __webpack_require__(657);

var bicyclePedestrianDetails = exports.bicyclePedestrianDetails = angular.module('components.bicyclePedestrian.bicyclePedestrianDetails', []).component('bicyclePedestrianDetails', _bicyclePedestrianDetails.bicyclePedestrianDetailsComponent)
// .config(($stateProvider) => {
//     'ngInject';

//     $stateProvider
//         .state('app.dashboard.bicyclePedestrianDetails', {
//             breadcrumbName: 'Details',
//             parentState: 'app.dashboard.BicycleAndPedestrian',
//             url: '/transportation-information/bicycle-pedestrian/:id/details',
//             component: 'bicyclePedestrianDetails',
//             resolve: {
//                 details($stateParams, TransportationAlternativeService) {
//                     '$ngInject';

//                     return TransportationAlternativeService.getBicyclePedestrianDetailsById($stateParams.id);
//                 }
//             }
//         });
// })
.name;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bicyclePedestrianEditComponent = exports.bicyclePedestrianEditComponent = {

    //passing title and onSubmit function for binding in main component
    template: '\n                <bicycle-pedestrian-main\n                    page-title=\'Edit\'\n                    details=\'$ctrl.details\'\n                    parent-slug=\'{{$ctrl.parentSlug}}\'\n                    disable-buttons=\'$ctrl.disableButtons\'\n                    on-submit=\'$ctrl.onSubmit(details)\'\n                    county=\'$ctrl.county\'>\n                </bicycle-pedestrian-main>',

    bindings: {
        details: '<',
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for BicyclePedestrianEditComponent
    controller: function () {
        BicyclePedestrianEditComponent.$inject = ["toastr", "$state", "$stateParams", "TransportationAlternativeService", "CompareObjectService", "DynamicMenusService", "SlugService"];
        function BicyclePedestrianEditComponent(toastr, $state, $stateParams, TransportationAlternativeService, CompareObjectService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, BicyclePedestrianEditComponent);

            this.toastr = toastr;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.transportationAlternativeService = TransportationAlternativeService;
            this.compareObjectService = CompareObjectService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        //storing old data in savedData


        _createClass(BicyclePedestrianEditComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.county = [];
                this.details = this.transportationAlternativeService.getBicyclePedestrianDetailsById(this.details);
                this.savedData = angular.copy(this.details);
                this._getCountyList();
            }

            //comparing old and new data for update on submit function

        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                var _details = angular.copy(details);
                var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, _details, true);
                if (isUpdated) {
                    var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'edit');
                    var _details2 = this.transportationAlternativeService._setTemplate2DetailObject(_details);

                    this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, _details2).then(function (details) {
                        var contentDetailsUrl = _this.slugService.getDetailsPageURL(url);
                        _this.toastr.success('Data updated successfully');
                        _this._redirectToParentState(contentDetailsUrl);
                        _this.disableButtons = false;
                    }).catch(function (err) {
                        _this.toastr.error(err);
                        _this._redirectToParentState(_this.parentSlug);
                        _this.disableButtons = false;
                    });
                } else {
                    this.toastr.success('Nothing to update');
                    this.disableButtons = false;
                }
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }, {
            key: '_getCountyList',
            value: function _getCountyList() {
                var _this2 = this;

                this.transportationAlternativeService.getCountyList().then(function (county) {
                    return _this2.county = county;
                });
            }
        }]);

        return BicyclePedestrianEditComponent;
    }()
};

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bicyclePedestrianEdit = undefined;

var _bicyclePedestrianEdit = __webpack_require__(659);

var bicyclePedestrianEdit = exports.bicyclePedestrianEdit = angular.module('components.transportationAlternative.bicyclePedestrian.bicyclePedestrianEdit', []).component('bicyclePedestrianEdit', _bicyclePedestrianEdit.bicyclePedestrianEditComponent).name;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bicyclePedestrianListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transportationAlternativeListTemplate = __webpack_require__(797);

var _transportationAlternativeListTemplate2 = _interopRequireDefault(_transportationAlternativeListTemplate);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bicyclePedestrianListComponent = exports.bicyclePedestrianListComponent = {
	bindings: {
		details: '<',
		slugUrl: '@'
	},

	templateUrl: _transportationAlternativeListTemplate2.default,

	controller: function () {
		BicyclePedestrianListComponent.$inject = ["$state", "toastr", "ApiService", "ModalService", "TransportationAlternativeService", "DashboardService", "DynamicMenusService", "SlugService"];
		function BicyclePedestrianListComponent($state, toastr, ApiService, ModalService, TransportationAlternativeService, DashboardService, DynamicMenusService, SlugService) {
			'ngInject';

			_classCallCheck(this, BicyclePedestrianListComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.apiService = ApiService;
			this.modalService = ModalService;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.dashboardService = DashboardService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		_createClass(BicyclePedestrianListComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.transportationAlternativeService.getBicyclePedestrianDetails(this.details);
				this.activeMenuName = this.dashboardService.getActiveMenuName();
				this.pageTitle = this.activeMenuName + ' List';

				this.currentPage = 1;
				this.itemPerPage = 10;
				this.totalItems = this.details.count;
				this.filterDetails = {
					'limit': this.itemPerPage,
					'page_id': this.currentPage
				};
			}
		}, {
			key: 'routeDetailsPageUrl',
			value: function routeDetailsPageUrl(slug) {
				var url = this.slugService.getDetailsPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeEditPageUrl',
			value: function routeEditPageUrl(slug) {
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: '_getImage',
			value: function _getImage(detail) {
				var image = detail.image;
				return image ? this.apiService.getResourceUrl('files/images/' + image) : '/./images/placeholder.png';
			}
		}, {
			key: 'routeAddPageUrl',
			value: function routeAddPageUrl() {
				var url = this.slugService.getAddPageURL(this.slugUrl);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'onChange',
			value: function onChange(pageNumber) {
				var _this = this;

				this.currentPage = pageNumber;
				this.filterDetails.limit = this.itemPerPage;
				this.filterDetails.page_id = this.currentPage;
				this.transportationAlternativeService.getFilterBicyclePedestrianDetails(this.filterDetails, this.slugUrl).then(function (result) {
					_this.details.list = result.list;
				});
			}

			//on delete the call for help data

		}, {
			key: 'onDelete',
			value: function onDelete(slug) {
				this.modalService.open({
					details: {
						bodyMessage: 'Are you sure you want to delete the data?'
					},

					buttons: [{
						name: 'No'
					}, {
						name: 'Yes',
						isPrimary: true,
						action: onSubmit.bind(this)
					}]
				});

				function onSubmit() {
					var _this2 = this;

					this.dynamicMenusService.deleteMenuDetailsByUrl(slug + '/delete').then(function (response) {
						_this2.totalItems -= 1;
						_this2.toastr.success("Data Deleted successfully");
					}).then(function (_) {
						return _this2.transportationAlternativeService.getFilterBicyclePedestrianDetails(_this2.filterDetails, _this2.slugUrl);
					}).then(function (_ref) {
						var list = _ref.list;

						_this2.details.list = list;
					}).catch(function (err) {
						_this2.toastr.error(err);
					});
				}
			}
		}]);

		return BicyclePedestrianListComponent;
	}()
};

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bicyclePedestrianList = undefined;

var _bicyclePedestrianList = __webpack_require__(661);

var bicyclePedestrianList = exports.bicyclePedestrianList = angular.module('components.transportationAlternative.bicyclePedestrian.bicyclePedestrianList', []).component('bicyclePedestrianList', _bicyclePedestrianList.bicyclePedestrianListComponent).name;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bicyclePedestrianMainComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bicyclePedestrianTemplate = __webpack_require__(793);

var _bicyclePedestrianTemplate2 = _interopRequireDefault(_bicyclePedestrianTemplate);

var _findIndex = __webpack_require__(8);

var _findIndex2 = _interopRequireDefault(_findIndex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var bicyclePedestrianMainComponent = exports.bicyclePedestrianMainComponent = {
	templateUrl: _bicyclePedestrianTemplate2.default,

	//binding title, details and onSubmit function
	bindings: {
		pageTitle: '@',
		details: '<',
		onSubmit: '&',
		county: '<',
		disableButtons: '<',
		parentSlug: '@'
	},

	//controller for BicyclePedestrianMainComponent
	controller: function () {
		BicyclePedestrianMainComponent.$inject = ["$state", "ModalService", "CompareObjectService", "Constants"];
		function BicyclePedestrianMainComponent($state, ModalService, CompareObjectService, Constants) {
			'ngInject';

			_classCallCheck(this, BicyclePedestrianMainComponent);

			this.$state = $state;
			this.modalService = ModalService;
			this.compareObjectService = CompareObjectService;
			this.constants = Constants;
		}

		_createClass(BicyclePedestrianMainComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.details || {
					serviceArea: [],
					name: "",
					url: "",
					image: "",
					description: ""
				};

				this.defaultCounties = this.details.serviceArea;
				this.saveData = angular.copy(this.details);
			}
		}, {
			key: 'onUpload',
			value: function onUpload(_ref) {
				var uuid = _ref.details.uuid;

				this.details.image = uuid;
			}

			//category select function for autocomplete

		}, {
			key: 'onSelectItem',
			value: function onSelectItem(value) {
				var index = (0, _findIndex2.default)(this.details.serviceArea, function (_ref2) {
					var id = _ref2.id;
					return id === value.id;
				});
				if (index === -1) {
					value.status = this.constants.STATUS.ADD;
					this.details.serviceArea.push(value);
				} else {
					this.details.serviceArea[index].status = -1;
				}
			}

			//category remove function for autocomplete

		}, {
			key: 'onRemoveTag',
			value: function onRemoveTag(value) {
				var index = (0, _findIndex2.default)(this.details.serviceArea, function (_ref3) {
					var name = _ref3.name;
					return name === value;
				});
				if (this.details.serviceArea[index].status !== 0) {
					this.details.serviceArea[index].status = this.constants.STATUS.DELETE;
				}
			}
		}, {
			key: 'onRemoveLogo',
			value: function onRemoveLogo() {
				this.details.image = "";
			}

			//on cancel function

		}, {
			key: 'onCancel',
			value: function onCancel() {
				var _details = angular.copy(this.details);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);

				if (isUpdated) {
					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},

						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToParentState(this.parentSlug);
				}

				function onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			}
		}, {
			key: '_onSubmit',
			value: function _onSubmit() {
				this.onSubmit({
					details: this.details
				});
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}]);

		return BicyclePedestrianMainComponent;
	}()
};

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bicyclePedestrianMain = undefined;

var _bicyclePedestrianMain = __webpack_require__(663);

var bicyclePedestrianMain = exports.bicyclePedestrianMain = angular.module('components.transportationALternative.bicyclePedestrian.bicyclePedestrianMain', []).component("bicyclePedestrianMain", _bicyclePedestrianMain.bicyclePedestrianMainComponent).name;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.bicyclePedestrian = undefined;

var _bicyclePedestrianList = __webpack_require__(662);

var _bicyclePedestrianAdd = __webpack_require__(656);

var _bicyclePedestrianEdit = __webpack_require__(660);

var _bicyclePedestrianMain = __webpack_require__(664);

var _bicyclePedestrianDetails = __webpack_require__(658);

var bicyclePedestrian = exports.bicyclePedestrian = angular.module('components.transportationAlternative.bicyclePedestrian', [_bicyclePedestrianList.bicyclePedestrianList, _bicyclePedestrianAdd.bicyclePedestrianAdd, _bicyclePedestrianEdit.bicyclePedestrianEdit, _bicyclePedestrianMain.bicyclePedestrianMain, _bicyclePedestrianDetails.bicyclePedestrianDetails]).name;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var callForHelpAddComponent = exports.callForHelpAddComponent = {

	//passing title and onSubmit function for binding in main component
	template: '\n\t<call-for-help-main\n\t\tdisable-buttons=\'$ctrl.disableButtons\'\n\t\tparent-slug=\'{{$ctrl.parentSlug}}\'\n\t\ton-submit=\'$ctrl.onSubmit($event)\'\n\t\tcounty=\'$ctrl.county\'>\n\t</call-for-help-main>',

	bindings: {
		parentSlug: '@',
		slugUrl: '@'
	},

	//controller for CallForHelpAddComponent
	controller: function () {
		CallForHelpAddComponent.$inject = ["$stateParams", "toastr", "$state", "TransportationAlternativeService", "DynamicMenusService", "SlugService"];
		function CallForHelpAddComponent($stateParams, toastr, $state, TransportationAlternativeService, DynamicMenusService, SlugService) {
			'ngInject';

			_classCallCheck(this, CallForHelpAddComponent);

			this.$stateParams = $stateParams;
			this.toastr = toastr;
			this.$state = $state;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		_createClass(CallForHelpAddComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.county = [];
				this._getCountyList();
			}

			//function to add class details

		}, {
			key: 'onSubmit',
			value: function onSubmit(details) {
				var _this = this;

				this.disableButtons = true;
				var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'add');
				details = this.transportationAlternativeService._setTemplate1DetailObject(details);

				// submit the request
				this.dynamicMenusService.addMenuDetailsByUrl(url, details).then(function (_ref) {
					var id = _ref.data.content_id;

					var contentDetailsUrl = _this.slugService.getContentDetailsURL(url, id);
					_this.toastr.success('Data added successfully');
					_this._redirectToParentState(contentDetailsUrl);
					_this.disableButtons = false;
				}).catch(function (err) {
					_this.toastr.error(err);
					_this.disableButtons = false;
				});
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}, {
			key: '_getCountyList',
			value: function _getCountyList() {
				var _this2 = this;

				this.transportationAlternativeService.getCallForHelpCountyList().then(function (countyList) {
					return _this2.county = countyList;
				});
			}
		}]);

		return CallForHelpAddComponent;
	}()
};

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.callForHelpAdd = undefined;

var _callForHelpAdd = __webpack_require__(666);

var callForHelpAdd = exports.callForHelpAdd = angular.module('components.transportationAlternative.callForHelp.callForHelpAdd', []).component('callForHelpAdd', _callForHelpAdd.callForHelpAddComponent).name;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.callForHelpDetailsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transportationAlternativeDetailsTemplate = __webpack_require__(137);

var _transportationAlternativeDetailsTemplate2 = _interopRequireDefault(_transportationAlternativeDetailsTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var callForHelpDetailsComponent = exports.callForHelpDetailsComponent = {

	//binding details
	bindings: {
		details: '<',
		parentSlug: '@',
		slugUrl: '@'
	},

	templateUrl: _transportationAlternativeDetailsTemplate2.default,

	//controller for CallForHelpDetailsComponent
	controller: function () {
		CallForHelpDetailsComponent.$inject = ["$state", "ApiService", "TransportationAlternativeService", "SlugService"];
		function CallForHelpDetailsComponent($state, ApiService, TransportationAlternativeService, SlugService) {
			'ngInject';

			_classCallCheck(this, CallForHelpDetailsComponent);

			this.$state = $state;
			this.apiService = ApiService;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.slugService = SlugService;
		}

		_createClass(CallForHelpDetailsComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.transportationAlternativeService.getCallForHelpDetailsById(this.details);

				var selectedItems = {};
				this.details.operationInfo.daysOfOperation.map(function (value, index) {
					selectedItems[value.name] = value.isSelected;
					return value;
				});
				this.daysOfOperation = selectedItems;
			}
		}, {
			key: '_getImage',
			value: function _getImage(detail) {
				var image = detail.image;
				return image ? this.apiService.getResourceUrl('files/images/' + image) : '/./images/placeholder.png';
			}
		}, {
			key: 'onGoBack',
			value: function onGoBack() {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: this.parentSlug
				});
			}
		}, {
			key: 'onEdit',
			value: function onEdit() {
				var slug = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'details');
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}]);

		return CallForHelpDetailsComponent;
	}()
};

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
			value: true
});
exports.callForHelpDetails = undefined;

var _callForHelpDetails = __webpack_require__(668);

var callForHelpDetails = exports.callForHelpDetails = angular.module('components.callForHelp.callForHelpDetails', []).component('callForHelpDetails', _callForHelpDetails.callForHelpDetailsComponent)
// .config(($stateProvider) => {
// 	'ngInject';

// 	$stateProvider
// 		.state('app.dashboard.callForHelpDetails', {
//     		breadcrumbName: 'Details',
//     		parentState: 'app.dashboard.CallForHelp',
// 			url: '/transportation-information/mobility-managers/:id/details',
// 			component: 'callForHelpDetails',
// 			resolve: {
// 				details($stateParams, TransportationAlternativeService) {
// 					'$ngInject';

// 					return TransportationAlternativeService.getCallForHelpDetailsById($stateParams.id);
// 				}
// 			}
// 		});
// })
.name;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var callForHelpEditComponent = exports.callForHelpEditComponent = {

	//passing title and onSubmit function for binding in main component
	template: '\n\t\t\t<call-for-help-main \n\t\t\t\tdetails=\'$ctrl.details\'\n\t\t\t\tparent-slug=\'{{$ctrl.parentSlug}}\'\n\t\t\t\tdisable-buttons=\'$ctrl.disableButtons\'\n\t\t\t\ton-submit=\'$ctrl.onSubmit($event)\'\n\t\t\t\tcounty=\'$ctrl.county\'>\n\t\t\t</call-for-help-main>',

	bindings: {
		details: '<',
		parentSlug: '@',
		slugUrl: '@'
	},

	//controller for CallForHelpEditComponent
	controller: function () {
		CallForHelpEditComponent.$inject = ["toastr", "$state", "$stateParams", "TransportationAlternativeService", "CompareObjectService", "DynamicMenusService", "SlugService"];
		function CallForHelpEditComponent(toastr, $state, $stateParams, TransportationAlternativeService, CompareObjectService, DynamicMenusService, SlugService) {
			'ngInject';

			_classCallCheck(this, CallForHelpEditComponent);

			this.toastr = toastr;
			this.$state = $state;
			this.$stateParams = $stateParams;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.compareObjectService = CompareObjectService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		//storing old data in savedData


		_createClass(CallForHelpEditComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.county = [];
				this.details = this.transportationAlternativeService.getCallForHelpDetailsById(this.details);
				this.savedData = angular.copy(this.details);
				this._getCountyList();
			}

			//comparing old and new data for update on submit function

		}, {
			key: 'onSubmit',
			value: function onSubmit(details) {
				var _this = this;

				var _details = angular.copy(details);
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, _details, true);
				if (isUpdated) {
					var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'edit');
					var _details2 = this.transportationAlternativeService._setTemplate1DetailObject(_details);
					this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, _details2).then(function (_ref) {
						var data = _ref.data;

						var contentDetailsUrl = _this.slugService.getDetailsPageURL(url);
						_this.toastr.success('Data updated successfully');
						_this._redirectToParentState(contentDetailsUrl);
						_this.disableButtons = false;
					}).catch(function (err) {
						_this.toastr.error(err);
						_this.disableButtons = false;
					});
				} else {
					this.toastr.success('Nothing to update');
					this._redirectToParentState(this.parentSlug);
					this.disableButtons = false;
				}
			}
		}, {
			key: '_redirectToParentState',
			value: function _redirectToParentState(slug) {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: slug
				});
			}
		}, {
			key: '_getCountyList',
			value: function _getCountyList() {
				var _this2 = this;

				this.transportationAlternativeService.getCallForHelpCountyList().then(function (county) {
					return _this2.county = county;
				});
			}
		}]);

		return CallForHelpEditComponent;
	}()
};

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.callForHelpEdit = undefined;

var _callForHelpEdit = __webpack_require__(670);

var callForHelpEdit = exports.callForHelpEdit = angular.module('components.transportationAlternative.callForHelp.callForHelpEdit', []).component('callForHelpEdit', _callForHelpEdit.callForHelpEditComponent).name;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.callForHelpListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transportationAlternativeListTemplate = __webpack_require__(86);

var _transportationAlternativeListTemplate2 = _interopRequireDefault(_transportationAlternativeListTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var callForHelpListComponent = exports.callForHelpListComponent = {
	bindings: {
		details: '<',
		slugUrl: '@'
	},

	templateUrl: _transportationAlternativeListTemplate2.default,

	controller: function () {
		CallForHelpListComponent.$inject = ["$state", "toastr", "ApiService", "ModalService", "TransportationAlternativeService", "DashboardService", "DynamicMenusService", "SlugService"];
		function CallForHelpListComponent($state, toastr, ApiService, ModalService, TransportationAlternativeService, DashboardService, DynamicMenusService, SlugService) {
			'ngInject';

			_classCallCheck(this, CallForHelpListComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.apiService = ApiService;
			this.modalService = ModalService;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.dashboardService = DashboardService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		_createClass(CallForHelpListComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.transportationAlternativeService.getCallForHelpDetails(this.details);
				this.activeMenuName = this.dashboardService.getActiveMenuName();
				this.pageTitle = this.activeMenuName + ' List';

				this.currentPage = 1;
				this.itemPerPage = 10;
				this.totalItems = this.details.count;
				this.filterDetails = {
					'limit': this.itemPerPage,
					'page_id': this.currentPage
				};
				this.showPagination = true;
			}
		}, {
			key: '_getImage',
			value: function _getImage(detail) {
				var image = detail.image;
				return image ? this.apiService.getResourceUrl('files/images/' + image) : '/./images/placeholder.png';
			}
		}, {
			key: 'routeDetailsPageUrl',
			value: function routeDetailsPageUrl(slug) {
				var url = this.slugService.getDetailsPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeEditPageUrl',
			value: function routeEditPageUrl(slug) {
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeAddPageUrl',
			value: function routeAddPageUrl() {
				var url = this.slugService.getAddPageURL(this.slugUrl);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'onChange',
			value: function onChange(pageNumber) {
				var _this = this;

				this.currentPage = pageNumber;
				this.filterDetails.limit = this.itemPerPage;
				this.filterDetails.page_id = this.currentPage;
				this.transportationAlternativeService.getFilterCallForHelpDetails(this.filterDetails, this.slugUrl).then(function (result) {
					_this.details.list = result.list;
				});
			}

			//on delete the call for help data

		}, {
			key: 'onDelete',
			value: function onDelete(slug) {
				this.modalService.open({
					details: {
						bodyMessage: 'Are you sure you want to delete the data?'
					},

					buttons: [{
						name: 'No'
					}, {
						name: 'Yes',
						isPrimary: true,
						action: onSubmit.bind(this)
					}]
				});

				function onSubmit() {
					var _this2 = this;

					this.dynamicMenusService.deleteMenuDetailsByUrl(slug + '/delete').then(function (response) {
						_this2.totalItems -= 1;
						_this2.toastr.success("Data Deleted successfully");
					}).then(function (_) {
						return _this2.transportationAlternativeService.getFilterCallForHelpDetails(_this2.filterDetails, _this2.slugUrl);
					}).then(function (_ref) {
						var list = _ref.list;

						_this2.details.list = list;
					}).catch(function (err) {
						_this2.toastr.error(err);
					});
				}
			}
		}]);

		return CallForHelpListComponent;
	}()
};

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.callForHelpList = undefined;

var _callForHelpList = __webpack_require__(672);

var callForHelpList = exports.callForHelpList = angular.module('components.transportationAlternative.callForHelp.callForHelpList', []).component('callForHelpList', _callForHelpList.callForHelpListComponent).name;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.callForHelpMainComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _callForHelpTemplate = __webpack_require__(794);

var _callForHelpTemplate2 = _interopRequireDefault(_callForHelpTemplate);

var _assignIn = __webpack_require__(73);

var _assignIn2 = _interopRequireDefault(_assignIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var callForHelpMainComponent = exports.callForHelpMainComponent = {
	templateUrl: _callForHelpTemplate2.default,

	//binding title, details and onSubmit function
	bindings: {
		pageTitle: '@',
		details: '<',
		county: '<',
		onSubmit: '&',
		onPrevious: '&',
		disableButtons: '<',
		parentSlug: '@'
	},

	//controller for CallForHelpMainComponent
	controller: function () {
		CallForHelpMainComponent.$inject = ["$anchorScroll"];
		function CallForHelpMainComponent($anchorScroll) {
			'ngInject';

			_classCallCheck(this, CallForHelpMainComponent);

			this.$anchorScroll = $anchorScroll;
		}

		_createClass(CallForHelpMainComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.step = 1;
				this.isBasicInfoActive = true;
				this.isOperationInfoClassInActive = false;
				this.details = this.details || {
					basicInfo: {
						serviceArea: [],
						phone: [],
						name: "",
						url: "",
						image: "",
						email: ""
					},
					operationInfo: ''
				};
				this.saveData = angular.copy(this.details);
			}
		}, {
			key: 'onSubmitBasicInfo',
			value: function onSubmitBasicInfo(details) {
				this.$anchorScroll(function () {
					return $location.hash();
				});
				this.isOperationInfoClassActive = true;
				this.isBasicInfoActive = false;
				this.step += 1;
				this.details = (0, _assignIn2.default)(this.details, details);
			}
		}, {
			key: 'onSubmitOperationInfo',
			value: function onSubmitOperationInfo(details) {
				this.$anchorScroll(function () {
					return $location.hash();
				});
				this.isOperationInfoClassInActive = true;
				this.details = (0, _assignIn2.default)(this.details, details);
				this.onSubmit({
					$event: this.details
				});
			}
		}, {
			key: 'onOperationInfoPrevious',
			value: function onOperationInfoPrevious(details) {
				this.$anchorScroll(function () {
					return $location.hash();
				});
				this.isBasicInfoActive = true;
				this.isOperationInfoClassActive = false;
				this.step -= 1;
				this.details = (0, _assignIn2.default)(this.details, details);
			}
		}]);

		return CallForHelpMainComponent;
	}()
};

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callForHelpMain = undefined;

var _callForHelpMain = __webpack_require__(674);

var callForHelpMain = exports.callForHelpMain = angular.module('components.transportationALternative.callForHelp.callForHelpMain', []).component("callForHelpMain", _callForHelpMain.callForHelpMainComponent).name;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.callForHelp = undefined;

var _callForHelpList = __webpack_require__(673);

var _callForHelpAdd = __webpack_require__(667);

var _callForHelpEdit = __webpack_require__(671);

var _callForHelpMain = __webpack_require__(675);

var _callForHelpDetails = __webpack_require__(669);

var callForHelp = exports.callForHelp = angular.module('components.transportationAlternative.callForHelp', [_callForHelpList.callForHelpList, _callForHelpAdd.callForHelpAdd, _callForHelpEdit.callForHelpEdit, _callForHelpMain.callForHelpMain, _callForHelpDetails.callForHelpDetails]).name;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ridesharingAddComponent = exports.ridesharingAddComponent = {

    //passing title and onSubmit function for binding in main component
    template: '\n        <ridesharing-main\n            disable-buttons=\'$ctrl.disableButtons\'\n            parent-slug=\'{{$ctrl.parentSlug}}\'\n            on-submit=\'$ctrl.onSubmit($event)\'\n            county=\'$ctrl.county\'>\n        </ridesharing-main>',

    bindings: {
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for RidesharingAddComponent
    controller: function () {
        RidesharingAddComponent.$inject = ["$stateParams", "toastr", "$state", "TransportationAlternativeService", "DynamicMenusService", "SlugService"];
        function RidesharingAddComponent($stateParams, toastr, $state, TransportationAlternativeService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, RidesharingAddComponent);

            this.$stateParams = $stateParams;
            this.toastr = toastr;
            this.$state = $state;
            this.transportationAlternativeService = TransportationAlternativeService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        _createClass(RidesharingAddComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.county = [];
                this._getCountyList();
            }

            //function to add class details

        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                this.disableButtons = true;
                var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'add');
                details = this.transportationAlternativeService._setTemplate1DetailObject(details);

                // submit the request
                this.dynamicMenusService.addMenuDetailsByUrl(url, details).then(function (_ref) {
                    var id = _ref.data.content_id;

                    var contentDetailsUrl = _this.slugService.getContentDetailsURL(url, id);
                    _this.toastr.success('Data added successfully');
                    _this._redirectToParentState(contentDetailsUrl);
                    _this.disableButtons = false;
                }).catch(function (err) {
                    _this.toastr.error(err);
                    _this.disableButtons = false;
                });
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }, {
            key: '_getCountyList',
            value: function _getCountyList() {
                var _this2 = this;

                this.transportationAlternativeService.getCallForHelpCountyList().then(function (countyList) {
                    return _this2.county = countyList;
                });
            }
        }]);

        return RidesharingAddComponent;
    }()
};

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ridesharingAdd = undefined;

var _ridesharingAdd = __webpack_require__(677);

var ridesharingAdd = exports.ridesharingAdd = angular.module('components.transportationAlternative.ridesharing.ridesharingAdd', []).component('ridesharingAdd', _ridesharingAdd.ridesharingAddComponent).name;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ridesharingDetailsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transportationAlternativeDetailsTemplate = __webpack_require__(137);

var _transportationAlternativeDetailsTemplate2 = _interopRequireDefault(_transportationAlternativeDetailsTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ridesharingDetailsComponent = exports.ridesharingDetailsComponent = {

	//binding details
	bindings: {
		details: '<',
		parentSlug: '@',
		slugUrl: '@'
	},

	templateUrl: _transportationAlternativeDetailsTemplate2.default,

	//controller for RidesharingDetailsComponent
	controller: function () {
		RidesharingDetailsComponent.$inject = ["$state", "ApiService", "TransportationAlternativeService", "SlugService"];
		function RidesharingDetailsComponent($state, ApiService, TransportationAlternativeService, SlugService) {
			'ngInject';

			_classCallCheck(this, RidesharingDetailsComponent);

			this.$state = $state;
			this.apiService = ApiService;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.slugService = SlugService;
		}

		_createClass(RidesharingDetailsComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.transportationAlternativeService.getRidesharingDetailsById(this.details);
				var selectedItems = {};
				this.details.operationInfo.daysOfOperation.map(function (value, index) {
					selectedItems[value.name] = value.isSelected;
					return value;
				});
				this.daysOfOperation = selectedItems;
			}
		}, {
			key: '_getImage',
			value: function _getImage(detail) {
				var image = detail.image;
				return image ? this.apiService.getResourceUrl('files/images/' + image) : '';
			}
		}, {
			key: 'onGoBack',
			value: function onGoBack() {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: this.parentSlug
				});
			}
		}, {
			key: 'onEdit',
			value: function onEdit() {
				var slug = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'details');
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}]);

		return RidesharingDetailsComponent;
	}()
};

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
			value: true
});
exports.ridesharingDetails = undefined;

var _ridesharingDetails = __webpack_require__(679);

var ridesharingDetails = exports.ridesharingDetails = angular.module('components.ridesharing.ridesharingDetails', []).component('ridesharingDetails', _ridesharingDetails.ridesharingDetailsComponent)
// .config(($stateProvider) => {
// 	'ngInject';

// 	$stateProvider
// 		.state('app.dashboard.ridesharingDetails', {
//     		breadcrumbName: 'Details',
//     		parentState: 'app.dashboard.Ridesharing',
// 			url: '/transportation-information/ridesharing/:id/details',
// 			component: 'ridesharingDetails',
// 			resolve: {
// 				details($stateParams, TransportationAlternativeService) {
// 					'$ngInject';

// 					return TransportationAlternativeService.getRidesharingDetailsById($stateParams.id);
// 				}
// 			}
// 		});
// })
.name;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ridesharingEditComponent = exports.ridesharingEditComponent = {

    //passing title and onSubmit function for binding in main component
    template: '\n            <ridesharing-main \n                details=\'$ctrl.details\'\n                parent-slug=\'{{$ctrl.parentSlug}}\'\n                disable-buttons=\'$ctrl.disableButtons\'\n                on-submit=\'$ctrl.onSubmit($event)\'\n                county=\'$ctrl.county\'>\n            </ridesharing-main>',

    bindings: {
        details: '<',
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for RidesharingEditComponent
    controller: function () {
        RidesharingEditComponent.$inject = ["toastr", "$state", "$stateParams", "TransportationAlternativeService", "CompareObjectService", "DynamicMenusService", "SlugService"];
        function RidesharingEditComponent(toastr, $state, $stateParams, TransportationAlternativeService, CompareObjectService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, RidesharingEditComponent);

            this.toastr = toastr;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.transportationAlternativeService = TransportationAlternativeService;
            this.compareObjectService = CompareObjectService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        //storing old data in savedData


        _createClass(RidesharingEditComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.county = [];
                this.details = this.transportationAlternativeService.getRidesharingDetailsById(this.details);
                this.savedData = angular.copy(this.details);
                this._getCountyList();
            }

            //comparing old and new data for update on submit function

        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                var _details = angular.copy(details);
                var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, _details, true);
                if (isUpdated) {
                    var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'edit');
                    var _details2 = this.transportationAlternativeService._setTemplate1DetailObject(_details);

                    this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, _details2).then(function (details) {
                        var contentDetailsUrl = _this.slugService.getDetailsPageURL(url);
                        _this.toastr.success('Data updated successfully');
                        _this._redirectToParentState(contentDetailsUrl);
                        _this.disableButtons = false;
                    }).catch(function (err) {
                        _this.toastr.error(err);
                        _this.disableButtons = false;
                    });
                } else {
                    this.toastr.success('Nothing to update');
                    this._redirectToParentState(this.parentSlug);
                    this.disableButtons = false;
                }
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }, {
            key: '_getCountyList',
            value: function _getCountyList() {
                var _this2 = this;

                this.transportationAlternativeService.getCountyList().then(function (county) {
                    return _this2.county = county;
                });
            }
        }]);

        return RidesharingEditComponent;
    }()
};

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
			value: true
});
exports.ridesharingEdit = undefined;

var _ridesharingEdit = __webpack_require__(681);

var ridesharingEdit = exports.ridesharingEdit = angular.module('components.transportationAlternative.ridesharing.ridesharingEdit', []).component('ridesharingEdit', _ridesharingEdit.ridesharingEditComponent)
// .config(($stateProvider) => {
// 	'ngInject';

// 	$stateProvider
// 		.state('app.dashboard.ridesharingEdit', {
//     		url: '/transportation-information/ridesharing/:id/edit',
// 			breadcrumbName: 'Edit',
// 			parentState: 'app.dashboard.Ridesharing',
// 			component: 'ridesharingEdit',
// 			resolve : {
//                 details($stateParams, TransportationAlternativeService) {
//                     'ngInject';

//                     return TransportationAlternativeService.getRidesharingDetailsById($stateParams.id);
// 				},
// 				county(TransportationAlternativeService) {
// 					'ngInject';

// 					return TransportationAlternativeService.getCountyList()
// 				}					
//             }
// 		});
// })
.name;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ridesharingListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transportationAlternativeListTemplate = __webpack_require__(86);

var _transportationAlternativeListTemplate2 = _interopRequireDefault(_transportationAlternativeListTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ridesharingListComponent = exports.ridesharingListComponent = {
	bindings: {
		details: '<',
		slugUrl: '@'
	},

	templateUrl: _transportationAlternativeListTemplate2.default,

	controller: function () {
		RidesharingListComponent.$inject = ["$state", "toastr", "ApiService", "ModalService", "TransportationAlternativeService", "DashboardService", "DynamicMenusService", "SlugService"];
		function RidesharingListComponent($state, toastr, ApiService, ModalService, TransportationAlternativeService, DashboardService, DynamicMenusService, SlugService) {
			'ngInject';

			_classCallCheck(this, RidesharingListComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.apiService = ApiService;
			this.modalService = ModalService;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.dashboardService = DashboardService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		_createClass(RidesharingListComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.transportationAlternativeService.getRidesharingDetails(this.details);
				this.activeMenuName = this.dashboardService.getActiveMenuName();
				this.pageTitle = this.activeMenuName + ' List';

				this.currentPage = 1;
				this.itemPerPage = 10;
				this.totalItems = this.details.count;
				this.filterDetails = {
					'limit': this.itemPerPage,
					'page_id': this.currentPage
				};
				this.showPagination = true;
			}
		}, {
			key: 'routeDetailsPageUrl',
			value: function routeDetailsPageUrl(slug) {
				var url = this.slugService.getDetailsPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeEditPageUrl',
			value: function routeEditPageUrl(slug) {
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: '_getImage',
			value: function _getImage(detail) {
				var image = detail.image;
				return image ? this.apiService.getResourceUrl('files/images/' + image) : '/./images/placeholder.png';
			}
		}, {
			key: 'routeAddPageUrl',
			value: function routeAddPageUrl() {
				var url = this.slugService.getAddPageURL(this.slugUrl);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'onChange',
			value: function onChange(pageNumber) {
				var _this = this;

				this.currentPage = pageNumber;
				this.filterDetails.limit = this.itemPerPage;
				this.filterDetails.page_id = this.currentPage;
				this.transportationAlternativeService.getRidesharingDetailsByFilter(this.filterDetails, this.slugUrl).then(function (result) {
					_this.details.list = result.list;
				});
			}

			//on delete the call for help data

		}, {
			key: 'onDelete',
			value: function onDelete(slug) {
				this.modalService.open({
					details: {
						bodyMessage: 'Are you sure you want to delete the data?'
					},

					buttons: [{
						name: 'No'
					}, {
						name: 'Yes',
						isPrimary: true,
						action: onSubmit.bind(this)
					}]
				});

				function onSubmit() {
					var _this2 = this;

					this.dynamicMenusService.deleteMenuDetailsByUrl(slug + '/delete').then(function (response) {
						_this2.totalItems -= 1;
						_this2.toastr.success("Data Deleted successfully");
					}).then(function (_) {
						return _this2.transportationAlternativeService.getRidesharingDetailsByFilter(_this2.filterDetails, _this2.slugUrl);
					}).then(function (_ref) {
						var list = _ref.list;

						_this2.details.list = list;
					}).catch(function (err) {
						_this2.toastr.error(err);
					});
				}
			}
		}]);

		return RidesharingListComponent;
	}()
};

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ridesharingList = undefined;

var _ridesharingList = __webpack_require__(683);

var ridesharingList = exports.ridesharingList = angular.module('components.transportationAlternative.ridesharing.ridesharingList', []).component('ridesharingList', _ridesharingList.ridesharingListComponent).name;

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ridesharingMainComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ridesharingTemplate = __webpack_require__(795);

var _ridesharingTemplate2 = _interopRequireDefault(_ridesharingTemplate);

var _assignIn = __webpack_require__(73);

var _assignIn2 = _interopRequireDefault(_assignIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ridesharingMainComponent = exports.ridesharingMainComponent = {
    templateUrl: _ridesharingTemplate2.default,

    //binding title, details and onSubmit function
    bindings: {
        pageTitle: '@',
        details: '<',
        county: '<',
        onSubmit: '&',
        onPrevious: '&',
        disableButtons: '<',
        parentSlug: '@'
    },

    //controller for RidesharingMainComponent
    controller: function () {
        RidesharingMainComponent.$inject = ["$state", "$anchorScroll", "ModalService", "CompareObjectService"];
        function RidesharingMainComponent($state, $anchorScroll, ModalService, CompareObjectService) {
            'ngInject';

            _classCallCheck(this, RidesharingMainComponent);

            this.$state = $state;
            this.$anchorScroll = $anchorScroll;
            this.modalService = ModalService;
            this.compareObjectService = CompareObjectService;
        }

        _createClass(RidesharingMainComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.step = 1;
                this.isBasicInfoActive = true;
                this.isOperationInfoClassInActive = false;
                this.details = this.details || {
                    basicInfo: {
                        serviceArea: [],
                        phone: [],
                        name: "",
                        url: "",
                        image: "",
                        email: ""
                    },
                    operationInfo: ''
                };
                this.saveData = angular.copy(this.details);
            }
        }, {
            key: 'onSubmitBasicInfo',
            value: function onSubmitBasicInfo(details) {
                this.$anchorScroll(function () {
                    return $location.hash();
                });
                this.isOperationInfoClassActive = true;
                this.isBasicInfoActive = false;
                this.step += 1;
                this.details = (0, _assignIn2.default)(this.details, details);
            }
        }, {
            key: 'onSubmitOperationInfo',
            value: function onSubmitOperationInfo(details) {
                this.$anchorScroll(function () {
                    return $location.hash();
                });
                this.isOperationInfoClassInActive = true;
                this.details = (0, _assignIn2.default)(this.details, details);
                this.onSubmit({
                    $event: this.details
                });
            }
        }, {
            key: 'onOperationInfoPrevious',
            value: function onOperationInfoPrevious(details) {
                this.$anchorScroll(function () {
                    return $location.hash();
                });
                this.isBasicInfoActive = true;
                this.isOperationInfoClassActive = false;
                this.step -= 1;
                this.details = (0, _assignIn2.default)(this.details, details);
            }
        }]);

        return RidesharingMainComponent;
    }()
};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ridesharingMain = undefined;

var _ridesharingMain = __webpack_require__(685);

var ridesharingMain = exports.ridesharingMain = angular.module('components.transportationALternative.ridesharing.ridesharingMain', []).component("ridesharingMain", _ridesharingMain.ridesharingMainComponent).name;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ridesharing = undefined;

var _ridesharingList = __webpack_require__(684);

var _ridesharingAdd = __webpack_require__(678);

var _ridesharingEdit = __webpack_require__(682);

var _ridesharingMain = __webpack_require__(686);

var _ridesharingDetails = __webpack_require__(680);

var ridesharing = exports.ridesharing = angular.module('components.transportationAlternative.ridesharing', [_ridesharingList.ridesharingList, _ridesharingAdd.ridesharingAdd, _ridesharingEdit.ridesharingEdit, _ridesharingMain.ridesharingMain, _ridesharingDetails.ridesharingDetails]).name;

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transportationAlternative = undefined;

var _callForHelp = __webpack_require__(676);

var _ridesharing = __webpack_require__(687);

var _bicyclePedestrian = __webpack_require__(665);

var _transportationProviders = __webpack_require__(700);

var _transportationAlternative = __webpack_require__(689);

__webpack_require__(200);

var transportationAlternative = exports.transportationAlternative = angular.module('components.transportationAlternative', [_callForHelp.callForHelp, _ridesharing.ridesharing, _bicyclePedestrian.bicyclePedestrian, _transportationProviders.transportationProviders]).service('TransportationAlternativeService', _transportationAlternative.TransportationAlternativeService).name;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TransportationAlternativeService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filter = __webpack_require__(7);

var _filter2 = _interopRequireDefault(_filter);

var _head = __webpack_require__(5);

var _head2 = _interopRequireDefault(_head);

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

var _pick = __webpack_require__(387);

var _pick2 = _interopRequireDefault(_pick);

var _mapKeys = __webpack_require__(385);

var _mapKeys2 = _interopRequireDefault(_mapKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TransportationAlternativeService = exports.TransportationAlternativeService = function () {
    TransportationAlternativeService.$inject = ["$resource", "ApiService", "DateService"];
    function TransportationAlternativeService($resource, ApiService, DateService) {
        'ngInject';

        _classCallCheck(this, TransportationAlternativeService);

        this.$resource = $resource;
        this.apiService = ApiService;
        this.dateService = DateService;
        this.shortDayName = {
            monday: "mon",
            tuesday: "tue",
            wednesday: "wed",
            thursday: "thu",
            friday: "fri",
            saturday: "sat",
            sunday: "sun"
        };
        this.specialRequirementsOptionsName = {
            wheelchair_access: "wheelchair access",
            door_to_door: "door to door",
            door_through_door: "door through door",
            curb_to_curb: "curb to curb"
        };
        this.transportationAlternativesListResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationAlternatives');
        this.transportationAlternativesOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/TransportationAlternatives');
        this.transportationAlternativesSequenceResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationAlternatives/sequence');
        this.transportationAlternativesPublishPageResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationAlternatives/publish');
        this.countyListResourceUrl = this.apiService.getResourceUrl('cms/service-area');
        this.callForHelpCountyListResourceUrl = this.apiService.getResourceUrl('cms/call-for-help/service-area');
        this.serviceTypeListResourceUrl = this.apiService.getResourceUrl('cms/service-type');
        this.paymentMethodsListResourceUrl = this.apiService.getResourceUrl('cms/payment-methods');

        // this.callForHelpListResourceUrl = this.apiService.getResourceUrl('cms/menus/CallForHelp');
        this.callForHelpDetailByIdResourceUrl = this.apiService.getResourceUrl('cms/menus/CallForHelp/content/:content_id');
        this.callForHelpOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/CallForHelp');
        this.callForHelpAddResourceUrl = this.apiService.getResourceUrl('cms/call-for-help');
        this.callForHelpEditDeleteResourceUrl = this.apiService.getResourceUrl('cms/call-for-help/:content_id');

        this.ridesharingListResourceUrl = this.apiService.getResourceUrl('cms/menus/Ridesharing');
        this.ridesharingDetailByIdResourceUrl = this.apiService.getResourceUrl('cms/menus/Ridesharing/content/:content_id');
        this.ridesharingOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/Ridesharing');
        this.ridesharingAddResourceUrl = this.apiService.getResourceUrl('cms/ride-sharing');
        this.ridesharingEditDeleteResourceUrl = this.apiService.getResourceUrl('cms/ride-sharing/:content_id');

        this.bicyclePedestrianListResourceUrl = this.apiService.getResourceUrl('cms/menus/BicycleAndPedestrian');
        this.bicyclePedestrianDetailByIdResourceUrl = this.apiService.getResourceUrl('cms/menus/BicycleAndPedestrian/content/:content_id');
        this.bicyclePedestrianOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/BicycleAndPedestrian');
        this.bicyclePedestrianAddResourceUrl = this.apiService.getResourceUrl('cms/bicycle-and-pedestrian');
        this.bicyclePedestrianEditDeleteResourceUrl = this.apiService.getResourceUrl('cms/bicycle-and-pedestrian/:content_id');

        this.transportationProvidersDetailByIdResourceUrl = this.apiService.getResourceUrl('cms/menus/TransportationProviders/content/:content_id');
        this.transportationProvidersOverviewResourceUrl = this.apiService.getResourceUrl('cms/menus/overview/TransportationProviders');
        this.transportationProvidersAddResourceUrl = this.apiService.getResourceUrl('cms/transportation-providers');
        this.transportationProvidersEditDeleteResourceUrl = this.apiService.getResourceUrl('cms/transportation-providers/:content_id');

        this.transportationProvidersSearchResourceUrl = this.apiService.getResourceUrl('cms/transportation-providers/search');
        this.transportationProvidersSearchResource = this.$resource(this.transportationProvidersSearchResourceUrl);

        this.transportationAlternativesListResource = this.$resource(this.transportationAlternativesListResourceUrl);

        this.transportationAlternativesOverviewResource = this.$resource(this.transportationAlternativesOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.transportationAlternativesSequenceResource = this.$resource(this.transportationAlternativesSequenceResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.transportationAlternativesPublishPageResource = this.$resource(this.transportationAlternativesPublishPageResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.countyListResource = this.$resource(this.countyListResourceUrl);
        this.callForHelpCountyListResource = this.$resource(this.callForHelpCountyListResourceUrl);
        this.serviceTypeListResource = this.$resource(this.serviceTypeListResourceUrl);
        this.paymentMethodsListResource = this.$resource(this.paymentMethodsListResourceUrl);

        // this.callForHelpListResource = this.$resource(this.callForHelpListResourceUrl);
        this.callForHelpDetailByIdResource = this.$resource(this.callForHelpDetailByIdResourceUrl);
        this.callForHelpOverviewResource = this.$resource(this.callForHelpOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.callForHelpAddResource = this.$resource(this.callForHelpAddResourceUrl, null, {
            save: {
                method: 'POST'
            }
        });
        this.callForHelpEditDeleteResource = this.$resource(this.callForHelpEditDeleteResourceUrl, null, {
            update: {
                method: 'PUT',
                params: {
                    content_id: '@content_id'
                }
            },
            delete: {
                method: 'DELETE',
                params: {
                    content_id: '@content_id'
                }
            }
        });

        // this.ridesharingListResource = this.$resource(this.ridesharingListResourceUrl);
        this.ridesharingDetailByIdResource = this.$resource(this.ridesharingDetailByIdResourceUrl);
        this.ridesharingOverviewResource = this.$resource(this.ridesharingOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.ridesharingAddResource = this.$resource(this.ridesharingAddResourceUrl, null, {
            save: {
                method: 'POST'
            }
        });
        this.ridesharingEditDeleteResource = this.$resource(this.ridesharingEditDeleteResourceUrl, null, {
            update: {
                method: 'PUT',
                params: {
                    content_id: '@content_id'
                }
            },
            delete: {
                method: 'DELETE',
                params: {
                    content_id: '@content_id'
                }
            }
        });

        // this.bicyclePedestrianListResource = this.$resource(this.bicyclePedestrianListResourceUrl);
        this.bicyclePedestrianDetailByIdResource = this.$resource(this.bicyclePedestrianDetailByIdResourceUrl);
        this.bicyclePedestrianOverviewResource = this.$resource(this.bicyclePedestrianOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.bicyclePedestrianAddResource = this.$resource(this.bicyclePedestrianAddResourceUrl, null, {
            save: {
                method: 'POST'
            }
        });
        this.bicyclePedestrianEditDeleteResource = this.$resource(this.bicyclePedestrianEditDeleteResourceUrl, null, {
            update: {
                method: 'PUT',
                params: {
                    content_id: '@content_id'
                }
            },
            delete: {
                method: 'DELETE',
                params: {
                    content_id: '@content_id'
                }
            }
        });

        // this.transportationProvidersListResource = this.$resource(this.transportationProvidersListResourceUrl);
        this.transportationProvidersDetailByIdResource = this.$resource(this.transportationProvidersDetailByIdResourceUrl);
        this.transportationProvidersOverviewResource = this.$resource(this.transportationProvidersOverviewResourceUrl, null, {
            update: {
                method: 'PUT'
            }
        });
        this.transportationProvidersAddResource = this.$resource(this.transportationProvidersAddResourceUrl, null, {
            save: {
                method: 'POST'
            }
        });
        this.transportationProvidersEditDeleteResource = this.$resource(this.transportationProvidersEditDeleteResourceUrl, null, {
            update: {
                method: 'PUT',
                params: {
                    content_id: '@content_id'
                }
            },
            delete: {
                method: 'DELETE',
                params: {
                    content_id: '@content_id'
                }
            }
        });
    }

    _createClass(TransportationAlternativeService, [{
        key: '_getOverviewDetails',
        value: function _getOverviewDetails(details) {
            return {
                title: details.title,
                description: details.description,
                overview: details.overview,
                image: details.image
            };
        }
    }, {
        key: '_setOverviewObject',
        value: function _setOverviewObject(details) {
            return {
                title: details.title,
                description: details.description,
                image: details.image
            };
        }
    }, {
        key: '_getContentDetails',
        value: function _getContentDetails(content) {
            return content.map(function (_ref) {
                var title = _ref.title,
                    description = _ref.description,
                    name = _ref.name,
                    slug = _ref.slug;
                return { title: title, description: description, name: name, slug: slug };
            });
        }
    }, {
        key: '_getHoursOfOperationDetails',
        value: function _getHoursOfOperationDetails(value) {
            return {
                startTime: value.start_time ? this.dateService.parseDateFromServerDate(value.start_time) : "",
                endTime: value.end_time ? this.dateService.parseDateFromServerDate(value.end_time) : "",
                isAllDay: value.is_all_day
            };
        }
    }, {
        key: '_setHoursOfOperationDetails',
        value: function _setHoursOfOperationDetails(value) {
            return {
                start_time: this._resetDateWithTime(value.startTime),
                end_time: this._resetDateWithTime(value.endTime),
                is_all_day: value.isAllDay
            };
        }
    }, {
        key: '_resetDateWithTime',
        value: function _resetDateWithTime(date) {
            var time = date;
            return new Date(this.dateService.resetDateTimeWithOtherTime(date, time));
        }
    }, {
        key: '_getPhoneDetailsObject',
        value: function _getPhoneDetailsObject(values) {
            return values.map(function (_ref2) {
                var extn = _ref2.extn,
                    number = _ref2.number;
                return { extn: extn, number: number };
            });
        }
    }, {
        key: '_setPhoneDetailsObject',
        value: function _setPhoneDetailsObject(values) {
            return values.map(function (_ref3) {
                var extn = _ref3.extn,
                    number = _ref3.number;
                return { extn: extn, number: number };
            });
        }
    }, {
        key: '_getProviderPhoneDetailsObject',
        value: function _getProviderPhoneDetailsObject(values) {
            return values.map(function (_ref4) {
                var extn = _ref4.extn,
                    number = _ref4.number,
                    name = _ref4.name;
                return { extn: extn, number: number, name: name };
            });
        }
    }, {
        key: '_setProviderPhoneDetailsObject',
        value: function _setProviderPhoneDetailsObject(values) {
            return values.map(function (_ref5) {
                var extn = _ref5.extn,
                    number = _ref5.number,
                    name = _ref5.name;
                return { extn: extn, number: number, name: name };
            });
        }
    }, {
        key: '_getServiceAreaObject',
        value: function _getServiceAreaObject(values) {
            return values.map(function (value) {
                return {
                    id: value.service_area_id,
                    name: value.name + ' (' + value.state_code + ') (' + value.service_area_type + ')',
                    status: -1
                };
            });
        }
    }, {
        key: '_setServiceAreaObject',
        value: function _setServiceAreaObject(values) {
            return values.map(function (value) {
                return {
                    service_area_id: value.id,
                    name: value.name,
                    status: value.status
                };
            });
        }
    }, {
        key: '_getServiceTypeListObject',
        value: function _getServiceTypeListObject(values) {
            return values.map(function (value) {
                return {
                    id: value.service_type_id,
                    name: value.name
                };
            });
        }
    }, {
        key: '_getServiceTypeObject',
        value: function _getServiceTypeObject(values) {
            return values.map(function (value) {
                return {
                    id: value.service_type_id,
                    name: value.service_type
                };
            });
        }
    }, {
        key: '_getPaymentMethodObject',
        value: function _getPaymentMethodObject(values) {
            return values.map(function (value) {
                return {
                    id: value.payment_method_id,
                    name: value.payment_method,
                    status: -1
                };
            });
        }
    }, {
        key: '_setPaymentMethodObject',
        value: function _setPaymentMethodObject(values) {
            return values.map(function (value) {
                return {
                    payment_method_id: value.id,
                    payment_method: value.name,
                    status: value.status
                };
            });
        }
    }, {
        key: '_getDaysOfOperation',
        value: function _getDaysOfOperation(values) {
            var arr = [];
            (0, _mapKeys2.default)(this.shortDayName, function (value, key) {
                var obj = {};
                obj.name = key;
                obj.isSelected = (0, _pick2.default)(values, [key])[key];
                obj.displayName = value;
                arr.push(obj);
            });
            return arr;
        }
    }, {
        key: '_getSubContentDetails',
        value: function _getSubContentDetails(values) {
            var details = (0, _filter2.default)(values, ['name', 'CallForHelp']);
            return _getListDetails.call(this, (0, _head2.default)(details).values);

            function _getListDetails(data) {
                var _this = this;

                return data.map(function (value) {
                    return _this._getTemplate1ListObject(value);
                });
            }
        }

        //get content sequence object for display

    }, {
        key: '_getContentSequence',
        value: function _getContentSequence(_ref6) {
            var values = _ref6.content.values;

            return values.map(function (content) {
                return {
                    id: content.menu_id,
                    sortOrder: content.sort_order,
                    title: content.title
                };
            });
        }

        //set content sequence object for update

    }, {
        key: '_setContentSequence',
        value: function _setContentSequence(value) {
            return value.map(function (content) {
                return {
                    menu_id: content.id,
                    sort_order: content.sortOrder
                };
            });
        }

        //get publish status object for display

    }, {
        key: '_getPublishPageListObject',
        value: function _getPublishPageListObject(values) {
            return values.map(function (value) {
                return {
                    id: value.menu_id,
                    isActive: value.is_active,
                    title: value.title
                };
            });
        }

        //set publish status object for update

    }, {
        key: '_setPublishPageListObject',
        value: function _setPublishPageListObject(values) {
            return values.map(function (value) {
                return {
                    menu_id: value.id,
                    is_active: value.isActive
                };
            });
        }
    }, {
        key: '_getTemplate1ListObject',
        value: function _getTemplate1ListObject(value) {
            return {
                id: value.content_id,
                serviceArea: this._getServiceAreaObject(value.service_area),
                email: value.email,
                image: value.image,
                name: value.name,
                phone: this._setPhoneDetailsObject(value.phone),
                url: value.url,
                daysOfOperation: this._getDaysOfOperation(value.days_of_operation),
                hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation),
                slug: value.slug || null
            };
        }
    }, {
        key: '_getTemplate1DetailObject',
        value: function _getTemplate1DetailObject(value) {
            return {
                basicInfo: {
                    id: value.content_id,
                    serviceArea: this._getServiceAreaObject(value.service_area),
                    email: value.email,
                    image: value.image,
                    name: value.name,
                    phone: this._setPhoneDetailsObject(value.phone),
                    url: value.url
                },
                operationInfo: {
                    daysOfOperation: this._getDaysOfOperation(value.days_of_operation),
                    hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation)
                }
            };
        }
    }, {
        key: '_getDaysOfOperationObject',
        value: function _getDaysOfOperationObject(values) {
            var selectedItems = {};
            values.map(function (value, index) {
                selectedItems[value.name] = value.isSelected;
                return value;
            });
            return selectedItems;
        }
    }, {
        key: '_setTemplate1DetailObject',
        value: function _setTemplate1DetailObject(value) {
            return {
                service_area: this._setServiceAreaObject(value.basicInfo.serviceArea || value.serviceInfo.serviceArea),
                days_of_operation: this._getDaysOfOperationObject(value.operationInfo.daysOfOperation),
                email: value.basicInfo.email,
                hours_of_operation: this._setHoursOfOperationDetails(value.operationInfo.hoursOfOperation),
                image: value.basicInfo.image || '',
                name: value.basicInfo.name,
                phone: this._setPhoneDetailsObject(value.basicInfo.phone),
                url: value.basicInfo.url,
                status: value.status
            };
        }
    }, {
        key: '_getRideSharingDetails',
        value: function _getRideSharingDetails(values) {
            var details = (0, _filter2.default)(values, ['name', 'Ridesharing']);
            return _getListDetails.call(this, (0, _head2.default)(details).values);

            function _getListDetails(data) {
                var _this2 = this;

                return data.map(function (value) {
                    return _this2._getTemplate1ListObject(value);
                });
            }
        }
    }, {
        key: '_getTemplate2DetailObject',
        value: function _getTemplate2DetailObject(value) {
            return {
                id: value.content_id,
                serviceArea: this._getServiceAreaObject(value.service_area),
                image: value.image,
                name: value.name,
                url: value.url,
                description: value.description,
                slug: value.slug
            };
        }
    }, {
        key: '_setTemplate2DetailObject',
        value: function _setTemplate2DetailObject(value) {
            return {
                service_area: this._setServiceAreaObject(value.serviceArea),
                image: value.image,
                name: value.name,
                url: value.url,
                description: value.description
            };
        }
    }, {
        key: '_getBicyclePedestrianDetails',
        value: function _getBicyclePedestrianDetails(values) {
            var details = (0, _filter2.default)(values, ['name', 'BicycleAndPedestrian']);
            return _getListDetails.call(this, (0, _head2.default)(details).values);

            function _getListDetails(data) {
                var _this3 = this;

                return data.map(function (value) {
                    return _this3._getTemplate2DetailObject(value);
                });
            }
        }
    }, {
        key: '_getTransportationProvidersListObject',
        value: function _getTransportationProvidersListObject(value) {
            return {
                id: value.content_id,
                serviceArea: this._getServiceAreaObject(value.service_area),
                email: value.email,
                image: value.image,
                name: value.name,
                phone: this._getProviderPhoneDetailsObject(value.phone_number),
                url: value.url,
                daysOfOperation: this._getDaysOfOperation(value.days_of_operation),
                hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation),
                fees: value.fees,
                notes: value.notes,
                serviceType: this._getServiceTypeObject(value.service_type),
                methodOfPayment: this._getPaymentMethodObject(value.payment_methods),
                slug: value.slug || null
            };
        }
    }, {
        key: '_setTransportationProvidersListObject',
        value: function _setTransportationProvidersListObject(value) {
            return {
                isCheckedDestinationForServiceArea: value.serviceInfo.isCheckedDestinationForServiceArea || false,
                service_area: this._setServiceAreaObject(value.serviceInfo.serviceArea),
                email: value.basicInfo.email,
                image: value.basicInfo.image,
                name: value.basicInfo.name.trim(),
                phone_number: this._setProviderPhoneDetailsObject(value.basicInfo.phone),
                url: value.basicInfo.url,
                days_of_operation: this._getDaysOfOperationObject(value.operationInfo.daysOfOperation),
                hours_of_operation: this._setHoursOfOperationDetails(value.operationInfo.hoursOfOperation),
                fees: value.otherInfo.fees,
                notes: value.otherInfo.notes,
                service_type: this._setServiceTypeObject(value.serviceInfo.serviceType),
                payment_methods: this._setPaymentMethodObject(value.otherInfo.methodOfPayment),
                special_requirements: this._getCheckboxOptionsObject(value.serviceInfo.specialRequirements),
                medicaid_support: value.serviceInfo.medicaidSupport,
                veteran_support: value.serviceInfo.veteranSupport,
                status: value.status,
                costing: value.serviceInfo.costing
            };
        }
    }, {
        key: '_getTransportationProvidersDetailObject',
        value: function _getTransportationProvidersDetailObject(value) {
            return {
                basicInfo: {
                    id: value.content_id,
                    email: value.email,
                    image: value.image,
                    name: value.name,
                    phone: this._setProviderPhoneDetailsObject(value.phone_number),
                    url: value.url
                },
                serviceInfo: {
                    serviceType: this._getServiceTypeObject(value.service_type),
                    serviceArea: this._getServiceAreaObject(value.service_area),
                    specialRequirements: this._getCheckboxOptions(value.special_requirements, this.specialRequirementsOptionsName),
                    medicaidSupport: value.medicaid_support,
                    veteranSupport: value.veteran_support,
                    costing: value.costing,
                    isCheckedDestinationForServiceArea: value.isCheckedDestinationForServiceArea
                },
                operationInfo: {
                    daysOfOperation: this._getDaysOfOperation(value.days_of_operation),
                    hoursOfOperation: this._getHoursOfOperationDetails(value.hours_of_operation)
                },
                otherInfo: {
                    fees: value.fees,
                    notes: value.notes,
                    methodOfPayment: this._getPaymentMethodObject(value.payment_methods)
                }
            };
        }
    }, {
        key: '_getCheckboxOptions',
        value: function _getCheckboxOptions(values, optionNames) {
            var arr = [];
            (0, _mapKeys2.default)(optionNames, function (value, key) {
                var obj = {};
                obj.id = key;
                obj.isSelected = (0, _pick2.default)(values, [key])[key];
                obj.title = value;
                arr.push(obj);
            });
            return arr;
        }
    }, {
        key: '_getCheckboxOptionsObject',
        value: function _getCheckboxOptionsObject(values) {
            var selectedItems = {};
            values.map(function (value, index) {
                selectedItems[value.id] = value.isSelected || false;
                return value;
            });
            return selectedItems;
        }
    }, {
        key: '_getServiceTypeObject',
        value: function _getServiceTypeObject(values) {
            return values.map(function (value) {
                return {
                    id: value.service_type_id,
                    name: value.service_type,
                    status: -1
                };
            });
        }
    }, {
        key: '_setServiceTypeObject',
        value: function _setServiceTypeObject(values) {
            return values.map(function (value) {
                return {
                    service_type_id: value.id,
                    service_type: value.name,
                    status: value.status
                };
            });
        }
    }, {
        key: '_getTransportationProvidersDetails',
        value: function _getTransportationProvidersDetails(values) {
            var details = (0, _filter2.default)(values, ['name', 'TransportationProviders']);
            return _getListDetails.call(this, (0, _head2.default)(details).values);

            function _getListDetails(data) {
                var _this4 = this;

                return data.map(function (value) {
                    return _this4._getTransportationProvidersListObject(value);
                });
            }
        }
    }, {
        key: '_getMenuOverviewDetails',
        value: function _getMenuOverviewDetails(details) {
            return {
                id: details.content_id,
                displayName: details.display_name,
                title: details.title,
                description: details.description,
                image: details.image,
                name: details.name,
                overview: details.overview
            };
        }
    }, {
        key: '_getMenuContentDetails',
        value: function _getMenuContentDetails(value) {
            return {
                id: value.content_id,
                description: value.description,
                images: this._getContentImagesObject(value.images) || [],
                videos: value.videos || []
            };
        }
    }, {
        key: '_getContentImagesObject',
        value: function _getContentImagesObject(values) {
            return values ? values.map(function (_ref7) {
                var uuid = _ref7.uuid;
                return { uuid: uuid, status: -1 };
            }) : [];
        }
    }, {
        key: '_setMenuContentDetails',
        value: function _setMenuContentDetails(value) {
            return {
                description: value.description,
                images: value.images || [],
                videos: value.videos || []
            };
        }

        /**
        * function to get county list
        * @return {object} [information related to county list]
        */

    }, {
        key: 'getCountyList',
        value: function getCountyList() {
            var _this5 = this;

            var promise = this.countyListResource.get().$promise;

            return promise.then(function (details) {
                return _this5._getServiceAreaObject(details.data);
            }).catch(function (error) {
                throw _this5.apiService.getErrorMessage(error);
            });
        }
    }, {
        key: 'getCallForHelpCountyList',
        value: function getCallForHelpCountyList() {
            var _this6 = this;

            var promise = this.callForHelpCountyListResource.get().$promise;

            return promise.then(function (details) {
                return _this6._getServiceAreaObject(details.data);
            }).catch(function (error) {
                throw _this6.apiService.getErrorMessage(error);
            });
        }

        /**
        * function to get service type list
        * @return {object} [information related to service type list]
        */

    }, {
        key: 'getServiceTypeList',
        value: function getServiceTypeList() {
            var _this7 = this;

            var promise = this.serviceTypeListResource.get().$promise;

            return promise.then(function (details) {
                return _this7._getServiceTypeListObject(details.data);
            }).catch(function (error) {
                throw _this7.apiService.getErrorMessage(error);
            });
        }

        /**
        * function to get payment methods list
        * @return {object} [information related to payment methods list]
        */

    }, {
        key: 'getPaymentMethodsList',
        value: function getPaymentMethodsList() {
            var _this8 = this;

            var promise = this.paymentMethodsListResource.get().$promise;

            return promise.then(function (details) {
                return _this8._getPaymentMethodObject(details.data);
            }).catch(function (error) {
                throw _this8.apiService.getErrorMessage(error);
            });
        }

        /**
        * function to get transportation alternatives overview
        * @return {object} [information related to transportation alternatives overview]
        */

    }, {
        key: 'getTransportationAlternativesOverview',
        value: function getTransportationAlternativesOverview(details) {
            return this._getOverviewDetails(details.data);
        }

        /**
        * function to get transportation alternatives list
        * @return {object} [information related to transportation alternatives list]
        */

    }, {
        key: 'getTransportationAlternativesDetails',
        value: function getTransportationAlternativesDetails(details) {
            return {
                overview: this._getOverviewDetails(details.data.menuOverviewDetails),
                list: this._getContentDetails(details.data.children)
            };
        }

        /**
        * function to edit transportation alternatives overview
        * @return {object} [information related to transportation alternatives overview for edit]
        */

    }, {
        key: 'updateTransportationAlternativesOverview',
        value: function updateTransportationAlternativesOverview(details) {
            var _this9 = this;

            var promise = this.transportationAlternativesOverviewResource.update(this._setOverviewObject(details)).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (error) {
                throw _this9.apiService.getErrorMessage(error);
            });
        }

        //get content sequence service

    }, {
        key: 'getTransportationAlternativesEditSequence',
        value: function getTransportationAlternativesEditSequence(details) {
            return this._getContentSequence(details.data);
        }

        //update content sequence service

    }, {
        key: 'setTransportationAlternativesEditSequence',
        value: function setTransportationAlternativesEditSequence(sequenceObj) {
            var promise = this.transportationAlternativesSequenceResource.update(this._setContentSequence(sequenceObj)).$promise;

            return promise.then(function (response) {
                return response;
            });
        }

        //get publish status list

    }, {
        key: 'getTransportationAlternativesPublishPageList',
        value: function getTransportationAlternativesPublishPageList() {
            var _this10 = this;

            var promise = this.transportationAlternativesPublishPageResource.get().$promise;

            return promise.then(function (details) {
                return _this10._getPublishPageListObject(details.data);
            });
        }

        //update publish status list

    }, {
        key: 'setTransportationAlternativesPublishPageList',
        value: function setTransportationAlternativesPublishPageList(list) {
            var promise = this.transportationAlternativesPublishPageResource.update(this._setPublishPageListObject(list)).$promise;

            return promise.then(function (response) {
                return response;
            });
        }

        /**
        * function to get call for help list
        * @return {object} [information related to call for help list]
        */

    }, {
        key: 'getFilterCallForHelpDetails',
        value: function getFilterCallForHelpDetails(_ref8, url) {
            var _this11 = this;

            var _ref8$limit = _ref8.limit,
                limit = _ref8$limit === undefined ? 10 : _ref8$limit,
                _ref8$page_id = _ref8.page_id,
                page_id = _ref8$page_id === undefined ? 1 : _ref8$page_id;

            this.callForHelpListResourceUrl = this.apiService.getResourceUrl('cms/menus/' + url);
            this.callForHelpListResource = this.$resource(this.callForHelpListResourceUrl);

            var promise = this.callForHelpListResource.get({
                limit: limit,
                page_id: page_id
            }).$promise;

            return promise.then(function (details) {
                return {
                    list: _this11._getSubContentDetails(details.data.content),
                    count: details.data.count
                };
            }).catch(function (error) {
                throw _this11.apiService.getErrorMessage(error);
            });
        }
    }, {
        key: 'getCallForHelpDetails',
        value: function getCallForHelpDetails(details) {
            return {
                overview: this._getOverviewDetails(details.data.menuOverviewDetails),
                list: this._getSubContentDetails(details.data.content),
                count: details.data.count
            };
        }

        /**
        * function to get call for help detail by id
        * @return {object} [information related to call for help detail by id]
        */
        // getCallForHelpDetailsById(id) {
        //     const promise = this.callForHelpDetailByIdResource.get({
        //         content_id: id
        //     }).$promise;

        //     return promise.then(details => this._getTemplate1DetailObject(details.data))
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

    }, {
        key: 'getCallForHelpDetailsById',
        value: function getCallForHelpDetailsById(details) {
            return this._getTemplate1DetailObject(details.data);
        }

        /**
        * function to get call for help overview
        * @return {object} [information related to call for help overview]
        */
        // getCallForHelpOverview() {
        //     const promise = this.callForHelpOverviewResource.get().$promise;

        //     return promise.then(details => this._getOverviewDetails(details.data))
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

    }, {
        key: 'getCallForHelpOverview',
        value: function getCallForHelpOverview(details) {
            return this._getOverviewDetails(details.data);
        }

        /**
        * function to edit call for help overview
        * @return {object} [information related to call for help overview for edit]
        */

    }, {
        key: 'updateCallForHelpOverview',
        value: function updateCallForHelpOverview(details) {
            var _this12 = this;

            var promise = this.callForHelpOverviewResource.update(this._setOverviewObject(details)).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (error) {
                throw _this12.apiService.getErrorMessage(error);
            });
        }

        /**
        * function to add call for help data
        * @return {object} [information related to call for help data for add]
        */
        // addCallForHelpDetail(details) {
        //     const promise = this.callForHelpAddResource.save(this._setTemplate1DetailObject(details)).$promise;

        //     return promise.then(details => details.data)
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

        /**
        * function to edit call for help data
        * @return {object} [information related to call for help data for edit]
        */

    }, {
        key: 'updateCallForHelpDetail',
        value: function updateCallForHelpDetail(details, id) {
            var _this13 = this;

            var promise = this.callForHelpEditDeleteResource.update({
                content_id: id
            }, this._setTemplate1DetailObject(details)).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (error) {
                throw _this13.apiService.getErrorMessage(error);
            });
        }

        /**
        * function to delete call for help data
        * @return {object} [information related to call for help data for delete]
        */

    }, {
        key: 'deleteCallForHelpData',
        value: function deleteCallForHelpData(id) {
            var _this14 = this;

            var promise = this.callForHelpEditDeleteResource.delete({ content_id: id }).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (err) {
                throw _this14.apiService.getErrorMessage(err);
            });
        }

        /**
        * function to get ridesharing list
        * @return {object} [information related to ridesharing list]
        */

    }, {
        key: 'getRidesharingDetailsByFilter',
        value: function getRidesharingDetailsByFilter(_ref9, url) {
            var _this15 = this;

            var _ref9$limit = _ref9.limit,
                limit = _ref9$limit === undefined ? 10 : _ref9$limit,
                _ref9$page_id = _ref9.page_id,
                page_id = _ref9$page_id === undefined ? 1 : _ref9$page_id;

            this.ridesharingListResourceUrl = this.apiService.getResourceUrl('cms/menus/' + url);
            this.ridesharingListResource = this.$resource(this.ridesharingListResourceUrl);

            var promise = this.ridesharingListResource.get({
                limit: limit,
                page_id: page_id
            }).$promise;

            return promise.then(function (details) {
                return {
                    overview: _this15._getOverviewDetails(details.data.menuOverviewDetails),
                    list: _this15._getRideSharingDetails(details.data.content),
                    count: details.data.count
                };
            }).catch(function (error) {
                throw _this15.apiService.getErrorMessage(error);
            });
        }
    }, {
        key: 'getRidesharingDetails',
        value: function getRidesharingDetails(details) {
            return {
                overview: this._getOverviewDetails(details.data.menuOverviewDetails),
                list: this._getRideSharingDetails(details.data.content),
                count: details.data.count
            };
        }

        /**
        * function to get ridesharing detail by id
        * @return {object} [information related to ridesharing detail by id]
        */
        // getRidesharingDetailsById(id) {
        //     const promise = this.ridesharingDetailByIdResource.get({
        //         content_id: id
        //     }).$promise;

        //     return promise.then(details => this._getTemplate1DetailObject(details.data))
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

    }, {
        key: 'getRidesharingDetailsById',
        value: function getRidesharingDetailsById(details) {
            return this._getTemplate1DetailObject(details.data);
        }

        /**
        * function to get ridesharing overview
        * @return {object} [information related to ridesharing overview]
        */
        // getRidesharingOverview() {
        //     const promise = this.ridesharingOverviewResource.get().$promise;

        //     return promise.then(details => this._getOverviewDetails(details.data))
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

    }, {
        key: 'getRidesharingOverview',
        value: function getRidesharingOverview(details) {
            return this._getOverviewDetails(details.data);
        }

        /**
        * function to edit ridesharing overview
        * @return {object} [information related to ridesharing overview for edit]
        */

    }, {
        key: 'updateRidesharingOverview',
        value: function updateRidesharingOverview(details) {
            var _this16 = this;

            var promise = this.ridesharingOverviewResource.update(this._setOverviewObject(details)).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (error) {
                throw _this16.apiService.getErrorMessage(error);
            });
        }

        /**
        * function to add ridesharing data
        * @return {object} [information related to ridesharing data for add]
        */
        // addRidesharingDetail(details) {
        //     const promise = this.ridesharingAddResource.save(this._setTemplate1DetailObject(details)).$promise;

        //     return promise.then(details => details.data)
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

        /**
        * function to edit ridesharing data
        * @return {object} [information related to ridesharing data for edit]
        */
        // updateRidesharingDetail(details, id) {
        //     const promise = this.ridesharingEditDeleteResource.update({
        //         content_id: id
        //     }, this._setTemplate1DetailObject(details)).$promise;

        //     return promise.then(details => details.data)
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

        /**
        * function to delete ridesharing data
        * @return {object} [information related to ridesharing data for delete]
        */

    }, {
        key: 'deleteRidesharingData',
        value: function deleteRidesharingData(id) {
            var _this17 = this;

            var promise = this.ridesharingEditDeleteResource.delete({ content_id: id }).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (err) {
                throw _this17.apiService.getErrorMessage(err);
            });
        }

        /**
        * function to get bicycle pedestrian list
        * @return {object} [information related to bicycle pedestrian list]
        */

    }, {
        key: 'getFilterBicyclePedestrianDetails',
        value: function getFilterBicyclePedestrianDetails(_ref10, url) {
            var _this18 = this;

            var _ref10$limit = _ref10.limit,
                limit = _ref10$limit === undefined ? 10 : _ref10$limit,
                _ref10$page_id = _ref10.page_id,
                page_id = _ref10$page_id === undefined ? 1 : _ref10$page_id;

            this.bicyclePedestrianListResourceUrl = this.apiService.getResourceUrl('cms/menus/' + url);
            this.bicyclePedestrianListResource = this.$resource(this.bicyclePedestrianListResourceUrl);

            var promise = this.bicyclePedestrianListResource.get({
                limit: limit,
                page_id: page_id
            }).$promise;

            return promise.then(function (details) {
                return {
                    overview: _this18._getOverviewDetails(details.data.menuOverviewDetails),
                    list: _this18._getBicyclePedestrianDetails(details.data.content),
                    count: details.data.count
                };
            }).catch(function (error) {
                throw _this18.apiService.getErrorMessage(error);
            });
        }
    }, {
        key: 'getBicyclePedestrianDetails',
        value: function getBicyclePedestrianDetails(details) {
            return {
                overview: this._getOverviewDetails(details.data.menuOverviewDetails),
                list: this._getBicyclePedestrianDetails(details.data.content),
                count: details.data.count
            };
        }

        /**
        * function to get bicycle pedestrian detail by id
        * @return {object} [information related to bicycle pedestrian detail by id]
        */

    }, {
        key: 'getBicyclePedestrianDetailsById',
        value: function getBicyclePedestrianDetailsById(details) {
            return this._getTemplate2DetailObject(details.data);
        }

        /**
        * function to get bicycle pedetrian overview
        * @return {object} [information related to bicycle pedetrian overview]
        */

    }, {
        key: 'getBicyclePedestrianOverview',
        value: function getBicyclePedestrianOverview() {
            var _this19 = this;

            var promise = this.bicyclePedestrianOverviewResource.get().$promise;

            return promise.then(function (details) {
                return _this19._getOverviewDetails(details.data);
            }).catch(function (error) {
                throw _this19.apiService.getErrorMessage(error);
            });
        }

        /**
        * function to edit bicycle pedestrian overview
        * @return {object} [information related to bicycle pedestrian overview for edit]
        */

    }, {
        key: 'updateBicyclePedestrianOverview',
        value: function updateBicyclePedestrianOverview(details) {
            var _this20 = this;

            var promise = this.bicyclePedestrianOverviewResource.update(this._setOverviewObject(details)).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (error) {
                throw _this20.apiService.getErrorMessage(error);
            });
        }

        /**
        * function to add bicycle pedestrian data
        * @return {object} [information related to bicycle pedestrian data for add]
        */
        // addBicyclePedestrianDetail(details) {
        //     const promise = this.bicyclePedestrianAddResource.save(this._setTemplate2DetailObject(details)).$promise;

        //     return promise.then(details => details.data)
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

        /**
        * function to edit bicycle pedestrian data
        * @return {object} [information related to bicycle pedestrian data for edit]
        */
        // updateBicyclePedestrianDetail(details, id) {
        //     const promise = this.bicyclePedestrianEditDeleteResource.update({
        //         content_id: id
        //     }, this._setTemplate2DetailObject(details)).$promise;

        //     return promise.then(details => details.data)
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

        /**
        * function to delete bicycle pedestrian data
        * @return {object} [information related to bicycle pedestrian data for delete]
        */

    }, {
        key: 'deleteBicyclePedestrianData',
        value: function deleteBicyclePedestrianData(id) {
            var _this21 = this;

            var promise = this.bicyclePedestrianEditDeleteResource.delete({ content_id: id }).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (err) {
                throw _this21.apiService.getErrorMessage(err);
            });
        }

        /**
        * function to get transportation providers list
        * @return {object} [information related to transportation providers list]
        */

    }, {
        key: 'getTransportationProviderDetailsByFilter',
        value: function getTransportationProviderDetailsByFilter(_ref11, url) {
            var _this22 = this;

            var _ref11$limit = _ref11.limit,
                limit = _ref11$limit === undefined ? 10 : _ref11$limit,
                _ref11$page_id = _ref11.page_id,
                page_id = _ref11$page_id === undefined ? 1 : _ref11$page_id;

            this.transportationProvidersListResourceUrl = this.apiService.getResourceUrl('cms/menus/' + url);
            this.transportationProvidersListResource = this.$resource(this.transportationProvidersListResourceUrl);

            var promise = this.transportationProvidersListResource.get({
                limit: limit,
                page_id: page_id
            }).$promise;

            return promise.then(function (details) {
                return {
                    overview: _this22._getOverviewDetails(details.data.menuOverviewDetails),
                    list: _this22._getTransportationProvidersDetails(details.data.content),
                    count: details.data.count
                };
            }).catch(function (error) {
                throw _this22.apiService.getErrorMessage(error);
            });
        }
    }, {
        key: 'getTransportationProvidersDetails',
        value: function getTransportationProvidersDetails(details) {
            return {
                overview: this._getOverviewDetails(details.data.menuOverviewDetails),
                list: this._getTransportationProvidersDetails(details.data.content),
                count: details.data.count
            };
        }
    }, {
        key: 'getTransportationProvidersByName',
        value: function getTransportationProvidersByName(searchKey) {
            var _this23 = this;

            var promise = this.transportationProvidersSearchResource.get({
                search_key: searchKey
            }).$promise;

            return promise.then(function (transportationProviderDetails) {
                return transportationProviderDetails.data.map(function (value) {
                    return _this23._getTransportationProvidersListObject(value);
                });
            }).catch(function (error) {
                throw _this23.apiService.getErrorMessage(error);
            });
        }

        /**
        * function to get transportation providers detail by id
        * @return {object} [information related to transportation providers detail by id]
        */
        // getTransportationProvidersDetailsByIdEdit(id) {
        //     const promise = this.transportationProvidersDetailByIdResource.get({
        //         content_id: id
        //     }).$promise;

        //     return promise.then(details => this._getTransportationProvidersDetailObject(details.data))
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

    }, {
        key: 'getTransportationProvidersDetailsByIdEdit',
        value: function getTransportationProvidersDetailsByIdEdit(details) {
            return this._getTransportationProvidersDetailObject(details.data);
        }

        // getTransportationProvidersDetailsById(id) {
        //     const promise = this.transportationProvidersDetailByIdResource.get({
        //         content_id: id
        //     }).$promise;

        //     return promise.then(details => this._getTransportationProvidersListObject(details.data))
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

    }, {
        key: 'getTransportationProvidersDetailsById',
        value: function getTransportationProvidersDetailsById(details) {
            return this._getTransportationProvidersListObject(details.data);
        }

        /**
        * function to get transportation providers overview
        * @return {object} [information related to transportation providers overview]
        */
        // getTransportationProvidersOverview() {
        //     const promise = this.transportationProvidersOverviewResource.get().$promise;

        //     return promise.then(details => this._getOverviewDetails(details.data))
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

    }, {
        key: 'getTransportationProvidersOverview',
        value: function getTransportationProvidersOverview(details) {
            return this._getOverviewDetails(details.data);
        }

        /**
        * function to edit transportation providers overview
        * @return {object} [information related to transportation providers overview for edit]
        */

    }, {
        key: 'updateTransportationProvidersOverview',
        value: function updateTransportationProvidersOverview(details) {
            var _this24 = this;

            var promise = this.transportationProvidersOverviewResource.update(this._setOverviewObject(details)).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (error) {
                throw _this24.apiService.getErrorMessage(error);
            });
        }

        /**
        * function to add transportation providers data
        * @return {object} [information related to transportation providers data for add]
        */
        // addTransportationProvidersDetail(details) {
        //     const promise = this.transportationProvidersAddResource.save(this._setTransportationProvidersListObject(details)).$promise;

        //     return promise.then(details => details.data)
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

        /**
        * function to edit transportation providers data
        * @return {object} [information related to transportation providers data for edit]
        */
        // updateTransportationProvidersDetail(details, id) {
        //     const promise = this.transportationProvidersEditDeleteResource.update({
        //         content_id: id
        //     }, this._setTransportationProvidersListObject(details)).$promise;

        //     return promise.then(details => details.data)
        //         .catch((error) => {
        //             throw this.apiService.getErrorMessage(error);
        //         });
        // }

        /**
        * function to delete transportation providers data
        * @return {object} [information related to transportation providers data for delete]
        */

    }, {
        key: 'deleteTransportationProvidersData',
        value: function deleteTransportationProvidersData(id) {
            var _this25 = this;

            var promise = this.transportationProvidersEditDeleteResource.delete({ content_id: id }).$promise;

            return promise.then(function (details) {
                return details.data;
            }).catch(function (err) {
                throw _this25.apiService.getErrorMessage(err);
            });
        }
    }]);

    return TransportationAlternativeService;
}();

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var transportationProvidersAddComponent = exports.transportationProvidersAddComponent = {

    //passing title and onSubmit function for binding in main component
    template: '\n        <transportation-providers-main\n            disable-buttons=\'$ctrl.disableButtons\'\n            on-submit=\'$ctrl.onSubmit($event)\'\n            service-area=\'$ctrl.serviceArea\'\n            service-type=\'$ctrl.serviceType\'\n            parent-slug=\'{{$ctrl.parentSlug}}\'\n            payment-methods=\'$ctrl.paymentMethods\'>\n        </transportation-providers-main>',

    bindings: {
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for TransportationProvidersAddComponent
    controller: function () {
        TransportationProvidersAddComponent.$inject = ["$stateParams", "toastr", "$state", "TransportationAlternativeService", "DynamicMenusService", "SlugService"];
        function TransportationProvidersAddComponent($stateParams, toastr, $state, TransportationAlternativeService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, TransportationProvidersAddComponent);

            this.$stateParams = $stateParams;
            this.toastr = toastr;
            this.$state = $state;
            this.transportationAlternativeService = TransportationAlternativeService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        _createClass(TransportationProvidersAddComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.serviceArea = [];
                this.serviceType = [];
                this.paymentMethods = [];

                this._getServiceAreaList();
                this._getServiceTypeList();
                this._getPaymentMethodsList();
            }

            //function to add class details

        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                this.disableButtons = true;
                var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'add');
                details = this.transportationAlternativeService._setTransportationProvidersListObject(details);

                // submit the request
                this.dynamicMenusService.addMenuDetailsByUrl(url, details).then(function (_ref) {
                    var id = _ref.data.content_id;

                    var contentDetailsUrl = _this.slugService.getContentDetailsURL(url, id);
                    _this.toastr.success('Data added successfully');
                    _this._redirectToParentState(contentDetailsUrl);
                    _this.disableButtons = false;
                }).catch(function (err) {
                    _this.toastr.error(err);
                    _this.disableButtons = false;
                });
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }, {
            key: '_getServiceAreaList',
            value: function _getServiceAreaList() {
                var _this2 = this;

                this.transportationAlternativeService.getCallForHelpCountyList().then(function (serviceArea) {
                    return _this2.serviceArea = serviceArea;
                });
            }
        }, {
            key: '_getServiceTypeList',
            value: function _getServiceTypeList() {
                var _this3 = this;

                this.transportationAlternativeService.getServiceTypeList().then(function (serviceType) {
                    return _this3.serviceType = serviceType;
                });
            }
        }, {
            key: '_getPaymentMethodsList',
            value: function _getPaymentMethodsList() {
                var _this4 = this;

                this.transportationAlternativeService.getPaymentMethodsList().then(function (paymentMethods) {
                    return _this4.paymentMethods = paymentMethods;
                });
            }
        }]);

        return TransportationProvidersAddComponent;
    }()
};

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transportationProvidersAdd = undefined;

var _transportationProvidersAdd = __webpack_require__(690);

var transportationProvidersAdd = exports.transportationProvidersAdd = angular.module('components.transportationAlternative.transportationProviders.transportationProvidersAdd', []).component('transportationProvidersAdd', _transportationProvidersAdd.transportationProvidersAddComponent).name;

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transportationProvidersDetailsComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transportationProvidersDetails = __webpack_require__(798);

var _transportationProvidersDetails2 = _interopRequireDefault(_transportationProvidersDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var transportationProvidersDetailsComponent = exports.transportationProvidersDetailsComponent = {

	//binding details
	bindings: {
		details: '<',
		parentSlug: '@',
		slugUrl: '@'
	},

	templateUrl: _transportationProvidersDetails2.default,

	//controller for TransportationProvidersDetailsComponent
	controller: function () {
		TransportationProvidersDetailsComponent.$inject = ["$state", "ApiService", "TransportationAlternativeService", "SlugService"];
		function TransportationProvidersDetailsComponent($state, ApiService, TransportationAlternativeService, SlugService) {
			'ngInject';

			_classCallCheck(this, TransportationProvidersDetailsComponent);

			this.$state = $state;
			this.apiService = ApiService;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.slugService = SlugService;
		}

		_createClass(TransportationProvidersDetailsComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.transportationAlternativeService.getTransportationProvidersDetailsById(this.details);
				var selectedItems = {};
				this.details.daysOfOperation.map(function (value, index) {
					selectedItems[value.name] = value.isSelected;
					return value;
				});
				this.daysOfOperation = selectedItems;
			}
		}, {
			key: '_getImage',
			value: function _getImage(detail) {
				var image = detail.image;
				return image ? this.apiService.getResourceUrl('files/images/' + image) : '';
			}
		}, {
			key: 'onGoBack',
			value: function onGoBack() {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: this.parentSlug
				});
			}
		}, {
			key: 'onEdit',
			value: function onEdit() {
				var slug = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'details');
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}]);

		return TransportationProvidersDetailsComponent;
	}()
};

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transportationProvidersDetails = undefined;

var _transportationProvidersDetails = __webpack_require__(692);

var transportationProvidersDetails = exports.transportationProvidersDetails = angular.module('components.transportationProviders.transportationProvidersDetails', []).component('transportationProvidersDetails', _transportationProvidersDetails.transportationProvidersDetailsComponent).name;

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.transportationProvidersEditComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(11);

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var transportationProvidersEditComponent = exports.transportationProvidersEditComponent = {

    //passing title and onSubmit function for binding in main component
    template: '\n                <transportation-providers-main \n                    details=\'$ctrl.details\'\n                    disable-buttons=\'$ctrl.disableButtons\'\n                    on-submit=\'$ctrl.onSubmit($event)\'\n                    service-area=\'$ctrl.serviceArea\'\n                    service-type=\'$ctrl.serviceType\'\n                    parent-slug=\'{{$ctrl.parentSlug}}\'\n                    payment-methods=\'$ctrl.paymentMethods\'>\n                </transportation-providers-main>',

    bindings: {
        details: '<',
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for TransportationProvidersEditComponent
    controller: function () {
        TransportationProvidersEditComponent.$inject = ["toastr", "$state", "$stateParams", "TransportationAlternativeService", "CompareObjectService", "DynamicMenusService", "SlugService"];
        function TransportationProvidersEditComponent(toastr, $state, $stateParams, TransportationAlternativeService, CompareObjectService, DynamicMenusService, SlugService) {
            'ngInject';

            _classCallCheck(this, TransportationProvidersEditComponent);

            this.toastr = toastr;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.transportationAlternativeService = TransportationAlternativeService;
            this.compareObjectService = CompareObjectService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        //storing old data in savedData


        _createClass(TransportationProvidersEditComponent, [{
            key: '$onInit',
            value: function $onInit() {
                this.serviceArea = [];
                this.serviceType = [];
                this.paymentMethods = [];
                this.details = this.transportationAlternativeService.getTransportationProvidersDetailsByIdEdit(this.details);
                this.savedData = angular.copy(this.details);
                this._getServiceAreaList();
                this._getServiceTypeList();
                this._getPaymentMethodsList();
            }

            //comparing old and new data for update on submit function

        }, {
            key: 'onSubmit',
            value: function onSubmit(details) {
                var _this = this;

                var _details = angular.copy(details);
                var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, _details, true);
                if (isUpdated) {
                    var url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'edit');
                    var _details2 = this.transportationAlternativeService._setTransportationProvidersListObject(_details);

                    this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, _details2).then(function (details) {
                        var contentDetailsUrl = _this.slugService.getDetailsPageURL(url);
                        _this.toastr.success('Data updated successfully');
                        _this._redirectToParentState(contentDetailsUrl);
                        _this.disableButtons = false;
                    }).catch(function (err) {
                        _this.toastr.error(err);
                        _this.disableButtons = false;
                    });
                } else {
                    this.toastr.success('Nothing to update');
                    this._redirectToParentState(this.parentSlug);
                    this.disableButtons = false;
                }
            }
        }, {
            key: '_redirectToParentState',
            value: function _redirectToParentState(slug) {
                this.$state.go('app.dashboard.DynamicMenus', {
                    url: slug
                });
            }
        }, {
            key: '_getServiceAreaList',
            value: function _getServiceAreaList() {
                var _this2 = this;

                this.transportationAlternativeService.getCallForHelpCountyList().then(function (serviceArea) {
                    return _this2.serviceArea = (0, _clone2.default)(serviceArea);
                });
            }
        }, {
            key: '_getServiceTypeList',
            value: function _getServiceTypeList() {
                var _this3 = this;

                this.transportationAlternativeService.getServiceTypeList().then(function (serviceType) {
                    return _this3.serviceType = serviceType;
                });
            }
        }, {
            key: '_getPaymentMethodsList',
            value: function _getPaymentMethodsList() {
                var _this4 = this;

                this.transportationAlternativeService.getPaymentMethodsList().then(function (paymentMethods) {
                    return _this4.paymentMethods = paymentMethods;
                });
            }
        }]);

        return TransportationProvidersEditComponent;
    }()
};

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transportationProvidersEdit = undefined;

var _transportationProvidersEdit = __webpack_require__(694);

var transportationProvidersEdit = exports.transportationProvidersEdit = angular.module('components.transportationAlternative.transportationProviders.transportationProvidersEdit', []).component('transportationProvidersEdit', _transportationProvidersEdit.transportationProvidersEditComponent).name;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transportationProvidersListComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __webpack_require__(11);

var _clone2 = _interopRequireDefault(_clone);

var _transportationAlternativeListTemplate = __webpack_require__(86);

var _transportationAlternativeListTemplate2 = _interopRequireDefault(_transportationAlternativeListTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var transportationProvidersListComponent = exports.transportationProvidersListComponent = {
	bindings: {
		details: '<',
		slugUrl: '@'
	},

	templateUrl: _transportationAlternativeListTemplate2.default,

	controller: function () {
		TransportationProvidersListComponent.$inject = ["$state", "toastr", "ApiService", "ModalService", "TransportationAlternativeService", "DashboardService", "DynamicMenusService", "SlugService"];
		function TransportationProvidersListComponent($state, toastr, ApiService, ModalService, TransportationAlternativeService, DashboardService, DynamicMenusService, SlugService) {
			'ngInject';

			_classCallCheck(this, TransportationProvidersListComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.apiService = ApiService;
			this.modalService = ModalService;
			this.transportationAlternativeService = TransportationAlternativeService;
			this.dashboardService = DashboardService;
			this.dynamicMenusService = DynamicMenusService;
			this.slugService = SlugService;
		}

		_createClass(TransportationProvidersListComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.transportationAlternativeService.getTransportationProvidersDetails(this.details);
				this.activeMenuName = this.dashboardService.getActiveMenuName();
				this.pageTitle = this.activeMenuName + ' List';

				this.currentPage = 1;
				this.itemPerPage = 10;
				this.totalItems = this.details.count;
				this.filterDetails = {
					'limit': this.itemPerPage,
					'page_id': this.currentPage
				};
				this.isSearchBoxVisisble = true;
				this.showPagination = true;
			}
		}, {
			key: 'routeDetailsPageUrl',
			value: function routeDetailsPageUrl(slug) {
				var url = this.slugService.getDetailsPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeEditPageUrl',
			value: function routeEditPageUrl(slug) {
				var url = this.slugService.getEditPageURL(slug);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'routeAddPageUrl',
			value: function routeAddPageUrl() {
				var url = this.slugService.getAddPageURL(this.slugUrl);

				this.$state.go('app.dashboard.DynamicMenus', {
					url: url
				});
			}
		}, {
			key: 'onChange',
			value: function onChange(pageNumber) {
				var _this = this;

				this.currentPage = pageNumber;
				this.filterDetails.limit = this.itemPerPage;
				this.filterDetails.page_id = this.currentPage;
				this.transportationAlternativeService.getTransportationProviderDetailsByFilter(this.filterDetails, this.slugUrl).then(function (result) {
					_this.details.list = result.list;
				});
			}

			//on delete the call for help data

		}, {
			key: 'onDelete',
			value: function onDelete(slug) {
				this.modalService.open({
					details: {
						bodyMessage: 'Are you sure you want to delete the data?'
					},

					buttons: [{
						name: 'No'
					}, {
						name: 'Yes',
						isPrimary: true,
						action: onSubmit.bind(this)
					}]
				});

				function onSubmit() {
					var _this2 = this;

					this.dynamicMenusService.deleteMenuDetailsByUrl(slug + '/delete').then(function (response) {
						_this2.totalItems -= 1;
						_this2.toastr.success("Data Deleted successfully");
					}).then(function (_) {
						return _this2.transportationAlternativeService.getTransportationProviderDetailsByFilter(_this2.filterDetails, _this2.slugUrl);
					}).then(function (_ref) {
						var list = _ref.list;

						_this2.details.list = list;
					}).catch(function (err) {
						_this2.toastr.error(err);
					});
				}
			}
		}, {
			key: 'onSearch',
			value: function onSearch(searchKey) {
				searchKey ? this._getSerachProviderList(searchKey) : this._getAllProviderList();
			}
		}, {
			key: '_getSerachProviderList',
			value: function _getSerachProviderList(searchKey) {
				var _this3 = this;

				this.transportationAlternativeService.getTransportationProvidersByName(searchKey).then(function (TransportationProvidersDetails) {
					_this3.details.list = TransportationProvidersDetails;
					_this3.showPagination = false;
				});
			}
		}, {
			key: '_getAllProviderList',
			value: function _getAllProviderList() {
				var _this4 = this;

				this.transportationAlternativeService.getTransportationProviderDetailsByFilter({ limit: 10, page_id: 1 }, this.slugUrl).then(function (TransportationProvidersDetails) {
					_this4.details = (0, _clone2.default)(TransportationProvidersDetails);
					_this4.currentPage = 1;
					_this4.itemPerPage = 10;
					_this4.totalItems = _this4.details.count;
					_this4.filterDetails = {
						'limit': _this4.itemPerPage,
						'page_id': _this4.currentPage
					};
					_this4.showPagination = true;
				});
			}
		}, {
			key: '_getImage',
			value: function _getImage(detail) {
				var image = detail.image;
				return image ? this.apiService.getResourceUrl('files/images/' + image) : '/./images/placeholder.png';
			}
		}]);

		return TransportationProvidersListComponent;
	}()
};

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transportationProvidersList = undefined;

var _transportationProvidersList = __webpack_require__(696);

var transportationProvidersList = exports.transportationProvidersList = angular.module('components.transportationAlternative.transportationProviders.transportationProvidersList', []).component('transportationProvidersList', _transportationProvidersList.transportationProvidersListComponent).name;

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transportationProvidersMainComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _transportationProvidersTemplate = __webpack_require__(799);

var _transportationProvidersTemplate2 = _interopRequireDefault(_transportationProvidersTemplate);

var _assignIn = __webpack_require__(73);

var _assignIn2 = _interopRequireDefault(_assignIn);

var _size = __webpack_require__(12);

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var transportationProvidersMainComponent = exports.transportationProvidersMainComponent = {
	templateUrl: _transportationProvidersTemplate2.default,

	//binding title, details and onSubmit function
	bindings: {
		pageTitle: '@',
		details: '<',
		serviceArea: '<',
		serviceType: '<',
		paymentMethods: '<',
		onSubmit: '&',
		onPrevious: '&',
		disableButtons: '<',
		parentSlug: '@'
	},

	//controller for TransportationProvidersMainComponent
	controller: function () {
		TransportationProvidersMainComponent.$inject = ["$state", "ModalService", "toastr"];
		function TransportationProvidersMainComponent($state, ModalService, toastr) {
			'ngInject';

			_classCallCheck(this, TransportationProvidersMainComponent);

			this.$state = $state;
			this.modalService = ModalService;
			this.toastr = toastr;
		}

		_createClass(TransportationProvidersMainComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.step = 1;
				this.isBasicInfoActive = true;
				this.isServiceInfoActive = false;
				this.isOperationInfoClassInActive = false;
				this.isOtherInfoClassActive = false;
				this.isServiceInfoSubmitted = false;
				this.isOperationInfoClassSubmitted = false;
				this.isOtherInfoClassSubmitted = false;
				this.details = this.details || {
					basicInfo: {
						phone: [],
						name: "",
						url: "",
						image: "",
						email: ""
					},
					serviceInfo: {
						serviceType: [],
						serviceArea: [],
						specialRequirements: [],
						medicaidSupport: true,
						veteranSupport: true
					},
					operationInfo: {
						daysOfOperation: "",
						hoursOfOperation: {}
					},
					otherInfo: {
						fees: "",
						methodOfPayment: [],
						notes: ""
					}
				};
				this.saveData = angular.copy(this.details);
			}
		}, {
			key: 'onSubmitBasicInfo',
			value: function onSubmitBasicInfo(details) {
				this.isServiceInfoActive = true;
				this.isBasicInfoActive = false;
				this.step += 1;
				this.details = (0, _assignIn2.default)(this.details, details);
				document.querySelector(".rightpanel").scrollTop = 0;
			}
		}, {
			key: 'onSubmitServiceInfo',
			value: function onSubmitServiceInfo(details) {
				if ((0, _size2.default)(details.serviceInfo.serviceType) > 0 && (0, _size2.default)(details.serviceInfo.serviceArea) > 0) {
					this.isServiceInfoSubmitted = true;
					this.isOperationInfoClassActive = true;
					this.step += 1;
					this.details = (0, _assignIn2.default)(this.details, details);
					document.querySelector(".rightpanel").scrollTop = 0;
				} else {
					this.toastr.error("Please select service type and service area");
				}
			}
		}, {
			key: 'onSubmitOperationInfo',
			value: function onSubmitOperationInfo(details) {
				this.isOperationInfoClassSubmitted = true;
				this.isOtherInfoClassActive = true;
				this.step += 1;
				this.details = (0, _assignIn2.default)(this.details, details);
				document.querySelector(".rightpanel").scrollTop = 0;
			}
		}, {
			key: 'onSubmitOtherInfo',
			value: function onSubmitOtherInfo(details) {
				if ((0, _size2.default)(details.otherInfo.methodOfPayment) > 0) {
					this.isOtherInfoClassSubmitted = true;
					this.details = (0, _assignIn2.default)(this.details, details);
					this.onSubmit({
						$event: this.details
					});
				} else {
					this.toastr.error("Please select Payment methods");
				}
			}
		}, {
			key: 'onServiceInfoPrevious',
			value: function onServiceInfoPrevious(details) {
				this.isServiceInfoActive = false;
				this.isBasicInfoActive = true;
				this.step -= 1;
				this.details = (0, _assignIn2.default)(this.details, details);
				document.querySelector(".rightpanel").scrollTop = 0;
			}
		}, {
			key: 'onOperationInfoPrevious',
			value: function onOperationInfoPrevious(details) {
				this.isServiceInfoSubmitted = false;
				this.isOperationInfoClassActive = false;
				this.step -= 1;
				this.details = (0, _assignIn2.default)(this.details, details);
				document.querySelector(".rightpanel").scrollTop = 0;
			}
		}, {
			key: 'onOtherInfoPrevious',
			value: function onOtherInfoPrevious(details) {
				this.isOperationInfoClassSubmitted = false;
				this.isOtherInfoClassActive = false;
				this.step -= 1;
				this.details = (0, _assignIn2.default)(this.details, details);
				document.querySelector(".rightpanel").scrollTop = 0;
			}
		}]);

		return TransportationProvidersMainComponent;
	}()
};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transportationProvidersMain = undefined;

var _transportationProvidersMain = __webpack_require__(698);

var transportationProvidersMain = exports.transportationProvidersMain = angular.module('components.transportationALternative.transportationProviders.transportationProvidersMain', []).component("transportationProvidersMain", _transportationProvidersMain.transportationProvidersMainComponent).name;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.transportationProviders = undefined;

var _transportationProvidersList = __webpack_require__(697);

var _transportationProvidersAdd = __webpack_require__(691);

var _transportationProvidersEdit = __webpack_require__(695);

var _transportationProvidersMain = __webpack_require__(699);

var _transportationProvidersDetails = __webpack_require__(693);

var transportationProviders = exports.transportationProviders = angular.module('components.transportationAlternative.transportationProviders', [_transportationProvidersList.transportationProvidersList, _transportationProvidersAdd.transportationProvidersAdd, _transportationProvidersEdit.transportationProvidersEdit, _transportationProvidersMain.transportationProvidersMain, _transportationProvidersDetails.transportationProvidersDetails]).name;

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.tripPlanningComponent = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _tripPlanning = __webpack_require__(800);

var _tripPlanning2 = _interopRequireDefault(_tripPlanning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var tripPlanningComponent = exports.tripPlanningComponent = {
	bindings: {
		details: '<'
	},

	templateUrl: _tripPlanning2.default,

	controller: function () {
		TripPlanningComponent.$inject = ["$state", "toastr", "CompareObjectService", "ModalService", "TripPlanningService"];
		function TripPlanningComponent($state, toastr, CompareObjectService, ModalService, TripPlanningService) {
			'ngInject';

			_classCallCheck(this, TripPlanningComponent);

			this.$state = $state;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.tripPlanningService = TripPlanningService;
		}

		_createClass(TripPlanningComponent, [{
			key: '$onInit',
			value: function $onInit() {
				this.details = this.tripPlanningService.getTripPlanningDetails(this.details);
				this.details.pageTitle = "Edit Trip planning introduction";
				this.savedData = angular.copy(this.details.menuContentDetails);
			}
		}, {
			key: 'onCancel',
			value: function onCancel() {
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, false);

				if (isUpdated) {
					var _onSubmit = function _onSubmit() {
						this._redirectToHome();
					};

					this.modalService.open({
						details: {
							bodyMessage: 'Changes done will be reverted. Continue?'
						},
						buttons: [{
							name: 'No'
						}, {
							name: 'Yes',
							isPrimary: true,
							action: _onSubmit.bind(this)
						}]
					});
				} else {
					this._redirectToHome();
				}
			}
		}, {
			key: 'onSubmit',
			value: function onSubmit() {
				var _this = this;

				this.disableButtons = true;
				var isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, true);

				if (isUpdated) {
					this.tripPlanningService.editTripPlanningDetails(this.details.menuContentDetails).then(function (_) {
						_this.toastr.success('Data is updated successfully');
						_this.disableButtons = false;
					}).catch(function (err) {
						_this.toastr.error(err);
						_this.disableButtons = false;
					});
				} else {
					this.toastr.success('Nothing to update');
					this.disableButtons = false;
				}
			}
		}, {
			key: '_redirectToHome',
			value: function _redirectToHome() {
				this.$state.go('app.dashboard.DynamicMenus', {
					url: 'home-banner'
				});
			}
		}]);

		return TripPlanningComponent;
	}()
};

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tripPlanning = undefined;

var _tripPlanning = __webpack_require__(701);

var _tripPlanning2 = __webpack_require__(703);

var tripPlanning = exports.tripPlanning = angular.module('components.tripPlanning', []).service('TripPlanningService', _tripPlanning2.TripPlanningService).component('tripPlanning', _tripPlanning.tripPlanningComponent)
// .config(($stateProvider) => {
//     'ngInject';

//     $stateProvider
//         .state('app.dashboard.TripPlanning', {
//             url: '/trip-planning',
//             breadcrumbName: 'Trip Planning',
//             parentState: 'dashboard',
//             component: 'tripPlanning',
//             resolve: {
//                 details(TripPlanningService) {
//                     'ngInject';

//                     return TripPlanningService.getTripPlanningDetails();
//                 }
//             }
//         });
// })
.name;

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TripPlanningService = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(2);

var _find2 = _interopRequireDefault(_find);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TripPlanningService = exports.TripPlanningService = function () {
  TripPlanningService.$inject = ["$resource", "ApiService"];
  function TripPlanningService($resource, ApiService) {
    'ngInject';

    _classCallCheck(this, TripPlanningService);

    this.$resource = $resource;
    this.apiService = ApiService;

    this.tripPlanningResourceUrl = this.apiService.getResourceUrl('cms/menus/TripPlanning');
    this.editTripPlanningResourceUrl = this.apiService.getResourceUrl('cms/trip-planning');

    this.tripPlanningResource = this.$resource(this.tripPlanningResourceUrl);
    this.editTripPlanningResource = this.$resource(this.editTripPlanningResourceUrl, null, {
      update: {
        method: 'PUT'
      }
    });
  }

  _createClass(TripPlanningService, [{
    key: 'getTripPlanningDetails',
    value: function getTripPlanningDetails(details) {
      return { menuContentDetails: this._getContentDetails((0, _find2.default)(details.data.content, ['name', 'TripPlanning']).values[0]) };
    }
  }, {
    key: 'editTripPlanningDetails',
    value: function editTripPlanningDetails(details) {
      var _this = this;

      var promise = this.editTripPlanningResource.update(this._setContentDetails(details)).$promise;

      return promise.then(function (details) {
        return details;
      }).catch(function (err) {
        throw _this.apiService.getErrorMessage(err);
      });
    }
  }, {
    key: '_getContentDetails',
    value: function _getContentDetails(value) {
      return {
        id: value.content_id,
        description: value.description,
        images: this._getContentImagesObject(value.images) || [],
        videos: value.videos || []
      };
    }
  }, {
    key: '_getContentImagesObject',
    value: function _getContentImagesObject(values) {
      return values ? values.map(function (_ref) {
        var uuid = _ref.uuid;
        return { uuid: uuid, status: -1 };
      }) : [];
    }
  }, {
    key: '_setContentDetails',
    value: function _setContentDetails(value) {
      return {
        description: value.description,
        images: value.images || [],
        videos: value.videos || []
      };
    }
  }]);

  return TripPlanningService;
}();

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rootComponent = undefined;

var _root = __webpack_require__(801);

var _root2 = _interopRequireDefault(_root);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rootComponent = exports.rootComponent = {
  templateUrl: _root2.default
};

/***/ }),
/* 705 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/app-nav/app-nav-footer.html';
var html = "<footer class=\"navbar-fixed-bottom text-center\"> <div class=footer> <p>&copy; {{$ctrl.currentYear}} Rural Health Network of SCNY. All Rights Reserved</p> </div> </footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 706 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/app-nav/app-nav-header.html';
var html = "<header class=header> <div class=main-logo-div> <h1> <a class=logo-icon href=#> <img src=/./images/logo.png /> </a> </h1> <label for=toggle> <div class=\"menu-icon pull-right\"> <span class=icon-Menu></span> </div> </label> </div> <div class=search-nav-div> <div class=feature-title> <h2>{{$ctrl.activeMenuName}}</h2> </div> <div class=search-div> <div uib-dropdown class=admin-info> <div uib-dropdown-toggle class=dropdown-ul> <img src=/./images/profile-pic.png class=\"img-circle profile-pic\" alt={{$ctrl.user.first_name}} /> <span>{{$ctrl.user.first_name}} {{$ctrl.user.last_name}}</span> <i class=\"fa fa-sort-desc\" aria-hidden=true></i> </div> <ul uib-dropdown-menu role=menu class=dropdown-menu> <li ng-repeat=\"item in $ctrl.accountOptions\" ng-click=$ctrl.onOptionsClick(item)>{{item.title}}</li> </ul> </div> </div> </div> </header>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 707 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/app.html';
var html = "<div> <div ui-view></div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 708 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/address/address.html';
var html = "<div class=contact-info-address> <label>Address*</label> <div class=form-group> <input type=text class=form-control placeholder=\"Street Name\" ng-model=$ctrl.details.addressLine1 required/> </div> <div class=form-group> <input type=text class=form-control placeholder=\"Add optional details like room number, floor, landmark, etc\" ng-model=$ctrl.details.addressLine2 required/> </div> <div class=form-group> <input type=text class=form-control placeholder=State ng-model=$ctrl.details.stateName required/> </div> <div class=\"col-md-12 remove-padding\"> <div class=\"form-group col-md-6 remove-padding padding-right\"> <input type=text class=form-control placeholder=City ng-model=$ctrl.details.cityName required/> </div> <div class=\"form-group col-md-6 remove-padding\"> <input type=text ng-model=$ctrl.details.zipCode class=form-control placeholder=\"Zip Code\" minlength=4 maxlength=6 ng-trim=false input-validation required/> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 709 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/autocomplete/autocomplete.html';
var html = "<div class=tags> <div class=main-tag ng-click=$ctrl.onClick($event) ng-class=\"{'disableDiv' : $ctrl._isDisabled}\"> <tag items=$ctrl.tags on-remove=$ctrl._onTagRemove($event)></tag> <div class=autocomplete> <input type=text placeholder={{$ctrl.placeHolder}} id={{$ctrl.uniqIdForAutocompleteInput}} ng-model=$ctrl.searchText ng-keydown=$ctrl.onKeyDown($event) uib-typeahead=\"item as item.name for item in $ctrl._items | norepeat:$ctrl.tags:$ctrl.allowRepeat | filterAutocompleteItems:$viewValue\" class=\"form-control custom-input\" typeahead-no-results=$ctrl.isEmptyResult typeahead-on-select=$ctrl._onItemSelect($item) typeahead-template-url={{$ctrl.templateUrl}} typeahead-focus=true typeahead-focus-on-select=false ng-required=\"$ctrl.isRequired && $ctrl.tags.length==0\" ng-focus=\"$ctrl.isFocus=true\" ng-disabled=$ctrl._isDisabled ng-blur=$ctrl.resetSearchText()> </div> </div> </div> <div ng-if=\"$ctrl.isEmptyResult && $ctrl.items.length === $ctrl.tags.length && $ctrl.isFocus\"><span class=mismatch-pswd>No results to show</span></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 710 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/basic-info/basic-info.html';
var html = "<form ng-submit=\"$ctrl.onSubmit({$event: {basicInfo: $ctrl.details}})\" novalidate=novalidate name=emergencyContact autocomplete=off> <div class=basic-info> <div class=\"col-md-12 info-div\"> <div class=\"col-md-6 no-padding-left\"> <div class=form-padding> <div class=form-group> <label for=title>Title*</label> <character-count max-count=100 input=$ctrl.details.name> </character-count> <textarea id=title class=form-control rows=2 placeholder=\"Click to add title\" empty-text-validation ng-trim=false maxlength=100 ng-model=$ctrl.details.name required>\n                        </textarea> </div> </div> </div> <div class=\"col-md-6 no-padding-right\"> <upload-cover-pic page-name=\"call for help\" on-upload=$ctrl.onUpload($event) on-remove=$ctrl.onRemoveLogo() show-squre-photo=true heading-text=logo default-cover-pic={{$ctrl.details.image}} is-cover-photo-required=false> </upload-cover-pic> </div> </div> <div class=\"col-md-12 info-div\"> <div class=\"col-md-6 no-padding-left\" ng-if=$ctrl.details.serviceArea> <div class=form-padding> <div class=form-group> <label for=county>Select Service Area*</label> <autocomplete items=$ctrl.county default-selected=$ctrl.defaultCounties on-select-item=$ctrl.onSelectItem($item) on-remove-tag=$ctrl.onRemoveTag($event) is-disabled={{$ctrl.disableCounty}} is-required=true> </autocomplete> </div> </div> </div> <div class=no-padding-right ng-class=\"{'col-md-12 remove-padding': !$ctrl.details.serviceArea, 'col-md-6': $ctrl.details.serviceArea}\"> <div class=form-padding> <div class=form-group> <label for=email>Email</label> <character-count max-count=100 input=$ctrl.details.email> </character-count> <input type=text key=email id=email name=email class=form-control ng-trim=false maxlength=100 placeholder=\"Click to add email\" ng-model=$ctrl.details.email empty-text-validation input-validation/> </div> </div> </div> </div> <div class=\"col-md-12 info-div\"> <phone-template details=$ctrl.details.phone on-add=$ctrl.onAdd($event) on-delete=$ctrl.onDelete($event) hide-phone-purpose={{$ctrl.hidePhonePurpose}}> </phone-template> </div> <div class=\"col-md-12 info-div\"> <div class=form-padding> <div class=form-group> <label for=url>Web Address</label> <character-count max-count=200 input=$ctrl.details.url> </character-count> <input type=url id=url name=url class=form-control ng-trim=false maxlength=200 placeholder=\"Click to add website address\" ng-model=$ctrl.details.url empty-text-validation/> </div> </div> </div> </div> <form-buttons show-next-button={{$ctrl.showNextButton}} show-previous-button={{$ctrl.showPreviousButton}} show-submit-button={{!$ctrl.showNextButton}} on-cancel=$ctrl._onCancel() on-next=\"$ctrl.onNext({$event: {basicInfo: $ctrl.details}})\" disable-buttons=$ctrl.disableButtons />  </form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 711 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/breadcrumb/breadcrumb.html';
var html = "<section ng-if=\"$ctrl.breadcrumbs.length > 0\" id=breadcrumbs class=breadcrumbs ng-class=\"{'sidebar-open-breadcrumb': $ctrl.isSidebarOpen}\"> <div class=\"col-md-12 col-sm-12 col-xs-12\"> <a ui-sref=.dashboard> Dashboard </a> <div class=breadcrumbs-span> <span class=parent-span ng-repeat=\"page in $ctrl.breadcrumbs\"> <span class=child-span ng-if=!$last> <i class=\"fa fa-caret-right\" aria-hidden=true></i> <a ui-sref=app.dashboard.DynamicMenus({url:page.slug})>{{page.displayName}}</a> </span> <span class=child-span ng-if=$last> <i class=\"fa fa-caret-right\" aria-hidden=true></i> </span> <span class=child-span ng-if=$last> {{page.displayName}} </span> </span> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 712 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/character-count/character-count.html';
var html = "<span class=character-count>{{$ctrl.maxCount - $ctrl.input.length}} out of {{$ctrl.maxCount}} Characters left</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 713 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/checkbox-template1/checkbox-template1.html';
var html = "<div class=\"in-check form-group\"> <h2>{{$ctrl.title}}</h2> <input type=checkbox id=select-checkbox class=\"text-uppercase pull-right\" ng-model=$ctrl.selectCheckbox ng-click=$ctrl.onSelectCheckbox() /> <label for=select-checkbox class=\"text-uppercase pull-right select-checkbox-label\"> {{$ctrl.selectionText}} </label> </div> <ul class=checkbox-list> <li class=checkbox-li ng-repeat=\"option in $ctrl.options\" ng-class=\"{'selected-li': option.isSelected}\"> <div class=checkboxes> <div class=\"checkbox form-group\"> <input type=checkbox id={{option.displayName}} class=badgebox ng-change=\"$ctrl._onChange($event, option)\" ng-model=option.isSelected /> <span class=badge>&check;</span> <label for={{option.displayName}} class=\"btn btn-default text-uppercase\" ng-class=\"{'selected-label': option.isSelected}\">{{option.displayName}} </label> </div> </div> </li> </ul>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 714 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/checkbox/checkbox.html';
var html = "<div class=checkbox-section> <div class=\"in-check checkbox-options-list\"> <label for=info>{{$ctrl.title}}</label> </div> <ul class=checkbox-label-list> <li ng-repeat=\"option in $ctrl.options\"> <div class=checkboxes> <div class=\"checkbox form-group\"> <input ng-change=\"$ctrl._onChange($event, option)\" ng-model=option.isSelected type=checkbox class=form-control name=checkbox-{{$ctrl.name}} ng-disabled=\"$ctrl._isDisabled || option.isDisabled\" id=checkbox-option-{{$ctrl.name}}-{{$index+1}} /> <label for=checkbox-option-{{$ctrl.name}}-{{$index+1}} ng-class=\"{checkboxDisable: option.isDisabled}\" class=ng-binding>{{option.title}}</label> </div> </div> </li> </ul> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 715 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/content-sequence/content-sequence.html';
var html = "<div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12 content-sequence\"> <div class=seqncList> <h2>Drag & drop the following items to change their sequence</h2> <ol id=slippylist> <li ng-repeat=\"item in list\" class=demo-no-reorder> <div class=seqncContList> <h4> <span class=icon-Move></span> <span class=item-title>{{item.title}}</span> </h4> </div> </li> </ol> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 716 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/content-template/content-template.html';
var html = "<div class=content> <div class=menu-overview ng-if=$ctrl._isOverviewExist> <display-overview details=$ctrl.details.menuOverviewDetails slug-url={{$ctrl.slugUrl}}> </display-overview> </div> <section class=\"overview-template min-height-section\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title remove-margin\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.details.pageTitle}}</h2> </div> </div> <editor details=$ctrl.details.menuContentDetails on-submit=$ctrl.onSubmit() on-cancel=$ctrl.onCancel() disable-buttons=$ctrl.disableButtons> </editor> </section> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 717 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/datepicker/datepicker.html';
var html = "<div class=\"time-content main-date-picker\"> <div class=form-group> <label for=comment>{{$ctrl.details.title}}</label> </div> <div class=tid-vdm> <div class=\"form-group col-md-5 col-sm-5 col-lg-5 col-xs-5 name-div\" ng-if=!$ctrl.details.range ng-click=$ctrl.open()> <div class=input-clock> <h4 ng-if=!$ctrl.details.selectedDate>{{$ctrl.details.dateTitle || 'Select date'}}</h4> <h4 ng-if=$ctrl.details.selectedDate>{{$ctrl.details.selectedDate | date:'mediumDate'}}</h4> </div> <div class=clock> </div> <input type=hidden name=selectedDate ng-model=$ctrl.details.selectedDate ng-required=$ctrl.details.isRequired required-err-type=dateRequired /> <div uib-datepicker-popup datepicker-options=$ctrl.datepickerOptions ng-model=$ctrl.details.selectedDate is-open=$ctrl.opened ng-disabled=$ctrl.details.disableDate popup-placement=bottom-left class=\"col-md-6 endDatepicker1\"> </div> </div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 718 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/days-of-operation/days-of-operation.html';
var html = "<div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 days-of-operation\"> <h4 class=text-capitalize>days <span class=text-lowercase>of</span> operation</h4> <ul> <li ng-class=\"$ctrl._getClass('monday')\">M</li> <li ng-class=\"$ctrl._getClass('tuesday')\">T</li> <li ng-class=\"$ctrl._getClass('wednesday')\">W</li> <li ng-class=\"$ctrl._getClass('thursday')\">T</li> <li ng-class=\"$ctrl._getClass('friday')\">F</li> <li ng-class=\"$ctrl._getClass('saturday')\">S</li> <li ng-class=\"$ctrl._getClass('sunday')\">S</li> </ul> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 719 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/display-cover-pic/display-cover-pic.html';
var html = "<div class=item-image> <img ng-image-load={{$ctrl.coverPicUrl}} default-image-key=coverPic class=img-responsive /> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 720 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/display-overview/display-overview.html';
var html = "<section class=display-overview-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 overview no-padding\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>Overview</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <a ng-click=$ctrl.routeOveriviewPageUrl()> <span class=icon-Edit></span> </a> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 overview no-padding\"> <h3 class=text-capitalize>{{$ctrl.details.title}}</h3> <p>{{$ctrl.details.overview || $ctrl.details.description}}</p> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 721 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/display-square-pic/display-square-pic.html';
var html = "<div class=item-image> <img ng-image-load={{$ctrl.coverPicUrl}} default-image-key=coverPic class=img-responsive /> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 722 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/editor/editor-image-upload-modal/editor-image-upload-modal.html';
var html = "<div class=editor-image-upload-modal> <div class=modal-header> <h4 class=modal-title id=modal-title>Add Image</h4> <span class=icon-Close ng-click=$ctrl.close()></span> </div> <div class=tab-options> <ul ng-if=!$ctrl.isEditOptionEnabled> <li ng-repeat=\"tab in $ctrl.tabOptions\" ng-class=\"{'selected-tab': tab.isSelected,'unselected-tab': !tab.isSelected}\" ng-click=$ctrl.onChangeTab(tab)> {{tab.name}} <span ng-if=\"tab.name === 'image library'\">({{$ctrl.totalNumberOfImages}})</span> </li> </ul> <span class=edit ng-if=\"$ctrl.selectedTab.name === 'image library' && $ctrl.images.length !== 0 && !$ctrl.isEditOptionEnabled\" ng-click=$ctrl.onChangeEdit()> edit </span> <span class=delete-text ng-if=$ctrl.isEditOptionEnabled>Delete Image</span> </div> <div class=modal-body> <div class=loader ng-if=$ctrl.showLoader> <div class=loader-img> <img src=/./images/loader.svg alt=...> </div> </div> <div class=uploaded-image ng-if=\"$ctrl.selectedTab.name === 'upload image' && $ctrl.showUploadedImage\"> <div class=images> <div class=image> <img class=\"uploaded-img select\" ng-src={{$ctrl.getImageSrcPath($ctrl.selectedImageUuid)}}> <span class=delete-uploaded-image ng-click=$ctrl.onDeleteImage()>delete image</span> <div class=\"select-delete-image select\"> <img src=/./images/tick_white.png alt=selected> </div> </div> </div> </div> <div class=upload ng-if=\"$ctrl.selectedTab.name === 'upload image' && !$ctrl.showUploadedImage && !$ctrl.showLoader\"> <div class=upload-option> <span>Select image to upload</span> <button type=submit ngf-change=\"$ctrl.onChangeFile($files, $file)\" ngf-select accept=image/* ng-model=$ctrl.selectedImage ng-disabled=$ctrl.isBrowseDisabled class=\"btn upload-btn text-uppercase\"> select image </button> </div> </div> <div class=library ng-if=\"$ctrl.selectedTab.name === 'image library'\"> <p ng-if=\"$ctrl.images.length === 0\"> No Images Available. </p> <div class=images> <div class=image ng-repeat=\"image in $ctrl.images\" ng-if=\"image.status !== 2\"> <img class=uploaded-img ng-class=\"{'select': !$ctrl.isEditOptionEnabled && $ctrl.selectedImageUuid===image.uuid,'delete': $ctrl.isEditOptionEnabled && image.isSelected}\" ng-src={{$ctrl.getImageSrcPath(image.uuid)}} ng-click=$ctrl.onSelectImage(image.uuid)> <div class=select-delete-image ng-class=\"{'select': !$ctrl.isEditOptionEnabled && $ctrl.selectedImageUuid===image.uuid,'delete': image.isSelected}\"> <img src=/./images/tick_white.png alt=selected> </div> </div> </div> </div> </div> <div class=modal-footer> <button ng-click=$ctrl.onCancel() type=button class=\"btn cancel\"> Cancel </button> <button ng-if=\"!$ctrl.isEditOptionEnabled && $ctrl.selectedTab.name !== 'upload image'\" type=submit ng-click=$ctrl.onSubmit() class=\"btn submit\" ng-disabled=$ctrl.disableButtons> Add Image </button> <button ng-if=$ctrl.isEditOptionEnabled type=submit ng-click=$ctrl.onDeleteImage() class=\"btn delete\" ng-disabled=$ctrl.disableButtons> delete </button> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 723 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/editor/editor-video-link-modal/editor-video-link-modal.html';
var html = "<div class=editor-video-link-modal> <div class=modal-header> <h4 class=modal-title id=modal-title>Add Video</h4> <span class=icon-Close ng-click=$ctrl.close()></span> </div> <div class=tab-options> <ul ng-if=!$ctrl.isEditOptionEnabled> <li ng-repeat=\"tab in $ctrl.tabOptions\" ng-class=\"{'selected-tab': tab.isSelected,'unselected-tab': !tab.isSelected}\" ng-click=$ctrl.onChangeTab(tab)> {{tab.name}} <span ng-if=\"tab.name === 'video library'\">({{$ctrl.videos.length}})</span> </li> </ul> <span class=edit ng-if=\"$ctrl.selectedTab.name === 'video library' && $ctrl.videos.length !== 0 && !$ctrl.isEditOptionEnabled\" ng-click=$ctrl.onChangeEdit()> edit </span> <span class=delete-text ng-if=$ctrl.isEditOptionEnabled>Delete Video</span> </div> <div class=modal-body> <div class=uploaded-video ng-if=\"$ctrl.selectedTab.name === 'upload video' && $ctrl.showUploadedVideo\"> <div class=videos> <div class=video> <div class=\"iframe-div select\"> <iframe width=215 height=119 ng-src={{$ctrl.$sce.trustAsResourceUrl($ctrl.selectedLink)}} frameborder=0 allowfullscreen=\"\"></iframe> <div class=overlay> </div> </div> <span class=delete-uploaded-video ng-click=$ctrl.onDeleteVideo()>delete video</span> <div class=\"select-delete-video select\"> <img src=/./images/tick_white.png alt=selected> </div> </div> </div> </div> <div class=upload ng-if=\"$ctrl.selectedTab.name === 'upload video' && !$ctrl.showUploadedVideo\"> <div class=upload-option> <form ng-submit=$ctrl.onInsertVideo() novalidate=novalidate> <label for=video-link>Video Url</label> <div class=form-group> <input type=url ng-model=$ctrl.selectedLink class=form-control placeholder=\"Paste video url here\" required> </div> <div class=error ng-if=$ctrl.invalidVideoLink>Invalid link, Please select only Youtube or Vimeo Link or Link is already exist</div> <div class=link-button> <input type=submit class=\"btn link-btn\" value=\"link video\"> </div> </form> </div> </div> <div class=library ng-if=\"$ctrl.selectedTab.name === 'video library'\"> <p ng-if=\"$ctrl.videos.length === 0\"> No Videos Available. </p> <div class=videos> <div class=video ng-repeat=\"video in $ctrl.videos\"> <div class=iframe-div ng-class=\"{'select': !$ctrl.isEditOptionEnabled && $ctrl.selectedLink===video.link,'delete': $ctrl.isEditOptionEnabled && video.isSelected}\"> <iframe width=215 height=119 ng-src={{$ctrl.$sce.trustAsResourceUrl(video.link)}} frameborder=0 allowfullscreen=\"\"></iframe> <div class=overlay ng-click=$ctrl.onSelectLink(video.link)> </div> </div> <div class=select-delete-video ng-class=\"{'select': !$ctrl.isEditOptionEnabled && $ctrl.selectedLink===video.link,'delete': $ctrl.isEditOptionEnabled && video.isSelected}\"> <img src=/./images/tick_white.png alt=selected> </div> </div> </div> </div> </div> <div class=modal-footer> <button ng-click=$ctrl.onCancel() type=button class=\"btn cancel\"> Cancel </button> <button ng-if=\"!$ctrl.isEditOptionEnabled && $ctrl.selectedTab.name !== 'upload video'\" type=submit ng-click=$ctrl.onSubmit() class=\"btn submit\" ng-disabled=$ctrl.disableButtons> add video </button> <button ng-if=$ctrl.isEditOptionEnabled type=submit ng-click=$ctrl.onDeleteVideo() class=\"btn delete\" ng-disabled=$ctrl.disableButtons> delete </button> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 724 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/editor/editor.html';
var html = "<div class=editor> <div class=col-md-12> <form novalidate=novalidate name=overviewTemplate> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 content-div remove-padding\"> <div class=form-padding> <div class=form-group> <label for=time>{{$ctrl.pageTitle}}*</label> <textarea ng-model=$ctrl.details.description class=form-control rows=8 cols=66 id=editor ng-change=$ctrl.onChange() required>\n                        </textarea> </div> </div> <div class=error ng-if=$ctrl._editorFieldError>This field is required</div> </div> <div class=clear></div> <div class=\"col-md-12 edit-footer remove-padding\" ng-if=$ctrl._showFooterButtons> <div class=\"footer-button text-right\"> <button ng-click=$ctrl.onCancel() type=button class=\"btn cancel\" ng-disabled=$ctrl.disableButtons> Cancel </button> <button type=submit ng-click=$ctrl._onSubmit() class=\"btn submit\" ng-disabled=$ctrl.disableButtons> Save </button> </div> <div class=clear></div> </div> <div class=clear></div> </form> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 725 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/feature-main-page-template/feature-main-page-template.html';
var html = "<div class=transportation-alternative-list> <display-overview details=$ctrl.details.overview on-edit=$ctrl.onEditOverview() slug-url={{$ctrl.slugUrl}}> </display-overview> <section class=transportation-alternatives-section ng-class=\"{'sub-menu-list': $ctrl.isSubMenu}\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 transportation-alternatives\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.details.pageTitle}}</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <a ng-click=$ctrl.routeSequencePageUrl()> <span class=text-uppercase ng-class=\"{'single-button': $ctrl.isSubMenu}\">edit sequence</span> </a> <a ng-click=$ctrl.routePublishPageUrl()> <span class=text-uppercase ng-if=!$ctrl.isSubMenu>publish status</span> </a> <button ng-if=$ctrl.showAddNewMenuButton class=\"submit-btn text-uppercase add-new-menu-button\" ng-click=$ctrl.openNewMenuAddModal()>add new</button> </div> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item\" ng-repeat=\"item in $ctrl.details.list\"> <div class=\"col-md-10 col-xs-10 col-sm-10 col-lg-10 title-desc\"> <h2>{{item.title}}</h2> <p>{{item.overview || 'NA'}}</p> </div> <div class=\"col-md-2 col-xs-2 col-sm-2 col-lg-2 text-right view-btn\"> <a ui-sref=app.dashboard.DynamicMenus({url:item.slug})> <span class=icon-View></span> </a> </div> </div> </div> </section> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 726 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/feature-main-page-template/new-menu-add/new-menu-add.html';
var html = "<div class=new-menu-add-modal> <form novalidate=novalidate ng-submit=$ctrl.onSubmit()> <div class=new-menu-modal_header> <div class=title> <span>Add New Menu</span> </div> <div class=close_modal ng-click=$ctrl.close()> <span>X</span> </div> </div> <div class=new-menu-modal_body> <overview-template details=$ctrl.details disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.close() on-submit=$ctrl.onSubmit() is-description-available={{true}}> </overview-template> </div> <div class=new-menu-modal_footer> </div> </form> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 727 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/form-buttons/form-buttons.html';
var html = "<div class=\"col-md-12 edit-footer\"> <div class=\"footer-button text-right\"> <button ng-if=$ctrl.details.displayCancelButton ng-click=$ctrl.onCancel() type=button class=\"btn cancel\" ng-disabled=$ctrl.disableButtons> Cancel </button> <button type=button class=\"btn cancel previous-btn\" ng-if=$ctrl.details.displayPreviousButton ng-click=$ctrl.onPrevious()> Previous </button> <button type=submit ng-click=$ctrl.onSavePublish() class=\"btn submit save-publish\" ng-disabled=$ctrl.disableButtons ng-if=$ctrl.details.displaySavePublishButton> Save &amp; Publish </button> <button type=button ng-click=$ctrl.onSavePublish() class=\"btn submit save-publish\" ng-disabled=$ctrl.disableButtons ng-if=$ctrl.details.displaySavePublishTypeButton> Save &amp; Publish </button> <button type=submit ng-click=$ctrl.onSubmit() class=\"btn submit\" ng-disabled=$ctrl.disableButtons ng-if=$ctrl.details.displaySubmitButton> Save </button> <button type=button ng-click=$ctrl.onRepublish() class=\"btn submit\" ng-disabled=$ctrl.disableButtons ng-if=$ctrl.showRepublishButton> Republish </button> <button type=submit class=\"btn submit\" ng-click=$ctrl.onNext() ng-if=$ctrl.details.displayNextButton> Next </button> </div> <div class=clear></div> </div> <div class=clear></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 728 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/google-location/google-location.html';
var html = "<div class=\"form-group contForm phone-div location-text-input\"> <input type=text id=location class=form-control ng-change=$ctrl.onLocationChange() ng-class=\"{'error-input': $ctrl._isError}\" placeholder=\"Enter Service Area\" ng-model=$ctrl.locationName ng-disabled=$ctrl._isDisabledLocation ng-required=$ctrl._isRequired /> <span class=clear-input ng-click=$ctrl.clearLocationInput() ng-if=$ctrl._isDisabledLocation>X</span> <p ng-if=$ctrl._isError class=error>Invalid location: address should have at least county</p> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 729 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/modal/modal-window.html';
var html = "<div class=\"modal-dialog common-dialog {{size ? 'modal-' + size : 'image-crop'}}\"><div class=modal-content uib-modal-transclude></div></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 730 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/modal/modal.html';
var html = "<div ng-if=$ctrl.resolve.details.title class=modal-header> {{$ctrl.resolve.details.title}} </div> <div class=modal-body> <p>{{$ctrl.resolve.details.bodyMessage}}</p> </div> <div class=modal-footer> <button ng-repeat=\"button in $ctrl.resolve.buttons\" ng-click=$ctrl.buttonClick(button) class=btn ng-class=\"{'cancel-btn': !button.isPrimary, 'submit-btn': button.isPrimary === true}\">{{button.name}}</button> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 731 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/operation-info/operation-info.html';
var html = "<form ng-submit=$ctrl._onSubmit() novalidate=novalidate name=operationInfoForm autocomplete=off> <div class=\"col-md-12 operational-info\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 days-of-operation\"> <div> <checkbox-template1 title=\"Days of Operation*\" options=$ctrl.daysOfOperation on-change=$ctrl.onChange($event) is-disabled=$ctrl.isDisabled> </checkbox-template1> <span class=error>{{$ctrl.errorMsg}}</span> </div> </div> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 hours-of-operation\"> <h2>Hours of Operation*</h2> <div class=form-padding> <div class=form-group> <label for=all-day-checkbox class=\"pull-right text-uppercase\"> <input type=checkbox id=all-day-checkbox class=\"badgebox form-control\" ng-model=$ctrl.details.hoursOfOperation.isAllDay ng-click=$ctrl.onAllDayCheckboxSelected() /> <span class=badge>&check;</span> all day </label> </div> </div> <timepicker details=$ctrl.hoursOfOperation></timepicker> </div> <form-buttons show-next-button={{$ctrl._showNextButton}} show-previous-button={{$ctrl._showPreviousButton}} on-previous=\"$ctrl.onPrevious({$event: {operationInfo: $ctrl.details}})\" show-submit-button={{!$ctrl._showNextButton}} on-cancel=$ctrl._onCancel() disable-buttons=$ctrl.disableButtons />  </div> </form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 732 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/other-info/other-info.html';
var html = "<form ng-submit=$ctrl._onSubmit() novalidate=novalidate name=otherInfoForm autocomplete=off> <div class=\"col-md-12 other-info\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 fees\"> <div class=form-padding> <div class=form-group> <label for=fees>Fees*</label> <character-count max-count=200 input=$ctrl.details.fees> </character-count> <textarea id=fees class=form-control rows=2 placeholder=\"Click to add fees\" ng-model=$ctrl.details.fees ng-trim=false maxlength=200 empty-text-validation required>\n                    </textarea> </div> </div> </div> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 payment-methods\"> <div class=form-padding> <div class=form-group> <label for=fees>Methods of Payment*</label> <autocomplete items=$ctrl.paymentMethodsList default-selected=$ctrl.defaultPaymentMethod on-select-item=$ctrl.onSelectItem($item) on-remove-tag=$ctrl.onRemoveTag($event) is-disabled={{$ctrl.disablePaymentMethod}} is-required=true> </autocomplete> </div> </div> </div> <div class=\"col-md-12 note\"> <div class=form-padding> <div class=form-group> <label for=fees>Notes</label> <character-count max-count=2000 input=$ctrl.details.notes> </character-count> <textarea id=fees class=form-control rows=2 placeholder=\"Click to add note\" ng-model=$ctrl.details.notes ng-trim=false maxlength=2000 empty-text-validation>\n                    </textarea> </div> </div> </div> </div> <form-buttons show-next-button={{$ctrl._showNextButton}} show-previous-button={{$ctrl.showPreviousButton}} on-previous=\"$ctrl.onPrevious({$event: {otherInfo: $ctrl.details}})\" show-submit-button={{!$ctrl._showNextButton}} on-cancel=$ctrl._onCancel() on-next=$ctrl.onNext() disable-buttons=$ctrl.disableButtons />  </form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 733 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/overview-template/overview-template.html';
var html = "<section class=\"overview-template min-height-section\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.details.pageTitle}}</h2> </div> </div> <div class=col-md-12> <form ng-submit=$ctrl.onSubmit() novalidate=novalidate name=overviewTemplate> <div class=overview-edit-content> <div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12\" ng-class=\"{'display-cover-pic': !$ctrl.displayCoverPic}\"> <div class=form-padding> <div class=form-group> <label for=title>Title*</label> <character-count max-count=100 input=$ctrl.details.title> </character-count> <input type=text id=title name=title class=form-control empty-text-validation placeholder=\"Click to add title\" ng-model=$ctrl.details.title ng-trim=false maxlength=100 required/> </div> </div> <div class=form-padding ng-if=!$ctrl.displayCoverPic> <div class=form-group> <label for=description>Overview*</label> <character-count max-count={{$ctrl.maxOverviewCharacterCount}} input=$ctrl.details.overview> </character-count> <textarea id=description class=form-control rows=3 placeholder=\"Click to add overview\" ng-model=$ctrl.details.overview empty-text-validation ng-trim=false maxlength={{$ctrl.maxOverviewCharacterCount}} required>\n                            </textarea> </div> </div> <div class=form-padding ng-if=$ctrl._isDescriptionAvailable> <div class=form-group> <label for=description>Description*</label> <character-count max-count={{$ctrl.maxDescriptionCharacterCount}} input=$ctrl.details.description> </character-count> <textarea id=description class=form-control rows=3 placeholder=\"Click to add description\" ng-model=$ctrl.details.description empty-text-validation ng-trim=false maxlength={{$ctrl.maxDescriptionCharacterCount}} required>\n                            </textarea> </div> </div> </div> <div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12\" ng-if=$ctrl.displayCoverPic> <div class=cover-photo-area> <upload-cover-pic page-name={{$ctrl.pageName}} on-upload=$ctrl._onCoverPicUpload($event) on-remove=$ctrl.onRemoveCoverPic() heading-text=\"cover picture*\" default-cover-pic={{$ctrl.details.image}} is-cover-photo-required=true> </upload-cover-pic> </div> </div> <div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12 button-content\" ng-if=$ctrl.displayCoverPic> <div class=form-padding> <div class=form-group> <label for=buttonText class=text-capitalize>ADA text</label> <character-count max-count=50 input=$ctrl.details.ada.ada_image_text> </character-count> <input type=text id=buttonText name=buttonText class=form-control empty-text-validation ng-trim=false maxlength=50 placeholder=\"Click to add ada text\" ng-model=$ctrl.details.ada.overview_image_text /> </div> </div> </div> </div> <div class=clear></div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 734 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/page-content-count/page-content-count.html';
var html = "<span> {{ $ctrl.currentTotalItems }} of {{ $ctrl.totalItems }} </span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 735 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/page-status/page-status.html';
var html = "<div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12 content-sequence\"> <div class=seqncList> <h2>Please Check the tabs to Published the Content</h2> </div> <ul class=list> <li ng-repeat=\"item in $ctrl.list\"> <div class=\"form-group li-div\"> <div> <input type=checkbox id={{item.name}} class=badgebox ng-model=item.isActive ng-change=\"$ctrl.onChange({'$event': $ctrl.list})\"/> <span class=badge>&check;</span> </div> <label for={{item.name}} ng-class=\"{'selected-li': item.isActive}\"> <span>{{item.title}}</span> <div class=\"li-status pull-right\"> <p class=text-capitalize>status</p> <span ng-if=item.isActive ng-class=\"{'publish-li': item.isActive}\">Published</span> <span ng-if=!item.isActive ng-class=\"{'unpublish-li': item.isActive}\">Unpublished</span> </div> </label> </div> </li> </ul> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 736 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/pagination/pagination.html';
var html = "<nav aria-label=\"Page navigation\" class=pagi> <ul uib-pagination total-items=$ctrl.totalItems items-per-page=$ctrl.itemPerPage ng-change=$ctrl._onChange() ng-model=$ctrl.currentPage max-size=$ctrl.maxSize class=pagination-sm boundary-link-numbers=true> </ul> </nav> <div class=clear></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 737 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/phone-template/phone-template.html';
var html = "<div class=phone-template> <div class=heading> <p class=pull-left> Phone Number* </p> <a href=\"\" ng-click=$ctrl.onAdd() class=pull-right>ADD NEW</a> </div> <form> <div class=\"col-md-12 no-padding striped-div\"> <div class=phone-main ng-repeat=\"item in $ctrl.details track by $index\"> <div class=\"col-md-5 no-padding-left\" ng-if=\"$ctrl.hidePhonePurpose === 'false'\"> <div class=form-padding> <div class=form-group> <label for=purpose>Purpose</label> <input type=text id=purpose_{{$index}} class=form-control placeholder=\"Click to add purpose\" ng-trim=false maxlength=100 ng-model=item.name ng-init=\"$ctrl.onFocus('purpose',$index)\" empty-text-validation required/> </div> </div> </div> <div class=\"col-md-4 no-padding-right\" ng-class=\"{'no-padding-left': $ctrl.hidePhonePurpose === 'true'}\"> <div class=form-padding> <div class=form-group> <label for=phone>Phone Number</label> <input type=text id=phone_number_{{$index}} name=phone class=form-control placeholder=\"Click to add Number\" ng-model=item.number minlength=3 maxlength=20 ng-init=\"$ctrl.onFocus('phone_number',$index)\" input-validation required/> </div> </div> </div> <div class=\"col-md-2 no-padding-right\"> <div class=form-padding> <div class=form-group> <label for=ext>Ext</label> <input type=text name=ext class=form-control placeholder=\"Click to add ext\" ng-model=item.extn maxlength=4 input-validation/> </div> </div> </div> <div class=\"col-md-1 no-padding-right text-center delete-item\" ng-click=\"$ctrl.onDelete({$event: $index})\" ng-if=\"$index !== 0\"> <span class=\"icon-Delete icons-style\"></span> </div> </div> </div> </form></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 738 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/radio-buttons/radio-buttons.html';
var html = "<div class=\"form-group list-group\"> <label for=info>{{$ctrl.title}}</label> <ul class=radio-list> <li ng-repeat=\"option in $ctrl.options\"> <div class=radio ng-class=\"{'disabled-radio-button':option.disabled}\"> <input ng-change=$ctrl._onChange($event) id=radio-option-{{$ctrl.name}}-{{$index+1}} ng-model=$ctrl.defaultSelectedOptionId value={{option.id}} type=radio class=form-control name=radio{{$ctrl.name}} ng-disabled=option.disabled ng-required=$ctrl._isRequired /> <label for=radio-option-{{$ctrl.name}}-{{$index+1}}>{{option.title}}</label> <span class=option-value ng-if=option.value>{{option.value}}</span> </div> </li> </ul> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 739 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/report-repository/report-repository-detail/report-repository-detail.html';
var html = "<section class=reports-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 no-padding\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>Details</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <button type=button class=\"btn go-back text-uppercase\" ng-click=$ctrl.onGoBack()>go back</button> <span class=\"icons icon-Edit\" ng-click=\"$ctrl.onEdit({$event: $ctrl.details.id})\"></span> </div> </div> <div class=clearfix></div> <div class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 no-padding-left logo-div\"> <img ng-src={{$ctrl.details.image}}> </div> <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10 report-details-item no-padding\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 title item no-padding\"> <h1>{{$ctrl.details.title}}</h1> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 item no-padding\" ng-if=!$ctrl._isShortDetails> <div class=\"col-md-4 col-sm-4 col-xs-4 col-lg-4 no-padding\"> <h3>county</h3> <p>{{$ctrl.details.serviceAreaName}}</p> </div> <div class=\"col-md-4 col-sm-4 col-xs-4 col-lg-4 no-padding\"> <h3>Program Year</h3> <p>{{$ctrl.details.from}}</p> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 no-padding item button-view\"> <a class=\"view-btn text-uppercase\" ng-href={{$ctrl.details.url}} target=_blank>view pdf</a> </div> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 740 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/report-repository/report-repository-list/report-repository-list.html';
var html = "<div class=progress-reports> <display-overview details=$ctrl.details.overview slug-url={{$ctrl.slugUrl}} on-edit=$ctrl.onEditOverview()> </display-overview> <section class=progress-reports-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 progress-reports-list\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.details.pageTitle}}</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <button class=\"submit-btn text-uppercase\" ng-click=$ctrl.routeAddPageUrl()>add new</button> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 no-results-found\" ng-if=\"$ctrl.details.list.length === 0\"> <p>No results found!</p> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item\" ng-repeat=\"item in $ctrl.details.list\"> <div class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 logo-div\"> <img src={{item.image}}> </div> <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10 title-btns\"> <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10 title desc\"> <h3>{{item.title}}</h3> </div> <div class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 text-right item-btns\"> <a ng-click=$ctrl.routeDetailsPageUrl(item.slug)> <span class=\"icons icon-View\"></span> </a> <a ng-click=$ctrl.routeEditPageUrl(item.slug)> <span class=\"icons icon-Edit\"></span> </a> <a> <span class=\"icons icon-Delete\" ng-click=\"$ctrl.onDelete({$event: item.slug})\"></span> </a> </div> </div> </div> </div> </section> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 741 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/report-repository/report-repository.html';
var html = " <section class=progress-reports-template> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 progress-reports-add-edit no-padding\"> <form ng-submit=\"$ctrl.onSubmit({$event: $ctrl.details})\" novalidate=novalidate name=progressReportsTemplate> <div class=progress-reports-edit-content> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 main-content\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 title-desc\"> <div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12 title-dropdown\"> <div class=form-padding> <div class=form-group> <label for=title class=text-capitalize>title*</label> <character-count max-count=100 input=$ctrl.details.title> </character-count> <input type=text id=title name=title class=form-control placeholder=\"Click to add title\" ng-model=$ctrl.details.title empty-text-validation ng-trim=false maxlength=100 required/> </div> </div> <div class=form-padding ng-if=!$ctrl._isShortDetails> <select-dropdown list=$ctrl.programYears label-text=\"Select program year\" default-option=\"Select program year\" is-option-disabled=true selected-id=$ctrl.details.selectedProgramYearId on-change=$ctrl.onChangeProgramYear($event)> </select-dropdown> </div> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 dropdown-file-upload\" ng-class=\"{'col-md-12 col-lg-12 col-sm-12 col-xs-12 no-county-dropdown': $ctrl._isShortDetails}\"> <div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 county-dropdown\" ng-if=!$ctrl._isShortDetails> <div class=form-padding> <select-dropdown list=$ctrl.serviceAreaList label-text=\"Select county\" default-option=\"Select county\" is-option-disabled=true selected-id=$ctrl.details.selectedServiceAreaId on-change=$ctrl.onChangeCounty($event)> </select-dropdown> </div> </div> <div class=\"col-sm-12 col-xs-12 file-upload\" ng-class=\"{'upload-file-only': $ctrl._isShortDetails, 'col-md-6 col-lg-6': !$ctrl._isShortDetails,'col-md-12 col-lg-12':$ctrl._isShortDetails}\"> <div class=form-padding> <div class=form-group> <label for=progress-report class=text-capitalize>upload report*</label> <div class=file-wrap> <span class=\"text text-uppercase text-center\" ng-class=\"{'file-name': $ctrl.fileName !== 'BROWSE'}\">{{$ctrl.fileName}}</span> <input class=form-control id=progress-report type=file ngf-change=$ctrl.onFileChange($file) ngf-select ng-model=$ctrl.file ngf-pattern=\"'application/pdf'\" ngf-accept=\"'.pdf'\" ngf-max-size=20MB name=ReportsFile ng-if=!$ctrl.file ng-required=$ctrl.isPdfRequired /> <span class=\"icon-Delete delete-icon\" ng-if=\"$ctrl.fileName !== 'BROWSE'\" ng-click=$ctrl.onDelete()></span> </div> </div> </div> </div> </div> </div> </div> <div class=clear></div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=\"$ctrl.onCancel({$event: $ctrl.details})\"> </form-buttons> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 742 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/search-box/search-box.html';
var html = "<form> <div class=\"search-input form-group\"> <input type=search name=search ng-model=$ctrl.searchKey ng-change=$ctrl._onSearch() id=search placeholder={{$ctrl.placeholder}} empty-text-validation> <input type=image src=/./images/search-icon.png class=search-button alt=Submit> </div> </form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 743 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/select-dropdown/select-dropdown.html';
var html = "<div class=form-padding> <div class=form-group> <label for=year>{{$ctrl.labelText ? $ctrl.labelText + '*' : ''}}</label> <div class=select-wrapper> <select class=\"form-control select-wrapper\" id=year ng-model=$ctrl.selectedId ng-options=\"item.id as item.name for item in $ctrl.list\" ng-change=\"$ctrl.onChange({$event: $ctrl.selectedId})\" required> <option value=\"\" ng-disabled=$ctrl.isDisabled ng-if=$ctrl.defaultOption>{{$ctrl.defaultOption}}</option> </select> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 744 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/service-info/service-info.html';
var html = "<form ng-submit=$ctrl._onSubmit() novalidate=novalidate name=serviceInfoForm autocomplete=off> <div class=\"col-md-12 service-info\"> <div class=\"col-md-12 no-padding-left\"> <div class=form-padding> <div class=form-group> <label for=county>Select Service Type*</label> <autocomplete items=$ctrl.serviceTypeList default-selected=$ctrl.defaultServiceTypes on-select-item=$ctrl.onSelectItem($item) on-remove-tag=$ctrl.onRemoveTag($event) is-required=true> </autocomplete> </div> </div> <div class=\"form-padding check-destination-checkbox\"> <div class=form-group> <checkbox title=\"\" options=$ctrl.isCheckedDestinationForServiceAreaOption> </checkbox> </div> </div> </div> <div class=\"col-md-12 no-padding-left\"> <div class=form-padding> <div class=form-group> <label for=county>Select Service Area*</label> <autocomplete items=$ctrl.serviceAreas default-selected=$ctrl.defaultServiceAreas on-select-item=$ctrl.onSelectServiceArea($item) on-remove-tag=$ctrl.onRemoveServiceAreaTag($event) is-required=true> </autocomplete> </div> </div> </div> <div class=\"col-md-6 radio-buttons remove-padding\"> <radio-buttons title=Cost options=$ctrl.costingOptions on-change=$ctrl.onChangeCosting($event) default-selected-option-id={{$ctrl.defaultSelectedCostingOptionId}}> </radio-buttons> <radio-buttons title=\"Support Medicaid?\" options=$ctrl.options on-change=$ctrl.onChangeMedicaid($event) default-selected-option-id={{$ctrl.defaultSelectedMedicaidOptionId}}> </radio-buttons> <radio-buttons title=\"Support Veterans?\" options=$ctrl.options on-change=$ctrl.onChangeVeteran($event) default-selected-option-id={{$ctrl.defaultSelectedVeteranOptionId}}> </radio-buttons> </div> <div class=col-md-6> <checkbox title=\"Supported Special Requirements\" options=$ctrl.details.serviceInfo.specialRequirements> </checkbox> </div> <form-buttons show-next-button={{$ctrl._showNextButton}} show-previous-button={{$ctrl._showPreviousButton}} on-previous=\"$ctrl.onPrevious({$event: {serviceInfo: $ctrl.details.serviceInfo}})\" show-submit-button={{!$ctrl._showNextButton}} on-cancel=$ctrl._onCancel() disable-buttons=$ctrl.disableButtons />  </div> </form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 745 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/sidebar/sidebar.html';
var html = "<div class=\"main-container pull-left\"> <div class=\"toggle-container pull-left\" id=main-content> <div class=\"main-content-area pull-left\"> <input id=toggle type=checkbox ng-model=$ctrl.isSidebarOpen> <div class=\"col-md-3 col-lg-3 col-xs-12 col-sm-12 leftpanel\"> <div class=sidebar-open> <ul class=dashboard-list> <li ng-repeat=\"item in $ctrl.list.menuList1\" ui-sref=app.dashboard.DynamicMenus({url:item.slug}) ng-class=\"{active: $ctrl.isMenuActive(item.name)}\"> <span ng-class=item.icon></span> <a class=text-capitalize>{{item.displayName}}</a> </li> </ul> <ul class=other-list> <li ng-repeat=\"item in $ctrl.list.menuList2\" ui-sref=app.dashboard.DynamicMenus({url:item.slug}) ng-class=\"{active: $ctrl.isMenuActive(item.name)}\"> <span ng-class=item.icon></span> <a class=text-capitalize>{{item.displayName}}</a> </li> </ul> </div> <div class=\"sidebar-closed text-center\"> <ul class=list-closed> <li ng-repeat=\"item in $ctrl.list.menuList1\" ui-sref=app.dashboard.DynamicMenus({url:item.slug}) title={{item.displayName}} ng-class=\"{active: $ctrl.isMenuActive(item.name)}\"> <a> <span ng-class=item.icon></span> </a> </li> </ul> <ul class=other-list-closed> <li ng-repeat=\"item in $ctrl.list.menuList2\" ui-sref=app.dashboard.DynamicMenus({url:item.slug}) title={{item.displayName}} ng-class=\"{active: $ctrl.isMenuActive(item.name)}\"> <a> <span ng-class=item.icon></span> </a> </li> </ul> </div> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 746 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/sub-feature-repository/sub-feature-repository-detail/sub-feature-repository-detail.html';
var html = "<section class=sub-feature-repository> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 no-padding\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.details.title}}</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <span class=\"icons icon-Edit\" ng-click=$ctrl.onEdit()></span> </div> </div> <div class=clearfix></div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 no-padding details\"> <p>{{$ctrl.details.description}}</p> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 747 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/sub-feature-repository/sub-feature-repository-edit/sub-feature-repository-edit.html';
var html = "<section class=\"overview-template min-height-section\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=col-md-12> <form ng-submit=\"$ctrl.onSubmit({$event: $ctrl.details})\" novalidate=novalidate name=subFetaure> <div class=overview-edit-content> <div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12\"> <div class=form-padding> <div class=form-group> <label for=title>Title*</label> <character-count max-count=100 input=$ctrl.details.title> </character-count> <input type=text id=title name=title class=form-control empty-text-validation placeholder=\"Click to add title\" ng-model=$ctrl.details.title ng-trim=false maxlength=100 required/> </div> </div> <div class=form-padding> <div class=form-group> <label for=description>Description*</label> <character-count max-count=2000 input=$ctrl.details.description> </character-count> <textarea id=description class=form-control rows=3 placeholder=\"Click to add description\" ng-model=$ctrl.details.description empty-text-validation ng-trim=false maxlength=2000 required>\n                            </textarea> </div> </div> </div> </div> <div class=clear></div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=\"$ctrl.onCancel({$event: $ctrl.details})\"> </form-buttons> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 748 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/tag/tag.html';
var html = "<ul style=list-style:none> <li ng-repeat=\"(idx, tag) in $ctrl.items track by $index\" class=\"tag label label-success\">{{tag}} <a class=close href ng-click=$ctrl.remove(tag)>x</a> </li> </ul> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 749 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/timepicker/timepicker.html';
var html = "<div class=\"main-timepicker form-group\"> <div class=\"col-md-5 col-sm-5 col-lg-5 form-group\" uib-dropdown auto-close=outsideClick class=drpdwntime> <div uib-dropdown-toggle ng-if=$ctrl.details.range ng-disabled=$ctrl.details.range.startTime.isDisabled class=timePick> <div class=\"input-clock disabledInputDate\" ng-class=\"{'disable-dropdown': $ctrl.details.range.startTime.isDisabled}\"> <h4 ng-if=!$ctrl.details.range.startTime.selectedTime>{{$ctrl.details.range.startTime.title}}</h4> <h4 ng-if=$ctrl.details.range.startTime.selectedTime> {{$ctrl.details.range.startTime.selectedTime | date: 'shortTime'}} </h4> </div> <div class=\"clock disabledClock\"> </div> </div> <input type=hidden class=form-control name=startTime ng-model=$ctrl.details.range.startTime.selectedTime ng-required=\"$ctrl.details.range.startTime.isRequired && !$ctrl.details.range.startTime.isDisabled\"/> <ul class=\"dropdown-menu timePicker\" uib-dropdown-menu> <li> <div uib-timepicker ng-model=$ctrl.details.range.startTime.selectedTime max=$ctrl.details.range.startTime.max ng-change=$ctrl._onTimeChange()> </div> </li> </ul> </div> <div class=\"col-md-2 col-sm-2 col-lg-2 todate text-uppercase\" ng-if=$ctrl.details.range.endTime>To</div> <div class=\"col-md-5 col-sm-5 col-lg-5 form-group\" uib-dropdown auto-close=outsideClick class=drpdwntime> <div uib-dropdown-toggle ng-if=$ctrl.details.range.endTime ng-click=$ctrl.openEndTime() ng-disabled=$ctrl.details.range.endTime.isDisabled class=timePick> <div class=\"input-clock disabledInputDate\" ng-class=\"{'disable-dropdown': $ctrl.details.range.startTime.isDisabled}\"> <h4 ng-if=!$ctrl.details.range.endTime.selectedTime> {{$ctrl.details.range.endTime.title}} </h4> <h4 ng-if=$ctrl.details.range.endTime.selectedTime> {{$ctrl.details.range.endTime.selectedTime | date: 'shortTime'}} </h4> </div> <div class=\"clock disabledClock\"> </div> </div> <input type=hidden class=form-control name=endTime ng-model=$ctrl.details.range.endTime.selectedTime ng-required=\"$ctrl.details.range.endTime.isRequired && !$ctrl.details.range.endTime.isDisabled\" time-lesser=$ctrl.details.range.startTime.selectedTime /> <ul uib-dropdown-menu class=\"dropdown-menu timePicker\" role=menu> <li> <div uib-timepicker ng-model=$ctrl.details.range.endTime.selectedTime> </div> </li> </ul> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 750 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/upload-cover-pic/upload-cover-pic.html';
var html = "<div class=upload-cover-pic> <div class=form-padding ng-if=!$ctrl.roundedCoverPic> <div class=\"form-group cover-pic-label\"> <label for=cover>{{$ctrl.title}}<span ng-if=$ctrl._isCoverPhotoRequired>*</span></label> </div> </div> <div class=clear></div> <div class=\"upload-area form-group\" ng-if=!$ctrl.roundedCoverPic> <div class=upload-pic> <display-cover-pic cover-pic-url={{$ctrl.imageSrc}}> </display-cover-pic> </div> <div class=upload-pic-btn> <input type=button ng-if=\"$ctrl.defaultCoverPic !== ''\" ng-click=$ctrl._onRemove() class=\"remove-btn text-uppercase\" ng-class=$ctrl.removeClass value=Remove /> <input type=button ngf-change=\"$ctrl.onFileChange($files, $file)\" ngf-select accept=image/* ng-model=$ctrl.selectedImage upload-coverpic-validation is-required=$ctrl._isCoverPhotoRequired class=\"cancel-btn text-uppercase\" ng-disabled=$ctrl.isDisable ng-required=$ctrl._isCoverPhotoRequired ng-value=\"$ctrl.defaultCoverPic == '' ? 'Upload' : 'Change'\"/> </div> </div> <p ng-if=\"$ctrl.fileName !== undefined\">{{$ctrl.fileName}}</p> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 751 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/components/upload-cover-pic/upload-square-pic.html';
var html = "<div class=upload-cover-pic> <div class=form-padding> <div class=\"form-group cover-pic-label\"> <label for=cover>{{$ctrl.title}}<span ng-if=$ctrl._isCoverPhotoRequired>*</span></label> </div> </div> <div class=clear></div> <div class=\"upload-square-area form-group\" ng-if=!$ctrl.roundedCoverPic> <div class=square-pic ng-class=\"{'ratio': $ctrl._isRatioChange}\"> <display-cover-pic cover-pic-url={{$ctrl.imageSrc}}> </display-cover-pic> </div> <div class=square-pic-btn> <p>{{$ctrl.fileName}}</p> <input type=button ngf-change=\"$ctrl.onFileChange($files, $file)\" ngf-select accept=image/* ng-model=$ctrl.selectedImage class=\"cancel-btn text-uppercase\" ng-disabled=$ctrl.isDisable ng-required=$ctrl._isCoverPhotoRequired ng-value=\"$ctrl.defaultCoverPic == '' ? 'Upload' : 'Change'\"/> <input type=button ng-if=\"$ctrl.defaultCoverPic !== ''\" ng-click=$ctrl._onRemove() class=\"remove-btn text-uppercase\" ng-class=\"{'ratio-remove-btn': $ctrl._isRatioChange}\" value=Remove /> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 752 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/common/libs/image-crop/image-crop.html';
var html = "<div class=modal-body> <ui-cropper image=\"$ctrl.resolve.details.image | ngfDataUrl\" area-type={{$ctrl.resolve.details.config.areaType}} aspect-ratio=$ctrl.resolve.details.config.aspectRatio result-image=$ctrl.croppedImage ng-init=\"$ctrl.croppedImage=''\" result-image-size=$ctrl.resolve.details.config.resultImageSize result-image-quality=1 init-max-area=false> </ui-cropper> </div> <div class=modal-footer> <button ng-click=$ctrl.resolve.details.onCancel() class=\"btn cancel-btn\">cancel</button> <button ng-click=$ctrl.resolve.details.onCrop($ctrl.croppedImage) class=\"btn submit-btn\">crop</button> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 753 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/about-us/in-the-news/in-the-news-details/in-the-news-details.html';
var html = "<section class=call-for-help-details-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 call-for-help-details\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>details</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <button type=button class=\"btn go-back text-uppercase\" ng-click=$ctrl.onGoBack()>go back</button> <span class=icon-Edit ng-click=$ctrl.onEdit()></span> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item\"> <div class=item-detail> <h2 class=text-capitalize>{{$ctrl.details.title}}</h2> <div class=county-hrs-operation-wrap> <div class=county> <h3>Publish At</h3> <p ng-if=\"$ctrl.details.publishAt === null\">-</p> <p ng-if=\"$ctrl.details.publishAt !== null\">{{$ctrl.details.publishAt | date: 'MMM dd, yyyy, hh:mm a'}}</p> </div> <div class=desc> <h3>Description</h3> <p ng-bind-html=$ctrl.details.description></p> </div> </div> </div> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 754 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/about-us/in-the-news/in-the-news-list/in-the-news-list.html';
var html = "<display-overview slug-url={{$ctrl.slugUrl}} details=$ctrl.details.overview> </display-overview> <section class=in-the-news-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 in-the-news\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <span class=text-capitalize ng-click=\"$ctrl.tabChange('publish')\" ng-class=\"{'active-tab': $ctrl.isPublishedClicked}\">published ({{$ctrl.totalPublishedItems}})</span> <span class=text-capitalize ng-click=\"$ctrl.tabChange('unpublish')\" ng-class=\"{'active-tab': !$ctrl.isPublishedClicked}\">unpublished ({{$ctrl.totalUnpublishedItems}})</span> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <div class=button-div> <button class=\"submit-btn text-uppercase\" ng-click=$ctrl.routeAddPageUrl()>add new</button> </div> </div> </div> <div class=\"col-md-12 col-lg-12\" ng-include=$ctrl.tabTemplateUrl> </div> <div class=\"col-md-12 pagination\"> <pagination total-items=$ctrl.totalItems item-per-page=$ctrl.itemPerPage current-page=$ctrl.currentPage on-change=$ctrl.onChange($event)> </pagination> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 755 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/about-us/in-the-news/in-the-news-list/in-the-news-publish-template.html';
var html = "<div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 dropdown no-padding\"> <div class=\"col-md-4 col-sm-12 col-xs-12 col-lg-4 no-padding\"> <select-dropdown list=$ctrl.details.year selected-id=$ctrl.selectedYearId is-option-disabled=false on-change=$ctrl.onYearChange($event)></select-dropdown> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item no-result-found\" ng-if=\"$ctrl.publishedNewsList.length === 0\"> <h4>No Result Found!</h4> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 in-the-news-list no-padding\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item no-padding\" ng-repeat=\"item in $ctrl.publishedNewsList\"> <div class=\"col-md-10 col-sm-12 col-xs-12 col-lg-10 title-desc no-padding\"> <h4 class=text-capitalize><span class=date>{{item.newsDate | date: 'MMM dd, yyyy'}}</span><span class=title>{{item.firstName}} {{item.lastName}}</span></h4> <h2 class=text-capitalize>{{item.title}}</h2> </div> <div class=\"col-md-2 col-sm-12 col-xs-12 col-lg-2 buttons no-padding\"> <div class=\"text-right item-btns\"> <span class=\"icons icon-View\" ng-click=$ctrl.routeDetailsPageUrl(item.slug)></span> <span class=\"icons icon-Edit\" ng-click=$ctrl.routeEditPageUrl(item.slug)></span> <span class=\"icons icon-Delete\" ng-click=$ctrl.onDelete(item.slug)></span> </div> <div class=\"publish-btn text-right\"> <span class=text-uppercase>published</span> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 756 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/about-us/in-the-news/in-the-news-list/in-the-news-unpublish-template.html';
var html = "<div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 in-the-news-list no-padding\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item no-result-found\" ng-if=\"$ctrl.unpublishedNewsList.length === 0\"> <h4>No Result Found!</h4> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item no-padding\" ng-repeat=\"item in $ctrl.unpublishedNewsList\"> <div class=\"col-md-10 col-sm-12 col-xs-12 col-lg-10 title-desc no-padding\"> <h4 class=text-capitalize><span>{{item.firstName}} {{item.lastName}}</span></h4> <h2 class=text-capitalize>{{item.title}}</h2> </div> <div class=\"col-md-2 col-sm-12 col-xs-12 col-lg-2 buttons no-padding\"> <div class=\"text-right item-btns\"> <span class=\"icons icon-View\" ng-click=$ctrl.routeDetailsPageUrl(item.slug)></span> <span class=\"icons icon-Edit\" ng-click=$ctrl.routeEditPageUrl(item.slug)></span> <span class=\"icons icon-Delete\" ng-click=$ctrl.onDelete(item.slug)></span> </div> <div class=\"publish-btn text-right\"> <button class=\"cancel-btn text-uppercase\" ng-click=$ctrl.publishUnpublishNews(item.id)>publish</button> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 757 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/about-us/in-the-news/in-the-news-template.html';
var html = "<section class=\"in-the-news-template min-height-section\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 no-padding\"> <form ng-submit=$ctrl._onSubmit() novalidate=novalidate name=inTheNewsTemplate> <div class=home-banner-edit-content> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 main-content no-padding\"> <div class=title-desc> <div class=form-padding> <div class=form-group> <label for=title class=text-capitalize>news title*</label> <character-count max-count=100 input=$ctrl.details.title> </character-count> <input type=text id=title name=title class=form-control placeholder=\"Click to add title\" ng-model=$ctrl.details.title ng-trim=false maxlength=100 empty-text-validation required/> </div> </div> <div class=\"form-padding news-date\"> <div class=form-group> <datepicker details=$ctrl.newsDateDetails></datepicker> </div> <span class=custom-error ng-if=$ctrl.dateError>Please select date</span> </div> <div class=\"form-padding clear-both news-editor\"> <div class=form-group> <editor details=$ctrl.details show-footer-buttons=false page-title=\"News Content\" get-editor-details=$ctrl.setEditorDetails($event) editor-field-error={{$ctrl.editorFieldError}}> </editor> </div> </div> </div> </div> </div> <div class=clear></div> <form-buttons show-republish-button=$ctrl.showRepublishButton show-save-publish-type-button={{$ctrl.showSavePublishTypeButton}} disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel() on-save-publish=$ctrl._onSavePublish() on-republish=$ctrl._onRepublish()> </form-buttons> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 758 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/about-us/our-staff/our-staff-edit-sequence/our-staff-edit-sequence.html';
var html = "<section class=home-banner-edit-sequence> <form name=aboutUsEditSequenceForm ng-submit=$ctrl.onSubmit()> <div class=\"col-md-12 edit-sequence\"> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 inner-page-title\"> <h1 class=text-capitalize>edit sequence</h1> </div> <div class=clear></div> <content-sequence list=$ctrl.details></content-sequence> <div class=clear></div> <form-buttons disable-buttons=disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </div> </form> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 759 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/about-us/our-staff/our-staff-list/our-staff-list.html';
var html = "<div class=\"about-us-list our-Staff\"> <display-overview details=$ctrl.details.overview slug-url={{$ctrl.slugUrl}}> </display-overview> <section class=\"about-us-section our-staff-section\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 about-us our-staff\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>Staff</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <a ng-click=$ctrl.routeSequencePageUrl()> <span class=text-uppercase>edit sequence</span> </a> <button class=\"submit-btn text-uppercase\" ng-click=$ctrl.routeAddPageUrl()>add new</button> </div> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item\" ng-repeat=\"staff in $ctrl.details.ourStaffList\"> <div class=\"col-md-10 col-xs-10 col-sm-10 col-lg-10 title-desc\"> <div class=\"col-md-2 col-xs-2 col-sm-2 col-lg-2 staff-img\"> <img ng-src={{$ctrl._getImage(staff.image)}} alt=\"{{staff.firstName}}  {{staff.lastName}}\"> </div> <h2 class=text-capitalize>{{staff.firstName}} {{staff.lastName}}</h2> <p class=text-capitalize>{{staff.designation}}</p> </div> <div class=\"col-md-2 col-xs-2 col-sm-2 col-lg-2 text-right view-btn\"> <a ng-click=$ctrl.routeEditPageUrl(staff.slug)> <span class=icon-Edit></span> </a> <span class=icon-Delete ng-click=$ctrl.onDeleteStaff(staff.slug)></span> </div> </div> </div> </section> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 760 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/about-us/our-staff/our-staff-template.html';
var html = "<section class=\"bicycle-pedestrian-template min-height-section\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 no-padding\"> <form ng-submit=$ctrl._onSubmit() novalidate=novalidate name=ourStaff> <div class=our-staff-content> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 main-content no-padding\"> <div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 title-desc no-padding-left\"> <div class=form-padding> <div class=\"form-group col-md-12 col-sm-12 col-xs-12 col-lg-12\"> <label for=firstName>First Name*</label> <input type=text id=firstName class=form-control ng-model=$ctrl.details.firstName placeholder=\"First Name\" ng-trim=false empty-text-validation required> </div> <div class=\"form-group col-md-12 col-sm-12 col-xs-12 col-lg-12\"> <label for=lastName>Last Name*</label> <input type=text id=lastName class=form-control ng-model=$ctrl.details.lastName placeholder=\"Last Name\" ng-trim=false empty-text-validation required> </div> <div class=\"form-group col-md-12 col-sm-12 col-xs-12 col-lg-12\"> <label for=designation>Designation*</label> <input type=text id=designation class=form-control ng-model=$ctrl.details.designation placeholder=Designation ng-trim=false empty-text-validation required> </div> </div> </div> <div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 title-desc no-padding-right\"> <upload-cover-pic page-name=Staff on-upload=$ctrl.onUpload($event) on-remove=$ctrl.onRemoveLogo() show-squre-photo=true heading-text=photo type=staffProfile is-ratio-change=true default-cover-pic={{$ctrl.details.image}} is-cover-photo-required=false> </upload-cover-pic> </div> </div> <div class=clear></div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </div> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 761 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/auth/change-password/change-password.html';
var html = " <section class=overview-template> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>Change Password</h2> </div> </div> <div class=col-md-12> <form ng-submit=$ctrl.onSubmit() novalidate=novalidate name=overviewTemplate> <div class=overview-edit-content> <div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12\"> <div class=form-padding> <div class=\"form-group col-md-6 col-lg-6 col-sm-12 col-xs-12 no-padding-left\"> <label for=currentPass>Current Password</label> <input type=password class=form-control ng-model=$ctrl.details.currentPassword ng-focus=\"$ctrl.invalidOldPassword = false\" id=currentPass empty-text-validation required> <span class=mismatch-pswd ng-if=$ctrl.invalidOldPassword>{{$ctrl.invalidOldPasswordErrorMessage}}</span> </div> </div> </div> <div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12\"> <div class=form-padding> <div class=\"form-group col-md-6 col-lg-6 col-sm-12 col-xs-12 no-padding-left\"> <label for=newPass>New Password</label> <input type=password class=form-control ng-model=$ctrl.details.newPassword ng-focus=\"$ctrl.invalidNewPassword=false\" ng-pattern=$ctrl.Constants.PATTERN empty-text-validation ng-pattern-err-type=invalidPasswordError id=newPass required> </div> </div> </div> <div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12\"> <div class=form-padding> <div class=\"form-group col-md-6 col-lg-6 col-sm-12 col-xs-12 no-padding-left\"> <label for=confirmPass>Re-Type New Password</label> <input type=password class=form-control ng-model=$ctrl.details.reTypePassword ng-focus=\"$ctrl.invalidNewPassword=false\" id=confirmPass ng-pattern=$ctrl.Constants.PATTERN empty-text-validation ng-pattern-err-type=invalidPasswordError required> <span class=mismatch-pswd ng-if=$ctrl.invalidNewPassword>{{$ctrl.invalidNewPasswordErrorMessage}}</span> </div> </div> </div> </div> <div class=clear></div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 762 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/auth/login/login.html';
var html = "<div class=main-login> <div class=login-screen> <div class=login-logo> <img src=/images/login_logo.png> </div> <div class=card> <div class=login-form-card ng-class=\"{'login-hide': $ctrl.forgotPswd}\"> <h1>CMS Login</h1> <div class=login-form> <form name=loginForm novalidate=novalidate ng-submit=$ctrl.login()> <div class=id-pswd> <div class=\"form-group login-input-user\"> <span class=\"login-span icon-User\"> <input type=text class=form-control name=username placeholder=\"Email Address\" ng-model=$ctrl.username ng-focus=\"$ctrl.errorMsg = ''\" empty-text-validation required/> </span> </div> <div class=\"form-group login-input-div\"> <span class=\"login-span icon-Password\"> <input type=password class=form-control name=password placeholder=Password ng-model=$ctrl.password ng-focus=\"$ctrl.errorMsg = ''\" empty-text-validation required/> </span> <span class=mismatch-pswd>{{$ctrl.errorMsg}}</span> </div> </div> <div class=login-button-green> <button type=submit>Login</button> </div> <div class=pswd> <span ng-click=$ctrl.forgotPassword()>forgot password?</span> </div> </form> </div> </div> <div class=forgot-pswd-form ng-class=\"{'show-forgot': $ctrl.forgotPswd && !$ctrl.successSubmit, 'hide-forgot': $ctrl.successSubmit}\"> <div class=forgot-pswd ng-click=$ctrl.hideForgotPswdView()> <span class=icon-Back></span> </div> <form name=forgotPswdForm novalidate=novalidate ng-submit=$ctrl.onSubmit()> <p class=pswd-text>forgot password?</p> <p class=helper-text>Enter your Email Address below to receive your password reset instructions</p> <div class=\"pswd-input login-span form-group\"> <span class=\"login-span icon-User\"> <input type=email ng-model=$ctrl.emailId class=form-control name=email placeholder=\"Email Address\" input-validation empty-text-validation required/> </span> </div> <div class=\"login-button-green pswd-submit\"> <button type=submit>Submit</button> </div> </form> </div> <div class=verify-email-form ng-class=\"{'show-verify': $ctrl.successSubmit}\"> <div class=forgot-pswd ng-click=$ctrl.verifyEmailBackView()> <span class=icon-Back></span> </div> <p class=pswd-text>check your e-mail</p> <p class=helper-text>An email with password reset instructions has been sent to your email.</p> <p class=helper-text>If you haven't received the email to reset the password, please click on 'Resend Email' button below</p> <div class=login-button-green ng-click=$ctrl.submitVerifyForm()> <button>resend email</button> </div> </div> </div> </div> <div class=footer-div-login> <app-footer></app-footer> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 763 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/auth/reset-password/reset-password.html';
var html = "<div class=main-login> <div class=login-screen> <div class=login-logo> <img src=/images/login_logo.png> </div> <div class=card> <div class=reset-pswd-form ng-if=$ctrl.showResetForm> <form name=resetPswdForm novalidate=novalidate ng-submit=$ctrl.resetPassword()> <p class=pswd-text>Reset password?</p> <div class=helper-text>Please enter your new password below</div> <div class=\"form-group reset-input\"> <span class=\"login-span icon-Password\"> <input type=password class=form-control name=newPswd placeholder=\"New Password\" ng-pattern=$ctrl.Constants.PATTERN ng-pattern-err-type=invalidPasswordError ng-model=$ctrl.details.newPassword ng-model-options=\"{'updateOn': 'blur'}\" required/> </span> </div> <div class=\"form-group reset-input\"> <span class=\"login-span icon-Password\"> <input type=password class=form-control name=confirmPswd placeholder=\"Confirm Password\" ng-pattern=$ctrl.Constants.PATTERN ng-pattern-err-type=invalidPasswordError ng-model=$ctrl.details.confirmPassword ng-model-options=\"{'updateOn': 'blur'}\" required/> </span> <span ng-if=$ctrl.mismatchPswd class=mismatch-pswd>Password doesn't match</span> </div> <div class=\"login-button-green reset-btn\"> <button>reset password</button> </div> </form> </div> <div class=thanking-div ng-if=$ctrl.showThankingMsg> <p class=reset-code-text>Your password has been changed successfully!</p> </div> <div ng-if=\"{'show-expire': $ctrl.showExpireToken}\"> <div class=show-expire-div> <p class=link-expire>This link has expired.</p> </div> </div> </div> </div> <div class=footer-div-login> <app-footer></app-footer> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 764 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/contact-info/contact-info.html';
var html = "<section class=overview-template> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 padding-21 margin-bottom-20\"> <form ng-submit=$ctrl.onSubmit() novalidate=novalidate name=contactData autocomplete=off> <div class=\"col-md-12 remove-padding\"> <div class=form-padding> <div class=form-group> <label for=email>Email Id*</label> <character-count max-count=100 input=$ctrl.details.email> </character-count> <input type=text key=email id=email name=email class=form-control ng-trim=false maxlength=100 placeholder=\"Click to add email\" ng-model=$ctrl.details.email empty-text-validation input-validation required/> </div> </div> </div> <div class=\"col-md-12 info-div remove-padding\"> <phone-template details=$ctrl.details.phone on-add=$ctrl.onPhoneNumberAdd($event) on-delete=$ctrl.onPhoneNumberDelete($event) hide-phone-purpose=true> </phone-template> </div> <div class=\"col-md-12 info-div remove-padding\"> <address details=$ctrl.details.address></address> </div> <form-buttons on-cancel=$ctrl.onCancel() disable-buttons=$ctrl.disableButtons />  </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 765 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/dashboard/dashboard.html';
var html = "<app-header></app-header> <div> <breadcrumb is-sidebar-open=$ctrl.isSidebarOpen> </breadcrumb> <sidebar list=$ctrl.list is-sidebar-open=$ctrl.isSidebarOpen> </sidebar> <div ui-view class=\"col-md-9 col-lg-9 rightpanel\" ng-class=\"{'side-open-rightpanel': $ctrl.isSidebarOpen}\"></div> </div> <app-footer></app-footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 766 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/donation/donation.html';
var html = "<section class=overview-template> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title remove-margin\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 remove-padding\"> <form ng-submit=$ctrl.onSubmit() novalidate=novalidate name=overviewTemplate> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 content-div\"> <div class=form-padding> <div class=form-group> <label for=time>Url*</label> <input type=url ng-model=$ctrl.details.url class=form-control empty-text-validation required> </div> </div> </div> <div class=clear></div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 767 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/dynamic-menus/dynamic-menus.html';
var html = " <home-banner-list ng-if=\"$ctrl.activeMenu === 'HomeBanner'\" details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </home-banner-list> <home-banner-add ng-if=\"$ctrl.activeMenu === 'HomeBannerAdd'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></home-banner-add> <home-banner-edit ng-if=\"$ctrl.activeMenu === 'HomeBannerEdit'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></home-banner-edit> <home-banner-edit-sequence ng-if=\"$ctrl.activeMenu === 'HomeBannerSequence'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></home-banner-edit-sequence> <reference-map ng-if=\"$ctrl.activeMenu === 'DataMappingTool'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></reference-map> <call-for-help-list ng-if=\"$ctrl.activeMenu === 'CallForHelp'\" details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </call-for-help-list> <call-for-help-details ng-if=\"$ctrl.activeMenu === 'CallForHelpDetails'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </call-for-help-details> <call-for-help-add ng-if=\"$ctrl.activeMenu === 'CallForHelpAdd'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></call-for-help-add> <call-for-help-edit ng-if=\"$ctrl.activeMenu === 'CallForHelpEdit'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></call-for-help-edit> <bicycle-pedestrian-list ng-if=\"$ctrl.activeMenu === 'BicycleAndPedestrian'\" details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </bicycle-pedestrian-list> <bicycle-pedestrian-details ng-if=\"$ctrl.activeMenu === 'BicycleAndPedestrianDetails'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </bicycle-pedestrian-details> <bicycle-pedestrian-add ng-if=\"$ctrl.activeMenu === 'BicycleAndPedestrianAdd'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></bicycle-pedestrian-add> <bicycle-pedestrian-edit ng-if=\"$ctrl.activeMenu === 'BicycleAndPedestrianEdit'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></bicycle-pedestrian-edit> <ridesharing-list ng-if=\"$ctrl.activeMenu === 'Ridesharing'\" details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </ridesharing-list> <ridesharing-details ng-if=\"$ctrl.activeMenu === 'RidesharingDetails'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </ridesharing-details> <ridesharing-add ng-if=\"$ctrl.activeMenu === 'RidesharingAdd'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></ridesharing-add> <ridesharing-edit ng-if=\"$ctrl.activeMenu === 'RidesharingEdit'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></ridesharing-edit> <transportation-providers-list ng-if=\"$ctrl.activeMenu === 'TransportationProviders'\" details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </transportation-providers-list> <transportation-providers-details ng-if=\"$ctrl.activeMenu === 'TransportationProvidersDetails'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </transportation-providers-details> <transportation-providers-add ng-if=\"$ctrl.activeMenu === 'TransportationProvidersAdd'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></transportation-providers-add> <transportation-providers-edit ng-if=\"$ctrl.activeMenu === 'TransportationProvidersEdit'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></transportation-providers-edit> <in-the-news-list ng-if=\"$ctrl.activeMenu === 'InTheNews'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></in-the-news-list> <in-the-news-details ng-if=\"$ctrl.activeMenu === 'InTheNewsDetails'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></in-the-news-details> <in-the-news-add ng-if=\"$ctrl.activeMenu === 'InTheNewsAdd'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></in-the-news-add> <in-the-news-edit ng-if=\"$ctrl.activeMenu === 'InTheNewsEdit'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></in-the-news-edit> <our-staff-list ng-if=\"$ctrl.activeMenu === 'OurStaff'\" details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </our-staff-list> <our-staff-edit-sequence ng-if=\"$ctrl.activeMenu === 'OurStaffSequence'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></our-staff-edit-sequence> <our-staff-add ng-if=\"$ctrl.activeMenu === 'OurStaffAdd'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></our-staff-add> <our-staff-edit ng-if=\"$ctrl.activeMenu === 'OurStaffEdit'\" parent-slug={{$ctrl.parentSlug}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></our-staff-edit> <trip-planning ng-if=\"$ctrl.activeMenu === 'TripPlanning'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></trip-planning> <editor-template ng-if=$ctrl.isEditorTemplateComponent() parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </editor-template> <editor-template-overview ng-if=$ctrl.isEditorTemplateOverviewComponent() details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}} parent-slug={{$ctrl.parentSlug}} parent-name={{$ctrl.parentName}}> </editor-template-overview> <menu-list ng-if=$ctrl.isMenuListComponent() details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}} menu-name={{$ctrl.activeMenu}} menu-id={{$ctrl.menuId}}> </menu-list> <menu-sequence ng-if=$ctrl.isMenuSequenceComponent() parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </menu-sequence> <report-list ng-if=$ctrl.isReportListComponent() menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </report-list> <report-view ng-if=$ctrl.isReportViewComponent() parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}> </report-view> <report-add ng-if=$ctrl.isReportAddComponent() parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></report-add> <report-edit ng-if=$ctrl.isReportEditComponent() parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></report-edit> <page-publish ng-if=$ctrl.isPagePublishStatusComponent() parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}} parent-name={{$ctrl.parentName}}></page-publish> <payment-methods ng-if=\"$ctrl.activeMenu === 'PaymentMethods'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></payment-methods> <service-area-list ng-if=\"$ctrl.activeMenu === 'ServiceArea'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></service-area-list> <donation ng-if=\"$ctrl.activeMenu === 'Donation'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></donation> <social-share ng-if=\"$ctrl.activeMenu === 'SocialShare'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></social-share> <social-links ng-if=\"$ctrl.activeMenu === 'SocialLinks'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></social-links> <contact-info ng-if=\"$ctrl.activeMenu === 'ContactInfo'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></contact-info> <terms-and-condition ng-if=\"$ctrl.activeMenu === 'TermsAndCondition'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></terms-and-condition> <privacy-policy ng-if=\"$ctrl.activeMenu === 'PrivacyPolicy'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></privacy-policy> <rhnscny-logo ng-if=\"$ctrl.activeMenu === 'RHNSCNY'\" parent-slug={{$ctrl.parentSlug}} menu-name={{$ctrl.activeMenu}} details=$ctrl.menuDetails slug-url={{$ctrl.slugUrl}}></rhnscny-logo>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 768 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/editor-template-overview/editor-template-overview.html';
var html = "<overview-template page-name=\"Cover Photo\" details=$ctrl.details disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel() on-submit=$ctrl.onSubmit() is-description-available={{$ctrl.isDescriptionAvailable}} on-cover-pic-upload=$ctrl.onCoverPicUpload(details)> </overview-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 769 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/editor-template/editor-template.html';
var html = "<content-template details=$ctrl.details slug-url={{$ctrl.slugUrl}} disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel() on-submit=$ctrl.onSubmit()> </content-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 770 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/home-banner/home-banner-edit-sequence/home-banner-edit-sequence.html';
var html = "<section class=home-banner-edit-sequence> <form name=homeBannerEditSequenceForm ng-submit=$ctrl.onSubmit()> <div class=\"col-md-12 edit-sequence\"> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 inner-page-title\"> <h1 class=text-capitalize>edit sequence</h1> </div> <div class=clear></div> <content-sequence list=$ctrl.details></content-sequence> <div class=clear></div> <form-buttons disable-buttons=disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </div> </form> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 771 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/home-banner/home-banner-list/home-banner-list.html';
var html = "<section class=home-banner-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 home-banner\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <span class=text-capitalize ng-click=\"$ctrl.tabChange('publish')\" ng-class=\"{'active-tab': $ctrl.isPublishedClicked}\">published ({{$ctrl.details.publishedList.length}})</span> <span class=text-capitalize ng-click=\"$ctrl.tabChange('unpublish')\" ng-class=\"{'active-tab': !$ctrl.isPublishedClicked}\">unpublished ({{$ctrl.details.unPublishedList.length}})</span> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <a ng-click=$ctrl.routeSequencePageUrl()> <span class=text-uppercase>edit sequence</span> </a> <div class=button-div> <button class=\"submit-btn text-uppercase\" ng-click=$ctrl.routeAddPageUrl()>add new</button> </div> </div> </div> <div class=\"col-md-12 col-lg-12\" ng-include=$ctrl.tabTemplateUrl> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 772 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/home-banner/home-banner-list/home-banner-publish-template.html';
var html = "<div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 published-list\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 published-item\" ng-repeat=\"item in $ctrl.details.publishedList\"> <div class=\"col-md-3 col-xs-3 col-sm-3 col-lg-3 cover-img\"> <img class=img-responsive ng-src={{$ctrl._getImage(item)}} /> </div> <div class=\"col-md-9 col-xs-9 col-sm-9 col-lg-9 item-desc\"> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 item-title\"> <div class=\"col-md-9 col-xs-9 col-sm-9 col-lg-9 title-desc\"> <h3 class=text-capitalize>{{item.title}}</h3> <p>{{item.description}}</p> </div> <div class=\"col-md-3 col-xs-3 col-sm-3 col-lg-3 item-btns text-right\"> <span class=icon-Edit ng-click=$ctrl.routeEditPageUrl(item.slug)></span> <span class=icon-Delete ng-click=$ctrl.onDelete(item.slug)></span> </div> </div> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 item-url\"> <div class=\"col-md-9 col-xs-9 col-sm-9 col-lg-9 url-value\"> <h4 class=text-capitalize>web address(URL)</h4> <p>{{item.url || '-'}}</p> </div> <div class=\"col-md-3 col-xs-3 col-sm-3 col-lg-3 publish-btn text-right\"> <button ng-if=\"$ctrl.details.publishedList.length === 1\" class=\"disabled-btn cancel-btn text-uppercase\">unpublish</button> <button ng-if=\"$ctrl.details.publishedList.length > 1 && $ctrl.details.publishedList.length <= 5\" class=\"cancel-btn text-uppercase\" ng-click=\"$ctrl.publishUnpublishBanner(item.id, item.isActive)\">unpublish</button> </div> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 773 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/home-banner/home-banner-list/home-banner-unpublish-template.html';
var html = "<div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 unpublished-list\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 published-item\" ng-repeat=\"item in $ctrl.details.unPublishedList\"> <div class=\"col-md-3 col-xs-3 col-sm-3 col-lg-3 cover-img\"> <img class=img-responsive ng-src={{$ctrl._getImage(item)}} /> </div> <div class=\"col-md-9 col-xs-9 col-sm-9 col-lg-9 item-desc\"> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 item-title\"> <div class=\"col-md-9 col-xs-9 col-sm-9 col-lg-9 title-desc\"> <h3 class=text-capitalize>{{item.title}}</h3> <p>{{item.description}}</p> </div> <div class=\"col-md-3 col-xs-3 col-sm-3 col-lg-3 item-btns text-right\"> <span class=icon-Edit ng-click=$ctrl.routeEditPageUrl(item.slug)></span> <span class=icon-Delete ng-click=$ctrl.onDelete(item.slug)></span> </div> </div> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 item-url\"> <div class=\"col-md-9 col-xs-9 col-sm-9 col-lg-9 url-value\"> <h4 class=text-capitalize>web address(URL)</h4> <p>{{item.url || '-'}}</p> </div> <div class=\"col-md-3 col-xs-3 col-sm-3 col-lg-3 publish-btn text-right\"> <button ng-if=\"$ctrl.details.publishedList.length === 5\" class=\"cancel-btn text-uppercase not-allowed\">publish</button> <button ng-if=\"$ctrl.details.publishedList.length < 5\" class=\"cancel-btn text-uppercase\" ng-click=\"$ctrl.publishUnpublishBanner(item.id, item.isActive)\">publish</button> </div> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 774 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/home-banner/home-banner-template.html';
var html = "<section class=\"home-banner-template min-height-section\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12\"> <form ng-submit=$ctrl._onSubmit() novalidate=novalidate name=homeBannerTemplate> <div class=home-banner-edit-content> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 main-content\"> <div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 title-desc\"> <div class=form-padding> <div class=form-group> <label for=title class=text-capitalize>title</label> <character-count max-count=100 input=$ctrl.details.title> </character-count> <input type=text id=title name=title class=form-control placeholder=\"Click to add title\" ng-model=$ctrl.details.title empty-text-validation ng-trim=false maxlength=100 /> </div> </div> <div class=form-padding> <div class=form-group> <label for=description class=text-capitalize>description</label> <character-count max-count=2000 input=$ctrl.details.description> </character-count> <textarea id=description class=form-control rows=3 placeholder=\"Click to add description\" ng-model=$ctrl.details.description empty-text-validation ng-trim=false maxlength=2000>\n                                </textarea> </div> </div> </div> <div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 cover-pic\"> <div class=cover-photo-area> <upload-cover-pic type=banner page-name=\"Banner Picture\" on-upload=$ctrl.onCoverPicUpload($event) on-remove=$ctrl.onRemoveCoverPic() default-cover-pic={{$ctrl.details.image}} is-cover-photo-required=true> </upload-cover-pic> </div> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 button-div\"> <div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 button-content\"> <div class=form-padding> <div class=form-group> <label for=buttonText class=text-capitalize>button text</label> <character-count max-count=50 input=$ctrl.details.buttonText> </character-count> <input type=text id=buttonText name=buttonText class=form-control empty-text-validation ng-trim=false maxlength=50 placeholder=\"Click to add button text\" ng-model=$ctrl.details.buttonText /> </div> </div> </div> </div> <div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12 button-content remove-padding\"> <div class=form-padding> <div class=form-group> <label for=buttonText class=text-capitalize>ADA text</label> <character-count max-count=50 input=$ctrl.details.ada.banner_image_text> </character-count> <input type=text id=buttonText name=buttonText class=form-control empty-text-validation ng-trim=false maxlength=50 placeholder=\"Click to add ada text\" ng-model=$ctrl.details.ada.banner_image_text /> </div> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 url-div\"> <div class=form-padding> <div class=form-group> <label for=url class=text-capitalize>website address (redirect <span class=text-uppercase>url</span>)</label> <character-count max-count=200 input=$ctrl.details.url> </character-count> <input type=url id=url name=url class=form-control empty-text-validation ng-trim=false maxlength=200 placeholder=\"Click to add website address\" ng-model=$ctrl.details.url /> </div> </div> </div> </div> <div class=clear></div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 775 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/menu-list/menu-list.html';
var html = "<feature-main-page-template details=$ctrl.details slug-url={{$ctrl.slugUrl}} menu-name={{$ctrl.menuName}} menu-id={{$ctrl.menuId}} on-edit-overview=$ctrl.onEditOverview() on-edit-sequence=$ctrl.onEditSequence() on-publish-status=$ctrl.onPublishStatus()> </feature-main-page-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 776 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/menu-sequence/menu-sequence.html';
var html = "<section class=\"home-banner-edit-sequence min-height-section\"> <form name=TransportationAlternativesSequenceForm ng-submit=$ctrl.onSubmit()> <div class=\"col-md-12 edit-sequence\"> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 inner-page-title\"> <h1 class=text-capitalize>edit sequence</h1> </div> <div class=clear></div> <content-sequence list=$ctrl.details></content-sequence> <div class=clear></div> <form-buttons disable-buttons=disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </div> </form> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 777 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/page-publish/page-publish.html';
var html = "<section class=\"home-banner-edit-sequence min-height-section\"> <form name=TransportationAlternativePageStatusForm ng-submit=$ctrl.onSubmit()> <div class=\"col-md-12 edit-sequence\"> <div class=\"col-md-12 col-xs-12 col-sm-12 col-lg-12 inner-page-title\"> <h1 class=text-capitalize>edit publish status</h1> </div> <div class=clear></div> <page-status list=$ctrl.details on-change=$ctrl.onPageStatusListChange($event)></page-status> <div class=clear></div> <form-buttons disable-buttons=disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </div> </form> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 778 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/payment-methods/payment-methods-add/payment-methods-add.html';
var html = "<div class=service-area-add-modal> <form novalidate=novalidate ng-submit=$ctrl.onSubmit()> <div class=service-area-modal_header> <div class=title> <span>Add New Payment Method</span> </div> <div class=close_modal ng-click=$ctrl.close()> <span>X</span> </div> </div> <div class=service-area-modal_body> <span> Payment Method </span> <div class=\"google-location form-group\"> <input type=text placeholder=\"Enter payment method\" ng-model=$ctrl.details.paymentMethod class=form-control empty-text-validation required> </div> </div> <div class=service-area-modal_footer> <button class=btn-cancel ng-click=$ctrl.close()>Cancel</button> <input type=submit value=save class=btn-save ng-disabled=$ctrl.disableSaveButton> </div> </form> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 779 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/payment-methods/payment-methods.html';
var html = "<section class=\"serviceArea-list min-height-section\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}} ({{$ctrl.paymentMethods.length}})</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <button class=\"submit-btn text-uppercase\" ng-click=$ctrl.onPaymentMethodsAdd()>add new</button> </div> </div> <div class=serviceArea-table> <table class=table> <thead> <tr class=text-capitalize> <th scope=col class=\"col-md-8 col-xs-8 col-sm-8 col-lg-8\">Payment Methods</th> </tr> </thead> <tbody> <tr ng-repeat=\"methods in $ctrl.paymentMethods\"> <td class=\"col-md-8 col-xs-8 col-sm-8 col-lg-8 serviceArea-name payment-method-td\"> <span> {{methods.name}} </span> </td> </tr> </tbody> </table> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 780 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/planning-resources/reference-map/reference-map.html';
var html = "<div class=content> <display-overview details=$ctrl.details.overview slug-url={{$ctrl.slugUrl}} on-edit=$ctrl.onEditOverview()> </display-overview> <section class=overview-template> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title remove-margin\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=reference-map-edit-section> <form ng-submit=$ctrl.onSubmit() novalidate=novalidate name=referenceMap autocomplete=off> <div class=form-padding> <div class=\"col-md-12 form-group\"> <span class=label-text>Reference Map Code*</span> <textarea class=form-control ng-model=$ctrl.details.embedCode placeholder=\"Enter the Reference Map Code\" required></textarea> </div> </div> <div class=form-padding> <div class=form-group> <editor details=$ctrl.details show-footer-buttons=false page-title=\"Reference map introduction\" get-editor-details=$ctrl.setEditorDetails($event) editor-field-error={{$ctrl.editorFieldError}}> </editor> </div> </div> <form-buttons on-cancel=$ctrl.onCancel() disable-buttons=$ctrl.disableButtons />  </form> </div> </section> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 781 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/privacy-policy/privacy-policy.html';
var html = "<content-template details=$ctrl.details is-overview-exist=false disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel() on-submit=$ctrl.onSubmit()> </content-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 782 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/report-add/report-add.html';
var html = "<report-repository-add details=$ctrl.details page-title=\"Add Report\" disable-buttons=$ctrl.disableButtons is-short-details={{$ctrl.isShortDetails}} on-submit=$ctrl.onSubmit($event) on-cancel=$ctrl.onCancel($event) service-area-list=$ctrl.serviceAreaList program-years=$ctrl.programYears> </report-repository-add>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 783 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/report-edit/report-edit.html';
var html = "<report-repository-edit details=$ctrl.details page-title=\"Edit Report\" disable-buttons=$ctrl.disableButtons is-short-details={{$ctrl.isShortDetails}} on-submit=$ctrl.onSubmit($event) on-cancel=$ctrl.onCancel($event) service-area-list=$ctrl.serviceAreaList program-years=$ctrl.programYears> </report-repository-edit>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 784 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/report-list/report-list.html';
var html = "<report-repository-list details=$ctrl.details slug-url={{$ctrl.slugUrl}} on-edit-overview=$ctrl.onEditOverview() on-add=$ctrl.progressReportsAdd() on-view-details=$ctrl.onViewDetails($event) on-edit=$ctrl.onEdit($event) on-delete=$ctrl.onDelete($event)> </report-repository-list>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 785 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/report-view/report-view.html';
var html = "<report-repository-details details=$ctrl.details on-edit=$ctrl.onEdit($event) on-go-back=$ctrl.onGoBack() parent-slug={{$ctrl.parentSlug}} is-short-details={{$ctrl.isShortDetails}}> </report-repository-details>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 786 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/rhnscny-logo/rhnscny-logo.html';
var html = "<section class=overview-template> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title remove-margin\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=\"col-md-12 col-lg-12 col-sm-12 col-xs-12 cover-pic logo-pic\"> <form ng-submit=$ctrl.onSubmit() novalidate=novalidate name=logoTemplate> <div class=cover-photo-area> <upload-cover-pic type=siteLogo page-name=logo on-upload=$ctrl.onlogoUpload($event) on-remove=$ctrl.onRemoveLogo() default-cover-pic={{$ctrl.rhnscnyLogoDetails.image}} is-cover-photo-required=true> </upload-cover-pic> </div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 787 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/service-area/service-area-add/service-area-add.html';
var html = "<div class=service-area-add-modal> <form novalidate=novalidate ng-submit=$ctrl.onSubmit()> <div class=service-area-modal_header> <div class=title> <span>Add New Service Area</span> </div> <div class=close_modal ng-click=$ctrl.close()> <span>X</span> </div> </div> <div class=service-area-modal_body> <span> Service Area </span> <div class=google-location> <google-location is-required=true get-location-details=$ctrl.getLocationDetails(details) is-error={{$ctrl.isServiceAreaFieldHaveError}} is-disabled-location={{$ctrl.isLocationDisabled}}></google-location> </div> <div class=choose-area-type ng-if=\"$ctrl.serviceAreaTypeOptions.length > 0\"> <span>Choose Area Type</span> <radio-buttons is-required=true options=$ctrl.serviceAreaTypeOptions on-change=$ctrl.onChangeServiceAreaType($event)></radio-buttons> </div> </div> <div class=service-area-modal_footer> <button type=button class=btn-cancel ng-click=$ctrl.close()>Cancel</button> <input type=submit value=save class=btn-save ng-disabled=$ctrl.disableSaveButton> </div> </form> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 788 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/service-area/service-area-providers-list/service-area-providers-list.html';
var html = "<div class=service-area-provider-list-modal> <div class=service-area-provider-list-modal_header> <div class=title> <span>Providers List</span> </div> <div class=close_modal ng-click=$ctrl.close()> <span>X</span> </div> </div> <div class=service-area-provider-list-modal_body> <div class=\"list col-md-12 col-sm-12 col-xs-12 col-lg-12\" ng-repeat=\"item in $ctrl.list.transportationProviders\"> <div class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 item-image\"> <img class=img-responsive ng-src={{$ctrl._getImage(item.image)}} /> </div> <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10 item-details\"> <h3 class=title>{{item.name}}</h3> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 item-details-content no-padding\"> <p class=content-title>Service Area</p> <div class=details> <span ng-repeat=\"location in item.serviceArea\">{{location.name}}{{!$last ? ', ' : ''}}</span> </div> </div> </div> </div> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 789 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/service-area/service-area.html';
var html = "<section class=serviceArea-list> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}} ({{$ctrl.totalItems}})</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <button class=\"submit-btn text-uppercase\" ng-click=$ctrl.onServiceAreaAdd()>add new</button> </div> </div> <div class=service-area-type> <ul> <li class=area-type ng-repeat=\"area in $ctrl.serviceAreaList\" ng-class=\"{'area-type-selected': area.isSelected}\" ng-click=$ctrl.onChangeAreaType(area.serviceAreaType)> {{area.serviceAreaType}} ({{area.count}}) </li> </ul> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item no-result-found\" ng-if=\"$ctrl.selectedServiceAreas.length === 0\"> <h4>No Result Found!</h4> </div> <div class=serviceArea-table ng-if=\"$ctrl.selectedServiceAreas.length > 0\"> <table class=table> <thead> <tr class=text-capitalize> <th scope=col class=\"col-md-8 col-xs-8 col-sm-8 col-lg-8\">Service Area Name</th> <th scope=col class=\"col-md-4 col-xs-4 col-sm-4 col-lg-4\">Providers Linked</th> <th scope=col class=\"col-md-4 col-xs-4 col-sm-4 col-lg-4\">Actions</th> </tr> </thead> <tbody> <tr ng-repeat=\"serviceArea in $ctrl.selectedServiceAreas\"> <td class=\"col-md-8 col-xs-8 col-sm-8 col-lg-8 serviceArea-name\"> <span> {{serviceArea.name}} </span> </td> <td class=\"col-md-2 col-xs-2 col-sm-2 col-lg-2 provider-linked\"> <span ng-class=\"{'disabled-list': serviceArea.providersLinked === 0}\" ng-click=\"$ctrl.displayProvidersList(serviceArea.serviceAreaId, serviceArea.providersLinked)\">{{serviceArea.providersLinked}}</span> </td> <td class=\"col-md-2 col-xs-2 col-sm-2 col-lg-2 provider-delete\"> <span class=icon-Delete ng-click=$ctrl.onDeleteServiceArea(serviceArea)></span> </td> </tr> </tbody> </table> </div> <div class=\"pagination-div pull-left\" ng-if=\"$ctrl.selectedServiceAreas.length > 0\"> <page-content-count total-items=$ctrl.totalItems item-per-page=$ctrl.itemPerPage current-page=$ctrl.currentPage current-item-count=$ctrl.selectedServiceAreas.length> </page-content-count> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 pagination\"> <pagination total-items=$ctrl.totalItems item-per-page=$ctrl.itemPerPage current-page=$ctrl.currentPage on-change=$ctrl.onChange($event)> </pagination> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 790 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/social-links/social-links.html';
var html = "<section class=social-links> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title remove-margin\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 remove-padding\"> <form ng-submit=$ctrl.onSubmit() novalidate=novalidate name=overviewTemplate> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 content-div remove-padding\"> <div class=form-padding> <div class=form-group ng-repeat=\"socialLink in $ctrl.details\"> <label for={{socialLink.name}}>{{socialLink.name}} Url</label> <input type=url id={{socialLink.name}} ng-model=socialLink.url class=form-control placeholder=\"Enter {{socialLink.name}} Url\"> </div> </div> </div> <div class=clear></div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 791 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/social-share/social-share.html';
var html = "<section class=social-share-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title remove-margin\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 remove-padding\"> <form ng-submit=$ctrl.onSubmit() novalidate=novalidate name=overviewTemplate> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 content-div\"> <div class=form-padding> <div class=form-group ng-repeat=\"socialShare in $ctrl.details\"> <label for={{socialShare.name}}>{{socialShare.name}} App Id</label> <input type=text id={{socialShare.name}} ng-model=socialShare.appId class=form-control ng-change=$ctrl.onChangeAppId(socialShare.name) ng-class=\"{'currectAppId':socialShare.isCorrect,'wrongAppId':!socialShare.isCorrect && socialShare.appId}\" placeholder=\"Enter {{socialShare.name}} AppId\"> <img src=/./images/correct.png class=currectAppIdImg ng-if=socialShare.isCorrect> <img src=/./images/wrong.png class=wrongAppIdImg ng-if=\"!socialShare.isCorrect && socialShare.appId\"> </div> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 content-text\"> <div class=steps-help-text ng-click=$ctrl._showStepsForFacebookAppId()> <span>Steps to get Facebook App ID</span> <img src=/./images/close_drop_down.png alt=... ng-if=!$ctrl.showStepsForFacebookAppId> <img src=/./images/open_drop_down.png alt=... ng-if=$ctrl.showStepsForFacebookAppId> </div> <div class=error ng-if=$ctrl.isFacebookAppIdIsInvalid> <span>The facebook app ID is invalid</span> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 steps\" ng-if=$ctrl.showStepsForFacebookAppId> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 steps-inner-div\"> <ol> <li> Goto <a href=https://developers.facebook.com/ target=_black>https://developers.facebook.com/</a></li> <li> Login with your facebook account </li> <li> Click on <span class=strong>‘MyApps’</span> </li> <li> Click on <span class=strong>‘Add New App’</span> </li> <li> Enter the <span class=strong>App Name</span> (e.g: MMSCNY) </li> <li> Click on <span class=strong>‘Create App Id’</span> and Complete Security check</li> <li> Click on <span class=strong>‘Settings’</span> and select <span class=strong>‘Basic’</span></li> <li> Enter <span class=strong>App Domain’</span>(e.g: http://mmscny.infojiniconsulting.com)</li> <li> Enter <span class=strong>Privacy Policy URL</span> (e.g: http://mmscny.infojiniconsulting.com/#!/privacy-and-policy)</li> <li> Click on <span class=strong>‘Category’</span> And Select <span class=strong>‘Business and Pages’</span></li> <li> Click on <span class=strong>‘Add Platform’</span> and Select <span class=strong>‘Website’</span></li> <li> Enter <span class=strong>Website Url</span> (e.g: http://mmscny.infojiniconsulting.com/)</li> <li> Click on <span class=strong>Save Changes</span></li> <li> Click on <span class=strong>‘Status switch’</span> and <span class=strong>‘On’</span> it. (initially it is <span class=strong>‘off’</span>)</li> <li> Copy the <span class=strong>‘App Id’</span> and paste it in CMS.</li> </ol> </div> </div> <div class=clear></div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 792 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/terms-and-condition/terms-and-condition.html';
var html = "<content-template details=$ctrl.details is-overview-exist=false disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel() on-submit=$ctrl.onSubmit()> </content-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 793 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/transportation-alternative/bicycle-pedestrian/bicycle-pedestrian-template.html';
var html = "<section class=\"bicycle-pedestrian-template min-height-section\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 no-padding\"> <form ng-submit=$ctrl._onSubmit() novalidate=novalidate name=bicyclePedestrian> <div class=bicycle-pedestrian-edit-content> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 main-content no-padding\"> <div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 title-desc no-padding-left\"> <div class=form-padding> <div class=form-group> <label for=title class=text-capitalize>title*</label> <character-count max-count=100 input=$ctrl.details.name> </character-count> <textarea id=title class=form-control rows=2 placeholder=\"Click to add title\" ng-trim=false maxlength=100 ng-model=$ctrl.details.name empty-text-validation required>\n                                </textarea> </div> </div> </div> <div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 title-desc no-padding-right\"> <upload-cover-pic page-name=\"bicycle & pedestrian\" on-upload=$ctrl.onUpload($event) on-remove=$ctrl.onRemoveLogo() show-squre-photo=true heading-text=logo default-cover-pic={{$ctrl.details.image}} is-cover-photo-required=false> </upload-cover-pic> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 county-url-wrap no-padding\"> <div class=\"col-md-6 county no-padding-left\"> <div class=form-padding> <div class=form-group> <label for=county>Select County*</label> <autocomplete items=$ctrl.county default-selected=$ctrl.defaultCounties on-select-item=$ctrl.onSelectItem($item) on-remove-tag=$ctrl.onRemoveTag($event) is-disabled={{$ctrl.disableCounty}} is-required=true> </autocomplete> </div> </div> </div> <div class=\"col-md-6 url no-padding-right\"> <div class=form-padding> <div class=form-group> <label for=url class=text-capitalize>website address (redirect <span class=text-uppercase>url</span>)*</label> <character-count max-count=200 input=$ctrl.details.url> </character-count> <input type=url id=url name=url class=form-control ng-trim=false maxlength=200 placeholder=\"Click to add website address\" ng-model=$ctrl.details.url empty-text-validation required/> </div> </div> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 desc no-padding\"> <div class=form-padding> <div class=form-group> <label for=desc class=text-capitalize>description*</label> <character-count max-count=2000 input=$ctrl.details.description> </character-count> <textarea id=desc class=form-control rows=4 ng-trim=false maxlength=2000 placeholder=\"Click to add description\" ng-model=$ctrl.details.description empty-text-validation required>\n                            </textarea> </div> </div> </div> <div class=clear></div> <form-buttons disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel()> </form-buttons> </div> </form> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 794 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/transportation-alternative/call-for-help/call-for-help-template.html';
var html = "<section class=call-for-help> <div class=pagerList> <ul id=progressbar> <li ng-class=\"{active: $ctrl.isBasicInfoActive, submitted: !$ctrl.isBasicInfoActive}\"> <p> <span class=text-capitalize>basic info</span> </p> </li> <li ng-class=\"{active: $ctrl.isOperationInfoClassActive, submitted: $ctrl.isOperationInfoClassInActive}\"> <p> <span class=text-capitalize>operation info</span> </p> </li> </ul> </div> <div ng-switch=$ctrl.step> <div ng-switch-when=1> <basic-info show-next-button=true show-previous-button=false on-submit=$ctrl.onSubmitBasicInfo($event) on-cancel=$ctrl.onCancel() parent-slug={{$ctrl.parentSlug}} hide-phone-purpose=true county=$ctrl.county details=$ctrl.details.basicInfo> </basic-info> </div> <div ng-switch-when=2> <operation-info show-next-button=false show-previous-button=true on-previous=$ctrl.onOperationInfoPrevious($event) on-submit=$ctrl.onSubmitOperationInfo($event) on-cancel=$ctrl.onCancel() parent-slug={{$ctrl.parentSlug}} prev-details=$ctrl.saveData new-details=$ctrl.details details=$ctrl.details.operationInfo> </operation-info> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 795 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/transportation-alternative/ridesharing/ridesharing-template.html';
var html = "<section class=min-height-section> <div class=pagerList> <ul id=progressbar> <li ng-class=\"{active: $ctrl.isBasicInfoActive, submitted: !$ctrl.isBasicInfoActive}\"> <p> <span class=text-capitalize>basic info</span> </p> </li> <li ng-class=\"{active: $ctrl.isOperationInfoClassActive, submitted: $ctrl.isOperationInfoClassInActive}\"> <p> <span class=text-capitalize>operation info</span> </p> </li> </ul> </div> <div ng-switch=$ctrl.step> <div ng-switch-when=1> <basic-info show-next-button=true show-previous-button=false on-submit=$ctrl.onSubmitBasicInfo($event) on-cancel=$ctrl.onCancel() parent-slug={{$ctrl.parentSlug}} hide-phone-purpose=true county=$ctrl.county details=$ctrl.details.basicInfo> </basic-info> </div> <div ng-switch-when=2> <operation-info show-next-button=false show-previous-button=true on-previous=$ctrl.onOperationInfoPrevious($event) on-submit=$ctrl.onSubmitOperationInfo($event) on-cancel=$ctrl.onCancel() parent-slug={{$ctrl.parentSlug}} prev-details=$ctrl.saveData new-details=$ctrl.details details=$ctrl.details.operationInfo> </operation-info> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 796 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/transportation-alternative/transportation-alternative-details-template2.html';
var html = "<section class=call-for-help-details-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 call-for-help-details\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>details</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <button type=button class=\"btn go-back text-uppercase\" ng-click=$ctrl.onGoBack()>go back</button> <span class=icon-Edit ng-click=$ctrl.onEdit($ctrl.details.id)></span> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item display-flex\"> <div class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 item-image\"> <img ng-src={{$ctrl._getImage($ctrl.details)}} class=\"img img-responsive\"/> </div> <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10 item-detail\"> <h2 class=text-capitalize>{{$ctrl.details.name}}</h2> <div class=\"col-md-12 county-hrs-operation-wrap\"> <div class=\"col-md-12 county no-padding\"> <h3>County</h3> <p><span ng-repeat=\"location in $ctrl.details.serviceArea\">{{location.name}}{{!$last ? ', ' : ''}}</span></p> </div> <div class=\"col-md-12 desc\"> <h3>Description</h3> <p>{{$ctrl.details.description}}</p> </div> </div> </div> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/transportation-alternative/transportation-alternative-list-template2.html';
var html = "<div class=bicycle-pedestrian> <display-overview details=$ctrl.details.overview slug-url={{$ctrl.slugUrl}}> </display-overview> <section class=bicycle-pedestrian-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 bicycle-pedestrian-list\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>{{$ctrl.pageTitle}}</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <button class=\"submit-btn text-uppercase\" ng-click=$ctrl.routeAddPageUrl()>add new</button> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 list-item\" ng-repeat=\"item in $ctrl.details.list\"> <div class=\"col-md-12 list-content\"> <div class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 item-image\"> <img ng-src={{$ctrl._getImage(item)}} class=\"img img-responsive\"/> </div> <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10 item-details\"> <div class=\"col-md-12 title-btns-wrap\"> <h3 class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\">{{item.name}}</h3> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 text-right item-btns\"> <a ng-click=$ctrl.routeDetailsPageUrl(item.slug)> <span class=\"icons icon-View\"></span> </a> <a ng-click=$ctrl.routeEditPageUrl(item.slug)> <span class=\"icons icon-Edit\"></span> </a> <span class=\"icons icon-Delete\" ng-click=$ctrl.onDelete(item.slug)></span> </div> </div> <div class=\"col-md-12 desc\"> <p>{{item.description}}</p> </div> </div> </div> </div> <div class=\"col-md-12 pagination\"> <pagination total-items=$ctrl.totalItems item-per-page=$ctrl.itemPerPage current-page=$ctrl.currentPage on-change=$ctrl.onChange($event)> </pagination> </div> </div> </section> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 798 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/transportation-alternative/transportation-providers/transportation-providers-details/transportation-providers-details.html';
var html = "<section class=call-for-help-details-section> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 call-for-help-details\"> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 page-title\"> <div class=\"col-md-6 col-sm-6 col-xs-6 col-lg-6 title\"> <h2 class=text-capitalize>details</h2> </div> <div class=\"col-md-6 col-xs-6 col-sm-6 col-lg-6 text-right button\"> <button type=button class=\"btn go-back text-uppercase\" ng-click=$ctrl.onGoBack()>go back</button> <span class=icon-Edit ng-click=$ctrl.onEdit($ctrl.details.id)></span> </div> </div> <div class=\"col-md-12 col-sm-12 col-xs-12 col-lg-12 transportation-list-item\"> <div class=\"col-md-2 col-sm-2 col-xs-2 col-lg-2 item-image margin-right-10\"> <img ng-src={{$ctrl._getImage($ctrl.details)}} class=\"img img-responsive\"/> </div> <div class=\"col-md-10 col-sm-10 col-xs-10 col-lg-10 item-detail\"> <h2 class=text-capitalize>{{$ctrl.details.name}}</h2> <div class=\"col-md-12 county-hrs-operation-wrap\"> <div class=\"col-md-12 col-sm-12 col-xs-4 col-lg-4 county no-padding-left\"> <h3>Service Area</h3> <p><span ng-repeat=\"location in $ctrl.details.serviceArea\">{{location.name}}{{!$last ? ', ' : ''}}</span></p> </div> </div> <div class=\"col-md-12 phone-email-wrap\"> <div class=\"col-md-12 col-sm-12 col-xs-4 col-lg-4 hours-of-operation no-padding-left\"> <h3>Hours of Operation</h3> <p class=detail-span ng-if=!$ctrl.details.hoursOfOperation.isAllDay>{{$ctrl.details.hoursOfOperation.startTime | date:'hh:mm a'}} - {{$ctrl.details.hoursOfOperation.endTime | date:'hh:mm a'}} </p> <p class=detail-span ng-if=$ctrl.details.hoursOfOperation.isAllDay> All Day </p> </div> <div class=\"col-md-12 col-sm-12 col-xs-4 col-lg-4 provider-service-type no-padding-left\"> <h3>Transport Type</h3> <p><span ng-repeat=\"type in $ctrl.details.serviceType\">{{type.name}}{{!$last ? ', ' : ''}}</span></p> <p ng-if=\"$ctrl.details.serviceType.length === 0\">-</p> </div> </div> <div class=\"col-md-12 website-days-operation-wrap\"> <div class=\"col-md-12 col-sm-12 col-xs-4 col-lg-4 to-register no-padding-left\" ng-repeat=\"phone in $ctrl.details.phone\"> <h3>{{phone.name}}</h3> <p>{{phone.number}}, Ext.{{phone.extn}}{{!$last ? ', ' : ''}}</p> </div> <div class=\"col-md-12 col-sm-12 col-xs-6 col-lg-6 days-of-operation\"> <days-of-operation details=$ctrl.daysOfOperation></days-of-operation> </div> </div> </div> </div> <div class=\"col-md-10 other-info-div no-padding pull-right\"> <div class=\"col-md-12 fees-payment-wrap no-padding\"> <div class=\"col-md-12 col-sm-12 col-xs-4 col-lg-4 fees no-padding-left\"> <h3>Fees</h3> <p>{{$ctrl.details.fees}}</p> </div> <div class=\"col-md-12 col-sm-12 col-xs-4 col-lg-4 provider-payment no-padding-left\"> <h3>Methods of Payment</h3> <p><span ng-repeat=\"method in $ctrl.details.methodOfPayment\">{{method.name}}{{!$last ? ', ' : ''}}</span></p> </div> </div> <div class=\"col-md-12 notes no-padding\"> <h3>Notes</h3> <p>{{$ctrl.details.notes || 'N/A'}}</p> </div> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 799 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/transportation-alternative/transportation-providers/transportation-providers-template.html';
var html = "<section class=section> <div class=pagerList> <ul id=progressbar> <li ng-class=\"{active: $ctrl.isBasicInfoActive, submitted: !$ctrl.isBasicInfoActive}\"> <p> <span class=text-capitalize>basic info</span> </p> </li> <li ng-class=\"{active: $ctrl.isServiceInfoActive, submitted: $ctrl.isServiceInfoSubmitted}\"> <p> <span class=text-capitalize>service info</span> </p> </li> <li ng-class=\"{active: $ctrl.isOperationInfoClassActive, submitted: $ctrl.isOperationInfoClassSubmitted}\"> <p> <span class=text-capitalize>operation info</span> </p> </li> <li ng-class=\"{active: $ctrl.isOtherInfoClassActive, submitted: $ctrl.isOtherInfoClassSubmitted}\"> <p> <span class=text-capitalize>other info</span> </p> </li> </ul> </div> <div ng-switch=$ctrl.step> <div ng-switch-when=1> <basic-info show-next-button=true show-previous-button=false on-submit=$ctrl.onSubmitBasicInfo($event) on-cancel=$ctrl.onCancel() parent-slug={{$ctrl.parentSlug}} hide-phone-purpose=false details=$ctrl.details.basicInfo> </basic-info> </div> <div ng-switch-when=2> <service-info show-next-button=true show-previous-button=true on-previous=$ctrl.onServiceInfoPrevious($event) on-submit=$ctrl.onSubmitServiceInfo($event) prev-details=$ctrl.saveData new-details=$ctrl.details on-cancel=$ctrl.onCancel() service-areas=$ctrl.serviceArea service-type-list=$ctrl.serviceType parent-slug={{$ctrl.parentSlug}} details=$ctrl.details> </service-info> </div> <div ng-switch-when=3> <operation-info show-next-button=true parent-slug={{$ctrl.parentSlug}} show-previous-button=true on-previous=$ctrl.onOperationInfoPrevious($event) on-submit=$ctrl.onSubmitOperationInfo($event) prev-details=$ctrl.saveData new-details=$ctrl.details on-cancel=$ctrl.onCancel() details=$ctrl.details.operationInfo> </operation-info> </div> <div ng-switch-when=4> <other-info show-next-button=false parent-slug={{$ctrl.parentSlug}} show-previous-button=true on-previous=$ctrl.onOtherInfoPrevious($event) on-submit=$ctrl.onSubmitOtherInfo($event) prev-details=$ctrl.saveData new-details=$ctrl.details on-cancel=$ctrl.onCancel() payment-methods-list=$ctrl.paymentMethods details=$ctrl.details.otherInfo> </other-info> </div> </div> </section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 800 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/components/trip-planning/trip-planning.html';
var html = "<content-template details=$ctrl.details is-overview-exist=false disable-buttons=$ctrl.disableButtons on-cancel=$ctrl.onCancel() on-submit=$ctrl.onSubmit()> </content-template>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 801 */
/***/ (function(module, exports) {

var path = '/var/www/mmscny-cms/src/app/root.html';
var html = "<div class=root> <app></app> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(138);
module.exports = __webpack_require__(139);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/app452d17f1215727cecf7f.bundle.js